(function(scope){
'use strict';

function F(arity, fun, wrapper) {
  wrapper.a = arity;
  wrapper.f = fun;
  return wrapper;
}

function F2(fun) {
  return F(2, fun, function(a) { return function(b) { return fun(a,b); }; })
}
function F3(fun) {
  return F(3, fun, function(a) {
    return function(b) { return function(c) { return fun(a, b, c); }; };
  });
}
function F4(fun) {
  return F(4, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return fun(a, b, c, d); }; }; };
  });
}
function F5(fun) {
  return F(5, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return fun(a, b, c, d, e); }; }; }; };
  });
}
function F6(fun) {
  return F(6, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return fun(a, b, c, d, e, f); }; }; }; }; };
  });
}
function F7(fun) {
  return F(7, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return fun(a, b, c, d, e, f, g); }; }; }; }; }; };
  });
}
function F8(fun) {
  return F(8, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) {
    return fun(a, b, c, d, e, f, g, h); }; }; }; }; }; }; };
  });
}
function F9(fun) {
  return F(9, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) { return function(i) {
    return fun(a, b, c, d, e, f, g, h, i); }; }; }; }; }; }; }; };
  });
}

function A2(fun, a, b) {
  return fun.a === 2 ? fun.f(a, b) : fun(a)(b);
}
function A3(fun, a, b, c) {
  return fun.a === 3 ? fun.f(a, b, c) : fun(a)(b)(c);
}
function A4(fun, a, b, c, d) {
  return fun.a === 4 ? fun.f(a, b, c, d) : fun(a)(b)(c)(d);
}
function A5(fun, a, b, c, d, e) {
  return fun.a === 5 ? fun.f(a, b, c, d, e) : fun(a)(b)(c)(d)(e);
}
function A6(fun, a, b, c, d, e, f) {
  return fun.a === 6 ? fun.f(a, b, c, d, e, f) : fun(a)(b)(c)(d)(e)(f);
}
function A7(fun, a, b, c, d, e, f, g) {
  return fun.a === 7 ? fun.f(a, b, c, d, e, f, g) : fun(a)(b)(c)(d)(e)(f)(g);
}
function A8(fun, a, b, c, d, e, f, g, h) {
  return fun.a === 8 ? fun.f(a, b, c, d, e, f, g, h) : fun(a)(b)(c)(d)(e)(f)(g)(h);
}
function A9(fun, a, b, c, d, e, f, g, h, i) {
  return fun.a === 9 ? fun.f(a, b, c, d, e, f, g, h, i) : fun(a)(b)(c)(d)(e)(f)(g)(h)(i);
}




var _JsArray_empty = [];

function _JsArray_singleton(value)
{
    return [value];
}

function _JsArray_length(array)
{
    return array.length;
}

var _JsArray_initialize = F3(function(size, offset, func)
{
    var result = new Array(size);

    for (var i = 0; i < size; i++)
    {
        result[i] = func(offset + i);
    }

    return result;
});

var _JsArray_initializeFromList = F2(function (max, ls)
{
    var result = new Array(max);

    for (var i = 0; i < max && ls.b; i++)
    {
        result[i] = ls.a;
        ls = ls.b;
    }

    result.length = i;
    return _Utils_Tuple2(result, ls);
});

var _JsArray_unsafeGet = F2(function(index, array)
{
    return array[index];
});

var _JsArray_unsafeSet = F3(function(index, value, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[index] = value;
    return result;
});

var _JsArray_push = F2(function(value, array)
{
    var length = array.length;
    var result = new Array(length + 1);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[length] = value;
    return result;
});

var _JsArray_foldl = F3(function(func, acc, array)
{
    var length = array.length;

    for (var i = 0; i < length; i++)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_foldr = F3(function(func, acc, array)
{
    for (var i = array.length - 1; i >= 0; i--)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_map = F2(function(func, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = func(array[i]);
    }

    return result;
});

var _JsArray_indexedMap = F3(function(func, offset, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = A2(func, offset + i, array[i]);
    }

    return result;
});

var _JsArray_slice = F3(function(from, to, array)
{
    return array.slice(from, to);
});

var _JsArray_appendN = F3(function(n, dest, source)
{
    var destLen = dest.length;
    var itemsToCopy = n - destLen;

    if (itemsToCopy > source.length)
    {
        itemsToCopy = source.length;
    }

    var size = destLen + itemsToCopy;
    var result = new Array(size);

    for (var i = 0; i < destLen; i++)
    {
        result[i] = dest[i];
    }

    for (var i = 0; i < itemsToCopy; i++)
    {
        result[i + destLen] = source[i];
    }

    return result;
});



// LOG

var _Debug_log = F2(function(tag, value)
{
	return value;
});

var _Debug_log_UNUSED = F2(function(tag, value)
{
	console.log(tag + ': ' + _Debug_toString(value));
	return value;
});


// TODOS

function _Debug_todo(moduleName, region)
{
	return function(message) {
		_Debug_crash(8, moduleName, region, message);
	};
}

function _Debug_todoCase(moduleName, region, value)
{
	return function(message) {
		_Debug_crash(9, moduleName, region, value, message);
	};
}


// TO STRING

function _Debug_toString(value)
{
	return '<internals>';
}

function _Debug_toString_UNUSED(value)
{
	return _Debug_toAnsiString(false, value);
}

function _Debug_toAnsiString(ansi, value)
{
	if (typeof value === 'function')
	{
		return _Debug_internalColor(ansi, '<function>');
	}

	if (typeof value === 'boolean')
	{
		return _Debug_ctorColor(ansi, value ? 'True' : 'False');
	}

	if (typeof value === 'number')
	{
		return _Debug_numberColor(ansi, value + '');
	}

	if (value instanceof String)
	{
		return _Debug_charColor(ansi, "'" + _Debug_addSlashes(value, true) + "'");
	}

	if (typeof value === 'string')
	{
		return _Debug_stringColor(ansi, '"' + _Debug_addSlashes(value, false) + '"');
	}

	if (typeof value === 'object' && '$' in value)
	{
		var tag = value.$;

		if (typeof tag === 'number')
		{
			return _Debug_internalColor(ansi, '<internals>');
		}

		if (tag[0] === '#')
		{
			var output = [];
			for (var k in value)
			{
				if (k === '$') continue;
				output.push(_Debug_toAnsiString(ansi, value[k]));
			}
			return '(' + output.join(',') + ')';
		}

		if (tag === 'Set_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Set')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Set$toList(value));
		}

		if (tag === 'RBNode_elm_builtin' || tag === 'RBEmpty_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Dict')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Dict$toList(value));
		}

		if (tag === 'Array_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Array')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Array$toList(value));
		}

		if (tag === '::' || tag === '[]')
		{
			var output = '[';

			value.b && (output += _Debug_toAnsiString(ansi, value.a), value = value.b)

			for (; value.b; value = value.b) // WHILE_CONS
			{
				output += ',' + _Debug_toAnsiString(ansi, value.a);
			}
			return output + ']';
		}

		var output = '';
		for (var i in value)
		{
			if (i === '$') continue;
			var str = _Debug_toAnsiString(ansi, value[i]);
			var c0 = str[0];
			var parenless = c0 === '{' || c0 === '(' || c0 === '[' || c0 === '<' || c0 === '"' || str.indexOf(' ') < 0;
			output += ' ' + (parenless ? str : '(' + str + ')');
		}
		return _Debug_ctorColor(ansi, tag) + output;
	}

	if (typeof DataView === 'function' && value instanceof DataView)
	{
		return _Debug_stringColor(ansi, '<' + value.byteLength + ' bytes>');
	}

	if (typeof File !== 'undefined' && value instanceof File)
	{
		return _Debug_internalColor(ansi, '<' + value.name + '>');
	}

	if (typeof value === 'object')
	{
		var output = [];
		for (var key in value)
		{
			var field = key[0] === '_' ? key.slice(1) : key;
			output.push(_Debug_fadeColor(ansi, field) + ' = ' + _Debug_toAnsiString(ansi, value[key]));
		}
		if (output.length === 0)
		{
			return '{}';
		}
		return '{ ' + output.join(', ') + ' }';
	}

	return _Debug_internalColor(ansi, '<internals>');
}

function _Debug_addSlashes(str, isChar)
{
	var s = str
		.replace(/\\/g, '\\\\')
		.replace(/\n/g, '\\n')
		.replace(/\t/g, '\\t')
		.replace(/\r/g, '\\r')
		.replace(/\v/g, '\\v')
		.replace(/\0/g, '\\0');

	if (isChar)
	{
		return s.replace(/\'/g, '\\\'');
	}
	else
	{
		return s.replace(/\"/g, '\\"');
	}
}

function _Debug_ctorColor(ansi, string)
{
	return ansi ? '\x1b[96m' + string + '\x1b[0m' : string;
}

function _Debug_numberColor(ansi, string)
{
	return ansi ? '\x1b[95m' + string + '\x1b[0m' : string;
}

function _Debug_stringColor(ansi, string)
{
	return ansi ? '\x1b[93m' + string + '\x1b[0m' : string;
}

function _Debug_charColor(ansi, string)
{
	return ansi ? '\x1b[92m' + string + '\x1b[0m' : string;
}

function _Debug_fadeColor(ansi, string)
{
	return ansi ? '\x1b[37m' + string + '\x1b[0m' : string;
}

function _Debug_internalColor(ansi, string)
{
	return ansi ? '\x1b[36m' + string + '\x1b[0m' : string;
}

function _Debug_toHexDigit(n)
{
	return String.fromCharCode(n < 10 ? 48 + n : 55 + n);
}


// CRASH


function _Debug_crash(identifier)
{
	throw new Error('https://github.com/elm/core/blob/1.0.0/hints/' + identifier + '.md');
}


function _Debug_crash_UNUSED(identifier, fact1, fact2, fact3, fact4)
{
	switch(identifier)
	{
		case 0:
			throw new Error('What node should I take over? In JavaScript I need something like:\n\n    Elm.Main.init({\n        node: document.getElementById("elm-node")\n    })\n\nYou need to do this with any Browser.sandbox or Browser.element program.');

		case 1:
			throw new Error('Browser.application programs cannot handle URLs like this:\n\n    ' + document.location.href + '\n\nWhat is the root? The root of your file system? Try looking at this program with `elm reactor` or some other server.');

		case 2:
			var jsonErrorString = fact1;
			throw new Error('Problem with the flags given to your Elm program on initialization.\n\n' + jsonErrorString);

		case 3:
			var portName = fact1;
			throw new Error('There can only be one port named `' + portName + '`, but your program has multiple.');

		case 4:
			var portName = fact1;
			var problem = fact2;
			throw new Error('Trying to send an unexpected type of value through port `' + portName + '`:\n' + problem);

		case 5:
			throw new Error('Trying to use `(==)` on functions.\nThere is no way to know if functions are "the same" in the Elm sense.\nRead more about this at https://package.elm-lang.org/packages/elm/core/latest/Basics#== which describes why it is this way and what the better version will look like.');

		case 6:
			var moduleName = fact1;
			throw new Error('Your page is loading multiple Elm scripts with a module named ' + moduleName + '. Maybe a duplicate script is getting loaded accidentally? If not, rename one of them so I know which is which!');

		case 8:
			var moduleName = fact1;
			var region = fact2;
			var message = fact3;
			throw new Error('TODO in module `' + moduleName + '` ' + _Debug_regionToString(region) + '\n\n' + message);

		case 9:
			var moduleName = fact1;
			var region = fact2;
			var value = fact3;
			var message = fact4;
			throw new Error(
				'TODO in module `' + moduleName + '` from the `case` expression '
				+ _Debug_regionToString(region) + '\n\nIt received the following value:\n\n    '
				+ _Debug_toString(value).replace('\n', '\n    ')
				+ '\n\nBut the branch that handles it says:\n\n    ' + message.replace('\n', '\n    ')
			);

		case 10:
			throw new Error('Bug in https://github.com/elm/virtual-dom/issues');

		case 11:
			throw new Error('Cannot perform mod 0. Division by zero error.');
	}
}

function _Debug_regionToString(region)
{
	if (region.aju.cy === region.F3.cy)
	{
		return 'on line ' + region.aju.cy;
	}
	return 'on lines ' + region.aju.cy + ' through ' + region.F3.cy;
}



// EQUALITY

function _Utils_eq(x, y)
{
	for (
		var pair, stack = [], isEqual = _Utils_eqHelp(x, y, 0, stack);
		isEqual && (pair = stack.pop());
		isEqual = _Utils_eqHelp(pair.a, pair.b, 0, stack)
		)
	{}

	return isEqual;
}

function _Utils_eqHelp(x, y, depth, stack)
{
	if (x === y)
	{
		return true;
	}

	if (typeof x !== 'object' || x === null || y === null)
	{
		typeof x === 'function' && _Debug_crash(5);
		return false;
	}

	if (depth > 100)
	{
		stack.push(_Utils_Tuple2(x,y));
		return true;
	}

	/**_UNUSED/
	if (x.$ === 'Set_elm_builtin')
	{
		x = $elm$core$Set$toList(x);
		y = $elm$core$Set$toList(y);
	}
	if (x.$ === 'RBNode_elm_builtin' || x.$ === 'RBEmpty_elm_builtin')
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	/**/
	if (x.$ < 0)
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	for (var key in x)
	{
		if (!_Utils_eqHelp(x[key], y[key], depth + 1, stack))
		{
			return false;
		}
	}
	return true;
}

var _Utils_equal = F2(_Utils_eq);
var _Utils_notEqual = F2(function(a, b) { return !_Utils_eq(a,b); });



// COMPARISONS

// Code in Generate/JavaScript.hs, Basics.js, and List.js depends on
// the particular integer values assigned to LT, EQ, and GT.

function _Utils_cmp(x, y, ord)
{
	if (typeof x !== 'object')
	{
		return x === y ? /*EQ*/ 0 : x < y ? /*LT*/ -1 : /*GT*/ 1;
	}

	/**_UNUSED/
	if (x instanceof String)
	{
		var a = x.valueOf();
		var b = y.valueOf();
		return a === b ? 0 : a < b ? -1 : 1;
	}
	//*/

	/**/
	if (typeof x.$ === 'undefined')
	//*/
	/**_UNUSED/
	if (x.$[0] === '#')
	//*/
	{
		return (ord = _Utils_cmp(x.a, y.a))
			? ord
			: (ord = _Utils_cmp(x.b, y.b))
				? ord
				: _Utils_cmp(x.c, y.c);
	}

	// traverse conses until end of a list or a mismatch
	for (; x.b && y.b && !(ord = _Utils_cmp(x.a, y.a)); x = x.b, y = y.b) {} // WHILE_CONSES
	return ord || (x.b ? /*GT*/ 1 : y.b ? /*LT*/ -1 : /*EQ*/ 0);
}

var _Utils_lt = F2(function(a, b) { return _Utils_cmp(a, b) < 0; });
var _Utils_le = F2(function(a, b) { return _Utils_cmp(a, b) < 1; });
var _Utils_gt = F2(function(a, b) { return _Utils_cmp(a, b) > 0; });
var _Utils_ge = F2(function(a, b) { return _Utils_cmp(a, b) >= 0; });

var _Utils_compare = F2(function(x, y)
{
	var n = _Utils_cmp(x, y);
	return n < 0 ? $elm$core$Basics$LT : n ? $elm$core$Basics$GT : $elm$core$Basics$EQ;
});


// COMMON VALUES

var _Utils_Tuple0 = 0;
var _Utils_Tuple0_UNUSED = { $: '#0' };

function _Utils_Tuple2(a, b) { return { a: a, b: b }; }
function _Utils_Tuple2_UNUSED(a, b) { return { $: '#2', a: a, b: b }; }

function _Utils_Tuple3(a, b, c) { return { a: a, b: b, c: c }; }
function _Utils_Tuple3_UNUSED(a, b, c) { return { $: '#3', a: a, b: b, c: c }; }

function _Utils_chr(c) { return c; }
function _Utils_chr_UNUSED(c) { return new String(c); }


// RECORDS

function _Utils_update(oldRecord, updatedFields)
{
	var newRecord = {};

	for (var key in oldRecord)
	{
		newRecord[key] = oldRecord[key];
	}

	for (var key in updatedFields)
	{
		newRecord[key] = updatedFields[key];
	}

	return newRecord;
}


// APPEND

var _Utils_append = F2(_Utils_ap);

function _Utils_ap(xs, ys)
{
	// append Strings
	if (typeof xs === 'string')
	{
		return xs + ys;
	}

	// append Lists
	if (!xs.b)
	{
		return ys;
	}
	var root = _List_Cons(xs.a, ys);
	xs = xs.b
	for (var curr = root; xs.b; xs = xs.b) // WHILE_CONS
	{
		curr = curr.b = _List_Cons(xs.a, ys);
	}
	return root;
}



var _List_Nil = { $: 0 };
var _List_Nil_UNUSED = { $: '[]' };

function _List_Cons(hd, tl) { return { $: 1, a: hd, b: tl }; }
function _List_Cons_UNUSED(hd, tl) { return { $: '::', a: hd, b: tl }; }


var _List_cons = F2(_List_Cons);

function _List_fromArray(arr)
{
	var out = _List_Nil;
	for (var i = arr.length; i--; )
	{
		out = _List_Cons(arr[i], out);
	}
	return out;
}

function _List_toArray(xs)
{
	for (var out = []; xs.b; xs = xs.b) // WHILE_CONS
	{
		out.push(xs.a);
	}
	return out;
}

var _List_map2 = F3(function(f, xs, ys)
{
	for (var arr = []; xs.b && ys.b; xs = xs.b, ys = ys.b) // WHILE_CONSES
	{
		arr.push(A2(f, xs.a, ys.a));
	}
	return _List_fromArray(arr);
});

var _List_map3 = F4(function(f, xs, ys, zs)
{
	for (var arr = []; xs.b && ys.b && zs.b; xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A3(f, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map4 = F5(function(f, ws, xs, ys, zs)
{
	for (var arr = []; ws.b && xs.b && ys.b && zs.b; ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A4(f, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map5 = F6(function(f, vs, ws, xs, ys, zs)
{
	for (var arr = []; vs.b && ws.b && xs.b && ys.b && zs.b; vs = vs.b, ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A5(f, vs.a, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_sortBy = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		return _Utils_cmp(f(a), f(b));
	}));
});

var _List_sortWith = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		var ord = A2(f, a, b);
		return ord === $elm$core$Basics$EQ ? 0 : ord === $elm$core$Basics$LT ? -1 : 1;
	}));
});



// MATH

var _Basics_add = F2(function(a, b) { return a + b; });
var _Basics_sub = F2(function(a, b) { return a - b; });
var _Basics_mul = F2(function(a, b) { return a * b; });
var _Basics_fdiv = F2(function(a, b) { return a / b; });
var _Basics_idiv = F2(function(a, b) { return (a / b) | 0; });
var _Basics_pow = F2(Math.pow);

var _Basics_remainderBy = F2(function(b, a) { return a % b; });

// https://www.microsoft.com/en-us/research/wp-content/uploads/2016/02/divmodnote-letter.pdf
var _Basics_modBy = F2(function(modulus, x)
{
	var answer = x % modulus;
	return modulus === 0
		? _Debug_crash(11)
		:
	((answer > 0 && modulus < 0) || (answer < 0 && modulus > 0))
		? answer + modulus
		: answer;
});


// TRIGONOMETRY

var _Basics_pi = Math.PI;
var _Basics_e = Math.E;
var _Basics_cos = Math.cos;
var _Basics_sin = Math.sin;
var _Basics_tan = Math.tan;
var _Basics_acos = Math.acos;
var _Basics_asin = Math.asin;
var _Basics_atan = Math.atan;
var _Basics_atan2 = F2(Math.atan2);


// MORE MATH

function _Basics_toFloat(x) { return x; }
function _Basics_truncate(n) { return n | 0; }
function _Basics_isInfinite(n) { return n === Infinity || n === -Infinity; }

var _Basics_ceiling = Math.ceil;
var _Basics_floor = Math.floor;
var _Basics_round = Math.round;
var _Basics_sqrt = Math.sqrt;
var _Basics_log = Math.log;
var _Basics_isNaN = isNaN;


// BOOLEANS

function _Basics_not(bool) { return !bool; }
var _Basics_and = F2(function(a, b) { return a && b; });
var _Basics_or  = F2(function(a, b) { return a || b; });
var _Basics_xor = F2(function(a, b) { return a !== b; });



var _String_cons = F2(function(chr, str)
{
	return chr + str;
});

function _String_uncons(string)
{
	var word = string.charCodeAt(0);
	return !isNaN(word)
		? $elm$core$Maybe$Just(
			0xD800 <= word && word <= 0xDBFF
				? _Utils_Tuple2(_Utils_chr(string[0] + string[1]), string.slice(2))
				: _Utils_Tuple2(_Utils_chr(string[0]), string.slice(1))
		)
		: $elm$core$Maybe$Nothing;
}

var _String_append = F2(function(a, b)
{
	return a + b;
});

function _String_length(str)
{
	return str.length;
}

var _String_map = F2(function(func, string)
{
	var len = string.length;
	var array = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = string.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			array[i] = func(_Utils_chr(string[i] + string[i+1]));
			i += 2;
			continue;
		}
		array[i] = func(_Utils_chr(string[i]));
		i++;
	}
	return array.join('');
});

var _String_filter = F2(function(isGood, str)
{
	var arr = [];
	var len = str.length;
	var i = 0;
	while (i < len)
	{
		var char = str[i];
		var word = str.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += str[i];
			i++;
		}

		if (isGood(_Utils_chr(char)))
		{
			arr.push(char);
		}
	}
	return arr.join('');
});

function _String_reverse(str)
{
	var len = str.length;
	var arr = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = str.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			arr[len - i] = str[i + 1];
			i++;
			arr[len - i] = str[i - 1];
			i++;
		}
		else
		{
			arr[len - i] = str[i];
			i++;
		}
	}
	return arr.join('');
}

var _String_foldl = F3(function(func, state, string)
{
	var len = string.length;
	var i = 0;
	while (i < len)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += string[i];
			i++;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_foldr = F3(function(func, state, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_split = F2(function(sep, str)
{
	return str.split(sep);
});

var _String_join = F2(function(sep, strs)
{
	return strs.join(sep);
});

var _String_slice = F3(function(start, end, str) {
	return str.slice(start, end);
});

function _String_trim(str)
{
	return str.trim();
}

function _String_trimLeft(str)
{
	return str.replace(/^\s+/, '');
}

function _String_trimRight(str)
{
	return str.replace(/\s+$/, '');
}

function _String_words(str)
{
	return _List_fromArray(str.trim().split(/\s+/g));
}

function _String_lines(str)
{
	return _List_fromArray(str.split(/\r\n|\r|\n/g));
}

function _String_toUpper(str)
{
	return str.toUpperCase();
}

function _String_toLower(str)
{
	return str.toLowerCase();
}

var _String_any = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (isGood(_Utils_chr(char)))
		{
			return true;
		}
	}
	return false;
});

var _String_all = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (!isGood(_Utils_chr(char)))
		{
			return false;
		}
	}
	return true;
});

var _String_contains = F2(function(sub, str)
{
	return str.indexOf(sub) > -1;
});

var _String_startsWith = F2(function(sub, str)
{
	return str.indexOf(sub) === 0;
});

var _String_endsWith = F2(function(sub, str)
{
	return str.length >= sub.length &&
		str.lastIndexOf(sub) === str.length - sub.length;
});

var _String_indexes = F2(function(sub, str)
{
	var subLen = sub.length;

	if (subLen < 1)
	{
		return _List_Nil;
	}

	var i = 0;
	var is = [];

	while ((i = str.indexOf(sub, i)) > -1)
	{
		is.push(i);
		i = i + subLen;
	}

	return _List_fromArray(is);
});


// TO STRING

function _String_fromNumber(number)
{
	return number + '';
}


// INT CONVERSIONS

function _String_toInt(str)
{
	var total = 0;
	var code0 = str.charCodeAt(0);
	var start = code0 == 0x2B /* + */ || code0 == 0x2D /* - */ ? 1 : 0;

	for (var i = start; i < str.length; ++i)
	{
		var code = str.charCodeAt(i);
		if (code < 0x30 || 0x39 < code)
		{
			return $elm$core$Maybe$Nothing;
		}
		total = 10 * total + code - 0x30;
	}

	return i == start
		? $elm$core$Maybe$Nothing
		: $elm$core$Maybe$Just(code0 == 0x2D ? -total : total);
}


// FLOAT CONVERSIONS

function _String_toFloat(s)
{
	// check if it is a hex, octal, or binary number
	if (s.length === 0 || /[\sxbo]/.test(s))
	{
		return $elm$core$Maybe$Nothing;
	}
	var n = +s;
	// faster isNaN check
	return n === n ? $elm$core$Maybe$Just(n) : $elm$core$Maybe$Nothing;
}

function _String_fromList(chars)
{
	return _List_toArray(chars).join('');
}




function _Char_toCode(char)
{
	var code = char.charCodeAt(0);
	if (0xD800 <= code && code <= 0xDBFF)
	{
		return (code - 0xD800) * 0x400 + char.charCodeAt(1) - 0xDC00 + 0x10000
	}
	return code;
}

function _Char_fromCode(code)
{
	return _Utils_chr(
		(code < 0 || 0x10FFFF < code)
			? '\uFFFD'
			:
		(code <= 0xFFFF)
			? String.fromCharCode(code)
			:
		(code -= 0x10000,
			String.fromCharCode(Math.floor(code / 0x400) + 0xD800, code % 0x400 + 0xDC00)
		)
	);
}

function _Char_toUpper(char)
{
	return _Utils_chr(char.toUpperCase());
}

function _Char_toLower(char)
{
	return _Utils_chr(char.toLowerCase());
}

function _Char_toLocaleUpper(char)
{
	return _Utils_chr(char.toLocaleUpperCase());
}

function _Char_toLocaleLower(char)
{
	return _Utils_chr(char.toLocaleLowerCase());
}



/**_UNUSED/
function _Json_errorToString(error)
{
	return $elm$json$Json$Decode$errorToString(error);
}
//*/


// CORE DECODERS

function _Json_succeed(msg)
{
	return {
		$: 0,
		a: msg
	};
}

function _Json_fail(msg)
{
	return {
		$: 1,
		a: msg
	};
}

function _Json_decodePrim(decoder)
{
	return { $: 2, b: decoder };
}

var _Json_decodeInt = _Json_decodePrim(function(value) {
	return (typeof value !== 'number')
		? _Json_expecting('an INT', value)
		:
	(-2147483647 < value && value < 2147483647 && (value | 0) === value)
		? $elm$core$Result$Ok(value)
		:
	(isFinite(value) && !(value % 1))
		? $elm$core$Result$Ok(value)
		: _Json_expecting('an INT', value);
});

var _Json_decodeBool = _Json_decodePrim(function(value) {
	return (typeof value === 'boolean')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a BOOL', value);
});

var _Json_decodeFloat = _Json_decodePrim(function(value) {
	return (typeof value === 'number')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FLOAT', value);
});

var _Json_decodeValue = _Json_decodePrim(function(value) {
	return $elm$core$Result$Ok(_Json_wrap(value));
});

var _Json_decodeString = _Json_decodePrim(function(value) {
	return (typeof value === 'string')
		? $elm$core$Result$Ok(value)
		: (value instanceof String)
			? $elm$core$Result$Ok(value + '')
			: _Json_expecting('a STRING', value);
});

function _Json_decodeList(decoder) { return { $: 3, b: decoder }; }
function _Json_decodeArray(decoder) { return { $: 4, b: decoder }; }

function _Json_decodeNull(value) { return { $: 5, c: value }; }

var _Json_decodeField = F2(function(field, decoder)
{
	return {
		$: 6,
		d: field,
		b: decoder
	};
});

var _Json_decodeIndex = F2(function(index, decoder)
{
	return {
		$: 7,
		e: index,
		b: decoder
	};
});

function _Json_decodeKeyValuePairs(decoder)
{
	return {
		$: 8,
		b: decoder
	};
}

function _Json_mapMany(f, decoders)
{
	return {
		$: 9,
		f: f,
		g: decoders
	};
}

var _Json_andThen = F2(function(callback, decoder)
{
	return {
		$: 10,
		b: decoder,
		h: callback
	};
});

function _Json_oneOf(decoders)
{
	return {
		$: 11,
		g: decoders
	};
}


// DECODING OBJECTS

var _Json_map1 = F2(function(f, d1)
{
	return _Json_mapMany(f, [d1]);
});

var _Json_map2 = F3(function(f, d1, d2)
{
	return _Json_mapMany(f, [d1, d2]);
});

var _Json_map3 = F4(function(f, d1, d2, d3)
{
	return _Json_mapMany(f, [d1, d2, d3]);
});

var _Json_map4 = F5(function(f, d1, d2, d3, d4)
{
	return _Json_mapMany(f, [d1, d2, d3, d4]);
});

var _Json_map5 = F6(function(f, d1, d2, d3, d4, d5)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5]);
});

var _Json_map6 = F7(function(f, d1, d2, d3, d4, d5, d6)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6]);
});

var _Json_map7 = F8(function(f, d1, d2, d3, d4, d5, d6, d7)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7]);
});

var _Json_map8 = F9(function(f, d1, d2, d3, d4, d5, d6, d7, d8)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7, d8]);
});


// DECODE

var _Json_runOnString = F2(function(decoder, string)
{
	try
	{
		var value = JSON.parse(string);
		return _Json_runHelp(decoder, value);
	}
	catch (e)
	{
		return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'This is not valid JSON! ' + e.message, _Json_wrap(string)));
	}
});

var _Json_run = F2(function(decoder, value)
{
	return _Json_runHelp(decoder, _Json_unwrap(value));
});

function _Json_runHelp(decoder, value)
{
	switch (decoder.$)
	{
		case 2:
			return decoder.b(value);

		case 5:
			return (value === null)
				? $elm$core$Result$Ok(decoder.c)
				: _Json_expecting('null', value);

		case 3:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('a LIST', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _List_fromArray);

		case 4:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _Json_toElmArray);

		case 6:
			var field = decoder.d;
			if (typeof value !== 'object' || value === null || !(field in value))
			{
				return _Json_expecting('an OBJECT with a field named `' + field + '`', value);
			}
			var result = _Json_runHelp(decoder.b, value[field]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, field, result.a));

		case 7:
			var index = decoder.e;
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			if (index >= value.length)
			{
				return _Json_expecting('a LONGER array. Need index ' + index + ' but only see ' + value.length + ' entries', value);
			}
			var result = _Json_runHelp(decoder.b, value[index]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, index, result.a));

		case 8:
			if (typeof value !== 'object' || value === null || _Json_isArray(value))
			{
				return _Json_expecting('an OBJECT', value);
			}

			var keyValuePairs = _List_Nil;
			// TODO test perf of Object.keys and switch when support is good enough
			for (var key in value)
			{
				if (value.hasOwnProperty(key))
				{
					var result = _Json_runHelp(decoder.b, value[key]);
					if (!$elm$core$Result$isOk(result))
					{
						return $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, key, result.a));
					}
					keyValuePairs = _List_Cons(_Utils_Tuple2(key, result.a), keyValuePairs);
				}
			}
			return $elm$core$Result$Ok($elm$core$List$reverse(keyValuePairs));

		case 9:
			var answer = decoder.f;
			var decoders = decoder.g;
			for (var i = 0; i < decoders.length; i++)
			{
				var result = _Json_runHelp(decoders[i], value);
				if (!$elm$core$Result$isOk(result))
				{
					return result;
				}
				answer = answer(result.a);
			}
			return $elm$core$Result$Ok(answer);

		case 10:
			var result = _Json_runHelp(decoder.b, value);
			return (!$elm$core$Result$isOk(result))
				? result
				: _Json_runHelp(decoder.h(result.a), value);

		case 11:
			var errors = _List_Nil;
			for (var temp = decoder.g; temp.b; temp = temp.b) // WHILE_CONS
			{
				var result = _Json_runHelp(temp.a, value);
				if ($elm$core$Result$isOk(result))
				{
					return result;
				}
				errors = _List_Cons(result.a, errors);
			}
			return $elm$core$Result$Err($elm$json$Json$Decode$OneOf($elm$core$List$reverse(errors)));

		case 1:
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, decoder.a, _Json_wrap(value)));

		case 0:
			return $elm$core$Result$Ok(decoder.a);
	}
}

function _Json_runArrayDecoder(decoder, value, toElmValue)
{
	var len = value.length;
	var array = new Array(len);
	for (var i = 0; i < len; i++)
	{
		var result = _Json_runHelp(decoder, value[i]);
		if (!$elm$core$Result$isOk(result))
		{
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, i, result.a));
		}
		array[i] = result.a;
	}
	return $elm$core$Result$Ok(toElmValue(array));
}

function _Json_isArray(value)
{
	return Array.isArray(value) || (typeof FileList !== 'undefined' && value instanceof FileList);
}

function _Json_toElmArray(array)
{
	return A2($elm$core$Array$initialize, array.length, function(i) { return array[i]; });
}

function _Json_expecting(type, value)
{
	return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'Expecting ' + type, _Json_wrap(value)));
}


// EQUALITY

function _Json_equality(x, y)
{
	if (x === y)
	{
		return true;
	}

	if (x.$ !== y.$)
	{
		return false;
	}

	switch (x.$)
	{
		case 0:
		case 1:
			return x.a === y.a;

		case 2:
			return x.b === y.b;

		case 5:
			return x.c === y.c;

		case 3:
		case 4:
		case 8:
			return _Json_equality(x.b, y.b);

		case 6:
			return x.d === y.d && _Json_equality(x.b, y.b);

		case 7:
			return x.e === y.e && _Json_equality(x.b, y.b);

		case 9:
			return x.f === y.f && _Json_listEquality(x.g, y.g);

		case 10:
			return x.h === y.h && _Json_equality(x.b, y.b);

		case 11:
			return _Json_listEquality(x.g, y.g);
	}
}

function _Json_listEquality(aDecoders, bDecoders)
{
	var len = aDecoders.length;
	if (len !== bDecoders.length)
	{
		return false;
	}
	for (var i = 0; i < len; i++)
	{
		if (!_Json_equality(aDecoders[i], bDecoders[i]))
		{
			return false;
		}
	}
	return true;
}


// ENCODE

var _Json_encode = F2(function(indentLevel, value)
{
	return JSON.stringify(_Json_unwrap(value), null, indentLevel) + '';
});

function _Json_wrap_UNUSED(value) { return { $: 0, a: value }; }
function _Json_unwrap_UNUSED(value) { return value.a; }

function _Json_wrap(value) { return value; }
function _Json_unwrap(value) { return value; }

function _Json_emptyArray() { return []; }
function _Json_emptyObject() { return {}; }

var _Json_addField = F3(function(key, value, object)
{
	object[key] = _Json_unwrap(value);
	return object;
});

function _Json_addEntry(func)
{
	return F2(function(entry, array)
	{
		array.push(_Json_unwrap(func(entry)));
		return array;
	});
}

var _Json_encodeNull = _Json_wrap(null);



// TASKS

function _Scheduler_succeed(value)
{
	return {
		$: 0,
		a: value
	};
}

function _Scheduler_fail(error)
{
	return {
		$: 1,
		a: error
	};
}

function _Scheduler_binding(callback)
{
	return {
		$: 2,
		b: callback,
		c: null
	};
}

var _Scheduler_andThen = F2(function(callback, task)
{
	return {
		$: 3,
		b: callback,
		d: task
	};
});

var _Scheduler_onError = F2(function(callback, task)
{
	return {
		$: 4,
		b: callback,
		d: task
	};
});

function _Scheduler_receive(callback)
{
	return {
		$: 5,
		b: callback
	};
}


// PROCESSES

var _Scheduler_guid = 0;

function _Scheduler_rawSpawn(task)
{
	var proc = {
		$: 0,
		e: _Scheduler_guid++,
		f: task,
		g: null,
		h: []
	};

	_Scheduler_enqueue(proc);

	return proc;
}

function _Scheduler_spawn(task)
{
	return _Scheduler_binding(function(callback) {
		callback(_Scheduler_succeed(_Scheduler_rawSpawn(task)));
	});
}

function _Scheduler_rawSend(proc, msg)
{
	proc.h.push(msg);
	_Scheduler_enqueue(proc);
}

var _Scheduler_send = F2(function(proc, msg)
{
	return _Scheduler_binding(function(callback) {
		_Scheduler_rawSend(proc, msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});

function _Scheduler_kill(proc)
{
	return _Scheduler_binding(function(callback) {
		var task = proc.f;
		if (task.$ === 2 && task.c)
		{
			task.c();
		}

		proc.f = null;

		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
}


/* STEP PROCESSES

type alias Process =
  { $ : tag
  , id : unique_id
  , root : Task
  , stack : null | { $: SUCCEED | FAIL, a: callback, b: stack }
  , mailbox : [msg]
  }

*/


var _Scheduler_working = false;
var _Scheduler_queue = [];


function _Scheduler_enqueue(proc)
{
	_Scheduler_queue.push(proc);
	if (_Scheduler_working)
	{
		return;
	}
	_Scheduler_working = true;
	while (proc = _Scheduler_queue.shift())
	{
		_Scheduler_step(proc);
	}
	_Scheduler_working = false;
}


function _Scheduler_step(proc)
{
	while (proc.f)
	{
		var rootTag = proc.f.$;
		if (rootTag === 0 || rootTag === 1)
		{
			while (proc.g && proc.g.$ !== rootTag)
			{
				proc.g = proc.g.i;
			}
			if (!proc.g)
			{
				return;
			}
			proc.f = proc.g.b(proc.f.a);
			proc.g = proc.g.i;
		}
		else if (rootTag === 2)
		{
			proc.f.c = proc.f.b(function(newRoot) {
				proc.f = newRoot;
				_Scheduler_enqueue(proc);
			});
			return;
		}
		else if (rootTag === 5)
		{
			if (proc.h.length === 0)
			{
				return;
			}
			proc.f = proc.f.b(proc.h.shift());
		}
		else // if (rootTag === 3 || rootTag === 4)
		{
			proc.g = {
				$: rootTag === 3 ? 0 : 1,
				b: proc.f.b,
				i: proc.g
			};
			proc.f = proc.f.d;
		}
	}
}



function _Process_sleep(time)
{
	return _Scheduler_binding(function(callback) {
		var id = setTimeout(function() {
			callback(_Scheduler_succeed(_Utils_Tuple0));
		}, time);

		return function() { clearTimeout(id); };
	});
}




// PROGRAMS


var _Platform_worker = F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.dH,
		impl.ex,
		impl.em,
		function() { return function() {} }
	);
});



// INITIALIZE A PROGRAM


function _Platform_initialize(flagDecoder, args, init, update, subscriptions, stepperBuilder)
{
	var result = A2(_Json_run, flagDecoder, _Json_wrap(args ? args['flags'] : undefined));
	$elm$core$Result$isOk(result) || _Debug_crash(2 /**_UNUSED/, _Json_errorToString(result.a) /**/);
	var managers = {};
	var initPair = init(result.a);
	var model = initPair.a;
	var stepper = stepperBuilder(sendToApp, model);
	var ports = _Platform_setupEffects(managers, sendToApp);

	function sendToApp(msg, viewMetadata)
	{
		var pair = A2(update, msg, model);
		stepper(model = pair.a, viewMetadata);
		_Platform_enqueueEffects(managers, pair.b, subscriptions(model));
	}

	_Platform_enqueueEffects(managers, initPair.b, subscriptions(model));

	return ports ? { ports: ports } : {};
}



// TRACK PRELOADS
//
// This is used by code in elm/browser and elm/http
// to register any HTTP requests that are triggered by init.
//


var _Platform_preload;


function _Platform_registerPreload(url)
{
	_Platform_preload.add(url);
}



// EFFECT MANAGERS


var _Platform_effectManagers = {};


function _Platform_setupEffects(managers, sendToApp)
{
	var ports;

	// setup all necessary effect managers
	for (var key in _Platform_effectManagers)
	{
		var manager = _Platform_effectManagers[key];

		if (manager.a)
		{
			ports = ports || {};
			ports[key] = manager.a(key, sendToApp);
		}

		managers[key] = _Platform_instantiateManager(manager, sendToApp);
	}

	return ports;
}


function _Platform_createManager(init, onEffects, onSelfMsg, cmdMap, subMap)
{
	return {
		b: init,
		c: onEffects,
		d: onSelfMsg,
		e: cmdMap,
		f: subMap
	};
}


function _Platform_instantiateManager(info, sendToApp)
{
	var router = {
		g: sendToApp,
		h: undefined
	};

	var onEffects = info.c;
	var onSelfMsg = info.d;
	var cmdMap = info.e;
	var subMap = info.f;

	function loop(state)
	{
		return A2(_Scheduler_andThen, loop, _Scheduler_receive(function(msg)
		{
			var value = msg.a;

			if (msg.$ === 0)
			{
				return A3(onSelfMsg, router, value, state);
			}

			return cmdMap && subMap
				? A4(onEffects, router, value.i, value.j, state)
				: A3(onEffects, router, cmdMap ? value.i : value.j, state);
		}));
	}

	return router.h = _Scheduler_rawSpawn(A2(_Scheduler_andThen, loop, info.b));
}



// ROUTING


var _Platform_sendToApp = F2(function(router, msg)
{
	return _Scheduler_binding(function(callback)
	{
		router.g(msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});


var _Platform_sendToSelf = F2(function(router, msg)
{
	return A2(_Scheduler_send, router.h, {
		$: 0,
		a: msg
	});
});



// BAGS


function _Platform_leaf(home)
{
	return function(value)
	{
		return {
			$: 1,
			k: home,
			l: value
		};
	};
}


function _Platform_batch(list)
{
	return {
		$: 2,
		m: list
	};
}


var _Platform_map = F2(function(tagger, bag)
{
	return {
		$: 3,
		n: tagger,
		o: bag
	}
});



// PIPE BAGS INTO EFFECT MANAGERS
//
// Effects must be queued!
//
// Say your init contains a synchronous command, like Time.now or Time.here
//
//   - This will produce a batch of effects (FX_1)
//   - The synchronous task triggers the subsequent `update` call
//   - This will produce a batch of effects (FX_2)
//
// If we just start dispatching FX_2, subscriptions from FX_2 can be processed
// before subscriptions from FX_1. No good! Earlier versions of this code had
// this problem, leading to these reports:
//
//   https://github.com/elm/core/issues/980
//   https://github.com/elm/core/pull/981
//   https://github.com/elm/compiler/issues/1776
//
// The queue is necessary to avoid ordering issues for synchronous commands.


// Why use true/false here? Why not just check the length of the queue?
// The goal is to detect "are we currently dispatching effects?" If we
// are, we need to bail and let the ongoing while loop handle things.
//
// Now say the queue has 1 element. When we dequeue the final element,
// the queue will be empty, but we are still actively dispatching effects.
// So you could get queue jumping in a really tricky category of cases.
//
var _Platform_effectsQueue = [];
var _Platform_effectsActive = false;


function _Platform_enqueueEffects(managers, cmdBag, subBag)
{
	_Platform_effectsQueue.push({ p: managers, q: cmdBag, r: subBag });

	if (_Platform_effectsActive) return;

	_Platform_effectsActive = true;
	for (var fx; fx = _Platform_effectsQueue.shift(); )
	{
		_Platform_dispatchEffects(fx.p, fx.q, fx.r);
	}
	_Platform_effectsActive = false;
}


function _Platform_dispatchEffects(managers, cmdBag, subBag)
{
	var effectsDict = {};
	_Platform_gatherEffects(true, cmdBag, effectsDict, null);
	_Platform_gatherEffects(false, subBag, effectsDict, null);

	for (var home in managers)
	{
		_Scheduler_rawSend(managers[home], {
			$: 'fx',
			a: effectsDict[home] || { i: _List_Nil, j: _List_Nil }
		});
	}
}


function _Platform_gatherEffects(isCmd, bag, effectsDict, taggers)
{
	switch (bag.$)
	{
		case 1:
			var home = bag.k;
			var effect = _Platform_toEffect(isCmd, home, taggers, bag.l);
			effectsDict[home] = _Platform_insert(isCmd, effect, effectsDict[home]);
			return;

		case 2:
			for (var list = bag.m; list.b; list = list.b) // WHILE_CONS
			{
				_Platform_gatherEffects(isCmd, list.a, effectsDict, taggers);
			}
			return;

		case 3:
			_Platform_gatherEffects(isCmd, bag.o, effectsDict, {
				s: bag.n,
				t: taggers
			});
			return;
	}
}


function _Platform_toEffect(isCmd, home, taggers, value)
{
	function applyTaggers(x)
	{
		for (var temp = taggers; temp; temp = temp.t)
		{
			x = temp.s(x);
		}
		return x;
	}

	var map = isCmd
		? _Platform_effectManagers[home].e
		: _Platform_effectManagers[home].f;

	return A2(map, applyTaggers, value)
}


function _Platform_insert(isCmd, newEffect, effects)
{
	effects = effects || { i: _List_Nil, j: _List_Nil };

	isCmd
		? (effects.i = _List_Cons(newEffect, effects.i))
		: (effects.j = _List_Cons(newEffect, effects.j));

	return effects;
}



// PORTS


function _Platform_checkPortName(name)
{
	if (_Platform_effectManagers[name])
	{
		_Debug_crash(3, name)
	}
}



// OUTGOING PORTS


function _Platform_outgoingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		e: _Platform_outgoingPortMap,
		u: converter,
		a: _Platform_setupOutgoingPort
	};
	return _Platform_leaf(name);
}


var _Platform_outgoingPortMap = F2(function(tagger, value) { return value; });


function _Platform_setupOutgoingPort(name)
{
	var subs = [];
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Process_sleep(0);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, cmdList, state)
	{
		for ( ; cmdList.b; cmdList = cmdList.b) // WHILE_CONS
		{
			// grab a separate reference to subs in case unsubscribe is called
			var currentSubs = subs;
			var value = _Json_unwrap(converter(cmdList.a));
			for (var i = 0; i < currentSubs.length; i++)
			{
				currentSubs[i](value);
			}
		}
		return init;
	});

	// PUBLIC API

	function subscribe(callback)
	{
		subs.push(callback);
	}

	function unsubscribe(callback)
	{
		// copy subs into a new array in case unsubscribe is called within a
		// subscribed callback
		subs = subs.slice();
		var index = subs.indexOf(callback);
		if (index >= 0)
		{
			subs.splice(index, 1);
		}
	}

	return {
		subscribe: subscribe,
		unsubscribe: unsubscribe
	};
}



// INCOMING PORTS


function _Platform_incomingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		f: _Platform_incomingPortMap,
		u: converter,
		a: _Platform_setupIncomingPort
	};
	return _Platform_leaf(name);
}


var _Platform_incomingPortMap = F2(function(tagger, finalTagger)
{
	return function(value)
	{
		return tagger(finalTagger(value));
	};
});


function _Platform_setupIncomingPort(name, sendToApp)
{
	var subs = _List_Nil;
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Scheduler_succeed(null);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, subList, state)
	{
		subs = subList;
		return init;
	});

	// PUBLIC API

	function send(incomingValue)
	{
		var result = A2(_Json_run, converter, _Json_wrap(incomingValue));

		$elm$core$Result$isOk(result) || _Debug_crash(4, name, result.a);

		var value = result.a;
		for (var temp = subs; temp.b; temp = temp.b) // WHILE_CONS
		{
			sendToApp(temp.a(value));
		}
	}

	return { send: send };
}



// EXPORT ELM MODULES
//
// Have DEBUG and PROD versions so that we can (1) give nicer errors in
// debug mode and (2) not pay for the bits needed for that in prod mode.
//


function _Platform_export(exports)
{
	scope['Elm']
		? _Platform_mergeExportsProd(scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsProd(obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6)
				: _Platform_mergeExportsProd(obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}


function _Platform_export_UNUSED(exports)
{
	scope['Elm']
		? _Platform_mergeExportsDebug('Elm', scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsDebug(moduleName, obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6, moduleName)
				: _Platform_mergeExportsDebug(moduleName + '.' + name, obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}




// HELPERS


var _VirtualDom_divertHrefToApp;

var _VirtualDom_doc = typeof document !== 'undefined' ? document : {};


function _VirtualDom_appendChild(parent, child)
{
	parent.appendChild(child);
}

var _VirtualDom_init = F4(function(virtualNode, flagDecoder, debugMetadata, args)
{
	// NOTE: this function needs _Platform_export available to work

	/**/
	var node = args['node'];
	//*/
	/**_UNUSED/
	var node = args && args['node'] ? args['node'] : _Debug_crash(0);
	//*/

	node.parentNode.replaceChild(
		_VirtualDom_render(virtualNode, function() {}),
		node
	);

	return {};
});



// TEXT


function _VirtualDom_text(string)
{
	return {
		$: 0,
		a: string
	};
}



// NODE


var _VirtualDom_nodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 1,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_node = _VirtualDom_nodeNS(undefined);



// KEYED NODE


var _VirtualDom_keyedNodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 2,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_keyedNode = _VirtualDom_keyedNodeNS(undefined);



// CUSTOM


function _VirtualDom_custom(factList, model, render, diff)
{
	return {
		$: 3,
		d: _VirtualDom_organizeFacts(factList),
		g: model,
		h: render,
		i: diff
	};
}



// MAP


var _VirtualDom_map = F2(function(tagger, node)
{
	return {
		$: 4,
		j: tagger,
		k: node,
		b: 1 + (node.b || 0)
	};
});



// LAZY


function _VirtualDom_thunk(refs, thunk)
{
	return {
		$: 5,
		l: refs,
		m: thunk,
		k: undefined
	};
}

var _VirtualDom_lazy = F2(function(func, a)
{
	return _VirtualDom_thunk([func, a], function() {
		return func(a);
	});
});

var _VirtualDom_lazy2 = F3(function(func, a, b)
{
	return _VirtualDom_thunk([func, a, b], function() {
		return A2(func, a, b);
	});
});

var _VirtualDom_lazy3 = F4(function(func, a, b, c)
{
	return _VirtualDom_thunk([func, a, b, c], function() {
		return A3(func, a, b, c);
	});
});

var _VirtualDom_lazy4 = F5(function(func, a, b, c, d)
{
	return _VirtualDom_thunk([func, a, b, c, d], function() {
		return A4(func, a, b, c, d);
	});
});

var _VirtualDom_lazy5 = F6(function(func, a, b, c, d, e)
{
	return _VirtualDom_thunk([func, a, b, c, d, e], function() {
		return A5(func, a, b, c, d, e);
	});
});

var _VirtualDom_lazy6 = F7(function(func, a, b, c, d, e, f)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f], function() {
		return A6(func, a, b, c, d, e, f);
	});
});

var _VirtualDom_lazy7 = F8(function(func, a, b, c, d, e, f, g)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g], function() {
		return A7(func, a, b, c, d, e, f, g);
	});
});

var _VirtualDom_lazy8 = F9(function(func, a, b, c, d, e, f, g, h)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g, h], function() {
		return A8(func, a, b, c, d, e, f, g, h);
	});
});



// FACTS


var _VirtualDom_on = F2(function(key, handler)
{
	return {
		$: 'a0',
		n: key,
		o: handler
	};
});
var _VirtualDom_style = F2(function(key, value)
{
	return {
		$: 'a1',
		n: key,
		o: value
	};
});
var _VirtualDom_property = F2(function(key, value)
{
	return {
		$: 'a2',
		n: key,
		o: value
	};
});
var _VirtualDom_attribute = F2(function(key, value)
{
	return {
		$: 'a3',
		n: key,
		o: value
	};
});
var _VirtualDom_attributeNS = F3(function(namespace, key, value)
{
	return {
		$: 'a4',
		n: key,
		o: { f: namespace, o: value }
	};
});



// XSS ATTACK VECTOR CHECKS


function _VirtualDom_noScript(tag)
{
	return tag == 'script' ? 'p' : tag;
}

function _VirtualDom_noOnOrFormAction(key)
{
	return /^(on|formAction$)/i.test(key) ? 'data-' + key : key;
}

function _VirtualDom_noInnerHtmlOrFormAction(key)
{
	return key == 'innerHTML' || key == 'formAction' ? 'data-' + key : key;
}

function _VirtualDom_noJavaScriptUri(value)
{
	return /^javascript:/i.test(value.replace(/\s/g,'')) ? '' : value;
}

function _VirtualDom_noJavaScriptUri_UNUSED(value)
{
	return /^javascript:/i.test(value.replace(/\s/g,''))
		? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlUri(value)
{
	return /^\s*(javascript:|data:text\/html)/i.test(value) ? '' : value;
}

function _VirtualDom_noJavaScriptOrHtmlUri_UNUSED(value)
{
	return /^\s*(javascript:|data:text\/html)/i.test(value)
		? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
		: value;
}



// MAP FACTS


var _VirtualDom_mapAttribute = F2(function(func, attr)
{
	return (attr.$ === 'a0')
		? A2(_VirtualDom_on, attr.n, _VirtualDom_mapHandler(func, attr.o))
		: attr;
});

function _VirtualDom_mapHandler(func, handler)
{
	var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

	// 0 = Normal
	// 1 = MayStopPropagation
	// 2 = MayPreventDefault
	// 3 = Custom

	return {
		$: handler.$,
		a:
			!tag
				? A2($elm$json$Json$Decode$map, func, handler.a)
				:
			A3($elm$json$Json$Decode$map2,
				tag < 3
					? _VirtualDom_mapEventTuple
					: _VirtualDom_mapEventRecord,
				$elm$json$Json$Decode$succeed(func),
				handler.a
			)
	};
}

var _VirtualDom_mapEventTuple = F2(function(func, tuple)
{
	return _Utils_Tuple2(func(tuple.a), tuple.b);
});

var _VirtualDom_mapEventRecord = F2(function(func, record)
{
	return {
		bT: func(record.bT),
		avG: record.avG,
		avg: record.avg
	}
});



// ORGANIZE FACTS


function _VirtualDom_organizeFacts(factList)
{
	for (var facts = {}; factList.b; factList = factList.b) // WHILE_CONS
	{
		var entry = factList.a;

		var tag = entry.$;
		var key = entry.n;
		var value = entry.o;

		if (tag === 'a2')
		{
			(key === 'className')
				? _VirtualDom_addClass(facts, key, _Json_unwrap(value))
				: facts[key] = _Json_unwrap(value);

			continue;
		}

		var subFacts = facts[tag] || (facts[tag] = {});
		(tag === 'a3' && key === 'class')
			? _VirtualDom_addClass(subFacts, key, value)
			: subFacts[key] = value;
	}

	return facts;
}

function _VirtualDom_addClass(object, key, newClass)
{
	var classes = object[key];
	object[key] = classes ? classes + ' ' + newClass : newClass;
}



// RENDER


function _VirtualDom_render(vNode, eventNode)
{
	var tag = vNode.$;

	if (tag === 5)
	{
		return _VirtualDom_render(vNode.k || (vNode.k = vNode.m()), eventNode);
	}

	if (tag === 0)
	{
		return _VirtualDom_doc.createTextNode(vNode.a);
	}

	if (tag === 4)
	{
		var subNode = vNode.k;
		var tagger = vNode.j;

		while (subNode.$ === 4)
		{
			typeof tagger !== 'object'
				? tagger = [tagger, subNode.j]
				: tagger.push(subNode.j);

			subNode = subNode.k;
		}

		var subEventRoot = { j: tagger, p: eventNode };
		var domNode = _VirtualDom_render(subNode, subEventRoot);
		domNode.elm_event_node_ref = subEventRoot;
		return domNode;
	}

	if (tag === 3)
	{
		var domNode = vNode.h(vNode.g);
		_VirtualDom_applyFacts(domNode, eventNode, vNode.d);
		return domNode;
	}

	// at this point `tag` must be 1 or 2

	var domNode = vNode.f
		? _VirtualDom_doc.createElementNS(vNode.f, vNode.c)
		: _VirtualDom_doc.createElement(vNode.c);

	if (_VirtualDom_divertHrefToApp && vNode.c == 'a')
	{
		domNode.addEventListener('click', _VirtualDom_divertHrefToApp(domNode));
	}

	_VirtualDom_applyFacts(domNode, eventNode, vNode.d);

	for (var kids = vNode.e, i = 0; i < kids.length; i++)
	{
		_VirtualDom_appendChild(domNode, _VirtualDom_render(tag === 1 ? kids[i] : kids[i].b, eventNode));
	}

	return domNode;
}



// APPLY FACTS


function _VirtualDom_applyFacts(domNode, eventNode, facts)
{
	for (var key in facts)
	{
		var value = facts[key];

		key === 'a1'
			? _VirtualDom_applyStyles(domNode, value)
			:
		key === 'a0'
			? _VirtualDom_applyEvents(domNode, eventNode, value)
			:
		key === 'a3'
			? _VirtualDom_applyAttrs(domNode, value)
			:
		key === 'a4'
			? _VirtualDom_applyAttrsNS(domNode, value)
			:
		((key !== 'value' && key !== 'checked') || domNode[key] !== value) && (domNode[key] = value);
	}
}



// APPLY STYLES


function _VirtualDom_applyStyles(domNode, styles)
{
	var domNodeStyle = domNode.style;

	for (var key in styles)
	{
		domNodeStyle[key] = styles[key];
	}
}



// APPLY ATTRS


function _VirtualDom_applyAttrs(domNode, attrs)
{
	for (var key in attrs)
	{
		var value = attrs[key];
		typeof value !== 'undefined'
			? domNode.setAttribute(key, value)
			: domNode.removeAttribute(key);
	}
}



// APPLY NAMESPACED ATTRS


function _VirtualDom_applyAttrsNS(domNode, nsAttrs)
{
	for (var key in nsAttrs)
	{
		var pair = nsAttrs[key];
		var namespace = pair.f;
		var value = pair.o;

		typeof value !== 'undefined'
			? domNode.setAttributeNS(namespace, key, value)
			: domNode.removeAttributeNS(namespace, key);
	}
}



// APPLY EVENTS


function _VirtualDom_applyEvents(domNode, eventNode, events)
{
	var allCallbacks = domNode.elmFs || (domNode.elmFs = {});

	for (var key in events)
	{
		var newHandler = events[key];
		var oldCallback = allCallbacks[key];

		if (!newHandler)
		{
			domNode.removeEventListener(key, oldCallback);
			allCallbacks[key] = undefined;
			continue;
		}

		if (oldCallback)
		{
			var oldHandler = oldCallback.q;
			if (oldHandler.$ === newHandler.$)
			{
				oldCallback.q = newHandler;
				continue;
			}
			domNode.removeEventListener(key, oldCallback);
		}

		oldCallback = _VirtualDom_makeCallback(eventNode, newHandler);
		domNode.addEventListener(key, oldCallback,
			_VirtualDom_passiveSupported
			&& { passive: $elm$virtual_dom$VirtualDom$toHandlerInt(newHandler) < 2 }
		);
		allCallbacks[key] = oldCallback;
	}
}



// PASSIVE EVENTS


var _VirtualDom_passiveSupported;

try
{
	window.addEventListener('t', null, Object.defineProperty({}, 'passive', {
		get: function() { _VirtualDom_passiveSupported = true; }
	}));
}
catch(e) {}



// EVENT HANDLERS


function _VirtualDom_makeCallback(eventNode, initialHandler)
{
	function callback(event)
	{
		var handler = callback.q;
		var result = _Json_runHelp(handler.a, event);

		if (!$elm$core$Result$isOk(result))
		{
			return;
		}

		var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

		// 0 = Normal
		// 1 = MayStopPropagation
		// 2 = MayPreventDefault
		// 3 = Custom

		var value = result.a;
		var message = !tag ? value : tag < 3 ? value.a : value.bT;
		var stopPropagation = tag == 1 ? value.b : tag == 3 && value.avG;
		var currentEventNode = (
			stopPropagation && event.stopPropagation(),
			(tag == 2 ? value.b : tag == 3 && value.avg) && event.preventDefault(),
			eventNode
		);
		var tagger;
		var i;
		while (tagger = currentEventNode.j)
		{
			if (typeof tagger == 'function')
			{
				message = tagger(message);
			}
			else
			{
				for (var i = tagger.length; i--; )
				{
					message = tagger[i](message);
				}
			}
			currentEventNode = currentEventNode.p;
		}
		currentEventNode(message, stopPropagation); // stopPropagation implies isSync
	}

	callback.q = initialHandler;

	return callback;
}

function _VirtualDom_equalEvents(x, y)
{
	return x.$ == y.$ && _Json_equality(x.a, y.a);
}



// DIFF


// TODO: Should we do patches like in iOS?
//
// type Patch
//   = At Int Patch
//   | Batch (List Patch)
//   | Change ...
//
// How could it not be better?
//
function _VirtualDom_diff(x, y)
{
	var patches = [];
	_VirtualDom_diffHelp(x, y, patches, 0);
	return patches;
}


function _VirtualDom_pushPatch(patches, type, index, data)
{
	var patch = {
		$: type,
		r: index,
		s: data,
		t: undefined,
		u: undefined
	};
	patches.push(patch);
	return patch;
}


function _VirtualDom_diffHelp(x, y, patches, index)
{
	if (x === y)
	{
		return;
	}

	var xType = x.$;
	var yType = y.$;

	// Bail if you run into different types of nodes. Implies that the
	// structure has changed significantly and it's not worth a diff.
	if (xType !== yType)
	{
		if (xType === 1 && yType === 2)
		{
			y = _VirtualDom_dekey(y);
			yType = 1;
		}
		else
		{
			_VirtualDom_pushPatch(patches, 0, index, y);
			return;
		}
	}

	// Now we know that both nodes are the same $.
	switch (yType)
	{
		case 5:
			var xRefs = x.l;
			var yRefs = y.l;
			var i = xRefs.length;
			var same = i === yRefs.length;
			while (same && i--)
			{
				same = xRefs[i] === yRefs[i];
			}
			if (same)
			{
				y.k = x.k;
				return;
			}
			y.k = y.m();
			var subPatches = [];
			_VirtualDom_diffHelp(x.k, y.k, subPatches, 0);
			subPatches.length > 0 && _VirtualDom_pushPatch(patches, 1, index, subPatches);
			return;

		case 4:
			// gather nested taggers
			var xTaggers = x.j;
			var yTaggers = y.j;
			var nesting = false;

			var xSubNode = x.k;
			while (xSubNode.$ === 4)
			{
				nesting = true;

				typeof xTaggers !== 'object'
					? xTaggers = [xTaggers, xSubNode.j]
					: xTaggers.push(xSubNode.j);

				xSubNode = xSubNode.k;
			}

			var ySubNode = y.k;
			while (ySubNode.$ === 4)
			{
				nesting = true;

				typeof yTaggers !== 'object'
					? yTaggers = [yTaggers, ySubNode.j]
					: yTaggers.push(ySubNode.j);

				ySubNode = ySubNode.k;
			}

			// Just bail if different numbers of taggers. This implies the
			// structure of the virtual DOM has changed.
			if (nesting && xTaggers.length !== yTaggers.length)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			// check if taggers are "the same"
			if (nesting ? !_VirtualDom_pairwiseRefEqual(xTaggers, yTaggers) : xTaggers !== yTaggers)
			{
				_VirtualDom_pushPatch(patches, 2, index, yTaggers);
			}

			// diff everything below the taggers
			_VirtualDom_diffHelp(xSubNode, ySubNode, patches, index + 1);
			return;

		case 0:
			if (x.a !== y.a)
			{
				_VirtualDom_pushPatch(patches, 3, index, y.a);
			}
			return;

		case 1:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKids);
			return;

		case 2:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKeyedKids);
			return;

		case 3:
			if (x.h !== y.h)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
			factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

			var patch = y.i(x.g, y.g);
			patch && _VirtualDom_pushPatch(patches, 5, index, patch);

			return;
	}
}

// assumes the incoming arrays are the same length
function _VirtualDom_pairwiseRefEqual(as, bs)
{
	for (var i = 0; i < as.length; i++)
	{
		if (as[i] !== bs[i])
		{
			return false;
		}
	}

	return true;
}

function _VirtualDom_diffNodes(x, y, patches, index, diffKids)
{
	// Bail if obvious indicators have changed. Implies more serious
	// structural changes such that it's not worth it to diff.
	if (x.c !== y.c || x.f !== y.f)
	{
		_VirtualDom_pushPatch(patches, 0, index, y);
		return;
	}

	var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
	factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

	diffKids(x, y, patches, index);
}



// DIFF FACTS


// TODO Instead of creating a new diff object, it's possible to just test if
// there *is* a diff. During the actual patch, do the diff again and make the
// modifications directly. This way, there's no new allocations. Worth it?
function _VirtualDom_diffFacts(x, y, category)
{
	var diff;

	// look for changes and removals
	for (var xKey in x)
	{
		if (xKey === 'a1' || xKey === 'a0' || xKey === 'a3' || xKey === 'a4')
		{
			var subDiff = _VirtualDom_diffFacts(x[xKey], y[xKey] || {}, xKey);
			if (subDiff)
			{
				diff = diff || {};
				diff[xKey] = subDiff;
			}
			continue;
		}

		// remove if not in the new facts
		if (!(xKey in y))
		{
			diff = diff || {};
			diff[xKey] =
				!category
					? (typeof x[xKey] === 'string' ? '' : null)
					:
				(category === 'a1')
					? ''
					:
				(category === 'a0' || category === 'a3')
					? undefined
					:
				{ f: x[xKey].f, o: undefined };

			continue;
		}

		var xValue = x[xKey];
		var yValue = y[xKey];

		// reference equal, so don't worry about it
		if (xValue === yValue && xKey !== 'value' && xKey !== 'checked'
			|| category === 'a0' && _VirtualDom_equalEvents(xValue, yValue))
		{
			continue;
		}

		diff = diff || {};
		diff[xKey] = yValue;
	}

	// add new stuff
	for (var yKey in y)
	{
		if (!(yKey in x))
		{
			diff = diff || {};
			diff[yKey] = y[yKey];
		}
	}

	return diff;
}



// DIFF KIDS


function _VirtualDom_diffKids(xParent, yParent, patches, index)
{
	var xKids = xParent.e;
	var yKids = yParent.e;

	var xLen = xKids.length;
	var yLen = yKids.length;

	// FIGURE OUT IF THERE ARE INSERTS OR REMOVALS

	if (xLen > yLen)
	{
		_VirtualDom_pushPatch(patches, 6, index, {
			v: yLen,
			i: xLen - yLen
		});
	}
	else if (xLen < yLen)
	{
		_VirtualDom_pushPatch(patches, 7, index, {
			v: xLen,
			e: yKids
		});
	}

	// PAIRWISE DIFF EVERYTHING ELSE

	for (var minLen = xLen < yLen ? xLen : yLen, i = 0; i < minLen; i++)
	{
		var xKid = xKids[i];
		_VirtualDom_diffHelp(xKid, yKids[i], patches, ++index);
		index += xKid.b || 0;
	}
}



// KEYED DIFF


function _VirtualDom_diffKeyedKids(xParent, yParent, patches, rootIndex)
{
	var localPatches = [];

	var changes = {}; // Dict String Entry
	var inserts = []; // Array { index : Int, entry : Entry }
	// type Entry = { tag : String, vnode : VNode, index : Int, data : _ }

	var xKids = xParent.e;
	var yKids = yParent.e;
	var xLen = xKids.length;
	var yLen = yKids.length;
	var xIndex = 0;
	var yIndex = 0;

	var index = rootIndex;

	while (xIndex < xLen && yIndex < yLen)
	{
		var x = xKids[xIndex];
		var y = yKids[yIndex];

		var xKey = x.a;
		var yKey = y.a;
		var xNode = x.b;
		var yNode = y.b;

		var newMatch = undefined;
		var oldMatch = undefined;

		// check if keys match

		if (xKey === yKey)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNode, localPatches, index);
			index += xNode.b || 0;

			xIndex++;
			yIndex++;
			continue;
		}

		// look ahead 1 to detect insertions and removals.

		var xNext = xKids[xIndex + 1];
		var yNext = yKids[yIndex + 1];

		if (xNext)
		{
			var xNextKey = xNext.a;
			var xNextNode = xNext.b;
			oldMatch = yKey === xNextKey;
		}

		if (yNext)
		{
			var yNextKey = yNext.a;
			var yNextNode = yNext.b;
			newMatch = xKey === yNextKey;
		}


		// swap x and y
		if (newMatch && oldMatch)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			_VirtualDom_insertNode(changes, localPatches, xKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNextNode, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		// insert y
		if (newMatch)
		{
			index++;
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			index += xNode.b || 0;

			xIndex += 1;
			yIndex += 2;
			continue;
		}

		// remove x
		if (oldMatch)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 1;
			continue;
		}

		// remove x, insert y
		if (xNext && xNextKey === yNextKey)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNextNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		break;
	}

	// eat up any remaining nodes with removeNode and insertNode

	while (xIndex < xLen)
	{
		index++;
		var x = xKids[xIndex];
		var xNode = x.b;
		_VirtualDom_removeNode(changes, localPatches, x.a, xNode, index);
		index += xNode.b || 0;
		xIndex++;
	}

	while (yIndex < yLen)
	{
		var endInserts = endInserts || [];
		var y = yKids[yIndex];
		_VirtualDom_insertNode(changes, localPatches, y.a, y.b, undefined, endInserts);
		yIndex++;
	}

	if (localPatches.length > 0 || inserts.length > 0 || endInserts)
	{
		_VirtualDom_pushPatch(patches, 8, rootIndex, {
			w: localPatches,
			x: inserts,
			y: endInserts
		});
	}
}



// CHANGES FROM KEYED DIFF


var _VirtualDom_POSTFIX = '_elmW6BL';


function _VirtualDom_insertNode(changes, localPatches, key, vnode, yIndex, inserts)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		entry = {
			c: 0,
			z: vnode,
			r: yIndex,
			s: undefined
		};

		inserts.push({ r: yIndex, A: entry });
		changes[key] = entry;

		return;
	}

	// this key was removed earlier, a match!
	if (entry.c === 1)
	{
		inserts.push({ r: yIndex, A: entry });

		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(entry.z, vnode, subPatches, entry.r);
		entry.r = yIndex;
		entry.s.s = {
			w: subPatches,
			A: entry
		};

		return;
	}

	// this key has already been inserted or moved, a duplicate!
	_VirtualDom_insertNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, yIndex, inserts);
}


function _VirtualDom_removeNode(changes, localPatches, key, vnode, index)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		var patch = _VirtualDom_pushPatch(localPatches, 9, index, undefined);

		changes[key] = {
			c: 1,
			z: vnode,
			r: index,
			s: patch
		};

		return;
	}

	// this key was inserted earlier, a match!
	if (entry.c === 0)
	{
		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(vnode, entry.z, subPatches, index);

		_VirtualDom_pushPatch(localPatches, 9, index, {
			w: subPatches,
			A: entry
		});

		return;
	}

	// this key has already been removed or moved, a duplicate!
	_VirtualDom_removeNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, index);
}



// ADD DOM NODES
//
// Each DOM node has an "index" assigned in order of traversal. It is important
// to minimize our crawl over the actual DOM, so these indexes (along with the
// descendantsCount of virtual nodes) let us skip touching entire subtrees of
// the DOM if we know there are no patches there.


function _VirtualDom_addDomNodes(domNode, vNode, patches, eventNode)
{
	_VirtualDom_addDomNodesHelp(domNode, vNode, patches, 0, 0, vNode.b, eventNode);
}


// assumes `patches` is non-empty and indexes increase monotonically.
function _VirtualDom_addDomNodesHelp(domNode, vNode, patches, i, low, high, eventNode)
{
	var patch = patches[i];
	var index = patch.r;

	while (index === low)
	{
		var patchType = patch.$;

		if (patchType === 1)
		{
			_VirtualDom_addDomNodes(domNode, vNode.k, patch.s, eventNode);
		}
		else if (patchType === 8)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var subPatches = patch.s.w;
			if (subPatches.length > 0)
			{
				_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
			}
		}
		else if (patchType === 9)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var data = patch.s;
			if (data)
			{
				data.A.s = domNode;
				var subPatches = data.w;
				if (subPatches.length > 0)
				{
					_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
				}
			}
		}
		else
		{
			patch.t = domNode;
			patch.u = eventNode;
		}

		i++;

		if (!(patch = patches[i]) || (index = patch.r) > high)
		{
			return i;
		}
	}

	var tag = vNode.$;

	if (tag === 4)
	{
		var subNode = vNode.k;

		while (subNode.$ === 4)
		{
			subNode = subNode.k;
		}

		return _VirtualDom_addDomNodesHelp(domNode, subNode, patches, i, low + 1, high, domNode.elm_event_node_ref);
	}

	// tag must be 1 or 2 at this point

	var vKids = vNode.e;
	var childNodes = domNode.childNodes;
	for (var j = 0; j < vKids.length; j++)
	{
		low++;
		var vKid = tag === 1 ? vKids[j] : vKids[j].b;
		var nextLow = low + (vKid.b || 0);
		if (low <= index && index <= nextLow)
		{
			i = _VirtualDom_addDomNodesHelp(childNodes[j], vKid, patches, i, low, nextLow, eventNode);
			if (!(patch = patches[i]) || (index = patch.r) > high)
			{
				return i;
			}
		}
		low = nextLow;
	}
	return i;
}



// APPLY PATCHES


function _VirtualDom_applyPatches(rootDomNode, oldVirtualNode, patches, eventNode)
{
	if (patches.length === 0)
	{
		return rootDomNode;
	}

	_VirtualDom_addDomNodes(rootDomNode, oldVirtualNode, patches, eventNode);
	return _VirtualDom_applyPatchesHelp(rootDomNode, patches);
}

function _VirtualDom_applyPatchesHelp(rootDomNode, patches)
{
	for (var i = 0; i < patches.length; i++)
	{
		var patch = patches[i];
		var localDomNode = patch.t
		var newNode = _VirtualDom_applyPatch(localDomNode, patch);
		if (localDomNode === rootDomNode)
		{
			rootDomNode = newNode;
		}
	}
	return rootDomNode;
}

function _VirtualDom_applyPatch(domNode, patch)
{
	switch (patch.$)
	{
		case 0:
			return _VirtualDom_applyPatchRedraw(domNode, patch.s, patch.u);

		case 4:
			_VirtualDom_applyFacts(domNode, patch.u, patch.s);
			return domNode;

		case 3:
			domNode.replaceData(0, domNode.length, patch.s);
			return domNode;

		case 1:
			return _VirtualDom_applyPatchesHelp(domNode, patch.s);

		case 2:
			if (domNode.elm_event_node_ref)
			{
				domNode.elm_event_node_ref.j = patch.s;
			}
			else
			{
				domNode.elm_event_node_ref = { j: patch.s, p: patch.u };
			}
			return domNode;

		case 6:
			var data = patch.s;
			for (var i = 0; i < data.i; i++)
			{
				domNode.removeChild(domNode.childNodes[data.v]);
			}
			return domNode;

		case 7:
			var data = patch.s;
			var kids = data.e;
			var i = data.v;
			var theEnd = domNode.childNodes[i];
			for (; i < kids.length; i++)
			{
				domNode.insertBefore(_VirtualDom_render(kids[i], patch.u), theEnd);
			}
			return domNode;

		case 9:
			var data = patch.s;
			if (!data)
			{
				domNode.parentNode.removeChild(domNode);
				return domNode;
			}
			var entry = data.A;
			if (typeof entry.r !== 'undefined')
			{
				domNode.parentNode.removeChild(domNode);
			}
			entry.s = _VirtualDom_applyPatchesHelp(domNode, data.w);
			return domNode;

		case 8:
			return _VirtualDom_applyPatchReorder(domNode, patch);

		case 5:
			return patch.s(domNode);

		default:
			_Debug_crash(10); // 'Ran into an unknown patch!'
	}
}


function _VirtualDom_applyPatchRedraw(domNode, vNode, eventNode)
{
	var parentNode = domNode.parentNode;
	var newNode = _VirtualDom_render(vNode, eventNode);

	if (!newNode.elm_event_node_ref)
	{
		newNode.elm_event_node_ref = domNode.elm_event_node_ref;
	}

	if (parentNode && newNode !== domNode)
	{
		parentNode.replaceChild(newNode, domNode);
	}
	return newNode;
}


function _VirtualDom_applyPatchReorder(domNode, patch)
{
	var data = patch.s;

	// remove end inserts
	var frag = _VirtualDom_applyPatchReorderEndInsertsHelp(data.y, patch);

	// removals
	domNode = _VirtualDom_applyPatchesHelp(domNode, data.w);

	// inserts
	var inserts = data.x;
	for (var i = 0; i < inserts.length; i++)
	{
		var insert = inserts[i];
		var entry = insert.A;
		var node = entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u);
		domNode.insertBefore(node, domNode.childNodes[insert.r]);
	}

	// add end inserts
	if (frag)
	{
		_VirtualDom_appendChild(domNode, frag);
	}

	return domNode;
}


function _VirtualDom_applyPatchReorderEndInsertsHelp(endInserts, patch)
{
	if (!endInserts)
	{
		return;
	}

	var frag = _VirtualDom_doc.createDocumentFragment();
	for (var i = 0; i < endInserts.length; i++)
	{
		var insert = endInserts[i];
		var entry = insert.A;
		_VirtualDom_appendChild(frag, entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u)
		);
	}
	return frag;
}


function _VirtualDom_virtualize(node)
{
	// TEXT NODES

	if (node.nodeType === 3)
	{
		return _VirtualDom_text(node.textContent);
	}


	// WEIRD NODES

	if (node.nodeType !== 1)
	{
		return _VirtualDom_text('');
	}


	// ELEMENT NODES

	var attrList = _List_Nil;
	var attrs = node.attributes;
	for (var i = attrs.length; i--; )
	{
		var attr = attrs[i];
		var name = attr.name;
		var value = attr.value;
		attrList = _List_Cons( A2(_VirtualDom_attribute, name, value), attrList );
	}

	var tag = node.tagName.toLowerCase();
	var kidList = _List_Nil;
	var kids = node.childNodes;

	for (var i = kids.length; i--; )
	{
		kidList = _List_Cons(_VirtualDom_virtualize(kids[i]), kidList);
	}
	return A3(_VirtualDom_node, tag, attrList, kidList);
}

function _VirtualDom_dekey(keyedNode)
{
	var keyedKids = keyedNode.e;
	var len = keyedKids.length;
	var kids = new Array(len);
	for (var i = 0; i < len; i++)
	{
		kids[i] = keyedKids[i].b;
	}

	return {
		$: 1,
		c: keyedNode.c,
		d: keyedNode.d,
		e: kids,
		f: keyedNode.f,
		b: keyedNode.b
	};
}




// ELEMENT


var _Debugger_element;

var _Browser_element = _Debugger_element || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.dH,
		impl.ex,
		impl.em,
		function(sendToApp, initialModel) {
			var view = impl.ez;
			/**/
			var domNode = args['node'];
			//*/
			/**_UNUSED/
			var domNode = args && args['node'] ? args['node'] : _Debug_crash(0);
			//*/
			var currNode = _VirtualDom_virtualize(domNode);

			return _Browser_makeAnimator(initialModel, function(model)
			{
				var nextNode = view(model);
				var patches = _VirtualDom_diff(currNode, nextNode);
				domNode = _VirtualDom_applyPatches(domNode, currNode, patches, sendToApp);
				currNode = nextNode;
			});
		}
	);
});



// DOCUMENT


var _Debugger_document;

var _Browser_document = _Debugger_document || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.dH,
		impl.ex,
		impl.em,
		function(sendToApp, initialModel) {
			var divertHrefToApp = impl.fD && impl.fD(sendToApp)
			var view = impl.ez;
			var title = _VirtualDom_doc.title;
			var bodyNode = _VirtualDom_doc.body;
			var currNode = _VirtualDom_virtualize(bodyNode);
			return _Browser_makeAnimator(initialModel, function(model)
			{
				_VirtualDom_divertHrefToApp = divertHrefToApp;
				var doc = view(model);
				var nextNode = _VirtualDom_node('body')(_List_Nil)(doc._);
				var patches = _VirtualDom_diff(currNode, nextNode);
				bodyNode = _VirtualDom_applyPatches(bodyNode, currNode, patches, sendToApp);
				currNode = nextNode;
				_VirtualDom_divertHrefToApp = 0;
				(title !== doc.avV) && (_VirtualDom_doc.title = title = doc.avV);
			});
		}
	);
});



// ANIMATION


var _Browser_cancelAnimationFrame =
	typeof cancelAnimationFrame !== 'undefined'
		? cancelAnimationFrame
		: function(id) { clearTimeout(id); };

var _Browser_requestAnimationFrame =
	typeof requestAnimationFrame !== 'undefined'
		? requestAnimationFrame
		: function(callback) { return setTimeout(callback, 1000 / 60); };


function _Browser_makeAnimator(model, draw)
{
	draw(model);

	var state = 0;

	function updateIfNeeded()
	{
		state = state === 1
			? 0
			: ( _Browser_requestAnimationFrame(updateIfNeeded), draw(model), 1 );
	}

	return function(nextModel, isSync)
	{
		model = nextModel;

		isSync
			? ( draw(model),
				state === 2 && (state = 1)
				)
			: ( state === 0 && _Browser_requestAnimationFrame(updateIfNeeded),
				state = 2
				);
	};
}



// APPLICATION


function _Browser_application(impl)
{
	var onUrlChange = impl.X2;
	var onUrlRequest = impl.X3;
	var key = function() { key.a(onUrlChange(_Browser_getUrl())); };

	return _Browser_document({
		fD: function(sendToApp)
		{
			key.a = sendToApp;
			_Browser_window.addEventListener('popstate', key);
			_Browser_window.navigator.userAgent.indexOf('Trident') < 0 || _Browser_window.addEventListener('hashchange', key);

			return F2(function(domNode, event)
			{
				if (!event.ctrlKey && !event.metaKey && !event.shiftKey && event.button < 1 && !domNode.target && !domNode.hasAttribute('download'))
				{
					event.preventDefault();
					var href = domNode.href;
					var curr = _Browser_getUrl();
					var next = $elm$url$Url$fromString(href).a;
					sendToApp(onUrlRequest(
						(next
							&& curr.aat === next.aat
							&& curr.MU === next.MU
							&& curr.$f.a === next.$f.a
						)
							? $elm$browser$Browser$Internal(next)
							: $elm$browser$Browser$External(href)
					));
				}
			});
		},
		dH: function(flags)
		{
			return A3(impl.dH, flags, _Browser_getUrl(), key);
		},
		ez: impl.ez,
		ex: impl.ex,
		em: impl.em
	});
}

function _Browser_getUrl()
{
	return $elm$url$Url$fromString(_VirtualDom_doc.location.href).a || _Debug_crash(1);
}

var _Browser_go = F2(function(key, n)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		n && history.go(n);
		key();
	}));
});

var _Browser_pushUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.pushState({}, '', url);
		key();
	}));
});

var _Browser_replaceUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.replaceState({}, '', url);
		key();
	}));
});



// GLOBAL EVENTS


var _Browser_fakeNode = { addEventListener: function() {}, removeEventListener: function() {} };
var _Browser_doc = typeof document !== 'undefined' ? document : _Browser_fakeNode;
var _Browser_window = typeof window !== 'undefined' ? window : _Browser_fakeNode;

var _Browser_on = F3(function(node, eventName, sendToSelf)
{
	return _Scheduler_spawn(_Scheduler_binding(function(callback)
	{
		function handler(event)	{ _Scheduler_rawSpawn(sendToSelf(event)); }
		node.addEventListener(eventName, handler, _VirtualDom_passiveSupported && { passive: true });
		return function() { node.removeEventListener(eventName, handler); };
	}));
});

var _Browser_decodeEvent = F2(function(decoder, event)
{
	var result = _Json_runHelp(decoder, event);
	return $elm$core$Result$isOk(result) ? $elm$core$Maybe$Just(result.a) : $elm$core$Maybe$Nothing;
});



// PAGE VISIBILITY


function _Browser_visibilityInfo()
{
	return (typeof _VirtualDom_doc.hidden !== 'undefined')
		? { cs: 'hidden', p0: 'visibilitychange' }
		:
	(typeof _VirtualDom_doc.mozHidden !== 'undefined')
		? { cs: 'mozHidden', p0: 'mozvisibilitychange' }
		:
	(typeof _VirtualDom_doc.msHidden !== 'undefined')
		? { cs: 'msHidden', p0: 'msvisibilitychange' }
		:
	(typeof _VirtualDom_doc.webkitHidden !== 'undefined')
		? { cs: 'webkitHidden', p0: 'webkitvisibilitychange' }
		: { cs: 'hidden', p0: 'visibilitychange' };
}



// ANIMATION FRAMES


function _Browser_rAF()
{
	return _Scheduler_binding(function(callback)
	{
		var id = _Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(Date.now()));
		});

		return function() {
			_Browser_cancelAnimationFrame(id);
		};
	});
}


function _Browser_now()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(Date.now()));
	});
}



// DOM STUFF


function _Browser_withNode(id, doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			var node = document.getElementById(id);
			callback(node
				? _Scheduler_succeed(doStuff(node))
				: _Scheduler_fail($elm$browser$Browser$Dom$NotFound(id))
			);
		});
	});
}


function _Browser_withWindow(doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(doStuff()));
		});
	});
}


// FOCUS and BLUR


var _Browser_call = F2(function(functionName, id)
{
	return _Browser_withNode(id, function(node) {
		node[functionName]();
		return _Utils_Tuple0;
	});
});



// WINDOW VIEWPORT


function _Browser_getViewport()
{
	return {
		avu: _Browser_getScene(),
		awo: {
			asz: _Browser_window.pageXOffset,
			m: _Browser_window.pageYOffset,
			cb: _Browser_doc.documentElement.clientWidth,
			Mq: _Browser_doc.documentElement.clientHeight
		}
	};
}

function _Browser_getScene()
{
	var body = _Browser_doc.body;
	var elem = _Browser_doc.documentElement;
	return {
		cb: Math.max(body.scrollWidth, body.offsetWidth, elem.scrollWidth, elem.offsetWidth, elem.clientWidth),
		Mq: Math.max(body.scrollHeight, body.offsetHeight, elem.scrollHeight, elem.offsetHeight, elem.clientHeight)
	};
}

var _Browser_setViewport = F2(function(x, y)
{
	return _Browser_withWindow(function()
	{
		_Browser_window.scroll(x, y);
		return _Utils_Tuple0;
	});
});



// ELEMENT VIEWPORT


function _Browser_getViewportOf(id)
{
	return _Browser_withNode(id, function(node)
	{
		return {
			avu: {
				cb: node.scrollWidth,
				Mq: node.scrollHeight
			},
			awo: {
				asz: node.scrollLeft,
				m: node.scrollTop,
				cb: node.clientWidth,
				Mq: node.clientHeight
			}
		};
	});
}


var _Browser_setViewportOf = F3(function(id, x, y)
{
	return _Browser_withNode(id, function(node)
	{
		node.scrollLeft = x;
		node.scrollTop = y;
		return _Utils_Tuple0;
	});
});



// ELEMENT


function _Browser_getElement(id)
{
	return _Browser_withNode(id, function(node)
	{
		var rect = node.getBoundingClientRect();
		var x = _Browser_window.pageXOffset;
		var y = _Browser_window.pageYOffset;
		return {
			avu: _Browser_getScene(),
			awo: {
				asz: x,
				m: y,
				cb: _Browser_doc.documentElement.clientWidth,
				Mq: _Browser_doc.documentElement.clientHeight
			},
			E4: {
				asz: x + rect.left,
				m: y + rect.top,
				cb: rect.width,
				Mq: rect.height
			}
		};
	});
}



// LOAD and RELOAD


function _Browser_reload(skipCache)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		_VirtualDom_doc.location.reload(skipCache);
	}));
}

function _Browser_load(url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		try
		{
			_Browser_window.location = url;
		}
		catch(err)
		{
			// Only Firefox can throw a NS_ERROR_MALFORMED_URI exception here.
			// Other browsers reload the page, so let's be consistent about that.
			_VirtualDom_doc.location.reload(false);
		}
	}));
}


function _Url_percentEncode(string)
{
	return encodeURIComponent(string);
}

function _Url_percentDecode(string)
{
	try
	{
		return $elm$core$Maybe$Just(decodeURIComponent(string));
	}
	catch (e)
	{
		return $elm$core$Maybe$Nothing;
	}
}


// SEND REQUEST

var _Http_toTask = F3(function(router, toTask, request)
{
	return _Scheduler_binding(function(callback)
	{
		function done(response) {
			callback(toTask(request.aH.a(response)));
		}

		var xhr = new XMLHttpRequest();
		xhr.addEventListener('error', function() { done($elm$http$Http$NetworkError_); });
		xhr.addEventListener('timeout', function() { done($elm$http$Http$Timeout_); });
		xhr.addEventListener('load', function() { done(_Http_toResponse(request.aH.b, xhr)); });
		$elm$core$Maybe$isJust(request.av3) && _Http_track(router, xhr, request.av3.a);

		try {
			xhr.open(request.aO, request.a0, true);
		} catch (e) {
			return done($elm$http$Http$BadUrl_(request.a0));
		}

		_Http_configureRequest(xhr, request);

		request._.a && xhr.setRequestHeader('Content-Type', request._.a);
		xhr.send(request._.b);

		return function() { xhr.c = true; xhr.abort(); };
	});
});


// CONFIGURE

function _Http_configureRequest(xhr, request)
{
	for (var headers = request.ax; headers.b; headers = headers.b) // WHILE_CONS
	{
		xhr.setRequestHeader(headers.a.a, headers.a.b);
	}
	xhr.timeout = request.a_.a || 0;
	xhr.responseType = request.aH.d;
	xhr.withCredentials = request.as_;
}


// RESPONSES

function _Http_toResponse(toBody, xhr)
{
	return A2(
		200 <= xhr.status && xhr.status < 300 ? $elm$http$Http$GoodStatus_ : $elm$http$Http$BadStatus_,
		_Http_toMetadata(xhr),
		toBody(xhr.response)
	);
}


// METADATA

function _Http_toMetadata(xhr)
{
	return {
		a0: xhr.responseURL,
		avE: xhr.status,
		avF: xhr.statusText,
		ax: _Http_parseHeaders(xhr.getAllResponseHeaders())
	};
}


// HEADERS

function _Http_parseHeaders(rawHeaders)
{
	if (!rawHeaders)
	{
		return $elm$core$Dict$empty;
	}

	var headers = $elm$core$Dict$empty;
	var headerPairs = rawHeaders.split('\r\n');
	for (var i = headerPairs.length; i--; )
	{
		var headerPair = headerPairs[i];
		var index = headerPair.indexOf(': ');
		if (index > 0)
		{
			var key = headerPair.substring(0, index);
			var value = headerPair.substring(index + 2);

			headers = A3($elm$core$Dict$update, key, function(oldValue) {
				return $elm$core$Maybe$Just($elm$core$Maybe$isJust(oldValue)
					? value + ', ' + oldValue.a
					: value
				);
			}, headers);
		}
	}
	return headers;
}


// EXPECT

var _Http_expect = F3(function(type, toBody, toValue)
{
	return {
		$: 0,
		d: type,
		b: toBody,
		a: toValue
	};
});

var _Http_mapExpect = F2(function(func, expect)
{
	return {
		$: 0,
		d: expect.d,
		b: expect.b,
		a: function(x) { return func(expect.a(x)); }
	};
});

function _Http_toDataView(arrayBuffer)
{
	return new DataView(arrayBuffer);
}


// BODY and PARTS

var _Http_emptyBody = { $: 0 };
var _Http_pair = F2(function(a, b) { return { $: 0, a: a, b: b }; });

function _Http_toFormData(parts)
{
	for (var formData = new FormData(); parts.b; parts = parts.b) // WHILE_CONS
	{
		var part = parts.a;
		formData.append(part.a, part.b);
	}
	return formData;
}

var _Http_bytesToBlob = F2(function(mime, bytes)
{
	return new Blob([bytes], { type: mime });
});


// PROGRESS

function _Http_track(router, xhr, tracker)
{
	// TODO check out lengthComputable on loadstart event

	xhr.upload.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Sending({
			agS: event.loaded,
			ej: event.total
		}))));
	});
	xhr.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Receiving({
			avm: event.loaded,
			ej: event.lengthComputable ? $elm$core$Maybe$Just(event.total) : $elm$core$Maybe$Nothing
		}))));
	});
}


var _Bitwise_and = F2(function(a, b)
{
	return a & b;
});

var _Bitwise_or = F2(function(a, b)
{
	return a | b;
});

var _Bitwise_xor = F2(function(a, b)
{
	return a ^ b;
});

function _Bitwise_complement(a)
{
	return ~a;
};

var _Bitwise_shiftLeftBy = F2(function(offset, a)
{
	return a << offset;
});

var _Bitwise_shiftRightBy = F2(function(offset, a)
{
	return a >> offset;
});

var _Bitwise_shiftRightZfBy = F2(function(offset, a)
{
	return a >>> offset;
});


// CREATE

var _Regex_never = /.^/;

var _Regex_fromStringWith = F2(function(options, string)
{
	var flags = 'g';
	if (options.auL) { flags += 'm'; }
	if (options.atd) { flags += 'i'; }

	try
	{
		return $elm$core$Maybe$Just(new RegExp(string, flags));
	}
	catch(error)
	{
		return $elm$core$Maybe$Nothing;
	}
});


// USE

var _Regex_contains = F2(function(re, string)
{
	return string.match(re) !== null;
});


var _Regex_findAtMost = F3(function(n, re, str)
{
	var out = [];
	var number = 0;
	var string = str;
	var lastIndex = re.lastIndex;
	var prevLastIndex = -1;
	var result;
	while (number++ < n && (result = re.exec(string)))
	{
		if (prevLastIndex == re.lastIndex) break;
		var i = result.length - 1;
		var subs = new Array(i);
		while (i > 0)
		{
			var submatch = result[i];
			subs[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		out.push(A4($elm$regex$Regex$Match, result[0], result.index, number, _List_fromArray(subs)));
		prevLastIndex = re.lastIndex;
	}
	re.lastIndex = lastIndex;
	return _List_fromArray(out);
});


var _Regex_replaceAtMost = F4(function(n, re, replacer, string)
{
	var count = 0;
	function jsReplacer(match)
	{
		if (count++ >= n)
		{
			return match;
		}
		var i = arguments.length - 3;
		var submatches = new Array(i);
		while (i > 0)
		{
			var submatch = arguments[i];
			submatches[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		return replacer(A4($elm$regex$Regex$Match, match, arguments[arguments.length - 2], count, _List_fromArray(submatches)));
	}
	return string.replace(re, jsReplacer);
});

var _Regex_splitAtMost = F3(function(n, re, str)
{
	var string = str;
	var out = [];
	var start = re.lastIndex;
	var restoreLastIndex = re.lastIndex;
	while (n--)
	{
		var result = re.exec(string);
		if (!result) break;
		out.push(string.slice(start, result.index));
		start = re.lastIndex;
	}
	out.push(string.slice(start));
	re.lastIndex = restoreLastIndex;
	return _List_fromArray(out);
});

var _Regex_infinity = Infinity;




// STRINGS


var _Parser_isSubString = F5(function(smallString, offset, row, col, bigString)
{
	var smallLength = smallString.length;
	var isGood = offset + smallLength <= bigString.length;

	for (var i = 0; isGood && i < smallLength; )
	{
		var code = bigString.charCodeAt(offset);
		isGood =
			smallString[i++] === bigString[offset++]
			&& (
				code === 0x000A /* \n */
					? ( row++, col=1 )
					: ( col++, (code & 0xF800) === 0xD800 ? smallString[i++] === bigString[offset++] : 1 )
			)
	}

	return _Utils_Tuple3(isGood ? offset : -1, row, col);
});



// CHARS


var _Parser_isSubChar = F3(function(predicate, offset, string)
{
	return (
		string.length <= offset
			? -1
			:
		(string.charCodeAt(offset) & 0xF800) === 0xD800
			? (predicate(_Utils_chr(string.substr(offset, 2))) ? offset + 2 : -1)
			:
		(predicate(_Utils_chr(string[offset]))
			? ((string[offset] === '\n') ? -2 : (offset + 1))
			: -1
		)
	);
});


var _Parser_isAsciiCode = F3(function(code, offset, string)
{
	return string.charCodeAt(offset) === code;
});



// NUMBERS


var _Parser_chompBase10 = F2(function(offset, string)
{
	for (; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (code < 0x30 || 0x39 < code)
		{
			return offset;
		}
	}
	return offset;
});


var _Parser_consumeBase = F3(function(base, offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var digit = string.charCodeAt(offset) - 0x30;
		if (digit < 0 || base <= digit) break;
		total = base * total + digit;
	}
	return _Utils_Tuple2(offset, total);
});


var _Parser_consumeBase16 = F2(function(offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (0x30 <= code && code <= 0x39)
		{
			total = 16 * total + code - 0x30;
		}
		else if (0x41 <= code && code <= 0x46)
		{
			total = 16 * total + code - 55;
		}
		else if (0x61 <= code && code <= 0x66)
		{
			total = 16 * total + code - 87;
		}
		else
		{
			break;
		}
	}
	return _Utils_Tuple2(offset, total);
});



// FIND STRING


var _Parser_findSubString = F5(function(smallString, offset, row, col, bigString)
{
	var newOffset = bigString.indexOf(smallString, offset);
	var target = newOffset < 0 ? bigString.length : newOffset + smallString.length;

	while (offset < target)
	{
		var code = bigString.charCodeAt(offset++);
		code === 0x000A /* \n */
			? ( col=1, row++ )
			: ( col++, (code & 0xF800) === 0xD800 && offset++ )
	}

	return _Utils_Tuple3(newOffset, row, col);
});



// DECODER

var _File_decoder = _Json_decodePrim(function(value) {
	// NOTE: checks if `File` exists in case this is run on node
	return (typeof File !== 'undefined' && value instanceof File)
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FILE', value);
});


// METADATA

function _File_name(file) { return file.name; }
function _File_mime(file) { return file.type; }
function _File_size(file) { return file.size; }

function _File_lastModified(file)
{
	return $elm$time$Time$millisToPosix(file.lastModified);
}


// DOWNLOAD

var _File_downloadNode;

function _File_getDownloadNode()
{
	return _File_downloadNode || (_File_downloadNode = document.createElement('a'));
}

var _File_download = F3(function(name, mime, content)
{
	return _Scheduler_binding(function(callback)
	{
		var blob = new Blob([content], {type: mime});

		// for IE10+
		if (navigator.msSaveOrOpenBlob)
		{
			navigator.msSaveOrOpenBlob(blob, name);
			return;
		}

		// for HTML5
		var node = _File_getDownloadNode();
		var objectUrl = URL.createObjectURL(blob);
		node.href = objectUrl;
		node.download = name;
		_File_click(node);
		URL.revokeObjectURL(objectUrl);
	});
});

function _File_downloadUrl(href)
{
	return _Scheduler_binding(function(callback)
	{
		var node = _File_getDownloadNode();
		node.href = href;
		node.download = '';
		node.origin === location.origin || (node.target = '_blank');
		_File_click(node);
	});
}


// IE COMPATIBILITY

function _File_makeBytesSafeForInternetExplorer(bytes)
{
	// only needed by IE10 and IE11 to fix https://github.com/elm/file/issues/10
	// all other browsers can just run `new Blob([bytes])` directly with no problem
	//
	return new Uint8Array(bytes.buffer, bytes.byteOffset, bytes.byteLength);
}

function _File_click(node)
{
	// only needed by IE10 and IE11 to fix https://github.com/elm/file/issues/11
	// all other browsers have MouseEvent and do not need this conditional stuff
	//
	if (typeof MouseEvent === 'function')
	{
		node.dispatchEvent(new MouseEvent('click'));
	}
	else
	{
		var event = document.createEvent('MouseEvents');
		event.initMouseEvent('click', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
		document.body.appendChild(node);
		node.dispatchEvent(event);
		document.body.removeChild(node);
	}
}


// UPLOAD

var _File_node;

function _File_uploadOne(mimes)
{
	return _Scheduler_binding(function(callback)
	{
		_File_node = document.createElement('input');
		_File_node.type = 'file';
		_File_node.accept = A2($elm$core$String$join, ',', mimes);
		_File_node.addEventListener('change', function(event)
		{
			callback(_Scheduler_succeed(event.target.files[0]));
		});
		_File_click(_File_node);
	});
}

function _File_uploadOneOrMore(mimes)
{
	return _Scheduler_binding(function(callback)
	{
		_File_node = document.createElement('input');
		_File_node.type = 'file';
		_File_node.multiple = true;
		_File_node.accept = A2($elm$core$String$join, ',', mimes);
		_File_node.addEventListener('change', function(event)
		{
			var elmFiles = _List_fromArray(event.target.files);
			callback(_Scheduler_succeed(_Utils_Tuple2(elmFiles.a, elmFiles.b)));
		});
		_File_click(_File_node);
	});
}


// CONTENT

function _File_toString(blob)
{
	return _Scheduler_binding(function(callback)
	{
		var reader = new FileReader();
		reader.addEventListener('loadend', function() {
			callback(_Scheduler_succeed(reader.result));
		});
		reader.readAsText(blob);
		return function() { reader.abort(); };
	});
}

function _File_toBytes(blob)
{
	return _Scheduler_binding(function(callback)
	{
		var reader = new FileReader();
		reader.addEventListener('loadend', function() {
			callback(_Scheduler_succeed(new DataView(reader.result)));
		});
		reader.readAsArrayBuffer(blob);
		return function() { reader.abort(); };
	});
}

function _File_toUrl(blob)
{
	return _Scheduler_binding(function(callback)
	{
		var reader = new FileReader();
		reader.addEventListener('loadend', function() {
			callback(_Scheduler_succeed(reader.result));
		});
		reader.readAsDataURL(blob);
		return function() { reader.abort(); };
	});
}




function _Time_now(millisToPosix)
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(millisToPosix(Date.now())));
	});
}

var _Time_setInterval = F2(function(interval, task)
{
	return _Scheduler_binding(function(callback)
	{
		var id = setInterval(function() { _Scheduler_rawSpawn(task); }, interval);
		return function() { clearInterval(id); };
	});
});

function _Time_here()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(
			A2($elm$time$Time$customZone, -(new Date().getTimezoneOffset()), _List_Nil)
		));
	});
}


function _Time_getZoneName()
{
	return _Scheduler_binding(function(callback)
	{
		try
		{
			var name = $elm$time$Time$Name(Intl.DateTimeFormat().resolvedOptions().timeZone);
		}
		catch (e)
		{
			var name = $elm$time$Time$Offset(new Date().getTimezoneOffset());
		}
		callback(_Scheduler_succeed(name));
	});
}
var $elm$core$List$cons = _List_cons;
var $elm$core$Elm$JsArray$foldr = _JsArray_foldr;
var $elm$core$Array$foldr = F3(
	function (func, baseCase, _v0) {
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = F2(
			function (node, acc) {
				if (!node.$) {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldr, helper, acc, subTree);
				} else {
					var values = node.a;
					return A3($elm$core$Elm$JsArray$foldr, func, acc, values);
				}
			});
		return A3(
			$elm$core$Elm$JsArray$foldr,
			helper,
			A3($elm$core$Elm$JsArray$foldr, func, baseCase, tail),
			tree);
	});
var $elm$core$Array$toList = function (array) {
	return A3($elm$core$Array$foldr, $elm$core$List$cons, _List_Nil, array);
};
var $elm$core$Dict$foldr = F3(
	function (func, acc, t) {
		foldr:
		while (true) {
			if (t.$ === -2) {
				return acc;
			} else {
				var key = t.b;
				var value = t.c;
				var left = t.d;
				var right = t.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldr, func, acc, right)),
					$temp$t = left;
				func = $temp$func;
				acc = $temp$acc;
				t = $temp$t;
				continue foldr;
			}
		}
	});
var $elm$core$Dict$toList = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, list) {
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(key, value),
					list);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Dict$keys = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, keyList) {
				return A2($elm$core$List$cons, key, keyList);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Set$toList = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$keys(dict);
};
var $elm$core$Basics$EQ = 1;
var $elm$core$Basics$GT = 2;
var $elm$core$Basics$LT = 0;
var $elm$core$Result$Err = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Result$Ok = function (a) {
	return {$: 0, a: a};
};
var $elm$json$Json$Decode$Failure = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$json$Json$Decode$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$json$Json$Decode$Index = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$json$Json$Decode$OneOf = function (a) {
	return {$: 2, a: a};
};
var $elm$core$Basics$False = 1;
var $elm$core$Basics$add = _Basics_add;
var $elm$core$Maybe$Just = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Maybe$Nothing = {$: 1};
var $elm$core$String$all = _String_all;
var $elm$core$Basics$and = _Basics_and;
var $elm$core$Basics$append = _Utils_append;
var $elm$json$Json$Encode$encode = _Json_encode;
var $elm$core$String$fromInt = _String_fromNumber;
var $elm$core$String$join = F2(
	function (sep, chunks) {
		return A2(
			_String_join,
			sep,
			_List_toArray(chunks));
	});
var $elm$core$String$split = F2(
	function (sep, string) {
		return _List_fromArray(
			A2(_String_split, sep, string));
	});
var $elm$json$Json$Decode$indent = function (str) {
	return A2(
		$elm$core$String$join,
		'\n    ',
		A2($elm$core$String$split, '\n', str));
};
var $elm$core$List$foldl = F3(
	function (func, acc, list) {
		foldl:
		while (true) {
			if (!list.b) {
				return acc;
			} else {
				var x = list.a;
				var xs = list.b;
				var $temp$func = func,
					$temp$acc = A2(func, x, acc),
					$temp$list = xs;
				func = $temp$func;
				acc = $temp$acc;
				list = $temp$list;
				continue foldl;
			}
		}
	});
var $elm$core$List$length = function (xs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, i) {
				return i + 1;
			}),
		0,
		xs);
};
var $elm$core$List$map2 = _List_map2;
var $elm$core$Basics$le = _Utils_le;
var $elm$core$Basics$sub = _Basics_sub;
var $elm$core$List$rangeHelp = F3(
	function (lo, hi, list) {
		rangeHelp:
		while (true) {
			if (_Utils_cmp(lo, hi) < 1) {
				var $temp$lo = lo,
					$temp$hi = hi - 1,
					$temp$list = A2($elm$core$List$cons, hi, list);
				lo = $temp$lo;
				hi = $temp$hi;
				list = $temp$list;
				continue rangeHelp;
			} else {
				return list;
			}
		}
	});
var $elm$core$List$range = F2(
	function (lo, hi) {
		return A3($elm$core$List$rangeHelp, lo, hi, _List_Nil);
	});
var $elm$core$List$indexedMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$map2,
			f,
			A2(
				$elm$core$List$range,
				0,
				$elm$core$List$length(xs) - 1),
			xs);
	});
var $elm$core$Char$toCode = _Char_toCode;
var $elm$core$Char$isLower = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (97 <= code) && (code <= 122);
};
var $elm$core$Char$isUpper = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 90) && (65 <= code);
};
var $elm$core$Basics$or = _Basics_or;
var $elm$core$Char$isAlpha = function (_char) {
	return $elm$core$Char$isLower(_char) || $elm$core$Char$isUpper(_char);
};
var $elm$core$Char$isDigit = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 57) && (48 <= code);
};
var $elm$core$Char$isAlphaNum = function (_char) {
	return $elm$core$Char$isLower(_char) || ($elm$core$Char$isUpper(_char) || $elm$core$Char$isDigit(_char));
};
var $elm$core$List$reverse = function (list) {
	return A3($elm$core$List$foldl, $elm$core$List$cons, _List_Nil, list);
};
var $elm$core$String$uncons = _String_uncons;
var $elm$json$Json$Decode$errorOneOf = F2(
	function (i, error) {
		return '\n\n(' + ($elm$core$String$fromInt(i + 1) + (') ' + $elm$json$Json$Decode$indent(
			$elm$json$Json$Decode$errorToString(error))));
	});
var $elm$json$Json$Decode$errorToString = function (error) {
	return A2($elm$json$Json$Decode$errorToStringHelp, error, _List_Nil);
};
var $elm$json$Json$Decode$errorToStringHelp = F2(
	function (error, context) {
		errorToStringHelp:
		while (true) {
			switch (error.$) {
				case 0:
					var f = error.a;
					var err = error.b;
					var isSimple = function () {
						var _v1 = $elm$core$String$uncons(f);
						if (_v1.$ === 1) {
							return false;
						} else {
							var _v2 = _v1.a;
							var _char = _v2.a;
							var rest = _v2.b;
							return $elm$core$Char$isAlpha(_char) && A2($elm$core$String$all, $elm$core$Char$isAlphaNum, rest);
						}
					}();
					var fieldName = isSimple ? ('.' + f) : ('[\'' + (f + '\']'));
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, fieldName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 1:
					var i = error.a;
					var err = error.b;
					var indexName = '[' + ($elm$core$String$fromInt(i) + ']');
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, indexName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 2:
					var errors = error.a;
					if (!errors.b) {
						return 'Ran into a Json.Decode.oneOf with no possibilities' + function () {
							if (!context.b) {
								return '!';
							} else {
								return ' at json' + A2(
									$elm$core$String$join,
									'',
									$elm$core$List$reverse(context));
							}
						}();
					} else {
						if (!errors.b.b) {
							var err = errors.a;
							var $temp$error = err,
								$temp$context = context;
							error = $temp$error;
							context = $temp$context;
							continue errorToStringHelp;
						} else {
							var starter = function () {
								if (!context.b) {
									return 'Json.Decode.oneOf';
								} else {
									return 'The Json.Decode.oneOf at json' + A2(
										$elm$core$String$join,
										'',
										$elm$core$List$reverse(context));
								}
							}();
							var introduction = starter + (' failed in the following ' + ($elm$core$String$fromInt(
								$elm$core$List$length(errors)) + ' ways:'));
							return A2(
								$elm$core$String$join,
								'\n\n',
								A2(
									$elm$core$List$cons,
									introduction,
									A2($elm$core$List$indexedMap, $elm$json$Json$Decode$errorOneOf, errors)));
						}
					}
				default:
					var msg = error.a;
					var json = error.b;
					var introduction = function () {
						if (!context.b) {
							return 'Problem with the given value:\n\n';
						} else {
							return 'Problem with the value at json' + (A2(
								$elm$core$String$join,
								'',
								$elm$core$List$reverse(context)) + ':\n\n    ');
						}
					}();
					return introduction + ($elm$json$Json$Decode$indent(
						A2($elm$json$Json$Encode$encode, 4, json)) + ('\n\n' + msg));
			}
		}
	});
var $elm$core$Array$branchFactor = 32;
var $elm$core$Array$Array_elm_builtin = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $elm$core$Elm$JsArray$empty = _JsArray_empty;
var $elm$core$Basics$ceiling = _Basics_ceiling;
var $elm$core$Basics$fdiv = _Basics_fdiv;
var $elm$core$Basics$logBase = F2(
	function (base, number) {
		return _Basics_log(number) / _Basics_log(base);
	});
var $elm$core$Basics$toFloat = _Basics_toFloat;
var $elm$core$Array$shiftStep = $elm$core$Basics$ceiling(
	A2($elm$core$Basics$logBase, 2, $elm$core$Array$branchFactor));
var $elm$core$Array$empty = A4($elm$core$Array$Array_elm_builtin, 0, $elm$core$Array$shiftStep, $elm$core$Elm$JsArray$empty, $elm$core$Elm$JsArray$empty);
var $elm$core$Elm$JsArray$initialize = _JsArray_initialize;
var $elm$core$Array$Leaf = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Basics$apL = F2(
	function (f, x) {
		return f(x);
	});
var $elm$core$Basics$apR = F2(
	function (x, f) {
		return f(x);
	});
var $elm$core$Basics$eq = _Utils_equal;
var $elm$core$Basics$floor = _Basics_floor;
var $elm$core$Elm$JsArray$length = _JsArray_length;
var $elm$core$Basics$gt = _Utils_gt;
var $elm$core$Basics$max = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) > 0) ? x : y;
	});
var $elm$core$Basics$mul = _Basics_mul;
var $elm$core$Array$SubTree = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Elm$JsArray$initializeFromList = _JsArray_initializeFromList;
var $elm$core$Array$compressNodes = F2(
	function (nodes, acc) {
		compressNodes:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodes);
			var node = _v0.a;
			var remainingNodes = _v0.b;
			var newAcc = A2(
				$elm$core$List$cons,
				$elm$core$Array$SubTree(node),
				acc);
			if (!remainingNodes.b) {
				return $elm$core$List$reverse(newAcc);
			} else {
				var $temp$nodes = remainingNodes,
					$temp$acc = newAcc;
				nodes = $temp$nodes;
				acc = $temp$acc;
				continue compressNodes;
			}
		}
	});
var $elm$core$Tuple$first = function (_v0) {
	var x = _v0.a;
	return x;
};
var $elm$core$Array$treeFromBuilder = F2(
	function (nodeList, nodeListSize) {
		treeFromBuilder:
		while (true) {
			var newNodeSize = $elm$core$Basics$ceiling(nodeListSize / $elm$core$Array$branchFactor);
			if (newNodeSize === 1) {
				return A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodeList).a;
			} else {
				var $temp$nodeList = A2($elm$core$Array$compressNodes, nodeList, _List_Nil),
					$temp$nodeListSize = newNodeSize;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue treeFromBuilder;
			}
		}
	});
var $elm$core$Array$builderToArray = F2(
	function (reverseNodeList, builder) {
		if (!builder.v) {
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.A),
				$elm$core$Array$shiftStep,
				$elm$core$Elm$JsArray$empty,
				builder.A);
		} else {
			var treeLen = builder.v * $elm$core$Array$branchFactor;
			var depth = $elm$core$Basics$floor(
				A2($elm$core$Basics$logBase, $elm$core$Array$branchFactor, treeLen - 1));
			var correctNodeList = reverseNodeList ? $elm$core$List$reverse(builder.E) : builder.E;
			var tree = A2($elm$core$Array$treeFromBuilder, correctNodeList, builder.v);
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.A) + treeLen,
				A2($elm$core$Basics$max, 5, depth * $elm$core$Array$shiftStep),
				tree,
				builder.A);
		}
	});
var $elm$core$Basics$idiv = _Basics_idiv;
var $elm$core$Basics$lt = _Utils_lt;
var $elm$core$Array$initializeHelp = F5(
	function (fn, fromIndex, len, nodeList, tail) {
		initializeHelp:
		while (true) {
			if (fromIndex < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					false,
					{E: nodeList, v: (len / $elm$core$Array$branchFactor) | 0, A: tail});
			} else {
				var leaf = $elm$core$Array$Leaf(
					A3($elm$core$Elm$JsArray$initialize, $elm$core$Array$branchFactor, fromIndex, fn));
				var $temp$fn = fn,
					$temp$fromIndex = fromIndex - $elm$core$Array$branchFactor,
					$temp$len = len,
					$temp$nodeList = A2($elm$core$List$cons, leaf, nodeList),
					$temp$tail = tail;
				fn = $temp$fn;
				fromIndex = $temp$fromIndex;
				len = $temp$len;
				nodeList = $temp$nodeList;
				tail = $temp$tail;
				continue initializeHelp;
			}
		}
	});
var $elm$core$Basics$remainderBy = _Basics_remainderBy;
var $elm$core$Array$initialize = F2(
	function (len, fn) {
		if (len <= 0) {
			return $elm$core$Array$empty;
		} else {
			var tailLen = len % $elm$core$Array$branchFactor;
			var tail = A3($elm$core$Elm$JsArray$initialize, tailLen, len - tailLen, fn);
			var initialFromIndex = (len - tailLen) - $elm$core$Array$branchFactor;
			return A5($elm$core$Array$initializeHelp, fn, initialFromIndex, len, _List_Nil, tail);
		}
	});
var $elm$core$Basics$True = 0;
var $elm$core$Result$isOk = function (result) {
	if (!result.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$json$Json$Decode$decodeValue = _Json_run;
var $elm$json$Json$Decode$map = _Json_map1;
var $elm$json$Json$Decode$map2 = _Json_map2;
var $elm$json$Json$Decode$succeed = _Json_succeed;
var $elm$virtual_dom$VirtualDom$toHandlerInt = function (handler) {
	switch (handler.$) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		default:
			return 3;
	}
};
var $elm$html$Html$div = _VirtualDom_node('div');
var $elm$browser$Browser$External = function (a) {
	return {$: 1, a: a};
};
var $elm$browser$Browser$Internal = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Basics$identity = function (x) {
	return x;
};
var $elm$browser$Browser$Dom$NotFound = $elm$core$Basics$identity;
var $elm$url$Url$Http = 0;
var $elm$url$Url$Https = 1;
var $elm$url$Url$Url = F6(
	function (protocol, host, port_, path, query, fragment) {
		return {at5: fragment, MU: host, _n: path, $f: port_, aat: protocol, avk: query};
	});
var $elm$core$String$contains = _String_contains;
var $elm$core$String$length = _String_length;
var $elm$core$String$slice = _String_slice;
var $elm$core$String$dropLeft = F2(
	function (n, string) {
		return (n < 1) ? string : A3(
			$elm$core$String$slice,
			n,
			$elm$core$String$length(string),
			string);
	});
var $elm$core$String$indexes = _String_indexes;
var $elm$core$String$isEmpty = function (string) {
	return string === '';
};
var $elm$core$String$left = F2(
	function (n, string) {
		return (n < 1) ? '' : A3($elm$core$String$slice, 0, n, string);
	});
var $elm$core$String$toInt = _String_toInt;
var $elm$url$Url$chompBeforePath = F5(
	function (protocol, path, params, frag, str) {
		if ($elm$core$String$isEmpty(str) || A2($elm$core$String$contains, '@', str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, ':', str);
			if (!_v0.b) {
				return $elm$core$Maybe$Just(
					A6($elm$url$Url$Url, protocol, str, $elm$core$Maybe$Nothing, path, params, frag));
			} else {
				if (!_v0.b.b) {
					var i = _v0.a;
					var _v1 = $elm$core$String$toInt(
						A2($elm$core$String$dropLeft, i + 1, str));
					if (_v1.$ === 1) {
						return $elm$core$Maybe$Nothing;
					} else {
						var port_ = _v1;
						return $elm$core$Maybe$Just(
							A6(
								$elm$url$Url$Url,
								protocol,
								A2($elm$core$String$left, i, str),
								port_,
								path,
								params,
								frag));
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		}
	});
var $elm$url$Url$chompBeforeQuery = F4(
	function (protocol, params, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '/', str);
			if (!_v0.b) {
				return A5($elm$url$Url$chompBeforePath, protocol, '/', params, frag, str);
			} else {
				var i = _v0.a;
				return A5(
					$elm$url$Url$chompBeforePath,
					protocol,
					A2($elm$core$String$dropLeft, i, str),
					params,
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompBeforeFragment = F3(
	function (protocol, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '?', str);
			if (!_v0.b) {
				return A4($elm$url$Url$chompBeforeQuery, protocol, $elm$core$Maybe$Nothing, frag, str);
			} else {
				var i = _v0.a;
				return A4(
					$elm$url$Url$chompBeforeQuery,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompAfterProtocol = F2(
	function (protocol, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '#', str);
			if (!_v0.b) {
				return A3($elm$url$Url$chompBeforeFragment, protocol, $elm$core$Maybe$Nothing, str);
			} else {
				var i = _v0.a;
				return A3(
					$elm$url$Url$chompBeforeFragment,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$core$String$startsWith = _String_startsWith;
var $elm$url$Url$fromString = function (str) {
	return A2($elm$core$String$startsWith, 'http://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		0,
		A2($elm$core$String$dropLeft, 7, str)) : (A2($elm$core$String$startsWith, 'https://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		1,
		A2($elm$core$String$dropLeft, 8, str)) : $elm$core$Maybe$Nothing);
};
var $elm$core$Basics$never = function (_v0) {
	never:
	while (true) {
		var nvr = _v0;
		var $temp$_v0 = nvr;
		_v0 = $temp$_v0;
		continue never;
	}
};
var $elm$core$Task$Perform = $elm$core$Basics$identity;
var $elm$core$Task$succeed = _Scheduler_succeed;
var $elm$core$Task$init = $elm$core$Task$succeed(0);
var $elm$core$List$foldrHelper = F4(
	function (fn, acc, ctr, ls) {
		if (!ls.b) {
			return acc;
		} else {
			var a = ls.a;
			var r1 = ls.b;
			if (!r1.b) {
				return A2(fn, a, acc);
			} else {
				var b = r1.a;
				var r2 = r1.b;
				if (!r2.b) {
					return A2(
						fn,
						a,
						A2(fn, b, acc));
				} else {
					var c = r2.a;
					var r3 = r2.b;
					if (!r3.b) {
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(fn, c, acc)));
					} else {
						var d = r3.a;
						var r4 = r3.b;
						var res = (ctr > 500) ? A3(
							$elm$core$List$foldl,
							fn,
							acc,
							$elm$core$List$reverse(r4)) : A4($elm$core$List$foldrHelper, fn, acc, ctr + 1, r4);
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(
									fn,
									c,
									A2(fn, d, res))));
					}
				}
			}
		}
	});
var $elm$core$List$foldr = F3(
	function (fn, acc, ls) {
		return A4($elm$core$List$foldrHelper, fn, acc, 0, ls);
	});
var $elm$core$List$map = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, acc) {
					return A2(
						$elm$core$List$cons,
						f(x),
						acc);
				}),
			_List_Nil,
			xs);
	});
var $elm$core$Task$andThen = _Scheduler_andThen;
var $elm$core$Task$map = F2(
	function (func, taskA) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return $elm$core$Task$succeed(
					func(a));
			},
			taskA);
	});
var $elm$core$Task$map2 = F3(
	function (func, taskA, taskB) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return A2(
					$elm$core$Task$andThen,
					function (b) {
						return $elm$core$Task$succeed(
							A2(func, a, b));
					},
					taskB);
			},
			taskA);
	});
var $elm$core$Task$sequence = function (tasks) {
	return A3(
		$elm$core$List$foldr,
		$elm$core$Task$map2($elm$core$List$cons),
		$elm$core$Task$succeed(_List_Nil),
		tasks);
};
var $elm$core$Platform$sendToApp = _Platform_sendToApp;
var $elm$core$Task$spawnCmd = F2(
	function (router, _v0) {
		var task = _v0;
		return _Scheduler_spawn(
			A2(
				$elm$core$Task$andThen,
				$elm$core$Platform$sendToApp(router),
				task));
	});
var $elm$core$Task$onEffects = F3(
	function (router, commands, state) {
		return A2(
			$elm$core$Task$map,
			function (_v0) {
				return 0;
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Task$spawnCmd(router),
					commands)));
	});
var $elm$core$Task$onSelfMsg = F3(
	function (_v0, _v1, _v2) {
		return $elm$core$Task$succeed(0);
	});
var $elm$core$Task$cmdMap = F2(
	function (tagger, _v0) {
		var task = _v0;
		return A2($elm$core$Task$map, tagger, task);
	});
_Platform_effectManagers['Task'] = _Platform_createManager($elm$core$Task$init, $elm$core$Task$onEffects, $elm$core$Task$onSelfMsg, $elm$core$Task$cmdMap);
var $elm$core$Task$command = _Platform_leaf('Task');
var $elm$core$Task$perform = F2(
	function (toMessage, task) {
		return $elm$core$Task$command(
			A2($elm$core$Task$map, toMessage, task));
	});
var $elm$browser$Browser$element = _Browser_element;
var $elm$html$Html$h1 = _VirtualDom_node('h1');
var $elm$core$Tuple$mapFirst = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			func(x),
			y);
	});
var $elm$core$Platform$Cmd$batch = _Platform_batch;
var $elm$core$Platform$Cmd$none = $elm$core$Platform$Cmd$batch(_List_Nil);
var $elm$core$Platform$Sub$batch = _Platform_batch;
var $elm$core$Platform$Sub$none = $elm$core$Platform$Sub$batch(_List_Nil);
var $elm$html$Html$pre = _VirtualDom_node('pre');
var $elm$virtual_dom$VirtualDom$text = _VirtualDom_text;
var $elm$html$Html$text = $elm$virtual_dom$VirtualDom$text;
var $author$project$Browser$Custom$elementWithFlags = F2(
	function (decoder, program) {
		return $elm$browser$Browser$element(
			{
				dH: function (value) {
					var _v0 = A2($elm$json$Json$Decode$decodeValue, decoder, value);
					if (!_v0.$) {
						var flags = _v0.a;
						return A2(
							$elm$core$Tuple$mapFirst,
							$elm$core$Result$Ok,
							program.dH(flags));
					} else {
						var err = _v0.a;
						return _Utils_Tuple2(
							$elm$core$Result$Err(err),
							$elm$core$Platform$Cmd$none);
					}
				},
				em: function (result) {
					if (!result.$) {
						var model = result.a;
						return program.em(model);
					} else {
						return $elm$core$Platform$Sub$none;
					}
				},
				ex: F2(
					function (msg, result) {
						if (!result.$) {
							var model = result.a;
							return A2(
								$elm$core$Tuple$mapFirst,
								$elm$core$Result$Ok,
								A2(program.ex, msg, model));
						} else {
							return _Utils_Tuple2(result, $elm$core$Platform$Cmd$none);
						}
					}),
				ez: function (result) {
					if (!result.$) {
						var model = result.a;
						return program.ez(model);
					} else {
						var err = result.a;
						return A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h1,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Invalid flags')
										])),
									A2(
									$elm$html$Html$pre,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$elm$json$Json$Decode$errorToString(err))
										]))
								]));
					}
				}
			});
	});
var $author$project$Model$Component$Properties$VacancyFilterOptionSearch$Flags$Flags = F7(
	function (domainId, filterId, sessionToken, location, placeholder, noResultMessage, currentOptions) {
		return {xS: currentOptions, dp: domainId, H0: filterId, Rs: location, WB: noResultMessage, d5: placeholder, aW: sessionToken};
	});
var $author$project$Data$Id$Id = $elm$core$Basics$identity;
var $elm$json$Json$Decode$int = _Json_decodeInt;
var $author$project$Data$Id$decoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$int);
var $elm$json$Json$Decode$list = _Json_decodeList;
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom = $elm$json$Json$Decode$map2($elm$core$Basics$apR);
var $elm$json$Json$Decode$field = _Json_decodeField;
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required = F3(
	function (key, valDecoder, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A2($elm$json$Json$Decode$field, key, valDecoder),
			decoder);
	});
var $elm$json$Json$Decode$string = _Json_decodeString;
var $author$project$Model$Component$Properties$VacancyFilterOptionSearch$Flags$flagsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'currentOptions',
	$elm$json$Json$Decode$list($author$project$Data$Id$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'noResultMessage',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'placeholder',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'location',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'sessionToken',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'filterId',
						$author$project$Data$Id$decoder,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'domainId',
							$author$project$Data$Id$decoder,
							$elm$json$Json$Decode$succeed($author$project$Model$Component$Properties$VacancyFilterOptionSearch$Flags$Flags))))))));
var $author$project$VacancyFilterOptionSearch$FilterSearchMsg = $elm$core$Basics$identity;
var $lydell$elm_app_url$AppUrl$AppUrl = F3(
	function (path, queryParameters, fragment) {
		return {at5: fragment, _n: path, aaG: queryParameters};
	});
var $elm$core$Dict$RBEmpty_elm_builtin = {$: -2};
var $elm$core$Dict$empty = $elm$core$Dict$RBEmpty_elm_builtin;
var $elm$core$Maybe$map = F2(
	function (f, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return $elm$core$Maybe$Just(
				f(value));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $elm$url$Url$percentDecode = _Url_percentDecode;
var $elm$core$Maybe$withDefault = F2(
	function (_default, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return value;
		} else {
			return _default;
		}
	});
var $lydell$elm_app_url$AppUrl$percentDecode = function (string) {
	return A2(
		$elm$core$Maybe$withDefault,
		string,
		$elm$url$Url$percentDecode(string));
};
var $lydell$elm_app_url$AppUrl$trimLeadingSlash = function (string) {
	return A2($elm$core$String$startsWith, '/', string) ? A2($elm$core$String$dropLeft, 1, string) : string;
};
var $elm$core$Basics$negate = function (n) {
	return -n;
};
var $elm$core$String$dropRight = F2(
	function (n, string) {
		return (n < 1) ? string : A3($elm$core$String$slice, 0, -n, string);
	});
var $elm$core$String$endsWith = _String_endsWith;
var $lydell$elm_app_url$AppUrl$trimTrailingSlash = function (string) {
	return A2($elm$core$String$endsWith, '/', string) ? A2($elm$core$String$dropRight, 1, string) : string;
};
var $lydell$elm_app_url$AppUrl$parsePath = function (path) {
	var trimmed = $lydell$elm_app_url$AppUrl$trimTrailingSlash(
		$lydell$elm_app_url$AppUrl$trimLeadingSlash(path));
	return $elm$core$String$isEmpty(trimmed) ? _List_Nil : A2(
		$elm$core$List$map,
		$lydell$elm_app_url$AppUrl$percentDecode,
		A2($elm$core$String$split, '/', trimmed));
};
var $elm$core$Basics$composeR = F3(
	function (f, g, x) {
		return g(
			f(x));
	});
var $lydell$elm_app_url$AppUrl$insert = F2(
	function (value, maybeList) {
		return $elm$core$Maybe$Just(
			A2(
				$elm$core$List$cons,
				value,
				A2($elm$core$Maybe$withDefault, _List_Nil, maybeList)));
	});
var $elm$core$String$replace = F3(
	function (before, after, string) {
		return A2(
			$elm$core$String$join,
			after,
			A2($elm$core$String$split, before, string));
	});
var $lydell$elm_app_url$AppUrl$queryParameterDecode = A2(
	$elm$core$Basics$composeR,
	A2($elm$core$String$replace, '+', ' '),
	$lydell$elm_app_url$AppUrl$percentDecode);
var $elm$core$Basics$compare = _Utils_compare;
var $elm$core$Dict$get = F2(
	function (targetKey, dict) {
		get:
		while (true) {
			if (dict.$ === -2) {
				return $elm$core$Maybe$Nothing;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var _v1 = A2($elm$core$Basics$compare, targetKey, key);
				switch (_v1) {
					case 0:
						var $temp$targetKey = targetKey,
							$temp$dict = left;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
					case 1:
						return $elm$core$Maybe$Just(value);
					default:
						var $temp$targetKey = targetKey,
							$temp$dict = right;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
				}
			}
		}
	});
var $elm$core$Dict$Black = 1;
var $elm$core$Dict$RBNode_elm_builtin = F5(
	function (a, b, c, d, e) {
		return {$: -1, a: a, b: b, c: c, d: d, e: e};
	});
var $elm$core$Dict$Red = 0;
var $elm$core$Dict$balance = F5(
	function (color, key, value, left, right) {
		if ((right.$ === -1) && (!right.a)) {
			var _v1 = right.a;
			var rK = right.b;
			var rV = right.c;
			var rLeft = right.d;
			var rRight = right.e;
			if ((left.$ === -1) && (!left.a)) {
				var _v3 = left.a;
				var lK = left.b;
				var lV = left.c;
				var lLeft = left.d;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					key,
					value,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					rK,
					rV,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, left, rLeft),
					rRight);
			}
		} else {
			if ((((left.$ === -1) && (!left.a)) && (left.d.$ === -1)) && (!left.d.a)) {
				var _v5 = left.a;
				var lK = left.b;
				var lV = left.c;
				var _v6 = left.d;
				var _v7 = _v6.a;
				var llK = _v6.b;
				var llV = _v6.c;
				var llLeft = _v6.d;
				var llRight = _v6.e;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					lK,
					lV,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, key, value, lRight, right));
			} else {
				return A5($elm$core$Dict$RBNode_elm_builtin, color, key, value, left, right);
			}
		}
	});
var $elm$core$Dict$insertHelp = F3(
	function (key, value, dict) {
		if (dict.$ === -2) {
			return A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
		} else {
			var nColor = dict.a;
			var nKey = dict.b;
			var nValue = dict.c;
			var nLeft = dict.d;
			var nRight = dict.e;
			var _v1 = A2($elm$core$Basics$compare, key, nKey);
			switch (_v1) {
				case 0:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						A3($elm$core$Dict$insertHelp, key, value, nLeft),
						nRight);
				case 1:
					return A5($elm$core$Dict$RBNode_elm_builtin, nColor, nKey, value, nLeft, nRight);
				default:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						nLeft,
						A3($elm$core$Dict$insertHelp, key, value, nRight));
			}
		}
	});
var $elm$core$Dict$insert = F3(
	function (key, value, dict) {
		var _v0 = A3($elm$core$Dict$insertHelp, key, value, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$getMin = function (dict) {
	getMin:
	while (true) {
		if ((dict.$ === -1) && (dict.d.$ === -1)) {
			var left = dict.d;
			var $temp$dict = left;
			dict = $temp$dict;
			continue getMin;
		} else {
			return dict;
		}
	}
};
var $elm$core$Dict$moveRedLeft = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.e.d.$ === -1) && (!dict.e.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var lLeft = _v1.d;
			var lRight = _v1.e;
			var _v2 = dict.e;
			var rClr = _v2.a;
			var rK = _v2.b;
			var rV = _v2.c;
			var rLeft = _v2.d;
			var _v3 = rLeft.a;
			var rlK = rLeft.b;
			var rlV = rLeft.c;
			var rlL = rLeft.d;
			var rlR = rLeft.e;
			var rRight = _v2.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				rlK,
				rlV,
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					rlL),
				A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rlR, rRight));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v4 = dict.d;
			var lClr = _v4.a;
			var lK = _v4.b;
			var lV = _v4.c;
			var lLeft = _v4.d;
			var lRight = _v4.e;
			var _v5 = dict.e;
			var rClr = _v5.a;
			var rK = _v5.b;
			var rV = _v5.c;
			var rLeft = _v5.d;
			var rRight = _v5.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$moveRedRight = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.d.d.$ === -1) && (!dict.d.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var _v2 = _v1.d;
			var _v3 = _v2.a;
			var llK = _v2.b;
			var llV = _v2.c;
			var llLeft = _v2.d;
			var llRight = _v2.e;
			var lRight = _v1.e;
			var _v4 = dict.e;
			var rClr = _v4.a;
			var rK = _v4.b;
			var rV = _v4.c;
			var rLeft = _v4.d;
			var rRight = _v4.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				lK,
				lV,
				A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					lRight,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight)));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v5 = dict.d;
			var lClr = _v5.a;
			var lK = _v5.b;
			var lV = _v5.c;
			var lLeft = _v5.d;
			var lRight = _v5.e;
			var _v6 = dict.e;
			var rClr = _v6.a;
			var rK = _v6.b;
			var rV = _v6.c;
			var rLeft = _v6.d;
			var rRight = _v6.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$removeHelpPrepEQGT = F7(
	function (targetKey, dict, color, key, value, left, right) {
		if ((left.$ === -1) && (!left.a)) {
			var _v1 = left.a;
			var lK = left.b;
			var lV = left.c;
			var lLeft = left.d;
			var lRight = left.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				lK,
				lV,
				lLeft,
				A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, lRight, right));
		} else {
			_v2$2:
			while (true) {
				if ((right.$ === -1) && (right.a === 1)) {
					if (right.d.$ === -1) {
						if (right.d.a === 1) {
							var _v3 = right.a;
							var _v4 = right.d;
							var _v5 = _v4.a;
							return $elm$core$Dict$moveRedRight(dict);
						} else {
							break _v2$2;
						}
					} else {
						var _v6 = right.a;
						var _v7 = right.d;
						return $elm$core$Dict$moveRedRight(dict);
					}
				} else {
					break _v2$2;
				}
			}
			return dict;
		}
	});
var $elm$core$Dict$removeMin = function (dict) {
	if ((dict.$ === -1) && (dict.d.$ === -1)) {
		var color = dict.a;
		var key = dict.b;
		var value = dict.c;
		var left = dict.d;
		var lColor = left.a;
		var lLeft = left.d;
		var right = dict.e;
		if (lColor === 1) {
			if ((lLeft.$ === -1) && (!lLeft.a)) {
				var _v3 = lLeft.a;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					key,
					value,
					$elm$core$Dict$removeMin(left),
					right);
			} else {
				var _v4 = $elm$core$Dict$moveRedLeft(dict);
				if (_v4.$ === -1) {
					var nColor = _v4.a;
					var nKey = _v4.b;
					var nValue = _v4.c;
					var nLeft = _v4.d;
					var nRight = _v4.e;
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						$elm$core$Dict$removeMin(nLeft),
						nRight);
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			}
		} else {
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				value,
				$elm$core$Dict$removeMin(left),
				right);
		}
	} else {
		return $elm$core$Dict$RBEmpty_elm_builtin;
	}
};
var $elm$core$Dict$removeHelp = F2(
	function (targetKey, dict) {
		if (dict.$ === -2) {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_cmp(targetKey, key) < 0) {
				if ((left.$ === -1) && (left.a === 1)) {
					var _v4 = left.a;
					var lLeft = left.d;
					if ((lLeft.$ === -1) && (!lLeft.a)) {
						var _v6 = lLeft.a;
						return A5(
							$elm$core$Dict$RBNode_elm_builtin,
							color,
							key,
							value,
							A2($elm$core$Dict$removeHelp, targetKey, left),
							right);
					} else {
						var _v7 = $elm$core$Dict$moveRedLeft(dict);
						if (_v7.$ === -1) {
							var nColor = _v7.a;
							var nKey = _v7.b;
							var nValue = _v7.c;
							var nLeft = _v7.d;
							var nRight = _v7.e;
							return A5(
								$elm$core$Dict$balance,
								nColor,
								nKey,
								nValue,
								A2($elm$core$Dict$removeHelp, targetKey, nLeft),
								nRight);
						} else {
							return $elm$core$Dict$RBEmpty_elm_builtin;
						}
					}
				} else {
					return A5(
						$elm$core$Dict$RBNode_elm_builtin,
						color,
						key,
						value,
						A2($elm$core$Dict$removeHelp, targetKey, left),
						right);
				}
			} else {
				return A2(
					$elm$core$Dict$removeHelpEQGT,
					targetKey,
					A7($elm$core$Dict$removeHelpPrepEQGT, targetKey, dict, color, key, value, left, right));
			}
		}
	});
var $elm$core$Dict$removeHelpEQGT = F2(
	function (targetKey, dict) {
		if (dict.$ === -1) {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_eq(targetKey, key)) {
				var _v1 = $elm$core$Dict$getMin(right);
				if (_v1.$ === -1) {
					var minKey = _v1.b;
					var minValue = _v1.c;
					return A5(
						$elm$core$Dict$balance,
						color,
						minKey,
						minValue,
						left,
						$elm$core$Dict$removeMin(right));
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			} else {
				return A5(
					$elm$core$Dict$balance,
					color,
					key,
					value,
					left,
					A2($elm$core$Dict$removeHelp, targetKey, right));
			}
		} else {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		}
	});
var $elm$core$Dict$remove = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$removeHelp, key, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$update = F3(
	function (targetKey, alter, dictionary) {
		var _v0 = alter(
			A2($elm$core$Dict$get, targetKey, dictionary));
		if (!_v0.$) {
			var value = _v0.a;
			return A3($elm$core$Dict$insert, targetKey, value, dictionary);
		} else {
			return A2($elm$core$Dict$remove, targetKey, dictionary);
		}
	});
var $lydell$elm_app_url$AppUrl$parseQueryParameter = F2(
	function (segment, queryParameters) {
		var _v0 = A2($elm$core$String$split, '=', segment);
		if (!_v0.b) {
			return queryParameters;
		} else {
			if ((_v0.a === '') && (!_v0.b.b)) {
				return queryParameters;
			} else {
				var rawKey = _v0.a;
				var rest = _v0.b;
				return A3(
					$elm$core$Dict$update,
					$lydell$elm_app_url$AppUrl$queryParameterDecode(rawKey),
					$lydell$elm_app_url$AppUrl$insert(
						$lydell$elm_app_url$AppUrl$queryParameterDecode(
							A2($elm$core$String$join, '=', rest))),
					queryParameters);
			}
		}
	});
var $lydell$elm_app_url$AppUrl$parseQueryParameters = A2(
	$elm$core$Basics$composeR,
	$elm$core$String$split('&'),
	A2($elm$core$List$foldr, $lydell$elm_app_url$AppUrl$parseQueryParameter, $elm$core$Dict$empty));
var $lydell$elm_app_url$AppUrl$fromUrl = function (url) {
	return {
		at5: A2($elm$core$Maybe$map, $lydell$elm_app_url$AppUrl$percentDecode, url.at5),
		_n: $lydell$elm_app_url$AppUrl$parsePath(url._n),
		aaG: A2(
			$elm$core$Maybe$withDefault,
			$elm$core$Dict$empty,
			A2($elm$core$Maybe$map, $lydell$elm_app_url$AppUrl$parseQueryParameters, url.avk))
	};
};
var $author$project$View$Autocomplete$Http$State = $elm$core$Basics$identity;
var $author$project$View$Autocomplete$Http$DebounceMsg = function (a) {
	return {$: 7, a: a};
};
var $abymosa$elm_debounce$Debounce$Debounce = $elm$core$Basics$identity;
var $abymosa$elm_debounce$Debounce$init = F2(
	function (tagger, cooldown) {
		return {eO: cooldown, bj: _List_Nil, es: tagger};
	});
var $author$project$View$Autocomplete$Http$initDebouncer = A2($abymosa$elm_debounce$Debounce$init, $author$project$View$Autocomplete$Http$DebounceMsg, 500);
var $author$project$Data$Key$Key = $elm$core$Basics$identity;
var $author$project$Data$Key$newKey = 0;
var $author$project$Data$Autocomplete$Unknown = {$: 3};
var $author$project$Data$Autocomplete$unknown = $author$project$Data$Autocomplete$Unknown;
var $author$project$View$Autocomplete$Http$init = {y: $author$project$Data$Autocomplete$unknown, a4: $author$project$View$Autocomplete$Http$initDebouncer, ak: '', P2: $author$project$Data$Key$newKey};
var $author$project$View$FilterOptionSuggestions$init = function (flags) {
	var location = A2(
		$elm$core$Maybe$withDefault,
		A3($lydell$elm_app_url$AppUrl$AppUrl, _List_Nil, $elm$core$Dict$empty, $elm$core$Maybe$Nothing),
		A2(
			$elm$core$Maybe$map,
			function (url) {
				return _Utils_update(
					url,
					{at5: $elm$core$Maybe$Nothing});
			},
			A2(
				$elm$core$Maybe$map,
				$lydell$elm_app_url$AppUrl$fromUrl,
				$elm$url$Url$fromString(flags.Rs))));
	return _Utils_Tuple2(
		{
			xS: flags.xS,
			dp: flags.dp,
			H0: flags.H0,
			a7: $author$project$View$Autocomplete$Http$init,
			Rs: location,
			WB: flags.WB,
			d5: flags.d5,
			aW: $elm$core$Maybe$Just(flags.aW)
		},
		$elm$core$Platform$Cmd$none);
};
var $elm$core$Platform$Cmd$map = _Platform_map;
var $author$project$VacancyFilterOptionSearch$init = function (flags) {
	var _v0 = $author$project$View$FilterOptionSuggestions$init(flags);
	var model = _v0.a;
	var cmd = _v0.b;
	return _Utils_Tuple2(
		{b8: model},
		A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, cmd));
};
var $author$project$View$FilterOptionSuggestions$FilterOptionAutocompleteMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$View$Autocomplete$Http$Link = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Basics$composeL = F3(
	function (g, f, x) {
		return g(
			f(x));
	});
var $author$project$Copy$copy = {f5: 'Over ons', f7: 'Gebruik nieuwe tekst', f8: 'Accepteer alles', f9: 'Accepteer noodzakelijke cookies', ga: 'Accordion (enkel)', gb: 'Accordion start in open positie', gc: 'Accordion (groep)', gf: 'Actie uitgevoerd', gg: 'Soort actie', gh: 'Gesprek', gi: 'Standaard', gj: 'Review', gk: 'Acties', gm: 'Stel job alert in', gn: 'Actieve sollicitaties', gp: 'Actieve gebruikers', gq: 'Actieve vacatures', gr: 'Aantal actieve vacatures', gs: 'Activiteit', gt: 'Voeg toe', gu: 'Voeg ARIA-label toe', gv: 'Er is geen ‘Verantwoordelijke\' admin aanwezig', gw: 'Er is geen ‘Verantwoordelijke\' gebruiker aanwezig', gx: 'Voeg toe', gy: 'Notitie toevoegen', gz: 'Voeg contract toe', gA: 'Voeg CTA-kaart toe', gB: 'Upload je cv', gC: 'Voeg extra beschrijving toe', gD: 'Voeg formuliervelden toe', gE: 'Voeg icoon toe', gF: 'Voeg een extra item toe', gG: 'Voeg jouw motivatie toe', gH: 'Upload je motivatie', gI: 'Voeg nieuwe categorie toe', gJ: 'Voeg nieuw organisatieonderdeel toe', gK: 'Voeg extra organisatiekenmerk toe', gL: 'Toon salarisperiode in XML feed', gM: 'Voeg salarisperiode (per uur/maand/jaar) toe aan salaris in XML feed.', gN: 'Telefoonnummer', gO: 'Voeg stap toe', gP: 'Nieuwe salariscalculator', gQ: 'Tijd tonen bij einddatum', gR: 'Toont de tijd naast de vacature-einddatum in metadata. Zonder deze vlag wordt alleen de datum getoond.', gS: 'Voeg toe aan checkout', gT: 'Voeg nieuwe gebruiker toe', gU: 'Voeg gebruikers toe', gV: 'Voeg extra vacaturekenmerk toe', gW: 'Upload nieuw bestand', gX: 'Nieuwe versie', gZ: 'Upload document (1)', g_: 'Kies bestand', g$: 'Upload document (2)', g0: 'Kies bestand', g1: 'Extra bestand 3', g2: 'Upload extra bestand', g3: 'Extra bestand 4', g4: 'Upload extra bestand', g5: 'Extra bestand 5', g6: 'Upload extra bestand', g8: 'Adres ongeldig', g9: 'Adres', ha: 'Adres (autocomplete)', hb: 'Aanpassen:', hc: 'Pas SEO informatie aan', hd: 'Afghanistan', he: 'Afrika', hg: 'Na succesvol verzenden', hh: 'Na vacaturekaart nummer', hi: 'Middag', hj: 'Leeftijd', hl: 'Laat AI de afbeelding afbeelding met een instructie. Kies een vooraf ingestelde AI-instructie en pas deze aan naar wens. Niet tevreden met het resultaat? Pas de instructie aan en bewerk opnieuw. Je vorige afbeelding blijft gewoon bestaan, zodat je uiteindelijk de beste kunt uitkiezen. Als je meerdere afbeeldingen hebt bewerkt, dan wordt alleen de afbeelding opgeslagen die je op dat moment in je scherm ziet.', hm: 'Afbeelding bewerken met AI', hn: 'Afbeelding genereren met AI', ho: 'Laat AI een afbeelding genereren met een instructie. Kies een vooraf ingestelde AI-instructie en pas deze aan naar wens. Je kunt pas een afbeelding opslaan wanneer je deze een titel hebt gegeven. Niet tevreden met het resultaat? Pas de instructie aan en genereer opnieuw. Je vorige afbeelding blijft gewoon bestaan, zodat je uiteindelijk de beste kunt uitkiezen. Als je meerdere afbeeldingen hebt gegenereerd, dan wordt alleen de afbeelding opgeslagen die je op dat moment in je scherm ziet.', hp: 'AI instructie', hq: 'Creëer een inspirerende afbeelding voor een recruitmentpagina binnen het vakgebied [vakgebied].<br>De stijl moet warm, mensgericht en toegankelijk zijn.<br>Toon mensen in een natuurlijke werkomgeving die samenwerken of plezier hebben in hun werk.<br>Zorg voor diversiteit in leeftijd, gender en culturele achtergrond, zodat een breed en inclusief team zichtbaar wordt.<br>Gebruik kleuren die aansluiten bij de huisstijl van  {{bedrijfsnaam}}.<br>Voeg een subtiel visueel element toe dat specifiek is voor de organisatie, zoals een product, locatie of symbool dat herkenbaar is voor {{bedrijfsnaam}}.', hr: 'Voeg meer sfeer- en cultuur-elementen', hs: 'Werken bij ons bedrijf voor een doelgroep (met logo)', ht: 'Visuele elementen toevoegen', hu: 'Aanpassen van de kleuren', hv: 'Team aan het werk bij ons bedrijf in agile omgeving', hw: 'Inzicht in doorgroeimogelijkheden', hx: 'In een andere omgeving plaatsen', hy: 'Vergelijk de tekst inhoudelijk', hz: 'Omzetten naar cartoonstijl', hA: 'Kernwaarden en de manier van werken', hB: 'Achtergrondafbeelding maken', hC: 'Maken van een bannerafbeelding', hD: 'Zakelijke bannerafbeelding maken', hE: 'Illustratie van medewerker maken', hF: 'Werken bij ons bedrijf voor een doelgroep met logo', hG: 'Illustratie van functie maken', hH: 'Stockfoto voor functie creëren', hI: 'Moderne bannerafbeelding bij functie creëren', hJ: 'Grafische visual ontwerpen', hK: 'Elevator pitch voor de werken-bij-site', hL: 'Medewerker aan het woord', hM: 'Sfeerbeeld bij employer branding', hN: 'Uitleg functie en verantwoordelijkheden', hO: 'Verbeteren huidige tekst', hP: 'Introductietekst voor een doelgroep pagina', hQ: 'Maak de tekst inclusiever', hR: 'Maak de huidige tekst energieker', hS: 'Beschrijving missie en visie', hT: 'Afbeelding voor onboarding', hU: 'Optimaliseer de tekst voor SEO', hV: 'Optimaliseer de toon van de huidige tekst', hW: 'Mensen in moderne kantooromgeving', hX: 'Uitlichten projecten en klanten', hY: 'Inspirerende recruitmentafbeelding', hZ: 'Verplaatsen van de situatie', h_: 'Verwijder de achtergrond van de foto', h$: 'Verwijder enkele personen of objecten', h0: 'Vervang de achtergrond', h1: 'Herstructureer de tekst', h2: 'Herschrijf de functieomschrijving', h3: 'Beschrijving secundaire arbeidsvoorwaarden', h4: 'Verkort de tekst', h5: 'Afbeelding om kernwaarde te tonen', h6: 'Vertalen naar Engels', h7: 'Unieke voordelen van de functie', h8: 'Beschrijving werkdag van een functie', h9: 'Voeg meer sfeer- en cultuur-elementen toe aan de bestaande tekst, zodat kandidaten zich een beter beeld kunnen vormen van werken bij {{bedrijfsnaam}}.', ia: 'Maak op basis van deze afbeelding een nieuwe afbeelding waarin ons bedrijfslogo {{bedrijfsnaam}} subtiel terugkomt en wat de [DOELGROEP] interessant vindt om te werken', ib: 'Voeg visuele elementen toe die kernwaarden zoals samenwerking innovatie of diversiteit uitbeelden om kandidaten een indruk te geven van de bedrijfscultuur.', ic: 'Pas de kleuren en uitstraling van de foto aan zodat deze aansluit bij de huisstijl van de werken-bij-site.', id: 'Maak een afbeelding van een team dat aan het werk is bij {{bedrijfsnaam}} in agile werkomgeving', ie: 'Genereer een tekst in het [LANGUAGE] die uitlegt welke doorgroeimogelijkheden {{bedrijfsnaam}} biedt, inclusief voorbeelden van hoe medewerkers zich kunnen ontwikkelen binnen [VAKGEBIED].', $8: 'Plaats de mensen uit de foto in een moderne kantooromgeving van {{bedrijfsnaam}} zodat kandidaten een realistisch beeld krijgen van de werkplek.', ig: 'Vergelijk de tekst inhoudelijk met vacatureteksten van concurrenten binnen [VAKGEBIED] en maak hem onderscheidender en aantrekkelijker.', ih: 'Zet de afbeelding om naar een strip- of cartoonstijl om de cultuur en creatieve kant van het bedrijf speelser te tonen.', ii: 'Schrijf een inspirerend stukje in het [LANGUAGE] over de kernwaarden van {{bedrijfsnaam}} en hoe die terugkomen in de manier van werken.', ij: 'Genereer een achtergrondafbeelding (zonder logo of tekst) voor de werken-bij-homepage van {{bedrijfsnaam}} die trots op ons werk uitstraalt.', ik: 'Genereer een headerafbeelding (zonder tekst) voor de functie [FUNCTIE], in een moderne, professionele stijl waarbij het logo van {{bedrijfsnaam}} op de kleding staat.', il: 'Maak van de foto een zakelijke stockfoto-stijl die direct toepasbaar is als header-afbeelding (zonder tekst) op een vacaturepagina voor de functie [FUNCTIE].', im: 'Creëer een illustratie van een medewerker in de rol van [FUNCTIE], werkend in een setting die past bij de bedrijfscultuur van {{bedrijfsnaam}}', $9: 'Maak een nieuwe afbeelding waarin ons bedrijfslogo {{bedrijfsnaam}} subtiel terugkomt en wat de [DOELGROEP] interessant vindt om te werken', io: 'Maak een illustratie (zonder tekst) van een [FUNCTIE], zodat kandidaten direct een beeld krijgen van de functie.', ip: 'Creëer een stock-achtige maar merkgebonden foto van een medewerker aan het werk als [FUNCTIE] voor {{bedrijfsnaam}}.', iq: 'Genereer een moderne headerafbeelding (zonder tekst) voor de vacature [FUNCTIE] bij {{bedrijfsnaam}}, in de huisstijlkleuren en met een professionele uitstraling.', ir: 'Ontwerp een grafische visual die laat zien dat werk-privébalans belangrijk is binnen {{bedrijfsnaam}}', is: 'Genereer een korte, enthousiaste Werken bij {{bedrijfsnaam}}-pitch (max. 150 woorden) in het [LANGUAGE] die uitlegt waarom kandidaten voor deze organisatie moeten kiezen.', it: 'Schrijf een stukje  in het [LANGUAGE] waarin een medewerker met de functie van [FUNCTIENAAM] bij {{bedrijfsnaam}} aan het woord komt om een realistisch beeld te geven van de cultuur en sfeer. Voeg ook een quote toe die op andere pagina\'s gebruikt kan worden.', iu: 'Maak een sfeerbeeld (zonder tekst) dat diversiteit en inclusie benadrukt, passend bij de employer branding van {{bedrijfsnaam}}', iv: 'Stel een overzichtelijke uitleg op van de functie [FUNCTIENAAM] in het [LANGUAGE]: wat zijn de belangrijkste verantwoordelijkheden en welke impact heeft dit werk binnen {{companyname}}?', iw: 'Verbeter de huidige tekst  over [FUNCTIENAAM] bij {{bedrijfsnaam}} door hem enthousiaster en meer uitnodigend te maken voor potentiële kandidaten.', ix: 'Schrijf een wervende introductietekst (maximaal 500 karakters) voor de [VAKGEBIED] pagina van de werken-bij-site van {{bedrijfsnaam}} in het [LANGUAGE], waarin duidelijk de sfeer, cultuur en belangrijke kernwaarden naar voren komen.', iy: 'Maak de tekst inclusiever en aantrekkelijk voor een brede doelgroep, zonder de specifieke kenmerken van {{bedrijfsnaam}} te verliezen.', iz: 'Maak de huidige tekst energieker en actiever door gebruik te maken van positieve, actiegerichte formuleringen die passen bij de kernwaarden van {{bedrijfsnaam}}.', iA: 'Schrijf een inspirerende tekst in het [LANGUAGE] waarin de missie en visie van {{bedrijfsnaam}} worden gekoppeld aan de dagelijkse praktijk van [FUNCTIENAAM] binnen [VAKGEBIED].', iB: 'Ontwerp een afbeelding (zonder tekst) waarin het onboarding-programma van {{bedrijfsnaam}} centraal staat', iC: 'Optimaliseer de tekst voor SEO door relevante zoekwoorden zoals werken bij {{bedrijfsnaam}} en vacature [FUNCTIENAAM] natuurlijk in te passen.', iD: 'Optimaliseer de toon van de huidige tekst zodat hij persoonlijker en toegankelijker wordt, maar toch past bij de cultuur en kernwaarden van {{bedrijfsnaam}}.', iE: 'Plaats de mensen uit de foto in een moderne kantooromgeving van {{bedrijfsnaam}} zodat kandidaten een realistisch beeld krijgen van de werkplek.', iF: 'Genereer een wervend stukje  in het [LANGUAGE]  waarin de unieke projecten of klanten (geef een voorbeeld) van {{bedrijfsnaam}} worden uitgelicht en leg uit wat dit betekent voor iemand die start als [FUNCTIENAAM].', iG: 'Verplaats de afgebeelde personen naar een andere situatie zoals een teamoverleg of informele koffiepauze om de sociale kant van het werk te laten zien.', iH: 'Verwijder de achtergrond van de foto en vervang deze door een neutrale achtergrond die geschikt is voor gebruik op een werken-bij-site.', iI: 'Verwijder enkele personen of objecten uit de foto zodat de afbeelding professioneler en overzichtelijker oogt op de werken-bij-site van {{bedrijfsnaam}}.', iJ: 'Vervang de achtergrond door een inspirerende werkplek zoals een open kantoor creatieve studio of productielocatie die de sfeer van het bedrijf benadrukt.', iK: 'Herstructureer de tekst zodat hij beter scanbaar is, met duidelijke kopjes en bullets die de inhoud over [FUNCTIENAAM] overzichtelijk presenteren.', iL: 'Herschrijf de functieomschrijving in het [LANGUAGE] voor [FUNCTIENAAM] binnen [VAKGEBIED] zodat hij meer gericht is op de beleving van de kandidaat (focus op voordelen en kansen).', iM: 'Creëer een aantrekkelijke tekst in het [LANGUAGE] over de secundaire arbeidsvoorwaarden bij {{bedrijfsnaam}}, zoals opleidingsbudget, teamuitjes of flexibele werktijden. Gebruik een informele, maar professionele toon.', iN: 'Verkort de tekst zonder belangrijke informatie over [FUNCTIENAAM] te verliezen, zodat hij aantrekkelijker en sneller leesbaar wordt.', iO: 'Ontwerp een realistische afbeelding (zonder tekst) voor de werken-bij-website van {{bedrijfsnaam}} die de kernwaarde [KERNWAARDE] visueel tot leven brengt.', iP: 'Vertaal de huidige tekst naar het Engels, zodat hij geschikt is voor een internationale doelgroep.', iQ: 'Noem drie Unique Selling Points (1 kop en een zin) in het [LANGUAGE] waarom een [FUNCTIENAAM] voor {{bedrijfsnaam}} moet kiezen.', iR: 'Beschrijf in het [LANGUAGE] hoe een werkdag eruitziet als [FUNCTIENAAM] bij {{bedrijfsnaam}}, zodat kandidaten een goed beeld krijgen van de dagelijkse praktijk.', iS: 'AI instructie', iU: 'Laat AI tekst genereren op basis van je huidige tekst en een AI instructie. Kies een vooraf ingestelde AI instructie of pas deze aan naar wens. Sla het resultaat op wanneer je tevreden bent met de nieuwe tekst.', iV: 'AI tekst genereren', iW: 'Laat AI een volledig nieuwe tekst schrijven op basis van je AI instructie. Kies een vooraf ingestelde AI instructie of pas deze aan naar wens. Sla het resultaat op wanneer je tevreden bent met de nieuwe tekst.', iX: 'Nieuwe tekst genereren:', iY: 'Nieuwe tekst genereren:', iZ: 'Ålandseilanden', i_: 'Albanië', i$: 'Algerije', i0: 'Onder', i1: 'Midden', i2: 'Uitvullen', i5: 'Links', i6: 'Rechts', i8: 'Boven', i9: 'Alle', ja: 'Gebruiker heeft autorisatie voor alle organisatiekenmerken in dit domein.\n    ', jb: 'Gebruiker heeft autorisatie voor alle organisatiekenmerken in de categorie {0}.', jc: 'Gebruiker heeft autorisatie voor alle locaties.', jd: 'Alle tokens ingetrokken', je: 'Alle vervoersmiddelen', jf: 'Alle gebruikers uit het bestand kunnen succesvol geüpload worden.', jg: 'Alle vacatures', jh: 'Alle vacatures voor', jk: 'Toegestaan in de volgende kolommen', jl: 'Toegestaan in de volgende groepen', jp: 'Alternatieve styling', jq: 'Amerika', jr: 'Amerikaans-Samoa', js: 'Analytics', jt: 'Analytics & consent', ju: 'Conversational Apply', jv: 'Google Analytics (GA3)', jw: 'Analytics / GTM', jx: 'Analytics opslag altijd toegestaan', jy: 'Stuurt altijd analytics_storage: granted naar GTM, ook wanneer alleen noodzakelijke cookies zijn geaccepteerd.', jA: 'Anchor link', jB: 'En', jC: 'en/of', jD: 'Andorra', jE: 'Angola', jF: 'Anguilla', jG: 'Geanonimiseerd', jH: 'Anonimiseer', jI: 'Weet je zeker dat je deze sollicitatie wilt anonimiseren? Dit betekent dat je deze niet meer kan inzien en alle gegevens van de sollicitant worden leeggehaald. De geanonimiseerde sollicitatie wordt nog wel getoond in het overzicht en meegenomen in de telling.', jJ: 'Sollicitatie anonimiseren', jL: 'Antigua en Barbuda', jM: 'Maakt niet uit', jN: 'Appetizer', jO: 'Appetizer overschrijven', jP: 'Apple mail', jQ: 'Totale aantal Apple mail gebruikers.', jT: 'Journey', jU: 'Journeys (slider)', jV: 'Sollicitantreis met hover', jW: 'Schakelt het interactieve Sollicitantreis component in met hover-getriggerde animaties die sollicitatieprocesstappen tonen.', jX: 'Journeys (slider)', jY: 'Applicant journey met hover', jZ: 'Journeys (tabs + video)', j_: 'Journeys (tabs)', j$: 'Sollicitatie', j0: 'Actie', j1: 'Actie verwijderd', j2: 'Acties', j3: 'Sollicitaties succesvol bijgewerkt', j5: 'Sollicitanten CSV-export', j6: 'Voegt een knop toe om sollicitanten te exporteren naar CSV in het sollicitantenoverzicht.', j7: 'Sollicitatieformulier gestart', j8: 'Dit sollicitatieformulier wordt gebruikt door een vacature', j9: 'Sollicitatieformulier bekeken', ka: 'Sollicitatie funnel', kb: 'Funnel van website bezoeken tot aan aangenomen kandidaten', kc: 'Aangenomen', ke: 'Sollicitatiemethode', kf: 'Solliciteren via een gesprek.', kg: 'Standaard formulier', kh: 'Kandidaten vullen een formulier in.', ki: 'Overzicht sollicitaties', kj: 'Templates - Sollicitatiepagina', kk: 'Sollicitatieprocedure verwijderd', km: 'Sollicitatieproces', kn: 'Voorbeeld titel', ko: 'Sollicitatieproces opgeslagen.', kp: 'Solicitatie stap', kq: 'Sollicitatieproces stappen', kr: 'Sollicitatieprocedure', ks: 'Sollicitatieproces', kt: 'Afgewezen', ku: 'Sollicitatie gestart', kv: 'Sollicitatiestatus', kw: 'Sollicitatiestatussen', kx: 'Type sollicitatie', ky: 'Sollicitaties', kz: 'Sollicitaties vorige periode', kA: 'sollicitaties per pagina', kB: 'Sollicitatie op vacature', kC: 'Solliciteer direct', kD: 'Sollicitatie button overschrijven', kE: 'Sollicitatiedatum', kF: 'Toepassen filters', kG: 'Solliciteer op deze vacature', kH: 'Sollicitatieformulier in de vacaturebanner', kI: 'Solliciteer op passende vacatures', kJ: 'Solliciteren bij meerdere locaties', kK: 'Sollicitatieformulier op een nieuwe pagina', kL: 'Carerix sollicitatietags export', kM: 'Voegt UTM-trackingdata (bron, medium, campagne) toe als sollicitatietags op het kandidaatrecord bij export naar Carerix.', kN: 'Dit template geld voor:', kO: 'Sollicitatie-URL', kP: 'Solliciteer via', kQ: 'Goedgekeurd', kS: 'Archiveer gebruiker', kT: 'Gearchiveerd op:', kU: 'Weet je zeker dat je dit item wilt verwijderen?', kW: 'Argentinië', kX: 'Een ARIA-label draagt bij aan de toegankelijkheid van een website. Het label wordt voorgelezen door hulpmiddelen zoals screenreaders, zodat gebruikers met een visuele beperking begrijpen wat de functie of inhoud van een element is.', kY: 'Armenië', lf: 'Aruba', lg: 'Azië', lh: 'Vraag naar de locatie?', li: 'Banner groot (1180px breed, 800px hoog)', lj: 'Banner groot volledige breedte  (2040px breed, 800px hoog)', lk: 'Banner medium (1180px breed, 600px hoog)', ll: 'Banner medium volledige breedte (2040px breed, 600px hoog)', lm: 'Banner klein (1180px breed, 400px hoog)', ln: 'Banner klein volledige breedte (2040px breed, 400px hoog)', lo: 'Landschap (600px breed, 400px hoog)', lp: 'Portret (400px breed, 600px hoog)', lq: 'Vierkant (600px breed, 600px hoog)', ls: 'Toewijzen aan', lt: 'Toegewezen aan', lu: 'Verantwoordelijke (Toegewezen aan)', lv: 'Gekoppelde opties', lw: 'Schakelt het Gekoppelde Opties component in op vacaturepagina\'s. Toont tot 8 filteroptie-badges gerelateerd aan de huidige vacature (bijv. functietypes, locaties, urenreeksen). Alleen weergave, niet klikbaar.', lx: 'Minstens één van', ly: 'Minimaal een versie vereist', lz: 'om', lA: 'HamiltonCMS ATS-module', lB: 'Schakelt de HamiltonCMS ATS-module in. Migreert vacaturebron naar HamiltonCMS, ontgrendelt vacaturestatus-beheer, recruiter/locatie-toewijzing en autorisatiematrix-functies in het CMS.', lD: 'ATS koppelen', lE: 'Domein koppelen', lF: 'Koppelen maakt het {0}-schema en de standaardformulieren aan.', lG: 'Gekoppeld — schema en standaardformulier aangemaakt', lH: 'Koppeling verwijderd', lI: 'Koppeling bijgewerkt', lJ: 'ATS-koppelingen', lK: 'Credentials (JSON)', lL: 'Laat leeg om de opgeslagen credentials te behouden.', lM: 'Ontkoppelen', lN: 'Sollicitaties worden niet langer naar {0} geëxporteerd voor {1}.', lP: 'Het gekozen formulier hoort bij een ander ATS en kan hier niet worden gebruikt', lQ: 'Het gekozen formulier bestaat niet meer', lR: 'Het gekozen formulier is geen sollicitatieformulier', lS: 'Zodra Floyd Hamilton een ATS koppelt, verschijnt die hier met zijn schema en formulieren.', lT: 'Nog geen ATS gekoppeld', lU: '{0} eigen schema(\'s)', lV: 'Deze koppelingen worden beheerd door Floyd Hamilton.', lW: 'Minimaal 1 MB', lX: 'ATS-schema', lY: 'Alle domeinen', lZ: 'Toegestane bestandstypes', l_: 'Doorvoeren in bestaande formulieren', l$: 'Bestaande formulieren binnen dit bereik: {0}', l0: 'Ontbrekende verplichte velden worden toegevoegd aan elk bestaand formulier binnen dit bereik.', l1: 'Alleen laten gelden voor nieuwe formulieren', l2: 'Bestaande formulieren blijven zoals ze zijn. Een formulier dat daardoor een verplicht veld mist, kan pas weer worden opgeslagen als dat veld is toegevoegd.', l3: 'Standaard voor {0}: {1}', l4: 'Het ATS accepteert maximaal {0} MB.', l5: 'Wie wat wanneer heeft gewijzigd: de schema-instellingen per bereik en ATS, en het maken of opheffen van een eigen schema.', l6: 'Bestaande formulieren meekopiëren naar dit domein', l7: 'Elk gedeeld formulier krijgt een kopie voor dit domein met alleen de teksten van dit domein, en de vacaturetemplates en pagina\'s van dit domein wijzen naar de kopie. Zonder kopie begint dit domein zonder formulieren.', l8: 'Meekopiëren is hier verplicht', l9: 'Eigen schema maken voor {0}', ma: 'Eigen schema maken', mb: 'Standaard verplicht voor {0}', mc: 'Standaard {1} voor {0}', md: 'Formulieren die een verplicht veld missen', me: 'Deze formulieren kunnen pas weer worden opgeslagen als het ontbrekende veld is toegevoegd.', mf: 'Alle formulieren binnen dit bereik bevatten de verplichte velden.', mg: 'Wijkt af van {0}: daar standaard verplicht', mh: 'Wijkt af van {0}: daar standaard {1}', mi: 'Domeinen', mj: 'Aangevinkte velden worden bij een open sollicitatie niet gevraagd.', mk: '{0} verplicht · {1} beschikbaar · {2} niet beschikbaar', ml: '{0} staat nog op deze formulieren binnen dit bereik; haal het daar eerst weg voordat je het niet beschikbaar maakt:', mm: 'Beschikbaar', mn: 'Verplicht', mo: 'Niet beschikbaar', mp: 'Velden', mq: 'Niet beschikbaar: staat niet in de veldenkiezer. Beschikbaar: de klant kiest. Verplicht: staat op elk formulier.', mr: 'Bestandsregels', ms: 'Bestandsgrootte en bestandstypes gelden altijd direct.', mt: 'Wijkt af', mu: 'Vastgelegd door {0}', mv: '{0} volgt: Alle domeinen', mw: 'Soorten formulier waarvoor dit schema geldt', mx: 'Altijd verplicht', my: 'Het systeem heeft dit veld altijd nodig', mz: 'Maximale bestandsgrootte (MB)', mA: 'Ontbreekt: {0}', mB: 'Dit project heeft geen ATS waarvoor een schema geldt. Voeg een ATS-koppeling toe, of zet de ATM-module aan om het Applicant Tool te gebruiken.', mC: 'Er zijn nog geen formulieren binnen dit bereik.', mD: 'Dit project heeft één domein; het schema geldt daarvoor als geheel.', mE: 'Velden die niet meegaan bij een open sollicitatie', mF: '{0}: eigen schema', mG: 'Eigen schema', mH: 'Welke velden een formulier binnen dit bereik kan bevatten, welke verplicht zijn en welke bestandsregels gelden. Het schema is gevuld vanuit wat het ATS standaard verwacht; wat je hier instelt, geldt.', mI: 'Verplicht voor {0}', mJ: 'Verplicht volgens het ATS-schema', mK: 'Opheffen kan niet zolang een vacaturetemplate of pagina nog een eigen formulier gebruikt dat geen gedeelde tegenhanger heeft:', mL: 'Sollicitatiechats', mM: 'De eigen formulieren van dit domein worden verwijderd. Vacaturetemplates en pagina\'s die een kopie gebruiken, gaan terug naar het gedeelde formulier met dezelfde naam; daarna volgt het domein weer het schema voor alle domeinen.', mN: 'Eigen schema van {0} opheffen?', mO: 'Eigen schema opheffen', mP: '{0} volgt weer het schema voor alle domeinen.', mQ: 'Wat gebeurt er met de bestaande formulieren?', mR: 'Schema opslaan', mS: 'Het ATS-schema is opgeslagen.', mT: 'Bereik', mU: 'Gedeeld schema', mV: 'Zonder de bestaande formulieren mee te kopiëren houdt dit domein niets over om mee te solliciteren. Deze onderdelen gebruiken nu een gedeeld formulier en zouden er geen meer hebben:', mW: '{0} heeft nu een eigen schema.', mX: 'Deze vacaturetemplates van dit domein hebben geen formulier totdat er een is gemaakt en gekozen:', mY: 'Niet-opgeslagen wijzigingen', mZ: 'Kies een ATS', m_: 'Eigen schema maken voor {0}?', m$: 'Koppeling', m0: 'Je hebt wijzigingen in het schema die nog niet zijn opgeslagen. Wil je ze verwerpen?', m1: 'Verwerpen', m2: 'Verder bewerken', m3: 'Niet-opgeslagen wijzigingen', m4: 'Bijlage (optioneel)', m7: 'Product id', m9: 'Audio', na: 'Wijzigingsgeschiedenis', nb: 'Nog geen wijzigingen geregistreerd.', nc: 'Australië', as3: 'Oostenrijk', nd: 'We hebben jouw verzoek ontvangen', ne: 'Auteur', nf: 'Voeg auteur toe', ng: 'Autorisatie', nh: 'Automatisch afspelen', ni: 'Als dit veld aanstaat speelt de video automatisch af zonder geluid en word de thumbnail niet getoond.', nj: 'Bepaal automatisch op basis van de achtergrond kleur', nl: 'Beschikbaarheid (dagdeel)', nm: 'Beschikbaarheidsmatrix', nn: 'Schakelt het Beschikbaarheidsmatrix component in. Een wekelijks dag/dagdeel rooster op vacaturepagina\'s waar kandidaten hun beschikbaarheid aangeven.', no: 'Beschikbare dagdelen', nq: 'Gemiddeld aantal sollicitaties in deze periode:', nr: 'Gemiddelde sessie duur', ns: 'Azerbeidzjan', nt: 'Ga terug naar media', nu: 'Vastzetten op scherm (scrollt niet mee)', nG: 'Vast op scherm (fixed)', nI: 'Geavanceerde instellingen afbeelding', nK: 'Positionering', nL: 'Herhaling', nM: 'Schaalgedrag', nN: 'Onverwachte response body', nO: 'Het decoden van de response body is niet gelukt.', nP: 'Ongeldig verzoek', nQ: 'Verkeerde URL', nR: 'Bahama\'s', nS: 'Bahrein', nT: 'Balans', nU: 'Land waar je momenteel woont', nV: 'Interessegebieden', nW: 'Sectoren', nX: 'Interessegebieden en sectoren', nY: 'Je huidige functietitel', nZ: 'bijv. projectmanager', n_: 'Heb je nu of in de toekomst visumsponsoring nodig om in het Verenigd Koninkrijk en/of Ierland te werken?', n$: 'Bangladesh', n0: 'Banner (afbeelding)', n1: 'Banner & weergave', n2: 'Banner vacature appetizer (Recrubo)', n3: 'Schakelt de Recrubo-variant van de Vacature Appetizer banner in. Vervangt de standaard solliciteerknop door een Recrubo leadformulier-widget die vacaturedata vooraf invult. Vereist Recrubo Organisatie-ID en Flow-ID.', n4: 'Banner knoppen', n5: 'Schakelt het Banner Buttons component in. Een zelfstandige banner met meerdere knoppen, waarbij elke knop bij hover een ander beeld toont.', n6: 'Banner doorklik', n7: 'Schakelt het Banner Click-Through component in. Een banner met vorige/volgende pijllinks om tussen pagina\'s te navigeren.', n8: 'Kies het focuspunt van de bannerafbeelding', ob: 'Banner met zoekveld(en) - Afbeelding', oc: 'Banner met zoekveld(en) en logo\'s - Afbeelding', od: 'Banner met zoekveld(en) - Afbeelding', oe: 'Banner metadata positie', of: 'Positie van metadata ten opzichte van de banner afbeelding.', og: 'Banner metadata type', oh: 'Lay-out type voor banner metadata: kolom, rij, of icoon-gebaseerd.', oi: 'Banner met dropdownfilters - Afbeelding', oj: 'Banner zoeken met logo\'s', ok: 'Schakelt de Zoeken met Logo\'s bannercomponenten in. Een zoekbanner die een rij merklogo\'s toont tussen de koptekst en het zoekveld.', om: 'Vacaturebanner', on: 'Vacaturebanner met appetizer', oo: 'Vacaturebanner met appetizer -  Recrubo', op: 'Vacaturebanner met extra button', oq: 'Custom component \'Vacaturebanner met extra knop\' inschakelen', or: 'Extra button (optioneel)', os: 'Extra button voor de sollicitatiebutton plaatsen', ot: 'Alternatieve sollicitatiebanner', ou: 'Voegt een alternatieve vacaturebanner layout-optie toe. De standaard toont beeld en formulier naast elkaar; dit alternatief plaatst koptekst en metadata erboven, met een gestapelde layout eronder.', ov: 'Vacaturebanner met uitklapformulier', ow: 'Banner vacature appetizer', ox: 'Schakelt het Banner Vacature Appetizer component in. Een compacte vacaturebanner met tags, titel, metadata, samenvatting en solliciteer/deel-knoppen met vaste navigatie.', oy: 'Ik ken iemand', oz: 'Banner - Video', oA: 'Banner met zoekveld(en) - Video', oB: 'Banner met zoekveld(en) en logo\'s - Video', oD: 'Banner met dropdownfilters - Video', oE: 'Barbados', oF: 'Instellingen', oG: 'BCC', oI: 'Wit-Rusland', as6: 'België', oJ: 'Belize', oK: 'Benin', oL: 'Bermuda', oM: 'Better uptime', oS: 'Bhutan', oT: 'Fiets', oU: 'Facturering', o_: 'Bolivia', o1: 'Bosnië-Herzegovina', o3: 'Botswana', o5: 'Bouncepercentage', o6: 'Bounces', o8: 'Brazilië', o9: 'Pagina titel', pa: 'Kruimelpad', pb: 'Brits Indische Oceaanterritorium', pc: 'Britse Maagdeneilanden', pd: 'Browse media', pg: 'Analytics data per browser', ph: 'Browsers', pi: 'Browsers / Sollicitaties', pj: 'Brunei', pl: 'Bulgarije', pm: 'Kies actie op geselecteerde sollicitaties:', pn: 'Verstuur e-mail(s)', po: 'Burkina Faso', pp: 'Burundi', pq: 'Button', pr: 'Knop link', pt: 'Te voet', pv: 'Bereken salaris', atb: 'Landcode', px: 'Cambodja', py: 'Kameroen', pz: 'Campagne', pB: 'Campagne id', pC: 'Campagne', pD: 'Campagnestatus', pE: 'Campagnes', pF: 'Sollicitaties informatie per campagne', pG: 'Canada', atc: 'Annuleren', pI: 'Deze categorie kan niet verwijderd worden, aangezien er nog onderliggende organisatie kenmerken actief zijn.<br><br>Verwijder eerst de onderliggende organisatie kenmerken voordat deze categorie verwijderd kan worden.', pJ: 'Deze categorie kan niet verwijderd worden, aangezien er nog onderliggende vacaturekenmerken actief zijn.<br><br>Verwijder eerst de onderliggende vacaturekenmerken voordat deze categorie verwijderd kan worden.', pK: 'De volgende gebruikers kunnen niet geüpload worden:', pL: 'Kaapverdië', pM: 'Ondertiteling', pN: 'Auto', pO: 'Kaart', pP: 'Aantal kaarten om te tonen', pR: 'Kaarten (slider)', pT: 'Caribisch Nederland', pU: 'Categorie', pV: 'Beheer categorieën', pW: 'Sorteer bijbehorende vacaturekenmerken op basis van', pX: 'Type categorie', pY: 'Kaaimaneilanden', pZ: 'Midden', p_: 'Centraal-Afrikaanse Republiek', p$: 'Tsjaad', p0: 'Wijzigen', p1: 'Wijzig toegewezen aan', p2: 'Wijzig categorie', p3: 'Wijzigingsdatum', p4: 'Wijzig bestand', p5: 'Wijzig gegevens uit import', p6: 'Wijzig organisatieonderdeel', p7: 'Wijzigen status', p8: 'Kies welke actie uitgevoerd moet worden:', p9: 'Wijzigen sollicitatiestatus', qa: 'Met deze actie zal de sollicitatiestatus als volgt gewijzigd worden:', qb: 'De status van de vacature zal als volgt gewijzigd worden:', qc: 'Wijzig status', qe: 'Gewijzigd door', qf: 'Gewijzigd van import', qg: 'Kanalen', qm: 'Checkout', qr: 'Chili', atg: 'China', qs: 'Kies een tekstkleur', qt: 'Kies actie', qu: 'Kies een type categorie', qv: 'Kies communicatie', qw: 'Kies component', qx: 'Kies een custom component', qy: 'Kies nieuw bestand', qz: 'Kies vakgebied', qA: 'Kies bestaande media', qB: 'Kies bestand', qC: 'Kies groep(en)', qD: 'Kies interviewer(s)', qE: 'Kies locatie', qF: 'Kies optie(s) voor', qG: 'Kies bovenliggende categorie', qH: 'Kies persoon', qI: 'Kies vacature', qJ: 'Christmaseiland', qK: 'Chrome', qL: 'Totale aantal Chrome gebruikers.', qM: 'Stad', qN: 'Woonplaats', qO: 'Voer je woonplaats in', qP: 'Woonplaats', qQ: 'Woonplaats', qR: 'Leeg', qS: 'Wis periode', qT: 'Verwijder selectie', qU: 'Dit is een CLI test', qV: 'Klik om te verwijderen', qX: 'Geklikt', qY: 'Totaal aantal aangeklikte links. Dit totaal omvat ontvangers die meerdere keren op links in uw e-mail hebben geklikt.', q_: 'Geheim opnieuw gegenereerd', q0: 'Sluiten', q1: 'Vacatures sluiten aan einde dag', q2: 'Houdt vacatures zichtbaar gedurende de gehele einddatum door om 23:59 te controleren in plaats van middernacht. Zonder dit verdwijnen vacatures aan het begin van hun einddatum.', q3: 'Sluit submenu', q4: 'Sluit vacature', q5: 'Gesloten', q6: 'Afgeronde sollicitaties', q7: 'Gesloten vacatures', q9: 'Sollicitatie geanonimiseerd', ra: 'Geaccepteerd', rb: 'Afgewezen', rc: 'Geen gesprekken vastgelegd voor deze sollicitatie.', rd: 'Gesprek', re: 'Sollicitatie aangemaakt', rf: 'Sollicitatie verwijderd', rg: 'Email', rh: 'Voornaam', ri: 'Datum', rj: 'Achternaam', rk: 'Telefoonnummer', rl: 'Sollicitatiestatus', rm: 'Vacature ID', rn: 'Naam vacature', ro: 'Sollicitatie beoordeeld', rp: 'Sollicitatiestatus', rq: 'Sollicitatiestatussen', rr: 'Sollicitatie aangepast', rs: 'Stel hier het sjabloon in voor de inhoud van de e-mail die je wil ontvangen. Dit sjabloon ondersteunt Moustaches.', rt: 'Een optionele URL waar de gebruiker naartoe geleid wordt na het succesvol indienen van het contactformulier.', ru: 'Stel hier het sjabloon in voor het onderwerp van de e-mail die je wil ontvangen. Dit sjabloon ondersteunt moustaches.', rv: 'Extra document', rw: 'Motivatie', rx: 'CMS-bewerkingen overschrijven ATS', ry: 'Staat toe dat handmatige CMS-bewerkingen (bijv. spotlight-status) voorrang krijgen boven ATS-geimporteerde data. Zonder dit reset elke import CMS-bewerkte velden.', rz: 'Curriculum vitae', rA: 'Cocoseilanden', rD: 'Zijbalk inklappen', rE: 'Colombia', rF: 'Kleur', rG: 'Kolom', rH: 'Kolommen', rI: 'Gecombineerde Indeed feed', rJ: 'Voegt vacatures van alle domeinen samen in een enkele Indeed XML-feed in plaats van een feed per domein.', rK: 'Gecombineerde LinkedIn feed', rL: 'Voegt vacatures van alle domeinen samen in een enkele LinkedIn XML-feed in plaats van een feed per domein. Standaard ingeschakeld.', rM: 'Commandopalet (⌘K)', rN: 'Activeert het globale ⌘K-commandopalet om pagina\'s, vacatures, nieuws, evenementen, formulieren en sollicitaties te doorzoeken in alle CMS-domeinen waar je toegang toe hebt.', rO: 'Opmerking (optioneel)', rP: 'Notitie toegevoegd', rQ: 'Beste {{sollicitatieToegewezenVoornaam}},<br><br>{{gebruikerVoornaam}} heeft een opmerking geplaatst bij de sollicitatie van {{sollicitantVoornaam}} {{sollicitantAchternaam}} ({{vacatureTitel}}):<br><br>{{opmerking}}<br><br>{{{sollicitatieLink}}}', rR: 'Melding: Opmerking geplaatst bij sollicitatie', rS: 'Opmerking geplaatst bij {{sollicitantVoornaam}}', rT: 'Notitie verwijderd', rU: 'Voeg notitie toe', rV: 'Communicatie', rX: 'Communicatie verstuurd', rY: 'Inhoud', rZ: 'Titel communicatie', r_: 'Onderwerp e-mail', r$: 'Comoren', r1: 'Compleet', r3: 'Concept', r6: 'Bevestiging sollicitatie', r7: 'Beste {{sollicitantVoornaam}},<br><br>Bedankt voor je interesse in {{bedrijfsnaam}} en jouw sollicitatie op de functie van {{vacaturetitel}} {{locatie}} op {{sollicitatiedatum}}.<br><br>We gaan je sollicitatie goed bekijken. Uiterlijk binnen twee weken krijg je een inhoudelijke reactie.<br><br>Voor vragen kun je natuurlijk altijd contact opnemen via onderstaande gegevens.<br><br>Met vriendelijke groet,<br><br>{{vacatureToegewezenVoornaam}} {{vacatureToegewezenAchternaam}}<br>{{vacatureToegewezenTelefoonnummer}}<br>{{vacatureToegewezenEmail}}', r8: 'Bevestiging sollicitatie', r9: 'Jouw sollicitatie bij {{bedrijfsnaam}}', sb: 'Bevestig verwijderen', sc: 'Bevestig e-mailadres', sd: 'Bevestig je e-mailadres', se: 'Bevestig je e-mailadres', sn: 'Congo-Kinshasa', so: 'Connexys bedankpagina FH', sp: 'Gebruikt de Floyd Hamilton bedankpagina na een Connexys-sollicitatie.', ss: 'Consent instellingen', st: 'Toestemmingsstring cookienaam', su: 'Naam van de cookie die de Didomi-toestemmingsstring opslaat (standaard: didomi_dcs)', sv: 'Telt mee', sw: 'Consolidatie: uitgesloten filters', sx: 'Consolidatie: filters die meetellen', sz: 'Contactformulier', sA: 'Verzend contactverzoek naar e-mailadres:', sB: 'Doorsturen naar pagina (URL-pad) na succesvolle verzending (optioneel)', sC: 'Contactpersoon', sE: 'Naam contactpersoon', sF: 'Contactpersoon bij vacature', dg: 'Content', sG: 'Content', sH: 'Content (slider)', sI: 'Contract informatie', sJ: 'Contractvoorstel', sK: 'Contracttype', sL: 'Contracten', sM: 'Afhakers tellen pas mee nadat de bewaartermijn is verlopen. Dit cijfer loopt daardoor tot 14 dagen achter.', sN: 'Afgehaakt', sO: 'Vraag verduidelijkt', sP: 'Antwoord bevestigd', sQ: 'Waarde overgenomen', sR: 'Aangeboden', sS: 'Overgeslagen', sT: 'Bevestigd', sU: 'Hoe vaak de assistent kandidaten helpt een vraag te beantwoorden.', sV: 'De AI vraagt in {0}% van de gevallen om verduidelijking in plaats van het antwoord te bevestigen. Je vragen zijn mogelijk niet duidelijk genoeg.', sW: 'De AI bevestigt meestal het antwoord van de kandidaat ({0}%).', sX: 'AI-assistentie', sY: 'Alle apparaten', sZ: 'Alle chats', s_: 'Meeste afhakers', s$: 'Heb je de vragen in deze periode aangepast? Toegevoegde of gewijzigde vragen zijn gemarkeerd, zodat je cijfers eerlijk vergelijkt.', s0: 'Gestarte chats', s1: 'Conclusie', s2: 'A vergeleken met B', s3: 'gelijk', s4: 'Verschil', s5: 'hoger', s6: 'lager', s7: 'Verschillen per vraag zijn verkennend en niet gecorrigeerd voor meervoudig testen.', s8: '{0} {1} sneller', s9: 'Nog te weinig data om te vergelijken', ta: 'Beide chats presteren ongeveer gelijk', tb: '{0} converteert betrouwbaar hoger: {1} vs {2}', tc: 'Mediaan telt alleen verzonden chats; afgehaakt loopt tot 14 dagen achter.', td: 'Je hebt minimaal {0} chats aan beide kanten nodig — {1}: {2}, {3}: {4}', te: 'Statistiek', tf: 'Andere chat', tg: 'Vorige periode', th: 'Kies twee verschillende chats om te vergelijken', ti: 'Aantal vragen', tj: 'Betrouwbaar verschil (95%)', tk: 'Geen betrouwbaar verschil in conversie: {0} vs {1} (95%)', tl: 'Chats vergelijken', tm: 'Vergelijken met', tn: 'waarschijnlijk {0}–{1}%', to: 'Conversieratio', tp: 'beter dan de vorige periode', tq: 'slechter dan de vorige periode', tr: 'Desktop', ts: 'Het aandeel gestarte chats dat leidt tot een verzonden sollicitatie, per apparaat.', tt: 'Apparaat', tu: '{0} heeft de laagste conversie ({1}) — grootste kans om te verbeteren.', tv: 'Conversie per apparaat', tw: 'Maak deze vraag makkelijker — bijvoorbeeld optioneel of korter. Dat levert naar schatting {0} extra sollicitaties op.', tx: 'De meeste afhakers zitten bij ‘{0}’ — {1}% haakt hier af.', ty: '{0} chats gestart, waarvan {1} verzonden ({2}%)', tz: 'Alleen verzonden sollicitaties tellen mee; wie afhaakte, telt niet mee.', tA: 'Hoe lang kandidaten doen over een volledige sollicitatie.', tB: 'Doorlooptijd tot verzenden', tC: 'Afhakers', tD: 'Doorstroom', tE: 'Weergave', tF: 'Tijd', tG: 'Chatfunnel', tH: 'Keer geholpen', tI: 'vorige periode: {0}', tJ: 'Te weinig data voor een betrouwbare conclusie', tK: 'Helft klaar binnen', tL: 'Mobiel', tM: 'Nog geen chats in deze periode. Staat de chat live en is de periode lang genoeg?', tN: '—', tO: '9 van de 10 binnen', tP: 'Nog te weinig gesprekken (min. {0}) voor betrouwbare cijfers hieronder.', tQ: 'Nog te weinig chats voor een betrouwbare trend', tR: 'Aantal chats deze periode: {0} — kies een langere periode voor betrouwbare conclusies.', tS: 'Naar schatting {0} sollicitaties extra als deze vraag net zo goed presteert als je gemiddelde vraag', tT: 'Opnieuw proberen', tU: 'Sollicitatieformulier', tV: 'Verzonden', tW: 'Vragen die kandidaten de meeste tijd kosten', tX: '{0} direct afgehaakt', tY: 'Definitief afgehaakt na deze vraag, per apparaat: {0}', tZ: 'Bereikt: {0} · Doorgestroomd: {1} · Afgehaakt: {2}', t_: 'Gem. tijd bij deze vraag: {0}', t$: '(geen antwoord)', t0: '{0}% ging door', t1: '{0} afgehaakt', t2: 'gem. {0}', t3: 'Tijd is het gemiddelde per vraag; alleen kandidaten die de vraag beantwoordden tellen mee.', t4: 'Gestart → verzonden', t5: 'Tablet', t6: 'conversie daalt', t7: 'stabiel', t8: 'conversie stijgt', t9: 'Onbekend', ua: '{0}% haakt hier af', ub: 'Geen duidelijk uitvalpunt', uc: 'Ja, klopt', ud: 'AI-suggestie', ue: 'Nee', uf: 'Sla over', uh: 'Conversieratio', ui: 'Conversational Apply gebruiken', uk: 'Vraag beantwoord', ul: 'Gestart', um: 'Verzonden', un: 'Verzonden per template', uo: 'Conversational Apply', up: 'Terug', uq: 'Je hebt eerder op deze vacature gesolliciteerd. We hebben je sollicitatie ontvangen — je hoeft niets meer te doen.', ur: 'Toch opnieuw solliciteren', us: 'Je hebt al gesolliciteerd', ut: 'Je bent {0} begonnen met solliciteren op deze vacature. We bewaren je gegevens tot {1}.', uu: 'Ga verder met je sollicitatie', uv: 'Opnieuw beginnen', uw: 'Je bent vandaag begonnen met solliciteren op deze vacature. We bewaren je gegevens tot {0}.', ux: 'Je bent gisteren begonnen met solliciteren op deze vacature. We bewaren je gegevens tot {0}.', uy: 'Hmm, ik kreeg “{0}” binnen — bedoelde je “{1}”? Tik **ja** om dat over te nemen, of typ je antwoord opnieuw.', uz: 'Terug naar de vacature', uA: 'Terug naar de vacature', uB: 'Bevestiging tekst', uC: 'We hebben je sollicitatie goed ontvangen.\n    We nemen zo snel mogelijk contact met je op over het vervolg.', uD: 'Bijv. We nemen zo snel mogelijk contact met je op.', uE: 'Zojuist verstuurd', uF: 'Bekijk meer vacatures', uG: 'Bevestiging subtitel', uH: 'Bedankt voor je sollicitatie', uI: 'Bijv. Bedankt voor je sollicitatie', uJ: 'Bevestiging titel', uK: 'Sollicitatie verstuurd', uL: 'Bijv. Sollicitatie verstuurd', uM: 'Bevestiging tussenkop', uN: 'Wat gebeurt er nu?', uO: 'Bijv. Wat gebeurt er nu?', uP: 'Aangepast — {field} is nu “{value}”. Terug naar je vorige antwoord.', uQ: 'Het lijkt erop dat je je e-mailadres hebt getypt. Dat willen we inderdaad ook weten — daar vraag ik later in het gesprek naar.', uR: 'Het lijkt erop dat je je e-mailadres hebt getypt. Dat heb ik meteen genoteerd ({0}) — daar vraag ik straks niet meer naar.', uS: 'Het lijkt erop dat je je LinkedIn-profiel hebt getypt. Dat willen we inderdaad ook weten — daar vraag ik later in het gesprek naar.', uT: 'Het lijkt erop dat je je LinkedIn-profiel hebt getypt. Dat heb ik meteen genoteerd ({0}) — daar vraag ik straks niet meer naar.', uU: 'Het lijkt erop dat je je telefoonnummer hebt getypt. Dat willen we inderdaad ook weten — daar vraag ik later in het gesprek naar.', uV: 'Het lijkt erop dat je je telefoonnummer hebt getypt. Die heb ik meteen genoteerd ({0}) — daar vraag ik straks niet meer naar.', uW: 'Sleep je bestand hierheen', uX: 'OF', uY: 'Dit bestand is te groot. Maximaal {0} MB.', uZ: 'Sorry, dit bestandstype kan ik niet verwerken. Probeer een ander bestand.', u_: 'Dit antwoord aanpassen', u$: 'aanpassen', u0: 'Klopt dat?', u1: 'Wat is de datum?', u2: 'Wat is je antwoord?', u3: 'Wat kies je?', u4: 'Welke optie past het beste?', u5: 'Welke opties passen bij jou?', u6: 'Wat is je motivatie voor deze rol?', u7: 'Wat is de URL?', u8: 'Ja of nee?', u9: 'Dit is een verplichte vraag om te beantwoorden', va: 'Naam van formulier', vb: 'Solliciteren', vc: 'Is er nog een document dat je wilt delen? Upload het hier.', vd: 'Wat is je adres, bv. \'Hoofdstraat 12, 3052AB Rotterdam\'? Zo kunnen we de reisafstand inschatten.', ve: 'Ik bedoelde je adres, bv. \'Hoofdstraat 12, 3052AB Rotterdam\'. Kun je dat typen?', vf: 'Tik de dagdelen aan die je schikken, of typ bv. \'maandagochtend, vrijdagavond\'. Zo kunnen we dagdelen voorstellen die bij je passen.', vg: 'In welke plaats woon je?', vh: 'Kun je een korte motivatie toevoegen? Zo begrijpen we je sollicitatie beter.', vi: 'Upload een korte motivatie via de knop hieronder. Zo begrijpen we je sollicitatie beter.', vj: 'In welke provincie woon je?', vk: 'Wat omschrijft je etnische achtergrond het best?', vl: 'Identificeer je je als Hispanic of Latino?', vm: 'In welke staat woon je?', vn: 'Ik bedoelde een datum, bv. 12-04-1990 of \'12 april 1990\'. Kun je die typen?', vo: 'Wat is je geboortedatum, bv. 12-04-1990?', vp: 'Geen probleem — typ je antwoord gewoon in het tekstvak hieronder.', vq: 'Wat is je e-mailadres?', vr: 'Sorry — ik bedoelde je e-mailadres, bv. naam@voorbeeld.nl. Kun je het hier typen?', vs: 'Wat is je voornaam?', vt: 'Kun je je cijferlijst van je bachelor uploaden?', vu: 'Heb je nog een tweede cijferlijst van je bachelor? Upload die hier.', vv: 'Kun je je cijferlijst van je master uploaden?', vw: 'Heb je nog een tweede cijferlijst van je master? Upload die hier.', vx: 'Kun je je stagebeoordeling uploaden?', vy: 'Heb je nog een tweede stagebeoordeling? Upload die hier.', vz: 'Wat is je achternaam?', vA: 'Wat is de link naar je LinkedIn-profiel?', vB: 'Vertel in een paar zinnen wat je aanspreekt in deze functie. Zo begrijpen we waarom die bij je past.', vC: 'Op de hoogte blijven? Vink het vakje aan om je in te schrijven voor onze nieuwsbrief.', vD: 'Wat is je telefoonnummer?', vE: 'Ik bedoelde je telefoonnummer, bv. 0612345678. Kun je dat typen?', vF: 'Kun je je portfolio delen? Upload het hier.', vG: 'Wat is je postcode?', vH: 'Ga je akkoord met onze privacyverklaring?', vI: 'Ben je doorverwezen door een huidige medewerker?', vJ: 'Kun je je CV uploaden? Zo kan de recruiter je ervaring snel bekijken voordat we contact opnemen.', vK: 'Upload je CV via de knop hieronder. Zo kan de recruiter je ervaring snel bekijken.', vL: 'Geef een ruwe indicatie als bedrag of bandbreedte, bv. 3000 of 2800-3400. Zo matchen we je met de juiste rol.', vM: 'Wat is je aanhef? Bv. dhr., mevr. of mx.', vN: 'Kun je je scriptie uploaden?', vO: 'Is er een link die je wilt delen, bv. een eigen website? Plak die hier.', vP: 'Ik bedoelde een link, bv. https://www.voorbeeld.nl. Kun je die typen?', vQ: 'Wat is je Xing-link?', vR: 'Welkomsttekst', vS: 'Per-domein-tekst (optioneel)', vT: 'Hoi! Laten we beginnen — ik stel je een paar korte vragen.', vU: 'Mijn sollicitatie chats', vV: 'Volgende', vW: 'Sluiten', vX: 'Start sollicitatie', vY: 'Sollicitatie', vZ: 'druk op Enter ↵', v_: 'Akkoord', v$: 'Privacyverklaring?', v0: 'Ga je akkoord met onze', v1: 'Niet akkoord', v2: 'Geen probleem dat je twijfelt — maar zonder akkoord met de privacyverklaring kunnen we je sollicitatie niet verwerken. Klik **Akkoord** als je verder wilt.', v3: 'Je antwoorden worden direct opgeslagen, ook als je het formulier niet afmaakt. Je kunt je gegevens altijd laten verwijderen; stuur daarvoor een e-mail naar onze functionaris voor gegevensbescherming.', v4: 'Ga je akkoord met onze privacyverklaring?', v5: 'Zonder antwoord op deze vraag kan ik de sollicitatie helaas niet versturen', v6: 'Opnieuw beginnen', v7: 'hervat', v8: 'Maak je sollicitatie volledig', v9: 'Kun je je adres typen, bijvoorbeeld Hoofdstraat 12, 3052AB Rotterdam?', wa: 'Hmm, het adres klopt nog niet helemaal — kun je het nog eens proberen?', wb: 'Ik mis nog: {0}. Kun je dat aanvullen?', wc: 'Bijna! Kun je {0} nog aanvullen?', wd: 'Kun je de datum als DD-MM-JJJJ typen, bv. \'12 april 1990\'?', we: 'Tik op de dagdelen die passen, of typ bv. \'maandag ochtend, vrijdag avond\'.', wf: 'Sorry, dat begreep ik niet — kun je het nog eens anders proberen?', wg: 'Hmm, dat e-mailadres lijkt niet goed — kun je het nog eens controleren?', wh: 'Ik mis nog een @-teken — kun je je e-mailadres compleet typen?', wi: 'Ik mis nog een extensie zoals .com of .nl — kun je het e-mailadres aanvullen?', wj: 'Upload een bestand, of sla deze vraag over.', wk: 'Hmm, het nummer klopt nog niet — kun je het nog eens proberen?', wl: 'Er lijkt nog 1 cijfer te missen — kun je je telefoonnummer nog eens proberen?', wm: 'Er lijken nog {0} cijfers te missen — kun je je telefoonnummer nog eens proberen?', wn: 'Hmm, dat lijken een paar cijfers te veel — kun je het zonder spaties proberen?', wo: 'Probeer een bedrag tussen {0} en {1} — bv. {2} of {3}-{4}.', wp: 'Beantwoord de vraag via de knoppen hieronder.', wq: 'Klik aan wat past, of typ de namen gescheiden door komma\'s (bv. \'haskell, elm\').', wr: 'Hmm, die URL lijkt niet helemaal te kloppen — kun je het nog eens proberen?', ws: 'Kun je https:// voor de URL zetten?', wt: 'Goed om te weten: ik bewaar je antwoorden tot {0}, zodat je later verder kunt. Maak je je sollicitatie niet af, dan sturen we je eenmalig een herinnering per e-mail.', wu: '(overgeslagen)', wv: 'Overslaan', ww: 'Stap {0} van {1}', wx: 'Sollicitatie versturen', wy: 'Er ging iets mis. Probeer het opnieuw.', wz: 'We hebben nu alle benodigde gegevens om je sollicitatie in behandeling te nemen. Je hoort zo snel mogelijk van ons.', wA: 'Sollicitatie verstuurd!', wB: 'Bestand uploaden', wC: 'Welkom terug! Je antwoorden zijn bewaard — we gaan verder waar je was gebleven.', wD: '{0} korte vragen · ± {1} minuten', wE: 'Welkomsttitel', wF: 'Wij helpen je snel door je sollicitatie met een paar korte vragen in een gesprek. Geen lange formulieren.', wG: 'Welkomsttitel voor dit domein (optioneel)', wH: 'Bijv. Leuk dat je wilt solliciteren!', wI: 'Cookeilanden', wJ: 'cookieverklaring', wK: 'privacyverklaring', wL: 'Lees meer in onze', wM: 'Lees meer in de privacyverklaring', wN: 'De CookieBot-domeingroep-ID', wO: 'Alleen noodzakelijke cookies', wP: 'Accepteren', wQ: 'Weigeren', wR: 'Accepteer geselecteerde cookies', wS: 'Deze website maakt gebruik van cookies', wT: 'Cookie modal aanbieder', wU: 'Het consent management platform dat cookie-toestemming afhandelt.', wW: 'Wij, en derde partijen, maken op onze website gebruik van cookies. Wij gebruiken cookies om ervoor te zorgen dat onze website goed functioneert, om jouw voorkeuren op te slaan, om inzicht te verkrijgen in bezoekersgedrag, maar ook voor marketing en social media doeleinden (laten zien van gepersonaliseerde advertenties). Door op ‘Accepteren’ te klikken, ga je akkoord met het gebruik van alle cookies. In onze Cookieverklaring kun je meer lezen over de cookies die wij gebruiken en kun je jouw voorkeuren opslaan of wijzigen.  Door ‘Weigeren’ te klikken ga je alleen akkoord met het gebruik van functionele cookies.', wX: 'Cookies', wY: 'Kopieer', wZ: 'Kopieer de inhoud van een bestaande pagina', w_: 'Kopieer de inhoud van een bestaande vacature (optioneel)', w$: 'Kopieer de previewlink om te delen of zelf te bekijken', w0: 'Corporate site', w3: 'Costa Rica', w4: 'Sorry, dat antwoord begreep ik niet helemaal. Kun je het anders verwoorden?', w5: 'Land', w7: 'Voer land  in', w8: 'Toevoegen', w9: 'Nieuw evenement', xa: 'Nieuw formulier', xb: 'Nieuwe groep', xc: 'Groep succesvol aangemaakt', xd: 'Nieuw medialabel', xe: 'Maak nieuwe aan...', xf: 'Maak nieuwe vacature aan', xg: 'Voeg nieuws toe', xh: 'Maak nieuwsitem', xi: 'Voeg upload label toe', xj: 'Maak een social media-item', xk: 'Voeg label toe', xl: 'Voeg label toe', xm: 'Voeg template toe', xn: 'Nieuwe gebruiker', xo: 'Upload CSV bestand', xp: 'Gebruikers succesvol geimporteerd.', xq: 'Pas op je overschrijft de groepen van users die al bestaan', xr: 'Gebruiker successvol aangemaakt', xs: 'Genereer tekst  met AI', xt: 'Aangemaakt op', xu: 'Aanmaakdatum', xv: 'Inloggegevens verzonden naar {0}', xw: 'Kroatië', xB: 'Details', xC: 'CSS', xE: 'CSS bestand', xG: 'CTA-kaart', xI: 'Weergavetekst in button', xL: 'Cuba', xM: 'Curaçao', xN: '€', xT: 'Huidige periode', xU: 'Grafiek van gebruikers en sollicitaties over de huidige periode', xW: 'Huidige superusers', xX: 'Huidige tekst', xY: 'Huidige tekst', xZ: 'Huidige titel', x_: 'Huidige tablad', x0: 'Custom categorie', x2: 'Aangepast evenement', x3: 'Evenementnaam', x5: 'Aantal aangepaste filters overschreden. Neem contact op met de customer support.', x6: 'Custom', x7: 'Hoe heb je ons gevonden?', x8: 'Kies vakgebied(en)', x9: 'Aangepaste job alert e-mail', ya: 'Gebruikt een aangepast e-mailsjabloon voor job alert notificaties in plaats van het standaardsjabloon.', yc: 'Aangepaste salariscalculator', yd: 'Maakt het salariscalculator dropdown-component beschikbaar op vacaturepagina\'s in de pagina-editor.', ye: 'Zelf instelbare tussenruimte', yg: 'CV Deal feed', yh: 'Activeert een CV Deal-geformatteerd XML vacaturefeed-endpoint. Wanneer uitgeschakeld retourneert het endpoint een 404.', yi: 'Cyprus', yj: 'Tsjechische Republiek', yl: 'Zwarte tekst', ym: 'Dashboard', yn: 'Gegevens', yo: 'Data Studio URL', yp: 'Google Looker Studio rapport-URL voor analytics dashboard.', yq: 'Datum', yr: 'Datum en tijd', ys: 'Geboortedatum', yt: 'Geboortedatum buiten bereik', yu: 'Voer je geboortedaags in', yv: 'en/of filter op datum sollicitatie:', yw: 'van', yx: 'tot', yA: 'Vr', yB: 'Ma', yC: 'Za', yD: 'Zo', yE: 'Do', yF: 'Di', yG: 'Wo', yH: 'middag', yI: 'Dagdeel beschikbaarheid omschrijving', yJ: 'Beschikbaarheid (dagdeel)', yK: 'avond', yL: 'ochtend', yM: 'nacht', yO: 'Dagen om te verwerken', yP: 'Dagen om in te stellen', yQ: 'Gebruiker succesvol gearchiveerd', yR: 'Standaard', yS: 'Default communicatie', yU: 'Standaard toestemmingsniveau', yV: 'Standaard cookie-toestemmingsniveau voor gebruikersinteractie.', yW: 'Standaard', yZ: 'Er hoeft geen filter geselecteerd te worden. Dit template wordt standaard gebruikt wanneer geen andere templates aan de criteria voldoen.', atC: 'Verwijder', y$: 'Verwijder sollicitatie', y0: 'Verwijder categorie', y1: 'Weet je zeker dat je deze sollicitatie wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.', y2: 'Sollicitatie verwijderen', y3: 'Verwijder notitie', y4: 'Verwijder evenement', y5: 'Verwijder eventlabel', y6: 'Weet je zeker dat je de koppeling met {0} wilt verwijderen? Sollicitaties op vacatures van {0} worden daarna niet meer doorgestuurd, maar verzameld in de Applicant Tool.', y7: 'Verwijder file', y8: 'Verwijder medialabel', y9: 'Medialabel verwijderd', za: 'Verwijder nieuwsitem', zb: 'Verwijder nieuwslabel', zc: 'Verwijder organisatieonderdeel', zd: 'Verwijder pagina', ze: 'Verwijder upload labels', zf: 'Upload label succesvol verwijderd', zg: 'Status verwijderen', zh: 'Stap verwijderen', zi: 'Verwijder label', zj: 'Verwijder template', zk: 'Verwijder UBEEO Vacatures', zl: 'UBEEO vacatures verwijderd', zm: 'Weet je zeker dat je deze gearchiveerde gebruiker wilt verwijderen? De gebruiker zal met deze actie compleet verwijderd zijn en zal een \'verwijderde gebruiker\' worden.', zn: 'Gebruiker verwijderen', zo: 'Verwijder vacaturekenmerk', zp: 'Verwijder versie', zq: 'Verwijderd', zr: 'Bezorgd op', zs: 'Afgewezen', atD: 'Denemarken', zt: 'Afdeling', dn: 'Beschrijving', zu: 'Beschrijving 8', zv: 'Beschrijving 5', zw: 'Beschrijving 4', zx: 'Beschrijving 1', zy: 'Voeg beschrijving toe', zz: 'Beschrijving 7', zA: 'Beschrijving 6', zB: 'Beschrijving 3', zC: 'Beschrijving 2', zD: 'Knop', zE: 'Contactpersoon', zF: 'Merk', zG: 'Knoppen', zH: 'Header', zI: 'Koppen', zJ: 'Vlakken en randen', zK: 'Vorm', zL: 'Tekst', zM: 'Bold', zN: 'Vervagen', zO: 'Gevuld', zP: 'Medium', zQ: 'Geen', zR: 'Omlijnd', zS: 'Regular', zT: 'Rond', zU: 'Semi-bold', zV: 'Vierkant', zW: 'Designsysteem', zX: 'Maximaal {0}', zY: 'Alle knoppen', zZ: 'Vorm, ruimte, lettertype en dikte van elke knop. Een stijl kan een eigen lettertype krijgen.', z_: 'Minimaal {0}', z$: 'Solliciteer nu', z0: 'Standaard', z1: 'Standaardthema', z2: 'Afgeleid van {0}', z3: 'Volgt {0}', z4: 'Aangepast', z5: '{0} van {1} aangepast', z6: 'Kleur', z7: 'Houd vast om te vergelijken met gepubliceerd', z8: 'Deze versie van het CMS kan deze waarden niet tonen: {0}', z9: 'Contrast {0} : 1', Aa: 'Slecht leesbaar', Ab: 'Standaard: {0}', Ac: 'Afgeleid van ‘{0}’: {1}', Ad: 'Desktop', Ae: 'Concept', Af: 'Dit thema is intussen ergens anders opgeslagen of gepubliceerd. Laad het opnieuw om verder te gaan; je wijzigingen hier worden dan niet bewaard.', Ag: 'Concept opgeslagen', Ah: 'Uit: alle sites van dit project gebruiken hun huidige stylesheet, wat er per site ook is ingesteld. Aan: per site bepaalt de schakelaar onder Thema’s of die site het nieuwe designsysteem gebruikt. Aan- en uitzetten verandert verder niets, dus je kunt altijd terug.', Ai: '{0} niet gebruikt, verborgen', Aj: 'Volg ‘{0}’ weer', Ak: 'Volgt ‘{0}’: {1}', Al: 'Browser', Am: 'Bestanden kiezen', An: 'Dit bestand verdwijnt uit de bibliotheek. Een thema dat het lettertype gebruikt, valt voor deze dikte terug op een andere dikte van hetzelfde lettertype.', Ao: '{0} verwijderen?', Ap: 'Lettertype verwijderd', Aq: 'Terugval', Ar: 'Wat de bezoeker ziet zolang het lettertype laadt, of als het niet laadt', As: 'Naam', At: 'Zo heet het lettertype in de keuzelijsten. Bestanden met dezelfde naam horen bij één lettertype.', Au: 'Bestanden', Av: 'WOFF2 of WOFF, maximaal 2 MB per bestand. Kies meerdere bestanden om alle diktes in één keer te uploaden; dikte en stijl lezen we uit de bestandsnaam.', Aw: 'Cursief', Ax: 'Soort lettertype', Ay: 'Licentie', Az: 'Wie het lettertype heeft gekocht en voor welke sites het mag worden gebruikt', AA: 'Eigen lettertype uploaden', AB: 'Nog geen eigen lettertypen geüpload.', AC: 'Dit lettertype is niet geüpload', AD: '{0} is geen WOFF2- of WOFF-bestand', AE: 'Eigen', AF: 'Vervangt het bestand dat er al is', AG: 'Werk dat bij je past', AH: 'Stijl', AI: '{0} is groter dan 2 MB', AJ: 'Niet in gebruik', AK: 'Lettertype uploaden', AL: 'Lettertype geüpload', AM: 'Geüploade lettertypen', AN: 'Normaal', AO: 'Gebruikt door {0}', AP: 'Dikte', AQ: 'Thin (100)', AR: 'Extra light (200)', AS: 'Light (300)', AT: 'Regular (400)', AU: 'Medium (500)', AV: 'Semi-bold (600)', AW: 'Bold (700)', AX: 'Extra bold (800)', AY: 'Black (900)', AZ: 'Lettertypen', A_: 'Nog geen lettertypen. Upload een WOFF2- of WOFF-bestand per dikte en stijl; daarna kies je het lettertype bij de body, de introductie en elke kop.', A$: 'De lettertypen van het project. Elk thema kan ze kiezen; een site laadt alleen de lettertypen die zijn thema gebruikt.', A0: 'Ga naar {0}', A1: 'Kop {0}', A2: 'Deze waarde volgt of verwijst in een kring: {0}', A3: 'Introductie', A4: 'Ongeldige waarde', A5: 'Indeling', A6: 'Velden', A7: 'Voorbeeld', A8: 'Naast elkaar', A9: 'Lettertype', Ba: 'Regelhoogte', Bb: 'Live', Bc: 'Voorbeeld', Bd: 'Uiterlijk', Be: 'Mobiel', Bf: 'Onderdelen', Bg: 'Basis', Bh: 'Beheer', Bi: 'Overig', Bj: 'Typografie', Bk: 'Onderdelen van het thema', Bl: 'Nieuw designsysteem gebruiken', Bm: 'Uit: de site gebruikt de huidige stylesheet. Aan: de site rendert met het thema dat hier gekozen is.', Bn: 'Het nieuwe systeem is nog niet af: onderdelen die nog geen vormgeving hebben, tonen hier zonder opmaak.', Bo: 'Kies een van: {0}', Bp: 'Geen kleur: gebruik #rrggbb', Bq: 'Geen lettertype dat dit CMS kent', Br: 'Geen grootte in hele pixels', Bs: 'De server kon deze waarden niet lezen', Bt: 'Niet vastgezet ({0})', Bu: 'Niet vastgezet', Bv: 'slecht leesbaar', Bw: 'Niet opgeslagen: bekijk de meldingen bij de velden.', Bx: '‘{0}’ is een waarde van een ander soort', By: 'Niet gebruikt', Bz: 'Dit thema past nog niets aan', BA: 'Deze waarde heeft geen algemenere waarde om te volgen', BB: 'Alleen aangepast', BC: 'Dit onderdeel heeft maar één variant', BD: 'Voorbeeld bekijken', BE: 'Deze site laat zich hier niet tonen. Gebruik ‘Voorbeeld bekijken’ om hem in een nieuw tabblad te openen.', BF: 'De site ernaast kon niet worden bijgewerkt', BG: 'Homepage', BH: 'Toon {0} hier', BI: 'Pagina', BJ: '{0} — {1}', BK: '{0} te controleren', BL: 'Publiceren', BM: 'Gepubliceerd', BN: 'goed leesbaar', BO: 'Leesbaar op ‘{0}’: {1}', BP: 'Gelijk aan ‘{0}’: {1}', BQ: 'Opnieuw laden', BR: 'Thema opnieuw laden', BS: 'Alles terugzetten', BT: 'Terug naar standaard', BU: 'Terugzetten', BV: 'Teruggezet en gepubliceerd', BW: 'Zo ziet tekst eruit op deze kleur.', BX: 'Concept opslaan', BY: 'Sla een concept op om de site ernaast te zien', BZ: 'Bezig met opslaan…', B_: 'Zoek een instelling', B$: 'Geen instelling gevonden voor ‘{0}’', B0: 'Alles tonen', B1: 'Site ernaast', B2: 'Grootte', B3: 'versie {0} · klaar om te publiceren', B4: 'Nog niet gepubliceerd', B5: 'Lopende tekst', B6: 'Tekstkleur', B7: 'Te weinig contrast met ‘{0}’: {1} : 1, minimaal {2} : 1.', B8: 'Dit onderdeel bestaat niet meer', B9: 'Deze waarde bestaat niet meer: {0}', Ca: 'Deze optie bestaat niet meer', Cb: 'Deze variant bestaat niet meer', Cc: 'Onbekende melding van de server: {0}', Cd: 'Niet-opgeslagen wijzigingen', Ce: 'Verbergen', Cf: 'Tonen', Cg: '{0} niet gebruikt, zichtbaar', Ch: 'Gebruik {0}', Ci: 'Variant', Cj: 'Opties van ‘{0}’', Ck: 'versie {0}', Cl: 'Vervangen', Cm: 'Versies', Cn: 'Zonder deze waarde: {0}', Co: 'Tekstkleur', Cp: 'Lettertype', Cq: 'Tekstgrootte', Cr: 'Tekstgrootte op mobiel', Cs: 'Tekst: dikte', Ct: 'Regelhoogte', Cu: 'Regelhoogte op mobiel', Cv: 'Randkleur', Cw: 'Randdikte', Cx: 'Afronding', Cy: 'Knop: randdikte', Cz: 'Ruimte links en rechts', CA: 'Ruimte boven en onder', CB: 'Stijl 1: kleur', CC: 'Stijl 1: lettertype', CD: 'Stijl 1: dikte', CE: 'Stijl 2: kleur', CF: 'Stijl 2: lettertype', CG: 'Stijl 2: dikte', CH: 'Stijl 3: kleur', CI: 'Stijl 3: lettertype', CJ: 'Stijl 3: dikte', CK: 'Stijl 4: kleur', CL: 'Stijl 4: lettertype', CM: 'Stijl 4: dikte', CN: 'Kleur 1', CO: 'Kleur 2', CP: 'Kleur 3', CQ: 'Kleur 4', CR: 'Kop 1: kleur', CS: 'Kop 1: lettertype', CT: 'Kop 1: dikte', CU: 'Kop 1: regelhoogte', CV: 'Kop 1: regelhoogte op mobiel', CW: 'Kop 1: grootte', CX: 'Kop 1: grootte op mobiel', CY: 'Kop 2: kleur', CZ: 'Kop 2: lettertype', C_: 'Kop 2: dikte', C$: 'Kop 2: regelhoogte', C0: 'Kop 2: regelhoogte op mobiel', C1: 'Kop 2: grootte', C2: 'Kop 2: grootte op mobiel', C3: 'Kop 3: kleur', C4: 'Kop 3: lettertype', C5: 'Kop 3: dikte', C6: 'Kop 3: regelhoogte', C7: 'Kop 3: regelhoogte op mobiel', C8: 'Kop 3: grootte', C9: 'Kop 3: grootte op mobiel', Da: 'Kop 4: kleur', Db: 'Kop 4: lettertype', Dc: 'Kop 4: dikte', Dd: 'Kop 4: regelhoogte', De: 'Kop 4: regelhoogte op mobiel', Df: 'Kop 4: grootte', Dg: 'Kop 4: grootte op mobiel', Dh: 'Hoogte van de header', Di: 'Hoogte na scrollen', Dj: 'Introductie: kleur', Dk: 'Introductie: lettertype', Dl: 'Introductie: tekstgrootte', Dm: 'Introductie: tekstgrootte op mobiel', Dn: 'Introductie: dikte', Do: 'Introductie: regelhoogte', Dp: 'Introductie: regelhoogte op mobiel', Dq: 'Afronding', Dr: 'Achtergrond', Ds: 'Stijl 1: tekstkleur', Dt: 'Stijl 2: tekstkleur', Du: 'Stijl 3: tekstkleur', Dv: 'Stijl 4: tekstkleur', Dw: 'Tekst op kleur 1', Dx: 'Tekst op kleur 2', Dy: 'Tekst op kleur 3', Dz: 'Tekst op kleur 4', DA: 'Standaard', DB: 'Avatarkaart', DC: 'Compact', DD: 'Normaal', DE: 'Effect bij hover', DF: 'Stijl 1: effect bij hover', DG: 'Stijl 2: effect bij hover', DH: 'Stijl 3: effect bij hover', DI: 'Stijl 4: effect bij hover', DJ: 'Stijl 1', DK: 'Stijl 2', DL: 'Stijl 3', DM: 'Stijl 4', DN: 'Vorm van de foto', DO: 'Grootte van de foto', DP: 'Desktop', DQ: 'Totale aantal desktop gebruikers die op de link hebben geklikt in de email.', DR: 'Totale aantal desktop gebruikers die de email hebben geopend.', DS: 'Vacature', DU: 'Detail-URL', DV: 'Details', DW: 'Apparaat', DY: 'Apparaten', DZ: 'Apparaten / Sollicitaties', D_: 'Sollicitaties onderverdeeld per apparaat', D$: 'Waar wil je werken?', D0: 'Didomi API Key', D1: 'Didomi API key (UUID format). Required when Cookie Modal Provider is set to Didomi. Links to your Didomi consent configuration.', D2: 'Afmetingen', D5: 'Het is niet mogelijk om deze actie uit te voeren omdat de sollicitant geen emailadres heeft.', D6: 'Vakgebied', D7: 'Welk vakgebied behoort tot deze pagina?', D8: 'Vakgebied(en)', D9: 'Disclaimer', Ed: 'Afstand in kilometer', Eg: 'Djibouti', Ek: 'Domein', El: 'Dit domein heeft al een eigen schema.', Em: 'Dit domein volgt het schema voor alle domeinen.', Ep: 'Domein schakeltype', Eq: 'Hoe de domein/taalschakelaar wordt weergegeven.', Er: 'Actief domein', Es: 'Geen domein gevonden voor {0}.', Et: 'Zoek domein, url of taal', Eu: 'Wissel van domein', Ev: 'Dominica', Ew: 'Dominicaanse Republiek', Ex: 'Download sollicitaties', Ey: 'Download voorbeeld CSV', Ez: 'Download jobalert aanmeldingen', EA: 'Concept', EB: 'Drag & Drop', ED: 'Dupliceren', EE: 'Dupliceer vacature', EG: 'Looptijd', EI: 'Nederlands', EJ: 'Dynamische ATS-formulieren', EK: 'Schakelt dynamische sollicitatieformulieren in met velden afkomstig uit het ATS tijdens import (bijv. Jobylon screeningvelden). Formulierschema kan per vacature worden overschreven.', EL: 'Dynamische titel', EM: 'Ecuador', EN: 'Edge', EO: 'Totale aantal Edge gebruikers.', EP: 'Wijzig', EQ: 'Wijzig vacaturekenmerk', ER: 'Edit pagina', ES: 'Wijzig CTA-kaart', ET: 'Bewerk met AI', EU: 'Pas de items in de lijst aan', EV: 'Nieuwsbericht aanpassen', EW: 'Nieuwsbericht aanpassen', EX: 'Bewerk nieuwslabels', EY: 'Wijzig versienaam', E_: 'Editor', E$: 'Opleiding', E0: 'Opleidingsniveau', E1: 'Welk opleidingsniveau behoort tot deze pagina?', E2: 'Egypte', E3: 'El Salvador', eR: 'E-mail', E7: 'E-mailadres', E8: 'hallo@example.com', E9: 'BCC', Fa: 'Inhoud', Fc: 'Email clients', Fd: 'Alleen e-mailadressen eindigend op {0} mogen worden toegevoegd', Fe: 'E-mailadres al in gebruik', Ff: 'E-mailadres al in gebruik bij andere afkomst', Fg: 'Graag een geldig e-mailadres invullen.', Fh: 'Afzender', Fi: 'Heb je problemen met bovenstaande knop? Kopieer dan de volgende URL en plak deze in je web browser.', Fj: 'E-mail (voor inlog)', Fk: 'E-maillogo (PNG)', Fm: 'De e-mailadressen komen niet overeen', Fn: 'Heb je hulp nodig? Bekijk onze documentatie:', Fo: 'Inloggen', Fp: 'Met hartelijke groet,', Fq: '<p>Je wilt toegang tot jouw account in Hamilton CMS. Door de volgende stappen te volgen, log je eenvoudig in:</p>\n\n    <ul>\n      <li>Klik op de onderstaande knop <strong>‘Inloggen’</strong></li>\n      <li>Je wordt automatisch doorgestuurd naar een unieke link waar je een code kunt invoeren</li>\n      <li>Voer de code in die je per SMS hebt ontvangen op je mobiele nummer</li>\n      <li>Na invoer word je automatisch doorgestuurd naar je account in Hamilton CMS</li>\n    </ul>\n\n    <p>Veel succes en plezier met het gebruik van Hamilton CMS!</p>', Fr: 'Geen SMS ontvangen? Het kan zijn dat er een ander mobiel nummer bij ons geregistreerd staat. Neem contact op met de beheerders van Hamilton CMS binnen jouw organisatie — zij helpen je graag verder met je inlog.', Fs: 'Inloggen bij Hamilton CMS', Ft: 'E-mail wachtwoord', Fu: 'E-mail (publiek)', Fw: 'Onderwerp', Fz: 'Ontvanger', FB: 'Inloggen', FC: 'Hartelijke groet', FD: 'Je bent uitgenodigd om Hamilton CMS te gebruiken. Klik op de onderstaande knop om direct te beginnen.', FE: 'Je bent uitgenodigd', FF: 'emails zijn gebounced.', FH: 'Embedded chat', atI: 'Emea', FI: 'Werknemer', FJ: 'Werknemers content', FK: 'Upload verwijderd', FL: 'Gedeelde content (Share tool)', FN: 'Content info', FR: 'Naam van de medewerker', FS: 'Werknemer-ID', FT: 'Medewerkersscores', FU: 'Medewerkersscores', FV: 'Soort dienstverband', FW: 'Emply export', FX: 'Routeert sollicitaties via het interne Tafkar-formulier in plaats van door te sturen naar externe Emply-URL\'s. Schakelt ook het aanmaken/verwijderen van formulieren in het CMS uit.', FY: 'Leeg', FZ: 'Leeg', F$: 'Achtergrondkleur', F0: 'Voeg ruimte toe onder deze kaart', F1: 'Toon filter in vacatureoverzicht', F2: 'ingeschakeld', F4: 'Sluit op', F5: 'Engels', F6: 'Schrijf hier een instructie voor AI', F7: 'Enter details...', F8: 'Equatoriaal-Guinea', F9: 'Eritrea', cn: 'Error', Ga: 'Deze pagina bestaat niet.', Gb: 'Interne server error.', Gc: 'Kan de wijzigingsgeschiedenis niet laden.', Gd: 'Voor hulp: neem contact op met de Hamilton CMS-beheerder binnen jouw organisatie', Ge: 'Selecteer een geldige optie voor elke stap', Gf: 'Selecteer een geldige embedded chat', Gg: 'Selecteer een geldig open sollicitatieformulier', Gh: 'Selecteer een geldige salariscalculator', Gi: 'Je bent niet geautoriseerd om deze sollicitatie te bekijken.', Gj: 'Je hebt te veel opties geselecteerd voor dit veld. Verwijder een aantal van je selecties.', Gl: 'Foutieve invoer melding', Gm: 'Veld verplicht melding', Gn: 'Estland', Go: 'Eswatini', Gp: 'Ethiopië', Gq: 'Europa', Gr: 'Avond', Gs: 'Evenement', Gu: 'Details evenement', Gx: 'Overzicht evenementen', Gy: 'Event aanmeld formulier', Gz: 'Evenement', GA: 'Evenement opgeslagen', GB: 'Eventlabel toegevoegd', GC: 'Eventlabel aangepast', GD: 'Eventlabels', GF: 'Evenementen', GG: 'Alles', GH: 'Voorbeeld template titel', GI: 'Selecteer de vacatures die niet zichtbaar mogen zijn in het vacatureoverzicht, op basis van specifieke vacaturekenmerken.', GK: 'Sluit vacatures uit op basis van kenmerk(en):', GM: 'Zijbalk uitklappen', GS: 'ATS', GT: 'Extern id', GU: 'Externe titel', GV: 'Extra sollicitaties', GW: 'Schakelt het Extra Sollicitaties component in op de bedankpagina. Na het solliciteren zien kandidaten passende vacatures waarop ze ook kunnen solliciteren. Bewaart formuliergegevens tussen inzendingen.', G_: 'Vacaturekenmerken', G$: 'Selecteer afbeeldingen in vacaturebanner', G0: 'Content', G2: 'Extra gegevens', G3: 'Extra groot favicon', G4: 'Voegt een 48x48 favicon-link toe aan de paginahead voor rijkere browser-tab en bladwijzericonen.', G5: 'Grote tussenruimte van 80px', G8: 'Tooling voor medewerkers', Ha: 'Factor om het berekende salaris mee te vermenigvuldigen als de ingevulde uren lager zijn dan 12', Hb: 'Kan wijzigingslog niet laden', Hc: 'Notitie toevoegen mislukt', Hd: 'Verwijderen notitie mislukt', He: 'Falklandeilanden', Hf: 'Faeröer', Hg: 'Favicon', Hh: 'Voeg vacature toe aan favorieten', Hj: 'Mijn favoriete vacatures bekijken', Hk: 'Mijn favoriete vacatures', Hm: 'Feature Flags', Hn: 'Functie-integraties', Hp: 'Feedback', Hq: 'Veld', Hr: 'Veld-ID\'s moeten uniek zijn', Hs: 'Veld ontbreekt uit webformulier', Hu: 'Dit veld wordt niet ondersteund door het gekozen ATS en moet worden verwijderd', Hv: 'Veldopties', Hw: 'Dit is een verplicht veld', Hx: 'Dit veld is vereist door het systeem', HA: '15 minuten', HB: 'Fiji', HH: 'Titel', HJ: 'Graag een bestand toevoegen.', HK: 'Bestandsgrootte', HM: 'Dit bestand is groter dan het maximale formaat.', HN: 'Selecteer een niet leeg bestand.', HP: 'Fout bij het wegschrijven van bestand', HQ: 'Vul het aantal secondes in', HS: 'Filter', HT: 'Filter op ATS:', HU: 'Filter op type kenmerk', HV: 'Filter op evenement', HW: 'Filter op groep:', HX: 'Filter op label:', HY: 'Filter content', HZ: 'Filter content per device', H3: 'Filter op:', H4: 'Filteroptie verwijderd', H8: 'Filteroptie zoeken', H9: 'Schakelt het Filteroptie Zoeken component in. Een zelfstandig zoekveld op het vacatureoverzicht waar bezoekers filteropties kunnen zoeken en als tags selecteren om vacatures te filteren.', Ib: 'Filter inschrijvingen', Ic: 'Filter medewerkersscores', Id: 'Filter zoekbalk', Ie: 'Filteropties', If: 'Filter resultaten', Ig: 'Afgeronde sollicitaties', atZ: 'Finland', Ih: 'Firefox', Ii: 'Totale aantal Firefox gebruikers.', Ij: 'Eerste kleur', Ik: 'Eerste weergave', Il: 'Eerste gesprek', Im: 'Stuur uitnodiging eerste gesprek', Io: 'Eerste betekenisvolle weergave', Ip: 'Voornaam', Iq: 'Voornaam', Ir: 'Vul je voornaam in', Is: '5 minuten', Iu: 'Conversational Apply', Iv: 'Toon elk sollicitatieformulier als een gesprek: één vraag tegelijk.', Iw: 'Alleen doorverwijzen', Ix: 'Toon op de banner van een interne vacature voor doorverwijzen alleen de knop om door te verwijzen, zonder de knop om direct te solliciteren. Geldt alleen voor sites waar die knop al verschijnt (intern en met een doorverwijsformulier).', IA: 'Kaarten (uitklap)', IB: 'Gebruik alleen letters, cijfers, spaties, - en _ (maximaal 64 tekens)', IC: 'Kies een WOFF2- of WOFF-bestand', ID: 'Dit lettertype kan niet worden verwijderd: {{names}} gebruikt het', IE: 'Positie in footer (nummer)', IF: 'Formulier', IH: 'Voeg velden toe', II: 'Veld toevoegen', IJ: 'Voeg toe', IK: 'Dit veld is altijd verplicht (vereist door de export).', IL: 'Dit ATS ondersteunt de volgende velden niet. Ze worden van het formulier verwijderd: {0}', IM: 'Velden verwijderen', IN: 'ATS wijzigen', IO: 'Overstappen naar {0}?', IP: '{0} vereist ook deze velden, die nog niet op dit formulier staan: {1}', IQ: 'Voor dit project is geen ATS gekoppeld dat open sollicitaties kan ontvangen', IR: 'Dit formulier hoort bij {0}, maar daarvoor is geen actieve koppeling ingesteld', IS: 'De formulierkeuze voor {0} verwees naar een formulier dat niet meer in aanmerking komt en is gewist', IT: 'Kies een ATS dat open sollicitaties kan ontvangen', IU: '+ Voeg voorwaarde toe', IV: 'Voeg een voorwaarde toe om te beginnen.', IW: 'Voeg eerst een ander veld toe voordat je voorwaarden kunt instellen.', IX: 'alle', IY: 'Altijd tonen', IZ: 'een van', I_: 'Tonen onder voorwaarden', I$: 'onderstaande voorwaarden waar zijn:', I0: 'Verwijder voorwaarde', I1: 'Toon dit veld als', I2: 'Waarde', I3: 'Keuzevelden', I4: 'Akkoord', I5: 'Bestanden', I6: 'Links', I7: 'Open vragen', I8: 'Overig', I9: 'Persoonsgegevens', Ja: 'Klassiek formulier — alle vragen op één pagina. Velden naast elkaar wordt ondersteund.', Jb: 'STANDAARD', Jc: 'voorwaardelijk', Jd: 'Label voor dit domein…', Je: 'Placeholder voor dit domein…', Jf: 'Vraag voor dit domein…', Jg: 'Verwijder veld', Jh: 'Andere tekst voor dit domein (optioneel)', Ji: 'Sleep om te verplaatsen', Jj: 'Veld bewerken', Jk: 'Veld leeg', Jl: 'Bijv. Vul je voornaam in.', Jm: 'Veld ongeldig', Jn: 'Bijv. Dit lijkt geen geldig telefoonnummer.', Jo: 'Voorbeeld:', Jp: 'velden', Jq: 'veld', Jr: 'Formuliervelden', Js: 'Formulier-instellingen', Jt: 'Verberg label visueel (label blijft beschikbaar voor schermlezers)', Ju: '@ Variabele invoegen', Jv: 'Klik op een veld om een verwijzing toe te voegen', Jw: 'Voeg een eerder antwoord in', Jx: 'Max leeftijd', Jy: 'Max lengte', Jz: 'Het maximum aantal keuzes wordt door de export bepaald en kan hier niet worden aangepast.', JA: 'Min leeftijd', JB: 'Min lengte', JC: 'Omlaag', JD: 'Omhoog', JE: 'Geen velden gevonden voor deze zoekopdracht.', JF: 'Geen velden geselecteerd', JG: 'Dit formulier heeft nog geen velden', JH: 'Klik op ‘Veld toevoegen’ om te beginnen.', JI: 'Een van twee verplicht', JJ: 'Sollicitanten moeten ten minste één van de twee gekozen velden invullen.', JK: 'Sollicitanten moeten ten minste één van de twee gekozen velden invullen. Let op: dit geldt alleen voor het gewone sollicitatieformulier. In Conversational Apply worden vragen één voor één gesteld, dus daar is de keuze niet zichtbaar en zijn beide velden verplicht.', JL: 'Open editor', JM: 'bevat', JN: 'is gelijk aan', JO: 'is leeg', JP: 'is ingevuld', JQ: 'is niet gelijk aan', JR: 'is een van', JS: 'De opties volgen uit:', JT: 'Akkoord', JU: 'Klassiek', JV: 'Bedankt! Je formulier is compleet.', JW: '[content blok]', JX: 'Conversational Apply', JY: 'Volgende', JZ: 'Geen zichtbare velden voor de huidige antwoorden.', J_: 'Vorige', J$: 'Reset', J0: 'Reset alle antwoorden', J1: '[screening vragen]', J2: 'Selecteer (preview)', J3: 'Voorbeeld', J4: 'Dit veld is altijd verplicht: {0} heeft het nodig.', J5: 'Dit veld is altijd verplicht volgens het ATS-schema voor dit bereik.', J6: 'Dit veld of veld {0} is verplicht vanwege \'een van twee\' instellingen.', J7: 'Zoek een veldtype…', J8: 'Foutmeldingen', J9: 'Veldlabel', Ka: 'Het label boven het invoerveld', Kb: 'Placeholder', Kc: 'Voorbeeldtekst in het lege veld', Kd: 'Vraag', Ke: 'Wat ziet de sollicitant?', Kf: 'Validatie', Kg: 'Selecteer een veld', Kh: 'Klik op een veld om de instellingen, vraag en validatie te bewerken.', Ki: 'geselecteerd', Kj: 'Dit veldtype heeft een aparte editor.', Kl: 'Formulier verwijderd', Km: 'Het versturen van het formulier is mislukt', Kp: 'Formulier voor vacatures uit {0}', Ks: 'Dit formulier is geen sollicitatieformulier', Kt: 'Dit formulier is geen open sollicitatieformulier', Ku: 'Formulier wordt gebruikt door een component. Verwijder deze eerst.', Kv: 'Vorm bestaat niet', Kw: 'Dit formulier hoort niet bij het bereik van dit domein.', Kx: 'Overzicht formulieren', Kz: 'Formulieren', KA: 'Formulieren van {0}', KB: 'Vierde kleur', at6: 'Frankrijk', KC: 'Frans-Guyana', KD: 'Frans-Polynesië', KE: 'Vrijdag', KF: 'Vr', KG: 'Van', KH: 'Start kleur', KJ: 'Volledige vacature in job alert', KK: 'Toont de volledige vacaturesamenvatting in job alert e-mails. Wanneer uitgeschakeld wordt de samenvatting ingekort tot 20 woorden.', KL: 'Parttime/Fulltime', KN: 'Functioneel', KO: 'Functionele cookies zorgen ervoor dat deze website informatie kan onthouden die van invloed is op het gedrag en de vormgeving van de website, zoals bijvoorbeeld welke vacatures jouw favorieten zijn.', KP: 'Functies', KQ: 'Conversational Apply', KR: 'We tellen alleen bezoekers die analytics-cookies hebben geaccepteerd. De twee varianten worden niet tegelijk getoond; vergelijk daarom alleen binnen een periode waarin zowel Conversational Apply als het traditionele formulier actief was.', KS: '+{0}% relatief meer afgeronde sollicitaties', KT: 'Voltooiingsratio van gestarte sollicitaties.', KU: 'Conversational Apply vs. traditioneel formulier', KV: 'Traditioneel formulier', KW: 'Sollicitatie verzonden', KX: 'Bron: Google Analytics — alleen Conversational Apply, en alleen bezoekers die analytics-cookies hebben geaccepteerd.', KY: 'Privacy akkoord', KZ: 'Vraag {0}', K_: '{0} · {1} afgehaakt', K$: 'Uitval per vraag', K1: 'GA4 API-sleutel', K2: 'Google Analytics 4 API-sleutel voor server-side meting.', K3: 'GA4 Stream ID', K4: 'Google Analytics 4 datastream-meet ID.', K6: 'Wanneer een sollicitatie naar deze status wordt verplaatst, wordt het geselecteerde evenement naar Google Analytics gestuurd', K9: 'Gabon', La: 'Gambia', Lc: 'Maak afbeelding met AI', Ld: 'Genereer met AI', Le: 'Aan het genereren...', Lf: 'Geokaart', Lg: 'Schakelt een interactieve geokaart in op het vacatureoverzicht. Gebruikers kunnen vacatures zoeken en filteren op locatie via de kaart.', Li: 'Georgië', at8: 'Duitsland', Lj: 'Ghana', Lk: 'Gibraltar', at9: 'Global', Lp: 'Gmail', Lq: 'Ga terug', Lr: 'Terug naar', Ls: 'Ga naar de bedrijfswebsite', Lt: 'Ga naar mijn persoonlijke pagina', Lu: 'Terug naar vorige pagina', Lv: 'Toon gearchiveerde gebruikers', Lw: 'Toon actieve gebruikers', Lx: 'Terug naar alle vacatures', Ly: 'Goede lengte', LA: 'Google Analytics Evenement', LB: 'Google Analytics (GA4)', LH: 'Grades bachelor 1', LI: 'Kies bestand', LJ: 'Grades bachelor 2', LK: 'Kies bestand', LL: 'Grades master 1', LM: 'Kies bestand', LN: 'Grades master 2', LO: 'Kies bestand', aud: 'Verenigd Koninkrijk', LP: 'Griekenland', LR: 'Greenhouse export', LS: 'Routeert sollicitaties via het interne Tafkar-formulier in plaats van door te sturen naar externe Greenhouse-formulieren. Haalt ook extra vacaturedetails op uit Greenhouse tijdens import.', LT: 'Groenland', LU: 'Grenada', LV: 'Groep', LW: 'Groep verwijderd', LX: 'Een groep kan niet verwijderd worden als er zich nog actieve of gearchiveerde gebruikers in bevinden. Zorg eerst dat geen gebruikers meer aan deze groep gekoppeld zijn voordat deze verwijderd kan worden.', LY: 'Groepen', LZ: 'Groep succesvol opgeslagen', L_: 'Groepen', L$: 'GTM Consent Mode V2', L0: 'Schakel Google Tag Manager Consent Mode V2 in voor AVG-conforme tracking.', L1: 'GTM ID', L2: 'Google Tag Manager container ID (formaat: GTM-XXXXXX).', L3: 'GTM server-side URL', L4: 'Server-side GTM endpoint voor first-party dataverzameling.', L5: 'Guadeloupe', L6: 'Guam', L7: 'Guatemala', L8: 'Guernsey', L9: 'Guinea', Ma: 'Guinee-Bissau', Mc: 'Guyana', Md: 'Haïti', Me: 'Hamilton ID', Mf: 'Hardbounces', Mg: 'Geeft een permanent error aan, maar kan ook veroorzaakt worden door een security email filter.', Mh: 'Afbeelding', Mi: 'Content', Ml: 'Positie in header (nummer)', Mm: 'Titel', Mn: 'Heading', Mq: 'hoog', Mt: 'Customer Success', Mu: 'Type verborgen gebruiker', Mv: 'Customer Success', Mw: 'Ontwikkelaar', Mx: 'Zichtbare superuser', My: 'Verbergen in gebruikersoverzicht', Mz: 'Verborgen gebruikers verschijnen niet in de gebruikerslijst. Gebruik dit voor interne accounts.', dC: 'Titel niet tonen', MA: 'Verberg titel', MB: 'Als dit veld aan staat wordt de titel van het formulierveld niet getoond', MF: 'Toon extra snelfilter (switch) voor:', MH: 'Afgerond', MI: 'Succesvol afgerond', MJ: 'Aangenomen', MK: 'Hireserve CMS formulier', ML: 'Schakelt het Hireserve sollicitatieformulier component in de pagina-editor in voor Hireserve ATS-integratie.', MM: 'Hiring manager', MN: 'Beoordeling van sollicitaties (Review)', MQ: 'De Homepage is verplicht in de sitemap.', MR: 'Honduras', MS: 'Hong Kong', MV: 'uur', MW: 'Urenrange', MX: 'uren', MY: 'Hoeveel uur wil je werken?', M_: 'Maximaal aantal uren', M$: 'Minimaal aantal uren', M4: 'Huisnummer', M5: 'Voer je huisnummer in', M6: 'Huisnummer', M7: 'huisnummer', M9: 'Hoe heb je ons gevonden?', Na: 'Vertel ons hoe je deze vacature hebt gevonden', Nb: 'Evenementformulier', Nc: 'HR Office formulieren', Nd: 'Ontgrendelt HR Office formuliercomponenten (open sollicitatie en evenementregistratie) in de pagina-editor. Deze worden als iframes naar het HR Office platform weergegeven.', Ne: 'Open sollicitatieformulier', Ng: 'Begin de URL met http:// of https://', e_: 'HTML', Nh: 'Aspect ratio', Ni: 'Gebruik een aspect van 16:9 voor de html, handig voor iframe\'s', Nj: 'Aspect Ratio is de verhouding tussen breedte en hoogte van de afbeelding.', Nk: 'Hoogte van de HTML op de site (px)', Nl: 'Zet de hoogte op 0 om automatisch de hoogte van de html te bepalen', Nm: 'Html source', Nn: 'Http error', auh: 'Hongarije', Np: 'Ik accepteer de', Nq: 'IAB-cookienaam', Nr: 'Naam van de IAB TCF-toestemmingscookie (standaard: euconsent-v2)', Ns: 'IJsland', bb: 'Icoon', Nt: 'Icoon kleur', dE: 'Id', Nu: 'Iframe', Nw: 'Afbeelding', Ny: 'Het genereren van de afbeelding is mislukt, probeer het opnieuw', Nz: 'Het genereren van deze afbeelding is niet toegestaan, pas de instructie aan en probeer opnieuw', NA: 'Afbeelding', NC: 'Afbeeldingen', ND: 'Import', NF: 'Imports & exports', NG: 'In proces', NH: 'In behandeling', NI: 'In review', NO: 'Indeed conversiecode', NP: 'Indeed conversietracking pixel voor sollicitatietracking.', NT: 'India', NU: 'Indonesië', NV: 'Industrieën', NW: 'Industrie', NY: 'Loop items oneindig', auk: 'Informatie', N3: 'UA apparaatdetectie fallback', N4: 'Valt terug op User-Agent string parsing voor apparaatdetectie wanneer Client Hints headers niet beschikbaar zijn.', N8: 'Onvoldoende saldo om uit te checken', Oe: 'Interne sollicitatie', Of: 'Ik werk hier', Og: 'Interne pagina\'s kunnen niet in de sitemap zijn.', Oh: 'Interne site', Oj: 'Evaluatie stage 1', Ok: 'Kies bestand', Ol: 'Evaluatie stage 2', Om: 'Kies bestand', On: 'Interviewer(s)', Op: 'Introductie', Oq: 'Introductietekst', Or: 'Ongeldige sollicitatie', Os: 'Ongeldig bestandsformaat', Ot: 'Ongeldige evenementnaam (max 40 tekens, alleen letters/cijfers/underscores, moet beginnen met een letter)', Ou: 'Ongeldige LinkedIn-URL', Ov: 'Ongeldig menu', Ow: 'Ongeldig telefoonnummer', Ox: 'Ongeldige screeningsvraag', Oy: 'URL moet starten met een /', Oz: 'URL moet starten met een /', OA: 'Geselecteerde optie is ongeldig', OB: 'Ongeldige template', OC: 'Ongeldige URL', OD: 'Ongeldige vacature', OE: 'Ongeldige Xing-URL', OF: 'Stuur uitnodiging assessment', OG: 'Beste {{sollicitantVoornaam}},<br><br>Graag nodigen wij je uit voor een assessment als volgende stap in onze selectieprocedure.<br><br>Details van het assessment:<br><br>Datum: {{uitnodigingTijdstip}}<br>Locatie: {{locatieAdres}}, {{locatiePostcode}} {{locatieStad}} / of online via…<br>Duur: 1,5 tot 2 uur<br><br>Tijdens het assessment krijg je de kans om je vaardigheden en competenties te laten zien die relevant zijn voor de functie. We zullen (kort uitleggen wat het assessment inhoudt, bijvoorbeeld: een cognitieve test, een praktijkopdracht of een rollenspel).<br><br>Indien je verhinderd bent of deze datum en tijdstip niet tot jouw mogelijkheden behoort in je agenda neem dan even contact met ons op via onderstaande gegevens.<br><br>We kijken uit naar je deelname en wensen je alvast veel succes!<br><br>Met vriendelijke groet,<br><br>{{sollicitatieToegewezenVoornaam}} {{sollicitatieToegewezenAchternaam}}<br>{{sollicitatieToegewezenTelefoonnummer}}<br>{{sollicitatieToegewezenEmail}}', OH: 'Uitnodiging assessment', OI: 'Uitnodiging voor assessment', OK: 'Beste {{sollicitantVoornaam}},<br><br>Graag nodigen wij je uit voor een kennismakingsgesprek op {{uitnodigingTijdstip}} bij ons op kantoor met adres:<br><br>{{locatieAdres}}<br>{{locatiePostcode}} {{locatieStad}}<br><br>Je zal het gesprek hebben met {{interviewerNaam}}.<br><br>Indien je verhinderd bent of deze datum en tijdstip niet tot jouw mogelijkheden behoort in je agenda neem dan even contact met ons op via onderstaande gegevens.<br><br>We kijken uit naar het gesprek!<br><br>Met vriendelijke groet,<br><br>{{sollicitatieToegewezenVoornaam}} {{sollicitatieToegewezenAchternaam}}<br>{{sollicitatieToegewezenTelefoonnummer}}<br>{{sollicitatieToegewezenEmail}}', OL: 'Uitnodiging 1e gesprek', OM: 'Uitnodiging kennismakingsgesprek', ON: 'Stuur door voor review', OO: 'Beste {{interviewerVoornaam}},<br><br>Hierbij stuur ik je deze sollicitaties(s) door ter beoordeling:<br><br>{{{reviewLinks}}}<br><br>Mijn opmerking:<br><br>{{{opmerking}}}<br><br>Met vriendelijke groet,<br><br>{{gebruikerVoornaam}} {{gebruikerAchternaam}}<br>{{gebruikerTelefoonnummer}}<br>{{gebruikerEmail}}', OP: 'Stuur door voor review', OQ: 'Review sollicitant(en)', OR: 'Beste {{sollicitantVoornaam}},<br><br>Graag nodigen wij je uit voor een vervolggesprek op {{uitnodigingTijdstip}} bij ons op kantoor met adres:<br><br>{{locatieAdres}}<br>{{locatiePostcode}} {{locatieStad}}<br><br>Je zal het gesprek hebben met {{interviewerNaam}}.<br><br>Indien je verhinderd bent of deze datum en tijdstip niet tot jouw mogelijkheden behoort in je agenda neem dan even contact met ons op via onderstaande gegevens.<br><br>We kijken uit naar het gesprek!<br><br>Met vriendelijke groet,<br><br>{{sollicitatieToegewezenVoornaam}} {{sollicitatieToegewezenAchternaam}}<br>{{sollicitatieToegewezenTelefoonnummer}}<br>{{sollicitatieToegewezenEmail}}', OS: 'Uitnodiging 2e gesprek', OT: 'Uitnodiging vervolggesprek', OU: 'Iran', OV: 'Irak', aup: 'Ierland', OX: 'Actief', O1: 'Uitklappen', O2: 'Laat deze pagina zien in het submenu van pagina', O3: 'Is dit een leuke baan voor jou?', O5: 'Isle of Man', O7: 'Israël', O9: 'Italië', Pg: 'Ivoorkust', Ph: 'Jamaica', Pi: 'Japan', Pj: 'Jersey', Pk: 'Job alert', Pl: 'Meld je aan voor job alerts', Pm: 'Overschrijf job alert button', Pn: 'Bevestig', Po: 'Indien je niets hebt aangevraagd dan kun je deze e-mail negeren.', Pp: 'Je hebt een job alert aangevraagd voor {{companyName}}. Gebruik de knop om dit te bevestigen.', Pq: 'Bevestig je job alert voor {{companyName}}', Pr: 'Job Alert Email', Ps: 'Job alert email bericht', Pt: 'Er zijn vacatures voor {{companyName}} die overeenkomen met jouw job alert.', Pu: 'Schrijf hier het bericht voor de email. Dit bericht komt boven de vacatures te staan in de job alert email.', Pv: 'Job Alert email instellingen', Pw: 'Onderwerp van de email', Px: 'Job alerts van {{ companyName }}', Py: 'Jouw job alert voor {{companyName}}', Pz: 'Vul het onderwerp voor de job alert email in', PA: 'Job alert email afmeld bericht', PB: 'Hier kan je het email bericht van de job alert aanpassen.\n    Het bericht komt onder de volgende text in de email: Hi {{ voornaam }}.', PC: 'Als je onze job alerts niet meer wil ontvangen, kan je je uitschrijven via deze link', PD: 'Job alert formulier', PE: 'Nieuwe cijfers worden opgehaald…', PF: 'Tekst van link naar job alert (bij geen vacatures)', PG: 'E-mailadres', PH: 'Blijf op de hoogte van relevante nieuwe vacatures', PI: 'Sollicitatie & formulieren', PJ: 'Dit sollicitatieformulier is beschermd', PK: 'Dit sollicitatieformulier wordt gebruikt door een sollicitatiechat', PL: 'Dit sollicitatieformulier wordt gebruikt door een template', PM: 'Sollicitatie', PN: 'Bezorgd op', PO: 'Vacaturebezoek', PP: 'Industrie', PQ: 'Vacature titel', PR: 'Jordanië', PS: 'Niveau in journey', PT: 'Op welk niveau van de journey zit deze pagina?', PY: 'Uitvullen', P_: 'Kazachstan', P$: 'Kenia', P0: 'Start opnieuw', P1: 'Eén stap terug', P3: 'Trefwoord en locatie', P4: 'Trefwoord', P5: 'Vacature search', P9: 'Kiribati', Qd: 'Kosovo', Qf: 'Koeweit', Qg: 'Kirgizië', bO: 'Titel', Qh: 'Deze titel is al in gebruik', Qi: 'Deze status is al gekoppeld aan deze fase', Qj: 'Voeg een titel toe', Qk: 'Titel boven veld', Qm: 'Taal', Qn: 'Domeincode', Qo: 'Laos', Qp: 'Groot (800px)', Qq: 'Grote bestanden op de pagina', Qr: 'Normale tussenruimte van 40px', Qs: 'Laatste 30 dagen', Qt: 'Laatste 7 dagen', Qu: 'Datum laatste actie', Qv: 'Laatst ingelogd', Qw: 'Vorige maand', Qx: 'Achternaam', Qy: 'Achternaam', Qz: 'Voer je achternaam in', QA: 'Laatste periode', QB: 'Grafiek van gebruikers en sollicitaties over de vorige periode', QF: 'Letland', QQ: 'Libanon', QR: 'Links', QS: 'Lesotho', QT: 'Liberia', QU: 'Libië', QV: 'Liechtenstein', QW: 'Witte tekst', QZ: 'Log in met het geregistreerde e-mailadres. Toegang is verboden voor onbevoegden.', Q_: 'Hiermee kan je potentiële nieuwe collega’s persoonlijk uitnodigen om kennis te maken met jouw bedrijf. Toegang is verboden voor onbevoegden.', Q$: 'Hiermee kan je jouw bedrijf helpen om inspirerende content te creëren voor de recruitmentsite. Potentiële nieuwe collega’s kunnen zo zien hoe het is om bij jullie te werken. Toegang is verboden voor onbevoegden.', Q0: 'Link', Q7: 'Link (Optioneel)', Q8: 'Subitem(s) of link naar pagina verplicht', Q9: 'Overschrijf link in kaart', Ra: 'Link naar pagina verplicht', Rb: 'Link tracking', Re: 'LinkedIn pixel', Rf: 'LinkedIn Insight Tag partner ID voor conversietracking.', Rh: 'LinkedIn-URL', Ri: 'https://www.linkedin.com/gebruikersnaam', Rm: 'Lijstweergave', Rn: 'Litouwen', Ro: 'Live', Rp: 'Laden', Rq: 'Video bestand', Rs: 'Locatie', Rt: 'Vacaturezoeker op locatie', Ru: 'Kies naar welke omringende locaties je sollicitatie nog meer verstuurd mag worden.', Rw: 'Contactgegevens locatie', Rx: 'Alleen locatie', Ry: 'Locatie overzicht', Rz: 'Locatie opgeslagen', RA: 'Jouw locatie', RB: 'Type locatie', RC: 'Locatie niet beschikbaar', RF: 'Locatie(s)', RG: 'Inloggen', RH: 'Log in als medewerker', RI: 'Log in', RJ: 'Ik ben een kandidaat', RK: 'Log uit', RL: 'Ingelogd als', RN: 'We hebben jouw verzoek ontvangen', RQ: 'Logo', RR: 'Ga naar de homepagina van {{domainTitle}}', RS: 'Logo onder communicatie', RT: 'Bedrijfslogo in vacaturebanner', RU: 'Toont het bedrijfslogo (van locatie of filteroptie) in alle vacaturebanner-varianten op de publieke site. Dit regelt de weergave, niet de CMS-componentbeschikbaarheid.', RV: 'Bedrijfslogo in metadata', RW: 'Toont het bedrijfslogo in de vacature-metadatasectie (uren, salaris, locatie) op de publieke site. Schakelt ook het logo-uploadveld in bij filteropties in het CMS.', RY: 'Uitloggen', auB: 'Luxemburg', R_: 'Macau', R$: 'Noord-Macedonië', R0: 'Madagaskar', R3: 'Hoofd navigatie', R4: 'Maak favoriet:', R5: 'Malawi', R6: 'Maleisië', R7: 'Maldiven', R8: 'Mali', R9: 'Malta', Sa: 'Beheer organisatieonderdelen', Sb: 'Beheer vacaturekenmerken', Sc: 'Handmatige invoer', Sd: 'of voer handmatig in', Se: 'Handmatige configuratie vereist', Sg: 'Kaartweergave', Si: 'Marketing', Sj: 'Marketing cookies worden op deze site gebruikt om eventueel video’s via YouTube af te kunnen spelen. Verder ook om relevante advertenties weer te geven tijdens het bezoeken van andere websites.', Sk: 'Marshalleilanden', Sl: 'Martinique', Sn: 'Categorie successvol aangemaakt', So: 'Categorie successvol verwijderd', Sp: 'Categorie successvol aangepast', Ss: 'Mauritanië', St: 'Mauritius', dS: 'Max.', Sw: 'Maximum van 5 opties, verwijder een tag om verder te zoeken', Sy: 'Maximaal aantal uur', SA: 'Als je meerdere bestanden uploadt, probeer dan minder bestanden tegelijk te uploaden.', SB: 'Upload is te groot', SC: 'Maximaal salaris', SH: 'Maximaal', SI: 'Maximale leeftijd', SJ: 'Maximale datum', SK: 'Maximale bestandsgrootte', SL: 'Maximale bestandsgrootte in MB', SM: 'Maximaal aantal tekens', SO: 'Mayotte', SQ: 'Mediaitem verwijderd', SR: 'Dit bestand wordt niet gebruikt', SS: 'Media-item vervangen', ST: 'Mediaitem opgeslagen', SU: 'Dit bestand wordt gebruikt op onderstaande plekken', SW: 'Media', SX: 'Media', SY: 'Overzicht media', SZ: 'Medialabel toegevoegd', S_: 'Medialabel aangepast', S$: 'Medialabels', S0: 'Medium (600px)', S1: 'Kleine tussenruimte van 20px', S2: 'Menu', S3: 'Menu editor', S4: 'Project', S5: 'Lees meer', S6: 'Site', bT: 'Bericht', S7: 'Metabeschrijving', S8: 'Metabeschrijving voor zoekmachine-optimalisatie (maximaal 158 tekens)', S9: 'De metabeschrijving is te lang. Gebruik maximaal 158 tekens.', Ta: 'Mexico', Tb: 'Micronesië', cB: 'Min.', Te: 'Minimum aantal uur', Tg: 'Verschuif deze rij omhoog met een negatieve marge', Th: 'Minimaal salaris', Tj: 'Minimale cookies accepteren', Tl: 'Wijzigingsdatum', Tm: 'Minimaal', Tn: 'Minimum leeftijd', To: 'Minimale datum', Tp: 'Minimaal aantal tekens', Tr: 'Ontbrekende screeningsvraag', Ts: 'Mobiel', Tt: 'Totale aantal mobiel gebruikers die op de link hebben geklikt in de email.', Tu: 'Mobiel nummer (voor inlog)', Tv: 'Totale aantal mobiel gebruikers die de email hebben geopend.', Ty: 'Wijzigingsdatum', Tz: 'Moldavië', TA: 'Monaco', TB: 'Maandag', TC: 'Ma', TD: 'Mongolië', TE: 'Montenegro', TH: 'Montserrat', TI: 'Ochtend', TJ: 'Marokko', TK: 'Upload motivatie', TL: 'Upload je motivatie', TM: 'Voeg jouw motivatie toe', TN: 'Schrijf je motivatie hier', TO: 'Verplaats', TP: 'Mozambique', TQ: 'Meerkolomige dropdown', TR: 'Toon filterdropdowns in meerdere kolommen.', TS: 'Meerdere imports zelfde ATS', TT: 'Staat toe om vacatures te importeren vanuit meerdere accounts van dezelfde ATS-provider in een domein. Dedupliceert ATS-entries bij het samenvoegen.', TU: 'Meerdere locaties', TV: 'Mijn sollicitaties', TW: 'vragen beantwoord', TX: 'Je voortgang verschijnt hier zodra je een sollicitatie start.', TY: 'Nog geen sollicitaties', TZ: 'Verlopen — je antwoorden zijn verwijderd', T_: '{0} van {1} vragen beantwoord', T$: 'Opnieuw solliciteren', T0: 'Maak je sollicitatie af', T1: 'Bewaard tot', T2: 'alleen in deze browser', T3: 'Sollicitatie gestart op', T4: 'Verlopen', T5: 'Gestart', T6: 'Niet beschikbaar', T7: 'Deze vacature is niet meer beschikbaar', T8: 'Bekijk vacatures', T9: 'Mijn vacatures', Ua: 'Myanmar', Ub: 'naar', dY: 'Naam', Uc: 'Deze naam is in gebruik door een andere pagina', Ud: 'Deze naam is al in gebruik', Ue: 'Er bestaat al een sollicitatieformulier met deze naam en taal combinatie', Ug: 'Namibië', Uh: 'nationaliteit', Ui: 'Nauru', Uj: 'Noodzakelijk', Uk: 'Zelf negatieve marge instellen', Ul: 'Negatieve marge van -200px', Um: 'Negatieve marge van -100px', Un: 'Negatieve marge van -150px', Uo: 'Negatieve marge van -60px', Up: 'Negatieve marge van -20px', Uq: 'Nepal', Ur: 'Noodzakelijke cookies worden op deze website alleen gebruikt voor het onthouden van jouw cookie voorkeuren.', auN: 'Nederland', Us: 'Netwerkfout', Ut: 'Er is geen verbinding met de server. Controleer je internetverbinding en probeer het opnieuw.', Uu: 'Nooit ingelogd', Uv: 'Nieuw', Uw: 'Nieuwe sollicitatie', Ux: 'Nieuwe actie', Uy: 'Beste {{sollicitatieToegewezenVoornaam}},<br><br>Er is een nieuwe sollicitatie binnengekomen op de vacature {{vacatureTitel}} {{locatie}}:<br><br>{{{sollicitatieLink}}}<br><br>Met vriendelijke groet,<br><br>{{bedrijfsnaam}}', UA: 'Melding: Nieuwe sollicitatie', UB: 'Nieuwe sollicitatieprocedure', UC: '{{sollicitantVoornaam}} {{sollicitantAchternaam}} heeft gesolliciteerd op de vacature {{vacatureTitel}}', UD: 'Nieuw', UE: 'Beste {{sollicitatieToegewezenVoornaam}},<br><br>Je bent toegewezen aan de volgende sollicitatie(s):<br><br>{{{sollicitatieLinks}}}<br><br>Met vriendelijke groet,<br><br>{{gebruikerVoornaam}} {{gebruikerAchternaam}}<br>{{gebruikerTelefoonnummer}}<br>{{gebruikerEmail}}', UF: 'Melding: Toegewezen persoon gewijzigd', UG: 'Je bent toegewezen aan de volgende sollicitatie(s)', UH: 'Nieuw-Caledonië', UI: 'Nieuwe categorie', UJ: 'Voer titel van de categorie in', UK: 'Nieuwe kolom', UL: 'Nieuwe communicatie', UM: 'Nieuwe afbeelding', UN: 'Nieuw item', UO: 'Nieuw OAuth Client', UP: 'Voer titel van het organisatie onderdeel in', UQ: 'Nieuw organisatieonderdeel', UR: 'Nieuwe pagina', US: 'Nieuwe chat', UT: 'Nieuwe redirect', UU: 'Nieuwe sollicitatiestatus', UV: 'Titel invoeren voor dit label', UW: 'Nieuw template', UX: 'Nieuwe tekst', UY: 'Nieuwe tekst', UZ: 'Nieuwe titel', U_: 'Nieuwe gebruikers', U$: 'Nieuwe vacatures', U0: 'Nieuwe vacature', U1: 'Voer titel van het vacaturekenmerk in', U2: 'Voer titel van het vacature kenmerk in', U3: 'Nieuw vacaturekenmerk onder', U4: 'Nieuw vacaturekenmerk', U5: 'Voeg nieuw vacaturekenmerk toe', U6: 'Nieuwe waarde', U7: 'Nieuwe versie', U8: 'Nieuw tablad', U9: 'Nieuw-Zeeland', Va: 'Nieuws', Vb: 'Nieuws kan niet verwijderd worden als het gepubliceerd is', Vc: 'Nieuws informatie', Vd: 'Nieuwsbericht', Ve: 'Nieuwsbericht', Vf: 'Nieuwsitem opgeslagen', Vg: 'Nieuws', Vh: 'Nieuws items', Vi: 'Nieuwsoverzicht', Vj: 'Nieuws (overzicht)', Vk: 'Overzicht nieuws', Vl: 'Nieuwslabel toegevoegd', Vm: 'Nieuwslabel verwijderd', Vn: 'Nieuwslabel aangepast', Vo: 'Nieuwslabels', Vp: 'Nieuwslabels', Vq: 'Groot (40px)', Vr: 'Abonneren op de nieuwsbrief', Vs: 'Abonneren op de nieuwsbrief', Vt: 'Volgende stap', Vv: 'Nicaragua', Vw: 'Niger', Vx: 'Nigeria', Vy: 'Nacht', Vz: 'Niue', VA: 'Nee', VB: 'Geen sollicitatie gevonden', VC: 'Geen sollicitatieformulier op de pagina', VD: 'Geen sollicitatie procedure gevonden.', VE: 'Er zijn geen sollicitaties om te tonen', VF: 'Geen actieve campagnes gevonden', VG: 'Nog geen wijzigingen', VH: 'Geen actieve contracten gevonden', VI: 'Geen medewerkers gevonden', VJ: 'Je hebt nog geen medewerkers die iemand hebben aangedragen', VK: 'Je hebt nog geen medewerkers die content hebben geupload', VL: 'Geen events gevonden', VM: 'Je hebt nog geen events. Voeg een event toe om te beginnen.', VN: 'Geen eventlabels gevonden', VO: 'Er zijn nog geen eventlabels toegevoegd. Voeg een eventlabel toe om te beginnen.', VP: 'Geen ATS gekoppeld', VQ: 'Aan dit domein is nog geen ATS gekoppeld. Sollicitaties komen binnen in de Applicant Tool.', VR: 'Nog geen feedback', VS: 'Helaas geen filteroptie suggesties', VT: 'U hebt geen filters in uw organisatie', VU: 'Je hebt nog geen filters', VV: 'Er is geen formulier voor dit ATS. Vacatures van dit ATS krijgen geen sollicitatieformulier.', VW: 'Geen formulieren gevonden', VX: 'Er zijn nog geen formulieren aangemaakt. Maak een formulier aan om te beginnen.', VY: 'Geen formulieren gevonden voor deze zoekopdracht of dit ATS-filter.', VZ: 'Geen groepen gevonden', V_: 'Geen groepen gevonden. Maak er een aan.', V$: 'Geen items gevonden', V0: 'Je hebt nog geen items. Begin met het maken van een item.', V1: 'Helaas geen locatie suggesties', V2: 'Geen locaties gevonden', V3: 'Geen handmatige configuratie vereist', V4: 'Geen negatieve marge', V5: 'Geen media gevonden', V6: 'Je hebt nog geen bestanden. Voeg een bestand toe om te beginnen.', V7: 'Geen mediaitem geselecteerd', V8: 'Geen medialabels gevonden', V9: 'Er zijn nog geen medialabels toegevoegd. Voeg een medialabel toe om te beginnen.', Wa: 'Geen nieuwsitems gevonden', Wb: 'Je hebt nog geen nieuwsitems gemaakt. Maak een nieuwsitem aan om te starten.', Wc: 'Geen nieuwslabels gevonden', Wd: 'Er zijn nog geen nieuwslabels toegevoegd. Voeg een nieuwslabel toe om te beginnen.', We: 'Nog geen nieuwsberichten.', Wf: 'Geen open checkout gevonden', Wg: 'Er zijn nog geen categorieën binnen de organisatie', Wh: 'Geen categorieën in je organisatie gevonden', Wi: 'Er zijn geen organisatie onderdelen binnen de organisatie', Wj: 'Geen organisatieonderdelen gevonden', Wk: 'Geen pagina\'s beschikbaar', Wl: 'Geen pagina\'s gevonden', Wm: 'Je hebt nog geen pagina\'s. Voeg een page toe om te beginnen.', Wn: 'Geen voorkeur', Wo: 'Kies periode', Wp: 'Geen recruiters gevonden', Wq: 'Je hebt geen recruiters in uw organisatie.', Wr: 'Geen chats gevonden', Ws: 'Er zijn nog geen chats aangemaakt. Voeg een chat toe om te beginnen.', Wt: 'Je hebt nog geen redirects', Wu: 'Dit domein heeft nog geen ingestelde redirects.', Wv: 'Geen uitnodigingen gevonden', Ww: 'Er zijn nog geen uitnodigingen verstuurd naar Referrals door de medewerkers.', Wx: 'Geen inschrijvingen gevonden', Wy: 'U hebt nog geen inschrijvingen voor evenementen.', Wz: 'Not ok', WA: 'Geen resultaat', WB: 'Weergavetekst wanneer er geen resultaat beschikbaar is', WD: 'Geen salariscalculator gevonden', WE: 'Er is nog geen salariscalculator aangemaakt.', WF: 'Geen salaris calculator geselecteerd', WG: 'Geen upload labels gevonden', WH: 'Er zijn nog geen upload labels toegevoegd. Voeg een upload label toe om te beginnen.', WI: 'Geen superuser geconfigureerd. Voeg er een toe voordat u doorgaat.', WJ: 'Geen labels gevonden', WK: 'Er zijn nog geen labels toegevoegd. Voeg een label toe om te beginnen.', WL: 'Geen vacature templates gevonden', WM: 'Er zijn nog geen vacature templates aangemaakt. Voeg een vacature template toe om te beginnen.', WN: 'Geen transacties gevonden', WO: 'Geen transomaten gevonden', WP: 'Geen vertalingen waar gevonden', WQ: 'Geen uploads gevonden', WR: 'We konden nog geen uploads voor u vinden', WS: 'Geen gebruikers gevonden', WT: 'Geen gebruikers gevonden binnen je zoekopdracht', WU: 'Binnen deze selectie zijn geen vacatures beschikbaar. Verwijder je selectie om verder te gaan.', WV: 'Geen vacatures beschikbaar binnen je selectie', WW: 'Geen vacatures gevonden. Probeer het later opnieuw of stel een job alert in.', WX: 'Er zijn geen vacatures beschikbaar binnen je organisatie.', WY: 'Geen vacature', WZ: 'Geen vacaturefilter opties gevonden', W_: 'Er zijn vacaturefilter opties beschikbaar binnen de organisatie', W$: 'Geen vacaturefilters gevonden', W0: 'Er zijn vacaturefilters beschikbaar binnen de organisatie', W1: 'Geen vacature geselecteerd voor de preview', W2: 'Helaas geen vacature suggesties', W3: 'Norfolkeiland', W4: 'Noord-Korea', W5: 'Noordelijke Marianen', auX: 'Noorwegen', W6: 'Je bent niet geautoriseerd om sollicitaties te bekijken binnen dit domein.', W7: 'Je bent niet geautoriseerd om vacatures te bekijken binnen dit domein.', W8: 'Niet gevonden', W9: 'Niet verwerkt', Xa: 'Niet gepubliceerd', Xb: '—', Xc: 'Verberg WhatsApp button op deze pagina', Xg: ',', Xh: '.', Xi: 'Aantal uur', Xj: 'Aantal items te tonen', Xk: 'OAuth Client', Xl: 'Actief', Xm: 'Client aangemaakt', Xn: 'Deze OAuth client verwijderen?', Xo: 'Client verwijderd', Xp: 'Omschrijving', Xq: 'Client ID', Xr: 'Clientnaam', Xs: 'Client geheim opnieuw genereren? Alle bestaande tokens worden ongeldig.', Xt: 'Geheim opnieuw genereren', Xu: 'Alle tokens voor deze client intrekken?', Xv: 'Alle tokens intrekken', Xw: 'Client opgeslagen', Xx: 'Client Geheim', Xy: 'Inloggegevens verzenden naar {0}?', Xz: 'Inloggegevens delen', XA: 'Verloopt op', XB: 'Deelgeschiedenis', XC: 'Ontvanger e-mailadres', XD: 'Inloggegevens verzenden', XE: 'Delen verzonden naar', XF: 'Bekeken op', XG: 'Aantal tokens', XH: 'Uitgegeven op', XI: 'Tokens', XJ: 'OAuth Clients', XK: 'Deze inloggegevens zijn al bekeken.', XL: 'Deze inloggegevens zijn verlopen.', XM: 'Gebruik deze inloggegevens om te authenticeren met de API. Bewaar ze veilig.', XN: 'OAuth Inloggegevens', XP: 'Oceanië', XR: 'Van deze emails,', au2: 'Uit', XT: 'Stuur aanbieding', XU: 'Beste {{sollicitantVoornaam}},<br><br>Met veel plezier delen wij mee dat wij je graag een aanbod willen doen voor de functie van {{vacatureTitel}} bij {{bedrijfsnaam}}! We zijn erg enthousiast over de gesprekken die we hebben gevoerd en geloven dat je een waardevolle aanvulling op ons team zult zijn.<br><br>Hieronder vind je de belangrijkste details van het aanbod:<br><br>Functietitel: {{vacatureTitel}}<br>Startdatum: <br>Salaris: <br>Standplaats: {{locatie}}<br>Contractduur:<br><br>In de bijlage vind je de officiële aanbieding met alle details over het contract en arbeidsvoorwaarden. We willen je vragen om deze zorgvuldig door te nemen. Mocht je vragen hebben of bepaalde zaken willen bespreken, aarzel dan niet om contact met ons op te nemen.<br><br>We hopen natuurlijk dat je enthousiast bent en kijken ernaar uit om je binnen ons team te verwelkomen. Laat ons snel weten of je ons aanbod accepteert.<br><br>We kijken uit naar je reactie!<br><br>Met vriendelijke groet,<br><br>{{sollicitatieToegewezenVoornaam}} {{sollicitatieToegewezenAchternaam}}<br>{{sollicitatieToegewezenTelefoonnummer}}<br>{{sollicitatieToegewezenEmail}}', XV: 'Aanbod contract', XW: 'Ons aanbod voor de functie van {{vacatureTitel}}', XX: 'Offline', XZ: 'Oke', X_: 'Oude waarde', X$: 'Oman', au3: 'Aan', X4: 'Een van de twee velden verplicht maken', X5: 'Een of meer e-mailadressen bestaan al:', X6: 'Automatisch blokkeren', X7: 'Scripts automatisch blokkeren totdat de gebruiker toestemming geeft', X8: 'Basis-URL', X9: 'Aangepaste basis-URL voor OneTrust CDN (standaard: cdn.cookielaw.org)', Ya: 'OneTrust Cookie Modal ID', Yb: 'OneTrust domain script ID. Required when Cookie Modal Provider is set to OneTrust. Controls which OneTrust consent configuration is loaded.', Yc: 'Online', Yd: 'Open sollicitatie', Yf: 'Open sollicitatie mapping', Yg: 'Voegt een extern ID-veld toe aan Open Sollicitatie formulieren. Koppelt elk formulier aan een specifieke ATS-vacaturecategorie, meegenomen bij het exporteren van sollicitaties.', Yh: 'Selectieveld (4)', Yi: 'Extra checkbox 4-tekst', Yj: 'Selectieveld (1)', Yk: 'Extra checkbox 1-tekst', Yl: 'Selectieveld (3)', Ym: 'Extra checkbox 3-tekst', Yn: 'Selectieveld (2)', Yo: 'Extra checkbox 2 -tekst', Yp: 'Open sollicitatie', Yq: 'Open sollicitatie formulier', Yr: 'Open sollicitatie', Ys: 'Voegt het Open Sollicitatie formuliertype toe in het CMS formulieroverzicht voor spontane sollicitaties zonder specifieke vacature.', Yt: 'Open select omschrijving', Yu: 'Open select', Yv: 'Open select optie 5', Yw: 'Open select optie 4', Yx: 'Open select optie 1', Yy: 'Open select optie 3', Yz: 'Open select optie 2', YA: 'Open submenu', YB: 'Tekstveld', YC: 'Tekstveld', YD: 'Tekstveld Placeholder', YE: 'Open tracking', YF: 'Geopende emails', YG: 'Totale hoeveelheid emails die zijn geopened', YH: 'Optimale cookies accepteren', YI: 'Optimaliseer met AI', YJ: 'Aan het optimaliseren...', YP: 'optioneel', YQ: 'Optioneel veld', au7: 'Opties', YR: 'Opties van verwijderde vacatures', YS: 'Behoud filteropties van verwijderde vacatures in zoekfilters.', YU: 'of', YV: 'of voeg een externe link toe', YW: 'of toon bevestigingsbericht', YX: 'Order campaign', YY: 'Volgordenummer', YZ: 'Bestelstatus', Y_: 'Besteld', Y$: 'Lijst (genummerd)', Y4: 'Organisatie', Y5: 'Categorieën in de organisatie', Y6: 'Categorieën in de organisatie', Y7: 'Organisatieonderdeel', Za: 'Origineel', Zb: 'Gebruik deze code om in te loggen:', Zc: 'Outlook 2016', Zd: 'Totale aantal Outlook gebruikers.', Zf: 'Overzicht', Zg: 'Vacaturekaart', Zi: 'Overzicht vacatures', Zj: 'Overschrijf de standaard buttontekst', Zk: 'Titel bij e-mail', Zl: 'WhatsApp telefoonnummer overschrijven', Zm: 'WhatsApp button overschrijven', Zn: 'Titel bij WhatsApp', Zo: 'De inhoud van deze pagina kon niet worden geladen. Er wordt niets opgeslagen totdat de inhoud is geladen.', Zp: 'Inhoud van de pagina niet geladen', Zq: 'Opnieuw proberen', Zs: 'Pagina verwijderd', Zt: 'De pagina is niet leeggemaakt, omdat niet vaststaat welke versie je hebt geladen. Laad de pagina opnieuw en probeer het nog eens.', Zu: 'Pagina niet leeggemaakt', Zw: 'Ongeldig pagina id', Zx: 'Deze pagina bestaat niet, kies een andere pagina.', Zy: 'Pagina opnieuw laden', Zz: 'Pagina opgeslagen', ZA: 'Deze pagina is intussen elders gewijzigd, daarom zijn je wijzigingen niet opgeslagen. Laad de pagina opnieuw om de nieuwste versie te zien. Je niet-opgeslagen wijzigingen gaan daarbij verloren.', ZB: 'Pagina is elders gewijzigd', ZC: 'Paginainstellingen', ZD: 'Paginalabels', ZE: 'Voorbeeld paginatitel', ZG: 'Deze pagina wordt gebruikt in het menu. Verwijder de pagina eerst uit het menu', ZH: 'Deze versie van de pagina bestaat niet.', ZI: 'Naar de laatste versie', ZJ: 'Versie niet gevonden', ZL: 'Overzicht pagina\'s', ZM: 'Pagina\'s', ZN: 'Analytics data per pagina', ZO: 't/m', ZP: 'van', ZQ: 'Pakistan', ZR: 'Palau', ZS: 'Palestina', ZT: 'Actie', ZU: 'Opnieuw proberen', ZV: 'Zoekdienst niet bereikbaar', ZW: 'Sollicitatie', ZX: 'Evenement', ZY: 'Formulier', ZZ: 'Nieuws', Z_: 'Pagina', Z$: 'Referraltemplate', Z0: 'Vacature', Z1: '404-template', Z2: 'Sollicitatietemplate', Z3: 'Vacaturetemplate', Z4: 'Bedanktemplate', Z5: 'Typ minimaal {0} tekens…', Z6: 'navigeren', Z7: 'Geen resultaten voor {0}', Z8: 'openen', Z9: 'In {0}', _a: 'Zoeken…', _b: 'Zoeken naar {0}…', _c: 'Sectie', _d: 'Suggesties', _e: 'Wissel naar {0}', _f: 'Panama', _h: 'Papoea-Nieuw-Guinea', _i: 'Paraguay', _j: 'Parameter', _m: 'Type onderdeel', _n: 'URL-pad', _o: 'Dit URL-pad wordt al gebruikt door een andere pagina', _p: 'Ongeldig URL-pad. Gebruik letters, nummers of een koppelteken', _q: 'voorbeeld-pad', _r: 'Pad moet beginnen met het pad voorvoegsel', _s: 'Dit URL-pad is te lang', _t: 'On hold', _u: 'Zet vacature on hold', _v: 'On hold', _w: 'Let op', _x: 'De titel van dit kenmerk wordt in Hamilton CMS gewijzigd en zal niet meer door de import vanuit het ATS worden overschreven.', _z: 'In behandeling', _B: 'per uur', _C: 'per maand', _D: 'Performance', _E: 'Permissies', _H: 'Persoonlijke afbeelding voor de referral', _I: 'Persoonlijk bericht', _J: 'Dit is waar het persoonlijk bericht van jullie werknemer aan de potentiële kandidaat getoond wordt.', _K: 'Persoonlijk bericht voor de referral', _L: 'Peru', _M: 'Fase', _N: 'Filippijnen', _P: 'Een geldig telefoonnummer bestaat uit minstens 10 cijfers.', avb: 'Telefoonnummer', _R: 'Vul je telefoonnummer in', _S: 'Telefoonnummer (publiek)', _T: 'Telefoonnummer (met landcode)', _U: 'Vul je telefoonnummer in', _W: 'Je telefoonnummer lijkt een paar cijfers te lang. Kun je het controleren?', _X: 'Het lijkt erop dat er een cijfer mist in je telefoonnummer. Kun je het controleren?', _Z: 'Kies een platform', __: 'Hint: Kies een eind datum', _$: 'Hint: Kies een start datum', _2: 'Tekst in veld', _3: 'Tekst', _4: 'Platform', _5: 'Platforms', _7: 'Voer SMS code in', _8: 'Selecteer een nieuwslabel', _9: 'Welkom bij Hamilton CMS', $a: 'Welkom bij de Review Tool', $b: 'Welkom bij de Referral Tool', $c: 'Welkom bij de Employee Share Tool', ave: 'Polen', $d: 'Open chat na x aantal seconden', $e: 'Stel het aantal seconden in voordat de chatbot verschijnt', $g: 'Portfolio', $h: 'Kies bestand', avf: 'Portugal', $j: 'Onder midden', $k: 'Linksonder', $l: 'Rechtsonder', $m: 'Gecentreerd', $n: 'Midden links', $o: 'Midden rechts', $p: 'Aangepast', $q: 'Functie', $s: 'Boven midden', $t: 'Linksboven', $u: 'Rechtsboven', $v: 'van links', $w: 'van boven', $B: 'Postcode', $C: 'Ongeldige combinatie van postcode en huisnummer', $D: 'Postcode', $E: 'Voer postcode in', $F: 'Postcode te lang', $G: 'Postcode', $H: 'Postcode', $J: 'Vereisten voor posten', $K: 'Postmark analytics', $R: 'voorkeurs taal', $S: 'E-mail medewerker voorinvullen', $T: 'Vult het e-mailveld in sollicitatieformulieren vooraf in met het e-mailadres van de ingelogde medewerker. Werkt alleen op interne domeinen.', $V: 'Preview', $W: 'Prijs', $X: 'Afdrukknop', $Y: 'Toont een afdrukknop in de vacature social-sharing toolbar voor het afdrukken van de vacaturedetailpagina.', $Z: 'Print deze vacature', $$: 'Prioriteit', $0: 'Privacy', $1: 'Privacyverklaring', $2: 'Privacyvoorwaarden', $3: 'Ik accepteer de', $4: 'Graag de privacy voorwaarden accepteren.', $5: 'Privacyverklaring', $6: 'Privacyvoorwaarden', aaa: 'privacyvoorwaarden', aab: 'Privacyverklaring', aac: 'Privacyvoorwaarden', aad: 'Ik accepteer de', aae: 'Ik accepteer de', aaf: 'Rechten', aak: 'Product id', aal: 'Product niet gevonden', aam: 'Products', aan: 'Projectinstellingen', aar: 'Eigendommen', aau: 'Provincie', aav: 'Voer provincie in', aaw: 'Openbaar vervoer', aax: 'Publicatiedatum', aay: 'Publicatienaam', aaz: 'Publiceren', aaA: 'Publiceer vacature', aaB: 'Gepubliceerd', aaC: 'Gepubliceerd op', aaD: 'Puerto Rico', aaF: 'Qatar', aaJ: 'Vragen', aaK: 'Je hebt het limiet van deze maand bereikt voor AI-gebruik. Vanaf de eerste dag van de volgende maand kun je weer verder. Geen zorgen: vanaf volgende maand staat alles weer voor je klaar.', aaL: 'Vul een waarde binnen de toegestane range in', aaN: 'sollicitaties / vacaturebezoeken', aaR: 'Heractiveer gebruiker', aaS: 'Gebruiker succesvol gereactiveerd', aaT: 'Call-to-action bij meer vacatures', aaU: 'Lees meer in de cookieverklaring', aaV: 'Call-to-action bij meer nieuws', aaW: 'Redenen', aaX: 'Aanbevolen', aaZ: 'Contactpersoon uit ATS', aa_: 'Recruiter verwijderd', aa1: 'Contactpersonen', aa2: 'Recruiter opgeslagen', aa4: 'Recruitment chat', aa5: 'Keuzekompas', aa6: 'Chat verwijderd', aa8: 'Chat niet gevonden', aa9: 'Chat is ingebed in een andere chat flow', aba: 'Chat wordt gebruikt op een pagina', abc: 'Titel chat', abd: 'Deze titel wordt reeds voor een chat gebruikt', abe: 'Alle stappen onder het open sollicitatie formulier worden getoond na een succesvolle sollicitatie', abf: 'Alle tekst stappen direct na de salaris calculator kunnen de volgende variablen gebruiken: age, hours, function and total', abg: 'Chatstructuur', abh: 'Structuur', abi: 'Toont een KeuzeCompass recruitment chatbot-widget op de carrièresite voor kandidaatbegeleiding.', abj: 'Alle stappen onder het vacatureoverzicht worden getoond na een succesvolle sollicitatie', abk: 'Lees meer', abm: 'Redirect aangemaakt', abn: 'URL moet starten met een /', abo: 'Redirect niet toegestaan', abp: 'Doorverwijspagina', abq: 'De bron-URL wordt al gebruikt door een andere redirect', abr: 'Bron-URL en doel-URL moeten uniek zijn', abs: 'Redirect naar pagina', abt: 'Redirect aangepast', abu: 'Redirects', abw: 'Reference Id', abx: 'Je referral is succesvol verstuurd', aby: 'Referral', abz: 'hebben gesolliciteerd', abA: 'Bannerafbeelding', abB: 'Weergavetekst van de link', abC: 'Hier', abD: 'E-mailinhoud van de uitnodiging', abE: 'Beste {{firstName}},\n\n    Goed nieuws - u bent zojuist persoonlijk uitgenodigd door {{employeeFirstName}} om bij ons te solliciteren!\n    En het wordt nog beter! We hebben de best passende banen op een rij gezet en hebben enkele persoonlijke tips & tricks voor je om bij ons een droombaan te vinden.\n\n    Klik op {{button}} om naar je persoonlijke pagina te gaan.\n\n    Tot ziens!', abF: 'E-mailonderwerp uitnodiging', abG: 'Je bent uitgenodigd door {{employeeFirstName}} om te solliciteren bij ons!', abH: 'Afmeldbericht in de uitnodigingsmail', abI: 'Is deze e-mail niets voor jou of wil je je gegevens verwijderen? Klik hier.', abJ: 'Welkom', abK: 'E-mailadres', abL: 'Voer je e-mailadres in', abM: 'Referral formulier', abN: 'Welke banen zijn interessant?', abO: 'Voornaam', abP: 'Vul je voornaam in', abQ: 'Heb jij iemand in gedachten die perfect zou passen bij ons? Word ambassador en stuur je vriend een persoonlijke uitnodiging om bij ons te solliciteren.', abR: 'Achternaam', abS: 'Voer je achternaam in', abT: 'Wat voor soort vacatures passen het beste bij degene die je aandraagt?', abU: 'Jammer dat je gaat', abV: 'Persoonlijk bericht', abW: 'Voer een persoonlijk bericht in voor de persoon die je naar ons verwijst', abX: 'Telefoonnummer', abY: 'Voeg telefoonnummer toe', abZ: 'Telefoonnummer', ab_: 'Op welke website wil je dat de persoon die je aandraagt solliciteert?', ab$: 'Upload een persoonlijke foto', ab0: 'zijn uitgenodigd', ab1: 'Inlogpagina Referral Tool', ab2: 'Logo op inlogscherm', ab3: 'Upload hier het organisatielogo dat op het inlogscherm voor de medewerker wordt getoond.', ab4: 'Introductietekst op inlogscherm', ab5: 'Vul hier een introductietekst in die past bij jouw organisatie. Laat leeg voor de standaardtekst.', ab6: 'Koptekst op het inlogscherm', ab7: 'Welkom bij de Referral Tool', ab8: 'Wijzig hier de koptekst dat op het inlogscherm voor de medewerker wordt getoond.', ab9: 'Personaliseer de inlogpagina van de Referral Tool door één of meerdere van onderstaande velden in te vullen.', aca: 'Overzicht uitnodigingen', acb: 'Templates - Landingspagina\'s', acc: 'Referral indienen', acd: 'Bedankt voor je referral!', ace: 'Bedankt voor je verwijzing! Samen met jouw hulp kunnen we blijven groeien. Jouw vertrouwen in ons wordt zeer op prijs gesteld!', acf: 'Referral tool', acg: 'De banner afbeelding die wordt gebruikt op de referral pagina om iemand aan te dragen.', ach: 'Wat voor soort vacatures passen het beste bij je?', aci: 'Vul hier de tekst in van de link die verwijst naar de pagina, waar de referral in contact kan komen met je organisatie.', acj: 'Het bericht dat een referral ziet in de uitnodigingsmail.', ack: 'Vul hier het onderwerp in van de uitnodigingmail die aan de referral wordt gestuurd.', acl: 'De tekst in de link om de informatie van een referal anoniem te maken.', acm: 'Instellingen Referral Tool', acn: 'Schakelt de referral tool in, waarmee medewerkers kandidaten kunnen doorverwijzen voor openstaande posities. Bij inschakeling worden referralpagina\'s en formulieren aangemaakt in de database.', aco: 'Referral tool', acp: 'Bezoeken landingspagina\'s', acq: 'Uitnodigingen', acr: 'Aantal uitnodigingen', acs: 'Aantal sollicitaties', act: 'Referral veld', acu: 'Aanbevolen door', acv: 'Ik ben doorverwezen', acw: 'Referrer-fallback voor bron', acx: 'CMS-2161: gebruikt de cross-origin HTTP Referer-hostnaam als bron wanneer er geen UTM-parameters beschikbaar zijn. Verkleint het aandeel \'onbekende bron\', maar kan ook ruis geven.', avp: 'Regio', acB: 'Inschrijvingen', acC: 'Uitnodiging opnieuw versturen', acD: 'Uitnodiging opnieuw verstuurd', acE: 'Afgewezen', acF: 'Stuur afwijzing', acG: 'Beste {{sollicitantVoornaam}},<br><br>Hartelijk dank voor je sollicitatie voor de functie van {{vacatureTitel}} bij {{bedrijfsnaam}}. We hebben je sollicitatie met interesse bekeken en waarderen de tijd en moeite die je hebt genomen om te solliciteren.<br><br>Na een zorgvuldige afweging en vergelijking van alle kandidaten, hebben wij helaas besloten om voor deze functie een andere kandidaat te selecteren. Dit betekent echter niet dat we je kwaliteiten en ervaring niet waarderen. De keuze was niet eenvoudig, gezien het aantal sterke sollicitanten dat we hebben mogen ontvangen.<br><br>Wij moedigen je aan om in de toekomst opnieuw te solliciteren op andere passende functies binnen {{bedrijfsnaam}}. Mocht je interesse hebben in verdere mogelijkheden, dan nodigen we je graag uit om onze vacatures in de gaten te houden op {{{linkVacatureOverzicht}}}.<br><br>Nogmaals dank voor je interesse in ons bedrijf. We wensen je veel succes bij toekomstige sollicitaties en je verdere loopbaan.<br><br>Met vriendelijke groet,<br><br>{{sollicitatieToegewezenVoornaam}} {{sollicitatieToegewezenAchternaam}}<br>{{sollicitatieToegewezenTelefoonnummer}}<br>{{sollicitatieToegewezenEmail}}', acH: 'Afwijzing', acI: 'Je sollicitatie voor {{vacatureTitel}}', acK: 'Nieuws (selectie)', acL: 'Vacatures (selectie)', acM: 'Vacatures (slider)', acO: 'Remote', acP: 'Ok', acQ: 'Verwijder', acR: 'Verwijder CTA-kaart', acS: 'Wis filters', acT: 'Verwijder uit import', acV: 'Verwijderd uit import', acW: 'Render Flags', acX: 'Herordende items van sociale media', acZ: 'Allebei', ac_: 'Horizontaal', ac$: 'Geen', ac0: 'Verticaal', ac1: 'Vervang', ac2: 'Vervang media-item', ac3: 'Rapportage', ac4: 'Congo-Brazzaville', eb: 'Verplicht', adc: 'Verplicht veld', add: 'Als dit veld aan staat wordt het formulier veld verplicht om in te vullen op de website', adh: 'Afbeelding', adi: 'Resultaat', adj: 'Upload CV', adk: 'Upload CV', adn: 'Bewaartermijn', ado: 'Probeer opnieuw', adp: 'Terug', adq: 'Réunion', ads: 'Geef afbeelding links weer', adt: 'Verplaats kolom', adu: 'Review', adv: 'Selecteer tekst om opmaak te kunnen selecteren', adw: 'Rechts', avt: 'Roemenië', adA: 'Rij', adD: 'Rij is bestemd voor extra content', adH: 'Wijzig sollicitaties', adI: 'Rusland', adJ: 'Rwanda', adK: 'Geeft aan dat het email adres van de ontvanger niet overeenkomt met de SMTP username.', adL: 'Safari', adM: 'Totale aantal Safari gebruikers.', adN: 'Saint-Barthélemy', adO: 'Sint-Helena, Ascension en Tristan da Cunha', adP: 'Saint Kitts en Nevis', adQ: 'Saint Lucia', adR: 'Saint-Martin (Frans deel)', adS: 'Saint Pierre en Miquelon', adT: 'Saint Vincent en de Grenadines', adU: 'salaris', adV: 'Salariscalculator', adW: 'Salariscalculator (dropdown)', adX: 'Salariscalculator gekoppeld aan vacature', adY: 'Beschikbare salariscalculatoren', adZ: 'Salariscalculator succesvol opgeslagen', ad_: 'Hoeveel wil je verdienen?', ad0: 'Salaris van', ad2: 'Salarisindicatie', ad3: 'Salarisindicatie', ad4: 'Salarisperiode', ad5: 'Salarisrange', ad6: 'Salaris tot', ad8: 'Samoa', ad9: 'San Marino', aed: 'Sao Tomé en Príncipe', aef: 'Zaterdag', aeg: 'Za', aeh: 'Saoedi-Arabië', aei: 'Opslaan', aej: 'OK', aek: 'Opslaan & publiceren', ael: 'Opgeslagen', aem: 'Dit veld kent het schema niet.', aen: 'Het systeem heeft dit veld altijd nodig; het kan niet optioneel of niet beschikbaar zijn.', aep: 'De bestandsgrootte is groter dan het ATS accepteert.', aeq: 'Vul een bestandsgrootte van minstens 1 MB in.', aer: 'Het ATS ondersteunt dit soort formulier niet.', aes: 'Kies minstens één soort formulier.', aet: 'Onbekend bestandstype.', aeu: 'Kies minstens één bestandstype.', aev: 'Scores', aew: 'Pagina\'s / sessie', aex: 'Upload bestand', aey: 'Vul je antwoord in', aez: 'Selectievragen', aeA: 'SDK-pad', aeB: 'Aangepast SDK-pad voor Didomi (laat leeg voor standaard)', aeC: 'Zoeken...', aeD: 'Opnieuw zoeken', aeE: 'Zoek en selecteer een locatie uit de lijst', aeF: 'Zoekbalk placeholder', aeG: 'Welke vacature zoek je?', aeH: 'Wat is je adres?', aeI: 'Zoek op meerdere velden door \'&&\' te gebruiken. (Bijvoorbeeld: NL && Amsterdam)', aeK: 'Selecteer welke zoekvelden zichtbaar zijn', aeL: 'Zoek filter opties...', aeN: 'Locatie in zoeksuggesties', aeO: 'Toont locatienamen in vacature-autocompletesuggesties in de keyword zoekbalk (bijv. Developer in Amsterdam in plaats van alleen Developer).', aeP: 'Zoek nieuws op {0}', aeQ: 'Zoek op locatie', aeR: 'Zoek pagina\'s op {0}', aeS: 'Zoek pagina\'s, vacatures…', aeT: 'Zoek op trefwoord', aeU: 'Zoek vacatures op {0}', aeV: 'Gekozen locatie:', aeW: 'Tweede kleur', aeX: 'Tweede gesprek', aeY: 'Stuur uitnodiging tweede gesprek', ae0: 'Kies', ae1: 'Selecteer een kleur', ae2: 'Selecteer een formulier', ae3: 'Selecteer een transparantie', ae4: 'Selecteer een pagina en daarna een versie om te dupliceren (optioneel)', ae5: 'Selecteer een recruiter type', ae6: 'Afbeelding voor thumbnail', ae7: 'Select a vacancy', ae8: 'Selecteer een website', ae9: 'Selecteer een AI instructie', afa: 'Selecteer een AI instructie', afb: 'Selecteer alles', afc: 'Selecteer een avatar', afd: 'Kies een evenement', afe: 'Selecteer een extra afbeelding', aff: 'Selecteer een afbeelding', afg: 'Titel van de afbeelding', afh: 'Kies afbeeldingen voor social sharing', afi: 'Selecteer andere afbeelding', afj: 'Selecteer een ander logo', afk: 'Selecteer een andere video', afl: 'Selecteer een sollicitatieprocedure', afm: 'Selecteer een afmeting', afn: 'Selecteer ten minste één vacature', afo: 'Selecteer een audio bestand', afp: 'Stel achtergrond in', afq: 'Stel een achtergrondkleur in voor de pagina', afr: 'Stel de hoogte van de banner in', afs: 'Locatie van het sollicitatieformulier instellen', aft: 'Selecteer welke vacaturefilters als tabs boven de zoekbalk zichtbaar zijn', afu: 'Selecteer een merkkleur', afv: 'Selecteer een browser', afw: 'Selecteer een campagne', afx: 'Overlaykleur en transparantie instellen', afy: 'Kies contactpersoon', afz: 'Aantal evenementen', afA: 'Selecteer file', afB: 'Kies welke groep(en) deze gebruiker toe behoort:', afC: 'Selecteer een titelgrootte', afD: 'Kies hiring manager', afE: 'Horizontale uitlijning', afF: 'Selecteer afbeeldingen', afG: 'Selecteer de job alert velden', afH: 'LinkedIn kenmerk', afI: 'LinkedIn kenmerk', afJ: 'LinkedIn kenmerk', afK: 'Kies locatie', afL: 'Selecteer een logo', afM: 'Selecteer een', afN: 'Stel de transparantie van de overlay in', afO: 'Koppel aan verborgen vacature uit ATS', afP: 'Selecteer een pagina', afQ: 'Selecteer een pagina', afR: 'Selecteer een chat', afS: 'Selecteer een uitnodiging om te bekijken', afT: 'Aantal nieuws items', afU: 'Aantal vacatures', afV: 'Toegepast filter', afW: 'Selecteer een bron', afX: 'Selecteer een hoogte', afY: 'Selecteer waar de link opent', afZ: 'Horizontale uitlijning', af_: 'Hoe lang wil je onderweg zijn?', af$: 'Selecteer vacature', af0: 'Selecteer categorie (stap 1/2)', af1: 'Selecteer kenmerk (stap 2/2)', af2: 'Selecteer welke invoer verwacht wordt', af3: 'Selecteer een vacature om te bekijken', af4: 'Kies vacaturekenmerk', af5: 'Selecteer een vacature-beschrijving', af6: 'Selecteer een versie', af7: 'Verticale uitlijning', af8: 'Verticale uitlijning van de titel in de banner', af9: 'Alt-tekst (voor SEO en toegankelijkheid)', aga: 'Koppel afbeelding(en) van een kenmerk aan deze banner', agb: 'Selecteer een kleur', agc: 'Call-to-action', agd: 'Beschrijving', age: 'Geselecteerde afbeelding', agf: 'E-mail', agg: 'Selecteer welke extra content je wil weergeven', agh: 'Vul de gehele kolom', agi: 'Voornaam', agj: 'Hyperlink', agk: 'Selecteer een link kleur', agl: 'Stel maximale contenthoogte in', agm: 'Stel maximale contentbreedte in', agn: 'Stel maximale achtergrondbreedte in', ago: 'Alternatieve afbeelding voor mobiel', agp: 'Telefoonnummer', agq: 'Functie', agr: 'Alternatieve afbeelding voor tablet', ags: 'Open nieuwe pagina in', agt: 'Titel', agu: 'Selecteer een achtergrond video', agv: 'Video ID', agw: 'Plak alleen de video id bijv. \'ScMzIvxBSi4\'', agx: 'Selecteer een platform', agA: 'Geselecteerde afbeelding', agC: 'Geselecteerde locatie', agE: 'De geselecteerde gebruiker heeft geen toegang tot deze vacature.', agG: 'Je kunt de superuser-status van je eigen account niet verwijderen.', agH: 'Stuur een WhatsApp bericht', agI: 'Stuur een e-mail', agJ: 'Overschrijf contact formulier button', agK: 'Stuur communicatie', agL: 'Stuur afwijzing', agM: 'Verstuur', agN: 'Stuur naar', agO: 'Senegal', agP: 'Ervaring', agR: 'Welk level van senioriteit behoort tot deze pagina?', agS: 'Verstuurd', agT: 'Totale hoeveelheid emails die je hebt verstuurd', agU: 'Verzonden e-mail', agV: 'Verstuurde emails', agW: 'Doorgestuurd naar', agX: 'SEO overzicht', ag_: 'Servië', ag0: 'Sessies', ag2: 'Instellingen', ag3: 'Configuratie vereist', ag4: 'Seychellen', ag5: 'Deel', ag7: 'Deel', ag8: 'Deel op social media:', ag9: 'Share tool', aha: 'Upload label toegevoegd', ahb: 'Upload label aangepast', ahc: 'Upload labels', ahd: 'Schakelt de medewerkers content-deeltool in waar medewerkers foto\'s/video\'s kunnen uploaden en delen die op de carrièresite verschijnen.', ahe: 'Share tool', ahf: 'Deel deze vacature via Email', ahg: 'Deel deze vacature via Facebook', ahh: 'Deel deze vacature via Linkedin', ahi: 'Deel deze vacature via X', ahj: 'Deel deze vacature via Whatsapp', ahk: 'Gedeelde formulieren', ahl: 'Upload labels', ahn: 'Toon', aho: 'Toon actieve sollicitaties', ahp: 'Toon actieve vacatures', ahq: 'Toon alle activiteiten', ahs: 'Toon als label in vacature', ahu: 'Toon chat na x aantal seconden', ahv: 'Toon afgeronde sollicitaties', ahw: 'Toon gesloten vacatures', ahz: 'Toon de cookiemelding op de pagina', ahA: 'Toon CTA-kaart in vacatureoverzicht', ahB: 'Toon alleen content voor desktop', ahC: 'Zelf instellen', ahD: 'Bekijk hoe de pagina eruitziet op verschillende apparaten (desktop, tablet, mobiel)', ahE: 'Toon alle content', ahH: 'Toon de footer op de pagina', ahK: 'Laat ruimte zien tussen kolommen', ahM: 'Toon de header (menu) op de pagina', ahN: 'Overlay over afbeelding', ahO: 'Toon in Share Tool formulier', ahP: 'Toon de pagina in de sitemap', ahQ: 'Tonen in vacaturekaart', ahR: 'Toon zoekveld(en) boven het vacaturefilter', ahS: 'Link als button tonen', ahU: 'Laat locatie velden zien', ahV: 'Selecteer logo in vacature-kaart', ahW: 'Logo in vacaturekaart en -banner', ahX: 'Toon als masonry', ahY: 'Toon alleen content voor mobiel', ahZ: 'Toon meer', ah_: 'Bekijk meer nieuws', ah$: 'Bekijk meer vacatures', ah0: 'Toon filters in nieuwsoverzicht', ah1: 'Toon labels in nieuwskaarten', ah2: 'Toon op:', ah3: 'Weergave van deze rij per apparaat:', ah4: 'Toon label op website', ah5: 'Toon alleen notities', ah8: 'Toon publicatiedatum bij nieuwsbericht', ah9: 'Toon salarisperiode in vacature', aia: 'Toont \'per maand\' achter het salaris in vacatures en filters', aib: 'Geef slider weer in', aic: 'Toon alleen spotlight vacatures', aid: 'Toon alleen content voor tablet', aie: 'Toon label in', aih: 'Toon starttijd op website', aii: 'Toon WhatsApp button op deze pagina', aij: 'Selecteer de velden in de formulieren', aik: 'Sierra Leone', ail: 'Log in', avA: 'Singapore', aim: 'Sint-Maarten (Nederlands deel)', ain: 'Site-instellingen', aio: 'Vormgeving', aip: '60 minuten', aiq: 'Auto', air: 'Contain', ais: 'Cover', ait: 'Custom', aiv: 'Menu-items overslaan', aiA: '5 kaarten', aiB: '4 kaarten', aiC: '1 kaart', aiD: '3 kaarten', aiE: '2 kaarten', avC: 'Slowakije', aiG: 'Slovenië', aiH: 'Klein (400px)', aiI: 'Zeer kleine tussenruimte van 10px', aiK: 'SMS Code', aiL: 'SMTP errors', aiO: 'Gemaakt social media-item', aiP: 'Verwijderde sociale media-item', aiQ: 'Socials in footer', aiR: 'Sociale media', aiS: 'Succesvol bijgewerkt Social Media Item', aiT: 'Aanhef', aiU: 'Selecteer uw aanhef', aiV: 'Softbounces', aiW: 'De mailbox van de ontvanger is vol en accepteert geen emails meer.', aiX: 'Salomonseilanden', aiY: 'Somalië', aiZ: 'Er is iets mis gegaan', ai$: 'Alfabet', ai0: 'Sorteer op', ai1: 'Volgordenummer', ai2: 'Aantal vacatures', ai3: 'Bron-URL', ai4: 'Bron / sollicitaties', ai5: 'Diagram met verhouding van sollicitaties per bron', ai7: 'Bron', ai8: 'Sollicitaties informatie per bron', aja: 'Bronnen', ajb: 'Bronnen / Sollicitaties', ajc: 'Zuid-Afrika', ajd: 'Zuid-Korea', aje: 'Zuid-Soedan', ajf: 'Tussenruimte', avD: 'Spanje', aji: 'spam klachten.', ajk: 'Splitsen op locatie', ajl: 'Splitst Ubeeo V2 vacatures met meerdere locaties op in afzonderlijke vacaturerecords per locatie.', ajn: 'Spotlight', ajp: 'Sri Lanka', ajr: 'Standplaats', ajw: 'Start datum', ajA: 'Statistieken', ajB: 'Statistische cookies helpen ons te begrijpen hoe bezoekers deze website gebruiken, door anoniem gegevens te verzamelen en te rapporteren.', fL: 'Status', ajC: 'Permanent verplaatst (301)', ajD: 'Tijdelijk verplaatst (302)', ajE: 'Zie andere (303)', ajF: 'Naar sollicitatiestatus', ajH: 'Goedgekeurd', ajI: 'Assessment', ajJ: 'Statuswijziging', ajK: 'Status gewijzigd van', avE: 'Statuscode', ajL: 'Status is succesvol verwijderd', ajM: 'Statusbeschrijving', ajN: '1e gesprek', ajO: 'Aangenomen', ajP: 'You rock!', ajQ: 'Status kan niet worden verwijderd. Deze is beschermd.', ajR: 'Nieuw', ajS: 'Aanbod', ajT: 'In afwachting', ajU: 'Telefonisch interview', ajV: 'Afgewezen', ajW: 'Opnieuw proberen', ajX: 'Review', ajY: 'Screening', ajZ: '2e gesprek', aj_: 'Status wordt nog gebruikt in een actie. Wijs je actie toe aan een andere status voordat je de status verwijdert.', aj$: 'Status wordt nog gebruikt in een sollicitatie. Wijs je sollicitatie toe aan een andere status voordat je de status verwijdert.', aj0: 'Status wordt nog gebruikt in een communicatie template. Wijs je communicatie template toe aan een andere status voordat je de status verwijdert.', aj1: 'Teruggetrokken', aj2: 'Sollicitatiestatussen', fM: 'Stap', aj5: 'Je verkent Stibbe als', aj6: 'Langere bewaartermijn', aj7: 'Winkelnummer', aj8: 'Straat', aj9: 'Straat + huisnummer', aka: 'Voer straat en huisnummer in', akb: 'Straatnaam', akd: 'Voer je straatnaam in', ake: 'Straatnaam', akf: 'Straatnaam', akj: 'WWW-redirect verwijderen', akk: 'Redirect www.domein.nl naar domein.nl met een 301-redirect. Standaard ingeschakeld.', akm: 'Google kenmerk', akq: 'Submenu type', akr: 'Submenu weergave: met directe links of alleen dropdown.', aku: 'Submenu bij hover', akv: 'Opent navigatiesubmenu\'s bij muishover in plaats van een klik. Standaard ingeschakeld.', avI: 'Verstuur', akx: 'Sollicitatie succesvol verstuurd', aky: 'Verstuur', avJ: 'Formulier succesvol verstuurd', akA: 'Voeg subtitel toe', akC: 'Notitie toegevoegd', akE: 'Besteld', akF: 'Dat was leuk om het opnieuw te doen', akG: 'Uw inhoud is', akH: 'Ingediend!', akI: 'Uw inhoud is ingediend. Het wordt binnenkort gecontroleerd! Je kunt je inzendingen en hun statussen zien door op het Star-Icon te tikken! Volgende keer dat u zich aanmeldt, wordt u op de hoogte gebracht wanneer de status is gewijzigd!', akJ: 'Goed gedaan!', akK: 'Volg HKM People Instagram-kanaal', akL: 'Zie alle inzendingen', akM: 'Notitie verwijderd', akN: 'Je hebt per e-mail een tijdelijke link ontvangen waarmee je kunt inloggen op Hamilton CMS. Gebruik hiervoor de unieke code die je via SMS hebt ontvangen.', akO: 'Soedan', akW: 'Voeg samenvatting toe', akX: 'Zondag', akY: 'Zo', akZ: 'Superuser', ak_: 'Geeft volledige administratieve toegang tot alle domeinen. Gebruik dit spaarzaam.', ak$: '<b>Dit organisatie onderdeel is geïmporteerd. Weet je zeker dat je dit organisatieonderdeel wilt verwijderen?</b>\n\n    Als dit onderdeel nog aanwezig is in het externe systeem, dan zal deze tijdens de volgende import weer teruggeplaatst worden.\n\n    Het kan ook zijn dat er nog vacatures aan gekoppeld zijn. Wij adviseren om eerst deze vacatures aan een ander onderdeel te koppelen of dit  onderdeel te hernoemen.', ak0: '<b>Dit organisatie onderdeel is geïmporteerd. Weet je zeker dat je dit organisatieonderdeel wilt verwijderen?</b>\n\n    Als dit onderdeel nog aanwezig is in het externe systeem, dan zal deze tijdens de volgende import weer teruggeplaatst worden.\n\n    Het kan ook zijn dat er nog vacatures aan gekoppeld zijn. Wij adviseren om eerst deze vacatures aan een ander onderdeel te koppelen of dit  onderdeel te hernoemen.', ak1: '<b>Dit vacaturekenmerk is geïmporteerd. Weet je zeker dat je dit vacaturekenmerk wilt verwijderen?</b>\n    Als dit onderdeel nog aanwezig is in het externe systeem, dan zal deze tijdens de volgende import weer teruggeplaatst worden.\n\n    Het kan ook zijn dat er nog vacatures aan gekoppeld zijn. Wij adviseren om eerst deze vacatures aan een ander kenmerk te koppelen of dit kenmerk te hernoemen.', ak2: '<b>Dit vacaturekenmerk is geïmporteerd. Weet je zeker dat je dit vacaturekenmerk wilt verwijderen?</b>Als dit onderdeel nog aanwezig is in het externe systeem, dan zal deze tijdens de volgende import weer teruggeplaatst worden.\n\n    Het kan ook zijn dat er nog vacatures aan gekoppeld zijn. Wij adviseren om eerst deze vacatures aan een ander onderdeel te koppelen of dit  onderdeel te hernoemen.', ak3: 'Weet je zeker dat je dit item wilt verwijderen?', ak4: 'Weet je zeker dat je alle UBEEO vacatures wilt verwijderen?', ak5: 'Suriname', ak6: 'Svalbard en Jan Mayen', avQ: 'Zweden', avR: 'Zwitserland', ak7: 'Synoniemen', ak8: 'Genereren van synoniemen mislukt', ak9: 'Synoniemen succesvol gegenereerd', ala: 'Voer synoniemen in voor dit kenmerk, gescheiden door een puntkomma (;). Deze synoniemen worden gebruikt om de vindbaarheid via de zoekfunctie op jullie recruitmentsite te verbeteren.', alb: 'AI heeft automatisch synoniemen gegenereerd voor dit kenmerk. Deze worden gebruikt in de zoekfunctie op jullie recruitmentsite. Je kunt ze hier aanpassen. Scheid de synoniemen met een puntkomma (;).', alc: 'Syrië', ale: 'Tablet', alg: 'Label is succesvol aangemaakt', alh: 'Deze titel is al in gebruik voor een label.', ali: 'Oeps, deze titel is iets te lang. Gebruik maximaal 255 tekens.', alj: 'GTM altijd laden', alk: 'Laadt Google Tag Manager onvoorwaardelijk, ongeacht het cookietoestemmingsniveau. Standaard laadt GTM pas na toestemming.', all: 'Het label is succesvol aangepast.', aln: 'Labels', alo: 'Taiwan', alp: 'Tadzjikistan', alq: 'Haal offline', alr: 'Weet je zeker dat je dit offline wil halen?', als: 'Tanzania', alt: 'Doel-URL', alu: 'Template toegevoegd', alv: 'Template verwijderd', alx: 'Template kan niet worden verwijderd. Het is beschermd', alA: 'Templates - Vacaturepagina', alB: 'Templates - Vacaturepagina', alC: 'Dit is een test bericht', alD: 'Testimonial', alE: 'Inhoud', alG: 'Textkleur', alH: 'Tekst', alI: 'Tekst + Afbeelding component', alJ: 'Schakelt het Tekst + Afbeelding pagina-component in de CMS-editor in: een contentblok met tekst naast een afbeelding, met optioneel omgekeerde layout.', alK: 'Text in button', alM: 'Tekst te lang', alN: 'Tekst te kort', alO: 'Tekst', alP: 'Tekst + Video component', alQ: 'Schakelt het Tekst + Video pagina-component in de CMS-editor in: een contentblok met tekst naast een ingebedde video, met optioneel omgekeerde layout.', alR: 'Thailand', alS: 'Dankbericht bij succesvol solliciteren', alT: 'Bedankt', alU: 'Templates - Bedankpagina', alW: 'Thema', alX: 'en', alY: 'Hiermee halen andere thema’s de controles niet meer: {0}', alZ: 'Dit thema kan niet worden verwijderd: het wordt gebruikt door {0}', al_: 'Thema van deze site wijzigen?', al$: '{0} rendert hierna met het thema {1}. Bezoekers zien dat binnen vijf minuten.', al0: '{0} wijst hierna naar het thema {1}. Tot dat thema is gepubliceerd, blijft de site met het standaardthema renderen.', al1: 'Designsysteem wijzigen?', al2: '{0} gaat weer de huidige stylesheet gebruiken. Het thema doet dan niets.', al3: '{0} gaat het nieuwe designsysteem gebruiken en rendert met het gekozen thema.', al4: 'Standaard', al5: 'Thema verwijderen', al6: 'Weet je zeker dat je het thema {0} wilt verwijderen? Alle versies van dit thema gaan mee.', al7: 'Thema verwijderd', al8: 'Van het standaardthema: {0}', ama: 'Het standaardthema kan niet worden verwijderd', amb: 'Dit thema kan niet worden verwijderd: een versie van {{names}} gebruikt het', amc: 'Dit thema kan niet worden verwijderd: het is het thema van {{names}}', amd: 'De wijzigingen in de velden zijn nog niet opgeslagen en gaan verloren als je weggaat. Annuleer om ze eerst op te slaan als concept.', ame: 'Weggaan zonder opslaan', amf: 'Live sinds', amg: 'Nieuw thema', amh: 'Thema van de site', ami: 'Thema van deze site', amj: 'Thema openen', amk: '{0} pagina’s', aml: '1 pagina', amm: 'Voorbeeld op', amn: 'Publiceren voor {0}', amo: 'Naam wijzigen', amp: 'Naam gewijzigd', amq: 'Terugzetten en publiceren', amr: 'Versie {0} wordt meteen gepubliceerd en vervangt de live versie van dit thema.', ams: 'Niet-opgeslagen wijzigingen in de velden gaan verloren.', amt: 'Versie {0} terugzetten', amu: 'Daarmee verandert wat er te zien is op {0}.', amv: 'Thema opgeslagen', amw: '{0} sites', amx: '1 site', amy: 'De waarden van deze bron halen de controles niet meer', amz: 'Kleuren van {0}', amA: 'Kopie van {0}', amB: 'Leeg thema', amC: 'Beginnen met', amD: 'Tot dit thema is gepubliceerd, geldt het standaardthema.', amE: 'Tot dit thema is gepubliceerd, gelden de standaardwaarden van het designsysteem.', amF: '{0} niet-gepubliceerde versies', amG: '1 niet-gepubliceerde versie', amH: 'Gebruikt door', amI: 'Nog niet in gebruik', amJ: 'Thema’s', amK: 'De thema’s van dit project. Een thema volgt het standaardthema voor alles wat het zelf niet instelt.', amL: 'Maak een thema aan om de vormgeving van dit project vast te leggen.', amM: 'Nog geen thema’s', amN: 'Derde kleur', amO: '30 minuten', amP: 'Deze maand', amQ: 'Thunderbird', amR: 'Totale aantal Thunderbird gebruikers.', amS: 'Donderdag', amT: 'Do', amV: 'tot', a_: 'Timeout', amX: 'Het request duurde te lang.', amY: 'Oost-Timor', amZ: 'Type', avV: 'Titel', am_: 'Voorbeeld titel', am$: 'Tot en met', am0: 'Eindkleur', am2: 'Ga naar het begin van de pagina', fV: 'Vandaag', am3: 'Togo', am4: 'Tokelau', am5: 'Token cookienaam', am6: 'Naam van de cookie die het Didomi-toestemmingstoken opslaat (standaard: didomi_token)', am7: 'Tonga', am8: 'Te lang', am9: 'Te veel kolommen', ana: 'Voor SEO doeleinde is dit geen goed idee.', anb: 'Je probeert meer dan 1 H1 toe te voegen op de pagina...', anc: 'Er zijn te veel vacatures in de spotlight (maximaal 5)', and: 'Maximum van twee superusers bereikt. Verwijder eerst de status van een ander voordat u een nieuwe toewijst.', ane: 'Te kort', ang: 'Totaal', anh: 'Sollicitaties', ani: 'Totaal aantal dagen', anj: 'Totale laadtijd', ank: 'Totale score', ann: 'Actieve vacatures', ano: 'Vacature weergave', anp: 'Tracked emails', anq: 'Aantal verzonden e-mails met Link of Open Tracking ingeschakeld. Een e-mail waarin beide soorten tracking zijn ingeschakeld, verhoogt dit totaal alleen met 1.', anr: 'Tracking', ans: 'De Tracking code is niet valide', anv: 'Transacties', any: 'Transient bounces', anz: 'Geeft een tijdelijk probleem aan bij de server van de ontvanger, of een andere tijdelijk technisch probleem.', anA: 'Openbaar vervoer', anB: 'Vertalingen', anE: 'Reistijd', anF: 'Schakelt het Reistijd component in op vacaturepagina\'s, waarmee kandidaten hun reistijd naar de werklocatie kunnen berekenen.', anG: 'Trinidad en Tobago', anH: 'Dinsdag', anI: 'Di', anK: 'Tunesië', anL: 'Turkije', anM: 'Turkmenistan', anN: 'Turks- en Caicoseilanden', anP: 'Tuvalu', anR: 'Txt', anS: 'Ubeeo CMS formulier', anT: 'Schakelt het Ubeeo sollicitatieformulier component in de pagina-editor in voor Ubeeo ATS-integratie.', anU: 'Ubeeo bulk verwijderen', anV: 'Toont een bulk-verwijderknop in het CMS vacatureoverzicht om alle Ubeeo-bronvacatures in een keer te verwijderen.', anW: 'Ubeeo V1 evenementregistratie', anX: 'Ubeeo event registratie formulier', anY: 'Ubeeo evenement', anZ: 'Schakelt Ubeeo V1 evenementregistratieformulieren in voor kandidaataanmelding bij recruitment-evenementen.', an_: 'Ubeeo formulier', an$: 'Ubeeo V2 CMS-formulier', an0: 'Gebruikt het CMS-beheerde Ubeeo V2 sollicitatieformulier in plaats van het standaard Hireserve-formulier voor Ubeeo-geimporteerde vacatures.', an1: 'Ubeeo V2 evenementregistratie', an2: 'Schakelt Ubeeo V2 evenementregistratieformulieren in, de bijgewerkte integratie voor aanmelding bij recruitment-evenementen.', an3: 'Oeganda', an4: 'UI-aanpassingen', av6: 'Oekraïne', an5: 'Lijst (bullets)', an6: 'Depubliceren', an7: 'Kan het bestand niet lezen', an8: 'Plaats deze rij achter de vorige rij (bij negatieve marge)', aoa: 'Ongedaan maken', aob: 'Weet je zeker dat je je opgeslagen sollicitatiegegevens definitief wilt verwijderen? Dit kan niet ongedaan worden gemaakt.', aoc: 'Ja, verwijder mijn gegevens', aod: 'Gegevens verwijderen', aoe: 'Je sollicitatiegegevens zijn verwijderd.', aof: 'Gegevens verwijderd', aog: 'Je ontvangt geen herinneringen meer over je onafgemaakte sollicitatie.', aoh: 'Wil je je gegevens ook direct verwijderen? Gebruik dan de link “verwijder mijn gegevens” in de e-mail.', aoi: 'Geen herinneringen meer', aoj: 'Je was bezig met solliciteren en hebt al {0} van {1} vragen beantwoord. Je antwoorden zijn bewaard tot {2} — je kunt zo verder waar je gebleven was. Het duurt nog ongeveer twee minuten.', aok: 'Je was bezig met solliciteren en hebt al {0} vragen beantwoord. Je antwoorden zijn bewaard tot {1} — je kunt zo verder waar je gebleven was. Het duurt nog ongeveer twee minuten.', aol: 'Ga verder met je sollicitatie', aom: 'Verwijder je gegevens direct', aon: 'Liever niet?', aoo: 'Wij sturen je hierover maximaal één keer een bericht.', aop: 'Je ontvangt deze eenmalige herinnering omdat je een sollicitatie bent gestart bij {0}.', aoq: 'Hoi {0},', aor: 'Hoi,', aos: 'Je bent begonnen met solliciteren op {0}, maar je sollicitatie is nog niet af. Geen zorgen — we hebben je antwoorden bewaard.', aot: 'Geen herinneringen meer ontvangen', aou: 'Je hebt al {0} van de {1} {2} beantwoord', aov: 'Bewaard tot {0} — daarna verwijderen we je antwoorden automatisch.', aow: 'Je sollicitatie voor {0} is bewaard tot {1}', aox: 'Afmaken duurt nog ongeveer {0} {1}.', aoy: 'De link die je volgde is verlopen, dus we kunnen je opgeslagen sollicitatie niet meer openen.', aoz: 'Je antwoorden zijn verwijderd. Je kunt op elk moment een nieuwe sollicitatie starten.', aoA: 'Je opgeslagen sollicitatie is verlopen', aoB: 'Uniek geklikt', aoC: 'Geeft het totale aantal unieke links aan waarop is geklikt. Links worden beschouwd als uniek voor elke ontvanger, per e-mail. Dezelfde URL in zowel de tekst als de html-body\'s wordt echter behandeld als dezelfde link.', aoD: 'Uniek geopende emails', aoE: 'Totale hoeveelheid unieke emails die zijn geopened', aoF: 'Verenigde Arabische Emiraten', aoG: 'Verenigd Koninkrijk', av8: 'Verenigde Staten', aoH: 'Amerikaanse Maagdeneilanden', aoI: 'Anders', aoJ: 'Onbekend domein', av9: 'Er is iets misgegaan', aoK: 'Totale aantal gebruikers met een onbekende platform op de link hebben geklikt in de email.', aoL: 'Totale aantal gebruikers met een onbekende platform die de email hebben geopend.', aoM: 'Niet toegewezen', aoN: 'Gedepubliceerd', aoP: 'Eventlabel aanpassen', aoQ: 'Medialabel aanpassen', aoR: 'Nieuwslabels aanpassen', aoS: 'Oops dit is niet toegestaan', aoT: 'Upload label aanpassen', aoU: 'Update Social Media Item', aoV: 'Wijzig status', aoW: 'Update label', aoX: 'Gewijzigd op', aoY: 'Filters succesvol opgeslagen', aoZ: 'Upload', ao$: 'Upload media', ao0: 'Upload nieuw CSV bestand', ao1: 'Upload nieuw bestand', ao2: 'Overzicht uploads', ao3: 'Laten we gaan', ao4: 'Deel uw inhoud', ao5: '(Optioneel) Voeg een bijschrift toe bij uw inhoud', ao6: 'Ja, ik heb alle personen gevraagd in de geüploade inhoud voor goedkeuring van het gebruik (zorg ervoor dat u schriftelijke toestemming hebt).', ao7: 'Upload media', ao8: 'Lees verder', ao9: '', apa: 'Stap 1', apb: 'Stap 2', apc: 'Stap 3', apd: 'Voeg labels toe', ape: 'Uploads', apf: 'Uptime', a0: 'URL', apg: 'URL & redirect', aph: 'URL', apj: 'https://www.voorbeeld.com', apl: 'URL\'s met discipline', apm: 'Voegt de disciplinenaam toe als URL-segment in vacaturepagina-URL\'s (bijv. /vacatures/discipline/titel-stad-id/).', apn: 'URL\'s zonder stad', apo: 'Verwijdert de stadsnaam uit vacaturepagina-URL\'s (bijv. /vacatures/titel-id/ in plaats van /vacatures/titel-stad-id/).', app: 'Uruguay', apq: 'Optimaliseer tekst met AI', apr: 'Merkkleur', aps: 'Custom', apt: 'Afbeelding', apu: 'Video', apv: 'Gebruik huidige locatie', apz: 'Handige links', apA: 'Gebruiker', apB: 'Gearchiveerde gebruikers', apC: '{0} heeft geen toegang tot locatie {1}', apD: '{0} heeft geen toegang tot open sollicitatie', apE: '{0} heeft geen toegang tot {1}', apF: '{0} heeft geen toegang tot vacature {1}', apG: 'De UserCentrics-instellingen-ID voor uw account', apI: 'Gebruiker successvol verwijderd', apK: 'Gebruiker is gekoppeld aan één of meer vacatures of sollicitaties', apL: 'Gebruiker is hiring manager voor één of meer vacatures', apM: 'Deze gebruiker kan niet worden toegewezen', apN: 'Deze gebruiker kan niet getoond worden als hiring manager', apO: 'Deze gebruiker kan niet getoond worden als contactpersoon', apP: 'Gebruiker is contactpersoon voor één of meer vacatures', apQ: 'Soort gebruiker', apR: 'Gebruikers', apS: 'Gebruiker successvol opgeslagen', apT: 'Gebruiker', apU: 'onbekend', apW: 'Door deze wijziging verliest de gebruiker toegang tot één of meer gekoppelde vacatures of sollicitaties', apX: 'Gebruikers vorige periode', apY: 'Usp', apZ: 'Usp', ap_: 'UTM Campagne', ap3: 'UTM-bron', ap6: 'Oezbekistan', ap7: 'Vacatures', ap8: 'Vacatures in de buurt', ap9: 'Sollicitaties informatie per vacature', aqa: 'Vacature', aqb: '404 pagina template', aqc: 'Templates - Vacature 404', aqd: 'Vacaturetekst accordion', aqe: 'Vacaturetekst accordion (groep)', aqf: 'Vacature appetizer', aqg: 'Vacature geassociëerde opties', aqh: 'Vacaturekenmerk', aqi: 'Categorieën vacaturekenmerken', aqj: 'Titel vacaturekenmerk', aql: 'Vacaturegedrag', aqn: 'Vacature consolidatie', aqo: 'Vacatures worden samengevoegd wanneer alle informatie van de vacature overeenkomt (behalve de locatie)', aqp: 'Voegt dubbele vacatures van meerdere ATS-bronnen samen tot één vermelding wanneer alle details overeenkomen behalve de locatie. Schakelt ook locatiecombinatie en multi-locatie sollicitatiecomponenten in.', aqq: 'vacatures beschikbaar op deze locatie', aqr: 'vacature beschikbaar op deze locatie', aqt: 'Vacature succesvol aangemaakt', aqu: 'Nieuw aangemaakt', aqw: 'Vacature verwijderd', aqx: 'Verwijderd', aqy: 'Gehele vacature beschrijving (oud)', aqz: 'Vacaturebeschrijving', aqA: 'Vacaturepagina', aqC: 'Template - Bedankpagina', aqD: 'Template - Vacaturepagina', aqE: 'Kopie', aqF: 'Vacaturefilter', aqG: 'Deze titel is al in gebruik.', aqH: 'Vacaturelinks', aqI: 'Categorie type is al in gebruik door een andere categorie.', aqK: 'uur', aqL: 'Vacature id', aqM: 'Vacaturespecificatie', aqO: 'Vacature-item metadata', aqP: 'Lay-out van metadata op vacaturekaarten.', aqQ: 'Vacature-item type', aqR: 'Lay-out van vacaturekaarten: kolom, rij, of compact.', aqT: 'Er zijn nog geen locaties aangemaakt. Voeg ze toe bij Organisatiegegevens.', aqU: 'Vacature niet gevonden', aqV: 'Vacatureoverzicht', aqW: 'Vacatures (alle)', aqX: 'Link naar vacatures', aqY: 'Tekst van link naar vacatures', aq_: 'Vacatureoverzicht (gefilterd)', aq0: 'Vacaturekenmerk', aq2: 'Vacature zoeken & filteren', aq3: 'in', aq5: 'Vacature tags', aq6: 'Toont categorietags op vacaturekaarten en detailpagina\'s. Schakelt ook de toon-als-tag optie in bij filteropties in het CMS.', aq7: 'Pagina template', aq8: 'Vacaturetekst', aq9: 'Vacature text groep', ara: 'Bedanktpagina template', arb: 'Voer titel van de vacature in', arc: 'Vacature aangepast', ard: 'Vacature bekeken', are: 'Dit veld moet een geldig emailadres zijn.', arf: 'Gebruik valide html', arg: 'Validatie CSV bestand', arh: 'Valideer CSV bestand', arj: 'Vanuatu', ark: 'Vaticaanstad', arl: 'Venezuela', arm: 'Versie', arn: 'Versie verwijderd', aro: 'Helpt gebruikers verschillende versies te onderscheiden in het CMS.', arq: 'Versie opgeslagen', arr: 'Versies', ars: 'Video', art: 'Video bestand', aru: 'Video', arv: 'Plak alleen de video id bijv. \'ScMzIvxBSi4\'', arx: 'Om de video af te spelen, zul je de marketing cookies moeten accepteren. Wil je de marketing cookies accepteren?', ary: 'Ja, ik wil de video afspelen', arz: 'Vietnam', ez: 'Bekijk', arA: 'Bekijk sollicitatie', arB: 'Bekijk gegevens', arC: 'Bekijk e-mail', arD: 'Bekijk meer vacatures', arE: 'Bekijk preview', arF: 'Bekijk training', arG: 'Bekijk vacatures', arH: 'Bekijk vacature', arI: 'Weergeven', arJ: 'Vimeo', arL: 'Alleen CMS', arM: 'Share Tool formulier', arO: 'Website', arP: 'Share Tool formulier & Werken-bij website', arQ: 'Bezoek onze {{Platform}} pagina', arR: 'Website bezoek', arS: 'Lopend', arU: 'Wallis en Futuna', arV: 'Webmail', arW: 'Totale aantal webmail gebruikers die de email hebben geopend.', arX: 'Website', arY: 'Website instellingen', ar_: 'Woensdag', ar$: 'Wo', ar2: 'Deel je passie', ar3: 'Dien uw inhoud in', ar4: 'Wij zijn zo\'n leuk en gepassioneerd merk! We willen dit graag nog meer delen met onze (s) helden die in Hunkmöller over de hele wereld winkelen! Laten we ze inspireren wat HKM betekent! Help ons om inhoud te maken die we kunnen delen op internationale platforms! We zijn super benieuwd naar je ideeën!', ar5: 'Deel leuke en authentieke inhoud uit uw winkel-team', ar6: 'Geen enkele klanten zijn toegestaan in beeldmateriaal', ar7: 'Iedereen die in beeldmateriaal wordt weergegeven, gaat ermee akkoord de inhoud te delen', ar8: 'De basis', ar9: 'Je organisatie staat niet stil, net als de arbeidsmarkt. Dat betekent ook dat je recruitmentsite dynamisch moet zijn en met de ontwikkelingen meebeweegt. Met dit CMS kan je zelf aan de knoppen zitten en je recruitmentsite opbouwen en uitbreiden zoals nodig is. Als je vragen hebt over het gebruik van Hamilton CMS staat onze ServiceDesk tijdens kantooruren telefonisch ter beschikking via +31(0)20 244 0492.', asa: '<p>We helpen je graag om het maximale uit Hamilton CMS te halen en je recruitmentsite zo goed mogelijk in te richten.</p><br><br><h3>Hulp en ondersteuning</h3><br><p>Ben je gemachtigd om tickets aan te maken in de <strong>Customer Support Portal</strong>? Dan heb je ook toegang tot onze kennisbank. Hier vind je handige artikelen, uitleg en antwoorden op veelgestelde vragen over Hamilton CMS.</p><br><br><h3>Heb je geen toegang tot de kennisbank?</h3><br><p>Neem dan contact op met iemand binnen jouw organisatie die rechten heeft om tickets aan te maken in de <a target=\'_blank\' href=\'https://floydhamilton.atlassian.net/servicedesk/customer/portals\'>Customer Support Portal</a>. Deze persoon heeft toegang tot de kennisbank en kan, indien nodig, een supportticket aanmaken.</p><br><br><p>Veel plezier met het gebruik van Hamilton CMS!</p>', asb: 'Welkom in Hamilton CMS!', asc: 'emails zijn op geklikt.', asd: 'zijn geopend.', ase: 'Westelijke Sahara', ash: 'WhatsApp-nummer', asj: 'Ik wil graag solliciteren op de vacature', ask: 'Is dit een leuke baan voor jou?', asm: 'WhatsApp ons', asn: 'Wit', cb: 'breed', aso: 'met de volgende opmerking:', asp: 'Verwijderen', asq: 'Teruggetrokken', asr: 'Workday aanvullende data', ass: 'Stuurt een tweede SOAP-verzoek naar Workday met aanvullende velden (referral-ID, doorverwezen-door) na de primaire kandidaatinzending.', asv: 'Wereldkaart', asw: 'Schakelt het Wereldkaart component in. Een interactieve SVG-wereldkaart die vacaturelocaties wereldwijd toont.', asy: 'Schrijf een persoonlijk bericht voor je vriend of vriendin', asB: 'Xing-URL', asC: 'https://www.xing.com/profile/username', asF: 'Werkervaring', asG: 'Jemen', asH: 'Ja', asI: 'Gisteren', asJ: 'Wie zoeken wij', asK: 'You rock!', asL: 'Je hebt', asM: 'emails.', asN: 'YouTube', asO: 'Z-index rij', asP: 'Zambia', asS: 'Zimbabwe'};
var $elm$core$Basics$ge = _Utils_ge;
var $author$project$View$FilterOptionSuggestions$makeNoResultsMessage = function (model) {
	return ($elm$core$List$length(model.xS) >= 5) ? $author$project$Copy$copy.Sw : ($elm$core$String$isEmpty(model.WB) ? $author$project$Copy$copy.WA : model.WB);
};
var $author$project$View$FilterOptionSuggestions$makePlaceholder = function (model) {
	return $elm$core$String$isEmpty(model.d5) ? $author$project$Copy$copy.aeL : model.d5;
};
var $elm$url$Url$Builder$toQueryPair = function (_v0) {
	var key = _v0.a;
	var value = _v0.b;
	return key + ('=' + value);
};
var $elm$url$Url$Builder$toQuery = function (parameters) {
	if (!parameters.b) {
		return '';
	} else {
		return '?' + A2(
			$elm$core$String$join,
			'&',
			A2($elm$core$List$map, $elm$url$Url$Builder$toQueryPair, parameters));
	}
};
var $elm$url$Url$Builder$absolute = F2(
	function (pathSegments, parameters) {
		return '/' + (A2($elm$core$String$join, '/', pathSegments) + $elm$url$Url$Builder$toQuery(parameters));
	});
var $elm$http$Http$BadStatus_ = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$http$Http$BadUrl_ = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$GoodStatus_ = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $elm$http$Http$NetworkError_ = {$: 2};
var $elm$http$Http$Receiving = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$Sending = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$Timeout_ = {$: 1};
var $elm$core$Maybe$isJust = function (maybe) {
	if (!maybe.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$core$Platform$sendToSelf = _Platform_sendToSelf;
var $elm$http$Http$emptyBody = _Http_emptyBody;
var $elm$json$Json$Decode$decodeString = _Json_runOnString;
var $elm$http$Http$expectStringResponse = F2(
	function (toMsg, toResult) {
		return A3(
			_Http_expect,
			'',
			$elm$core$Basics$identity,
			A2($elm$core$Basics$composeR, toResult, toMsg));
	});
var $elm$core$Result$mapError = F2(
	function (f, result) {
		if (!result.$) {
			var v = result.a;
			return $elm$core$Result$Ok(v);
		} else {
			var e = result.a;
			return $elm$core$Result$Err(
				f(e));
		}
	});
var $elm$http$Http$BadBody = function (a) {
	return {$: 4, a: a};
};
var $elm$http$Http$BadStatus = function (a) {
	return {$: 3, a: a};
};
var $elm$http$Http$BadUrl = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$NetworkError = {$: 2};
var $elm$http$Http$Timeout = {$: 1};
var $elm$http$Http$resolve = F2(
	function (toResult, response) {
		switch (response.$) {
			case 0:
				var url = response.a;
				return $elm$core$Result$Err(
					$elm$http$Http$BadUrl(url));
			case 1:
				return $elm$core$Result$Err($elm$http$Http$Timeout);
			case 2:
				return $elm$core$Result$Err($elm$http$Http$NetworkError);
			case 3:
				var metadata = response.a;
				return $elm$core$Result$Err(
					$elm$http$Http$BadStatus(metadata.avE));
			default:
				var body = response.b;
				return A2(
					$elm$core$Result$mapError,
					$elm$http$Http$BadBody,
					toResult(body));
		}
	});
var $elm$http$Http$expectJson = F2(
	function (toMsg, decoder) {
		return A2(
			$elm$http$Http$expectStringResponse,
			toMsg,
			$elm$http$Http$resolve(
				function (string) {
					return A2(
						$elm$core$Result$mapError,
						$elm$json$Json$Decode$errorToString,
						A2($elm$json$Json$Decode$decodeString, decoder, string));
				}));
	});
var $author$project$Model$FilterOptionSuggestion$FilterOptionSuggestion = F2(
	function (optionLabel, optionKey) {
		return {YN: optionKey, YO: optionLabel};
	});
var $author$project$Model$FilterOptionSuggestion$filterOptionSuggestionDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'optionKey',
	$author$project$Data$Id$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'optionLabel',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Model$FilterOptionSuggestion$FilterOptionSuggestion)));
var $elm$json$Json$Decode$index = _Json_decodeIndex;
var $elm$json$Json$Decode$oneOf = _Json_oneOf;
var $elm$json$Json$Decode$maybe = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder),
				$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
			]));
};
var $elm$core$Tuple$pair = F2(
	function (a, b) {
		return _Utils_Tuple2(a, b);
	});
var $elm$http$Http$Request = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$State = F2(
	function (reqs, subs) {
		return {ac5: reqs, akz: subs};
	});
var $elm$http$Http$init = $elm$core$Task$succeed(
	A2($elm$http$Http$State, $elm$core$Dict$empty, _List_Nil));
var $elm$core$Process$kill = _Scheduler_kill;
var $elm$core$Process$spawn = _Scheduler_spawn;
var $elm$http$Http$updateReqs = F3(
	function (router, cmds, reqs) {
		updateReqs:
		while (true) {
			if (!cmds.b) {
				return $elm$core$Task$succeed(reqs);
			} else {
				var cmd = cmds.a;
				var otherCmds = cmds.b;
				if (!cmd.$) {
					var tracker = cmd.a;
					var _v2 = A2($elm$core$Dict$get, tracker, reqs);
					if (_v2.$ === 1) {
						var $temp$router = router,
							$temp$cmds = otherCmds,
							$temp$reqs = reqs;
						router = $temp$router;
						cmds = $temp$cmds;
						reqs = $temp$reqs;
						continue updateReqs;
					} else {
						var pid = _v2.a;
						return A2(
							$elm$core$Task$andThen,
							function (_v3) {
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A2($elm$core$Dict$remove, tracker, reqs));
							},
							$elm$core$Process$kill(pid));
					}
				} else {
					var req = cmd.a;
					return A2(
						$elm$core$Task$andThen,
						function (pid) {
							var _v4 = req.av3;
							if (_v4.$ === 1) {
								return A3($elm$http$Http$updateReqs, router, otherCmds, reqs);
							} else {
								var tracker = _v4.a;
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A3($elm$core$Dict$insert, tracker, pid, reqs));
							}
						},
						$elm$core$Process$spawn(
							A3(
								_Http_toTask,
								router,
								$elm$core$Platform$sendToApp(router),
								req)));
				}
			}
		}
	});
var $elm$http$Http$onEffects = F4(
	function (router, cmds, subs, state) {
		return A2(
			$elm$core$Task$andThen,
			function (reqs) {
				return $elm$core$Task$succeed(
					A2($elm$http$Http$State, reqs, subs));
			},
			A3($elm$http$Http$updateReqs, router, cmds, state.ac5));
	});
var $elm$core$List$maybeCons = F3(
	function (f, mx, xs) {
		var _v0 = f(mx);
		if (!_v0.$) {
			var x = _v0.a;
			return A2($elm$core$List$cons, x, xs);
		} else {
			return xs;
		}
	});
var $elm$core$List$filterMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			$elm$core$List$maybeCons(f),
			_List_Nil,
			xs);
	});
var $elm$http$Http$maybeSend = F4(
	function (router, desiredTracker, progress, _v0) {
		var actualTracker = _v0.a;
		var toMsg = _v0.b;
		return _Utils_eq(desiredTracker, actualTracker) ? $elm$core$Maybe$Just(
			A2(
				$elm$core$Platform$sendToApp,
				router,
				toMsg(progress))) : $elm$core$Maybe$Nothing;
	});
var $elm$http$Http$onSelfMsg = F3(
	function (router, _v0, state) {
		var tracker = _v0.a;
		var progress = _v0.b;
		return A2(
			$elm$core$Task$andThen,
			function (_v1) {
				return $elm$core$Task$succeed(state);
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$filterMap,
					A3($elm$http$Http$maybeSend, router, tracker, progress),
					state.akz)));
	});
var $elm$http$Http$Cancel = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$cmdMap = F2(
	function (func, cmd) {
		if (!cmd.$) {
			var tracker = cmd.a;
			return $elm$http$Http$Cancel(tracker);
		} else {
			var r = cmd.a;
			return $elm$http$Http$Request(
				{
					as_: r.as_,
					_: r._,
					aH: A2(_Http_mapExpect, func, r.aH),
					ax: r.ax,
					aO: r.aO,
					a_: r.a_,
					av3: r.av3,
					a0: r.a0
				});
		}
	});
var $elm$http$Http$MySub = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$http$Http$subMap = F2(
	function (func, _v0) {
		var tracker = _v0.a;
		var toMsg = _v0.b;
		return A2(
			$elm$http$Http$MySub,
			tracker,
			A2($elm$core$Basics$composeR, toMsg, func));
	});
_Platform_effectManagers['Http'] = _Platform_createManager($elm$http$Http$init, $elm$http$Http$onEffects, $elm$http$Http$onSelfMsg, $elm$http$Http$cmdMap, $elm$http$Http$subMap);
var $elm$http$Http$command = _Platform_leaf('Http');
var $elm$http$Http$subscription = _Platform_leaf('Http');
var $elm$http$Http$request = function (r) {
	return $elm$http$Http$command(
		$elm$http$Http$Request(
			{as_: false, _: r._, aH: r.aH, ax: r.ax, aO: r.aO, a_: r.a_, av3: r.av3, a0: r.a0}));
};
var $elm$url$Url$Builder$QueryParameter = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$url$Url$percentEncode = _Url_percentEncode;
var $elm$url$Url$Builder$string = F2(
	function (key, value) {
		return A2(
			$elm$url$Url$Builder$QueryParameter,
			$elm$url$Url$percentEncode(key),
			$elm$url$Url$percentEncode(value));
	});
var $author$project$Data$Id$toInt = function (_v0) {
	var id = _v0;
	return id;
};
var $author$project$Data$Id$toString = A2($elm$core$Basics$composeL, $elm$core$String$fromInt, $author$project$Data$Id$toInt);
var $author$project$View$FilterOptionSuggestions$requestFilterOptionSuggestion = F3(
	function (model, trackingId, keyword) {
		var params = A2(
			$elm$core$List$cons,
			A2($elm$url$Url$Builder$string, 'keywords', keyword),
			A2(
				$elm$core$List$map,
				function (option) {
					return A2(
						$elm$url$Url$Builder$string,
						'current-options',
						$author$project$Data$Id$toString(option));
				},
				model.xS));
		return $elm$http$Http$request(
			{
				_: $elm$http$Http$emptyBody,
				aH: A2(
					$elm$http$Http$expectJson,
					$elm$core$Basics$identity,
					A3(
						$elm$json$Json$Decode$map2,
						$elm$core$Tuple$pair,
						A2(
							$elm$json$Json$Decode$index,
							0,
							$elm$json$Json$Decode$list($author$project$Model$FilterOptionSuggestion$filterOptionSuggestionDecoder)),
						$elm$json$Json$Decode$maybe(
							A2($elm$json$Json$Decode$index, 1, $elm$json$Json$Decode$int)))),
				ax: _List_Nil,
				aO: 'GET',
				a_: $elm$core$Maybe$Nothing,
				av3: $elm$core$Maybe$Just(trackingId),
				a0: A2(
					$elm$url$Url$Builder$absolute,
					_List_fromArray(
						[
							'api',
							$author$project$Data$Id$toString(model.dp),
							'suggestions',
							'filter-options',
							$author$project$Data$Id$toString(model.H0)
						]),
					params)
			});
	});
var $elm$core$List$append = F2(
	function (xs, ys) {
		if (!ys.b) {
			return xs;
		} else {
			return A3($elm$core$List$foldr, $elm$core$List$cons, ys, xs);
		}
	});
var $elm$core$List$concat = function (lists) {
	return A3($elm$core$List$foldr, $elm$core$List$append, _List_Nil, lists);
};
var $author$project$View$FilterOptionSuggestions$filterOptionParam = 'fo';
var $elm$core$List$any = F2(
	function (isOkay, list) {
		any:
		while (true) {
			if (!list.b) {
				return false;
			} else {
				var x = list.a;
				var xs = list.b;
				if (isOkay(x)) {
					return true;
				} else {
					var $temp$isOkay = isOkay,
						$temp$list = xs;
					isOkay = $temp$isOkay;
					list = $temp$list;
					continue any;
				}
			}
		}
	});
var $elm$core$List$member = F2(
	function (x, xs) {
		return A2(
			$elm$core$List$any,
			function (a) {
				return _Utils_eq(a, x);
			},
			xs);
	});
var $lydell$elm_app_url$Escape$Fragment = 3;
var $elm$core$String$concat = function (strings) {
	return A2($elm$core$String$join, '', strings);
};
var $elm$core$String$cons = _String_cons;
var $elm$core$String$fromChar = function (_char) {
	return A2($elm$core$String$cons, _char, '');
};
var $lydell$elm_app_url$Escape$forPath = function (_char) {
	switch (_char) {
		case '/':
			return '%2F';
		case '?':
			return '%3F';
		case '#':
			return '%23';
		default:
			return $elm$core$String$fromChar(_char);
	}
};
var $lydell$elm_app_url$Escape$forQueryKey = function (_char) {
	switch (_char) {
		case '=':
			return '%3D';
		case '&':
			return '%26';
		case '#':
			return '%23';
		default:
			return $elm$core$String$fromChar(_char);
	}
};
var $lydell$elm_app_url$Escape$forQueryValue = function (_char) {
	switch (_char) {
		case '&':
			return '%26';
		case '#':
			return '%23';
		default:
			return $elm$core$String$fromChar(_char);
	}
};
var $lydell$elm_app_url$Escape$escapePart = function (part) {
	switch (part) {
		case 0:
			return $lydell$elm_app_url$Escape$forPath;
		case 1:
			return $lydell$elm_app_url$Escape$forQueryKey;
		case 2:
			return $lydell$elm_app_url$Escape$forQueryValue;
		default:
			return $elm$core$String$fromChar;
	}
};
var $lydell$elm_app_url$Escape$shouldHandlePlusAndSpace = function (part) {
	switch (part) {
		case 0:
			return false;
		case 1:
			return true;
		case 2:
			return true;
		default:
			return false;
	}
};
var $lydell$elm_app_url$Escape$forAll = F2(
	function (part, _char) {
		switch (_char) {
			case '\u0000':
				return '%00';
			case '\u0001':
				return '%01';
			case '\u0002':
				return '%02';
			case '\u0003':
				return '%03';
			case '\u0004':
				return '%04';
			case '\u0005':
				return '%05';
			case '\u0006':
				return '%06';
			case '\u0007':
				return '%07';
			case '\u0008':
				return '%08';
			case '\t':
				return '%09';
			case '\n':
				return '%0A';
			case '\u000B':
				return '%0B';
			case '\u000C':
				return '%0C';
			case '\u000D':
				return '%0D';
			case '\u000E':
				return '%0E';
			case '\u000F':
				return '%0F';
			case '\u0010':
				return '%10';
			case '\u0011':
				return '%11';
			case '\u0012':
				return '%12';
			case '\u0013':
				return '%13';
			case '\u0014':
				return '%14';
			case '\u0015':
				return '%15';
			case '\u0016':
				return '%16';
			case '\u0017':
				return '%17';
			case '\u0018':
				return '%18';
			case '\u0019':
				return '%19';
			case '\u001A':
				return '%1A';
			case '\u001B':
				return '%1B';
			case '\u001C':
				return '%1C';
			case '\u001D':
				return '%1D';
			case '\u001E':
				return '%1E';
			case '\u001F':
				return '%1F';
			case ' ':
				return $lydell$elm_app_url$Escape$shouldHandlePlusAndSpace(part) ? '+' : '%20';
			case '%':
				return '%25';
			case '+':
				return $lydell$elm_app_url$Escape$shouldHandlePlusAndSpace(part) ? '%2B' : $elm$core$String$fromChar(_char);
			case '\u00A0':
				return '%C2%A0';
			case '\u1680':
				return '%E1%9A%80';
			case '\u2000':
				return '%E2%80%80';
			case '\u2001':
				return '%E2%80%81';
			case '\u2002':
				return '%E2%80%82';
			case '\u2003':
				return '%E2%80%83';
			case '\u2004':
				return '%E2%80%84';
			case '\u2005':
				return '%E2%80%85';
			case '\u2006':
				return '%E2%80%86';
			case '\u2007':
				return '%E2%80%87';
			case '\u2008':
				return '%E2%80%88';
			case '\u2009':
				return '%E2%80%89';
			case '\u200A':
				return '%E2%80%8A';
			case '\u2028':
				return '%E2%80%A8';
			case '\u2029':
				return '%E2%80%A9';
			case '\u202F':
				return '%E2%80%AF';
			case '\u205F':
				return '%E2%81%9F';
			case '\u3000':
				return '%E3%80%80';
			case '\uFEFF':
				return '%EF%BB%BF';
			default:
				return A2($lydell$elm_app_url$Escape$escapePart, part, _char);
		}
	});
var $elm$core$String$foldr = _String_foldr;
var $elm$core$String$toList = function (string) {
	return A3($elm$core$String$foldr, $elm$core$List$cons, _List_Nil, string);
};
var $lydell$elm_app_url$AppUrl$percentEncode = F2(
	function (part, string) {
		return $elm$core$String$concat(
			A2(
				$elm$core$List$map,
				$lydell$elm_app_url$Escape$forAll(part),
				$elm$core$String$toList(string)));
	});
var $lydell$elm_app_url$AppUrl$fragmentToString = function (maybeFragment) {
	if (!maybeFragment.$) {
		var fragment = maybeFragment.a;
		return '#' + A2($lydell$elm_app_url$AppUrl$percentEncode, 3, fragment);
	} else {
		return '';
	}
};
var $lydell$elm_app_url$Escape$Path = 0;
var $lydell$elm_app_url$AppUrl$pathToString = function (path) {
	return '/' + A2(
		$elm$core$String$join,
		'/',
		A2(
			$elm$core$List$map,
			$lydell$elm_app_url$AppUrl$percentEncode(0),
			path));
};
var $elm$core$List$concatMap = F2(
	function (f, list) {
		return $elm$core$List$concat(
			A2($elm$core$List$map, f, list));
	});
var $elm$core$Dict$foldl = F3(
	function (func, acc, dict) {
		foldl:
		while (true) {
			if (dict.$ === -2) {
				return acc;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldl, func, acc, left)),
					$temp$dict = right;
				func = $temp$func;
				acc = $temp$acc;
				dict = $temp$dict;
				continue foldl;
			}
		}
	});
var $elm$core$Dict$filter = F2(
	function (isGood, dict) {
		return A3(
			$elm$core$Dict$foldl,
			F3(
				function (k, v, d) {
					return A2(isGood, k, v) ? A3($elm$core$Dict$insert, k, v, d) : d;
				}),
			$elm$core$Dict$empty,
			dict);
	});
var $elm$core$Dict$isEmpty = function (dict) {
	if (dict.$ === -2) {
		return true;
	} else {
		return false;
	}
};
var $elm$core$List$isEmpty = function (xs) {
	if (!xs.b) {
		return true;
	} else {
		return false;
	}
};
var $elm$core$Basics$not = _Basics_not;
var $lydell$elm_app_url$Escape$QueryKey = 1;
var $lydell$elm_app_url$Escape$QueryValue = 2;
var $lydell$elm_app_url$AppUrl$queryParameterToString = function (_v0) {
	var key = _v0.a;
	var values = _v0.b;
	return A2(
		$elm$core$List$map,
		function (value) {
			return ((!$elm$core$String$isEmpty(key)) && $elm$core$String$isEmpty(value)) ? A2($lydell$elm_app_url$AppUrl$percentEncode, 1, key) : (A2($lydell$elm_app_url$AppUrl$percentEncode, 1, key) + ('=' + A2($lydell$elm_app_url$AppUrl$percentEncode, 2, value)));
		},
		values);
};
var $lydell$elm_app_url$AppUrl$queryParametersToString = function (queryParameters) {
	var filteredQueryParameters = A2(
		$elm$core$Dict$filter,
		F2(
			function (_v0, values) {
				return !$elm$core$List$isEmpty(values);
			}),
		queryParameters);
	return $elm$core$Dict$isEmpty(filteredQueryParameters) ? '' : ('?' + A2(
		$elm$core$String$join,
		'&',
		A2(
			$elm$core$List$concatMap,
			$lydell$elm_app_url$AppUrl$queryParameterToString,
			$elm$core$Dict$toList(filteredQueryParameters))));
};
var $lydell$elm_app_url$AppUrl$toString = function (url) {
	return _Utils_ap(
		$lydell$elm_app_url$AppUrl$pathToString(url._n),
		_Utils_ap(
			$lydell$elm_app_url$AppUrl$queryParametersToString(url.aaG),
			$lydell$elm_app_url$AppUrl$fragmentToString(url.at5)));
};
var $elm$core$Dict$values = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, valueList) {
				return A2($elm$core$List$cons, value, valueList);
			}),
		_List_Nil,
		dict);
};
var $author$project$View$FilterOptionSuggestions$toUrl = F2(
	function (url, filterOptionId) {
		var values = $elm$core$Dict$values(url.aaG);
		var paramValue = $author$project$Data$Id$toString(filterOptionId);
		var isMember = A2(
			$elm$core$List$member,
			paramValue,
			$elm$core$List$concat(values));
		var currentParams = A2($elm$core$Dict$get, $author$project$View$FilterOptionSuggestions$filterOptionParam, url.aaG);
		return isMember ? $lydell$elm_app_url$AppUrl$toString(url) : $lydell$elm_app_url$AppUrl$toString(
			_Utils_update(
				url,
				{
					aaG: function () {
						if (currentParams.$ === 1) {
							return A3(
								$elm$core$Dict$insert,
								$author$project$View$FilterOptionSuggestions$filterOptionParam,
								_List_fromArray(
									[paramValue]),
								url.aaG);
						} else {
							return A3(
								$elm$core$Dict$update,
								$author$project$View$FilterOptionSuggestions$filterOptionParam,
								$elm$core$Maybe$map(
									$elm$core$List$append(
										_List_fromArray(
											[paramValue]))),
								url.aaG);
						}
					}()
				}));
	});
var $author$project$View$FilterOptionSuggestions$filterSearchConfig = function (model) {
	var id = 'filter-option';
	return {
		eI: $elm$core$Maybe$Nothing,
		dE: id,
		aul: $elm$core$Maybe$Nothing,
		aut: $author$project$View$FilterOptionSuggestions$FilterOptionAutocompleteMsg,
		WC: $author$project$View$FilterOptionSuggestions$makeNoResultsMessage(model),
		d5: $author$project$View$FilterOptionSuggestions$makePlaceholder(model),
		ac8: A2($author$project$View$FilterOptionSuggestions$requestFilterOptionSuggestion, model, id),
		avO: $author$project$View$Autocomplete$Http$Link(
			{
				avM: A2(
					$elm$core$Basics$composeL,
					$author$project$View$FilterOptionSuggestions$toUrl(model.Rs),
					function ($) {
						return $.YN;
					}),
				anl: $elm$core$Maybe$Nothing
			}),
		avS: $elm$core$Maybe$Nothing,
		am1: function ($) {
			return $.YO;
		},
		cO: A2(
			$elm$core$Basics$composeL,
			$elm$html$Html$text,
			function ($) {
				return $.YO;
			}),
		fW: $elm$core$Maybe$Nothing,
		fX: id
	};
};
var $elm$core$Platform$Sub$map = _Platform_map;
var $author$project$View$Autocomplete$Http$SetAutocomplete = function (a) {
	return {$: 5, a: a};
};
var $author$project$View$Autocomplete$Http$SetInputFromAutocomplete = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$View$Autocomplete$Http$Close = {$: 6};
var $elm$core$Basics$always = F2(
	function (a, _v0) {
		return a;
	});
var $elm$browser$Browser$Events$Document = 0;
var $elm$browser$Browser$Events$MySub = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $elm$browser$Browser$Events$State = F2(
	function (subs, pids) {
		return {_0: pids, akz: subs};
	});
var $elm$browser$Browser$Events$init = $elm$core$Task$succeed(
	A2($elm$browser$Browser$Events$State, _List_Nil, $elm$core$Dict$empty));
var $elm$browser$Browser$Events$nodeToKey = function (node) {
	if (!node) {
		return 'd_';
	} else {
		return 'w_';
	}
};
var $elm$browser$Browser$Events$addKey = function (sub) {
	var node = sub.a;
	var name = sub.b;
	return _Utils_Tuple2(
		_Utils_ap(
			$elm$browser$Browser$Events$nodeToKey(node),
			name),
		sub);
};
var $elm$core$Dict$fromList = function (assocs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, dict) {
				var key = _v0.a;
				var value = _v0.b;
				return A3($elm$core$Dict$insert, key, value, dict);
			}),
		$elm$core$Dict$empty,
		assocs);
};
var $elm$core$Dict$merge = F6(
	function (leftStep, bothStep, rightStep, leftDict, rightDict, initialResult) {
		var stepState = F3(
			function (rKey, rValue, _v0) {
				stepState:
				while (true) {
					var list = _v0.a;
					var result = _v0.b;
					if (!list.b) {
						return _Utils_Tuple2(
							list,
							A3(rightStep, rKey, rValue, result));
					} else {
						var _v2 = list.a;
						var lKey = _v2.a;
						var lValue = _v2.b;
						var rest = list.b;
						if (_Utils_cmp(lKey, rKey) < 0) {
							var $temp$rKey = rKey,
								$temp$rValue = rValue,
								$temp$_v0 = _Utils_Tuple2(
								rest,
								A3(leftStep, lKey, lValue, result));
							rKey = $temp$rKey;
							rValue = $temp$rValue;
							_v0 = $temp$_v0;
							continue stepState;
						} else {
							if (_Utils_cmp(lKey, rKey) > 0) {
								return _Utils_Tuple2(
									list,
									A3(rightStep, rKey, rValue, result));
							} else {
								return _Utils_Tuple2(
									rest,
									A4(bothStep, lKey, lValue, rValue, result));
							}
						}
					}
				}
			});
		var _v3 = A3(
			$elm$core$Dict$foldl,
			stepState,
			_Utils_Tuple2(
				$elm$core$Dict$toList(leftDict),
				initialResult),
			rightDict);
		var leftovers = _v3.a;
		var intermediateResult = _v3.b;
		return A3(
			$elm$core$List$foldl,
			F2(
				function (_v4, result) {
					var k = _v4.a;
					var v = _v4.b;
					return A3(leftStep, k, v, result);
				}),
			intermediateResult,
			leftovers);
	});
var $elm$browser$Browser$Events$Event = F2(
	function (key, event) {
		return {Gs: event, P2: key};
	});
var $elm$browser$Browser$Events$spawn = F3(
	function (router, key, _v0) {
		var node = _v0.a;
		var name = _v0.b;
		var actualNode = function () {
			if (!node) {
				return _Browser_doc;
			} else {
				return _Browser_window;
			}
		}();
		return A2(
			$elm$core$Task$map,
			function (value) {
				return _Utils_Tuple2(key, value);
			},
			A3(
				_Browser_on,
				actualNode,
				name,
				function (event) {
					return A2(
						$elm$core$Platform$sendToSelf,
						router,
						A2($elm$browser$Browser$Events$Event, key, event));
				}));
	});
var $elm$core$Dict$union = F2(
	function (t1, t2) {
		return A3($elm$core$Dict$foldl, $elm$core$Dict$insert, t2, t1);
	});
var $elm$browser$Browser$Events$onEffects = F3(
	function (router, subs, state) {
		var stepRight = F3(
			function (key, sub, _v6) {
				var deads = _v6.a;
				var lives = _v6.b;
				var news = _v6.c;
				return _Utils_Tuple3(
					deads,
					lives,
					A2(
						$elm$core$List$cons,
						A3($elm$browser$Browser$Events$spawn, router, key, sub),
						news));
			});
		var stepLeft = F3(
			function (_v4, pid, _v5) {
				var deads = _v5.a;
				var lives = _v5.b;
				var news = _v5.c;
				return _Utils_Tuple3(
					A2($elm$core$List$cons, pid, deads),
					lives,
					news);
			});
		var stepBoth = F4(
			function (key, pid, _v2, _v3) {
				var deads = _v3.a;
				var lives = _v3.b;
				var news = _v3.c;
				return _Utils_Tuple3(
					deads,
					A3($elm$core$Dict$insert, key, pid, lives),
					news);
			});
		var newSubs = A2($elm$core$List$map, $elm$browser$Browser$Events$addKey, subs);
		var _v0 = A6(
			$elm$core$Dict$merge,
			stepLeft,
			stepBoth,
			stepRight,
			state._0,
			$elm$core$Dict$fromList(newSubs),
			_Utils_Tuple3(_List_Nil, $elm$core$Dict$empty, _List_Nil));
		var deadPids = _v0.a;
		var livePids = _v0.b;
		var makeNewPids = _v0.c;
		return A2(
			$elm$core$Task$andThen,
			function (pids) {
				return $elm$core$Task$succeed(
					A2(
						$elm$browser$Browser$Events$State,
						newSubs,
						A2(
							$elm$core$Dict$union,
							livePids,
							$elm$core$Dict$fromList(pids))));
			},
			A2(
				$elm$core$Task$andThen,
				function (_v1) {
					return $elm$core$Task$sequence(makeNewPids);
				},
				$elm$core$Task$sequence(
					A2($elm$core$List$map, $elm$core$Process$kill, deadPids))));
	});
var $elm$browser$Browser$Events$onSelfMsg = F3(
	function (router, _v0, state) {
		var key = _v0.P2;
		var event = _v0.Gs;
		var toMessage = function (_v2) {
			var subKey = _v2.a;
			var _v3 = _v2.b;
			var node = _v3.a;
			var name = _v3.b;
			var decoder = _v3.c;
			return _Utils_eq(subKey, key) ? A2(_Browser_decodeEvent, decoder, event) : $elm$core$Maybe$Nothing;
		};
		var messages = A2($elm$core$List$filterMap, toMessage, state.akz);
		return A2(
			$elm$core$Task$andThen,
			function (_v1) {
				return $elm$core$Task$succeed(state);
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Platform$sendToApp(router),
					messages)));
	});
var $elm$browser$Browser$Events$subMap = F2(
	function (func, _v0) {
		var node = _v0.a;
		var name = _v0.b;
		var decoder = _v0.c;
		return A3(
			$elm$browser$Browser$Events$MySub,
			node,
			name,
			A2($elm$json$Json$Decode$map, func, decoder));
	});
_Platform_effectManagers['Browser.Events'] = _Platform_createManager($elm$browser$Browser$Events$init, $elm$browser$Browser$Events$onEffects, $elm$browser$Browser$Events$onSelfMsg, 0, $elm$browser$Browser$Events$subMap);
var $elm$browser$Browser$Events$subscription = _Platform_leaf('Browser.Events');
var $elm$browser$Browser$Events$on = F3(
	function (node, name, decoder) {
		return $elm$browser$Browser$Events$subscription(
			A3($elm$browser$Browser$Events$MySub, node, name, decoder));
	});
var $elm$browser$Browser$Events$onMouseDown = A2($elm$browser$Browser$Events$on, 0, 'mousedown');
var $elm$json$Json$Decode$andThen = _Json_andThen;
var $elm$json$Json$Decode$fail = _Json_fail;
var $author$project$Data$DropDown$invertDecoder = function (decoder) {
	return A2(
		$elm$json$Json$Decode$andThen,
		function (maybe) {
			return _Utils_eq(maybe, $elm$core$Maybe$Nothing) ? $elm$json$Json$Decode$succeed(0) : $elm$json$Json$Decode$fail('');
		},
		$elm$json$Json$Decode$maybe(decoder));
};
var $author$project$Data$DropDown$succeedIfBloodlineHasId = function (targetId) {
	return A2(
		$elm$json$Json$Decode$andThen,
		function (id) {
			return _Utils_eq(id, targetId) ? $elm$json$Json$Decode$succeed(0) : A2(
				$elm$json$Json$Decode$field,
				'parentNode',
				$author$project$Data$DropDown$succeedIfBloodlineHasId(targetId));
		},
		A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string));
};
var $author$project$Data$DropDown$succeedIfClickOustideOfId = function (targetId) {
	return $author$project$Data$DropDown$invertDecoder(
		A2(
			$elm$json$Json$Decode$field,
			'relatedTarget',
			$author$project$Data$DropDown$succeedIfBloodlineHasId(targetId)));
};
var $author$project$View$Autocomplete$Http$clickOutSideSubscription = function (config) {
	return $elm$browser$Browser$Events$onMouseDown(
		A2(
			$elm$json$Json$Decode$map,
			$elm$core$Basics$always(
				config.aut($author$project$View$Autocomplete$Http$Close)),
			$author$project$Data$DropDown$succeedIfClickOustideOfId(config.dE)));
};
var $wernerdegroot$listzipper$List$Zipper$current = function (_v0) {
	var x = _v0.b;
	return x;
};
var $author$project$Keyboard$matchKey = F2(
	function (key, msg) {
		return A2(
			$elm$json$Json$Decode$andThen,
			function (s) {
				return _Utils_eq(key, s) ? $elm$json$Json$Decode$succeed(msg) : $elm$json$Json$Decode$fail('Not a match');
			},
			A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string));
	});
var $author$project$Data$Autocomplete$HasFocus = function (a) {
	return {$: 1, a: a};
};
var $author$project$Data$Autocomplete$NoFocus = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Data$Autocomplete$NothingToSuggest = {$: 2};
var $wernerdegroot$listzipper$List$Zipper$after = function (_v0) {
	var rs = _v0.c;
	return rs;
};
var $wernerdegroot$listzipper$List$Zipper$Zipper = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $wernerdegroot$listzipper$List$Zipper$first = function (zipper) {
	var ls = zipper.a;
	var x = zipper.b;
	var rs = zipper.c;
	var _v0 = $elm$core$List$reverse(ls);
	if (!_v0.b) {
		return zipper;
	} else {
		var y = _v0.a;
		var ys = _v0.b;
		return A3(
			$wernerdegroot$listzipper$List$Zipper$Zipper,
			_List_Nil,
			y,
			_Utils_ap(
				ys,
				_Utils_ap(
					_List_fromArray(
						[x]),
					rs)));
	}
};
var $wernerdegroot$listzipper$List$Zipper$fromCons = F2(
	function (x, xs) {
		return A3($wernerdegroot$listzipper$List$Zipper$Zipper, _List_Nil, x, xs);
	});
var $wernerdegroot$listzipper$List$Zipper$next = function (_v0) {
	var ls = _v0.a;
	var x = _v0.b;
	var rs = _v0.c;
	if (!rs.b) {
		return $elm$core$Maybe$Nothing;
	} else {
		var y = rs.a;
		var ys = rs.b;
		return $elm$core$Maybe$Just(
			A3(
				$wernerdegroot$listzipper$List$Zipper$Zipper,
				A2($elm$core$List$cons, x, ls),
				y,
				ys));
	}
};
var $author$project$Data$Autocomplete$next = function (suggestions) {
	switch (suggestions.$) {
		case 3:
			return $author$project$Data$Autocomplete$Unknown;
		case 2:
			return $author$project$Data$Autocomplete$NothingToSuggest;
		case 0:
			var x = suggestions.a;
			var xs = suggestions.b;
			return $author$project$Data$Autocomplete$HasFocus(
				$wernerdegroot$listzipper$List$Zipper$first(
					A2($wernerdegroot$listzipper$List$Zipper$fromCons, x, xs)));
		default:
			var zipper = suggestions.a;
			var _v1 = $wernerdegroot$listzipper$List$Zipper$next(zipper);
			if (_v1.$ === 1) {
				return A2(
					$author$project$Data$Autocomplete$NoFocus,
					$wernerdegroot$listzipper$List$Zipper$current(
						$wernerdegroot$listzipper$List$Zipper$first(zipper)),
					$wernerdegroot$listzipper$List$Zipper$after(
						$wernerdegroot$listzipper$List$Zipper$first(zipper)));
			} else {
				var zipper_ = _v1.a;
				return $author$project$Data$Autocomplete$HasFocus(zipper_);
			}
	}
};
var $wernerdegroot$listzipper$List$Zipper$last = function (zipper) {
	var ls = zipper.a;
	var x = zipper.b;
	var rs = zipper.c;
	var _v0 = $elm$core$List$reverse(rs);
	if (!_v0.b) {
		return zipper;
	} else {
		var y = _v0.a;
		var ys = _v0.b;
		return A3(
			$wernerdegroot$listzipper$List$Zipper$Zipper,
			_Utils_ap(
				ys,
				_Utils_ap(
					_List_fromArray(
						[x]),
					ls)),
			y,
			_List_Nil);
	}
};
var $wernerdegroot$listzipper$List$Zipper$previous = function (_v0) {
	var ls = _v0.a;
	var x = _v0.b;
	var rs = _v0.c;
	if (!ls.b) {
		return $elm$core$Maybe$Nothing;
	} else {
		var y = ls.a;
		var ys = ls.b;
		return $elm$core$Maybe$Just(
			A3(
				$wernerdegroot$listzipper$List$Zipper$Zipper,
				ys,
				y,
				A2($elm$core$List$cons, x, rs)));
	}
};
var $author$project$Data$Autocomplete$previous = function (suggestions) {
	switch (suggestions.$) {
		case 3:
			return $author$project$Data$Autocomplete$Unknown;
		case 2:
			return $author$project$Data$Autocomplete$NothingToSuggest;
		case 0:
			var x = suggestions.a;
			var xs = suggestions.b;
			return $author$project$Data$Autocomplete$HasFocus(
				$wernerdegroot$listzipper$List$Zipper$last(
					A2($wernerdegroot$listzipper$List$Zipper$fromCons, x, xs)));
		default:
			var zipper = suggestions.a;
			var _v1 = $wernerdegroot$listzipper$List$Zipper$previous(zipper);
			if (_v1.$ === 1) {
				return A2(
					$author$project$Data$Autocomplete$NoFocus,
					$wernerdegroot$listzipper$List$Zipper$current(
						$wernerdegroot$listzipper$List$Zipper$first(zipper)),
					$wernerdegroot$listzipper$List$Zipper$after(
						$wernerdegroot$listzipper$List$Zipper$first(zipper)));
			} else {
				var zipper_ = _v1.a;
				return $author$project$Data$Autocomplete$HasFocus(zipper_);
			}
	}
};
var $author$project$View$Autocomplete$Http$navigationSubscriptions = function (autocomplete) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$author$project$Keyboard$matchKey,
				'ArrowUp',
				$author$project$View$Autocomplete$Http$SetAutocomplete(
					$author$project$Data$Autocomplete$previous(autocomplete))),
				A2(
				$author$project$Keyboard$matchKey,
				'ArrowDown',
				$author$project$View$Autocomplete$Http$SetAutocomplete(
					$author$project$Data$Autocomplete$next(autocomplete))),
				A2(
				$author$project$Keyboard$matchKey,
				'Escape',
				$author$project$View$Autocomplete$Http$SetAutocomplete($author$project$Data$Autocomplete$unknown))
			]));
};
var $elm$browser$Browser$Events$onKeyDown = A2($elm$browser$Browser$Events$on, 0, 'keydown');
var $author$project$View$Autocomplete$Http$subscriptions = F2(
	function (config, _v0) {
		var state = _v0;
		var _v1 = state.y;
		switch (_v1.$) {
			case 3:
				return $elm$core$Platform$Sub$none;
			case 2:
				return $elm$core$Platform$Sub$batch(
					_List_fromArray(
						[
							$author$project$View$Autocomplete$Http$clickOutSideSubscription(config),
							A2(
							$elm$core$Platform$Sub$map,
							config.aut,
							$elm$browser$Browser$Events$onKeyDown(
								A2(
									$author$project$Keyboard$matchKey,
									'Escape',
									$author$project$View$Autocomplete$Http$SetAutocomplete($author$project$Data$Autocomplete$unknown))))
						]));
			case 0:
				return $elm$core$Platform$Sub$batch(
					_List_fromArray(
						[
							$author$project$View$Autocomplete$Http$clickOutSideSubscription(config),
							A2(
							$elm$core$Platform$Sub$map,
							config.aut,
							$elm$browser$Browser$Events$onKeyDown(
								$author$project$View$Autocomplete$Http$navigationSubscriptions(state.y)))
						]));
			default:
				var autocomplete = _v1.a;
				return $elm$browser$Browser$Events$onKeyDown(
					$elm$json$Json$Decode$oneOf(
						_List_fromArray(
							[
								function () {
								var _v2 = _Utils_Tuple2(
									$wernerdegroot$listzipper$List$Zipper$current(autocomplete),
									config.avO);
								if (!_v2.a.$) {
									if (_v2.b.$ === 1) {
										var suggestion = _v2.a.a;
										var btn = _v2.b.a;
										return $elm$json$Json$Decode$oneOf(
											_List_fromArray(
												[
													A2(
													$author$project$Keyboard$matchKey,
													'Enter',
													btn.avN(suggestion)),
													A2(
													$author$project$Keyboard$matchKey,
													'Tab',
													btn.avN(suggestion))
												]));
									} else {
										var suggestion = _v2.a.a;
										return A2(
											$elm$json$Json$Decode$map,
											config.aut,
											A2(
												$author$project$Keyboard$matchKey,
												'Tab',
												A2(
													$author$project$View$Autocomplete$Http$SetInputFromAutocomplete,
													config.dE,
													config.am1(suggestion))));
									}
								} else {
									return $elm$json$Json$Decode$fail('');
								}
							}(),
								A2(
								$elm$json$Json$Decode$map,
								config.aut,
								$author$project$View$Autocomplete$Http$navigationSubscriptions(state.y))
							])));
		}
	});
var $author$project$View$FilterOptionSuggestions$subscriptions = F2(
	function (lift, model) {
		return A2(
			$elm$core$Platform$Sub$map,
			lift,
			$elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$author$project$View$Autocomplete$Http$subscriptions,
						$author$project$View$FilterOptionSuggestions$filterSearchConfig(model),
						model.a7)
					])));
	});
var $author$project$VacancyFilterOptionSearch$subscriptions = function (model) {
	return A2($author$project$View$FilterOptionSuggestions$subscriptions, $elm$core$Basics$identity, model.b8);
};
var $author$project$View$Autocomplete$Http$currentlyFocussedValue = function (_v0) {
	var state = _v0;
	var _v1 = state.y;
	if (_v1.$ === 1) {
		var suggestions = _v1.a;
		var _v2 = $wernerdegroot$listzipper$List$Zipper$current(suggestions);
		if (!_v2.$) {
			var suggestion = _v2.a;
			return $elm$core$Maybe$Just(suggestion);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$browser$Browser$Navigation$load = _Browser_load;
var $author$project$View$Autocomplete$Http$GotSuggestions = function (a) {
	return {$: 4, a: a};
};
var $author$project$View$Autocomplete$Http$NoOp = {$: 0};
var $author$project$View$Autocomplete$Http$RequestSuggestions = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$View$Autocomplete$Http$Suggestion = function (a) {
	return {$: 0, a: a};
};
var $author$project$View$Autocomplete$Http$TotalSuggestions = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Task$onError = _Scheduler_onError;
var $elm$core$Task$attempt = F2(
	function (resultToMessage, task) {
		return $elm$core$Task$command(
			A2(
				$elm$core$Task$onError,
				A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
					$elm$core$Result$Err),
				A2(
					$elm$core$Task$andThen,
					A2(
						$elm$core$Basics$composeL,
						A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
						$elm$core$Result$Ok),
					task)));
	});
var $author$project$Data$Autocomplete$blur = function (suggestions) {
	switch (suggestions.$) {
		case 3:
			return $author$project$Data$Autocomplete$Unknown;
		case 2:
			return $author$project$Data$Autocomplete$NothingToSuggest;
		case 0:
			var x = suggestions.a;
			var xs = suggestions.b;
			return A2($author$project$Data$Autocomplete$NoFocus, x, xs);
		default:
			var zipper = suggestions.a;
			return A2(
				$author$project$Data$Autocomplete$NoFocus,
				$wernerdegroot$listzipper$List$Zipper$current(
					$wernerdegroot$listzipper$List$Zipper$first(zipper)),
				$wernerdegroot$listzipper$List$Zipper$after(
					$wernerdegroot$listzipper$List$Zipper$first(zipper)));
	}
};
var $elm$browser$Browser$Dom$focus = _Browser_call('focus');
var $author$project$Data$Autocomplete$noFocus = $author$project$Data$Autocomplete$NoFocus;
var $author$project$Data$Autocomplete$nothingToSuggest = $author$project$Data$Autocomplete$NothingToSuggest;
var $author$project$Data$Autocomplete$fromList = function (xs) {
	if (xs.b) {
		var y = xs.a;
		var ys = xs.b;
		return A2($author$project$Data$Autocomplete$noFocus, y, ys);
	} else {
		return $author$project$Data$Autocomplete$nothingToSuggest;
	}
};
var $elm$core$Maybe$andThen = F2(
	function (callback, maybeValue) {
		if (!maybeValue.$) {
			var value = maybeValue.a;
			return callback(value);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $elm$core$Bitwise$and = _Bitwise_and;
var $elm$core$Bitwise$shiftRightZfBy = _Bitwise_shiftRightZfBy;
var $elm$core$Array$bitMask = 4294967295 >>> (32 - $elm$core$Array$shiftStep);
var $elm$core$Elm$JsArray$unsafeGet = _JsArray_unsafeGet;
var $elm$core$Array$getHelp = F3(
	function (shift, index, tree) {
		getHelp:
		while (true) {
			var pos = $elm$core$Array$bitMask & (index >>> shift);
			var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
			if (!_v0.$) {
				var subTree = _v0.a;
				var $temp$shift = shift - $elm$core$Array$shiftStep,
					$temp$index = index,
					$temp$tree = subTree;
				shift = $temp$shift;
				index = $temp$index;
				tree = $temp$tree;
				continue getHelp;
			} else {
				var values = _v0.a;
				return A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, values);
			}
		}
	});
var $elm$core$Bitwise$shiftLeftBy = _Bitwise_shiftLeftBy;
var $elm$core$Array$tailIndex = function (len) {
	return (len >>> 5) << 5;
};
var $elm$core$Array$get = F2(
	function (index, _v0) {
		var len = _v0.a;
		var startShift = _v0.b;
		var tree = _v0.c;
		var tail = _v0.d;
		return ((index < 0) || (_Utils_cmp(index, len) > -1)) ? $elm$core$Maybe$Nothing : ((_Utils_cmp(
			index,
			$elm$core$Array$tailIndex(len)) > -1) ? $elm$core$Maybe$Just(
			A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, tail)) : $elm$core$Maybe$Just(
			A3($elm$core$Array$getHelp, startShift, index, tree)));
	});
var $lukewestby$elm_string_interpolate$String$Interpolate$applyInterpolation = F2(
	function (replacements, _v0) {
		var match = _v0.auE;
		var ordinalString = A2(
			$elm$core$Basics$composeL,
			$elm$core$String$dropLeft(1),
			$elm$core$String$dropRight(1))(match);
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$andThen,
				function (value) {
					return A2($elm$core$Array$get, value, replacements);
				},
				$elm$core$String$toInt(ordinalString)));
	});
var $elm$core$Array$fromListHelp = F3(
	function (list, nodeList, nodeListSize) {
		fromListHelp:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, list);
			var jsArray = _v0.a;
			var remainingItems = _v0.b;
			if (_Utils_cmp(
				$elm$core$Elm$JsArray$length(jsArray),
				$elm$core$Array$branchFactor) < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					true,
					{E: nodeList, v: nodeListSize, A: jsArray});
			} else {
				var $temp$list = remainingItems,
					$temp$nodeList = A2(
					$elm$core$List$cons,
					$elm$core$Array$Leaf(jsArray),
					nodeList),
					$temp$nodeListSize = nodeListSize + 1;
				list = $temp$list;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue fromListHelp;
			}
		}
	});
var $elm$core$Array$fromList = function (list) {
	if (!list.b) {
		return $elm$core$Array$empty;
	} else {
		return A3($elm$core$Array$fromListHelp, list, _List_Nil, 0);
	}
};
var $elm$regex$Regex$Match = F4(
	function (match, index, number, submatches) {
		return {NR: index, auE: match, au1: number, akt: submatches};
	});
var $elm$regex$Regex$fromStringWith = _Regex_fromStringWith;
var $elm$regex$Regex$fromString = function (string) {
	return A2(
		$elm$regex$Regex$fromStringWith,
		{atd: false, auL: false},
		string);
};
var $elm$regex$Regex$never = _Regex_never;
var $lukewestby$elm_string_interpolate$String$Interpolate$interpolationRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('\\{\\d+\\}'));
var $elm$regex$Regex$replace = _Regex_replaceAtMost(_Regex_infinity);
var $lukewestby$elm_string_interpolate$String$Interpolate$interpolate = F2(
	function (string, args) {
		var asArray = $elm$core$Array$fromList(args);
		return A3(
			$elm$regex$Regex$replace,
			$lukewestby$elm_string_interpolate$String$Interpolate$interpolationRegex,
			$lukewestby$elm_string_interpolate$String$Interpolate$applyInterpolation(asArray),
			string);
	});
var $elm$core$Maybe$map2 = F3(
	function (func, ma, mb) {
		if (ma.$ === 1) {
			return $elm$core$Maybe$Nothing;
		} else {
			var a = ma.a;
			if (mb.$ === 1) {
				return $elm$core$Maybe$Nothing;
			} else {
				var b = mb.a;
				return $elm$core$Maybe$Just(
					A2(func, a, b));
			}
		}
	});
var $elm$core$Tuple$mapSecond = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			x,
			func(y));
	});
var $author$project$Data$Key$nextKey = function (_v0) {
	var k = _v0;
	return k + 1;
};
var $abymosa$elm_debounce$Debounce$EmitIfSettled = function (a) {
	return {$: 0, a: a};
};
var $abymosa$elm_debounce$Debounce$addToQueue = F2(
	function (msg, _v0) {
		var options = _v0;
		var queue = options.bj;
		return _Utils_update(
			options,
			{
				bj: A2($elm$core$List$cons, msg, queue)
			});
	});
var $elm$core$Process$sleep = _Process_sleep;
var $abymosa$elm_debounce$Utils$Cmd$emitAfter = F2(
	function (delay, msg) {
		return A2(
			$elm$core$Task$perform,
			$elm$core$Basics$always(msg),
			$elm$core$Process$sleep(delay));
	});
var $abymosa$elm_debounce$Debounce$push = F2(
	function (msg, debounce) {
		var cooldown = debounce.eO;
		var queue = debounce.bj;
		var tagger = debounce.es;
		return _Utils_Tuple2(
			A2($abymosa$elm_debounce$Debounce$addToQueue, msg, debounce),
			A2(
				$abymosa$elm_debounce$Utils$Cmd$emitAfter,
				cooldown,
				tagger(
					$abymosa$elm_debounce$Debounce$EmitIfSettled(
						$elm$core$List$length(queue) + 1))));
	});
var $abymosa$elm_debounce$Utils$Cmd$emit = function (msg) {
	return A2(
		$elm$core$Task$perform,
		$elm$core$Basics$identity,
		$elm$core$Task$succeed(msg));
};
var $elm$core$List$head = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(x);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $abymosa$elm_debounce$Debounce$resetQueue = function (_v0) {
	var options = _v0;
	return _Utils_update(
		options,
		{bj: _List_Nil});
};
var $abymosa$elm_debounce$Debounce$update = F2(
	function (internalMsg, debounce) {
		var cooldown = debounce.eO;
		var queue = debounce.bj;
		var tagger = debounce.es;
		if (!internalMsg.$) {
			var msgCount = internalMsg.a;
			return _Utils_eq(
				$elm$core$List$length(queue),
				msgCount) ? _Utils_Tuple2(
				$abymosa$elm_debounce$Debounce$resetQueue(debounce),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					A2(
						$elm$core$Maybe$map,
						$abymosa$elm_debounce$Utils$Cmd$emit,
						$elm$core$List$head(queue)))) : _Utils_Tuple2(debounce, $elm$core$Platform$Cmd$none);
		} else {
			var msg = internalMsg.a;
			return _Utils_Tuple2(
				A2($abymosa$elm_debounce$Debounce$addToQueue, msg, debounce),
				A2(
					$abymosa$elm_debounce$Utils$Cmd$emitAfter,
					cooldown,
					tagger(
						$abymosa$elm_debounce$Debounce$EmitIfSettled(
							$elm$core$List$length(queue) + 1))));
		}
	});
var $author$project$View$Autocomplete$Http$update = F4(
	function (lift, config, msg, state_) {
		var state = state_;
		return A2(
			$elm$core$Tuple$mapSecond,
			$elm$core$Platform$Cmd$map(lift),
			function () {
				switch (msg.$) {
					case 0:
						return _Utils_Tuple2(state_, $elm$core$Platform$Cmd$none);
					case 6:
						return _Utils_Tuple2(
							_Utils_update(
								state,
								{y: $author$project$Data$Autocomplete$unknown}),
							$elm$core$Platform$Cmd$none);
					case 2:
						var id = msg.a;
						var suggestion = msg.b;
						return _Utils_Tuple2(
							_Utils_update(
								state,
								{y: $author$project$Data$Autocomplete$unknown, ak: suggestion}),
							A2(
								$elm$core$Task$attempt,
								function (_v1) {
									return $author$project$View$Autocomplete$Http$NoOp;
								},
								$elm$browser$Browser$Dom$focus(
									A2(
										$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
										'form-input-{0}',
										_List_fromArray(
											[id])))));
					case 1:
						if (msg.a === '') {
							var val = msg.a;
							return _Utils_Tuple2(
								_Utils_update(
									state,
									{
										y: $author$project$Data$Autocomplete$unknown,
										ak: val,
										P2: $author$project$Data$Key$nextKey(state.P2)
									}),
								$elm$core$Platform$Cmd$none);
						} else {
							var val = msg.a;
							var nextKey = $author$project$Data$Key$nextKey(state.P2);
							var autocomplete = ($elm$core$String$length(val) >= 3) ? $author$project$Data$Autocomplete$blur(state.y) : $author$project$Data$Autocomplete$unknown;
							var _v2 = ($elm$core$String$length(val) >= 3) ? A2(
								$abymosa$elm_debounce$Debounce$push,
								A2($author$project$View$Autocomplete$Http$RequestSuggestions, nextKey, val),
								state.a4) : _Utils_Tuple2(state.a4, $elm$core$Platform$Cmd$none);
							var newDebouncer = _v2.a;
							var pushCmd = _v2.b;
							return _Utils_Tuple2(
								{y: autocomplete, a4: newDebouncer, ak: val, P2: nextKey},
								pushCmd);
						}
					case 3:
						var key = msg.a;
						var val = msg.b;
						return _Utils_eq(key, state.P2) ? _Utils_Tuple2(
							state_,
							A2(
								$elm$core$Platform$Cmd$map,
								$author$project$View$Autocomplete$Http$GotSuggestions,
								config.ac8(val))) : _Utils_Tuple2(state_, $elm$core$Platform$Cmd$none);
					case 4:
						if (!msg.a.$) {
							var _v3 = msg.a.a;
							var suggestions = _v3.a;
							var maybeTotal = _v3.b;
							var totalToHref = function () {
								var _v6 = config.avO;
								if (!_v6.$) {
									var x = _v6.a;
									return A2(
										$elm$core$Maybe$map,
										$elm$core$Basics$always(0),
										x.anl);
								} else {
									var x = _v6.a;
									return A2(
										$elm$core$Maybe$map,
										$elm$core$Basics$always(0),
										x.av2);
								}
							}();
							var total = function () {
								var _v4 = A3($elm$core$Maybe$map2, $elm$core$Tuple$pair, maybeTotal, totalToHref);
								if (_v4.$ === 1) {
									return _List_Nil;
								} else {
									var _v5 = _v4.a;
									var n = _v5.a;
									return (n > 5) ? _List_fromArray(
										[
											$author$project$View$Autocomplete$Http$TotalSuggestions(n)
										]) : _List_Nil;
								}
							}();
							return _Utils_Tuple2(
								_Utils_update(
									state,
									{
										y: $author$project$Data$Autocomplete$fromList(
											_Utils_ap(
												A2($elm$core$List$map, $author$project$View$Autocomplete$Http$Suggestion, suggestions),
												total))
									}),
								$elm$core$Platform$Cmd$none);
						} else {
							return _Utils_Tuple2(state, $elm$core$Platform$Cmd$none);
						}
					case 5:
						var autocomplete = msg.a;
						return _Utils_Tuple2(
							_Utils_update(
								state,
								{y: autocomplete}),
							$elm$core$Platform$Cmd$none);
					default:
						var dm = msg.a;
						var _v7 = A2($abymosa$elm_debounce$Debounce$update, dm, state.a4);
						var newDebouncer = _v7.a;
						var debCmd = _v7.b;
						return _Utils_Tuple2(
							_Utils_update(
								state,
								{a4: newDebouncer}),
							debCmd);
				}
			}());
	});
var $author$project$View$FilterOptionSuggestions$update = F2(
	function (msg, model) {
		if (!msg.$) {
			return _Utils_Tuple2(
				model,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeL,
							A2(
								$elm$core$Basics$composeL,
								$elm$browser$Browser$Navigation$load,
								$author$project$View$FilterOptionSuggestions$toUrl(model.Rs)),
							function ($) {
								return $.YN;
							}),
						$author$project$View$Autocomplete$Http$currentlyFocussedValue(model.a7))));
		} else {
			var autoMsg = msg.a;
			var _v1 = A4(
				$author$project$View$Autocomplete$Http$update,
				$author$project$View$FilterOptionSuggestions$FilterOptionAutocompleteMsg,
				$author$project$View$FilterOptionSuggestions$filterSearchConfig(model),
				autoMsg,
				model.a7);
			var autocompleteState = _v1.a;
			var autocompleteCmds = _v1.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{a7: autocompleteState}),
				autocompleteCmds);
		}
	});
var $author$project$VacancyFilterOptionSearch$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A2($author$project$View$FilterOptionSuggestions$update, subMsg, model.b8);
		var model_ = _v1.a;
		var cmd = _v1.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{b8: model_}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, cmd));
	});
var $elm$json$Json$Decode$value = _Json_decodeValue;
var $elm$virtual_dom$VirtualDom$map = _VirtualDom_map;
var $elm$html$Html$map = $elm$virtual_dom$VirtualDom$map;
var $elm$json$Json$Encode$string = _Json_wrap;
var $elm$html$Html$Attributes$stringProperty = F2(
	function (key, string) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$string(string));
	});
var $elm$html$Html$Attributes$class = $elm$html$Html$Attributes$stringProperty('className');
var $author$project$View$FilterOptionSuggestions$OnSubmit = {$: 0};
var $elm$virtual_dom$VirtualDom$Custom = function (a) {
	return {$: 3, a: a};
};
var $elm$virtual_dom$VirtualDom$on = _VirtualDom_on;
var $elm$html$Html$Events$custom = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$Custom(decoder));
	});
var $elm$html$Html$form = _VirtualDom_node('form');
var $author$project$View$Autocomplete$Http$OnInput = function (a) {
	return {$: 1, a: a};
};
var $elm$html$Html$Attributes$autocomplete = function (bool) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'autocomplete',
		bool ? 'on' : 'off');
};
var $elm$html$Html$Attributes$id = $elm$html$Html$Attributes$stringProperty('id');
var $elm$html$Html$input = _VirtualDom_node('input');
var $elm$html$Html$Attributes$name = $elm$html$Html$Attributes$stringProperty('name');
var $elm$html$Html$Events$alwaysStop = function (x) {
	return _Utils_Tuple2(x, true);
};
var $elm$virtual_dom$VirtualDom$MayStopPropagation = function (a) {
	return {$: 1, a: a};
};
var $elm$html$Html$Events$stopPropagationOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayStopPropagation(decoder));
	});
var $elm$json$Json$Decode$at = F2(
	function (fields, decoder) {
		return A3($elm$core$List$foldr, $elm$json$Json$Decode$field, decoder, fields);
	});
var $elm$html$Html$Events$targetValue = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'value']),
	$elm$json$Json$Decode$string);
var $elm$html$Html$Events$onInput = function (tagger) {
	return A2(
		$elm$html$Html$Events$stopPropagationOn,
		'input',
		A2(
			$elm$json$Json$Decode$map,
			$elm$html$Html$Events$alwaysStop,
			A2($elm$json$Json$Decode$map, tagger, $elm$html$Html$Events$targetValue)));
};
var $elm$html$Html$Attributes$placeholder = $elm$html$Html$Attributes$stringProperty('placeholder');
var $elm$core$List$singleton = function (value) {
	return _List_fromArray(
		[value]);
};
var $elm$html$Html$Attributes$tabindex = function (n) {
	return A2(
		_VirtualDom_attribute,
		'tabIndex',
		$elm$core$String$fromInt(n));
};
var $elm$html$Html$Attributes$type_ = $elm$html$Html$Attributes$stringProperty('type');
var $elm$html$Html$Attributes$value = $elm$html$Html$Attributes$stringProperty('value');
var $wernerdegroot$listzipper$List$Zipper$before = function (_v0) {
	var ls = _v0.a;
	return $elm$core$List$reverse(ls);
};
var $elm$html$Html$img = _VirtualDom_node('img');
var $elm$html$Html$li = _VirtualDom_node('li');
var $elm$html$Html$Attributes$src = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'src',
		_VirtualDom_noJavaScriptOrHtmlUri(url));
};
var $elm$html$Html$ul = _VirtualDom_node('ul');
var $author$project$Util$View$viewMaybe = F2(
	function (maybe, html) {
		if (!maybe.$) {
			var a = maybe.a;
			return html(a);
		} else {
			return $elm$html$Html$text('');
		}
	});
var $elm$html$Html$a = _VirtualDom_node('a');
var $elm$core$List$filter = F2(
	function (isGood, list) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, xs) {
					return isGood(x) ? A2($elm$core$List$cons, x, xs) : xs;
				}),
			_List_Nil,
			list);
	});
var $elm$core$Tuple$second = function (_v0) {
	var y = _v0.b;
	return y;
};
var $elm$html$Html$Attributes$classList = function (classes) {
	return $elm$html$Html$Attributes$class(
		A2(
			$elm$core$String$join,
			' ',
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$first,
				A2($elm$core$List$filter, $elm$core$Tuple$second, classes))));
};
var $wernerdegroot$listzipper$List$Zipper$find = F2(
	function (predicate, zipper) {
		find:
		while (true) {
			var ls = zipper.a;
			var x = zipper.b;
			var rs = zipper.c;
			if (predicate(x)) {
				return $elm$core$Maybe$Just(zipper);
			} else {
				var _v0 = $wernerdegroot$listzipper$List$Zipper$next(zipper);
				if (!_v0.$) {
					var nextZipper = _v0.a;
					var $temp$predicate = predicate,
						$temp$zipper = nextZipper;
					predicate = $temp$predicate;
					zipper = $temp$zipper;
					continue find;
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		}
	});
var $wernerdegroot$listzipper$List$Zipper$findFirst = function (predicate) {
	return A2(
		$elm$core$Basics$composeL,
		$wernerdegroot$listzipper$List$Zipper$find(predicate),
		$wernerdegroot$listzipper$List$Zipper$first);
};
var $author$project$Data$Autocomplete$focus = F2(
	function (val, suggestions) {
		switch (suggestions.$) {
			case 3:
				return $author$project$Data$Autocomplete$Unknown;
			case 2:
				return $author$project$Data$Autocomplete$NothingToSuggest;
			case 0:
				var x = suggestions.a;
				var xs = suggestions.b;
				var _v1 = A2(
					$wernerdegroot$listzipper$List$Zipper$findFirst,
					$elm$core$Basics$eq(val),
					A2($wernerdegroot$listzipper$List$Zipper$fromCons, x, xs));
				if (_v1.$ === 1) {
					return suggestions;
				} else {
					var zipper_ = _v1.a;
					return $author$project$Data$Autocomplete$HasFocus(zipper_);
				}
			default:
				var zipper = suggestions.a;
				var _v2 = A2(
					$wernerdegroot$listzipper$List$Zipper$findFirst,
					$elm$core$Basics$eq(val),
					zipper);
				if (_v2.$ === 1) {
					return suggestions;
				} else {
					var zipper_ = _v2.a;
					return $author$project$Data$Autocomplete$HasFocus(zipper_);
				}
		}
	});
var $elm$html$Html$Attributes$href = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'href',
		_VirtualDom_noJavaScriptUri(url));
};
var $elm$virtual_dom$VirtualDom$Normal = function (a) {
	return {$: 0, a: a};
};
var $elm$html$Html$Events$on = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$Normal(decoder));
	});
var $elm$html$Html$Events$onClick = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'click',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$html$Html$Events$onMouseOut = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'mouseout',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$html$Html$Events$onMouseOver = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'mouseover',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$View$Autocomplete$Http$viewSuggestion = F6(
	function (config, inputValue, suggestions, extraClass, suggestionOrTotal, tIndex) {
		var focus = A3(
			$elm$core$Basics$composeL,
			config.aut,
			$author$project$View$Autocomplete$Http$SetAutocomplete,
			A2($author$project$Data$Autocomplete$focus, suggestionOrTotal, suggestions));
		var blur = A3(
			$elm$core$Basics$composeL,
			config.aut,
			$author$project$View$Autocomplete$Http$SetAutocomplete,
			$author$project$Data$Autocomplete$blur(suggestions));
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Events$onMouseOver(focus),
					$elm$html$Html$Events$onMouseOut(blur)
				]),
			function () {
				if (!suggestionOrTotal.$) {
					var suggestion = suggestionOrTotal.a;
					var _v1 = config.avO;
					if (!_v1.$) {
						var link = _v1.a;
						return _List_fromArray(
							[
								A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$href(
										link.avM(suggestion)),
										$elm$html$Html$Attributes$tabindex(tIndex),
										$elm$html$Html$Attributes$class('search-suggestion ' + extraClass)
									]),
								_List_fromArray(
									[
										config.cO(suggestion)
									]))
							]);
					} else {
						var btn = _v1.a;
						return _List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Events$onClick(
										btn.avN(suggestion)),
										$elm$html$Html$Attributes$tabindex(tIndex),
										$elm$html$Html$Attributes$class('search-suggestion ' + extraClass)
									]),
								_List_fromArray(
									[
										config.cO(suggestion)
									]))
							]);
					}
				} else {
					var total = suggestionOrTotal.a;
					var _v2 = config.avO;
					if (!_v2.$) {
						var link = _v2.a;
						var _v3 = link.anl;
						if (_v3.$ === 1) {
							return _List_Nil;
						} else {
							var f = _v3.a;
							return _List_fromArray(
								[
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$href(
											A2(f, total, inputValue).adz),
											$elm$html$Html$Attributes$tabindex(tIndex),
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('search-suggestion', true),
													_Utils_Tuple2(extraClass, true),
													_Utils_Tuple2(
													A2($elm$core$Maybe$withDefault, '', config.fW),
													true)
												]))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2(f, total, inputValue).avV)
										]))
								]);
						}
					} else {
						var btn = _v2.a;
						var _v4 = btn.av2;
						if (_v4.$ === 1) {
							return _List_Nil;
						} else {
							var f = _v4.a;
							return _List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Events$onClick(
											A2(f, total, inputValue).avZ),
											$elm$html$Html$Attributes$tabindex(tIndex),
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('search-suggestion', true),
													_Utils_Tuple2(extraClass, true),
													_Utils_Tuple2(
													A2($elm$core$Maybe$withDefault, '', config.fW),
													true)
												]))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2(f, total, inputValue).avV)
										]))
								]);
						}
					}
				}
			}());
	});
var $author$project$View$Autocomplete$Http$viewAutocomplete = F3(
	function (inputValue, suggestions, config) {
		var minIndex = 1 + A2($elm$core$Maybe$withDefault, 0, config.avS);
		var viewSuggestion_ = F3(
			function (extraClass, tabIndex, suggestion) {
				return A6($author$project$View$Autocomplete$Http$viewSuggestion, config, inputValue, suggestions, extraClass, suggestion, minIndex + tabIndex);
			});
		switch (suggestions.$) {
			case 3:
				return $elm$html$Html$text('');
			case 2:
				return A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('search-suggestions')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('search-suggestion')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(config.WC)
								]))
						]));
			case 0:
				var hd = suggestions.a;
				var tail = suggestions.b;
				return A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('search-suggestions')
						]),
					$elm$core$List$concat(
						_List_fromArray(
							[
								A2(
								$elm$core$List$indexedMap,
								viewSuggestion_(''),
								A2($elm$core$List$cons, hd, tail)),
								_List_fromArray(
								[
									A2(
									$author$project$Util$View$viewMaybe,
									config.eI,
									function (url) {
										return A2(
											$elm$html$Html$img,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$src(url)
												]),
											_List_Nil);
									})
								])
							])));
			default:
				var suggestions_ = suggestions.a;
				var tabIndexBefore = $elm$core$List$length(
					$wernerdegroot$listzipper$List$Zipper$before(suggestions_)) + 1;
				return A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('search-suggestions')
						]),
					$elm$core$List$concat(
						_List_fromArray(
							[
								A2(
								$elm$core$List$indexedMap,
								viewSuggestion_(''),
								$wernerdegroot$listzipper$List$Zipper$before(suggestions_)),
								_List_fromArray(
								[
									A3(
									viewSuggestion_,
									'-current',
									tabIndexBefore,
									$wernerdegroot$listzipper$List$Zipper$current(suggestions_))
								]),
								A2(
								$elm$core$List$indexedMap,
								F2(
									function (i, v) {
										return A3(viewSuggestion_, '', tabIndexBefore + i, v);
									}),
								$wernerdegroot$listzipper$List$Zipper$after(suggestions_)),
								_List_fromArray(
								[
									A2(
									$author$project$Util$View$viewMaybe,
									config.eI,
									function (url) {
										return A2(
											$elm$html$Html$img,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$src(url)
												]),
											_List_Nil);
									})
								])
							])));
		}
	});
var $author$project$View$Autocomplete$Http$view = F2(
	function (config, _v0) {
		var state = _v0;
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				config.aut,
				A2(
					$elm$html$Html$input,
					_Utils_ap(
						_List_fromArray(
							[
								$elm$html$Html$Attributes$name(config.dE),
								$elm$html$Html$Attributes$type_('text'),
								$elm$html$Html$Attributes$autocomplete(false),
								$elm$html$Html$Attributes$class('form-input'),
								$elm$html$Html$Attributes$id(
								A2(
									$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
									'form-input-{0}',
									_List_fromArray(
										[config.dE]))),
								$elm$html$Html$Attributes$placeholder(config.d5),
								$elm$html$Html$Attributes$value(state.ak),
								$elm$html$Html$Events$onInput($author$project$View$Autocomplete$Http$OnInput)
							]),
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								A2($elm$core$Basics$composeL, $elm$core$List$singleton, $elm$html$Html$Attributes$tabindex),
								config.avS))),
					_List_Nil)),
				A3($author$project$View$Autocomplete$Http$viewAutocomplete, state.ak, state.y, config)
			]);
	});
var $author$project$View$FilterOptionSuggestions$viewFilterSearch = function (model) {
	var msg = $elm$json$Json$Decode$succeed(
		{bT: $author$project$View$FilterOptionSuggestions$OnSubmit, avg: true, avG: true});
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$form,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('form-search'),
					A2($elm$html$Html$Events$custom, 'submit', msg)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('form-field')
						]),
					A2(
						$author$project$View$Autocomplete$Http$view,
						$author$project$View$FilterOptionSuggestions$filterSearchConfig(model),
						model.a7))
				]))
		]);
};
var $author$project$View$FilterOptionSuggestions$view = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('search-bar-content')
			]),
		$author$project$View$FilterOptionSuggestions$viewFilterSearch(model));
};
var $author$project$VacancyFilterOptionSearch$view = function (model) {
	return A2(
		$elm$html$Html$map,
		$elm$core$Basics$identity,
		$author$project$View$FilterOptionSuggestions$view(model.b8));
};
var $author$project$VacancyFilterOptionSearch$main = A2(
	$author$project$Browser$Custom$elementWithFlags,
	$author$project$Model$Component$Properties$VacancyFilterOptionSearch$Flags$flagsDecoder,
	{dH: $author$project$VacancyFilterOptionSearch$init, em: $author$project$VacancyFilterOptionSearch$subscriptions, ex: $author$project$VacancyFilterOptionSearch$update, ez: $author$project$VacancyFilterOptionSearch$view});
var $author$project$TravelTime$Flags = F7(
	function (id, domainId, windowWidth, latitude, longitude, sessionToken, csrfToken) {
		return {ci: csrfToken, dp: domainId, dE: id, QE: latitude, RZ: longitude, aW: sessionToken, cX: windowWidth};
	});
var $elm$json$Json$Decode$float = _Json_decodeFloat;
var $author$project$Browser$Dom$Breakpoint$WindowWidth = $elm$core$Basics$identity;
var $author$project$Browser$Dom$Breakpoint$windowWidthDecoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$float);
var $author$project$TravelTime$decodeFlags = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'csrfToken',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'sessionToken',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'longitude',
			$elm$json$Json$Decode$float,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'latitude',
				$elm$json$Json$Decode$float,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'windowWidth',
					$author$project$Browser$Dom$Breakpoint$windowWidthDecoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'domainId',
						$author$project$Data$Id$decoder,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'id',
							$elm$json$Json$Decode$string,
							$elm$json$Json$Decode$succeed($author$project$TravelTime$Flags))))))));
var $author$project$TravelTime$Car = 2;
var $author$project$TravelTime$Setup = {$: 0};
var $author$project$View$LocationSuggestions$State = $elm$core$Basics$identity;
var $author$project$View$LocationSuggestions$Unknown = {$: 0};
var $author$project$View$LocationSuggestions$init = {al: $author$project$View$Autocomplete$Http$init, a1: $author$project$View$LocationSuggestions$Unknown};
var $author$project$TravelTime$encodeDrivingMode = function (drivingMode) {
	return $elm$json$Json$Encode$string(
		function () {
			switch (drivingMode) {
				case 2:
					return 'DRIVING';
				case 0:
					return 'BICYCLING';
				case 1:
					return 'WALKING';
				default:
					return 'TRANSIT';
			}
		}());
};
var $elm$json$Json$Encode$float = _Json_wrap;
var $author$project$TravelTime$encodeEventAttributes = function (event) {
	if (event.$ === 1) {
		var config = event.a;
		return _List_fromArray(
			[
				_Utils_Tuple2(
				'drivingMode',
				$author$project$TravelTime$encodeDrivingMode(config.EC)),
				_Utils_Tuple2(
				'latitude',
				$elm$json$Json$Encode$float(config.Rs.QE)),
				_Utils_Tuple2(
				'longitude',
				$elm$json$Json$Encode$float(config.Rs.RZ))
			]);
	} else {
		return _List_Nil;
	}
};
var $author$project$TravelTime$eventToString = function (event) {
	if (!event.$) {
		return 'setup';
	} else {
		return 'distance';
	}
};
var $elm$json$Json$Encode$object = function (pairs) {
	return _Json_wrap(
		A3(
			$elm$core$List$foldl,
			F2(
				function (_v0, obj) {
					var k = _v0.a;
					var v = _v0.b;
					return A3(_Json_addField, k, v, obj);
				}),
			_Json_emptyObject(0),
			pairs));
};
var $author$project$TravelTime$encodeTravelTimeEvent = function (event) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$cons,
			_Utils_Tuple2(
				'kind',
				$elm$json$Json$Encode$string(
					$author$project$TravelTime$eventToString(event))),
			$author$project$TravelTime$encodeEventAttributes(event)));
};
var $author$project$TravelTime$travelTimeStream = _Platform_outgoingPort('travelTimeStream', $elm$core$Basics$identity);
var $author$project$TravelTime$pushTravelTimeEvent = function (event) {
	return $author$project$TravelTime$travelTimeStream(
		$author$project$TravelTime$encodeTravelTimeEvent(event));
};
var $author$project$TravelTime$init = function (flags) {
	return _Utils_Tuple2(
		{
			c8: $elm$core$Maybe$Nothing,
			ci: flags.ci,
			dp: flags.dp,
			EC: 2,
			dq: $elm$core$Maybe$Nothing,
			dE: flags.dE,
			az: $author$project$View$LocationSuggestions$init,
			aW: $elm$core$Maybe$Just(flags.aW),
			ajv: {QE: flags.QE, RZ: flags.RZ},
			cX: flags.cX
		},
		$author$project$TravelTime$pushTravelTimeEvent($author$project$TravelTime$Setup));
};
var $author$project$TravelTime$GotCsrfToken = function (a) {
	return {$: 4, a: a};
};
var $author$project$View$Autocomplete$Http$Button = function (a) {
	return {$: 1, a: a};
};
var $author$project$TravelTime$LocationSuggestionsMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$TravelTime$SetLocationSuggestion = function (a) {
	return {$: 1, a: a};
};
var $author$project$View$LocationSuggestions$TomTom = 1;
var $author$project$TravelTime$locationSuggestionsConfig = F3(
	function (domainId, sessionToken, csrfToken) {
		return {
			db: 'location-search-only',
			ci: csrfToken,
			dp: domainId,
			aul: $elm$core$Maybe$Nothing,
			aut: $author$project$TravelTime$LocationSuggestionsMsg,
			avy: 1,
			aW: sessionToken,
			avO: $author$project$View$Autocomplete$Http$Button(
				{avN: $author$project$TravelTime$SetLocationSuggestion, av2: $elm$core$Maybe$Nothing}),
			avS: $elm$core$Maybe$Nothing,
			fX: 'location-search-travel-time'
		};
	});
var $author$project$View$LocationSuggestions$GotVisitorCoordinates = function (a) {
	return {$: 2, a: a};
};
var $author$project$View$LocationSuggestions$gotVisitorCoordinates = _Platform_incomingPort('gotVisitorCoordinates', $elm$json$Json$Decode$value);
var $author$project$View$LocationSuggestions$LocationAutocompleteMsg = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$Header = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$http$Http$header = $elm$http$Http$Header;
var $author$project$Model$Suggestion$LocationSuggestion = F5(
	function (locationDescription, streetName, localName, latitude, longitude) {
		return {QE: latitude, Rr: localName, auy: locationDescription, RZ: longitude, akc: streetName};
	});
var $elm$json$Json$Decode$null = _Json_decodeNull;
var $elm$json$Json$Decode$nullable = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder)
			]));
};
var $author$project$Model$Suggestion$locationSuggestionDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'longitude',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$float),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'latitude',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$float),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'localName',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'streetName',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'locationDescription',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Model$Suggestion$LocationSuggestion))))));
var $author$project$View$LocationSuggestions$serviceParam = function (service) {
	return A2(
		$elm$url$Url$Builder$string,
		'service',
		function () {
			if (service === 1) {
				return 'tomtom';
			} else {
				return 'google';
			}
		}());
};
var $author$project$View$LocationSuggestions$requestLocationSuggestions = F6(
	function (domainId, service, trackingId, mSessionToken, csrfToken, keyword) {
		var defaultParams = _List_fromArray(
			[
				A2($elm$url$Url$Builder$string, 'keywords', keyword),
				$author$project$View$LocationSuggestions$serviceParam(service)
			]);
		var paramsWithSessionToken = A2(
			$elm$core$Maybe$withDefault,
			defaultParams,
			A2(
				$elm$core$Maybe$map,
				function (sessionToken) {
					return _Utils_ap(
						defaultParams,
						_List_fromArray(
							[
								A2($elm$url$Url$Builder$string, 'sessionToken', sessionToken)
							]));
				},
				mSessionToken));
		return $elm$http$Http$request(
			{
				_: $elm$http$Http$emptyBody,
				aH: A2(
					$elm$http$Http$expectJson,
					$elm$core$Basics$identity,
					A2(
						$elm$json$Json$Decode$map,
						function (suggestions) {
							return _Utils_Tuple2(suggestions, $elm$core$Maybe$Nothing);
						},
						$elm$json$Json$Decode$list($author$project$Model$Suggestion$locationSuggestionDecoder))),
				ax: _List_fromArray(
					[
						A2($elm$http$Http$header, 'X-XSRF-TOKEN', csrfToken)
					]),
				aO: 'GET',
				a_: $elm$core$Maybe$Nothing,
				av3: $elm$core$Maybe$Just(trackingId),
				a0: A2(
					$elm$url$Url$Builder$absolute,
					_List_fromArray(
						[
							'api',
							$author$project$Data$Id$toString(domainId),
							'suggestions',
							'locations'
						]),
					paramsWithSessionToken)
			});
	});
var $author$project$View$LocationSuggestions$locationSearchConfig = F2(
	function (config, _v0) {
		return {
			eI: function () {
				var _v1 = config.avy;
				if (_v1 === 1) {
					return $elm$core$Maybe$Nothing;
				} else {
					return $elm$core$Maybe$Just(
						A2(
							$elm$url$Url$Builder$absolute,
							_List_fromArray(
								['static', 'images', 'powered_by_google_on_white_hdpi.png']),
							_List_Nil));
				}
			}(),
			dE: 'location',
			aul: config.aul,
			aut: A2($elm$core$Basics$composeL, config.aut, $author$project$View$LocationSuggestions$LocationAutocompleteMsg),
			WC: $author$project$Copy$copy.V1,
			d5: $author$project$Copy$copy.aeH,
			ac8: A5($author$project$View$LocationSuggestions$requestLocationSuggestions, config.dp, config.avy, config.fX, config.aW, config.ci),
			avO: config.avO,
			avS: config.avS,
			am1: function ($) {
				return $.auy;
			},
			cO: A2(
				$elm$core$Basics$composeL,
				$elm$html$Html$text,
				function ($) {
					return $.auy;
				}),
			fW: $elm$core$Maybe$Just('all-vacancies'),
			fX: config.fX
		};
	});
var $author$project$View$LocationSuggestions$Known = function (a) {
	return {$: 4, a: a};
};
var $author$project$View$LocationSuggestions$VisitorRequestError = {$: 2};
var $elm$core$Result$withDefault = F2(
	function (def, result) {
		if (!result.$) {
			var a = result.a;
			return a;
		} else {
			return def;
		}
	});
var $author$project$View$LocationSuggestions$visitorCoordinates = function (value) {
	var decoder = A3(
		$elm$json$Json$Decode$map2,
		F2(
			function (lat, lng) {
				return $author$project$View$LocationSuggestions$Known(
					{fb: lat, fd: lng});
			}),
		A2($elm$json$Json$Decode$field, 'lat', $elm$json$Json$Decode$float),
		A2($elm$json$Json$Decode$field, 'lng', $elm$json$Json$Decode$float));
	return A2(
		$elm$core$Result$withDefault,
		$author$project$View$LocationSuggestions$VisitorRequestError,
		A2($elm$json$Json$Decode$decodeValue, decoder, value));
};
var $author$project$View$LocationSuggestions$subscriptions = F2(
	function (config, state) {
		var state_ = state;
		return $elm$core$Platform$Sub$batch(
			_List_fromArray(
				[
					A2(
					$author$project$View$Autocomplete$Http$subscriptions,
					A2($author$project$View$LocationSuggestions$locationSearchConfig, config, state),
					state_.al),
					A2(
					$elm$core$Platform$Sub$map,
					config.aut,
					$author$project$View$LocationSuggestions$gotVisitorCoordinates(
						A2($elm$core$Basics$composeL, $author$project$View$LocationSuggestions$GotVisitorCoordinates, $author$project$View$LocationSuggestions$visitorCoordinates)))
				]));
	});
var $author$project$TravelTime$updateTravelTimeCsrfToken = _Platform_incomingPort('updateTravelTimeCsrfToken', $elm$json$Json$Decode$string);
var $author$project$TravelTime$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$author$project$View$LocationSuggestions$subscriptions,
				A3($author$project$TravelTime$locationSuggestionsConfig, model.dp, model.aW, model.ci),
				model.az),
				$author$project$TravelTime$updateTravelTimeCsrfToken($author$project$TravelTime$GotCsrfToken)
			]));
};
var $author$project$TravelTime$CalculateDistance = function (a) {
	return {$: 1, a: a};
};
var $author$project$TravelTime$toCalcEvent = F2(
	function (drivingMode, latlong) {
		return $author$project$TravelTime$pushTravelTimeEvent(
			$author$project$TravelTime$CalculateDistance(
				{EC: drivingMode, Rs: latlong}));
	});
var $author$project$TravelTime$cmdCalcDistance = F2(
	function (drivingMode, latlong) {
		return A2(
			$elm$core$Maybe$withDefault,
			$elm$core$Platform$Cmd$none,
			A2(
				$elm$core$Maybe$map,
				$author$project$TravelTime$toCalcEvent(drivingMode),
				latlong));
	});
var $author$project$View$Autocomplete$Http$reset = function (_v0) {
	var state = _v0;
	return _Utils_update(
		state,
		{y: $author$project$Data$Autocomplete$unknown, P2: $author$project$Data$Key$newKey});
};
var $author$project$View$LocationSuggestions$reset = function (_v0) {
	var state = _v0;
	return _Utils_update(
		state,
		{
			al: $author$project$View$Autocomplete$Http$reset(state.al),
			a1: $author$project$View$LocationSuggestions$Unknown
		});
};
var $author$project$TravelTime$toLatLong = function (location) {
	return A3(
		$elm$core$Maybe$map2,
		F2(
			function (lat, _long) {
				return {QE: lat, RZ: _long};
			}),
		location.QE,
		location.RZ);
};
var $author$project$View$LocationSuggestions$Requested = {$: 1};
var $author$project$View$LocationSuggestions$ReverseGeocodingError = function (a) {
	return {$: 3, a: a};
};
var $author$project$View$Autocomplete$Http$fromList = function (xs) {
	return {
		y: $author$project$Data$Autocomplete$fromList(
			A2($elm$core$List$map, $author$project$View$Autocomplete$Http$Suggestion, xs)),
		a4: $author$project$View$Autocomplete$Http$initDebouncer,
		ak: '',
		P2: $author$project$Data$Key$newKey
	};
};
var $author$project$View$LocationSuggestions$GotReverseGeocoding = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$core$String$fromFloat = _String_fromNumber;
var $author$project$View$LocationSuggestions$requestReverseGeocoding = F4(
	function (domainId, service, csrfToken, coordinates) {
		return $elm$http$Http$request(
			{
				_: $elm$http$Http$emptyBody,
				aH: A2(
					$elm$http$Http$expectJson,
					$author$project$View$LocationSuggestions$GotReverseGeocoding(
						$author$project$View$LocationSuggestions$Known(coordinates)),
					$elm$json$Json$Decode$list($author$project$Model$Suggestion$locationSuggestionDecoder)),
				ax: _List_fromArray(
					[
						A2($elm$http$Http$header, 'X-XSRF-TOKEN', csrfToken)
					]),
				aO: 'GET',
				a_: $elm$core$Maybe$Nothing,
				av3: $elm$core$Maybe$Nothing,
				a0: A2(
					$elm$url$Url$Builder$absolute,
					_List_fromArray(
						[
							'api',
							$author$project$Data$Id$toString(domainId),
							'suggestions',
							'reverse-geocoding'
						]),
					_List_fromArray(
						[
							A2(
							$elm$url$Url$Builder$string,
							'lat',
							$elm$core$String$fromFloat(coordinates.fb)),
							A2(
							$elm$url$Url$Builder$string,
							'lng',
							$elm$core$String$fromFloat(coordinates.fd)),
							$author$project$View$LocationSuggestions$serviceParam(service)
						]))
			});
	});
var $elm$json$Json$Encode$null = _Json_encodeNull;
var $author$project$View$LocationSuggestions$requestVisitorCoordinates = _Platform_outgoingPort(
	'requestVisitorCoordinates',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$View$LocationSuggestions$setMinIndex = function (config) {
	return _Utils_update(
		config,
		{
			avS: A2(
				$elm$core$Maybe$map,
				$elm$core$Basics$add(1),
				config.avS)
		});
};
var $author$project$View$LocationSuggestions$update = F3(
	function (config, msg, state) {
		var state_ = state;
		switch (msg.$) {
			case 0:
				var msg_ = msg.a;
				var _v1 = A4(
					$author$project$View$Autocomplete$Http$update,
					A2($elm$core$Basics$composeL, config.aut, $author$project$View$LocationSuggestions$LocationAutocompleteMsg),
					A2(
						$author$project$View$LocationSuggestions$locationSearchConfig,
						$author$project$View$LocationSuggestions$setMinIndex(config),
						state),
					msg_,
					state_.al);
				var autocompleteState = _v1.a;
				var autocompleteCmds = _v1.b;
				return _Utils_Tuple2(
					_Utils_update(
						state_,
						{al: autocompleteState}),
					autocompleteCmds);
			case 1:
				return _Utils_Tuple2(
					_Utils_update(
						state_,
						{a1: $author$project$View$LocationSuggestions$Requested}),
					$author$project$View$LocationSuggestions$requestVisitorCoordinates(0));
			case 2:
				if (msg.a.$ === 4) {
					var coordinates = msg.a.a;
					return _Utils_Tuple2(
						state,
						A2(
							$elm$core$Platform$Cmd$map,
							config.aut,
							A4($author$project$View$LocationSuggestions$requestReverseGeocoding, config.dp, config.avy, config.ci, coordinates)));
				} else {
					var location = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							state_,
							{a1: location}),
						$elm$core$Platform$Cmd$none);
				}
			default:
				if (msg.b.$ === 1) {
					var err = msg.b.a;
					return _Utils_Tuple2(
						_Utils_update(
							state_,
							{
								a1: $author$project$View$LocationSuggestions$ReverseGeocodingError(err)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var visitorLocation = msg.a;
					var suggestions = msg.b.a;
					return _Utils_Tuple2(
						_Utils_update(
							state_,
							{
								al: $author$project$View$Autocomplete$Http$fromList(suggestions),
								a1: visitorLocation
							}),
						$elm$core$Platform$Cmd$none);
				}
		}
	});
var $author$project$TravelTime$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 3:
				var distance = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							c8: $elm$core$Maybe$Just(distance)
						}),
					$elm$core$Platform$Cmd$none);
			case 0:
				var mode = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{EC: mode}),
					A2($author$project$TravelTime$cmdCalcDistance, mode, model.dq));
			case 1:
				var location = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							dq: $author$project$TravelTime$toLatLong(location),
							az: $author$project$View$LocationSuggestions$reset(model.az)
						}),
					A2(
						$author$project$TravelTime$cmdCalcDistance,
						model.EC,
						$author$project$TravelTime$toLatLong(location)));
			case 2:
				var locationSuggestionsMsg = msg.a;
				var _v1 = A3(
					$author$project$View$LocationSuggestions$update,
					A3($author$project$TravelTime$locationSuggestionsConfig, model.dp, model.aW, model.ci),
					locationSuggestionsMsg,
					model.az);
				var locationSuggestionsModel = _v1.a;
				var locationSuggestionsCmds = _v1.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{az: locationSuggestionsModel}),
					locationSuggestionsCmds);
			default:
				var token = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{ci: token}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Data$Icon$Path = $elm$core$Basics$identity;
var $author$project$Data$Icon$path = {ga: '/static/icons/accordion.svg', gc: '/static/icons/accordion-group.svg', gl: '/static/icons/activate.svg', gt: '/static/icons/add.svg', asW: '/static/icons/address.svg', asX: '/static/icons/address-autofill.svg', i1: '/static/icons/align-center.svg', i4: '/static/icons/align-justify.svg', i5: '/static/icons/align-left.svg', i6: '/static/icons/align-right.svg', i7: '/static/icons/align-stretch.svg', js: '/static/icons/analytics.svg', jA: '/static/icons/anchor-link.svg', jH: '/static/icons/anonymize.svg', jN: '/static/icons/appetizer.svg', jU: '/static/icons/applicant-journey-group.svg', ks: '/static/icons/application-process.svg', kR: '/static/icons/archive.svg', kZ: '/static/icons/arrow-down.svg', k_: '/static/icons/arrow-down-light.svg', k$: '/static/icons/arrow-down-new.svg', k0: '/static/icons/arrow-down-openluchtmuseum.svg', k1: '/static/icons/arrow-down-solid.svg', k2: '/static/icons/arrow-left.svg', k3: '/static/icons/arrow-left-light.svg', k4: '/static/icons/arrow-left-new.svg', k5: '/static/icons/arrow-left-openluchtmuseum.svg', k6: '/static/icons/arrow-right.svg', k7: '/static/icons/arrow-right-light.svg', k8: '/static/icons/arrow-right-new.svg', k9: '/static/icons/arrow-right-openluchtmuseum.svg', la: '/static/icons/arrow-turn-left.svg', lb: '/static/icons/arrow-up.svg', lc: '/static/icons/arrow-up-light.svg', ld: '/static/icons/arrow-up-new.svg', le: '/static/icons/arrows-rotate.svg', lr: '/static/icons/assessment.svg', lC: '/static/icons/atom.svg', m8: '/static/icons/audio.svg', as3: '/static/icons/austria.svg', nk: '/static/icons/availability.svg', n0: '/static/icons/banner.svg', od: '/static/icons/banner-location-search.svg', oi: '/static/icons/banner-search.svg', oz: '/static/icons/banner-video.svg', oC: '/static/icons/banner-video-location-search.svg', oD: '/static/icons/banner-video-search.svg', as6: '/static/icons/belgium.svg', oO: '/static/icons/bg-size-auto.svg', oP: '/static/icons/bg-size-contain.svg', oQ: '/static/icons/bg-size-cover.svg', oR: '/static/icons/bg-size-custom.svg', oT: '/static/icons/bike.svg', as8: '/static/icons/birthday.svg', oZ: '/static/icons/bold.svg', pa: '/static/icons/breadcrumbs.svg', pq: '/static/icons/button.svg', pw: '/static/icons/calendar.svg', ata: '/static/icons/calendar-new.svg', pN: '/static/icons/car.svg', pO: '/static/icons/card.svg', pQ: '/static/icons/card-fold-out.svg', pR: '/static/icons/card-slider.svg', qi: '/static/icons/chat.svg', ql: '/static/icons/chat-outline.svg', ate: '/static/icons/checkmark.svg', eL: '/static/icons/checkmark-new.svg', qn: '/static/icons/chevron-down.svg', qo: '/static/icons/chevron-right.svg', qp: '/static/icons/chevron-up.svg', atg: '/static/icons/china.svg', qM: '/static/icons/city.svg', qW: '/static/icons/click-trough.svg', q$: '/static/icons/clock.svg', eN: '/static/icons/code.svg', sq: '/static/icons/consent.svg', sy: '/static/icons/contact.svg', sz: '/static/icons/contact-form.svg', sC: '/static/icons/contact-person.svg', sD: '/static/icons/contact-person-ats.svg', dg: '/static/icons/content.svg', sH: '/static/icons/content-slider.svg', sK: '/static/icons/contract-type.svg', wY: '/static/icons/copy.svg', w5: '/static/icons/country.svg', yf: '/static/icons/cv.svg', ym: '/static/icons/dashboard.svg', yy: '/static/icons/datepicker.svg', atC: '/static/icons/delete.svg', atD: '/static/icons/denmark.svg', zt: '/static/icons/department.svg', DP: '/static/icons/desktop.svg', D6: '/static/icons/discipline.svg', Ec: '/static/icons/distance.svg', Ei: '/static/icons/document.svg', Ej: '/static/icons/documents.svg', EP: '/static/icons/edit.svg', E$: '/static/icons/education.svg', E5: '/static/icons/ellipsis.svg', E6: '/static/icons/ellipsis-vertical.svg', eR: '/static/icons/email.svg', FJ: '/static/icons/employee-content.svg', F4: '/static/icons/end-date.svg', F5: '/static/icons/english.svg', Gv: '/static/icons/event-items.svg', GF: '/static/icons/events.svg', GL: '/static/icons/expand.svg', GO: '/static/icons/experience.svg', GR: '/static/icons/external.svg', G9: '/static/icons/facebook.svg', Hi: '/static/icons/favorites.svg', HC: '/static/icons/file.svg', HD: '/static/icons/file-audio.svg', HE: '/static/icons/file-browser.png', HF: '/static/icons/file-doc.svg', HG: '/static/icons/file-image.svg', HI: '/static/icons/file-pdf.svg', HL: '/static/icons/file-svg.svg', HO: '/static/icons/file-video.svg', HS: '/static/icons/filter.svg', atZ: '/static/icons/finland.svg', In: '/static/icons/first-live-interview.svg', Ip: '/static/icons/first-name.svg', IF: '/static/icons/form.svg', IG: '/static/icons/formBuilder.svg', Kz: '/static/icons/forms.svg', at6: '/static/icons/france.svg', Lf: '/static/icons/geo-map.svg', at8: '/static/icons/germany.svg', at9: '/static/icons/global.svg', Lo: '/static/icons/globe.svg', Mm: '/static/icons/heading.svg', Mp: '/static/icons/heart.svg', MP: '/static/icons/home.svg', M0: '/static/icons/house.svg', M1: '/static/icons/houseAutocomplete.svg', M2: '/static/icons/house-blank.png', e_: '/static/icons/html.svg', auh: '/static/icons/hungary.svg', Nu: '/static/icons/iframe.svg', Nw: '/static/icons/image.svg', auk: '/static/icons/info.svg', N1: '/static/icons/input-text.svg', N7: '/static/icons/instagram.svg', aum: '/static/icons/intro.svg', aup: '/static/icons/ireland.svg', O8: '/static/icons/italic.svg', Pk: '/static/icons/job-alert.svg', PU: '/static/icons/journey-slider.svg', PV: '/static/icons/journey-tabs.svg', PW: '/static/icons/journey-tabs-video.svg', P5: '/static/icons/keyword-search.svg', Qe: '/static/icons/kununu.svg', QG: '/static/icons/layout1.svg', QH: '/static/icons/layout2.svg', QI: '/static/icons/layout3.svg', QJ: '/static/icons/layout4.svg', QK: '/static/icons/layout5.svg', QL: '/static/icons/layout6.svg', QM: '/static/icons/layout7.svg', QN: '/static/icons/layout8.svg', Q0: '/static/icons/link.svg', Rj: '/static/icons/linkedin.svg', Rk: '/static/icons/linkedin-outline.svg', auv: '/static/icons/linkedin-url.svg', Rl: '/static/icons/list-item-defenture.svg', Rp: '/static/icons/loading.svg', Rs: '/static/icons/location.svg', Rv: '/static/icons/location-contact.svg', RE: '/static/icons/location-vector.svg', RY: '/static/icons/logout.svg', auB: '/static/icons/luxembourg.svg', Sf: '/static/icons/map.svg', auD: '/static/icons/map-new.svg', SV: '/static/icons/mediaLibrary.svg', Tk: '/static/icons/minimize.svg', Tu: '/static/icons/mobile-phone.svg', auK: '/static/icons/motivation.svg', TO: '/static/icons/move.svg', auN: '/static/icons/netherlands.svg', Vi: '/static/icons/news-overview.svg', auX: '/static/icons/norway.svg', Xd: '/static/icons/not-visible.svg', Xe: '/static/icons/notification.svg', auY: '/static/icons/notification-checkmark.svg', auZ: '/static/icons/notification-close.svg', au_: '/static/icons/notification-error.svg', au$: '/static/icons/notification-info.svg', au0: '/static/icons/notification-warning.svg', XS: '/static/icons/offer.svg', Y$: '/static/icons/ordered-list.svg', Y8: '/static/icons/orientation-day.svg', ZL: '/static/icons/pages.svg', ZM: '/static/icons/pagesOverview.svg', _g: '/static/icons/paper-plane.svg', _n: '/static/icons/Path.svg', au9: '/static/icons/person.svg', _F: '/static/icons/personCms.svg', aR: '/static/icons/phone.svg', _O: '/static/icons/phone-interview.svg', ava: '/static/icons/phone-new.svg', _Y: '/static/icons/phone-with-country-code.svg', _1: '/static/icons/pinterest.svg', _6: '/static/icons/play-icon.svg', ave: '/static/icons/poland.svg', avf: '/static/icons/portugal.svg', aaz: '/static/icons/publish.svg', abv: '/static/icons/redo.svg', acJ: '/static/icons/related-news.svg', acL: '/static/icons/related-vacancies.svg', acM: '/static/icons/related-vacancies-slider.svg', acQ: '/static/icons/remove.svg', avt: '/static/icons/romania.svg', ady: '/static/icons/rotate.svg', adz: '/static/icons/route.svg', adA: '/static/icons/row.svg', adV: '/static/icons/salary-calculator.svg', ad1: '/static/icons/salary-indication.svg', aei: '/static/icons/save.svg', aeC: '/static/icons/search.svg', aeM: '/static/icons/search-glass.svg', aeZ: '/static/icons/second-live-interview.svg', ae0: '/static/icons/select.svg', ag2: '/static/icons/settings.svg', ahm: '/static/icons/sharp-light-camera-user.svg', avA: '/static/icons/singapore.svg', aiu: '/static/icons/skill-test.svg', aiw: '/static/icons/skype.svg', aiy: '/static/icons/slider-arrow.svg', aiz: '/static/icons/slider-arrow-white.svg', avC: '/static/icons/slovakia.svg', aiM: '/static/icons/snapchat.svg', ajf: '/static/icons/spacer.svg', ajh: '/static/icons/spacing.svg', avD: '/static/icons/spain.svg', ajj: '/static/icons/sparkles.svg', ajm: '/static/icons/spotify.svg', ajo: '/static/icons/square-ellipsis-vertical.svg', ajs: '/static/icons/star-filled.svg', ajt: '/static/icons/star-outline.svg', aju: '/static/icons/start.svg', avH: '/static/icons/store-data.svg', akh: '/static/icons/strikethrough.svg', akw: '/static/icons/submit-application.svg', avQ: '/static/icons/sweden.svg', avR: '/static/icons/switzerland.svg', ale: '/static/icons/tablet.svg', alf: '/static/icons/tabs-video.svg', alD: '/static/icons/testimonial.svg', alE: '/static/icons/text.svg', avU: '/static/icons/text-area.svg', alV: '/static/icons/the-netherlands.svg', amU: '/static/icons/tiktok.svg', anu: '/static/icons/train.svg', anC: '/static/icons/trash.svg', anD: '/static/icons/trash-outline.svg', anE: '/static/icons/travel-time.svg', anJ: '/static/icons/tumblr.svg', anQ: '/static/icons/twitter.svg', av6: '/static/icons/ukraine.svg', an9: '/static/icons/underline.svg', aoa: '/static/icons/undo.svg', aoG: '/static/icons/united-kingdom.svg', av8: '/static/icons/united-states.svg', awd: '/static/icons/unordered-list.svg', ao_: '/static/icons/upload-file.svg', apV: '/static/icons/user-unlock.svg', apY: '/static/icons/usp.svg', aqg: '/static/icons/vacancy-associated-options.svg', aqk: '/static/icons/vacancy-banner.svg', aqy: '/static/icons/vacancy-description.svg', aqH: '/static/icons/vacancy-filter-links.svg', aqJ: '/static/icons/vacancy-hidden-form.svg', aqS: '/static/icons/vacancy-list.svg', aqV: '/static/icons/vacancy-overview.svg', aq1: '/static/icons/vacancy-search.svg', ars: '/static/icons/video.svg', arw: '/static/icons/video-interview.svg', arK: '/static/icons/visible.svg', arS: '/static/icons/walking.svg', arT: '/static/icons/wallet.svg', arZ: '/static/icons/wechat.svg', asf: '/static/icons/whatsapp.svg', asu: '/static/icons/world.svg', asx: '/static/icons/worldmap.svg', asz: '/static/icons/x.svg', asA: '/static/icons/xing.svg', asN: '/static/icons/youtube.svg', aws: '/static/icons/youtube-fill.svg'};
var $author$project$View$Icon$path = $author$project$Data$Icon$path;
var $author$project$TravelTime$modeToIcon = function (drivingMode) {
	switch (drivingMode) {
		case 2:
			return $author$project$View$Icon$path.pN;
		case 0:
			return $author$project$View$Icon$path.oT;
		case 3:
			return $author$project$View$Icon$path.anu;
		default:
			return $author$project$View$Icon$path.arS;
	}
};
var $elm$html$Html$span = _VirtualDom_node('span');
var $author$project$Model$MaskColor$Secondary = 3;
var $elm$virtual_dom$VirtualDom$style = _VirtualDom_style;
var $elm$html$Html$Attributes$style = $elm$virtual_dom$VirtualDom$style;
var $author$project$Data$MaskColor$toClass = function (maskColor) {
	switch (maskColor) {
		case 0:
			return 'bg-white';
		case 1:
			return 'bg-text';
		case 2:
			return 'bg-color-1';
		case 3:
			return 'bg-color-2';
		default:
			return 'original';
	}
};
var $author$project$View$Icon$viewMasked = F2(
	function (color, _v0) {
		var iconPath = _v0;
		var maskImage = A2(
			$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
			'url(\'{0}\')',
			_List_fromArray(
				[iconPath]));
		var style_ = function () {
			if (color === 4) {
				return _List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'background-image', maskImage)
					]);
			} else {
				return _List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'mask-image', maskImage),
						A2($elm$html$Html$Attributes$style, '-webkit-mask-image', maskImage)
					]);
			}
		}();
		var class_ = $elm$html$Html$Attributes$class(
			$author$project$Data$MaskColor$toClass(color));
		var attrs = _Utils_ap(
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('icon'),
					class_
				]),
			style_);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('colored-icon')
				]),
			_List_fromArray(
				[
					A2($elm$html$Html$div, attrs, _List_Nil)
				]));
	});
var $author$project$View$Icon$viewColored = $author$project$View$Icon$viewMasked(3);
var $author$project$TravelTime$viewDistance = function (model) {
	return A2(
		$author$project$Util$View$viewMaybe,
		model.c8,
		function (distance) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('info-window')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('distance-info')
							]),
						_List_fromArray(
							[
								$author$project$View$Icon$viewColored(
								$author$project$TravelTime$modeToIcon(model.EC)),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('duration')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(distance.EG)
									]))
							])),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('distance')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(distance.Ec)
							]))
					]));
		});
};
var $author$project$TravelTime$GotNewDistance = function (a) {
	return {$: 3, a: a};
};
var $author$project$Util$Decode$debugHelper = F3(
	function (_v0, decoder, _v1) {
		return decoder;
	});
var $author$project$Util$Decode$debug = F2(
	function (message, decoder) {
		return A2(
			$elm$json$Json$Decode$andThen,
			A2($author$project$Util$Decode$debugHelper, message, decoder),
			$elm$json$Json$Decode$value);
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt = F3(
	function (path, valDecoder, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A2($elm$json$Json$Decode$at, path, valDecoder),
			decoder);
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$resolve = $elm$json$Json$Decode$andThen($elm$core$Basics$identity);
var $author$project$TravelTime$decodeDistance = function () {
	var toDistance = F4(
		function (distance, distanceVal, durationStr, durationVal) {
			return $elm$json$Json$Decode$succeed(
				$author$project$TravelTime$GotNewDistance(
					{Ec: distance, Ef: distanceVal, EG: durationStr, EH: durationVal}));
		});
	return A2(
		$author$project$Util$Decode$debug,
		'distance: ',
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$resolve(
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
				_List_fromArray(
					['detail', 'duration', 'value']),
				$elm$json$Json$Decode$float,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
					_List_fromArray(
						['detail', 'duration', 'text']),
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
						_List_fromArray(
							['detail', 'distance', 'value']),
						$elm$json$Json$Decode$float,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
							_List_fromArray(
								['detail', 'distance', 'text']),
							$elm$json$Json$Decode$string,
							$elm$json$Json$Decode$succeed(toDistance)))))));
}();
var $author$project$TravelTime$viewMap = function (id_) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('map'),
				$elm$html$Html$Attributes$id(id_),
				A2($elm$html$Html$Events$on, 'onDistanceChange', $author$project$TravelTime$decodeDistance)
			]),
		_List_Nil);
};
var $elm$core$Basics$neq = _Utils_notEqual;
var $author$project$View$LocationSuggestions$viewHiddenCoordinateInputs = function (visitorLocation) {
	if (visitorLocation.$ === 4) {
		var location = visitorLocation.a;
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('hidden'),
							$elm$html$Html$Attributes$name('latitude'),
							$elm$html$Html$Attributes$value(
							$elm$core$String$fromFloat(location.fb))
						]),
					_List_Nil),
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('hidden'),
							$elm$html$Html$Attributes$name('longitude'),
							$elm$html$Html$Attributes$value(
							$elm$core$String$fromFloat(location.fd))
						]),
					_List_Nil)
				]));
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$View$LocationSuggestions$RequestVisitorLocation = {$: 1};
var $elm$virtual_dom$VirtualDom$attribute = F2(
	function (key, value) {
		return A2(
			_VirtualDom_attribute,
			_VirtualDom_noOnOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlUri(value));
	});
var $elm$html$Html$Attributes$attribute = $elm$virtual_dom$VirtualDom$attribute;
var $elm$html$Html$button = _VirtualDom_node('button');
var $elm$virtual_dom$VirtualDom$MayPreventDefault = function (a) {
	return {$: 2, a: a};
};
var $elm$html$Html$Events$preventDefaultOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayPreventDefault(decoder));
	});
var $elm$html$Html$Attributes$title = $elm$html$Html$Attributes$stringProperty('title');
var $author$project$View$LocationSuggestions$viewRequestVisitorLocation = F2(
	function (config, visitorLocation) {
		switch (visitorLocation.$) {
			case 3:
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('visitor-location-error')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('visitor-location-btn-text')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text($author$project$Copy$copy.RC)
								]))
						]));
			case 2:
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('visitor-location-error')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('visitor-location-btn-text')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text($author$project$Copy$copy.RC)
								]))
						]));
			case 1:
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('visitor-location-loading')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('visitor-location-btn-text')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text($author$project$Copy$copy.Rp)
								]))
						]));
			case 4:
				return $elm$html$Html$text('');
			default:
				var optionalAttrs = A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						A2($elm$core$Basics$composeL, $elm$core$List$singleton, $elm$html$Html$Attributes$tabindex),
						config.avS));
				return A2(
					$elm$html$Html$button,
					_Utils_ap(
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('visitor-location-btn'),
								$elm$html$Html$Attributes$type_('button'),
								$elm$html$Html$Attributes$title($author$project$Copy$copy.aeH),
								A2($elm$html$Html$Attributes$attribute, 'aria-label', $author$project$Copy$copy.aeH),
								A2(
								$elm$html$Html$Events$preventDefaultOn,
								'click',
								$elm$json$Json$Decode$succeed(
									_Utils_Tuple2($author$project$View$LocationSuggestions$RequestVisitorLocation, true)))
							]),
						optionalAttrs),
					_List_fromArray(
						[
							$author$project$View$Icon$viewColored($author$project$View$Icon$path.Ec)
						]));
		}
	});
var $author$project$View$LocationSuggestions$view = F2(
	function (config, state) {
		var state_ = state;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id('form-field-location'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('form-field-wrapper', true),
							_Utils_Tuple2(config.db, true),
							_Utils_Tuple2(
							'inline',
							!_Utils_eq(config.aul, $elm$core$Maybe$Nothing))
						]))
				]),
			_Utils_ap(
				A2(
					$author$project$View$Autocomplete$Http$view,
					A2(
						$author$project$View$LocationSuggestions$locationSearchConfig,
						$author$project$View$LocationSuggestions$setMinIndex(config),
						state),
					state_.al),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$map,
						config.aut,
						A2(
							$author$project$View$LocationSuggestions$viewRequestVisitorLocation,
							$author$project$View$LocationSuggestions$setMinIndex(config),
							state_.a1)),
						function () {
						var _v0 = config.aul;
						if (!_v0.$) {
							var url = _v0.a;
							return A2(
								$elm$html$Html$a,
								_Utils_ap(
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('visitor-location-btn search'),
											$elm$html$Html$Attributes$href(url)
										]),
									function () {
										var _v1 = config.avS;
										if (!_v1.$) {
											var idx = _v1.a;
											return _List_fromArray(
												[
													$elm$html$Html$Attributes$tabindex(idx + 1)
												]);
										} else {
											return _List_Nil;
										}
									}()),
								_List_fromArray(
									[
										$author$project$View$Icon$viewColored($author$project$View$Icon$path.aeC)
									]));
						} else {
							return $elm$html$Html$text('');
						}
					}(),
						$author$project$View$LocationSuggestions$viewHiddenCoordinateInputs(state_.a1)
					])));
	});
var $author$project$TravelTime$Bike = 0;
var $author$project$TravelTime$ByFoot = 1;
var $author$project$TravelTime$SetDrivingMode = function (a) {
	return {$: 0, a: a};
};
var $author$project$TravelTime$Transit = 3;
var $author$project$TravelTime$modeToTranslation = function (drivingMode) {
	switch (drivingMode) {
		case 2:
			return $author$project$Copy$copy.pN;
		case 0:
			return $author$project$Copy$copy.oT;
		case 3:
			return $author$project$Copy$copy.anA;
		default:
			return $author$project$Copy$copy.pt;
	}
};
var $author$project$TravelTime$viewDrivingMode = function (drivingMode) {
	var toButton = function (mode) {
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('btn', true),
							_Utils_Tuple2(
							'active',
							_Utils_eq(drivingMode, mode))
						])),
					$elm$html$Html$Events$onClick(
					$author$project$TravelTime$SetDrivingMode(mode)),
					$elm$html$Html$Attributes$title(
					$author$project$TravelTime$modeToTranslation(mode))
				]),
			_List_fromArray(
				[
					$author$project$View$Icon$viewColored(
					$author$project$TravelTime$modeToIcon(mode))
				]));
	};
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('driving-mode')
			]),
		_List_fromArray(
			[
				toButton(0),
				toButton(1),
				toButton(2),
				toButton(3)
			]));
};
var $author$project$TravelTime$viewNavigation = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('navigation')
			]),
		_List_fromArray(
			[
				A2(
				$author$project$View$LocationSuggestions$view,
				A3($author$project$TravelTime$locationSuggestionsConfig, model.dp, model.aW, model.ci),
				model.az),
				$author$project$TravelTime$viewDrivingMode(model.EC)
			]));
};
var $author$project$TravelTime$view = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('travel-time')
			]),
		_List_fromArray(
			[
				$author$project$TravelTime$viewNavigation(model),
				$author$project$TravelTime$viewDistance(model),
				$author$project$TravelTime$viewMap(model.dE)
			]));
};
var $author$project$TravelTime$main = A2(
	$author$project$Browser$Custom$elementWithFlags,
	$author$project$TravelTime$decodeFlags,
	{dH: $author$project$TravelTime$init, em: $author$project$TravelTime$subscriptions, ex: $author$project$TravelTime$update, ez: $author$project$TravelTime$view});
var $author$project$Model$Component$Slider$ElmFlags = F8(
	function (slider, sliderType, windowWidth, infinity, useDifferentArrow, uploads, vacancyCounts, minTabIndex) {
		return {NX: infinity, aP: minTabIndex, aix: slider, aiF: sliderType, ape: uploads, apw: useDifferentArrow, aqs: vacancyCounts, cX: windowWidth};
	});
var $elm$json$Json$Decode$bool = _Json_decodeBool;
var $author$project$Model$Component$Slider$ApplicantJourneySlider = function (a) {
	return {$: 0, a: a};
};
var $author$project$Model$Component$Slider$ApplicantJourneyWithHoverSlider = function (a) {
	return {$: 1, a: a};
};
var $author$project$Model$Component$Slider$ApplicationProcedureSlider = function (a) {
	return {$: 2, a: a};
};
var $author$project$Model$Component$Slider$CardSlider = function (a) {
	return {$: 3, a: a};
};
var $author$project$Model$Component$Slider$ContentSlider = function (a) {
	return {$: 4, a: a};
};
var $author$project$Model$Component$Slider$RelatedVacanciesSlider = function (a) {
	return {$: 5, a: a};
};
var $author$project$Model$Content$ApplicantJourney$ApplicantJourney = F5(
	function (title, description, image, cta, link) {
		return {xF: cta, dn: description, Nw: image, Q0: link, avV: title};
	});
var $author$project$Model$Content$Image$Image = F7(
	function (src, alt, title, align, horizontalAlign, url, ariaLabel) {
		return {Q: align, jn: alt, c1: ariaLabel, MT: horizontalAlign, ek: src, avV: title, a0: url};
	});
var $author$project$Model$Align$HorizontalAlignCenter = 1;
var $author$project$Model$Align$HorizontalAlignFill = 3;
var $author$project$Model$Align$HorizontalAlignLeft = 0;
var $author$project$Model$Align$HorizontalAlignRight = 2;
var $author$project$Model$Align$horizontalAlignDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'horizontal-align-left':
				return $elm$json$Json$Decode$succeed(0);
			case 'horizontal-align-center':
				return $elm$json$Json$Decode$succeed(1);
			case 'horizontal-align-right':
				return $elm$json$Json$Decode$succeed(2);
			case 'horizontal-align-fill':
				return $elm$json$Json$Decode$succeed(3);
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Model$ImageSource$ExternalUrl = function (a) {
	return {$: 1, a: a};
};
var $author$project$Model$ImageSource$InternalUrl = function (a) {
	return {$: 2, a: a};
};
var $author$project$Model$ImageSource$UploadId = function (a) {
	return {$: 0, a: a};
};
var $author$project$Model$ImageSource$imageSourceDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'upload-id':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Data$Id$decoder,
					$elm$json$Json$Decode$succeed($author$project$Model$ImageSource$UploadId));
			case 'external-url':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Model$ImageSource$ExternalUrl));
			case 'internal-url':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Model$ImageSource$InternalUrl));
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	A2($elm$json$Json$Decode$field, 'tag', $elm$json$Json$Decode$string));
var $author$project$Model$Align$VerticalAlignBottom = 0;
var $author$project$Model$Align$VerticalAlignCenter = 1;
var $author$project$Model$Align$VerticalAlignFill = 3;
var $author$project$Model$Align$VerticalAlignTop = 2;
var $author$project$Model$Align$verticalAlignDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'vertical-align-bottom':
				return $elm$json$Json$Decode$succeed(0);
			case 'vertical-align-center':
				return $elm$json$Json$Decode$succeed(1);
			case 'vertical-align-top':
				return $elm$json$Json$Decode$succeed(2);
			case 'vertical-align-fill':
				return $elm$json$Json$Decode$succeed(3);
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Model$Content$Image$imageDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'ariaLabel',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'url',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'horizontalAlign',
			$author$project$Model$Align$horizontalAlignDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'align',
				$author$project$Model$Align$verticalAlignDecoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'title',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'alt',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'src',
							$elm$json$Json$Decode$nullable($author$project$Model$ImageSource$imageSourceDecoder),
							$elm$json$Json$Decode$succeed($author$project$Model$Content$Image$Image))))))));
var $author$project$Model$Content$ApplicantJourney$applicantJourneyDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'link',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'cta',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'image',
			$author$project$Model$Content$Image$imageDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'description',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'title',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Model$Content$ApplicantJourney$ApplicantJourney))))));
var $author$project$Model$Content$ApplicantJourneyWithHover$ApplicantJourneyWithHover = F6(
	function (title, description, image, hoverVideo, cta, link) {
		return {xF: cta, dn: description, M8: hoverVideo, Nw: image, Q0: link, avV: title};
	});
var $author$project$Model$Content$Video$Video = F6(
	function (source, poster, showControls, aspectRatio, ariaLabel, autoPlay) {
		return {c1: ariaLabel, as2: aspectRatio, nh: autoPlay, aT: poster, ahx: showControls, ai3: source};
	});
var $author$project$Model$Content$Video$AspectRatio$FourByThree = 2;
var $author$project$Model$Content$Video$AspectRatio$NineBySixteen = 1;
var $author$project$Model$Content$Video$AspectRatio$Original = 3;
var $author$project$Model$Content$Video$AspectRatio$SixteenByNine = 0;
var $author$project$Model$Content$Video$AspectRatio$aspectRatioDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'sixteen-by-nine':
				return $elm$json$Json$Decode$succeed(0);
			case 'nine-by-sixteen':
				return $elm$json$Json$Decode$succeed(1);
			case 'four-by-three':
				return $elm$json$Json$Decode$succeed(2);
			case 'original':
				return $elm$json$Json$Decode$succeed(3);
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Model$Content$Video$Url = function (a) {
	return {$: 2, a: a};
};
var $author$project$Model$Content$Video$Vimeo = function (a) {
	return {$: 1, a: a};
};
var $author$project$Model$Content$Video$YouTube = function (a) {
	return {$: 0, a: a};
};
var $author$project$Model$Content$Video$VimeoId = $elm$core$Basics$identity;
var $author$project$Model$Content$Video$vimeoIdDecoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$string);
var $author$project$Model$Content$Video$YouTubeId = $elm$core$Basics$identity;
var $author$project$Model$Content$Video$youTubeIdDecoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$string);
var $author$project$Model$Content$Video$sourceDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'you-tube':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$Content$Video$youTubeIdDecoder,
					$elm$json$Json$Decode$succeed($author$project$Model$Content$Video$YouTube));
			case 'vimeo':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$Content$Video$vimeoIdDecoder,
					$elm$json$Json$Decode$succeed($author$project$Model$Content$Video$Vimeo));
			case 'url':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$ImageSource$imageSourceDecoder,
					$elm$json$Json$Decode$succeed($author$project$Model$Content$Video$Url));
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	A2($elm$json$Json$Decode$field, 'tag', $elm$json$Json$Decode$string));
var $author$project$Model$Content$Video$videoDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'autoPlay',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'ariaLabel',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'aspectRatio',
			$author$project$Model$Content$Video$AspectRatio$aspectRatioDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'showControls',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'poster',
					$elm$json$Json$Decode$nullable($author$project$Model$ImageSource$imageSourceDecoder),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'source',
						$elm$json$Json$Decode$nullable($author$project$Model$Content$Video$sourceDecoder),
						$elm$json$Json$Decode$succeed($author$project$Model$Content$Video$Video)))))));
var $author$project$Model$Content$ApplicantJourneyWithHover$applicantJourneyWithHoverDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'link',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'cta',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'hoverVideo',
			$author$project$Model$Content$Video$videoDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'image',
				$author$project$Model$Content$Image$imageDecoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'description',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'title',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Model$Content$ApplicantJourneyWithHover$ApplicantJourneyWithHover)))))));
var $author$project$Model$Component$Card$Card = F5(
	function (heading, image, linkElement, plainText, spacer) {
		return {Mm: heading, Nw: image, Q4: linkElement, _3: plainText, ajf: spacer};
	});
var $author$project$Model$Content$Heading$Heading = F4(
	function (text, size, align, color) {
		return {Q: align, rF: color, ej: size, alE: text};
	});
var $author$project$Model$TextAlign$TextAlignCenter = 1;
var $author$project$Model$TextAlign$TextAlignJustify = 3;
var $author$project$Model$TextAlign$TextAlignLeft = 0;
var $author$project$Model$TextAlign$TextAlignRight = 2;
var $author$project$Model$TextAlign$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'left':
				return $elm$json$Json$Decode$succeed(0);
			case 'center':
				return $elm$json$Json$Decode$succeed(1);
			case 'right':
				return $elm$json$Json$Decode$succeed(2);
			case 'justify':
				return $elm$json$Json$Decode$succeed(3);
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Model$TextColor$BackgroundDependent = 0;
var $author$project$Model$TextColor$Dark = 2;
var $author$project$Model$TextColor$Light = 1;
var $author$project$Model$TextColor$textColorDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'background-dependent':
				return $elm$json$Json$Decode$succeed(0);
			case 'light':
				return $elm$json$Json$Decode$succeed(1);
			case 'dark':
				return $elm$json$Json$Decode$succeed(2);
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Model$Content$Heading$headingDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'color',
	$author$project$Model$TextColor$textColorDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'align',
		$author$project$Model$TextAlign$decoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'size',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'text',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Model$Content$Heading$Heading)))));
var $author$project$Model$Content$Link$Link = F6(
	function (text, href, target, style, align, ariaLabel) {
		return {Q: align, c1: ariaLabel, Nf: href, ao: style, alt: target, alE: text};
	});
var $author$project$Model$Content$Link$Style$Style1 = 0;
var $author$project$Model$Content$Link$Style$Style2 = 1;
var $author$project$Model$Content$Link$Style$Style3 = 2;
var $author$project$Model$Content$Link$Style$Style4 = 3;
var $author$project$Model$Content$Link$Style$styleDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'style1':
				return $elm$json$Json$Decode$succeed(0);
			case 'style2':
				return $elm$json$Json$Decode$succeed(1);
			case 'style3':
				return $elm$json$Json$Decode$succeed(2);
			case 'style4':
				return $elm$json$Json$Decode$succeed(3);
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Model$Content$Link$linkDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'ariaLabel',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'align',
		$author$project$Model$Align$horizontalAlignDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'style',
			$author$project$Model$Content$Link$Style$styleDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'target',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'href',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'text',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Model$Content$Link$Link)))))));
var $author$project$Model$Content$PlainText$PlainText = F3(
	function (text, align, color) {
		return {Q: align, rF: color, alE: text};
	});
var $author$project$Model$Content$PlainText$plainTextDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'color',
	$author$project$Model$TextColor$textColorDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'align',
		$author$project$Model$TextAlign$decoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'text',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Model$Content$PlainText$PlainText))));
var $author$project$Model$Size$SizeCustom = function (a) {
	return {$: 4, a: a};
};
var $author$project$Model$Size$SizeExtraLarge = {$: 3};
var $author$project$Model$Size$SizeLarge = {$: 2};
var $author$project$Model$Size$SizeMedium = {$: 1};
var $author$project$Model$Size$SizeSmall = {$: 0};
var $author$project$Model$Size$sizeDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'size-small':
				return $elm$json$Json$Decode$succeed($author$project$Model$Size$SizeSmall);
			case 'size-medium':
				return $elm$json$Json$Decode$succeed($author$project$Model$Size$SizeMedium);
			case 'size-large':
				return $elm$json$Json$Decode$succeed($author$project$Model$Size$SizeLarge);
			case 'size-extra-large':
				return $elm$json$Json$Decode$succeed($author$project$Model$Size$SizeExtraLarge);
			case 'size-custom':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$elm$json$Json$Decode$int,
					$elm$json$Json$Decode$succeed($author$project$Model$Size$SizeCustom));
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	A2($elm$json$Json$Decode$field, 'tag', $elm$json$Json$Decode$string));
var $author$project$Model$Component$Card$cardDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'spacer',
	$elm$json$Json$Decode$nullable($author$project$Model$Size$sizeDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'plainText',
		$author$project$Model$Content$PlainText$plainTextDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'linkElement',
			$author$project$Model$Content$Link$linkDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'image',
				$author$project$Model$Content$Image$imageDecoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'heading',
					$author$project$Model$Content$Heading$headingDecoder,
					$elm$json$Json$Decode$succeed($author$project$Model$Component$Card$Card))))));
var $author$project$Model$Component$ContentGroup$ContentGroup = F4(
	function (align, content, maxWidth, maxHeight) {
		return {Q: align, dg: content, Sx: maxHeight, SF: maxWidth};
	});
var $author$project$Model$Content$AnchorLink = function (a) {
	return {$: 0, a: a};
};
var $author$project$Model$Content$ApplicantJourney = function (a) {
	return {$: 1, a: a};
};
var $author$project$Model$Content$ApplicantJourneyWithHover = function (a) {
	return {$: 2, a: a};
};
var $author$project$Model$Content$Button = function (a) {
	return {$: 3, a: a};
};
var $author$project$Model$Content$Heading = function (a) {
	return {$: 4, a: a};
};
var $author$project$Model$Content$Image = function (a) {
	return {$: 5, a: a};
};
var $author$project$Model$Content$IntroText = function (a) {
	return {$: 6, a: a};
};
var $author$project$Model$Content$Link = function (a) {
	return {$: 7, a: a};
};
var $author$project$Model$Content$OrderedList = function (a) {
	return {$: 8, a: a};
};
var $author$project$Model$Content$PlainText = function (a) {
	return {$: 9, a: a};
};
var $author$project$Model$Content$ResponsiveImage = function (a) {
	return {$: 10, a: a};
};
var $author$project$Model$Content$Spacer = function (a) {
	return {$: 11, a: a};
};
var $author$project$Model$Content$UnorderedList = function (a) {
	return {$: 13, a: a};
};
var $author$project$Model$Content$Usp = function (a) {
	return {$: 12, a: a};
};
var $author$project$Model$Content$VacancyOverviewLink = function (a) {
	return {$: 14, a: a};
};
var $author$project$Model$Content$Video = function (a) {
	return {$: 15, a: a};
};
var $author$project$Model$Content$AnchorLink$AnchorLink = function (anchor) {
	return {jz: anchor};
};
var $author$project$Model$Content$AnchorLink$anchorLinkDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'anchor',
	$elm$json$Json$Decode$string,
	$elm$json$Json$Decode$succeed($author$project$Model$Content$AnchorLink$AnchorLink));
var $author$project$Model$Content$Button$Button = F6(
	function (text, href, target, style, align, ariaLabel) {
		return {Q: align, c1: ariaLabel, Nf: href, ao: style, alt: target, alE: text};
	});
var $author$project$Model$Content$Button$Style$Style1 = 0;
var $author$project$Model$Content$Button$Style$Style2 = 1;
var $author$project$Model$Content$Button$Style$Style3 = 2;
var $author$project$Model$Content$Button$Style$Style4 = 3;
var $author$project$Model$Content$Button$Style$styleDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'style1':
				return $elm$json$Json$Decode$succeed(0);
			case 'style2':
				return $elm$json$Json$Decode$succeed(1);
			case 'style3':
				return $elm$json$Json$Decode$succeed(2);
			case 'style4':
				return $elm$json$Json$Decode$succeed(3);
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Model$Content$Button$buttonDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'ariaLabel',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'align',
		$author$project$Model$Align$horizontalAlignDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'style',
			$author$project$Model$Content$Button$Style$styleDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'target',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'href',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'text',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Model$Content$Button$Button)))))));
var $author$project$Model$Content$IntroText$IntroText = F3(
	function (text, align, color) {
		return {Q: align, rF: color, alE: text};
	});
var $author$project$Model$Content$IntroText$introTextDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'color',
	$author$project$Model$TextColor$textColorDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'align',
		$author$project$Model$TextAlign$decoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'text',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Model$Content$IntroText$IntroText))));
var $author$project$Model$Content$OrderedList$OrderedList = F2(
	function (items, ariaLabel) {
		return {c1: ariaLabel, dM: items};
	});
var $author$project$Model$Content$OrderedList$orderedListDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'ariaLabel',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'items',
		$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
		$elm$json$Json$Decode$succeed($author$project$Model$Content$OrderedList$OrderedList)));
var $author$project$Model$Content$ResponsiveImage$ResponsiveImage = F5(
	function (alt, title, mobile, tablet, desktop) {
		return {jn: alt, DP: desktop, Ts: mobile, ale: tablet, avV: title};
	});
var $author$project$Model$Content$ResponsiveImage$responsiveImageDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'desktop',
	$elm$json$Json$Decode$nullable($author$project$Model$ImageSource$imageSourceDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'tablet',
		$elm$json$Json$Decode$nullable($author$project$Model$ImageSource$imageSourceDecoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'mobile',
			$elm$json$Json$Decode$nullable($author$project$Model$ImageSource$imageSourceDecoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'title',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'alt',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Model$Content$ResponsiveImage$ResponsiveImage))))));
var $author$project$Model$Content$Spacer$Spacer = function (size) {
	return {ej: size};
};
var $author$project$Model$Content$Spacer$spacerDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'size',
	$author$project$Model$Size$sizeDecoder,
	$elm$json$Json$Decode$succeed($author$project$Model$Content$Spacer$Spacer));
var $author$project$Model$Content$UnorderedList$UnorderedList = F2(
	function (items, ariaLabel) {
		return {c1: ariaLabel, dM: items};
	});
var $author$project$Model$Content$UnorderedList$unorderedListDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'ariaLabel',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'items',
		$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
		$elm$json$Json$Decode$succeed($author$project$Model$Content$UnorderedList$UnorderedList)));
var $author$project$Model$Content$Usp$Usp = F8(
	function (text, src, alt, title, ariaLabel, url, description, bgFill) {
		return {jn: alt, c1: ariaLabel, oN: bgFill, dn: description, ek: src, alE: text, avV: title, a0: url};
	});
var $author$project$Model$BackgroundFill$BackgroundBrandColor = function (a) {
	return {$: 3, a: a};
};
var $author$project$Model$BackgroundFill$BackgroundGradient = function (a) {
	return {$: 0, a: a};
};
var $author$project$Model$BackgroundFill$BackgroundImage = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Model$BackgroundFill$BackgroundVideo = function (a) {
	return {$: 2, a: a};
};
var $author$project$Model$BackgroundGradient$BackgroundGradient = F2(
	function (from, to) {
		return {KG: from, am$: to};
	});
var $author$project$Model$Color$Rgba = F4(
	function (red, green, blue, alpha) {
		return {jm: alpha, oY: blue, LQ: green, abl: red};
	});
var $author$project$Model$Color$rgbaDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'alpha',
	$elm$json$Json$Decode$float,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'blue',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'green',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'red',
				$elm$json$Json$Decode$int,
				$elm$json$Json$Decode$succeed($author$project$Model$Color$Rgba)))));
var $author$project$Model$BackgroundGradient$backgroundGradientDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'to',
	$author$project$Model$Color$rgbaDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'from',
		$author$project$Model$Color$rgbaDecoder,
		$elm$json$Json$Decode$succeed($author$project$Model$BackgroundGradient$BackgroundGradient)));
var $author$project$Model$BackgroundImageOptions$BackgroundImageOptions = F4(
	function (size, position, repeat, fixedAttachment) {
		return {It: fixedAttachment, $i: position, acY: repeat, ej: size};
	});
var $author$project$Model$BackgroundPosition$BottomCenter = {$: 7};
var $author$project$Model$BackgroundPosition$BottomLeft = {$: 6};
var $author$project$Model$BackgroundPosition$BottomRight = {$: 8};
var $author$project$Model$BackgroundPosition$Center = {$: 4};
var $author$project$Model$BackgroundPosition$CenterLeft = {$: 3};
var $author$project$Model$BackgroundPosition$CenterRight = {$: 5};
var $author$project$Model$BackgroundPosition$CustomPosition = function (a) {
	return {$: 9, a: a};
};
var $author$project$Model$BackgroundPosition$TopCenter = {$: 1};
var $author$project$Model$BackgroundPosition$TopLeft = {$: 0};
var $author$project$Model$BackgroundPosition$TopRight = {$: 2};
var $author$project$Model$BackgroundPosition$backgroundPositionDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'top-left':
				return $elm$json$Json$Decode$succeed($author$project$Model$BackgroundPosition$TopLeft);
			case 'top-center':
				return $elm$json$Json$Decode$succeed($author$project$Model$BackgroundPosition$TopCenter);
			case 'top-right':
				return $elm$json$Json$Decode$succeed($author$project$Model$BackgroundPosition$TopRight);
			case 'center-left':
				return $elm$json$Json$Decode$succeed($author$project$Model$BackgroundPosition$CenterLeft);
			case 'center':
				return $elm$json$Json$Decode$succeed($author$project$Model$BackgroundPosition$Center);
			case 'center-right':
				return $elm$json$Json$Decode$succeed($author$project$Model$BackgroundPosition$CenterRight);
			case 'bottom-left':
				return $elm$json$Json$Decode$succeed($author$project$Model$BackgroundPosition$BottomLeft);
			case 'bottom-center':
				return $elm$json$Json$Decode$succeed($author$project$Model$BackgroundPosition$BottomCenter);
			case 'bottom-right':
				return $elm$json$Json$Decode$succeed($author$project$Model$BackgroundPosition$BottomRight);
			case 'custom-position':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Model$BackgroundPosition$CustomPosition));
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	A2($elm$json$Json$Decode$field, 'tag', $elm$json$Json$Decode$string));
var $author$project$Model$BackgroundRepeat$Both = 3;
var $author$project$Model$BackgroundRepeat$Horizontal = 1;
var $author$project$Model$BackgroundRepeat$None = 0;
var $author$project$Model$BackgroundRepeat$Vertical = 2;
var $author$project$Model$BackgroundRepeat$backgroundRepeatDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'none':
				return $elm$json$Json$Decode$succeed(0);
			case 'horizontal':
				return $elm$json$Json$Decode$succeed(1);
			case 'vertical':
				return $elm$json$Json$Decode$succeed(2);
			case 'both':
				return $elm$json$Json$Decode$succeed(3);
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Model$BackgroundSize$Auto = {$: 2};
var $author$project$Model$BackgroundSize$Contain = {$: 1};
var $author$project$Model$BackgroundSize$Cover = {$: 0};
var $author$project$Model$BackgroundSize$CustomSize = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Model$BackgroundSize$backgroundSizeDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'cover':
				return $elm$json$Json$Decode$succeed($author$project$Model$BackgroundSize$Cover);
			case 'contain':
				return $elm$json$Json$Decode$succeed($author$project$Model$BackgroundSize$Contain);
			case 'auto':
				return $elm$json$Json$Decode$succeed($author$project$Model$BackgroundSize$Auto);
			case 'custom-size':
				return A2(
					$elm$json$Json$Decode$field,
					'contents',
					A2(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
						A2($elm$json$Json$Decode$index, 1, $elm$json$Json$Decode$string),
						A2(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
							A2($elm$json$Json$Decode$index, 0, $elm$json$Json$Decode$string),
							$elm$json$Json$Decode$succeed($author$project$Model$BackgroundSize$CustomSize))));
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	A2($elm$json$Json$Decode$field, 'tag', $elm$json$Json$Decode$string));
var $author$project$Model$BackgroundImageOptions$backgroundImageOptionsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'fixedAttachment',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'repeat',
		$elm$json$Json$Decode$nullable($author$project$Model$BackgroundRepeat$backgroundRepeatDecoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'position',
			$elm$json$Json$Decode$nullable($author$project$Model$BackgroundPosition$backgroundPositionDecoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'size',
				$elm$json$Json$Decode$nullable($author$project$Model$BackgroundSize$backgroundSizeDecoder),
				$elm$json$Json$Decode$succeed($author$project$Model$BackgroundImageOptions$BackgroundImageOptions)))));
var $author$project$Model$BrandColor$Color1 = 0;
var $author$project$Model$BrandColor$Color2 = 1;
var $author$project$Model$BrandColor$Color3 = 2;
var $author$project$Model$BrandColor$Color4 = 3;
var $author$project$Model$BrandColor$brandColorDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'color1':
				return $elm$json$Json$Decode$succeed(0);
			case 'color2':
				return $elm$json$Json$Decode$succeed(1);
			case 'color3':
				return $elm$json$Json$Decode$succeed(2);
			case 'color4':
				return $elm$json$Json$Decode$succeed(3);
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Model$BackgroundFill$backgroundFillDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'background-gradient':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$BackgroundGradient$backgroundGradientDecoder,
					$elm$json$Json$Decode$succeed($author$project$Model$BackgroundFill$BackgroundGradient));
			case 'background-image':
				return A2(
					$elm$json$Json$Decode$field,
					'contents',
					A2(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
						A2(
							$elm$json$Json$Decode$index,
							1,
							$elm$json$Json$Decode$nullable($author$project$Model$BackgroundImageOptions$backgroundImageOptionsDecoder)),
						A2(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
							A2($elm$json$Json$Decode$index, 0, $author$project$Model$ImageSource$imageSourceDecoder),
							$elm$json$Json$Decode$succeed($author$project$Model$BackgroundFill$BackgroundImage))));
			case 'background-video':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$ImageSource$imageSourceDecoder,
					$elm$json$Json$Decode$succeed($author$project$Model$BackgroundFill$BackgroundVideo));
			case 'background-brand-color':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$BrandColor$brandColorDecoder,
					$elm$json$Json$Decode$succeed($author$project$Model$BackgroundFill$BackgroundBrandColor));
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	A2($elm$json$Json$Decode$field, 'tag', $elm$json$Json$Decode$string));
var $author$project$Model$Content$Usp$uspDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'bgFill',
	$elm$json$Json$Decode$nullable($author$project$Model$BackgroundFill$backgroundFillDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'description',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'url',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'ariaLabel',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'title',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'alt',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'src',
							$elm$json$Json$Decode$nullable($author$project$Model$ImageSource$imageSourceDecoder),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'text',
								$elm$json$Json$Decode$string,
								$elm$json$Json$Decode$succeed($author$project$Model$Content$Usp$Usp)))))))));
var $author$project$Model$Content$VacancyOverviewLink$VacancyOverviewLink = F5(
	function (text, optionIds, style, align, jobAlertLinkText) {
		return {Q: align, PF: jobAlertLinkText, YM: optionIds, ao: style, alE: text};
	});
var $author$project$Model$Content$VacancyOverviewLink$vacancyOverviewLinkDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'jobAlertLinkText',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'align',
		$author$project$Model$Align$horizontalAlignDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'style',
			$author$project$Model$Content$Link$Style$styleDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'optionIds',
				$elm$json$Json$Decode$list($author$project$Data$Id$decoder),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'text',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Model$Content$VacancyOverviewLink$VacancyOverviewLink))))));
var $author$project$Model$Content$contentDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'anchor-link':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$Content$AnchorLink$anchorLinkDecoder,
					$elm$json$Json$Decode$succeed($author$project$Model$Content$AnchorLink));
			case 'applicant-journey':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$Content$ApplicantJourney$applicantJourneyDecoder,
					$elm$json$Json$Decode$succeed($author$project$Model$Content$ApplicantJourney));
			case 'applicant-journey-with-hover':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$Content$ApplicantJourneyWithHover$applicantJourneyWithHoverDecoder,
					$elm$json$Json$Decode$succeed($author$project$Model$Content$ApplicantJourneyWithHover));
			case 'button':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$Content$Button$buttonDecoder,
					$elm$json$Json$Decode$succeed($author$project$Model$Content$Button));
			case 'heading':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$Content$Heading$headingDecoder,
					$elm$json$Json$Decode$succeed($author$project$Model$Content$Heading));
			case 'image':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$Content$Image$imageDecoder,
					$elm$json$Json$Decode$succeed($author$project$Model$Content$Image));
			case 'intro-text':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$Content$IntroText$introTextDecoder,
					$elm$json$Json$Decode$succeed($author$project$Model$Content$IntroText));
			case 'link':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$Content$Link$linkDecoder,
					$elm$json$Json$Decode$succeed($author$project$Model$Content$Link));
			case 'ordered-list':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$Content$OrderedList$orderedListDecoder,
					$elm$json$Json$Decode$succeed($author$project$Model$Content$OrderedList));
			case 'plain-text':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$Content$PlainText$plainTextDecoder,
					$elm$json$Json$Decode$succeed($author$project$Model$Content$PlainText));
			case 'responsive-image':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$Content$ResponsiveImage$responsiveImageDecoder,
					$elm$json$Json$Decode$succeed($author$project$Model$Content$ResponsiveImage));
			case 'spacer':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$Content$Spacer$spacerDecoder,
					$elm$json$Json$Decode$succeed($author$project$Model$Content$Spacer));
			case 'usp':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$Content$Usp$uspDecoder,
					$elm$json$Json$Decode$succeed($author$project$Model$Content$Usp));
			case 'unordered-list':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$Content$UnorderedList$unorderedListDecoder,
					$elm$json$Json$Decode$succeed($author$project$Model$Content$UnorderedList));
			case 'vacancy-overview-link':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$Content$VacancyOverviewLink$vacancyOverviewLinkDecoder,
					$elm$json$Json$Decode$succeed($author$project$Model$Content$VacancyOverviewLink));
			case 'video':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$Content$Video$videoDecoder,
					$elm$json$Json$Decode$succeed($author$project$Model$Content$Video));
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	A2($elm$json$Json$Decode$field, 'tag', $elm$json$Json$Decode$string));
var $author$project$Model$Component$ContentGroup$contentGroupDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'maxHeight',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'maxWidth',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'content',
			$elm$json$Json$Decode$list($author$project$Model$Content$contentDecoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'align',
				$author$project$Model$Align$verticalAlignDecoder,
				$elm$json$Json$Decode$succeed($author$project$Model$Component$ContentGroup$ContentGroup)))));
var $author$project$Model$ApplicationProcedure$ApplicationProcedureStep = F4(
	function (title, description, icon, maskColor) {
		return {dn: description, bb: icon, Sm: maskColor, avV: title};
	});
var $author$project$Model$MaskColor$NoMask = 4;
var $author$project$Model$MaskColor$Primary = 2;
var $author$project$Model$MaskColor$TextColor = 1;
var $author$project$Model$MaskColor$White = 0;
var $author$project$Model$MaskColor$maskColorDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'white':
				return $elm$json$Json$Decode$succeed(0);
			case 'text-color':
				return $elm$json$Json$Decode$succeed(1);
			case 'primary':
				return $elm$json$Json$Decode$succeed(2);
			case 'secondary':
				return $elm$json$Json$Decode$succeed(3);
			case 'no-mask':
				return $elm$json$Json$Decode$succeed(4);
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Model$ApplicationProcedure$stepDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'maskColor',
	$author$project$Model$MaskColor$maskColorDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'icon',
		$elm$json$Json$Decode$nullable($author$project$Model$ImageSource$imageSourceDecoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'description',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'title',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Model$ApplicationProcedure$ApplicationProcedureStep)))));
var $author$project$Model$Component$Slider$sliderDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'applicant-journey-slider':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$elm$json$Json$Decode$list($author$project$Model$Content$ApplicantJourney$applicantJourneyDecoder),
					$elm$json$Json$Decode$succeed($author$project$Model$Component$Slider$ApplicantJourneySlider));
			case 'applicant-journey-with-hover-slider':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$elm$json$Json$Decode$list($author$project$Model$Content$ApplicantJourneyWithHover$applicantJourneyWithHoverDecoder),
					$elm$json$Json$Decode$succeed($author$project$Model$Component$Slider$ApplicantJourneyWithHoverSlider));
			case 'application-procedure-slider':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$elm$json$Json$Decode$list($author$project$Model$ApplicationProcedure$stepDecoder),
					$elm$json$Json$Decode$succeed($author$project$Model$Component$Slider$ApplicationProcedureSlider));
			case 'card-slider':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$elm$json$Json$Decode$list($author$project$Model$Component$Card$cardDecoder),
					$elm$json$Json$Decode$succeed($author$project$Model$Component$Slider$CardSlider));
			case 'content-slider':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$elm$json$Json$Decode$list($author$project$Model$Component$ContentGroup$contentGroupDecoder),
					$elm$json$Json$Decode$succeed($author$project$Model$Component$Slider$ContentSlider));
			case 'related-vacancies-slider':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Model$Component$Slider$RelatedVacanciesSlider));
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	A2($elm$json$Json$Decode$field, 'tag', $elm$json$Json$Decode$string));
var $author$project$Model$SliderType$InFives = 4;
var $author$project$Model$SliderType$InFours = 3;
var $author$project$Model$SliderType$InOne = 0;
var $author$project$Model$SliderType$InThrees = 2;
var $author$project$Model$SliderType$InTwos = 1;
var $author$project$Model$SliderType$sliderTypeDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'in-one':
				return $elm$json$Json$Decode$succeed(0);
			case 'in-twos':
				return $elm$json$Json$Decode$succeed(1);
			case 'in-threes':
				return $elm$json$Json$Decode$succeed(2);
			case 'in-fours':
				return $elm$json$Json$Decode$succeed(3);
			case 'in-fives':
				return $elm$json$Json$Decode$succeed(4);
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Uploads$Uploads = $elm$core$Basics$identity;
var $elm$json$Json$Decode$keyValuePairs = _Json_decodeKeyValuePairs;
var $elm$json$Json$Decode$dict = function (decoder) {
	return A2(
		$elm$json$Json$Decode$map,
		$elm$core$Dict$fromList,
		$elm$json$Json$Decode$keyValuePairs(decoder));
};
var $author$project$Data$Uploads$uploadsDecoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Basics$identity,
	$elm$json$Json$Decode$dict($elm$json$Json$Decode$string));
var $author$project$Data$VacancyCounts$VacancyCountEntry = F2(
	function (count, url) {
		return {atq: count, a0: url};
	});
var $author$project$Data$VacancyCounts$vacancyCountEntryDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'url',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'count',
		$elm$json$Json$Decode$int,
		$elm$json$Json$Decode$succeed($author$project$Data$VacancyCounts$VacancyCountEntry)));
var $author$project$Model$Component$Slider$elmFlagsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'minTabIndex',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'vacancyCounts',
		$elm$json$Json$Decode$list(
			$elm$json$Json$Decode$list(
				$elm$json$Json$Decode$nullable($author$project$Data$VacancyCounts$vacancyCountEntryDecoder))),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'uploads',
			$author$project$Data$Uploads$uploadsDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'useDifferentArrow',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'infinity',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'windowWidth',
						$elm$json$Json$Decode$int,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'sliderType',
							$author$project$Model$SliderType$sliderTypeDecoder,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'slider',
								$author$project$Model$Component$Slider$sliderDecoder,
								$elm$json$Json$Decode$succeed($author$project$Model$Component$Slider$ElmFlags)))))))));
var $author$project$Slider$amountOfVisibleCards = function (sliderType) {
	switch (sliderType) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		default:
			return 5;
	}
};
var $elm$core$Result$map = F2(
	function (func, ra) {
		if (!ra.$) {
			var a = ra.a;
			return $elm$core$Result$Ok(
				func(a));
		} else {
			var e = ra.a;
			return $elm$core$Result$Err(e);
		}
	});
var $hecrj$html_parser$Html$Parser$Element = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var $elm$parser$Parser$Advanced$Bad = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$Good = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $elm$parser$Parser$Advanced$Parser = $elm$core$Basics$identity;
var $elm$parser$Parser$Advanced$andThen = F2(
	function (callback, _v0) {
		var parseA = _v0;
		return function (s0) {
			var _v1 = parseA(s0);
			if (_v1.$ === 1) {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p1 = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				var _v2 = callback(a);
				var parseB = _v2;
				var _v3 = parseB(s1);
				if (_v3.$ === 1) {
					var p2 = _v3.a;
					var x = _v3.b;
					return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
				} else {
					var p2 = _v3.a;
					var b = _v3.b;
					var s2 = _v3.c;
					return A3($elm$parser$Parser$Advanced$Good, p1 || p2, b, s2);
				}
			}
		};
	});
var $elm$parser$Parser$andThen = $elm$parser$Parser$Advanced$andThen;
var $elm$parser$Parser$Advanced$backtrackable = function (_v0) {
	var parse = _v0;
	return function (s0) {
		var _v1 = parse(s0);
		if (_v1.$ === 1) {
			var x = _v1.b;
			return A2($elm$parser$Parser$Advanced$Bad, false, x);
		} else {
			var a = _v1.b;
			var s1 = _v1.c;
			return A3($elm$parser$Parser$Advanced$Good, false, a, s1);
		}
	};
};
var $elm$parser$Parser$backtrackable = $elm$parser$Parser$Advanced$backtrackable;
var $elm$parser$Parser$UnexpectedChar = {$: 11};
var $elm$parser$Parser$Advanced$AddRight = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$DeadEnd = F4(
	function (row, col, problem, contextStack) {
		return {rB: col, ato: contextStack, aag: problem, adA: row};
	});
var $elm$parser$Parser$Advanced$Empty = {$: 0};
var $elm$parser$Parser$Advanced$fromState = F2(
	function (s, x) {
		return A2(
			$elm$parser$Parser$Advanced$AddRight,
			$elm$parser$Parser$Advanced$Empty,
			A4($elm$parser$Parser$Advanced$DeadEnd, s.adA, s.rB, x, s.f));
	});
var $elm$parser$Parser$Advanced$isSubChar = _Parser_isSubChar;
var $elm$parser$Parser$Advanced$chompIf = F2(
	function (isGood, expecting) {
		return function (s) {
			var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, s.F, s.ek);
			return _Utils_eq(newOffset, -1) ? A2(
				$elm$parser$Parser$Advanced$Bad,
				false,
				A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : (_Utils_eq(newOffset, -2) ? A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				0,
				{rB: 1, f: s.f, h: s.h, F: s.F + 1, adA: s.adA + 1, ek: s.ek}) : A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				0,
				{rB: s.rB + 1, f: s.f, h: s.h, F: newOffset, adA: s.adA, ek: s.ek}));
		};
	});
var $elm$parser$Parser$chompIf = function (isGood) {
	return A2($elm$parser$Parser$Advanced$chompIf, isGood, $elm$parser$Parser$UnexpectedChar);
};
var $elm$parser$Parser$Advanced$chompWhileHelp = F5(
	function (isGood, offset, row, col, s0) {
		chompWhileHelp:
		while (true) {
			var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, offset, s0.ek);
			if (_Utils_eq(newOffset, -1)) {
				return A3(
					$elm$parser$Parser$Advanced$Good,
					_Utils_cmp(s0.F, offset) < 0,
					0,
					{rB: col, f: s0.f, h: s0.h, F: offset, adA: row, ek: s0.ek});
			} else {
				if (_Utils_eq(newOffset, -2)) {
					var $temp$isGood = isGood,
						$temp$offset = offset + 1,
						$temp$row = row + 1,
						$temp$col = 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				} else {
					var $temp$isGood = isGood,
						$temp$offset = newOffset,
						$temp$row = row,
						$temp$col = col + 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$chompWhile = function (isGood) {
	return function (s) {
		return A5($elm$parser$Parser$Advanced$chompWhileHelp, isGood, s.F, s.adA, s.rB, s);
	};
};
var $elm$parser$Parser$chompWhile = $elm$parser$Parser$Advanced$chompWhile;
var $elm$parser$Parser$Advanced$map2 = F3(
	function (func, _v0, _v1) {
		var parseA = _v0;
		var parseB = _v1;
		return function (s0) {
			var _v2 = parseA(s0);
			if (_v2.$ === 1) {
				var p = _v2.a;
				var x = _v2.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p1 = _v2.a;
				var a = _v2.b;
				var s1 = _v2.c;
				var _v3 = parseB(s1);
				if (_v3.$ === 1) {
					var p2 = _v3.a;
					var x = _v3.b;
					return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
				} else {
					var p2 = _v3.a;
					var b = _v3.b;
					var s2 = _v3.c;
					return A3(
						$elm$parser$Parser$Advanced$Good,
						p1 || p2,
						A2(func, a, b),
						s2);
				}
			}
		};
	});
var $elm$parser$Parser$Advanced$ignorer = F2(
	function (keepParser, ignoreParser) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$always, keepParser, ignoreParser);
	});
var $elm$parser$Parser$ignorer = $elm$parser$Parser$Advanced$ignorer;
var $hecrj$html_parser$Html$Parser$chompOneOrMore = function (fn) {
	return A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$chompIf(fn),
		$elm$parser$Parser$chompWhile(fn));
};
var $elm$parser$Parser$Advanced$mapChompedString = F2(
	function (func, _v0) {
		var parse = _v0;
		return function (s0) {
			var _v1 = parse(s0);
			if (_v1.$ === 1) {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				return A3(
					$elm$parser$Parser$Advanced$Good,
					p,
					A2(
						func,
						A3($elm$core$String$slice, s0.F, s1.F, s0.ek),
						a),
					s1);
			}
		};
	});
var $elm$parser$Parser$Advanced$getChompedString = function (parser) {
	return A2($elm$parser$Parser$Advanced$mapChompedString, $elm$core$Basics$always, parser);
};
var $elm$parser$Parser$getChompedString = $elm$parser$Parser$Advanced$getChompedString;
var $hecrj$html_parser$Html$Parser$isSpaceCharacter = function (c) {
	return (c === ' ') || ((c === '\t') || ((c === '\n') || ((c === '\u000D') || ((c === '\u000C') || (c === '\u00A0')))));
};
var $elm$parser$Parser$Problem = function (a) {
	return {$: 12, a: a};
};
var $elm$parser$Parser$Advanced$problem = function (x) {
	return function (s) {
		return A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, x));
	};
};
var $elm$parser$Parser$problem = function (msg) {
	return $elm$parser$Parser$Advanced$problem(
		$elm$parser$Parser$Problem(msg));
};
var $elm$parser$Parser$Advanced$succeed = function (a) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$Good, false, a, s);
	};
};
var $elm$parser$Parser$succeed = $elm$parser$Parser$Advanced$succeed;
var $elm$core$String$toLower = _String_toLower;
var $hecrj$html_parser$Html$Parser$closingTag = function (name) {
	var chompName = A2(
		$elm$parser$Parser$andThen,
		function (closingName) {
			return _Utils_eq(
				$elm$core$String$toLower(closingName),
				name) ? $elm$parser$Parser$succeed(0) : $elm$parser$Parser$problem('closing tag does not match opening tag: ' + name);
		},
		$elm$parser$Parser$getChompedString(
			$hecrj$html_parser$Html$Parser$chompOneOrMore(
				function (c) {
					return (!$hecrj$html_parser$Html$Parser$isSpaceCharacter(c)) && (c !== '>');
				})));
	return A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$chompIf(
						$elm$core$Basics$eq('<')),
					$elm$parser$Parser$chompIf(
						$elm$core$Basics$eq('/'))),
				chompName),
			$elm$parser$Parser$chompWhile($hecrj$html_parser$Html$Parser$isSpaceCharacter)),
		$elm$parser$Parser$chompIf(
			$elm$core$Basics$eq('>')));
};
var $hecrj$html_parser$Html$Parser$Comment = function (a) {
	return {$: 2, a: a};
};
var $elm$parser$Parser$Advanced$findSubString = _Parser_findSubString;
var $elm$parser$Parser$Advanced$fromInfo = F4(
	function (row, col, x, context) {
		return A2(
			$elm$parser$Parser$Advanced$AddRight,
			$elm$parser$Parser$Advanced$Empty,
			A4($elm$parser$Parser$Advanced$DeadEnd, row, col, x, context));
	});
var $elm$parser$Parser$Advanced$chompUntil = function (_v0) {
	var str = _v0.a;
	var expecting = _v0.b;
	return function (s) {
		var _v1 = A5($elm$parser$Parser$Advanced$findSubString, str, s.F, s.adA, s.rB, s.ek);
		var newOffset = _v1.a;
		var newRow = _v1.b;
		var newCol = _v1.c;
		return _Utils_eq(newOffset, -1) ? A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A4($elm$parser$Parser$Advanced$fromInfo, newRow, newCol, expecting, s.f)) : A3(
			$elm$parser$Parser$Advanced$Good,
			_Utils_cmp(s.F, newOffset) < 0,
			0,
			{rB: newCol, f: s.f, h: s.h, F: newOffset, adA: newRow, ek: s.ek});
	};
};
var $elm$parser$Parser$Expecting = function (a) {
	return {$: 0, a: a};
};
var $elm$parser$Parser$Advanced$Token = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$parser$Parser$toToken = function (str) {
	return A2(
		$elm$parser$Parser$Advanced$Token,
		str,
		$elm$parser$Parser$Expecting(str));
};
var $elm$parser$Parser$chompUntil = function (str) {
	return $elm$parser$Parser$Advanced$chompUntil(
		$elm$parser$Parser$toToken(str));
};
var $elm$parser$Parser$Advanced$keeper = F2(
	function (parseFunc, parseArg) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$apL, parseFunc, parseArg);
	});
var $elm$parser$Parser$keeper = $elm$parser$Parser$Advanced$keeper;
var $elm$parser$Parser$Advanced$isSubString = _Parser_isSubString;
var $elm$parser$Parser$Advanced$token = function (_v0) {
	var str = _v0.a;
	var expecting = _v0.b;
	var progress = !$elm$core$String$isEmpty(str);
	return function (s) {
		var _v1 = A5($elm$parser$Parser$Advanced$isSubString, str, s.F, s.adA, s.rB, s.ek);
		var newOffset = _v1.a;
		var newRow = _v1.b;
		var newCol = _v1.c;
		return _Utils_eq(newOffset, -1) ? A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : A3(
			$elm$parser$Parser$Advanced$Good,
			progress,
			0,
			{rB: newCol, f: s.f, h: s.h, F: newOffset, adA: newRow, ek: s.ek});
	};
};
var $elm$parser$Parser$token = function (str) {
	return $elm$parser$Parser$Advanced$token(
		$elm$parser$Parser$toToken(str));
};
var $hecrj$html_parser$Html$Parser$commentString = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed($elm$core$Basics$identity),
			$elm$parser$Parser$token('<!')),
		$elm$parser$Parser$token('--')),
	A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$getChompedString(
			$elm$parser$Parser$chompUntil('-->')),
		$elm$parser$Parser$token('-->')));
var $elm$parser$Parser$Advanced$map = F2(
	function (func, _v0) {
		var parse = _v0;
		return function (s0) {
			var _v1 = parse(s0);
			if (!_v1.$) {
				var p = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				return A3(
					$elm$parser$Parser$Advanced$Good,
					p,
					func(a),
					s1);
			} else {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			}
		};
	});
var $elm$parser$Parser$map = $elm$parser$Parser$Advanced$map;
var $hecrj$html_parser$Html$Parser$comment = A2($elm$parser$Parser$map, $hecrj$html_parser$Html$Parser$Comment, $hecrj$html_parser$Html$Parser$commentString);
var $hecrj$html_parser$Html$Parser$voidElements = _List_fromArray(
	['area', 'base', 'br', 'col', 'embed', 'hr', 'img', 'input', 'link', 'meta', 'param', 'source', 'track', 'wbr']);
var $hecrj$html_parser$Html$Parser$isVoidElement = function (name) {
	return A2($elm$core$List$member, name, $hecrj$html_parser$Html$Parser$voidElements);
};
var $elm$parser$Parser$Done = function (a) {
	return {$: 1, a: a};
};
var $elm$parser$Parser$Loop = function (a) {
	return {$: 0, a: a};
};
var $elm$parser$Parser$Advanced$loopHelp = F4(
	function (p, state, callback, s0) {
		loopHelp:
		while (true) {
			var _v0 = callback(state);
			var parse = _v0;
			var _v1 = parse(s0);
			if (!_v1.$) {
				var p1 = _v1.a;
				var step = _v1.b;
				var s1 = _v1.c;
				if (!step.$) {
					var newState = step.a;
					var $temp$p = p || p1,
						$temp$state = newState,
						$temp$callback = callback,
						$temp$s0 = s1;
					p = $temp$p;
					state = $temp$state;
					callback = $temp$callback;
					s0 = $temp$s0;
					continue loopHelp;
				} else {
					var result = step.a;
					return A3($elm$parser$Parser$Advanced$Good, p || p1, result, s1);
				}
			} else {
				var p1 = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p || p1, x);
			}
		}
	});
var $elm$parser$Parser$Advanced$loop = F2(
	function (state, callback) {
		return function (s) {
			return A4($elm$parser$Parser$Advanced$loopHelp, false, state, callback, s);
		};
	});
var $elm$parser$Parser$Advanced$Done = function (a) {
	return {$: 1, a: a};
};
var $elm$parser$Parser$Advanced$Loop = function (a) {
	return {$: 0, a: a};
};
var $elm$parser$Parser$toAdvancedStep = function (step) {
	if (!step.$) {
		var s = step.a;
		return $elm$parser$Parser$Advanced$Loop(s);
	} else {
		var a = step.a;
		return $elm$parser$Parser$Advanced$Done(a);
	}
};
var $elm$parser$Parser$loop = F2(
	function (state, callback) {
		return A2(
			$elm$parser$Parser$Advanced$loop,
			state,
			function (s) {
				return A2(
					$elm$parser$Parser$map,
					$elm$parser$Parser$toAdvancedStep,
					callback(s));
			});
	});
var $elm$parser$Parser$Advanced$Append = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$oneOfHelp = F3(
	function (s0, bag, parsers) {
		oneOfHelp:
		while (true) {
			if (!parsers.b) {
				return A2($elm$parser$Parser$Advanced$Bad, false, bag);
			} else {
				var parse = parsers.a;
				var remainingParsers = parsers.b;
				var _v1 = parse(s0);
				if (!_v1.$) {
					var step = _v1;
					return step;
				} else {
					var step = _v1;
					var p = step.a;
					var x = step.b;
					if (p) {
						return step;
					} else {
						var $temp$s0 = s0,
							$temp$bag = A2($elm$parser$Parser$Advanced$Append, bag, x),
							$temp$parsers = remainingParsers;
						s0 = $temp$s0;
						bag = $temp$bag;
						parsers = $temp$parsers;
						continue oneOfHelp;
					}
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$oneOf = function (parsers) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$oneOfHelp, s, $elm$parser$Parser$Advanced$Empty, parsers);
	};
};
var $elm$parser$Parser$oneOf = $elm$parser$Parser$Advanced$oneOf;
var $hecrj$html_parser$Html$Parser$many = function (parser_) {
	return A2(
		$elm$parser$Parser$loop,
		_List_Nil,
		function (list) {
			return $elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						A2(
						$elm$parser$Parser$map,
						function (_new) {
							return $elm$parser$Parser$Loop(
								A2($elm$core$List$cons, _new, list));
						},
						parser_),
						$elm$parser$Parser$succeed(
						$elm$parser$Parser$Done(
							$elm$core$List$reverse(list)))
					]));
		});
};
var $hecrj$html_parser$Html$Parser$isTagAttributeCharacter = function (c) {
	return (!$hecrj$html_parser$Html$Parser$isSpaceCharacter(c)) && ((c !== '\"') && ((c !== '\'') && ((c !== '>') && ((c !== '/') && (c !== '=')))));
};
var $hecrj$html_parser$Html$Parser$tagAttributeName = A2(
	$elm$parser$Parser$map,
	$elm$core$String$toLower,
	$elm$parser$Parser$getChompedString(
		$hecrj$html_parser$Html$Parser$chompOneOrMore($hecrj$html_parser$Html$Parser$isTagAttributeCharacter)));
var $hecrj$html_parser$Html$Parser$chompSemicolon = $elm$parser$Parser$chompIf(
	$elm$core$Basics$eq(';'));
var $hecrj$html_parser$Html$Parser$NamedCharacterReferences$dict = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2('Aacute', 'Á'),
			_Utils_Tuple2('aacute', 'á'),
			_Utils_Tuple2('Abreve', 'Ă'),
			_Utils_Tuple2('abreve', 'ă'),
			_Utils_Tuple2('ac', '∾'),
			_Utils_Tuple2('acd', '∿'),
			_Utils_Tuple2('acE', '∾̳'),
			_Utils_Tuple2('Acirc', 'Â'),
			_Utils_Tuple2('acirc', 'â'),
			_Utils_Tuple2('acute', '´'),
			_Utils_Tuple2('Acy', 'А'),
			_Utils_Tuple2('acy', 'а'),
			_Utils_Tuple2('AElig', 'Æ'),
			_Utils_Tuple2('aelig', 'æ'),
			_Utils_Tuple2('af', '\u2061'),
			_Utils_Tuple2('Afr', '\uD835\uDD04'),
			_Utils_Tuple2('afr', '\uD835\uDD1E'),
			_Utils_Tuple2('Agrave', 'À'),
			_Utils_Tuple2('agrave', 'à'),
			_Utils_Tuple2('alefsym', 'ℵ'),
			_Utils_Tuple2('aleph', 'ℵ'),
			_Utils_Tuple2('Alpha', 'Α'),
			_Utils_Tuple2('alpha', 'α'),
			_Utils_Tuple2('Amacr', 'Ā'),
			_Utils_Tuple2('amacr', 'ā'),
			_Utils_Tuple2('amalg', '⨿'),
			_Utils_Tuple2('amp', '&'),
			_Utils_Tuple2('AMP', '&'),
			_Utils_Tuple2('andand', '⩕'),
			_Utils_Tuple2('And', '⩓'),
			_Utils_Tuple2('and', '∧'),
			_Utils_Tuple2('andd', '⩜'),
			_Utils_Tuple2('andslope', '⩘'),
			_Utils_Tuple2('andv', '⩚'),
			_Utils_Tuple2('ang', '∠'),
			_Utils_Tuple2('ange', '⦤'),
			_Utils_Tuple2('angle', '∠'),
			_Utils_Tuple2('angmsdaa', '⦨'),
			_Utils_Tuple2('angmsdab', '⦩'),
			_Utils_Tuple2('angmsdac', '⦪'),
			_Utils_Tuple2('angmsdad', '⦫'),
			_Utils_Tuple2('angmsdae', '⦬'),
			_Utils_Tuple2('angmsdaf', '⦭'),
			_Utils_Tuple2('angmsdag', '⦮'),
			_Utils_Tuple2('angmsdah', '⦯'),
			_Utils_Tuple2('angmsd', '∡'),
			_Utils_Tuple2('angrt', '∟'),
			_Utils_Tuple2('angrtvb', '⊾'),
			_Utils_Tuple2('angrtvbd', '⦝'),
			_Utils_Tuple2('angsph', '∢'),
			_Utils_Tuple2('angst', 'Å'),
			_Utils_Tuple2('angzarr', '⍼'),
			_Utils_Tuple2('Aogon', 'Ą'),
			_Utils_Tuple2('aogon', 'ą'),
			_Utils_Tuple2('Aopf', '\uD835\uDD38'),
			_Utils_Tuple2('aopf', '\uD835\uDD52'),
			_Utils_Tuple2('apacir', '⩯'),
			_Utils_Tuple2('ap', '≈'),
			_Utils_Tuple2('apE', '⩰'),
			_Utils_Tuple2('ape', '≊'),
			_Utils_Tuple2('apid', '≋'),
			_Utils_Tuple2('apos', '\''),
			_Utils_Tuple2('ApplyFunction', '\u2061'),
			_Utils_Tuple2('approx', '≈'),
			_Utils_Tuple2('approxeq', '≊'),
			_Utils_Tuple2('Aring', 'Å'),
			_Utils_Tuple2('aring', 'å'),
			_Utils_Tuple2('Ascr', '\uD835\uDC9C'),
			_Utils_Tuple2('ascr', '\uD835\uDCB6'),
			_Utils_Tuple2('Assign', '≔'),
			_Utils_Tuple2('ast', '*'),
			_Utils_Tuple2('asymp', '≈'),
			_Utils_Tuple2('asympeq', '≍'),
			_Utils_Tuple2('Atilde', 'Ã'),
			_Utils_Tuple2('atilde', 'ã'),
			_Utils_Tuple2('Auml', 'Ä'),
			_Utils_Tuple2('auml', 'ä'),
			_Utils_Tuple2('awconint', '∳'),
			_Utils_Tuple2('awint', '⨑'),
			_Utils_Tuple2('backcong', '≌'),
			_Utils_Tuple2('backepsilon', '϶'),
			_Utils_Tuple2('backprime', '‵'),
			_Utils_Tuple2('backsim', '∽'),
			_Utils_Tuple2('backsimeq', '⋍'),
			_Utils_Tuple2('Backslash', '∖'),
			_Utils_Tuple2('Barv', '⫧'),
			_Utils_Tuple2('barvee', '⊽'),
			_Utils_Tuple2('barwed', '⌅'),
			_Utils_Tuple2('Barwed', '⌆'),
			_Utils_Tuple2('barwedge', '⌅'),
			_Utils_Tuple2('bbrk', '⎵'),
			_Utils_Tuple2('bbrktbrk', '⎶'),
			_Utils_Tuple2('bcong', '≌'),
			_Utils_Tuple2('Bcy', 'Б'),
			_Utils_Tuple2('bcy', 'б'),
			_Utils_Tuple2('bdquo', '„'),
			_Utils_Tuple2('becaus', '∵'),
			_Utils_Tuple2('because', '∵'),
			_Utils_Tuple2('Because', '∵'),
			_Utils_Tuple2('bemptyv', '⦰'),
			_Utils_Tuple2('bepsi', '϶'),
			_Utils_Tuple2('bernou', 'ℬ'),
			_Utils_Tuple2('Bernoullis', 'ℬ'),
			_Utils_Tuple2('Beta', 'Β'),
			_Utils_Tuple2('beta', 'β'),
			_Utils_Tuple2('beth', 'ℶ'),
			_Utils_Tuple2('between', '≬'),
			_Utils_Tuple2('Bfr', '\uD835\uDD05'),
			_Utils_Tuple2('bfr', '\uD835\uDD1F'),
			_Utils_Tuple2('bigcap', '⋂'),
			_Utils_Tuple2('bigcirc', '◯'),
			_Utils_Tuple2('bigcup', '⋃'),
			_Utils_Tuple2('bigodot', '⨀'),
			_Utils_Tuple2('bigoplus', '⨁'),
			_Utils_Tuple2('bigotimes', '⨂'),
			_Utils_Tuple2('bigsqcup', '⨆'),
			_Utils_Tuple2('bigstar', '★'),
			_Utils_Tuple2('bigtriangledown', '▽'),
			_Utils_Tuple2('bigtriangleup', '△'),
			_Utils_Tuple2('biguplus', '⨄'),
			_Utils_Tuple2('bigvee', '⋁'),
			_Utils_Tuple2('bigwedge', '⋀'),
			_Utils_Tuple2('bkarow', '⤍'),
			_Utils_Tuple2('blacklozenge', '⧫'),
			_Utils_Tuple2('blacksquare', '▪'),
			_Utils_Tuple2('blacktriangle', '▴'),
			_Utils_Tuple2('blacktriangledown', '▾'),
			_Utils_Tuple2('blacktriangleleft', '◂'),
			_Utils_Tuple2('blacktriangleright', '▸'),
			_Utils_Tuple2('blank', '␣'),
			_Utils_Tuple2('blk12', '▒'),
			_Utils_Tuple2('blk14', '░'),
			_Utils_Tuple2('blk34', '▓'),
			_Utils_Tuple2('block', '█'),
			_Utils_Tuple2('bne', '=⃥'),
			_Utils_Tuple2('bnequiv', '≡⃥'),
			_Utils_Tuple2('bNot', '⫭'),
			_Utils_Tuple2('bnot', '⌐'),
			_Utils_Tuple2('Bopf', '\uD835\uDD39'),
			_Utils_Tuple2('bopf', '\uD835\uDD53'),
			_Utils_Tuple2('bot', '⊥'),
			_Utils_Tuple2('bottom', '⊥'),
			_Utils_Tuple2('bowtie', '⋈'),
			_Utils_Tuple2('boxbox', '⧉'),
			_Utils_Tuple2('boxdl', '┐'),
			_Utils_Tuple2('boxdL', '╕'),
			_Utils_Tuple2('boxDl', '╖'),
			_Utils_Tuple2('boxDL', '╗'),
			_Utils_Tuple2('boxdr', '┌'),
			_Utils_Tuple2('boxdR', '╒'),
			_Utils_Tuple2('boxDr', '╓'),
			_Utils_Tuple2('boxDR', '╔'),
			_Utils_Tuple2('boxh', '─'),
			_Utils_Tuple2('boxH', '═'),
			_Utils_Tuple2('boxhd', '┬'),
			_Utils_Tuple2('boxHd', '╤'),
			_Utils_Tuple2('boxhD', '╥'),
			_Utils_Tuple2('boxHD', '╦'),
			_Utils_Tuple2('boxhu', '┴'),
			_Utils_Tuple2('boxHu', '╧'),
			_Utils_Tuple2('boxhU', '╨'),
			_Utils_Tuple2('boxHU', '╩'),
			_Utils_Tuple2('boxminus', '⊟'),
			_Utils_Tuple2('boxplus', '⊞'),
			_Utils_Tuple2('boxtimes', '⊠'),
			_Utils_Tuple2('boxul', '┘'),
			_Utils_Tuple2('boxuL', '╛'),
			_Utils_Tuple2('boxUl', '╜'),
			_Utils_Tuple2('boxUL', '╝'),
			_Utils_Tuple2('boxur', '└'),
			_Utils_Tuple2('boxuR', '╘'),
			_Utils_Tuple2('boxUr', '╙'),
			_Utils_Tuple2('boxUR', '╚'),
			_Utils_Tuple2('boxv', '│'),
			_Utils_Tuple2('boxV', '║'),
			_Utils_Tuple2('boxvh', '┼'),
			_Utils_Tuple2('boxvH', '╪'),
			_Utils_Tuple2('boxVh', '╫'),
			_Utils_Tuple2('boxVH', '╬'),
			_Utils_Tuple2('boxvl', '┤'),
			_Utils_Tuple2('boxvL', '╡'),
			_Utils_Tuple2('boxVl', '╢'),
			_Utils_Tuple2('boxVL', '╣'),
			_Utils_Tuple2('boxvr', '├'),
			_Utils_Tuple2('boxvR', '╞'),
			_Utils_Tuple2('boxVr', '╟'),
			_Utils_Tuple2('boxVR', '╠'),
			_Utils_Tuple2('bprime', '‵'),
			_Utils_Tuple2('breve', '˘'),
			_Utils_Tuple2('Breve', '˘'),
			_Utils_Tuple2('brvbar', '¦'),
			_Utils_Tuple2('bscr', '\uD835\uDCB7'),
			_Utils_Tuple2('Bscr', 'ℬ'),
			_Utils_Tuple2('bsemi', '⁏'),
			_Utils_Tuple2('bsim', '∽'),
			_Utils_Tuple2('bsime', '⋍'),
			_Utils_Tuple2('bsolb', '⧅'),
			_Utils_Tuple2('bsol', '\\'),
			_Utils_Tuple2('bsolhsub', '⟈'),
			_Utils_Tuple2('bull', '•'),
			_Utils_Tuple2('bullet', '•'),
			_Utils_Tuple2('bump', '≎'),
			_Utils_Tuple2('bumpE', '⪮'),
			_Utils_Tuple2('bumpe', '≏'),
			_Utils_Tuple2('Bumpeq', '≎'),
			_Utils_Tuple2('bumpeq', '≏'),
			_Utils_Tuple2('Cacute', 'Ć'),
			_Utils_Tuple2('cacute', 'ć'),
			_Utils_Tuple2('capand', '⩄'),
			_Utils_Tuple2('capbrcup', '⩉'),
			_Utils_Tuple2('capcap', '⩋'),
			_Utils_Tuple2('cap', '∩'),
			_Utils_Tuple2('Cap', '⋒'),
			_Utils_Tuple2('capcup', '⩇'),
			_Utils_Tuple2('capdot', '⩀'),
			_Utils_Tuple2('CapitalDifferentialD', 'ⅅ'),
			_Utils_Tuple2('caps', '∩︀'),
			_Utils_Tuple2('caret', '⁁'),
			_Utils_Tuple2('caron', 'ˇ'),
			_Utils_Tuple2('Cayleys', 'ℭ'),
			_Utils_Tuple2('ccaps', '⩍'),
			_Utils_Tuple2('Ccaron', 'Č'),
			_Utils_Tuple2('ccaron', 'č'),
			_Utils_Tuple2('Ccedil', 'Ç'),
			_Utils_Tuple2('ccedil', 'ç'),
			_Utils_Tuple2('Ccirc', 'Ĉ'),
			_Utils_Tuple2('ccirc', 'ĉ'),
			_Utils_Tuple2('Cconint', '∰'),
			_Utils_Tuple2('ccups', '⩌'),
			_Utils_Tuple2('ccupssm', '⩐'),
			_Utils_Tuple2('Cdot', 'Ċ'),
			_Utils_Tuple2('cdot', 'ċ'),
			_Utils_Tuple2('cedil', '¸'),
			_Utils_Tuple2('Cedilla', '¸'),
			_Utils_Tuple2('cemptyv', '⦲'),
			_Utils_Tuple2('cent', '¢'),
			_Utils_Tuple2('centerdot', '·'),
			_Utils_Tuple2('CenterDot', '·'),
			_Utils_Tuple2('cfr', '\uD835\uDD20'),
			_Utils_Tuple2('Cfr', 'ℭ'),
			_Utils_Tuple2('CHcy', 'Ч'),
			_Utils_Tuple2('chcy', 'ч'),
			_Utils_Tuple2('check', '✓'),
			_Utils_Tuple2('checkmark', '✓'),
			_Utils_Tuple2('Chi', 'Χ'),
			_Utils_Tuple2('chi', 'χ'),
			_Utils_Tuple2('circ', 'ˆ'),
			_Utils_Tuple2('circeq', '≗'),
			_Utils_Tuple2('circlearrowleft', '↺'),
			_Utils_Tuple2('circlearrowright', '↻'),
			_Utils_Tuple2('circledast', '⊛'),
			_Utils_Tuple2('circledcirc', '⊚'),
			_Utils_Tuple2('circleddash', '⊝'),
			_Utils_Tuple2('CircleDot', '⊙'),
			_Utils_Tuple2('circledR', '®'),
			_Utils_Tuple2('circledS', 'Ⓢ'),
			_Utils_Tuple2('CircleMinus', '⊖'),
			_Utils_Tuple2('CirclePlus', '⊕'),
			_Utils_Tuple2('CircleTimes', '⊗'),
			_Utils_Tuple2('cir', '○'),
			_Utils_Tuple2('cirE', '⧃'),
			_Utils_Tuple2('cire', '≗'),
			_Utils_Tuple2('cirfnint', '⨐'),
			_Utils_Tuple2('cirmid', '⫯'),
			_Utils_Tuple2('cirscir', '⧂'),
			_Utils_Tuple2('ClockwiseContourIntegral', '∲'),
			_Utils_Tuple2('CloseCurlyDoubleQuote', '”'),
			_Utils_Tuple2('CloseCurlyQuote', '’'),
			_Utils_Tuple2('clubs', '♣'),
			_Utils_Tuple2('clubsuit', '♣'),
			_Utils_Tuple2('colon', ':'),
			_Utils_Tuple2('Colon', '∷'),
			_Utils_Tuple2('Colone', '⩴'),
			_Utils_Tuple2('colone', '≔'),
			_Utils_Tuple2('coloneq', '≔'),
			_Utils_Tuple2('comma', ','),
			_Utils_Tuple2('commat', '@'),
			_Utils_Tuple2('comp', '∁'),
			_Utils_Tuple2('compfn', '∘'),
			_Utils_Tuple2('complement', '∁'),
			_Utils_Tuple2('complexes', 'ℂ'),
			_Utils_Tuple2('cong', '≅'),
			_Utils_Tuple2('congdot', '⩭'),
			_Utils_Tuple2('Congruent', '≡'),
			_Utils_Tuple2('conint', '∮'),
			_Utils_Tuple2('Conint', '∯'),
			_Utils_Tuple2('ContourIntegral', '∮'),
			_Utils_Tuple2('copf', '\uD835\uDD54'),
			_Utils_Tuple2('Copf', 'ℂ'),
			_Utils_Tuple2('coprod', '∐'),
			_Utils_Tuple2('Coproduct', '∐'),
			_Utils_Tuple2('copy', '©'),
			_Utils_Tuple2('COPY', '©'),
			_Utils_Tuple2('copysr', '℗'),
			_Utils_Tuple2('CounterClockwiseContourIntegral', '∳'),
			_Utils_Tuple2('crarr', '↵'),
			_Utils_Tuple2('cross', '✗'),
			_Utils_Tuple2('Cross', '⨯'),
			_Utils_Tuple2('Cscr', '\uD835\uDC9E'),
			_Utils_Tuple2('cscr', '\uD835\uDCB8'),
			_Utils_Tuple2('csub', '⫏'),
			_Utils_Tuple2('csube', '⫑'),
			_Utils_Tuple2('csup', '⫐'),
			_Utils_Tuple2('csupe', '⫒'),
			_Utils_Tuple2('ctdot', '⋯'),
			_Utils_Tuple2('cudarrl', '⤸'),
			_Utils_Tuple2('cudarrr', '⤵'),
			_Utils_Tuple2('cuepr', '⋞'),
			_Utils_Tuple2('cuesc', '⋟'),
			_Utils_Tuple2('cularr', '↶'),
			_Utils_Tuple2('cularrp', '⤽'),
			_Utils_Tuple2('cupbrcap', '⩈'),
			_Utils_Tuple2('cupcap', '⩆'),
			_Utils_Tuple2('CupCap', '≍'),
			_Utils_Tuple2('cup', '∪'),
			_Utils_Tuple2('Cup', '⋓'),
			_Utils_Tuple2('cupcup', '⩊'),
			_Utils_Tuple2('cupdot', '⊍'),
			_Utils_Tuple2('cupor', '⩅'),
			_Utils_Tuple2('cups', '∪︀'),
			_Utils_Tuple2('curarr', '↷'),
			_Utils_Tuple2('curarrm', '⤼'),
			_Utils_Tuple2('curlyeqprec', '⋞'),
			_Utils_Tuple2('curlyeqsucc', '⋟'),
			_Utils_Tuple2('curlyvee', '⋎'),
			_Utils_Tuple2('curlywedge', '⋏'),
			_Utils_Tuple2('curren', '¤'),
			_Utils_Tuple2('curvearrowleft', '↶'),
			_Utils_Tuple2('curvearrowright', '↷'),
			_Utils_Tuple2('cuvee', '⋎'),
			_Utils_Tuple2('cuwed', '⋏'),
			_Utils_Tuple2('cwconint', '∲'),
			_Utils_Tuple2('cwint', '∱'),
			_Utils_Tuple2('cylcty', '⌭'),
			_Utils_Tuple2('dagger', '†'),
			_Utils_Tuple2('Dagger', '‡'),
			_Utils_Tuple2('daleth', 'ℸ'),
			_Utils_Tuple2('darr', '↓'),
			_Utils_Tuple2('Darr', '↡'),
			_Utils_Tuple2('dArr', '⇓'),
			_Utils_Tuple2('dash', '‐'),
			_Utils_Tuple2('Dashv', '⫤'),
			_Utils_Tuple2('dashv', '⊣'),
			_Utils_Tuple2('dbkarow', '⤏'),
			_Utils_Tuple2('dblac', '˝'),
			_Utils_Tuple2('Dcaron', 'Ď'),
			_Utils_Tuple2('dcaron', 'ď'),
			_Utils_Tuple2('Dcy', 'Д'),
			_Utils_Tuple2('dcy', 'д'),
			_Utils_Tuple2('ddagger', '‡'),
			_Utils_Tuple2('ddarr', '⇊'),
			_Utils_Tuple2('DD', 'ⅅ'),
			_Utils_Tuple2('dd', 'ⅆ'),
			_Utils_Tuple2('DDotrahd', '⤑'),
			_Utils_Tuple2('ddotseq', '⩷'),
			_Utils_Tuple2('deg', '°'),
			_Utils_Tuple2('Del', '∇'),
			_Utils_Tuple2('Delta', 'Δ'),
			_Utils_Tuple2('delta', 'δ'),
			_Utils_Tuple2('demptyv', '⦱'),
			_Utils_Tuple2('dfisht', '⥿'),
			_Utils_Tuple2('Dfr', '\uD835\uDD07'),
			_Utils_Tuple2('dfr', '\uD835\uDD21'),
			_Utils_Tuple2('dHar', '⥥'),
			_Utils_Tuple2('dharl', '⇃'),
			_Utils_Tuple2('dharr', '⇂'),
			_Utils_Tuple2('DiacriticalAcute', '´'),
			_Utils_Tuple2('DiacriticalDot', '˙'),
			_Utils_Tuple2('DiacriticalDoubleAcute', '˝'),
			_Utils_Tuple2('DiacriticalGrave', '`'),
			_Utils_Tuple2('DiacriticalTilde', '˜'),
			_Utils_Tuple2('diam', '⋄'),
			_Utils_Tuple2('diamond', '⋄'),
			_Utils_Tuple2('Diamond', '⋄'),
			_Utils_Tuple2('diamondsuit', '♦'),
			_Utils_Tuple2('diams', '♦'),
			_Utils_Tuple2('die', '¨'),
			_Utils_Tuple2('DifferentialD', 'ⅆ'),
			_Utils_Tuple2('digamma', 'ϝ'),
			_Utils_Tuple2('disin', '⋲'),
			_Utils_Tuple2('div', '÷'),
			_Utils_Tuple2('divide', '÷'),
			_Utils_Tuple2('divideontimes', '⋇'),
			_Utils_Tuple2('divonx', '⋇'),
			_Utils_Tuple2('DJcy', 'Ђ'),
			_Utils_Tuple2('djcy', 'ђ'),
			_Utils_Tuple2('dlcorn', '⌞'),
			_Utils_Tuple2('dlcrop', '⌍'),
			_Utils_Tuple2('dollar', '$'),
			_Utils_Tuple2('Dopf', '\uD835\uDD3B'),
			_Utils_Tuple2('dopf', '\uD835\uDD55'),
			_Utils_Tuple2('Dot', '¨'),
			_Utils_Tuple2('dot', '˙'),
			_Utils_Tuple2('DotDot', '⃜'),
			_Utils_Tuple2('doteq', '≐'),
			_Utils_Tuple2('doteqdot', '≑'),
			_Utils_Tuple2('DotEqual', '≐'),
			_Utils_Tuple2('dotminus', '∸'),
			_Utils_Tuple2('dotplus', '∔'),
			_Utils_Tuple2('dotsquare', '⊡'),
			_Utils_Tuple2('doublebarwedge', '⌆'),
			_Utils_Tuple2('DoubleContourIntegral', '∯'),
			_Utils_Tuple2('DoubleDot', '¨'),
			_Utils_Tuple2('DoubleDownArrow', '⇓'),
			_Utils_Tuple2('DoubleLeftArrow', '⇐'),
			_Utils_Tuple2('DoubleLeftRightArrow', '⇔'),
			_Utils_Tuple2('DoubleLeftTee', '⫤'),
			_Utils_Tuple2('DoubleLongLeftArrow', '⟸'),
			_Utils_Tuple2('DoubleLongLeftRightArrow', '⟺'),
			_Utils_Tuple2('DoubleLongRightArrow', '⟹'),
			_Utils_Tuple2('DoubleRightArrow', '⇒'),
			_Utils_Tuple2('DoubleRightTee', '⊨'),
			_Utils_Tuple2('DoubleUpArrow', '⇑'),
			_Utils_Tuple2('DoubleUpDownArrow', '⇕'),
			_Utils_Tuple2('DoubleVerticalBar', '∥'),
			_Utils_Tuple2('DownArrowBar', '⤓'),
			_Utils_Tuple2('downarrow', '↓'),
			_Utils_Tuple2('DownArrow', '↓'),
			_Utils_Tuple2('Downarrow', '⇓'),
			_Utils_Tuple2('DownArrowUpArrow', '⇵'),
			_Utils_Tuple2('DownBreve', '̑'),
			_Utils_Tuple2('downdownarrows', '⇊'),
			_Utils_Tuple2('downharpoonleft', '⇃'),
			_Utils_Tuple2('downharpoonright', '⇂'),
			_Utils_Tuple2('DownLeftRightVector', '⥐'),
			_Utils_Tuple2('DownLeftTeeVector', '⥞'),
			_Utils_Tuple2('DownLeftVectorBar', '⥖'),
			_Utils_Tuple2('DownLeftVector', '↽'),
			_Utils_Tuple2('DownRightTeeVector', '⥟'),
			_Utils_Tuple2('DownRightVectorBar', '⥗'),
			_Utils_Tuple2('DownRightVector', '⇁'),
			_Utils_Tuple2('DownTeeArrow', '↧'),
			_Utils_Tuple2('DownTee', '⊤'),
			_Utils_Tuple2('drbkarow', '⤐'),
			_Utils_Tuple2('drcorn', '⌟'),
			_Utils_Tuple2('drcrop', '⌌'),
			_Utils_Tuple2('Dscr', '\uD835\uDC9F'),
			_Utils_Tuple2('dscr', '\uD835\uDCB9'),
			_Utils_Tuple2('DScy', 'Ѕ'),
			_Utils_Tuple2('dscy', 'ѕ'),
			_Utils_Tuple2('dsol', '⧶'),
			_Utils_Tuple2('Dstrok', 'Đ'),
			_Utils_Tuple2('dstrok', 'đ'),
			_Utils_Tuple2('dtdot', '⋱'),
			_Utils_Tuple2('dtri', '▿'),
			_Utils_Tuple2('dtrif', '▾'),
			_Utils_Tuple2('duarr', '⇵'),
			_Utils_Tuple2('duhar', '⥯'),
			_Utils_Tuple2('dwangle', '⦦'),
			_Utils_Tuple2('DZcy', 'Џ'),
			_Utils_Tuple2('dzcy', 'џ'),
			_Utils_Tuple2('dzigrarr', '⟿'),
			_Utils_Tuple2('Eacute', 'É'),
			_Utils_Tuple2('eacute', 'é'),
			_Utils_Tuple2('easter', '⩮'),
			_Utils_Tuple2('Ecaron', 'Ě'),
			_Utils_Tuple2('ecaron', 'ě'),
			_Utils_Tuple2('Ecirc', 'Ê'),
			_Utils_Tuple2('ecirc', 'ê'),
			_Utils_Tuple2('ecir', '≖'),
			_Utils_Tuple2('ecolon', '≕'),
			_Utils_Tuple2('Ecy', 'Э'),
			_Utils_Tuple2('ecy', 'э'),
			_Utils_Tuple2('eDDot', '⩷'),
			_Utils_Tuple2('Edot', 'Ė'),
			_Utils_Tuple2('edot', 'ė'),
			_Utils_Tuple2('eDot', '≑'),
			_Utils_Tuple2('ee', 'ⅇ'),
			_Utils_Tuple2('efDot', '≒'),
			_Utils_Tuple2('Efr', '\uD835\uDD08'),
			_Utils_Tuple2('efr', '\uD835\uDD22'),
			_Utils_Tuple2('eg', '⪚'),
			_Utils_Tuple2('Egrave', 'È'),
			_Utils_Tuple2('egrave', 'è'),
			_Utils_Tuple2('egs', '⪖'),
			_Utils_Tuple2('egsdot', '⪘'),
			_Utils_Tuple2('el', '⪙'),
			_Utils_Tuple2('Element', '∈'),
			_Utils_Tuple2('elinters', '⏧'),
			_Utils_Tuple2('ell', 'ℓ'),
			_Utils_Tuple2('els', '⪕'),
			_Utils_Tuple2('elsdot', '⪗'),
			_Utils_Tuple2('Emacr', 'Ē'),
			_Utils_Tuple2('emacr', 'ē'),
			_Utils_Tuple2('empty', '∅'),
			_Utils_Tuple2('emptyset', '∅'),
			_Utils_Tuple2('EmptySmallSquare', '◻'),
			_Utils_Tuple2('emptyv', '∅'),
			_Utils_Tuple2('EmptyVerySmallSquare', '▫'),
			_Utils_Tuple2('emsp13', '\u2004'),
			_Utils_Tuple2('emsp14', '\u2005'),
			_Utils_Tuple2('emsp', '\u2003'),
			_Utils_Tuple2('ENG', 'Ŋ'),
			_Utils_Tuple2('eng', 'ŋ'),
			_Utils_Tuple2('ensp', '\u2002'),
			_Utils_Tuple2('Eogon', 'Ę'),
			_Utils_Tuple2('eogon', 'ę'),
			_Utils_Tuple2('Eopf', '\uD835\uDD3C'),
			_Utils_Tuple2('eopf', '\uD835\uDD56'),
			_Utils_Tuple2('epar', '⋕'),
			_Utils_Tuple2('eparsl', '⧣'),
			_Utils_Tuple2('eplus', '⩱'),
			_Utils_Tuple2('epsi', 'ε'),
			_Utils_Tuple2('Epsilon', 'Ε'),
			_Utils_Tuple2('epsilon', 'ε'),
			_Utils_Tuple2('epsiv', 'ϵ'),
			_Utils_Tuple2('eqcirc', '≖'),
			_Utils_Tuple2('eqcolon', '≕'),
			_Utils_Tuple2('eqsim', '≂'),
			_Utils_Tuple2('eqslantgtr', '⪖'),
			_Utils_Tuple2('eqslantless', '⪕'),
			_Utils_Tuple2('Equal', '⩵'),
			_Utils_Tuple2('equals', '='),
			_Utils_Tuple2('EqualTilde', '≂'),
			_Utils_Tuple2('equest', '≟'),
			_Utils_Tuple2('Equilibrium', '⇌'),
			_Utils_Tuple2('equiv', '≡'),
			_Utils_Tuple2('equivDD', '⩸'),
			_Utils_Tuple2('eqvparsl', '⧥'),
			_Utils_Tuple2('erarr', '⥱'),
			_Utils_Tuple2('erDot', '≓'),
			_Utils_Tuple2('escr', 'ℯ'),
			_Utils_Tuple2('Escr', 'ℰ'),
			_Utils_Tuple2('esdot', '≐'),
			_Utils_Tuple2('Esim', '⩳'),
			_Utils_Tuple2('esim', '≂'),
			_Utils_Tuple2('Eta', 'Η'),
			_Utils_Tuple2('eta', 'η'),
			_Utils_Tuple2('ETH', 'Ð'),
			_Utils_Tuple2('eth', 'ð'),
			_Utils_Tuple2('Euml', 'Ë'),
			_Utils_Tuple2('euml', 'ë'),
			_Utils_Tuple2('euro', '€'),
			_Utils_Tuple2('excl', '!'),
			_Utils_Tuple2('exist', '∃'),
			_Utils_Tuple2('Exists', '∃'),
			_Utils_Tuple2('expectation', 'ℰ'),
			_Utils_Tuple2('exponentiale', 'ⅇ'),
			_Utils_Tuple2('ExponentialE', 'ⅇ'),
			_Utils_Tuple2('fallingdotseq', '≒'),
			_Utils_Tuple2('Fcy', 'Ф'),
			_Utils_Tuple2('fcy', 'ф'),
			_Utils_Tuple2('female', '♀'),
			_Utils_Tuple2('ffilig', 'ﬃ'),
			_Utils_Tuple2('fflig', 'ﬀ'),
			_Utils_Tuple2('ffllig', 'ﬄ'),
			_Utils_Tuple2('Ffr', '\uD835\uDD09'),
			_Utils_Tuple2('ffr', '\uD835\uDD23'),
			_Utils_Tuple2('filig', 'ﬁ'),
			_Utils_Tuple2('FilledSmallSquare', '◼'),
			_Utils_Tuple2('FilledVerySmallSquare', '▪'),
			_Utils_Tuple2('fjlig', 'fj'),
			_Utils_Tuple2('flat', '♭'),
			_Utils_Tuple2('fllig', 'ﬂ'),
			_Utils_Tuple2('fltns', '▱'),
			_Utils_Tuple2('fnof', 'ƒ'),
			_Utils_Tuple2('Fopf', '\uD835\uDD3D'),
			_Utils_Tuple2('fopf', '\uD835\uDD57'),
			_Utils_Tuple2('forall', '∀'),
			_Utils_Tuple2('ForAll', '∀'),
			_Utils_Tuple2('fork', '⋔'),
			_Utils_Tuple2('forkv', '⫙'),
			_Utils_Tuple2('Fouriertrf', 'ℱ'),
			_Utils_Tuple2('fpartint', '⨍'),
			_Utils_Tuple2('frac12', '½'),
			_Utils_Tuple2('frac13', '⅓'),
			_Utils_Tuple2('frac14', '¼'),
			_Utils_Tuple2('frac15', '⅕'),
			_Utils_Tuple2('frac16', '⅙'),
			_Utils_Tuple2('frac18', '⅛'),
			_Utils_Tuple2('frac23', '⅔'),
			_Utils_Tuple2('frac25', '⅖'),
			_Utils_Tuple2('frac34', '¾'),
			_Utils_Tuple2('frac35', '⅗'),
			_Utils_Tuple2('frac38', '⅜'),
			_Utils_Tuple2('frac45', '⅘'),
			_Utils_Tuple2('frac56', '⅚'),
			_Utils_Tuple2('frac58', '⅝'),
			_Utils_Tuple2('frac78', '⅞'),
			_Utils_Tuple2('frasl', '⁄'),
			_Utils_Tuple2('frown', '⌢'),
			_Utils_Tuple2('fscr', '\uD835\uDCBB'),
			_Utils_Tuple2('Fscr', 'ℱ'),
			_Utils_Tuple2('gacute', 'ǵ'),
			_Utils_Tuple2('Gamma', 'Γ'),
			_Utils_Tuple2('gamma', 'γ'),
			_Utils_Tuple2('Gammad', 'Ϝ'),
			_Utils_Tuple2('gammad', 'ϝ'),
			_Utils_Tuple2('gap', '⪆'),
			_Utils_Tuple2('Gbreve', 'Ğ'),
			_Utils_Tuple2('gbreve', 'ğ'),
			_Utils_Tuple2('Gcedil', 'Ģ'),
			_Utils_Tuple2('Gcirc', 'Ĝ'),
			_Utils_Tuple2('gcirc', 'ĝ'),
			_Utils_Tuple2('Gcy', 'Г'),
			_Utils_Tuple2('gcy', 'г'),
			_Utils_Tuple2('Gdot', 'Ġ'),
			_Utils_Tuple2('gdot', 'ġ'),
			_Utils_Tuple2('ge', '≥'),
			_Utils_Tuple2('gE', '≧'),
			_Utils_Tuple2('gEl', '⪌'),
			_Utils_Tuple2('gel', '⋛'),
			_Utils_Tuple2('geq', '≥'),
			_Utils_Tuple2('geqq', '≧'),
			_Utils_Tuple2('geqslant', '⩾'),
			_Utils_Tuple2('gescc', '⪩'),
			_Utils_Tuple2('ges', '⩾'),
			_Utils_Tuple2('gesdot', '⪀'),
			_Utils_Tuple2('gesdoto', '⪂'),
			_Utils_Tuple2('gesdotol', '⪄'),
			_Utils_Tuple2('gesl', '⋛︀'),
			_Utils_Tuple2('gesles', '⪔'),
			_Utils_Tuple2('Gfr', '\uD835\uDD0A'),
			_Utils_Tuple2('gfr', '\uD835\uDD24'),
			_Utils_Tuple2('gg', '≫'),
			_Utils_Tuple2('Gg', '⋙'),
			_Utils_Tuple2('ggg', '⋙'),
			_Utils_Tuple2('gimel', 'ℷ'),
			_Utils_Tuple2('GJcy', 'Ѓ'),
			_Utils_Tuple2('gjcy', 'ѓ'),
			_Utils_Tuple2('gla', '⪥'),
			_Utils_Tuple2('gl', '≷'),
			_Utils_Tuple2('glE', '⪒'),
			_Utils_Tuple2('glj', '⪤'),
			_Utils_Tuple2('gnap', '⪊'),
			_Utils_Tuple2('gnapprox', '⪊'),
			_Utils_Tuple2('gne', '⪈'),
			_Utils_Tuple2('gnE', '≩'),
			_Utils_Tuple2('gneq', '⪈'),
			_Utils_Tuple2('gneqq', '≩'),
			_Utils_Tuple2('gnsim', '⋧'),
			_Utils_Tuple2('Gopf', '\uD835\uDD3E'),
			_Utils_Tuple2('gopf', '\uD835\uDD58'),
			_Utils_Tuple2('grave', '`'),
			_Utils_Tuple2('GreaterEqual', '≥'),
			_Utils_Tuple2('GreaterEqualLess', '⋛'),
			_Utils_Tuple2('GreaterFullEqual', '≧'),
			_Utils_Tuple2('GreaterGreater', '⪢'),
			_Utils_Tuple2('GreaterLess', '≷'),
			_Utils_Tuple2('GreaterSlantEqual', '⩾'),
			_Utils_Tuple2('GreaterTilde', '≳'),
			_Utils_Tuple2('Gscr', '\uD835\uDCA2'),
			_Utils_Tuple2('gscr', 'ℊ'),
			_Utils_Tuple2('gsim', '≳'),
			_Utils_Tuple2('gsime', '⪎'),
			_Utils_Tuple2('gsiml', '⪐'),
			_Utils_Tuple2('gtcc', '⪧'),
			_Utils_Tuple2('gtcir', '⩺'),
			_Utils_Tuple2('gt', '>'),
			_Utils_Tuple2('GT', '>'),
			_Utils_Tuple2('Gt', '≫'),
			_Utils_Tuple2('gtdot', '⋗'),
			_Utils_Tuple2('gtlPar', '⦕'),
			_Utils_Tuple2('gtquest', '⩼'),
			_Utils_Tuple2('gtrapprox', '⪆'),
			_Utils_Tuple2('gtrarr', '⥸'),
			_Utils_Tuple2('gtrdot', '⋗'),
			_Utils_Tuple2('gtreqless', '⋛'),
			_Utils_Tuple2('gtreqqless', '⪌'),
			_Utils_Tuple2('gtrless', '≷'),
			_Utils_Tuple2('gtrsim', '≳'),
			_Utils_Tuple2('gvertneqq', '≩︀'),
			_Utils_Tuple2('gvnE', '≩︀'),
			_Utils_Tuple2('Hacek', 'ˇ'),
			_Utils_Tuple2('hairsp', '\u200A'),
			_Utils_Tuple2('half', '½'),
			_Utils_Tuple2('hamilt', 'ℋ'),
			_Utils_Tuple2('HARDcy', 'Ъ'),
			_Utils_Tuple2('hardcy', 'ъ'),
			_Utils_Tuple2('harrcir', '⥈'),
			_Utils_Tuple2('harr', '↔'),
			_Utils_Tuple2('hArr', '⇔'),
			_Utils_Tuple2('harrw', '↭'),
			_Utils_Tuple2('Hat', '^'),
			_Utils_Tuple2('hbar', 'ℏ'),
			_Utils_Tuple2('Hcirc', 'Ĥ'),
			_Utils_Tuple2('hcirc', 'ĥ'),
			_Utils_Tuple2('hearts', '♥'),
			_Utils_Tuple2('heartsuit', '♥'),
			_Utils_Tuple2('hellip', '…'),
			_Utils_Tuple2('hercon', '⊹'),
			_Utils_Tuple2('hfr', '\uD835\uDD25'),
			_Utils_Tuple2('Hfr', 'ℌ'),
			_Utils_Tuple2('HilbertSpace', 'ℋ'),
			_Utils_Tuple2('hksearow', '⤥'),
			_Utils_Tuple2('hkswarow', '⤦'),
			_Utils_Tuple2('hoarr', '⇿'),
			_Utils_Tuple2('homtht', '∻'),
			_Utils_Tuple2('hookleftarrow', '↩'),
			_Utils_Tuple2('hookrightarrow', '↪'),
			_Utils_Tuple2('hopf', '\uD835\uDD59'),
			_Utils_Tuple2('Hopf', 'ℍ'),
			_Utils_Tuple2('horbar', '―'),
			_Utils_Tuple2('HorizontalLine', '─'),
			_Utils_Tuple2('hscr', '\uD835\uDCBD'),
			_Utils_Tuple2('Hscr', 'ℋ'),
			_Utils_Tuple2('hslash', 'ℏ'),
			_Utils_Tuple2('Hstrok', 'Ħ'),
			_Utils_Tuple2('hstrok', 'ħ'),
			_Utils_Tuple2('HumpDownHump', '≎'),
			_Utils_Tuple2('HumpEqual', '≏'),
			_Utils_Tuple2('hybull', '⁃'),
			_Utils_Tuple2('hyphen', '‐'),
			_Utils_Tuple2('Iacute', 'Í'),
			_Utils_Tuple2('iacute', 'í'),
			_Utils_Tuple2('ic', '\u2063'),
			_Utils_Tuple2('Icirc', 'Î'),
			_Utils_Tuple2('icirc', 'î'),
			_Utils_Tuple2('Icy', 'И'),
			_Utils_Tuple2('icy', 'и'),
			_Utils_Tuple2('Idot', 'İ'),
			_Utils_Tuple2('IEcy', 'Е'),
			_Utils_Tuple2('iecy', 'е'),
			_Utils_Tuple2('iexcl', '¡'),
			_Utils_Tuple2('iff', '⇔'),
			_Utils_Tuple2('ifr', '\uD835\uDD26'),
			_Utils_Tuple2('Ifr', 'ℑ'),
			_Utils_Tuple2('Igrave', 'Ì'),
			_Utils_Tuple2('igrave', 'ì'),
			_Utils_Tuple2('ii', 'ⅈ'),
			_Utils_Tuple2('iiiint', '⨌'),
			_Utils_Tuple2('iiint', '∭'),
			_Utils_Tuple2('iinfin', '⧜'),
			_Utils_Tuple2('iiota', '℩'),
			_Utils_Tuple2('IJlig', 'Ĳ'),
			_Utils_Tuple2('ijlig', 'ĳ'),
			_Utils_Tuple2('Imacr', 'Ī'),
			_Utils_Tuple2('imacr', 'ī'),
			_Utils_Tuple2('image', 'ℑ'),
			_Utils_Tuple2('ImaginaryI', 'ⅈ'),
			_Utils_Tuple2('imagline', 'ℐ'),
			_Utils_Tuple2('imagpart', 'ℑ'),
			_Utils_Tuple2('imath', 'ı'),
			_Utils_Tuple2('Im', 'ℑ'),
			_Utils_Tuple2('imof', '⊷'),
			_Utils_Tuple2('imped', 'Ƶ'),
			_Utils_Tuple2('Implies', '⇒'),
			_Utils_Tuple2('incare', '℅'),
			_Utils_Tuple2('in', '∈'),
			_Utils_Tuple2('infin', '∞'),
			_Utils_Tuple2('infintie', '⧝'),
			_Utils_Tuple2('inodot', 'ı'),
			_Utils_Tuple2('intcal', '⊺'),
			_Utils_Tuple2('int', '∫'),
			_Utils_Tuple2('Int', '∬'),
			_Utils_Tuple2('integers', 'ℤ'),
			_Utils_Tuple2('Integral', '∫'),
			_Utils_Tuple2('intercal', '⊺'),
			_Utils_Tuple2('Intersection', '⋂'),
			_Utils_Tuple2('intlarhk', '⨗'),
			_Utils_Tuple2('intprod', '⨼'),
			_Utils_Tuple2('InvisibleComma', '\u2063'),
			_Utils_Tuple2('InvisibleTimes', '\u2062'),
			_Utils_Tuple2('IOcy', 'Ё'),
			_Utils_Tuple2('iocy', 'ё'),
			_Utils_Tuple2('Iogon', 'Į'),
			_Utils_Tuple2('iogon', 'į'),
			_Utils_Tuple2('Iopf', '\uD835\uDD40'),
			_Utils_Tuple2('iopf', '\uD835\uDD5A'),
			_Utils_Tuple2('Iota', 'Ι'),
			_Utils_Tuple2('iota', 'ι'),
			_Utils_Tuple2('iprod', '⨼'),
			_Utils_Tuple2('iquest', '¿'),
			_Utils_Tuple2('iscr', '\uD835\uDCBE'),
			_Utils_Tuple2('Iscr', 'ℐ'),
			_Utils_Tuple2('isin', '∈'),
			_Utils_Tuple2('isindot', '⋵'),
			_Utils_Tuple2('isinE', '⋹'),
			_Utils_Tuple2('isins', '⋴'),
			_Utils_Tuple2('isinsv', '⋳'),
			_Utils_Tuple2('isinv', '∈'),
			_Utils_Tuple2('it', '\u2062'),
			_Utils_Tuple2('Itilde', 'Ĩ'),
			_Utils_Tuple2('itilde', 'ĩ'),
			_Utils_Tuple2('Iukcy', 'І'),
			_Utils_Tuple2('iukcy', 'і'),
			_Utils_Tuple2('Iuml', 'Ï'),
			_Utils_Tuple2('iuml', 'ï'),
			_Utils_Tuple2('Jcirc', 'Ĵ'),
			_Utils_Tuple2('jcirc', 'ĵ'),
			_Utils_Tuple2('Jcy', 'Й'),
			_Utils_Tuple2('jcy', 'й'),
			_Utils_Tuple2('Jfr', '\uD835\uDD0D'),
			_Utils_Tuple2('jfr', '\uD835\uDD27'),
			_Utils_Tuple2('jmath', 'ȷ'),
			_Utils_Tuple2('Jopf', '\uD835\uDD41'),
			_Utils_Tuple2('jopf', '\uD835\uDD5B'),
			_Utils_Tuple2('Jscr', '\uD835\uDCA5'),
			_Utils_Tuple2('jscr', '\uD835\uDCBF'),
			_Utils_Tuple2('Jsercy', 'Ј'),
			_Utils_Tuple2('jsercy', 'ј'),
			_Utils_Tuple2('Jukcy', 'Є'),
			_Utils_Tuple2('jukcy', 'є'),
			_Utils_Tuple2('Kappa', 'Κ'),
			_Utils_Tuple2('kappa', 'κ'),
			_Utils_Tuple2('kappav', 'ϰ'),
			_Utils_Tuple2('Kcedil', 'Ķ'),
			_Utils_Tuple2('kcedil', 'ķ'),
			_Utils_Tuple2('Kcy', 'К'),
			_Utils_Tuple2('kcy', 'к'),
			_Utils_Tuple2('Kfr', '\uD835\uDD0E'),
			_Utils_Tuple2('kfr', '\uD835\uDD28'),
			_Utils_Tuple2('kgreen', 'ĸ'),
			_Utils_Tuple2('KHcy', 'Х'),
			_Utils_Tuple2('khcy', 'х'),
			_Utils_Tuple2('KJcy', 'Ќ'),
			_Utils_Tuple2('kjcy', 'ќ'),
			_Utils_Tuple2('Kopf', '\uD835\uDD42'),
			_Utils_Tuple2('kopf', '\uD835\uDD5C'),
			_Utils_Tuple2('Kscr', '\uD835\uDCA6'),
			_Utils_Tuple2('kscr', '\uD835\uDCC0'),
			_Utils_Tuple2('lAarr', '⇚'),
			_Utils_Tuple2('Lacute', 'Ĺ'),
			_Utils_Tuple2('lacute', 'ĺ'),
			_Utils_Tuple2('laemptyv', '⦴'),
			_Utils_Tuple2('lagran', 'ℒ'),
			_Utils_Tuple2('Lambda', 'Λ'),
			_Utils_Tuple2('lambda', 'λ'),
			_Utils_Tuple2('lang', '⟨'),
			_Utils_Tuple2('Lang', '⟪'),
			_Utils_Tuple2('langd', '⦑'),
			_Utils_Tuple2('langle', '⟨'),
			_Utils_Tuple2('lap', '⪅'),
			_Utils_Tuple2('Laplacetrf', 'ℒ'),
			_Utils_Tuple2('laquo', '«'),
			_Utils_Tuple2('larrb', '⇤'),
			_Utils_Tuple2('larrbfs', '⤟'),
			_Utils_Tuple2('larr', '←'),
			_Utils_Tuple2('Larr', '↞'),
			_Utils_Tuple2('lArr', '⇐'),
			_Utils_Tuple2('larrfs', '⤝'),
			_Utils_Tuple2('larrhk', '↩'),
			_Utils_Tuple2('larrlp', '↫'),
			_Utils_Tuple2('larrpl', '⤹'),
			_Utils_Tuple2('larrsim', '⥳'),
			_Utils_Tuple2('larrtl', '↢'),
			_Utils_Tuple2('latail', '⤙'),
			_Utils_Tuple2('lAtail', '⤛'),
			_Utils_Tuple2('lat', '⪫'),
			_Utils_Tuple2('late', '⪭'),
			_Utils_Tuple2('lates', '⪭︀'),
			_Utils_Tuple2('lbarr', '⤌'),
			_Utils_Tuple2('lBarr', '⤎'),
			_Utils_Tuple2('lbbrk', '❲'),
			_Utils_Tuple2('lbrace', '{'),
			_Utils_Tuple2('lbrack', '['),
			_Utils_Tuple2('lbrke', '⦋'),
			_Utils_Tuple2('lbrksld', '⦏'),
			_Utils_Tuple2('lbrkslu', '⦍'),
			_Utils_Tuple2('Lcaron', 'Ľ'),
			_Utils_Tuple2('lcaron', 'ľ'),
			_Utils_Tuple2('Lcedil', 'Ļ'),
			_Utils_Tuple2('lcedil', 'ļ'),
			_Utils_Tuple2('lceil', '⌈'),
			_Utils_Tuple2('lcub', '{'),
			_Utils_Tuple2('Lcy', 'Л'),
			_Utils_Tuple2('lcy', 'л'),
			_Utils_Tuple2('ldca', '⤶'),
			_Utils_Tuple2('ldquo', '“'),
			_Utils_Tuple2('ldquor', '„'),
			_Utils_Tuple2('ldrdhar', '⥧'),
			_Utils_Tuple2('ldrushar', '⥋'),
			_Utils_Tuple2('ldsh', '↲'),
			_Utils_Tuple2('le', '≤'),
			_Utils_Tuple2('lE', '≦'),
			_Utils_Tuple2('LeftAngleBracket', '⟨'),
			_Utils_Tuple2('LeftArrowBar', '⇤'),
			_Utils_Tuple2('leftarrow', '←'),
			_Utils_Tuple2('LeftArrow', '←'),
			_Utils_Tuple2('Leftarrow', '⇐'),
			_Utils_Tuple2('LeftArrowRightArrow', '⇆'),
			_Utils_Tuple2('leftarrowtail', '↢'),
			_Utils_Tuple2('LeftCeiling', '⌈'),
			_Utils_Tuple2('LeftDoubleBracket', '⟦'),
			_Utils_Tuple2('LeftDownTeeVector', '⥡'),
			_Utils_Tuple2('LeftDownVectorBar', '⥙'),
			_Utils_Tuple2('LeftDownVector', '⇃'),
			_Utils_Tuple2('LeftFloor', '⌊'),
			_Utils_Tuple2('leftharpoondown', '↽'),
			_Utils_Tuple2('leftharpoonup', '↼'),
			_Utils_Tuple2('leftleftarrows', '⇇'),
			_Utils_Tuple2('leftrightarrow', '↔'),
			_Utils_Tuple2('LeftRightArrow', '↔'),
			_Utils_Tuple2('Leftrightarrow', '⇔'),
			_Utils_Tuple2('leftrightarrows', '⇆'),
			_Utils_Tuple2('leftrightharpoons', '⇋'),
			_Utils_Tuple2('leftrightsquigarrow', '↭'),
			_Utils_Tuple2('LeftRightVector', '⥎'),
			_Utils_Tuple2('LeftTeeArrow', '↤'),
			_Utils_Tuple2('LeftTee', '⊣'),
			_Utils_Tuple2('LeftTeeVector', '⥚'),
			_Utils_Tuple2('leftthreetimes', '⋋'),
			_Utils_Tuple2('LeftTriangleBar', '⧏'),
			_Utils_Tuple2('LeftTriangle', '⊲'),
			_Utils_Tuple2('LeftTriangleEqual', '⊴'),
			_Utils_Tuple2('LeftUpDownVector', '⥑'),
			_Utils_Tuple2('LeftUpTeeVector', '⥠'),
			_Utils_Tuple2('LeftUpVectorBar', '⥘'),
			_Utils_Tuple2('LeftUpVector', '↿'),
			_Utils_Tuple2('LeftVectorBar', '⥒'),
			_Utils_Tuple2('LeftVector', '↼'),
			_Utils_Tuple2('lEg', '⪋'),
			_Utils_Tuple2('leg', '⋚'),
			_Utils_Tuple2('leq', '≤'),
			_Utils_Tuple2('leqq', '≦'),
			_Utils_Tuple2('leqslant', '⩽'),
			_Utils_Tuple2('lescc', '⪨'),
			_Utils_Tuple2('les', '⩽'),
			_Utils_Tuple2('lesdot', '⩿'),
			_Utils_Tuple2('lesdoto', '⪁'),
			_Utils_Tuple2('lesdotor', '⪃'),
			_Utils_Tuple2('lesg', '⋚︀'),
			_Utils_Tuple2('lesges', '⪓'),
			_Utils_Tuple2('lessapprox', '⪅'),
			_Utils_Tuple2('lessdot', '⋖'),
			_Utils_Tuple2('lesseqgtr', '⋚'),
			_Utils_Tuple2('lesseqqgtr', '⪋'),
			_Utils_Tuple2('LessEqualGreater', '⋚'),
			_Utils_Tuple2('LessFullEqual', '≦'),
			_Utils_Tuple2('LessGreater', '≶'),
			_Utils_Tuple2('lessgtr', '≶'),
			_Utils_Tuple2('LessLess', '⪡'),
			_Utils_Tuple2('lesssim', '≲'),
			_Utils_Tuple2('LessSlantEqual', '⩽'),
			_Utils_Tuple2('LessTilde', '≲'),
			_Utils_Tuple2('lfisht', '⥼'),
			_Utils_Tuple2('lfloor', '⌊'),
			_Utils_Tuple2('Lfr', '\uD835\uDD0F'),
			_Utils_Tuple2('lfr', '\uD835\uDD29'),
			_Utils_Tuple2('lg', '≶'),
			_Utils_Tuple2('lgE', '⪑'),
			_Utils_Tuple2('lHar', '⥢'),
			_Utils_Tuple2('lhard', '↽'),
			_Utils_Tuple2('lharu', '↼'),
			_Utils_Tuple2('lharul', '⥪'),
			_Utils_Tuple2('lhblk', '▄'),
			_Utils_Tuple2('LJcy', 'Љ'),
			_Utils_Tuple2('ljcy', 'љ'),
			_Utils_Tuple2('llarr', '⇇'),
			_Utils_Tuple2('ll', '≪'),
			_Utils_Tuple2('Ll', '⋘'),
			_Utils_Tuple2('llcorner', '⌞'),
			_Utils_Tuple2('Lleftarrow', '⇚'),
			_Utils_Tuple2('llhard', '⥫'),
			_Utils_Tuple2('lltri', '◺'),
			_Utils_Tuple2('Lmidot', 'Ŀ'),
			_Utils_Tuple2('lmidot', 'ŀ'),
			_Utils_Tuple2('lmoustache', '⎰'),
			_Utils_Tuple2('lmoust', '⎰'),
			_Utils_Tuple2('lnap', '⪉'),
			_Utils_Tuple2('lnapprox', '⪉'),
			_Utils_Tuple2('lne', '⪇'),
			_Utils_Tuple2('lnE', '≨'),
			_Utils_Tuple2('lneq', '⪇'),
			_Utils_Tuple2('lneqq', '≨'),
			_Utils_Tuple2('lnsim', '⋦'),
			_Utils_Tuple2('loang', '⟬'),
			_Utils_Tuple2('loarr', '⇽'),
			_Utils_Tuple2('lobrk', '⟦'),
			_Utils_Tuple2('longleftarrow', '⟵'),
			_Utils_Tuple2('LongLeftArrow', '⟵'),
			_Utils_Tuple2('Longleftarrow', '⟸'),
			_Utils_Tuple2('longleftrightarrow', '⟷'),
			_Utils_Tuple2('LongLeftRightArrow', '⟷'),
			_Utils_Tuple2('Longleftrightarrow', '⟺'),
			_Utils_Tuple2('longmapsto', '⟼'),
			_Utils_Tuple2('longrightarrow', '⟶'),
			_Utils_Tuple2('LongRightArrow', '⟶'),
			_Utils_Tuple2('Longrightarrow', '⟹'),
			_Utils_Tuple2('looparrowleft', '↫'),
			_Utils_Tuple2('looparrowright', '↬'),
			_Utils_Tuple2('lopar', '⦅'),
			_Utils_Tuple2('Lopf', '\uD835\uDD43'),
			_Utils_Tuple2('lopf', '\uD835\uDD5D'),
			_Utils_Tuple2('loplus', '⨭'),
			_Utils_Tuple2('lotimes', '⨴'),
			_Utils_Tuple2('lowast', '∗'),
			_Utils_Tuple2('lowbar', '_'),
			_Utils_Tuple2('LowerLeftArrow', '↙'),
			_Utils_Tuple2('LowerRightArrow', '↘'),
			_Utils_Tuple2('loz', '◊'),
			_Utils_Tuple2('lozenge', '◊'),
			_Utils_Tuple2('lozf', '⧫'),
			_Utils_Tuple2('lpar', '('),
			_Utils_Tuple2('lparlt', '⦓'),
			_Utils_Tuple2('lrarr', '⇆'),
			_Utils_Tuple2('lrcorner', '⌟'),
			_Utils_Tuple2('lrhar', '⇋'),
			_Utils_Tuple2('lrhard', '⥭'),
			_Utils_Tuple2('lrm', '\u200E'),
			_Utils_Tuple2('lrtri', '⊿'),
			_Utils_Tuple2('lsaquo', '‹'),
			_Utils_Tuple2('lscr', '\uD835\uDCC1'),
			_Utils_Tuple2('Lscr', 'ℒ'),
			_Utils_Tuple2('lsh', '↰'),
			_Utils_Tuple2('Lsh', '↰'),
			_Utils_Tuple2('lsim', '≲'),
			_Utils_Tuple2('lsime', '⪍'),
			_Utils_Tuple2('lsimg', '⪏'),
			_Utils_Tuple2('lsqb', '['),
			_Utils_Tuple2('lsquo', '‘'),
			_Utils_Tuple2('lsquor', '‚'),
			_Utils_Tuple2('Lstrok', 'Ł'),
			_Utils_Tuple2('lstrok', 'ł'),
			_Utils_Tuple2('ltcc', '⪦'),
			_Utils_Tuple2('ltcir', '⩹'),
			_Utils_Tuple2('lt', '<'),
			_Utils_Tuple2('LT', '<'),
			_Utils_Tuple2('Lt', '≪'),
			_Utils_Tuple2('ltdot', '⋖'),
			_Utils_Tuple2('lthree', '⋋'),
			_Utils_Tuple2('ltimes', '⋉'),
			_Utils_Tuple2('ltlarr', '⥶'),
			_Utils_Tuple2('ltquest', '⩻'),
			_Utils_Tuple2('ltri', '◃'),
			_Utils_Tuple2('ltrie', '⊴'),
			_Utils_Tuple2('ltrif', '◂'),
			_Utils_Tuple2('ltrPar', '⦖'),
			_Utils_Tuple2('lurdshar', '⥊'),
			_Utils_Tuple2('luruhar', '⥦'),
			_Utils_Tuple2('lvertneqq', '≨︀'),
			_Utils_Tuple2('lvnE', '≨︀'),
			_Utils_Tuple2('macr', '¯'),
			_Utils_Tuple2('male', '♂'),
			_Utils_Tuple2('malt', '✠'),
			_Utils_Tuple2('maltese', '✠'),
			_Utils_Tuple2('Map', '⤅'),
			_Utils_Tuple2('map', '↦'),
			_Utils_Tuple2('mapsto', '↦'),
			_Utils_Tuple2('mapstodown', '↧'),
			_Utils_Tuple2('mapstoleft', '↤'),
			_Utils_Tuple2('mapstoup', '↥'),
			_Utils_Tuple2('marker', '▮'),
			_Utils_Tuple2('mcomma', '⨩'),
			_Utils_Tuple2('Mcy', 'М'),
			_Utils_Tuple2('mcy', 'м'),
			_Utils_Tuple2('mdash', '—'),
			_Utils_Tuple2('mDDot', '∺'),
			_Utils_Tuple2('measuredangle', '∡'),
			_Utils_Tuple2('MediumSpace', '\u205F'),
			_Utils_Tuple2('Mellintrf', 'ℳ'),
			_Utils_Tuple2('Mfr', '\uD835\uDD10'),
			_Utils_Tuple2('mfr', '\uD835\uDD2A'),
			_Utils_Tuple2('mho', '℧'),
			_Utils_Tuple2('micro', 'µ'),
			_Utils_Tuple2('midast', '*'),
			_Utils_Tuple2('midcir', '⫰'),
			_Utils_Tuple2('mid', '∣'),
			_Utils_Tuple2('middot', '·'),
			_Utils_Tuple2('minusb', '⊟'),
			_Utils_Tuple2('minus', '−'),
			_Utils_Tuple2('minusd', '∸'),
			_Utils_Tuple2('minusdu', '⨪'),
			_Utils_Tuple2('MinusPlus', '∓'),
			_Utils_Tuple2('mlcp', '⫛'),
			_Utils_Tuple2('mldr', '…'),
			_Utils_Tuple2('mnplus', '∓'),
			_Utils_Tuple2('models', '⊧'),
			_Utils_Tuple2('Mopf', '\uD835\uDD44'),
			_Utils_Tuple2('mopf', '\uD835\uDD5E'),
			_Utils_Tuple2('mp', '∓'),
			_Utils_Tuple2('mscr', '\uD835\uDCC2'),
			_Utils_Tuple2('Mscr', 'ℳ'),
			_Utils_Tuple2('mstpos', '∾'),
			_Utils_Tuple2('Mu', 'Μ'),
			_Utils_Tuple2('mu', 'μ'),
			_Utils_Tuple2('multimap', '⊸'),
			_Utils_Tuple2('mumap', '⊸'),
			_Utils_Tuple2('nabla', '∇'),
			_Utils_Tuple2('Nacute', 'Ń'),
			_Utils_Tuple2('nacute', 'ń'),
			_Utils_Tuple2('nang', '∠⃒'),
			_Utils_Tuple2('nap', '≉'),
			_Utils_Tuple2('napE', '⩰̸'),
			_Utils_Tuple2('napid', '≋̸'),
			_Utils_Tuple2('napos', 'ŉ'),
			_Utils_Tuple2('napprox', '≉'),
			_Utils_Tuple2('natural', '♮'),
			_Utils_Tuple2('naturals', 'ℕ'),
			_Utils_Tuple2('natur', '♮'),
			_Utils_Tuple2('nbsp', '\u00A0'),
			_Utils_Tuple2('nbump', '≎̸'),
			_Utils_Tuple2('nbumpe', '≏̸'),
			_Utils_Tuple2('ncap', '⩃'),
			_Utils_Tuple2('Ncaron', 'Ň'),
			_Utils_Tuple2('ncaron', 'ň'),
			_Utils_Tuple2('Ncedil', 'Ņ'),
			_Utils_Tuple2('ncedil', 'ņ'),
			_Utils_Tuple2('ncong', '≇'),
			_Utils_Tuple2('ncongdot', '⩭̸'),
			_Utils_Tuple2('ncup', '⩂'),
			_Utils_Tuple2('Ncy', 'Н'),
			_Utils_Tuple2('ncy', 'н'),
			_Utils_Tuple2('ndash', '–'),
			_Utils_Tuple2('nearhk', '⤤'),
			_Utils_Tuple2('nearr', '↗'),
			_Utils_Tuple2('neArr', '⇗'),
			_Utils_Tuple2('nearrow', '↗'),
			_Utils_Tuple2('ne', '≠'),
			_Utils_Tuple2('nedot', '≐̸'),
			_Utils_Tuple2('NegativeMediumSpace', '\u200B'),
			_Utils_Tuple2('NegativeThickSpace', '\u200B'),
			_Utils_Tuple2('NegativeThinSpace', '\u200B'),
			_Utils_Tuple2('NegativeVeryThinSpace', '\u200B'),
			_Utils_Tuple2('nequiv', '≢'),
			_Utils_Tuple2('nesear', '⤨'),
			_Utils_Tuple2('nesim', '≂̸'),
			_Utils_Tuple2('NestedGreaterGreater', '≫'),
			_Utils_Tuple2('NestedLessLess', '≪'),
			_Utils_Tuple2('NewLine', '\n'),
			_Utils_Tuple2('nexist', '∄'),
			_Utils_Tuple2('nexists', '∄'),
			_Utils_Tuple2('Nfr', '\uD835\uDD11'),
			_Utils_Tuple2('nfr', '\uD835\uDD2B'),
			_Utils_Tuple2('ngE', '≧̸'),
			_Utils_Tuple2('nge', '≱'),
			_Utils_Tuple2('ngeq', '≱'),
			_Utils_Tuple2('ngeqq', '≧̸'),
			_Utils_Tuple2('ngeqslant', '⩾̸'),
			_Utils_Tuple2('nges', '⩾̸'),
			_Utils_Tuple2('nGg', '⋙̸'),
			_Utils_Tuple2('ngsim', '≵'),
			_Utils_Tuple2('nGt', '≫⃒'),
			_Utils_Tuple2('ngt', '≯'),
			_Utils_Tuple2('ngtr', '≯'),
			_Utils_Tuple2('nGtv', '≫̸'),
			_Utils_Tuple2('nharr', '↮'),
			_Utils_Tuple2('nhArr', '⇎'),
			_Utils_Tuple2('nhpar', '⫲'),
			_Utils_Tuple2('ni', '∋'),
			_Utils_Tuple2('nis', '⋼'),
			_Utils_Tuple2('nisd', '⋺'),
			_Utils_Tuple2('niv', '∋'),
			_Utils_Tuple2('NJcy', 'Њ'),
			_Utils_Tuple2('njcy', 'њ'),
			_Utils_Tuple2('nlarr', '↚'),
			_Utils_Tuple2('nlArr', '⇍'),
			_Utils_Tuple2('nldr', '‥'),
			_Utils_Tuple2('nlE', '≦̸'),
			_Utils_Tuple2('nle', '≰'),
			_Utils_Tuple2('nleftarrow', '↚'),
			_Utils_Tuple2('nLeftarrow', '⇍'),
			_Utils_Tuple2('nleftrightarrow', '↮'),
			_Utils_Tuple2('nLeftrightarrow', '⇎'),
			_Utils_Tuple2('nleq', '≰'),
			_Utils_Tuple2('nleqq', '≦̸'),
			_Utils_Tuple2('nleqslant', '⩽̸'),
			_Utils_Tuple2('nles', '⩽̸'),
			_Utils_Tuple2('nless', '≮'),
			_Utils_Tuple2('nLl', '⋘̸'),
			_Utils_Tuple2('nlsim', '≴'),
			_Utils_Tuple2('nLt', '≪⃒'),
			_Utils_Tuple2('nlt', '≮'),
			_Utils_Tuple2('nltri', '⋪'),
			_Utils_Tuple2('nltrie', '⋬'),
			_Utils_Tuple2('nLtv', '≪̸'),
			_Utils_Tuple2('nmid', '∤'),
			_Utils_Tuple2('NoBreak', '\u2060'),
			_Utils_Tuple2('NonBreakingSpace', '\u00A0'),
			_Utils_Tuple2('nopf', '\uD835\uDD5F'),
			_Utils_Tuple2('Nopf', 'ℕ'),
			_Utils_Tuple2('Not', '⫬'),
			_Utils_Tuple2('not', '¬'),
			_Utils_Tuple2('NotCongruent', '≢'),
			_Utils_Tuple2('NotCupCap', '≭'),
			_Utils_Tuple2('NotDoubleVerticalBar', '∦'),
			_Utils_Tuple2('NotElement', '∉'),
			_Utils_Tuple2('NotEqual', '≠'),
			_Utils_Tuple2('NotEqualTilde', '≂̸'),
			_Utils_Tuple2('NotExists', '∄'),
			_Utils_Tuple2('NotGreater', '≯'),
			_Utils_Tuple2('NotGreaterEqual', '≱'),
			_Utils_Tuple2('NotGreaterFullEqual', '≧̸'),
			_Utils_Tuple2('NotGreaterGreater', '≫̸'),
			_Utils_Tuple2('NotGreaterLess', '≹'),
			_Utils_Tuple2('NotGreaterSlantEqual', '⩾̸'),
			_Utils_Tuple2('NotGreaterTilde', '≵'),
			_Utils_Tuple2('NotHumpDownHump', '≎̸'),
			_Utils_Tuple2('NotHumpEqual', '≏̸'),
			_Utils_Tuple2('notin', '∉'),
			_Utils_Tuple2('notindot', '⋵̸'),
			_Utils_Tuple2('notinE', '⋹̸'),
			_Utils_Tuple2('notinva', '∉'),
			_Utils_Tuple2('notinvb', '⋷'),
			_Utils_Tuple2('notinvc', '⋶'),
			_Utils_Tuple2('NotLeftTriangleBar', '⧏̸'),
			_Utils_Tuple2('NotLeftTriangle', '⋪'),
			_Utils_Tuple2('NotLeftTriangleEqual', '⋬'),
			_Utils_Tuple2('NotLess', '≮'),
			_Utils_Tuple2('NotLessEqual', '≰'),
			_Utils_Tuple2('NotLessGreater', '≸'),
			_Utils_Tuple2('NotLessLess', '≪̸'),
			_Utils_Tuple2('NotLessSlantEqual', '⩽̸'),
			_Utils_Tuple2('NotLessTilde', '≴'),
			_Utils_Tuple2('NotNestedGreaterGreater', '⪢̸'),
			_Utils_Tuple2('NotNestedLessLess', '⪡̸'),
			_Utils_Tuple2('notni', '∌'),
			_Utils_Tuple2('notniva', '∌'),
			_Utils_Tuple2('notnivb', '⋾'),
			_Utils_Tuple2('notnivc', '⋽'),
			_Utils_Tuple2('NotPrecedes', '⊀'),
			_Utils_Tuple2('NotPrecedesEqual', '⪯̸'),
			_Utils_Tuple2('NotPrecedesSlantEqual', '⋠'),
			_Utils_Tuple2('NotReverseElement', '∌'),
			_Utils_Tuple2('NotRightTriangleBar', '⧐̸'),
			_Utils_Tuple2('NotRightTriangle', '⋫'),
			_Utils_Tuple2('NotRightTriangleEqual', '⋭'),
			_Utils_Tuple2('NotSquareSubset', '⊏̸'),
			_Utils_Tuple2('NotSquareSubsetEqual', '⋢'),
			_Utils_Tuple2('NotSquareSuperset', '⊐̸'),
			_Utils_Tuple2('NotSquareSupersetEqual', '⋣'),
			_Utils_Tuple2('NotSubset', '⊂⃒'),
			_Utils_Tuple2('NotSubsetEqual', '⊈'),
			_Utils_Tuple2('NotSucceeds', '⊁'),
			_Utils_Tuple2('NotSucceedsEqual', '⪰̸'),
			_Utils_Tuple2('NotSucceedsSlantEqual', '⋡'),
			_Utils_Tuple2('NotSucceedsTilde', '≿̸'),
			_Utils_Tuple2('NotSuperset', '⊃⃒'),
			_Utils_Tuple2('NotSupersetEqual', '⊉'),
			_Utils_Tuple2('NotTilde', '≁'),
			_Utils_Tuple2('NotTildeEqual', '≄'),
			_Utils_Tuple2('NotTildeFullEqual', '≇'),
			_Utils_Tuple2('NotTildeTilde', '≉'),
			_Utils_Tuple2('NotVerticalBar', '∤'),
			_Utils_Tuple2('nparallel', '∦'),
			_Utils_Tuple2('npar', '∦'),
			_Utils_Tuple2('nparsl', '⫽⃥'),
			_Utils_Tuple2('npart', '∂̸'),
			_Utils_Tuple2('npolint', '⨔'),
			_Utils_Tuple2('npr', '⊀'),
			_Utils_Tuple2('nprcue', '⋠'),
			_Utils_Tuple2('nprec', '⊀'),
			_Utils_Tuple2('npreceq', '⪯̸'),
			_Utils_Tuple2('npre', '⪯̸'),
			_Utils_Tuple2('nrarrc', '⤳̸'),
			_Utils_Tuple2('nrarr', '↛'),
			_Utils_Tuple2('nrArr', '⇏'),
			_Utils_Tuple2('nrarrw', '↝̸'),
			_Utils_Tuple2('nrightarrow', '↛'),
			_Utils_Tuple2('nRightarrow', '⇏'),
			_Utils_Tuple2('nrtri', '⋫'),
			_Utils_Tuple2('nrtrie', '⋭'),
			_Utils_Tuple2('nsc', '⊁'),
			_Utils_Tuple2('nsccue', '⋡'),
			_Utils_Tuple2('nsce', '⪰̸'),
			_Utils_Tuple2('Nscr', '\uD835\uDCA9'),
			_Utils_Tuple2('nscr', '\uD835\uDCC3'),
			_Utils_Tuple2('nshortmid', '∤'),
			_Utils_Tuple2('nshortparallel', '∦'),
			_Utils_Tuple2('nsim', '≁'),
			_Utils_Tuple2('nsime', '≄'),
			_Utils_Tuple2('nsimeq', '≄'),
			_Utils_Tuple2('nsmid', '∤'),
			_Utils_Tuple2('nspar', '∦'),
			_Utils_Tuple2('nsqsube', '⋢'),
			_Utils_Tuple2('nsqsupe', '⋣'),
			_Utils_Tuple2('nsub', '⊄'),
			_Utils_Tuple2('nsubE', '⫅̸'),
			_Utils_Tuple2('nsube', '⊈'),
			_Utils_Tuple2('nsubset', '⊂⃒'),
			_Utils_Tuple2('nsubseteq', '⊈'),
			_Utils_Tuple2('nsubseteqq', '⫅̸'),
			_Utils_Tuple2('nsucc', '⊁'),
			_Utils_Tuple2('nsucceq', '⪰̸'),
			_Utils_Tuple2('nsup', '⊅'),
			_Utils_Tuple2('nsupE', '⫆̸'),
			_Utils_Tuple2('nsupe', '⊉'),
			_Utils_Tuple2('nsupset', '⊃⃒'),
			_Utils_Tuple2('nsupseteq', '⊉'),
			_Utils_Tuple2('nsupseteqq', '⫆̸'),
			_Utils_Tuple2('ntgl', '≹'),
			_Utils_Tuple2('Ntilde', 'Ñ'),
			_Utils_Tuple2('ntilde', 'ñ'),
			_Utils_Tuple2('ntlg', '≸'),
			_Utils_Tuple2('ntriangleleft', '⋪'),
			_Utils_Tuple2('ntrianglelefteq', '⋬'),
			_Utils_Tuple2('ntriangleright', '⋫'),
			_Utils_Tuple2('ntrianglerighteq', '⋭'),
			_Utils_Tuple2('Nu', 'Ν'),
			_Utils_Tuple2('nu', 'ν'),
			_Utils_Tuple2('num', '#'),
			_Utils_Tuple2('numero', '№'),
			_Utils_Tuple2('numsp', '\u2007'),
			_Utils_Tuple2('nvap', '≍⃒'),
			_Utils_Tuple2('nvdash', '⊬'),
			_Utils_Tuple2('nvDash', '⊭'),
			_Utils_Tuple2('nVdash', '⊮'),
			_Utils_Tuple2('nVDash', '⊯'),
			_Utils_Tuple2('nvge', '≥⃒'),
			_Utils_Tuple2('nvgt', '>⃒'),
			_Utils_Tuple2('nvHarr', '⤄'),
			_Utils_Tuple2('nvinfin', '⧞'),
			_Utils_Tuple2('nvlArr', '⤂'),
			_Utils_Tuple2('nvle', '≤⃒'),
			_Utils_Tuple2('nvlt', '<⃒'),
			_Utils_Tuple2('nvltrie', '⊴⃒'),
			_Utils_Tuple2('nvrArr', '⤃'),
			_Utils_Tuple2('nvrtrie', '⊵⃒'),
			_Utils_Tuple2('nvsim', '∼⃒'),
			_Utils_Tuple2('nwarhk', '⤣'),
			_Utils_Tuple2('nwarr', '↖'),
			_Utils_Tuple2('nwArr', '⇖'),
			_Utils_Tuple2('nwarrow', '↖'),
			_Utils_Tuple2('nwnear', '⤧'),
			_Utils_Tuple2('Oacute', 'Ó'),
			_Utils_Tuple2('oacute', 'ó'),
			_Utils_Tuple2('oast', '⊛'),
			_Utils_Tuple2('Ocirc', 'Ô'),
			_Utils_Tuple2('ocirc', 'ô'),
			_Utils_Tuple2('ocir', '⊚'),
			_Utils_Tuple2('Ocy', 'О'),
			_Utils_Tuple2('ocy', 'о'),
			_Utils_Tuple2('odash', '⊝'),
			_Utils_Tuple2('Odblac', 'Ő'),
			_Utils_Tuple2('odblac', 'ő'),
			_Utils_Tuple2('odiv', '⨸'),
			_Utils_Tuple2('odot', '⊙'),
			_Utils_Tuple2('odsold', '⦼'),
			_Utils_Tuple2('OElig', 'Œ'),
			_Utils_Tuple2('oelig', 'œ'),
			_Utils_Tuple2('ofcir', '⦿'),
			_Utils_Tuple2('Ofr', '\uD835\uDD12'),
			_Utils_Tuple2('ofr', '\uD835\uDD2C'),
			_Utils_Tuple2('ogon', '˛'),
			_Utils_Tuple2('Ograve', 'Ò'),
			_Utils_Tuple2('ograve', 'ò'),
			_Utils_Tuple2('ogt', '⧁'),
			_Utils_Tuple2('ohbar', '⦵'),
			_Utils_Tuple2('ohm', 'Ω'),
			_Utils_Tuple2('oint', '∮'),
			_Utils_Tuple2('olarr', '↺'),
			_Utils_Tuple2('olcir', '⦾'),
			_Utils_Tuple2('olcross', '⦻'),
			_Utils_Tuple2('oline', '‾'),
			_Utils_Tuple2('olt', '⧀'),
			_Utils_Tuple2('Omacr', 'Ō'),
			_Utils_Tuple2('omacr', 'ō'),
			_Utils_Tuple2('Omega', 'Ω'),
			_Utils_Tuple2('omega', 'ω'),
			_Utils_Tuple2('Omicron', 'Ο'),
			_Utils_Tuple2('omicron', 'ο'),
			_Utils_Tuple2('omid', '⦶'),
			_Utils_Tuple2('ominus', '⊖'),
			_Utils_Tuple2('Oopf', '\uD835\uDD46'),
			_Utils_Tuple2('oopf', '\uD835\uDD60'),
			_Utils_Tuple2('opar', '⦷'),
			_Utils_Tuple2('OpenCurlyDoubleQuote', '“'),
			_Utils_Tuple2('OpenCurlyQuote', '‘'),
			_Utils_Tuple2('operp', '⦹'),
			_Utils_Tuple2('oplus', '⊕'),
			_Utils_Tuple2('orarr', '↻'),
			_Utils_Tuple2('Or', '⩔'),
			_Utils_Tuple2('or', '∨'),
			_Utils_Tuple2('ord', '⩝'),
			_Utils_Tuple2('order', 'ℴ'),
			_Utils_Tuple2('orderof', 'ℴ'),
			_Utils_Tuple2('ordf', 'ª'),
			_Utils_Tuple2('ordm', 'º'),
			_Utils_Tuple2('origof', '⊶'),
			_Utils_Tuple2('oror', '⩖'),
			_Utils_Tuple2('orslope', '⩗'),
			_Utils_Tuple2('orv', '⩛'),
			_Utils_Tuple2('oS', 'Ⓢ'),
			_Utils_Tuple2('Oscr', '\uD835\uDCAA'),
			_Utils_Tuple2('oscr', 'ℴ'),
			_Utils_Tuple2('Oslash', 'Ø'),
			_Utils_Tuple2('oslash', 'ø'),
			_Utils_Tuple2('osol', '⊘'),
			_Utils_Tuple2('Otilde', 'Õ'),
			_Utils_Tuple2('otilde', 'õ'),
			_Utils_Tuple2('otimesas', '⨶'),
			_Utils_Tuple2('Otimes', '⨷'),
			_Utils_Tuple2('otimes', '⊗'),
			_Utils_Tuple2('Ouml', 'Ö'),
			_Utils_Tuple2('ouml', 'ö'),
			_Utils_Tuple2('ovbar', '⌽'),
			_Utils_Tuple2('OverBar', '‾'),
			_Utils_Tuple2('OverBrace', '⏞'),
			_Utils_Tuple2('OverBracket', '⎴'),
			_Utils_Tuple2('OverParenthesis', '⏜'),
			_Utils_Tuple2('para', '¶'),
			_Utils_Tuple2('parallel', '∥'),
			_Utils_Tuple2('par', '∥'),
			_Utils_Tuple2('parsim', '⫳'),
			_Utils_Tuple2('parsl', '⫽'),
			_Utils_Tuple2('part', '∂'),
			_Utils_Tuple2('PartialD', '∂'),
			_Utils_Tuple2('Pcy', 'П'),
			_Utils_Tuple2('pcy', 'п'),
			_Utils_Tuple2('percnt', '%'),
			_Utils_Tuple2('period', '.'),
			_Utils_Tuple2('permil', '‰'),
			_Utils_Tuple2('perp', '⊥'),
			_Utils_Tuple2('pertenk', '‱'),
			_Utils_Tuple2('Pfr', '\uD835\uDD13'),
			_Utils_Tuple2('pfr', '\uD835\uDD2D'),
			_Utils_Tuple2('Phi', 'Φ'),
			_Utils_Tuple2('phi', 'φ'),
			_Utils_Tuple2('phiv', 'ϕ'),
			_Utils_Tuple2('phmmat', 'ℳ'),
			_Utils_Tuple2('phone', '☎'),
			_Utils_Tuple2('Pi', 'Π'),
			_Utils_Tuple2('pi', 'π'),
			_Utils_Tuple2('pitchfork', '⋔'),
			_Utils_Tuple2('piv', 'ϖ'),
			_Utils_Tuple2('planck', 'ℏ'),
			_Utils_Tuple2('planckh', 'ℎ'),
			_Utils_Tuple2('plankv', 'ℏ'),
			_Utils_Tuple2('plusacir', '⨣'),
			_Utils_Tuple2('plusb', '⊞'),
			_Utils_Tuple2('pluscir', '⨢'),
			_Utils_Tuple2('plus', '+'),
			_Utils_Tuple2('plusdo', '∔'),
			_Utils_Tuple2('plusdu', '⨥'),
			_Utils_Tuple2('pluse', '⩲'),
			_Utils_Tuple2('PlusMinus', '±'),
			_Utils_Tuple2('plusmn', '±'),
			_Utils_Tuple2('plussim', '⨦'),
			_Utils_Tuple2('plustwo', '⨧'),
			_Utils_Tuple2('pm', '±'),
			_Utils_Tuple2('Poincareplane', 'ℌ'),
			_Utils_Tuple2('pointint', '⨕'),
			_Utils_Tuple2('popf', '\uD835\uDD61'),
			_Utils_Tuple2('Popf', 'ℙ'),
			_Utils_Tuple2('pound', '£'),
			_Utils_Tuple2('prap', '⪷'),
			_Utils_Tuple2('Pr', '⪻'),
			_Utils_Tuple2('pr', '≺'),
			_Utils_Tuple2('prcue', '≼'),
			_Utils_Tuple2('precapprox', '⪷'),
			_Utils_Tuple2('prec', '≺'),
			_Utils_Tuple2('preccurlyeq', '≼'),
			_Utils_Tuple2('Precedes', '≺'),
			_Utils_Tuple2('PrecedesEqual', '⪯'),
			_Utils_Tuple2('PrecedesSlantEqual', '≼'),
			_Utils_Tuple2('PrecedesTilde', '≾'),
			_Utils_Tuple2('preceq', '⪯'),
			_Utils_Tuple2('precnapprox', '⪹'),
			_Utils_Tuple2('precneqq', '⪵'),
			_Utils_Tuple2('precnsim', '⋨'),
			_Utils_Tuple2('pre', '⪯'),
			_Utils_Tuple2('prE', '⪳'),
			_Utils_Tuple2('precsim', '≾'),
			_Utils_Tuple2('prime', '′'),
			_Utils_Tuple2('Prime', '″'),
			_Utils_Tuple2('primes', 'ℙ'),
			_Utils_Tuple2('prnap', '⪹'),
			_Utils_Tuple2('prnE', '⪵'),
			_Utils_Tuple2('prnsim', '⋨'),
			_Utils_Tuple2('prod', '∏'),
			_Utils_Tuple2('Product', '∏'),
			_Utils_Tuple2('profalar', '⌮'),
			_Utils_Tuple2('profline', '⌒'),
			_Utils_Tuple2('profsurf', '⌓'),
			_Utils_Tuple2('prop', '∝'),
			_Utils_Tuple2('Proportional', '∝'),
			_Utils_Tuple2('Proportion', '∷'),
			_Utils_Tuple2('propto', '∝'),
			_Utils_Tuple2('prsim', '≾'),
			_Utils_Tuple2('prurel', '⊰'),
			_Utils_Tuple2('Pscr', '\uD835\uDCAB'),
			_Utils_Tuple2('pscr', '\uD835\uDCC5'),
			_Utils_Tuple2('Psi', 'Ψ'),
			_Utils_Tuple2('psi', 'ψ'),
			_Utils_Tuple2('puncsp', '\u2008'),
			_Utils_Tuple2('Qfr', '\uD835\uDD14'),
			_Utils_Tuple2('qfr', '\uD835\uDD2E'),
			_Utils_Tuple2('qint', '⨌'),
			_Utils_Tuple2('qopf', '\uD835\uDD62'),
			_Utils_Tuple2('Qopf', 'ℚ'),
			_Utils_Tuple2('qprime', '⁗'),
			_Utils_Tuple2('Qscr', '\uD835\uDCAC'),
			_Utils_Tuple2('qscr', '\uD835\uDCC6'),
			_Utils_Tuple2('quaternions', 'ℍ'),
			_Utils_Tuple2('quatint', '⨖'),
			_Utils_Tuple2('quest', '?'),
			_Utils_Tuple2('questeq', '≟'),
			_Utils_Tuple2('quot', '\"'),
			_Utils_Tuple2('QUOT', '\"'),
			_Utils_Tuple2('rAarr', '⇛'),
			_Utils_Tuple2('race', '∽̱'),
			_Utils_Tuple2('Racute', 'Ŕ'),
			_Utils_Tuple2('racute', 'ŕ'),
			_Utils_Tuple2('radic', '√'),
			_Utils_Tuple2('raemptyv', '⦳'),
			_Utils_Tuple2('rang', '⟩'),
			_Utils_Tuple2('Rang', '⟫'),
			_Utils_Tuple2('rangd', '⦒'),
			_Utils_Tuple2('range', '⦥'),
			_Utils_Tuple2('rangle', '⟩'),
			_Utils_Tuple2('raquo', '»'),
			_Utils_Tuple2('rarrap', '⥵'),
			_Utils_Tuple2('rarrb', '⇥'),
			_Utils_Tuple2('rarrbfs', '⤠'),
			_Utils_Tuple2('rarrc', '⤳'),
			_Utils_Tuple2('rarr', '→'),
			_Utils_Tuple2('Rarr', '↠'),
			_Utils_Tuple2('rArr', '⇒'),
			_Utils_Tuple2('rarrfs', '⤞'),
			_Utils_Tuple2('rarrhk', '↪'),
			_Utils_Tuple2('rarrlp', '↬'),
			_Utils_Tuple2('rarrpl', '⥅'),
			_Utils_Tuple2('rarrsim', '⥴'),
			_Utils_Tuple2('Rarrtl', '⤖'),
			_Utils_Tuple2('rarrtl', '↣'),
			_Utils_Tuple2('rarrw', '↝'),
			_Utils_Tuple2('ratail', '⤚'),
			_Utils_Tuple2('rAtail', '⤜'),
			_Utils_Tuple2('ratio', '∶'),
			_Utils_Tuple2('rationals', 'ℚ'),
			_Utils_Tuple2('rbarr', '⤍'),
			_Utils_Tuple2('rBarr', '⤏'),
			_Utils_Tuple2('RBarr', '⤐'),
			_Utils_Tuple2('rbbrk', '❳'),
			_Utils_Tuple2('rbrace', '}'),
			_Utils_Tuple2('rbrack', ']'),
			_Utils_Tuple2('rbrke', '⦌'),
			_Utils_Tuple2('rbrksld', '⦎'),
			_Utils_Tuple2('rbrkslu', '⦐'),
			_Utils_Tuple2('Rcaron', 'Ř'),
			_Utils_Tuple2('rcaron', 'ř'),
			_Utils_Tuple2('Rcedil', 'Ŗ'),
			_Utils_Tuple2('rcedil', 'ŗ'),
			_Utils_Tuple2('rceil', '⌉'),
			_Utils_Tuple2('rcub', '}'),
			_Utils_Tuple2('Rcy', 'Р'),
			_Utils_Tuple2('rcy', 'р'),
			_Utils_Tuple2('rdca', '⤷'),
			_Utils_Tuple2('rdldhar', '⥩'),
			_Utils_Tuple2('rdquo', '”'),
			_Utils_Tuple2('rdquor', '”'),
			_Utils_Tuple2('rdsh', '↳'),
			_Utils_Tuple2('real', 'ℜ'),
			_Utils_Tuple2('realine', 'ℛ'),
			_Utils_Tuple2('realpart', 'ℜ'),
			_Utils_Tuple2('reals', 'ℝ'),
			_Utils_Tuple2('Re', 'ℜ'),
			_Utils_Tuple2('rect', '▭'),
			_Utils_Tuple2('reg', '®'),
			_Utils_Tuple2('REG', '®'),
			_Utils_Tuple2('ReverseElement', '∋'),
			_Utils_Tuple2('ReverseEquilibrium', '⇋'),
			_Utils_Tuple2('ReverseUpEquilibrium', '⥯'),
			_Utils_Tuple2('rfisht', '⥽'),
			_Utils_Tuple2('rfloor', '⌋'),
			_Utils_Tuple2('rfr', '\uD835\uDD2F'),
			_Utils_Tuple2('Rfr', 'ℜ'),
			_Utils_Tuple2('rHar', '⥤'),
			_Utils_Tuple2('rhard', '⇁'),
			_Utils_Tuple2('rharu', '⇀'),
			_Utils_Tuple2('rharul', '⥬'),
			_Utils_Tuple2('Rho', 'Ρ'),
			_Utils_Tuple2('rho', 'ρ'),
			_Utils_Tuple2('rhov', 'ϱ'),
			_Utils_Tuple2('RightAngleBracket', '⟩'),
			_Utils_Tuple2('RightArrowBar', '⇥'),
			_Utils_Tuple2('rightarrow', '→'),
			_Utils_Tuple2('RightArrow', '→'),
			_Utils_Tuple2('Rightarrow', '⇒'),
			_Utils_Tuple2('RightArrowLeftArrow', '⇄'),
			_Utils_Tuple2('rightarrowtail', '↣'),
			_Utils_Tuple2('RightCeiling', '⌉'),
			_Utils_Tuple2('RightDoubleBracket', '⟧'),
			_Utils_Tuple2('RightDownTeeVector', '⥝'),
			_Utils_Tuple2('RightDownVectorBar', '⥕'),
			_Utils_Tuple2('RightDownVector', '⇂'),
			_Utils_Tuple2('RightFloor', '⌋'),
			_Utils_Tuple2('rightharpoondown', '⇁'),
			_Utils_Tuple2('rightharpoonup', '⇀'),
			_Utils_Tuple2('rightleftarrows', '⇄'),
			_Utils_Tuple2('rightleftharpoons', '⇌'),
			_Utils_Tuple2('rightrightarrows', '⇉'),
			_Utils_Tuple2('rightsquigarrow', '↝'),
			_Utils_Tuple2('RightTeeArrow', '↦'),
			_Utils_Tuple2('RightTee', '⊢'),
			_Utils_Tuple2('RightTeeVector', '⥛'),
			_Utils_Tuple2('rightthreetimes', '⋌'),
			_Utils_Tuple2('RightTriangleBar', '⧐'),
			_Utils_Tuple2('RightTriangle', '⊳'),
			_Utils_Tuple2('RightTriangleEqual', '⊵'),
			_Utils_Tuple2('RightUpDownVector', '⥏'),
			_Utils_Tuple2('RightUpTeeVector', '⥜'),
			_Utils_Tuple2('RightUpVectorBar', '⥔'),
			_Utils_Tuple2('RightUpVector', '↾'),
			_Utils_Tuple2('RightVectorBar', '⥓'),
			_Utils_Tuple2('RightVector', '⇀'),
			_Utils_Tuple2('ring', '˚'),
			_Utils_Tuple2('risingdotseq', '≓'),
			_Utils_Tuple2('rlarr', '⇄'),
			_Utils_Tuple2('rlhar', '⇌'),
			_Utils_Tuple2('rlm', '\u200F'),
			_Utils_Tuple2('rmoustache', '⎱'),
			_Utils_Tuple2('rmoust', '⎱'),
			_Utils_Tuple2('rnmid', '⫮'),
			_Utils_Tuple2('roang', '⟭'),
			_Utils_Tuple2('roarr', '⇾'),
			_Utils_Tuple2('robrk', '⟧'),
			_Utils_Tuple2('ropar', '⦆'),
			_Utils_Tuple2('ropf', '\uD835\uDD63'),
			_Utils_Tuple2('Ropf', 'ℝ'),
			_Utils_Tuple2('roplus', '⨮'),
			_Utils_Tuple2('rotimes', '⨵'),
			_Utils_Tuple2('RoundImplies', '⥰'),
			_Utils_Tuple2('rpar', ')'),
			_Utils_Tuple2('rpargt', '⦔'),
			_Utils_Tuple2('rppolint', '⨒'),
			_Utils_Tuple2('rrarr', '⇉'),
			_Utils_Tuple2('Rrightarrow', '⇛'),
			_Utils_Tuple2('rsaquo', '›'),
			_Utils_Tuple2('rscr', '\uD835\uDCC7'),
			_Utils_Tuple2('Rscr', 'ℛ'),
			_Utils_Tuple2('rsh', '↱'),
			_Utils_Tuple2('Rsh', '↱'),
			_Utils_Tuple2('rsqb', ']'),
			_Utils_Tuple2('rsquo', '’'),
			_Utils_Tuple2('rsquor', '’'),
			_Utils_Tuple2('rthree', '⋌'),
			_Utils_Tuple2('rtimes', '⋊'),
			_Utils_Tuple2('rtri', '▹'),
			_Utils_Tuple2('rtrie', '⊵'),
			_Utils_Tuple2('rtrif', '▸'),
			_Utils_Tuple2('rtriltri', '⧎'),
			_Utils_Tuple2('RuleDelayed', '⧴'),
			_Utils_Tuple2('ruluhar', '⥨'),
			_Utils_Tuple2('rx', '℞'),
			_Utils_Tuple2('Sacute', 'Ś'),
			_Utils_Tuple2('sacute', 'ś'),
			_Utils_Tuple2('sbquo', '‚'),
			_Utils_Tuple2('scap', '⪸'),
			_Utils_Tuple2('Scaron', 'Š'),
			_Utils_Tuple2('scaron', 'š'),
			_Utils_Tuple2('Sc', '⪼'),
			_Utils_Tuple2('sc', '≻'),
			_Utils_Tuple2('sccue', '≽'),
			_Utils_Tuple2('sce', '⪰'),
			_Utils_Tuple2('scE', '⪴'),
			_Utils_Tuple2('Scedil', 'Ş'),
			_Utils_Tuple2('scedil', 'ş'),
			_Utils_Tuple2('Scirc', 'Ŝ'),
			_Utils_Tuple2('scirc', 'ŝ'),
			_Utils_Tuple2('scnap', '⪺'),
			_Utils_Tuple2('scnE', '⪶'),
			_Utils_Tuple2('scnsim', '⋩'),
			_Utils_Tuple2('scpolint', '⨓'),
			_Utils_Tuple2('scsim', '≿'),
			_Utils_Tuple2('Scy', 'С'),
			_Utils_Tuple2('scy', 'с'),
			_Utils_Tuple2('sdotb', '⊡'),
			_Utils_Tuple2('sdot', '⋅'),
			_Utils_Tuple2('sdote', '⩦'),
			_Utils_Tuple2('searhk', '⤥'),
			_Utils_Tuple2('searr', '↘'),
			_Utils_Tuple2('seArr', '⇘'),
			_Utils_Tuple2('searrow', '↘'),
			_Utils_Tuple2('sect', '§'),
			_Utils_Tuple2('semi', ';'),
			_Utils_Tuple2('seswar', '⤩'),
			_Utils_Tuple2('setminus', '∖'),
			_Utils_Tuple2('setmn', '∖'),
			_Utils_Tuple2('sext', '✶'),
			_Utils_Tuple2('Sfr', '\uD835\uDD16'),
			_Utils_Tuple2('sfr', '\uD835\uDD30'),
			_Utils_Tuple2('sfrown', '⌢'),
			_Utils_Tuple2('sharp', '♯'),
			_Utils_Tuple2('SHCHcy', 'Щ'),
			_Utils_Tuple2('shchcy', 'щ'),
			_Utils_Tuple2('SHcy', 'Ш'),
			_Utils_Tuple2('shcy', 'ш'),
			_Utils_Tuple2('ShortDownArrow', '↓'),
			_Utils_Tuple2('ShortLeftArrow', '←'),
			_Utils_Tuple2('shortmid', '∣'),
			_Utils_Tuple2('shortparallel', '∥'),
			_Utils_Tuple2('ShortRightArrow', '→'),
			_Utils_Tuple2('ShortUpArrow', '↑'),
			_Utils_Tuple2('shy', '\u00AD'),
			_Utils_Tuple2('Sigma', 'Σ'),
			_Utils_Tuple2('sigma', 'σ'),
			_Utils_Tuple2('sigmaf', 'ς'),
			_Utils_Tuple2('sigmav', 'ς'),
			_Utils_Tuple2('sim', '∼'),
			_Utils_Tuple2('simdot', '⩪'),
			_Utils_Tuple2('sime', '≃'),
			_Utils_Tuple2('simeq', '≃'),
			_Utils_Tuple2('simg', '⪞'),
			_Utils_Tuple2('simgE', '⪠'),
			_Utils_Tuple2('siml', '⪝'),
			_Utils_Tuple2('simlE', '⪟'),
			_Utils_Tuple2('simne', '≆'),
			_Utils_Tuple2('simplus', '⨤'),
			_Utils_Tuple2('simrarr', '⥲'),
			_Utils_Tuple2('slarr', '←'),
			_Utils_Tuple2('SmallCircle', '∘'),
			_Utils_Tuple2('smallsetminus', '∖'),
			_Utils_Tuple2('smashp', '⨳'),
			_Utils_Tuple2('smeparsl', '⧤'),
			_Utils_Tuple2('smid', '∣'),
			_Utils_Tuple2('smile', '⌣'),
			_Utils_Tuple2('smt', '⪪'),
			_Utils_Tuple2('smte', '⪬'),
			_Utils_Tuple2('smtes', '⪬︀'),
			_Utils_Tuple2('SOFTcy', 'Ь'),
			_Utils_Tuple2('softcy', 'ь'),
			_Utils_Tuple2('solbar', '⌿'),
			_Utils_Tuple2('solb', '⧄'),
			_Utils_Tuple2('sol', '/'),
			_Utils_Tuple2('Sopf', '\uD835\uDD4A'),
			_Utils_Tuple2('sopf', '\uD835\uDD64'),
			_Utils_Tuple2('spades', '♠'),
			_Utils_Tuple2('spadesuit', '♠'),
			_Utils_Tuple2('spar', '∥'),
			_Utils_Tuple2('sqcap', '⊓'),
			_Utils_Tuple2('sqcaps', '⊓︀'),
			_Utils_Tuple2('sqcup', '⊔'),
			_Utils_Tuple2('sqcups', '⊔︀'),
			_Utils_Tuple2('Sqrt', '√'),
			_Utils_Tuple2('sqsub', '⊏'),
			_Utils_Tuple2('sqsube', '⊑'),
			_Utils_Tuple2('sqsubset', '⊏'),
			_Utils_Tuple2('sqsubseteq', '⊑'),
			_Utils_Tuple2('sqsup', '⊐'),
			_Utils_Tuple2('sqsupe', '⊒'),
			_Utils_Tuple2('sqsupset', '⊐'),
			_Utils_Tuple2('sqsupseteq', '⊒'),
			_Utils_Tuple2('square', '□'),
			_Utils_Tuple2('Square', '□'),
			_Utils_Tuple2('SquareIntersection', '⊓'),
			_Utils_Tuple2('SquareSubset', '⊏'),
			_Utils_Tuple2('SquareSubsetEqual', '⊑'),
			_Utils_Tuple2('SquareSuperset', '⊐'),
			_Utils_Tuple2('SquareSupersetEqual', '⊒'),
			_Utils_Tuple2('SquareUnion', '⊔'),
			_Utils_Tuple2('squarf', '▪'),
			_Utils_Tuple2('squ', '□'),
			_Utils_Tuple2('squf', '▪'),
			_Utils_Tuple2('srarr', '→'),
			_Utils_Tuple2('Sscr', '\uD835\uDCAE'),
			_Utils_Tuple2('sscr', '\uD835\uDCC8'),
			_Utils_Tuple2('ssetmn', '∖'),
			_Utils_Tuple2('ssmile', '⌣'),
			_Utils_Tuple2('sstarf', '⋆'),
			_Utils_Tuple2('Star', '⋆'),
			_Utils_Tuple2('star', '☆'),
			_Utils_Tuple2('starf', '★'),
			_Utils_Tuple2('straightepsilon', 'ϵ'),
			_Utils_Tuple2('straightphi', 'ϕ'),
			_Utils_Tuple2('strns', '¯'),
			_Utils_Tuple2('sub', '⊂'),
			_Utils_Tuple2('Sub', '⋐'),
			_Utils_Tuple2('subdot', '⪽'),
			_Utils_Tuple2('subE', '⫅'),
			_Utils_Tuple2('sube', '⊆'),
			_Utils_Tuple2('subedot', '⫃'),
			_Utils_Tuple2('submult', '⫁'),
			_Utils_Tuple2('subnE', '⫋'),
			_Utils_Tuple2('subne', '⊊'),
			_Utils_Tuple2('subplus', '⪿'),
			_Utils_Tuple2('subrarr', '⥹'),
			_Utils_Tuple2('subset', '⊂'),
			_Utils_Tuple2('Subset', '⋐'),
			_Utils_Tuple2('subseteq', '⊆'),
			_Utils_Tuple2('subseteqq', '⫅'),
			_Utils_Tuple2('SubsetEqual', '⊆'),
			_Utils_Tuple2('subsetneq', '⊊'),
			_Utils_Tuple2('subsetneqq', '⫋'),
			_Utils_Tuple2('subsim', '⫇'),
			_Utils_Tuple2('subsub', '⫕'),
			_Utils_Tuple2('subsup', '⫓'),
			_Utils_Tuple2('succapprox', '⪸'),
			_Utils_Tuple2('succ', '≻'),
			_Utils_Tuple2('succcurlyeq', '≽'),
			_Utils_Tuple2('Succeeds', '≻'),
			_Utils_Tuple2('SucceedsEqual', '⪰'),
			_Utils_Tuple2('SucceedsSlantEqual', '≽'),
			_Utils_Tuple2('SucceedsTilde', '≿'),
			_Utils_Tuple2('succeq', '⪰'),
			_Utils_Tuple2('succnapprox', '⪺'),
			_Utils_Tuple2('succneqq', '⪶'),
			_Utils_Tuple2('succnsim', '⋩'),
			_Utils_Tuple2('succsim', '≿'),
			_Utils_Tuple2('SuchThat', '∋'),
			_Utils_Tuple2('sum', '∑'),
			_Utils_Tuple2('Sum', '∑'),
			_Utils_Tuple2('sung', '♪'),
			_Utils_Tuple2('sup1', '¹'),
			_Utils_Tuple2('sup2', '²'),
			_Utils_Tuple2('sup3', '³'),
			_Utils_Tuple2('sup', '⊃'),
			_Utils_Tuple2('Sup', '⋑'),
			_Utils_Tuple2('supdot', '⪾'),
			_Utils_Tuple2('supdsub', '⫘'),
			_Utils_Tuple2('supE', '⫆'),
			_Utils_Tuple2('supe', '⊇'),
			_Utils_Tuple2('supedot', '⫄'),
			_Utils_Tuple2('Superset', '⊃'),
			_Utils_Tuple2('SupersetEqual', '⊇'),
			_Utils_Tuple2('suphsol', '⟉'),
			_Utils_Tuple2('suphsub', '⫗'),
			_Utils_Tuple2('suplarr', '⥻'),
			_Utils_Tuple2('supmult', '⫂'),
			_Utils_Tuple2('supnE', '⫌'),
			_Utils_Tuple2('supne', '⊋'),
			_Utils_Tuple2('supplus', '⫀'),
			_Utils_Tuple2('supset', '⊃'),
			_Utils_Tuple2('Supset', '⋑'),
			_Utils_Tuple2('supseteq', '⊇'),
			_Utils_Tuple2('supseteqq', '⫆'),
			_Utils_Tuple2('supsetneq', '⊋'),
			_Utils_Tuple2('supsetneqq', '⫌'),
			_Utils_Tuple2('supsim', '⫈'),
			_Utils_Tuple2('supsub', '⫔'),
			_Utils_Tuple2('supsup', '⫖'),
			_Utils_Tuple2('swarhk', '⤦'),
			_Utils_Tuple2('swarr', '↙'),
			_Utils_Tuple2('swArr', '⇙'),
			_Utils_Tuple2('swarrow', '↙'),
			_Utils_Tuple2('swnwar', '⤪'),
			_Utils_Tuple2('szlig', 'ß'),
			_Utils_Tuple2('Tab', '\t'),
			_Utils_Tuple2('target', '⌖'),
			_Utils_Tuple2('Tau', 'Τ'),
			_Utils_Tuple2('tau', 'τ'),
			_Utils_Tuple2('tbrk', '⎴'),
			_Utils_Tuple2('Tcaron', 'Ť'),
			_Utils_Tuple2('tcaron', 'ť'),
			_Utils_Tuple2('Tcedil', 'Ţ'),
			_Utils_Tuple2('tcedil', 'ţ'),
			_Utils_Tuple2('Tcy', 'Т'),
			_Utils_Tuple2('tcy', 'т'),
			_Utils_Tuple2('tdot', '⃛'),
			_Utils_Tuple2('telrec', '⌕'),
			_Utils_Tuple2('Tfr', '\uD835\uDD17'),
			_Utils_Tuple2('tfr', '\uD835\uDD31'),
			_Utils_Tuple2('there4', '∴'),
			_Utils_Tuple2('therefore', '∴'),
			_Utils_Tuple2('Therefore', '∴'),
			_Utils_Tuple2('Theta', 'Θ'),
			_Utils_Tuple2('theta', 'θ'),
			_Utils_Tuple2('thetasym', 'ϑ'),
			_Utils_Tuple2('thetav', 'ϑ'),
			_Utils_Tuple2('thickapprox', '≈'),
			_Utils_Tuple2('thicksim', '∼'),
			_Utils_Tuple2('ThickSpace', '\u205F\u200A'),
			_Utils_Tuple2('ThinSpace', '\u2009'),
			_Utils_Tuple2('thinsp', '\u2009'),
			_Utils_Tuple2('thkap', '≈'),
			_Utils_Tuple2('thksim', '∼'),
			_Utils_Tuple2('THORN', 'Þ'),
			_Utils_Tuple2('thorn', 'þ'),
			_Utils_Tuple2('tilde', '˜'),
			_Utils_Tuple2('Tilde', '∼'),
			_Utils_Tuple2('TildeEqual', '≃'),
			_Utils_Tuple2('TildeFullEqual', '≅'),
			_Utils_Tuple2('TildeTilde', '≈'),
			_Utils_Tuple2('timesbar', '⨱'),
			_Utils_Tuple2('timesb', '⊠'),
			_Utils_Tuple2('times', '×'),
			_Utils_Tuple2('timesd', '⨰'),
			_Utils_Tuple2('tint', '∭'),
			_Utils_Tuple2('toea', '⤨'),
			_Utils_Tuple2('topbot', '⌶'),
			_Utils_Tuple2('topcir', '⫱'),
			_Utils_Tuple2('top', '⊤'),
			_Utils_Tuple2('Topf', '\uD835\uDD4B'),
			_Utils_Tuple2('topf', '\uD835\uDD65'),
			_Utils_Tuple2('topfork', '⫚'),
			_Utils_Tuple2('tosa', '⤩'),
			_Utils_Tuple2('tprime', '‴'),
			_Utils_Tuple2('trade', '™'),
			_Utils_Tuple2('TRADE', '™'),
			_Utils_Tuple2('triangle', '▵'),
			_Utils_Tuple2('triangledown', '▿'),
			_Utils_Tuple2('triangleleft', '◃'),
			_Utils_Tuple2('trianglelefteq', '⊴'),
			_Utils_Tuple2('triangleq', '≜'),
			_Utils_Tuple2('triangleright', '▹'),
			_Utils_Tuple2('trianglerighteq', '⊵'),
			_Utils_Tuple2('tridot', '◬'),
			_Utils_Tuple2('trie', '≜'),
			_Utils_Tuple2('triminus', '⨺'),
			_Utils_Tuple2('TripleDot', '⃛'),
			_Utils_Tuple2('triplus', '⨹'),
			_Utils_Tuple2('trisb', '⧍'),
			_Utils_Tuple2('tritime', '⨻'),
			_Utils_Tuple2('trpezium', '⏢'),
			_Utils_Tuple2('Tscr', '\uD835\uDCAF'),
			_Utils_Tuple2('tscr', '\uD835\uDCC9'),
			_Utils_Tuple2('TScy', 'Ц'),
			_Utils_Tuple2('tscy', 'ц'),
			_Utils_Tuple2('TSHcy', 'Ћ'),
			_Utils_Tuple2('tshcy', 'ћ'),
			_Utils_Tuple2('Tstrok', 'Ŧ'),
			_Utils_Tuple2('tstrok', 'ŧ'),
			_Utils_Tuple2('twixt', '≬'),
			_Utils_Tuple2('twoheadleftarrow', '↞'),
			_Utils_Tuple2('twoheadrightarrow', '↠'),
			_Utils_Tuple2('Uacute', 'Ú'),
			_Utils_Tuple2('uacute', 'ú'),
			_Utils_Tuple2('uarr', '↑'),
			_Utils_Tuple2('Uarr', '↟'),
			_Utils_Tuple2('uArr', '⇑'),
			_Utils_Tuple2('Uarrocir', '⥉'),
			_Utils_Tuple2('Ubrcy', 'Ў'),
			_Utils_Tuple2('ubrcy', 'ў'),
			_Utils_Tuple2('Ubreve', 'Ŭ'),
			_Utils_Tuple2('ubreve', 'ŭ'),
			_Utils_Tuple2('Ucirc', 'Û'),
			_Utils_Tuple2('ucirc', 'û'),
			_Utils_Tuple2('Ucy', 'У'),
			_Utils_Tuple2('ucy', 'у'),
			_Utils_Tuple2('udarr', '⇅'),
			_Utils_Tuple2('Udblac', 'Ű'),
			_Utils_Tuple2('udblac', 'ű'),
			_Utils_Tuple2('udhar', '⥮'),
			_Utils_Tuple2('ufisht', '⥾'),
			_Utils_Tuple2('Ufr', '\uD835\uDD18'),
			_Utils_Tuple2('ufr', '\uD835\uDD32'),
			_Utils_Tuple2('Ugrave', 'Ù'),
			_Utils_Tuple2('ugrave', 'ù'),
			_Utils_Tuple2('uHar', '⥣'),
			_Utils_Tuple2('uharl', '↿'),
			_Utils_Tuple2('uharr', '↾'),
			_Utils_Tuple2('uhblk', '▀'),
			_Utils_Tuple2('ulcorn', '⌜'),
			_Utils_Tuple2('ulcorner', '⌜'),
			_Utils_Tuple2('ulcrop', '⌏'),
			_Utils_Tuple2('ultri', '◸'),
			_Utils_Tuple2('Umacr', 'Ū'),
			_Utils_Tuple2('umacr', 'ū'),
			_Utils_Tuple2('uml', '¨'),
			_Utils_Tuple2('UnderBar', '_'),
			_Utils_Tuple2('UnderBrace', '⏟'),
			_Utils_Tuple2('UnderBracket', '⎵'),
			_Utils_Tuple2('UnderParenthesis', '⏝'),
			_Utils_Tuple2('Union', '⋃'),
			_Utils_Tuple2('UnionPlus', '⊎'),
			_Utils_Tuple2('Uogon', 'Ų'),
			_Utils_Tuple2('uogon', 'ų'),
			_Utils_Tuple2('Uopf', '\uD835\uDD4C'),
			_Utils_Tuple2('uopf', '\uD835\uDD66'),
			_Utils_Tuple2('UpArrowBar', '⤒'),
			_Utils_Tuple2('uparrow', '↑'),
			_Utils_Tuple2('UpArrow', '↑'),
			_Utils_Tuple2('Uparrow', '⇑'),
			_Utils_Tuple2('UpArrowDownArrow', '⇅'),
			_Utils_Tuple2('updownarrow', '↕'),
			_Utils_Tuple2('UpDownArrow', '↕'),
			_Utils_Tuple2('Updownarrow', '⇕'),
			_Utils_Tuple2('UpEquilibrium', '⥮'),
			_Utils_Tuple2('upharpoonleft', '↿'),
			_Utils_Tuple2('upharpoonright', '↾'),
			_Utils_Tuple2('uplus', '⊎'),
			_Utils_Tuple2('UpperLeftArrow', '↖'),
			_Utils_Tuple2('UpperRightArrow', '↗'),
			_Utils_Tuple2('upsi', 'υ'),
			_Utils_Tuple2('Upsi', 'ϒ'),
			_Utils_Tuple2('upsih', 'ϒ'),
			_Utils_Tuple2('Upsilon', 'Υ'),
			_Utils_Tuple2('upsilon', 'υ'),
			_Utils_Tuple2('UpTeeArrow', '↥'),
			_Utils_Tuple2('UpTee', '⊥'),
			_Utils_Tuple2('upuparrows', '⇈'),
			_Utils_Tuple2('urcorn', '⌝'),
			_Utils_Tuple2('urcorner', '⌝'),
			_Utils_Tuple2('urcrop', '⌎'),
			_Utils_Tuple2('Uring', 'Ů'),
			_Utils_Tuple2('uring', 'ů'),
			_Utils_Tuple2('urtri', '◹'),
			_Utils_Tuple2('Uscr', '\uD835\uDCB0'),
			_Utils_Tuple2('uscr', '\uD835\uDCCA'),
			_Utils_Tuple2('utdot', '⋰'),
			_Utils_Tuple2('Utilde', 'Ũ'),
			_Utils_Tuple2('utilde', 'ũ'),
			_Utils_Tuple2('utri', '▵'),
			_Utils_Tuple2('utrif', '▴'),
			_Utils_Tuple2('uuarr', '⇈'),
			_Utils_Tuple2('Uuml', 'Ü'),
			_Utils_Tuple2('uuml', 'ü'),
			_Utils_Tuple2('uwangle', '⦧'),
			_Utils_Tuple2('vangrt', '⦜'),
			_Utils_Tuple2('varepsilon', 'ϵ'),
			_Utils_Tuple2('varkappa', 'ϰ'),
			_Utils_Tuple2('varnothing', '∅'),
			_Utils_Tuple2('varphi', 'ϕ'),
			_Utils_Tuple2('varpi', 'ϖ'),
			_Utils_Tuple2('varpropto', '∝'),
			_Utils_Tuple2('varr', '↕'),
			_Utils_Tuple2('vArr', '⇕'),
			_Utils_Tuple2('varrho', 'ϱ'),
			_Utils_Tuple2('varsigma', 'ς'),
			_Utils_Tuple2('varsubsetneq', '⊊︀'),
			_Utils_Tuple2('varsubsetneqq', '⫋︀'),
			_Utils_Tuple2('varsupsetneq', '⊋︀'),
			_Utils_Tuple2('varsupsetneqq', '⫌︀'),
			_Utils_Tuple2('vartheta', 'ϑ'),
			_Utils_Tuple2('vartriangleleft', '⊲'),
			_Utils_Tuple2('vartriangleright', '⊳'),
			_Utils_Tuple2('vBar', '⫨'),
			_Utils_Tuple2('Vbar', '⫫'),
			_Utils_Tuple2('vBarv', '⫩'),
			_Utils_Tuple2('Vcy', 'В'),
			_Utils_Tuple2('vcy', 'в'),
			_Utils_Tuple2('vdash', '⊢'),
			_Utils_Tuple2('vDash', '⊨'),
			_Utils_Tuple2('Vdash', '⊩'),
			_Utils_Tuple2('VDash', '⊫'),
			_Utils_Tuple2('Vdashl', '⫦'),
			_Utils_Tuple2('veebar', '⊻'),
			_Utils_Tuple2('vee', '∨'),
			_Utils_Tuple2('Vee', '⋁'),
			_Utils_Tuple2('veeeq', '≚'),
			_Utils_Tuple2('vellip', '⋮'),
			_Utils_Tuple2('verbar', '|'),
			_Utils_Tuple2('Verbar', '‖'),
			_Utils_Tuple2('vert', '|'),
			_Utils_Tuple2('Vert', '‖'),
			_Utils_Tuple2('VerticalBar', '∣'),
			_Utils_Tuple2('VerticalLine', '|'),
			_Utils_Tuple2('VerticalSeparator', '❘'),
			_Utils_Tuple2('VerticalTilde', '≀'),
			_Utils_Tuple2('VeryThinSpace', '\u200A'),
			_Utils_Tuple2('Vfr', '\uD835\uDD19'),
			_Utils_Tuple2('vfr', '\uD835\uDD33'),
			_Utils_Tuple2('vltri', '⊲'),
			_Utils_Tuple2('vnsub', '⊂⃒'),
			_Utils_Tuple2('vnsup', '⊃⃒'),
			_Utils_Tuple2('Vopf', '\uD835\uDD4D'),
			_Utils_Tuple2('vopf', '\uD835\uDD67'),
			_Utils_Tuple2('vprop', '∝'),
			_Utils_Tuple2('vrtri', '⊳'),
			_Utils_Tuple2('Vscr', '\uD835\uDCB1'),
			_Utils_Tuple2('vscr', '\uD835\uDCCB'),
			_Utils_Tuple2('vsubnE', '⫋︀'),
			_Utils_Tuple2('vsubne', '⊊︀'),
			_Utils_Tuple2('vsupnE', '⫌︀'),
			_Utils_Tuple2('vsupne', '⊋︀'),
			_Utils_Tuple2('Vvdash', '⊪'),
			_Utils_Tuple2('vzigzag', '⦚'),
			_Utils_Tuple2('Wcirc', 'Ŵ'),
			_Utils_Tuple2('wcirc', 'ŵ'),
			_Utils_Tuple2('wedbar', '⩟'),
			_Utils_Tuple2('wedge', '∧'),
			_Utils_Tuple2('Wedge', '⋀'),
			_Utils_Tuple2('wedgeq', '≙'),
			_Utils_Tuple2('weierp', '℘'),
			_Utils_Tuple2('Wfr', '\uD835\uDD1A'),
			_Utils_Tuple2('wfr', '\uD835\uDD34'),
			_Utils_Tuple2('Wopf', '\uD835\uDD4E'),
			_Utils_Tuple2('wopf', '\uD835\uDD68'),
			_Utils_Tuple2('wp', '℘'),
			_Utils_Tuple2('wr', '≀'),
			_Utils_Tuple2('wreath', '≀'),
			_Utils_Tuple2('Wscr', '\uD835\uDCB2'),
			_Utils_Tuple2('wscr', '\uD835\uDCCC'),
			_Utils_Tuple2('xcap', '⋂'),
			_Utils_Tuple2('xcirc', '◯'),
			_Utils_Tuple2('xcup', '⋃'),
			_Utils_Tuple2('xdtri', '▽'),
			_Utils_Tuple2('Xfr', '\uD835\uDD1B'),
			_Utils_Tuple2('xfr', '\uD835\uDD35'),
			_Utils_Tuple2('xharr', '⟷'),
			_Utils_Tuple2('xhArr', '⟺'),
			_Utils_Tuple2('Xi', 'Ξ'),
			_Utils_Tuple2('xi', 'ξ'),
			_Utils_Tuple2('xlarr', '⟵'),
			_Utils_Tuple2('xlArr', '⟸'),
			_Utils_Tuple2('xmap', '⟼'),
			_Utils_Tuple2('xnis', '⋻'),
			_Utils_Tuple2('xodot', '⨀'),
			_Utils_Tuple2('Xopf', '\uD835\uDD4F'),
			_Utils_Tuple2('xopf', '\uD835\uDD69'),
			_Utils_Tuple2('xoplus', '⨁'),
			_Utils_Tuple2('xotime', '⨂'),
			_Utils_Tuple2('xrarr', '⟶'),
			_Utils_Tuple2('xrArr', '⟹'),
			_Utils_Tuple2('Xscr', '\uD835\uDCB3'),
			_Utils_Tuple2('xscr', '\uD835\uDCCD'),
			_Utils_Tuple2('xsqcup', '⨆'),
			_Utils_Tuple2('xuplus', '⨄'),
			_Utils_Tuple2('xutri', '△'),
			_Utils_Tuple2('xvee', '⋁'),
			_Utils_Tuple2('xwedge', '⋀'),
			_Utils_Tuple2('Yacute', 'Ý'),
			_Utils_Tuple2('yacute', 'ý'),
			_Utils_Tuple2('YAcy', 'Я'),
			_Utils_Tuple2('yacy', 'я'),
			_Utils_Tuple2('Ycirc', 'Ŷ'),
			_Utils_Tuple2('ycirc', 'ŷ'),
			_Utils_Tuple2('Ycy', 'Ы'),
			_Utils_Tuple2('ycy', 'ы'),
			_Utils_Tuple2('yen', '¥'),
			_Utils_Tuple2('Yfr', '\uD835\uDD1C'),
			_Utils_Tuple2('yfr', '\uD835\uDD36'),
			_Utils_Tuple2('YIcy', 'Ї'),
			_Utils_Tuple2('yicy', 'ї'),
			_Utils_Tuple2('Yopf', '\uD835\uDD50'),
			_Utils_Tuple2('yopf', '\uD835\uDD6A'),
			_Utils_Tuple2('Yscr', '\uD835\uDCB4'),
			_Utils_Tuple2('yscr', '\uD835\uDCCE'),
			_Utils_Tuple2('YUcy', 'Ю'),
			_Utils_Tuple2('yucy', 'ю'),
			_Utils_Tuple2('yuml', 'ÿ'),
			_Utils_Tuple2('Yuml', 'Ÿ'),
			_Utils_Tuple2('Zacute', 'Ź'),
			_Utils_Tuple2('zacute', 'ź'),
			_Utils_Tuple2('Zcaron', 'Ž'),
			_Utils_Tuple2('zcaron', 'ž'),
			_Utils_Tuple2('Zcy', 'З'),
			_Utils_Tuple2('zcy', 'з'),
			_Utils_Tuple2('Zdot', 'Ż'),
			_Utils_Tuple2('zdot', 'ż'),
			_Utils_Tuple2('zeetrf', 'ℨ'),
			_Utils_Tuple2('ZeroWidthSpace', '\u200B'),
			_Utils_Tuple2('Zeta', 'Ζ'),
			_Utils_Tuple2('zeta', 'ζ'),
			_Utils_Tuple2('zfr', '\uD835\uDD37'),
			_Utils_Tuple2('Zfr', 'ℨ'),
			_Utils_Tuple2('ZHcy', 'Ж'),
			_Utils_Tuple2('zhcy', 'ж'),
			_Utils_Tuple2('zigrarr', '⇝'),
			_Utils_Tuple2('zopf', '\uD835\uDD6B'),
			_Utils_Tuple2('Zopf', 'ℤ'),
			_Utils_Tuple2('Zscr', '\uD835\uDCB5'),
			_Utils_Tuple2('zscr', '\uD835\uDCCF'),
			_Utils_Tuple2('zwj', '\u200D'),
			_Utils_Tuple2('zwnj', '\u200C')
		]));
var $hecrj$html_parser$Html$Parser$namedCharacterReference = A2(
	$elm$parser$Parser$map,
	function (reference) {
		return A2(
			$elm$core$Maybe$withDefault,
			'&' + (reference + ';'),
			A2($elm$core$Dict$get, reference, $hecrj$html_parser$Html$Parser$NamedCharacterReferences$dict));
	},
	$elm$parser$Parser$getChompedString(
		$hecrj$html_parser$Html$Parser$chompOneOrMore($elm$core$Char$isAlpha)));
var $elm$core$Char$fromCode = _Char_fromCode;
var $elm$core$Basics$pow = _Basics_pow;
var $rtfeldman$elm_hex$Hex$fromStringHelp = F3(
	function (position, chars, accumulated) {
		fromStringHelp:
		while (true) {
			if (!chars.b) {
				return $elm$core$Result$Ok(accumulated);
			} else {
				var _char = chars.a;
				var rest = chars.b;
				switch (_char) {
					case '0':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated;
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '1':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + A2($elm$core$Basics$pow, 16, position);
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '2':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (2 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '3':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (3 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '4':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (4 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '5':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (5 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '6':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (6 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '7':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (7 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '8':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (8 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '9':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (9 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'a':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (10 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'b':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (11 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'c':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (12 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'd':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (13 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'e':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (14 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'f':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (15 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					default:
						var nonHex = _char;
						return $elm$core$Result$Err(
							$elm$core$String$fromChar(nonHex) + ' is not a valid hexadecimal character.');
				}
			}
		}
	});
var $elm$core$List$tail = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(xs);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $rtfeldman$elm_hex$Hex$fromString = function (str) {
	if ($elm$core$String$isEmpty(str)) {
		return $elm$core$Result$Err('Empty strings are not valid hexadecimal strings.');
	} else {
		var result = function () {
			if (A2($elm$core$String$startsWith, '-', str)) {
				var list = A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					$elm$core$List$tail(
						$elm$core$String$toList(str)));
				return A2(
					$elm$core$Result$map,
					$elm$core$Basics$negate,
					A3(
						$rtfeldman$elm_hex$Hex$fromStringHelp,
						$elm$core$List$length(list) - 1,
						list,
						0));
			} else {
				return A3(
					$rtfeldman$elm_hex$Hex$fromStringHelp,
					$elm$core$String$length(str) - 1,
					$elm$core$String$toList(str),
					0);
			}
		}();
		var formatError = function (err) {
			return A2(
				$elm$core$String$join,
				' ',
				_List_fromArray(
					['\"' + (str + '\"'), 'is not a valid hexadecimal string because', err]));
		};
		return A2($elm$core$Result$mapError, formatError, result);
	}
};
var $elm$core$Char$isHexDigit = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return ((48 <= code) && (code <= 57)) || (((65 <= code) && (code <= 70)) || ((97 <= code) && (code <= 102)));
};
var $hecrj$html_parser$Html$Parser$hexadecimal = A2(
	$elm$parser$Parser$andThen,
	function (hex) {
		var _v0 = $rtfeldman$elm_hex$Hex$fromString(
			$elm$core$String$toLower(hex));
		if (!_v0.$) {
			var value = _v0.a;
			return $elm$parser$Parser$succeed(value);
		} else {
			var error = _v0.a;
			return $elm$parser$Parser$problem(error);
		}
	},
	$elm$parser$Parser$getChompedString(
		$hecrj$html_parser$Html$Parser$chompOneOrMore($elm$core$Char$isHexDigit)));
var $elm$parser$Parser$ExpectingInt = {$: 1};
var $elm$parser$Parser$Advanced$consumeBase = _Parser_consumeBase;
var $elm$parser$Parser$Advanced$consumeBase16 = _Parser_consumeBase16;
var $elm$parser$Parser$Advanced$bumpOffset = F2(
	function (newOffset, s) {
		return {rB: s.rB + (newOffset - s.F), f: s.f, h: s.h, F: newOffset, adA: s.adA, ek: s.ek};
	});
var $elm$parser$Parser$Advanced$chompBase10 = _Parser_chompBase10;
var $elm$parser$Parser$Advanced$isAsciiCode = _Parser_isAsciiCode;
var $elm$parser$Parser$Advanced$consumeExp = F2(
	function (offset, src) {
		if (A3($elm$parser$Parser$Advanced$isAsciiCode, 101, offset, src) || A3($elm$parser$Parser$Advanced$isAsciiCode, 69, offset, src)) {
			var eOffset = offset + 1;
			var expOffset = (A3($elm$parser$Parser$Advanced$isAsciiCode, 43, eOffset, src) || A3($elm$parser$Parser$Advanced$isAsciiCode, 45, eOffset, src)) ? (eOffset + 1) : eOffset;
			var newOffset = A2($elm$parser$Parser$Advanced$chompBase10, expOffset, src);
			return _Utils_eq(expOffset, newOffset) ? (-newOffset) : newOffset;
		} else {
			return offset;
		}
	});
var $elm$parser$Parser$Advanced$consumeDotAndExp = F2(
	function (offset, src) {
		return A3($elm$parser$Parser$Advanced$isAsciiCode, 46, offset, src) ? A2(
			$elm$parser$Parser$Advanced$consumeExp,
			A2($elm$parser$Parser$Advanced$chompBase10, offset + 1, src),
			src) : A2($elm$parser$Parser$Advanced$consumeExp, offset, src);
	});
var $elm$parser$Parser$Advanced$finalizeInt = F5(
	function (invalid, handler, startOffset, _v0, s) {
		var endOffset = _v0.a;
		var n = _v0.b;
		if (handler.$ === 1) {
			var x = handler.a;
			return A2(
				$elm$parser$Parser$Advanced$Bad,
				true,
				A2($elm$parser$Parser$Advanced$fromState, s, x));
		} else {
			var toValue = handler.a;
			return _Utils_eq(startOffset, endOffset) ? A2(
				$elm$parser$Parser$Advanced$Bad,
				_Utils_cmp(s.F, startOffset) < 0,
				A2($elm$parser$Parser$Advanced$fromState, s, invalid)) : A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				toValue(n),
				A2($elm$parser$Parser$Advanced$bumpOffset, endOffset, s));
		}
	});
var $elm$core$String$toFloat = _String_toFloat;
var $elm$parser$Parser$Advanced$finalizeFloat = F6(
	function (invalid, expecting, intSettings, floatSettings, intPair, s) {
		var intOffset = intPair.a;
		var floatOffset = A2($elm$parser$Parser$Advanced$consumeDotAndExp, intOffset, s.ek);
		if (floatOffset < 0) {
			return A2(
				$elm$parser$Parser$Advanced$Bad,
				true,
				A4($elm$parser$Parser$Advanced$fromInfo, s.adA, s.rB - (floatOffset + s.F), invalid, s.f));
		} else {
			if (_Utils_eq(s.F, floatOffset)) {
				return A2(
					$elm$parser$Parser$Advanced$Bad,
					false,
					A2($elm$parser$Parser$Advanced$fromState, s, expecting));
			} else {
				if (_Utils_eq(intOffset, floatOffset)) {
					return A5($elm$parser$Parser$Advanced$finalizeInt, invalid, intSettings, s.F, intPair, s);
				} else {
					if (floatSettings.$ === 1) {
						var x = floatSettings.a;
						return A2(
							$elm$parser$Parser$Advanced$Bad,
							true,
							A2($elm$parser$Parser$Advanced$fromState, s, invalid));
					} else {
						var toValue = floatSettings.a;
						var _v1 = $elm$core$String$toFloat(
							A3($elm$core$String$slice, s.F, floatOffset, s.ek));
						if (_v1.$ === 1) {
							return A2(
								$elm$parser$Parser$Advanced$Bad,
								true,
								A2($elm$parser$Parser$Advanced$fromState, s, invalid));
						} else {
							var n = _v1.a;
							return A3(
								$elm$parser$Parser$Advanced$Good,
								true,
								toValue(n),
								A2($elm$parser$Parser$Advanced$bumpOffset, floatOffset, s));
						}
					}
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$number = function (c) {
	return function (s) {
		if (A3($elm$parser$Parser$Advanced$isAsciiCode, 48, s.F, s.ek)) {
			var zeroOffset = s.F + 1;
			var baseOffset = zeroOffset + 1;
			return A3($elm$parser$Parser$Advanced$isAsciiCode, 120, zeroOffset, s.ek) ? A5(
				$elm$parser$Parser$Advanced$finalizeInt,
				c.aun,
				c.Mr,
				baseOffset,
				A2($elm$parser$Parser$Advanced$consumeBase16, baseOffset, s.ek),
				s) : (A3($elm$parser$Parser$Advanced$isAsciiCode, 111, zeroOffset, s.ek) ? A5(
				$elm$parser$Parser$Advanced$finalizeInt,
				c.aun,
				c.XQ,
				baseOffset,
				A3($elm$parser$Parser$Advanced$consumeBase, 8, baseOffset, s.ek),
				s) : (A3($elm$parser$Parser$Advanced$isAsciiCode, 98, zeroOffset, s.ek) ? A5(
				$elm$parser$Parser$Advanced$finalizeInt,
				c.aun,
				c.oV,
				baseOffset,
				A3($elm$parser$Parser$Advanced$consumeBase, 2, baseOffset, s.ek),
				s) : A6(
				$elm$parser$Parser$Advanced$finalizeFloat,
				c.aun,
				c.GN,
				c.N9,
				c.Iy,
				_Utils_Tuple2(zeroOffset, 0),
				s)));
		} else {
			return A6(
				$elm$parser$Parser$Advanced$finalizeFloat,
				c.aun,
				c.GN,
				c.N9,
				c.Iy,
				A3($elm$parser$Parser$Advanced$consumeBase, 10, s.F, s.ek),
				s);
		}
	};
};
var $elm$parser$Parser$Advanced$int = F2(
	function (expecting, invalid) {
		return $elm$parser$Parser$Advanced$number(
			{
				oV: $elm$core$Result$Err(invalid),
				GN: expecting,
				Iy: $elm$core$Result$Err(invalid),
				Mr: $elm$core$Result$Err(invalid),
				N9: $elm$core$Result$Ok($elm$core$Basics$identity),
				aun: invalid,
				XQ: $elm$core$Result$Err(invalid)
			});
	});
var $elm$parser$Parser$int = A2($elm$parser$Parser$Advanced$int, $elm$parser$Parser$ExpectingInt, $elm$parser$Parser$ExpectingInt);
var $hecrj$html_parser$Html$Parser$numericCharacterReference = function () {
	var codepoint = $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed($elm$core$Basics$identity),
					$elm$parser$Parser$chompIf(
						function (c) {
							return (c === 'x') || (c === 'X');
						})),
				$hecrj$html_parser$Html$Parser$hexadecimal),
				A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed($elm$core$Basics$identity),
					$elm$parser$Parser$chompWhile(
						$elm$core$Basics$eq('0'))),
				$elm$parser$Parser$int)
			]));
	return A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed($elm$core$Basics$identity),
			$elm$parser$Parser$chompIf(
				$elm$core$Basics$eq('#'))),
		A2(
			$elm$parser$Parser$map,
			A2($elm$core$Basics$composeR, $elm$core$Char$fromCode, $elm$core$String$fromChar),
			codepoint));
}();
var $hecrj$html_parser$Html$Parser$characterReference = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$succeed($elm$core$Basics$identity),
		$elm$parser$Parser$chompIf(
			$elm$core$Basics$eq('&'))),
	$elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$backtrackable($hecrj$html_parser$Html$Parser$namedCharacterReference),
				$hecrj$html_parser$Html$Parser$chompSemicolon),
				A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$backtrackable($hecrj$html_parser$Html$Parser$numericCharacterReference),
				$hecrj$html_parser$Html$Parser$chompSemicolon),
				$elm$parser$Parser$succeed('&')
			])));
var $hecrj$html_parser$Html$Parser$tagAttributeQuotedValue = function (quote) {
	var isQuotedValueChar = function (c) {
		return (!_Utils_eq(c, quote)) && (c !== '&');
	};
	return A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed($elm$core$Basics$identity),
			$elm$parser$Parser$chompIf(
				$elm$core$Basics$eq(quote))),
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$map,
				$elm$core$String$join(''),
				$hecrj$html_parser$Html$Parser$many(
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								$elm$parser$Parser$getChompedString(
								$hecrj$html_parser$Html$Parser$chompOneOrMore(isQuotedValueChar)),
								$hecrj$html_parser$Html$Parser$characterReference
							])))),
			$elm$parser$Parser$chompIf(
				$elm$core$Basics$eq(quote))));
};
var $hecrj$html_parser$Html$Parser$oneOrMore = F2(
	function (type_, parser_) {
		return A2(
			$elm$parser$Parser$loop,
			_List_Nil,
			function (list) {
				return $elm$parser$Parser$oneOf(
					_List_fromArray(
						[
							A2(
							$elm$parser$Parser$map,
							function (_new) {
								return $elm$parser$Parser$Loop(
									A2($elm$core$List$cons, _new, list));
							},
							parser_),
							$elm$core$List$isEmpty(list) ? $elm$parser$Parser$problem('expecting at least one ' + type_) : $elm$parser$Parser$succeed(
							$elm$parser$Parser$Done(
								$elm$core$List$reverse(list)))
						]));
			});
	});
var $hecrj$html_parser$Html$Parser$tagAttributeUnquotedValue = function () {
	var isUnquotedValueChar = function (c) {
		return (!$hecrj$html_parser$Html$Parser$isSpaceCharacter(c)) && ((c !== '\"') && ((c !== '\'') && ((c !== '=') && ((c !== '<') && ((c !== '>') && ((c !== '`') && (c !== '&')))))));
	};
	return A2(
		$elm$parser$Parser$map,
		$elm$core$String$join(''),
		A2(
			$hecrj$html_parser$Html$Parser$oneOrMore,
			'attribute value',
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						$elm$parser$Parser$getChompedString(
						$hecrj$html_parser$Html$Parser$chompOneOrMore(isUnquotedValueChar)),
						$hecrj$html_parser$Html$Parser$characterReference
					]))));
}();
var $hecrj$html_parser$Html$Parser$tagAttributeValue = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$ignorer,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed($elm$core$Basics$identity),
					$elm$parser$Parser$chompIf(
						$elm$core$Basics$eq('='))),
				$elm$parser$Parser$chompWhile($hecrj$html_parser$Html$Parser$isSpaceCharacter)),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						$hecrj$html_parser$Html$Parser$tagAttributeUnquotedValue,
						$hecrj$html_parser$Html$Parser$tagAttributeQuotedValue('\"'),
						$hecrj$html_parser$Html$Parser$tagAttributeQuotedValue('\'')
					]))),
			$elm$parser$Parser$succeed('')
		]));
var $hecrj$html_parser$Html$Parser$tagAttribute = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$keeper,
		$elm$parser$Parser$succeed($elm$core$Tuple$pair),
		A2(
			$elm$parser$Parser$ignorer,
			$hecrj$html_parser$Html$Parser$tagAttributeName,
			$elm$parser$Parser$chompWhile($hecrj$html_parser$Html$Parser$isSpaceCharacter))),
	A2(
		$elm$parser$Parser$ignorer,
		$hecrj$html_parser$Html$Parser$tagAttributeValue,
		$elm$parser$Parser$chompWhile($hecrj$html_parser$Html$Parser$isSpaceCharacter)));
var $hecrj$html_parser$Html$Parser$tagAttributes = $hecrj$html_parser$Html$Parser$many($hecrj$html_parser$Html$Parser$tagAttribute);
var $hecrj$html_parser$Html$Parser$tagName = A2(
	$elm$parser$Parser$map,
	$elm$core$String$toLower,
	$elm$parser$Parser$getChompedString(
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$chompIf($elm$core$Char$isAlphaNum),
			$elm$parser$Parser$chompWhile(
				function (c) {
					return $elm$core$Char$isAlphaNum(c) || (c === '-');
				}))));
var $hecrj$html_parser$Html$Parser$Text = function (a) {
	return {$: 0, a: a};
};
var $hecrj$html_parser$Html$Parser$text = A2(
	$elm$parser$Parser$map,
	A2(
		$elm$core$Basics$composeR,
		$elm$core$String$join(''),
		$hecrj$html_parser$Html$Parser$Text),
	A2(
		$hecrj$html_parser$Html$Parser$oneOrMore,
		'text element',
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					$elm$parser$Parser$getChompedString(
					$hecrj$html_parser$Html$Parser$chompOneOrMore(
						function (c) {
							return (c !== '<') && (c !== '&');
						})),
					$hecrj$html_parser$Html$Parser$characterReference
				]))));
function $hecrj$html_parser$Html$Parser$cyclic$node() {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				$hecrj$html_parser$Html$Parser$text,
				$hecrj$html_parser$Html$Parser$comment,
				$hecrj$html_parser$Html$Parser$cyclic$element()
			]));
}
function $hecrj$html_parser$Html$Parser$cyclic$element() {
	return A2(
		$elm$parser$Parser$andThen,
		function (_v0) {
			var name = _v0.a;
			var attributes = _v0.b;
			return $hecrj$html_parser$Html$Parser$isVoidElement(name) ? A2(
				$elm$parser$Parser$ignorer,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed(
						A3($hecrj$html_parser$Html$Parser$Element, name, attributes, _List_Nil)),
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								$elm$parser$Parser$chompIf(
								$elm$core$Basics$eq('/')),
								$elm$parser$Parser$succeed(0)
							]))),
				$elm$parser$Parser$chompIf(
					$elm$core$Basics$eq('>'))) : A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed(
						A2($hecrj$html_parser$Html$Parser$Element, name, attributes)),
					$elm$parser$Parser$chompIf(
						$elm$core$Basics$eq('>'))),
				A2(
					$elm$parser$Parser$ignorer,
					$hecrj$html_parser$Html$Parser$many(
						$elm$parser$Parser$backtrackable(
							$hecrj$html_parser$Html$Parser$cyclic$node())),
					$hecrj$html_parser$Html$Parser$closingTag(name)));
		},
		A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed($elm$core$Tuple$pair),
					$elm$parser$Parser$chompIf(
						$elm$core$Basics$eq('<'))),
				A2(
					$elm$parser$Parser$ignorer,
					$hecrj$html_parser$Html$Parser$tagName,
					$elm$parser$Parser$chompWhile($hecrj$html_parser$Html$Parser$isSpaceCharacter))),
			$hecrj$html_parser$Html$Parser$tagAttributes));
}
var $hecrj$html_parser$Html$Parser$node = $hecrj$html_parser$Html$Parser$cyclic$node();
$hecrj$html_parser$Html$Parser$cyclic$node = function () {
	return $hecrj$html_parser$Html$Parser$node;
};
var $hecrj$html_parser$Html$Parser$element = $hecrj$html_parser$Html$Parser$cyclic$element();
$hecrj$html_parser$Html$Parser$cyclic$element = function () {
	return $hecrj$html_parser$Html$Parser$element;
};
var $elm$parser$Parser$DeadEnd = F3(
	function (row, col, problem) {
		return {rB: col, aag: problem, adA: row};
	});
var $elm$parser$Parser$problemToDeadEnd = function (p) {
	return A3($elm$parser$Parser$DeadEnd, p.adA, p.rB, p.aag);
};
var $elm$parser$Parser$Advanced$bagToList = F2(
	function (bag, list) {
		bagToList:
		while (true) {
			switch (bag.$) {
				case 0:
					return list;
				case 1:
					var bag1 = bag.a;
					var x = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$core$List$cons, x, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
				default:
					var bag1 = bag.a;
					var bag2 = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$parser$Parser$Advanced$bagToList, bag2, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
			}
		}
	});
var $elm$parser$Parser$Advanced$run = F2(
	function (_v0, src) {
		var parse = _v0;
		var _v1 = parse(
			{rB: 1, f: _List_Nil, h: 1, F: 0, adA: 1, ek: src});
		if (!_v1.$) {
			var value = _v1.b;
			return $elm$core$Result$Ok(value);
		} else {
			var bag = _v1.b;
			return $elm$core$Result$Err(
				A2($elm$parser$Parser$Advanced$bagToList, bag, _List_Nil));
		}
	});
var $elm$parser$Parser$run = F2(
	function (parser, source) {
		var _v0 = A2($elm$parser$Parser$Advanced$run, parser, source);
		if (!_v0.$) {
			var a = _v0.a;
			return $elm$core$Result$Ok(a);
		} else {
			var problems = _v0.a;
			return $elm$core$Result$Err(
				A2($elm$core$List$map, $elm$parser$Parser$problemToDeadEnd, problems));
		}
	});
var $hecrj$html_parser$Html$Parser$run = function (str) {
	return $elm$core$String$isEmpty(str) ? $elm$core$Result$Ok(_List_Nil) : A2(
		$elm$parser$Parser$run,
		A2($hecrj$html_parser$Html$Parser$oneOrMore, 'node', $hecrj$html_parser$Html$Parser$node),
		str);
};
var $elm$virtual_dom$VirtualDom$node = function (tag) {
	return _VirtualDom_node(
		_VirtualDom_noScript(tag));
};
var $elm$html$Html$node = $elm$virtual_dom$VirtualDom$node;
var $hecrj$html_parser$Html$Parser$Util$toAttribute = function (_v0) {
	var name = _v0.a;
	var value = _v0.b;
	return A2($elm$html$Html$Attributes$attribute, name, value);
};
var $hecrj$html_parser$Html$Parser$Util$toVirtualDom = function (nodes) {
	return A2($elm$core$List$map, $hecrj$html_parser$Html$Parser$Util$toVirtualDomEach, nodes);
};
var $hecrj$html_parser$Html$Parser$Util$toVirtualDomEach = function (node) {
	switch (node.$) {
		case 1:
			var name = node.a;
			var attrs = node.b;
			var children = node.c;
			return A3(
				$elm$html$Html$node,
				name,
				A2($elm$core$List$map, $hecrj$html_parser$Html$Parser$Util$toAttribute, attrs),
				$hecrj$html_parser$Html$Parser$Util$toVirtualDom(children));
		case 0:
			var s = node.a;
			return $elm$html$Html$text(s);
		default:
			return $elm$html$Html$text('');
	}
};
var $author$project$Util$Html$parseOnly = function (content) {
	return A2(
		$elm$core$Result$withDefault,
		_List_Nil,
		A2(
			$elm$core$Result$map,
			function (x) {
				return $hecrj$html_parser$Html$Parser$Util$toVirtualDom(x);
			},
			$hecrj$html_parser$Html$Parser$run(
				A3($elm$core$String$replace, '\n', '', content))));
};
var $author$project$Slider$getSliderLength = function (slider) {
	switch (slider.$) {
		case 0:
			var slides = slider.a;
			return $elm$core$List$length(slides);
		case 1:
			var slides = slider.a;
			return $elm$core$List$length(slides);
		case 2:
			var slides = slider.a;
			return $elm$core$List$length(slides);
		case 3:
			var slides = slider.a;
			return $elm$core$List$length(slides);
		case 5:
			var slides = slider.a;
			return $elm$core$List$length(
				$author$project$Util$Html$parseOnly(slides));
		default:
			var slides = slider.a;
			return $elm$core$List$length(slides);
	}
};
var $author$project$Slider$allowInfinitySlider = F3(
	function (infinity, slider, sliderType) {
		return infinity && (_Utils_cmp(
			$author$project$Slider$getSliderLength(slider),
			$author$project$Slider$amountOfVisibleCards(sliderType)) > -1);
	});
var $author$project$Slider$init = function (flags) {
	return _Utils_Tuple2(
		{
			aw: $elm$core$Maybe$Nothing,
			cu: $elm$core$Maybe$Nothing,
			L: A3($author$project$Slider$allowInfinitySlider, flags.NX, flags.aix, flags.aiF) ? $elm$core$Maybe$Just(
				{
					F: $author$project$Slider$getSliderLength(flags.aix),
					b5: true
				}) : $elm$core$Maybe$Nothing,
			aP: flags.aP,
			F: 0,
			aix: flags.aix,
			aiF: flags.aiF,
			cR: 250,
			ape: flags.ape,
			apw: flags.apw,
			aqs: flags.aqs,
			cX: flags.cX
		},
		$elm$core$Platform$Cmd$none);
};
var $author$project$Slider$OnBrowserResize = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $elm$browser$Browser$Events$Window = 1;
var $elm$browser$Browser$Events$onResize = function (func) {
	return A3(
		$elm$browser$Browser$Events$on,
		1,
		'resize',
		A2(
			$elm$json$Json$Decode$field,
			'target',
			A3(
				$elm$json$Json$Decode$map2,
				func,
				A2($elm$json$Json$Decode$field, 'innerWidth', $elm$json$Json$Decode$int),
				A2($elm$json$Json$Decode$field, 'innerHeight', $elm$json$Json$Decode$int))));
};
var $author$project$Slider$subscriptions = $elm$browser$Browser$Events$onResize($author$project$Slider$OnBrowserResize);
var $author$project$Slider$Horizontal = 1;
var $author$project$Slider$Undecided = 0;
var $elm$core$Basics$abs = function (n) {
	return (n < 0) ? (-n) : n;
};
var $elm$core$Basics$clamp = F3(
	function (low, high, number) {
		return (_Utils_cmp(number, low) < 0) ? low : ((_Utils_cmp(number, high) > 0) ? high : number);
	});
var $author$project$Slider$SetOffset = function (a) {
	return {$: 0, a: a};
};
var $author$project$Slider$toInfinitySettings = F3(
	function (slider, offset, infinity) {
		return (_Utils_cmp(
			offset,
			$author$project$Slider$getSliderLength(slider)) > -1) ? _Utils_Tuple2(
			-1,
			$elm$core$Maybe$Just(
				_Utils_update(
					infinity,
					{b5: false}))) : ((offset < 0) ? _Utils_Tuple2(
			$author$project$Slider$getSliderLength(slider),
			$elm$core$Maybe$Just(
				_Utils_update(
					infinity,
					{b5: false}))) : _Utils_Tuple2(
			offset,
			$elm$core$Maybe$Just(
				_Utils_update(
					infinity,
					{b5: true}))));
	});
var $author$project$Slider$setOffset = F2(
	function (model, offset) {
		var _v0 = A2(
			$elm$core$Maybe$withDefault,
			_Utils_Tuple2(offset, $elm$core$Maybe$Nothing),
			A2(
				$elm$core$Maybe$map,
				A2($author$project$Slider$toInfinitySettings, model.aix, offset),
				model.L));
		var newOffset = _v0.a;
		var newSettings = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{cu: $elm$core$Maybe$Nothing, L: newSettings, F: newOffset}),
			_Utils_eq(newOffset, -1) ? A2(
				$elm$core$Task$perform,
				function (_v1) {
					return $author$project$Slider$SetOffset(newOffset + 1);
				},
				$elm$core$Process$sleep(model.cR - 150)) : ((_Utils_eq(offset, -1) && _Utils_eq(
				newOffset,
				$author$project$Slider$getSliderLength(model.aix))) ? A2(
				$elm$core$Task$perform,
				function (_v2) {
					return $author$project$Slider$SetOffset(newOffset - 1);
				},
				$elm$core$Process$sleep(model.cR - 150)) : $elm$core$Platform$Cmd$none));
	});
var $author$project$Slider$Vertical = 2;
var $elm$core$Basics$sqrt = _Basics_sqrt;
var $author$project$Slider$updateDrag = F2(
	function (touchPoint, drag) {
		var newIntent = function () {
			var _v0 = drag.bc;
			if (!_v0) {
				var dy = $elm$core$Basics$abs(touchPoint.m - drag.aju.m);
				var dx = $elm$core$Basics$abs(touchPoint.asz - drag.aju.asz);
				var totalDistance = $elm$core$Basics$sqrt((dx * dx) + (dy * dy));
				return (totalDistance > 20) ? ((_Utils_cmp(dx, dy) > 0) ? 1 : 2) : 0;
			} else {
				var resolved = _v0;
				return resolved;
			}
		}();
		return _Utils_update(
			drag,
			{atr: touchPoint, bc: newIntent});
	});
var $author$project$Slider$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var offset = msg.a;
				return A2($author$project$Slider$setOffset, model, offset);
			case 1:
				var touchPoint = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aw: $elm$core$Maybe$Just(
								{atr: touchPoint, bc: 0, aju: touchPoint})
						}),
					$elm$core$Platform$Cmd$none);
			case 2:
				var touchPoint = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aw: A2(
								$elm$core$Maybe$map,
								$author$project$Slider$updateDrag(touchPoint),
								model.aw)
						}),
					$elm$core$Platform$Cmd$none);
			case 3:
				var _v1 = model.aw;
				if (_v1.$ === 1) {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				} else {
					var drag = _v1.a;
					var keepWithinBounds = A2(
						$elm$core$Basics$clamp,
						0,
						$author$project$Slider$getSliderLength(model.aix) - 1);
					var dx = drag.atr.asz - drag.aju.asz;
					var dt = A2($elm$core$Basics$max, 1, drag.atr.et - drag.aju.et);
					var direction = (dx > 0) ? (-1) : 1;
					var absDx = $elm$core$Basics$abs(dx);
					var velocity = absDx / dt;
					var isValidSwipe = (drag.bc === 1) && ((absDx > 50) || (velocity > 0.3));
					var _v2 = isValidSwipe ? A2($author$project$Slider$setOffset, model, model.F + direction) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					var newModel = _v2.a;
					var newCmd = _v2.b;
					var clearedModel = _Utils_update(
						newModel,
						{aw: $elm$core$Maybe$Nothing});
					return A2(
						$elm$core$Maybe$withDefault,
						_Utils_Tuple2(
							_Utils_update(
								clearedModel,
								{
									F: keepWithinBounds(clearedModel.F)
								}),
							newCmd),
						A2(
							$elm$core$Maybe$map,
							function (_v3) {
								return _Utils_Tuple2(clearedModel, newCmd);
							},
							model.L));
				}
			case 4:
				var w = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cX: w}),
					$elm$core$Platform$Cmd$none);
			default:
				var maybeIndex = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cu: maybeIndex}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $elm_community$maybe_extra$Maybe$Extra$isJust = function (m) {
	if (m.$ === 1) {
		return false;
	} else {
		return true;
	}
};
var $author$project$Slider$isMobile = function (windowWidth) {
	return windowWidth < 992;
};
var $elm_community$maybe_extra$Maybe$Extra$isNothing = function (m) {
	if (m.$ === 1) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Slider$toIcon = F2(
	function (useDifferentArrow, defaultPath) {
		return $author$project$View$Icon$viewColored(
			useDifferentArrow ? $author$project$View$Icon$path.k9 : defaultPath);
	});
var $author$project$Util$View$viewIf = F2(
	function (bool, html) {
		return bool ? html(0) : $elm$html$Html$text('');
	});
var $author$project$Slider$viewDot = F6(
	function (sliderType, infinitySettings, currentIndex, mobile, max, dotIndex) {
		var check = (mobile || $elm_community$maybe_extra$Maybe$Extra$isJust(infinitySettings)) ? (_Utils_cmp(dotIndex, max - 1) < 1) : ((_Utils_cmp(
			max,
			$author$project$Slider$amountOfVisibleCards(sliderType)) > 0) && (_Utils_cmp(
			dotIndex,
			max - $author$project$Slider$amountOfVisibleCards(sliderType)) < 1));
		return A2(
			$author$project$Util$View$viewIf,
			check,
			function (_v0) {
				return A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick(
							$author$project$Slider$SetOffset(dotIndex)),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('dot', true),
									_Utils_Tuple2(
									'active',
									_Utils_eq(
										dotIndex,
										$elm$core$Basics$abs(currentIndex)))
								]))
						]),
					_List_Nil);
			});
	});
var $author$project$Util$View$viewIfNot = F2(
	function (bool, html) {
		return (!bool) ? html(0) : $elm$html$Html$text('');
	});
var $author$project$Slider$viewControls = F6(
	function (useDifferentArrow, sliderType, slideLength, currentIndex, infinitySettings, mobile) {
		var mobileArrows = mobile ? 1 : $author$project$Slider$amountOfVisibleCards(sliderType);
		var isInactive = _Utils_eq(currentIndex, slideLength - mobileArrows) && (!$elm_community$maybe_extra$Maybe$Extra$isJust(infinitySettings));
		var condition = A2(
			$elm$core$List$member,
			true,
			_List_fromArray(
				[
					(_Utils_cmp(
					slideLength,
					$author$project$Slider$amountOfVisibleCards(sliderType)) < 1) && ($elm_community$maybe_extra$Maybe$Extra$isNothing(infinitySettings) && (!mobile)),
					_Utils_cmp(
					slideLength,
					$author$project$Slider$amountOfVisibleCards(sliderType)) < 0
				]));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('controller show')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('slider-control-buttons')
						]),
					A2(
						$elm$core$List$map,
						A5($author$project$Slider$viewDot, sliderType, infinitySettings, currentIndex, mobile, slideLength),
						A2($elm$core$List$range, 0, slideLength))),
					A2(
					$author$project$Util$View$viewIfNot,
					condition,
					function (_v0) {
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('slider-arrows')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Events$onClick(
											$author$project$Slider$SetOffset(currentIndex - 1)),
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('slider-arrow', true),
													_Utils_Tuple2('slider-arrow-left', true),
													_Utils_Tuple2(
													'inactive',
													(!currentIndex) && (!$elm_community$maybe_extra$Maybe$Extra$isJust(infinitySettings)))
												]))
										]),
									_List_fromArray(
										[
											A2($author$project$Slider$toIcon, useDifferentArrow, $author$project$View$Icon$path.aiy)
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Events$onClick(
											$author$project$Slider$SetOffset(currentIndex + 1)),
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('slider-arrow', true),
													_Utils_Tuple2('slider-arrow-right', true),
													_Utils_Tuple2('inactive', isInactive)
												]))
										]),
									_List_fromArray(
										[
											A2($author$project$Slider$toIcon, useDifferentArrow, $author$project$View$Icon$path.aiy)
										]))
								]));
					})
				]));
	});
var $author$project$Slider$OnDragAt = function (a) {
	return {$: 2, a: a};
};
var $author$project$Slider$OnDragEnd = {$: 3};
var $author$project$Slider$OnDragStart = function (a) {
	return {$: 1, a: a};
};
var $author$project$Slider$coordDecoder = A3(
	$elm$json$Json$Decode$map2,
	F2(
		function (x, y) {
			return _Utils_Tuple2(x, y);
		}),
	A2($elm$json$Json$Decode$field, 'clientX', $elm$json$Json$Decode$float),
	A2($elm$json$Json$Decode$field, 'clientY', $elm$json$Json$Decode$float));
var $author$project$Slider$pointDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['touches', '0']),
			$author$project$Slider$coordDecoder),
			A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['changedTouches', '0']),
			$author$project$Slider$coordDecoder),
			A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['targetTouches', '0']),
			$author$project$Slider$coordDecoder),
			$author$project$Slider$coordDecoder
		]));
var $author$project$Slider$decodeTouchPoint = A3(
	$elm$json$Json$Decode$map2,
	F2(
		function (_v0, time) {
			var x = _v0.a;
			var y = _v0.b;
			return {et: time, asz: x, m: y};
		}),
	$author$project$Slider$pointDecoder,
	A2($elm$json$Json$Decode$field, 'timeStamp', $elm$json$Json$Decode$float));
var $elm$virtual_dom$VirtualDom$keyedNode = function (tag) {
	return _VirtualDom_keyedNode(
		_VirtualDom_noScript(tag));
};
var $elm$html$Html$Keyed$node = $elm$virtual_dom$VirtualDom$keyedNode;
var $author$project$Slider$nonPassiveOn = F2(
	function (event, decoder) {
		return A2(
			$elm$html$Html$Events$custom,
			event,
			A2(
				$elm$json$Json$Decode$map,
				function (msg) {
					return {bT: msg, avg: false, avG: false};
				},
				decoder));
	});
var $elm$core$List$repeatHelp = F3(
	function (result, n, value) {
		repeatHelp:
		while (true) {
			if (n <= 0) {
				return result;
			} else {
				var $temp$result = A2($elm$core$List$cons, value, result),
					$temp$n = n - 1,
					$temp$value = value;
				result = $temp$result;
				n = $temp$n;
				value = $temp$value;
				continue repeatHelp;
			}
		}
	});
var $elm$core$List$repeat = F2(
	function (n, value) {
		return A3($elm$core$List$repeatHelp, _List_Nil, n, value);
	});
var $author$project$Slider$sliderTypeToClass = function (sliderType) {
	switch (sliderType) {
		case 0:
			return 'one';
		case 1:
			return 'twos';
		case 2:
			return 'thirds';
		case 3:
			return 'fours';
		default:
			return 'fives';
	}
};
var $author$project$Slider$transformWithDrag = F5(
	function (sliderType, offset, infinitySettings, windowWidth, maybeDrag) {
		var infinityOffset = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.F;
				},
				infinitySettings));
		var offset_ = offset + infinityOffset;
		var dragPixels = function () {
			if (!maybeDrag.$) {
				var drag = maybeDrag.a;
				return (drag.bc === 1) ? (drag.atr.asz - drag.aju.asz) : 0;
			} else {
				return 0;
			}
		}();
		var amountOfVisibleCards_ = $author$project$Slider$amountOfVisibleCards(sliderType);
		var basePercent = $author$project$Slider$isMobile(windowWidth) ? (100 * offset_) : ((100 / amountOfVisibleCards_) * offset_);
		return (!dragPixels) ? A2(
			$elm$html$Html$Attributes$style,
			'transform',
			A2(
				$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
				'translateX({0}%)',
				_List_fromArray(
					[
						$elm$core$String$fromFloat(-basePercent)
					]))) : A2(
			$elm$html$Html$Attributes$style,
			'transform',
			A2(
				$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
				'translateX(calc({0}% + {1}px))',
				_List_fromArray(
					[
						$elm$core$String$fromFloat(-basePercent),
						$elm$core$String$fromFloat(dragPixels)
					])));
	});
var $author$project$Slider$transitionBase = F2(
	function (transitionSpeed, infinitySettings) {
		var needsTransition = A2(
			$elm$core$Maybe$withDefault,
			true,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.b5;
				},
				infinitySettings));
		return needsTransition ? A2(
			$elm$html$Html$Attributes$style,
			'transition',
			A2(
				$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
				'{0}ms ease-in-out',
				_List_fromArray(
					[
						$elm$core$String$fromFloat(transitionSpeed)
					]))) : A2($elm$html$Html$Attributes$style, '', '');
	});
var $author$project$Slider$transitionWithDrag = F3(
	function (transitionSpeed, infinitySettings, maybeDrag) {
		if (!maybeDrag.$) {
			var drag = maybeDrag.a;
			return (drag.bc === 1) ? A2($elm$html$Html$Attributes$style, 'transition', 'none') : A2($author$project$Slider$transitionBase, transitionSpeed, infinitySettings);
		} else {
			return A2($author$project$Slider$transitionBase, transitionSpeed, infinitySettings);
		}
	});
var $elm_community$maybe_extra$Maybe$Extra$join = function (mx) {
	if (!mx.$) {
		var x = mx.a;
		return x;
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Data$Link$toLink = F2(
	function (text, href) {
		return {Q: 3, c1: '', Nf: href, ao: 1, alt: '', alE: text};
	});
var $author$project$Slider$isElementVisible = F4(
	function (index, _v0, _v1, infinitySettings) {
		if (infinitySettings.$ === 1) {
			return true;
		} else {
			var settings = infinitySettings.a;
			var sliderLength = settings.F;
			var middleRepetitionStart = sliderLength;
			var middleRepetitionEnd = (sliderLength * 2) - 1;
			return (_Utils_cmp(index, middleRepetitionStart) > -1) && (_Utils_cmp(index, middleRepetitionEnd) < 1);
		}
	});
var $author$project$Data$Content$View$toNeededTabIndex = function (content) {
	switch (content.$) {
		case 3:
			return 1;
		case 4:
			return 1;
		case 6:
			return 1;
		case 7:
			return 1;
		case 8:
			var list = content.a;
			return $elm$core$List$length(list.dM);
		case 9:
			return 1;
		case 12:
			return 2;
		case 13:
			var list = content.a;
			return $elm$core$List$length(list.dM);
		case 15:
			return 2;
		default:
			return 0;
	}
};
var $author$project$Slider$toTabIndex = F7(
	function (sliderType, minTabIndex, index, inCardOffset, offset, sliderTypeForVisibility, infinitySettings) {
		if (A4($author$project$Slider$isElementVisible, index, offset, sliderTypeForVisibility, infinitySettings)) {
			switch (sliderType.$) {
				case 0:
					return (minTabIndex + ((3 * index) - 1)) + inCardOffset;
				case 1:
					return (minTabIndex + ((3 * index) - 1)) + inCardOffset;
				case 2:
					return (minTabIndex + ((2 * index) - 1)) + inCardOffset;
				case 3:
					return (minTabIndex + ((3 * index) - 1)) + inCardOffset;
				case 5:
					return 0;
				default:
					var slides = sliderType.a;
					var filterCurr = F2(
						function (c, content) {
							return A3(
								$elm$core$List$foldr,
								A2(
									$elm$core$Basics$composeL,
									A2($elm$core$Basics$composeL, $elm$core$Basics$add, $author$project$Data$Content$View$toNeededTabIndex),
									$elm$core$Tuple$second),
								0,
								A2(
									$elm$core$List$filter,
									function (_v3) {
										var i = _v3.a;
										return _Utils_cmp(i, c) < 0;
									},
									A2($elm$core$List$indexedMap, $elm$core$Tuple$pair, content)));
						});
					return A3(
						$elm$core$List$foldr,
						$elm$core$Basics$add,
						minTabIndex,
						A2(
							$elm$core$List$map,
							function (_v2) {
								var i = _v2.a;
								var v = _v2.b;
								return _Utils_eq(i, index) ? A2(filterCurr, inCardOffset, v.dg) : A3(
									$elm$core$List$foldr,
									A2($elm$core$Basics$composeL, $elm$core$Basics$add, $author$project$Data$Content$View$toNeededTabIndex),
									0,
									v.dg);
							},
							A2(
								$elm$core$List$filter,
								function (_v1) {
									var i = _v1.a;
									return _Utils_cmp(i, index) < 1;
								},
								A2($elm$core$List$indexedMap, $elm$core$Tuple$pair, slides))));
			}
		} else {
			return -1;
		}
	});
var $author$project$Data$ImageSource$toTextFromUploads = F2(
	function (_v0, imgSrc) {
		var uploads = _v0;
		switch (imgSrc.$) {
			case 1:
				var url = imgSrc.a;
				return $elm$core$Maybe$Just(url);
			case 0:
				var id = imgSrc.a;
				return A2(
					$elm$core$Dict$get,
					$author$project$Data$Id$toString(id),
					uploads);
			default:
				var url = imgSrc.a;
				return $elm$core$Maybe$Just(url);
		}
	});
var $author$project$Util$Regex$replace = F3(
	function (userRegex, replacer, string) {
		var _v0 = $elm$regex$Regex$fromString(userRegex);
		if (_v0.$ === 1) {
			return string;
		} else {
			var regex = _v0.a;
			return A3($elm$regex$Regex$replace, regex, replacer, string);
		}
	});
var $author$project$Util$Regex$replaceNewLine = function (text) {
	return A3(
		$author$project$Util$Regex$replace,
		'(\u000D\n|\u000D|\n)',
		function (_v0) {
			return '<br />';
		},
		text);
};
var $author$project$Util$Html$parse = function (content) {
	return A2(
		$elm$core$Result$withDefault,
		_List_fromArray(
			[
				$elm$html$Html$text(content)
			]),
		A2(
			$elm$core$Result$map,
			function (x) {
				return $hecrj$html_parser$Html$Parser$Util$toVirtualDom(x);
			},
			$hecrj$html_parser$Html$Parser$run(
				$author$project$Util$Regex$replaceNewLine(content))));
};
var $author$project$Util$Html$parseWithElement = F2(
	function (textValue, htmlEl) {
		return htmlEl(
			$author$project$Util$Html$parse(textValue));
	});
var $author$project$Slider$viewDescription = F2(
	function (tabIndex, description) {
		return A2(
			$author$project$Util$Html$parseWithElement,
			description,
			$elm$html$Html$div(
				_List_fromArray(
					[
						$elm$html$Html$Attributes$tabindex(tabIndex),
						$elm$html$Html$Attributes$class('text description text-align-left')
					])));
	});
var $author$project$Slider$viewIfNotEmpty = F2(
	function (toView, value) {
		return A2(
			$author$project$Util$View$viewIfNot,
			$elm$core$String$isEmpty(value),
			function (_v0) {
				return toView(value);
			});
	});
var $elm$html$Html$Attributes$alt = $elm$html$Html$Attributes$stringProperty('alt');
var $author$project$Slider$viewImage = F2(
	function (uploads, image) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('image image-align-center image-horizontal-align-fill')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('image-wrapper')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$src(
									A2(
										$elm$core$Maybe$withDefault,
										'',
										$elm_community$maybe_extra$Maybe$Extra$join(
											A2(
												$elm$core$Maybe$map,
												$author$project$Data$ImageSource$toTextFromUploads(uploads),
												image.ek)))),
									$elm$html$Html$Attributes$title(image.avV),
									$elm$html$Html$Attributes$alt(image.jn),
									A2($elm$html$Html$Attributes$attribute, 'aria-label', image.c1)
								]),
							_List_Nil)
						]))
				]));
	});
var $author$project$Slider$alignToClass = function (align) {
	switch (align) {
		case 0:
			return 'horizontal-align-left';
		case 1:
			return 'horizontal-align-center';
		case 2:
			return 'horizontal-align-right';
		default:
			return 'horizontal-align-fill';
	}
};
var $author$project$Slider$styleToClass = function (style) {
	switch (style) {
		case 0:
			return 'color-1';
		case 1:
			return 'color-2';
		case 2:
			return 'color-3';
		default:
			return 'color-4';
	}
};
var $elm$html$Html$Attributes$target = $elm$html$Html$Attributes$stringProperty('target');
var $author$project$Slider$viewLink = F3(
	function (tabIndex, useDifferentArrow, link) {
		var linkValueEmpty = $elm$core$String$isEmpty(link.alE) && $elm$core$String$isEmpty(link.Nf);
		return A2(
			$author$project$Util$View$viewIfNot,
			linkValueEmpty,
			function (_v0) {
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							A2(
								$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
								'link-group link-{0}',
								_List_fromArray(
									[
										$author$project$Slider$alignToClass(link.Q)
									])))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class(
									A2(
										$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
										'link {0}',
										_List_fromArray(
											[
												$author$project$Slider$styleToClass(link.ao)
											]))),
									$elm$html$Html$Attributes$href(link.Nf),
									$elm$html$Html$Attributes$tabindex(tabIndex),
									$elm$html$Html$Attributes$target(link.alt)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(link.alE)
										])),
									A2($author$project$Slider$toIcon, useDifferentArrow, $author$project$View$Icon$path.k8)
								]))
						]));
			});
	});
var $author$project$Data$Content$View$allowEmpty = F3(
	function (config, val, f) {
		return config.ji ? f : A2(
			$author$project$Util$View$viewIfNot,
			val,
			$elm$core$Basics$always(f));
	});
var $elm$html$Html$h2 = _VirtualDom_node('h2');
var $elm$html$Html$h3 = _VirtualDom_node('h3');
var $elm$html$Html$h4 = _VirtualDom_node('h4');
var $author$project$Data$TextAlign$toClass = function (align) {
	switch (align) {
		case 0:
			return 'text-align-left';
		case 1:
			return 'text-align-center';
		case 2:
			return 'text-align-right';
		default:
			return 'text-align-justify';
	}
};
var $author$project$Data$Content$View$toTabIndex = function (config) {
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			function (v) {
				return _List_fromArray(
					[
						$elm$html$Html$Attributes$tabindex(v)
					]);
			},
			config.avS));
};
var $author$project$Data$Content$View$viewHeadingHelp = F3(
	function (textColorClass, config, content) {
		var _v0 = function () {
			var _v1 = content.ej;
			switch (_v1) {
				case 1:
					return _Utils_Tuple2($elm$html$Html$h1, 'heading-one');
				case 2:
					return _Utils_Tuple2($elm$html$Html$h2, 'heading-two');
				case 3:
					return _Utils_Tuple2($elm$html$Html$h3, 'heading-three');
				case 4:
					return _Utils_Tuple2($elm$html$Html$h4, 'heading-four');
				default:
					return _Utils_Tuple2($elm$html$Html$h3, 'heading-three');
			}
		}();
		var elem = _v0.a;
		var class_ = _v0.b;
		var classes = A2(
			$elm$core$String$join,
			' ',
			A2(
				$elm$core$List$filter,
				A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$String$isEmpty),
				_Utils_ap(
					_List_fromArray(
						[
							'heading',
							$author$project$Data$TextAlign$toClass(content.Q),
							class_,
							textColorClass
						]),
					config.GZ)));
		return A3(
			$author$project$Data$Content$View$allowEmpty,
			config,
			$elm$core$String$isEmpty(content.alE),
			A2(
				$author$project$Util$Html$parseWithElement,
				content.alE,
				elem(
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$class(classes),
						$author$project$Data$Content$View$toTabIndex(config)))));
	});
var $author$project$Data$Content$View$viewHeading = $author$project$Data$Content$View$viewHeadingHelp('');
var $author$project$Slider$viewTitle = F2(
	function (tabIndex, title) {
		return A2(
			$author$project$Data$Content$View$viewHeading,
			{
				ji: false,
				GZ: _List_fromArray(
					['title']),
				avS: $elm$core$Maybe$Just(tabIndex),
				ape: $elm$core$Dict$empty,
				apx: false,
				f_: $elm$core$Maybe$Nothing
			},
			{Q: 0, rF: 2, ej: 3, alE: title});
	});
var $author$project$Slider$viewApplicantJourneySlide = F9(
	function (slider, minTabIndex, uploads, useDifferentArrow, index, sliderType, infinitySettings, offset, slide) {
		return $elm$core$String$isEmpty(slide.Q0) ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('slide-item')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('slide-item-card')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Slider$viewIfNotEmpty,
							function (_v0) {
								return A2($author$project$Slider$viewImage, uploads, slide.Nw);
							},
							A2(
								$elm$core$Maybe$withDefault,
								'',
								$elm_community$maybe_extra$Maybe$Extra$join(
									A2(
										$elm$core$Maybe$map,
										$author$project$Data$ImageSource$toTextFromUploads(uploads),
										slide.Nw.ek)))),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('slide-item-body')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Slider$viewIfNotEmpty,
									$author$project$Slider$viewTitle(
										A7($author$project$Slider$toTabIndex, slider, minTabIndex, index, 1, offset, sliderType, infinitySettings)),
									slide.avV),
									A2(
									$author$project$Slider$viewIfNotEmpty,
									$author$project$Slider$viewDescription(
										A7($author$project$Slider$toTabIndex, slider, minTabIndex, index, 2, offset, sliderType, infinitySettings)),
									slide.dn)
								]))
						]))
				])) : A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$href(slide.Q0),
					$elm$html$Html$Attributes$class('slide-item')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('slide-item-card')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Slider$viewIfNotEmpty,
							function (_v1) {
								return A2($author$project$Slider$viewImage, uploads, slide.Nw);
							},
							A2(
								$elm$core$Maybe$withDefault,
								'',
								$elm_community$maybe_extra$Maybe$Extra$join(
									A2(
										$elm$core$Maybe$map,
										$author$project$Data$ImageSource$toTextFromUploads(uploads),
										slide.Nw.ek)))),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('slide-item-body')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Slider$viewIfNotEmpty,
									$author$project$Slider$viewTitle(
										A7($author$project$Slider$toTabIndex, slider, minTabIndex, index, 1, offset, sliderType, infinitySettings)),
									slide.avV),
									A2(
									$author$project$Slider$viewIfNotEmpty,
									$author$project$Slider$viewDescription(
										A7($author$project$Slider$toTabIndex, slider, minTabIndex, index, 2, offset, sliderType, infinitySettings)),
									slide.dn),
									A3(
									$author$project$Slider$viewLink,
									A7($author$project$Slider$toTabIndex, slider, minTabIndex, index, 3, offset, sliderType, infinitySettings),
									useDifferentArrow,
									A2($author$project$Data$Link$toLink, slide.xF, slide.Q0))
								]))
						]))
				]));
	});
var $author$project$Slider$Hovering = function (a) {
	return {$: 5, a: a};
};
var $elm$html$Html$Events$onMouseEnter = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'mouseenter',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$html$Html$Events$onMouseLeave = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'mouseleave',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$Data$Content$View$toVideoFileSource = F3(
	function (uploads, mPoster, mSource) {
		if ((!mSource.$) && (mSource.a.$ === 2)) {
			var src = mSource.a.a;
			var url = A2(
				$elm$core$Maybe$withDefault,
				'',
				A2($author$project$Data$ImageSource$toTextFromUploads, uploads, src));
			if (!mPoster.$) {
				return url;
			} else {
				return A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'{0}#t=0.1',
					_List_fromArray(
						[url]));
			}
		} else {
			return '';
		}
	});
var $elm$json$Json$Encode$bool = _Json_wrap;
var $elm$html$Html$Attributes$boolProperty = F2(
	function (key, bool) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$bool(bool));
	});
var $elm$html$Html$Attributes$autoplay = $elm$html$Html$Attributes$boolProperty('autoplay');
var $elm$html$Html$Attributes$loop = $elm$html$Html$Attributes$boolProperty('loop');
var $elm$html$Html$Attributes$poster = $elm$html$Html$Attributes$stringProperty('poster');
var $elm$virtual_dom$VirtualDom$property = F2(
	function (key, value) {
		return A2(
			_VirtualDom_property,
			_VirtualDom_noInnerHtmlOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlUri(value));
	});
var $elm$html$Html$Attributes$property = $elm$virtual_dom$VirtualDom$property;
var $elm$html$Html$video = _VirtualDom_node('video');
var $author$project$Slider$viewVideo = F2(
	function (uploads, _v0) {
		var source = _v0.ai3;
		var poster = _v0.aT;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('video video-align-center')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('video-wrapper')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$video,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$autoplay(true),
									A2(
									$elm$html$Html$Attributes$property,
									'muted',
									$elm$json$Json$Encode$bool(true)),
									$elm$html$Html$Attributes$src(
									A3($author$project$Data$Content$View$toVideoFileSource, uploads, poster, source)),
									$elm$html$Html$Attributes$loop(true),
									$elm$html$Html$Attributes$poster(
									A2(
										$elm$core$Maybe$withDefault,
										'',
										$elm_community$maybe_extra$Maybe$Extra$join(
											A2(
												$elm$core$Maybe$map,
												$author$project$Data$ImageSource$toTextFromUploads(uploads),
												poster))))
								]),
							_List_Nil)
						]))
				]));
	});
var $author$project$Slider$viewApplicantJourneyWithHoverSlide = function (slider) {
	return function (minTabIndex) {
		return function (uploads) {
			return function (offset) {
				return function (sliderType) {
					return function (useDifferentArrow) {
						return function (currentlyHovering) {
							return function (index) {
								return function (infinitySettings) {
									return function (slide) {
										var nonEmptyVideo = !$elm$core$String$isEmpty(
											A3($author$project$Data$Content$View$toVideoFileSource, uploads, $elm$core$Maybe$Nothing, slide.M8.ai3));
										var isVisible = (_Utils_cmp(index, offset) > -1) && (_Utils_cmp(
											index,
											(offset + $author$project$Slider$amountOfVisibleCards(sliderType)) - 1) < 1);
										var isHoveringCurrent = A2(
											$elm$core$Maybe$withDefault,
											false,
											A2(
												$elm$core$Maybe$map,
												function (hoverIndex) {
													return _Utils_eq(hoverIndex, index);
												},
												currentlyHovering));
										var video = A2(
											$author$project$Util$View$viewIf,
											isHoveringCurrent && nonEmptyVideo,
											function (_v1) {
												return A2($author$project$Slider$viewVideo, uploads, slide.M8);
											});
										var image = A2(
											$author$project$Slider$viewIfNotEmpty,
											function (_v0) {
												return A2($author$project$Slider$viewImage, uploads, slide.Nw);
											},
											A2(
												$elm$core$Maybe$withDefault,
												'',
												$elm_community$maybe_extra$Maybe$Extra$join(
													A2(
														$elm$core$Maybe$map,
														$author$project$Data$ImageSource$toTextFromUploads(uploads),
														slide.Nw.ek))));
										var generalAttributes = _List_fromArray(
											[
												$elm$html$Html$Attributes$classList(
												_List_fromArray(
													[
														_Utils_Tuple2('slide-item', true),
														_Utils_Tuple2('visible', isVisible),
														_Utils_Tuple2(
														'hovering',
														$elm_community$maybe_extra$Maybe$Extra$isJust(currentlyHovering) && (isHoveringCurrent && isVisible)),
														_Utils_Tuple2(
														'not-hovering',
														$elm_community$maybe_extra$Maybe$Extra$isJust(currentlyHovering) && ((!isHoveringCurrent) && isVisible))
													])),
												$elm$html$Html$Events$onMouseEnter(
												$author$project$Slider$Hovering(
													$elm$core$Maybe$Just(index))),
												$elm$html$Html$Events$onMouseLeave(
												$author$project$Slider$Hovering($elm$core$Maybe$Nothing))
											]);
										return $elm$core$String$isEmpty(slide.Q0) ? A2(
											$elm$html$Html$div,
											generalAttributes,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('slide-item-card')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('slide-item-media')
																]),
															_List_fromArray(
																[video, image])),
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('slide-item-body')
																]),
															_List_fromArray(
																[
																	A2(
																	$author$project$Slider$viewIfNotEmpty,
																	$author$project$Slider$viewTitle(
																		A7($author$project$Slider$toTabIndex, slider, minTabIndex, index, 1, offset, sliderType, infinitySettings)),
																	slide.avV),
																	A2(
																	$author$project$Slider$viewIfNotEmpty,
																	$author$project$Slider$viewDescription(
																		A7($author$project$Slider$toTabIndex, slider, minTabIndex, index, 2, offset, sliderType, infinitySettings)),
																	slide.dn)
																]))
														]))
												])) : A2(
											$elm$html$Html$a,
											A2(
												$elm$core$List$cons,
												$elm$html$Html$Attributes$href(slide.Q0),
												generalAttributes),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('slide-item-card')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('slide-item-media')
																]),
															_List_fromArray(
																[video, image])),
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('slide-item-body')
																]),
															_List_fromArray(
																[
																	A2(
																	$author$project$Slider$viewIfNotEmpty,
																	$author$project$Slider$viewTitle(
																		A7($author$project$Slider$toTabIndex, slider, minTabIndex, index, 1, offset, sliderType, infinitySettings)),
																	slide.avV),
																	A2(
																	$author$project$Slider$viewIfNotEmpty,
																	$author$project$Slider$viewDescription(
																		A7($author$project$Slider$toTabIndex, slider, minTabIndex, index, 2, offset, sliderType, infinitySettings)),
																	slide.dn),
																	A2(
																	$elm$html$Html$div,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$class('link-group')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			$elm$html$Html$a,
																			_List_fromArray(
																				[
																					$elm$html$Html$Attributes$href(slide.Q0),
																					$elm$html$Html$Attributes$class('link color-2'),
																					$elm$html$Html$Attributes$tabindex(
																					A7($author$project$Slider$toTabIndex, slider, minTabIndex, index, 3, offset, sliderType, infinitySettings))
																				]),
																			_List_fromArray(
																				[
																					$elm$html$Html$text(slide.xF)
																				])),
																			A2($author$project$Slider$toIcon, useDifferentArrow, $author$project$View$Icon$path.k8)
																		]))
																]))
														]))
												]));
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Slider$offsetHelper = F3(
	function (lst, elem, defaultOffset) {
		offsetHelper:
		while (true) {
			if (!lst.b) {
				return -1;
			} else {
				var _v1 = lst.a;
				var index = _v1.a;
				var x = _v1.b;
				var xs = lst.b;
				if (_Utils_eq(x, elem)) {
					return index;
				} else {
					var $temp$lst = xs,
						$temp$elem = elem,
						$temp$defaultOffset = defaultOffset + 1;
					lst = $temp$lst;
					elem = $temp$elem;
					defaultOffset = $temp$defaultOffset;
					continue offsetHelper;
				}
			}
		}
	});
var $author$project$Slider$indexOf = F2(
	function (lst, element) {
		return A3($author$project$Slider$offsetHelper, lst, element, 0);
	});
var $elm$core$Set$Set_elm_builtin = $elm$core$Basics$identity;
var $elm$core$Set$empty = $elm$core$Dict$empty;
var $elm$core$Set$insert = F2(
	function (key, _v0) {
		var dict = _v0;
		return A3($elm$core$Dict$insert, key, 0, dict);
	});
var $elm$core$Set$fromList = function (list) {
	return A3($elm$core$List$foldl, $elm$core$Set$insert, $elm$core$Set$empty, list);
};
var $author$project$Data$MimeType$imageFileExtensions = $elm$core$Set$fromList(
	_List_fromArray(
		['gif', 'heic', 'heif', 'jfi', 'jfif', 'jif', 'jpe', 'jpeg', 'jpg', 'png', 'webp']));
var $elm$core$Dict$member = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$get, key, dict);
		if (!_v0.$) {
			return true;
		} else {
			return false;
		}
	});
var $elm$core$Set$member = F2(
	function (key, _v0) {
		var dict = _v0;
		return A2($elm$core$Dict$member, key, dict);
	});
var $author$project$Data$MimeType$toFileExtension = A2(
	$elm$core$Basics$composeL,
	A2(
		$elm$core$Basics$composeL,
		A2($elm$core$Basics$composeL, $elm$core$List$head, $elm$core$List$reverse),
		$elm$core$String$split('.')),
	$elm$core$String$toLower);
var $author$project$Data$MimeType$isImage = function (mediaItem) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function (extension) {
				return A2($elm$core$Set$member, extension, $author$project$Data$MimeType$imageFileExtensions);
			},
			$author$project$Data$MimeType$toFileExtension(mediaItem)));
};
var $author$project$Data$MimeType$svgXmlFileExtensions = $elm$core$Set$fromList(
	_List_fromArray(
		['svg']));
var $author$project$Data$MimeType$isSvg = function (mediaItem) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function (extension) {
				return A2($elm$core$Set$member, extension, $author$project$Data$MimeType$svgXmlFileExtensions);
			},
			$author$project$Data$MimeType$toFileExtension(mediaItem)));
};
var $author$project$Slider$viewIcon = F4(
	function (uploads, stepIcon, offset, maskColor) {
		return A2(
			$author$project$Util$View$viewMaybe,
			$elm_community$maybe_extra$Maybe$Extra$join(
				A2(
					$elm$core$Maybe$map,
					$author$project$Data$ImageSource$toTextFromUploads(uploads),
					stepIcon)),
			function (iconSrc) {
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('slide-icon')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('slide-offset')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('slide-step')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text($author$project$Copy$copy.fM)
										])),
									$elm$html$Html$text(
									$elm$core$String$fromInt(offset + 1))
								])),
							A2($author$project$View$Icon$viewMasked, maskColor, iconSrc)
						]));
			});
	});
var $author$project$Slider$viewApplicationProcedureSlide = F9(
	function (slider, minTabIndex, uploads, mInfintiySettings, slides, index, sliderType, offset, slide) {
		var toOffset = A2(
			$elm$core$Maybe$withDefault,
			index,
			A2(
				$elm$core$Maybe$map,
				function (_v2) {
					return A2($author$project$Slider$indexOf, slides, slide);
				},
				mInfintiySettings));
		var iconSrc = A2(
			$elm$core$Maybe$withDefault,
			'',
			$elm_community$maybe_extra$Maybe$Extra$join(
				A2(
					$elm$core$Maybe$map,
					$author$project$Data$ImageSource$toTextFromUploads(uploads),
					slide.bb)));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('slide-item', true),
							_Utils_Tuple2(
							'with-image',
							$author$project$Data$MimeType$isImage(iconSrc))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('slide-item-card')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Util$View$viewIf,
							$author$project$Data$MimeType$isImage(iconSrc),
							function (_v0) {
								return A2(
									$author$project$Slider$viewImage,
									uploads,
									{Q: 3, jn: '', c1: '', MT: 3, ek: slide.bb, avV: '', a0: ''});
							}),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('slide-item-body')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Util$View$viewIf,
									$author$project$Data$MimeType$isSvg(iconSrc),
									function (_v1) {
										return A4($author$project$Slider$viewIcon, uploads, slide.bb, toOffset, slide.Sm);
									}),
									A2(
									$author$project$Slider$viewTitle,
									A7($author$project$Slider$toTabIndex, slider, minTabIndex, index, 1, offset, sliderType, mInfintiySettings),
									slide.avV),
									A2(
									$author$project$Slider$viewDescription,
									A7($author$project$Slider$toTabIndex, slider, minTabIndex, index, 2, offset, sliderType, mInfintiySettings),
									slide.dn)
								]))
						]))
				]));
	});
var $elm$core$List$all = F2(
	function (isOkay, list) {
		return !A2(
			$elm$core$List$any,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, isOkay),
			list);
	});
var $author$project$Data$TextColor$toClass = function (textColor) {
	switch (textColor) {
		case 0:
			return '';
		case 2:
			return 'text-dark';
		default:
			return 'text-white';
	}
};
var $author$project$Data$Content$View$viewPlainText = F2(
	function (config, content) {
		return A3(
			$author$project$Data$Content$View$allowEmpty,
			config,
			$elm$core$String$isEmpty(content.alE),
			A2(
				$elm$html$Html$div,
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$class(
						A2(
							$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
							'text {0} {1}',
							_List_fromArray(
								[
									$author$project$Data$TextAlign$toClass(content.Q),
									$author$project$Data$TextColor$toClass(content.rF)
								]))),
					$author$project$Data$Content$View$toTabIndex(config)),
				$author$project$Util$Html$parse(content.alE)));
	});
var $author$project$Slider$viewCard = F9(
	function (slider, minTabIndex, uploads, useDifferentArrow, index, sliderType, infinitySettings, offset, card) {
		var values = _List_fromArray(
			[card.Mm.alE, card._3.alE, card.Q4.alE]);
		var showBody = A2(
			$elm$core$List$all,
			$elm$core$Basics$identity,
			A2($elm$core$List$map, $elm$core$String$isEmpty, values));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('slide-item')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('card')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Slider$viewIfNotEmpty,
							function (_v0) {
								return A2($author$project$Slider$viewImage, uploads, card.Nw);
							},
							A2(
								$elm$core$Maybe$withDefault,
								'',
								$elm_community$maybe_extra$Maybe$Extra$join(
									A2(
										$elm$core$Maybe$map,
										$author$project$Data$ImageSource$toTextFromUploads(uploads),
										card.Nw.ek)))),
							A2(
							$author$project$Util$View$viewIfNot,
							showBody,
							function (_v1) {
								return A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('card-body')
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Data$Content$View$viewHeading,
											{
												ji: false,
												GZ: _List_Nil,
												avS: $elm$core$Maybe$Just(
													A7($author$project$Slider$toTabIndex, slider, minTabIndex, index, 1, offset, sliderType, infinitySettings)),
												ape: uploads,
												apx: false,
												f_: $elm$core$Maybe$Nothing
											},
											card.Mm),
											A2(
											$author$project$Data$Content$View$viewPlainText,
											{
												ji: false,
												GZ: _List_Nil,
												avS: $elm$core$Maybe$Just(
													A7($author$project$Slider$toTabIndex, slider, minTabIndex, index, 2, offset, sliderType, infinitySettings)),
												ape: uploads,
												apx: false,
												f_: $elm$core$Maybe$Nothing
											},
											card._3),
											A2(
											$author$project$Util$View$viewIfNot,
											$elm$core$String$isEmpty(card.Q4.alE),
											function (_v2) {
												return A3(
													$author$project$Slider$viewLink,
													A7($author$project$Slider$toTabIndex, slider, minTabIndex, index, 3, offset, sliderType, infinitySettings),
													useDifferentArrow,
													card.Q4);
											})
										]));
							})
						]))
				]));
	});
var $author$project$Data$Align$verticalAlignToClass = function (align) {
	switch (align) {
		case 2:
			return 'vertical-align-top';
		case 1:
			return 'vertical-align-center';
		case 0:
			return 'vertical-align-bottom';
		default:
			return 'vertical-align-fill';
	}
};
var $elm$html$Html$p = _VirtualDom_node('p');
var $author$project$Data$Content$View$viewHeadingSimple = F3(
	function (config, size, text) {
		return A2(
			$author$project$Data$Content$View$viewHeading,
			config,
			{Q: 0, rF: 2, ej: size, alE: text});
	});
var $author$project$Data$Align$horizontalAlignToClass = function (align) {
	switch (align) {
		case 0:
			return 'horizontal-align-left';
		case 1:
			return 'horizontal-align-center';
		case 2:
			return 'horizontal-align-right';
		default:
			return 'horizontal-align-fill';
	}
};
var $author$project$Data$Content$View$viewImageHtml = F2(
	function (uploads, content) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(
					A2(
						$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
						'image image-{0} image-{1}',
						_List_fromArray(
							[
								$author$project$Data$Align$verticalAlignToClass(content.Q),
								$author$project$Data$Align$horizontalAlignToClass(content.MT)
							])))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('image-wrapper')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$src(
									A2(
										$elm$core$Maybe$withDefault,
										'',
										$elm_community$maybe_extra$Maybe$Extra$join(
											A2(
												$elm$core$Maybe$map,
												$author$project$Data$ImageSource$toTextFromUploads(uploads),
												content.ek))))
								]),
							_List_Nil)
						]))
				]));
	});
var $author$project$Data$Content$View$viewImage = F2(
	function (config, content) {
		return A3(
			$author$project$Data$Content$View$allowEmpty,
			config,
			$elm$core$String$isEmpty(
				A2(
					$elm$core$Maybe$withDefault,
					'',
					$elm_community$maybe_extra$Maybe$Extra$join(
						A2(
							$elm$core$Maybe$map,
							$author$project$Data$ImageSource$toTextFromUploads(config.ape),
							content.ek)))),
			$elm$core$String$isEmpty(content.a0) ? A2($author$project$Data$Content$View$viewImageHtml, config.ape, content) : A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('image-link'),
						$elm$html$Html$Attributes$href(content.a0)
					]),
				_List_fromArray(
					[
						A2($author$project$Data$Content$View$viewImageHtml, config.ape, content)
					])));
	});
var $author$project$Data$Content$View$viewApplicantJourney = F2(
	function (config, content) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2($author$project$Data$Content$View$viewImage, config, content.Nw),
					A3($author$project$Data$Content$View$viewHeadingSimple, config, 3, content.avV),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					$author$project$Util$Html$parse(content.dn)),
					$elm$html$Html$text(content.xF)
				]));
	});
var $author$project$Data$Content$View$viewApplicantJourneyWithHover = F2(
	function (config, content) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2($author$project$Data$Content$View$viewImage, config, content.Nw),
					A3($author$project$Data$Content$View$viewHeadingSimple, config, 3, content.avV),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					$author$project$Util$Html$parse(content.dn)),
					$elm$html$Html$text(content.xF)
				]));
	});
var $author$project$Data$Button$toClass = function (style) {
	switch (style) {
		case 0:
			return 'bg-color-1';
		case 1:
			return 'bg-color-2';
		case 2:
			return 'bg-color-3';
		default:
			return 'bg-color-4';
	}
};
var $author$project$Data$Content$View$viewButton = F2(
	function (config, content) {
		return A2(
			$author$project$Util$View$viewIfNot,
			$elm$core$String$isEmpty(content.alE),
			function (_v0) {
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							A2(
								$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
								'btn-group btn-{0}',
								_List_fromArray(
									[
										$author$project$Data$Align$horizontalAlignToClass(content.Q)
									])))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$a,
							_Utils_ap(
								_List_fromArray(
									[
										$elm$html$Html$Attributes$href(content.Nf),
										$elm$html$Html$Attributes$class(
										A2(
											$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
											'btn color-white {0}',
											_List_fromArray(
												[
													$author$project$Data$Button$toClass(content.ao)
												])))
									]),
								$author$project$Data$Content$View$toTabIndex(config)),
							_List_fromArray(
								[
									$elm$html$Html$text(content.alE)
								]))
						]));
			});
	});
var $author$project$Data$Content$View$viewContentHeading = F2(
	function (config, content) {
		return A3(
			$author$project$Data$Content$View$viewHeadingHelp,
			$author$project$Data$TextColor$toClass(content.rF),
			config,
			content);
	});
var $author$project$Data$Content$View$viewIntroText = F2(
	function (config, content) {
		return A3(
			$author$project$Data$Content$View$allowEmpty,
			config,
			$elm$core$String$isEmpty(content.alE),
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class(
						A2(
							$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
							'intro {0}',
							_List_fromArray(
								[
									$author$project$Data$TextAlign$toClass(content.Q)
								])))
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						A2(
							$elm$core$List$cons,
							$elm$html$Html$Attributes$class(
								A2(
									$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
									'text {0}',
									_List_fromArray(
										[
											$author$project$Data$TextColor$toClass(content.rF)
										]))),
							$author$project$Data$Content$View$toTabIndex(config)),
						$author$project$Util$Html$parse(content.alE))
					])));
	});
var $author$project$Data$Link$toClass = function (style) {
	switch (style) {
		case 0:
			return 'color-1';
		case 1:
			return 'color-2';
		case 2:
			return 'color-3';
		default:
			return 'color-4';
	}
};
var $author$project$Data$Link$toMaskColor = function (style) {
	switch (style) {
		case 0:
			return 2;
		case 1:
			return 3;
		case 2:
			return 1;
		default:
			return 1;
	}
};
var $author$project$Data$Content$View$viewLink = F2(
	function (config, content) {
		return A2(
			$author$project$Util$View$viewIfNot,
			$elm$core$String$isEmpty(content.alE),
			function (_v0) {
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							A2(
								$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
								'link-group link-{0}',
								_List_fromArray(
									[
										$author$project$Data$Align$horizontalAlignToClass(content.Q)
									])))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$a,
							_Utils_ap(
								_List_fromArray(
									[
										$elm$html$Html$Attributes$href(content.Nf),
										$elm$html$Html$Attributes$target(content.alt),
										$elm$html$Html$Attributes$class(
										A2(
											$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
											'link {0}',
											_List_fromArray(
												[
													$author$project$Data$Link$toClass(content.ao)
												])))
									]),
								$author$project$Data$Content$View$toTabIndex(config)),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(content.alE)
										])),
									A2(
									$author$project$View$Icon$viewMasked,
									$author$project$Data$Link$toMaskColor(content.ao),
									$author$project$View$Icon$path.k8)
								]))
						]));
			});
	});
var $elm$html$Html$ol = _VirtualDom_node('ol');
var $author$project$Data$Content$View$viewOrderedListItems = F2(
	function (config, content) {
		return A2(
			$elm$html$Html$ol,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('list list-ordered')
				]),
			A2(
				$elm$core$List$indexedMap,
				F2(
					function (i, item) {
						return A2(
							$elm$html$Html$li,
							$author$project$Data$Content$View$toTabIndex(
								_Utils_update(
									config,
									{
										avS: A2(
											$elm$core$Maybe$map,
											$elm$core$Basics$add(i),
											config.avS)
									})),
							$author$project$Util$Html$parse(item));
					}),
				content.dM));
	});
var $author$project$Data$Content$View$viewResponsiveImage = F2(
	function (uploads, content) {
		return A2(
			$author$project$Util$View$viewMaybe,
			$elm_community$maybe_extra$Maybe$Extra$join(
				A2(
					$elm$core$Maybe$map,
					$author$project$Data$ImageSource$toTextFromUploads(uploads),
					content.DP)),
			function (desktopSrc) {
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$src(desktopSrc)
								]),
							_List_Nil)
						]));
			});
	});
var $author$project$Data$Size$toStyle = function (size) {
	switch (size.$) {
		case 0:
			return _Utils_Tuple2('sm', '');
		case 1:
			return _Utils_Tuple2('md', '');
		case 2:
			return _Utils_Tuple2('lg', '');
		case 3:
			return _Utils_Tuple2('xl', '');
		default:
			var sizeValue = size.a;
			return _Utils_Tuple2(
				'custom',
				$elm$core$String$fromInt(sizeValue));
	}
};
var $author$project$Data$Content$View$viewSpacer = function (content) {
	var _v0 = $author$project$Data$Size$toStyle(content.ej);
	var size_ = _v0.a;
	var style_ = _v0.b;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class(
				A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'spacer spacer-size-{0}',
					_List_fromArray(
						[size_]))),
				A2(
				$elm$html$Html$Attributes$style,
				'height',
				A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'{0}px',
					_List_fromArray(
						[style_])))
			]),
		_List_Nil);
};
var $author$project$Data$Content$View$viewUnOrderedListItems = F2(
	function (config, content) {
		return A2(
			$elm$html$Html$ul,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('list list-unordered')
				]),
			A2(
				$elm$core$List$indexedMap,
				F2(
					function (i, item) {
						return A2(
							$elm$html$Html$li,
							$author$project$Data$Content$View$toTabIndex(
								_Utils_update(
									config,
									{
										avS: A2(
											$elm$core$Maybe$map,
											$elm$core$Basics$add(i),
											config.avS)
									})),
							$author$project$Util$Html$parse(item));
					}),
				content.dM));
	});
var $author$project$Data$Content$View$viewUsp = F2(
	function (config, content) {
		var el = $elm$core$String$isEmpty(content.a0) ? $elm$html$Html$div(
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('usp')
				])) : $elm$html$Html$a(
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('usp'),
					$elm$html$Html$Attributes$href(content.a0)
				]));
		return el(
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('usp-aside')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Data$Content$View$viewImageHtml,
							config.ape,
							{Q: 2, jn: content.jn, c1: '', MT: 3, ek: content.ek, avV: content.avV, a0: ''})
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('usp-body')
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Data$Content$View$allowEmpty,
							config,
							$elm$core$String$isEmpty(content.alE),
							A2(
								$author$project$Data$Content$View$viewHeading,
								config,
								{Q: 0, rF: 0, ej: 3, alE: content.alE})),
							A3(
							$author$project$Data$Content$View$allowEmpty,
							config,
							$elm$core$String$isEmpty(content.dn),
							A2(
								$author$project$Data$Content$View$viewPlainText,
								config,
								{Q: 0, rF: 0, alE: content.dn}))
						]))
				]));
	});
var $author$project$Data$Content$View$viewVacancyOverviewLink = F2(
	function (config, content) {
		return A2(
			$author$project$Util$View$viewIfNot,
			$elm$core$String$isEmpty(content.alE) && $elm$core$String$isEmpty(content.PF),
			function (_v0) {
				var orDefault = F2(
					function (fallback, value) {
						return $elm$core$String$isEmpty(value) ? fallback : value;
					});
				var linkHref = A2(
					$elm$core$Maybe$withDefault,
					'#',
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.a0;
						},
						config.f_));
				var count = A2(
					$elm$core$Maybe$withDefault,
					0,
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.atq;
						},
						config.f_));
				var arrow = A2(
					$author$project$View$Icon$viewMasked,
					$author$project$Data$Link$toMaskColor(content.ao),
					$author$project$View$Icon$path.k8);
				var children = (count > 0) ? _List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2(orDefault, $author$project$Copy$copy.arG, content.alE))
							])),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('vacancy-count')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2(
									$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
									'({0})',
									_List_fromArray(
										[
											$elm$core$String$fromInt(count)
										])))
							])),
						arrow
					]) : _List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2(orDefault, $author$project$Copy$copy.gm, content.PF))
							])),
						arrow
					]);
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							A2(
								$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
								'link-group link-{0}',
								_List_fromArray(
									[
										$author$project$Data$Align$horizontalAlignToClass(content.Q)
									])))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$a,
							_Utils_ap(
								_List_fromArray(
									[
										$elm$html$Html$Attributes$href(linkHref),
										$elm$html$Html$Attributes$class(
										A2(
											$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
											'link vacancy-overview-link {0}',
											_List_fromArray(
												[
													$author$project$Data$Link$toClass(content.ao)
												])))
									]),
								$author$project$Data$Content$View$toTabIndex(config)),
							children)
						]));
			});
	});
var $author$project$Data$AspectRatio$toClass = function (aspectRatio) {
	switch (aspectRatio) {
		case 3:
			return '';
		case 1:
			return 'aspect-9-16';
		case 2:
			return 'aspect-4-3';
		default:
			return 'aspect-16-9';
	}
};
var $elm$html$Html$Attributes$controls = $elm$html$Html$Attributes$boolProperty('controls');
var $elm$html$Html$iframe = _VirtualDom_node('iframe');
var $elm$html$Html$Attributes$srcdoc = $elm$html$Html$Attributes$stringProperty('srcdoc');
var $author$project$Data$Content$View$toVideoSource = F4(
	function (uploads, mPoster, mSource, autoPlay) {
		var autoplayParams = autoPlay ? '?autoplay=1&muted=1&mute=1' : '';
		if (!mSource.$) {
			switch (mSource.a.$) {
				case 2:
					var src = mSource.a.a;
					if (!mPoster.$) {
						return A2(
							$elm$core$Maybe$withDefault,
							'',
							A2($author$project$Data$ImageSource$toTextFromUploads, uploads, src));
					} else {
						return A2(
							$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
							'{0}#t=0.1',
							_List_fromArray(
								[
									A2(
									$elm$core$Maybe$withDefault,
									'',
									A2($author$project$Data$ImageSource$toTextFromUploads, uploads, src))
								]));
					}
				case 0:
					var youtubeId = mSource.a.a;
					return A2(
						$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
						'https://www.youtube-nocookie.com/embed/{0}{1}',
						_List_fromArray(
							[youtubeId, autoplayParams]));
				default:
					var vimeoId = mSource.a.a;
					return A2(
						$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
						'https://player.vimeo.com/video/{0}{1}',
						_List_fromArray(
							[vimeoId, autoplayParams]));
			}
		} else {
			return '';
		}
	});
var $author$project$Data$Content$View$viewSrcDoc = F4(
	function (uploads, mSource, autoPlay, posterSrc) {
		var poster = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2($author$project$Data$ImageSource$toTextFromUploads, uploads, posterSrc));
		return A2(
			$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
			'\n        <style>\n          * { padding:0; margin:0; overflow:hidden }\n          html,body{height:100% }\n          img, span { position:absolute; width:100%; height: 100%; top:0; bottom:0; margin:auto; object-fit: cover;}\n          span{ height:1.5em; text-align:center; font:48px/1.5 sans-serif; color:white; text-shadow:0 0 0.5em black }\n        </style>\n        <a href="{0}?autoplay=1&muted=1&mute=1"><img src="{1}"><span>▶</span></a>\n        ',
			_List_fromArray(
				[
					A4(
					$author$project$Data$Content$View$toVideoSource,
					uploads,
					$elm$core$Maybe$Just(posterSrc),
					mSource,
					autoPlay),
					poster
				]));
	});
var $author$project$Data$Content$View$toVideoHtml = F2(
	function (uploads, props) {
		var toSrcDoc = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, $elm$core$List$singleton, $elm$html$Html$Attributes$srcdoc),
					A3($author$project$Data$Content$View$viewSrcDoc, uploads, props.ai3, props.nh)),
				props.aT));
		var toAutoplayProps = props.nh ? _List_fromArray(
			[
				$elm$html$Html$Attributes$autoplay(true),
				A2(
				$elm$html$Html$Attributes$property,
				'muted',
				$elm$json$Json$Encode$bool(true)),
				$elm$html$Html$Attributes$loop(true)
			]) : _List_Nil;
		var _v0 = props.ai3;
		if (!_v0.$) {
			switch (_v0.a.$) {
				case 2:
					return A2(
						$elm$html$Html$video,
						_Utils_ap(
							_List_fromArray(
								[
									$elm$html$Html$Attributes$src(
									A4($author$project$Data$Content$View$toVideoSource, uploads, props.aT, props.ai3, props.nh)),
									$elm$html$Html$Attributes$controls(true),
									$elm$html$Html$Attributes$poster(
									A2(
										$elm$core$Maybe$withDefault,
										'',
										$elm_community$maybe_extra$Maybe$Extra$join(
											A2(
												$elm$core$Maybe$map,
												$author$project$Data$ImageSource$toTextFromUploads(uploads),
												props.aT))))
								]),
							toAutoplayProps),
						_List_Nil);
				case 0:
					return A2(
						$elm$html$Html$iframe,
						_Utils_ap(
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$attribute, 'frameborder', '0'),
									A2($elm$html$Html$Attributes$attribute, 'allowfullscreen', 'true'),
									$elm$html$Html$Attributes$src(
									A4($author$project$Data$Content$View$toVideoSource, uploads, props.aT, props.ai3, props.nh))
								]),
							toSrcDoc),
						_List_Nil);
				default:
					return A2(
						$elm$html$Html$iframe,
						_Utils_ap(
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$attribute, 'frameborder', '0'),
									A2($elm$html$Html$Attributes$attribute, 'allowfullscreen', 'true'),
									$elm$html$Html$Attributes$src(
									A4($author$project$Data$Content$View$toVideoSource, uploads, props.aT, props.ai3, props.nh))
								]),
							toSrcDoc),
						_List_Nil);
			}
		} else {
			return A2($elm$html$Html$div, _List_Nil, _List_Nil);
		}
	});
var $elm$html$Html$Attributes$action = function (uri) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'action',
		_VirtualDom_noJavaScriptUri(uri));
};
var $elm$html$Html$Attributes$method = $elm$html$Html$Attributes$stringProperty('method');
var $author$project$Data$Content$View$toVideoIframeWithDataSrc = F2(
	function (uploads, props) {
		var url = A4($author$project$Data$Content$View$toVideoSource, uploads, props.aT, props.ai3, props.nh);
		var toSrcDoc = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, $elm$core$List$singleton, $elm$html$Html$Attributes$srcdoc),
					A3($author$project$Data$Content$View$viewSrcDoc, uploads, props.ai3, props.nh)),
				props.aT));
		return A2(
			$elm$html$Html$iframe,
			_Utils_ap(
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'frameborder', '0'),
						A2($elm$html$Html$Attributes$attribute, 'allowfullscreen', 'true'),
						A2($elm$html$Html$Attributes$attribute, 'data-src', url),
						$elm$html$Html$Attributes$type_('text/html')
					]),
				toSrcDoc),
			_List_Nil);
	});
var $author$project$View$Icon$view = function (_v0) {
	var iconPath = _v0;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('icon')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$img,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$src(iconPath)
					]),
				_List_Nil)
			]));
};
var $author$project$Data$Content$View$viewConsentGatedVideo = F2(
	function (uploads, video_) {
		var posterUrl = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$andThen,
				$author$project$Data$ImageSource$toTextFromUploads(uploads),
				video_.aT));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('video')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('video-wrapper placeholder')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('placeholder-video')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('placeholder-accept-consent')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('placeholder-logo')
												]),
											_List_fromArray(
												[
													$author$project$View$Icon$view($author$project$View$Icon$path.aws)
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('placeholder-text')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text($author$project$Copy$copy.arx)
												])),
											A2(
											$elm$html$Html$form,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$action('/api/cookie-consent'),
													$elm$html$Html$Attributes$method('post')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$input,
													_List_fromArray(
														[
															A2($elm$html$Html$Attributes$attribute, 'hidden', ''),
															$elm$html$Html$Attributes$name('consent'),
															A2($elm$html$Html$Attributes$attribute, 'value', 'marketing')
														]),
													_List_Nil),
													A2(
													$elm$html$Html$button,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('btn placeholder-btn color-white'),
															$elm$html$Html$Attributes$type_('submit')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$span,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text($author$project$Copy$copy.ary)
																]))
														]))
												])),
											$elm$core$String$isEmpty(posterUrl) ? A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('placeholder-poster-image')
												]),
											_List_Nil) : A2(
											$elm$html$Html$img,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('placeholder-poster-image'),
													$elm$html$Html$Attributes$src(posterUrl)
												]),
											_List_Nil)
										]))
								])),
							A2($author$project$Data$Content$View$toVideoIframeWithDataSrc, uploads, video_)
						]))
				]));
	});
var $author$project$Data$Content$View$viewVideoHtml = F2(
	function (uploads, video_) {
		var _v0 = video_.ai3;
		_v0$2:
		while (true) {
			if (!_v0.$) {
				switch (_v0.a.$) {
					case 0:
						return A2($author$project$Data$Content$View$viewConsentGatedVideo, uploads, video_);
					case 1:
						return A2($author$project$Data$Content$View$viewConsentGatedVideo, uploads, video_);
					default:
						break _v0$2;
				}
			} else {
				break _v0$2;
			}
		}
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(
					A2(
						$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
						'video {0}',
						_List_fromArray(
							[
								$author$project$Data$AspectRatio$toClass(video_.as2)
							])))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('video-wrapper')
						]),
					_List_fromArray(
						[
							A2($author$project$Data$Content$View$toVideoHtml, uploads, video_)
						]))
				]));
	});
var $author$project$Data$Content$View$viewVideoPlaceholder = A2(
	$elm$html$Html$div,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$elm$html$Html$img,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$src('/static/images/video-placeholder.png')
				]),
			_List_Nil)
		]));
var $author$project$Data$Content$View$viewVideo = F2(
	function (config, video) {
		return config.apx ? $author$project$Data$Content$View$viewVideoPlaceholder : A2($author$project$Data$Content$View$viewVideoHtml, config.ape, video);
	});
var $author$project$Data$Content$View$view = F2(
	function (config, content) {
		switch (content.$) {
			case 0:
				return $elm$html$Html$text('');
			case 1:
				var applicantJourney = content.a;
				return A2($author$project$Data$Content$View$viewApplicantJourney, config, applicantJourney);
			case 2:
				var applicantJourneyWithHover = content.a;
				return A2($author$project$Data$Content$View$viewApplicantJourneyWithHover, config, applicantJourneyWithHover);
			case 3:
				var button = content.a;
				return A2($author$project$Data$Content$View$viewButton, config, button);
			case 4:
				var heading = content.a;
				return A2($author$project$Data$Content$View$viewContentHeading, config, heading);
			case 5:
				var image = content.a;
				return A2($author$project$Data$Content$View$viewImage, config, image);
			case 6:
				var introText = content.a;
				return A2($author$project$Data$Content$View$viewIntroText, config, introText);
			case 7:
				var link = content.a;
				return A2($author$project$Data$Content$View$viewLink, config, link);
			case 8:
				var list = content.a;
				return A2($author$project$Data$Content$View$viewOrderedListItems, config, list);
			case 9:
				var plainText = content.a;
				return A2($author$project$Data$Content$View$viewPlainText, config, plainText);
			case 10:
				var responsiveImage = content.a;
				return A2($author$project$Data$Content$View$viewResponsiveImage, config.ape, responsiveImage);
			case 11:
				var spacer = content.a;
				return $author$project$Data$Content$View$viewSpacer(spacer);
			case 12:
				var usp = content.a;
				return A2($author$project$Data$Content$View$viewUsp, config, usp);
			case 13:
				var list = content.a;
				return A2($author$project$Data$Content$View$viewUnOrderedListItems, config, list);
			case 14:
				var vacancyOverviewLink = content.a;
				return A2($author$project$Data$Content$View$viewVacancyOverviewLink, config, vacancyOverviewLink);
			default:
				var video = content.a;
				return A2($author$project$Data$Content$View$viewVideo, config, video);
		}
	});
var $elm_community$list_extra$List$Extra$zip = $elm$core$List$map2($elm$core$Tuple$pair);
var $author$project$Slider$viewContentGroup = F9(
	function (slider, minTabIndex, uploads, groupCounts, index, sliderType, infinitySettings, offset, contentGroup) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('slide-item')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('group', true),
									_Utils_Tuple2('full-width', contentGroup.SF),
									_Utils_Tuple2('full-height', contentGroup.Sx),
									_Utils_Tuple2(
									A2(
										$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
										'group-{0}',
										_List_fromArray(
											[
												$author$project$Data$Align$verticalAlignToClass(contentGroup.Q)
											])),
									true)
								]))
						]),
					A2(
						$elm$core$List$indexedMap,
						F2(
							function (i, _v0) {
								var c = _v0.a;
								var itemCount = _v0.b;
								return A2(
									$author$project$Data$Content$View$view,
									{
										ji: false,
										GZ: _List_Nil,
										avS: $elm$core$Maybe$Just(
											A7($author$project$Slider$toTabIndex, slider, minTabIndex, index, i, offset, sliderType, infinitySettings)),
										ape: uploads,
										apx: false,
										f_: itemCount
									},
									c);
							}),
						A2($elm_community$list_extra$List$Extra$zip, contentGroup.dg, groupCounts)))
				]));
	});
var $author$project$Slider$viewSlider = function (model) {
	var toSlider = function (slides) {
		return A2(
			$elm$core$Maybe$withDefault,
			slides,
			A2(
				$elm$core$Maybe$map,
				$elm$core$Basics$always(
					$elm$core$List$concat(
						A2($elm$core$List$repeat, 3, slides))),
				model.L));
	};
	var keyedSlide = F2(
		function (index, child) {
			return _Utils_Tuple2(
				'slide-' + $elm$core$String$fromInt(index),
				child);
		});
	return A3(
		$elm$html$Html$Keyed$node,
		'div',
		_List_fromArray(
			[
				A2(
				$author$project$Slider$nonPassiveOn,
				'touchstart',
				A2($elm$json$Json$Decode$map, $author$project$Slider$OnDragStart, $author$project$Slider$decodeTouchPoint)),
				A2(
				$author$project$Slider$nonPassiveOn,
				'touchmove',
				A2($elm$json$Json$Decode$map, $author$project$Slider$OnDragAt, $author$project$Slider$decodeTouchPoint)),
				A2(
				$author$project$Slider$nonPassiveOn,
				'touchend',
				$elm$json$Json$Decode$succeed($author$project$Slider$OnDragEnd)),
				A2(
				$author$project$Slider$nonPassiveOn,
				'touchcancel',
				$elm$json$Json$Decode$succeed($author$project$Slider$OnDragEnd)),
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('slider-container', true),
						_Utils_Tuple2(
						$author$project$Slider$sliderTypeToClass(model.aiF),
						true)
					])),
				A5($author$project$Slider$transformWithDrag, model.aiF, model.F, model.L, model.cX, model.aw),
				A3($author$project$Slider$transitionWithDrag, model.cR, model.L, model.aw),
				A2($elm$html$Html$Attributes$style, 'user-select', 'none'),
				A2($elm$html$Html$Attributes$style, '-webkit-user-select', 'none')
			]),
		function () {
			var _v0 = model.aix;
			switch (_v0.$) {
				case 0:
					var slides = _v0.a;
					return A2(
						$elm$core$List$indexedMap,
						F2(
							function (index, slide) {
								return A2(
									keyedSlide,
									index,
									A9($author$project$Slider$viewApplicantJourneySlide, model.aix, model.aP, model.ape, model.apw, index, model.aiF, model.L, model.F, slide));
							}),
						toSlider(slides));
				case 1:
					var slides = _v0.a;
					return A2(
						$elm$core$List$indexedMap,
						F2(
							function (index, slide) {
								return A2(
									keyedSlide,
									index,
									$author$project$Slider$viewApplicantJourneyWithHoverSlide(model.aix)(model.aP)(model.ape)(model.F)(model.aiF)(model.apw)(model.cu)(index)(model.L)(slide));
							}),
						toSlider(slides));
				case 2:
					var slides = _v0.a;
					return A2(
						$elm$core$List$indexedMap,
						F2(
							function (index, slide) {
								return A2(
									keyedSlide,
									index,
									A9(
										$author$project$Slider$viewApplicationProcedureSlide,
										model.aix,
										model.aP,
										model.ape,
										model.L,
										A2($elm$core$List$indexedMap, $elm$core$Tuple$pair, slides),
										index,
										model.aiF,
										model.F,
										slide));
							}),
						toSlider(slides));
				case 3:
					var slides = _v0.a;
					return A2(
						$elm$core$List$indexedMap,
						F2(
							function (index, card) {
								return A2(
									keyedSlide,
									index,
									A9($author$project$Slider$viewCard, model.aix, model.aP, model.ape, model.apw, index, model.aiF, model.L, model.F, card));
							}),
						toSlider(slides));
				case 5:
					var slides = _v0.a;
					return A2(
						$elm$core$List$indexedMap,
						keyedSlide,
						toSlider(
							$author$project$Util$Html$parseOnly(slides)));
				default:
					var slides = _v0.a;
					return A2(
						$elm$core$List$indexedMap,
						F2(
							function (index, _v1) {
								var contentGroup = _v1.a;
								var groupCounts = _v1.b;
								return A2(
									keyedSlide,
									index,
									A9($author$project$Slider$viewContentGroup, model.aix, model.aP, model.ape, groupCounts, index, model.aiF, model.L, model.F, contentGroup));
							}),
						toSlider(
							A2($elm_community$list_extra$List$Extra$zip, slides, model.aqs)));
			}
		}());
};
var $author$project$Slider$view = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('slider-wrapper', true),
						_Utils_Tuple2(
						'infinity-slider',
						$elm_community$maybe_extra$Maybe$Extra$isJust(model.L))
					]))
			]),
		_List_fromArray(
			[
				$author$project$Slider$viewSlider(model),
				A6(
				$author$project$Slider$viewControls,
				model.apw,
				model.aiF,
				$author$project$Slider$getSliderLength(model.aix),
				model.F,
				model.L,
				$author$project$Slider$isMobile(model.cX))
			]));
};
var $author$project$Slider$main = A2(
	$author$project$Browser$Custom$elementWithFlags,
	$author$project$Model$Component$Slider$elmFlagsDecoder,
	{
		dH: $author$project$Slider$init,
		em: $elm$core$Basics$always($author$project$Slider$subscriptions),
		ex: $author$project$Slider$update,
		ez: $author$project$Slider$view
	});
var $author$project$ShareToolForm$Flags = F3(
	function (tags, translations, currentLangCode) {
		return {bE: currentLangCode, aln: tags, anB: translations};
	});
var $author$project$Data$Entity$Entity = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Data$Entity$decoder = A2(
	$elm$json$Json$Decode$map2,
	$author$project$Data$Entity$Entity,
	A2($elm$json$Json$Decode$field, 'id', $author$project$Data$Id$decoder));
var $author$project$Model$LangCode$LangCodeDa = 0;
var $author$project$Model$LangCode$LangCodeDe = 1;
var $author$project$Model$LangCode$LangCodeDeAt = 2;
var $author$project$Model$LangCode$LangCodeDeCh = 3;
var $author$project$Model$LangCode$LangCodeDeLu = 4;
var $author$project$Model$LangCode$LangCodeEn = 5;
var $author$project$Model$LangCode$LangCodeEnGb = 6;
var $author$project$Model$LangCode$LangCodeEnIe = 7;
var $author$project$Model$LangCode$LangCodeEnUs = 8;
var $author$project$Model$LangCode$LangCodeEs = 9;
var $author$project$Model$LangCode$LangCodeFi = 10;
var $author$project$Model$LangCode$LangCodeFr = 11;
var $author$project$Model$LangCode$LangCodeFrBe = 12;
var $author$project$Model$LangCode$LangCodeFrCh = 13;
var $author$project$Model$LangCode$LangCodeFrLu = 14;
var $author$project$Model$LangCode$LangCodeHu = 15;
var $author$project$Model$LangCode$LangCodeNl = 16;
var $author$project$Model$LangCode$LangCodeNlBe = 17;
var $author$project$Model$LangCode$LangCodeNo = 18;
var $author$project$Model$LangCode$LangCodePl = 19;
var $author$project$Model$LangCode$LangCodePt = 20;
var $author$project$Model$LangCode$LangCodeRo = 21;
var $author$project$Model$LangCode$LangCodeSk = 22;
var $author$project$Model$LangCode$LangCodeSv = 23;
var $author$project$Model$LangCode$LangCodeUk = 24;
var $author$project$Model$LangCode$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'da':
				return $elm$json$Json$Decode$succeed(0);
			case 'de':
				return $elm$json$Json$Decode$succeed(1);
			case 'de-at':
				return $elm$json$Json$Decode$succeed(2);
			case 'de-ch':
				return $elm$json$Json$Decode$succeed(3);
			case 'de-lu':
				return $elm$json$Json$Decode$succeed(4);
			case 'en':
				return $elm$json$Json$Decode$succeed(5);
			case 'en-gb':
				return $elm$json$Json$Decode$succeed(6);
			case 'en-ie':
				return $elm$json$Json$Decode$succeed(7);
			case 'en-us':
				return $elm$json$Json$Decode$succeed(8);
			case 'es':
				return $elm$json$Json$Decode$succeed(9);
			case 'fi':
				return $elm$json$Json$Decode$succeed(10);
			case 'fr':
				return $elm$json$Json$Decode$succeed(11);
			case 'fr-be':
				return $elm$json$Json$Decode$succeed(12);
			case 'fr-ch':
				return $elm$json$Json$Decode$succeed(13);
			case 'fr-lu':
				return $elm$json$Json$Decode$succeed(14);
			case 'hu':
				return $elm$json$Json$Decode$succeed(15);
			case 'nl':
				return $elm$json$Json$Decode$succeed(16);
			case 'nl-be':
				return $elm$json$Json$Decode$succeed(17);
			case 'no':
				return $elm$json$Json$Decode$succeed(18);
			case 'pl':
				return $elm$json$Json$Decode$succeed(19);
			case 'pt':
				return $elm$json$Json$Decode$succeed(20);
			case 'ro':
				return $elm$json$Json$Decode$succeed(21);
			case 'sk':
				return $elm$json$Json$Decode$succeed(22);
			case 'sv':
				return $elm$json$Json$Decode$succeed(23);
			case 'uk':
				return $elm$json$Json$Decode$succeed(24);
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	$elm$json$Json$Decode$string);
var $elm$json$Json$Decode$map3 = _Json_map3;
var $author$project$Model$ShareToolTag$ShareToolTag = F6(
	function (label, itemIds, availableToEmployee, visibleOnSite, inserted, updated) {
		return {np: availableToEmployee, e6: inserted, Pc: itemIds, bO: label, fY: updated, arN: visibleOnSite};
	});
var $elm$parser$Parser$deadEndsToString = function (deadEnds) {
	return 'TODO deadEndsToString';
};
var $elm$parser$Parser$ExpectingEnd = {$: 10};
var $elm$parser$Parser$Advanced$end = function (x) {
	return function (s) {
		return _Utils_eq(
			$elm$core$String$length(s.ek),
			s.F) ? A3($elm$parser$Parser$Advanced$Good, false, 0, s) : A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, x));
	};
};
var $elm$parser$Parser$end = $elm$parser$Parser$Advanced$end($elm$parser$Parser$ExpectingEnd);
var $elm$core$Basics$round = _Basics_round;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$fractionsOfASecondInMs = A2(
	$elm$parser$Parser$andThen,
	function (str) {
		if ($elm$core$String$length(str) <= 9) {
			var _v0 = $elm$core$String$toFloat('0.' + str);
			if (!_v0.$) {
				var floatVal = _v0.a;
				return $elm$parser$Parser$succeed(
					$elm$core$Basics$round(floatVal * 1000));
			} else {
				return $elm$parser$Parser$problem('Invalid float: \"' + (str + '\"'));
			}
		} else {
			return $elm$parser$Parser$problem(
				'Expected at most 9 digits, but got ' + $elm$core$String$fromInt(
					$elm$core$String$length(str)));
		}
	},
	$elm$parser$Parser$getChompedString(
		$elm$parser$Parser$chompWhile($elm$core$Char$isDigit)));
var $elm$time$Time$Posix = $elm$core$Basics$identity;
var $elm$time$Time$millisToPosix = $elm$core$Basics$identity;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts = F6(
	function (monthYearDayMs, hour, minute, second, ms, utcOffsetMinutes) {
		return $elm$time$Time$millisToPosix((((monthYearDayMs + (((hour * 60) * 60) * 1000)) + (((minute - utcOffsetMinutes) * 60) * 1000)) + (second * 1000)) + ms);
	});
var $elm$core$String$append = _String_append;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt = function (quantity) {
	var helper = function (str) {
		if (_Utils_eq(
			$elm$core$String$length(str),
			quantity)) {
			var _v0 = $elm$core$String$toInt(str);
			if (!_v0.$) {
				var intVal = _v0.a;
				return A2(
					$elm$parser$Parser$map,
					$elm$parser$Parser$Done,
					$elm$parser$Parser$succeed(intVal));
			} else {
				return $elm$parser$Parser$problem('Invalid integer: \"' + (str + '\"'));
			}
		} else {
			return A2(
				$elm$parser$Parser$map,
				function (nextChar) {
					return $elm$parser$Parser$Loop(
						A2($elm$core$String$append, str, nextChar));
				},
				$elm$parser$Parser$getChompedString(
					$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
		}
	};
	return A2($elm$parser$Parser$loop, '', helper);
};
var $elm$parser$Parser$ExpectingSymbol = function (a) {
	return {$: 8, a: a};
};
var $elm$parser$Parser$Advanced$symbol = $elm$parser$Parser$Advanced$token;
var $elm$parser$Parser$symbol = function (str) {
	return $elm$parser$Parser$Advanced$symbol(
		A2(
			$elm$parser$Parser$Advanced$Token,
			str,
			$elm$parser$Parser$ExpectingSymbol(str)));
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear = 1970;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay = function (day) {
	return $elm$parser$Parser$problem(
		'Invalid day: ' + $elm$core$String$fromInt(day));
};
var $elm$core$Basics$modBy = _Basics_modBy;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear = function (year) {
	return (!A2($elm$core$Basics$modBy, 4, year)) && ((!(!A2($elm$core$Basics$modBy, 100, year))) || (!A2($elm$core$Basics$modBy, 400, year)));
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore = function (y1) {
	var y = y1 - 1;
	return (((y / 4) | 0) - ((y / 100) | 0)) + ((y / 400) | 0);
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerDay = 86400000;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerYear = 31536000000;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$yearMonthDay = function (_v0) {
	var year = _v0.a;
	var month = _v0.b;
	var dayInMonth = _v0.c;
	if (dayInMonth < 0) {
		return $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth);
	} else {
		var succeedWith = function (extraMs) {
			var yearMs = $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerYear * (year - $rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear);
			var days = ((month < 3) || (!$rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear(year))) ? (dayInMonth - 1) : dayInMonth;
			var dayMs = $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerDay * (days + ($rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore(year) - $rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore($rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear)));
			return $elm$parser$Parser$succeed((extraMs + yearMs) + dayMs);
		};
		switch (month) {
			case 1:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(0);
			case 2:
				return ((dayInMonth > 29) || ((dayInMonth === 29) && (!$rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear(year)))) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(2678400000);
			case 3:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(5097600000);
			case 4:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(7776000000);
			case 5:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(10368000000);
			case 6:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(13046400000);
			case 7:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(15638400000);
			case 8:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(18316800000);
			case 9:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(20995200000);
			case 10:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(23587200000);
			case 11:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(26265600000);
			case 12:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(28857600000);
			default:
				return $elm$parser$Parser$problem(
					'Invalid month: \"' + ($elm$core$String$fromInt(month) + '\"'));
		}
	}
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$monthYearDayInMs = A2(
	$elm$parser$Parser$andThen,
	$rtfeldman$elm_iso8601_date_strings$Iso8601$yearMonthDay,
	A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				$elm$parser$Parser$succeed(
					F3(
						function (year, month, day) {
							return _Utils_Tuple3(year, month, day);
						})),
				$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(4)),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$ignorer,
							$elm$parser$Parser$succeed($elm$core$Basics$identity),
							$elm$parser$Parser$symbol('-')),
						$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
						$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
					]))),
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$ignorer,
						$elm$parser$Parser$succeed($elm$core$Basics$identity),
						$elm$parser$Parser$symbol('-')),
					$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
					$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
				]))));
var $rtfeldman$elm_iso8601_date_strings$Iso8601$utcOffsetInMinutes = function () {
	var utcOffsetMinutesFromParts = F3(
		function (multiplier, hours, minutes) {
			return (multiplier * (hours * 60)) + minutes;
		});
	return A2(
		$elm$parser$Parser$keeper,
		$elm$parser$Parser$succeed($elm$core$Basics$identity),
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$map,
					function (_v0) {
						return 0;
					},
					$elm$parser$Parser$symbol('Z')),
					A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							$elm$parser$Parser$succeed(utcOffsetMinutesFromParts),
							$elm$parser$Parser$oneOf(
								_List_fromArray(
									[
										A2(
										$elm$parser$Parser$map,
										function (_v1) {
											return 1;
										},
										$elm$parser$Parser$symbol('+')),
										A2(
										$elm$parser$Parser$map,
										function (_v2) {
											return -1;
										},
										$elm$parser$Parser$symbol('-'))
									]))),
						$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								A2(
								$elm$parser$Parser$keeper,
								A2(
									$elm$parser$Parser$ignorer,
									$elm$parser$Parser$succeed($elm$core$Basics$identity),
									$elm$parser$Parser$symbol(':')),
								$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
								$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2),
								$elm$parser$Parser$succeed(0)
							]))),
					A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed(0),
					$elm$parser$Parser$end)
				])));
}();
var $rtfeldman$elm_iso8601_date_strings$Iso8601$iso8601 = A2(
	$elm$parser$Parser$andThen,
	function (datePart) {
		return $elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							A2(
								$elm$parser$Parser$keeper,
								A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed(
											$rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts(datePart)),
										$elm$parser$Parser$symbol('T')),
									$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
								$elm$parser$Parser$oneOf(
									_List_fromArray(
										[
											A2(
											$elm$parser$Parser$keeper,
											A2(
												$elm$parser$Parser$ignorer,
												$elm$parser$Parser$succeed($elm$core$Basics$identity),
												$elm$parser$Parser$symbol(':')),
											$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
											$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
										]))),
							$elm$parser$Parser$oneOf(
								_List_fromArray(
									[
										A2(
										$elm$parser$Parser$keeper,
										A2(
											$elm$parser$Parser$ignorer,
											$elm$parser$Parser$succeed($elm$core$Basics$identity),
											$elm$parser$Parser$symbol(':')),
										$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
										$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
									]))),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed($elm$core$Basics$identity),
										$elm$parser$Parser$symbol('.')),
									$rtfeldman$elm_iso8601_date_strings$Iso8601$fractionsOfASecondInMs),
									$elm$parser$Parser$succeed(0)
								]))),
					A2($elm$parser$Parser$ignorer, $rtfeldman$elm_iso8601_date_strings$Iso8601$utcOffsetInMinutes, $elm$parser$Parser$end)),
					A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed(
						A6($rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts, datePart, 0, 0, 0, 0, 0)),
					$elm$parser$Parser$end)
				]));
	},
	$rtfeldman$elm_iso8601_date_strings$Iso8601$monthYearDayInMs);
var $rtfeldman$elm_iso8601_date_strings$Iso8601$toTime = function (str) {
	return A2($elm$parser$Parser$run, $rtfeldman$elm_iso8601_date_strings$Iso8601$iso8601, str);
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		var _v0 = $rtfeldman$elm_iso8601_date_strings$Iso8601$toTime(str);
		if (_v0.$ === 1) {
			var deadEnds = _v0.a;
			return $elm$json$Json$Decode$fail(
				$elm$parser$Parser$deadEndsToString(deadEnds));
		} else {
			var time = _v0.a;
			return $elm$json$Json$Decode$succeed(time);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Model$ShareToolTag$shareToolTagDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'shareToolTagUpdated',
	$elm$json$Json$Decode$nullable($rtfeldman$elm_iso8601_date_strings$Iso8601$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'shareToolTagInserted',
		$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'shareToolTagVisibleOnSite',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'shareToolTagAvailableToEmployee',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'shareToolTagItemIds',
					$elm$json$Json$Decode$list($author$project$Data$Id$decoder),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'shareToolTagLabel',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Model$ShareToolTag$ShareToolTag)))))));
var $author$project$Data$Translation$Translations = $elm$core$Basics$identity;
var $author$project$Data$Translation$translationsDecoder = A2(
	$elm$json$Json$Decode$field,
	'translations',
	A2(
		$elm$json$Json$Decode$map,
		$elm$core$Basics$identity,
		$elm$json$Json$Decode$dict($elm$json$Json$Decode$string)));
var $author$project$ShareToolForm$decodeFlags = A4(
	$elm$json$Json$Decode$map3,
	$author$project$ShareToolForm$Flags,
	A2(
		$elm$json$Json$Decode$field,
		'tags',
		$elm$json$Json$Decode$list(
			$author$project$Data$Entity$decoder($author$project$Model$ShareToolTag$shareToolTagDecoder))),
	$author$project$Data$Translation$translationsDecoder,
	A2($elm$json$Json$Decode$field, 'currentLangCode', $author$project$Model$LangCode$decoder));
var $author$project$ShareToolForm$initForm = {pM: '', sq: false, SP: $elm$core$Maybe$Nothing, fQ: _List_Nil};
var $author$project$ShareToolForm$init = function (flags) {
	return _Utils_Tuple2(
		{
			bE: flags.bE,
			ap: _Utils_Tuple2($author$project$ShareToolForm$initForm, $elm$core$Maybe$Nothing),
			aln: flags.aln,
			anB: flags.anB,
			cU: $elm$core$Maybe$Nothing
		},
		$elm$core$Platform$Cmd$none);
};
var $author$project$ShareToolForm$GotProgress = function (a) {
	return {$: 7, a: a};
};
var $elm$http$Http$track = F2(
	function (tracker, toMsg) {
		return $elm$http$Http$subscription(
			A2($elm$http$Http$MySub, tracker, toMsg));
	});
var $author$project$ShareToolForm$subscriptions = function (_v0) {
	return A2($elm$http$Http$track, 'submit', $author$project$ShareToolForm$GotProgress);
};
var $author$project$ShareToolForm$GotCreateEmployeeContent = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$ShareToolForm$GotPreviews = function (a) {
	return {$: 2, a: a};
};
var $author$project$ShareToolForm$SelectFiles = {$: 3};
var $author$project$ShareToolForm$SelectedFiles = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Api$DecodeError = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$HttpError = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$BadStatus = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Api$BadUrl = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$NetworkError = {$: 2};
var $author$project$Api$Timeout = {$: 1};
var $author$project$Api$ValidationDecodeError = function (a) {
	return {$: 5, a: a};
};
var $author$project$Api$ValidationError = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$ValidationResponse$ValidationResponse = F3(
	function (globalError, parseError, fieldError) {
		return {atU: fieldError, Ln: globalError, _l: parseError};
	});
var $author$project$Api$ValidationResponse$validationResponseDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'fieldError',
	$elm$json$Json$Decode$dict(
		$elm$json$Json$Decode$dict($elm$json$Json$Decode$string)),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'parseError',
		$elm$json$Json$Decode$dict($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'globalError',
			$elm$json$Json$Decode$dict($elm$json$Json$Decode$string),
			$elm$json$Json$Decode$succeed($author$project$Api$ValidationResponse$ValidationResponse))));
var $author$project$Api$decodeValidationError = function (body) {
	var _v0 = A2($elm$json$Json$Decode$decodeString, $author$project$Api$ValidationResponse$validationResponseDecoder, body);
	if (!_v0.$) {
		var validationErrors = _v0.a;
		return $author$project$Api$ValidationError(validationErrors);
	} else {
		var err = _v0.a;
		return $author$project$Api$HttpError(
			$author$project$Api$ValidationDecodeError(
				$elm$json$Json$Decode$errorToString(err)));
	}
};
var $author$project$Api$expectResponse = F2(
	function (toMsg, parseString) {
		return A2(
			$elm$http$Http$expectStringResponse,
			toMsg,
			function (response) {
				switch (response.$) {
					case 0:
						var url = response.a;
						return $elm$core$Result$Err(
							$author$project$Api$HttpError(
								$author$project$Api$BadUrl(url)));
					case 1:
						return $elm$core$Result$Err(
							$author$project$Api$HttpError($author$project$Api$Timeout));
					case 2:
						return $elm$core$Result$Err(
							$author$project$Api$HttpError($author$project$Api$NetworkError));
					case 3:
						var metadata = response.a;
						var body = response.b;
						var _v1 = metadata.avE;
						if (_v1 === 400) {
							return $elm$core$Result$Err(
								$author$project$Api$decodeValidationError(body));
						} else {
							var statusCode = _v1;
							return $elm$core$Result$Err(
								$author$project$Api$HttpError(
									A2($author$project$Api$BadStatus, statusCode, body)));
						}
					default:
						var metadata = response.a;
						var body = response.b;
						return A2(parseString, metadata, body);
				}
			});
	});
var $author$project$Api$expectJson = F2(
	function (toMsg, decoder) {
		return A2(
			$author$project$Api$expectResponse,
			toMsg,
			F2(
				function (_v0, body) {
					var _v1 = A2($elm$json$Json$Decode$decodeString, decoder, body);
					if (!_v1.$) {
						var value = _v1.a;
						return $elm$core$Result$Ok(value);
					} else {
						var err = _v1.a;
						return $elm$core$Result$Err(
							$author$project$Api$HttpError(
								$author$project$Api$DecodeError(
									$elm$json$Json$Decode$errorToString(err))));
					}
				}));
	});
var $elm$file$File$Select$files = F2(
	function (mimes, toMsg) {
		return A2(
			$elm$core$Task$perform,
			function (_v0) {
				var f = _v0.a;
				var fs = _v0.b;
				return A2(toMsg, f, fs);
			},
			_File_uploadOneOrMore(mimes));
	});
var $elm$http$Http$fractionSent = function (p) {
	return (!p.ej) ? 1 : A3($elm$core$Basics$clamp, 0, 1, p.agS / p.ej);
};
var $author$project$Model$RedirectUrl$RedirectUrl = function (unRedirectUrl) {
	return {av7: unRedirectUrl};
};
var $author$project$Model$RedirectUrl$redirectUrlDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'unRedirectUrl',
	$elm$json$Json$Decode$string,
	$elm$json$Json$Decode$succeed($author$project$Model$RedirectUrl$RedirectUrl));
var $elm$http$Http$filePart = _Http_pair;
var $elm$http$Http$multipartBody = function (parts) {
	return A2(
		_Http_pair,
		'',
		_Http_toFormData(parts));
};
var $elm$http$Http$stringPart = _Http_pair;
var $author$project$ShareToolForm$toMultiPartBody = function (form) {
	var toFilePart = function (mediaToUpload) {
		return A2($elm$http$Http$filePart, 'media', mediaToUpload.HC);
	};
	var tagsStringPart = $elm$core$List$map(
		A2(
			$elm$core$Basics$composeL,
			$elm$http$Http$stringPart('tagIds'),
			$author$project$Data$Id$toString));
	var fileParts = function (maybeFiles) {
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				$elm$core$List$map(toFilePart),
				maybeFiles));
	};
	return $elm$http$Http$multipartBody(
		A2(
			$elm$core$List$cons,
			A2($elm$http$Http$stringPart, 'caption', form.pM),
			_Utils_ap(
				tagsStringPart(form.fQ),
				fileParts(form.SP))));
};
var $author$project$Data$MimeType$Audio = 4;
var $author$project$Data$MimeType$Image = 0;
var $author$project$Data$MimeType$Pdf = 1;
var $author$project$Data$MimeType$SvgXml = 3;
var $author$project$Data$MimeType$Video = 2;
var $author$project$Data$MimeType$fromBase64 = function (base64) {
	return A2($elm$core$String$startsWith, 'data:image/svg+xml', base64) ? $elm$core$Maybe$Just(3) : (A2($elm$core$String$startsWith, 'data:application/pdf', base64) ? $elm$core$Maybe$Just(1) : (A2($elm$core$String$startsWith, 'data:image/', base64) ? $elm$core$Maybe$Just(0) : (A2($elm$core$String$startsWith, 'data:video/', base64) ? $elm$core$Maybe$Just(2) : (A2($elm$core$String$startsWith, 'data:audio/', base64) ? $elm$core$Maybe$Just(4) : $elm$core$Maybe$Nothing))));
};
var $author$project$ShareToolForm$maxImageSize = _Utils_Tuple2(10000000, '10MB');
var $author$project$ShareToolForm$maxVideoSize = _Utils_Tuple2(60000000, '60MB');
var $author$project$ShareToolForm$toPreview = function (base64) {
	var maybeMimeType = $author$project$Data$MimeType$fromBase64(base64);
	if (!maybeMimeType.$) {
		if (maybeMimeType.a === 2) {
			var _v1 = maybeMimeType.a;
			return {eK: base64, dF: '/static/images/video-placeholder.png', cA: $author$project$ShareToolForm$maxVideoSize};
		} else {
			return {eK: base64, dF: base64, cA: $author$project$ShareToolForm$maxImageSize};
		}
	} else {
		return {eK: base64, dF: '/static/images/image-placeholder.png', cA: $author$project$ShareToolForm$maxImageSize};
	}
};
var $elm$file$File$toUrl = _File_toUrl;
var $author$project$ShareToolForm$update = F2(
	function (msg, model) {
		update:
		while (true) {
			switch (msg.$) {
				case 0:
					var _v1 = model.ap;
					var contentForm = _v1.a;
					return _Utils_Tuple2(
						model,
						$elm$http$Http$request(
							{
								_: $author$project$ShareToolForm$toMultiPartBody(contentForm),
								aH: A2(
									$author$project$Api$expectJson,
									$author$project$ShareToolForm$GotCreateEmployeeContent(contentForm),
									$author$project$Model$RedirectUrl$redirectUrlDecoder),
								ax: _List_Nil,
								aO: 'POST',
								a_: $elm$core$Maybe$Nothing,
								av3: $elm$core$Maybe$Just('submit'),
								a0: '/api/employee-content'
							}));
				case 1:
					if (!msg.b.$) {
						var unRedirectUrl = msg.b.a.av7;
						return _Utils_Tuple2(
							model,
							$elm$browser$Browser$Navigation$load(unRedirectUrl));
					} else {
						if (!msg.b.a.$) {
							var form = msg.a;
							var error = msg.b.a.a;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										ap: _Utils_Tuple2(
											form,
											$elm$core$Maybe$Just(error)),
										cU: $elm$core$Maybe$Nothing
									}),
								$elm$core$Platform$Cmd$none);
						} else {
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{cU: $elm$core$Maybe$Nothing}),
								$elm$core$Platform$Cmd$none);
						}
					}
				case 6:
					var form = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{ap: form}),
						$elm$core$Platform$Cmd$none);
				case 3:
					return _Utils_Tuple2(
						model,
						A2(
							$elm$file$File$Select$files,
							_List_fromArray(
								['image/*', 'video/*']),
							$author$project$ShareToolForm$SelectedFiles));
				case 5:
					var _v2 = model.ap;
					var form = _v2.a;
					var error = _v2.b;
					var $temp$msg = $author$project$ShareToolForm$SelectFiles,
						$temp$model = _Utils_update(
						model,
						{
							ap: _Utils_Tuple2(
								_Utils_update(
									form,
									{SP: $elm$core$Maybe$Nothing}),
								error)
						});
					msg = $temp$msg;
					model = $temp$model;
					continue update;
				case 4:
					var file = msg.a;
					var files = msg.b;
					var fileToMediaItemToUpload = function (f) {
						return A2(
							$elm$core$Task$map,
							function (base64) {
								return {
									HC: f,
									$V: $author$project$ShareToolForm$toPreview(base64)
								};
							},
							$elm$file$File$toUrl(f));
					};
					return _Utils_Tuple2(
						model,
						A2(
							$elm$core$Task$perform,
							$author$project$ShareToolForm$GotPreviews,
							$elm$core$Task$sequence(
								A2(
									$elm$core$List$map,
									fileToMediaItemToUpload,
									A2($elm$core$List$cons, file, files)))));
				case 2:
					var previews = msg.a;
					var _v3 = model.ap;
					var form = _v3.a;
					var errorResponse = _v3.b;
					var previews_ = A2(
						$elm$core$Maybe$withDefault,
						previews,
						A2(
							$elm$core$Maybe$map,
							function (xs) {
								return _Utils_ap(xs, previews);
							},
							form.SP));
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								ap: _Utils_Tuple2(
									_Utils_update(
										form,
										{
											SP: $elm$core$Maybe$Just(previews_)
										}),
									errorResponse)
							}),
						$elm$core$Platform$Cmd$none);
				default:
					if (msg.a.$ === 1) {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					} else {
						var progress = msg.a.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									cU: $elm$core$Maybe$Just(
										$elm$http$Http$fractionSent(progress))
								}),
							$elm$core$Platform$Cmd$none);
					}
			}
		}
	});
var $author$project$ShareToolForm$CreateEmployeeContent = {$: 0};
var $author$project$ShareToolForm$UpdateEmployeeContentForm = function (a) {
	return {$: 6, a: a};
};
var $elm$file$File$size = _File_size;
var $author$project$ShareToolForm$mediaItemAccepted = function (_v0) {
	var file = _v0.HC;
	var preview = _v0.$V;
	return _Utils_cmp(
		$elm$file$File$size(file),
		preview.cA.a) < 1;
};
var $author$project$ShareToolForm$mediaAccepted = function (maybeItems) {
	return A2(
		$elm$core$Maybe$withDefault,
		true,
		A2(
			$elm$core$Maybe$map,
			$elm$core$List$all($author$project$ShareToolForm$mediaItemAccepted),
			maybeItems));
};
var $elm$html$Html$Events$alwaysPreventDefault = function (msg) {
	return _Utils_Tuple2(msg, true);
};
var $elm$html$Html$Events$onSubmit = function (msg) {
	return A2(
		$elm$html$Html$Events$preventDefaultOn,
		'submit',
		A2(
			$elm$json$Json$Decode$map,
			$elm$html$Html$Events$alwaysPreventDefault,
			$elm$json$Json$Decode$succeed(msg)));
};
var $author$project$ShareToolForm$maxRequestSize = _Utils_Tuple2(100000000, '100MB');
var $author$project$ShareToolForm$toTotalRequestSize = function (previews) {
	return A3(
		$elm$core$List$foldr,
		F2(
			function (_v0, acc) {
				var file = _v0.HC;
				return acc + $elm$file$File$size(file);
			}),
		0,
		previews);
};
var $author$project$ShareToolForm$requestSizeAccepted = function (maybeItems) {
	if (maybeItems.$ === 1) {
		return true;
	} else {
		var items = maybeItems.a;
		return _Utils_cmp(
			$author$project$ShareToolForm$toTotalRequestSize(items),
			$author$project$ShareToolForm$maxRequestSize.a) < 0;
	}
};
var $author$project$Util$LangCode$toString = function (langCode) {
	switch (langCode) {
		case 1:
			return 'de';
		case 2:
			return 'de-at';
		case 3:
			return 'de-ch';
		case 4:
			return 'de-lu';
		case 0:
			return 'da';
		case 5:
			return 'en';
		case 6:
			return 'en-gb';
		case 7:
			return 'en-ie';
		case 8:
			return 'en-us';
		case 9:
			return 'es';
		case 10:
			return 'fi';
		case 11:
			return 'fr';
		case 12:
			return 'fr-be';
		case 13:
			return 'fr-ch';
		case 14:
			return 'fr-lu';
		case 15:
			return 'hu';
		case 16:
			return 'nl';
		case 17:
			return 'nl-be';
		case 18:
			return 'no';
		case 19:
			return 'pl';
		case 20:
			return 'pt';
		case 21:
			return 'ro';
		case 22:
			return 'sk';
		case 23:
			return 'sv';
		default:
			return 'uk';
	}
};
var $elm$html$Html$Attributes$rows = function (n) {
	return A2(
		_VirtualDom_attribute,
		'rows',
		$elm$core$String$fromInt(n));
};
var $author$project$Data$Translation$toString = F2(
	function (_v0, _v1) {
		var translations = _v0;
		var name = _v1;
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			A2($elm$core$Dict$get, name, translations));
	});
var $author$project$Data$Translation$text = function (translations) {
	return A2(
		$elm$core$Basics$composeL,
		$elm$html$Html$text,
		$author$project$Data$Translation$toString(translations));
};
var $elm$html$Html$textarea = _VirtualDom_node('textarea');
var $author$project$Model$Translation$TranslationName = $elm$core$Basics$identity;
var $author$project$Model$Translation$uploadPageCaptionLabel = 'upload-page-caption-label';
var $author$project$Model$Translation$uploadPageStep3 = 'upload-page-step3';
var $author$project$ShareToolForm$viewCaption = F3(
	function (translations, form, toMsg) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h4,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('share-tool-form__step-title')
						]),
					_List_fromArray(
						[
							A2($author$project$Data$Translation$text, translations, $author$project$Model$Translation$uploadPageStep3)
						])),
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('share-tool-form__step-description')
						]),
					_List_fromArray(
						[
							A2($author$project$Data$Translation$text, translations, $author$project$Model$Translation$uploadPageCaptionLabel)
						])),
					A2(
					$elm$html$Html$textarea,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$value(form.pM),
							$elm$html$Html$Attributes$rows(5),
							$elm$html$Html$Events$onInput(
							A2(
								$elm$core$Basics$composeL,
								toMsg,
								function (v) {
									return _Utils_update(
										form,
										{pM: v});
								}))
						]),
					_List_Nil)
				]));
	});
var $elm$html$Html$Attributes$checked = $elm$html$Html$Attributes$boolProperty('checked');
var $elm$html$Html$label = _VirtualDom_node('label');
var $author$project$Model$Translation$uploadPageConsentText = 'upload-page-consent-text';
var $author$project$Model$Translation$uploadPagePrivacyLinkLabel = 'upload-page-privacy-link-label';
var $author$project$Model$Translation$uploadPagePrivacyLinkPath = 'upload-page-privacy-link-path';
var $author$project$ShareToolForm$viewPrivacyStatementLink = function (translations) {
	var linkPath = A2($author$project$Data$Translation$toString, translations, $author$project$Model$Translation$uploadPagePrivacyLinkPath);
	var linkLabel = A2($author$project$Data$Translation$toString, translations, $author$project$Model$Translation$uploadPagePrivacyLinkLabel);
	var isValid = function (key) {
		return $elm$core$String$length(key) > 0;
	};
	return A2(
		$author$project$Util$View$viewIf,
		isValid(linkLabel) && isValid(linkPath),
		function (_v0) {
			return A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('link'),
						$elm$html$Html$Attributes$href(linkPath)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(linkLabel)
					]));
		});
};
var $author$project$ShareToolForm$viewConsent = F3(
	function (translations, form, toMsg) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('share-tool-form__consent-field')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('form-checkbox-label')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$type_('checkbox'),
									$elm$html$Html$Attributes$id('consent'),
									$elm$html$Html$Attributes$name('consent'),
									$elm$html$Html$Attributes$checked(form.sq),
									$elm$html$Html$Attributes$class('form-checkbox'),
									$elm$html$Html$Events$onClick(
									toMsg(
										_Utils_update(
											form,
											{sq: !form.sq})))
								]),
							_List_Nil),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('checkbox')
								]),
							_List_Nil),
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									A2($author$project$Data$Translation$text, translations, $author$project$Model$Translation$uploadPageConsentText),
									$author$project$ShareToolForm$viewPrivacyStatementLink(translations)
								]))
						]))
				]));
	});
var $author$project$Model$Translation$uploadPageMediaLabel = 'upload-page-media-label';
var $author$project$Model$Translation$uploadPageStep1 = 'upload-page-step1';
var $author$project$Model$Translation$browseMedia = 'browse-media';
var $author$project$ShareToolForm$viewBrowseMediaButton = F2(
	function (translations, maybeMedia) {
		var maxRequestSizeExceeded = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function (media) {
					return _Utils_cmp(
						$author$project$ShareToolForm$toTotalRequestSize(media),
						$author$project$ShareToolForm$maxRequestSize.a) > -1;
				},
				maybeMedia));
		return A2(
			$author$project$Util$View$viewIfNot,
			maxRequestSizeExceeded,
			function (_v0) {
				return A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('button'),
							$elm$html$Html$Attributes$class('btn btn-submit bg-color-1 color-white'),
							$elm$html$Html$Events$onClick($author$project$ShareToolForm$SelectFiles)
						]),
					_List_fromArray(
						[
							A2($author$project$Data$Translation$text, translations, $author$project$Model$Translation$browseMedia)
						]));
			});
	});
var $author$project$Component$Form$Input$viewFormFieldHelp = F4(
	function (labelAttributes, translation, error, field) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('form-field', true),
							_Utils_Tuple2(
							'error',
							$elm_community$maybe_extra$Maybe$Extra$isJust(error))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Util$View$viewIfNot,
					$elm$core$String$isEmpty(translation),
					function (_v0) {
						return A2(
							$elm$html$Html$label,
							A2(
								$elm$core$List$cons,
								$elm$html$Html$Attributes$class('label'),
								labelAttributes),
							_List_fromArray(
								[
									$elm$html$Html$text(translation)
								]));
					}),
					field,
					A2(
					$author$project$Util$View$viewMaybe,
					error,
					function (message) {
						return A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('error-message')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(message)
								]));
					})
				]));
	});
var $author$project$Component$Form$Input$viewFormField = F3(
	function (translation, error, field) {
		return A4($author$project$Component$Form$Input$viewFormFieldHelp, _List_Nil, translation, error, field);
	});
var $author$project$ShareToolForm$RedoSelectFiles = {$: 5};
var $author$project$Model$Translation$maxRequestSizeExceededDescription = 'max-request-size-exceeded-description';
var $author$project$Model$Translation$maxRequestSizeExceededTitle = 'max-request-size-exceeded-title';
var $elm$core$List$drop = F2(
	function (n, list) {
		drop:
		while (true) {
			if (n <= 0) {
				return list;
			} else {
				if (!list.b) {
					return list;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs;
					n = $temp$n;
					list = $temp$list;
					continue drop;
				}
			}
		}
	});
var $elm$core$List$takeReverse = F3(
	function (n, list, kept) {
		takeReverse:
		while (true) {
			if (n <= 0) {
				return kept;
			} else {
				if (!list.b) {
					return kept;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs,
						$temp$kept = A2($elm$core$List$cons, x, kept);
					n = $temp$n;
					list = $temp$list;
					kept = $temp$kept;
					continue takeReverse;
				}
			}
		}
	});
var $elm$core$List$takeTailRec = F2(
	function (n, list) {
		return $elm$core$List$reverse(
			A3($elm$core$List$takeReverse, n, list, _List_Nil));
	});
var $elm$core$List$takeFast = F3(
	function (ctr, n, list) {
		if (n <= 0) {
			return _List_Nil;
		} else {
			var _v0 = _Utils_Tuple2(n, list);
			_v0$1:
			while (true) {
				_v0$5:
				while (true) {
					if (!_v0.b.b) {
						return list;
					} else {
						if (_v0.b.b.b) {
							switch (_v0.a) {
								case 1:
									break _v0$1;
								case 2:
									var _v2 = _v0.b;
									var x = _v2.a;
									var _v3 = _v2.b;
									var y = _v3.a;
									return _List_fromArray(
										[x, y]);
								case 3:
									if (_v0.b.b.b.b) {
										var _v4 = _v0.b;
										var x = _v4.a;
										var _v5 = _v4.b;
										var y = _v5.a;
										var _v6 = _v5.b;
										var z = _v6.a;
										return _List_fromArray(
											[x, y, z]);
									} else {
										break _v0$5;
									}
								default:
									if (_v0.b.b.b.b && _v0.b.b.b.b.b) {
										var _v7 = _v0.b;
										var x = _v7.a;
										var _v8 = _v7.b;
										var y = _v8.a;
										var _v9 = _v8.b;
										var z = _v9.a;
										var _v10 = _v9.b;
										var w = _v10.a;
										var tl = _v10.b;
										return (ctr > 1000) ? A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A2($elm$core$List$takeTailRec, n - 4, tl))))) : A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A3($elm$core$List$takeFast, ctr + 1, n - 4, tl)))));
									} else {
										break _v0$5;
									}
							}
						} else {
							if (_v0.a === 1) {
								break _v0$1;
							} else {
								break _v0$5;
							}
						}
					}
				}
				return list;
			}
			var _v1 = _v0.b;
			var x = _v1.a;
			return _List_fromArray(
				[x]);
		}
	});
var $elm$core$List$take = F2(
	function (n, list) {
		return A3($elm$core$List$takeFast, 0, n, list);
	});
var $author$project$Util$List$removeByIndex = F2(
	function (index, xs) {
		return _Utils_ap(
			A2($elm$core$List$take, index, xs),
			A2($elm$core$List$drop, index + 1, xs));
	});
var $author$project$Component$Message$viewDescription = function (_v0) {
	var description = _v0.dn;
	return A2(
		$author$project$Util$View$viewIfNot,
		$elm$core$String$isEmpty(description),
		function (_v1) {
			return A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('description')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(description)
					]));
		});
};
var $author$project$Component$Message$viewExtraHtml = function (_v0) {
	var html = _v0.e_;
	return A2($author$project$Util$View$viewMaybe, html, $elm$core$Basics$identity);
};
var $author$project$Component$Message$viewTitle = function (_v0) {
	var title = _v0.avV;
	return A2(
		$author$project$Util$View$viewIfNot,
		$elm$core$String$isEmpty(title),
		function (_v1) {
			return A2(
				$elm$html$Html$h2,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('title')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(title)
					]));
		});
};
var $author$project$Component$Message$view = function (message) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('message')
			]),
		_List_fromArray(
			[
				$author$project$Component$Message$viewTitle(message),
				$author$project$Component$Message$viewDescription(message),
				$author$project$Component$Message$viewExtraHtml(message)
			]));
};
var $author$project$Util$Translation$FileTooBig = function (a) {
	return {$: 7, a: a};
};
var $author$project$Model$Translation$clickToRemove = 'click-to-remove';
var $elm$file$File$name = _File_name;
var $author$project$Copy$language = 16;
var $author$project$Util$Translation$translation = function (translationKey) {
	switch (translationKey.$) {
		case 0:
			var status = translationKey.a;
			return {
				ats: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Status {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						])),
				att: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Status {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						])),
				atu: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Status {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						])),
				atv: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Status {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						])),
				atw: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Status {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						])),
				F_: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Status {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						])),
				atJ: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Status {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						])),
				n: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Status {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						])),
				p: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Status {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						])),
				q: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Status {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						])),
				r: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Status {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						])),
				atK: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Status {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						])),
				atM: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Estado {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						])),
				atT: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Tila {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						])),
				at1: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Statut {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						])),
				at2: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Statut {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						])),
				at3: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Statut {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						])),
				at4: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Statut {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						])),
				aug: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Állapot {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						])),
				auO: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Status {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						])),
				auP: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Status {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						])),
				VA: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Status {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						])),
				avc: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Status {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						])),
				avj: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Status {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						])),
				avs: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Status {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						])),
				avB: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Status {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						])),
				avP: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Status {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						])),
				av5: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Status {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						]))
			};
		case 1:
			var status = translationKey.a;
			return {
				ats: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Anmodningen mislykkedes med statuskode {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						])),
				att: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Die Anforderung ist mit dem Statuscode fehlgeschlagen {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						])),
				atu: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Die Anforderung ist mit dem Statuscode fehlgeschlagen {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						])),
				atv: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Die Anforderung ist mit dem Statuscode fehlgeschlagen {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						])),
				atw: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Die Anforderung ist mit dem Statuscode fehlgeschlagen {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						])),
				F_: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'The request failed with status code {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						])),
				atJ: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'The request failed with status code {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						])),
				n: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'The request failed with status code {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						])),
				p: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'The request failed with status code {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						])),
				q: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'The request failed with status code {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						])),
				r: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'The request failed with status code {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						])),
				atK: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'The request failed with status code {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						])),
				atM: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'La solicitud falló con el código de estado {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						])),
				atT: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Pyyntö epäonnistui tilakoodilla {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						])),
				at1: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Le serveur répond avec un code d\'état {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						])),
				at2: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Le serveur répond avec un code d\'état {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						])),
				at3: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Le serveur répond avec un code d\'état {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						])),
				at4: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Le serveur répond avec un code d\'état {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						])),
				aug: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'A kérés meghiúsult, állapotkód: {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						])),
				auO: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'De server antwoordde met statuscode {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						])),
				auP: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'De server antwoordde met statuscode {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						])),
				VA: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Forespørselen mislyktes med statuskoden {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						])),
				avc: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Żądanie nie powiodło się z kodem stanu {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						])),
				avj: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'O servidor responde com o código de status {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						])),
				avs: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Serverul răspunde cu codul de stare {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						])),
				avB: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Server odpovie stavovým kódom {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						])),
				avP: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Begäran misslyckades med statuskoden {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						])),
				av5: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Сервер відповідає кодом статусу {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						]))
			};
		case 2:
			var url = translationKey.a;
			return {
				ats: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Adres URL {0} nie istnieje.',
					_List_fromArray(
						[url])),
				att: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Die URL {0} existiert nicht.',
					_List_fromArray(
						[url])),
				atu: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Die URL {0} existiert nicht.',
					_List_fromArray(
						[url])),
				atv: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Die URL {0} existiert nicht.',
					_List_fromArray(
						[url])),
				atw: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Die URL {0} existiert nicht.',
					_List_fromArray(
						[url])),
				F_: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'The url {0} does not exist.',
					_List_fromArray(
						[url])),
				atJ: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'The url {0} does not exist.',
					_List_fromArray(
						[url])),
				n: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'The url {0} does not exist.',
					_List_fromArray(
						[url])),
				p: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'The url {0} does not exist.',
					_List_fromArray(
						[url])),
				q: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'The url {0} does not exist.',
					_List_fromArray(
						[url])),
				r: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'The url {0} does not exist.',
					_List_fromArray(
						[url])),
				atK: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'The url {0} does not exist.',
					_List_fromArray(
						[url])),
				atM: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'La URL {0} no existe.',
					_List_fromArray(
						[url])),
				atT: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'URL -osoitetta {0} ei ole olemassa.',
					_List_fromArray(
						[url])),
				at1: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'L\'url {0} n\'existe pas.',
					_List_fromArray(
						[url])),
				at2: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'L\'url {0} n\'existe pas.',
					_List_fromArray(
						[url])),
				at3: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'L\'url {0} n\'existe pas.',
					_List_fromArray(
						[url])),
				at4: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'L\'url {0} n\'existe pas.',
					_List_fromArray(
						[url])),
				aug: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'A(z) {0} URL nem létezik.',
					_List_fromArray(
						[url])),
				auO: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'De url {0} bestaat niet.',
					_List_fromArray(
						[url])),
				auP: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'De url {0} bestaat niet.',
					_List_fromArray(
						[url])),
				VA: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Nettadressen {0} eksisterer ikke.',
					_List_fromArray(
						[url])),
				avc: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Adres URL {0} nie istnieje.',
					_List_fromArray(
						[url])),
				avj: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'O URL {0} não existe.',
					_List_fromArray(
						[url])),
				avs: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Adresa URL {0} nu există.',
					_List_fromArray(
						[url])),
				avB: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Adresa URL {0} neexistuje.',
					_List_fromArray(
						[url])),
				avP: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Webbadressen {0} finns inte.',
					_List_fromArray(
						[url])),
				av5: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'URL-адреса {0} не існує',
					_List_fromArray(
						[url]))
			};
		case 9:
			var max = translationKey.a;
			return {
				ats: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Det maksimale beløb for {0} offentliggjorte konti på sociale medier er nået.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				att: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Der Höchstbetrag von {0} veröffentlichten Social-Media-Konten ist erreicht.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				atu: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Der Höchstbetrag von {0} veröffentlichten Social-Media-Konten ist erreicht.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				atv: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Der Höchstbetrag von {0} veröffentlichten Social-Media-Konten ist erreicht.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				atw: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Der Höchstbetrag von {0} veröffentlichten Social-Media-Konten ist erreicht.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				F_: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'The maximum amount of {0} published social media accounts is reached.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				atJ: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'The maximum amount of {0} published social media accounts is reached.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				n: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'The maximum amount of {0} published social media accounts is reached.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				p: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'The maximum amount of {0} published social media accounts is reached.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				q: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'The maximum amount of {0} published social media accounts is reached.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				r: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'The maximum amount of {0} published social media accounts is reached.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				atK: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'The maximum amount of {0} published social media accounts is reached.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				atM: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Se alcanza la cantidad máxima de cuentas de redes sociales publicadas.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				atT: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Julkaistujen sosiaalisen median tilien enimmäismäärä on saavutettu.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				at1: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Le nombre maximal de {0} comptes de médias sociaux publiés est atteint.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				at2: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Le nombre maximal de {0} comptes de médias sociaux publiés est atteint.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				at3: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Le nombre maximal de {0} comptes de médias sociaux publiés est atteint.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				at4: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Le nombre maximal de {0} comptes de médias sociaux publiés est atteint.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				aug: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Elérte a közzétehető közösségi fiókok maximumát: {0}.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				auO: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Het maximale aantal van {0} gepubliceerde social media accounts is bereikt.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				auP: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Het maximale aantal van {0} gepubliceerde social media accounts is bereikt.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				VA: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Maksimalt antall {0} publiserte sosiale medier -kontoer er nådd.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				avc: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Osiągnięto maksymalną liczbę {0} opublikowanych kont w mediach społecznościowych.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				avj: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'O número máximo de {0} contas de mídia social publicadas foi atingido.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				avs: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'A fost atinsă cantitatea maximă de {0} conturi de social media publicate.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				avB: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Dosiahli ste maximálny počet {0} zverejnených účtov sociálnych médií.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				avP: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Det högsta beloppet för {0} publicerade sociala mediekonton har uppnåtts.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				av5: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Досягнуто максимальної кількості опублікованих облікових записів соціальних мереж: {0}.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						]))
			};
		case 8:
			var max = translationKey.a;
			return {
				ats: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Högst {0} sökandesresor tillåtna',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				att: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Maximal {0} Antragsteller-Reisen erlaubt',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				atu: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Maximal {0} Antragsteller-Reisen erlaubt',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				atv: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Maximal {0} Antragsteller-Reisen erlaubt',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				atw: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Maximal {0} Antragsteller-Reisen erlaubt',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				F_: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Maximum {0} applicant journeys allowed',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				atJ: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Maximum {0} applicant journeys allowed',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				n: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Maximum {0} applicant journeys allowed',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				p: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Maximum {0} applicant journeys allowed',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				q: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Maximum {0} applicant journeys allowed',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				r: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Maximum {0} applicant journeys allowed',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				atK: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Maximum {0} applicant journeys allowed',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				atM: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Máximo {0} Viajes solicitantes permitidos',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				atT: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Suurin sallittu {0} hakijamatka',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				at1: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Maximum {0} voyages de candidat autorisés',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				at2: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Maximum {0} voyages de candidat autorisés',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				at3: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Maximum {0} voyages de candidat autorisés',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				at4: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Maximum {0} voyages de candidat autorisés',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				aug: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Legfeljebb {0} jelentkezői útvonal engedélyezett',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				auO: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Maximaal {0} applicant journeys toegestaan',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				auP: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Maximaal {0} applicant journeys toegestaan',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				VA: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Maksimalt tillatte {0} søkereiser',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				avc: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Maksymalna dozwolona liczba podróży {0} kandydata',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				avj: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Máximo de {0} viagens de candidatos permitidas',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				avs: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Maximum {0} călătorii ale solicitantului permise',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				avB: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Maximálny povolený počet ciest žiadateľa je {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				avP: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Högst {0} sökandesresor tillåtna',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				av5: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Максимальна кількість заявників: {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						]))
			};
		case 11:
			var tag = translationKey.a;
			return {
				ats: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Er du sikker på, at du vil fjerne denne {0}?',
					_List_fromArray(
						[tag])),
				att: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Sind Sie sicher, dass Sie diese {0} entfernen möchten?',
					_List_fromArray(
						[tag])),
				atu: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Sind Sie sicher, dass Sie diese {0} entfernen möchten?',
					_List_fromArray(
						[tag])),
				atv: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Sind Sie sicher, dass Sie diese {0} entfernen möchten?',
					_List_fromArray(
						[tag])),
				atw: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Sind Sie sicher, dass Sie diese {0} entfernen möchten?',
					_List_fromArray(
						[tag])),
				F_: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Are you sure you want to remove this {0}?',
					_List_fromArray(
						[tag])),
				atJ: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Are you sure you want to remove this {0}?',
					_List_fromArray(
						[tag])),
				n: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Are you sure you want to remove this {0}?',
					_List_fromArray(
						[tag])),
				p: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Are you sure you want to remove this {0}?',
					_List_fromArray(
						[tag])),
				q: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Are you sure you want to remove this {0}?',
					_List_fromArray(
						[tag])),
				r: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Are you sure you want to remove this {0}?',
					_List_fromArray(
						[tag])),
				atK: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Are you sure you want to remove this {0}?',
					_List_fromArray(
						[tag])),
				atM: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Está seguro de que desea eliminar este {0}?',
					_List_fromArray(
						[tag])),
				atT: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Haluatko varmasti poistaa tämän {0}?',
					_List_fromArray(
						[tag])),
				at1: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Êtes-vous sûr de vouloir supprimer ces {0}?',
					_List_fromArray(
						[tag])),
				at2: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Êtes-vous sûr de vouloir supprimer ces {0}?',
					_List_fromArray(
						[tag])),
				at3: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Êtes-vous sûr de vouloir supprimer ces {0}?',
					_List_fromArray(
						[tag])),
				at4: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Êtes-vous sûr de vouloir supprimer ces {0}?',
					_List_fromArray(
						[tag])),
				aug: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Biztosan eltávolítja ezt: {0}?',
					_List_fromArray(
						[tag])),
				auO: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Weet je zeker dat je deze {0} wilt verwijderen?',
					_List_fromArray(
						[tag])),
				auP: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Weet je zeker dat je deze {0} wilt verwijderen?',
					_List_fromArray(
						[tag])),
				VA: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Er du sikker på at du vil fjerne denne {0}?',
					_List_fromArray(
						[tag])),
				avc: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Czy na pewno chcesz usunąć ten {0}?',
					_List_fromArray(
						[tag])),
				avj: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Tem certeza de que deseja excluir este {0}?',
					_List_fromArray(
						[tag])),
				avs: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Sigur doriți să eliminați acest {0}?',
					_List_fromArray(
						[tag])),
				avB: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Naozaj chcete odstrániť toto {0}?',
					_List_fromArray(
						[tag])),
				avP: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Är du säker på att du vill ta bort den här {0}?',
					_List_fromArray(
						[tag])),
				av5: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Ви впевнені, що хочете видалити цей {0}?',
					_List_fromArray(
						[tag]))
			};
		case 12:
			var max = translationKey.a;
			return {
				ats: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'For mange filtre aktiveret. Maks. {0} filtre',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				att: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Zu viele Filter aktiviert. Max {0} Filter',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				atu: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Zu viele Filter aktiviert. Max {0} Filter',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				atv: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Zu viele Filter aktiviert. Max {0} Filter',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				atw: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Zu viele Filter aktiviert. Max {0} Filter',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				F_: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Too many filters enabled. Max {0} filters',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				atJ: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Too many filters enabled. Max {0} filters',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				n: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Too many filters enabled. Max {0} filters',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				p: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Too many filters enabled. Max {0} filters',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				q: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Too many filters enabled. Max {0} filters',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				r: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Too many filters enabled. Max {0} filters',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				atK: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Too many filters enabled. Max {0} filters',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				atM: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Demasiados filtros habilitados. Max {0} filtros',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				atT: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Liian monta suodatinta käytössä. Enintään {0} suodatinta',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				at1: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Trop de filtres activés. Maximum {0} filtres.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				at2: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Trop de filtres activés. Maximum {0} filtres.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				at3: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Trop de filtres activés. Maximum {0} filtres.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				at4: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Trop de filtres activés. Maximum {0} filtres.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				aug: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Túl sok szűrő van bekapcsolva. Legfeljebb {0} szűrő',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				auO: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Te veel filters geselecteerd. Maximaal {0} filters',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				auP: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Te veel filters geselecteerd. Maximaal {0} filters',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				VA: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'For mange filtre aktivert. Maks. {0} filtre',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				avc: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Włączono zbyt wiele filtrów. Maks. {0} filtrów',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				avj: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Muitos filtros selecionados. Máximo de {0} filtros',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				avs: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Prea multe filtre activate. Max {0} filtre',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				avB: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Je povolených príliš veľa filtrov. Maximálny počet filtrov: {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				avP: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'För många filter aktiverade. Max. {0} filter',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				av5: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Вибрано забагато фільтрів. Максимальна кількість фільтрів: {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						]))
			};
		case 15:
			var tag = translationKey.a;
			var col = translationKey.b;
			var column = translationKey.c;
			return {
				ats: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Det er ikke tilladt at tilføje en {0} i {1} {2}',
					_List_fromArray(
						[
							tag,
							$elm$core$String$fromInt(col),
							$elm$core$String$toLower(column)
						])),
				att: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Es dürfen kein {0} in {1} {2} hinzufügen',
					_List_fromArray(
						[
							tag,
							$elm$core$String$fromInt(col),
							$elm$core$String$toLower(column)
						])),
				atu: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Es dürfen kein {0} in {1} {2} hinzufügen',
					_List_fromArray(
						[
							tag,
							$elm$core$String$fromInt(col),
							$elm$core$String$toLower(column)
						])),
				atv: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Es dürfen kein {0} in {1} {2} hinzufügen',
					_List_fromArray(
						[
							tag,
							$elm$core$String$fromInt(col),
							$elm$core$String$toLower(column)
						])),
				atw: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Es dürfen kein {0} in {1} {2} hinzufügen',
					_List_fromArray(
						[
							tag,
							$elm$core$String$fromInt(col),
							$elm$core$String$toLower(column)
						])),
				F_: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'It\'s not allowed to add a {0} in {1} {2}',
					_List_fromArray(
						[
							tag,
							$elm$core$String$fromInt(col),
							$elm$core$String$toLower(column)
						])),
				atJ: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'It\'s not allowed to add a {0} in {1} {2}',
					_List_fromArray(
						[
							tag,
							$elm$core$String$fromInt(col),
							$elm$core$String$toLower(column)
						])),
				n: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'It\'s not allowed to add a {0} in {1} {2}',
					_List_fromArray(
						[
							tag,
							$elm$core$String$fromInt(col),
							$elm$core$String$toLower(column)
						])),
				p: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'It\'s not allowed to add a {0} in {1} {2}',
					_List_fromArray(
						[
							tag,
							$elm$core$String$fromInt(col),
							$elm$core$String$toLower(column)
						])),
				q: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'It\'s not allowed to add a {0} in {1} {2}',
					_List_fromArray(
						[
							tag,
							$elm$core$String$fromInt(col),
							$elm$core$String$toLower(column)
						])),
				r: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'It\'s not allowed to add a {0} in {1} {2}',
					_List_fromArray(
						[
							tag,
							$elm$core$String$fromInt(col),
							$elm$core$String$toLower(column)
						])),
				atK: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'It\'s not allowed to add a {0} in {1} {2}',
					_List_fromArray(
						[
							tag,
							$elm$core$String$fromInt(col),
							$elm$core$String$toLower(column)
						])),
				atM: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'No se le permite agregar un {0} en {1} {2}',
					_List_fromArray(
						[
							tag,
							$elm$core$String$fromInt(col),
							$elm$core$String$toLower(column)
						])),
				atT: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'{0} ei saa lisätä kohteeseen {1} {2}',
					_List_fromArray(
						[
							tag,
							$elm$core$String$fromInt(col),
							$elm$core$String$toLower(column)
						])),
				at1: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Il n\'est pas permis d\'ajouter {0} dans {1} {2}',
					_List_fromArray(
						[
							tag,
							$elm$core$String$fromInt(col),
							$elm$core$String$toLower(column)
						])),
				at2: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Il n\'est pas permis d\'ajouter {0} dans {1} {2}',
					_List_fromArray(
						[
							tag,
							$elm$core$String$fromInt(col),
							$elm$core$String$toLower(column)
						])),
				at3: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Il n\'est pas permis d\'ajouter {0} dans {1} {2}',
					_List_fromArray(
						[
							tag,
							$elm$core$String$fromInt(col),
							$elm$core$String$toLower(column)
						])),
				at4: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Il n\'est pas permis d\'ajouter {0} dans {1} {2}',
					_List_fromArray(
						[
							tag,
							$elm$core$String$fromInt(col),
							$elm$core$String$toLower(column)
						])),
				aug: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Nem adható hozzá {0} a következőhöz: {1} {2}',
					_List_fromArray(
						[
							tag,
							$elm$core$String$fromInt(col),
							$elm$core$String$toLower(column)
						])),
				auO: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Het is niet toegestaan om {0} in {1} {2} te plaatsen',
					_List_fromArray(
						[
							tag,
							$elm$core$String$fromInt(col),
							$elm$core$String$toLower(column)
						])),
				auP: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Het is niet toegestaan om {0} in {1} {2} te plaatsen',
					_List_fromArray(
						[
							tag,
							$elm$core$String$fromInt(col),
							$elm$core$String$toLower(column)
						])),
				VA: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Det er ikke tillatt å legge til en {0} i {1} {2}',
					_List_fromArray(
						[
							tag,
							$elm$core$String$fromInt(col),
							$elm$core$String$toLower(column)
						])),
				avc: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Nie można dodawać {0} w {1} {2}',
					_List_fromArray(
						[
							tag,
							$elm$core$String$fromInt(col),
							$elm$core$String$toLower(column)
						])),
				avj: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Não é permitido colocar {0} em {1} {2}',
					_List_fromArray(
						[
							tag,
							$elm$core$String$fromInt(col),
							$elm$core$String$toLower(column)
						])),
				avs: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Nu este permis să adăugați un {0} în {1} {2}',
					_List_fromArray(
						[
							tag,
							$elm$core$String$fromInt(col),
							$elm$core$String$toLower(column)
						])),
				avB: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Nie je povolené pridať {0} v {1} {2}',
					_List_fromArray(
						[
							tag,
							$elm$core$String$fromInt(col),
							$elm$core$String$toLower(column)
						])),
				avP: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Det är inte tillåtet att lägga till en {0} i {1} {2}',
					_List_fromArray(
						[
							tag,
							$elm$core$String$fromInt(col),
							$elm$core$String$toLower(column)
						])),
				av5: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Не дозволено розміщувати {0} в {1} {2}',
					_List_fromArray(
						[
							tag,
							$elm$core$String$fromInt(col),
							$elm$core$String$toLower(column)
						]))
			};
		case 3:
			var name = translationKey.a;
			return {
				ats: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Accepter venligst {0} betingelserne.',
					_List_fromArray(
						[name])),
				att: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Bitte akzeptieren Sie die Bedingungen {0}.',
					_List_fromArray(
						[name])),
				atu: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Bitte akzeptieren Sie die Bedingungen {0}.',
					_List_fromArray(
						[name])),
				atv: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Bitte akzeptieren Sie die Bedingungen {0}.',
					_List_fromArray(
						[name])),
				atw: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Bitte akzeptieren Sie die Bedingungen {0}.',
					_List_fromArray(
						[name])),
				F_: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Please accept the {0} conditions.',
					_List_fromArray(
						[name])),
				atJ: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Please accept the {0} conditions.',
					_List_fromArray(
						[name])),
				n: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Please accept the {0} conditions.',
					_List_fromArray(
						[name])),
				p: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Please accept the {0} conditions.',
					_List_fromArray(
						[name])),
				q: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Please accept the {0} conditions.',
					_List_fromArray(
						[name])),
				r: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Please accept the {0} conditions.',
					_List_fromArray(
						[name])),
				atK: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Please accept the {0} conditions.',
					_List_fromArray(
						[name])),
				atM: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Por favor acepte las condiciones {0}',
					_List_fromArray(
						[name])),
				atT: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Hyväksy {0} ehdot.',
					_List_fromArray(
						[name])),
				at1: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Veuillez accepter les {0} conditions.',
					_List_fromArray(
						[name])),
				at2: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Veuillez accepter les {0} conditions.',
					_List_fromArray(
						[name])),
				at3: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Veuillez accepter les {0} conditions.',
					_List_fromArray(
						[name])),
				at4: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Veuillez accepter les {0} conditions.',
					_List_fromArray(
						[name])),
				aug: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Fogadja el a(z) {0} feltételeket.',
					_List_fromArray(
						[name])),
				auO: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Graag de {0} voorwaarden accepteren.',
					_List_fromArray(
						[name])),
				auP: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Graag de {0} voorwaarden accepteren.',
					_List_fromArray(
						[name])),
				VA: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Godta vilkårene for {0}.',
					_List_fromArray(
						[name])),
				avc: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Zaakceptuj {0} warunki.',
					_List_fromArray(
						[name])),
				avj: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Aceite as {0} condições.',
					_List_fromArray(
						[name])),
				avs: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Vă rugăm să acceptați {0} condițiile.',
					_List_fromArray(
						[name])),
				avB: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Prijmite podmienky {0}.',
					_List_fromArray(
						[name])),
				avP: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Godkänn {0} villkoren.',
					_List_fromArray(
						[name])),
				av5: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Прийміть умови {0}.',
					_List_fromArray(
						[name]))
			};
		case 10:
			var mime = translationKey.a;
			return {
				ats: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Filtillägg {0} är inte tillåtet.',
					_List_fromArray(
						[mime])),
				att: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Dateierweiterung {0} nicht erlaubt.',
					_List_fromArray(
						[mime])),
				atu: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Dateierweiterung {0} nicht erlaubt.',
					_List_fromArray(
						[mime])),
				atv: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Dateierweiterung {0} nicht erlaubt.',
					_List_fromArray(
						[mime])),
				atw: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Dateierweiterung {0} nicht erlaubt.',
					_List_fromArray(
						[mime])),
				F_: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'File extension {0} not allowed.',
					_List_fromArray(
						[mime])),
				atJ: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'File extension {0} not allowed.',
					_List_fromArray(
						[mime])),
				n: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'File extension {0} not allowed.',
					_List_fromArray(
						[mime])),
				p: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Bestandstype {0} niet toegestaan.',
					_List_fromArray(
						[mime])),
				q: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Bestandstype {0} niet toegestaan.',
					_List_fromArray(
						[mime])),
				r: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Bestandstype {0} niet toegestaan.',
					_List_fromArray(
						[mime])),
				atK: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'File extension {0} not allowed.',
					_List_fromArray(
						[mime])),
				atM: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Extensión de archivo {0} No se permite',
					_List_fromArray(
						[mime])),
				atT: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Tiedostopääte {0} ei ole sallittu.',
					_List_fromArray(
						[mime])),
				at1: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Type de fichier {0} non autorisé.',
					_List_fromArray(
						[mime])),
				at2: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Type de fichier {0} non autorisé.',
					_List_fromArray(
						[mime])),
				at3: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Type de fichier {0} non autorisé.',
					_List_fromArray(
						[mime])),
				at4: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Type de fichier {0} non autorisé.',
					_List_fromArray(
						[mime])),
				aug: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'A(z) {0} fájlkiterjesztés nem engedélyezett.',
					_List_fromArray(
						[mime])),
				auO: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Bestandstype {0} niet toegestaan.',
					_List_fromArray(
						[mime])),
				auP: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Bestandstype {0} niet toegestaan.',
					_List_fromArray(
						[mime])),
				VA: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Filutvidelse {0} er ikke tillatt.',
					_List_fromArray(
						[mime])),
				avc: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Rozszerzenie pliku {0} jest niedozwolone.',
					_List_fromArray(
						[mime])),
				avj: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Tipo de arquivo {0} não permitido.',
					_List_fromArray(
						[mime])),
				avs: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Extensia de fișier {0} nu este permisă.',
					_List_fromArray(
						[mime])),
				avB: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Prípona súboru {0} nie je povolená.',
					_List_fromArray(
						[mime])),
				avP: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Filtillägg {0} är inte tillåtet.',
					_List_fromArray(
						[mime])),
				av5: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Розширення файлу {0} заборонено.',
					_List_fromArray(
						[mime]))
			};
		case 4:
			var length = translationKey.a;
			return {
				ats: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Den maksimale længde af dette felt er {0} tegn.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						])),
				att: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Die maximale Länge dieses Feldes ist {0} Zeichen.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						])),
				atu: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Die maximale Länge dieses Feldes ist {0} Zeichen.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						])),
				atv: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Die maximale Länge dieses Feldes ist {0} Zeichen.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						])),
				atw: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Die maximale Länge dieses Feldes ist {0} Zeichen.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						])),
				F_: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'The maximum length of this field is {0} characters.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						])),
				atJ: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'The maximum length of this field is {0} characters.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						])),
				n: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'The maximum length of this field is {0} characters.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						])),
				p: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'The maximum length of this field is {0} characters.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						])),
				q: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'The maximum length of this field is {0} characters.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						])),
				r: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'The maximum length of this field is {0} characters.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						])),
				atK: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'The maximum length of this field is {0} characters.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						])),
				atM: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'La longitud máxima de este campo es {0} caracteres',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						])),
				atT: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Tämän kentän enimmäispituus on {0} merkkiä.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						])),
				at1: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'La longueur maximale de ce champ de saisie est {0} karakters.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						])),
				at2: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'La longueur maximale de ce champ de saisie est {0} karakters.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						])),
				at3: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'La longueur maximale de ce champ de saisie est {0} karakters.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						])),
				at4: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'La longueur maximale de ce champ de saisie est {0} karakters.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						])),
				aug: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Ez a mező legfeljebb {0} karakter hosszú lehet.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						])),
				auO: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'De maximale lengte van dit veld is {0} karakters.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						])),
				auP: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'De maximale lengte van dit veld is {0} karakters.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						])),
				VA: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Maksimal lengde på dette feltet er {0} tegn.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						])),
				avc: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Maksymalna długość tego pola to {0} znaków.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						])),
				avj: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'O comprimento máximo deste campo é de {0} caracteres.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						])),
				avs: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Lungimea maximă a acestui câmp este de {0} caractere.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						])),
				avB: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Maximálna dĺžka tohto poľa je {0} znakov.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						])),
				avP: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Den maximala längden för detta fält är {0} tecken.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						])),
				av5: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Максимальна довжина цього поля – {0} символів.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						]))
			};
		case 5:
			var length = translationKey.a;
			return {
				ats: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Minimumsfeltet for dette felt er {0} tegn.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						])),
				att: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Die Mindestlänge dieses Feldes ist {0} Zeichen.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						])),
				atu: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Die Mindestlänge dieses Feldes ist {0} Zeichen.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						])),
				atv: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Die Mindestlänge dieses Feldes ist {0} Zeichen.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						])),
				atw: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Die Mindestlänge dieses Feldes ist {0} Zeichen.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						])),
				F_: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'The minimum length of this field is {0} characters.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						])),
				atJ: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'The minimum length of this field is {0} characters.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						])),
				n: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'The minimum length of this field is {0} characters.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						])),
				p: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'The minimum length of this field is {0} characters.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						])),
				q: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'The minimum length of this field is {0} characters.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						])),
				r: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'The minimum length of this field is {0} characters.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						])),
				atK: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'The minimum length of this field is {0} characters.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						])),
				atM: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'La longitud mínima de este campo es {0} caracteres',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						])),
				atT: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Tämän kentän vähimmäispituus on {0} merkkiä.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						])),
				at1: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'La longueur minimale de ce champ est {0} karakters.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						])),
				at2: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'La longueur minimale de ce champ est {0} karakters.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						])),
				at3: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'La longueur minimale de ce champ est {0} karakters.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						])),
				at4: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'La longueur minimale de ce champ est {0} karakters.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						])),
				aug: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Ez a mező legalább {0} karakter hosszú legyen.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						])),
				auO: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'De minimale lengte van dit veld is {0} karakters.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						])),
				auP: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'De minimale lengte van dit veld is {0} karakters.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						])),
				VA: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Minimumslengden for dette feltet er {0} tegn.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						])),
				avc: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Minimalna długość tego pola to {0} znaków.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						])),
				avj: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'O comprimento mínimo deste campo é de {0} caracteres.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						])),
				avs: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Lungimea minimă a acestui câmp este de {0} caractere.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						])),
				avB: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Minimálna dĺžka tohto poľa je {0} znakov.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						])),
				avP: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Minsta längd för detta fält är {0} tecken.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						])),
				av5: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Мінімальна довжина цього поля – {0} символів.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						]))
			};
		case 6:
			var name = translationKey.a;
			return {
				ats: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Tilføj din {0}.',
					_List_fromArray(
						[name])),
				att: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Bitte füge dein {0} hinzu.',
					_List_fromArray(
						[name])),
				atu: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Bitte füge dein {0} hinzu.',
					_List_fromArray(
						[name])),
				atv: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Bitte füge dein {0} hinzu.',
					_List_fromArray(
						[name])),
				atw: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Bitte füge dein {0} hinzu.',
					_List_fromArray(
						[name])),
				F_: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Please add your {0}.',
					_List_fromArray(
						[name])),
				atJ: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Please add your {0}.',
					_List_fromArray(
						[name])),
				n: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Please add your {0}.',
					_List_fromArray(
						[name])),
				p: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Please add your {0}.',
					_List_fromArray(
						[name])),
				q: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Please add your {0}.',
					_List_fromArray(
						[name])),
				r: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Please add your {0}.',
					_List_fromArray(
						[name])),
				atK: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Please add your {0}.',
					_List_fromArray(
						[name])),
				atM: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Por favor agregue su {0}',
					_List_fromArray(
						[name])),
				atT: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Lisää {0}.',
					_List_fromArray(
						[name])),
				at1: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Veuillez ajouter votre {0}.',
					_List_fromArray(
						[name])),
				at2: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Veuillez ajouter votre {0}.',
					_List_fromArray(
						[name])),
				at3: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Veuillez ajouter votre {0}.',
					_List_fromArray(
						[name])),
				at4: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Veuillez ajouter votre {0}.',
					_List_fromArray(
						[name])),
				aug: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Adja meg: {0}.',
					_List_fromArray(
						[name])),
				auO: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Graag je {0} toevoegen.',
					_List_fromArray(
						[name])),
				auP: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Graag je {0} toevoegen.',
					_List_fromArray(
						[name])),
				VA: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Legg til {0}.',
					_List_fromArray(
						[name])),
				avc: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Dodaj swój {0}.',
					_List_fromArray(
						[name])),
				avj: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Adicione seu {0}.',
					_List_fromArray(
						[name])),
				avs: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Vă rugăm să adăugați {0}.',
					_List_fromArray(
						[name])),
				avB: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Pridajte svoj {0}.',
					_List_fromArray(
						[name])),
				avP: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Lägg till din {0}.',
					_List_fromArray(
						[name])),
				av5: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Будь ласка, додайте свій {0}.',
					_List_fromArray(
						[name]))
			};
		case 7:
			var maxSize = translationKey.a;
			return {
				ats: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Filstørrelse er begrænset til: {0}.',
					_List_fromArray(
						[maxSize])),
				att: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Dateigröße ist begrenzt auf: {0}.',
					_List_fromArray(
						[maxSize])),
				atu: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Dateigröße ist begrenzt auf: {0}.',
					_List_fromArray(
						[maxSize])),
				atv: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Dateigröße ist begrenzt auf: {0}.',
					_List_fromArray(
						[maxSize])),
				atw: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Dateigröße ist begrenzt auf: {0}.',
					_List_fromArray(
						[maxSize])),
				F_: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'File size is limited to: {0}.',
					_List_fromArray(
						[maxSize])),
				atJ: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'File size is limited to: {0}.',
					_List_fromArray(
						[maxSize])),
				n: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'File size is limited to: {0}.',
					_List_fromArray(
						[maxSize])),
				p: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'File size is limited to: {0}.',
					_List_fromArray(
						[maxSize])),
				q: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'File size is limited to: {0}.',
					_List_fromArray(
						[maxSize])),
				r: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'File size is limited to: {0}.',
					_List_fromArray(
						[maxSize])),
				atK: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'File size is limited to: {0}.',
					_List_fromArray(
						[maxSize])),
				atM: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'El tamaño del archivo se limita a: {0}.',
					_List_fromArray(
						[maxSize])),
				atT: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Tiedoston koko on rajoitettu: {0} Mt.',
					_List_fromArray(
						[maxSize])),
				at1: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Le fichier ne peut pas dépasser: {0}.',
					_List_fromArray(
						[maxSize])),
				at2: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Le fichier ne peut pas dépasser: {0}.',
					_List_fromArray(
						[maxSize])),
				at3: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Le fichier ne peut pas dépasser: {0}.',
					_List_fromArray(
						[maxSize])),
				at4: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Le fichier ne peut pas dépasser: {0}.',
					_List_fromArray(
						[maxSize])),
				aug: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'A fájl mérete legfeljebb: {0}.',
					_List_fromArray(
						[maxSize])),
				auO: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Bestand mag niet groter zijn dan: {0}.',
					_List_fromArray(
						[maxSize])),
				auP: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Bestand mag niet groter zijn dan: {0}.',
					_List_fromArray(
						[maxSize])),
				VA: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Filstørrelsen er begrenset til: {0}.',
					_List_fromArray(
						[maxSize])),
				avc: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Rozmiar pliku jest ograniczony do: {0}.',
					_List_fromArray(
						[maxSize])),
				avj: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'O arquivo não pode ser maior que: {0}.',
					_List_fromArray(
						[maxSize])),
				avs: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Dimensiunea fișierului este limitată la: {0}.',
					_List_fromArray(
						[maxSize])),
				avB: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Veľkosť súboru je obmedzená na: {0}.',
					_List_fromArray(
						[maxSize])),
				avP: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Filstorleken är begränsad till: {0}.',
					_List_fromArray(
						[maxSize])),
				av5: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Розмір файлу обмежено: {0}.',
					_List_fromArray(
						[maxSize]))
			};
		case 13:
			var maxAge = translationKey.a;
			return {
				ats: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Du skal være yngre end {0} år for at ansøge.',
					_List_fromArray(
						[maxAge])),
				att: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Sie müssen jünger als {0} Jahre alt sein, um sich zu bewerben.',
					_List_fromArray(
						[maxAge])),
				atu: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Sie müssen jünger als {0} Jahre alt sein, um sich zu bewerben.',
					_List_fromArray(
						[maxAge])),
				atv: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Sie müssen jünger als {0} Jahre alt sein, um sich zu bewerben.',
					_List_fromArray(
						[maxAge])),
				atw: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Sie müssen jünger als {0} Jahre alt sein, um sich zu bewerben.',
					_List_fromArray(
						[maxAge])),
				F_: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'You must be younger than {0} years old to apply.',
					_List_fromArray(
						[maxAge])),
				atJ: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'You must be younger than {0} years old to apply.',
					_List_fromArray(
						[maxAge])),
				n: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'You must be younger than {0} years old to apply.',
					_List_fromArray(
						[maxAge])),
				p: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'You must be younger than {0} years old to apply.',
					_List_fromArray(
						[maxAge])),
				q: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'You must be younger than {0} years old to apply.',
					_List_fromArray(
						[maxAge])),
				r: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'You must be younger than {0} years old to apply.',
					_List_fromArray(
						[maxAge])),
				atK: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'You must be younger than {0} years old to apply.',
					_List_fromArray(
						[maxAge])),
				atM: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Debe ser más joven que {0} Años para aplicar.',
					_List_fromArray(
						[maxAge])),
				atT: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Sinun on oltava alle {0} vuotta vanha hakemaan.',
					_List_fromArray(
						[maxAge])),
				at1: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Vous devez être âgé de moins de {0} ans pour postuler.',
					_List_fromArray(
						[maxAge])),
				at2: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Vous devez être âgé de moins de {0} ans pour postuler.',
					_List_fromArray(
						[maxAge])),
				at3: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Vous devez être âgé de moins de {0} ans pour postuler.',
					_List_fromArray(
						[maxAge])),
				at4: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Vous devez être âgé de moins de {0} ans pour postuler.',
					_List_fromArray(
						[maxAge])),
				aug: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'A jelentkezéshez {0} évnél fiatalabbnak kell lennie.',
					_List_fromArray(
						[maxAge])),
				auO: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Je moet jonger dan {0} jaar oud zijn om te solliciteren.',
					_List_fromArray(
						[maxAge])),
				auP: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Je moet jonger dan {0} jaar oud zijn om te solliciteren.',
					_List_fromArray(
						[maxAge])),
				VA: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Du skal være yngre end {0} år for at ansøge.',
					_List_fromArray(
						[maxAge])),
				avc: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Aby złożyć wniosek, musisz mieć mniej niż {0} lat.',
					_List_fromArray(
						[maxAge])),
				avj: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Você deve ter menos de {0} anos para se inscrever.',
					_List_fromArray(
						[maxAge])),
				avs: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Trebuie să aveți mai puțin de {0} ani pentru a aplica.',
					_List_fromArray(
						[maxAge])),
				avB: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Ak sa chcete prihlásiť, musíte mať menej ako {0} rokov.',
					_List_fromArray(
						[maxAge])),
				avP: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Du måste vara yngre än {0} år för att ansöka.',
					_List_fromArray(
						[maxAge])),
				av5: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Щоб подати заявку, ви маєте бути молодше {0} років.',
					_List_fromArray(
						[maxAge]))
			};
		case 14:
			var minAge = translationKey.a;
			return {
				ats: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Du skal være {0} år for at ansøge.',
					_List_fromArray(
						[minAge])),
				att: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Sie müssen {0} Jahre alt sein, um sich zu bewerben.',
					_List_fromArray(
						[minAge])),
				atu: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Sie müssen {0} Jahre alt sein, um sich zu bewerben.',
					_List_fromArray(
						[minAge])),
				atv: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Sie müssen {0} Jahre alt sein, um sich zu bewerben.',
					_List_fromArray(
						[minAge])),
				atw: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Sie müssen {0} Jahre alt sein, um sich zu bewerben.',
					_List_fromArray(
						[minAge])),
				F_: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'You must be {0} years old to apply.',
					_List_fromArray(
						[minAge])),
				atJ: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'You must be {0} years old to apply.',
					_List_fromArray(
						[minAge])),
				n: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'You must be {0} years old to apply.',
					_List_fromArray(
						[minAge])),
				p: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'You must be {0} years old to apply.',
					_List_fromArray(
						[minAge])),
				q: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'You must be {0} years old to apply.',
					_List_fromArray(
						[minAge])),
				r: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'You must be {0} years old to apply.',
					_List_fromArray(
						[minAge])),
				atK: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'You must be {0} years old to apply.',
					_List_fromArray(
						[minAge])),
				atM: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Debes ser {0} años de edad para aplicar.',
					_List_fromArray(
						[minAge])),
				atT: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Sinun on oltava {0} vuotta vanha hakemaan.',
					_List_fromArray(
						[minAge])),
				at1: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Vous devez avoir plus de {0} ans.',
					_List_fromArray(
						[minAge])),
				at2: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Vous devez avoir plus de {0} ans.',
					_List_fromArray(
						[minAge])),
				at3: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Vous devez avoir plus de {0} ans.',
					_List_fromArray(
						[minAge])),
				at4: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Vous devez avoir plus de {0} ans.',
					_List_fromArray(
						[minAge])),
				aug: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'A jelentkezéshez {0} évesnek kell lennie.',
					_List_fromArray(
						[minAge])),
				auO: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Je moet ouder zijn dan {0} jaar oud.',
					_List_fromArray(
						[minAge])),
				auP: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Je moet ouder zijn dan {0} jaar oud.',
					_List_fromArray(
						[minAge])),
				VA: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Du må være {0} år gammel for å søke.',
					_List_fromArray(
						[minAge])),
				avc: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Aby złożyć wniosek, musisz mieć ukończone {0} lat.',
					_List_fromArray(
						[minAge])),
				avj: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Você deve ter mais de {0} anos.',
					_List_fromArray(
						[minAge])),
				avs: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Trebuie să aveți {0} ani pentru a aplica.',
					_List_fromArray(
						[minAge])),
				avB: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Ak chcete podať žiadosť, musíte mať {0} rokov.',
					_List_fromArray(
						[minAge])),
				avP: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Du måste vara {0} år för att ansöka.',
					_List_fromArray(
						[minAge])),
				av5: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Щоб подати заявку, вам має бути {0} років.',
					_List_fromArray(
						[minAge]))
			};
		case 16:
			var age = translationKey.a;
			var minAge = translationKey.b;
			var nl = A2(
				$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
				'Ongeldige leeftijd: {0}. De mimimum leeftijd is: {1}.',
				_List_fromArray(
					[
						$elm$core$String$fromInt(age),
						$elm$core$String$fromInt(minAge)
					]));
			var hu = A2(
				$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
				'Érvénytelen életkor: {0}. A minimális életkor: {1}.',
				_List_fromArray(
					[
						$elm$core$String$fromInt(age),
						$elm$core$String$fromInt(minAge)
					]));
			var fr = A2(
				$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
				'Âge non valide: {0}. L\'âge minimum est: {1}.',
				_List_fromArray(
					[
						$elm$core$String$fromInt(age),
						$elm$core$String$fromInt(minAge)
					]));
			var en = A2(
				$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
				'invalid age: {0}. The minimum age is: {1}.',
				_List_fromArray(
					[
						$elm$core$String$fromInt(age),
						$elm$core$String$fromInt(minAge)
					]));
			var de = A2(
				$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
				'Ungültiges Alter: {0}. Das Mindestalter beträgt: {1}.',
				_List_fromArray(
					[
						$elm$core$String$fromInt(age),
						$elm$core$String$fromInt(minAge)
					]));
			return {
				ats: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Ugyldig alder: {0}. Minimumsalderen er: {1}.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(age),
							$elm$core$String$fromInt(minAge)
						])),
				att: de,
				atu: de,
				atv: de,
				atw: de,
				F_: en,
				atJ: en,
				n: en,
				p: en,
				q: en,
				r: en,
				atK: en,
				atM: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Edad no válida: {0}. La edad mínima es: {1}.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(age),
							$elm$core$String$fromInt(minAge)
						])),
				atT: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Virheellinen ikä: {0}. Alaikäraja on: {1}.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(age),
							$elm$core$String$fromInt(minAge)
						])),
				at1: fr,
				at2: fr,
				at3: fr,
				at4: fr,
				aug: hu,
				auO: nl,
				auP: nl,
				VA: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Ugyldig alder: {0}. Minimumsalderen er: {1}.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(age),
							$elm$core$String$fromInt(minAge)
						])),
				avc: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Nieprawidłowy wiek: {0}. Minimalny wiek to: {1}.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(age),
							$elm$core$String$fromInt(minAge)
						])),
				avj: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Idade inválida: {0}. A idade mínima é: {1}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(age),
							$elm$core$String$fromInt(minAge)
						])),
				avs: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'vârstă nevalidă: {0}. Vârsta minimă este: {1}.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(age),
							$elm$core$String$fromInt(minAge)
						])),
				avB: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'neplatný vek: {0}. Minimálny vek je: {1}.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(age),
							$elm$core$String$fromInt(minAge)
						])),
				avP: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Ogiltig ålder: {0}. Minimiåldern är: {1}.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(age),
							$elm$core$String$fromInt(minAge)
						])),
				av5: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'недійсний вік: {0}. Мінімальний вік: {1}.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(age),
							$elm$core$String$fromInt(minAge)
						]))
			};
		case 17:
			var hours = translationKey.a;
			var minHours = translationKey.b;
			var nl = A2(
				$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
				'Ongeldig aantal uren: {0}. Het minimum aantal uur is {1}.',
				_List_fromArray(
					[
						$elm$core$String$fromInt(hours),
						$elm$core$String$fromInt(minHours)
					]));
			var hu = A2(
				$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
				'Érvénytelen óraszám: {0}. A minimális óraszám: {1}.',
				_List_fromArray(
					[
						$elm$core$String$fromInt(hours),
						$elm$core$String$fromInt(minHours)
					]));
			var fr = A2(
				$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
				'Nombre d\'heures non valide: {0}. Le nombre d\'heures minimum est de {1}.',
				_List_fromArray(
					[
						$elm$core$String$fromInt(hours),
						$elm$core$String$fromInt(minHours)
					]));
			var en = A2(
				$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
				'Invalid amount of hours: {0}. The minimum amount of hours is: {1}.',
				_List_fromArray(
					[
						$elm$core$String$fromInt(hours),
						$elm$core$String$fromInt(minHours)
					]));
			var de = A2(
				$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
				'Ungültige Stundenanzahl: {0}. Die Mindeststundenzahl beträgt {1}.',
				_List_fromArray(
					[
						$elm$core$String$fromInt(hours),
						$elm$core$String$fromInt(minHours)
					]));
			return {
				ats: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Ugyldigt antal timer: {0}. Minimumsantallet af timer er {1}.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(hours),
							$elm$core$String$fromInt(minHours)
						])),
				att: de,
				atu: de,
				atv: de,
				atw: de,
				F_: en,
				atJ: en,
				n: en,
				p: en,
				q: en,
				r: en,
				atK: en,
				atM: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Número de horas no válido: {0}. El número mínimo de horas es {1}.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(hours),
							$elm$core$String$fromInt(minHours)
						])),
				atT: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Virheellinen tuntimäärä: {0}. Tuntien vähimmäismäärä on {1}.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(hours),
							$elm$core$String$fromInt(minHours)
						])),
				at1: fr,
				at2: fr,
				at3: fr,
				at4: fr,
				aug: hu,
				auO: nl,
				auP: nl,
				VA: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Ugyldig antall timer: {0}. Minste antall timer er {1}.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(hours),
							$elm$core$String$fromInt(minHours)
						])),
				avc: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Nieprawidłowa liczba godzin: {0}. Minimalna liczba godzin to {1}.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(hours),
							$elm$core$String$fromInt(minHours)
						])),
				avj: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Número de horas inválido: {0}. O número mínimo de horas é {1}.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(hours),
							$elm$core$String$fromInt(minHours)
						])),
				avs: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Număr de ore nevalid: {0}. Cantitatea minimă de ore este: {1}.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(hours),
							$elm$core$String$fromInt(minHours)
						])),
				avB: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Neplatný počet hodín: {0}. Minimálny počet hodín je: {1}.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(hours),
							$elm$core$String$fromInt(minHours)
						])),
				avP: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Ogiltigt antal timmar: {0}. Minsta antal timmar är {1}.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(hours),
							$elm$core$String$fromInt(minHours)
						])),
				av5: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Недійсна кількість годин: {0}. Мінімальна кількість годин становить {1}.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(hours),
							$elm$core$String$fromInt(minHours)
						]))
			};
		default:
			var filterName = translationKey.a;
			var nl = A2(
				$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
				'Onder {0} zijn reeds de volgende vacaturekenmerken aanwezig:',
				_List_fromArray(
					[filterName]));
			var hu = A2(
				$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
				'A(z) {0} alatt már szerepelnek a következő állásjellemzők:',
				_List_fromArray(
					[filterName]));
			var fr = A2(
				$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
				'Les caractéristiques de poste vacant suivantes sont déjà présentes sous {0} :',
				_List_fromArray(
					[filterName]));
			var en = A2(
				$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
				'The following vacancy characteristics are already present under {0}:',
				_List_fromArray(
					[filterName]));
			var de = A2(
				$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
				'Folgende Leerstandsmerkmale sind bereits unter {0} vorhanden:',
				_List_fromArray(
					[filterName]));
			return {
				ats: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Følgende stillingskarakteristika er allerede til stede under {0}:',
					_List_fromArray(
						[filterName])),
				att: de,
				atu: de,
				atv: de,
				atw: de,
				F_: en,
				atJ: en,
				n: en,
				p: en,
				q: en,
				r: en,
				atK: en,
				atM: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Las siguientes características de vacante ya están presentes en {0}:',
					_List_fromArray(
						[filterName])),
				atT: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Seuraavat avoimet ominaisuudet ovat jo olemassa {0} ssa:',
					_List_fromArray(
						[filterName])),
				at1: fr,
				at2: fr,
				at3: fr,
				at4: fr,
				aug: hu,
				auO: nl,
				auP: nl,
				VA: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Følgende stillingsegenskaper finnes allerede under {0}:',
					_List_fromArray(
						[filterName])),
				avc: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Następujące cechy wakatów są już obecne w obszarze {0}:',
					_List_fromArray(
						[filterName])),
				avj: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'As seguintes características da vaga já estão presentes em {0}:',
					_List_fromArray(
						[filterName])),
				avs: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Următoarele caracteristici ale postului vacant sunt deja prezente sub {0}:',
					_List_fromArray(
						[filterName])),
				avB: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Nasledujúce charakteristiky voľných pracovných miest sa už nachádzajú pod {0}:',
					_List_fromArray(
						[filterName])),
				avP: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Följande lediga tjänster finns redan under {0}:',
					_List_fromArray(
						[filterName])),
				av5: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Наступні характеристики вакансії вже присутні в {0}:',
					_List_fromArray(
						[filterName]))
			};
	}
};
var $author$project$Util$Translation$translate = function () {
	var _v0 = $author$project$Copy$language;
	switch (_v0) {
		case 1:
			return A2(
				$elm$core$Basics$composeL,
				function ($) {
					return $.att;
				},
				$author$project$Util$Translation$translation);
		case 2:
			return A2(
				$elm$core$Basics$composeL,
				function ($) {
					return $.atu;
				},
				$author$project$Util$Translation$translation);
		case 3:
			return A2(
				$elm$core$Basics$composeL,
				function ($) {
					return $.atv;
				},
				$author$project$Util$Translation$translation);
		case 4:
			return A2(
				$elm$core$Basics$composeL,
				function ($) {
					return $.atw;
				},
				$author$project$Util$Translation$translation);
		case 0:
			return A2(
				$elm$core$Basics$composeL,
				function ($) {
					return $.ats;
				},
				$author$project$Util$Translation$translation);
		case 5:
			return A2(
				$elm$core$Basics$composeL,
				function ($) {
					return $.F_;
				},
				$author$project$Util$Translation$translation);
		case 6:
			return A2(
				$elm$core$Basics$composeL,
				function ($) {
					return $.atJ;
				},
				$author$project$Util$Translation$translation);
		case 7:
			return A2(
				$elm$core$Basics$composeL,
				function ($) {
					return $.n;
				},
				$author$project$Util$Translation$translation);
		case 8:
			return A2(
				$elm$core$Basics$composeL,
				function ($) {
					return $.atK;
				},
				$author$project$Util$Translation$translation);
		case 9:
			return A2(
				$elm$core$Basics$composeL,
				function ($) {
					return $.atM;
				},
				$author$project$Util$Translation$translation);
		case 10:
			return A2(
				$elm$core$Basics$composeL,
				function ($) {
					return $.atT;
				},
				$author$project$Util$Translation$translation);
		case 11:
			return A2(
				$elm$core$Basics$composeL,
				function ($) {
					return $.at1;
				},
				$author$project$Util$Translation$translation);
		case 13:
			return A2(
				$elm$core$Basics$composeL,
				function ($) {
					return $.at3;
				},
				$author$project$Util$Translation$translation);
		case 12:
			return A2(
				$elm$core$Basics$composeL,
				function ($) {
					return $.at2;
				},
				$author$project$Util$Translation$translation);
		case 14:
			return A2(
				$elm$core$Basics$composeL,
				function ($) {
					return $.at4;
				},
				$author$project$Util$Translation$translation);
		case 15:
			return A2(
				$elm$core$Basics$composeL,
				function ($) {
					return $.aug;
				},
				$author$project$Util$Translation$translation);
		case 16:
			return A2(
				$elm$core$Basics$composeL,
				function ($) {
					return $.auO;
				},
				$author$project$Util$Translation$translation);
		case 17:
			return A2(
				$elm$core$Basics$composeL,
				function ($) {
					return $.auP;
				},
				$author$project$Util$Translation$translation);
		case 18:
			return A2(
				$elm$core$Basics$composeL,
				function ($) {
					return $.VA;
				},
				$author$project$Util$Translation$translation);
		case 19:
			return A2(
				$elm$core$Basics$composeL,
				function ($) {
					return $.avc;
				},
				$author$project$Util$Translation$translation);
		case 20:
			return A2(
				$elm$core$Basics$composeL,
				function ($) {
					return $.avj;
				},
				$author$project$Util$Translation$translation);
		case 21:
			return A2(
				$elm$core$Basics$composeL,
				function ($) {
					return $.avs;
				},
				$author$project$Util$Translation$translation);
		case 22:
			return A2(
				$elm$core$Basics$composeL,
				function ($) {
					return $.avB;
				},
				$author$project$Util$Translation$translation);
		case 23:
			return A2(
				$elm$core$Basics$composeL,
				function ($) {
					return $.avP;
				},
				$author$project$Util$Translation$translation);
		default:
			return A2(
				$elm$core$Basics$composeL,
				function ($) {
					return $.av5;
				},
				$author$project$Util$Translation$translation);
	}
}();
var $author$project$ShareToolForm$viewPreview = F3(
	function (translations, msg, mediaItem) {
		var file = mediaItem.HC;
		var preview = mediaItem.$V;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('share-tool-form__preview')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('img-container'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'error',
									!$author$project$ShareToolForm$mediaItemAccepted(mediaItem))
								]))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$src(preview.dF)
								]),
							_List_Nil),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('img-container__banner bg-color-1 color-white')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$elm$file$File$name(file))
										])),
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$type_('button'),
											$elm$html$Html$Attributes$class('btn color-white'),
											$elm$html$Html$Events$onClick(msg)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('＋')
										]))
								]))
						])),
					A2(
					$author$project$Util$View$viewIf,
					!$author$project$ShareToolForm$mediaItemAccepted(mediaItem),
					function (_v0) {
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('error-overlay'),
									$elm$html$Html$Events$onClick(msg)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Util$Translation$translate(
												$author$project$Util$Translation$FileTooBig(preview.cA.b)))
										])),
									$author$project$View$Icon$viewColored($author$project$View$Icon$path.au_),
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											A2($author$project$Data$Translation$text, translations, $author$project$Model$Translation$clickToRemove)
										]))
								]));
					})
				]));
	});
var $author$project$ShareToolForm$viewPreviews = F4(
	function (translations, form, toMsg, previews) {
		var translate = $author$project$Data$Translation$toString(translations);
		var removePreview = function (index) {
			return _Utils_update(
				form,
				{
					SP: $elm$core$Maybe$Just(
						A2($author$project$Util$List$removeByIndex, index, previews))
				});
		};
		return (_Utils_cmp(
			$author$project$ShareToolForm$toTotalRequestSize(previews),
			$author$project$ShareToolForm$maxRequestSize.a) > -1) ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('share-tool__request-too-big')
				]),
			_List_fromArray(
				[
					$author$project$Component$Message$view(
					{
						dn: translate($author$project$Model$Translation$maxRequestSizeExceededDescription),
						e_: $elm$core$Maybe$Just(
							A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$type_('button'),
										$elm$html$Html$Attributes$class('btn btn-submit bg-color-1 color-white'),
										$elm$html$Html$Events$onClick($author$project$ShareToolForm$RedoSelectFiles)
									]),
								_List_fromArray(
									[
										A2($author$project$Data$Translation$text, translations, $author$project$Model$Translation$browseMedia)
									]))),
						avV: translate($author$project$Model$Translation$maxRequestSizeExceededTitle)
					})
				])) : A2(
			$elm$html$Html$ul,
			_List_Nil,
			A2(
				$elm$core$List$indexedMap,
				F2(
					function (index, preview) {
						return A3(
							$author$project$ShareToolForm$viewPreview,
							translations,
							toMsg(
								removePreview(index)),
							preview);
					}),
				previews));
	});
var $author$project$ShareToolForm$viewMediaUploads = F4(
	function (translations, form, toMsg, toError) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('share-tool__container')
				]),
			_List_fromArray(
				[
					A3(
					$author$project$Component$Form$Input$viewFormField,
					'',
					toError('media'),
					A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h4,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('share-tool-form__step-title')
									]),
								_List_fromArray(
									[
										A2($author$project$Data$Translation$text, translations, $author$project$Model$Translation$uploadPageStep1)
									])),
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('share-tool-form__step-description')
									]),
								_List_fromArray(
									[
										A2($author$project$Data$Translation$text, translations, $author$project$Model$Translation$uploadPageMediaLabel)
									])),
								A2(
								$author$project$Util$View$viewMaybe,
								form.SP,
								A3($author$project$ShareToolForm$viewPreviews, translations, form, toMsg)),
								A2($author$project$ShareToolForm$viewBrowseMediaButton, translations, form.SP)
							])))
				]));
	});
var $elm$html$Html$Attributes$disabled = $elm$html$Html$Attributes$boolProperty('disabled');
var $author$project$Model$Translation$submit = 'submit';
var $author$project$ShareToolForm$viewSubmitButton = F3(
	function (translations, maybeLoading, isDisabled) {
		var classes = _List_fromArray(
			[
				_Utils_Tuple2(
				'loading',
				$elm_community$maybe_extra$Maybe$Extra$isJust(maybeLoading)),
				_Utils_Tuple2('btn btn-submit bg-color-1 color-white', true)
			]);
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$type_('submit'),
					$elm$html$Html$Attributes$classList(classes),
					$elm$html$Html$Attributes$disabled(isDisabled)
				]),
			_List_fromArray(
				[
					A2($author$project$Data$Translation$text, translations, $author$project$Model$Translation$submit),
					A2(
					$author$project$Util$View$viewMaybe,
					maybeLoading,
					function (progress) {
						return A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('share-tool-form__progress-bar'),
									A2(
									$elm$html$Html$Attributes$style,
									'width',
									A2(
										$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
										'{0}%',
										_List_fromArray(
											[
												$elm$core$String$fromFloat(100 * progress)
											])))
								]),
							_List_Nil);
					})
				]));
	});
var $author$project$Model$Translation$uploadPageStep2 = 'upload-page-step2';
var $author$project$Model$Translation$uploadPageTagsLabel = 'upload-page-tags-label';
var $elm$html$Html$Attributes$for = $elm$html$Html$Attributes$stringProperty('htmlFor');
var $elm$html$Html$Events$targetChecked = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'checked']),
	$elm$json$Json$Decode$bool);
var $elm$html$Html$Events$onCheck = function (tagger) {
	return A2(
		$elm$html$Html$Events$on,
		'change',
		A2($elm$json$Json$Decode$map, tagger, $elm$html$Html$Events$targetChecked));
};
var $author$project$ShareToolForm$viewTag = F3(
	function (form, toMsg, _v0) {
		var tagId = _v0.a;
		var tag = _v0.b;
		var toSelectedTagIds = function (checked) {
			return checked ? A2($elm$core$List$cons, tagId, form.fQ) : A2(
				$elm$core$List$filter,
				$elm$core$Basics$neq(tagId),
				form.fQ);
		};
		var isChecked = A2($elm$core$List$member, tagId, form.fQ);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('share-tool-form__tag')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('checkbox'),
							$elm$html$Html$Attributes$class('form-checkbox'),
							$elm$html$Html$Attributes$id(tag.bO),
							$elm$html$Html$Attributes$name(tag.bO),
							$elm$html$Html$Attributes$checked(isChecked),
							$elm$html$Html$Events$onCheck(
							A2(
								$elm$core$Basics$composeL,
								toMsg,
								function (v) {
									return _Utils_update(
										form,
										{
											fQ: toSelectedTagIds(v)
										});
								}))
						]),
					_List_Nil),
					A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$for(tag.bO)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(tag.bO)
						]))
				]));
	});
var $author$project$ShareToolForm$viewTags = F5(
	function (translations, tags, form, toMsg, toError) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('share-tool__container share-tool-form__tags-field')
				]),
			_List_fromArray(
				[
					A3(
					$author$project$Component$Form$Input$viewFormField,
					'',
					toError('tagIds'),
					A2(
						$elm$html$Html$div,
						_List_Nil,
						_Utils_ap(
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h4,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('share-tool-form__step-title')
										]),
									_List_fromArray(
										[
											A2($author$project$Data$Translation$text, translations, $author$project$Model$Translation$uploadPageStep2)
										])),
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('share-tool-form__step-description')
										]),
									_List_fromArray(
										[
											A2($author$project$Data$Translation$text, translations, $author$project$Model$Translation$uploadPageTagsLabel)
										]))
								]),
							A2(
								$elm$core$List$map,
								A2($author$project$ShareToolForm$viewTag, form, toMsg),
								tags))))
				]));
	});
var $author$project$ShareToolForm$view = function (model) {
	var _v0 = model.ap;
	var form = _v0.a;
	var errorResponse = _v0.b;
	var toError = function (key) {
		if (!errorResponse.$) {
			var validationErrors = errorResponse.a;
			return A2(
				$elm$core$Maybe$andThen,
				$elm$core$Dict$get(
					$author$project$Util$LangCode$toString(model.bE)),
				A2($elm$core$Dict$get, key, validationErrors.atU));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	};
	var updateField = function (f) {
		return $author$project$ShareToolForm$UpdateEmployeeContentForm(
			_Utils_Tuple2(f, errorResponse));
	};
	var allowSubmit = form.sq && ($author$project$ShareToolForm$mediaAccepted(form.SP) && $author$project$ShareToolForm$requestSizeAccepted(form.SP));
	return A2(
		$elm$html$Html$form,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('form share-tool-form'),
				$elm$html$Html$Events$onSubmit($author$project$ShareToolForm$CreateEmployeeContent)
			]),
		_List_fromArray(
			[
				A4($author$project$ShareToolForm$viewMediaUploads, model.anB, form, updateField, toError),
				A5($author$project$ShareToolForm$viewTags, model.anB, model.aln, form, updateField, toError),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('share-tool__container')
					]),
				_List_fromArray(
					[
						A3($author$project$ShareToolForm$viewCaption, model.anB, form, updateField),
						A3($author$project$ShareToolForm$viewConsent, model.anB, form, updateField),
						A3($author$project$ShareToolForm$viewSubmitButton, model.anB, model.cU, !allowSubmit)
					]))
			]));
};
var $author$project$ShareToolForm$main = A2(
	$author$project$Browser$Custom$elementWithFlags,
	$author$project$ShareToolForm$decodeFlags,
	{dH: $author$project$ShareToolForm$init, em: $author$project$ShareToolForm$subscriptions, ex: $author$project$ShareToolForm$update, ez: $author$project$ShareToolForm$view});
var $author$project$ShareToolEmployeeContentCollection$Flags = F4(
	function (employee, tags, translations, timeZoneOffset) {
		return {FI: employee, aln: tags, amW: timeZoneOffset, anB: translations};
	});
var $author$project$Model$Employee$Employee = function (employeeNumber) {
	return function (identifier) {
		return function (firstName) {
			return function (lastName) {
				return function (country) {
					return function (preferredLanguage) {
						return function (_function) {
							return function (storeNumber) {
								return function (regionName) {
									return function (locationType) {
										return {w5: country, FS: employeeNumber, Ip: firstName, KM: _function, aui: identifier, Qx: lastName, RB: locationType, $R: preferredLanguage, acz: regionName, aj7: storeNumber};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Model$Employee$employeeDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'employeeLocationType',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'employeeRegionName',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'employeeStoreNumber',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'employeeFunction',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'employeePreferredLanguage',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'employeeCountry',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'employeeLastName',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'employeeFirstName',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'employeeIdentifier',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'employeeEmployeeNumber',
										$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
										$elm$json$Json$Decode$succeed($author$project$Model$Employee$Employee)))))))))));
var $author$project$ShareToolEmployeeContentCollection$decodeFlags = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'timeZoneOffset',
	$elm$json$Json$Decode$int,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Data$Translation$translationsDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'tags',
			$elm$json$Json$Decode$list(
				$author$project$Data$Entity$decoder($author$project$Model$ShareToolTag$shareToolTagDecoder)),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'employee',
				$author$project$Model$Employee$employeeDecoder,
				$elm$json$Json$Decode$succeed($author$project$ShareToolEmployeeContentCollection$Flags)))));
var $author$project$ShareToolEmployeeContentCollection$GotEmployeeContentStatus = function (a) {
	return {$: 3, a: a};
};
var $author$project$Data$Status$Loading = {$: 1};
var $elm$time$Time$Zone = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$time$Time$customZone = $elm$time$Time$Zone;
var $author$project$Component$Notifications$Notifications = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Component$Notifications$emptyNotifications = A2($author$project$Component$Notifications$Notifications, 0, _List_Nil);
var $author$project$Model$EmployeeContentResponse$EmployeeContentResponse = F3(
	function (employeeEntity, employeeContentUploads, employeeContentEntity) {
		return {FM: employeeContentEntity, FO: employeeContentUploads, FP: employeeEntity};
	});
var $author$project$Model$EmployeeContent$EmployeeContent = F8(
	function (employeeId, uploads, caption, feedback, status, live, inserted, updated) {
		return {pM: caption, FQ: employeeId, Hp: feedback, e6: inserted, Ro: live, fL: status, fY: updated, ape: uploads};
	});
var $author$project$Model$EmployeeContent$Approved = 2;
var $author$project$Model$EmployeeContent$Honors = 3;
var $author$project$Model$EmployeeContent$Pending = 0;
var $author$project$Model$EmployeeContent$Retry = 1;
var $author$project$Model$EmployeeContent$employeeContentStatusDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'pending':
				return $elm$json$Json$Decode$succeed(0);
			case 'retry':
				return $elm$json$Json$Decode$succeed(1);
			case 'approved':
				return $elm$json$Json$Decode$succeed(2);
			case 'honors':
				return $elm$json$Json$Decode$succeed(3);
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Model$EmployeeContent$employeeContentDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'employeeContentUpdated',
	$elm$json$Json$Decode$nullable($rtfeldman$elm_iso8601_date_strings$Iso8601$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'employeeContentInserted',
		$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'employeeContentLive',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'employeeContentStatus',
				$author$project$Model$EmployeeContent$employeeContentStatusDecoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'employeeContentFeedback',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'employeeContentCaption',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'employeeContentUploads',
							$elm$json$Json$Decode$list($author$project$Data$Id$decoder),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'employeeContentEmployeeId',
								$author$project$Data$Id$decoder,
								$elm$json$Json$Decode$succeed($author$project$Model$EmployeeContent$EmployeeContent)))))))));
var $author$project$Model$ShareToolUpload$ShareToolUpload = F4(
	function (fileName, inserted, updated, deleted) {
		return {zq: deleted, HH: fileName, e6: inserted, fY: updated};
	});
var $author$project$Model$ShareToolUpload$shareToolUploadDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'shareToolUploadDeleted',
	$elm$json$Json$Decode$nullable($rtfeldman$elm_iso8601_date_strings$Iso8601$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'shareToolUploadUpdated',
		$elm$json$Json$Decode$nullable($rtfeldman$elm_iso8601_date_strings$Iso8601$decoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'shareToolUploadInserted',
			$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'shareToolUploadFileName',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Model$ShareToolUpload$ShareToolUpload)))));
var $author$project$Model$EmployeeContentResponse$employeeContentResponseDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'employeeContentEntity',
	$author$project$Data$Entity$decoder($author$project$Model$EmployeeContent$employeeContentDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'employeeContentUploads',
		$elm$json$Json$Decode$list(
			A3(
				$elm$json$Json$Decode$map2,
				$elm$core$Tuple$pair,
				A2(
					$elm$json$Json$Decode$index,
					0,
					$author$project$Data$Entity$decoder($author$project$Model$ShareToolUpload$shareToolUploadDecoder)),
				A2($elm$json$Json$Decode$index, 1, $elm$json$Json$Decode$string))),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'employeeEntity',
			$author$project$Data$Entity$decoder($author$project$Model$Employee$employeeDecoder),
			$elm$json$Json$Decode$succeed($author$project$Model$EmployeeContentResponse$EmployeeContentResponse))));
var $NoRedInk$http_upgrade_shim$Http$Legacy$emptyBody = $elm$http$Http$emptyBody;
var $NoRedInk$http_upgrade_shim$Http$Legacy$BadPayload = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $NoRedInk$http_upgrade_shim$Http$Legacy$combine = function (result) {
	if (!result.$) {
		var x = result.a;
		return x;
	} else {
		var x = result.a;
		return x;
	}
};
var $NoRedInk$http_upgrade_shim$Http$Legacy$BadStatus = function (a) {
	return {$: 3, a: a};
};
var $NoRedInk$http_upgrade_shim$Http$Legacy$BadUrl = function (a) {
	return {$: 0, a: a};
};
var $NoRedInk$http_upgrade_shim$Http$Legacy$NetworkError = {$: 2};
var $NoRedInk$http_upgrade_shim$Http$Legacy$Timeout = {$: 1};
var $NoRedInk$http_upgrade_shim$Http$Legacy$metadataAndBodyToResponse = F2(
	function (meta, body) {
		return {
			_: body,
			ax: meta.ax,
			fL: {eN: meta.avE, bT: meta.avF},
			a0: meta.a0
		};
	});
var $NoRedInk$http_upgrade_shim$Http$Legacy$fromHttpResponse = function (response) {
	switch (response.$) {
		case 0:
			var url = response.a;
			return $elm$core$Result$Err(
				$NoRedInk$http_upgrade_shim$Http$Legacy$BadUrl(url));
		case 1:
			return $elm$core$Result$Err($NoRedInk$http_upgrade_shim$Http$Legacy$Timeout);
		case 2:
			return $elm$core$Result$Err($NoRedInk$http_upgrade_shim$Http$Legacy$NetworkError);
		case 3:
			var meta = response.a;
			var body = response.b;
			return $elm$core$Result$Err(
				$NoRedInk$http_upgrade_shim$Http$Legacy$BadStatus(
					A2($NoRedInk$http_upgrade_shim$Http$Legacy$metadataAndBodyToResponse, meta, body)));
		default:
			var meta = response.a;
			var body = response.b;
			return $elm$core$Result$Ok(
				A2($NoRedInk$http_upgrade_shim$Http$Legacy$metadataAndBodyToResponse, meta, body));
	}
};
var $NoRedInk$http_upgrade_shim$Http$Legacy$expectJson = function (decoder) {
	return {
		bF: function (response) {
			return A2(
				$elm$core$Result$mapError,
				function (err) {
					return A2(
						$NoRedInk$http_upgrade_shim$Http$Legacy$BadPayload,
						$elm$json$Json$Decode$errorToString(err),
						response);
				},
				A2($elm$json$Json$Decode$decodeString, decoder, response._));
		},
		aH: A2(
			$elm$http$Http$expectStringResponse,
			A2($elm$core$Basics$composeL, $NoRedInk$http_upgrade_shim$Http$Legacy$fromHttpResponse, $NoRedInk$http_upgrade_shim$Http$Legacy$combine),
			$elm$core$Result$Ok)
	};
};
var $NoRedInk$http_upgrade_shim$Http$Legacy$request = $elm$core$Basics$identity;
var $author$project$Api$Endpoint$requestLegacy = function (config) {
	var _v0 = config.a0;
	var url = _v0;
	return $NoRedInk$http_upgrade_shim$Http$Legacy$request(
		{_: config._, aH: config.aH, ax: config.ax, aO: config.aO, a_: config.a_, a0: url, bx: config.bx});
};
var $author$project$Api$requestJson = F4(
	function (method, url, body, decoder) {
		return $author$project$Api$Endpoint$requestLegacy(
			{
				_: body,
				aH: $NoRedInk$http_upgrade_shim$Http$Legacy$expectJson(decoder),
				ax: _List_Nil,
				aO: method,
				a_: $elm$core$Maybe$Nothing,
				a0: url,
				bx: false
			});
	});
var $author$project$Api$get = function (url) {
	return A3($author$project$Api$requestJson, 'GET', url, $NoRedInk$http_upgrade_shim$Http$Legacy$emptyBody);
};
var $author$project$Api$Endpoint$Endpoint = $elm$core$Basics$identity;
var $author$project$Api$Endpoint$endpoint = function (segments) {
	return A2(
		$elm$url$Url$Builder$absolute,
		A2($elm$core$List$cons, 'api', segments),
		_List_Nil);
};
var $author$project$Api$Endpoint$personalEmployeeContentCollection = $author$project$Api$Endpoint$endpoint(
	_List_fromArray(
		['share', 'uploads']));
var $author$project$Data$EmployeeContent$getPersonalCollection = A2(
	$author$project$Api$get,
	$author$project$Api$Endpoint$personalEmployeeContentCollection,
	$elm$json$Json$Decode$list($author$project$Model$EmployeeContentResponse$employeeContentResponseDecoder));
var $author$project$Component$Modal$Confirm$Hidden = {$: 1};
var $author$project$Component$Modal$Confirm$hidden = $author$project$Component$Modal$Confirm$Hidden;
var $author$project$Api$httpLegacyToHttpError = function (err) {
	switch (err.$) {
		case 3:
			var body = err.a._;
			var status = err.a.fL;
			return A2($author$project$Api$BadStatus, status.eN, body);
		case 0:
			var url = err.a;
			return $author$project$Api$BadUrl(url);
		case 1:
			return $author$project$Api$Timeout;
		case 2:
			return $author$project$Api$NetworkError;
		default:
			var error = err.a;
			return $author$project$Api$DecodeError(error);
	}
};
var $elm$core$Result$andThen = F2(
	function (callback, result) {
		if (!result.$) {
			var value = result.a;
			return callback(value);
		} else {
			var msg = result.a;
			return $elm$core$Result$Err(msg);
		}
	});
var $elm$http$Http$riskyRequest = function (r) {
	return $elm$http$Http$command(
		$elm$http$Http$Request(
			{as_: true, _: r._, aH: r.aH, ax: r.ax, aO: r.aO, a_: r.a_, av3: r.av3, a0: r.a0}));
};
var $NoRedInk$http_upgrade_shim$Http$Legacy$send = F2(
	function (callback, _v0) {
		var method = _v0.aO;
		var headers = _v0.ax;
		var url = _v0.a0;
		var body = _v0._;
		var expect = _v0.aH;
		var timeout = _v0.a_;
		var withCredentials = _v0.bx;
		var request_ = {_: body, aH: expect.aH, ax: headers, aO: method, a_: timeout, av3: $elm$core$Maybe$Nothing, a0: url};
		var handleResponse = function (response) {
			return callback(
				A2($elm$core$Result$andThen, expect.bF, response));
		};
		return A2(
			$elm$core$Platform$Cmd$map,
			handleResponse,
			withCredentials ? $elm$http$Http$riskyRequest(request_) : $elm$http$Http$request(request_));
	});
var $author$project$Api$send = function (msg) {
	return $NoRedInk$http_upgrade_shim$Http$Legacy$send(
		A2(
			$elm$core$Basics$composeL,
			msg,
			$elm$core$Result$mapError($author$project$Api$httpLegacyToHttpError)));
};
var $author$project$ShareToolEmployeeContentCollection$init = function (flags) {
	return _Utils_Tuple2(
		{
			cZ: $elm$core$Maybe$Nothing,
			sb: $author$project$Component$Modal$Confirm$hidden,
			FI: flags.FI,
			FJ: $author$project$Data$Status$Loading,
			Xf: $author$project$Component$Notifications$emptyNotifications,
			aln: flags.aln,
			fS: A2($elm$time$Time$customZone, flags.amW, _List_Nil),
			anB: flags.anB
		},
		A2($author$project$Api$send, $author$project$ShareToolEmployeeContentCollection$GotEmployeeContentStatus, $author$project$Data$EmployeeContent$getPersonalCollection));
};
var $author$project$ShareToolEmployeeContentCollection$DeleteEmployeeContent = function (a) {
	return {$: 1, a: a};
};
var $author$project$ShareToolEmployeeContentCollection$UpdateConfirmDelete = function (a) {
	return {$: 4, a: a};
};
var $author$project$ShareToolEmployeeContentCollection$confirmDeleteConfig = {
	_: $elm$core$Basics$always($author$project$Copy$copy.kU),
	sa: $elm$core$Maybe$Nothing,
	Mm: $elm$core$Basics$always($author$project$Copy$copy.atC),
	bf: $author$project$ShareToolEmployeeContentCollection$UpdateConfirmDelete,
	X0: $author$project$ShareToolEmployeeContentCollection$DeleteEmployeeContent
};
var $author$project$Component$Modal$Confirm$Close = {$: 2};
var $author$project$Component$Modal$Confirm$subscriptions = F2(
	function (config, confirm) {
		if (confirm.$ === 1) {
			return $elm$core$Platform$Sub$none;
		} else {
			return $elm$browser$Browser$Events$onKeyDown(
				A2(
					$author$project$Keyboard$matchKey,
					'Escape',
					config.bf($author$project$Component$Modal$Confirm$Close)));
		}
	});
var $author$project$ShareToolEmployeeContentCollection$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2($author$project$Component$Modal$Confirm$subscriptions, $author$project$ShareToolEmployeeContentCollection$confirmDeleteConfig, model.sb)
			]));
};
var $author$project$ShareToolEmployeeContentCollection$DeleteToastById = function (a) {
	return {$: 5, a: a};
};
var $author$project$ShareToolEmployeeContentCollection$GotDeleteEmployeeContent = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$delete = $author$project$Api$requestJson('DELETE');
var $author$project$Api$Endpoint$employeeContent = function (contentId) {
	return $author$project$Api$Endpoint$endpoint(
		_List_fromArray(
			[
				'employee-content',
				$author$project$Data$Id$toString(contentId)
			]));
};
var $author$project$Data$EmployeeContent$delete = function (contentId) {
	return A3(
		$author$project$Api$delete,
		$author$project$Api$Endpoint$employeeContent(contentId),
		$NoRedInk$http_upgrade_shim$Http$Legacy$emptyBody,
		$elm$json$Json$Decode$succeed(0));
};
var $author$project$Data$Status$Failure = function (a) {
	return {$: 2, a: a};
};
var $author$project$Data$Status$Success = function (a) {
	return {$: 3, a: a};
};
var $author$project$Data$Status$fromResult = function (result) {
	if (!result.$) {
		var x = result.a;
		return $author$project$Data$Status$Success(x);
	} else {
		var err = result.a;
		return $author$project$Data$Status$Failure(err);
	}
};
var $author$project$Util$Translation$BadStatus = function (a) {
	return {$: 0, a: a};
};
var $author$project$Util$Translation$BadStatusDescription = function (a) {
	return {$: 1, a: a};
};
var $author$project$Util$Translation$BadUrlDescription = function (a) {
	return {$: 2, a: a};
};
var $elm_community$maybe_extra$Maybe$Extra$or = F2(
	function (ma, mb) {
		if (ma.$ === 1) {
			return mb;
		} else {
			return ma;
		}
	});
var $author$project$Util$Translation$httpError = function (error) {
	switch (error.$) {
		case 0:
			var url = error.a;
			return {
				dn: $author$project$Util$Translation$translate(
					$author$project$Util$Translation$BadUrlDescription(url)),
				avV: $author$project$Copy$copy.nQ
			};
		case 1:
			return {dn: $author$project$Copy$copy.amX, avV: $author$project$Copy$copy.a_};
		case 2:
			return {dn: $author$project$Copy$copy.Ut, avV: $author$project$Copy$copy.Us};
		case 3:
			var statusCode = error.a;
			var b = error.b;
			switch (statusCode) {
				case 400:
					return $author$project$Util$Translation$responseError(
						$author$project$Api$decodeValidationError(b));
				case 404:
					return {
						dn: $author$project$Copy$copy.Ga,
						avV: $author$project$Util$Translation$translate(
							$author$project$Util$Translation$BadStatus(statusCode))
					};
				case 413:
					return {
						dn: $author$project$Copy$copy.SB,
						avV: $author$project$Util$Translation$translate(
							$author$project$Util$Translation$BadStatus(statusCode))
					};
				case 429:
					return {
						dn: $elm$core$String$isEmpty(b) ? $author$project$Copy$copy.aaK : b,
						avV: $author$project$Util$Translation$translate(
							$author$project$Util$Translation$BadStatus(statusCode))
					};
				case 500:
					return {
						dn: $author$project$Copy$copy.Gb,
						avV: $author$project$Util$Translation$translate(
							$author$project$Util$Translation$BadStatus(statusCode))
					};
				default:
					var status = statusCode;
					return {
						dn: $author$project$Util$Translation$translate(
							$author$project$Util$Translation$BadStatusDescription(status)),
						avV: $author$project$Util$Translation$translate(
							$author$project$Util$Translation$BadStatus(status))
					};
			}
		case 4:
			var err = error.a;
			return {
				dn: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'{0} | {1}',
					_List_fromArray(
						[$author$project$Copy$copy.nO, err])),
				avV: $author$project$Copy$copy.nN
			};
		default:
			var err = error.a;
			return {
				dn: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'{0} | {1}',
					_List_fromArray(
						[$author$project$Copy$copy.nO, err])),
				avV: $author$project$Copy$copy.nN
			};
	}
};
var $author$project$Util$Translation$responseError = function (error) {
	var withoutMessage = {
		dn: $author$project$Util$Translation$translate(
			$author$project$Util$Translation$BadStatusDescription(400)),
		avV: $author$project$Copy$copy.nP
	};
	var toMessage = function (msg) {
		return {dn: msg, avV: $author$project$Copy$copy.nP};
	};
	var inLanguage = $elm$core$Dict$get(
		$author$project$Util$LangCode$toString($author$project$Copy$language));
	if (!error.$) {
		var globalError = error.a.Ln;
		var parseError = error.a._l;
		return A2(
			$elm$core$Maybe$withDefault,
			withoutMessage,
			A2(
				$elm$core$Maybe$map,
				toMessage,
				A2(
					$elm_community$maybe_extra$Maybe$Extra$or,
					inLanguage(globalError),
					A2($elm$core$Dict$get, 'en', parseError))));
	} else {
		var err = error.a;
		return $author$project$Util$Translation$httpError(err);
	}
};
var $author$project$Component$Notifications$Info = 3;
var $author$project$Component$Notifications$Notification = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $author$project$Component$Notifications$NotificationId = $elm$core$Basics$identity;
var $author$project$Component$Notifications$addNotificationWithId = F3(
	function (level, content, _v0) {
		var counter = _v0.a;
		var notifications = _v0.b;
		return _Utils_Tuple2(
			counter,
			A2(
				$author$project$Component$Notifications$Notifications,
				counter + 1,
				A2(
					$elm$core$List$cons,
					A3($author$project$Component$Notifications$Notification, counter, content, level),
					notifications)));
	});
var $author$project$Component$Notifications$notify = F4(
	function (level, content, toMsg, _v0) {
		var model = _v0.a;
		var cmd = _v0.b;
		var _v1 = A3($author$project$Component$Notifications$addNotificationWithId, level, content, model.Xf);
		var id = _v1.a;
		var notifications = _v1.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{Xf: notifications}),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Task$perform,
						$elm$core$Basics$always(
							toMsg(id)),
						$elm$core$Process$sleep(7500)),
						cmd
					])));
	});
var $author$project$Component$Notifications$notifySnackbar = function (description) {
	return A2(
		$author$project$Component$Notifications$notify,
		3,
		{dn: description, avV: ''});
};
var $author$project$Component$Notifications$removeNotification = F2(
	function (id, _v0) {
		var counter = _v0.a;
		var notifications = _v0.b;
		return A2(
			$author$project$Component$Notifications$Notifications,
			counter,
			A2(
				$elm$core$List$filter,
				function (_v1) {
					var id1 = _v1.a;
					return !_Utils_eq(id1, id);
				},
				notifications));
	});
var $author$project$Component$Modal$Confirm$NoOp = {$: 0};
var $author$project$Component$Modal$Confirm$Visible = function (a) {
	return {$: 0, a: a};
};
var $author$project$Component$Modal$Confirm$update = F3(
	function (_v0, msg, confirm) {
		var liftMsg = _v0.bf;
		switch (msg.$) {
			case 0:
				return _Utils_Tuple2(confirm, $elm$core$Platform$Cmd$none);
			case 2:
				return _Utils_Tuple2($author$project$Component$Modal$Confirm$Hidden, $elm$core$Platform$Cmd$none);
			default:
				var a = msg.a;
				return _Utils_Tuple2(
					$author$project$Component$Modal$Confirm$Visible(a),
					A2(
						$elm$core$Platform$Cmd$map,
						liftMsg,
						A2(
							$elm$core$Task$attempt,
							$elm$core$Basics$always($author$project$Component$Modal$Confirm$NoOp),
							$elm$browser$Browser$Dom$focus('confirm-delete'))));
		}
	});
var $author$project$ShareToolEmployeeContentCollection$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var maybeId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cZ: maybeId}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var contentId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{sb: $author$project$Component$Modal$Confirm$hidden}),
					A2(
						$author$project$Api$send,
						$author$project$ShareToolEmployeeContentCollection$GotDeleteEmployeeContent,
						$author$project$Data$EmployeeContent$delete(contentId)));
			case 2:
				if (!msg.a.$) {
					return _Utils_Tuple2(
						model,
						A2($author$project$Api$send, $author$project$ShareToolEmployeeContentCollection$GotEmployeeContentStatus, $author$project$Data$EmployeeContent$getPersonalCollection));
				} else {
					var err = msg.a.a;
					return A3(
						$author$project$Component$Notifications$notifySnackbar,
						$author$project$Util$Translation$httpError(err).dn,
						$author$project$ShareToolEmployeeContentCollection$DeleteToastById,
						_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
				}
			case 3:
				var result = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							FJ: $author$project$Data$Status$fromResult(result)
						}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var msg_ = msg.a;
				var _v1 = A3($author$project$Component$Modal$Confirm$update, $author$project$ShareToolEmployeeContentCollection$confirmDeleteConfig, msg_, model.sb);
				var confirm = _v1.a;
				var cmd = _v1.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{sb: confirm}),
					cmd);
			default:
				var id = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							Xf: A2($author$project$Component$Notifications$removeNotification, id, model.Xf)
						}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Component$Button$Attribute = $elm$core$Basics$identity;
var $author$project$Component$Button$Button = $elm$core$Basics$identity;
var $author$project$Component$Button$set = function (_with) {
	return function (_v0) {
		var config = _v0;
		return _with(config);
	};
};
var $author$project$Component$Button$customCss = function (styles) {
	return $author$project$Component$Button$set(
		function (attribute) {
			return _Utils_update(
				attribute,
				{cj: styles});
		});
};
var $rtfeldman$elm_css$Css$Preprocess$AppendProperty = function (a) {
	return {$: 0, a: a};
};
var $rtfeldman$elm_css$Css$Structure$Property = $elm$core$Basics$identity;
var $rtfeldman$elm_css$Css$property = F2(
	function (key, value) {
		return $rtfeldman$elm_css$Css$Preprocess$AppendProperty(key + (':' + value));
	});
var $rtfeldman$elm_css$Css$prop1 = F2(
	function (key, arg) {
		return A2($rtfeldman$elm_css$Css$property, key, arg.ey);
	});
var $rtfeldman$elm_css$Css$marginRight = $rtfeldman$elm_css$Css$prop1('margin-right');
var $author$project$Component$Button$onClick = function (msg_) {
	return $author$project$Component$Button$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{
					cC: $elm$core$Maybe$Just(msg_)
				});
		});
};
var $author$project$Component$Button$OnlyIcon = function (a) {
	return {$: 3, a: a};
};
var $author$project$Component$Button$onlyIcon = function (iconPath) {
	return $author$project$Component$Button$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{
					bb: $author$project$Component$Button$OnlyIcon(iconPath)
				});
		});
};
var $author$project$Component$Button$OutlinePrimary = 3;
var $author$project$Component$Button$outlinePrimary = $author$project$Component$Button$set(
	function (attribute) {
		return _Utils_update(
			attribute,
			{ao: 3});
	});
var $author$project$Component$Button$Primary = 0;
var $author$project$Component$Button$primary = $author$project$Component$Button$set(
	function (attribute) {
		return _Utils_update(
			attribute,
			{ao: 0});
	});
var $rtfeldman$elm_css$Css$PxUnits = 0;
var $rtfeldman$elm_css$Css$Structure$Compatible = 0;
var $rtfeldman$elm_css$Css$Internal$lengthConverter = F3(
	function (units, unitLabel, numericValue) {
		return {
			f6: 0,
			pu: 0,
			bK: 0,
			T: 0,
			cx: 0,
			bP: 0,
			aN: 0,
			bQ: 0,
			bR: 0,
			bd: 0,
			be: 0,
			ay: 0,
			bS: 0,
			aQ: numericValue,
			b1: 0,
			b6: unitLabel,
			cT: units,
			ey: _Utils_ap(
				$elm$core$String$fromFloat(numericValue),
				unitLabel)
		};
	});
var $rtfeldman$elm_css$Css$px = A2($rtfeldman$elm_css$Css$Internal$lengthConverter, 0, 'px');
var $author$project$Component$Button$ButtonTypeSubmit = 1;
var $author$project$Component$Button$Enabled = 1;
var $author$project$Component$Button$None = {$: 0};
var $author$project$Component$Button$WidthUnbounded = 1;
var $author$project$Component$Button$build = {by: $elm$core$Maybe$Nothing, bB: 1, dc: '', x$: _List_Nil, cj: _List_Nil, bb: $author$project$Component$Button$None, bO: _List_Nil, cC: $elm$core$Maybe$Nothing, aX: 1, ao: 0, cb: 1};
var $rtfeldman$elm_css$VirtualDom$Styled$Unstyled = function (a) {
	return {$: 4, a: a};
};
var $rtfeldman$elm_css$VirtualDom$Styled$text = function (str) {
	return $rtfeldman$elm_css$VirtualDom$Styled$Unstyled(
		$elm$virtual_dom$VirtualDom$text(str));
};
var $rtfeldman$elm_css$Html$Styled$text = $rtfeldman$elm_css$VirtualDom$Styled$text;
var $author$project$Component$Button$label = function (label_) {
	return $author$project$Component$Button$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{
					bO: _List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(label_)
						])
				});
		});
};
var $rtfeldman$elm_css$Css$Preprocess$ApplyStyles = function (a) {
	return {$: 6, a: a};
};
var $rtfeldman$elm_css$Css$batch = $rtfeldman$elm_css$Css$Preprocess$ApplyStyles;
var $rtfeldman$elm_css$Css$borderRadius = $rtfeldman$elm_css$Css$prop1('border-radius');
var $rtfeldman$elm_css$Css$color = function (c) {
	return A2($rtfeldman$elm_css$Css$property, 'color', c.ey);
};
var $rtfeldman$elm_css$Css$cursor = $rtfeldman$elm_css$Css$prop1('cursor');
var $rtfeldman$elm_css$Css$displayFlex = A2($rtfeldman$elm_css$Css$property, 'display', 'flex');
var $rtfeldman$elm_css$Css$prop2 = F3(
	function (key, argA, argB) {
		return A2($rtfeldman$elm_css$Css$property, key, argA.ey + (' ' + argB.ey));
	});
var $rtfeldman$elm_css$Css$flexFlow2 = $rtfeldman$elm_css$Css$prop2('flex-flow');
var $rtfeldman$elm_css$Css$fontWeight = function (_v0) {
	var value = _v0.ey;
	return A2($rtfeldman$elm_css$Css$property, 'font-weight', value);
};
var $rtfeldman$elm_css$Css$Preprocess$ExtendSelector = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Structure$PseudoClassSelector = function (a) {
	return {$: 2, a: a};
};
var $rtfeldman$elm_css$Css$pseudoClass = function (_class) {
	return $rtfeldman$elm_css$Css$Preprocess$ExtendSelector(
		$rtfeldman$elm_css$Css$Structure$PseudoClassSelector(_class));
};
var $rtfeldman$elm_css$Css$hover = $rtfeldman$elm_css$Css$pseudoClass('hover');
var $rtfeldman$elm_css$Css$noWrap = {cp: 0, dz: 0, ey: 'nowrap', bw: 0};
var $rtfeldman$elm_css$Css$normal = {Ho: 0, cq: 0, a9: 0, bS: 0, Ze: 0, ey: 'normal', bw: 0};
var $rtfeldman$elm_css$Css$padding2 = $rtfeldman$elm_css$Css$prop2('padding');
var $rtfeldman$elm_css$Css$pointer = {b: 0, ey: 'pointer'};
var $rtfeldman$elm_css$Css$row = {eV: 0, cp: 0, ey: 'row'};
var $rtfeldman$elm_css$Css$withPrecedingHash = function (str) {
	return A2($elm$core$String$startsWith, '#', str) ? str : A2($elm$core$String$cons, '#', str);
};
var $rtfeldman$elm_css$Css$erroneousHex = function (str) {
	return {
		jm: 1,
		oY: 0,
		rF: 0,
		LQ: 0,
		abl: 0,
		ey: $rtfeldman$elm_css$Css$withPrecedingHash(str)
	};
};
var $elm$core$String$fromList = _String_fromList;
var $rtfeldman$elm_css$Css$validHex = F5(
	function (str, _v0, _v1, _v2, _v3) {
		var r1 = _v0.a;
		var r2 = _v0.b;
		var g1 = _v1.a;
		var g2 = _v1.b;
		var b1 = _v2.a;
		var b2 = _v2.b;
		var a1 = _v3.a;
		var a2 = _v3.b;
		var toResult = A2(
			$elm$core$Basics$composeR,
			$elm$core$String$fromList,
			A2($elm$core$Basics$composeR, $elm$core$String$toLower, $rtfeldman$elm_hex$Hex$fromString));
		var results = _Utils_Tuple2(
			_Utils_Tuple2(
				toResult(
					_List_fromArray(
						[r1, r2])),
				toResult(
					_List_fromArray(
						[g1, g2]))),
			_Utils_Tuple2(
				toResult(
					_List_fromArray(
						[b1, b2])),
				toResult(
					_List_fromArray(
						[a1, a2]))));
		if ((((!results.a.a.$) && (!results.a.b.$)) && (!results.b.a.$)) && (!results.b.b.$)) {
			var _v5 = results.a;
			var red = _v5.a.a;
			var green = _v5.b.a;
			var _v6 = results.b;
			var blue = _v6.a.a;
			var alpha = _v6.b.a;
			return {
				jm: alpha / 255,
				oY: blue,
				rF: 0,
				LQ: green,
				abl: red,
				ey: $rtfeldman$elm_css$Css$withPrecedingHash(str)
			};
		} else {
			return $rtfeldman$elm_css$Css$erroneousHex(str);
		}
	});
var $rtfeldman$elm_css$Css$hex = function (str) {
	var withoutHash = A2($elm$core$String$startsWith, '#', str) ? A2($elm$core$String$dropLeft, 1, str) : str;
	var _v0 = $elm$core$String$toList(withoutHash);
	_v0$4:
	while (true) {
		if ((_v0.b && _v0.b.b) && _v0.b.b.b) {
			if (!_v0.b.b.b.b) {
				var r = _v0.a;
				var _v1 = _v0.b;
				var g = _v1.a;
				var _v2 = _v1.b;
				var b = _v2.a;
				return A5(
					$rtfeldman$elm_css$Css$validHex,
					str,
					_Utils_Tuple2(r, r),
					_Utils_Tuple2(g, g),
					_Utils_Tuple2(b, b),
					_Utils_Tuple2('f', 'f'));
			} else {
				if (!_v0.b.b.b.b.b) {
					var r = _v0.a;
					var _v3 = _v0.b;
					var g = _v3.a;
					var _v4 = _v3.b;
					var b = _v4.a;
					var _v5 = _v4.b;
					var a = _v5.a;
					return A5(
						$rtfeldman$elm_css$Css$validHex,
						str,
						_Utils_Tuple2(r, r),
						_Utils_Tuple2(g, g),
						_Utils_Tuple2(b, b),
						_Utils_Tuple2(a, a));
				} else {
					if (_v0.b.b.b.b.b.b) {
						if (!_v0.b.b.b.b.b.b.b) {
							var r1 = _v0.a;
							var _v6 = _v0.b;
							var r2 = _v6.a;
							var _v7 = _v6.b;
							var g1 = _v7.a;
							var _v8 = _v7.b;
							var g2 = _v8.a;
							var _v9 = _v8.b;
							var b1 = _v9.a;
							var _v10 = _v9.b;
							var b2 = _v10.a;
							return A5(
								$rtfeldman$elm_css$Css$validHex,
								str,
								_Utils_Tuple2(r1, r2),
								_Utils_Tuple2(g1, g2),
								_Utils_Tuple2(b1, b2),
								_Utils_Tuple2('f', 'f'));
						} else {
							if (_v0.b.b.b.b.b.b.b.b && (!_v0.b.b.b.b.b.b.b.b.b)) {
								var r1 = _v0.a;
								var _v11 = _v0.b;
								var r2 = _v11.a;
								var _v12 = _v11.b;
								var g1 = _v12.a;
								var _v13 = _v12.b;
								var g2 = _v13.a;
								var _v14 = _v13.b;
								var b1 = _v14.a;
								var _v15 = _v14.b;
								var b2 = _v15.a;
								var _v16 = _v15.b;
								var a1 = _v16.a;
								var _v17 = _v16.b;
								var a2 = _v17.a;
								return A5(
									$rtfeldman$elm_css$Css$validHex,
									str,
									_Utils_Tuple2(r1, r2),
									_Utils_Tuple2(g1, g2),
									_Utils_Tuple2(b1, b2),
									_Utils_Tuple2(a1, a2));
							} else {
								break _v0$4;
							}
						}
					} else {
						break _v0$4;
					}
				}
			}
		} else {
			break _v0$4;
		}
	}
	return $rtfeldman$elm_css$Css$erroneousHex(str);
};
var $author$project$Component$Button$white = $rtfeldman$elm_css$Css$hex('ffffff');
var $rtfeldman$elm_css$Css$whiteSpace = $rtfeldman$elm_css$Css$prop1('white-space');
var $author$project$Component$Button$btn = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(10),
			$rtfeldman$elm_css$Css$px(15)),
			$rtfeldman$elm_css$Css$displayFlex,
			A2($rtfeldman$elm_css$Css$flexFlow2, $rtfeldman$elm_css$Css$row, $rtfeldman$elm_css$Css$noWrap),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$px(5)),
			$rtfeldman$elm_css$Css$fontWeight($rtfeldman$elm_css$Css$normal),
			$rtfeldman$elm_css$Css$whiteSpace($rtfeldman$elm_css$Css$noWrap),
			$rtfeldman$elm_css$Css$color($author$project$Component$Button$white),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
				]))
		]));
var $rtfeldman$elm_css$VirtualDom$Styled$Node = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $rtfeldman$elm_css$VirtualDom$Styled$node = $rtfeldman$elm_css$VirtualDom$Styled$Node;
var $rtfeldman$elm_css$Html$Styled$node = $rtfeldman$elm_css$VirtualDom$Styled$node;
var $rtfeldman$elm_css$Html$Styled$button = $rtfeldman$elm_css$Html$Styled$node('button');
var $rtfeldman$elm_css$Css$Internal$property = F2(
	function (key, value) {
		return $rtfeldman$elm_css$Css$Preprocess$AppendProperty(key + (':' + value));
	});
var $rtfeldman$elm_css$Css$Internal$getOverloadedProperty = F3(
	function (functionName, desiredKey, style) {
		getOverloadedProperty:
		while (true) {
			switch (style.$) {
				case 0:
					var str = style.a;
					var key = A2(
						$elm$core$Maybe$withDefault,
						'',
						$elm$core$List$head(
							A2($elm$core$String$split, ':', str)));
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, key);
				case 1:
					var selector = style.a;
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-selector'));
				case 2:
					var combinator = style.a;
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-combinator'));
				case 3:
					var pseudoElement = style.a;
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-pseudo-element setter'));
				case 4:
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-media-query'));
				case 5:
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-keyframes'));
				default:
					if (!style.a.b) {
						return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-empty-Style'));
					} else {
						if (!style.a.b.b) {
							var _v1 = style.a;
							var only = _v1.a;
							var $temp$functionName = functionName,
								$temp$desiredKey = desiredKey,
								$temp$style = only;
							functionName = $temp$functionName;
							desiredKey = $temp$desiredKey;
							style = $temp$style;
							continue getOverloadedProperty;
						} else {
							var _v2 = style.a;
							var first = _v2.a;
							var rest = _v2.b;
							var $temp$functionName = functionName,
								$temp$desiredKey = desiredKey,
								$temp$style = $rtfeldman$elm_css$Css$Preprocess$ApplyStyles(rest);
							functionName = $temp$functionName;
							desiredKey = $temp$desiredKey;
							style = $temp$style;
							continue getOverloadedProperty;
						}
					}
			}
		}
	});
var $rtfeldman$elm_css$Css$Internal$IncompatibleUnits = 0;
var $rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty = A3($rtfeldman$elm_css$Css$Internal$lengthConverter, 0, '', 0);
var $rtfeldman$elm_css$Css$alignSelf = function (fn) {
	return A3(
		$rtfeldman$elm_css$Css$Internal$getOverloadedProperty,
		'alignSelf',
		'align-self',
		fn($rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty));
};
var $rtfeldman$elm_css$Css$center = $rtfeldman$elm_css$Css$prop1('center');
var $rtfeldman$elm_css$Css$flexEnd = $rtfeldman$elm_css$Css$prop1('flex-end');
var $rtfeldman$elm_css$Css$start = $rtfeldman$elm_css$Css$prop1('start');
var $author$project$Component$Button$buttonAlignmentToClass = function (buttonAlignment) {
	switch (buttonAlignment) {
		case 0:
			return $rtfeldman$elm_css$Css$alignSelf($rtfeldman$elm_css$Css$start);
		case 1:
			return $rtfeldman$elm_css$Css$alignSelf($rtfeldman$elm_css$Css$center);
		default:
			return $rtfeldman$elm_css$Css$alignSelf($rtfeldman$elm_css$Css$flexEnd);
	}
};
var $rtfeldman$elm_css$Css$backgroundColor = function (c) {
	return A2($rtfeldman$elm_css$Css$property, 'background-color', c.ey);
};
var $rtfeldman$elm_css$Css$prop3 = F4(
	function (key, argA, argB, argC) {
		return A2($rtfeldman$elm_css$Css$property, key, argA.ey + (' ' + (argB.ey + (' ' + argC.ey))));
	});
var $rtfeldman$elm_css$Css$border3 = $rtfeldman$elm_css$Css$prop3('border');
var $rtfeldman$elm_css$Css$borderColor = function (c) {
	return A2($rtfeldman$elm_css$Css$property, 'border-color', c.ey);
};
var $author$project$Component$Button$brandColor1 = $rtfeldman$elm_css$Css$hex('132834');
var $author$project$Component$Button$brandColor2 = $rtfeldman$elm_css$Css$hex('f8bbbe');
var $author$project$Component$Button$btnSecondaryHover = $rtfeldman$elm_css$Css$hex('132834');
var $rtfeldman$elm_css$Css$solid = {aa: 0, br: 0, ey: 'solid'};
var $rtfeldman$elm_css$Css$transparent = {rF: 0, ey: 'transparent'};
var $author$project$Component$Button$buttonStyleToCss = function (buttonStyle) {
	switch (buttonStyle) {
		case 0:
			return $rtfeldman$elm_css$Css$batch(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$backgroundColor($author$project$Component$Button$brandColor1),
						$rtfeldman$elm_css$Css$color($author$project$Component$Button$white)
					]));
		case 1:
			return $rtfeldman$elm_css$Css$batch(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$backgroundColor($author$project$Component$Button$brandColor2),
						$rtfeldman$elm_css$Css$color($author$project$Component$Button$white)
					]));
		case 2:
			return $rtfeldman$elm_css$Css$batch(_List_Nil);
		case 3:
			return $rtfeldman$elm_css$Css$batch(
				_List_fromArray(
					[
						A3(
						$rtfeldman$elm_css$Css$border3,
						$rtfeldman$elm_css$Css$px(1),
						$rtfeldman$elm_css$Css$solid,
						$author$project$Component$Button$brandColor1),
						$rtfeldman$elm_css$Css$color($author$project$Component$Button$brandColor1),
						$rtfeldman$elm_css$Css$backgroundColor($rtfeldman$elm_css$Css$transparent),
						$rtfeldman$elm_css$Css$hover(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$borderColor($author$project$Component$Button$btnSecondaryHover),
								$rtfeldman$elm_css$Css$backgroundColor($author$project$Component$Button$btnSecondaryHover),
								$rtfeldman$elm_css$Css$color($author$project$Component$Button$white)
							]))
					]));
		default:
			return $rtfeldman$elm_css$Css$batch(
				_List_fromArray(
					[
						A3(
						$rtfeldman$elm_css$Css$border3,
						$rtfeldman$elm_css$Css$px(1),
						$rtfeldman$elm_css$Css$solid,
						$author$project$Component$Button$brandColor2),
						$rtfeldman$elm_css$Css$color($author$project$Component$Button$brandColor2),
						$rtfeldman$elm_css$Css$backgroundColor($rtfeldman$elm_css$Css$transparent)
					]));
	}
};
var $author$project$Component$Button$buttonTypeToString = function (buttonType) {
	if (!buttonType) {
		return 'button';
	} else {
		return 'submit';
	}
};
var $rtfeldman$elm_css$Css$border = $rtfeldman$elm_css$Css$prop1('border');
var $author$project$Component$Button$btnPrimaryHover = $rtfeldman$elm_css$Css$hex('050b0f');
var $rtfeldman$elm_css$Css$UnitlessInteger = 0;
var $rtfeldman$elm_css$Css$int = function (val) {
	return {
		a9: 0,
		dJ: 0,
		be: 0,
		ay: 0,
		au1: 0,
		dZ: 0,
		aQ: val,
		b6: '',
		cT: 0,
		ey: $elm$core$String$fromInt(val)
	};
};
var $rtfeldman$elm_css$Css$zIndex = $rtfeldman$elm_css$Css$prop1('z-index');
var $author$project$Component$Button$primaryButton = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$border(
			$rtfeldman$elm_css$Css$px(1)),
			$rtfeldman$elm_css$Css$borderColor($author$project$Component$Button$brandColor1),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$Component$Button$brandColor1),
			$rtfeldman$elm_css$Css$zIndex(
			$rtfeldman$elm_css$Css$int(2)),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$borderColor($author$project$Component$Button$btnPrimaryHover),
					$rtfeldman$elm_css$Css$backgroundColor($author$project$Component$Button$btnPrimaryHover)
				]))
		]));
var $author$project$Component$Button$secondaryButton = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$color($author$project$Component$Button$brandColor1),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$Component$Button$brandColor2),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$borderColor($author$project$Component$Button$btnSecondaryHover),
					$rtfeldman$elm_css$Css$backgroundColor($author$project$Component$Button$btnSecondaryHover),
					$rtfeldman$elm_css$Css$color($author$project$Component$Button$white)
				]))
		]));
var $author$project$Component$Button$buttonVariantToCss = function (buttonStyle) {
	switch (buttonStyle) {
		case 0:
			return $rtfeldman$elm_css$Css$batch(
				_List_fromArray(
					[$author$project$Component$Button$primaryButton]));
		case 1:
			return $rtfeldman$elm_css$Css$batch(
				_List_fromArray(
					[$author$project$Component$Button$secondaryButton]));
		default:
			return $rtfeldman$elm_css$Css$batch(_List_Nil);
	}
};
var $rtfeldman$elm_css$Css$maxWidth = $rtfeldman$elm_css$Css$prop1('max-width');
var $rtfeldman$elm_css$Css$none = {bA: 0, oX: 0, aa: 0, b: 0, u: 0, auf: 0, N$: 0, fa: 0, bR: 0, bd: 0, ay: 0, e: 0, c: 0, fp: 0, d3: 0, avd: 0, as: 0, ec: 0, avw: 0, b0: 0, bs: 0, ai: 0, k: 0, awe: 0, ey: 'none'};
var $rtfeldman$elm_css$Css$PercentageUnits = 0;
var $rtfeldman$elm_css$Css$pct = A2($rtfeldman$elm_css$Css$Internal$lengthConverter, 0, '%');
var $rtfeldman$elm_css$Css$width = $rtfeldman$elm_css$Css$prop1('width');
var $author$project$Component$Button$buttonWidthToCss = function (buttonWidth) {
	switch (buttonWidth) {
		case 1:
			return $rtfeldman$elm_css$Css$maxWidth($rtfeldman$elm_css$Css$none);
		case 0:
			return $rtfeldman$elm_css$Css$width(
				$rtfeldman$elm_css$Css$pct(100));
		default:
			return $rtfeldman$elm_css$Css$maxWidth($rtfeldman$elm_css$Css$none);
	}
};
var $rtfeldman$elm_css$VirtualDom$Styled$Attribute = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $rtfeldman$elm_css$VirtualDom$Styled$property = F2(
	function (key, value) {
		return A3(
			$rtfeldman$elm_css$VirtualDom$Styled$Attribute,
			A2($elm$virtual_dom$VirtualDom$property, key, value),
			false,
			'');
	});
var $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty = F2(
	function (key, string) {
		return A2(
			$rtfeldman$elm_css$VirtualDom$Styled$property,
			key,
			$elm$json$Json$Encode$string(string));
	});
var $rtfeldman$elm_css$Html$Styled$Attributes$class = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('className');
var $rtfeldman$elm_css$Css$Structure$compactHelp = F2(
	function (declaration, _v0) {
		var keyframesByName = _v0.a;
		var declarations = _v0.b;
		switch (declaration.$) {
			case 0:
				var _v2 = declaration.a;
				var properties = _v2.c;
				return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 1:
				var styleBlocks = declaration.b;
				return A2(
					$elm$core$List$all,
					function (_v3) {
						var properties = _v3.c;
						return $elm$core$List$isEmpty(properties);
					},
					styleBlocks) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 2:
				var otherDeclarations = declaration.b;
				return $elm$core$List$isEmpty(otherDeclarations) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 3:
				return _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 4:
				var properties = declaration.a;
				return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 5:
				var properties = declaration.a;
				return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 6:
				var record = declaration.a;
				return $elm$core$String$isEmpty(record.aty) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					A3($elm$core$Dict$insert, record.dY, record.aty, keyframesByName),
					declarations);
			case 7:
				var properties = declaration.a;
				return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 8:
				var properties = declaration.a;
				return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			default:
				var tuples = declaration.a;
				return A2(
					$elm$core$List$all,
					function (_v4) {
						var properties = _v4.b;
						return $elm$core$List$isEmpty(properties);
					},
					tuples) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
		}
	});
var $rtfeldman$elm_css$Css$Structure$Keyframes = function (a) {
	return {$: 6, a: a};
};
var $rtfeldman$elm_css$Css$Structure$withKeyframeDeclarations = F2(
	function (keyframesByName, compactedDeclarations) {
		return A2(
			$elm$core$List$append,
			A2(
				$elm$core$List$map,
				function (_v0) {
					var name = _v0.a;
					var decl = _v0.b;
					return $rtfeldman$elm_css$Css$Structure$Keyframes(
						{aty: decl, dY: name});
				},
				$elm$core$Dict$toList(keyframesByName)),
			compactedDeclarations);
	});
var $rtfeldman$elm_css$Css$Structure$compactDeclarations = function (declarations) {
	var _v0 = A3(
		$elm$core$List$foldr,
		$rtfeldman$elm_css$Css$Structure$compactHelp,
		_Utils_Tuple2($elm$core$Dict$empty, _List_Nil),
		declarations);
	var keyframesByName = _v0.a;
	var compactedDeclarations = _v0.b;
	return A2($rtfeldman$elm_css$Css$Structure$withKeyframeDeclarations, keyframesByName, compactedDeclarations);
};
var $rtfeldman$elm_css$Css$Structure$compactStylesheet = function (_v0) {
	var charset = _v0.qh;
	var imports = _v0.NE;
	var namespaces = _v0.Uf;
	var declarations = _v0.atz;
	return {
		qh: charset,
		atz: $rtfeldman$elm_css$Css$Structure$compactDeclarations(declarations),
		NE: imports,
		Uf: namespaces
	};
};
var $rtfeldman$elm_css$Css$Structure$Output$charsetToString = function (charset) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			function (str) {
				return '@charset \"' + (str + '\"');
			},
			charset));
};
var $rtfeldman$elm_css$Css$String$mapJoinHelp = F4(
	function (map, sep, strs, result) {
		mapJoinHelp:
		while (true) {
			if (!strs.b) {
				return result;
			} else {
				if (!strs.b.b) {
					var first = strs.a;
					return result + (map(first) + '');
				} else {
					var first = strs.a;
					var rest = strs.b;
					var $temp$map = map,
						$temp$sep = sep,
						$temp$strs = rest,
						$temp$result = result + (map(first) + (sep + ''));
					map = $temp$map;
					sep = $temp$sep;
					strs = $temp$strs;
					result = $temp$result;
					continue mapJoinHelp;
				}
			}
		}
	});
var $rtfeldman$elm_css$Css$String$mapJoin = F3(
	function (map, sep, strs) {
		return A4($rtfeldman$elm_css$Css$String$mapJoinHelp, map, sep, strs, '');
	});
var $rtfeldman$elm_css$Css$Structure$Output$mediaExpressionToString = function (expression) {
	return '(' + (expression.Hl + (A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			$elm$core$Basics$append(': '),
			expression.ey)) + ')'));
};
var $rtfeldman$elm_css$Css$Structure$Output$mediaTypeToString = function (mediaType) {
	switch (mediaType) {
		case 0:
			return 'print';
		case 1:
			return 'screen';
		default:
			return 'speech';
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$mediaQueryToString = function (mediaQuery) {
	var prefixWith = F3(
		function (str, mediaType, expressions) {
			return str + (' ' + A2(
				$elm$core$String$join,
				' and ',
				A2(
					$elm$core$List$cons,
					$rtfeldman$elm_css$Css$Structure$Output$mediaTypeToString(mediaType),
					A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$Output$mediaExpressionToString, expressions))));
		});
	switch (mediaQuery.$) {
		case 0:
			var expressions = mediaQuery.a;
			return A3($rtfeldman$elm_css$Css$String$mapJoin, $rtfeldman$elm_css$Css$Structure$Output$mediaExpressionToString, ' and ', expressions);
		case 1:
			var mediaType = mediaQuery.a;
			var expressions = mediaQuery.b;
			return A3(prefixWith, 'only', mediaType, expressions);
		case 2:
			var mediaType = mediaQuery.a;
			var expressions = mediaQuery.b;
			return A3(prefixWith, 'not', mediaType, expressions);
		default:
			var str = mediaQuery.a;
			return str;
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$importMediaQueryToString = F2(
	function (name, mediaQuery) {
		return '@import \"' + (name + ($rtfeldman$elm_css$Css$Structure$Output$mediaQueryToString(mediaQuery) + '\"'));
	});
var $rtfeldman$elm_css$Css$Structure$Output$importToString = function (_v0) {
	var name = _v0.a;
	var mediaQueries = _v0.b;
	return A3(
		$rtfeldman$elm_css$Css$String$mapJoin,
		$rtfeldman$elm_css$Css$Structure$Output$importMediaQueryToString(name),
		'\n',
		mediaQueries);
};
var $rtfeldman$elm_css$Css$Structure$Output$namespaceToString = function (_v0) {
	var prefix = _v0.a;
	var str = _v0.b;
	return '@namespace ' + (prefix + ('\"' + (str + '\"')));
};
var $rtfeldman$elm_css$Css$Structure$Output$emitProperties = function (properties) {
	return A3(
		$rtfeldman$elm_css$Css$String$mapJoin,
		function (_v0) {
			var prop = _v0;
			return prop + ';';
		},
		'',
		properties);
};
var $rtfeldman$elm_css$Css$Structure$Output$pseudoElementToString = function (_v0) {
	var str = _v0;
	return '::' + str;
};
var $rtfeldman$elm_css$Css$Structure$Output$combinatorToString = function (combinator) {
	switch (combinator) {
		case 0:
			return '+';
		case 1:
			return '~';
		case 2:
			return '>';
		default:
			return '';
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString = function (repeatableSimpleSelector) {
	switch (repeatableSimpleSelector.$) {
		case 0:
			var str = repeatableSimpleSelector.a;
			return '.' + str;
		case 1:
			var str = repeatableSimpleSelector.a;
			return '#' + str;
		case 2:
			var str = repeatableSimpleSelector.a;
			return ':' + str;
		default:
			var str = repeatableSimpleSelector.a;
			return '[' + (str + ']');
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$simpleSelectorSequenceToString = function (simpleSelectorSequence) {
	switch (simpleSelectorSequence.$) {
		case 0:
			var str = simpleSelectorSequence.a;
			var repeatableSimpleSelectors = simpleSelectorSequence.b;
			return _Utils_ap(
				str,
				A3($rtfeldman$elm_css$Css$String$mapJoin, $rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString, '', repeatableSimpleSelectors));
		case 1:
			var repeatableSimpleSelectors = simpleSelectorSequence.a;
			return $elm$core$List$isEmpty(repeatableSimpleSelectors) ? '*' : A3($rtfeldman$elm_css$Css$String$mapJoin, $rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString, '', repeatableSimpleSelectors);
		default:
			var str = simpleSelectorSequence.a;
			var repeatableSimpleSelectors = simpleSelectorSequence.b;
			return _Utils_ap(
				str,
				A3($rtfeldman$elm_css$Css$String$mapJoin, $rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString, '', repeatableSimpleSelectors));
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$selectorChainToString = function (_v0) {
	var combinator = _v0.a;
	var sequence = _v0.b;
	return $rtfeldman$elm_css$Css$Structure$Output$combinatorToString(combinator) + (' ' + $rtfeldman$elm_css$Css$Structure$Output$simpleSelectorSequenceToString(sequence));
};
var $rtfeldman$elm_css$Css$Structure$Output$selectorToString = function (_v0) {
	var simpleSelectorSequence = _v0.a;
	var chain = _v0.b;
	var pseudoElement = _v0.c;
	var segments = A2(
		$elm$core$List$cons,
		$rtfeldman$elm_css$Css$Structure$Output$simpleSelectorSequenceToString(simpleSelectorSequence),
		A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$Output$selectorChainToString, chain));
	var pseudoElementsString = A2(
		$elm$core$Maybe$withDefault,
		'',
		A2($elm$core$Maybe$map, $rtfeldman$elm_css$Css$Structure$Output$pseudoElementToString, pseudoElement));
	return A2(
		$elm$core$String$append,
		A2($elm$core$String$join, ' ', segments),
		pseudoElementsString);
};
var $rtfeldman$elm_css$Css$Structure$Output$prettyPrintStyleBlock = function (_v0) {
	var firstSelector = _v0.a;
	var otherSelectors = _v0.b;
	var properties = _v0.c;
	var selectorStr = A3(
		$rtfeldman$elm_css$Css$String$mapJoin,
		$rtfeldman$elm_css$Css$Structure$Output$selectorToString,
		',',
		A2($elm$core$List$cons, firstSelector, otherSelectors));
	return selectorStr + ('{' + ($rtfeldman$elm_css$Css$Structure$Output$emitProperties(properties) + '}'));
};
var $rtfeldman$elm_css$Css$Structure$Output$prettyPrintDeclaration = function (decl) {
	switch (decl.$) {
		case 0:
			var styleBlock = decl.a;
			return $rtfeldman$elm_css$Css$Structure$Output$prettyPrintStyleBlock(styleBlock);
		case 1:
			var mediaQueries = decl.a;
			var styleBlocks = decl.b;
			var query = A3($rtfeldman$elm_css$Css$String$mapJoin, $rtfeldman$elm_css$Css$Structure$Output$mediaQueryToString, ', ', mediaQueries);
			var blocks = A3($rtfeldman$elm_css$Css$String$mapJoin, $rtfeldman$elm_css$Css$Structure$Output$prettyPrintStyleBlock, '\n', styleBlocks);
			return '@media ' + (query + ('{' + (blocks + '}')));
		case 2:
			return 'TODO';
		case 3:
			return 'TODO';
		case 4:
			return 'TODO';
		case 5:
			return 'TODO';
		case 6:
			var name = decl.a.dY;
			var declaration = decl.a.aty;
			return '@keyframes ' + (name + ('{' + (declaration + '}')));
		case 7:
			return 'TODO';
		case 8:
			return 'TODO';
		default:
			return 'TODO';
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$prettyPrint = function (_v0) {
	var charset = _v0.qh;
	var imports = _v0.NE;
	var namespaces = _v0.Uf;
	var declarations = _v0.atz;
	return $rtfeldman$elm_css$Css$Structure$Output$charsetToString(charset) + (A3($rtfeldman$elm_css$Css$String$mapJoin, $rtfeldman$elm_css$Css$Structure$Output$importToString, '\n', imports) + (A3($rtfeldman$elm_css$Css$String$mapJoin, $rtfeldman$elm_css$Css$Structure$Output$namespaceToString, '\n', namespaces) + (A3($rtfeldman$elm_css$Css$String$mapJoin, $rtfeldman$elm_css$Css$Structure$Output$prettyPrintDeclaration, '\n', declarations) + '')));
};
var $rtfeldman$elm_css$Css$Structure$CounterStyle = function (a) {
	return {$: 8, a: a};
};
var $rtfeldman$elm_css$Css$Structure$FontFace = function (a) {
	return {$: 5, a: a};
};
var $rtfeldman$elm_css$Css$Structure$PageRule = function (a) {
	return {$: 4, a: a};
};
var $rtfeldman$elm_css$Css$Structure$Selector = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $rtfeldman$elm_css$Css$Structure$StyleBlock = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration = function (a) {
	return {$: 0, a: a};
};
var $rtfeldman$elm_css$Css$Structure$SupportsRule = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Structure$Viewport = function (a) {
	return {$: 7, a: a};
};
var $rtfeldman$elm_css$Css$Structure$MediaRule = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Structure$mapLast = F2(
	function (update, list) {
		if (!list.b) {
			return list;
		} else {
			if (!list.b.b) {
				var only = list.a;
				return _List_fromArray(
					[
						update(only)
					]);
			} else {
				var first = list.a;
				var rest = list.b;
				return A2(
					$elm$core$List$cons,
					first,
					A2($rtfeldman$elm_css$Css$Structure$mapLast, update, rest));
			}
		}
	});
var $rtfeldman$elm_css$Css$Structure$withPropertyAppended = F2(
	function (property, _v0) {
		var firstSelector = _v0.a;
		var otherSelectors = _v0.b;
		var properties = _v0.c;
		return A3(
			$rtfeldman$elm_css$Css$Structure$StyleBlock,
			firstSelector,
			otherSelectors,
			_Utils_ap(
				properties,
				_List_fromArray(
					[property])));
	});
var $rtfeldman$elm_css$Css$Structure$appendProperty = F2(
	function (property, declarations) {
		if (!declarations.b) {
			return declarations;
		} else {
			if (!declarations.b.b) {
				switch (declarations.a.$) {
					case 0:
						var styleBlock = declarations.a.a;
						return _List_fromArray(
							[
								$rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
								A2($rtfeldman$elm_css$Css$Structure$withPropertyAppended, property, styleBlock))
							]);
					case 1:
						var _v1 = declarations.a;
						var mediaQueries = _v1.a;
						var styleBlocks = _v1.b;
						return _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Css$Structure$MediaRule,
								mediaQueries,
								A2(
									$rtfeldman$elm_css$Css$Structure$mapLast,
									$rtfeldman$elm_css$Css$Structure$withPropertyAppended(property),
									styleBlocks))
							]);
					default:
						return declarations;
				}
			} else {
				var first = declarations.a;
				var rest = declarations.b;
				return A2(
					$elm$core$List$cons,
					first,
					A2($rtfeldman$elm_css$Css$Structure$appendProperty, property, rest));
			}
		}
	});
var $rtfeldman$elm_css$Css$Structure$appendToLastSelector = F2(
	function (f, styleBlock) {
		if (!styleBlock.b.b) {
			var only = styleBlock.a;
			var properties = styleBlock.c;
			return _List_fromArray(
				[
					A3($rtfeldman$elm_css$Css$Structure$StyleBlock, only, _List_Nil, properties),
					A3(
					$rtfeldman$elm_css$Css$Structure$StyleBlock,
					f(only),
					_List_Nil,
					_List_Nil)
				]);
		} else {
			var first = styleBlock.a;
			var rest = styleBlock.b;
			var properties = styleBlock.c;
			var newRest = A2($elm$core$List$map, f, rest);
			var newFirst = f(first);
			return _List_fromArray(
				[
					A3($rtfeldman$elm_css$Css$Structure$StyleBlock, first, rest, properties),
					A3($rtfeldman$elm_css$Css$Structure$StyleBlock, newFirst, newRest, _List_Nil)
				]);
		}
	});
var $rtfeldman$elm_css$Css$Structure$applyPseudoElement = F2(
	function (pseudo, _v0) {
		var sequence = _v0.a;
		var selectors = _v0.b;
		return A3(
			$rtfeldman$elm_css$Css$Structure$Selector,
			sequence,
			selectors,
			$elm$core$Maybe$Just(pseudo));
	});
var $rtfeldman$elm_css$Css$Structure$appendPseudoElementToLastSelector = F2(
	function (pseudo, styleBlock) {
		return A2(
			$rtfeldman$elm_css$Css$Structure$appendToLastSelector,
			$rtfeldman$elm_css$Css$Structure$applyPseudoElement(pseudo),
			styleBlock);
	});
var $rtfeldman$elm_css$Css$Structure$CustomSelector = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Structure$TypeSelectorSequence = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence = function (a) {
	return {$: 1, a: a};
};
var $rtfeldman$elm_css$Css$Structure$appendRepeatable = F2(
	function (selector, sequence) {
		switch (sequence.$) {
			case 0:
				var typeSelector = sequence.a;
				var list = sequence.b;
				return A2(
					$rtfeldman$elm_css$Css$Structure$TypeSelectorSequence,
					typeSelector,
					_Utils_ap(
						list,
						_List_fromArray(
							[selector])));
			case 1:
				var list = sequence.a;
				return $rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence(
					_Utils_ap(
						list,
						_List_fromArray(
							[selector])));
			default:
				var str = sequence.a;
				var list = sequence.b;
				return A2(
					$rtfeldman$elm_css$Css$Structure$CustomSelector,
					str,
					_Utils_ap(
						list,
						_List_fromArray(
							[selector])));
		}
	});
var $rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator = F2(
	function (selector, list) {
		if (!list.b) {
			return _List_Nil;
		} else {
			if (!list.b.b) {
				var _v1 = list.a;
				var combinator = _v1.a;
				var sequence = _v1.b;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						combinator,
						A2($rtfeldman$elm_css$Css$Structure$appendRepeatable, selector, sequence))
					]);
			} else {
				var first = list.a;
				var rest = list.b;
				return A2(
					$elm$core$List$cons,
					first,
					A2($rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator, selector, rest));
			}
		}
	});
var $rtfeldman$elm_css$Css$Structure$appendRepeatableSelector = F2(
	function (repeatableSimpleSelector, selector) {
		if (!selector.b.b) {
			var sequence = selector.a;
			var pseudoElement = selector.c;
			return A3(
				$rtfeldman$elm_css$Css$Structure$Selector,
				A2($rtfeldman$elm_css$Css$Structure$appendRepeatable, repeatableSimpleSelector, sequence),
				_List_Nil,
				pseudoElement);
		} else {
			var firstSelector = selector.a;
			var tuples = selector.b;
			var pseudoElement = selector.c;
			return A3(
				$rtfeldman$elm_css$Css$Structure$Selector,
				firstSelector,
				A2($rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator, repeatableSimpleSelector, tuples),
				pseudoElement);
		}
	});
var $rtfeldman$elm_css$Css$Structure$appendRepeatableToLastSelector = F2(
	function (selector, styleBlock) {
		return A2(
			$rtfeldman$elm_css$Css$Structure$appendToLastSelector,
			$rtfeldman$elm_css$Css$Structure$appendRepeatableSelector(selector),
			styleBlock);
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors = function (declarations) {
	collectSelectors:
	while (true) {
		if (!declarations.b) {
			return _List_Nil;
		} else {
			if (!declarations.a.$) {
				var _v1 = declarations.a.a;
				var firstSelector = _v1.a;
				var otherSelectors = _v1.b;
				var rest = declarations.b;
				return _Utils_ap(
					A2($elm$core$List$cons, firstSelector, otherSelectors),
					$rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors(rest));
			} else {
				var rest = declarations.b;
				var $temp$declarations = rest;
				declarations = $temp$declarations;
				continue collectSelectors;
			}
		}
	}
};
var $rtfeldman$elm_css$Css$Structure$DocumentRule = F5(
	function (a, b, c, d, e) {
		return {$: 3, a: a, b: b, c: c, d: d, e: e};
	});
var $rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock = F2(
	function (update, declarations) {
		_v0$12:
		while (true) {
			if (!declarations.b) {
				return declarations;
			} else {
				if (!declarations.b.b) {
					switch (declarations.a.$) {
						case 0:
							var styleBlock = declarations.a.a;
							return A2(
								$elm$core$List$map,
								$rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration,
								update(styleBlock));
						case 1:
							if (declarations.a.b.b) {
								if (!declarations.a.b.b.b) {
									var _v1 = declarations.a;
									var mediaQueries = _v1.a;
									var _v2 = _v1.b;
									var styleBlock = _v2.a;
									return _List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Css$Structure$MediaRule,
											mediaQueries,
											update(styleBlock))
										]);
								} else {
									var _v3 = declarations.a;
									var mediaQueries = _v3.a;
									var _v4 = _v3.b;
									var first = _v4.a;
									var rest = _v4.b;
									var _v5 = A2(
										$rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock,
										update,
										_List_fromArray(
											[
												A2($rtfeldman$elm_css$Css$Structure$MediaRule, mediaQueries, rest)
											]));
									if ((_v5.b && (_v5.a.$ === 1)) && (!_v5.b.b)) {
										var _v6 = _v5.a;
										var newMediaQueries = _v6.a;
										var newStyleBlocks = _v6.b;
										return _List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Css$Structure$MediaRule,
												newMediaQueries,
												A2($elm$core$List$cons, first, newStyleBlocks))
											]);
									} else {
										var newDeclarations = _v5;
										return newDeclarations;
									}
								}
							} else {
								break _v0$12;
							}
						case 2:
							var _v7 = declarations.a;
							var str = _v7.a;
							var nestedDeclarations = _v7.b;
							return _List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Css$Structure$SupportsRule,
									str,
									A2($rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock, update, nestedDeclarations))
								]);
						case 3:
							var _v8 = declarations.a;
							var str1 = _v8.a;
							var str2 = _v8.b;
							var str3 = _v8.c;
							var str4 = _v8.d;
							var styleBlock = _v8.e;
							return A2(
								$elm$core$List$map,
								A4($rtfeldman$elm_css$Css$Structure$DocumentRule, str1, str2, str3, str4),
								update(styleBlock));
						case 4:
							return declarations;
						case 5:
							return declarations;
						case 6:
							return declarations;
						case 7:
							return declarations;
						case 8:
							return declarations;
						default:
							return declarations;
					}
				} else {
					break _v0$12;
				}
			}
		}
		var first = declarations.a;
		var rest = declarations.b;
		return A2(
			$elm$core$List$cons,
			first,
			A2($rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock, update, rest));
	});
var $robinheghan$murmur3$Murmur3$HashData = F4(
	function (shift, seed, hash, charsProcessed) {
		return {bC: charsProcessed, bN: hash, ah: seed, bY: shift};
	});
var $robinheghan$murmur3$Murmur3$c1 = 3432918353;
var $robinheghan$murmur3$Murmur3$c2 = 461845907;
var $robinheghan$murmur3$Murmur3$multiplyBy = F2(
	function (b, a) {
		return ((a & 65535) * b) + ((((a >>> 16) * b) & 65535) << 16);
	});
var $elm$core$Bitwise$or = _Bitwise_or;
var $robinheghan$murmur3$Murmur3$rotlBy = F2(
	function (b, a) {
		return (a << b) | (a >>> (32 - b));
	});
var $elm$core$Bitwise$xor = _Bitwise_xor;
var $robinheghan$murmur3$Murmur3$finalize = function (data) {
	var acc = (!(!data.bN)) ? (data.ah ^ A2(
		$robinheghan$murmur3$Murmur3$multiplyBy,
		$robinheghan$murmur3$Murmur3$c2,
		A2(
			$robinheghan$murmur3$Murmur3$rotlBy,
			15,
			A2($robinheghan$murmur3$Murmur3$multiplyBy, $robinheghan$murmur3$Murmur3$c1, data.bN)))) : data.ah;
	var h0 = acc ^ data.bC;
	var h1 = A2($robinheghan$murmur3$Murmur3$multiplyBy, 2246822507, h0 ^ (h0 >>> 16));
	var h2 = A2($robinheghan$murmur3$Murmur3$multiplyBy, 3266489909, h1 ^ (h1 >>> 13));
	return (h2 ^ (h2 >>> 16)) >>> 0;
};
var $elm$core$String$foldl = _String_foldl;
var $robinheghan$murmur3$Murmur3$mix = F2(
	function (h1, k1) {
		return A2(
			$robinheghan$murmur3$Murmur3$multiplyBy,
			5,
			A2(
				$robinheghan$murmur3$Murmur3$rotlBy,
				13,
				h1 ^ A2(
					$robinheghan$murmur3$Murmur3$multiplyBy,
					$robinheghan$murmur3$Murmur3$c2,
					A2(
						$robinheghan$murmur3$Murmur3$rotlBy,
						15,
						A2($robinheghan$murmur3$Murmur3$multiplyBy, $robinheghan$murmur3$Murmur3$c1, k1))))) + 3864292196;
	});
var $robinheghan$murmur3$Murmur3$hashFold = F2(
	function (c, data) {
		var res = data.bN | ((255 & $elm$core$Char$toCode(c)) << data.bY);
		var _v0 = data.bY;
		if (_v0 === 24) {
			return {
				bC: data.bC + 1,
				bN: 0,
				ah: A2($robinheghan$murmur3$Murmur3$mix, data.ah, res),
				bY: 0
			};
		} else {
			return {bC: data.bC + 1, bN: res, ah: data.ah, bY: data.bY + 8};
		}
	});
var $robinheghan$murmur3$Murmur3$hashString = F2(
	function (seed, str) {
		return $robinheghan$murmur3$Murmur3$finalize(
			A3(
				$elm$core$String$foldl,
				$robinheghan$murmur3$Murmur3$hashFold,
				A4($robinheghan$murmur3$Murmur3$HashData, 0, seed, 0, 0),
				str));
	});
var $rtfeldman$elm_css$Hash$initialSeed = 15739;
var $rtfeldman$elm_hex$Hex$unsafeToDigit = function (num) {
	unsafeToDigit:
	while (true) {
		switch (num) {
			case 0:
				return '0';
			case 1:
				return '1';
			case 2:
				return '2';
			case 3:
				return '3';
			case 4:
				return '4';
			case 5:
				return '5';
			case 6:
				return '6';
			case 7:
				return '7';
			case 8:
				return '8';
			case 9:
				return '9';
			case 10:
				return 'a';
			case 11:
				return 'b';
			case 12:
				return 'c';
			case 13:
				return 'd';
			case 14:
				return 'e';
			case 15:
				return 'f';
			default:
				var $temp$num = num;
				num = $temp$num;
				continue unsafeToDigit;
		}
	}
};
var $rtfeldman$elm_hex$Hex$unsafePositiveToDigits = F2(
	function (digits, num) {
		unsafePositiveToDigits:
		while (true) {
			if (num < 16) {
				return A2(
					$elm$core$List$cons,
					$rtfeldman$elm_hex$Hex$unsafeToDigit(num),
					digits);
			} else {
				var $temp$digits = A2(
					$elm$core$List$cons,
					$rtfeldman$elm_hex$Hex$unsafeToDigit(
						A2($elm$core$Basics$modBy, 16, num)),
					digits),
					$temp$num = (num / 16) | 0;
				digits = $temp$digits;
				num = $temp$num;
				continue unsafePositiveToDigits;
			}
		}
	});
var $rtfeldman$elm_hex$Hex$toString = function (num) {
	return $elm$core$String$fromList(
		(num < 0) ? A2(
			$elm$core$List$cons,
			'-',
			A2($rtfeldman$elm_hex$Hex$unsafePositiveToDigits, _List_Nil, -num)) : A2($rtfeldman$elm_hex$Hex$unsafePositiveToDigits, _List_Nil, num));
};
var $rtfeldman$elm_css$Hash$fromString = function (str) {
	return A2(
		$elm$core$String$cons,
		'_',
		$rtfeldman$elm_hex$Hex$toString(
			A2($robinheghan$murmur3$Murmur3$hashString, $rtfeldman$elm_css$Hash$initialSeed, str)));
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$last = function (list) {
	last:
	while (true) {
		if (!list.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			if (!list.b.b) {
				var singleton = list.a;
				return $elm$core$Maybe$Just(singleton);
			} else {
				var rest = list.b;
				var $temp$list = rest;
				list = $temp$list;
				continue last;
			}
		}
	}
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$lastDeclaration = function (declarations) {
	lastDeclaration:
	while (true) {
		if (!declarations.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			if (!declarations.b.b) {
				var x = declarations.a;
				return $elm$core$Maybe$Just(
					_List_fromArray(
						[x]));
			} else {
				var xs = declarations.b;
				var $temp$declarations = xs;
				declarations = $temp$declarations;
				continue lastDeclaration;
			}
		}
	}
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$oneOf = function (maybes) {
	oneOf:
	while (true) {
		if (!maybes.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			var maybe = maybes.a;
			var rest = maybes.b;
			if (maybe.$ === 1) {
				var $temp$maybes = rest;
				maybes = $temp$maybes;
				continue oneOf;
			} else {
				return maybe;
			}
		}
	}
};
var $rtfeldman$elm_css$Css$Structure$FontFeatureValues = function (a) {
	return {$: 9, a: a};
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveFontFeatureValues = function (tuples) {
	var expandTuples = function (tuplesToExpand) {
		if (!tuplesToExpand.b) {
			return _List_Nil;
		} else {
			var properties = tuplesToExpand.a;
			var rest = tuplesToExpand.b;
			return A2(
				$elm$core$List$cons,
				properties,
				expandTuples(rest));
		}
	};
	var newTuples = expandTuples(tuples);
	return _List_fromArray(
		[
			$rtfeldman$elm_css$Css$Structure$FontFeatureValues(newTuples)
		]);
};
var $rtfeldman$elm_css$Css$Structure$styleBlockToMediaRule = F2(
	function (mediaQueries, declaration) {
		if (!declaration.$) {
			var styleBlock = declaration.a;
			return A2(
				$rtfeldman$elm_css$Css$Structure$MediaRule,
				mediaQueries,
				_List_fromArray(
					[styleBlock]));
		} else {
			return declaration;
		}
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule = F5(
	function (str1, str2, str3, str4, declaration) {
		if (!declaration.$) {
			var structureStyleBlock = declaration.a;
			return A5($rtfeldman$elm_css$Css$Structure$DocumentRule, str1, str2, str3, str4, structureStyleBlock);
		} else {
			return declaration;
		}
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule = F2(
	function (mediaQueries, declaration) {
		switch (declaration.$) {
			case 0:
				var structureStyleBlock = declaration.a;
				return A2(
					$rtfeldman$elm_css$Css$Structure$MediaRule,
					mediaQueries,
					_List_fromArray(
						[structureStyleBlock]));
			case 1:
				var newMediaQueries = declaration.a;
				var structureStyleBlocks = declaration.b;
				return A2(
					$rtfeldman$elm_css$Css$Structure$MediaRule,
					_Utils_ap(mediaQueries, newMediaQueries),
					structureStyleBlocks);
			case 2:
				var str = declaration.a;
				var declarations = declaration.b;
				return A2(
					$rtfeldman$elm_css$Css$Structure$SupportsRule,
					str,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule(mediaQueries),
						declarations));
			case 3:
				var str1 = declaration.a;
				var str2 = declaration.b;
				var str3 = declaration.c;
				var str4 = declaration.d;
				var structureStyleBlock = declaration.e;
				return A5($rtfeldman$elm_css$Css$Structure$DocumentRule, str1, str2, str3, str4, structureStyleBlock);
			case 4:
				return declaration;
			case 5:
				return declaration;
			case 6:
				return declaration;
			case 7:
				return declaration;
			case 8:
				return declaration;
			default:
				return declaration;
		}
	});
var $rtfeldman$elm_css$Css$Preprocess$unwrapSnippet = function (_v0) {
	var declarations = _v0;
	return declarations;
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast = F4(
	function (nestedStyles, rest, f, declarations) {
		var withoutParent = function (decls) {
			return A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				$elm$core$List$tail(decls));
		};
		var nextResult = A2(
			$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
			rest,
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				$rtfeldman$elm_css$Css$Preprocess$Resolve$lastDeclaration(declarations)));
		var newDeclarations = function () {
			var _v14 = _Utils_Tuple2(
				$elm$core$List$head(nextResult),
				$rtfeldman$elm_css$Css$Preprocess$Resolve$last(declarations));
			if ((!_v14.a.$) && (!_v14.b.$)) {
				var nextResultParent = _v14.a.a;
				var originalParent = _v14.b.a;
				return _Utils_ap(
					A2(
						$elm$core$List$take,
						$elm$core$List$length(declarations) - 1,
						declarations),
					_List_fromArray(
						[
							(!_Utils_eq(originalParent, nextResultParent)) ? nextResultParent : originalParent
						]));
			} else {
				return declarations;
			}
		}();
		var insertStylesToNestedDecl = function (lastDecl) {
			return $elm$core$List$concat(
				A2(
					$rtfeldman$elm_css$Css$Structure$mapLast,
					$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles(nestedStyles),
					A2(
						$elm$core$List$map,
						$elm$core$List$singleton,
						A2($rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock, f, lastDecl))));
		};
		var initialResult = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				insertStylesToNestedDecl,
				$rtfeldman$elm_css$Css$Preprocess$Resolve$lastDeclaration(declarations)));
		return _Utils_ap(
			newDeclarations,
			_Utils_ap(
				withoutParent(initialResult),
				withoutParent(nextResult)));
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles = F2(
	function (styles, declarations) {
		if (!styles.b) {
			return declarations;
		} else {
			switch (styles.a.$) {
				case 0:
					var property = styles.a.a;
					var rest = styles.b;
					return A2(
						$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
						rest,
						A2($rtfeldman$elm_css$Css$Structure$appendProperty, property, declarations));
				case 1:
					var _v4 = styles.a;
					var selector = _v4.a;
					var nestedStyles = _v4.b;
					var rest = styles.b;
					return A4(
						$rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast,
						nestedStyles,
						rest,
						$rtfeldman$elm_css$Css$Structure$appendRepeatableToLastSelector(selector),
						declarations);
				case 2:
					var _v5 = styles.a;
					var selectorCombinator = _v5.a;
					var snippets = _v5.b;
					var rest = styles.b;
					var chain = F2(
						function (_v9, _v10) {
							var originalSequence = _v9.a;
							var originalTuples = _v9.b;
							var originalPseudoElement = _v9.c;
							var newSequence = _v10.a;
							var newTuples = _v10.b;
							var newPseudoElement = _v10.c;
							return A3(
								$rtfeldman$elm_css$Css$Structure$Selector,
								originalSequence,
								_Utils_ap(
									originalTuples,
									A2(
										$elm$core$List$cons,
										_Utils_Tuple2(selectorCombinator, newSequence),
										newTuples)),
								$rtfeldman$elm_css$Css$Preprocess$Resolve$oneOf(
									_List_fromArray(
										[newPseudoElement, originalPseudoElement])));
						});
					var expandDeclaration = function (declaration) {
						switch (declaration.$) {
							case 0:
								var _v7 = declaration.a;
								var firstSelector = _v7.a;
								var otherSelectors = _v7.b;
								var nestedStyles = _v7.c;
								var newSelectors = A2(
									$elm$core$List$concatMap,
									function (originalSelector) {
										return A2(
											$elm$core$List$map,
											chain(originalSelector),
											A2($elm$core$List$cons, firstSelector, otherSelectors));
									},
									$rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors(declarations));
								var newDeclarations = function () {
									if (!newSelectors.b) {
										return _List_Nil;
									} else {
										var first = newSelectors.a;
										var remainder = newSelectors.b;
										return _List_fromArray(
											[
												$rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
												A3($rtfeldman$elm_css$Css$Structure$StyleBlock, first, remainder, _List_Nil))
											]);
									}
								}();
								return A2($rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles, nestedStyles, newDeclarations);
							case 1:
								var mediaQueries = declaration.a;
								var styleBlocks = declaration.b;
								return A2($rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule, mediaQueries, styleBlocks);
							case 2:
								var str = declaration.a;
								var otherSnippets = declaration.b;
								return A2($rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule, str, otherSnippets);
							case 3:
								var str1 = declaration.a;
								var str2 = declaration.b;
								var str3 = declaration.c;
								var str4 = declaration.d;
								var styleBlock = declaration.e;
								return A2(
									$elm$core$List$map,
									A4($rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule, str1, str2, str3, str4),
									$rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock));
							case 4:
								var properties = declaration.a;
								return _List_fromArray(
									[
										$rtfeldman$elm_css$Css$Structure$PageRule(properties)
									]);
							case 5:
								var properties = declaration.a;
								return _List_fromArray(
									[
										$rtfeldman$elm_css$Css$Structure$FontFace(properties)
									]);
							case 6:
								var properties = declaration.a;
								return _List_fromArray(
									[
										$rtfeldman$elm_css$Css$Structure$Viewport(properties)
									]);
							case 7:
								var properties = declaration.a;
								return _List_fromArray(
									[
										$rtfeldman$elm_css$Css$Structure$CounterStyle(properties)
									]);
							default:
								var tuples = declaration.a;
								return $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveFontFeatureValues(tuples);
						}
					};
					return $elm$core$List$concat(
						_Utils_ap(
							_List_fromArray(
								[
									A2($rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles, rest, declarations)
								]),
							A2(
								$elm$core$List$map,
								expandDeclaration,
								A2($elm$core$List$concatMap, $rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, snippets))));
				case 3:
					var _v11 = styles.a;
					var pseudoElement = _v11.a;
					var nestedStyles = _v11.b;
					var rest = styles.b;
					return A4(
						$rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast,
						nestedStyles,
						rest,
						$rtfeldman$elm_css$Css$Structure$appendPseudoElementToLastSelector(pseudoElement),
						declarations);
				case 5:
					var str = styles.a.a;
					var rest = styles.b;
					var name = $rtfeldman$elm_css$Hash$fromString(str);
					var newProperty = 'animation-name:' + name;
					var newDeclarations = A2(
						$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
						rest,
						A2($rtfeldman$elm_css$Css$Structure$appendProperty, newProperty, declarations));
					return A2(
						$elm$core$List$append,
						newDeclarations,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$Structure$Keyframes(
								{aty: str, dY: name})
							]));
				case 4:
					var _v12 = styles.a;
					var mediaQueries = _v12.a;
					var nestedStyles = _v12.b;
					var rest = styles.b;
					var extraDeclarations = function () {
						var _v13 = $rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors(declarations);
						if (!_v13.b) {
							return _List_Nil;
						} else {
							var firstSelector = _v13.a;
							var otherSelectors = _v13.b;
							return A2(
								$elm$core$List$map,
								$rtfeldman$elm_css$Css$Structure$styleBlockToMediaRule(mediaQueries),
								A2(
									$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
									nestedStyles,
									$elm$core$List$singleton(
										$rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
											A3($rtfeldman$elm_css$Css$Structure$StyleBlock, firstSelector, otherSelectors, _List_Nil)))));
						}
					}();
					return _Utils_ap(
						A2($rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles, rest, declarations),
						extraDeclarations);
				default:
					var otherStyles = styles.a.a;
					var rest = styles.b;
					return A2(
						$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
						_Utils_ap(otherStyles, rest),
						declarations);
			}
		}
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock = function (_v2) {
	var firstSelector = _v2.a;
	var otherSelectors = _v2.b;
	var styles = _v2.c;
	return A2(
		$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
		styles,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
				A3($rtfeldman$elm_css$Css$Structure$StyleBlock, firstSelector, otherSelectors, _List_Nil))
			]));
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$extract = function (snippetDeclarations) {
	if (!snippetDeclarations.b) {
		return _List_Nil;
	} else {
		var first = snippetDeclarations.a;
		var rest = snippetDeclarations.b;
		return _Utils_ap(
			$rtfeldman$elm_css$Css$Preprocess$Resolve$toDeclarations(first),
			$rtfeldman$elm_css$Css$Preprocess$Resolve$extract(rest));
	}
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule = F2(
	function (mediaQueries, styleBlocks) {
		var handleStyleBlock = function (styleBlock) {
			return A2(
				$elm$core$List$map,
				$rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule(mediaQueries),
				$rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock));
		};
		return A2($elm$core$List$concatMap, handleStyleBlock, styleBlocks);
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule = F2(
	function (str, snippets) {
		var declarations = $rtfeldman$elm_css$Css$Preprocess$Resolve$extract(
			A2($elm$core$List$concatMap, $rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, snippets));
		return _List_fromArray(
			[
				A2($rtfeldman$elm_css$Css$Structure$SupportsRule, str, declarations)
			]);
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$toDeclarations = function (snippetDeclaration) {
	switch (snippetDeclaration.$) {
		case 0:
			var styleBlock = snippetDeclaration.a;
			return $rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock);
		case 1:
			var mediaQueries = snippetDeclaration.a;
			var styleBlocks = snippetDeclaration.b;
			return A2($rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule, mediaQueries, styleBlocks);
		case 2:
			var str = snippetDeclaration.a;
			var snippets = snippetDeclaration.b;
			return A2($rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule, str, snippets);
		case 3:
			var str1 = snippetDeclaration.a;
			var str2 = snippetDeclaration.b;
			var str3 = snippetDeclaration.c;
			var str4 = snippetDeclaration.d;
			var styleBlock = snippetDeclaration.e;
			return A2(
				$elm$core$List$map,
				A4($rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule, str1, str2, str3, str4),
				$rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock));
		case 4:
			var properties = snippetDeclaration.a;
			return _List_fromArray(
				[
					$rtfeldman$elm_css$Css$Structure$PageRule(properties)
				]);
		case 5:
			var properties = snippetDeclaration.a;
			return _List_fromArray(
				[
					$rtfeldman$elm_css$Css$Structure$FontFace(properties)
				]);
		case 6:
			var properties = snippetDeclaration.a;
			return _List_fromArray(
				[
					$rtfeldman$elm_css$Css$Structure$Viewport(properties)
				]);
		case 7:
			var properties = snippetDeclaration.a;
			return _List_fromArray(
				[
					$rtfeldman$elm_css$Css$Structure$CounterStyle(properties)
				]);
		default:
			var tuples = snippetDeclaration.a;
			return $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveFontFeatureValues(tuples);
	}
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$toStructure = function (_v0) {
	var charset = _v0.qh;
	var imports = _v0.NE;
	var namespaces = _v0.Uf;
	var snippets = _v0.aiN;
	var declarations = $rtfeldman$elm_css$Css$Preprocess$Resolve$extract(
		A2($elm$core$List$concatMap, $rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, snippets));
	return {qh: charset, atz: declarations, NE: imports, Uf: namespaces};
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$compile = function (sheet) {
	return $rtfeldman$elm_css$Css$Structure$Output$prettyPrint(
		$rtfeldman$elm_css$Css$Structure$compactStylesheet(
			$rtfeldman$elm_css$Css$Preprocess$Resolve$toStructure(sheet)));
};
var $rtfeldman$elm_css$Css$Preprocess$Snippet = $elm$core$Basics$identity;
var $rtfeldman$elm_css$Css$Preprocess$StyleBlock = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $rtfeldman$elm_css$Css$Preprocess$StyleBlockDeclaration = function (a) {
	return {$: 0, a: a};
};
var $rtfeldman$elm_css$VirtualDom$Styled$makeSnippet = F2(
	function (styles, sequence) {
		var selector = A3($rtfeldman$elm_css$Css$Structure$Selector, sequence, _List_Nil, $elm$core$Maybe$Nothing);
		return _List_fromArray(
			[
				$rtfeldman$elm_css$Css$Preprocess$StyleBlockDeclaration(
				A3($rtfeldman$elm_css$Css$Preprocess$StyleBlock, selector, _List_Nil, styles))
			]);
	});
var $rtfeldman$elm_css$Css$Preprocess$stylesheet = function (snippets) {
	return {qh: $elm$core$Maybe$Nothing, NE: _List_Nil, Uf: _List_Nil, aiN: snippets};
};
var $rtfeldman$elm_css$Css$Structure$ClassSelector = function (a) {
	return {$: 0, a: a};
};
var $rtfeldman$elm_css$VirtualDom$Styled$classnameStandin = '\u0007';
var $rtfeldman$elm_css$VirtualDom$Styled$templateSelector = $rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$Structure$ClassSelector($rtfeldman$elm_css$VirtualDom$Styled$classnameStandin)
		]));
var $rtfeldman$elm_css$VirtualDom$Styled$getCssTemplate = function (styles) {
	if (!styles.b) {
		return '';
	} else {
		var otherwise = styles;
		return $rtfeldman$elm_css$Css$Preprocess$Resolve$compile(
			$rtfeldman$elm_css$Css$Preprocess$stylesheet(
				_List_fromArray(
					[
						A2($rtfeldman$elm_css$VirtualDom$Styled$makeSnippet, styles, $rtfeldman$elm_css$VirtualDom$Styled$templateSelector)
					])));
	}
};
var $rtfeldman$elm_css$Html$Styled$Internal$css = function (styles) {
	var cssTemplate = $rtfeldman$elm_css$VirtualDom$Styled$getCssTemplate(styles);
	var classProperty = A2($elm$virtual_dom$VirtualDom$attribute, '', '');
	return A3($rtfeldman$elm_css$VirtualDom$Styled$Attribute, classProperty, true, cssTemplate);
};
var $rtfeldman$elm_css$Html$Styled$Attributes$css = $rtfeldman$elm_css$Html$Styled$Internal$css;
var $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty = F2(
	function (key, bool) {
		return A2(
			$rtfeldman$elm_css$VirtualDom$Styled$property,
			key,
			$elm$json$Json$Encode$bool(bool));
	});
var $rtfeldman$elm_css$Html$Styled$Attributes$disabled = $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty('disabled');
var $rtfeldman$elm_css$VirtualDom$Styled$on = F2(
	function (eventName, handler) {
		return A3(
			$rtfeldman$elm_css$VirtualDom$Styled$Attribute,
			A2($elm$virtual_dom$VirtualDom$on, eventName, handler),
			false,
			'');
	});
var $rtfeldman$elm_css$Html$Styled$Events$on = F2(
	function (event, decoder) {
		return A2(
			$rtfeldman$elm_css$VirtualDom$Styled$on,
			event,
			$elm$virtual_dom$VirtualDom$Normal(decoder));
	});
var $rtfeldman$elm_css$Html$Styled$Events$onClick = function (msg) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$Events$on,
		'click',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$Component$Button$btnDisabled = $rtfeldman$elm_css$Css$hex('c8ecec');
var $author$project$Component$Button$btnDisabledText = $rtfeldman$elm_css$Css$hex('46606c');
var $rtfeldman$elm_css$Css$disabled = $rtfeldman$elm_css$Css$pseudoClass('disabled');
var $rtfeldman$elm_css$Css$notAllowed = {b: 0, ey: 'not-allowed'};
var $author$project$Component$Button$stateStyle = function (state) {
	if (!state) {
		return $rtfeldman$elm_css$Css$batch(
			_List_fromArray(
				[
					A3(
					$rtfeldman$elm_css$Css$border3,
					$rtfeldman$elm_css$Css$px(1),
					$rtfeldman$elm_css$Css$solid,
					$author$project$Component$Button$btnDisabled),
					$rtfeldman$elm_css$Css$backgroundColor($author$project$Component$Button$btnDisabled),
					$rtfeldman$elm_css$Css$disabled(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$color($author$project$Component$Button$btnDisabledText)
						])),
					$rtfeldman$elm_css$Css$hover(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$notAllowed),
							A3(
							$rtfeldman$elm_css$Css$border3,
							$rtfeldman$elm_css$Css$px(1),
							$rtfeldman$elm_css$Css$solid,
							$author$project$Component$Button$btnDisabled),
							$rtfeldman$elm_css$Css$backgroundColor($author$project$Component$Button$btnDisabled)
						]))
				]));
	} else {
		return $rtfeldman$elm_css$Css$batch(_List_Nil);
	}
};
var $rtfeldman$elm_css$VirtualDom$Styled$UnscopedStyles = function (a) {
	return {$: 0, a: a};
};
var $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles = F2(
	function (_v0, styles) {
		var isCssStyles = _v0.b;
		var cssTemplate = _v0.c;
		if (isCssStyles) {
			var _v1 = A2($elm$core$Dict$get, cssTemplate, styles);
			if (!_v1.$) {
				return styles;
			} else {
				return A3(
					$elm$core$Dict$insert,
					cssTemplate,
					$rtfeldman$elm_css$Hash$fromString(cssTemplate),
					styles);
			}
		} else {
			return styles;
		}
	});
var $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute = F2(
	function (styles, _v0) {
		var val = _v0.a;
		var isCssStyles = _v0.b;
		var cssTemplate = _v0.c;
		if (isCssStyles) {
			var _v1 = A2($elm$core$Dict$get, cssTemplate, styles);
			if (!_v1.$) {
				var classname = _v1.a;
				return A2(
					$elm$virtual_dom$VirtualDom$property,
					'className',
					$elm$json$Json$Encode$string(classname));
			} else {
				return A2(
					$elm$virtual_dom$VirtualDom$property,
					'className',
					$elm$json$Json$Encode$string('_unstyled'));
			}
		} else {
			return val;
		}
	});
var $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttributeNS = F2(
	function (styles, _v0) {
		var val = _v0.a;
		var isCssStyles = _v0.b;
		var cssTemplate = _v0.c;
		if (isCssStyles) {
			var _v1 = A2($elm$core$Dict$get, cssTemplate, styles);
			if (!_v1.$) {
				var classname = _v1.a;
				return A2($elm$virtual_dom$VirtualDom$attribute, 'class', classname);
			} else {
				return A2($elm$virtual_dom$VirtualDom$attribute, 'class', '_unstyled');
			}
		} else {
			return val;
		}
	});
var $elm$virtual_dom$VirtualDom$keyedNodeNS = F2(
	function (namespace, tag) {
		return A2(
			_VirtualDom_keyedNodeNS,
			namespace,
			_VirtualDom_noScript(tag));
	});
var $elm$virtual_dom$VirtualDom$nodeNS = function (tag) {
	return _VirtualDom_nodeNS(
		_VirtualDom_noScript(tag));
};
var $rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml = F2(
	function (_v6, _v7) {
		var key = _v6.a;
		var html = _v6.b;
		var pairs = _v7.a;
		var styles = _v7.b;
		switch (html.$) {
			case 4:
				var vdom = html.a;
				return _Utils_Tuple2(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(key, vdom),
						pairs),
					styles);
			case 0:
				var elemType = html.a;
				var properties = html.b;
				var children = html.c;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v9 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v9.a;
				var finalStyles = _v9.b;
				var vdom = A3(
					$elm$virtual_dom$VirtualDom$node,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute(finalStyles),
						properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(key, vdom),
						pairs),
					finalStyles);
			case 1:
				var ns = html.a;
				var elemType = html.b;
				var properties = html.c;
				var children = html.d;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v10 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v10.a;
				var finalStyles = _v10.b;
				var vdom = A4(
					$elm$virtual_dom$VirtualDom$nodeNS,
					ns,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute(finalStyles),
						properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(key, vdom),
						pairs),
					finalStyles);
			case 2:
				var elemType = html.a;
				var properties = html.b;
				var children = html.c;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v11 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v11.a;
				var finalStyles = _v11.b;
				var vdom = A3(
					$elm$virtual_dom$VirtualDom$keyedNode,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute(finalStyles),
						properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(key, vdom),
						pairs),
					finalStyles);
			default:
				var ns = html.a;
				var elemType = html.b;
				var properties = html.c;
				var children = html.d;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v12 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v12.a;
				var finalStyles = _v12.b;
				var vdom = A4(
					$elm$virtual_dom$VirtualDom$keyedNodeNS,
					ns,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute(finalStyles),
						properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(key, vdom),
						pairs),
					finalStyles);
		}
	});
var $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml = F2(
	function (html, _v0) {
		var nodes = _v0.a;
		var styles = _v0.b;
		switch (html.$) {
			case 4:
				var vdomNode = html.a;
				return _Utils_Tuple2(
					A2($elm$core$List$cons, vdomNode, nodes),
					styles);
			case 0:
				var elemType = html.a;
				var properties = html.b;
				var children = html.c;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v2 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v2.a;
				var finalStyles = _v2.b;
				var vdomNode = A3(
					$elm$virtual_dom$VirtualDom$node,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute(finalStyles),
						properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2($elm$core$List$cons, vdomNode, nodes),
					finalStyles);
			case 1:
				var ns = html.a;
				var elemType = html.b;
				var properties = html.c;
				var children = html.d;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v3 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v3.a;
				var finalStyles = _v3.b;
				var vdomNode = A4(
					$elm$virtual_dom$VirtualDom$nodeNS,
					ns,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttributeNS(finalStyles),
						properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2($elm$core$List$cons, vdomNode, nodes),
					finalStyles);
			case 2:
				var elemType = html.a;
				var properties = html.b;
				var children = html.c;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v4 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v4.a;
				var finalStyles = _v4.b;
				var vdomNode = A3(
					$elm$virtual_dom$VirtualDom$keyedNode,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute(finalStyles),
						properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2($elm$core$List$cons, vdomNode, nodes),
					finalStyles);
			default:
				var ns = html.a;
				var elemType = html.b;
				var properties = html.c;
				var children = html.d;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v5 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v5.a;
				var finalStyles = _v5.b;
				var vdomNode = A4(
					$elm$virtual_dom$VirtualDom$keyedNodeNS,
					ns,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttributeNS(finalStyles),
						properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2($elm$core$List$cons, vdomNode, nodes),
					finalStyles);
		}
	});
var $rtfeldman$elm_css$VirtualDom$Styled$styleToDeclaration = F3(
	function (template, classname, declaration) {
		return declaration + ('\n' + A3($elm$core$String$replace, $rtfeldman$elm_css$VirtualDom$Styled$classnameStandin, classname, template));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$toDeclaration = function (dict) {
	return A3($elm$core$Dict$foldl, $rtfeldman$elm_css$VirtualDom$Styled$styleToDeclaration, '', dict);
};
var $rtfeldman$elm_css$VirtualDom$Styled$toScopedDeclaration = F2(
	function (scopingPrefix, dict) {
		return A3(
			$elm$core$Dict$foldl,
			F3(
				function (template, classname, declaration) {
					return declaration + ('\n' + A3($elm$core$String$replace, '.' + $rtfeldman$elm_css$VirtualDom$Styled$classnameStandin, '#' + (scopingPrefix + ('.' + classname)), template));
				}),
			'',
			dict);
	});
var $rtfeldman$elm_css$VirtualDom$Styled$toStyleNode = F2(
	function (maybeNonce, accumulatedStyles) {
		var cssText = function () {
			if (!accumulatedStyles.$) {
				var allStyles = accumulatedStyles.a;
				return $rtfeldman$elm_css$VirtualDom$Styled$toDeclaration(allStyles);
			} else {
				var scope = accumulatedStyles.a;
				var rootStyles = accumulatedStyles.b;
				var descendantStyles = accumulatedStyles.c;
				return A2($rtfeldman$elm_css$VirtualDom$Styled$toScopedDeclaration, scope, rootStyles) + ('\n' + A2($rtfeldman$elm_css$VirtualDom$Styled$toScopedDeclaration, scope + ' ', descendantStyles));
			}
		}();
		return A3(
			$elm$virtual_dom$VirtualDom$node,
			'span',
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'style', 'display: none;'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'class', 'elm-css-style-wrapper')
				]),
			_List_fromArray(
				[
					A3(
					$elm$virtual_dom$VirtualDom$node,
					'style',
					function () {
						if (!maybeNonce.$) {
							var nonce = maybeNonce.a;
							return _List_fromArray(
								[
									A2($elm$virtual_dom$VirtualDom$attribute, 'nonce', nonce)
								]);
						} else {
							return _List_Nil;
						}
					}(),
					$elm$core$List$singleton(
						$elm$virtual_dom$VirtualDom$text(cssText)))
				]));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$unstyle = F4(
	function (maybeNonce, elemType, properties, children) {
		var initialStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, $elm$core$Dict$empty, properties);
		var _v0 = A3(
			$elm$core$List$foldl,
			$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
			_Utils_Tuple2(_List_Nil, initialStyles),
			children);
		var childNodes = _v0.a;
		var styles = _v0.b;
		var styleNode = A2(
			$rtfeldman$elm_css$VirtualDom$Styled$toStyleNode,
			maybeNonce,
			$rtfeldman$elm_css$VirtualDom$Styled$UnscopedStyles(styles));
		var unstyledProperties = A2(
			$elm$core$List$map,
			$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute(styles),
			properties);
		return A3(
			$elm$virtual_dom$VirtualDom$node,
			elemType,
			unstyledProperties,
			A2(
				$elm$core$List$cons,
				styleNode,
				$elm$core$List$reverse(childNodes)));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$containsKey = F2(
	function (key, pairs) {
		containsKey:
		while (true) {
			if (!pairs.b) {
				return false;
			} else {
				var _v1 = pairs.a;
				var str = _v1.a;
				var rest = pairs.b;
				if (_Utils_eq(key, str)) {
					return true;
				} else {
					var $temp$key = key,
						$temp$pairs = rest;
					key = $temp$key;
					pairs = $temp$pairs;
					continue containsKey;
				}
			}
		}
	});
var $rtfeldman$elm_css$VirtualDom$Styled$getUnusedKey = F2(
	function (_default, pairs) {
		getUnusedKey:
		while (true) {
			if (!pairs.b) {
				return _default;
			} else {
				var _v1 = pairs.a;
				var firstKey = _v1.a;
				var rest = pairs.b;
				var newKey = '_' + firstKey;
				if (A2($rtfeldman$elm_css$VirtualDom$Styled$containsKey, newKey, rest)) {
					var $temp$default = newKey,
						$temp$pairs = rest;
					_default = $temp$default;
					pairs = $temp$pairs;
					continue getUnusedKey;
				} else {
					return newKey;
				}
			}
		}
	});
var $rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode = F3(
	function (maybeNonce, accumulatedStyles, keyedChildNodes) {
		var styleNodeKey = A2($rtfeldman$elm_css$VirtualDom$Styled$getUnusedKey, '_', keyedChildNodes);
		var finalNode = A2($rtfeldman$elm_css$VirtualDom$Styled$toStyleNode, maybeNonce, accumulatedStyles);
		return _Utils_Tuple2(styleNodeKey, finalNode);
	});
var $rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyed = F4(
	function (maybeNonce, elemType, properties, keyedChildren) {
		var initialStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, $elm$core$Dict$empty, properties);
		var _v0 = A3(
			$elm$core$List$foldl,
			$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
			_Utils_Tuple2(_List_Nil, initialStyles),
			keyedChildren);
		var keyedChildNodes = _v0.a;
		var styles = _v0.b;
		var keyedStyleNode = A3(
			$rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode,
			maybeNonce,
			$rtfeldman$elm_css$VirtualDom$Styled$UnscopedStyles(styles),
			keyedChildNodes);
		var unstyledProperties = A2(
			$elm$core$List$map,
			$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute(styles),
			properties);
		return A3(
			$elm$virtual_dom$VirtualDom$keyedNode,
			elemType,
			unstyledProperties,
			A2(
				$elm$core$List$cons,
				keyedStyleNode,
				$elm$core$List$reverse(keyedChildNodes)));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyedNS = F5(
	function (maybeNonce, ns, elemType, properties, keyedChildren) {
		var initialStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, $elm$core$Dict$empty, properties);
		var _v0 = A3(
			$elm$core$List$foldl,
			$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
			_Utils_Tuple2(_List_Nil, initialStyles),
			keyedChildren);
		var keyedChildNodes = _v0.a;
		var styles = _v0.b;
		var keyedStyleNode = A3(
			$rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode,
			maybeNonce,
			$rtfeldman$elm_css$VirtualDom$Styled$UnscopedStyles(styles),
			keyedChildNodes);
		var unstyledProperties = A2(
			$elm$core$List$map,
			$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttributeNS(styles),
			properties);
		return A4(
			$elm$virtual_dom$VirtualDom$keyedNodeNS,
			ns,
			elemType,
			unstyledProperties,
			A2(
				$elm$core$List$cons,
				keyedStyleNode,
				$elm$core$List$reverse(keyedChildNodes)));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$unstyleNS = F5(
	function (maybeNonce, ns, elemType, properties, children) {
		var initialStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, $elm$core$Dict$empty, properties);
		var _v0 = A3(
			$elm$core$List$foldl,
			$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
			_Utils_Tuple2(_List_Nil, initialStyles),
			children);
		var childNodes = _v0.a;
		var styles = _v0.b;
		var styleNode = A2(
			$rtfeldman$elm_css$VirtualDom$Styled$toStyleNode,
			maybeNonce,
			$rtfeldman$elm_css$VirtualDom$Styled$UnscopedStyles(styles));
		var unstyledProperties = A2(
			$elm$core$List$map,
			$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttributeNS(styles),
			properties);
		return A4(
			$elm$virtual_dom$VirtualDom$nodeNS,
			ns,
			elemType,
			unstyledProperties,
			A2(
				$elm$core$List$cons,
				styleNode,
				$elm$core$List$reverse(childNodes)));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$toUnstyled = function (vdom) {
	switch (vdom.$) {
		case 4:
			var plainNode = vdom.a;
			return plainNode;
		case 0:
			var elemType = vdom.a;
			var properties = vdom.b;
			var children = vdom.c;
			return A4($rtfeldman$elm_css$VirtualDom$Styled$unstyle, $elm$core$Maybe$Nothing, elemType, properties, children);
		case 1:
			var ns = vdom.a;
			var elemType = vdom.b;
			var properties = vdom.c;
			var children = vdom.d;
			return A5($rtfeldman$elm_css$VirtualDom$Styled$unstyleNS, $elm$core$Maybe$Nothing, ns, elemType, properties, children);
		case 2:
			var elemType = vdom.a;
			var properties = vdom.b;
			var children = vdom.c;
			return A4($rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyed, $elm$core$Maybe$Nothing, elemType, properties, children);
		default:
			var ns = vdom.a;
			var elemType = vdom.b;
			var properties = vdom.c;
			var children = vdom.d;
			return A5($rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyedNS, $elm$core$Maybe$Nothing, ns, elemType, properties, children);
	}
};
var $rtfeldman$elm_css$Html$Styled$toUnstyled = $rtfeldman$elm_css$VirtualDom$Styled$toUnstyled;
var $rtfeldman$elm_css$Html$Styled$Attributes$type_ = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('type');
var $rtfeldman$elm_css$VirtualDom$Styled$unstyledNode = $rtfeldman$elm_css$VirtualDom$Styled$Unstyled;
var $rtfeldman$elm_css$Html$Styled$fromUnstyled = $rtfeldman$elm_css$VirtualDom$Styled$unstyledNode;
var $rtfeldman$elm_css$Css$marginLeft = $rtfeldman$elm_css$Css$prop1('margin-left');
var $rtfeldman$elm_css$Html$Styled$span = $rtfeldman$elm_css$Html$Styled$node('span');
var $author$project$Component$Button$viewButtonIcon = F3(
	function (style, icon, label_) {
		var toIcon = function () {
			if (!style) {
				return $author$project$View$Icon$viewMasked(0);
			} else {
				return $author$project$View$Icon$viewMasked(2);
			}
		}();
		switch (icon.$) {
			case 0:
				return label_;
			case 2:
				var iconPath = icon.a;
				return A2(
					$elm$core$List$cons,
					A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('btn-icon'),
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Css$marginRight(
										$rtfeldman$elm_css$Css$px(10))
									]))
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$fromUnstyled(
								toIcon(iconPath))
							])),
					label_);
			case 1:
				var iconPath = icon.a;
				return _Utils_ap(
					label_,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('btn-icon'),
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Css$marginLeft(
											$rtfeldman$elm_css$Css$px(10))
										]))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$fromUnstyled(
									toIcon(iconPath))
								]))
						]));
			default:
				var iconPath = icon.a;
				return A2(
					$elm$core$List$cons,
					A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('btn-icon')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$fromUnstyled(
								toIcon(iconPath))
							])),
					label_);
		}
	});
var $author$project$Component$Button$viewButton = function (_v0) {
	var config = _v0;
	var onClickAttributes = function () {
		var _v3 = config.cC;
		if (!_v3.$) {
			var message = _v3.a;
			return _List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Events$onClick(message)
				]);
		} else {
			return _List_Nil;
		}
	}();
	var isDisabled = function () {
		var _v2 = config.aX;
		switch (_v2) {
			case 1:
				return false;
			case 0:
				return true;
			default:
				return true;
		}
	}();
	var alignmentStyle = function () {
		var _v1 = config.by;
		if (!_v1.$) {
			var alignment = _v1.a;
			return $author$project$Component$Button$buttonAlignmentToClass(alignment);
		} else {
			return $rtfeldman$elm_css$Css$batch(_List_Nil);
		}
	}();
	var combinedStyles = _List_fromArray(
		[
			$rtfeldman$elm_css$Css$batch(
			_Utils_ap(
				_List_fromArray(
					[
						$author$project$Component$Button$btn,
						alignmentStyle,
						$author$project$Component$Button$buttonWidthToCss(config.cb),
						$author$project$Component$Button$buttonStyleToCss(config.ao),
						$author$project$Component$Button$buttonVariantToCss(config.ao),
						$author$project$Component$Button$stateStyle(config.aX)
					]),
				config.cj))
		]);
	var buttonAttributes = _Utils_ap(
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(combinedStyles),
				$rtfeldman$elm_css$Html$Styled$Attributes$disabled(isDisabled),
				$rtfeldman$elm_css$Html$Styled$Attributes$class('btn'),
				$rtfeldman$elm_css$Html$Styled$Attributes$class(config.dc),
				$rtfeldman$elm_css$Html$Styled$Attributes$type_(
				$author$project$Component$Button$buttonTypeToString(config.bB))
			]),
		onClickAttributes);
	return $rtfeldman$elm_css$Html$Styled$toUnstyled(
		A2(
			$rtfeldman$elm_css$Html$Styled$button,
			buttonAttributes,
			A3($author$project$Component$Button$viewButtonIcon, config.ao, config.bb, config.bO)));
};
var $author$project$Component$Button$view = F2(
	function (name, attributes) {
		return $author$project$Component$Button$viewButton(
			A3(
				$elm$core$List$foldl,
				F2(
					function (_v0, b) {
						var attribute = _v0;
						return attribute(b);
					}),
				$author$project$Component$Button$build,
				A2(
					$elm$core$List$cons,
					$author$project$Component$Button$label(name),
					attributes)));
	});
var $rtfeldman$elm_css$Css$padding = $rtfeldman$elm_css$Css$prop1('padding');
var $author$project$Component$Button$onlyIconButtonStyle = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(0)),
			$rtfeldman$elm_css$Css$backgroundColor($rtfeldman$elm_css$Css$transparent)
		]));
var $author$project$Component$Button$viewIconButton = function (_v0) {
	var config = _v0;
	var onClickAttributes = function () {
		var _v1 = config.cC;
		if (!_v1.$) {
			var message = _v1.a;
			return _List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Events$onClick(message)
				]);
		} else {
			return _List_Nil;
		}
	}();
	var iconStyle = A2(
		$elm$core$List$cons,
		$rtfeldman$elm_css$Css$batch(
			_List_fromArray(
				[$author$project$Component$Button$onlyIconButtonStyle])),
		config.cj);
	var buttonAttributes = _Utils_ap(
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(iconStyle),
				$rtfeldman$elm_css$Html$Styled$Attributes$type_(
				$author$project$Component$Button$buttonTypeToString(config.bB))
			]),
		onClickAttributes);
	return $rtfeldman$elm_css$Html$Styled$toUnstyled(
		A2(
			$rtfeldman$elm_css$Html$Styled$button,
			buttonAttributes,
			A3($author$project$Component$Button$viewButtonIcon, config.ao, config.bb, config.bO)));
};
var $author$project$Component$Button$viewIcon = function (attributes) {
	return $author$project$Component$Button$viewIconButton(
		A3(
			$elm$core$List$foldl,
			F2(
				function (_v0, b) {
					var attribute = _v0;
					return attribute(b);
				}),
			$author$project$Component$Button$build,
			attributes));
};
var $author$project$Component$Modal$Confirm$view = F2(
	function (config, confirm) {
		if (confirm.$ === 1) {
			return $elm$html$Html$text('');
		} else {
			var a = confirm.a;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('confirm-modal open')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('modal-background'),
								$elm$html$Html$Events$onClick(
								config.bf($author$project$Component$Modal$Confirm$Close))
							]),
						_List_Nil),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('modal-card')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('modal-card-header')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$h2,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(
												config.Mm(a))
											])),
										$author$project$Component$Button$viewIcon(
										_List_fromArray(
											[
												$author$project$Component$Button$onlyIcon($author$project$View$Icon$path.auZ),
												$author$project$Component$Button$onClick(
												config.bf($author$project$Component$Modal$Confirm$Close))
											]))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('modal-card-body')
									]),
								$author$project$Util$Html$parse(
									config._(a))),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('modal-card-footer')
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Component$Button$view,
										$author$project$Copy$copy.atc,
										_List_fromArray(
											[
												$author$project$Component$Button$outlinePrimary,
												$author$project$Component$Button$onClick(
												config.bf($author$project$Component$Modal$Confirm$Close)),
												$author$project$Component$Button$customCss(
												_List_fromArray(
													[
														$rtfeldman$elm_css$Css$marginRight(
														$rtfeldman$elm_css$Css$px(10))
													]))
											])),
										A2(
										$author$project$Component$Button$view,
										A2(
											$elm$core$Maybe$withDefault,
											$author$project$Copy$copy.atC,
											A2(
												$elm$core$Maybe$map,
												function (f) {
													return f(a);
												},
												config.sa)),
										_List_fromArray(
											[
												$author$project$Component$Button$primary,
												$author$project$Component$Button$onClick(
												config.X0(a))
											]))
									]))
							]))
					]));
		}
	});
var $author$project$Component$Notifications$viewSnack = F2(
	function (removeNotificationMsg, _v0) {
		var id = _v0.a;
		var description = _v0.b.dn;
		return _Utils_Tuple2(
			$elm$core$String$fromInt(id),
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('snackbar__snack')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(description)
							])),
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick(
								removeNotificationMsg(id)),
								$elm$html$Html$Attributes$class('remove')
							]),
						_List_fromArray(
							[
								$author$project$View$Icon$viewColored($author$project$View$Icon$path.auZ)
							]))
					])));
	});
var $author$project$Component$Notifications$viewAsSnackbar = F2(
	function (removeNotificationMsg, _v0) {
		var notifications = _v0.b;
		return A2(
			$author$project$Util$View$viewIfNot,
			$elm$core$List$isEmpty(notifications),
			function (_v1) {
				return A3(
					$elm$html$Html$Keyed$node,
					'div',
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('snackbar')
						]),
					A2(
						$elm$core$List$map,
						$author$project$Component$Notifications$viewSnack(removeNotificationMsg),
						notifications));
			});
	});
var $author$project$Model$Translation$noUploadsFound = 'no-uploads-found';
var $author$project$Model$Translation$noUploadsFoundDescription = 'no-uploads-found-description';
var $author$project$Data$Entity$id = function (_v0) {
	var a = _v0.a;
	return a;
};
var $author$project$Model$Translation$caption = 'caption';
var $author$project$Model$Translation$feedback = 'feedback';
var $author$project$Component$Button$Right = function (a) {
	return {$: 1, a: a};
};
var $author$project$Component$Button$iconRight = function (iconPath) {
	return $author$project$Component$Button$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{
					bb: $author$project$Component$Button$Right(iconPath)
				});
		});
};
var $author$project$Model$Translation$noFeedbackYet = 'no-feedback-yet';
var $author$project$Component$Modal$Confirm$Show = function (a) {
	return {$: 1, a: a};
};
var $author$project$Component$Modal$Confirm$show = F2(
	function (_v0, a) {
		var liftMsg = _v0.bf;
		return liftMsg(
			$author$project$Component$Modal$Confirm$Show(a));
	});
var $author$project$Model$Translation$tags = 'tags';
var $author$project$Component$Button$unboundedWidth = $author$project$Component$Button$set(
	function (attributes) {
		return _Utils_update(
			attributes,
			{cb: 1});
	});
var $author$project$ShareToolEmployeeContentCollection$viewContentItemTag = function (_v0) {
	var tag = _v0.b;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('ec-item__body__tag')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(tag.bO)
			]));
};
var $author$project$ShareToolEmployeeContentCollection$viewContentItemTags = function (tags) {
	return $elm$core$List$isEmpty(tags) ? A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('-')
			])) : A2(
		$elm$html$Html$ul,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('ec-item__body__tags')
			]),
		A2($elm$core$List$map, $author$project$ShareToolEmployeeContentCollection$viewContentItemTag, tags));
};
var $author$project$Component$VideoPlayer$Attribute = $elm$core$Basics$identity;
var $author$project$Component$VideoPlayer$VideoPlayer = $elm$core$Basics$identity;
var $author$project$Component$VideoPlayer$set = function (_with) {
	return function (_v0) {
		var config = _v0;
		return _with(config);
	};
};
var $author$project$Component$VideoPlayer$controls = function (showControls) {
	return $author$project$Component$VideoPlayer$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{dh: showControls});
		});
};
var $author$project$Data$FilePath$AudioFilePath = function (a) {
	return {$: 3, a: a};
};
var $author$project$Data$FilePath$FilePath = $elm$core$Basics$identity;
var $author$project$Data$FilePath$ImageFilePath = function (a) {
	return {$: 2, a: a};
};
var $author$project$Data$FilePath$PdfFilePath = function (a) {
	return {$: 1, a: a};
};
var $author$project$Data$FilePath$UnknownFilePath = function (a) {
	return {$: 4, a: a};
};
var $author$project$Data$FilePath$VideoFilePath = function (a) {
	return {$: 0, a: a};
};
var $author$project$Data$MimeType$audioFileExtensions = $elm$core$Set$fromList(
	_List_fromArray(
		['mp3', 'wav']));
var $author$project$Data$MimeType$isAudio = function (mediaItem) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function (extension) {
				return A2($elm$core$Set$member, extension, $author$project$Data$MimeType$audioFileExtensions);
			},
			$author$project$Data$MimeType$toFileExtension(mediaItem)));
};
var $author$project$Data$MimeType$pdfFileExtensions = $elm$core$Set$fromList(
	_List_fromArray(
		['pdf']));
var $author$project$Data$MimeType$isPdf = function (mediaItem) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function (extension) {
				return A2($elm$core$Set$member, extension, $author$project$Data$MimeType$pdfFileExtensions);
			},
			$author$project$Data$MimeType$toFileExtension(mediaItem)));
};
var $author$project$Data$MimeType$videoFileExtensions = $elm$core$Set$fromList(
	_List_fromArray(
		['mp4', 'mov', 'flv', 'avi']));
var $author$project$Data$MimeType$isVideo = function (mediaItem) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function (extension) {
				return A2($elm$core$Set$member, extension, $author$project$Data$MimeType$videoFileExtensions);
			},
			$author$project$Data$MimeType$toFileExtension(mediaItem)));
};
var $author$project$Data$MimeType$fromString = function (fileName) {
	return $author$project$Data$MimeType$isImage(fileName) ? $elm$core$Maybe$Just(0) : ($author$project$Data$MimeType$isPdf(fileName) ? $elm$core$Maybe$Just(1) : ($author$project$Data$MimeType$isVideo(fileName) ? $elm$core$Maybe$Just(2) : ($author$project$Data$MimeType$isSvg(fileName) ? $elm$core$Maybe$Just(3) : ($author$project$Data$MimeType$isAudio(fileName) ? $elm$core$Maybe$Just(4) : $elm$core$Maybe$Nothing))));
};
var $author$project$Data$FilePath$fromString = function (path) {
	var _v0 = _Utils_Tuple2(
		A2($elm$core$String$startsWith, '/', path),
		$author$project$Data$MimeType$fromString(path));
	if ((!_v0.a) && (!_v0.b.$)) {
		switch (_v0.b.a) {
			case 2:
				var _v1 = _v0.b.a;
				return $author$project$Data$FilePath$VideoFilePath(path);
			case 1:
				var _v2 = _v0.b.a;
				return $author$project$Data$FilePath$PdfFilePath(path);
			case 0:
				var _v3 = _v0.b.a;
				return $author$project$Data$FilePath$ImageFilePath(path);
			case 3:
				var _v4 = _v0.b.a;
				return $author$project$Data$FilePath$ImageFilePath(path);
			default:
				var _v5 = _v0.b.a;
				return $author$project$Data$FilePath$AudioFilePath(path);
		}
	} else {
		return $author$project$Data$FilePath$UnknownFilePath(path);
	}
};
var $author$project$Component$VideoPlayer$src = function (path) {
	return $author$project$Component$VideoPlayer$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{
					ek: $elm$core$Maybe$Just(path)
				});
		});
};
var $author$project$Util$Url$staticUrl = function (val) {
	return A2(
		$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
		'/static/uploads/{0}',
		_List_fromArray(
			[val]));
};
var $author$project$Data$FilePath$toStaticUrl = function (_v0) {
	var path = _v0;
	return A2(
		$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
		'/static/uploads/{0}',
		_List_fromArray(
			[path]));
};
var $author$project$Data$FilePath$toString = function (_v0) {
	var a = _v0;
	return a;
};
var $author$project$Component$VideoPlayer$build = {c6: false, db: '', dh: false, dX: false, d6: true, ek: $elm$core$Maybe$Nothing};
var $elm$html$Html$source = _VirtualDom_node('source');
var $author$project$Component$VideoPlayer$viewPlayer = function (_v0) {
	var config = _v0;
	var boolToString = function (bool) {
		return bool ? 'true' : 'false';
	};
	return A2(
		$author$project$Util$View$viewMaybe,
		config.ek,
		function (src_) {
			return A2(
				$elm$html$Html$video,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$autoplay(config.c6),
						$elm$html$Html$Attributes$controls(config.dh),
						A2(
						$elm$html$Html$Attributes$attribute,
						'muted',
						boolToString(config.dX)),
						$elm$html$Html$Attributes$class(config.db),
						A2(
						$elm$html$Html$Attributes$attribute,
						'playsinline',
						boolToString(config.d6))
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$source,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$src(
								$author$project$Data$FilePath$toString(src_))
							]),
						_List_Nil)
					]));
		});
};
var $author$project$Component$VideoPlayer$view = function (attributes) {
	return $author$project$Component$VideoPlayer$viewPlayer(
		A3(
			$elm$core$List$foldl,
			function (_v0) {
				var attribute = _v0;
				return attribute;
			},
			$author$project$Component$VideoPlayer$build,
			attributes));
};
var $author$project$ShareToolEmployeeContentCollection$viewMediaItem = F2(
	function (filePath, showControls) {
		var _v0 = $author$project$Data$FilePath$fromString(filePath);
		switch (_v0.$) {
			case 3:
				return A2(
					$elm$html$Html$img,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$src('/static/images/audio-placeholder.png')
						]),
					_List_Nil);
			case 0:
				var videoFilePath = _v0.a;
				return $author$project$Component$VideoPlayer$view(
					_List_fromArray(
						[
							$author$project$Component$VideoPlayer$src(
							$author$project$Data$FilePath$toStaticUrl(videoFilePath)),
							$author$project$Component$VideoPlayer$controls(showControls)
						]));
			case 1:
				return A2(
					$elm$html$Html$img,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$src('/static/images/pdf-placeholder.png')
						]),
					_List_Nil);
			case 2:
				var imageFilePath = _v0.a;
				return A2(
					$elm$html$Html$img,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$src(
							$author$project$Util$Url$staticUrl(
								$author$project$Data$FilePath$toString(imageFilePath)))
						]),
					_List_Nil);
			default:
				var unknownFilePath = _v0.a;
				return A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('ec-header__media__placeholder')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Data$FilePath$toString(unknownFilePath))
						]));
		}
	});
var $author$project$ShareToolEmployeeContentCollection$viewContentItemUpload = function (_v0) {
	var src_ = _v0.b;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('ec-item__body__upload')
			]),
		_List_fromArray(
			[
				A2($author$project$ShareToolEmployeeContentCollection$viewMediaItem, src_, true)
			]));
};
var $author$project$ShareToolEmployeeContentCollection$viewContentItemUploads = function (uploads) {
	return $elm$core$List$isEmpty(uploads) ? A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('media placeholder')
			])) : A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('ec-item__body__uploads')
			]),
		A2($elm$core$List$map, $author$project$ShareToolEmployeeContentCollection$viewContentItemUpload, uploads));
};
var $author$project$ShareToolEmployeeContentCollection$viewLabeledContent = F2(
	function (heading, content) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('ec__detail')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h3,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(heading)
						])),
					content
				]));
	});
var $author$project$Util$String$withDefault = F2(
	function (_default, value) {
		return $elm$core$String$isEmpty(value) ? _default : value;
	});
var $author$project$ShareToolEmployeeContentCollection$viewContentItemBody = F4(
	function (translations, _v0, uploads, allTags) {
		var contentId = _v0.a;
		var content = _v0.b;
		var translate = $author$project$Data$Translation$toString(translations);
		var itemTags = A2(
			$elm$core$List$filter,
			function (_v2) {
				var tag = _v2.b;
				return A2($elm$core$List$member, contentId, tag.Pc);
			},
			allTags);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('ec-item__body')
				]),
			_List_fromArray(
				[
					$author$project$ShareToolEmployeeContentCollection$viewContentItemUploads(uploads),
					A2(
					$author$project$ShareToolEmployeeContentCollection$viewLabeledContent,
					translate($author$project$Model$Translation$tags),
					$author$project$ShareToolEmployeeContentCollection$viewContentItemTags(itemTags)),
					A2(
					$author$project$ShareToolEmployeeContentCollection$viewLabeledContent,
					translate($author$project$Model$Translation$caption),
					$elm$html$Html$text(
						A2($author$project$Util$String$withDefault, '_', content.pM))),
					A2(
					$author$project$ShareToolEmployeeContentCollection$viewLabeledContent,
					translate($author$project$Model$Translation$feedback),
					$elm$html$Html$text(
						A2(
							$author$project$Util$String$withDefault,
							translate($author$project$Model$Translation$noFeedbackYet),
							content.Hp))),
					A2(
					$author$project$Util$View$viewIf,
					!content.fL,
					function (_v1) {
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('ec-item__body__btn-container')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Component$Button$view,
									$author$project$Copy$copy.asp,
									_List_fromArray(
										[
											$author$project$Component$Button$onClick(
											A2($author$project$Component$Modal$Confirm$show, $author$project$ShareToolEmployeeContentCollection$confirmDeleteConfig, contentId)),
											$author$project$Component$Button$iconRight($author$project$View$Icon$path.atC),
											$author$project$Component$Button$unboundedWidth
										]))
								]));
					})
				]));
	});
var $author$project$ShareToolEmployeeContentCollection$SetActiveContentItemId = function (a) {
	return {$: 0, a: a};
};
var $ryan_haskell$date_format$DateFormat$DayOfMonthNumber = {$: 5};
var $ryan_haskell$date_format$DateFormat$dayOfMonthNumber = $ryan_haskell$date_format$DateFormat$DayOfMonthNumber;
var $ryan_haskell$date_format$DateFormat$Language$Language = F6(
	function (toMonthName, toMonthAbbreviation, toWeekdayName, toWeekdayAbbreviation, toAmPm, toOrdinalSuffix) {
		return {avW: toAmPm, avX: toMonthAbbreviation, avY: toMonthName, b3: toOrdinalSuffix, av0: toWeekdayAbbreviation, av1: toWeekdayName};
	});
var $ryan_haskell$date_format$DateFormat$Language$toDutchMonthName = function (month) {
	switch (month) {
		case 0:
			return 'januari';
		case 1:
			return 'februari';
		case 2:
			return 'maart';
		case 3:
			return 'april';
		case 4:
			return 'mei';
		case 5:
			return 'juni';
		case 6:
			return 'juli';
		case 7:
			return 'augustus';
		case 8:
			return 'september';
		case 9:
			return 'oktober';
		case 10:
			return 'november';
		default:
			return 'december';
	}
};
var $ryan_haskell$date_format$DateFormat$Language$toDutchSuffix = function (num) {
	return ((num > 20) || ((num === 1) || (num === 8))) ? 'ste' : 'de';
};
var $ryan_haskell$date_format$DateFormat$Language$toDutchWeekdayName = function (weekday) {
	switch (weekday) {
		case 0:
			return 'maandag';
		case 1:
			return 'dinsdag';
		case 2:
			return 'woensdag';
		case 3:
			return 'donderdag';
		case 4:
			return 'vrijdag';
		case 5:
			return 'zaterdag';
		default:
			return 'zondag';
	}
};
var $ryan_haskell$date_format$DateFormat$Language$toEnglishAmPm = function (hour) {
	return (hour > 11) ? 'pm' : 'am';
};
var $ryan_haskell$date_format$DateFormat$Language$dutch = A6(
	$ryan_haskell$date_format$DateFormat$Language$Language,
	$ryan_haskell$date_format$DateFormat$Language$toDutchMonthName,
	A2(
		$elm$core$Basics$composeR,
		$ryan_haskell$date_format$DateFormat$Language$toDutchMonthName,
		$elm$core$String$left(3)),
	$ryan_haskell$date_format$DateFormat$Language$toDutchWeekdayName,
	A2(
		$elm$core$Basics$composeR,
		$ryan_haskell$date_format$DateFormat$Language$toDutchWeekdayName,
		$elm$core$String$left(3)),
	$ryan_haskell$date_format$DateFormat$Language$toEnglishAmPm,
	$ryan_haskell$date_format$DateFormat$Language$toDutchSuffix);
var $elm$time$Time$flooredDiv = F2(
	function (numerator, denominator) {
		return $elm$core$Basics$floor(numerator / denominator);
	});
var $elm$time$Time$posixToMillis = function (_v0) {
	var millis = _v0;
	return millis;
};
var $elm$time$Time$toAdjustedMinutesHelp = F3(
	function (defaultOffset, posixMinutes, eras) {
		toAdjustedMinutesHelp:
		while (true) {
			if (!eras.b) {
				return posixMinutes + defaultOffset;
			} else {
				var era = eras.a;
				var olderEras = eras.b;
				if (_Utils_cmp(era.aju, posixMinutes) < 0) {
					return posixMinutes + era.F;
				} else {
					var $temp$defaultOffset = defaultOffset,
						$temp$posixMinutes = posixMinutes,
						$temp$eras = olderEras;
					defaultOffset = $temp$defaultOffset;
					posixMinutes = $temp$posixMinutes;
					eras = $temp$eras;
					continue toAdjustedMinutesHelp;
				}
			}
		}
	});
var $elm$time$Time$toAdjustedMinutes = F2(
	function (_v0, time) {
		var defaultOffset = _v0.a;
		var eras = _v0.b;
		return A3(
			$elm$time$Time$toAdjustedMinutesHelp,
			defaultOffset,
			A2(
				$elm$time$Time$flooredDiv,
				$elm$time$Time$posixToMillis(time),
				60000),
			eras);
	});
var $elm$time$Time$toHour = F2(
	function (zone, time) {
		return A2(
			$elm$core$Basics$modBy,
			24,
			A2(
				$elm$time$Time$flooredDiv,
				A2($elm$time$Time$toAdjustedMinutes, zone, time),
				60));
	});
var $ryan_haskell$date_format$DateFormat$amPm = F3(
	function (language, zone, posix) {
		return language.avW(
			A2($elm$time$Time$toHour, zone, posix));
	});
var $elm$time$Time$toCivil = function (minutes) {
	var rawDay = A2($elm$time$Time$flooredDiv, minutes, 60 * 24) + 719468;
	var era = (((rawDay >= 0) ? rawDay : (rawDay - 146096)) / 146097) | 0;
	var dayOfEra = rawDay - (era * 146097);
	var yearOfEra = ((((dayOfEra - ((dayOfEra / 1460) | 0)) + ((dayOfEra / 36524) | 0)) - ((dayOfEra / 146096) | 0)) / 365) | 0;
	var dayOfYear = dayOfEra - (((365 * yearOfEra) + ((yearOfEra / 4) | 0)) - ((yearOfEra / 100) | 0));
	var mp = (((5 * dayOfYear) + 2) / 153) | 0;
	var month = mp + ((mp < 10) ? 3 : (-9));
	var year = yearOfEra + (era * 400);
	return {
		yz: (dayOfYear - ((((153 * mp) + 2) / 5) | 0)) + 1,
		TF: month,
		asD: year + ((month <= 2) ? 1 : 0)
	};
};
var $elm$time$Time$toDay = F2(
	function (zone, time) {
		return $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).yz;
	});
var $ryan_haskell$date_format$DateFormat$dayOfMonth = $elm$time$Time$toDay;
var $elm$time$Time$Sun = 6;
var $elm$time$Time$Fri = 4;
var $elm$time$Time$Mon = 0;
var $elm$time$Time$Sat = 5;
var $elm$time$Time$Thu = 3;
var $elm$time$Time$Tue = 1;
var $elm$time$Time$Wed = 2;
var $ryan_haskell$date_format$DateFormat$days = _List_fromArray(
	[6, 0, 1, 2, 3, 4, 5]);
var $elm$time$Time$toWeekday = F2(
	function (zone, time) {
		var _v0 = A2(
			$elm$core$Basics$modBy,
			7,
			A2(
				$elm$time$Time$flooredDiv,
				A2($elm$time$Time$toAdjustedMinutes, zone, time),
				60 * 24));
		switch (_v0) {
			case 0:
				return 3;
			case 1:
				return 4;
			case 2:
				return 5;
			case 3:
				return 6;
			case 4:
				return 0;
			case 5:
				return 1;
			default:
				return 2;
		}
	});
var $ryan_haskell$date_format$DateFormat$dayOfWeek = F2(
	function (zone, posix) {
		return function (_v1) {
			var i = _v1.a;
			return i;
		}(
			A2(
				$elm$core$Maybe$withDefault,
				_Utils_Tuple2(0, 6),
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (_v0) {
							var day = _v0.b;
							return _Utils_eq(
								day,
								A2($elm$time$Time$toWeekday, zone, posix));
						},
						A2(
							$elm$core$List$indexedMap,
							F2(
								function (i, day) {
									return _Utils_Tuple2(i, day);
								}),
							$ryan_haskell$date_format$DateFormat$days)))));
	});
var $ryan_haskell$date_format$DateFormat$isLeapYear = function (year_) {
	return (!(!A2($elm$core$Basics$modBy, 4, year_))) ? false : ((!(!A2($elm$core$Basics$modBy, 100, year_))) ? true : ((!(!A2($elm$core$Basics$modBy, 400, year_))) ? false : true));
};
var $ryan_haskell$date_format$DateFormat$daysInMonth = F2(
	function (year_, month) {
		switch (month) {
			case 0:
				return 31;
			case 1:
				return $ryan_haskell$date_format$DateFormat$isLeapYear(year_) ? 29 : 28;
			case 2:
				return 31;
			case 3:
				return 30;
			case 4:
				return 31;
			case 5:
				return 30;
			case 6:
				return 31;
			case 7:
				return 31;
			case 8:
				return 30;
			case 9:
				return 31;
			case 10:
				return 30;
			default:
				return 31;
		}
	});
var $elm$time$Time$Jan = 0;
var $elm$time$Time$Apr = 3;
var $elm$time$Time$Aug = 7;
var $elm$time$Time$Dec = 11;
var $elm$time$Time$Feb = 1;
var $elm$time$Time$Jul = 6;
var $elm$time$Time$Jun = 5;
var $elm$time$Time$Mar = 2;
var $elm$time$Time$May = 4;
var $elm$time$Time$Nov = 10;
var $elm$time$Time$Oct = 9;
var $elm$time$Time$Sep = 8;
var $ryan_haskell$date_format$DateFormat$months = _List_fromArray(
	[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]);
var $elm$time$Time$toMonth = F2(
	function (zone, time) {
		var _v0 = $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).TF;
		switch (_v0) {
			case 1:
				return 0;
			case 2:
				return 1;
			case 3:
				return 2;
			case 4:
				return 3;
			case 5:
				return 4;
			case 6:
				return 5;
			case 7:
				return 6;
			case 8:
				return 7;
			case 9:
				return 8;
			case 10:
				return 9;
			case 11:
				return 10;
			default:
				return 11;
		}
	});
var $ryan_haskell$date_format$DateFormat$monthPair = F2(
	function (zone, posix) {
		return A2(
			$elm$core$Maybe$withDefault,
			_Utils_Tuple2(0, 0),
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (_v0) {
						var i = _v0.a;
						var m = _v0.b;
						return _Utils_eq(
							m,
							A2($elm$time$Time$toMonth, zone, posix));
					},
					A2(
						$elm$core$List$indexedMap,
						F2(
							function (a, b) {
								return _Utils_Tuple2(a, b);
							}),
						$ryan_haskell$date_format$DateFormat$months))));
	});
var $ryan_haskell$date_format$DateFormat$monthNumber_ = F2(
	function (zone, posix) {
		return 1 + function (_v0) {
			var i = _v0.a;
			var m = _v0.b;
			return i;
		}(
			A2($ryan_haskell$date_format$DateFormat$monthPair, zone, posix));
	});
var $elm$core$List$sum = function (numbers) {
	return A3($elm$core$List$foldl, $elm$core$Basics$add, 0, numbers);
};
var $elm$time$Time$toYear = F2(
	function (zone, time) {
		return $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).asD;
	});
var $ryan_haskell$date_format$DateFormat$dayOfYear = F2(
	function (zone, posix) {
		var monthsBeforeThisOne = A2(
			$elm$core$List$take,
			A2($ryan_haskell$date_format$DateFormat$monthNumber_, zone, posix) - 1,
			$ryan_haskell$date_format$DateFormat$months);
		var daysBeforeThisMonth = $elm$core$List$sum(
			A2(
				$elm$core$List$map,
				$ryan_haskell$date_format$DateFormat$daysInMonth(
					A2($elm$time$Time$toYear, zone, posix)),
				monthsBeforeThisOne));
		return daysBeforeThisMonth + A2($ryan_haskell$date_format$DateFormat$dayOfMonth, zone, posix);
	});
var $ryan_haskell$date_format$DateFormat$quarter = F2(
	function (zone, posix) {
		return (A2($ryan_haskell$date_format$DateFormat$monthNumber_, zone, posix) / 4) | 0;
	});
var $elm$core$String$right = F2(
	function (n, string) {
		return (n < 1) ? '' : A3(
			$elm$core$String$slice,
			-n,
			$elm$core$String$length(string),
			string);
	});
var $ryan_haskell$date_format$DateFormat$toFixedLength = F2(
	function (totalChars, num) {
		var numStr = $elm$core$String$fromInt(num);
		var numZerosNeeded = totalChars - $elm$core$String$length(numStr);
		var zeros = A2(
			$elm$core$String$join,
			'',
			A2(
				$elm$core$List$map,
				function (_v0) {
					return '0';
				},
				A2($elm$core$List$range, 1, numZerosNeeded)));
		return _Utils_ap(zeros, numStr);
	});
var $elm$time$Time$toMillis = F2(
	function (_v0, time) {
		return A2(
			$elm$core$Basics$modBy,
			1000,
			$elm$time$Time$posixToMillis(time));
	});
var $elm$time$Time$toMinute = F2(
	function (zone, time) {
		return A2(
			$elm$core$Basics$modBy,
			60,
			A2($elm$time$Time$toAdjustedMinutes, zone, time));
	});
var $ryan_haskell$date_format$DateFormat$toNonMilitary = function (num) {
	return (!num) ? 12 : ((num <= 12) ? num : (num - 12));
};
var $elm$time$Time$toSecond = F2(
	function (_v0, time) {
		return A2(
			$elm$core$Basics$modBy,
			60,
			A2(
				$elm$time$Time$flooredDiv,
				$elm$time$Time$posixToMillis(time),
				1000));
	});
var $elm$core$String$toUpper = _String_toUpper;
var $ryan_haskell$date_format$DateFormat$millisecondsPerYear = $elm$core$Basics$round((((1000 * 60) * 60) * 24) * 365.25);
var $ryan_haskell$date_format$DateFormat$firstDayOfYear = F2(
	function (zone, time) {
		return $elm$time$Time$millisToPosix(
			$ryan_haskell$date_format$DateFormat$millisecondsPerYear * A2($elm$time$Time$toYear, zone, time));
	});
var $ryan_haskell$date_format$DateFormat$weekOfYear = F2(
	function (zone, posix) {
		var firstDay = A2($ryan_haskell$date_format$DateFormat$firstDayOfYear, zone, posix);
		var firstDayOffset = A2($ryan_haskell$date_format$DateFormat$dayOfWeek, zone, firstDay);
		var daysSoFar = A2($ryan_haskell$date_format$DateFormat$dayOfYear, zone, posix);
		return (((daysSoFar + firstDayOffset) / 7) | 0) + 1;
	});
var $ryan_haskell$date_format$DateFormat$year = F2(
	function (zone, time) {
		return $elm$core$String$fromInt(
			A2($elm$time$Time$toYear, zone, time));
	});
var $ryan_haskell$date_format$DateFormat$piece = F4(
	function (language, zone, posix, token) {
		switch (token.$) {
			case 0:
				return $elm$core$String$fromInt(
					A2($ryan_haskell$date_format$DateFormat$monthNumber_, zone, posix));
			case 1:
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.b3(num));
				}(
					A2($ryan_haskell$date_format$DateFormat$monthNumber_, zone, posix));
			case 2:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					A2($ryan_haskell$date_format$DateFormat$monthNumber_, zone, posix));
			case 3:
				return language.avX(
					A2($elm$time$Time$toMonth, zone, posix));
			case 4:
				return language.avY(
					A2($elm$time$Time$toMonth, zone, posix));
			case 17:
				return $elm$core$String$fromInt(
					1 + A2($ryan_haskell$date_format$DateFormat$quarter, zone, posix));
			case 18:
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.b3(num));
				}(
					1 + A2($ryan_haskell$date_format$DateFormat$quarter, zone, posix));
			case 5:
				return $elm$core$String$fromInt(
					A2($ryan_haskell$date_format$DateFormat$dayOfMonth, zone, posix));
			case 6:
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.b3(num));
				}(
					A2($ryan_haskell$date_format$DateFormat$dayOfMonth, zone, posix));
			case 7:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					A2($ryan_haskell$date_format$DateFormat$dayOfMonth, zone, posix));
			case 8:
				return $elm$core$String$fromInt(
					A2($ryan_haskell$date_format$DateFormat$dayOfYear, zone, posix));
			case 9:
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.b3(num));
				}(
					A2($ryan_haskell$date_format$DateFormat$dayOfYear, zone, posix));
			case 10:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					3,
					A2($ryan_haskell$date_format$DateFormat$dayOfYear, zone, posix));
			case 11:
				return $elm$core$String$fromInt(
					A2($ryan_haskell$date_format$DateFormat$dayOfWeek, zone, posix));
			case 12:
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.b3(num));
				}(
					A2($ryan_haskell$date_format$DateFormat$dayOfWeek, zone, posix));
			case 13:
				return language.av0(
					A2($elm$time$Time$toWeekday, zone, posix));
			case 14:
				return language.av1(
					A2($elm$time$Time$toWeekday, zone, posix));
			case 19:
				return $elm$core$String$fromInt(
					A2($ryan_haskell$date_format$DateFormat$weekOfYear, zone, posix));
			case 20:
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.b3(num));
				}(
					A2($ryan_haskell$date_format$DateFormat$weekOfYear, zone, posix));
			case 21:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					A2($ryan_haskell$date_format$DateFormat$weekOfYear, zone, posix));
			case 15:
				return A2(
					$elm$core$String$right,
					2,
					A2($ryan_haskell$date_format$DateFormat$year, zone, posix));
			case 16:
				return A2($ryan_haskell$date_format$DateFormat$year, zone, posix);
			case 22:
				return $elm$core$String$toUpper(
					A3($ryan_haskell$date_format$DateFormat$amPm, language, zone, posix));
			case 23:
				return $elm$core$String$toLower(
					A3($ryan_haskell$date_format$DateFormat$amPm, language, zone, posix));
			case 24:
				return $elm$core$String$fromInt(
					A2($elm$time$Time$toHour, zone, posix));
			case 25:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					A2($elm$time$Time$toHour, zone, posix));
			case 26:
				return $elm$core$String$fromInt(
					$ryan_haskell$date_format$DateFormat$toNonMilitary(
						A2($elm$time$Time$toHour, zone, posix)));
			case 27:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					$ryan_haskell$date_format$DateFormat$toNonMilitary(
						A2($elm$time$Time$toHour, zone, posix)));
			case 28:
				return $elm$core$String$fromInt(
					1 + A2($elm$time$Time$toHour, zone, posix));
			case 29:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					1 + A2($elm$time$Time$toHour, zone, posix));
			case 30:
				return $elm$core$String$fromInt(
					A2($elm$time$Time$toMinute, zone, posix));
			case 31:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					A2($elm$time$Time$toMinute, zone, posix));
			case 32:
				return $elm$core$String$fromInt(
					A2($elm$time$Time$toSecond, zone, posix));
			case 33:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					A2($elm$time$Time$toSecond, zone, posix));
			case 34:
				return $elm$core$String$fromInt(
					A2($elm$time$Time$toMillis, zone, posix));
			case 35:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					3,
					A2($elm$time$Time$toMillis, zone, posix));
			default:
				var string = token.a;
				return string;
		}
	});
var $ryan_haskell$date_format$DateFormat$formatWithLanguage = F4(
	function (language, tokens, zone, time) {
		return A2(
			$elm$core$String$join,
			'',
			A2(
				$elm$core$List$map,
				A3($ryan_haskell$date_format$DateFormat$piece, language, zone, time),
				tokens));
	});
var $ryan_haskell$date_format$DateFormat$HourMilitaryFixed = {$: 25};
var $ryan_haskell$date_format$DateFormat$hourMilitaryFixed = $ryan_haskell$date_format$DateFormat$HourMilitaryFixed;
var $ryan_haskell$date_format$DateFormat$MinuteFixed = {$: 31};
var $ryan_haskell$date_format$DateFormat$minuteFixed = $ryan_haskell$date_format$DateFormat$MinuteFixed;
var $ryan_haskell$date_format$DateFormat$MonthNameAbbreviated = {$: 3};
var $ryan_haskell$date_format$DateFormat$monthNameAbbreviated = $ryan_haskell$date_format$DateFormat$MonthNameAbbreviated;
var $ryan_haskell$date_format$DateFormat$Text = function (a) {
	return {$: 36, a: a};
};
var $ryan_haskell$date_format$DateFormat$text = $ryan_haskell$date_format$DateFormat$Text;
var $ryan_haskell$date_format$DateFormat$YearNumber = {$: 16};
var $ryan_haskell$date_format$DateFormat$yearNumber = $ryan_haskell$date_format$DateFormat$YearNumber;
var $author$project$Util$Date$format = function (timeZone) {
	return A3(
		$ryan_haskell$date_format$DateFormat$formatWithLanguage,
		$ryan_haskell$date_format$DateFormat$Language$dutch,
		_List_fromArray(
			[
				$ryan_haskell$date_format$DateFormat$dayOfMonthNumber,
				$ryan_haskell$date_format$DateFormat$text(' '),
				$ryan_haskell$date_format$DateFormat$monthNameAbbreviated,
				$ryan_haskell$date_format$DateFormat$text(' '),
				$ryan_haskell$date_format$DateFormat$yearNumber,
				$ryan_haskell$date_format$DateFormat$text(' '),
				$ryan_haskell$date_format$DateFormat$text($author$project$Copy$copy.lz),
				$ryan_haskell$date_format$DateFormat$text(' '),
				$ryan_haskell$date_format$DateFormat$hourMilitaryFixed,
				$ryan_haskell$date_format$DateFormat$text(':'),
				$ryan_haskell$date_format$DateFormat$minuteFixed
			]),
		timeZone);
};
var $author$project$Model$Translation$status = 'status';
var $author$project$Model$Translation$statusApproved = 'status-approved';
var $author$project$Model$Translation$statusHonors = 'status-honors';
var $author$project$Model$Translation$statusPending = 'status-pending';
var $author$project$Model$Translation$statusRetry = 'status-retry';
var $author$project$Data$EmployeeContent$statusToTranslationName = function (status) {
	switch (status) {
		case 0:
			return $author$project$Model$Translation$statusPending;
		case 1:
			return $author$project$Model$Translation$statusRetry;
		case 2:
			return $author$project$Model$Translation$statusApproved;
		default:
			return $author$project$Model$Translation$statusHonors;
	}
};
var $author$project$ShareToolEmployeeContentCollection$viewEmployeeContentStatus = F2(
	function (translations, status) {
		var toStatusClass = function () {
			switch (status) {
				case 0:
					return 'pending';
				case 1:
					return 'retry';
				case 2:
					return 'approved';
				default:
					return 'honors';
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('ec__detail')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h3,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$Data$Translation$text, translations, $author$project$Model$Translation$status)
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(toStatusClass)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Data$Translation$text,
							translations,
							$author$project$Data$EmployeeContent$statusToTranslationName(status))
						]))
				]));
	});
var $author$project$Data$EmployeeContent$statusToRating = function (status) {
	switch (status) {
		case 0:
			return 1;
		case 1:
			return 1;
		case 2:
			return 2;
		default:
			return 3;
	}
};
var $author$project$ShareToolEmployeeContentCollection$viewEmptyStar = $author$project$View$Icon$viewColored($author$project$View$Icon$path.ajt);
var $author$project$ShareToolEmployeeContentCollection$viewFullStar = $author$project$View$Icon$viewColored($author$project$View$Icon$path.ajs);
var $author$project$ShareToolEmployeeContentCollection$viewEmployeeContentStatusRating = function (status) {
	var viewRating = F2(
		function (filled, total) {
			return $elm$core$List$concat(
				_List_fromArray(
					[
						A2($elm$core$List$repeat, filled, $author$project$ShareToolEmployeeContentCollection$viewFullStar),
						A2($elm$core$List$repeat, total - filled, $author$project$ShareToolEmployeeContentCollection$viewEmptyStar)
					]));
		});
	var maxRating = 3;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('ec-item__header__status')
			]),
		A2(
			viewRating,
			$author$project$Data$EmployeeContent$statusToRating(status),
			maxRating));
};
var $author$project$ShareToolEmployeeContentCollection$viewContentItemHeaderDetails = F3(
	function (translations, timeZone, content) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('ec-header__details')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('ec-header__details__date')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2($author$project$Util$Date$format, timeZone, content.e6))
						])),
					A2($author$project$ShareToolEmployeeContentCollection$viewEmployeeContentStatus, translations, content.fL),
					$author$project$ShareToolEmployeeContentCollection$viewEmployeeContentStatusRating(content.fL)
				]));
	});
var $author$project$ShareToolEmployeeContentCollection$viewContentItemHeaderUploads = function (uploads) {
	if (!uploads.b) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('media placeholder')
				]));
	} else {
		if (!uploads.b.b) {
			var _v1 = uploads.a;
			var src_ = _v1.b;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('ec-header__media')
					]),
				_List_fromArray(
					[
						A2($author$project$ShareToolEmployeeContentCollection$viewMediaItem, src_, false)
					]));
		} else {
			var _v2 = uploads.a;
			var src_ = _v2.b;
			var xs = uploads.b;
			var count = $elm$core$String$fromInt(
				$elm$core$List$length(xs));
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('ec-header__media')
					]),
				_List_fromArray(
					[
						A2($author$project$ShareToolEmployeeContentCollection$viewMediaItem, src_, false),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('ec-header__counter')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2(
									$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
									'+{0}',
									_List_fromArray(
										[count])))
							]))
					]));
		}
	}
};
var $author$project$ShareToolEmployeeContentCollection$viewContentItemHeader = F5(
	function (translations, timeZone, _v0, uploads, isActive) {
		var contentId = _v0.a;
		var content = _v0.b;
		var toMsg = isActive ? $author$project$ShareToolEmployeeContentCollection$SetActiveContentItemId($elm$core$Maybe$Nothing) : $author$project$ShareToolEmployeeContentCollection$SetActiveContentItemId(
			$elm$core$Maybe$Just(contentId));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('ec-header', true),
							_Utils_Tuple2('is-active', isActive)
						])),
					$elm$html$Html$Events$onClick(toMsg)
				]),
			_List_fromArray(
				[
					$author$project$ShareToolEmployeeContentCollection$viewContentItemHeaderUploads(uploads),
					A3($author$project$ShareToolEmployeeContentCollection$viewContentItemHeaderDetails, translations, timeZone, content),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('ec-header__arrow', true),
									_Utils_Tuple2('is-active', isActive)
								]))
						]),
					_List_Nil)
				]));
	});
var $author$project$ShareToolEmployeeContentCollection$viewContentItem = F5(
	function (translations, timeZone, activeContentId, tags, _v0) {
		var employeeContentEntity = _v0.FM;
		var employeeContentUploads = _v0.FO;
		var isActive = _Utils_eq(
			activeContentId,
			$elm$core$Maybe$Just(
				$author$project$Data$Entity$id(employeeContentEntity)));
		return A2(
			$elm$html$Html$li,
			_List_Nil,
			_List_fromArray(
				[
					A5($author$project$ShareToolEmployeeContentCollection$viewContentItemHeader, translations, timeZone, employeeContentEntity, employeeContentUploads, isActive),
					A2(
					$author$project$Util$View$viewIf,
					isActive,
					function (_v1) {
						return A4($author$project$ShareToolEmployeeContentCollection$viewContentItemBody, translations, employeeContentEntity, employeeContentUploads, tags);
					})
				]));
	});
var $author$project$Data$Entity$value = function (_v0) {
	var b = _v0.b;
	return b;
};
var $author$project$ShareToolEmployeeContentCollection$viewEmployeeBanner = F2(
	function (employee, items) {
		var totalStarCount = A3(
			$elm$core$List$foldl,
			A2(
				$elm$core$Basics$composeL,
				A2(
					$elm$core$Basics$composeL,
					A2(
						$elm$core$Basics$composeL,
						A2($elm$core$Basics$composeL, $elm$core$Basics$add, $author$project$Data$EmployeeContent$statusToRating),
						function ($) {
							return $.fL;
						}),
					$author$project$Data$Entity$value),
				function ($) {
					return $.FM;
				}),
			0,
			items);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('ec-employee-banner')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h3,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('ec-employee-banner__greeting')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
								'Hi {0}!',
								_List_fromArray(
									[employee.Ip])))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('ec-employee-banner__star-count')
						]),
					_List_fromArray(
						[
							$author$project$ShareToolEmployeeContentCollection$viewFullStar,
							A2(
							$elm$html$Html$h3,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$elm$core$String$fromInt(totalStarCount))
								]))
						]))
				]));
	});
var $author$project$ShareToolEmployeeContentCollection$viewEmployeeContent = F6(
	function (translations, timeZone, employee, activeContentId, tags, items) {
		return $elm$core$List$isEmpty(items) ? $author$project$Component$Message$view(
			{
				dn: A2($author$project$Data$Translation$toString, translations, $author$project$Model$Translation$noUploadsFoundDescription),
				e_: $elm$core$Maybe$Nothing,
				avV: A2($author$project$Data$Translation$toString, translations, $author$project$Model$Translation$noUploadsFound)
			}) : A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2($author$project$ShareToolEmployeeContentCollection$viewEmployeeBanner, employee, items),
					A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('ec-list')
						]),
					A2(
						$elm$core$List$map,
						A4($author$project$ShareToolEmployeeContentCollection$viewContentItem, translations, timeZone, activeContentId, tags),
						items))
				]));
	});
var $author$project$Component$Message$viewError = function (error) {
	var _v0 = $author$project$Util$Translation$httpError(error);
	var title = _v0.avV;
	var description = _v0.dn;
	return $author$project$Component$Message$view(
		{dn: description, e_: $elm$core$Maybe$Nothing, avV: title});
};
var $author$project$Util$View$viewLoader = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('loading-spinner')
		]),
	_List_Nil);
var $author$project$Util$View$viewPageLoader = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('loading-page-container')
		]),
	_List_fromArray(
		[$author$project$Util$View$viewLoader]));
var $author$project$Data$Status$viewSuccessOrFailure = F3(
	function (viewFailure, status, f) {
		switch (status.$) {
			case 0:
				return $elm$html$Html$text('');
			case 1:
				return $author$project$Util$View$viewPageLoader;
			case 2:
				var error = status.a;
				return viewFailure(error);
			default:
				var a = status.a;
				return f(a);
		}
	});
var $author$project$Data$Status$viewSuccess = $author$project$Data$Status$viewSuccessOrFailure($author$project$Component$Message$viewError);
var $author$project$ShareToolEmployeeContentCollection$view = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('page-container')
			]),
		_List_fromArray(
			[
				A2($author$project$Component$Modal$Confirm$view, $author$project$ShareToolEmployeeContentCollection$confirmDeleteConfig, model.sb),
				A2($author$project$Component$Notifications$viewAsSnackbar, $author$project$ShareToolEmployeeContentCollection$DeleteToastById, model.Xf),
				A2(
				$author$project$Data$Status$viewSuccess,
				model.FJ,
				A5($author$project$ShareToolEmployeeContentCollection$viewEmployeeContent, model.anB, model.fS, model.FI, model.cZ, model.aln))
			]));
};
var $author$project$ShareToolEmployeeContentCollection$main = A2(
	$author$project$Browser$Custom$elementWithFlags,
	$author$project$ShareToolEmployeeContentCollection$decodeFlags,
	{dH: $author$project$ShareToolEmployeeContentCollection$init, em: $author$project$ShareToolEmployeeContentCollection$subscriptions, ex: $author$project$ShareToolEmployeeContentCollection$update, ez: $author$project$ShareToolEmployeeContentCollection$view});
var $author$project$SalaryCalculator$Flags = F4(
	function (salaryCalculators, plainText, useDropDown, weeksPerMonth) {
		return {_3: plainText, bo: salaryCalculators, b7: useDropDown, a3: weeksPerMonth};
	});
var $mgold$elm_nonempty_list$List$Nonempty$Nonempty = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$json$Json$Decode$oneOrMoreHelp = F2(
	function (toValue, xs) {
		if (!xs.b) {
			return $elm$json$Json$Decode$fail('a ARRAY with at least ONE element');
		} else {
			var y = xs.a;
			var ys = xs.b;
			return $elm$json$Json$Decode$succeed(
				A2(toValue, y, ys));
		}
	});
var $elm$json$Json$Decode$oneOrMore = F2(
	function (toValue, decoder) {
		return A2(
			$elm$json$Json$Decode$andThen,
			$elm$json$Json$Decode$oneOrMoreHelp(toValue),
			$elm$json$Json$Decode$list(decoder));
	});
var $langyu_app$elm_ancillary_nonempty_list$List$Nonempty$Ancillary$decodeArray = function (d) {
	return A2($elm$json$Json$Decode$oneOrMore, $mgold$elm_nonempty_list$List$Nonempty$Nonempty, d);
};
var $elm$json$Json$Decode$map4 = _Json_map4;
var $author$project$Model$SalaryCalculator$SalaryCalculator = function (domainId) {
	return function (vacancyId) {
		return function (label) {
			return function (extraDescription) {
				return function (minHours) {
					return function (maxHours) {
						return function (factorBelowThreshold) {
							return function (salaries) {
								return function (inserted) {
									return function (updated) {
										return {dp: domainId, G1: extraDescription, Ha: factorBelowThreshold, e6: inserted, bO: label, Sy: maxHours, Te: minHours, bn: salaries, fY: updated, aqL: vacancyId};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Model$Salary$Salaries = $elm$core$Basics$identity;
var $author$project$Model$Salary$Salary = F2(
	function (age, perHour) {
		return {hj: age, _B: perHour};
	});
var $author$project$Model$Salary$salaryDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'perHour',
	$elm$json$Json$Decode$float,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'age',
		$elm$json$Json$Decode$int,
		$elm$json$Json$Decode$succeed($author$project$Model$Salary$Salary)));
var $author$project$Model$Salary$salariesDecoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Basics$identity,
	$langyu_app$elm_ancillary_nonempty_list$List$Nonempty$Ancillary$decodeArray($author$project$Model$Salary$salaryDecoder));
var $author$project$Model$SalaryCalculator$salaryCalculatorDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'salaryCalculatorUpdated',
	$elm$json$Json$Decode$nullable($rtfeldman$elm_iso8601_date_strings$Iso8601$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'salaryCalculatorInserted',
		$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'salaryCalculatorSalaries',
			$author$project$Model$Salary$salariesDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'salaryCalculatorFactorBelowThreshold',
				$elm$json$Json$Decode$float,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'salaryCalculatorMaxHours',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'salaryCalculatorMinHours',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'salaryCalculatorExtraDescription',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'salaryCalculatorLabel',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'salaryCalculatorVacancyId',
									$elm$json$Json$Decode$nullable($author$project$Data$Id$decoder),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'salaryCalculatorDomainId',
										$author$project$Data$Id$decoder,
										$elm$json$Json$Decode$succeed($author$project$Model$SalaryCalculator$SalaryCalculator)))))))))));
var $author$project$SalaryCalculator$decodeFlags = A5(
	$elm$json$Json$Decode$map4,
	$author$project$SalaryCalculator$Flags,
	A2(
		$elm$json$Json$Decode$field,
		'salaryCalculators',
		$langyu_app$elm_ancillary_nonempty_list$List$Nonempty$Ancillary$decodeArray(
			$author$project$Data$Entity$decoder($author$project$Model$SalaryCalculator$salaryCalculatorDecoder))),
	A2($elm$json$Json$Decode$field, 'plainText', $author$project$Model$Content$PlainText$plainTextDecoder),
	A2($elm$json$Json$Decode$field, 'useDropDown', $elm$json$Json$Decode$bool),
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'weeksPerMonth', $elm$json$Json$Decode$float)));
var $mgold$elm_nonempty_list$List$Nonempty$head = function (_v0) {
	var x = _v0.a;
	var xs = _v0.b;
	return x;
};
var $author$project$View$SalaryCalculator$State = $elm$core$Basics$identity;
var $author$project$View$SalaryCalculator$getMaxHours = function (salaryCalculatorEntity) {
	return A2(
		$elm$core$Maybe$withDefault,
		40,
		$author$project$Data$Entity$value(salaryCalculatorEntity).Sy);
};
var $elm$core$List$sortWith = _List_sortWith;
var $mgold$elm_nonempty_list$List$Nonempty$insertWith = F3(
	function (cmp, hd, aList) {
		if (aList.b) {
			var x = aList.a;
			var xs = aList.b;
			return (!A2(cmp, x, hd)) ? A2(
				$mgold$elm_nonempty_list$List$Nonempty$Nonempty,
				x,
				A2(
					$elm$core$List$sortWith,
					cmp,
					A2($elm$core$List$cons, hd, xs))) : A2($mgold$elm_nonempty_list$List$Nonempty$Nonempty, hd, aList);
		} else {
			return A2($mgold$elm_nonempty_list$List$Nonempty$Nonempty, hd, _List_Nil);
		}
	});
var $elm$core$List$sortBy = _List_sortBy;
var $mgold$elm_nonempty_list$List$Nonempty$sortBy = F2(
	function (f, _v0) {
		var x = _v0.a;
		var xs = _v0.b;
		return A3(
			$mgold$elm_nonempty_list$List$Nonempty$insertWith,
			F2(
				function (a, b) {
					return A2(
						$elm$core$Basics$compare,
						f(a),
						f(b));
				}),
			x,
			A2($elm$core$List$sortBy, f, xs));
	});
var $author$project$Data$SalaryCalculator$toNonEmptySalaries = function (_v0) {
	var salaries = _v0;
	return salaries;
};
var $author$project$Data$SalaryCalculator$minAge = A2(
	$elm$core$Basics$composeR,
	function ($) {
		return $.bn;
	},
	A2(
		$elm$core$Basics$composeR,
		$author$project$Data$SalaryCalculator$toNonEmptySalaries,
		A2(
			$elm$core$Basics$composeR,
			$mgold$elm_nonempty_list$List$Nonempty$sortBy(
				function ($) {
					return $.hj;
				}),
			A2(
				$elm$core$Basics$composeR,
				$mgold$elm_nonempty_list$List$Nonempty$head,
				function ($) {
					return $.hj;
				}))));
var $author$project$View$SalaryCalculator$init = function (salaryCalculatorEntity) {
	return {
		hj: $author$project$Data$SalaryCalculator$minAge(
			$author$project$Data$Entity$value(salaryCalculatorEntity)),
		MX: $author$project$View$SalaryCalculator$getMaxHours(salaryCalculatorEntity),
		au: salaryCalculatorEntity
	};
};
var $author$project$SalaryCalculator$init = function (flags) {
	return _Utils_Tuple2(
		{
			_3: flags._3,
			adV: $author$project$View$SalaryCalculator$init(
				$mgold$elm_nonempty_list$List$Nonempty$head(flags.bo)),
			bo: flags.bo,
			b7: flags.b7,
			a3: flags.a3
		},
		$elm$core$Platform$Cmd$none);
};
var $author$project$SalaryCalculator$update = F2(
	function (state, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{adV: state}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$View$SalaryCalculator$AgeEighteen = 4;
var $author$project$View$SalaryCalculator$AgeFifteen = 1;
var $author$project$View$SalaryCalculator$AgeFourTeen = 0;
var $author$project$View$SalaryCalculator$AgeNineteen = 5;
var $author$project$View$SalaryCalculator$AgeSeventeen = 3;
var $author$project$View$SalaryCalculator$AgeSixteen = 2;
var $author$project$View$SalaryCalculator$AgeTwenty = 6;
var $author$project$View$SalaryCalculator$AgeTwentyOne = 7;
var $author$project$View$SalaryCalculator$ageToInt = function (age) {
	switch (age) {
		case 0:
			return 14;
		case 1:
			return 15;
		case 2:
			return 16;
		case 3:
			return 17;
		case 4:
			return 18;
		case 5:
			return 19;
		case 6:
			return 20;
		default:
			return 21;
	}
};
var $author$project$View$SalaryCalculator$ageToString = function (age) {
	switch (age) {
		case 0:
			return '14';
		case 1:
			return '15';
		case 2:
			return '16';
		case 3:
			return '17';
		case 4:
			return '18';
		case 5:
			return '19';
		case 6:
			return '20';
		default:
			return '21+';
	}
};
var $author$project$View$SalaryCalculator$getMinHours = function (salaryCalculatorEntity) {
	return A2(
		$elm$core$Maybe$withDefault,
		0,
		$author$project$Data$Entity$value(salaryCalculatorEntity).Te);
};
var $author$project$Component$Form$NumberInput$Attribute = $elm$core$Basics$identity;
var $author$project$Component$Form$NumberInput$NumberInput = $elm$core$Basics$identity;
var $author$project$Component$Form$NumberInput$set = function (_with) {
	return function (_v0) {
		var config = _v0;
		return _with(config);
	};
};
var $author$project$Component$Form$NumberInput$id = function (id_) {
	return $author$project$Component$Form$NumberInput$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{
					dE: $elm$core$Maybe$Just(id_)
				});
		});
};
var $author$project$View$SalaryCalculator$intToAge = function (n) {
	switch (n) {
		case 14:
			return 0;
		case 15:
			return 1;
		case 16:
			return 2;
		case 17:
			return 3;
		case 18:
			return 4;
		case 19:
			return 5;
		case 20:
			return 6;
		case 21:
			return 7;
		default:
			return 7;
	}
};
var $mgold$elm_nonempty_list$List$Nonempty$isSingleton = function (_v0) {
	var x = _v0.a;
	var xs = _v0.b;
	return $elm$core$List$isEmpty(xs);
};
var $author$project$Component$Form$NumberInput$max = function (max_) {
	return $author$project$Component$Form$NumberInput$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{
					dS: $elm$core$Maybe$Just(max_)
				});
		});
};
var $author$project$Component$Form$NumberInput$min = function (min_) {
	return $author$project$Component$Form$NumberInput$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{cB: min_});
		});
};
var $author$project$Component$Form$NumberInput$onInput = function (msg_) {
	return $author$project$Component$Form$NumberInput$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{
					d1: $elm$core$Maybe$Just(msg_)
				});
		});
};
var $author$project$Component$Form$NumberInput$placeholder = function (placeholder_) {
	return $author$project$Component$Form$NumberInput$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{
					d5: $elm$core$Maybe$Just(placeholder_)
				});
		});
};
var $author$project$View$SalaryCalculator$setAge = F2(
	function (_v0, i) {
		var state = _v0;
		return _Utils_update(
			state,
			{hj: i});
	});
var $author$project$View$SalaryCalculator$setHours = F2(
	function (_v0, i) {
		var state = _v0;
		return _Utils_update(
			state,
			{MX: i});
	});
var $author$project$View$SalaryCalculator$stringToAge = function (str) {
	switch (str) {
		case '14':
			return $elm$core$Maybe$Just(0);
		case '15':
			return $elm$core$Maybe$Just(1);
		case '16':
			return $elm$core$Maybe$Just(2);
		case '17':
			return $elm$core$Maybe$Just(3);
		case '18':
			return $elm$core$Maybe$Just(4);
		case '19':
			return $elm$core$Maybe$Just(5);
		case '20':
			return $elm$core$Maybe$Just(6);
		case '21+':
			return $elm$core$Maybe$Just(7);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Component$Form$NumberInput$value = function (value_) {
	return $author$project$Component$Form$NumberInput$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{ey: value_});
		});
};
var $author$project$Component$Form$NumberInput$WidthFillContainer = 0;
var $author$project$Component$Form$NumberInput$build = {$7: false, cn: $elm$core$Maybe$Nothing, dC: false, dE: $elm$core$Maybe$Nothing, dI: false, bO: '', dS: $elm$core$Maybe$Nothing, cB: 0, dY: $elm$core$Maybe$Nothing, d1: $elm$core$Maybe$Nothing, d5: $elm$core$Maybe$Nothing, eb: false, eq: $elm$core$Maybe$Nothing, ey: 0, cb: 0};
var $author$project$Component$Form$NumberInput$label = function (label_) {
	return $author$project$Component$Form$NumberInput$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{bO: label_});
		});
};
var $author$project$Component$Form$NumberInput$Auto = 1;
var $elm$core$Basics$min = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) < 0) ? x : y;
	});
var $author$project$Component$Form$NumberInput$failOnNegative = F4(
	function (toString, min_, max_, n) {
		return (_Utils_cmp(n, min_) < 0) ? $elm$json$Json$Decode$fail(
			'Expected at least ' + toString(min_)) : $elm$json$Json$Decode$succeed(
			A2(
				$elm$core$Basics$min,
				n,
				A2($elm$core$Maybe$withDefault, n, max_)));
	});
var $author$project$Util$Tabindex$fieldTabIndexUnstyled = A2(
	$elm$core$Basics$composeL,
	$elm$core$Maybe$withDefault(_List_Nil),
	$elm$core$Maybe$map(
		A2($elm$core$Basics$composeL, $elm$core$List$singleton, $elm$html$Html$Attributes$tabindex)));
var $elm$core$String$words = _String_words;
var $author$project$Component$Form$NumberInput$generateId = function (labelText) {
	return A2(
		$elm$core$String$join,
		'-',
		$elm$core$String$words(labelText));
};
var $elm$html$Html$Attributes$max = $elm$html$Html$Attributes$stringProperty('max');
var $elm$html$Html$Attributes$min = $elm$html$Html$Attributes$stringProperty('min');
var $elm$html$Html$Attributes$required = $elm$html$Html$Attributes$boolProperty('required');
var $author$project$Component$Form$NumberInput$viewNumberInput = function (_v0) {
	var config = _v0;
	var toOnInput = function (toMsg) {
		return A2(
			$elm$html$Html$Events$on,
			'input',
			A2(
				$elm$json$Json$Decode$map,
				toMsg,
				A2(
					$elm$json$Json$Decode$andThen,
					A3($author$project$Component$Form$NumberInput$failOnNegative, $elm$core$String$fromInt, config.cB, config.dS),
					A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['target', 'valueAsNumber']),
						$elm$json$Json$Decode$int))));
	};
	var placeholder_ = A2($elm$core$Maybe$withDefault, config.bO, config.d5);
	var maybeAttributes = A2(
		$elm$core$List$filterMap,
		$elm$core$Basics$identity,
		_List_fromArray(
			[
				A2($elm$core$Maybe$map, toOnInput, config.d1),
				A2(
				$elm$core$Maybe$map,
				A2($elm$core$Basics$composeL, $elm$html$Html$Attributes$max, $elm$core$String$fromInt),
				config.dS),
				A2($elm$core$Maybe$map, $elm$html$Html$Attributes$name, config.dY)
			]));
	var labelClasslist = _List_fromArray(
		[
			_Utils_Tuple2('label', true),
			_Utils_Tuple2('visually-hidden', config.dC)
		]);
	var idValue = function () {
		var _v2 = config.dE;
		if (!_v2.$) {
			var id_ = _v2.a;
			return id_;
		} else {
			return $author$project$Component$Form$NumberInput$generateId(config.bO);
		}
	}();
	var inputAttributes = _Utils_ap(
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('form-input'),
				$elm$html$Html$Attributes$type_('number'),
				$elm$html$Html$Attributes$value(
				$elm$core$String$fromInt(config.ey)),
				$elm$html$Html$Attributes$min(
				$elm$core$String$fromInt(config.cB)),
				$elm$html$Html$Attributes$id(idValue),
				$elm$html$Html$Attributes$placeholder(placeholder_),
				$elm$html$Html$Attributes$required(config.eb),
				$elm$html$Html$Attributes$disabled(config.$7)
			]),
		$author$project$Util$Tabindex$fieldTabIndexUnstyled(config.eq));
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('form-field', true),
						_Utils_Tuple2(
						'error',
						$elm_community$maybe_extra$Maybe$Extra$isJust(config.cn)),
						_Utils_Tuple2('inline', config.dI),
						_Utils_Tuple2('width-auto', config.cb === 1)
					]))
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('form-field-wrapper')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$classList(labelClasslist),
								$elm$html$Html$Attributes$for(idValue)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Util$View$viewIfNot,
								$elm$core$String$isEmpty(config.bO),
								function (_v1) {
									return $elm$html$Html$text(config.bO);
								})
							])),
						A2(
						$elm$html$Html$input,
						_Utils_ap(inputAttributes, maybeAttributes),
						_List_Nil),
						A2(
						$author$project$Util$View$viewMaybe,
						config.cn,
						function (error_) {
							return A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('error-message')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(error_)
									]));
						})
					]))
			]));
};
var $author$project$Component$Form$NumberInput$view = F2(
	function (label_, attributes) {
		return $author$project$Component$Form$NumberInput$viewNumberInput(
			A3(
				$elm$core$List$foldl,
				function (_v0) {
					var attribute = _v0;
					return attribute;
				},
				$author$project$Component$Form$NumberInput$build,
				A2(
					$elm$core$List$cons,
					$author$project$Component$Form$NumberInput$label(label_),
					attributes)));
	});
var $author$project$View$SalaryCalculator$getFactor = function (salaryCalculatorEntity) {
	return $author$project$Data$Entity$value(salaryCalculatorEntity).Ha;
};
var $cuducos$elm_format_number$FormatNumber$Locales$Exact = function (a) {
	return {$: 2, a: a};
};
var $author$project$Util$Mustache$Variable = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $cuducos$elm_format_number$FormatNumber$Parser$FormattedNumber = F5(
	function (original, integers, decimals, prefix, suffix) {
		return {atx: decimals, Oa: integers, Za: original, d8: prefix, ep: suffix};
	});
var $cuducos$elm_format_number$FormatNumber$Parser$Negative = 2;
var $cuducos$elm_format_number$FormatNumber$Parser$Positive = 0;
var $cuducos$elm_format_number$FormatNumber$Parser$Zero = 1;
var $cuducos$elm_format_number$FormatNumber$Parser$classify = function (formatted) {
	var onlyZeros = A2(
		$elm$core$String$all,
		function (_char) {
			return _char === '0';
		},
		$elm$core$String$concat(
			A2(
				$elm$core$List$append,
				formatted.Oa,
				$elm$core$List$singleton(formatted.atx))));
	return onlyZeros ? 1 : ((formatted.Za < 0) ? 2 : 0);
};
var $elm$core$String$filter = _String_filter;
var $elm$core$Bitwise$shiftRightBy = _Bitwise_shiftRightBy;
var $elm$core$String$repeatHelp = F3(
	function (n, chunk, result) {
		return (n <= 0) ? result : A3(
			$elm$core$String$repeatHelp,
			n >> 1,
			_Utils_ap(chunk, chunk),
			(!(n & 1)) ? result : _Utils_ap(result, chunk));
	});
var $elm$core$String$repeat = F2(
	function (n, chunk) {
		return A3($elm$core$String$repeatHelp, n, chunk, '');
	});
var $cuducos$elm_format_number$FormatNumber$Parser$addZerosToFit = F2(
	function (desiredLength, value) {
		var length = $elm$core$String$length(value);
		var missing = (_Utils_cmp(length, desiredLength) < 0) ? $elm$core$Basics$abs(desiredLength - length) : 0;
		return _Utils_ap(
			value,
			A2($elm$core$String$repeat, missing, '0'));
	});
var $cuducos$elm_format_number$FormatNumber$Parser$removeZeros = function (decimals) {
	return (A2($elm$core$String$right, 1, decimals) !== '0') ? decimals : $cuducos$elm_format_number$FormatNumber$Parser$removeZeros(
		A2($elm$core$String$dropRight, 1, decimals));
};
var $cuducos$elm_format_number$FormatNumber$Parser$getDecimals = F2(
	function (locale, digits) {
		var _v0 = locale.atx;
		switch (_v0.$) {
			case 1:
				return $cuducos$elm_format_number$FormatNumber$Parser$removeZeros(digits);
			case 2:
				return digits;
			default:
				var min = _v0.a;
				return A2($cuducos$elm_format_number$FormatNumber$Parser$addZerosToFit, min, digits);
		}
	});
var $myrho$elm_round$Round$addSign = F2(
	function (signed, str) {
		var isNotZero = A2(
			$elm$core$List$any,
			function (c) {
				return (c !== '0') && (c !== '.');
			},
			$elm$core$String$toList(str));
		return _Utils_ap(
			(signed && isNotZero) ? '-' : '',
			str);
	});
var $myrho$elm_round$Round$increaseNum = function (_v0) {
	var head = _v0.a;
	var tail = _v0.b;
	if (head === '9') {
		var _v1 = $elm$core$String$uncons(tail);
		if (_v1.$ === 1) {
			return '01';
		} else {
			var headtail = _v1.a;
			return A2(
				$elm$core$String$cons,
				'0',
				$myrho$elm_round$Round$increaseNum(headtail));
		}
	} else {
		var c = $elm$core$Char$toCode(head);
		return ((c >= 48) && (c < 57)) ? A2(
			$elm$core$String$cons,
			$elm$core$Char$fromCode(c + 1),
			tail) : '0';
	}
};
var $elm$core$Basics$isInfinite = _Basics_isInfinite;
var $elm$core$Basics$isNaN = _Basics_isNaN;
var $elm$core$String$padRight = F3(
	function (n, _char, string) {
		return _Utils_ap(
			string,
			A2(
				$elm$core$String$repeat,
				n - $elm$core$String$length(string),
				$elm$core$String$fromChar(_char)));
	});
var $elm$core$String$reverse = _String_reverse;
var $myrho$elm_round$Round$splitComma = function (str) {
	var _v0 = A2($elm$core$String$split, '.', str);
	if (_v0.b) {
		if (_v0.b.b) {
			var before = _v0.a;
			var _v1 = _v0.b;
			var after = _v1.a;
			return _Utils_Tuple2(before, after);
		} else {
			var before = _v0.a;
			return _Utils_Tuple2(before, '0');
		}
	} else {
		return _Utils_Tuple2('0', '0');
	}
};
var $myrho$elm_round$Round$toDecimal = function (fl) {
	var _v0 = A2(
		$elm$core$String$split,
		'e',
		$elm$core$String$fromFloat(
			$elm$core$Basics$abs(fl)));
	if (_v0.b) {
		if (_v0.b.b) {
			var num = _v0.a;
			var _v1 = _v0.b;
			var exp = _v1.a;
			var e = A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(
					A2($elm$core$String$startsWith, '+', exp) ? A2($elm$core$String$dropLeft, 1, exp) : exp));
			var _v2 = $myrho$elm_round$Round$splitComma(num);
			var before = _v2.a;
			var after = _v2.b;
			var total = _Utils_ap(before, after);
			var zeroed = (e < 0) ? A2(
				$elm$core$Maybe$withDefault,
				'0',
				A2(
					$elm$core$Maybe$map,
					function (_v3) {
						var a = _v3.a;
						var b = _v3.b;
						return a + ('.' + b);
					},
					A2(
						$elm$core$Maybe$map,
						$elm$core$Tuple$mapFirst($elm$core$String$fromChar),
						$elm$core$String$uncons(
							_Utils_ap(
								A2(
									$elm$core$String$repeat,
									$elm$core$Basics$abs(e),
									'0'),
								total))))) : A3($elm$core$String$padRight, e + 1, '0', total);
			return _Utils_ap(
				(fl < 0) ? '-' : '',
				zeroed);
		} else {
			var num = _v0.a;
			return _Utils_ap(
				(fl < 0) ? '-' : '',
				num);
		}
	} else {
		return '';
	}
};
var $myrho$elm_round$Round$roundFun = F3(
	function (functor, s, fl) {
		if ($elm$core$Basics$isInfinite(fl) || $elm$core$Basics$isNaN(fl)) {
			return $elm$core$String$fromFloat(fl);
		} else {
			var signed = fl < 0;
			var _v0 = $myrho$elm_round$Round$splitComma(
				$myrho$elm_round$Round$toDecimal(
					$elm$core$Basics$abs(fl)));
			var before = _v0.a;
			var after = _v0.b;
			var r = $elm$core$String$length(before) + s;
			var normalized = _Utils_ap(
				A2($elm$core$String$repeat, (-r) + 1, '0'),
				A3(
					$elm$core$String$padRight,
					r,
					'0',
					_Utils_ap(before, after)));
			var totalLen = $elm$core$String$length(normalized);
			var roundDigitIndex = A2($elm$core$Basics$max, 1, r);
			var increase = A2(
				functor,
				signed,
				A3($elm$core$String$slice, roundDigitIndex, totalLen, normalized));
			var remains = A3($elm$core$String$slice, 0, roundDigitIndex, normalized);
			var num = increase ? $elm$core$String$reverse(
				A2(
					$elm$core$Maybe$withDefault,
					'1',
					A2(
						$elm$core$Maybe$map,
						$myrho$elm_round$Round$increaseNum,
						$elm$core$String$uncons(
							$elm$core$String$reverse(remains))))) : remains;
			var numLen = $elm$core$String$length(num);
			var numZeroed = (num === '0') ? num : ((s <= 0) ? _Utils_ap(
				num,
				A2(
					$elm$core$String$repeat,
					$elm$core$Basics$abs(s),
					'0')) : ((_Utils_cmp(
				s,
				$elm$core$String$length(after)) < 0) ? (A3($elm$core$String$slice, 0, numLen - s, num) + ('.' + A3($elm$core$String$slice, numLen - s, numLen, num))) : _Utils_ap(
				before + '.',
				A3($elm$core$String$padRight, s, '0', after))));
			return A2($myrho$elm_round$Round$addSign, signed, numZeroed);
		}
	});
var $myrho$elm_round$Round$round = $myrho$elm_round$Round$roundFun(
	F2(
		function (signed, str) {
			var _v0 = $elm$core$String$uncons(str);
			if (_v0.$ === 1) {
				return false;
			} else {
				if ('5' === _v0.a.a) {
					if (_v0.a.b === '') {
						var _v1 = _v0.a;
						return !signed;
					} else {
						var _v2 = _v0.a;
						return true;
					}
				} else {
					var _v3 = _v0.a;
					var _int = _v3.a;
					return function (i) {
						return ((i > 53) && signed) || ((i >= 53) && (!signed));
					}(
						$elm$core$Char$toCode(_int));
				}
			}
		}));
var $cuducos$elm_format_number$FormatNumber$Parser$splitInParts = F2(
	function (locale, value) {
		var toString = function () {
			var _v1 = locale.atx;
			switch (_v1.$) {
				case 1:
					var max = _v1.a;
					return $myrho$elm_round$Round$round(max);
				case 0:
					return $elm$core$String$fromFloat;
				default:
					var exact = _v1.a;
					return $myrho$elm_round$Round$round(exact);
			}
		}();
		var asList = A2(
			$elm$core$String$split,
			'.',
			toString(value));
		var decimals = function () {
			var _v0 = $elm$core$List$tail(asList);
			if (!_v0.$) {
				var values = _v0.a;
				return A2(
					$elm$core$Maybe$withDefault,
					'',
					$elm$core$List$head(values));
			} else {
				return '';
			}
		}();
		var integers = A2(
			$elm$core$Maybe$withDefault,
			'',
			$elm$core$List$head(asList));
		return _Utils_Tuple2(integers, decimals);
	});
var $cuducos$elm_format_number$FormatNumber$Parser$splitByIndian = function (integers) {
	var thousand = ($elm$core$String$length(integers) > 3) ? A2($elm$core$String$right, 3, integers) : integers;
	var reversedSplitHundreds = function (value) {
		return ($elm$core$String$length(value) > 2) ? A2(
			$elm$core$List$cons,
			A2($elm$core$String$right, 2, value),
			reversedSplitHundreds(
				A2($elm$core$String$dropRight, 2, value))) : ((!$elm$core$String$length(value)) ? _List_Nil : _List_fromArray(
			[value]));
	};
	return $elm$core$List$reverse(
		A2(
			$elm$core$List$cons,
			thousand,
			reversedSplitHundreds(
				A2($elm$core$String$dropRight, 3, integers))));
};
var $cuducos$elm_format_number$FormatNumber$Parser$splitByWestern = function (integers) {
	var reversedSplitThousands = function (value) {
		return ($elm$core$String$length(value) > 3) ? A2(
			$elm$core$List$cons,
			A2($elm$core$String$right, 3, value),
			reversedSplitThousands(
				A2($elm$core$String$dropRight, 3, value))) : _List_fromArray(
			[value]);
	};
	return $elm$core$List$reverse(
		reversedSplitThousands(integers));
};
var $cuducos$elm_format_number$FormatNumber$Parser$splitIntegers = F2(
	function (system, integers) {
		if (!system) {
			return $cuducos$elm_format_number$FormatNumber$Parser$splitByWestern(
				A2($elm$core$String$filter, $elm$core$Char$isDigit, integers));
		} else {
			return $cuducos$elm_format_number$FormatNumber$Parser$splitByIndian(
				A2($elm$core$String$filter, $elm$core$Char$isDigit, integers));
		}
	});
var $cuducos$elm_format_number$FormatNumber$Parser$parse = F2(
	function (locale, original) {
		var parts = A2($cuducos$elm_format_number$FormatNumber$Parser$splitInParts, locale, original);
		var integers = A2(
			$cuducos$elm_format_number$FormatNumber$Parser$splitIntegers,
			locale.ald,
			A2($elm$core$String$filter, $elm$core$Char$isDigit, parts.a));
		var decimals = A2($cuducos$elm_format_number$FormatNumber$Parser$getDecimals, locale, parts.b);
		var partial = A5($cuducos$elm_format_number$FormatNumber$Parser$FormattedNumber, original, integers, decimals, '', '');
		var _v0 = $cuducos$elm_format_number$FormatNumber$Parser$classify(partial);
		switch (_v0) {
			case 2:
				return _Utils_update(
					partial,
					{d8: locale.fm, ep: locale.fn});
			case 0:
				return _Utils_update(
					partial,
					{d8: locale.$x, ep: locale.$y});
			default:
				return _Utils_update(
					partial,
					{d8: locale.asQ, ep: locale.asR});
		}
	});
var $cuducos$elm_format_number$FormatNumber$Stringfy$formatDecimals = F2(
	function (locale, decimals) {
		return (decimals === '') ? '' : _Utils_ap(locale.a5, decimals);
	});
var $cuducos$elm_format_number$FormatNumber$Stringfy$stringfy = F2(
	function (locale, formatted) {
		var stringfyDecimals = $cuducos$elm_format_number$FormatNumber$Stringfy$formatDecimals(locale);
		var integers = A2($elm$core$String$join, locale.aZ, formatted.Oa);
		var decimals = stringfyDecimals(formatted.atx);
		return $elm$core$String$concat(
			_List_fromArray(
				[formatted.d8, integers, decimals, formatted.ep]));
	});
var $cuducos$elm_format_number$FormatNumber$format = F2(
	function (locale, number_) {
		return A2(
			$cuducos$elm_format_number$FormatNumber$Stringfy$stringfy,
			locale,
			A2($cuducos$elm_format_number$FormatNumber$Parser$parse, locale, number_));
	});
var $cuducos$elm_format_number$FormatNumber$Locales$Min = function (a) {
	return {$: 0, a: a};
};
var $cuducos$elm_format_number$FormatNumber$Locales$Western = 0;
var $cuducos$elm_format_number$FormatNumber$Locales$base = {
	a5: '.',
	atx: $cuducos$elm_format_number$FormatNumber$Locales$Min(0),
	fm: '−',
	fn: '',
	$x: '',
	$y: '',
	ald: 0,
	aZ: '',
	asQ: '',
	asR: ''
};
var $cuducos$elm_format_number$FormatNumber$Locales$frenchLocale = _Utils_update(
	$cuducos$elm_format_number$FormatNumber$Locales$base,
	{
		a5: ',',
		atx: $cuducos$elm_format_number$FormatNumber$Locales$Exact(3),
		aZ: '\u202F'
	});
var $mgold$elm_nonempty_list$List$Nonempty$foldl = F3(
	function (f, b, _v0) {
		var x = _v0.a;
		var xs = _v0.b;
		return A3(
			$elm$core$List$foldl,
			f,
			b,
			A2($elm$core$List$cons, x, xs));
	});
var $author$project$Util$NonEmpty$find = function (f) {
	return A2(
		$mgold$elm_nonempty_list$List$Nonempty$foldl,
		F2(
			function (x, acc) {
				if (acc.$ === 1) {
					return f(x) ? $elm$core$Maybe$Just(x) : $elm$core$Maybe$Nothing;
				} else {
					return acc;
				}
			}),
		$elm$core$Maybe$Nothing);
};
var $author$project$Data$SalaryCalculator$getSalaryPerHour = function (age) {
	return A2(
		$elm$core$Basics$composeR,
		function ($) {
			return $.bn;
		},
		A2(
			$elm$core$Basics$composeR,
			$author$project$Data$SalaryCalculator$toNonEmptySalaries,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Util$NonEmpty$find(
					function (v) {
						return _Utils_eq(v.hj, age);
					}),
				$elm$core$Maybe$map(
					function ($) {
						return $._B;
					}))));
};
var $author$project$Data$SalaryCalculator$defaultWeeksPerMonth = 4.3;
var $author$project$Data$SalaryCalculator$hourConfig = F2(
	function (maybeWeeksPerMonth, weeklyHours) {
		var monthlyHours = weeklyHours * A2($elm$core$Maybe$withDefault, $author$project$Data$SalaryCalculator$defaultWeeksPerMonth, maybeWeeksPerMonth);
		var yearlyHours = monthlyHours * 12;
		return {fk: monthlyHours, f2: weeklyHours, f4: yearlyHours};
	});
var $mgold$elm_nonempty_list$List$Nonempty$reverse = function (_v0) {
	var x = _v0.a;
	var xs = _v0.b;
	var revapp = function (_v1) {
		revapp:
		while (true) {
			var ls = _v1.a;
			var c = _v1.b;
			var rs = _v1.c;
			if (!rs.b) {
				return A2($mgold$elm_nonempty_list$List$Nonempty$Nonempty, c, ls);
			} else {
				var r = rs.a;
				var rss = rs.b;
				var $temp$_v1 = _Utils_Tuple3(
					A2($elm$core$List$cons, c, ls),
					r,
					rss);
				_v1 = $temp$_v1;
				continue revapp;
			}
		}
	};
	return revapp(
		_Utils_Tuple3(_List_Nil, x, xs));
};
var $author$project$Data$SalaryCalculator$maxSalaryPerHour = A2(
	$elm$core$Basics$composeR,
	function ($) {
		return $.bn;
	},
	A2(
		$elm$core$Basics$composeR,
		$author$project$Data$SalaryCalculator$toNonEmptySalaries,
		A2(
			$elm$core$Basics$composeR,
			$mgold$elm_nonempty_list$List$Nonempty$sortBy(
				function ($) {
					return $._B;
				}),
			A2(
				$elm$core$Basics$composeR,
				$mgold$elm_nonempty_list$List$Nonempty$reverse,
				A2(
					$elm$core$Basics$composeR,
					$mgold$elm_nonempty_list$List$Nonempty$head,
					function ($) {
						return $._B;
					})))));
var $author$project$Util$Mustache$headSafe = function (xs) {
	return A2(
		$elm$core$Maybe$withDefault,
		$elm$core$Maybe$Nothing,
		$elm$core$List$head(xs));
};
var $author$project$Util$Mustache$toCapitalCase = function (str) {
	return _Utils_ap(
		$elm$core$String$toUpper(
			A2($elm$core$String$left, 1, str)),
		A2($elm$core$String$dropLeft, 1, str));
};
var $author$project$Util$Mustache$toKeyString = function (str) {
	return A3(
		$elm$core$String$replace,
		'}',
		'',
		A3(
			$elm$core$String$replace,
			'{',
			'',
			A3(
				$elm$core$String$replace,
				' ',
				'',
				A2(
					$elm$core$String$join,
					'',
					A2(
						$elm$core$List$map,
						$author$project$Util$Mustache$toCapitalCase,
						$elm$core$String$words(
							$elm$core$String$toLower(str)))))));
};
var $author$project$Util$Mustache$isKey = F4(
	function (key_, val, def, matchValue) {
		return _Utils_eq(
			A2($elm$core$Maybe$map, $author$project$Util$Mustache$toKeyString, matchValue),
			$elm$core$Maybe$Just(key_)) ? val : def;
	});
var $author$project$Util$Mustache$matchKey = F3(
	function (match, f, d) {
		return A2(
			$elm$core$Maybe$withDefault,
			d,
			A2(
				$elm$core$Maybe$map,
				f(d),
				$elm$core$List$head(match.akt)));
	});
var $author$project$Util$Mustache$getSection = F2(
	function (nodes, match) {
		var expand = function (node) {
			if (node.$ === 1) {
				var key_ = node.a;
				var bool = node.b;
				return A3(
					$author$project$Util$Mustache$matchKey,
					match,
					A2($author$project$Util$Mustache$isKey, key_, bool),
					false);
			} else {
				return false;
			}
		};
		return A2($elm$core$List$any, expand, nodes) ? $author$project$Util$Mustache$headSafe(
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				$elm$core$List$tail(match.akt))) : $elm$core$Maybe$Nothing;
	});
var $author$project$Util$Mustache$mustacheRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('{[{]?#\\s?(.+?)\\s?\\i?[}]?}(.+?){[{]?/\\s?(.+?)\\s?\\i?[}]?}'));
var $author$project$Util$Mustache$renderSections = F2(
	function (template, nodes) {
		return A3(
			$elm$regex$Regex$replace,
			$author$project$Util$Mustache$mustacheRegex,
			A2(
				$elm$core$Basics$composeL,
				$elm$core$Maybe$withDefault(''),
				$author$project$Util$Mustache$getSection(nodes)),
			template);
	});
var $elm_community$maybe_extra$Maybe$Extra$cons = F2(
	function (item, list) {
		if (!item.$) {
			var v = item.a;
			return A2($elm$core$List$cons, v, list);
		} else {
			return list;
		}
	});
var $elm_community$maybe_extra$Maybe$Extra$values = A2($elm$core$List$foldr, $elm_community$maybe_extra$Maybe$Extra$cons, _List_Nil);
var $author$project$Util$Mustache$getVariable = F2(
	function (nodes, match) {
		var getContent = function (node) {
			if (!node.$) {
				var key_ = node.a;
				var val = node.b;
				return A3(
					$author$project$Util$Mustache$matchKey,
					match,
					A2(
						$author$project$Util$Mustache$isKey,
						key_,
						$elm$core$Maybe$Just(val)),
					$elm$core$Maybe$Nothing);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		};
		return A2(
			$elm$core$Maybe$withDefault,
			match.auE,
			$elm$core$List$head(
				$elm_community$maybe_extra$Maybe$Extra$values(
					A2($elm$core$List$map, getContent, nodes))));
	});
var $author$project$Util$Mustache$varRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('{[{]?\\s?(.+?)\\s?\\i?[}]?}'));
var $author$project$Util$Mustache$renderVariables = F2(
	function (nodes, template) {
		return A3(
			$elm$regex$Regex$replace,
			$author$project$Util$Mustache$varRegex,
			$author$project$Util$Mustache$getVariable(nodes),
			template);
	});
var $author$project$Util$Mustache$render = F2(
	function (nodes, template) {
		return A2(
			$author$project$Util$Mustache$renderVariables,
			nodes,
			A2($author$project$Util$Mustache$renderSections, template, nodes));
	});
var $author$project$Data$SalaryCalculator$interpolateMessage = F6(
	function (salaryCalculator, message, age, hours, factor, maybeWeeksPerMonth) {
		var perHour = A2(
			$elm$core$Maybe$withDefault,
			$author$project$Data$SalaryCalculator$maxSalaryPerHour(salaryCalculator),
			A2($author$project$Data$SalaryCalculator$getSalaryPerHour, age, salaryCalculator));
		var locale = $cuducos$elm_format_number$FormatNumber$Locales$frenchLocale;
		var _int = function (v) {
			return $elm$core$String$fromInt(v);
		};
		var hourConfig_ = A2($author$project$Data$SalaryCalculator$hourConfig, maybeWeeksPerMonth, hours);
		var applyFactor = function (h) {
			return (hours <= 12) ? ((perHour * factor) * h) : (perHour * h);
		};
		var toHourSalary = function (h) {
			return A2(
				$cuducos$elm_format_number$FormatNumber$format,
				_Utils_update(
					locale,
					{
						atx: $cuducos$elm_format_number$FormatNumber$Locales$Exact(2)
					}),
				applyFactor(h));
		};
		var perMonth = toHourSalary(hourConfig_.fk);
		var perWeek = toHourSalary(hourConfig_.f2);
		var perYear = toHourSalary(hourConfig_.f4);
		var total = toHourSalary(hours);
		return A2(
			$author$project$Util$Mustache$render,
			_List_fromArray(
				[
					A2(
					$author$project$Util$Mustache$Variable,
					'Age',
					_int(age)),
					A2(
					$author$project$Util$Mustache$Variable,
					'Leeftijd',
					_int(age)),
					A2(
					$author$project$Util$Mustache$Variable,
					'Hours',
					_int(hours)),
					A2(
					$author$project$Util$Mustache$Variable,
					'Uren',
					_int(hours)),
					A2($author$project$Util$Mustache$Variable, 'Function', salaryCalculator.bO),
					A2($author$project$Util$Mustache$Variable, 'Functie', salaryCalculator.bO),
					A2(
					$author$project$Util$Mustache$Variable,
					'Hourly',
					toHourSalary(1)),
					A2(
					$author$project$Util$Mustache$Variable,
					'Peruur',
					toHourSalary(1)),
					A2($author$project$Util$Mustache$Variable, 'Weekly', perWeek),
					A2($author$project$Util$Mustache$Variable, 'Wekelijks', perWeek),
					A2($author$project$Util$Mustache$Variable, 'Monthly', perMonth),
					A2($author$project$Util$Mustache$Variable, 'Maandelijks', perMonth),
					A2($author$project$Util$Mustache$Variable, 'Yearly', perYear),
					A2($author$project$Util$Mustache$Variable, 'Jaarlijks', perYear),
					A2($author$project$Util$Mustache$Variable, 'Totaal', total),
					A2($author$project$Util$Mustache$Variable, 'Total', total)
				]),
			message);
	});
var $author$project$View$SalaryCalculator$viewBodyCalculated = F5(
	function (_v0, plainText, age, hours, maybeWeeksPerMonth) {
		var state_ = _v0;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('salary-body-text')
				]),
			$author$project$Util$Html$parse(
				A6(
					$author$project$Data$SalaryCalculator$interpolateMessage,
					$author$project$Data$Entity$value(state_.au),
					plainText,
					age,
					hours,
					$author$project$View$SalaryCalculator$getFactor(state_.au),
					maybeWeeksPerMonth)));
	});
var $elm$html$Html$Attributes$step = function (n) {
	return A2($elm$html$Html$Attributes$stringProperty, 'step', n);
};
var $author$project$Component$Form$Input$viewRangeInput = F2(
	function (toMsg, config) {
		var widthPercentage = A2($elm$core$Basics$min, 100, ((config.ey - config.cB) / (config.dS - config.cB)) * 100);
		var widthString = A2(
			$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
			'{0}%',
			_List_fromArray(
				[
					$elm$core$String$fromFloat(widthPercentage)
				]));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('range-input', true),
							_Utils_Tuple2('styled', config.el)
						]))
				]),
			$elm$core$List$concat(
				_List_fromArray(
					[
						_List_fromArray(
						[
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$required(config.eb),
									$elm$html$Html$Attributes$type_('range'),
									$elm$html$Html$Attributes$min(
									$elm$core$String$fromFloat(config.cB)),
									$elm$html$Html$Attributes$max(
									$elm$core$String$fromFloat(config.dS)),
									$elm$html$Html$Attributes$step(
									$elm$core$String$fromFloat(config.fM)),
									$elm$html$Html$Attributes$id(
									A2(
										$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
										'{0}-input',
										_List_fromArray(
											[config.e5]))),
									$elm$html$Html$Attributes$value(
									$elm$core$String$fromFloat(config.ey)),
									A2(
									$elm$html$Html$Events$on,
									'input',
									A2(
										$elm$json$Json$Decode$map,
										toMsg,
										A2(
											$elm$json$Json$Decode$at,
											_List_fromArray(
												['target', 'valueAsNumber']),
											$elm$json$Json$Decode$float)))
								]),
							_List_Nil)
						]),
						config.el ? _List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('track')
								]),
							_List_Nil),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('range'),
									A2($elm$html$Html$Attributes$style, 'left', widthString)
								]),
							_List_Nil),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('thumb'),
									A2($elm$html$Html$Attributes$style, 'left', widthString)
								]),
							_List_Nil),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('tooltip'),
									A2($elm$html$Html$Attributes$style, 'left', widthString)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$elm$core$Maybe$withDefault,
										$elm$core$String$fromFloat(config.ey),
										A2(
											$elm$core$Maybe$map,
											function (f) {
												return f(config.ey);
											},
											config.fU)))
								]))
						]) : _List_Nil
					])));
	});
var $elm$html$Html$option = _VirtualDom_node('option');
var $elm$html$Html$select = _VirtualDom_node('select');
var $elm$html$Html$Attributes$selected = $elm$html$Html$Attributes$boolProperty('selected');
var $elm_community$maybe_extra$Maybe$Extra$unwrap = F3(
	function (_default, f, m) {
		if (m.$ === 1) {
			return _default;
		} else {
			var a = m.a;
			return f(a);
		}
	});
var $author$project$Component$Form$SelectNonEmpty$viewOption = F5(
	function (current, isDisabledCheck, toTitle, toValue, opt) {
		return A2(
			$elm$html$Html$option,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$value(
					toValue(opt)),
					$elm$html$Html$Attributes$selected(
					A2(
						$elm$core$Maybe$withDefault,
						false,
						A2(
							$elm$core$Maybe$map,
							$elm$core$Basics$apR(opt),
							current))),
					$elm$html$Html$Attributes$disabled(
					A3(
						$elm_community$maybe_extra$Maybe$Extra$unwrap,
						false,
						$elm$core$Basics$apR(opt),
						isDisabledCheck))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					toTitle(opt))
				]));
	});
var $author$project$Component$Form$SelectNonEmpty$viewSelectHelp = F3(
	function (maybeToShortTitle, extraAttributes, config) {
		var selectAttributes = _Utils_ap(
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeL, $elm$core$List$singleton, $elm$html$Html$Attributes$tabindex),
					config.avS)),
			extraAttributes);
		var isSelected = function (opt) {
			return A2(
				$elm$core$Maybe$withDefault,
				false,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$apR(opt),
					config.atr));
		};
		var isJust = function (maybeValue) {
			if (maybeValue.$ === 1) {
				return $elm$json$Json$Decode$fail('Value is Nothing');
			} else {
				var value = maybeValue.a;
				return $elm$json$Json$Decode$succeed(value);
			}
		};
		var decoder = A2(
			$elm$json$Json$Decode$andThen,
			A2($elm$core$Basics$composeL, isJust, config.at7),
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['target', 'value']),
				$elm$json$Json$Decode$string));
		var _v0 = config.au7;
		var x = _v0.a;
		var xs = _v0.b;
		var echo = function () {
			if (maybeToShortTitle.$ === 1) {
				return _List_Nil;
			} else {
				var toShortTitle = maybeToShortTitle.a;
				return A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function (opt) {
							return _List_fromArray(
								[
									A2(
									$elm$html$Html$select,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('custom-select-echo'),
											A2($elm$html$Html$Attributes$attribute, 'inert', ''),
											A2($elm$html$Html$Attributes$attribute, 'aria-hidden', 'true'),
											$elm$html$Html$Attributes$tabindex(-1)
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$option,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$selected(true)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													toShortTitle(opt))
												]))
										]))
								]);
						},
						$elm$core$List$head(
							A2(
								$elm$core$List$filter,
								isSelected,
								A2($elm$core$List$cons, x, xs)))));
			}
		}();
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('custom-select'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('as-text', config.avz),
							_Utils_Tuple2(
							'has-code-overlay',
							!$elm$core$List$isEmpty(echo))
						]))
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$elm$html$Html$select,
					A2(
						$elm$core$List$cons,
						A2(
							$elm$html$Html$Events$on,
							'change',
							A2($elm$json$Json$Decode$map, config.avZ, decoder)),
						selectAttributes),
					A2(
						$elm$core$List$map,
						A4($author$project$Component$Form$SelectNonEmpty$viewOption, config.atr, config.auq, config.av_, config.av$),
						A2($elm$core$List$cons, x, xs))),
				echo));
	});
var $author$project$Component$Form$SelectNonEmpty$viewSelect = A2($author$project$Component$Form$SelectNonEmpty$viewSelectHelp, $elm$core$Maybe$Nothing, _List_Nil);
var $mgold$elm_nonempty_list$List$Nonempty$tail = function (_v0) {
	var x = _v0.a;
	var xs = _v0.b;
	return xs;
};
var $author$project$View$SalaryCalculator$viewSelect = F2(
	function (_v0, all) {
		var selectedSalaryCalculator = _v0.au;
		return $author$project$Component$Form$SelectNonEmpty$viewSelect(
			{
				atr: $elm$core$Maybe$Just(
					$elm$core$Basics$eq(selectedSalaryCalculator)),
				at7: function (id) {
					return A2(
						$author$project$Util$NonEmpty$find,
						A2(
							$elm$core$Basics$composeL,
							A2(
								$elm$core$Basics$composeL,
								$elm$core$Basics$eq(id),
								$author$project$Data$Id$toString),
							$author$project$Data$Entity$id),
						all);
				},
				auq: $elm$core$Maybe$Nothing,
				au7: _Utils_Tuple2(
					$mgold$elm_nonempty_list$List$Nonempty$head(all),
					$mgold$elm_nonempty_list$List$Nonempty$tail(all)),
				avz: false,
				avS: $elm$core$Maybe$Nothing,
				avZ: $author$project$View$SalaryCalculator$init,
				av_: A2(
					$elm$core$Basics$composeL,
					function ($) {
						return $.bO;
					},
					$author$project$Data$Entity$value),
				av$: A2($elm$core$Basics$composeL, $author$project$Data$Id$toString, $author$project$Data$Entity$id)
			});
	});
var $author$project$View$SalaryCalculator$getExtraDescription = function (salaryCalculatorEntity) {
	return $author$project$Data$Entity$value(salaryCalculatorEntity).G1;
};
var $author$project$View$SalaryCalculator$viewVacancyExtraDescription = function (salaryCalculatorEntity) {
	return A2(
		$author$project$Util$View$viewMaybe,
		$author$project$View$SalaryCalculator$getExtraDescription(salaryCalculatorEntity),
		function (extraDescription) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('salary-body-text')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(extraDescription)
					]));
		});
};
var $author$project$View$SalaryCalculator$viewBodyCalculating = F5(
	function (state, plainText, allTables, udb, maybeWeeksPerMonth) {
		var state_ = state;
		var selectConfig = {
			atr: $elm$core$Maybe$Just(
				$elm$core$Basics$eq(
					$author$project$View$SalaryCalculator$intToAge(state_.hj))),
			at7: $author$project$View$SalaryCalculator$stringToAge,
			auq: $elm$core$Maybe$Nothing,
			au7: _Utils_Tuple2(
				0,
				_List_fromArray(
					[1, 2, 3, 4, 5, 6, 7])),
			avz: false,
			avS: $elm$core$Maybe$Nothing,
			avZ: A2(
				$elm$core$Basics$composeR,
				$author$project$View$SalaryCalculator$ageToInt,
				$author$project$View$SalaryCalculator$setAge(state)),
			av_: $author$project$View$SalaryCalculator$ageToString,
			av$: $author$project$View$SalaryCalculator$ageToString
		};
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('salary-calculator-body', true)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Util$View$viewIfNot,
					$mgold$elm_nonempty_list$List$Nonempty$isSingleton(allTables),
					function (_v0) {
						return A2($author$project$View$SalaryCalculator$viewSelect, state, allTables);
					}),
					udb ? A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('form-fields')
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Component$Form$Input$viewFormField,
							$author$project$Copy$copy.hj,
							$elm$core$Maybe$Nothing,
							$author$project$Component$Form$SelectNonEmpty$viewSelect(selectConfig)),
							A3(
							$author$project$Component$Form$Input$viewFormField,
							$author$project$Copy$copy.Xi,
							$elm$core$Maybe$Nothing,
							A2(
								$author$project$Component$Form$NumberInput$view,
								'',
								_List_fromArray(
									[
										$author$project$Component$Form$NumberInput$onInput(
										$author$project$View$SalaryCalculator$setHours(state)),
										$author$project$Component$Form$NumberInput$id('float-input'),
										$author$project$Component$Form$NumberInput$value(state_.MX),
										$author$project$Component$Form$NumberInput$placeholder('0'),
										$author$project$Component$Form$NumberInput$max(
										$author$project$View$SalaryCalculator$getMaxHours(state_.au)),
										$author$project$Component$Form$NumberInput$min(
										$author$project$View$SalaryCalculator$getMinHours(state_.au))
									])))
						])) : A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('form-fields')
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Component$Form$Input$viewFormField,
							$author$project$Copy$copy.hj,
							$elm$core$Maybe$Nothing,
							A2(
								$author$project$Component$Form$Input$viewRangeInput,
								A2(
									$elm$core$Basics$composeR,
									$elm$core$Basics$round,
									$author$project$View$SalaryCalculator$setAge(state)),
								{
									e5: 'range',
									dS: 99,
									cB: $author$project$Data$SalaryCalculator$minAge(
										$author$project$Data$Entity$value(state_.au)),
									eb: false,
									fM: 1,
									el: true,
									fU: $elm$core$Maybe$Nothing,
									ey: state_.hj
								})),
							A3(
							$author$project$Component$Form$Input$viewFormField,
							$author$project$Copy$copy.Xi,
							$elm$core$Maybe$Nothing,
							A2(
								$author$project$Component$Form$Input$viewRangeInput,
								A2(
									$elm$core$Basics$composeR,
									$elm$core$Basics$round,
									$author$project$View$SalaryCalculator$setHours(state)),
								{
									e5: 'range',
									dS: $author$project$View$SalaryCalculator$getMaxHours(state_.au),
									cB: $author$project$View$SalaryCalculator$getMinHours(state_.au),
									eb: false,
									fM: 1,
									el: true,
									fU: $elm$core$Maybe$Nothing,
									ey: state_.MX
								}))
						])),
					A5($author$project$View$SalaryCalculator$viewBodyCalculated, state, plainText, state_.hj, state_.MX, maybeWeeksPerMonth),
					$author$project$View$SalaryCalculator$viewVacancyExtraDescription(state_.au)
				]));
	});
var $author$project$View$SalaryCalculator$view = F2(
	function (config, state) {
		return A2(
			$elm$html$Html$map,
			config.aut,
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('salary-calculator-wrapper')
					]),
				_List_fromArray(
					[
						A5($author$project$View$SalaryCalculator$viewBodyCalculating, state, config._3, config.bo, config.b7, config.a3)
					])));
	});
var $author$project$SalaryCalculator$view = function (model) {
	return A2(
		$author$project$View$SalaryCalculator$view,
		{aut: $elm$core$Basics$identity, _3: model._3.alE, bo: model.bo, b7: model.b7, a3: model.a3},
		model.adV);
};
var $author$project$SalaryCalculator$main = A2(
	$author$project$Browser$Custom$elementWithFlags,
	$author$project$SalaryCalculator$decodeFlags,
	{
		dH: $author$project$SalaryCalculator$init,
		em: $elm$core$Basics$always($elm$core$Platform$Sub$none),
		ex: $author$project$SalaryCalculator$update,
		ez: $author$project$SalaryCalculator$view
	});
var $author$project$ReferralToolForm$Flags = F7(
	function (translations, currentLangCode, referralFormResponse, domainId, sessionToken, csrfToken, domains) {
		return {ci: csrfToken, bE: currentLangCode, dp: domainId, bG: domains, cJ: referralFormResponse, aW: sessionToken, anB: translations};
	});
var $author$project$Data$Domains$Domains = $elm$core$Basics$identity;
var $author$project$Data$Domains$decodeZipper = function () {
	var decode = function (x) {
		if (!x.b) {
			return $elm$json$Json$Decode$fail('can\'t make a zipper from an empty list');
		} else {
			var y = x.a;
			var ys = x.b;
			return $elm$json$Json$Decode$succeed(
				A2($wernerdegroot$listzipper$List$Zipper$fromCons, y, ys));
		}
	};
	return A2(
		$elm$core$Basics$composeL,
		$elm$json$Json$Decode$andThen(decode),
		$elm$json$Json$Decode$list);
}();
var $author$project$Model$Domain$Domain = function (addressEnabled) {
	return function (altCss) {
		return function (betterUptimeUrl) {
			return function (consentDefault) {
				return function (cookieModalSettings) {
					return function (corporateWebsite) {
						return function (corporateWebsiteUrl) {
							return function (cssClass) {
								return function (customEmailLogo) {
									return function (customFavicon) {
										return function (customLogo) {
											return function (domainSwitchLabel) {
												return function (email) {
													return function (googleForJobsCustomLogo) {
														return function (googleAnalyticsApiKey) {
															return function (googleAnalyticsStreamId) {
																return function (googleCloudApiKey) {
																	return function (googleCloudMapsApiKey) {
																		return function (googleDataStudioUrl) {
																			return function (googleGeocodingRegion) {
																				return function (googleTagManagerId) {
																					return function (googleTagManagerServerSideTrackingUrl) {
																						return function (headSnippets) {
																							return function (headerJobAlertTitle) {
																								return function (hoursFilterEnabled) {
																									return function (includeInCmsSwitch) {
																										return function (includeInLanguageSwitch) {
																											return function (includeInTopBarDomainSwitch) {
																												return function (indeedConversionCode) {
																													return function (indeedFulltimeThreshold) {
																														return function (isInternal) {
																															return function (isNonVacancyDomain) {
																																return function (label) {
																																	return function (langCode) {
																																		return function (linkedDomainKey) {
																																			return function (linkedInPixel) {
																																				return function (locationUrlPrefix) {
																																					return function (mobileSubMenuToggle) {
																																						return function (name) {
																																							return function (pathPrefix) {
																																								return function (possibleAltCss) {
																																									return function (postmarkApiKey) {
																																										return function (region) {
																																											return function (salaryFilterEnabled) {
																																												return function (samlLoginText) {
																																													return function (seedPages) {
																																														return function (showDomainSwitch) {
																																															return function (title) {
																																																return function (vacancyDetailMetadata) {
																																																	return function (vacancyItemImageDefault) {
																																																		return function (vacancyOverviewMetadata) {
																																																			return function (consolidationExcludeFilters) {
																																																				return function (whatsappNumber) {
																																																					return function (whatsappConfig) {
																																																						return function (boundingBox) {
																																																							return function (orgName) {
																																																								return function (themeId) {
																																																									return function (seqNo) {
																																																										return function (extraSearchableCountries) {
																																																											return {g7: addressEnabled, jo: altCss, as7: betterUptimeUrl, o7: boundingBox, sr: consentDefault, sw: consolidationExcludeFilters, wV: cookieModalSettings, w1: corporateWebsite, w2: corporateWebsiteUrl, xD: cssClass, x1: customEmailLogo, x4: customFavicon, yb: customLogo, Eo: domainSwitchLabel, eR: email, G7: extraSearchableCountries, Lz: googleAnalyticsApiKey, aua: googleAnalyticsStreamId, aub: googleCloudApiKey, LC: googleCloudMapsApiKey, auc: googleDataStudioUrl, LD: googleForJobsCustomLogo, LE: googleGeocodingRegion, LF: googleTagManagerId, LG: googleTagManagerServerSideTrackingUrl, Mj: headSnippets, Mk: headerJobAlertTitle, MZ: hoursFilterEnabled, NL: includeInCmsSwitch, NM: includeInLanguageSwitch, NN: includeInTopBarDomainSwitch, NO: indeedConversionCode, NQ: indeedFulltimeThreshold, aur: isInternal, O0: isNonVacancyDomain, bO: label, Ql: langCode, Rc: linkedDomainKey, Re: linkedInPixel, RD: locationUrlPrefix, Tw: mobileSubMenuToggle, dY: name, Y0: orgName, ft: pathPrefix, $z: possibleAltCss, $L: postmarkApiKey, avp: region, ad$: salaryFilterEnabled, ad7: samlLoginText, ae$: seedPages, agZ: seqNo, ahF: showDomainSwitch, al9: themeId, avV: title, aqB: vacancyDetailMetadata, aqN: vacancyItemImageDefault, aqZ: vacancyOverviewMetadata, asg: whatsappConfig, asi: whatsappNumber};
																																																										};
																																																									};
																																																								};
																																																							};
																																																						};
																																																					};
																																																				};
																																																			};
																																																		};
																																																	};
																																																};
																																															};
																																														};
																																													};
																																												};
																																											};
																																										};
																																									};
																																								};
																																							};
																																						};
																																					};
																																				};
																																			};
																																		};
																																	};
																																};
																															};
																														};
																													};
																												};
																											};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Model$AltCss$AltCss = F2(
	function (label, file) {
		return {HC: file, bO: label};
	});
var $author$project$Model$AltCss$altCssDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'file',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'label',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Model$AltCss$AltCss)));
var $author$project$Model$Geography$BoundingBox = F2(
	function (topLeft, bottomRight) {
		return {o4: bottomRight, anf: topLeft};
	});
var $author$project$Model$Geography$GeoPoint = F2(
	function (latitude, longitude) {
		return {QE: latitude, RZ: longitude};
	});
var $author$project$Model$Geography$geoPointDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'longitude',
	$elm$json$Json$Decode$float,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'latitude',
		$elm$json$Json$Decode$float,
		$elm$json$Json$Decode$succeed($author$project$Model$Geography$GeoPoint)));
var $author$project$Model$Geography$boundingBoxDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'bottomRight',
	$author$project$Model$Geography$geoPointDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'topLeft',
		$author$project$Model$Geography$geoPointDecoder,
		$elm$json$Json$Decode$succeed($author$project$Model$Geography$BoundingBox)));
var $author$project$Model$CookieConsent$Functional = 1;
var $author$project$Model$CookieConsent$Marketing = 3;
var $author$project$Model$CookieConsent$Necessary = 0;
var $author$project$Model$CookieConsent$Statistics = 2;
var $author$project$Model$CookieConsent$cookieConsentDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'necessary':
				return $elm$json$Json$Decode$succeed(0);
			case 'functional':
				return $elm$json$Json$Decode$succeed(1);
			case 'statistics':
				return $elm$json$Json$Decode$succeed(2);
			case 'marketing':
				return $elm$json$Json$Decode$succeed(3);
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Model$CookieModalSettings$CookieBot = function (a) {
	return {$: 3, a: a};
};
var $author$project$Model$CookieModalSettings$Didimo = function (a) {
	return {$: 1, a: a};
};
var $author$project$Model$CookieModalSettings$OneTrust = function (a) {
	return {$: 4, a: a};
};
var $author$project$Model$CookieModalSettings$Tafkar = {$: 0};
var $author$project$Model$CookieModalSettings$UserCentrics = function (a) {
	return {$: 2, a: a};
};
var $author$project$Model$CookieModalSettings$DidomiConfig = F5(
	function (didomiId, tokenCookieName, consentStringCookieName, iabCookieName, sdkPath) {
		return {st: consentStringCookieName, D0: didomiId, Nq: iabCookieName, aeA: sdkPath, am5: tokenCookieName};
	});
var $danyx23$elm_uuid$Uuid$Uuid = $elm$core$Basics$identity;
var $elm$regex$Regex$contains = _Regex_contains;
var $danyx23$elm_uuid$Uuid$Barebones$uuidRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^[0-9A-Fa-f]{8,8}-[0-9A-Fa-f]{4,4}-[1-5][0-9A-Fa-f]{3,3}-[8-9A-Ba-b][0-9A-Fa-f]{3,3}-[0-9A-Fa-f]{12,12}$'));
var $danyx23$elm_uuid$Uuid$Barebones$isValidUuid = function (uuidAsString) {
	return A2($elm$regex$Regex$contains, $danyx23$elm_uuid$Uuid$Barebones$uuidRegex, uuidAsString);
};
var $danyx23$elm_uuid$Uuid$fromString = function (text) {
	return $danyx23$elm_uuid$Uuid$Barebones$isValidUuid(text) ? $elm$core$Maybe$Just(
		$elm$core$String$toLower(text)) : $elm$core$Maybe$Nothing;
};
var $danyx23$elm_uuid$Uuid$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		var _v0 = $danyx23$elm_uuid$Uuid$fromString(string);
		if (!_v0.$) {
			var uuid = _v0.a;
			return $elm$json$Json$Decode$succeed(uuid);
		} else {
			return $elm$json$Json$Decode$fail('Not a valid UUID');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Model$CookieModalSettings$didomiConfigDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'sdkPath',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'iabCookieName',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'consentStringCookieName',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'tokenCookieName',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'didomiId',
					$danyx23$elm_uuid$Uuid$decoder,
					$elm$json$Json$Decode$succeed($author$project$Model$CookieModalSettings$DidomiConfig))))));
var $author$project$Model$CookieModalSettings$OneTrustConfig = F3(
	function (oneTrustId, oneTrustBaseUrl, oneTrustAutoBlock) {
		return {X6: oneTrustAutoBlock, X8: oneTrustBaseUrl, Ya: oneTrustId};
	});
var $author$project$Model$CookieModalSettings$oneTrustConfigDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'oneTrustAutoBlock',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'oneTrustBaseUrl',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'oneTrustId',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Model$CookieModalSettings$OneTrustConfig))));
var $author$project$Model$CookieModalSettings$cookieModalSettingsDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'tafkar':
				return $elm$json$Json$Decode$succeed($author$project$Model$CookieModalSettings$Tafkar);
			case 'didimo':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$CookieModalSettings$didomiConfigDecoder,
					$elm$json$Json$Decode$succeed($author$project$Model$CookieModalSettings$Didimo));
			case 'user-centrics':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Model$CookieModalSettings$UserCentrics));
			case 'cookie-bot':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Model$CookieModalSettings$CookieBot));
			case 'one-trust':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$CookieModalSettings$oneTrustConfigDecoder,
					$elm$json$Json$Decode$succeed($author$project$Model$CookieModalSettings$OneTrust));
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	A2($elm$json$Json$Decode$field, 'tag', $elm$json$Json$Decode$string));
var $author$project$Model$CorporateLink = F2(
	function (url, label) {
		return {bO: label, a0: url};
	});
var $author$project$Model$corporateLinkDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'label',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'url',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Model$CorporateLink)));
var $author$project$Model$Country$AT = 0;
var $author$project$Model$Country$BE = 1;
var $author$project$Model$Country$CH = 2;
var $author$project$Model$Country$CN = 3;
var $author$project$Model$Country$DE = 4;
var $author$project$Model$Country$DK = 5;
var $author$project$Model$Country$ES = 6;
var $author$project$Model$Country$FI = 7;
var $author$project$Model$Country$FR = 8;
var $author$project$Model$Country$GB = 9;
var $author$project$Model$Country$HU = 10;
var $author$project$Model$Country$IE = 11;
var $author$project$Model$Country$LU = 12;
var $author$project$Model$Country$NL = 13;
var $author$project$Model$Country$NO = 14;
var $author$project$Model$Country$PL = 15;
var $author$project$Model$Country$PT = 16;
var $author$project$Model$Country$RO = 17;
var $author$project$Model$Country$SE = 19;
var $author$project$Model$Country$SK = 18;
var $author$project$Model$Country$UK = 21;
var $author$project$Model$Country$US = 20;
var $author$project$Model$Country$countryDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'at':
				return $elm$json$Json$Decode$succeed(0);
			case 'be':
				return $elm$json$Json$Decode$succeed(1);
			case 'ch':
				return $elm$json$Json$Decode$succeed(2);
			case 'cn':
				return $elm$json$Json$Decode$succeed(3);
			case 'de':
				return $elm$json$Json$Decode$succeed(4);
			case 'dk':
				return $elm$json$Json$Decode$succeed(5);
			case 'es':
				return $elm$json$Json$Decode$succeed(6);
			case 'fi':
				return $elm$json$Json$Decode$succeed(7);
			case 'fr':
				return $elm$json$Json$Decode$succeed(8);
			case 'gb':
				return $elm$json$Json$Decode$succeed(9);
			case 'hu':
				return $elm$json$Json$Decode$succeed(10);
			case 'ie':
				return $elm$json$Json$Decode$succeed(11);
			case 'lu':
				return $elm$json$Json$Decode$succeed(12);
			case 'nl':
				return $elm$json$Json$Decode$succeed(13);
			case 'no':
				return $elm$json$Json$Decode$succeed(14);
			case 'pl':
				return $elm$json$Json$Decode$succeed(15);
			case 'pt':
				return $elm$json$Json$Decode$succeed(16);
			case 'ro':
				return $elm$json$Json$Decode$succeed(17);
			case 'sk':
				return $elm$json$Json$Decode$succeed(18);
			case 'se':
				return $elm$json$Json$Decode$succeed(19);
			case 'us':
				return $elm$json$Json$Decode$succeed(20);
			case 'uk':
				return $elm$json$Json$Decode$succeed(21);
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Model$WhatsappConfig$WhatsappConfig = F4(
	function (countryCallingCode, phone, disable, btnText) {
		return {pk: btnText, w6: countryCallingCode, D3: disable, aR: phone};
	});
var $author$project$Util$Json$maybeToDecoder = F2(
	function (decoder, f) {
		return A2(
			$elm$json$Json$Decode$andThen,
			function (x) {
				var _v0 = f(x);
				if (_v0.$ === 1) {
					return $elm$json$Json$Decode$fail('Maybe value was Nothing');
				} else {
					var y = _v0.a;
					return $elm$json$Json$Decode$succeed(y);
				}
			},
			decoder);
	});
var $author$project$Util$Json$enumDecoder = function (fromString) {
	return A2($author$project$Util$Json$maybeToDecoder, $elm$json$Json$Decode$string, fromString);
};
var $author$project$Model$CountryCallingCode$Afghanistan = 0;
var $author$project$Model$CountryCallingCode$AlandIslands = 1;
var $author$project$Model$CountryCallingCode$Albania = 2;
var $author$project$Model$CountryCallingCode$Algeria = 3;
var $author$project$Model$CountryCallingCode$AmericanSamoa = 4;
var $author$project$Model$CountryCallingCode$Andorra = 5;
var $author$project$Model$CountryCallingCode$Angola = 6;
var $author$project$Model$CountryCallingCode$Anguilla = 7;
var $author$project$Model$CountryCallingCode$AntiguaandBarbuda = 8;
var $author$project$Model$CountryCallingCode$Argentina = 9;
var $author$project$Model$CountryCallingCode$Armenia = 10;
var $author$project$Model$CountryCallingCode$Aruba = 11;
var $author$project$Model$CountryCallingCode$Australia = 12;
var $author$project$Model$CountryCallingCode$Austria = 13;
var $author$project$Model$CountryCallingCode$Azerbaijan = 14;
var $author$project$Model$CountryCallingCode$Bahamas = 15;
var $author$project$Model$CountryCallingCode$Bahrain = 16;
var $author$project$Model$CountryCallingCode$Bangladesh = 17;
var $author$project$Model$CountryCallingCode$Barbados = 18;
var $author$project$Model$CountryCallingCode$Belarus = 19;
var $author$project$Model$CountryCallingCode$Belgium = 20;
var $author$project$Model$CountryCallingCode$Belize = 21;
var $author$project$Model$CountryCallingCode$Benin = 22;
var $author$project$Model$CountryCallingCode$Bermuda = 23;
var $author$project$Model$CountryCallingCode$Bhutan = 24;
var $author$project$Model$CountryCallingCode$Bolivia = 25;
var $author$project$Model$CountryCallingCode$BosniaandHerzegovina = 26;
var $author$project$Model$CountryCallingCode$Botswana = 27;
var $author$project$Model$CountryCallingCode$Brazil = 28;
var $author$project$Model$CountryCallingCode$BritishIndianOceanTerritory = 29;
var $author$project$Model$CountryCallingCode$BritishVirginIslands = 30;
var $author$project$Model$CountryCallingCode$Brunei = 31;
var $author$project$Model$CountryCallingCode$Bulgaria = 32;
var $author$project$Model$CountryCallingCode$BurkinaFaso = 33;
var $author$project$Model$CountryCallingCode$Burundi = 34;
var $author$project$Model$CountryCallingCode$Cambodia = 35;
var $author$project$Model$CountryCallingCode$Cameroon = 36;
var $author$project$Model$CountryCallingCode$Canada = 37;
var $author$project$Model$CountryCallingCode$CapeVerde = 38;
var $author$project$Model$CountryCallingCode$CaribbeanNetherlands = 39;
var $author$project$Model$CountryCallingCode$CaymanIslands = 40;
var $author$project$Model$CountryCallingCode$CentralAfricanRepublic = 41;
var $author$project$Model$CountryCallingCode$Chad = 42;
var $author$project$Model$CountryCallingCode$Chile = 43;
var $author$project$Model$CountryCallingCode$China = 44;
var $author$project$Model$CountryCallingCode$ChristmasIsland = 45;
var $author$project$Model$CountryCallingCode$CocosKeelingIslands = 46;
var $author$project$Model$CountryCallingCode$Colombia = 47;
var $author$project$Model$CountryCallingCode$Comoros = 48;
var $author$project$Model$CountryCallingCode$Congo = 56;
var $author$project$Model$CountryCallingCode$CookIslands = 49;
var $author$project$Model$CountryCallingCode$CostaRica = 50;
var $author$project$Model$CountryCallingCode$Croatia = 51;
var $author$project$Model$CountryCallingCode$Cuba = 52;
var $author$project$Model$CountryCallingCode$Curacao = 53;
var $author$project$Model$CountryCallingCode$Cyprus = 54;
var $author$project$Model$CountryCallingCode$CzechRepublic = 55;
var $author$project$Model$CountryCallingCode$Denmark = 57;
var $author$project$Model$CountryCallingCode$Djibouti = 58;
var $author$project$Model$CountryCallingCode$Dominica = 59;
var $author$project$Model$CountryCallingCode$DominicanRepublic = 60;
var $author$project$Model$CountryCallingCode$Ecuador = 61;
var $author$project$Model$CountryCallingCode$Egypt = 62;
var $author$project$Model$CountryCallingCode$ElSalvador = 63;
var $author$project$Model$CountryCallingCode$EquatorialGuinea = 64;
var $author$project$Model$CountryCallingCode$Eritrea = 65;
var $author$project$Model$CountryCallingCode$Estonia = 66;
var $author$project$Model$CountryCallingCode$Eswatini = 67;
var $author$project$Model$CountryCallingCode$Ethiopia = 68;
var $author$project$Model$CountryCallingCode$FalklandIslands = 69;
var $author$project$Model$CountryCallingCode$FaroeIslands = 70;
var $author$project$Model$CountryCallingCode$Fiji = 71;
var $author$project$Model$CountryCallingCode$Finland = 72;
var $author$project$Model$CountryCallingCode$France = 73;
var $author$project$Model$CountryCallingCode$FrenchGuiana = 74;
var $author$project$Model$CountryCallingCode$FrenchPolynesia = 75;
var $author$project$Model$CountryCallingCode$Gabon = 76;
var $author$project$Model$CountryCallingCode$Gambia = 77;
var $author$project$Model$CountryCallingCode$Georgia = 78;
var $author$project$Model$CountryCallingCode$Germany = 79;
var $author$project$Model$CountryCallingCode$Ghana = 80;
var $author$project$Model$CountryCallingCode$Gibraltar = 81;
var $author$project$Model$CountryCallingCode$Greece = 82;
var $author$project$Model$CountryCallingCode$Greenland = 83;
var $author$project$Model$CountryCallingCode$Grenada = 84;
var $author$project$Model$CountryCallingCode$Guadeloupe = 85;
var $author$project$Model$CountryCallingCode$Guam = 86;
var $author$project$Model$CountryCallingCode$Guatemala = 87;
var $author$project$Model$CountryCallingCode$Guernsey = 88;
var $author$project$Model$CountryCallingCode$Guinea = 89;
var $author$project$Model$CountryCallingCode$GuineaBissau = 90;
var $author$project$Model$CountryCallingCode$Guyana = 91;
var $author$project$Model$CountryCallingCode$Haiti = 92;
var $author$project$Model$CountryCallingCode$Honduras = 93;
var $author$project$Model$CountryCallingCode$HongKong = 94;
var $author$project$Model$CountryCallingCode$Hungary = 95;
var $author$project$Model$CountryCallingCode$Iceland = 96;
var $author$project$Model$CountryCallingCode$India = 97;
var $author$project$Model$CountryCallingCode$Indonesia = 98;
var $author$project$Model$CountryCallingCode$Iran = 99;
var $author$project$Model$CountryCallingCode$Iraq = 100;
var $author$project$Model$CountryCallingCode$Ireland = 101;
var $author$project$Model$CountryCallingCode$IsleofMan = 102;
var $author$project$Model$CountryCallingCode$Israel = 103;
var $author$project$Model$CountryCallingCode$Italy = 104;
var $author$project$Model$CountryCallingCode$IvoryCoast = 105;
var $author$project$Model$CountryCallingCode$Jamaica = 106;
var $author$project$Model$CountryCallingCode$Japan = 107;
var $author$project$Model$CountryCallingCode$Jersey = 108;
var $author$project$Model$CountryCallingCode$Jordan = 109;
var $author$project$Model$CountryCallingCode$Kazakhstan = 110;
var $author$project$Model$CountryCallingCode$Kenya = 111;
var $author$project$Model$CountryCallingCode$Kiribati = 112;
var $author$project$Model$CountryCallingCode$Kosovo = 113;
var $author$project$Model$CountryCallingCode$Kuwait = 114;
var $author$project$Model$CountryCallingCode$Kyrgyzstan = 115;
var $author$project$Model$CountryCallingCode$Laos = 116;
var $author$project$Model$CountryCallingCode$Latvia = 117;
var $author$project$Model$CountryCallingCode$Lebanon = 118;
var $author$project$Model$CountryCallingCode$Lesotho = 119;
var $author$project$Model$CountryCallingCode$Liberia = 120;
var $author$project$Model$CountryCallingCode$Libya = 121;
var $author$project$Model$CountryCallingCode$Liechtenstein = 122;
var $author$project$Model$CountryCallingCode$Lithuania = 123;
var $author$project$Model$CountryCallingCode$Luxembourg = 124;
var $author$project$Model$CountryCallingCode$Macau = 125;
var $author$project$Model$CountryCallingCode$Macedonia = 126;
var $author$project$Model$CountryCallingCode$Madagascar = 127;
var $author$project$Model$CountryCallingCode$Malawi = 128;
var $author$project$Model$CountryCallingCode$Malaysia = 129;
var $author$project$Model$CountryCallingCode$Maldives = 130;
var $author$project$Model$CountryCallingCode$Mali = 131;
var $author$project$Model$CountryCallingCode$Malta = 132;
var $author$project$Model$CountryCallingCode$MarshallIslands = 133;
var $author$project$Model$CountryCallingCode$Martinique = 134;
var $author$project$Model$CountryCallingCode$Mauritania = 135;
var $author$project$Model$CountryCallingCode$Mauritius = 136;
var $author$project$Model$CountryCallingCode$Mayotte = 137;
var $author$project$Model$CountryCallingCode$Mexico = 138;
var $author$project$Model$CountryCallingCode$Micronesia = 139;
var $author$project$Model$CountryCallingCode$Moldova = 140;
var $author$project$Model$CountryCallingCode$Monaco = 141;
var $author$project$Model$CountryCallingCode$Mongolia = 142;
var $author$project$Model$CountryCallingCode$Montenegro = 143;
var $author$project$Model$CountryCallingCode$Montserrat = 144;
var $author$project$Model$CountryCallingCode$Morocco = 145;
var $author$project$Model$CountryCallingCode$Mozambique = 146;
var $author$project$Model$CountryCallingCode$Myanmar = 147;
var $author$project$Model$CountryCallingCode$Namibia = 148;
var $author$project$Model$CountryCallingCode$Nauru = 149;
var $author$project$Model$CountryCallingCode$Nepal = 150;
var $author$project$Model$CountryCallingCode$Netherlands = 151;
var $author$project$Model$CountryCallingCode$NewCaledonia = 152;
var $author$project$Model$CountryCallingCode$NewZealand = 153;
var $author$project$Model$CountryCallingCode$Nicaragua = 154;
var $author$project$Model$CountryCallingCode$Niger = 155;
var $author$project$Model$CountryCallingCode$Nigeria = 156;
var $author$project$Model$CountryCallingCode$Niue = 157;
var $author$project$Model$CountryCallingCode$NorfolkIsland = 158;
var $author$project$Model$CountryCallingCode$NorthKorea = 159;
var $author$project$Model$CountryCallingCode$NorthernMarianaIslands = 160;
var $author$project$Model$CountryCallingCode$Norway = 161;
var $author$project$Model$CountryCallingCode$Oman = 162;
var $author$project$Model$CountryCallingCode$Pakistan = 163;
var $author$project$Model$CountryCallingCode$Palau = 164;
var $author$project$Model$CountryCallingCode$Palestine = 165;
var $author$project$Model$CountryCallingCode$Panama = 166;
var $author$project$Model$CountryCallingCode$PapuaNewGuinea = 167;
var $author$project$Model$CountryCallingCode$Paraguay = 168;
var $author$project$Model$CountryCallingCode$Peru = 169;
var $author$project$Model$CountryCallingCode$Philippines = 170;
var $author$project$Model$CountryCallingCode$Poland = 171;
var $author$project$Model$CountryCallingCode$Portugal = 172;
var $author$project$Model$CountryCallingCode$PuertoRico = 173;
var $author$project$Model$CountryCallingCode$Qatar = 174;
var $author$project$Model$CountryCallingCode$RepublicoftheCongo = 175;
var $author$project$Model$CountryCallingCode$Reunion = 179;
var $author$project$Model$CountryCallingCode$Romania = 176;
var $author$project$Model$CountryCallingCode$Russia = 177;
var $author$project$Model$CountryCallingCode$Rwanda = 178;
var $author$project$Model$CountryCallingCode$SaintBarthelemy = 180;
var $author$project$Model$CountryCallingCode$SaintHelenaAscensionandTristandaCunha = 181;
var $author$project$Model$CountryCallingCode$SaintKittsandNevis = 182;
var $author$project$Model$CountryCallingCode$SaintLucia = 183;
var $author$project$Model$CountryCallingCode$SaintMartin = 184;
var $author$project$Model$CountryCallingCode$SaintPierreandMiquelon = 185;
var $author$project$Model$CountryCallingCode$SaintVincentandtheGrenadines = 186;
var $author$project$Model$CountryCallingCode$Samoa = 187;
var $author$project$Model$CountryCallingCode$SanMarino = 188;
var $author$project$Model$CountryCallingCode$SaoTomeandPrincipe = 189;
var $author$project$Model$CountryCallingCode$SaudiArabia = 190;
var $author$project$Model$CountryCallingCode$Senegal = 191;
var $author$project$Model$CountryCallingCode$Serbia = 192;
var $author$project$Model$CountryCallingCode$Seychelles = 193;
var $author$project$Model$CountryCallingCode$SierraLeone = 194;
var $author$project$Model$CountryCallingCode$Singapore = 195;
var $author$project$Model$CountryCallingCode$SintMaarten = 196;
var $author$project$Model$CountryCallingCode$Slovakia = 197;
var $author$project$Model$CountryCallingCode$Slovenia = 198;
var $author$project$Model$CountryCallingCode$SolomonIslands = 199;
var $author$project$Model$CountryCallingCode$Somalia = 200;
var $author$project$Model$CountryCallingCode$SouthAfrica = 201;
var $author$project$Model$CountryCallingCode$SouthKorea = 202;
var $author$project$Model$CountryCallingCode$SouthSudan = 203;
var $author$project$Model$CountryCallingCode$Spain = 204;
var $author$project$Model$CountryCallingCode$SriLanka = 205;
var $author$project$Model$CountryCallingCode$Sudan = 206;
var $author$project$Model$CountryCallingCode$Suriname = 207;
var $author$project$Model$CountryCallingCode$SvalbardandJanMayen = 208;
var $author$project$Model$CountryCallingCode$Sweden = 209;
var $author$project$Model$CountryCallingCode$Switzerland = 210;
var $author$project$Model$CountryCallingCode$Syria = 211;
var $author$project$Model$CountryCallingCode$Taiwan = 212;
var $author$project$Model$CountryCallingCode$Tajikistan = 213;
var $author$project$Model$CountryCallingCode$Tanzania = 214;
var $author$project$Model$CountryCallingCode$Thailand = 215;
var $author$project$Model$CountryCallingCode$TimorLeste = 216;
var $author$project$Model$CountryCallingCode$Togo = 217;
var $author$project$Model$CountryCallingCode$Tokelau = 218;
var $author$project$Model$CountryCallingCode$Tonga = 219;
var $author$project$Model$CountryCallingCode$TrinidadandTobago = 220;
var $author$project$Model$CountryCallingCode$Tunisia = 221;
var $author$project$Model$CountryCallingCode$Turkey = 222;
var $author$project$Model$CountryCallingCode$Turkmenistan = 223;
var $author$project$Model$CountryCallingCode$TurksandCaicosIslands = 224;
var $author$project$Model$CountryCallingCode$Tuvalu = 225;
var $author$project$Model$CountryCallingCode$Uganda = 226;
var $author$project$Model$CountryCallingCode$Ukraine = 227;
var $author$project$Model$CountryCallingCode$UnitedArabEmirates = 228;
var $author$project$Model$CountryCallingCode$UnitedKingdom = 229;
var $author$project$Model$CountryCallingCode$UnitedStates = 230;
var $author$project$Model$CountryCallingCode$UnitedStatesVirginIslands = 231;
var $author$project$Model$CountryCallingCode$Uruguay = 232;
var $author$project$Model$CountryCallingCode$Uzbekistan = 233;
var $author$project$Model$CountryCallingCode$Vanuatu = 234;
var $author$project$Model$CountryCallingCode$VaticanCity = 235;
var $author$project$Model$CountryCallingCode$Venezuela = 236;
var $author$project$Model$CountryCallingCode$Vietnam = 237;
var $author$project$Model$CountryCallingCode$WallisandFutuna = 238;
var $author$project$Model$CountryCallingCode$WesternSahara = 239;
var $author$project$Model$CountryCallingCode$Yemen = 240;
var $author$project$Model$CountryCallingCode$Zambia = 241;
var $author$project$Model$CountryCallingCode$Zimbabwe = 242;
var $author$project$Model$CountryCallingCode$fromString = function (a) {
	switch (a) {
		case 'afghanistan':
			return $elm$core$Maybe$Just(0);
		case 'aland-islands':
			return $elm$core$Maybe$Just(1);
		case 'albania':
			return $elm$core$Maybe$Just(2);
		case 'algeria':
			return $elm$core$Maybe$Just(3);
		case 'american-samoa':
			return $elm$core$Maybe$Just(4);
		case 'andorra':
			return $elm$core$Maybe$Just(5);
		case 'angola':
			return $elm$core$Maybe$Just(6);
		case 'anguilla':
			return $elm$core$Maybe$Just(7);
		case 'antiguaand-barbuda':
			return $elm$core$Maybe$Just(8);
		case 'argentina':
			return $elm$core$Maybe$Just(9);
		case 'armenia':
			return $elm$core$Maybe$Just(10);
		case 'aruba':
			return $elm$core$Maybe$Just(11);
		case 'australia':
			return $elm$core$Maybe$Just(12);
		case 'austria':
			return $elm$core$Maybe$Just(13);
		case 'azerbaijan':
			return $elm$core$Maybe$Just(14);
		case 'bahamas':
			return $elm$core$Maybe$Just(15);
		case 'bahrain':
			return $elm$core$Maybe$Just(16);
		case 'bangladesh':
			return $elm$core$Maybe$Just(17);
		case 'barbados':
			return $elm$core$Maybe$Just(18);
		case 'belarus':
			return $elm$core$Maybe$Just(19);
		case 'belgium':
			return $elm$core$Maybe$Just(20);
		case 'belize':
			return $elm$core$Maybe$Just(21);
		case 'benin':
			return $elm$core$Maybe$Just(22);
		case 'bermuda':
			return $elm$core$Maybe$Just(23);
		case 'bhutan':
			return $elm$core$Maybe$Just(24);
		case 'bolivia':
			return $elm$core$Maybe$Just(25);
		case 'bosniaand-herzegovina':
			return $elm$core$Maybe$Just(26);
		case 'botswana':
			return $elm$core$Maybe$Just(27);
		case 'brazil':
			return $elm$core$Maybe$Just(28);
		case 'british-indian-ocean-territory':
			return $elm$core$Maybe$Just(29);
		case 'british-virgin-islands':
			return $elm$core$Maybe$Just(30);
		case 'brunei':
			return $elm$core$Maybe$Just(31);
		case 'bulgaria':
			return $elm$core$Maybe$Just(32);
		case 'burkina-faso':
			return $elm$core$Maybe$Just(33);
		case 'burundi':
			return $elm$core$Maybe$Just(34);
		case 'cambodia':
			return $elm$core$Maybe$Just(35);
		case 'cameroon':
			return $elm$core$Maybe$Just(36);
		case 'canada':
			return $elm$core$Maybe$Just(37);
		case 'cape-verde':
			return $elm$core$Maybe$Just(38);
		case 'caribbean-netherlands':
			return $elm$core$Maybe$Just(39);
		case 'cayman-islands':
			return $elm$core$Maybe$Just(40);
		case 'central-african-republic':
			return $elm$core$Maybe$Just(41);
		case 'chad':
			return $elm$core$Maybe$Just(42);
		case 'chile':
			return $elm$core$Maybe$Just(43);
		case 'china':
			return $elm$core$Maybe$Just(44);
		case 'christmas-island':
			return $elm$core$Maybe$Just(45);
		case 'cocos-keeling-islands':
			return $elm$core$Maybe$Just(46);
		case 'colombia':
			return $elm$core$Maybe$Just(47);
		case 'comoros':
			return $elm$core$Maybe$Just(48);
		case 'cook-islands':
			return $elm$core$Maybe$Just(49);
		case 'costa-rica':
			return $elm$core$Maybe$Just(50);
		case 'croatia':
			return $elm$core$Maybe$Just(51);
		case 'cuba':
			return $elm$core$Maybe$Just(52);
		case 'curacao':
			return $elm$core$Maybe$Just(53);
		case 'cyprus':
			return $elm$core$Maybe$Just(54);
		case 'czech-republic':
			return $elm$core$Maybe$Just(55);
		case 'congo':
			return $elm$core$Maybe$Just(56);
		case 'denmark':
			return $elm$core$Maybe$Just(57);
		case 'djibouti':
			return $elm$core$Maybe$Just(58);
		case 'dominica':
			return $elm$core$Maybe$Just(59);
		case 'dominican-republic':
			return $elm$core$Maybe$Just(60);
		case 'ecuador':
			return $elm$core$Maybe$Just(61);
		case 'egypt':
			return $elm$core$Maybe$Just(62);
		case 'el-salvador':
			return $elm$core$Maybe$Just(63);
		case 'equatorial-guinea':
			return $elm$core$Maybe$Just(64);
		case 'eritrea':
			return $elm$core$Maybe$Just(65);
		case 'estonia':
			return $elm$core$Maybe$Just(66);
		case 'eswatini':
			return $elm$core$Maybe$Just(67);
		case 'ethiopia':
			return $elm$core$Maybe$Just(68);
		case 'falkland-islands':
			return $elm$core$Maybe$Just(69);
		case 'faroe-islands':
			return $elm$core$Maybe$Just(70);
		case 'fiji':
			return $elm$core$Maybe$Just(71);
		case 'finland':
			return $elm$core$Maybe$Just(72);
		case 'france':
			return $elm$core$Maybe$Just(73);
		case 'french-guiana':
			return $elm$core$Maybe$Just(74);
		case 'french-polynesia':
			return $elm$core$Maybe$Just(75);
		case 'gabon':
			return $elm$core$Maybe$Just(76);
		case 'gambia':
			return $elm$core$Maybe$Just(77);
		case 'georgia':
			return $elm$core$Maybe$Just(78);
		case 'germany':
			return $elm$core$Maybe$Just(79);
		case 'ghana':
			return $elm$core$Maybe$Just(80);
		case 'gibraltar':
			return $elm$core$Maybe$Just(81);
		case 'greece':
			return $elm$core$Maybe$Just(82);
		case 'greenland':
			return $elm$core$Maybe$Just(83);
		case 'grenada':
			return $elm$core$Maybe$Just(84);
		case 'guadeloupe':
			return $elm$core$Maybe$Just(85);
		case 'guam':
			return $elm$core$Maybe$Just(86);
		case 'guatemala':
			return $elm$core$Maybe$Just(87);
		case 'guernsey':
			return $elm$core$Maybe$Just(88);
		case 'guinea':
			return $elm$core$Maybe$Just(89);
		case 'guinea-bissau':
			return $elm$core$Maybe$Just(90);
		case 'guyana':
			return $elm$core$Maybe$Just(91);
		case 'haiti':
			return $elm$core$Maybe$Just(92);
		case 'honduras':
			return $elm$core$Maybe$Just(93);
		case 'hong-kong':
			return $elm$core$Maybe$Just(94);
		case 'hungary':
			return $elm$core$Maybe$Just(95);
		case 'iceland':
			return $elm$core$Maybe$Just(96);
		case 'india':
			return $elm$core$Maybe$Just(97);
		case 'indonesia':
			return $elm$core$Maybe$Just(98);
		case 'iran':
			return $elm$core$Maybe$Just(99);
		case 'iraq':
			return $elm$core$Maybe$Just(100);
		case 'ireland':
			return $elm$core$Maybe$Just(101);
		case 'isleof-man':
			return $elm$core$Maybe$Just(102);
		case 'israel':
			return $elm$core$Maybe$Just(103);
		case 'italy':
			return $elm$core$Maybe$Just(104);
		case 'ivory-coast':
			return $elm$core$Maybe$Just(105);
		case 'jamaica':
			return $elm$core$Maybe$Just(106);
		case 'japan':
			return $elm$core$Maybe$Just(107);
		case 'jersey':
			return $elm$core$Maybe$Just(108);
		case 'jordan':
			return $elm$core$Maybe$Just(109);
		case 'kazakhstan':
			return $elm$core$Maybe$Just(110);
		case 'kenya':
			return $elm$core$Maybe$Just(111);
		case 'kiribati':
			return $elm$core$Maybe$Just(112);
		case 'kosovo':
			return $elm$core$Maybe$Just(113);
		case 'kuwait':
			return $elm$core$Maybe$Just(114);
		case 'kyrgyzstan':
			return $elm$core$Maybe$Just(115);
		case 'laos':
			return $elm$core$Maybe$Just(116);
		case 'latvia':
			return $elm$core$Maybe$Just(117);
		case 'lebanon':
			return $elm$core$Maybe$Just(118);
		case 'lesotho':
			return $elm$core$Maybe$Just(119);
		case 'liberia':
			return $elm$core$Maybe$Just(120);
		case 'libya':
			return $elm$core$Maybe$Just(121);
		case 'liechtenstein':
			return $elm$core$Maybe$Just(122);
		case 'lithuania':
			return $elm$core$Maybe$Just(123);
		case 'luxembourg':
			return $elm$core$Maybe$Just(124);
		case 'macau':
			return $elm$core$Maybe$Just(125);
		case 'macedonia':
			return $elm$core$Maybe$Just(126);
		case 'madagascar':
			return $elm$core$Maybe$Just(127);
		case 'malawi':
			return $elm$core$Maybe$Just(128);
		case 'malaysia':
			return $elm$core$Maybe$Just(129);
		case 'maldives':
			return $elm$core$Maybe$Just(130);
		case 'mali':
			return $elm$core$Maybe$Just(131);
		case 'malta':
			return $elm$core$Maybe$Just(132);
		case 'marshall-islands':
			return $elm$core$Maybe$Just(133);
		case 'martinique':
			return $elm$core$Maybe$Just(134);
		case 'mauritania':
			return $elm$core$Maybe$Just(135);
		case 'mauritius':
			return $elm$core$Maybe$Just(136);
		case 'mayotte':
			return $elm$core$Maybe$Just(137);
		case 'mexico':
			return $elm$core$Maybe$Just(138);
		case 'micronesia':
			return $elm$core$Maybe$Just(139);
		case 'moldova':
			return $elm$core$Maybe$Just(140);
		case 'monaco':
			return $elm$core$Maybe$Just(141);
		case 'mongolia':
			return $elm$core$Maybe$Just(142);
		case 'montenegro':
			return $elm$core$Maybe$Just(143);
		case 'montserrat':
			return $elm$core$Maybe$Just(144);
		case 'morocco':
			return $elm$core$Maybe$Just(145);
		case 'mozambique':
			return $elm$core$Maybe$Just(146);
		case 'myanmar':
			return $elm$core$Maybe$Just(147);
		case 'namibia':
			return $elm$core$Maybe$Just(148);
		case 'nauru':
			return $elm$core$Maybe$Just(149);
		case 'nepal':
			return $elm$core$Maybe$Just(150);
		case 'netherlands':
			return $elm$core$Maybe$Just(151);
		case 'new-caledonia':
			return $elm$core$Maybe$Just(152);
		case 'new-zealand':
			return $elm$core$Maybe$Just(153);
		case 'nicaragua':
			return $elm$core$Maybe$Just(154);
		case 'niger':
			return $elm$core$Maybe$Just(155);
		case 'nigeria':
			return $elm$core$Maybe$Just(156);
		case 'niue':
			return $elm$core$Maybe$Just(157);
		case 'norfolk-island':
			return $elm$core$Maybe$Just(158);
		case 'north-korea':
			return $elm$core$Maybe$Just(159);
		case 'northern-mariana-islands':
			return $elm$core$Maybe$Just(160);
		case 'norway':
			return $elm$core$Maybe$Just(161);
		case 'oman':
			return $elm$core$Maybe$Just(162);
		case 'pakistan':
			return $elm$core$Maybe$Just(163);
		case 'palau':
			return $elm$core$Maybe$Just(164);
		case 'palestine':
			return $elm$core$Maybe$Just(165);
		case 'panama':
			return $elm$core$Maybe$Just(166);
		case 'papua-new-guinea':
			return $elm$core$Maybe$Just(167);
		case 'paraguay':
			return $elm$core$Maybe$Just(168);
		case 'peru':
			return $elm$core$Maybe$Just(169);
		case 'philippines':
			return $elm$core$Maybe$Just(170);
		case 'poland':
			return $elm$core$Maybe$Just(171);
		case 'portugal':
			return $elm$core$Maybe$Just(172);
		case 'puerto-rico':
			return $elm$core$Maybe$Just(173);
		case 'qatar':
			return $elm$core$Maybe$Just(174);
		case 'republicofthe-congo':
			return $elm$core$Maybe$Just(175);
		case 'romania':
			return $elm$core$Maybe$Just(176);
		case 'russia':
			return $elm$core$Maybe$Just(177);
		case 'rwanda':
			return $elm$core$Maybe$Just(178);
		case 'reunion':
			return $elm$core$Maybe$Just(179);
		case 'saint-barthelemy':
			return $elm$core$Maybe$Just(180);
		case 'saint-helena-ascensionand-tristanda-cunha':
			return $elm$core$Maybe$Just(181);
		case 'saint-kittsand-nevis':
			return $elm$core$Maybe$Just(182);
		case 'saint-lucia':
			return $elm$core$Maybe$Just(183);
		case 'saint-martin':
			return $elm$core$Maybe$Just(184);
		case 'saint-pierreand-miquelon':
			return $elm$core$Maybe$Just(185);
		case 'saint-vincentandthe-grenadines':
			return $elm$core$Maybe$Just(186);
		case 'samoa':
			return $elm$core$Maybe$Just(187);
		case 'san-marino':
			return $elm$core$Maybe$Just(188);
		case 'sao-tomeand-principe':
			return $elm$core$Maybe$Just(189);
		case 'saudi-arabia':
			return $elm$core$Maybe$Just(190);
		case 'senegal':
			return $elm$core$Maybe$Just(191);
		case 'serbia':
			return $elm$core$Maybe$Just(192);
		case 'seychelles':
			return $elm$core$Maybe$Just(193);
		case 'sierra-leone':
			return $elm$core$Maybe$Just(194);
		case 'singapore':
			return $elm$core$Maybe$Just(195);
		case 'sint-maarten':
			return $elm$core$Maybe$Just(196);
		case 'slovakia':
			return $elm$core$Maybe$Just(197);
		case 'slovenia':
			return $elm$core$Maybe$Just(198);
		case 'solomon-islands':
			return $elm$core$Maybe$Just(199);
		case 'somalia':
			return $elm$core$Maybe$Just(200);
		case 'south-africa':
			return $elm$core$Maybe$Just(201);
		case 'south-korea':
			return $elm$core$Maybe$Just(202);
		case 'south-sudan':
			return $elm$core$Maybe$Just(203);
		case 'spain':
			return $elm$core$Maybe$Just(204);
		case 'sri-lanka':
			return $elm$core$Maybe$Just(205);
		case 'sudan':
			return $elm$core$Maybe$Just(206);
		case 'suriname':
			return $elm$core$Maybe$Just(207);
		case 'svalbardand-jan-mayen':
			return $elm$core$Maybe$Just(208);
		case 'sweden':
			return $elm$core$Maybe$Just(209);
		case 'switzerland':
			return $elm$core$Maybe$Just(210);
		case 'syria':
			return $elm$core$Maybe$Just(211);
		case 'taiwan':
			return $elm$core$Maybe$Just(212);
		case 'tajikistan':
			return $elm$core$Maybe$Just(213);
		case 'tanzania':
			return $elm$core$Maybe$Just(214);
		case 'thailand':
			return $elm$core$Maybe$Just(215);
		case 'timor-leste':
			return $elm$core$Maybe$Just(216);
		case 'togo':
			return $elm$core$Maybe$Just(217);
		case 'tokelau':
			return $elm$core$Maybe$Just(218);
		case 'tonga':
			return $elm$core$Maybe$Just(219);
		case 'trinidadand-tobago':
			return $elm$core$Maybe$Just(220);
		case 'tunisia':
			return $elm$core$Maybe$Just(221);
		case 'turkey':
			return $elm$core$Maybe$Just(222);
		case 'turkmenistan':
			return $elm$core$Maybe$Just(223);
		case 'turksand-caicos-islands':
			return $elm$core$Maybe$Just(224);
		case 'tuvalu':
			return $elm$core$Maybe$Just(225);
		case 'uganda':
			return $elm$core$Maybe$Just(226);
		case 'ukraine':
			return $elm$core$Maybe$Just(227);
		case 'united-arab-emirates':
			return $elm$core$Maybe$Just(228);
		case 'united-kingdom':
			return $elm$core$Maybe$Just(229);
		case 'united-states':
			return $elm$core$Maybe$Just(230);
		case 'united-states-virgin-islands':
			return $elm$core$Maybe$Just(231);
		case 'uruguay':
			return $elm$core$Maybe$Just(232);
		case 'uzbekistan':
			return $elm$core$Maybe$Just(233);
		case 'vanuatu':
			return $elm$core$Maybe$Just(234);
		case 'vatican-city':
			return $elm$core$Maybe$Just(235);
		case 'venezuela':
			return $elm$core$Maybe$Just(236);
		case 'vietnam':
			return $elm$core$Maybe$Just(237);
		case 'wallisand-futuna':
			return $elm$core$Maybe$Just(238);
		case 'western-sahara':
			return $elm$core$Maybe$Just(239);
		case 'yemen':
			return $elm$core$Maybe$Just(240);
		case 'zambia':
			return $elm$core$Maybe$Just(241);
		case 'zimbabwe':
			return $elm$core$Maybe$Just(242);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Model$WhatsappConfig$decodeWhatsappConfig = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'btnText',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'disable',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'phone',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'countryCallingCode',
				$author$project$Util$Json$enumDecoder($author$project$Model$CountryCallingCode$fromString),
				$elm$json$Json$Decode$succeed($author$project$Model$WhatsappConfig$WhatsappConfig)))));
var $author$project$Model$Country$GeocodingRegion = function (geocodingRegionToNonEmpty) {
	return {Lh: geocodingRegionToNonEmpty};
};
var $author$project$Model$Country$geocodingRegionDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'geocodingRegionToNonEmpty',
	$langyu_app$elm_ancillary_nonempty_list$List$Nonempty$Ancillary$decodeArray($author$project$Model$Country$countryDecoder),
	$elm$json$Json$Decode$succeed($author$project$Model$Country$GeocodingRegion));
var $author$project$Model$Region$Austria = 0;
var $author$project$Model$Region$Belgium = 1;
var $author$project$Model$Region$China = 2;
var $author$project$Model$Region$Denmark = 4;
var $author$project$Model$Region$Emea = 5;
var $author$project$Model$Region$Finland = 6;
var $author$project$Model$Region$France = 7;
var $author$project$Model$Region$Germany = 8;
var $author$project$Model$Region$Global = 9;
var $author$project$Model$Region$GreatBritain = 10;
var $author$project$Model$Region$Hungary = 11;
var $author$project$Model$Region$Ireland = 12;
var $author$project$Model$Region$Luxembourg = 13;
var $author$project$Model$Region$Netherlands = 14;
var $author$project$Model$Region$Norway = 15;
var $author$project$Model$Region$Poland = 17;
var $author$project$Model$Region$Portugal = 18;
var $author$project$Model$Region$Romania = 19;
var $author$project$Model$Region$Singapore = 21;
var $author$project$Model$Region$Slovakia = 20;
var $author$project$Model$Region$Spain = 22;
var $author$project$Model$Region$Sweden = 23;
var $author$project$Model$Region$Switzerland = 3;
var $author$project$Model$Region$Ukraine = 16;
var $author$project$Model$Region$UnitedStates = 24;
var $author$project$Model$Region$regionDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'austria':
				return $elm$json$Json$Decode$succeed(0);
			case 'belgium':
				return $elm$json$Json$Decode$succeed(1);
			case 'china':
				return $elm$json$Json$Decode$succeed(2);
			case 'switzerland':
				return $elm$json$Json$Decode$succeed(3);
			case 'denmark':
				return $elm$json$Json$Decode$succeed(4);
			case 'emea':
				return $elm$json$Json$Decode$succeed(5);
			case 'finland':
				return $elm$json$Json$Decode$succeed(6);
			case 'france':
				return $elm$json$Json$Decode$succeed(7);
			case 'germany':
				return $elm$json$Json$Decode$succeed(8);
			case 'global':
				return $elm$json$Json$Decode$succeed(9);
			case 'great-britain':
				return $elm$json$Json$Decode$succeed(10);
			case 'hungary':
				return $elm$json$Json$Decode$succeed(11);
			case 'ireland':
				return $elm$json$Json$Decode$succeed(12);
			case 'luxembourg':
				return $elm$json$Json$Decode$succeed(13);
			case 'netherlands':
				return $elm$json$Json$Decode$succeed(14);
			case 'norway':
				return $elm$json$Json$Decode$succeed(15);
			case 'ukraine':
				return $elm$json$Json$Decode$succeed(16);
			case 'poland':
				return $elm$json$Json$Decode$succeed(17);
			case 'portugal':
				return $elm$json$Json$Decode$succeed(18);
			case 'romania':
				return $elm$json$Json$Decode$succeed(19);
			case 'slovakia':
				return $elm$json$Json$Decode$succeed(20);
			case 'singapore':
				return $elm$json$Json$Decode$succeed(21);
			case 'spain':
				return $elm$json$Json$Decode$succeed(22);
			case 'sweden':
				return $elm$json$Json$Decode$succeed(23);
			case 'united-states':
				return $elm$json$Json$Decode$succeed(24);
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Model$VacancyFilterType$City = 0;
var $author$project$Model$VacancyFilterType$ContractType = 1;
var $author$project$Model$VacancyFilterType$Country = 2;
var $author$project$Model$VacancyFilterType$CustomFilter01 = 3;
var $author$project$Model$VacancyFilterType$CustomFilter02 = 4;
var $author$project$Model$VacancyFilterType$CustomFilter03 = 5;
var $author$project$Model$VacancyFilterType$CustomFilter04 = 6;
var $author$project$Model$VacancyFilterType$CustomFilter05 = 7;
var $author$project$Model$VacancyFilterType$CustomFilter06 = 8;
var $author$project$Model$VacancyFilterType$CustomFilter07 = 9;
var $author$project$Model$VacancyFilterType$CustomFilter08 = 10;
var $author$project$Model$VacancyFilterType$CustomFilter09 = 11;
var $author$project$Model$VacancyFilterType$CustomFilter10 = 12;
var $author$project$Model$VacancyFilterType$CustomFilter11 = 13;
var $author$project$Model$VacancyFilterType$CustomFilter12 = 14;
var $author$project$Model$VacancyFilterType$CustomFilter13 = 15;
var $author$project$Model$VacancyFilterType$CustomFilter14 = 16;
var $author$project$Model$VacancyFilterType$CustomFilter15 = 17;
var $author$project$Model$VacancyFilterType$CustomFilter16 = 18;
var $author$project$Model$VacancyFilterType$CustomFilter17 = 19;
var $author$project$Model$VacancyFilterType$CustomFilter18 = 20;
var $author$project$Model$VacancyFilterType$CustomFilter19 = 21;
var $author$project$Model$VacancyFilterType$CustomFilter20 = 22;
var $author$project$Model$VacancyFilterType$Department = 23;
var $author$project$Model$VacancyFilterType$Discipline = 24;
var $author$project$Model$VacancyFilterType$EducationLevel = 25;
var $author$project$Model$VacancyFilterType$EndDate = 26;
var $author$project$Model$VacancyFilterType$ExperienceLevel = 27;
var $author$project$Model$VacancyFilterType$FulltimeParttime = 28;
var $author$project$Model$VacancyFilterType$Hours = 29;
var $author$project$Model$VacancyFilterType$Location = 30;
var $author$project$Model$VacancyFilterType$LocationName = 31;
var $author$project$Model$VacancyFilterType$LocationType = 32;
var $author$project$Model$VacancyFilterType$Province = 33;
var $author$project$Model$VacancyFilterType$PublicationDate = 34;
var $author$project$Model$VacancyFilterType$Salary = 35;
var $author$project$Model$VacancyFilterType$vacancyFilterTypeDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'city':
				return $elm$json$Json$Decode$succeed(0);
			case 'contract-type':
				return $elm$json$Json$Decode$succeed(1);
			case 'country':
				return $elm$json$Json$Decode$succeed(2);
			case 'custom-filter01':
				return $elm$json$Json$Decode$succeed(3);
			case 'custom-filter02':
				return $elm$json$Json$Decode$succeed(4);
			case 'custom-filter03':
				return $elm$json$Json$Decode$succeed(5);
			case 'custom-filter04':
				return $elm$json$Json$Decode$succeed(6);
			case 'custom-filter05':
				return $elm$json$Json$Decode$succeed(7);
			case 'custom-filter06':
				return $elm$json$Json$Decode$succeed(8);
			case 'custom-filter07':
				return $elm$json$Json$Decode$succeed(9);
			case 'custom-filter08':
				return $elm$json$Json$Decode$succeed(10);
			case 'custom-filter09':
				return $elm$json$Json$Decode$succeed(11);
			case 'custom-filter10':
				return $elm$json$Json$Decode$succeed(12);
			case 'custom-filter11':
				return $elm$json$Json$Decode$succeed(13);
			case 'custom-filter12':
				return $elm$json$Json$Decode$succeed(14);
			case 'custom-filter13':
				return $elm$json$Json$Decode$succeed(15);
			case 'custom-filter14':
				return $elm$json$Json$Decode$succeed(16);
			case 'custom-filter15':
				return $elm$json$Json$Decode$succeed(17);
			case 'custom-filter16':
				return $elm$json$Json$Decode$succeed(18);
			case 'custom-filter17':
				return $elm$json$Json$Decode$succeed(19);
			case 'custom-filter18':
				return $elm$json$Json$Decode$succeed(20);
			case 'custom-filter19':
				return $elm$json$Json$Decode$succeed(21);
			case 'custom-filter20':
				return $elm$json$Json$Decode$succeed(22);
			case 'department':
				return $elm$json$Json$Decode$succeed(23);
			case 'discipline':
				return $elm$json$Json$Decode$succeed(24);
			case 'education-level':
				return $elm$json$Json$Decode$succeed(25);
			case 'end-date':
				return $elm$json$Json$Decode$succeed(26);
			case 'experience-level':
				return $elm$json$Json$Decode$succeed(27);
			case 'fulltime-parttime':
				return $elm$json$Json$Decode$succeed(28);
			case 'hours':
				return $elm$json$Json$Decode$succeed(29);
			case 'location':
				return $elm$json$Json$Decode$succeed(30);
			case 'location-name':
				return $elm$json$Json$Decode$succeed(31);
			case 'location-type':
				return $elm$json$Json$Decode$succeed(32);
			case 'province':
				return $elm$json$Json$Decode$succeed(33);
			case 'publication-date':
				return $elm$json$Json$Decode$succeed(34);
			case 'salary':
				return $elm$json$Json$Decode$succeed(35);
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Model$Domain$domainDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'domainExtraSearchableCountries',
	$elm$json$Json$Decode$list($author$project$Model$Country$countryDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'domainSeqNo',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'domainThemeId',
			$elm$json$Json$Decode$nullable($author$project$Data$Id$decoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'domainOrgName',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'domainBoundingBox',
					$elm$json$Json$Decode$nullable($author$project$Model$Geography$boundingBoxDecoder),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'domainWhatsappConfig',
						$elm$json$Json$Decode$nullable($author$project$Model$WhatsappConfig$decodeWhatsappConfig),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'domainWhatsappNumber',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'domainConsolidationExcludeFilters',
								$elm$json$Json$Decode$list($author$project$Model$VacancyFilterType$vacancyFilterTypeDecoder),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'domainVacancyOverviewMetadata',
									$elm$json$Json$Decode$list($author$project$Model$VacancyFilterType$vacancyFilterTypeDecoder),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'domainVacancyItemImageDefault',
										$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'domainVacancyDetailMetadata',
											$elm$json$Json$Decode$list($author$project$Model$VacancyFilterType$vacancyFilterTypeDecoder),
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'domainTitle',
												$elm$json$Json$Decode$string,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'domainShowDomainSwitch',
													$elm$json$Json$Decode$bool,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'domainSeedPages',
														$elm$json$Json$Decode$bool,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'domainSamlLoginText',
															$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'domainSalaryFilterEnabled',
																$elm$json$Json$Decode$bool,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'domainRegion',
																	$author$project$Model$Region$regionDecoder,
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'domainPostmarkApiKey',
																		$elm$json$Json$Decode$string,
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'domainPossibleAltCss',
																			$elm$json$Json$Decode$list($author$project$Model$AltCss$altCssDecoder),
																			A3(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																				'domainPathPrefix',
																				$elm$json$Json$Decode$string,
																				A3(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																					'domainName',
																					$elm$json$Json$Decode$string,
																					A3(
																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																						'domainMobileSubMenuToggle',
																						$elm$json$Json$Decode$bool,
																						A3(
																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																							'domainLocationUrlPrefix',
																							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																							A3(
																								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																								'domainLinkedInPixel',
																								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																								A3(
																									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																									'domainLinkedDomainKey',
																									$elm$json$Json$Decode$nullable($author$project$Data$Id$decoder),
																									A3(
																										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																										'domainLangCode',
																										$author$project$Model$LangCode$decoder,
																										A3(
																											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																											'domainLabel',
																											$elm$json$Json$Decode$string,
																											A3(
																												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																												'domainIsNonVacancyDomain',
																												$elm$json$Json$Decode$bool,
																												A3(
																													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																													'domainIsInternal',
																													$elm$json$Json$Decode$bool,
																													A3(
																														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																														'domainIndeedFulltimeThreshold',
																														$elm$json$Json$Decode$float,
																														A3(
																															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																															'domainIndeedConversionCode',
																															$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																															A3(
																																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																'domainIncludeInTopBarDomainSwitch',
																																$elm$json$Json$Decode$bool,
																																A3(
																																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																	'domainIncludeInLanguageSwitch',
																																	$elm$json$Json$Decode$bool,
																																	A3(
																																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																		'domainIncludeInCmsSwitch',
																																		$elm$json$Json$Decode$bool,
																																		A3(
																																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																			'domainHoursFilterEnabled',
																																			$elm$json$Json$Decode$bool,
																																			A3(
																																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																				'domainHeaderJobAlertTitle',
																																				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																																				A3(
																																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																					'domainHeadSnippets',
																																					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																																					A3(
																																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																						'domainGoogleTagManagerServerSideTrackingUrl',
																																						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																																						A3(
																																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																							'domainGoogleTagManagerId',
																																							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																																							A3(
																																								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																								'domainGoogleGeocodingRegion',
																																								$elm$json$Json$Decode$nullable($author$project$Model$Country$geocodingRegionDecoder),
																																								A3(
																																									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																									'domainGoogleDataStudioUrl',
																																									$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																																									A3(
																																										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																										'domainGoogleCloudMapsApiKey',
																																										$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																																										A3(
																																											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																											'domainGoogleCloudApiKey',
																																											$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																																											A3(
																																												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																												'domainGoogleAnalyticsStreamId',
																																												$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																																												A3(
																																													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																													'domainGoogleAnalyticsApiKey',
																																													$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																																													A3(
																																														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																														'domainGoogleForJobsCustomLogo',
																																														$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																																														A3(
																																															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																															'domainEmail',
																																															$elm$json$Json$Decode$string,
																																															A3(
																																																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																'domainDomainSwitchLabel',
																																																$elm$json$Json$Decode$string,
																																																A3(
																																																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																	'domainCustomLogo',
																																																	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																																																	A3(
																																																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																		'domainCustomFavicon',
																																																		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																																																		A3(
																																																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																			'domainCustomEmailLogo',
																																																			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																																																			A3(
																																																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																				'domainCssClass',
																																																				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																																																				A3(
																																																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																					'domainCorporateWebsiteUrl',
																																																					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																																																					A3(
																																																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																						'domainCorporateWebsite',
																																																						$elm$json$Json$Decode$nullable($author$project$Model$corporateLinkDecoder),
																																																						A3(
																																																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																							'domainCookieModalSettings',
																																																							$author$project$Model$CookieModalSettings$cookieModalSettingsDecoder,
																																																							A3(
																																																								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																								'domainConsentDefault',
																																																								$author$project$Model$CookieConsent$cookieConsentDecoder,
																																																								A3(
																																																									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																									'domainBetterUptimeUrl',
																																																									$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																																																									A3(
																																																										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																										'domainAltCss',
																																																										$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																																																										A3(
																																																											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																											'domainAddressEnabled',
																																																											$elm$json$Json$Decode$bool,
																																																											$elm$json$Json$Decode$succeed($author$project$Model$Domain$Domain))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
var $author$project$Data$Domains$domainsDecoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Basics$identity,
	$author$project$Data$Domains$decodeZipper(
		$author$project$Data$Entity$decoder($author$project$Model$Domain$domainDecoder)));
var $elm$json$Json$Decode$map7 = _Json_map7;
var $author$project$Model$ReferralFormResponse$NestedReferralFormResponse = function (a) {
	return {$: 1, a: a};
};
var $author$project$Model$ReferralFormResponse$SimpleReferralFormResponse = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Model$ReferralFormResponse$FilterWithOptions = F2(
	function (filter, options) {
		return {HS: filter, au7: options};
	});
var $author$project$Model$VacancyFilter$VacancyFilter = function (filterType) {
	return function (valueType) {
		return function (sort) {
			return function (domainId) {
				return function (label) {
					return function (enabled) {
						return function (langCode) {
							return function (masterDataType) {
								return function (masterDataOrigin) {
									return function (icon) {
										return function (maskColor) {
											return function (updated) {
												return function (seqNo) {
													return {dp: domainId, F2: enabled, atY: filterType, bb: icon, bO: label, Ql: langCode, Sm: maskColor, Sq: masterDataOrigin, Sr: masterDataType, agZ: seqNo, ai_: sort, fY: updated, ari: valueType};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Model$MasterDataOrigin$CMS = 0;
var $author$project$Model$MasterDataOrigin$Import = 1;
var $author$project$Model$MasterDataOrigin$masterDataOriginDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'cms':
				return $elm$json$Json$Decode$succeed(0);
			case 'import':
				return $elm$json$Json$Decode$succeed(1);
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Model$MasterDataType$OrganizationData = 0;
var $author$project$Model$MasterDataType$VacancyData = 1;
var $author$project$Model$MasterDataType$masterDataTypeDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'organization-data':
				return $elm$json$Json$Decode$succeed(0);
			case 'vacancy-data':
				return $elm$json$Json$Decode$succeed(1);
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Model$VacancyFilterSort$Alphabetical = 0;
var $author$project$Model$VacancyFilterSort$CustomOrder = 1;
var $author$project$Model$VacancyFilterSort$VacancyCount = 2;
var $author$project$Model$VacancyFilterSort$vacancyFilterSortDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'alphabetical':
				return $elm$json$Json$Decode$succeed(0);
			case 'custom-order':
				return $elm$json$Json$Decode$succeed(1);
			case 'vacancy-count':
				return $elm$json$Json$Decode$succeed(2);
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Model$VacancyFilterValue$HourRange = 0;
var $author$project$Model$VacancyFilterValue$LocationValue = 3;
var $author$project$Model$VacancyFilterValue$SalaryRange = 1;
var $author$project$Model$VacancyFilterValue$TextValue = 2;
var $author$project$Model$VacancyFilterValue$vacancyFilterValueDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'hour-range':
				return $elm$json$Json$Decode$succeed(0);
			case 'salary-range':
				return $elm$json$Json$Decode$succeed(1);
			case 'text-value':
				return $elm$json$Json$Decode$succeed(2);
			case 'location-value':
				return $elm$json$Json$Decode$succeed(3);
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Model$VacancyFilter$vacancyFilterDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'vacancyFilterSeqNo',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'vacancyFilterUpdated',
		$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'vacancyFilterMaskColor',
			$author$project$Model$MaskColor$maskColorDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'vacancyFilterIcon',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'vacancyFilterMasterDataOrigin',
					$author$project$Model$MasterDataOrigin$masterDataOriginDecoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'vacancyFilterMasterDataType',
						$elm$json$Json$Decode$nullable($author$project$Model$MasterDataType$masterDataTypeDecoder),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'vacancyFilterLangCode',
							$author$project$Model$LangCode$decoder,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'vacancyFilterEnabled',
								$elm$json$Json$Decode$bool,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'vacancyFilterLabel',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'vacancyFilterDomainId',
										$author$project$Data$Id$decoder,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'vacancyFilterSort',
											$author$project$Model$VacancyFilterSort$vacancyFilterSortDecoder,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'vacancyFilterValueType',
												$author$project$Model$VacancyFilterValue$vacancyFilterValueDecoder,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'vacancyFilterFilterType',
													$author$project$Model$VacancyFilterType$vacancyFilterTypeDecoder,
													$elm$json$Json$Decode$succeed($author$project$Model$VacancyFilter$VacancyFilter))))))))))))));
var $author$project$Model$VacancyFilterOption$VacancyFilterOption = function (externalId) {
	return function (externalAts) {
		return function (domainId) {
			return function (filterId) {
				return function (value) {
					return function (displayLabel) {
						return function (className) {
							return function (seqNo) {
								return function (companyLogo) {
									return function (bannerImages) {
										return function (showAsTag) {
											return function (structuredDataType) {
												return function (linkedInFieldType) {
													return function (vacancyIdsMirror) {
														return function (masterDataOrigin) {
															return function (updated) {
																return function (synonyms) {
																	return function (isLocationPart) {
																		return {oa: bannerImages, dc: className, r0: companyLogo, Eb: displayLabel, dp: domainId, GS: externalAts, GT: externalId, H0: filterId, O$: isLocationPart, Rd: linkedInFieldType, Sq: masterDataOrigin, agZ: seqNo, ahs: showAsTag, akl: structuredDataType, ak7: synonyms, fY: updated, awj: vacancyIdsMirror, ey: value};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Model$Ats$Afas = 0;
var $author$project$Model$Ats$Avature = 1;
var $author$project$Model$Ats$Bullhorn = 2;
var $author$project$Model$Ats$Byner = 3;
var $author$project$Model$Ats$Carerix = 4;
var $author$project$Model$Ats$Connexys = 5;
var $author$project$Model$Ats$ConnexysJson = 6;
var $author$project$Model$Ats$Cornerstone = 7;
var $author$project$Model$Ats$CvWarehouse = 8;
var $author$project$Model$Ats$Daywize = 9;
var $author$project$Model$Ats$DigitalRecruiters = 10;
var $author$project$Model$Ats$Easycruit = 11;
var $author$project$Model$Ats$Emply = 12;
var $author$project$Model$Ats$Greenhouse = 13;
var $author$project$Model$Ats$HamiltonCMS = 14;
var $author$project$Model$Ats$Harver = 15;
var $author$project$Model$Ats$Hireserve = 16;
var $author$project$Model$Ats$Homerun = 17;
var $author$project$Model$Ats$HomerunJSON = 19;
var $author$project$Model$Ats$HrOffice = 18;
var $author$project$Model$Ats$Jobvite = 20;
var $author$project$Model$Ats$Jobylon = 21;
var $author$project$Model$Ats$JobylonV2 = 22;
var $author$project$Model$Ats$Netive = 23;
var $author$project$Model$Ats$Otys = 24;
var $author$project$Model$Ats$Recruitee = 25;
var $author$project$Model$Ats$RecruiteeAts = 26;
var $author$project$Model$Ats$Salesforce = 27;
var $author$project$Model$Ats$SmartRecruiters = 28;
var $author$project$Model$Ats$SuccessFactors = 29;
var $author$project$Model$Ats$Talentsoft = 30;
var $author$project$Model$Ats$Teamtailor = 31;
var $author$project$Model$Ats$Tigris = 32;
var $author$project$Model$Ats$Trakstar = 33;
var $author$project$Model$Ats$Ubeeo = 34;
var $author$project$Model$Ats$UbeeoV2 = 35;
var $author$project$Model$Ats$UbeeoV2Events = 36;
var $author$project$Model$Ats$Webqube = 37;
var $author$project$Model$Ats$Workday = 38;
var $author$project$Model$Ats$atsDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'afas':
				return $elm$json$Json$Decode$succeed(0);
			case 'avature':
				return $elm$json$Json$Decode$succeed(1);
			case 'bullhorn':
				return $elm$json$Json$Decode$succeed(2);
			case 'byner':
				return $elm$json$Json$Decode$succeed(3);
			case 'carerix':
				return $elm$json$Json$Decode$succeed(4);
			case 'connexys':
				return $elm$json$Json$Decode$succeed(5);
			case 'connexys-json':
				return $elm$json$Json$Decode$succeed(6);
			case 'cornerstone':
				return $elm$json$Json$Decode$succeed(7);
			case 'cv-warehouse':
				return $elm$json$Json$Decode$succeed(8);
			case 'daywize':
				return $elm$json$Json$Decode$succeed(9);
			case 'digital-recruiters':
				return $elm$json$Json$Decode$succeed(10);
			case 'easycruit':
				return $elm$json$Json$Decode$succeed(11);
			case 'emply':
				return $elm$json$Json$Decode$succeed(12);
			case 'greenhouse':
				return $elm$json$Json$Decode$succeed(13);
			case 'hamilton-cms':
				return $elm$json$Json$Decode$succeed(14);
			case 'harver':
				return $elm$json$Json$Decode$succeed(15);
			case 'hireserve':
				return $elm$json$Json$Decode$succeed(16);
			case 'homerun':
				return $elm$json$Json$Decode$succeed(17);
			case 'hr-office':
				return $elm$json$Json$Decode$succeed(18);
			case 'homerun-json':
				return $elm$json$Json$Decode$succeed(19);
			case 'jobvite':
				return $elm$json$Json$Decode$succeed(20);
			case 'jobylon':
				return $elm$json$Json$Decode$succeed(21);
			case 'jobylon-v2':
				return $elm$json$Json$Decode$succeed(22);
			case 'netive':
				return $elm$json$Json$Decode$succeed(23);
			case 'otys':
				return $elm$json$Json$Decode$succeed(24);
			case 'recruitee':
				return $elm$json$Json$Decode$succeed(25);
			case 'recruitee-ats':
				return $elm$json$Json$Decode$succeed(26);
			case 'salesforce':
				return $elm$json$Json$Decode$succeed(27);
			case 'smart-recruiters':
				return $elm$json$Json$Decode$succeed(28);
			case 'success-factors':
				return $elm$json$Json$Decode$succeed(29);
			case 'talentsoft':
				return $elm$json$Json$Decode$succeed(30);
			case 'teamtailor':
				return $elm$json$Json$Decode$succeed(31);
			case 'tigris':
				return $elm$json$Json$Decode$succeed(32);
			case 'trakstar':
				return $elm$json$Json$Decode$succeed(33);
			case 'ubeeo':
				return $elm$json$Json$Decode$succeed(34);
			case 'ubeeo-v2':
				return $elm$json$Json$Decode$succeed(35);
			case 'ubeeo-v2-events':
				return $elm$json$Json$Decode$succeed(36);
			case 'webqube':
				return $elm$json$Json$Decode$succeed(37);
			case 'workday':
				return $elm$json$Json$Decode$succeed(38);
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Model$LinkedInFieldType$ExperienceLevel = function (a) {
	return {$: 2, a: a};
};
var $author$project$Model$LinkedInFieldType$JobFunction = function (a) {
	return {$: 1, a: a};
};
var $author$project$Model$LinkedInFieldType$JobType = function (a) {
	return {$: 0, a: a};
};
var $author$project$Model$ExperienceLevel$Associate = 3;
var $author$project$Model$ExperienceLevel$Director = 5;
var $author$project$Model$ExperienceLevel$EntryLevel = 2;
var $author$project$Model$ExperienceLevel$Executive = 6;
var $author$project$Model$ExperienceLevel$Internship = 1;
var $author$project$Model$ExperienceLevel$MidSeniorLevel = 4;
var $author$project$Model$ExperienceLevel$NotApplicable = 0;
var $author$project$Model$ExperienceLevel$experienceLevelDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'not-applicable':
				return $elm$json$Json$Decode$succeed(0);
			case 'internship':
				return $elm$json$Json$Decode$succeed(1);
			case 'entry-level':
				return $elm$json$Json$Decode$succeed(2);
			case 'associate':
				return $elm$json$Json$Decode$succeed(3);
			case 'mid-senior-level':
				return $elm$json$Json$Decode$succeed(4);
			case 'director':
				return $elm$json$Json$Decode$succeed(5);
			case 'executive':
				return $elm$json$Json$Decode$succeed(6);
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Model$JobFunctionType$AccountingAuditing = 0;
var $author$project$Model$JobFunctionType$Administrative = 1;
var $author$project$Model$JobFunctionType$Advertising = 2;
var $author$project$Model$JobFunctionType$Analyst = 3;
var $author$project$Model$JobFunctionType$ArtCreative = 4;
var $author$project$Model$JobFunctionType$BusinessDevelopment = 5;
var $author$project$Model$JobFunctionType$Consulting = 6;
var $author$project$Model$JobFunctionType$CustomerService = 7;
var $author$project$Model$JobFunctionType$Design = 9;
var $author$project$Model$JobFunctionType$Distribution = 8;
var $author$project$Model$JobFunctionType$Education = 10;
var $author$project$Model$JobFunctionType$Engineering = 11;
var $author$project$Model$JobFunctionType$Finance = 12;
var $author$project$Model$JobFunctionType$GeneralBusiness = 13;
var $author$project$Model$JobFunctionType$HealthCareProvider = 14;
var $author$project$Model$JobFunctionType$HumanResources = 15;
var $author$project$Model$JobFunctionType$InformationTechnology = 16;
var $author$project$Model$JobFunctionType$Legal = 17;
var $author$project$Model$JobFunctionType$Management = 18;
var $author$project$Model$JobFunctionType$Manufacturing = 19;
var $author$project$Model$JobFunctionType$Marketing = 20;
var $author$project$Model$JobFunctionType$Other = 21;
var $author$project$Model$JobFunctionType$ProductManagement = 24;
var $author$project$Model$JobFunctionType$Production = 26;
var $author$project$Model$JobFunctionType$ProjectManagement = 25;
var $author$project$Model$JobFunctionType$PublicRelations = 22;
var $author$project$Model$JobFunctionType$Purchasing = 23;
var $author$project$Model$JobFunctionType$QualityAssurance = 27;
var $author$project$Model$JobFunctionType$Research = 28;
var $author$project$Model$JobFunctionType$Sales = 29;
var $author$project$Model$JobFunctionType$Science = 30;
var $author$project$Model$JobFunctionType$StrategyPlanning = 31;
var $author$project$Model$JobFunctionType$SupplyChain = 32;
var $author$project$Model$JobFunctionType$Training = 33;
var $author$project$Model$JobFunctionType$WritingEditing = 34;
var $author$project$Model$JobFunctionType$jobFunctionTypeDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'accounting-auditing':
				return $elm$json$Json$Decode$succeed(0);
			case 'administrative':
				return $elm$json$Json$Decode$succeed(1);
			case 'advertising':
				return $elm$json$Json$Decode$succeed(2);
			case 'analyst':
				return $elm$json$Json$Decode$succeed(3);
			case 'art-creative':
				return $elm$json$Json$Decode$succeed(4);
			case 'business-development':
				return $elm$json$Json$Decode$succeed(5);
			case 'consulting':
				return $elm$json$Json$Decode$succeed(6);
			case 'customer-service':
				return $elm$json$Json$Decode$succeed(7);
			case 'distribution':
				return $elm$json$Json$Decode$succeed(8);
			case 'design':
				return $elm$json$Json$Decode$succeed(9);
			case 'education':
				return $elm$json$Json$Decode$succeed(10);
			case 'engineering':
				return $elm$json$Json$Decode$succeed(11);
			case 'finance':
				return $elm$json$Json$Decode$succeed(12);
			case 'general-business':
				return $elm$json$Json$Decode$succeed(13);
			case 'health-care-provider':
				return $elm$json$Json$Decode$succeed(14);
			case 'human-resources':
				return $elm$json$Json$Decode$succeed(15);
			case 'information-technology':
				return $elm$json$Json$Decode$succeed(16);
			case 'legal':
				return $elm$json$Json$Decode$succeed(17);
			case 'management':
				return $elm$json$Json$Decode$succeed(18);
			case 'manufacturing':
				return $elm$json$Json$Decode$succeed(19);
			case 'marketing':
				return $elm$json$Json$Decode$succeed(20);
			case 'other':
				return $elm$json$Json$Decode$succeed(21);
			case 'public-relations':
				return $elm$json$Json$Decode$succeed(22);
			case 'purchasing':
				return $elm$json$Json$Decode$succeed(23);
			case 'product-management':
				return $elm$json$Json$Decode$succeed(24);
			case 'project-management':
				return $elm$json$Json$Decode$succeed(25);
			case 'production':
				return $elm$json$Json$Decode$succeed(26);
			case 'quality-assurance':
				return $elm$json$Json$Decode$succeed(27);
			case 'research':
				return $elm$json$Json$Decode$succeed(28);
			case 'sales':
				return $elm$json$Json$Decode$succeed(29);
			case 'science':
				return $elm$json$Json$Decode$succeed(30);
			case 'strategy-planning':
				return $elm$json$Json$Decode$succeed(31);
			case 'supply-chain':
				return $elm$json$Json$Decode$succeed(32);
			case 'training':
				return $elm$json$Json$Decode$succeed(33);
			case 'writing-editing':
				return $elm$json$Json$Decode$succeed(34);
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Model$JobType$Contract = 2;
var $author$project$Model$JobType$FullTime = 4;
var $author$project$Model$JobType$Intern = 1;
var $author$project$Model$JobType$PartTime = 3;
var $author$project$Model$JobType$Volunteer = 0;
var $author$project$Model$JobType$jobTypeDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'volunteer':
				return $elm$json$Json$Decode$succeed(0);
			case 'intern':
				return $elm$json$Json$Decode$succeed(1);
			case 'contract':
				return $elm$json$Json$Decode$succeed(2);
			case 'part-time':
				return $elm$json$Json$Decode$succeed(3);
			case 'full-time':
				return $elm$json$Json$Decode$succeed(4);
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Model$LinkedInFieldType$linkedInFieldTypeDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'job-type':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$JobType$jobTypeDecoder,
					$elm$json$Json$Decode$succeed($author$project$Model$LinkedInFieldType$JobType));
			case 'job-function':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$JobFunctionType$jobFunctionTypeDecoder,
					$elm$json$Json$Decode$succeed($author$project$Model$LinkedInFieldType$JobFunction));
			case 'experience-level':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$ExperienceLevel$experienceLevelDecoder,
					$elm$json$Json$Decode$succeed($author$project$Model$LinkedInFieldType$ExperienceLevel));
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	A2($elm$json$Json$Decode$field, 'tag', $elm$json$Json$Decode$string));
var $author$project$Model$StructuredDataType$EmploymentType = $elm$core$Basics$identity;
var $author$project$Model$EmploymentType$Contractor = 2;
var $author$project$Model$EmploymentType$FullTime = 0;
var $author$project$Model$EmploymentType$Intern = 4;
var $author$project$Model$EmploymentType$Other = 7;
var $author$project$Model$EmploymentType$PartTime = 1;
var $author$project$Model$EmploymentType$PerDiem = 6;
var $author$project$Model$EmploymentType$Temporary = 3;
var $author$project$Model$EmploymentType$Volunteer = 5;
var $author$project$Model$EmploymentType$employmentTypeDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'full-time':
				return $elm$json$Json$Decode$succeed(0);
			case 'part-time':
				return $elm$json$Json$Decode$succeed(1);
			case 'contractor':
				return $elm$json$Json$Decode$succeed(2);
			case 'temporary':
				return $elm$json$Json$Decode$succeed(3);
			case 'intern':
				return $elm$json$Json$Decode$succeed(4);
			case 'volunteer':
				return $elm$json$Json$Decode$succeed(5);
			case 'per-diem':
				return $elm$json$Json$Decode$succeed(6);
			case 'other':
				return $elm$json$Json$Decode$succeed(7);
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Model$StructuredDataType$structuredDataTypeDecoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $author$project$Model$EmploymentType$employmentTypeDecoder);
var $author$project$Model$VacancyFilterOptionValue$HourRange = function (a) {
	return {$: 0, a: a};
};
var $author$project$Model$VacancyFilterOptionValue$SalaryRange = function (a) {
	return {$: 1, a: a};
};
var $author$project$Model$VacancyFilterOptionValue$TextValue = function (a) {
	return {$: 2, a: a};
};
var $author$project$Model$VacancyFilterOptionValue$HourRangeValue = F2(
	function (minHours, maxHours) {
		return {Sy: maxHours, Te: minHours};
	});
var $author$project$Model$VacancyFilterOptionValue$hourRangeValueDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'maxHours',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'minHours',
		$elm$json$Json$Decode$int,
		$elm$json$Json$Decode$succeed($author$project$Model$VacancyFilterOptionValue$HourRangeValue)));
var $author$project$Model$VacancyFilterOptionValue$SalaryRangeValue = F2(
	function (minSalary, maxSalary) {
		return {SC: maxSalary, Th: minSalary};
	});
var $author$project$Model$VacancyFilterOptionValue$salaryRangeValueDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'maxSalary',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'minSalary',
		$elm$json$Json$Decode$int,
		$elm$json$Json$Decode$succeed($author$project$Model$VacancyFilterOptionValue$SalaryRangeValue)));
var $author$project$Model$VacancyFilterOptionValue$vacancyFilterOptionValueDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'hour-range':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$VacancyFilterOptionValue$hourRangeValueDecoder,
					$elm$json$Json$Decode$succeed($author$project$Model$VacancyFilterOptionValue$HourRange));
			case 'salary-range':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$VacancyFilterOptionValue$salaryRangeValueDecoder,
					$elm$json$Json$Decode$succeed($author$project$Model$VacancyFilterOptionValue$SalaryRange));
			case 'text-value':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Model$VacancyFilterOptionValue$TextValue));
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	A2($elm$json$Json$Decode$field, 'tag', $elm$json$Json$Decode$string));
var $author$project$Model$VacancyFilterOption$vacancyFilterOptionDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'isLocationPart',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'synonyms',
		$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'updated',
			$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'masterDataOrigin',
				$author$project$Model$MasterDataOrigin$masterDataOriginDecoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'vacancyIdsMirror',
					$elm$json$Json$Decode$list($author$project$Data$Id$decoder),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'linkedInFieldType',
						$elm$json$Json$Decode$nullable($author$project$Model$LinkedInFieldType$linkedInFieldTypeDecoder),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'structuredDataType',
							$elm$json$Json$Decode$nullable($author$project$Model$StructuredDataType$structuredDataTypeDecoder),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'showAsTag',
								$elm$json$Json$Decode$bool,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'bannerImages',
									$elm$json$Json$Decode$list($author$project$Model$ImageSource$imageSourceDecoder),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'companyLogo',
										$elm$json$Json$Decode$nullable($author$project$Model$ImageSource$imageSourceDecoder),
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'seqNo',
											$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'className',
												$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'displayLabel',
													$elm$json$Json$Decode$string,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'value',
														$author$project$Model$VacancyFilterOptionValue$vacancyFilterOptionValueDecoder,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'filterId',
															$author$project$Data$Id$decoder,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'domainId',
																$author$project$Data$Id$decoder,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'externalAts',
																	$elm$json$Json$Decode$nullable($author$project$Model$Ats$atsDecoder),
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'externalId',
																		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																		$elm$json$Json$Decode$succeed($author$project$Model$VacancyFilterOption$VacancyFilterOption)))))))))))))))))));
var $author$project$Model$ReferralFormResponse$filterWithOptionsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'options',
	$elm$json$Json$Decode$list(
		$author$project$Data$Entity$decoder($author$project$Model$VacancyFilterOption$vacancyFilterOptionDecoder)),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'filter',
		$author$project$Data$Entity$decoder($author$project$Model$VacancyFilter$vacancyFilterDecoder),
		$elm$json$Json$Decode$succeed($author$project$Model$ReferralFormResponse$FilterWithOptions)));
var $author$project$Model$ReferralFormResponse$NestedFormArgsResponse = F3(
	function (initialFilterOption, filters, askLocation) {
		return {lh: askLocation, If: filters, NZ: initialFilterOption};
	});
var $author$project$Model$ReferralFormResponse$nestedFormArgsResponseDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'askLocation',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'filters',
		$elm$json$Json$Decode$list($author$project$Model$ReferralFormResponse$filterWithOptionsDecoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'initialFilterOption',
			$author$project$Data$Entity$decoder($author$project$Model$VacancyFilterOption$vacancyFilterOptionDecoder),
			$elm$json$Json$Decode$succeed($author$project$Model$ReferralFormResponse$NestedFormArgsResponse))));
var $author$project$Model$ReferralFormResponse$referralFormResponseDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'simple-referral-form-response':
				return A2(
					$elm$json$Json$Decode$field,
					'contents',
					A2(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
						A2($elm$json$Json$Decode$index, 1, $elm$json$Json$Decode$bool),
						A2(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
							A2(
								$elm$json$Json$Decode$index,
								0,
								$elm$json$Json$Decode$list($author$project$Model$ReferralFormResponse$filterWithOptionsDecoder)),
							$elm$json$Json$Decode$succeed($author$project$Model$ReferralFormResponse$SimpleReferralFormResponse))));
			case 'nested-referral-form-response':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$elm$json$Json$Decode$list($author$project$Model$ReferralFormResponse$nestedFormArgsResponseDecoder),
					$elm$json$Json$Decode$succeed($author$project$Model$ReferralFormResponse$NestedReferralFormResponse));
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	A2($elm$json$Json$Decode$field, 'tag', $elm$json$Json$Decode$string));
var $author$project$ReferralToolForm$decodeFlags = A8(
	$elm$json$Json$Decode$map7,
	$author$project$ReferralToolForm$Flags,
	$author$project$Data$Translation$translationsDecoder,
	A2($elm$json$Json$Decode$field, 'currentLangCode', $author$project$Model$LangCode$decoder),
	A2($elm$json$Json$Decode$field, 'referralFormResponse', $author$project$Model$ReferralFormResponse$referralFormResponseDecoder),
	A2($elm$json$Json$Decode$field, 'domainId', $author$project$Data$Id$decoder),
	A2($elm$json$Json$Decode$field, 'sessionToken', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'csrfToken', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'domains', $author$project$Data$Domains$domainsDecoder));
var $author$project$ReferralToolForm$initForm = function (domainKey) {
	return {sq: false, atF: domainKey, eR: '', Ip: '', Nw: $elm$core$Maybe$Nothing, Qx: '', QC: $elm$core$Maybe$Nothing, Rs: '', _I: '', aR: '', awg: _List_Nil};
};
var $author$project$ReferralToolForm$init = function (flags) {
	return _Utils_Tuple2(
		{
			ci: flags.ci,
			bE: flags.bE,
			atF: flags.dp,
			bG: flags.bG,
			NZ: $elm$core$Maybe$Nothing,
			az: $author$project$View$LocationSuggestions$init,
			R: _Utils_Tuple2(
				$author$project$ReferralToolForm$initForm(flags.dp),
				$elm$core$Maybe$Nothing),
			cJ: flags.cJ,
			aW: $elm$core$Maybe$Just(flags.aW),
			anB: flags.anB,
			cU: $elm$core$Maybe$Nothing
		},
		$elm$core$Platform$Cmd$none);
};
var $author$project$ReferralToolForm$GotProgress = function (a) {
	return {$: 4, a: a};
};
var $author$project$ReferralToolForm$LocationSuggestionsMsg = function (a) {
	return {$: 10, a: a};
};
var $author$project$ReferralToolForm$SetLocationSuggestion = function (a) {
	return {$: 11, a: a};
};
var $author$project$ReferralToolForm$locationSuggestionsConfig = function (model) {
	return {
		db: 'location-search-only',
		ci: model.ci,
		dp: model.atF,
		aul: $elm$core$Maybe$Nothing,
		aut: $author$project$ReferralToolForm$LocationSuggestionsMsg,
		avy: 1,
		aW: model.aW,
		avO: $author$project$View$Autocomplete$Http$Button(
			{avN: $author$project$ReferralToolForm$SetLocationSuggestion, av2: $elm$core$Maybe$Nothing}),
		avS: $elm$core$Maybe$Nothing,
		fX: 'location-suggestion'
	};
};
var $author$project$ReferralToolForm$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2($elm$http$Http$track, 'submit', $author$project$ReferralToolForm$GotProgress),
				A2(
				$author$project$View$LocationSuggestions$subscriptions,
				$author$project$ReferralToolForm$locationSuggestionsConfig(model),
				model.az)
			]));
};
var $author$project$ReferralToolForm$GotCreateReferral = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$ReferralToolForm$GotPreviews = function (a) {
	return {$: 6, a: a};
};
var $author$project$ReferralToolForm$SelectedFile = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$Api$Endpoint$referrals = function (domainKey) {
	return $author$project$Api$Endpoint$endpoint(
		_List_fromArray(
			[
				$author$project$Data$Id$toString(domainKey),
				'referrals'
			]));
};
var $author$project$Api$Endpoint$request = function (config) {
	var _v0 = config.a0;
	var url = _v0;
	return $elm$http$Http$request(
		{_: config._, aH: config.aH, ax: config.ax, aO: config.aO, a_: config.a_, av3: config.av3, a0: url});
};
var $author$project$View$Autocomplete$Http$currentInputValue = function (_v0) {
	var state = _v0;
	return state.ak;
};
var $author$project$View$Autocomplete$Http$resetWith = F2(
	function (toString, state_) {
		var state = state_;
		return _Utils_update(
			state,
			{
				y: $author$project$Data$Autocomplete$unknown,
				ak: A2(
					$elm$core$Maybe$withDefault,
					$author$project$View$Autocomplete$Http$currentInputValue(state_),
					A2(
						$elm$core$Maybe$map,
						toString,
						$author$project$View$Autocomplete$Http$currentlyFocussedValue(state_))),
				P2: $author$project$Data$Key$newKey
			});
	});
var $author$project$View$LocationSuggestions$resetWithValue = function (_v0) {
	var state = _v0;
	return _Utils_update(
		state,
		{
			al: A2(
				$author$project$View$Autocomplete$Http$resetWith,
				function ($) {
					return $.auy;
				},
				state.al)
		});
};
var $author$project$Model$ReferralLocation$encodeReferralLocation = function (a) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'latitude',
				$elm$json$Json$Encode$float(a.QE)),
				_Utils_Tuple2(
				'longitude',
				$elm$json$Json$Encode$float(a.RZ))
			]));
};
var $author$project$ReferralToolForm$toMultiPartBody = function (form) {
	var toLatLongPart = A2(
		$elm$core$Basics$composeL,
		A2(
			$elm$core$Basics$composeL,
			A2(
				$elm$core$Basics$composeL,
				$elm$core$List$singleton,
				$elm$http$Http$stringPart('latLong')),
			$elm$json$Json$Encode$encode(0)),
		$author$project$Model$ReferralLocation$encodeReferralLocation);
	var toLocation = A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2($elm$core$Maybe$map, toLatLongPart, form.QC));
	var restOfBody = _List_fromArray(
		[
			A2($elm$http$Http$stringPart, 'firstName', form.Ip),
			A2($elm$http$Http$stringPart, 'lastName', form.Qx),
			A2($elm$http$Http$stringPart, 'email', form.eR),
			A2($elm$http$Http$stringPart, 'phone', form.aR),
			A2($elm$http$Http$stringPart, 'location', form.Rs),
			A2($elm$http$Http$stringPart, 'personalMessage', form._I)
		]);
	var optionParts = A2(
		$elm$core$List$map,
		A2(
			$elm$core$Basics$composeL,
			$elm$http$Http$stringPart('optionIds'),
			$author$project$Data$Id$toString),
		form.awg);
	var filePart = A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			function (mediaItem) {
				return _List_fromArray(
					[
						A2($elm$http$Http$filePart, 'personalImage', mediaItem.HC)
					]);
			},
			form.Nw));
	var body = _Utils_ap(
		filePart,
		_Utils_ap(
			optionParts,
			_Utils_ap(restOfBody, toLocation)));
	return $elm$http$Http$multipartBody(body);
};
var $author$project$ReferralToolForm$maxImageSize = _Utils_Tuple2(10000000, '10MB');
var $author$project$ReferralToolForm$toPreview = function (base64) {
	var _v0 = $author$project$Data$MimeType$fromBase64(base64);
	if (!_v0.$) {
		return {eK: base64, dF: base64, cA: $author$project$ReferralToolForm$maxImageSize};
	} else {
		return {eK: base64, dF: '/static/images/image-placeholder.png', cA: $author$project$ReferralToolForm$maxImageSize};
	}
};
var $author$project$ReferralToolForm$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 1:
				var _v1 = model.R;
				var referralForm = _v1.a;
				return _Utils_Tuple2(
					model,
					$author$project$Api$Endpoint$request(
						{
							_: $author$project$ReferralToolForm$toMultiPartBody(referralForm),
							aH: A2(
								$author$project$Api$expectJson,
								$author$project$ReferralToolForm$GotCreateReferral(referralForm),
								$author$project$Model$RedirectUrl$redirectUrlDecoder),
							ax: _List_Nil,
							aO: 'POST',
							a_: $elm$core$Maybe$Nothing,
							av3: $elm$core$Maybe$Just('submit'),
							a0: $author$project$Api$Endpoint$referrals(referralForm.atF)
						}));
			case 3:
				if (!msg.b.$) {
					var unRedirectUrl = msg.b.a.av7;
					return _Utils_Tuple2(
						model,
						$elm$browser$Browser$Navigation$load(unRedirectUrl));
				} else {
					if (!msg.b.a.$) {
						var form = msg.a;
						var error = msg.b.a.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									R: _Utils_Tuple2(
										form,
										$elm$core$Maybe$Just(error)),
									cU: $elm$core$Maybe$Nothing
								}),
							$elm$core$Platform$Cmd$none);
					} else {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{cU: $elm$core$Maybe$Nothing}),
							$elm$core$Platform$Cmd$none);
					}
				}
			case 4:
				if (msg.a.$ === 1) {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				} else {
					var progress = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								cU: $elm$core$Maybe$Just(
									$elm$http$Http$fractionSent(progress))
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 5:
				var form = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{R: form}),
					$elm$core$Platform$Cmd$none);
			case 2:
				var maybeOptionId = msg.a;
				var _v2 = model.R;
				var form = _v2.a;
				var errorResponse = _v2.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							NZ: maybeOptionId,
							R: _Utils_Tuple2(
								_Utils_update(
									form,
									{awg: _List_Nil}),
								errorResponse)
						}),
					$elm$core$Platform$Cmd$none);
			case 7:
				return _Utils_Tuple2(
					model,
					A2(
						$elm$file$File$Select$files,
						_List_fromArray(
							['image/*', 'gif/*']),
						$author$project$ReferralToolForm$SelectedFile));
			case 8:
				var file = msg.a;
				var files = msg.b;
				var fileToMediaItemToUpload = function (f) {
					return A2(
						$elm$core$Task$map,
						function (base64) {
							return {
								HC: f,
								$V: $author$project$ReferralToolForm$toPreview(base64)
							};
						},
						$elm$file$File$toUrl(f));
				};
				return _Utils_Tuple2(
					model,
					A2(
						$elm$core$Task$perform,
						$author$project$ReferralToolForm$GotPreviews,
						$elm$core$Task$sequence(
							A2(
								$elm$core$List$map,
								fileToMediaItemToUpload,
								A2($elm$core$List$cons, file, files)))));
			case 6:
				if (msg.a.b) {
					var _v3 = msg.a;
					var preview = _v3.a;
					var _v4 = model.R;
					var form = _v4.a;
					var errorResponse = _v4.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								R: _Utils_Tuple2(
									_Utils_update(
										form,
										{
											Nw: $elm$core$Maybe$Just(preview)
										}),
									errorResponse)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 9:
				var _v5 = model.R;
				var form = _v5.a;
				var error = _v5.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							R: _Utils_Tuple2(
								_Utils_update(
									form,
									{Nw: $elm$core$Maybe$Nothing}),
								error)
						}),
					$elm$core$Platform$Cmd$none);
			case 10:
				var locationSuggestionsMsg = msg.a;
				var _v6 = A3(
					$author$project$View$LocationSuggestions$update,
					$author$project$ReferralToolForm$locationSuggestionsConfig(model),
					locationSuggestionsMsg,
					model.az);
				var locationSuggestionsModel = _v6.a;
				var locationSuggestionsCmds = _v6.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{az: locationSuggestionsModel}),
					locationSuggestionsCmds);
			default:
				var location = msg.a;
				var toLatLong = function () {
					var _v8 = _Utils_Tuple2(location.QE, location.RZ);
					if ((!_v8.a.$) && (!_v8.b.$)) {
						var lat = _v8.a.a;
						var _long = _v8.b.a;
						return $elm$core$Maybe$Just(
							{QE: lat, RZ: _long});
					} else {
						return $elm$core$Maybe$Nothing;
					}
				}();
				var _v7 = model.R;
				var form = _v7.a;
				var errorResponse = _v7.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							az: $author$project$View$LocationSuggestions$resetWithValue(model.az),
							R: _Utils_Tuple2(
								_Utils_update(
									form,
									{QC: toLatLong}),
								errorResponse)
						}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$ReferralToolForm$CreateReferral = {$: 1};
var $author$project$ReferralToolForm$UpdateReferralForm = function (a) {
	return {$: 5, a: a};
};
var $author$project$Component$Form$TextInput$Attribute = $elm$core$Basics$identity;
var $author$project$Component$Form$TextInput$TextInput = $elm$core$Basics$identity;
var $author$project$Component$Form$TextInput$set = function (_with) {
	return function (_v0) {
		var config = _v0;
		return _with(config);
	};
};
var $author$project$Component$Form$TextInput$class = function (class_) {
	return $author$project$Component$Form$TextInput$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{
					df: $elm$core$Maybe$Just(class_)
				});
		});
};
var $author$project$Component$Form$TextArea$Attribute = $elm$core$Basics$identity;
var $author$project$Component$Form$TextArea$TextArea = $elm$core$Basics$identity;
var $author$project$Component$Form$TextArea$set = function (_with) {
	return function (_v0) {
		var config = _v0;
		return _with(config);
	};
};
var $author$project$Component$Form$TextArea$error = function (error_) {
	return $author$project$Component$Form$TextArea$set(
		function (config) {
			return _Utils_update(
				config,
				{cn: error_});
		});
};
var $author$project$Component$Form$TextInput$error = function (error_) {
	return $author$project$Component$Form$TextInput$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{
					bI: A2(
						$elm$core$Maybe$map,
						function (err) {
							return $rtfeldman$elm_css$Html$Styled$toUnstyled(
								A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('error-message')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(err)
										])));
						},
						error_)
				});
		});
};
var $wernerdegroot$listzipper$List$Zipper$toList = function (z) {
	return _Utils_ap(
		$wernerdegroot$listzipper$List$Zipper$before(z),
		_Utils_ap(
			_List_fromArray(
				[
					$wernerdegroot$listzipper$List$Zipper$current(z)
				]),
			$wernerdegroot$listzipper$List$Zipper$after(z)));
};
var $author$project$Data$Domains$toList = function (_v0) {
	var domains = _v0;
	return $wernerdegroot$listzipper$List$Zipper$toList(domains);
};
var $author$project$Data$Domains$hasMultipleDomains = A2(
	$elm$core$Basics$composeL,
	A2(
		$elm$core$Basics$composeL,
		$elm$core$Basics$lt(1),
		$elm$core$List$length),
	$author$project$Data$Domains$toList);
var $author$project$Component$Form$TextArea$hiddenLabel = function (hidden) {
	return $author$project$Component$Form$TextArea$set(
		function (config) {
			return _Utils_update(
				config,
				{dC: hidden});
		});
};
var $author$project$Component$Form$TextInput$hiddenLabel = function (val) {
	return $author$project$Component$Form$TextInput$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{dC: val});
		});
};
var $author$project$Component$Form$TextInput$icon = function (path) {
	return $author$project$Component$Form$TextInput$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{
					bb: $elm$core$Maybe$Just(path)
				});
		});
};
var $author$project$Component$Form$TextArea$onInput = function (msg_) {
	return $author$project$Component$Form$TextArea$set(
		function (config) {
			return _Utils_update(
				config,
				{
					d1: $elm$core$Maybe$Just(msg_)
				});
		});
};
var $author$project$Component$Form$TextInput$onInput = function (msg_) {
	return $author$project$Component$Form$TextInput$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{
					d1: $elm$core$Maybe$Just(msg_)
				});
		});
};
var $author$project$Model$Translation$personalMessage = 'personal-message';
var $author$project$Model$Translation$phoneNumberLabel = 'phone-number-label';
var $author$project$Component$Form$TextArea$placeholder = function (placeholder_) {
	return $author$project$Component$Form$TextArea$set(
		function (config) {
			return _Utils_update(
				config,
				{
					d5: $elm$core$Maybe$Just(placeholder_)
				});
		});
};
var $author$project$Component$Form$TextInput$placeholder = function (placeholder_) {
	return $author$project$Component$Form$TextInput$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{
					d5: $elm$core$Maybe$Just(placeholder_)
				});
		});
};
var $author$project$Model$Translation$referralFormEmailLabel = 'referral-form-email-label';
var $author$project$Model$Translation$referralFormEmailPlaceholder = 'referral-form-email-placeholder';
var $author$project$Model$Translation$referralFormFirstNameLabel = 'referral-form-first-name-label';
var $author$project$Model$Translation$referralFormFirstNamePlaceholder = 'referral-form-first-name-placeholder';
var $author$project$Model$Translation$referralFormLastNameLabel = 'referral-form-last-name-label';
var $author$project$Model$Translation$referralFormLastNamePlaceholder = 'referral-form-last-name-placeholder';
var $author$project$Model$Translation$referralFormMatchingMetadata = 'referral-form-matching-metadata';
var $author$project$Model$Translation$referralFormPhoneNumber = 'referral-form-phone-number';
var $author$project$Model$Translation$referralFormReferSomeoneLabel = 'referral-form-refer-someone-label';
var $author$project$Data$Domains$refocus = F2(
	function (_v0, config) {
		var domains = _v0;
		var focus = function (id) {
			return _Utils_Tuple2(
				id,
				A2(
					$wernerdegroot$listzipper$List$Zipper$findFirst,
					A2(
						$elm$core$Basics$composeL,
						$elm$core$Basics$eq(id),
						$author$project$Data$Entity$id),
					domains));
		};
		var _v1 = A2($elm$core$Maybe$map, focus, config.auF);
		if (!_v1.$) {
			if (!_v1.a.b.$) {
				var _v2 = _v1.a;
				var refocusedDomains = _v2.b.a;
				return _Utils_Tuple2(refocusedDomains, config.avK);
			} else {
				var _v3 = _v1.a;
				var id = _v3.a;
				var _v4 = _v3.b;
				return _Utils_Tuple2(
					domains,
					config.awa(id));
			}
		} else {
			return _Utils_Tuple2(domains, config.awb);
		}
	});
var $author$project$Component$Form$TextArea$rows = function (rows_) {
	return $author$project$Component$Form$TextArea$set(
		function (config) {
			return _Utils_update(
				config,
				{
					ee: $elm$core$Maybe$Just(rows_)
				});
		});
};
var $author$project$ReferralToolForm$isSelected = F2(
	function (maybeInitialOption, args) {
		return _Utils_eq(
			maybeInitialOption,
			$elm$core$Maybe$Just(
				$author$project$Data$Entity$id(args.NZ)));
	});
var $author$project$ReferralToolForm$maybeArgs = F2(
	function (maybeInitialOption, argsList) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				$author$project$ReferralToolForm$isSelected(maybeInitialOption),
				argsList));
	});
var $author$project$ReferralToolForm$toAskLocation = F2(
	function (initialFilterOption, formResponse) {
		if (!formResponse.$) {
			var askLocation = formResponse.b;
			return askLocation;
		} else {
			var args = formResponse.a;
			return A2(
				$elm$core$Maybe$withDefault,
				false,
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.lh;
					},
					A2($author$project$ReferralToolForm$maybeArgs, initialFilterOption, args)));
		}
	});
var $author$project$ReferralToolForm$toFilterOptionCount = F2(
	function (maybeInitialOption, response) {
		if (!response.$) {
			var filterOptions = response.a;
			return $elm$core$List$length(filterOptions);
		} else {
			var argList = response.a;
			return A2(
				$elm$core$Maybe$withDefault,
				1,
				A2(
					$elm$core$Maybe$map,
					function (_v1) {
						var filters = _v1.If;
						return $elm$core$List$length(filters);
					},
					A2($author$project$ReferralToolForm$maybeArgs, maybeInitialOption, argList)));
		}
	});
var $author$project$Component$Form$TextArea$value = function (value_) {
	return $author$project$Component$Form$TextArea$set(
		function (config) {
			return _Utils_update(
				config,
				{ey: value_});
		});
};
var $author$project$Component$Form$TextInput$value = function (value_) {
	return $author$project$Component$Form$TextInput$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{ey: value_});
		});
};
var $author$project$Component$DomainSelect$domainIdsFromGroup = function (_v0) {
	var perms = _v0;
	return A2(
		$elm$core$List$filterMap,
		function (_v1) {
			var dId = _v1.a;
			var ps = _v1.b;
			return $elm$core$List$isEmpty(ps) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(dId);
		},
		perms);
};
var $author$project$Component$DomainSelect$computeAccessibleDomainIds = F3(
	function (maybeUser, groups, domains) {
		var allDomainIds = A2(
			$elm$core$List$map,
			$author$project$Data$Entity$id,
			$author$project$Data$Domains$toList(domains));
		if (maybeUser.$ === 1) {
			return allDomainIds;
		} else {
			var user = maybeUser.a;
			if (user.asY) {
				return allDomainIds;
			} else {
				var userGroups = A2(
					$elm$core$List$filter,
					function (gE) {
						return A2(
							$elm$core$List$member,
							$author$project$Data$Entity$id(gE),
							user.aue);
					},
					groups);
				var groupDomainIds = A2(
					$elm$core$List$concatMap,
					A2(
						$elm$core$Basics$composeL,
						A2(
							$elm$core$Basics$composeL,
							$author$project$Component$DomainSelect$domainIdsFromGroup,
							function ($) {
								return $.atG;
							}),
						$author$project$Data$Entity$value),
					userGroups);
				return A2(
					$elm$core$List$filter,
					function (dId) {
						return A2($elm$core$List$member, dId, groupDomainIds);
					},
					allDomainIds);
			}
		}
	});
var $author$project$Data$Domains$currentId = function (_v0) {
	var domains = _v0;
	return $author$project$Data$Entity$id(
		$wernerdegroot$listzipper$List$Zipper$current(domains));
};
var $author$project$Component$DomainSelect$domainToLabel = function (_v0) {
	var domain = _v0.b;
	var regionLabel = function () {
		var _v1 = domain.avp;
		switch (_v1) {
			case 0:
				return $author$project$Copy$copy.as3;
			case 1:
				return $author$project$Copy$copy.as6;
			case 2:
				return $author$project$Copy$copy.atg;
			case 3:
				return $author$project$Copy$copy.avR;
			case 4:
				return $author$project$Copy$copy.atD;
			case 5:
				return $author$project$Copy$copy.atI;
			case 6:
				return $author$project$Copy$copy.atZ;
			case 7:
				return $author$project$Copy$copy.at6;
			case 8:
				return $author$project$Copy$copy.at8;
			case 9:
				return $author$project$Copy$copy.at9;
			case 10:
				return $author$project$Copy$copy.aud;
			case 11:
				return $author$project$Copy$copy.auh;
			case 12:
				return $author$project$Copy$copy.aup;
			case 13:
				return $author$project$Copy$copy.auB;
			case 14:
				return $author$project$Copy$copy.auN;
			case 15:
				return $author$project$Copy$copy.auX;
			case 17:
				return $author$project$Copy$copy.ave;
			case 18:
				return $author$project$Copy$copy.avf;
			case 19:
				return $author$project$Copy$copy.avt;
			case 21:
				return $author$project$Copy$copy.avA;
			case 20:
				return $author$project$Copy$copy.avC;
			case 22:
				return $author$project$Copy$copy.avD;
			case 23:
				return $author$project$Copy$copy.avQ;
			case 24:
				return $author$project$Copy$copy.av8;
			default:
				return $author$project$Copy$copy.av6;
		}
	}();
	return A2(
		$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
		'{0} | {1}',
		_List_fromArray(
			[domain.bO, regionLabel]));
};
var $author$project$Data$Id$fromString = A2(
	$elm$core$Basics$composeL,
	$elm$core$Maybe$map($elm$core$Basics$identity),
	$elm$core$String$toInt);
var $author$project$Component$DomainSelect$isAccessible = F2(
	function (accessibleDomainIds, domainId) {
		return A2($elm$core$List$member, domainId, accessibleDomainIds);
	});
var $author$project$Data$Domains$toNonEmpty = function (_v0) {
	var domains = _v0;
	return _Utils_Tuple2(
		$wernerdegroot$listzipper$List$Zipper$current(
			$wernerdegroot$listzipper$List$Zipper$first(domains)),
		$wernerdegroot$listzipper$List$Zipper$after(
			$wernerdegroot$listzipper$List$Zipper$first(domains)));
};
var $author$project$Component$DomainSelect$view = F4(
	function (toMsg, maybeUser, groups, domains) {
		var isCurrent = $elm$core$Maybe$Just(
			A2(
				$elm$core$Basics$composeL,
				$elm$core$Basics$eq(
					$author$project$Data$Domains$currentId(domains)),
				$author$project$Data$Entity$id));
		var accessibleDomainIds = A3($author$project$Component$DomainSelect$computeAccessibleDomainIds, maybeUser, groups, domains);
		return A2(
			$author$project$Util$View$viewIf,
			$author$project$Data$Domains$hasMultipleDomains(domains),
			function (_v0) {
				return $author$project$Component$Form$SelectNonEmpty$viewSelect(
					{
						atr: isCurrent,
						at7: $author$project$Data$Id$fromString,
						auq: $elm$core$Maybe$Just(
							function (entity) {
								return !A2(
									$author$project$Component$DomainSelect$isAccessible,
									accessibleDomainIds,
									$author$project$Data$Entity$id(entity));
							}),
						au7: $author$project$Data$Domains$toNonEmpty(domains),
						avz: false,
						avS: $elm$core$Maybe$Nothing,
						avZ: toMsg,
						av_: $author$project$Component$DomainSelect$domainToLabel,
						av$: A2($elm$core$Basics$composeL, $author$project$Data$Id$toString, $author$project$Data$Entity$id)
					});
			});
	});
var $author$project$Component$Form$TextArea$build = {c5: false, dd: $elm$core$Maybe$Nothing, $7: false, cn: $elm$core$Maybe$Nothing, dy: $elm$core$Maybe$Nothing, dC: false, dE: '', dI: false, bO: '', d1: $elm$core$Maybe$Nothing, d5: $elm$core$Maybe$Nothing, eb: false, ee: $elm$core$Maybe$Nothing, avz: false, eq: $elm$core$Maybe$Nothing, ey: ''};
var $author$project$Component$Form$TextArea$label = function (label_) {
	return $author$project$Component$Form$TextArea$set(
		function (config) {
			return _Utils_update(
				config,
				{bO: label_});
		});
};
var $elm$html$Html$Attributes$cols = function (n) {
	return A2(
		_VirtualDom_attribute,
		'cols',
		$elm$core$String$fromInt(n));
};
var $author$project$Component$Form$TextArea$viewTextArea = function (_v0) {
	var config = _v0;
	var placeholder_ = A2($elm$core$Maybe$withDefault, config.bO, config.d5);
	var maybeAttributes = A2(
		$elm$core$List$filterMap,
		$elm$core$Basics$identity,
		_List_fromArray(
			[
				A2($elm$core$Maybe$map, $elm$html$Html$Attributes$rows, config.ee),
				A2($elm$core$Maybe$map, $elm$html$Html$Attributes$cols, config.dd),
				A2($elm$core$Maybe$map, $elm$html$Html$Events$onInput, config.d1)
			]));
	var labelClassList = _List_fromArray(
		[
			_Utils_Tuple2('label', true),
			_Utils_Tuple2('visually-hidden', config.dC)
		]);
	var inputClassList = _List_fromArray(
		[
			_Utils_Tuple2('form-input ', true),
			_Utils_Tuple2('form-textarea', true),
			_Utils_Tuple2('as-text', config.avz)
		]);
	var inputAttributes = _Utils_ap(
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(inputClassList),
				$elm$html$Html$Attributes$disabled(config.$7),
				$elm$html$Html$Attributes$placeholder(placeholder_),
				$elm$html$Html$Attributes$value(config.ey),
				$elm$html$Html$Attributes$id(config.dE),
				$elm$html$Html$Attributes$required(config.eb)
			]),
		$author$project$Util$Tabindex$fieldTabIndexUnstyled(config.eq));
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('form-field', true),
						_Utils_Tuple2('inline', config.dI),
						_Utils_Tuple2('as-text', config.avz),
						_Utils_Tuple2(
						'error',
						$elm_community$maybe_extra$Maybe$Extra$isJust(config.cn))
					]))
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$label,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$classList(labelClassList),
						$elm$html$Html$Attributes$for(config.dE)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(config.bO)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('form-field-wrapper'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('autogrow', config.c5),
								_Utils_Tuple2('as-text', config.avz)
							])),
						A2($elm$html$Html$Attributes$attribute, 'data-value', config.ey)
					]),
				_List_fromArray(
					[
						config.avz ? A2(
						$elm$html$Html$div,
						_Utils_ap(inputAttributes, maybeAttributes),
						$author$project$Util$Html$parse(config.ey)) : A2(
						$elm$html$Html$textarea,
						_Utils_ap(inputAttributes, maybeAttributes),
						_List_Nil),
						A2($author$project$Util$View$viewMaybe, config.dy, $elm$core$Basics$identity)
					])),
				A2(
				$author$project$Util$View$viewMaybe,
				config.cn,
				function (error_) {
					return A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('error-message')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(error_)
							]));
				})
			]));
};
var $author$project$Component$Form$TextArea$view = F2(
	function (label_, attributes) {
		return $author$project$Component$Form$TextArea$viewTextArea(
			A3(
				$elm$core$List$foldl,
				function (_v0) {
					var attribute = _v0;
					return attribute;
				},
				$author$project$Component$Form$TextArea$build,
				A2(
					$elm$core$List$cons,
					$author$project$Component$Form$TextArea$label(label_),
					attributes)));
	});
var $author$project$Component$Form$TextInput$Text = 1;
var $author$project$Component$Form$TextInput$build = {cY: false, df: $elm$core$Maybe$Nothing, cj: _List_Nil, $7: false, bI: $elm$core$Maybe$Nothing, co: $elm$core$Maybe$Nothing, dy: $elm$core$Maybe$Nothing, cs: false, dC: false, cv: _List_Nil, bb: $elm$core$Maybe$Nothing, dE: $elm$core$Maybe$Nothing, dI: false, bO: '', cz: $elm$core$Maybe$Nothing, dY: $elm$core$Maybe$Nothing, d_: $elm$core$Maybe$Nothing, d1: $elm$core$Maybe$Nothing, d5: $elm$core$Maybe$Nothing, eb: false, cM: false, avz: false, eq: $elm$core$Maybe$Nothing, ew: 1, ey: '', eA: false};
var $author$project$Component$Form$TextInput$label = function (label_) {
	return $author$project$Component$Form$TextInput$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{bO: label_});
		});
};
var $rtfeldman$elm_css$Html$Styled$Attributes$classList = function (classes) {
	return $rtfeldman$elm_css$Html$Styled$Attributes$class(
		A3(
			$rtfeldman$elm_css$Css$String$mapJoin,
			$elm$core$Tuple$first,
			' ',
			A2($elm$core$List$filter, $elm$core$Tuple$second, classes)));
};
var $rtfeldman$elm_css$Html$Styled$div = $rtfeldman$elm_css$Html$Styled$node('div');
var $rtfeldman$elm_css$Html$Styled$Attributes$for = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('htmlFor');
var $author$project$Component$Form$TextInput$generateId = function (labelText) {
	return A2(
		$elm$core$String$join,
		'-',
		$elm$core$String$words(labelText));
};
var $rtfeldman$elm_css$Html$Styled$Attributes$id = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('id');
var $rtfeldman$elm_css$Html$Styled$input = $rtfeldman$elm_css$Html$Styled$node('input');
var $author$project$Component$Form$TextInput$inputType = function (inputType_) {
	switch (inputType_) {
		case 0:
			return 'email';
		case 2:
			return 'url';
		case 1:
			return 'text';
		default:
			return 'phone';
	}
};
var $rtfeldman$elm_css$Html$Styled$label = $rtfeldman$elm_css$Html$Styled$node('label');
var $rtfeldman$elm_css$Html$Styled$Attributes$name = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('name');
var $rtfeldman$elm_css$Html$Styled$Events$onBlur = function (msg) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$Events$on,
		'blur',
		$elm$json$Json$Decode$succeed(msg));
};
var $rtfeldman$elm_css$Html$Styled$Events$alwaysStop = function (x) {
	return _Utils_Tuple2(x, true);
};
var $rtfeldman$elm_css$Html$Styled$Events$stopPropagationOn = F2(
	function (event, decoder) {
		return A2(
			$rtfeldman$elm_css$VirtualDom$Styled$on,
			event,
			$elm$virtual_dom$VirtualDom$MayStopPropagation(decoder));
	});
var $rtfeldman$elm_css$Html$Styled$Events$targetValue = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'value']),
	$elm$json$Json$Decode$string);
var $rtfeldman$elm_css$Html$Styled$Events$onInput = function (tagger) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$Events$stopPropagationOn,
		'input',
		A2(
			$elm$json$Json$Decode$map,
			$rtfeldman$elm_css$Html$Styled$Events$alwaysStop,
			A2($elm$json$Json$Decode$map, tagger, $rtfeldman$elm_css$Html$Styled$Events$targetValue)));
};
var $rtfeldman$elm_css$Html$Styled$Attributes$placeholder = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('placeholder');
var $rtfeldman$elm_css$Html$Styled$Attributes$required = $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty('required');
var $rtfeldman$elm_css$VirtualDom$Styled$attribute = F2(
	function (key, value) {
		return A3(
			$rtfeldman$elm_css$VirtualDom$Styled$Attribute,
			A2($elm$virtual_dom$VirtualDom$attribute, key, value),
			false,
			'');
	});
var $rtfeldman$elm_css$Html$Styled$Attributes$tabindex = function (n) {
	return A2(
		$rtfeldman$elm_css$VirtualDom$Styled$attribute,
		'tabIndex',
		$elm$core$String$fromInt(n));
};
var $rtfeldman$elm_css$Html$Styled$Attributes$value = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('value');
var $author$project$Component$Form$TextInput$viewTextInput = function (_v0) {
	var config = _v0;
	var placeholder_ = A2($elm$core$Maybe$withDefault, config.bO, config.d5);
	var maybeClass = A2(
		$elm$core$List$filterMap,
		$elm$core$Basics$identity,
		_List_fromArray(
			[
				A2($elm$core$Maybe$map, $rtfeldman$elm_css$Html$Styled$Attributes$class, config.df)
			]));
	var maybeAttributes = A2(
		$elm$core$List$filterMap,
		$elm$core$Basics$identity,
		_List_fromArray(
			[
				A2($elm$core$Maybe$map, $rtfeldman$elm_css$Html$Styled$Events$onInput, config.d1),
				A2($elm$core$Maybe$map, $rtfeldman$elm_css$Html$Styled$Events$onBlur, config.d_),
				A2($elm$core$Maybe$map, $rtfeldman$elm_css$Html$Styled$Attributes$name, config.dY),
				(config.cs || config.$7) ? $elm$core$Maybe$Nothing : A2($elm$core$Maybe$map, $rtfeldman$elm_css$Html$Styled$Attributes$tabindex, config.eq)
			]));
	var idValue = function () {
		var _v2 = config.dE;
		if (!_v2.$) {
			var id_ = _v2.a;
			return id_;
		} else {
			return $author$project$Component$Form$TextInput$generateId(config.bO);
		}
	}();
	var inputAttributes = _List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$Attributes$class('form-input'),
			$rtfeldman$elm_css$Html$Styled$Attributes$classList(
			_List_fromArray(
				[
					_Utils_Tuple2('as-text', config.avz),
					_Utils_Tuple2('as-h2', config.cM)
				])),
			$rtfeldman$elm_css$Html$Styled$Attributes$type_(
			$author$project$Component$Form$TextInput$inputType(config.ew)),
			$rtfeldman$elm_css$Html$Styled$Attributes$disabled(config.$7),
			$rtfeldman$elm_css$Html$Styled$Attributes$placeholder(placeholder_),
			$rtfeldman$elm_css$Html$Styled$Attributes$value(config.ey),
			$rtfeldman$elm_css$Html$Styled$Attributes$id(idValue),
			$rtfeldman$elm_css$Html$Styled$Attributes$required(config.eb)
		]);
	var labelAttrs = _List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$Attributes$classList(
			_List_fromArray(
				[
					_Utils_Tuple2('label', true),
					_Utils_Tuple2('visually-hidden', config.dC)
				])),
			$rtfeldman$elm_css$Html$Styled$Attributes$for(idValue)
		]);
	var attrList = _Utils_ap(
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('form-field', true),
						_Utils_Tuple2(
						'error',
						$elm_community$maybe_extra$Maybe$Extra$isJust(config.bI)),
						_Utils_Tuple2(
						'with-icon',
						$elm_community$maybe_extra$Maybe$Extra$isJust(config.bb) || $elm_community$maybe_extra$Maybe$Extra$isJust(config.cz)),
						_Utils_Tuple2('inline', config.dI),
						_Utils_Tuple2('warning', config.eA),
						_Utils_Tuple2('active', config.cY),
						_Utils_Tuple2('hidden', config.cs)
					])),
				$rtfeldman$elm_css$Html$Styled$Attributes$css(config.cj)
			]),
		maybeClass);
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		attrList,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$fromUnstyled(
				A2(
					$author$project$Util$View$viewIfNot,
					$elm$core$String$isEmpty(config.bO),
					function (_v1) {
						return $rtfeldman$elm_css$Html$Styled$toUnstyled(
							A2(
								$rtfeldman$elm_css$Html$Styled$label,
								labelAttrs,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(config.bO)
									])));
					})),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('form-field-wrapper', true),
								_Utils_Tuple2('as-text', config.avz),
								_Utils_Tuple2('as-h2', config.cM)
							]))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$fromUnstyled(
						A2($author$project$Util$View$viewMaybe, config.co, $elm$core$Basics$identity)),
						config.avz ? A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_Utils_ap(
							inputAttributes,
							_Utils_ap(maybeAttributes, config.cv)),
						A2(
							$elm$core$List$map,
							$rtfeldman$elm_css$Html$Styled$fromUnstyled,
							$author$project$Util$Html$parse(config.ey))) : A2(
						$rtfeldman$elm_css$Html$Styled$input,
						_Utils_ap(
							inputAttributes,
							_Utils_ap(maybeAttributes, config.cv)),
						_List_Nil),
						$rtfeldman$elm_css$Html$Styled$fromUnstyled(
						A2(
							$author$project$Util$View$viewMaybe,
							config.cz,
							$author$project$View$Icon$viewMasked(4))),
						$rtfeldman$elm_css$Html$Styled$fromUnstyled(
						A2($author$project$Util$View$viewMaybe, config.bb, $author$project$View$Icon$viewColored)),
						$rtfeldman$elm_css$Html$Styled$fromUnstyled(
						A2($author$project$Util$View$viewMaybe, config.dy, $elm$core$Basics$identity))
					])),
				$rtfeldman$elm_css$Html$Styled$fromUnstyled(
				A2($author$project$Util$View$viewMaybe, config.bI, $elm$core$Basics$identity))
			]));
};
var $author$project$Component$Form$TextInput$view = F2(
	function (label_, attributes) {
		return $rtfeldman$elm_css$Html$Styled$toUnstyled(
			$author$project$Component$Form$TextInput$viewTextInput(
				A3(
					$elm$core$List$foldl,
					function (_v0) {
						var attribute = _v0;
						return attribute;
					},
					$author$project$Component$Form$TextInput$build,
					A2(
						$elm$core$List$cons,
						$author$project$Component$Form$TextInput$label(label_),
						attributes))));
	});
var $author$project$Component$Form$RadioInput$Attribute = $elm$core$Basics$identity;
var $author$project$Component$Form$RadioInput$RadioInput = $elm$core$Basics$identity;
var $author$project$Component$Form$RadioInput$set = function (_with) {
	return function (_v0) {
		var config = _v0;
		return _with(config);
	};
};
var $author$project$Component$Form$RadioInput$error = function (error_) {
	return $author$project$Component$Form$RadioInput$set(
		function (config) {
			return _Utils_update(
				config,
				{cn: error_});
		});
};
var $elm_community$list_extra$List$Extra$find = F2(
	function (predicate, list) {
		find:
		while (true) {
			if (!list.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var first = list.a;
				var rest = list.b;
				if (predicate(first)) {
					return $elm$core$Maybe$Just(first);
				} else {
					var $temp$predicate = predicate,
						$temp$list = rest;
					predicate = $temp$predicate;
					list = $temp$list;
					continue find;
				}
			}
		}
	});
var $author$project$ReferralToolForm$findOptionById = F2(
	function (allOptions, id) {
		return A2(
			$elm_community$list_extra$List$Extra$find,
			A2(
				$elm$core$Basics$composeL,
				$elm$core$Basics$eq(id),
				$author$project$Data$Entity$id),
			allOptions);
	});
var $author$project$ReferralToolForm$maybeSelectedOption = F2(
	function (allOptions, form) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$filterMap,
				$author$project$ReferralToolForm$findOptionById(allOptions),
				form.awg));
	});
var $author$project$Component$Form$RadioInput$onSelect = function (onSelect_) {
	return $author$project$Component$Form$RadioInput$set(
		function (config) {
			return _Utils_update(
				config,
				{
					fr: $elm$core$Maybe$Just(onSelect_)
				});
		});
};
var $author$project$Data$VacancyFilterOptionValue$toHours = F2(
	function (langCode, _v0) {
		var minHours = _v0.Te;
		var maxHours = _v0.Sy;
		var toTranslation = ((maxHours === 1) || (langCode === 16)) ? 'uur' : 'uren';
		return _Utils_eq(minHours, maxHours) ? ($elm$core$String$fromInt(minHours) + 'uur') : A2(
			$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
			'{0} - {1} {2}',
			_List_fromArray(
				[
					$elm$core$String$fromInt(minHours),
					$elm$core$String$fromInt(maxHours),
					toTranslation
				]));
	});
var $author$project$Data$VacancyFilterOptionValue$toSalary = function (_v0) {
	var minSalary = _v0.Th;
	var maxSalary = _v0.SC;
	return A2(
		$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
		'€{0} - €{1}',
		_List_fromArray(
			[
				$elm$core$String$fromInt(minSalary),
				$elm$core$String$fromInt(maxSalary)
			]));
};
var $author$project$Data$VacancyFilterOptionValue$toText = F2(
	function (langCode, value) {
		switch (value.$) {
			case 0:
				var hourRange = value.a;
				return A2($author$project$Data$VacancyFilterOptionValue$toHours, langCode, hourRange);
			case 2:
				var text = value.a;
				return text;
			default:
				var salaryRange = value.a;
				return $author$project$Data$VacancyFilterOptionValue$toSalary(salaryRange);
		}
	});
var $author$project$Component$Form$RadioInput$build = function (_v0) {
	var label = _v0.bO;
	var name = _v0.dY;
	var options = _v0.au7;
	var toValue = _v0.av$;
	var toLabel = _v0.cO;
	var selectedValue = _v0.cL;
	return {$7: false, cn: $elm$core$Maybe$Nothing, dC: false, bO: label, dY: name, fr: $elm$core$Maybe$Nothing, au7: options, cL: selectedValue, eq: $elm$core$Maybe$Nothing, fT: $elm$core$Maybe$Nothing, cO: toLabel, av$: toValue};
};
var $author$project$Component$Form$RadioInput$toFocusableOption = function (config) {
	var _v0 = config.cL;
	if (!_v0.$) {
		var selected = _v0.a;
		return $elm$core$Maybe$Just(selected);
	} else {
		return $elm$core$List$head(config.au7);
	}
};
var $author$project$Component$Form$RadioInput$generateId = function (labelText) {
	return A2(
		$elm$core$String$join,
		'-',
		$elm$core$String$words(labelText));
};
var $author$project$Component$Form$RadioInput$viewRadioButton = F3(
	function (config, focusableOption, radioOption) {
		var onClick_ = function () {
			var _v1 = _Utils_Tuple2(config.fr, config.$7);
			if ((!_v1.a.$) && (!_v1.b)) {
				var onSelect_ = _v1.a.a;
				return _List_fromArray(
					[
						$elm$html$Html$Events$onClick(
						onSelect_(radioOption))
					]);
			} else {
				return _List_Nil;
			}
		}();
		var idValue = function () {
			var _v0 = config.fT;
			if (!_v0.$) {
				var toId_ = _v0.a;
				return toId_(radioOption);
			} else {
				return $author$project$Component$Form$RadioInput$generateId(
					config.cO(radioOption));
			}
		}();
		return A2(
			$elm$html$Html$label,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('radio-button-container'),
					$elm$html$Html$Attributes$for(idValue)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$input,
					_Utils_ap(
						_List_fromArray(
							[
								$elm$html$Html$Attributes$type_('radio'),
								$elm$html$Html$Attributes$class('radio-button'),
								$elm$html$Html$Attributes$value(
								config.av$(radioOption)),
								$elm$html$Html$Attributes$id(idValue),
								$elm$html$Html$Attributes$checked(
								_Utils_eq(
									$elm$core$Maybe$Just(radioOption),
									config.cL)),
								$elm$html$Html$Attributes$disabled(config.$7),
								$elm$html$Html$Attributes$name(config.dY)
							]),
						_Utils_ap(
							$author$project$Util$Tabindex$fieldTabIndexUnstyled(
								A2(
									$elm$core$Maybe$map,
									function (index) {
										return _Utils_eq(
											focusableOption,
											$elm$core$Maybe$Just(radioOption)) ? index : (-1);
									},
									config.eq)),
							onClick_)),
					_List_Nil),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('radio-button-label')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							config.cO(radioOption))
						]))
				]));
	});
var $author$project$Component$Form$RadioInput$viewRadioInput = function (_v0) {
	var config = _v0;
	var labelClassList = _List_fromArray(
		[
			_Utils_Tuple2('label', true),
			_Utils_Tuple2('visually-hidden', config.dC)
		]);
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('form-field', true),
						_Utils_Tuple2(
						'error',
						$elm_community$maybe_extra$Maybe$Extra$isJust(config.cn))
					]))
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$label,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$classList(labelClassList)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(config.bO)
					])),
				A2(
				$elm$html$Html$ul,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('radio-input-container')
					]),
				A2(
					$elm$core$List$map,
					A2(
						$author$project$Component$Form$RadioInput$viewRadioButton,
						config,
						$author$project$Component$Form$RadioInput$toFocusableOption(config)),
					config.au7)),
				A2(
				$author$project$Util$View$viewMaybe,
				config.cn,
				function (error_) {
					return A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('error-message')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(error_)
							]));
				})
			]));
};
var $author$project$Component$Form$RadioInput$view = F2(
	function (requiredConfig, config) {
		return $author$project$Component$Form$RadioInput$viewRadioInput(
			A3(
				$elm$core$List$foldl,
				function (_v0) {
					var attribute = _v0;
					return attribute;
				},
				$author$project$Component$Form$RadioInput$build(requiredConfig),
				config));
	});
var $author$project$ReferralToolForm$viewFilterRadioInput = F5(
	function (langCode, toMsg, toError, form, filterWithOptions) {
		var filterOptions = filterWithOptions.au7;
		var replaceSelected = function (optionId_) {
			var _v2 = A2($author$project$ReferralToolForm$maybeSelectedOption, filterOptions, form);
			if (!_v2.$) {
				var _v3 = _v2.a;
				var selectedOptionId = _v3.a;
				return A2(
					$elm$core$List$cons,
					optionId_,
					A2(
						$elm$core$List$filter,
						$elm$core$Basics$neq(selectedOptionId),
						form.awg));
			} else {
				return A2($elm$core$List$cons, optionId_, form.awg);
			}
		};
		var onSelectMsg = function (_v1) {
			var optionId_ = _v1.a;
			return _Utils_update(
				form,
				{
					awg: replaceSelected(optionId_)
				});
		};
		var _v0 = filterWithOptions.HS;
		var filterId = _v0.a;
		var filter = _v0.b;
		var radioInputConfig = {
			bO: filter.bO,
			dY: $author$project$Data$Id$toString(filterId),
			au7: filterOptions,
			cL: A2($author$project$ReferralToolForm$maybeSelectedOption, filterOptions, form),
			cO: A2(
				$elm$core$Basics$composeL,
				A2(
					$elm$core$Basics$composeL,
					$author$project$Data$VacancyFilterOptionValue$toText(langCode),
					function ($) {
						return $.ey;
					}),
				$author$project$Data$Entity$value),
			av$: A2($elm$core$Basics$composeL, $author$project$Data$Id$toString, $author$project$Data$Entity$id)
		};
		return A2(
			$author$project$Component$Form$RadioInput$view,
			radioInputConfig,
			_List_fromArray(
				[
					$author$project$Component$Form$RadioInput$error(
					toError('vacancyFilterOptionIds')),
					$author$project$Component$Form$RadioInput$onSelect(
					A2($elm$core$Basics$composeL, toMsg, onSelectMsg))
				]));
	});
var $author$project$ReferralToolForm$viewFiltersWithOptions = F5(
	function (langCode, toMsg, toError, form, filters) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('referral-form-filters-container')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('referral-form-filters')
						]),
					A2(
						$elm$core$List$map,
						A4($author$project$ReferralToolForm$viewFilterRadioInput, langCode, toMsg, toError, form),
						filters))
				]));
	});
var $author$project$ReferralToolForm$FocusFilterAndResetFilterOptions = function (a) {
	return {$: 2, a: a};
};
var $author$project$Component$Button$ButtonTypeButton = 0;
var $author$project$Component$Button$buttonTypeButton = $author$project$Component$Button$set(
	function (attributes) {
		return _Utils_update(
			attributes,
			{bB: 0});
	});
var $author$project$Component$Button$WidthFillContainer = 0;
var $author$project$Component$Button$fillContainerWidth = $author$project$Component$Button$set(
	function (attributes) {
		return _Utils_update(
			attributes,
			{cb: 0});
	});
var $author$project$Component$Button$Secondary = 1;
var $author$project$Component$Button$secondary = $author$project$Component$Button$set(
	function (attribute) {
		return _Utils_update(
			attribute,
			{ao: 1});
	});
var $author$project$ReferralToolForm$viewNestedFilterOptionButton = F3(
	function (langCode, maybeInitialOption, args) {
		var _v0 = args.NZ;
		var initialOptionId = _v0.a;
		var initialOption = _v0.b;
		var isSelected_ = _Utils_eq(
			maybeInitialOption,
			$elm$core$Maybe$Just(initialOptionId));
		var buttonStyle = isSelected_ ? $author$project$Component$Button$primary : $author$project$Component$Button$secondary;
		return A2(
			$author$project$Component$Button$view,
			A2($author$project$Data$VacancyFilterOptionValue$toText, langCode, initialOption.ey),
			_List_fromArray(
				[
					$author$project$Component$Button$fillContainerWidth,
					$author$project$Component$Button$buttonTypeButton,
					$author$project$Component$Button$onClick(
					$author$project$ReferralToolForm$FocusFilterAndResetFilterOptions(
						$elm$core$Maybe$Just(initialOptionId))),
					buttonStyle
				]));
	});
var $author$project$ReferralToolForm$viewNoPreferencesButton = function (maybeOptionId) {
	var buttonStyle = $elm_community$maybe_extra$Maybe$Extra$isNothing(maybeOptionId) ? $author$project$Component$Button$primary : $author$project$Component$Button$secondary;
	return A2(
		$author$project$Component$Button$view,
		$author$project$Copy$copy.Wn,
		_List_fromArray(
			[
				$author$project$Component$Button$onClick(
				$author$project$ReferralToolForm$FocusFilterAndResetFilterOptions($elm$core$Maybe$Nothing)),
				$author$project$Component$Button$buttonTypeButton,
				buttonStyle
			]));
};
var $author$project$ReferralToolForm$viewFilterOptionSelect = F6(
	function (langCode, toMsg, toError, form, referralFormResponse, maybeInitialOption) {
		if (!referralFormResponse.$) {
			var filtersWithOptions = referralFormResponse.a;
			return A5($author$project$ReferralToolForm$viewFiltersWithOptions, langCode, toMsg, toError, form, filtersWithOptions);
		} else {
			var argsList = referralFormResponse.a;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('referral-form-tabs-container')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('referral-form-tabs')
							]),
						_Utils_ap(
							A2(
								$elm$core$List$map,
								A2($author$project$ReferralToolForm$viewNestedFilterOptionButton, langCode, maybeInitialOption),
								argsList),
							_List_fromArray(
								[
									$author$project$ReferralToolForm$viewNoPreferencesButton(maybeInitialOption)
								]))),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Util$View$viewMaybe,
								A2($author$project$ReferralToolForm$maybeArgs, maybeInitialOption, argsList),
								function (args) {
									return A5($author$project$ReferralToolForm$viewFiltersWithOptions, langCode, toMsg, toError, form, args.If);
								})
							]))
					]));
		}
	});
var $author$project$Model$Translation$referralFormUploadLabel = 'referral-form-upload-label';
var $author$project$ReferralToolForm$SelectFile = {$: 7};
var $author$project$ReferralToolForm$viewBrowseMediaButton = function (translations) {
	return A2(
		$elm$html$Html$button,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$type_('button'),
				$elm$html$Html$Attributes$class('btn btn-submit bg-color-2 color-white'),
				$elm$html$Html$Events$onClick($author$project$ReferralToolForm$SelectFile)
			]),
		_List_fromArray(
			[
				A2($author$project$Data$Translation$text, translations, $author$project$Model$Translation$browseMedia)
			]));
};
var $author$project$ReferralToolForm$mediaItemAccepted = function (_v0) {
	var file = _v0.HC;
	var preview = _v0.$V;
	return _Utils_cmp(
		$elm$file$File$size(file),
		preview.cA.a) < 1;
};
var $author$project$ReferralToolForm$viewPreview = F3(
	function (translations, msg, mediaItem) {
		var file = mediaItem.HC;
		var preview = mediaItem.$V;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('share-tool-form__preview')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('img-container'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'error',
									!$author$project$ReferralToolForm$mediaItemAccepted(mediaItem))
								]))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$src(preview.dF)
								]),
							_List_Nil),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('img-container__banner bg-color-2 color-white')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$elm$file$File$name(file))
										])),
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$type_('button'),
											$elm$html$Html$Attributes$class('btn color-white'),
											$elm$html$Html$Events$onClick(msg)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('＋')
										]))
								]))
						])),
					A2(
					$author$project$Util$View$viewIf,
					!$author$project$ReferralToolForm$mediaItemAccepted(mediaItem),
					function (_v0) {
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('error-overlay'),
									$elm$html$Html$Events$onClick(msg)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Util$Translation$translate(
												$author$project$Util$Translation$FileTooBig(preview.cA.b)))
										])),
									$author$project$View$Icon$viewColored($author$project$View$Icon$path.au_),
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											A2($author$project$Data$Translation$text, translations, $author$project$Model$Translation$clickToRemove)
										]))
								]));
					})
				]));
	});
var $author$project$ReferralToolForm$viewPreviews = F4(
	function (translations, form, toMsg, preview) {
		return (_Utils_cmp(
			$elm$file$File$size(preview.HC),
			$author$project$ReferralToolForm$maxImageSize.a) > -1) ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('share-tool__request-too-big')
				]),
			_List_fromArray(
				[
					$author$project$Component$Message$view(
					{
						dn: A2($author$project$Data$Translation$toString, translations, $author$project$Model$Translation$maxRequestSizeExceededDescription),
						e_: $elm$core$Maybe$Just(
							A2(
								$author$project$Component$Button$view,
								A2($author$project$Data$Translation$toString, translations, $author$project$Model$Translation$browseMedia),
								_List_fromArray(
									[$author$project$Component$Button$secondary]))),
						avV: A2($author$project$Data$Translation$toString, translations, $author$project$Model$Translation$maxRequestSizeExceededTitle)
					})
				])) : A3(
			$author$project$ReferralToolForm$viewPreview,
			translations,
			toMsg(
				_Utils_update(
					form,
					{Nw: $elm$core$Maybe$Nothing})),
			preview);
	});
var $author$project$ReferralToolForm$viewMediaUploads = F4(
	function (translations, form, toMsg, toError) {
		return A3(
			$author$project$Component$Form$Input$viewFormField,
			A2($author$project$Data$Translation$toString, translations, $author$project$Model$Translation$referralFormUploadLabel),
			toError('media'),
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('form-row')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Util$View$viewMaybe,
						form.Nw,
						A3($author$project$ReferralToolForm$viewPreviews, translations, form, toMsg)),
						$author$project$ReferralToolForm$viewBrowseMediaButton(translations)
					])));
	});
var $author$project$ReferralToolForm$view = function (model) {
	var translate = $author$project$Data$Translation$toString(model.anB);
	var _v0 = model.R;
	var form = _v0.a;
	var errorResponse = _v0.b;
	var toError = function (key) {
		if (!errorResponse.$) {
			var validationErrors = errorResponse.a;
			return A2(
				$elm$core$Maybe$andThen,
				$elm$core$Dict$get(
					$author$project$Util$LangCode$toString(model.bE)),
				A2($elm$core$Dict$get, key, validationErrors.atU));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	};
	var toMsg = function (f) {
		return $author$project$ReferralToolForm$UpdateReferralForm(
			_Utils_Tuple2(f, errorResponse));
	};
	var focussedDomains = A2(
		$author$project$Data$Domains$refocus,
		model.bG,
		{
			auF: $elm$core$Maybe$Just(form.atF),
			avK: $elm$core$Maybe$Nothing,
			awa: $elm$core$Basics$always($elm$core$Maybe$Nothing),
			awb: $elm$core$Maybe$Nothing
		}).a;
	return A2(
		$elm$html$Html$form,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('referral-form form'),
				$elm$html$Html$Events$onSubmit($author$project$ReferralToolForm$CreateReferral)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Util$View$viewIf,
				$author$project$Data$Domains$hasMultipleDomains(model.bG),
				function (_v1) {
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('form-row form-field domain-select')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('label')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										translate($author$project$Model$Translation$referralFormReferSomeoneLabel))
									])),
								A4(
								$author$project$Component$DomainSelect$view,
								A2(
									$elm$core$Basics$composeL,
									toMsg,
									function (v) {
										return _Utils_update(
											form,
											{atF: v});
									}),
								$elm$core$Maybe$Nothing,
								_List_Nil,
								focussedDomains)
							]));
				}),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('form-row')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Component$Form$TextInput$view,
						translate($author$project$Model$Translation$referralFormFirstNameLabel),
						_List_fromArray(
							[
								$author$project$Component$Form$TextInput$error(
								toError('firstName')),
								$author$project$Component$Form$TextInput$icon($author$project$View$Icon$path.au9),
								$author$project$Component$Form$TextInput$hiddenLabel(true),
								$author$project$Component$Form$TextInput$onInput(
								A2(
									$elm$core$Basics$composeL,
									toMsg,
									function (v) {
										return _Utils_update(
											form,
											{Ip: v});
									})),
								$author$project$Component$Form$TextInput$placeholder(
								translate($author$project$Model$Translation$referralFormFirstNamePlaceholder)),
								$author$project$Component$Form$TextInput$value(form.Ip)
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('form-row')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Component$Form$TextInput$view,
						translate($author$project$Model$Translation$referralFormLastNameLabel),
						_List_fromArray(
							[
								$author$project$Component$Form$TextInput$error(
								toError('lastName')),
								$author$project$Component$Form$TextInput$onInput(
								A2(
									$elm$core$Basics$composeL,
									toMsg,
									function (v) {
										return _Utils_update(
											form,
											{Qx: v});
									})),
								$author$project$Component$Form$TextInput$icon($author$project$View$Icon$path.au9),
								$author$project$Component$Form$TextInput$hiddenLabel(true),
								$author$project$Component$Form$TextInput$placeholder(
								translate($author$project$Model$Translation$referralFormLastNamePlaceholder)),
								$author$project$Component$Form$TextInput$value(form.Qx)
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('form-row')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Component$Form$TextInput$view,
						translate($author$project$Model$Translation$referralFormEmailLabel),
						_List_fromArray(
							[
								$author$project$Component$Form$TextInput$error(
								toError('email')),
								$author$project$Component$Form$TextInput$class('email-address'),
								$author$project$Component$Form$TextInput$icon($author$project$View$Icon$path.eR),
								$author$project$Component$Form$TextInput$hiddenLabel(true),
								$author$project$Component$Form$TextInput$onInput(
								A2(
									$elm$core$Basics$composeL,
									toMsg,
									function (v) {
										return _Utils_update(
											form,
											{eR: v});
									})),
								$author$project$Component$Form$TextInput$placeholder(
								translate($author$project$Model$Translation$referralFormEmailPlaceholder)),
								$author$project$Component$Form$TextInput$value(form.eR)
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('form-row')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Component$Form$TextInput$view,
						translate($author$project$Model$Translation$phoneNumberLabel),
						_List_fromArray(
							[
								$author$project$Component$Form$TextInput$error(
								toError('phone')),
								$author$project$Component$Form$TextInput$class('phone-number'),
								$author$project$Component$Form$TextInput$icon($author$project$View$Icon$path.aR),
								$author$project$Component$Form$TextInput$hiddenLabel(true),
								$author$project$Component$Form$TextInput$onInput(
								A2(
									$elm$core$Basics$composeL,
									toMsg,
									function (v) {
										return _Utils_update(
											form,
											{aR: v});
									})),
								$author$project$Component$Form$TextInput$placeholder(
								translate($author$project$Model$Translation$referralFormPhoneNumber)),
								$author$project$Component$Form$TextInput$value(form.aR)
							]))
					])),
				A2(
				$author$project$Util$View$viewIfNot,
				!A2($author$project$ReferralToolForm$toFilterOptionCount, model.NZ, model.cJ),
				function (_v2) {
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('form-row')
							]),
						_List_fromArray(
							[
								A3(
								$author$project$Component$Form$Input$viewFormField,
								translate($author$project$Model$Translation$referralFormMatchingMetadata),
								toError('vacancyFilterOptionIds'),
								A6($author$project$ReferralToolForm$viewFilterOptionSelect, model.bE, toMsg, toError, form, model.cJ, model.NZ))
							]));
				}),
				A2(
				$author$project$Util$View$viewIf,
				A2($author$project$ReferralToolForm$toAskLocation, model.NZ, model.cJ),
				function (_v3) {
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('form-row')
							]),
						_List_fromArray(
							[
								A2(
								$author$project$View$LocationSuggestions$view,
								$author$project$ReferralToolForm$locationSuggestionsConfig(model),
								model.az)
							]));
				}),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('form-row')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Component$Form$TextArea$view,
						translate($author$project$Model$Translation$personalMessage),
						_List_fromArray(
							[
								$author$project$Component$Form$TextArea$error(
								toError('personalMessage')),
								$author$project$Component$Form$TextArea$onInput(
								A2(
									$elm$core$Basics$composeL,
									toMsg,
									function (v) {
										return _Utils_update(
											form,
											{_I: v});
									})),
								$author$project$Component$Form$TextArea$hiddenLabel(true),
								$author$project$Component$Form$TextArea$placeholder(
								translate($author$project$Model$Translation$personalMessage)),
								$author$project$Component$Form$TextArea$value(form._I),
								$author$project$Component$Form$TextArea$rows(5)
							]))
					])),
				A4($author$project$ReferralToolForm$viewMediaUploads, model.anB, form, toMsg, toError),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('form-row ')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('form-field')
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Component$Button$view,
								$author$project$Copy$copy.avI,
								_List_fromArray(
									[$author$project$Component$Button$primary]))
							]))
					]))
			]));
};
var $author$project$ReferralToolForm$main = A2(
	$author$project$Browser$Custom$elementWithFlags,
	$author$project$ReferralToolForm$decodeFlags,
	{dH: $author$project$ReferralToolForm$init, em: $author$project$ReferralToolForm$subscriptions, ex: $author$project$ReferralToolForm$update, ez: $author$project$ReferralToolForm$view});
var $author$project$ReferralToolEditForm$Flags = F7(
	function (translations, currentLangCode, domainId, sessionToken, csrfToken, referralEntity, referralFormResponse) {
		return {ci: csrfToken, bE: currentLangCode, dp: domainId, bl: referralEntity, cJ: referralFormResponse, aW: sessionToken, anB: translations};
	});
var $author$project$Model$Referral$Referral = function (employeeId) {
	return function (firstName) {
		return function (lastName) {
			return function (email) {
				return function (location) {
					return function (latLong) {
						return function (personalMessage) {
							return function (personalImage) {
								return function (phone) {
									return function (langCode) {
										return function (vacancyFilterOptionIds) {
											return function (uuid) {
												return function (actions) {
													return function (allowed) {
														return function (inserted) {
															return function (updated) {
																return {gk: actions, jj: allowed, eR: email, FQ: employeeId, Ip: firstName, e6: inserted, Ql: langCode, Qx: lastName, QC: latLong, Rs: location, _G: personalImage, _I: personalMessage, aR: phone, fY: updated, ap5: uuid, awg: vacancyFilterOptionIds};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Model$ReferralAction$ReferralAction = F2(
	function (inserted, actionType) {
		return {gg: actionType, e6: inserted};
	});
var $author$project$Model$ReferralAction$ApplicationSend = function (a) {
	return {$: 0, a: a};
};
var $author$project$Model$ReferralAction$JobAlert = {$: 3};
var $author$project$Model$ReferralAction$OpenApplicationSend = {$: 1};
var $author$project$Model$ReferralAction$PersonalPageVisited = {$: 2};
var $author$project$Model$ReferralAction$referralActionTypeDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'application-send':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Data$Id$decoder,
					$elm$json$Json$Decode$succeed($author$project$Model$ReferralAction$ApplicationSend));
			case 'open-application-send':
				return $elm$json$Json$Decode$succeed($author$project$Model$ReferralAction$OpenApplicationSend);
			case 'personal-page-visited':
				return $elm$json$Json$Decode$succeed($author$project$Model$ReferralAction$PersonalPageVisited);
			case 'job-alert':
				return $elm$json$Json$Decode$succeed($author$project$Model$ReferralAction$JobAlert);
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	A2($elm$json$Json$Decode$field, 'tag', $elm$json$Json$Decode$string));
var $author$project$Model$ReferralAction$referralActionDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'actionType',
	$author$project$Model$ReferralAction$referralActionTypeDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'inserted',
		$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
		$elm$json$Json$Decode$succeed($author$project$Model$ReferralAction$ReferralAction)));
var $author$project$Model$ReferralLocation$ReferralLocation = F2(
	function (latitude, longitude) {
		return {QE: latitude, RZ: longitude};
	});
var $author$project$Model$ReferralLocation$referralLocationDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'longitude',
	$elm$json$Json$Decode$float,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'latitude',
		$elm$json$Json$Decode$float,
		$elm$json$Json$Decode$succeed($author$project$Model$ReferralLocation$ReferralLocation)));
var $author$project$Model$Referral$referralDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'referralUpdated',
	$elm$json$Json$Decode$nullable($rtfeldman$elm_iso8601_date_strings$Iso8601$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'referralInserted',
		$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'referralAllowed',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'referralActions',
				$elm$json$Json$Decode$list($author$project$Model$ReferralAction$referralActionDecoder),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'referralUuid',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'referralVacancyFilterOptionIds',
						$elm$json$Json$Decode$list($author$project$Data$Id$decoder),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'referralLangCode',
							$author$project$Model$LangCode$decoder,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'referralPhone',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'referralPersonalImage',
									$elm$json$Json$Decode$nullable($author$project$Model$ImageSource$imageSourceDecoder),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'referralPersonalMessage',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'referralLatLong',
											$elm$json$Json$Decode$nullable($author$project$Model$ReferralLocation$referralLocationDecoder),
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'referralLocation',
												$elm$json$Json$Decode$string,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'referralEmail',
													$elm$json$Json$Decode$string,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'referralLastName',
														$elm$json$Json$Decode$string,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'referralFirstName',
															$elm$json$Json$Decode$string,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'referralEmployeeId',
																$author$project$Data$Id$decoder,
																$elm$json$Json$Decode$succeed($author$project$Model$Referral$Referral)))))))))))))))));
var $author$project$ReferralToolEditForm$decodeFlags = A8(
	$elm$json$Json$Decode$map7,
	$author$project$ReferralToolEditForm$Flags,
	$author$project$Data$Translation$translationsDecoder,
	A2($elm$json$Json$Decode$field, 'currentLangCode', $author$project$Model$LangCode$decoder),
	A2($elm$json$Json$Decode$field, 'domainId', $author$project$Data$Id$decoder),
	A2($elm$json$Json$Decode$field, 'sessionToken', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'csrfToken', $elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$field,
		'referralEntity',
		$author$project$Data$Entity$decoder($author$project$Model$Referral$referralDecoder)),
	A2($elm$json$Json$Decode$field, 'referralFormResponse', $author$project$Model$ReferralFormResponse$referralFormResponseDecoder));
var $author$project$ReferralToolEditForm$initForm = function (_v0) {
	var referral = _v0.b;
	return {sq: false, Ip: referral.Ip, Nw: $elm$core$Maybe$Nothing, Qx: referral.Qx, QC: $elm$core$Maybe$Nothing, _I: referral._I, aR: referral.aR, awg: referral.awg};
};
var $author$project$ReferralToolEditForm$init = function (flags) {
	return _Utils_Tuple2(
		{
			ci: flags.ci,
			bE: flags.bE,
			dp: flags.dp,
			NZ: $elm$core$List$head(
				$author$project$Data$Entity$value(flags.bl).awg),
			az: $author$project$View$LocationSuggestions$init,
			bl: flags.bl,
			R: _Utils_Tuple2(
				$author$project$ReferralToolEditForm$initForm(flags.bl),
				$elm$core$Maybe$Nothing),
			cJ: flags.cJ,
			aW: $elm$core$Maybe$Just(flags.aW),
			cN: false,
			anB: flags.anB,
			cU: $elm$core$Maybe$Nothing
		},
		$elm$core$Platform$Cmd$none);
};
var $author$project$ReferralToolEditForm$GotProgress = function (a) {
	return {$: 3, a: a};
};
var $author$project$ReferralToolEditForm$LocationSuggestionsMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$ReferralToolEditForm$SetLocationSuggestion = function (a) {
	return {$: 10, a: a};
};
var $author$project$ReferralToolEditForm$locationSuggestionsConfig = function (model) {
	return {
		db: 'location-search-only',
		ci: model.ci,
		dp: model.dp,
		aul: $elm$core$Maybe$Nothing,
		aut: $author$project$ReferralToolEditForm$LocationSuggestionsMsg,
		avy: 1,
		aW: model.aW,
		avO: $author$project$View$Autocomplete$Http$Button(
			{avN: $author$project$ReferralToolEditForm$SetLocationSuggestion, av2: $elm$core$Maybe$Nothing}),
		avS: $elm$core$Maybe$Nothing,
		fX: 'location-suggestion'
	};
};
var $author$project$ReferralToolEditForm$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2($elm$http$Http$track, 'submit', $author$project$ReferralToolEditForm$GotProgress),
				A2(
				$author$project$View$LocationSuggestions$subscriptions,
				$author$project$ReferralToolEditForm$locationSuggestionsConfig(model),
				model.az)
			]));
};
var $author$project$ReferralToolEditForm$GotPatchReferral = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$ReferralToolEditForm$GotPreviews = function (a) {
	return {$: 5, a: a};
};
var $author$project$ReferralToolEditForm$SelectedFile = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Api$Endpoint$referral = function (referralId) {
	return $author$project$Api$Endpoint$endpoint(
		_List_fromArray(
			[
				'referrals',
				$author$project$Data$Id$toString(referralId)
			]));
};
var $author$project$ReferralToolEditForm$toMultiPartBody = function (form) {
	var toLatLongPart = A2(
		$elm$core$Basics$composeL,
		A2(
			$elm$core$Basics$composeL,
			A2(
				$elm$core$Basics$composeL,
				$elm$core$List$singleton,
				$elm$http$Http$stringPart('latLong')),
			$elm$json$Json$Encode$encode(0)),
		$author$project$Model$ReferralLocation$encodeReferralLocation);
	var toLocation = A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2($elm$core$Maybe$map, toLatLongPart, form.QC));
	var restOfBody = _List_fromArray(
		[
			A2($elm$http$Http$stringPart, 'firstName', form.Ip),
			A2($elm$http$Http$stringPart, 'lastName', form.Qx),
			A2($elm$http$Http$stringPart, 'phone', form.aR),
			A2($elm$http$Http$stringPart, 'personalMessage', form._I)
		]);
	var optionParts = A2(
		$elm$core$List$map,
		A2(
			$elm$core$Basics$composeL,
			$elm$http$Http$stringPart('optionIds'),
			$author$project$Data$Id$toString),
		form.awg);
	var filePart = A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			function (mediaItem) {
				return _List_fromArray(
					[
						A2($elm$http$Http$filePart, 'personalImage', mediaItem.HC)
					]);
			},
			form.Nw));
	var body = _Utils_ap(
		filePart,
		_Utils_ap(
			optionParts,
			_Utils_ap(restOfBody, toLocation)));
	return $elm$http$Http$multipartBody(body);
};
var $author$project$ReferralToolEditForm$maxImageSize = _Utils_Tuple2(10000000, '10MB');
var $author$project$ReferralToolEditForm$toPreview = function (base64) {
	var _v0 = $author$project$Data$MimeType$fromBase64(base64);
	if (!_v0.$) {
		return {eK: base64, dF: base64, cA: $author$project$ReferralToolEditForm$maxImageSize};
	} else {
		return {eK: base64, dF: '/static/images/image-placeholder.png', cA: $author$project$ReferralToolEditForm$maxImageSize};
	}
};
var $author$project$ReferralToolEditForm$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 1:
				var _v1 = model.R;
				var referralForm = _v1.a;
				return _Utils_Tuple2(
					model,
					$author$project$Api$Endpoint$request(
						{
							_: $author$project$ReferralToolEditForm$toMultiPartBody(referralForm),
							aH: A2(
								$author$project$Api$expectJson,
								$author$project$ReferralToolEditForm$GotPatchReferral(referralForm),
								$elm$json$Json$Decode$succeed(0)),
							ax: _List_Nil,
							aO: 'PATCH',
							a_: $elm$core$Maybe$Nothing,
							av3: $elm$core$Maybe$Just('submit'),
							a0: $author$project$Api$Endpoint$referral(
								$author$project$Data$Entity$id(model.bl))
						}));
			case 2:
				if (!msg.b.$) {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{cN: true}),
						$elm$core$Platform$Cmd$none);
				} else {
					if (!msg.b.a.$) {
						var form = msg.a;
						var error = msg.b.a.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									R: _Utils_Tuple2(
										form,
										$elm$core$Maybe$Just(error)),
									cU: $elm$core$Maybe$Nothing
								}),
							$elm$core$Platform$Cmd$none);
					} else {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{cU: $elm$core$Maybe$Nothing}),
							$elm$core$Platform$Cmd$none);
					}
				}
			case 3:
				if (msg.a.$ === 1) {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				} else {
					var progress = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								cU: $elm$core$Maybe$Just(
									$elm$http$Http$fractionSent(progress))
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 4:
				var form = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{R: form, cN: false}),
					$elm$core$Platform$Cmd$none);
			case 6:
				return _Utils_Tuple2(
					model,
					A2(
						$elm$file$File$Select$files,
						_List_fromArray(
							['image/*', 'gif/*']),
						$author$project$ReferralToolEditForm$SelectedFile));
			case 7:
				var file = msg.a;
				var files = msg.b;
				var fileToMediaItemToUpload = function (f) {
					return A2(
						$elm$core$Task$map,
						function (base64) {
							return {
								HC: f,
								$V: $author$project$ReferralToolEditForm$toPreview(base64)
							};
						},
						$elm$file$File$toUrl(f));
				};
				return _Utils_Tuple2(
					model,
					A2(
						$elm$core$Task$perform,
						$author$project$ReferralToolEditForm$GotPreviews,
						$elm$core$Task$sequence(
							A2(
								$elm$core$List$map,
								fileToMediaItemToUpload,
								A2($elm$core$List$cons, file, files)))));
			case 5:
				if (msg.a.b) {
					var _v2 = msg.a;
					var preview = _v2.a;
					var _v3 = model.R;
					var form = _v3.a;
					var errorResponse = _v3.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								R: _Utils_Tuple2(
									_Utils_update(
										form,
										{
											Nw: $elm$core$Maybe$Just(preview)
										}),
									errorResponse)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 8:
				var _v4 = model.R;
				var form = _v4.a;
				var error = _v4.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							R: _Utils_Tuple2(
								_Utils_update(
									form,
									{Nw: $elm$core$Maybe$Nothing}),
								error)
						}),
					$elm$core$Platform$Cmd$none);
			case 9:
				var locationSuggestionsMsg = msg.a;
				var _v5 = A3(
					$author$project$View$LocationSuggestions$update,
					$author$project$ReferralToolEditForm$locationSuggestionsConfig(model),
					locationSuggestionsMsg,
					model.az);
				var locationSuggestionsModel = _v5.a;
				var locationSuggestionsCmds = _v5.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{az: locationSuggestionsModel}),
					locationSuggestionsCmds);
			case 10:
				var location = msg.a;
				var toLatLong = function () {
					var _v7 = _Utils_Tuple2(location.QE, location.RZ);
					if ((!_v7.a.$) && (!_v7.b.$)) {
						var lat = _v7.a.a;
						var _long = _v7.b.a;
						return $elm$core$Maybe$Just(
							{QE: lat, RZ: _long});
					} else {
						return $elm$core$Maybe$Nothing;
					}
				}();
				var _v6 = model.R;
				var form = _v6.a;
				var errorResponse = _v6.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							az: $author$project$View$LocationSuggestions$resetWithValue(model.az),
							R: _Utils_Tuple2(
								_Utils_update(
									form,
									{QC: toLatLong}),
								errorResponse)
						}),
					$elm$core$Platform$Cmd$none);
			default:
				var maybeOptionId = msg.a;
				var _v8 = model.R;
				var form = _v8.a;
				var errorResponse = _v8.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							NZ: maybeOptionId,
							R: _Utils_Tuple2(
								_Utils_update(
									form,
									{awg: _List_Nil}),
								errorResponse)
						}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$ReferralToolEditForm$PatchReferral = {$: 1};
var $author$project$ReferralToolEditForm$UpdateReferralForm = function (a) {
	return {$: 4, a: a};
};
var $author$project$Model$Translation$referralToolChangeFilter = 'referral-tool-change-filter';
var $author$project$ReferralToolEditForm$isSelected = F2(
	function (maybeInitialOption, args) {
		return _Utils_eq(
			maybeInitialOption,
			$elm$core$Maybe$Just(
				$author$project$Data$Entity$id(args.NZ)));
	});
var $author$project$ReferralToolEditForm$maybeArgs = F2(
	function (maybeInitialOption, argsList) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				$author$project$ReferralToolEditForm$isSelected(maybeInitialOption),
				argsList));
	});
var $author$project$ReferralToolEditForm$findOptionById = F2(
	function (allOptions, id) {
		return A2(
			$elm_community$list_extra$List$Extra$find,
			A2(
				$elm$core$Basics$composeL,
				$elm$core$Basics$eq(id),
				$author$project$Data$Entity$id),
			allOptions);
	});
var $author$project$ReferralToolEditForm$maybeSelectedOption = F2(
	function (allOptions, form) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$filterMap,
				$author$project$ReferralToolEditForm$findOptionById(allOptions),
				form.awg));
	});
var $author$project$ReferralToolEditForm$viewFilterRadioInput = F5(
	function (langCode, toMsg, toError, form, filterWithOptions) {
		var filterOptions = filterWithOptions.au7;
		var replaceSelected = function (optionId_) {
			var _v2 = A2($author$project$ReferralToolEditForm$maybeSelectedOption, filterOptions, form);
			if (!_v2.$) {
				var _v3 = _v2.a;
				var selectedOptionId = _v3.a;
				return A2(
					$elm$core$List$cons,
					optionId_,
					A2(
						$elm$core$List$filter,
						$elm$core$Basics$neq(selectedOptionId),
						form.awg));
			} else {
				return A2($elm$core$List$cons, optionId_, form.awg);
			}
		};
		var onSelectMsg = function (_v1) {
			var optionId_ = _v1.a;
			return _Utils_update(
				form,
				{
					awg: replaceSelected(optionId_)
				});
		};
		var _v0 = filterWithOptions.HS;
		var filterId = _v0.a;
		var filter = _v0.b;
		var radioInputConfig = {
			bO: filter.bO,
			dY: $author$project$Data$Id$toString(filterId),
			au7: filterOptions,
			cL: A2($author$project$ReferralToolEditForm$maybeSelectedOption, filterOptions, form),
			cO: A2(
				$elm$core$Basics$composeL,
				A2(
					$elm$core$Basics$composeL,
					$author$project$Data$VacancyFilterOptionValue$toText(langCode),
					function ($) {
						return $.ey;
					}),
				$author$project$Data$Entity$value),
			av$: A2($elm$core$Basics$composeL, $author$project$Data$Id$toString, $author$project$Data$Entity$id)
		};
		return A2(
			$author$project$Component$Form$RadioInput$view,
			radioInputConfig,
			_List_fromArray(
				[
					$author$project$Component$Form$RadioInput$error(
					toError('vacancyFilterOptionIds')),
					$author$project$Component$Form$RadioInput$onSelect(
					A2($elm$core$Basics$composeL, toMsg, onSelectMsg))
				]));
	});
var $author$project$ReferralToolEditForm$viewFiltersWithOptions = F5(
	function (langCode, toMsg, toError, form, filters) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('referral-form-filters-container')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('referral-form-filters')
						]),
					A2(
						$elm$core$List$map,
						A4($author$project$ReferralToolEditForm$viewFilterRadioInput, langCode, toMsg, toError, form),
						filters))
				]));
	});
var $author$project$ReferralToolEditForm$FocusFilterAndResetFilterOptions = function (a) {
	return {$: 11, a: a};
};
var $author$project$ReferralToolEditForm$viewNestedFilterOptionButton = F3(
	function (langCode, maybeInitialOption, args) {
		var _v0 = args.NZ;
		var initialOptionId = _v0.a;
		var initialOption = _v0.b;
		var isSelected_ = _Utils_eq(
			maybeInitialOption,
			$elm$core$Maybe$Just(initialOptionId));
		var buttonStyle = isSelected_ ? $author$project$Component$Button$primary : $author$project$Component$Button$secondary;
		return A2(
			$author$project$Component$Button$view,
			A2($author$project$Data$VacancyFilterOptionValue$toText, langCode, initialOption.ey),
			_List_fromArray(
				[
					$author$project$Component$Button$fillContainerWidth,
					$author$project$Component$Button$buttonTypeButton,
					$author$project$Component$Button$onClick(
					$author$project$ReferralToolEditForm$FocusFilterAndResetFilterOptions(
						$elm$core$Maybe$Just(initialOptionId))),
					buttonStyle
				]));
	});
var $author$project$ReferralToolEditForm$viewNoPreferencesButton = function (maybeOptionId) {
	var buttonStyle = $elm_community$maybe_extra$Maybe$Extra$isNothing(maybeOptionId) ? $author$project$Component$Button$primary : $author$project$Component$Button$secondary;
	return A2(
		$author$project$Component$Button$view,
		$author$project$Copy$copy.Wn,
		_List_fromArray(
			[
				$author$project$Component$Button$onClick(
				$author$project$ReferralToolEditForm$FocusFilterAndResetFilterOptions($elm$core$Maybe$Nothing)),
				$author$project$Component$Button$buttonTypeButton,
				buttonStyle
			]));
};
var $author$project$ReferralToolEditForm$viewFilterOptionSelect = F6(
	function (langCode, toMsg, toError, form, referralFormResponse, maybeInitialOption) {
		if (!referralFormResponse.$) {
			var filtersWithOptions = referralFormResponse.a;
			return A5($author$project$ReferralToolEditForm$viewFiltersWithOptions, langCode, toMsg, toError, form, filtersWithOptions);
		} else {
			var argsList = referralFormResponse.a;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('referral-form-tabs-container')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('referral-form-tabs')
							]),
						_Utils_ap(
							A2(
								$elm$core$List$map,
								A2($author$project$ReferralToolEditForm$viewNestedFilterOptionButton, langCode, maybeInitialOption),
								argsList),
							_List_fromArray(
								[
									$author$project$ReferralToolEditForm$viewNoPreferencesButton(maybeInitialOption)
								]))),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Util$View$viewMaybe,
								A2($author$project$ReferralToolEditForm$maybeArgs, maybeInitialOption, argsList),
								function (args) {
									return A5($author$project$ReferralToolEditForm$viewFiltersWithOptions, langCode, toMsg, toError, form, args.If);
								})
							]))
					]));
		}
	});
var $author$project$ReferralToolEditForm$view = function (model) {
	var translate = $author$project$Data$Translation$toString(model.anB);
	var _v0 = model.R;
	var form = _v0.a;
	var errorResponse = _v0.b;
	var toError = function (key) {
		if (!errorResponse.$) {
			var validationErrors = errorResponse.a;
			return A2(
				$elm$core$Maybe$andThen,
				$elm$core$Dict$get(
					$author$project$Util$LangCode$toString(model.bE)),
				A2($elm$core$Dict$get, key, validationErrors.atU));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	};
	var toMsg = function (f) {
		return $author$project$ReferralToolEditForm$UpdateReferralForm(
			_Utils_Tuple2(f, errorResponse));
	};
	return A2(
		$elm$html$Html$form,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('referral-tool-edit-form'),
				$elm$html$Html$Events$onSubmit($author$project$ReferralToolEditForm$PatchReferral)
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('form-row')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Component$Form$TextInput$view,
						translate($author$project$Model$Translation$referralFormFirstNameLabel),
						_List_fromArray(
							[
								$author$project$Component$Form$TextInput$error(
								toError('firstName')),
								$author$project$Component$Form$TextInput$onInput(
								A2(
									$elm$core$Basics$composeL,
									toMsg,
									function (v) {
										return _Utils_update(
											form,
											{Ip: v});
									})),
								$author$project$Component$Form$TextInput$placeholder(
								translate($author$project$Model$Translation$referralFormFirstNamePlaceholder)),
								$author$project$Component$Form$TextInput$value(form.Ip)
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('form-row')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Component$Form$TextInput$view,
						translate($author$project$Model$Translation$referralFormLastNameLabel),
						_List_fromArray(
							[
								$author$project$Component$Form$TextInput$error(
								toError('lastName')),
								$author$project$Component$Form$TextInput$onInput(
								A2(
									$elm$core$Basics$composeL,
									toMsg,
									function (v) {
										return _Utils_update(
											form,
											{Qx: v});
									})),
								$author$project$Component$Form$TextInput$placeholder(
								translate($author$project$Model$Translation$referralFormLastNamePlaceholder)),
								$author$project$Component$Form$TextInput$value(form.Qx)
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('form-row')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Component$Form$TextInput$view,
						translate($author$project$Model$Translation$phoneNumberLabel),
						_List_fromArray(
							[
								$author$project$Component$Form$TextInput$error(
								toError('phone')),
								$author$project$Component$Form$TextInput$onInput(
								A2(
									$elm$core$Basics$composeL,
									toMsg,
									function (v) {
										return _Utils_update(
											form,
											{aR: v});
									})),
								$author$project$Component$Form$TextInput$placeholder(
								translate($author$project$Model$Translation$referralFormPhoneNumber)),
								$author$project$Component$Form$TextInput$value(form.aR)
							]))
					])),
				A2(
				$elm$html$Html$label,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						translate($author$project$Model$Translation$referralToolChangeFilter))
					])),
				A6($author$project$ReferralToolEditForm$viewFilterOptionSelect, model.bE, toMsg, toError, form, model.cJ, model.NZ),
				A2(
				$author$project$Util$View$viewIf,
				model.cN,
				function (_v1) {
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('form-row success')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text($author$project$Copy$copy.avJ)
									]))
							]));
				}),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('form-row ')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Component$Button$view,
						$author$project$Copy$copy.avI,
						_List_fromArray(
							[$author$project$Component$Button$primary]))
					]))
			]));
};
var $author$project$ReferralToolEditForm$main = A2(
	$author$project$Browser$Custom$elementWithFlags,
	$author$project$ReferralToolEditForm$decodeFlags,
	{dH: $author$project$ReferralToolEditForm$init, em: $author$project$ReferralToolEditForm$subscriptions, ex: $author$project$ReferralToolEditForm$update, ez: $author$project$ReferralToolEditForm$view});
var $author$project$RecruitmentChat$Flags = function (recruitmentChat) {
	return function (recruitmentChats) {
		return function (localStorageState) {
			return function (showRecruitmentChat) {
				return function (showChat) {
					return function (sessionToken) {
						return function (domainId) {
							return function (langCode) {
								return function (pathPrefix) {
									return function (today) {
										return function (windowWidth) {
											return function (currentNodesOnly) {
												return function (privacyPageUrl) {
													return function (uploads) {
														return function (weeksPerMonth) {
															return function (csrfToken) {
																return {ci: csrfToken, S: currentNodesOnly, dp: domainId, Ql: langCode, dP: localStorageState, ft: pathPrefix, aV: privacyPageUrl, aa4: recruitmentChat, cH: recruitmentChats, aW: sessionToken, aht: showChat, fE: showRecruitmentChat, fV: today, ape: uploads, a3: weeksPerMonth, cX: windowWidth};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$View$ChatBot$LocalStorageState = F6(
	function (nodeId, showFormOfVacancyId, showFormOfNodeId, salaryCalculatorInput, showOpenApplicationFormId, showOpenApplicationNodeId) {
		return {O: nodeId, at: salaryCalculatorInput, ahI: showFormOfNodeId, ahJ: showFormOfVacancyId, ah6: showOpenApplicationFormId, ah7: showOpenApplicationNodeId};
	});
var $author$project$Dict$Custom$Dict = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $author$project$Dict$Custom$empty = F2(
	function (f, g) {
		return A3($author$project$Dict$Custom$Dict, f, g, $elm$core$Dict$empty);
	});
var $author$project$Dict$Custom$insert = F3(
	function (k, v, _v0) {
		var f = _v0.a;
		var g = _v0.b;
		var dict = _v0.c;
		return A3(
			$author$project$Dict$Custom$Dict,
			f,
			g,
			A3(
				$elm$core$Dict$insert,
				f(k),
				v,
				dict));
	});
var $author$project$Dict$Custom$fromList = F3(
	function (f, g, list) {
		var ins = F2(
			function (_v0, acc) {
				var k = _v0.a;
				var v = _v0.b;
				return A3($author$project$Dict$Custom$insert, k, v, acc);
			});
		return A3(
			$elm$core$List$foldl,
			ins,
			A2($author$project$Dict$Custom$empty, f, g),
			list);
	});
var $author$project$Dict$Custom$fromListVia = function (_v0) {
	var f = _v0.a;
	var g = _v0.b;
	return A2($author$project$Dict$Custom$fromList, f, g);
};
var $author$project$Dict$Custom$decoderVia = F3(
	function (dict, f, g) {
		return A2(
			$elm$json$Json$Decode$map,
			$author$project$Dict$Custom$fromListVia(dict),
			$elm$json$Json$Decode$list(
				A3(
					$elm$json$Json$Decode$map2,
					$elm$core$Tuple$pair,
					A2($elm$json$Json$Decode$index, 0, f),
					A2($elm$json$Json$Decode$index, 1, g))));
	});
var $author$project$Data$ChatBot$NodeId = function (a) {
	return {$: 0, a: a};
};
var $danyx23$elm_uuid$Uuid$toString = function (_v0) {
	var internalString = _v0;
	return internalString;
};
var $author$project$Data$ChatBot$idToInt = function (nodeId) {
	switch (nodeId.$) {
		case 2:
			return 0;
		case 0:
			var id = nodeId.a;
			return id;
		default:
			var uuid = nodeId.a;
			return $elm$core$Basics$abs(
				$elm$core$List$sum(
					A2(
						$elm$core$List$map,
						$elm$core$Char$toCode,
						$elm$core$String$toList(
							$danyx23$elm_uuid$Uuid$toString(uuid)))));
	}
};
var $author$project$Data$ChatBot$emptyDict = A2($author$project$Dict$Custom$empty, $author$project$Data$ChatBot$idToInt, $author$project$Data$ChatBot$NodeId);
var $elm$json$Json$Decode$map6 = _Json_map6;
var $author$project$Data$ChatBot$UuidNodeId = function (a) {
	return {$: 1, a: a};
};
var $author$project$Data$ChatBot$uuidDecoder = function (str) {
	var _v0 = $danyx23$elm_uuid$Uuid$fromString(str);
	if (!_v0.$) {
		var uuid = _v0.a;
		return $elm$json$Json$Decode$succeed(uuid);
	} else {
		return $elm$json$Json$Decode$fail('Invalid UUID: ' + str);
	}
};
var $author$project$Data$ChatBot$nodeIdDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2($elm$json$Json$Decode$map, $author$project$Data$ChatBot$NodeId, $elm$json$Json$Decode$int),
			A2(
			$elm$json$Json$Decode$map,
			$author$project$Data$ChatBot$UuidNodeId,
			A2($elm$json$Json$Decode$andThen, $author$project$Data$ChatBot$uuidDecoder, $elm$json$Json$Decode$string))
		]));
var $author$project$View$ChatBot$localStorageStateDecoder = A7(
	$elm$json$Json$Decode$map6,
	$author$project$View$ChatBot$LocalStorageState,
	A2($elm$json$Json$Decode$field, 'nodeId', $author$project$Data$ChatBot$nodeIdDecoder),
	A2(
		$elm$json$Json$Decode$field,
		'showFormOfVacancyId',
		$elm$json$Json$Decode$nullable($author$project$Data$Id$decoder)),
	A2(
		$elm$json$Json$Decode$field,
		'showFormOfNodeId',
		$elm$json$Json$Decode$nullable($author$project$Data$ChatBot$nodeIdDecoder)),
	A2(
		$elm$json$Json$Decode$field,
		'salaryCalculatorInput',
		A3(
			$author$project$Dict$Custom$decoderVia,
			$author$project$Data$ChatBot$emptyDict,
			$author$project$Data$ChatBot$nodeIdDecoder,
			A3(
				$elm$json$Json$Decode$map2,
				F2(
					function (age, hours) {
						return {hj: age, MX: hours};
					}),
				A2($elm$json$Json$Decode$field, 'age', $elm$json$Json$Decode$int),
				A2($elm$json$Json$Decode$field, 'hours', $elm$json$Json$Decode$int)))),
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'showOpenApplicationFormId', $author$project$Data$Id$decoder)),
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'showOpenApplicationNodeId', $author$project$Data$ChatBot$nodeIdDecoder)));
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder = F3(
	function (pathDecoder, valDecoder, fallback) {
		var nullOr = function (decoder) {
			return $elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						decoder,
						$elm$json$Json$Decode$null(fallback)
					]));
		};
		var handleResult = function (input) {
			var _v0 = A2($elm$json$Json$Decode$decodeValue, pathDecoder, input);
			if (!_v0.$) {
				var rawValue = _v0.a;
				var _v1 = A2(
					$elm$json$Json$Decode$decodeValue,
					nullOr(valDecoder),
					rawValue);
				if (!_v1.$) {
					var finalResult = _v1.a;
					return $elm$json$Json$Decode$succeed(finalResult);
				} else {
					var finalErr = _v1.a;
					return $elm$json$Json$Decode$fail(
						$elm$json$Json$Decode$errorToString(finalErr));
				}
			} else {
				return $elm$json$Json$Decode$succeed(fallback);
			}
		};
		return A2($elm$json$Json$Decode$andThen, handleResult, $elm$json$Json$Decode$value);
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional = F4(
	function (key, valDecoder, fallback, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder,
				A2($elm$json$Json$Decode$field, key, $elm$json$Json$Decode$value),
				valDecoder,
				fallback),
			decoder);
	});
var $author$project$Model$RecruitmentChat$RecruitmentChat = F8(
	function (domainId, label, title, introduction, chatBot, botAvatar, inserted, updated) {
		return {o2: botAvatar, qj: chatBot, dp: domainId, e6: inserted, cw: introduction, bO: label, avV: title, fY: updated};
	});
var $author$project$Model$RecruitmentChat$ChatBot$ChatBot = $elm$core$Basics$identity;
var $elm$json$Json$Decode$lazy = function (thunk) {
	return A2(
		$elm$json$Json$Decode$andThen,
		thunk,
		$elm$json$Json$Decode$succeed(0));
};
var $zwilias$elm_rosetree$Tree$Tree = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $zwilias$elm_rosetree$Tree$tree = $zwilias$elm_rosetree$Tree$Tree;
var $author$project$Util$Tree$decoder = function (decode) {
	return A3(
		$elm$json$Json$Decode$map2,
		$zwilias$elm_rosetree$Tree$tree,
		A2($elm$json$Json$Decode$field, 'label', decode),
		A2(
			$elm$json$Json$Decode$field,
			'children',
			$elm$json$Json$Decode$list(
				$elm$json$Json$Decode$lazy(
					function (_v0) {
						return $author$project$Util$Tree$decoder(decode);
					}))));
};
var $author$project$Model$RecruitmentChat$ChatBot$EmbeddedChatBot = function (a) {
	return {$: 8, a: a};
};
var $author$project$Model$RecruitmentChat$ChatBot$Image = function (a) {
	return {$: 6, a: a};
};
var $author$project$Model$RecruitmentChat$ChatBot$Link = function (a) {
	return {$: 3, a: a};
};
var $author$project$Model$RecruitmentChat$ChatBot$OpenApplicationForm = function (a) {
	return {$: 9, a: a};
};
var $author$project$Model$RecruitmentChat$ChatBot$Option = function (a) {
	return {$: 0, a: a};
};
var $author$project$Model$RecruitmentChat$ChatBot$Root = {$: 10};
var $author$project$Model$RecruitmentChat$ChatBot$SalaryCalculator = function (a) {
	return {$: 5, a: a};
};
var $author$project$Model$RecruitmentChat$ChatBot$Text = function (a) {
	return {$: 1, a: a};
};
var $author$project$Model$RecruitmentChat$ChatBot$Title = function (a) {
	return {$: 2, a: a};
};
var $author$project$Model$RecruitmentChat$ChatBot$VacancyOverview = function (a) {
	return {$: 4, a: a};
};
var $author$project$Model$RecruitmentChat$ChatBot$Video = function (a) {
	return {$: 7, a: a};
};
var $author$project$Model$RecruitmentChat$ChatBot$LinkSettings = F4(
	function (title, url, target, showAsButton) {
		return {ahr: showAsButton, alt: target, avV: title, a0: url};
	});
var $author$project$Model$RecruitmentChat$ChatBot$Blank = 0;
var $author$project$Model$RecruitmentChat$ChatBot$Self = 1;
var $author$project$Model$RecruitmentChat$ChatBot$linkTargetDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'blank':
				return $elm$json$Json$Decode$succeed(0);
			case 'self':
				return $elm$json$Json$Decode$succeed(1);
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Model$RecruitmentChat$ChatBot$linkSettingsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'showAsButton',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'target',
		$author$project$Model$RecruitmentChat$ChatBot$linkTargetDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'url',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'title',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Model$RecruitmentChat$ChatBot$LinkSettings)))));
var $author$project$Model$RecruitmentChat$ChatBot$VacancyOverviewSettings = F2(
	function (vacancyFilterOptionIds, enableLocationSort) {
		return {atL: enableLocationSort, awg: vacancyFilterOptionIds};
	});
var $author$project$Model$RecruitmentChat$ChatBot$vacancyOverviewSettingsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'enableLocationSort',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'vacancyFilterOptionIds',
		$elm$json$Json$Decode$list($author$project$Data$Id$decoder),
		$elm$json$Json$Decode$succeed($author$project$Model$RecruitmentChat$ChatBot$VacancyOverviewSettings)));
var $author$project$Model$RecruitmentChat$ChatBot$nodeDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'option':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Model$RecruitmentChat$ChatBot$Option));
			case 'text':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Model$RecruitmentChat$ChatBot$Text));
			case 'title':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Model$RecruitmentChat$ChatBot$Title));
			case 'link':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$RecruitmentChat$ChatBot$linkSettingsDecoder,
					$elm$json$Json$Decode$succeed($author$project$Model$RecruitmentChat$ChatBot$Link));
			case 'vacancy-overview':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$RecruitmentChat$ChatBot$vacancyOverviewSettingsDecoder,
					$elm$json$Json$Decode$succeed($author$project$Model$RecruitmentChat$ChatBot$VacancyOverview));
			case 'salary-calculator':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$elm$json$Json$Decode$nullable($author$project$Data$Id$decoder),
					$elm$json$Json$Decode$succeed($author$project$Model$RecruitmentChat$ChatBot$SalaryCalculator));
			case 'image':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$ImageSource$imageSourceDecoder,
					$elm$json$Json$Decode$succeed($author$project$Model$RecruitmentChat$ChatBot$Image));
			case 'video':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$ImageSource$imageSourceDecoder,
					$elm$json$Json$Decode$succeed($author$project$Model$RecruitmentChat$ChatBot$Video));
			case 'embedded-chat-bot':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$elm$json$Json$Decode$nullable($author$project$Data$Id$decoder),
					$elm$json$Json$Decode$succeed($author$project$Model$RecruitmentChat$ChatBot$EmbeddedChatBot));
			case 'open-application-form':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$elm$json$Json$Decode$nullable($author$project$Data$Id$decoder),
					$elm$json$Json$Decode$succeed($author$project$Model$RecruitmentChat$ChatBot$OpenApplicationForm));
			case 'root':
				return $elm$json$Json$Decode$succeed($author$project$Model$RecruitmentChat$ChatBot$Root);
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	A2($elm$json$Json$Decode$field, 'tag', $elm$json$Json$Decode$string));
var $author$project$Model$RecruitmentChat$ChatBot$chatBotDecoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Basics$identity,
	$author$project$Util$Tree$decoder($author$project$Model$RecruitmentChat$ChatBot$nodeDecoder));
var $author$project$Model$RecruitmentChat$recruitmentChatDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'recruitmentChatUpdated',
	$elm$json$Json$Decode$nullable($rtfeldman$elm_iso8601_date_strings$Iso8601$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'recruitmentChatInserted',
		$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'recruitmentChatBotAvatar',
			$elm$json$Json$Decode$nullable($author$project$Model$ImageSource$imageSourceDecoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'recruitmentChatChatBot',
				$author$project$Model$RecruitmentChat$ChatBot$chatBotDecoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'recruitmentChatIntroduction',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'recruitmentChatTitle',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'recruitmentChatLabel',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'recruitmentChatDomainId',
								$author$project$Data$Id$decoder,
								$elm$json$Json$Decode$succeed($author$project$Model$RecruitmentChat$RecruitmentChat)))))))));
var $author$project$Util$Date$Today = $elm$core$Basics$identity;
var $justinmimbs$date$Date$RD = $elm$core$Basics$identity;
var $justinmimbs$date$Date$isLeapYear = function (y) {
	return ((!A2($elm$core$Basics$modBy, 4, y)) && (!(!A2($elm$core$Basics$modBy, 100, y)))) || (!A2($elm$core$Basics$modBy, 400, y));
};
var $justinmimbs$date$Date$daysBeforeMonth = F2(
	function (y, m) {
		var leapDays = $justinmimbs$date$Date$isLeapYear(y) ? 1 : 0;
		switch (m) {
			case 0:
				return 0;
			case 1:
				return 31;
			case 2:
				return 59 + leapDays;
			case 3:
				return 90 + leapDays;
			case 4:
				return 120 + leapDays;
			case 5:
				return 151 + leapDays;
			case 6:
				return 181 + leapDays;
			case 7:
				return 212 + leapDays;
			case 8:
				return 243 + leapDays;
			case 9:
				return 273 + leapDays;
			case 10:
				return 304 + leapDays;
			default:
				return 334 + leapDays;
		}
	});
var $justinmimbs$date$Date$floorDiv = F2(
	function (a, b) {
		return $elm$core$Basics$floor(a / b);
	});
var $justinmimbs$date$Date$daysBeforeYear = function (y1) {
	var y = y1 - 1;
	var leapYears = (A2($justinmimbs$date$Date$floorDiv, y, 4) - A2($justinmimbs$date$Date$floorDiv, y, 100)) + A2($justinmimbs$date$Date$floorDiv, y, 400);
	return (365 * y) + leapYears;
};
var $justinmimbs$date$Date$daysInMonth = F2(
	function (y, m) {
		switch (m) {
			case 0:
				return 31;
			case 1:
				return $justinmimbs$date$Date$isLeapYear(y) ? 29 : 28;
			case 2:
				return 31;
			case 3:
				return 30;
			case 4:
				return 31;
			case 5:
				return 30;
			case 6:
				return 31;
			case 7:
				return 31;
			case 8:
				return 30;
			case 9:
				return 31;
			case 10:
				return 30;
			default:
				return 31;
		}
	});
var $justinmimbs$date$Date$fromCalendarDate = F3(
	function (y, m, d) {
		return ($justinmimbs$date$Date$daysBeforeYear(y) + A2($justinmimbs$date$Date$daysBeforeMonth, y, m)) + A3(
			$elm$core$Basics$clamp,
			1,
			A2($justinmimbs$date$Date$daysInMonth, y, m),
			d);
	});
var $justinmimbs$date$Date$fromPosix = F2(
	function (zone, posix) {
		return A3(
			$justinmimbs$date$Date$fromCalendarDate,
			A2($elm$time$Time$toYear, zone, posix),
			A2($elm$time$Time$toMonth, zone, posix),
			A2($elm$time$Time$toDay, zone, posix));
	});
var $author$project$Util$Date$todayFromPosix = function (zone) {
	return A2(
		$elm$core$Basics$composeL,
		$elm$core$Basics$identity,
		$justinmimbs$date$Date$fromPosix(zone));
};
var $author$project$Util$Date$todayDecoder = function () {
	var today = F2(
		function (now, offset) {
			return A2(
				$author$project$Util$Date$todayFromPosix,
				A2($elm$time$Time$customZone, offset, _List_Nil),
				$elm$time$Time$millisToPosix(now));
		});
	return A3(
		$elm$json$Json$Decode$map2,
		today,
		A2($elm$json$Json$Decode$field, 'now', $elm$json$Json$Decode$int),
		A2($elm$json$Json$Decode$field, 'timeZoneOffset', $elm$json$Json$Decode$int));
}();
var $author$project$RecruitmentChat$decodeFlags = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'csrfToken',
	$elm$json$Json$Decode$string,
	'',
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'weeksPerMonth',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$float),
		$elm$core$Maybe$Nothing,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'uploads',
			$author$project$Data$Uploads$uploadsDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'privacyPageUrl',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'currentNodesOnly',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'windowWidth',
						$author$project$Browser$Dom$Breakpoint$windowWidthDecoder,
						A2(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
							$author$project$Util$Date$todayDecoder,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'pathPrefix',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'langCode',
									$author$project$Model$LangCode$decoder,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'domainId',
										$author$project$Data$Id$decoder,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'sessionToken',
											$elm$json$Json$Decode$string,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'showChat',
												$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'showRecruitmentChat',
													$elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool),
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'localStorageState',
														$elm$json$Json$Decode$oneOf(
															_List_fromArray(
																[
																	A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$View$ChatBot$localStorageStateDecoder),
																	$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
																])),
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'recruitmentChats',
															$elm$json$Json$Decode$list(
																$author$project$Data$Entity$decoder($author$project$Model$RecruitmentChat$recruitmentChatDecoder)),
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'recruitmentChat',
																$author$project$Data$Entity$decoder($author$project$Model$RecruitmentChat$recruitmentChatDecoder),
																$elm$json$Json$Decode$succeed($author$project$RecruitmentChat$Flags)))))))))))))))));
var $author$project$RecruitmentChat$ChatBotMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$RecruitmentChat$HideIntroduction = {$: 3};
var $author$project$RecruitmentChat$autoHideIntroduction = A2(
	$elm$core$Task$perform,
	$elm$core$Basics$identity,
	A2(
		$elm$core$Task$andThen,
		$elm$core$Basics$always(
			$elm$core$Task$succeed($author$project$RecruitmentChat$HideIntroduction)),
		$elm$core$Process$sleep(1000 * 10)));
var $author$project$RecruitmentChat$NoOp = {$: 6};
var $author$project$RecruitmentChat$ShowChatBot = {$: 1};
var $author$project$RecruitmentChat$delayShowChatBot = F2(
	function (mTime, mShowChat) {
		var time = 1000 * A2($elm$core$Maybe$withDefault, 0, mTime);
		var msg = function () {
			if (mTime.$ === 1) {
				return $author$project$RecruitmentChat$NoOp;
			} else {
				return $author$project$RecruitmentChat$ShowChatBot;
			}
		}();
		return $elm_community$maybe_extra$Maybe$Extra$isNothing(mShowChat) ? A2(
			$elm$core$Task$perform,
			$elm$core$Basics$identity,
			A2(
				$elm$core$Task$andThen,
				$elm$core$Basics$always(
					$elm$core$Task$succeed(msg)),
				$elm$core$Process$sleep(time))) : $elm$core$Platform$Cmd$none;
	});
var $author$project$Data$Id$emptyDict = A2($author$project$Dict$Custom$empty, $author$project$Data$Id$toInt, $elm$core$Basics$identity);
var $author$project$Data$Status$NotAsked = {$: 0};
var $zwilias$elm_rosetree$Tree$mapAccumulateHelp = F4(
	function (f, state, acc, stack) {
		mapAccumulateHelp:
		while (true) {
			var _v0 = acc.B;
			if (!_v0.b) {
				var node = A2(
					$zwilias$elm_rosetree$Tree$Tree,
					acc.bO,
					$elm$core$List$reverse(acc.d));
				if (!stack.b) {
					return _Utils_Tuple2(state, node);
				} else {
					var top = stack.a;
					var rest = stack.b;
					var $temp$f = f,
						$temp$state = state,
						$temp$acc = _Utils_update(
						top,
						{
							d: A2($elm$core$List$cons, node, top.d)
						}),
						$temp$stack = rest;
					f = $temp$f;
					state = $temp$state;
					acc = $temp$acc;
					stack = $temp$stack;
					continue mapAccumulateHelp;
				}
			} else {
				if (!_v0.a.b.b) {
					var _v2 = _v0.a;
					var d = _v2.a;
					var rest = _v0.b;
					var _v3 = A2(f, state, d);
					var state_ = _v3.a;
					var label_ = _v3.b;
					var $temp$f = f,
						$temp$state = state_,
						$temp$acc = _Utils_update(
						acc,
						{
							d: A2(
								$elm$core$List$cons,
								A2($zwilias$elm_rosetree$Tree$Tree, label_, _List_Nil),
								acc.d),
							B: rest
						}),
						$temp$stack = stack;
					f = $temp$f;
					state = $temp$state;
					acc = $temp$acc;
					stack = $temp$stack;
					continue mapAccumulateHelp;
				} else {
					var _v4 = _v0.a;
					var d = _v4.a;
					var cs = _v4.b;
					var rest = _v0.b;
					var _v5 = A2(f, state, d);
					var state_ = _v5.a;
					var label_ = _v5.b;
					var $temp$f = f,
						$temp$state = state_,
						$temp$acc = {d: _List_Nil, bO: label_, B: cs},
						$temp$stack = A2(
						$elm$core$List$cons,
						_Utils_update(
							acc,
							{B: rest}),
						stack);
					f = $temp$f;
					state = $temp$state;
					acc = $temp$acc;
					stack = $temp$stack;
					continue mapAccumulateHelp;
				}
			}
		}
	});
var $zwilias$elm_rosetree$Tree$mapAccumulate = F3(
	function (f, s, _v0) {
		var d = _v0.a;
		var cs = _v0.b;
		var _v1 = A2(f, s, d);
		var s_ = _v1.a;
		var d_ = _v1.b;
		return A4(
			$zwilias$elm_rosetree$Tree$mapAccumulateHelp,
			f,
			s_,
			{d: _List_Nil, bO: d_, B: cs},
			_List_Nil);
	});
var $zwilias$elm_rosetree$Tree$map = F2(
	function (f, t) {
		return A3(
			$zwilias$elm_rosetree$Tree$mapAccumulate,
			F2(
				function (_v0, e) {
					return _Utils_Tuple2(
						0,
						f(e));
				}),
			0,
			t).b;
	});
var $author$project$Data$ChatBot$NodeDepth = $elm$core$Basics$identity;
var $author$project$Data$ChatBot$NodeIdUnset = {$: 2};
var $author$project$Data$ChatBot$newNodeWithId = function (node) {
	return {ck: 0, dE: $author$project$Data$ChatBot$NodeIdUnset, bh: node};
};
var $zwilias$elm_rosetree$Tree$children = function (_v0) {
	var c = _v0.b;
	return c;
};
var $zwilias$elm_rosetree$Tree$label = function (_v0) {
	var v = _v0.a;
	return v;
};
var $author$project$Data$ChatBot$setDepthHelper = F2(
	function (depth, tree) {
		return A2(
			$zwilias$elm_rosetree$Tree$tree,
			function (n) {
				return _Utils_update(
					n,
					{ck: depth});
			}(
				$zwilias$elm_rosetree$Tree$label(tree)),
			A2(
				$elm$core$List$map,
				$author$project$Data$ChatBot$setDepthHelper(depth + 1),
				$zwilias$elm_rosetree$Tree$children(tree)));
	});
var $author$project$Data$ChatBot$setDepth = function (tree) {
	return A2(
		$zwilias$elm_rosetree$Tree$tree,
		function (n) {
			return _Utils_update(
				n,
				{ck: 0});
		}(
			$zwilias$elm_rosetree$Tree$label(tree)),
		A2(
			$elm$core$List$map,
			$author$project$Data$ChatBot$setDepthHelper(1),
			$zwilias$elm_rosetree$Tree$children(tree)));
};
var $zwilias$elm_rosetree$Tree$foldlHelp = F4(
	function (f, acc, trees, nextSets) {
		foldlHelp:
		while (true) {
			if (!trees.b) {
				if (nextSets.b) {
					var set = nextSets.a;
					var sets = nextSets.b;
					var $temp$f = f,
						$temp$acc = acc,
						$temp$trees = set,
						$temp$nextSets = sets;
					f = $temp$f;
					acc = $temp$acc;
					trees = $temp$trees;
					nextSets = $temp$nextSets;
					continue foldlHelp;
				} else {
					return acc;
				}
			} else {
				if (!trees.a.b.b) {
					var _v2 = trees.a;
					var d = _v2.a;
					var rest = trees.b;
					var $temp$f = f,
						$temp$acc = A2(f, d, acc),
						$temp$trees = rest,
						$temp$nextSets = nextSets;
					f = $temp$f;
					acc = $temp$acc;
					trees = $temp$trees;
					nextSets = $temp$nextSets;
					continue foldlHelp;
				} else {
					var _v3 = trees.a;
					var d = _v3.a;
					var xs = _v3.b;
					var rest = trees.b;
					var $temp$f = f,
						$temp$acc = A2(f, d, acc),
						$temp$trees = xs,
						$temp$nextSets = A2($elm$core$List$cons, rest, nextSets);
					f = $temp$f;
					acc = $temp$acc;
					trees = $temp$trees;
					nextSets = $temp$nextSets;
					continue foldlHelp;
				}
			}
		}
	});
var $zwilias$elm_rosetree$Tree$foldl = F3(
	function (f, acc, t) {
		return A4(
			$zwilias$elm_rosetree$Tree$foldlHelp,
			f,
			acc,
			_List_fromArray(
				[t]),
			_List_Nil);
	});
var $author$project$Data$ChatBot$maxId = A2(
	$zwilias$elm_rosetree$Tree$foldl,
	F2(
		function (x, acc) {
			return A2(
				$elm$core$Basics$max,
				acc,
				$author$project$Data$ChatBot$idToInt(x.dE));
		}),
	0);
var $author$project$Data$ChatBot$updateNewIds = function (tree) {
	var updateId = F2(
		function (nextId, node) {
			var _v0 = node.dE;
			switch (_v0.$) {
				case 2:
					return _Utils_Tuple2(
						nextId + 1,
						_Utils_update(
							node,
							{
								dE: $author$project$Data$ChatBot$NodeId(nextId)
							}));
				case 0:
					return _Utils_Tuple2(nextId, node);
				default:
					return _Utils_Tuple2(nextId, node);
			}
		});
	return A3(
		$zwilias$elm_rosetree$Tree$mapAccumulate,
		F2(
			function (acc, node) {
				return A2(updateId, acc, node);
			}),
		$author$project$Data$ChatBot$maxId(tree) + 1,
		tree).b;
};
var $author$project$Data$ChatBot$fromChatBot = function (_v0) {
	var tree = _v0;
	return $author$project$Data$ChatBot$setDepth(
		$author$project$Data$ChatBot$updateNewIds(
			A2($zwilias$elm_rosetree$Tree$map, $author$project$Data$ChatBot$newNodeWithId, tree)));
};
var $zwilias$elm_rosetree$Tree$singleton = function (v) {
	return A2($zwilias$elm_rosetree$Tree$Tree, v, _List_Nil);
};
var $author$project$Data$ChatBot$emptyTree = $author$project$Data$ChatBot$fromChatBot(
	$zwilias$elm_rosetree$Tree$singleton($author$project$Model$RecruitmentChat$ChatBot$Root));
var $zwilias$elm_rosetree$Tree$Zipper$Zipper = $elm$core$Basics$identity;
var $zwilias$elm_rosetree$Tree$Zipper$fromTree = function (t) {
	return {hf: _List_Nil, oH: _List_Nil, J: _List_Nil, Iz: t};
};
var $author$project$Data$ChatBot$emptyZipper = $zwilias$elm_rosetree$Tree$Zipper$fromTree($author$project$Data$ChatBot$emptyTree);
var $author$project$ScrollToInElement$State = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $tad_lispy$springs$Spring$Spring = $elm$core$Basics$identity;
var $tad_lispy$springs$Spring$create = function (_v0) {
	var strength = _v0.akg;
	var dampness = _v0.yk;
	return {
		yk: A2($elm$core$Basics$pow, dampness, 2),
		akg: strength,
		alt: 0,
		ey: 0,
		bt: 0
	};
};
var $author$project$ScrollToInElement$initWithSettings = F2(
	function (nodeId, settings) {
		return A2(
			$author$project$ScrollToInElement$State,
			nodeId,
			{
				asz: $tad_lispy$springs$Spring$create(settings),
				m: $tad_lispy$springs$Spring$create(settings)
			});
	});
var $author$project$ScrollToInElement$init = function (nodeId) {
	return A2(
		$author$project$ScrollToInElement$initWithSettings,
		nodeId,
		{yk: 4.5, akg: 120});
};
var $author$project$View$ChatBot$empty = {
	G: $elm$core$Maybe$Nothing,
	K: $elm$core$Maybe$Nothing,
	qj: $author$project$Data$ChatBot$emptyZipper,
	c9: A2($author$project$Dict$Custom$fromListVia, $author$project$Data$Id$emptyDict, _List_Nil),
	ci: '',
	S: false,
	aI: $elm$core$Maybe$Nothing,
	az: $elm$core$Maybe$Nothing,
	ft: '',
	aV: '',
	bj: $elm$core$Set$empty,
	at: $author$project$Data$ChatBot$emptyDict,
	bo: $author$project$Data$Id$emptyDict,
	V: $author$project$ScrollToInElement$init('chat-nodes'),
	aW: $elm$core$Maybe$Nothing,
	ape: $elm$core$Dict$empty,
	Y: $author$project$Data$ChatBot$emptyDict,
	a3: $elm$core$Maybe$Nothing
};
var $author$project$View$ChatBot$ScrollToMsg = function (a) {
	return {$: 5, a: a};
};
var $zwilias$elm_rosetree$Tree$Zipper$tree = function (_v0) {
	var focus = _v0.Iz;
	return focus;
};
var $zwilias$elm_rosetree$Tree$Zipper$label = function (zipper) {
	return $zwilias$elm_rosetree$Tree$label(
		$zwilias$elm_rosetree$Tree$Zipper$tree(zipper));
};
var $zwilias$elm_rosetree$Tree$Zipper$find = F3(
	function (predicate, move, zipper) {
		find:
		while (true) {
			var _v0 = move(zipper);
			if (!_v0.$) {
				var next = _v0.a;
				if (predicate(
					$zwilias$elm_rosetree$Tree$Zipper$label(next))) {
					return $elm$core$Maybe$Just(next);
				} else {
					var $temp$predicate = predicate,
						$temp$move = move,
						$temp$zipper = next;
					predicate = $temp$predicate;
					move = $temp$move;
					zipper = $temp$zipper;
					continue find;
				}
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}
	});
var $zwilias$elm_rosetree$Tree$Zipper$firstChild = function (_v0) {
	var zipper = _v0;
	var _v1 = $zwilias$elm_rosetree$Tree$children(zipper.Iz);
	if (!_v1.b) {
		return $elm$core$Maybe$Nothing;
	} else {
		var c = _v1.a;
		var cs = _v1.b;
		return $elm$core$Maybe$Just(
			{
				hf: cs,
				oH: _List_Nil,
				J: A2(
					$elm$core$List$cons,
					{
						hf: zipper.hf,
						oH: zipper.oH,
						bO: $zwilias$elm_rosetree$Tree$label(zipper.Iz)
					},
					zipper.J),
				Iz: c
			});
	}
};
var $zwilias$elm_rosetree$Tree$Zipper$firstOf = F2(
	function (options, v) {
		firstOf:
		while (true) {
			if (!options.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var option = options.a;
				var rest = options.b;
				var _v1 = option(v);
				if (!_v1.$) {
					var r = _v1.a;
					return $elm$core$Maybe$Just(r);
				} else {
					var $temp$options = rest,
						$temp$v = v;
					options = $temp$options;
					v = $temp$v;
					continue firstOf;
				}
			}
		}
	});
var $zwilias$elm_rosetree$Tree$Zipper$nextSibling = function (_v0) {
	var zipper = _v0;
	var _v1 = zipper.hf;
	if (!_v1.b) {
		return $elm$core$Maybe$Nothing;
	} else {
		var next = _v1.a;
		var rest = _v1.b;
		return $elm$core$Maybe$Just(
			{
				hf: rest,
				oH: A2($elm$core$List$cons, zipper.Iz, zipper.oH),
				J: zipper.J,
				Iz: next
			});
	}
};
var $zwilias$elm_rosetree$Tree$Zipper$reconstruct = F4(
	function (focus, before, after, l) {
		return A2(
			$zwilias$elm_rosetree$Tree$tree,
			l,
			_Utils_ap(
				$elm$core$List$reverse(before),
				_Utils_ap(
					_List_fromArray(
						[focus]),
					after)));
	});
var $zwilias$elm_rosetree$Tree$Zipper$parent = function (_v0) {
	var zipper = _v0;
	var _v1 = zipper.J;
	if (!_v1.b) {
		return $elm$core$Maybe$Nothing;
	} else {
		var crumb = _v1.a;
		var rest = _v1.b;
		return $elm$core$Maybe$Just(
			{
				hf: crumb.hf,
				oH: crumb.oH,
				J: rest,
				Iz: A4($zwilias$elm_rosetree$Tree$Zipper$reconstruct, zipper.Iz, zipper.oH, zipper.hf, crumb.bO)
			});
	}
};
var $zwilias$elm_rosetree$Tree$Zipper$nextSiblingOfAncestor = function (zipper) {
	nextSiblingOfAncestor:
	while (true) {
		var _v0 = $zwilias$elm_rosetree$Tree$Zipper$parent(zipper);
		if (_v0.$ === 1) {
			return $elm$core$Maybe$Nothing;
		} else {
			var parent_ = _v0.a;
			var _v1 = $zwilias$elm_rosetree$Tree$Zipper$nextSibling(parent_);
			if (_v1.$ === 1) {
				var $temp$zipper = parent_;
				zipper = $temp$zipper;
				continue nextSiblingOfAncestor;
			} else {
				var s = _v1.a;
				return $elm$core$Maybe$Just(s);
			}
		}
	}
};
var $zwilias$elm_rosetree$Tree$Zipper$forward = function (zipper) {
	return A2(
		$zwilias$elm_rosetree$Tree$Zipper$firstOf,
		_List_fromArray(
			[$zwilias$elm_rosetree$Tree$Zipper$firstChild, $zwilias$elm_rosetree$Tree$Zipper$nextSibling, $zwilias$elm_rosetree$Tree$Zipper$nextSiblingOfAncestor]),
		zipper);
};
var $zwilias$elm_rosetree$Tree$Zipper$findNext = F2(
	function (f, zipper) {
		return A3($zwilias$elm_rosetree$Tree$Zipper$find, f, $zwilias$elm_rosetree$Tree$Zipper$forward, zipper);
	});
var $zwilias$elm_rosetree$Tree$Zipper$previousSibling = function (_v0) {
	var zipper = _v0;
	var _v1 = zipper.oH;
	if (!_v1.b) {
		return $elm$core$Maybe$Nothing;
	} else {
		var previous = _v1.a;
		var rest = _v1.b;
		return $elm$core$Maybe$Just(
			{
				hf: A2($elm$core$List$cons, zipper.Iz, zipper.hf),
				oH: rest,
				J: zipper.J,
				Iz: previous
			});
	}
};
var $zwilias$elm_rosetree$Tree$Zipper$firstSibling = function (zipper) {
	firstSibling:
	while (true) {
		var _v0 = $zwilias$elm_rosetree$Tree$Zipper$previousSibling(zipper);
		if (_v0.$ === 1) {
			return zipper;
		} else {
			var z = _v0.a;
			var $temp$zipper = z;
			zipper = $temp$zipper;
			continue firstSibling;
		}
	}
};
var $zwilias$elm_rosetree$Tree$Zipper$root = function (zipper) {
	root:
	while (true) {
		var _v0 = $zwilias$elm_rosetree$Tree$Zipper$parent(zipper);
		if (_v0.$ === 1) {
			return $zwilias$elm_rosetree$Tree$Zipper$firstSibling(zipper);
		} else {
			var z = _v0.a;
			var $temp$zipper = z;
			zipper = $temp$zipper;
			continue root;
		}
	}
};
var $zwilias$elm_rosetree$Tree$Zipper$findFromRoot = F2(
	function (f, zipper) {
		var r = $zwilias$elm_rosetree$Tree$Zipper$root(zipper);
		return f(
			$zwilias$elm_rosetree$Tree$Zipper$label(r)) ? $elm$core$Maybe$Just(r) : A2($zwilias$elm_rosetree$Tree$Zipper$findNext, f, r);
	});
var $author$project$Data$ChatBot$nodeIdEquals = F2(
	function (id1, id2) {
		var _v0 = _Utils_Tuple2(id1, id2);
		_v0$5:
		while (true) {
			switch (_v0.a.$) {
				case 2:
					if (_v0.b.$ === 2) {
						var _v1 = _v0.a;
						var _v2 = _v0.b;
						return true;
					} else {
						break _v0$5;
					}
				case 0:
					switch (_v0.b.$) {
						case 0:
							var int1 = _v0.a.a;
							var int2 = _v0.b.a;
							return _Utils_eq(int1, int2);
						case 1:
							var _int = _v0.a.a;
							var uuid = _v0.b.a;
							return _Utils_eq(
								$elm$core$String$fromInt(_int),
								$danyx23$elm_uuid$Uuid$toString(uuid));
						default:
							break _v0$5;
					}
				default:
					switch (_v0.b.$) {
						case 1:
							var uuid1 = _v0.a.a;
							var uuid2 = _v0.b.a;
							return _Utils_eq(
								$danyx23$elm_uuid$Uuid$toString(uuid1),
								$danyx23$elm_uuid$Uuid$toString(uuid2));
						case 0:
							var uuid = _v0.a.a;
							var _int = _v0.b.a;
							return _Utils_eq(
								$danyx23$elm_uuid$Uuid$toString(uuid),
								$elm$core$String$fromInt(_int));
						default:
							break _v0$5;
					}
			}
		}
		return false;
	});
var $author$project$View$ChatBot$CheckQueue = function (a) {
	return {$: 4, a: a};
};
var $zwilias$elm_rosetree$Tree$Zipper$children = function (zipper) {
	return $zwilias$elm_rosetree$Tree$children(
		$zwilias$elm_rosetree$Tree$Zipper$tree(zipper));
};
var $author$project$Data$ChatBot$current = function (x) {
	return $zwilias$elm_rosetree$Tree$Zipper$children(x);
};
var $author$project$Data$ChatBot$idToString = function (nodeId) {
	switch (nodeId.$) {
		case 2:
			return '0';
		case 0:
			var id = nodeId.a;
			return $elm$core$String$fromInt(id);
		default:
			var uuid = nodeId.a;
			return $danyx23$elm_uuid$Uuid$toString(uuid);
	}
};
function $author$project$Data$ChatBot$cyclic$before() {
	return A2(
		$elm$core$Basics$composeL,
		A2(
			$elm$core$Basics$composeL,
			$elm$core$Maybe$withDefault(_List_Nil),
			$elm$core$Maybe$map(
				function (x) {
					return _Utils_ap(
						$author$project$Data$ChatBot$cyclic$before()(x),
						$zwilias$elm_rosetree$Tree$Zipper$children(x));
				})),
		$zwilias$elm_rosetree$Tree$Zipper$parent);
}
var $author$project$Data$ChatBot$before = $author$project$Data$ChatBot$cyclic$before();
$author$project$Data$ChatBot$cyclic$before = function () {
	return $author$project$Data$ChatBot$before;
};
var $author$project$Data$ChatBot$currentAndBefore = function (x) {
	return _Utils_ap(
		$author$project$Data$ChatBot$before(x),
		$zwilias$elm_rosetree$Tree$Zipper$children(x));
};
var $author$project$View$ChatBot$nextNode = function (data) {
	var nodesInDisplayOrder = A2(
		$elm$core$List$map,
		$zwilias$elm_rosetree$Tree$label,
		$author$project$Data$ChatBot$currentAndBefore(data.qj));
	var isNotInQueue = function (node) {
		return !A2(
			$elm$core$Set$member,
			$author$project$Data$ChatBot$idToString(node.dE),
			data.bj);
	};
	return $elm$core$List$head(
		A2($elm$core$List$filter, isNotInQueue, nodesInDisplayOrder));
};
var $author$project$View$ChatBot$nodeTypeToDelay = F2(
	function (currentNodesOnly, nodeType) {
		if (currentNodesOnly) {
			return 0;
		} else {
			switch (nodeType.$) {
				case 1:
					var val = nodeType.a;
					return A3(
						$elm$core$Basics$clamp,
						1250,
						2000,
						$elm$core$String$length(val) * 32);
				case 2:
					var val = nodeType.a;
					return A3(
						$elm$core$Basics$clamp,
						1250,
						2000,
						$elm$core$String$length(val) * 32);
				case 3:
					return 600;
				case 0:
					var val = nodeType.a;
					return A3(
						$elm$core$Basics$clamp,
						750,
						2000,
						$elm$core$String$length(val) * 16);
				case 4:
					return 600;
				case 5:
					return 600;
				case 6:
					return 600;
				case 7:
					return 600;
				case 8:
					return 600;
				case 9:
					return 600;
				default:
					return 0;
			}
		}
	});
var $author$project$View$ChatBot$queueNextNodeToShow = function (data) {
	if (data.S) {
		var nodesInDisplayOrder = A2(
			$elm$core$List$map,
			$zwilias$elm_rosetree$Tree$label,
			$author$project$Data$ChatBot$current(data.qj));
		var isNotInQueue = function (node) {
			return !A2(
				$elm$core$Set$member,
				$author$project$Data$ChatBot$idToString(node.dE),
				data.bj);
		};
		var missingNodes = A2($elm$core$List$filter, isNotInQueue, nodesInDisplayOrder);
		return $elm$core$Platform$Cmd$batch(
			A2(
				$elm$core$List$map,
				function (node) {
					return A2(
						$elm$core$Task$perform,
						$author$project$View$ChatBot$CheckQueue,
						$elm$core$Task$succeed(node.dE));
				},
				missingNodes));
	} else {
		var _v0 = $author$project$View$ChatBot$nextNode(data);
		if (_v0.$ === 1) {
			return $elm$core$Platform$Cmd$none;
		} else {
			var node = _v0.a;
			return A2(
				$elm$core$Task$perform,
				function (_v1) {
					return $author$project$View$ChatBot$CheckQueue(node.dE);
				},
				$elm$core$Process$sleep(
					A2($author$project$View$ChatBot$nodeTypeToDelay, data.S, node.bh)));
		}
	}
};
var $author$project$View$ChatBot$GotSalaryCalculator = F2(
	function (a, b) {
		return {$: 15, a: a, b: b};
	});
var $author$project$Api$Endpoint$salaryCalculator = F2(
	function (domainId, id) {
		return $author$project$Api$Endpoint$endpoint(
			_List_fromArray(
				[
					$author$project$Data$Id$toString(domainId),
					'salary-calculator',
					$author$project$Data$Id$toString(id)
				]));
	});
var $author$project$Data$SalaryCalculator$get = F2(
	function (domainId, salaryCalculatorId) {
		return A2(
			$author$project$Api$get,
			A2($author$project$Api$Endpoint$salaryCalculator, domainId, salaryCalculatorId),
			$author$project$Data$Entity$decoder($author$project$Model$SalaryCalculator$salaryCalculatorDecoder));
	});
var $author$project$Dict$Custom$get = F2(
	function (k, _v0) {
		var f = _v0.a;
		var dict = _v0.c;
		return A2(
			$elm$core$Dict$get,
			f(k),
			dict);
	});
var $author$project$Model$VacancyListRenderType$List = 0;
var $author$project$Data$SearchParams$defaultSearchParams = {lt: $elm$core$Maybe$Nothing, da: _List_Nil, rq: _List_Nil, zq: $elm$core$Maybe$Nothing, atE: $elm$core$Maybe$Nothing, EC: $elm$core$Maybe$Nothing, atN: _List_Nil, atO: $elm$core$Maybe$Nothing, atX: _List_Nil, N5: $elm$core$Maybe$Nothing, N6: $elm$core$Maybe$Nothing, OY: true, P6: '', QY: 10, Rs: '', auw: _List_Nil, aux: _List_Nil, dQ: _List_Nil, auz: _List_Nil, Sy: $elm$core$Maybe$Nothing, SD: $elm$core$Maybe$Nothing, Te: $elm$core$Maybe$Nothing, XY: 0, au6: _List_Nil, bm: 0, adU: 0, ajn: true, fL: _List_Nil};
var $author$project$View$ChatBot$maxResults = 5;
var $author$project$View$ChatBot$chatBotSearchParams = _Utils_update(
	$author$project$Data$SearchParams$defaultSearchParams,
	{OY: false, QY: $author$project$View$ChatBot$maxResults});
var $author$project$View$ChatBot$getOriginalSearchParams = F2(
	function (nodeId, vacancySearchResults) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$View$ChatBot$chatBotSearchParams,
			A2(
				$elm$core$Maybe$andThen,
				function (status) {
					if (status.$ === 3) {
						var _v1 = status.a;
						var params = _v1.a;
						return $elm$core$Maybe$Just(params);
					} else {
						return $elm$core$Maybe$Nothing;
					}
				},
				A2($author$project$Dict$Custom$get, nodeId, vacancySearchResults)));
	});
var $author$project$Model$Translation$Form = 0;
var $author$project$View$ChatBot$GotForm = function (a) {
	return {$: 2, a: a};
};
var $author$project$View$ChatBot$HttpError = $elm$core$Basics$identity;
var $author$project$Api$Endpoint$vacancyApplicationForm = F2(
	function (domainId, vacancyId) {
		return $author$project$Api$Endpoint$endpoint(
			_List_fromArray(
				[
					$author$project$Data$Id$toString(domainId),
					'vacancies',
					$author$project$Data$Id$toString(vacancyId),
					'application-form'
				]));
	});
var $author$project$Api$VacancyApplicationForm$VacancyApplicationForm = F3(
	function (formId, form, schemaFields) {
		return {IF: form, Kq: formId, aeo: schemaFields};
	});
var $author$project$Model$FormV2$Form = function (label) {
	return function (formType) {
		return function (fields) {
			return function (required) {
				return function (isDefaultApplicationForm) {
					return function (externalId) {
						return function (openApplicationExternalId) {
							return function (ats) {
								return function (domainId) {
									return function (introText) {
										return function (welcomeTitle) {
											return function (inserted) {
												return function (updated) {
													return {eH: ats, dp: domainId, GT: externalId, atV: fields, aM: formType, e6: inserted, Op: introText, OZ: isDefaultApplicationForm, bO: label, Ye: openApplicationExternalId, eb: required, fY: updated, asb: welcomeTitle};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Model$FormFieldV2$FieldNames = $elm$core$Basics$identity;
var $author$project$Model$FormFieldV2$AdditionalFile1 = {$: 0};
var $author$project$Model$FormFieldV2$AdditionalFile2 = {$: 1};
var $author$project$Model$FormFieldV2$AdditionalFile3 = {$: 2};
var $author$project$Model$FormFieldV2$AdditionalFile4 = {$: 3};
var $author$project$Model$FormFieldV2$AdditionalFile5 = {$: 4};
var $author$project$Model$FormFieldV2$Address = {$: 5};
var $author$project$Model$FormFieldV2$AddressWithAutoFill = {$: 6};
var $author$project$Model$FormFieldV2$AgencyContactEmailAddress = {$: 7};
var $author$project$Model$FormFieldV2$AgencyContactName = {$: 8};
var $author$project$Model$FormFieldV2$AgencyName = {$: 9};
var $author$project$Model$FormFieldV2$Availability = {$: 10};
var $author$project$Model$FormFieldV2$BusinessUnit = {$: 11};
var $author$project$Model$FormFieldV2$Button = {$: 12};
var $author$project$Model$FormFieldV2$City = {$: 13};
var $author$project$Model$FormFieldV2$ConfirmEmailAddress = {$: 14};
var $author$project$Model$FormFieldV2$ConversionFactor = {$: 15};
var $author$project$Model$FormFieldV2$Custom = function (a) {
	return {$: 16, a: a};
};
var $author$project$Model$FormFieldV2$CustomCanadaProvince = {$: 17};
var $author$project$Model$FormFieldV2$CustomCountry = {$: 22};
var $author$project$Model$FormFieldV2$CustomEthnicIdentification = {$: 18};
var $author$project$Model$FormFieldV2$CustomHowDidYouGetHereSelect = {$: 19};
var $author$project$Model$FormFieldV2$CustomIsHispanic = {$: 23};
var $author$project$Model$FormFieldV2$CustomNationality = {$: 20};
var $author$project$Model$FormFieldV2$CustomPreferredLanguage = {$: 21};
var $author$project$Model$FormFieldV2$CustomSelect = {$: 24};
var $author$project$Model$FormFieldV2$CustomState = {$: 25};
var $author$project$Model$FormFieldV2$DateOfBirth = {$: 26};
var $author$project$Model$FormFieldV2$DesiredMonthlySalary = {$: 27};
var $author$project$Model$FormFieldV2$EmailAddress = {$: 28};
var $author$project$Model$FormFieldV2$FirstName = {$: 29};
var $author$project$Model$FormFieldV2$GradesBachelor1 = {$: 30};
var $author$project$Model$FormFieldV2$GradesBachelor2 = {$: 31};
var $author$project$Model$FormFieldV2$GradesMaster1 = {$: 32};
var $author$project$Model$FormFieldV2$GradesMaster2 = {$: 33};
var $author$project$Model$FormFieldV2$Heading = {$: 34};
var $author$project$Model$FormFieldV2$HoursAvailablePerWeek = {$: 37};
var $author$project$Model$FormFieldV2$HowDidYouGetHere = {$: 38};
var $author$project$Model$FormFieldV2$Image = {$: 39};
var $author$project$Model$FormFieldV2$Internal = {$: 40};
var $author$project$Model$FormFieldV2$InternshipEvaluation1 = {$: 41};
var $author$project$Model$FormFieldV2$InternshipEvaluation2 = {$: 42};
var $author$project$Model$FormFieldV2$IntroText = {$: 43};
var $author$project$Model$FormFieldV2$LastName = {$: 44};
var $author$project$Model$FormFieldV2$Link = {$: 45};
var $author$project$Model$FormFieldV2$LinkedInUrl = {$: 46};
var $author$project$Model$FormFieldV2$Motivation = {$: 47};
var $author$project$Model$FormFieldV2$MotivationTextArea = {$: 48};
var $author$project$Model$FormFieldV2$NewsletterSubscription = {$: 49};
var $author$project$Model$FormFieldV2$OpenApplicationExternalId = {$: 50};
var $author$project$Model$FormFieldV2$OpenCheckboxFour = {$: 51};
var $author$project$Model$FormFieldV2$OpenCheckboxOne = {$: 52};
var $author$project$Model$FormFieldV2$OpenCheckboxThree = {$: 53};
var $author$project$Model$FormFieldV2$OpenCheckboxTwo = {$: 54};
var $author$project$Model$FormFieldV2$OpenText = {$: 55};
var $author$project$Model$FormFieldV2$OrderedList = {$: 56};
var $author$project$Model$FormFieldV2$PhoneNumber = {$: 57};
var $author$project$Model$FormFieldV2$PhoneNumberWithCallingCode = {$: 58};
var $author$project$Model$FormFieldV2$PlainText = {$: 59};
var $author$project$Model$FormFieldV2$Portfolio = {$: 60};
var $author$project$Model$FormFieldV2$PostalCode = {$: 61};
var $author$project$Model$FormFieldV2$Privacy = {$: 62};
var $author$project$Model$FormFieldV2$ReferenceId = {$: 35};
var $author$project$Model$FormFieldV2$Referred = {$: 63};
var $author$project$Model$FormFieldV2$ReferredBy = {$: 36};
var $author$project$Model$FormFieldV2$Resume = {$: 64};
var $author$project$Model$FormFieldV2$SalaryIndication = {$: 65};
var $author$project$Model$FormFieldV2$ScreeningQuestions = {$: 66};
var $author$project$Model$FormFieldV2$SocialTitle = {$: 67};
var $author$project$Model$FormFieldV2$Source = {$: 68};
var $author$project$Model$FormFieldV2$Spacer = {$: 69};
var $author$project$Model$FormFieldV2$StoreData = {$: 70};
var $author$project$Model$FormFieldV2$Thesis = {$: 71};
var $author$project$Model$FormFieldV2$UnorderedList = {$: 72};
var $author$project$Model$FormFieldV2$Url = {$: 73};
var $author$project$Model$FormFieldV2$Usp = {$: 74};
var $author$project$Model$FormFieldV2$Video = {$: 75};
var $author$project$Model$FormFieldV2$XingUrl = {$: 76};
var $author$project$Model$FormFieldV2$fieldNameDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'additional-file1':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$AdditionalFile1);
			case 'additional-file2':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$AdditionalFile2);
			case 'additional-file3':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$AdditionalFile3);
			case 'additional-file4':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$AdditionalFile4);
			case 'additional-file5':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$AdditionalFile5);
			case 'address':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$Address);
			case 'address-with-auto-fill':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$AddressWithAutoFill);
			case 'agency-contact-email-address':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$AgencyContactEmailAddress);
			case 'agency-contact-name':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$AgencyContactName);
			case 'agency-name':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$AgencyName);
			case 'availability':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$Availability);
			case 'business-unit':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$BusinessUnit);
			case 'button':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$Button);
			case 'city':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$City);
			case 'confirm-email-address':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$ConfirmEmailAddress);
			case 'conversion-factor':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$ConversionFactor);
			case 'custom':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$Custom));
			case 'custom-canada-province':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$CustomCanadaProvince);
			case 'custom-ethnic-identification':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$CustomEthnicIdentification);
			case 'custom-how-did-you-get-here-select':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$CustomHowDidYouGetHereSelect);
			case 'custom-nationality':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$CustomNationality);
			case 'custom-preferred-language':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$CustomPreferredLanguage);
			case 'custom-country':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$CustomCountry);
			case 'custom-is-hispanic':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$CustomIsHispanic);
			case 'custom-select':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$CustomSelect);
			case 'custom-state':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$CustomState);
			case 'date-of-birth':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$DateOfBirth);
			case 'desired-monthly-salary':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$DesiredMonthlySalary);
			case 'email-address':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$EmailAddress);
			case 'first-name':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$FirstName);
			case 'grades-bachelor1':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$GradesBachelor1);
			case 'grades-bachelor2':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$GradesBachelor2);
			case 'grades-master1':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$GradesMaster1);
			case 'grades-master2':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$GradesMaster2);
			case 'heading':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$Heading);
			case 'reference-id':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$ReferenceId);
			case 'referred-by':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$ReferredBy);
			case 'hours-available-per-week':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$HoursAvailablePerWeek);
			case 'how-did-you-get-here':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$HowDidYouGetHere);
			case 'image':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$Image);
			case 'internal':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$Internal);
			case 'internship-evaluation1':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$InternshipEvaluation1);
			case 'internship-evaluation2':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$InternshipEvaluation2);
			case 'intro-text':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$IntroText);
			case 'last-name':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$LastName);
			case 'link':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$Link);
			case 'linked-in-url':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$LinkedInUrl);
			case 'motivation':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$Motivation);
			case 'motivation-text-area':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$MotivationTextArea);
			case 'newsletter-subscription':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$NewsletterSubscription);
			case 'open-application-external-id':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$OpenApplicationExternalId);
			case 'open-checkbox-four':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$OpenCheckboxFour);
			case 'open-checkbox-one':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$OpenCheckboxOne);
			case 'open-checkbox-three':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$OpenCheckboxThree);
			case 'open-checkbox-two':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$OpenCheckboxTwo);
			case 'open-text':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$OpenText);
			case 'ordered-list':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$OrderedList);
			case 'phone-number':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$PhoneNumber);
			case 'phone-number-with-calling-code':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$PhoneNumberWithCallingCode);
			case 'plain-text':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$PlainText);
			case 'portfolio':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$Portfolio);
			case 'postal-code':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$PostalCode);
			case 'privacy':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$Privacy);
			case 'referred':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$Referred);
			case 'resume':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$Resume);
			case 'salary-indication':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$SalaryIndication);
			case 'screening-questions':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$ScreeningQuestions);
			case 'social-title':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$SocialTitle);
			case 'source':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$Source);
			case 'spacer':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$Spacer);
			case 'store-data':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$StoreData);
			case 'thesis':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$Thesis);
			case 'unordered-list':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$UnorderedList);
			case 'url':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$Url);
			case 'usp':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$Usp);
			case 'video':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$Video);
			case 'xing-url':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$XingUrl);
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	A2($elm$json$Json$Decode$field, 'tag', $elm$json$Json$Decode$string));
var $author$project$Model$FormFieldV2$fieldNamesDecoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Basics$identity,
	$elm$json$Json$Decode$list(
		$elm$json$Json$Decode$list($author$project$Model$FormFieldV2$fieldNameDecoder)));
var $author$project$Model$FormFieldV2$Fields = $elm$core$Basics$identity;
var $author$project$Model$FormFieldV2$Field = F9(
	function (type_, name, hiddenLabel, label, question, placeholder, missingError, invalidError, visibilityRule) {
		return {dB: hiddenLabel, auo: invalidError, bO: label, auJ: missingError, dY: name, d5: placeholder, aaI: question, ew: type_, awp: visibilityRule};
	});
var $author$project$Model$FormFieldTypeV2$Address = {$: 0};
var $author$project$Model$FormFieldTypeV2$Checkbox = {$: 1};
var $author$project$Model$FormFieldTypeV2$Code = {$: 2};
var $author$project$Model$FormFieldTypeV2$Content = function (a) {
	return {$: 3, a: a};
};
var $author$project$Model$FormFieldTypeV2$Date = function (a) {
	return {$: 4, a: a};
};
var $author$project$Model$FormFieldTypeV2$DaypartAvailability = function (a) {
	return {$: 5, a: a};
};
var $author$project$Model$FormFieldTypeV2$EmailAddress = {$: 6};
var $author$project$Model$FormFieldTypeV2$File = function (a) {
	return {$: 7, a: a};
};
var $author$project$Model$FormFieldTypeV2$HiddenText = function (a) {
	return {$: 8, a: a};
};
var $author$project$Model$FormFieldTypeV2$Phone = {$: 9};
var $author$project$Model$FormFieldTypeV2$Radio = function (a) {
	return {$: 11, a: a};
};
var $author$project$Model$FormFieldTypeV2$Range = function (a) {
	return {$: 10, a: a};
};
var $author$project$Model$FormFieldTypeV2$ScreeningQuestions = {$: 18};
var $author$project$Model$FormFieldTypeV2$Select = function (a) {
	return {$: 12, a: a};
};
var $author$project$Model$FormFieldTypeV2$SelectMultiple = function (a) {
	return {$: 13, a: a};
};
var $author$project$Model$FormFieldTypeV2$SelectWithIds = function (a) {
	return {$: 14, a: a};
};
var $author$project$Model$FormFieldTypeV2$Text = function (a) {
	return {$: 15, a: a};
};
var $author$project$Model$FormFieldTypeV2$TextArea = function (a) {
	return {$: 16, a: a};
};
var $author$project$Model$FormFieldTypeV2$Url = function (a) {
	return {$: 17, a: a};
};
var $author$project$Model$FormFieldTypeV2$YesNo = {$: 19};
var $author$project$Model$FormFieldTypeV2$DateFieldOptions = F2(
	function (minOffsetFromTodayInYears, maxOffsetFromTodayInYears) {
		return {dT: maxOffsetFromTodayInYears, dU: minOffsetFromTodayInYears};
	});
var $author$project$Model$FormFieldTypeV2$dateFieldOptionsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'maxOffsetFromTodayInYears',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'minOffsetFromTodayInYears',
		$elm$json$Json$Decode$int,
		$elm$json$Json$Decode$succeed($author$project$Model$FormFieldTypeV2$DateFieldOptions)));
var $author$project$Model$FormFieldTypeV2$DaypartAvailabilityFieldOptions = function (availableParts) {
	return {as4: availableParts};
};
var $author$project$Model$FormFieldTypeV2$Friday = 4;
var $author$project$Model$FormFieldTypeV2$Monday = 0;
var $author$project$Model$FormFieldTypeV2$Saturday = 5;
var $author$project$Model$FormFieldTypeV2$Sunday = 6;
var $author$project$Model$FormFieldTypeV2$Thursday = 3;
var $author$project$Model$FormFieldTypeV2$Tuesday = 1;
var $author$project$Model$FormFieldTypeV2$Wednesday = 2;
var $author$project$Model$FormFieldTypeV2$dayOfWeekDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'monday':
				return $elm$json$Json$Decode$succeed(0);
			case 'tuesday':
				return $elm$json$Json$Decode$succeed(1);
			case 'wednesday':
				return $elm$json$Json$Decode$succeed(2);
			case 'thursday':
				return $elm$json$Json$Decode$succeed(3);
			case 'friday':
				return $elm$json$Json$Decode$succeed(4);
			case 'saturday':
				return $elm$json$Json$Decode$succeed(5);
			case 'sunday':
				return $elm$json$Json$Decode$succeed(6);
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Model$FormFieldTypeV2$Afternoon = 1;
var $author$project$Model$FormFieldTypeV2$Evening = 2;
var $author$project$Model$FormFieldTypeV2$Morning = 0;
var $author$project$Model$FormFieldTypeV2$Night = 3;
var $author$project$Model$FormFieldTypeV2$daypartDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'morning':
				return $elm$json$Json$Decode$succeed(0);
			case 'afternoon':
				return $elm$json$Json$Decode$succeed(1);
			case 'evening':
				return $elm$json$Json$Decode$succeed(2);
			case 'night':
				return $elm$json$Json$Decode$succeed(3);
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Model$FormFieldTypeV2$daypartAvailabilityFieldOptionsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'availableParts',
	$elm$json$Json$Decode$list(
		A3(
			$elm$json$Json$Decode$map2,
			$elm$core$Tuple$pair,
			A2($elm$json$Json$Decode$index, 0, $author$project$Model$FormFieldTypeV2$dayOfWeekDecoder),
			A2($elm$json$Json$Decode$index, 1, $author$project$Model$FormFieldTypeV2$daypartDecoder))),
	$elm$json$Json$Decode$succeed($author$project$Model$FormFieldTypeV2$DaypartAvailabilityFieldOptions));
var $author$project$Model$FormFieldTypeV2$FileFieldOptions = F2(
	function (mimeTypes, maxFileSizeInMB) {
		return {Sv: maxFileSizeInMB, Tc: mimeTypes};
	});
var $author$project$Model$FormFieldTypeV2$MimeType = $elm$core$Basics$identity;
var $author$project$Model$FormFieldTypeV2$mimeTypeDecoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$string);
var $author$project$Model$FormFieldTypeV2$fileFieldOptionsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'maxFileSizeInMB',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'mimeTypes',
		$elm$json$Json$Decode$list($author$project$Model$FormFieldTypeV2$mimeTypeDecoder),
		$elm$json$Json$Decode$succeed($author$project$Model$FormFieldTypeV2$FileFieldOptions)));
var $author$project$Model$FormFieldTypeV2$RangeFieldOptions = F3(
	function (minValue, maxValue, stepValue) {
		return {SE: maxValue, Ti: minValue, aj3: stepValue};
	});
var $author$project$Model$FormFieldTypeV2$rangeFieldOptionsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'stepValue',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'maxValue',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'minValue',
			$elm$json$Json$Decode$int,
			$elm$json$Json$Decode$succeed($author$project$Model$FormFieldTypeV2$RangeFieldOptions))));
var $author$project$Model$FormFieldTypeV2$TextFieldOptions = F2(
	function (minLength, maxLength) {
		return {Sz: maxLength, Tf: minLength};
	});
var $author$project$Model$FormFieldTypeV2$textFieldOptionsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'maxLength',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'minLength',
		$elm$json$Json$Decode$int,
		$elm$json$Json$Decode$succeed($author$project$Model$FormFieldTypeV2$TextFieldOptions)));
var $author$project$Model$FormFieldTypeV2$Default = 0;
var $author$project$Model$FormFieldTypeV2$LinkedInUrl = 2;
var $author$project$Model$FormFieldTypeV2$XingUrl = 1;
var $author$project$Model$FormFieldTypeV2$urlTypeDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'default':
				return $elm$json$Json$Decode$succeed(0);
			case 'xing-url':
				return $elm$json$Json$Decode$succeed(1);
			case 'linked-in-url':
				return $elm$json$Json$Decode$succeed(2);
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Model$FormFieldTypeV2$fieldTypeDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'address':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldTypeV2$Address);
			case 'checkbox':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldTypeV2$Checkbox);
			case 'code':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldTypeV2$Code);
			case 'content':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$Content$contentDecoder,
					$elm$json$Json$Decode$succeed($author$project$Model$FormFieldTypeV2$Content));
			case 'date':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$FormFieldTypeV2$dateFieldOptionsDecoder,
					$elm$json$Json$Decode$succeed($author$project$Model$FormFieldTypeV2$Date));
			case 'daypart-availability':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$FormFieldTypeV2$daypartAvailabilityFieldOptionsDecoder,
					$elm$json$Json$Decode$succeed($author$project$Model$FormFieldTypeV2$DaypartAvailability));
			case 'email-address':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldTypeV2$EmailAddress);
			case 'file':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$FormFieldTypeV2$fileFieldOptionsDecoder,
					$elm$json$Json$Decode$succeed($author$project$Model$FormFieldTypeV2$File));
			case 'hidden-text':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$FormFieldTypeV2$textFieldOptionsDecoder,
					$elm$json$Json$Decode$succeed($author$project$Model$FormFieldTypeV2$HiddenText));
			case 'phone':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldTypeV2$Phone);
			case 'range':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$FormFieldTypeV2$rangeFieldOptionsDecoder,
					$elm$json$Json$Decode$succeed($author$project$Model$FormFieldTypeV2$Range));
			case 'radio':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$elm$json$Json$Decode$list(
						A3(
							$elm$json$Json$Decode$map2,
							$elm$core$Tuple$pair,
							A2($elm$json$Json$Decode$index, 0, $elm$json$Json$Decode$string),
							A2($elm$json$Json$Decode$index, 1, $elm$json$Json$Decode$string))),
					$elm$json$Json$Decode$succeed($author$project$Model$FormFieldTypeV2$Radio));
			case 'select':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
					$elm$json$Json$Decode$succeed($author$project$Model$FormFieldTypeV2$Select));
			case 'select-multiple':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$elm$json$Json$Decode$list(
						A3(
							$elm$json$Json$Decode$map2,
							$elm$core$Tuple$pair,
							A2($elm$json$Json$Decode$index, 0, $elm$json$Json$Decode$string),
							A2($elm$json$Json$Decode$index, 1, $elm$json$Json$Decode$string))),
					$elm$json$Json$Decode$succeed($author$project$Model$FormFieldTypeV2$SelectMultiple));
			case 'select-with-ids':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$elm$json$Json$Decode$list(
						A3(
							$elm$json$Json$Decode$map2,
							$elm$core$Tuple$pair,
							A2($elm$json$Json$Decode$index, 0, $elm$json$Json$Decode$string),
							A2($elm$json$Json$Decode$index, 1, $elm$json$Json$Decode$string))),
					$elm$json$Json$Decode$succeed($author$project$Model$FormFieldTypeV2$SelectWithIds));
			case 'text':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$FormFieldTypeV2$textFieldOptionsDecoder,
					$elm$json$Json$Decode$succeed($author$project$Model$FormFieldTypeV2$Text));
			case 'text-area':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$FormFieldTypeV2$textFieldOptionsDecoder,
					$elm$json$Json$Decode$succeed($author$project$Model$FormFieldTypeV2$TextArea));
			case 'url':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$FormFieldTypeV2$urlTypeDecoder,
					$elm$json$Json$Decode$succeed($author$project$Model$FormFieldTypeV2$Url));
			case 'screening-questions':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldTypeV2$ScreeningQuestions);
			case 'yes-no':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldTypeV2$YesNo);
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	A2($elm$json$Json$Decode$field, 'tag', $elm$json$Json$Decode$string));
var $author$project$Model$VisibilityRule$VisibilityRule = F2(
	function (combinator, conditions) {
		return {ati: combinator, atm: conditions};
	});
var $author$project$Model$VisibilityRule$AllOf = 0;
var $author$project$Model$VisibilityRule$AnyOf = 1;
var $author$project$Model$VisibilityRule$combinatorDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'all-of':
				return $elm$json$Json$Decode$succeed(0);
			case 'any-of':
				return $elm$json$Json$Decode$succeed(1);
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Model$VisibilityRule$Condition = F3(
	function (conditionFieldName, conditionOperator, conditionValue) {
		return {atj: conditionFieldName, atk: conditionOperator, atl: conditionValue};
	});
var $author$project$Model$VisibilityRule$Contains = 4;
var $author$project$Model$VisibilityRule$Equals = 0;
var $author$project$Model$VisibilityRule$IsEmpty = 2;
var $author$project$Model$VisibilityRule$IsNotEmpty = 3;
var $author$project$Model$VisibilityRule$NotEquals = 1;
var $author$project$Model$VisibilityRule$OneOf = 5;
var $author$project$Model$VisibilityRule$conditionOperatorDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'equals':
				return $elm$json$Json$Decode$succeed(0);
			case 'not-equals':
				return $elm$json$Json$Decode$succeed(1);
			case 'is-empty':
				return $elm$json$Json$Decode$succeed(2);
			case 'is-not-empty':
				return $elm$json$Json$Decode$succeed(3);
			case 'contains':
				return $elm$json$Json$Decode$succeed(4);
			case 'one-of':
				return $elm$json$Json$Decode$succeed(5);
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Model$VisibilityRule$CBool = function (a) {
	return {$: 1, a: a};
};
var $author$project$Model$VisibilityRule$CEmpty = {$: 3};
var $author$project$Model$VisibilityRule$CList = function (a) {
	return {$: 2, a: a};
};
var $author$project$Model$VisibilityRule$CText = function (a) {
	return {$: 0, a: a};
};
var $author$project$Model$VisibilityRule$conditionValueDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'c-text':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Model$VisibilityRule$CText));
			case 'c-bool':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$elm$json$Json$Decode$bool,
					$elm$json$Json$Decode$succeed($author$project$Model$VisibilityRule$CBool));
			case 'c-list':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
					$elm$json$Json$Decode$succeed($author$project$Model$VisibilityRule$CList));
			case 'c-empty':
				return $elm$json$Json$Decode$succeed($author$project$Model$VisibilityRule$CEmpty);
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	A2($elm$json$Json$Decode$field, 'tag', $elm$json$Json$Decode$string));
var $author$project$Model$VisibilityRule$conditionDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'conditionValue',
	$author$project$Model$VisibilityRule$conditionValueDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'conditionOperator',
		$author$project$Model$VisibilityRule$conditionOperatorDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'conditionFieldName',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Model$VisibilityRule$Condition))));
var $author$project$Model$VisibilityRule$visibilityRuleDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'conditions',
	$elm$json$Json$Decode$list($author$project$Model$VisibilityRule$conditionDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'combinator',
		$author$project$Model$VisibilityRule$combinatorDecoder,
		$elm$json$Json$Decode$succeed($author$project$Model$VisibilityRule$VisibilityRule)));
var $author$project$Model$FormFieldV2$fieldDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'visibilityRule',
	$elm$json$Json$Decode$nullable($author$project$Model$VisibilityRule$visibilityRuleDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'invalidError',
		$elm$json$Json$Decode$list(
			A3(
				$elm$json$Json$Decode$map2,
				$elm$core$Tuple$pair,
				A2($elm$json$Json$Decode$index, 0, $author$project$Data$Id$decoder),
				A2($elm$json$Json$Decode$index, 1, $elm$json$Json$Decode$string))),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'missingError',
			$elm$json$Json$Decode$list(
				A3(
					$elm$json$Json$Decode$map2,
					$elm$core$Tuple$pair,
					A2($elm$json$Json$Decode$index, 0, $author$project$Data$Id$decoder),
					A2($elm$json$Json$Decode$index, 1, $elm$json$Json$Decode$string))),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'placeholder',
				$elm$json$Json$Decode$list(
					A3(
						$elm$json$Json$Decode$map2,
						$elm$core$Tuple$pair,
						A2($elm$json$Json$Decode$index, 0, $author$project$Data$Id$decoder),
						A2($elm$json$Json$Decode$index, 1, $elm$json$Json$Decode$string))),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'question',
					$elm$json$Json$Decode$list(
						A3(
							$elm$json$Json$Decode$map2,
							$elm$core$Tuple$pair,
							A2($elm$json$Json$Decode$index, 0, $author$project$Data$Id$decoder),
							A2($elm$json$Json$Decode$index, 1, $elm$json$Json$Decode$string))),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'label',
						$elm$json$Json$Decode$list(
							A3(
								$elm$json$Json$Decode$map2,
								$elm$core$Tuple$pair,
								A2($elm$json$Json$Decode$index, 0, $author$project$Data$Id$decoder),
								A2($elm$json$Json$Decode$index, 1, $elm$json$Json$Decode$string))),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'hiddenLabel',
							$elm$json$Json$Decode$bool,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'name',
								$author$project$Model$FormFieldV2$fieldNameDecoder,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'type_',
									$author$project$Model$FormFieldTypeV2$fieldTypeDecoder,
									$elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$Field))))))))));
var $author$project$Model$FormFieldV2$fieldsDecoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Basics$identity,
	$elm$json$Json$Decode$list(
		$elm$json$Json$Decode$list($author$project$Model$FormFieldV2$fieldDecoder)));
var $author$project$Model$Form$FormType$EventRegistration = 2;
var $author$project$Model$Form$FormType$JobApplication = 0;
var $author$project$Model$Form$FormType$OpenJobApplication = 1;
var $author$project$Model$Form$FormType$UbeeoEventRegistration = 3;
var $author$project$Model$Form$FormType$UbeeoV2EventRegistration = 4;
var $author$project$Model$Form$FormType$formTypeDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'job-application':
				return $elm$json$Json$Decode$succeed(0);
			case 'open-job-application':
				return $elm$json$Json$Decode$succeed(1);
			case 'event-registration':
				return $elm$json$Json$Decode$succeed(2);
			case 'ubeeo-event-registration':
				return $elm$json$Json$Decode$succeed(3);
			case 'ubeeo-v2-event-registration':
				return $elm$json$Json$Decode$succeed(4);
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Model$FormV2$IntroText$IntroText = function (text) {
	return {alE: text};
};
var $author$project$Model$FormV2$IntroText$introTextDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'text',
	$elm$json$Json$Decode$list(
		A3(
			$elm$json$Json$Decode$map2,
			$elm$core$Tuple$pair,
			A2($elm$json$Json$Decode$index, 0, $author$project$Data$Id$decoder),
			A2($elm$json$Json$Decode$index, 1, $elm$json$Json$Decode$string))),
	$elm$json$Json$Decode$succeed($author$project$Model$FormV2$IntroText$IntroText));
var $author$project$Model$FormV2$formDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'formUpdated',
	$elm$json$Json$Decode$nullable($rtfeldman$elm_iso8601_date_strings$Iso8601$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'formInserted',
		$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'formWelcomeTitle',
			$author$project$Model$FormV2$IntroText$introTextDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'formIntroText',
				$author$project$Model$FormV2$IntroText$introTextDecoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'formDomainId',
					$elm$json$Json$Decode$nullable($author$project$Data$Id$decoder),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'formAts',
						$author$project$Model$Ats$atsDecoder,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'formOpenApplicationExternalId',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'formExternalId',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'formIsDefaultApplicationForm',
									$elm$json$Json$Decode$bool,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'formRequired',
										$author$project$Model$FormFieldV2$fieldNamesDecoder,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'formFields',
											$author$project$Model$FormFieldV2$fieldsDecoder,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'formFormType',
												$author$project$Model$Form$FormType$formTypeDecoder,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'formLabel',
													$elm$json$Json$Decode$string,
													$elm$json$Json$Decode$succeed($author$project$Model$FormV2$Form))))))))))))));
var $author$project$Model$FormV2Schema$SchemaField = F9(
	function (type_, name, requiredByExport, requiredBy, defaultRequired, disableCopyPaste, question, label, placeholder) {
		return {yY: defaultRequired, D4: disableCopyPaste, bO: label, dY: name, d5: placeholder, aaI: question, ada: requiredBy, adb: requiredByExport, ew: type_};
	});
var $author$project$Model$FormV2Schema$RequiredByAts = function (a) {
	return {$: 0, a: a};
};
var $author$project$Model$FormV2Schema$RequiredBySystem = {$: 1};
var $author$project$Model$FormV2Schema$requiredByDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'required-by-ats':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Model$FormV2Schema$RequiredByAts));
			case 'required-by-system':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormV2Schema$RequiredBySystem);
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	A2($elm$json$Json$Decode$field, 'tag', $elm$json$Json$Decode$string));
var $author$project$Model$FormV2Schema$schemaFieldDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'placeholder',
	$elm$json$Json$Decode$list(
		A3(
			$elm$json$Json$Decode$map2,
			$elm$core$Tuple$pair,
			A2($elm$json$Json$Decode$index, 0, $author$project$Data$Id$decoder),
			A2($elm$json$Json$Decode$index, 1, $elm$json$Json$Decode$string))),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'label',
		$elm$json$Json$Decode$list(
			A3(
				$elm$json$Json$Decode$map2,
				$elm$core$Tuple$pair,
				A2($elm$json$Json$Decode$index, 0, $author$project$Data$Id$decoder),
				A2($elm$json$Json$Decode$index, 1, $elm$json$Json$Decode$string))),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'question',
			$elm$json$Json$Decode$list(
				A3(
					$elm$json$Json$Decode$map2,
					$elm$core$Tuple$pair,
					A2($elm$json$Json$Decode$index, 0, $author$project$Data$Id$decoder),
					A2($elm$json$Json$Decode$index, 1, $elm$json$Json$Decode$string))),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'disableCopyPaste',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'defaultRequired',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'requiredBy',
						$elm$json$Json$Decode$nullable($author$project$Model$FormV2Schema$requiredByDecoder),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'requiredByExport',
							$elm$json$Json$Decode$bool,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'name',
								$author$project$Model$FormFieldV2$fieldNameDecoder,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'type_',
									$author$project$Model$FormFieldTypeV2$fieldTypeDecoder,
									$elm$json$Json$Decode$succeed($author$project$Model$FormV2Schema$SchemaField))))))))));
var $author$project$Api$VacancyApplicationForm$vacancyApplicationFormDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'vacancyApplicationFormSchemaFields',
	$elm$json$Json$Decode$list($author$project$Model$FormV2Schema$schemaFieldDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'vacancyApplicationFormForm',
		$author$project$Model$FormV2$formDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'vacancyApplicationFormFormId',
			$author$project$Data$Id$decoder,
			$elm$json$Json$Decode$succeed($author$project$Api$VacancyApplicationForm$VacancyApplicationForm))));
var $author$project$Data$Vacancy$getApplicationForm = F2(
	function (domainId, vacancyId) {
		return A2(
			$author$project$Api$get,
			A2($author$project$Api$Endpoint$vacancyApplicationForm, domainId, vacancyId),
			A3(
				$elm$json$Json$Decode$map2,
				$elm$core$Tuple$pair,
				$author$project$Api$VacancyApplicationForm$vacancyApplicationFormDecoder,
				$elm$json$Json$Decode$oneOf(
					_List_fromArray(
						[
							A2($elm$json$Json$Decode$field, 'uploads', $author$project$Data$Uploads$uploadsDecoder),
							$elm$json$Json$Decode$succeed($elm$core$Dict$empty)
						]))));
	});
var $author$project$Model$Translation$Translation = function (name) {
	return function (tags) {
		return function (da) {
			return function (de) {
				return function (deAt) {
					return function (deCh) {
						return function (deLu) {
							return function (en) {
								return function (enGb) {
									return function (enUs) {
										return function (es) {
											return function (fi) {
												return function (fr) {
													return function (frBe) {
														return function (frCh) {
															return function (frLu) {
																return function (hu) {
																	return function (nl) {
																		return function (nlBe) {
																			return function (no) {
																				return function (pl) {
																					return function (pt) {
																						return function (ro) {
																							return function (sk) {
																								return function (sv) {
																									return function (uk) {
																										return function (inserted) {
																											return function (updated) {
																												return {ats: da, att: de, atu: deAt, atv: deCh, atw: deLu, F_: en, atJ: enGb, atK: enUs, atM: es, atT: fi, at1: fr, at2: frBe, at3: frCh, at4: frLu, aug: hu, e6: inserted, dY: name, auO: nl, auP: nlBe, VA: no, avc: pl, avj: pt, avs: ro, avB: sk, avP: sv, aln: tags, av5: uk, fY: updated};
																											};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Model$Translation$translationNameDecoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$string);
var $author$project$Model$Translation$TranslationTags = $elm$core$Basics$identity;
var $author$project$Model$Translation$ReferralTool = 1;
var $author$project$Model$Translation$ShareTool = 2;
var $author$project$Model$Translation$Vacancy = 3;
var $author$project$Model$Translation$translationTagDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'form':
				return $elm$json$Json$Decode$succeed(0);
			case 'referral-tool':
				return $elm$json$Json$Decode$succeed(1);
			case 'share-tool':
				return $elm$json$Json$Decode$succeed(2);
			case 'vacancy':
				return $elm$json$Json$Decode$succeed(3);
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Model$Translation$translationTagsDecoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Basics$identity,
	$elm$json$Json$Decode$list($author$project$Model$Translation$translationTagDecoder));
var $author$project$Model$Translation$translationDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'translationUpdated',
	$elm$json$Json$Decode$nullable($rtfeldman$elm_iso8601_date_strings$Iso8601$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'translationInserted',
		$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'translationUk',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'translationSv',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'translationSk',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'translationRo',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'translationPt',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'translationPl',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'translationNo',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'translationNlBe',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'translationNl',
											$elm$json$Json$Decode$string,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'translationHu',
												$elm$json$Json$Decode$string,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'translationFrLu',
													$elm$json$Json$Decode$string,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'translationFrCh',
														$elm$json$Json$Decode$string,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'translationFrBe',
															$elm$json$Json$Decode$string,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'translationFr',
																$elm$json$Json$Decode$string,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'translationFi',
																	$elm$json$Json$Decode$string,
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'translationEs',
																		$elm$json$Json$Decode$string,
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'translationEnUs',
																			$elm$json$Json$Decode$string,
																			A3(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																				'translationEnGb',
																				$elm$json$Json$Decode$string,
																				A3(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																					'translationEn',
																					$elm$json$Json$Decode$string,
																					A3(
																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																						'translationDeLu',
																						$elm$json$Json$Decode$string,
																						A3(
																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																							'translationDeCh',
																							$elm$json$Json$Decode$string,
																							A3(
																								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																								'translationDeAt',
																								$elm$json$Json$Decode$string,
																								A3(
																									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																									'translationDe',
																									$elm$json$Json$Decode$string,
																									A3(
																										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																										'translationDa',
																										$elm$json$Json$Decode$string,
																										A3(
																											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																											'translationTags',
																											$author$project$Model$Translation$translationTagsDecoder,
																											A3(
																												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																												'translationName',
																												$author$project$Model$Translation$translationNameDecoder,
																												$elm$json$Json$Decode$succeed($author$project$Model$Translation$Translation)))))))))))))))))))))))))))));
var $author$project$Api$Endpoint$endpointWithQueryParameters = F2(
	function (segments, queryParameters) {
		return A2(
			$elm$url$Url$Builder$absolute,
			A2($elm$core$List$cons, 'api', segments),
			queryParameters);
	});
var $author$project$Data$TranslationTag$translationTagToString = function (tag) {
	switch (tag) {
		case 0:
			return 'form';
		case 1:
			return 'referral-tool';
		case 2:
			return 'share-tool';
		default:
			return 'vacancy';
	}
};
var $author$project$Api$Endpoint$translations = function (translationTags) {
	var tagsQueryParameter = A2(
		$elm$url$Url$Builder$string,
		'tags',
		A2(
			$elm$core$String$join,
			',',
			A2($elm$core$List$map, $author$project$Data$TranslationTag$translationTagToString, translationTags)));
	return A2(
		$author$project$Api$Endpoint$endpointWithQueryParameters,
		_List_fromArray(
			['translations']),
		_List_fromArray(
			[tagsQueryParameter]));
};
var $author$project$Data$Translation$getCollection = function (translationTags) {
	return A2(
		$author$project$Api$get,
		$author$project$Api$Endpoint$translations(translationTags),
		$elm$json$Json$Decode$list(
			$author$project$Data$Entity$decoder($author$project$Model$Translation$translationDecoder)));
};
var $author$project$Model$FormFieldTypeV2$ScreeningQuestion = F4(
	function (id, label, fieldType, required) {
		return {Hy: fieldType, dE: id, bO: label, eb: required};
	});
var $author$project$Model$FormFieldTypeV2$screeningQuestionDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'required',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'fieldType',
		$author$project$Model$FormFieldTypeV2$fieldTypeDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'label',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'id',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Model$FormFieldTypeV2$ScreeningQuestion)))));
var $author$project$Api$Endpoint$vacancyScreeningQuestions = F2(
	function (domainId, vacancyId) {
		return $author$project$Api$Endpoint$endpoint(
			_List_fromArray(
				[
					$author$project$Data$Id$toString(domainId),
					'vacancies',
					$author$project$Data$Id$toString(vacancyId),
					'screening-questions'
				]));
	});
var $author$project$Data$Vacancy$getScreeningQuestions = F2(
	function (domainId, vacancyId) {
		return A2(
			$author$project$Api$get,
			A2($author$project$Api$Endpoint$vacancyScreeningQuestions, domainId, vacancyId),
			$elm$json$Json$Decode$list($author$project$Model$FormFieldTypeV2$screeningQuestionDecoder));
	});
var $elm$core$Task$map3 = F4(
	function (func, taskA, taskB, taskC) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return A2(
					$elm$core$Task$andThen,
					function (b) {
						return A2(
							$elm$core$Task$andThen,
							function (c) {
								return $elm$core$Task$succeed(
									A3(func, a, b, c));
							},
							taskC);
					},
					taskB);
			},
			taskA);
	});
var $elm$core$Task$fail = _Scheduler_fail;
var $elm$core$Task$mapError = F2(
	function (convert, task) {
		return A2(
			$elm$core$Task$onError,
			A2($elm$core$Basics$composeL, $elm$core$Task$fail, convert),
			task);
	});
var $NoRedInk$http_upgrade_shim$Http$Legacy$handleTaskResponse = F2(
	function (req, response) {
		var _v0 = $NoRedInk$http_upgrade_shim$Http$Legacy$fromHttpResponse(response);
		if (_v0.$ === 1) {
			var err = _v0.a;
			return $elm$core$Task$fail(err);
		} else {
			var response_ = _v0.a;
			var _v1 = req.aH.bF(response_);
			if (!_v1.$) {
				var payload = _v1.a;
				return $elm$core$Task$succeed(payload);
			} else {
				var err = _v1.a;
				return $elm$core$Task$fail(err);
			}
		}
	});
var $elm$http$Http$resultToTask = function (result) {
	if (!result.$) {
		var a = result.a;
		return $elm$core$Task$succeed(a);
	} else {
		var x = result.a;
		return $elm$core$Task$fail(x);
	}
};
var $elm$http$Http$riskyTask = function (r) {
	return A3(
		_Http_toTask,
		0,
		$elm$http$Http$resultToTask,
		{as_: true, _: r._, aH: r.avq, ax: r.ax, aO: r.aO, a_: r.a_, av3: $elm$core$Maybe$Nothing, a0: r.a0});
};
var $elm$http$Http$stringResolver = A2(_Http_expect, '', $elm$core$Basics$identity);
var $elm$http$Http$task = function (r) {
	return A3(
		_Http_toTask,
		0,
		$elm$http$Http$resultToTask,
		{as_: false, _: r._, aH: r.avq, ax: r.ax, aO: r.aO, a_: r.a_, av3: $elm$core$Maybe$Nothing, a0: r.a0});
};
var $NoRedInk$http_upgrade_shim$Http$Legacy$toTask = function (req) {
	var taskReq = {
		_: req._,
		ax: req.ax,
		aO: req.aO,
		avq: $elm$http$Http$stringResolver($elm$core$Result$Ok),
		a_: req.a_,
		a0: req.a0
	};
	var task = req.bx ? $elm$http$Http$riskyTask(taskReq) : $elm$http$Http$task(taskReq);
	return A2(
		$elm$core$Task$andThen,
		$NoRedInk$http_upgrade_shim$Http$Legacy$handleTaskResponse(req),
		task);
};
var $author$project$View$ChatBot$requestFormData = F2(
	function (domainId, _v0) {
		var model = _v0.a;
		var cmds = _v0.b;
		return A2(
			$elm$core$Tuple$mapSecond,
			function (cmd) {
				return $elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[cmd, cmds]));
			},
			function () {
				var _v1 = model.G;
				if (_v1.$ === 1) {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				} else {
					var formData = _v1.a;
					var _v2 = formData.IF;
					if (!_v2.$) {
						return _Utils_Tuple2(
							model,
							A2(
								$elm$core$Task$attempt,
								$author$project$View$ChatBot$GotForm,
								A2(
									$elm$core$Task$mapError,
									A2($elm$core$Basics$composeL, $elm$core$Basics$identity, $author$project$Api$httpLegacyToHttpError),
									A4(
										$elm$core$Task$map3,
										F3(
											function (_v3, translations, screeningQuestions) {
												var resolved = _v3.a;
												var uploads = _v3.b;
												return {
													IF: A2($author$project$Data$Entity$Entity, resolved.Kq, resolved.IF),
													aeo: resolved.aeo,
													fB: screeningQuestions,
													anB: translations,
													ape: uploads
												};
											}),
										$NoRedInk$http_upgrade_shim$Http$Legacy$toTask(
											A2($author$project$Data$Vacancy$getApplicationForm, domainId, formData.aqL)),
										$NoRedInk$http_upgrade_shim$Http$Legacy$toTask(
											$author$project$Data$Translation$getCollection(
												_List_fromArray(
													[0]))),
										A2(
											$elm$core$Task$onError,
											function (_v4) {
												return $elm$core$Task$succeed(_List_Nil);
											},
											$NoRedInk$http_upgrade_shim$Http$Legacy$toTask(
												A2($author$project$Data$Vacancy$getScreeningQuestions, domainId, formData.aqL)))))));
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				}
			}());
	});
var $author$project$View$ChatBot$GotOpenApplicationForm = function (a) {
	return {$: 12, a: a};
};
var $author$project$Model$Ats$toString = function (a) {
	switch (a) {
		case 0:
			return 'afas';
		case 1:
			return 'avature';
		case 2:
			return 'bullhorn';
		case 3:
			return 'byner';
		case 4:
			return 'carerix';
		case 5:
			return 'connexys';
		case 6:
			return 'connexys-json';
		case 7:
			return 'cornerstone';
		case 8:
			return 'cv-warehouse';
		case 9:
			return 'daywize';
		case 10:
			return 'digital-recruiters';
		case 11:
			return 'easycruit';
		case 12:
			return 'emply';
		case 13:
			return 'greenhouse';
		case 14:
			return 'hamilton-cms';
		case 15:
			return 'harver';
		case 16:
			return 'hireserve';
		case 17:
			return 'homerun';
		case 18:
			return 'hr-office';
		case 19:
			return 'homerun-json';
		case 20:
			return 'jobvite';
		case 21:
			return 'jobylon';
		case 22:
			return 'jobylon-v2';
		case 23:
			return 'netive';
		case 24:
			return 'otys';
		case 25:
			return 'recruitee';
		case 26:
			return 'recruitee-ats';
		case 27:
			return 'salesforce';
		case 28:
			return 'smart-recruiters';
		case 29:
			return 'success-factors';
		case 30:
			return 'talentsoft';
		case 31:
			return 'teamtailor';
		case 32:
			return 'tigris';
		case 33:
			return 'trakstar';
		case 34:
			return 'ubeeo';
		case 35:
			return 'ubeeo-v2';
		case 36:
			return 'ubeeo-v2-events';
		case 37:
			return 'webqube';
		default:
			return 'workday';
	}
};
var $author$project$Api$Endpoint$formSchema = F3(
	function (domainKey, formKey, maybeAts) {
		return A2(
			$author$project$Api$Endpoint$endpointWithQueryParameters,
			_List_fromArray(
				[
					$author$project$Data$Id$toString(domainKey),
					'form',
					$author$project$Data$Id$toString(formKey),
					'schema'
				]),
			function () {
				if (!maybeAts.$) {
					var ats = maybeAts.a;
					return _List_fromArray(
						[
							A2(
							$elm$url$Url$Builder$string,
							'ats',
							$author$project$Model$Ats$toString(ats))
						]);
				} else {
					return _List_Nil;
				}
			}());
	});
var $author$project$Data$Form$getSchema = F3(
	function (domainKey, formKey, maybeAts) {
		return A2(
			$author$project$Api$get,
			A3($author$project$Api$Endpoint$formSchema, domainKey, formKey, maybeAts),
			$elm$json$Json$Decode$list($author$project$Model$FormV2Schema$schemaFieldDecoder));
	});
var $author$project$Api$Endpoint$form = function (formId) {
	return $author$project$Api$Endpoint$endpoint(
		_List_fromArray(
			[
				'form',
				$author$project$Data$Id$toString(formId)
			]));
};
var $author$project$Data$Form$getWithUploads = function (formId) {
	return A2(
		$author$project$Api$get,
		$author$project$Api$Endpoint$form(formId),
		A3(
			$elm$json$Json$Decode$map2,
			$elm$core$Tuple$pair,
			$author$project$Data$Entity$decoder($author$project$Model$FormV2$formDecoder),
			$elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						A2($elm$json$Json$Decode$field, 'uploads', $author$project$Data$Uploads$uploadsDecoder),
						$elm$json$Json$Decode$succeed($elm$core$Dict$empty)
					]))));
};
var $author$project$View$ChatBot$requestOpenApplicationFormData = F4(
	function (domainId, formId, nodeId, _v0) {
		var model = _v0.a;
		var cmds = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					K: $elm$core$Maybe$Just(
						{IF: $author$project$Data$Status$NotAsked, Kq: formId, O: nodeId})
				}),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						cmds,
						A2(
						$elm$core$Task$attempt,
						$author$project$View$ChatBot$GotOpenApplicationForm,
						A2(
							$elm$core$Task$mapError,
							A2($elm$core$Basics$composeL, $elm$core$Basics$identity, $author$project$Api$httpLegacyToHttpError),
							A4(
								$elm$core$Task$map3,
								F3(
									function (_v1, translations, schemaFields) {
										var form = _v1.a;
										var uploads = _v1.b;
										return {IF: form, aeo: schemaFields, fB: _List_Nil, anB: translations, ape: uploads};
									}),
								$NoRedInk$http_upgrade_shim$Http$Legacy$toTask(
									$author$project$Data$Form$getWithUploads(formId)),
								$NoRedInk$http_upgrade_shim$Http$Legacy$toTask(
									$author$project$Data$Translation$getCollection(
										_List_fromArray(
											[0]))),
								$NoRedInk$http_upgrade_shim$Http$Legacy$toTask(
									A3($author$project$Data$Form$getSchema, domainId, formId, $elm$core$Maybe$Nothing)))))
					])));
	});
var $author$project$View$ChatBot$GotVacancySearch = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var $NoRedInk$http_upgrade_shim$Http$Legacy$header = $elm$http$Http$header;
var $author$project$Api$getWithHeader = F3(
	function (url, headers, decoder) {
		return $author$project$Api$Endpoint$requestLegacy(
			{
				_: $NoRedInk$http_upgrade_shim$Http$Legacy$emptyBody,
				aH: $NoRedInk$http_upgrade_shim$Http$Legacy$expectJson(decoder),
				ax: A2(
					$elm$core$List$map,
					function (_v0) {
						var k = _v0.a;
						var v = _v0.b;
						return A2($NoRedInk$http_upgrade_shim$Http$Legacy$header, k, v);
					},
					headers),
				aO: 'GET',
				a_: $elm$core$Maybe$Nothing,
				a0: url,
				bx: false
			});
	});
var $author$project$Model$VacancySearch$ResultWithMetadata = F6(
	function (vacancies, total, overviewUrl, distanceInfo, filterFacets, filters) {
		return {Ee: distanceInfo, H$: filterFacets, If: filters, Zh: overviewUrl, ang: total, ap7: vacancies};
	});
var $author$project$Model$VacancySearch$DistanceInfo = F2(
	function (vacancyId, distanceInKm) {
		return {Ed: distanceInKm, aqL: vacancyId};
	});
var $author$project$Model$VacancySearch$distanceInfoDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'distanceInKm',
	$elm$json$Json$Decode$float,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'vacancyId',
		$author$project$Data$Id$decoder,
		$elm$json$Json$Decode$succeed($author$project$Model$VacancySearch$DistanceInfo)));
var $author$project$Model$VacancySearch$Filter = F3(
	function (filterId, filterLabel, filterEnabled) {
		return {H_: filterEnabled, H0: filterId, H2: filterLabel};
	});
var $author$project$Model$VacancySearch$filterDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'filterEnabled',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'filterLabel',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'filterId',
			$author$project$Data$Id$decoder,
			$elm$json$Json$Decode$succeed($author$project$Model$VacancySearch$Filter))));
var $author$project$Model$VacancySearch$FilterFacet = F5(
	function (filterId, filterOptionId, filterOptionLabel, preFilterVacancyCount, postFilterVacancyCount) {
		return {H0: filterId, H5: filterOptionId, H7: filterOptionLabel, $A: postFilterVacancyCount, $O: preFilterVacancyCount};
	});
var $author$project$Model$VacancySearch$filterFacetDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'postFilterVacancyCount',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'preFilterVacancyCount',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'filterOptionLabel',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'filterOptionId',
				$author$project$Data$Id$decoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'filterId',
					$author$project$Data$Id$decoder,
					$elm$json$Json$Decode$succeed($author$project$Model$VacancySearch$FilterFacet))))));
var $author$project$Model$VacancySearch$VacancyWithLocation = F2(
	function (vacancy, location) {
		return {Rs: location, aqa: vacancy};
	});
var $author$project$Model$Location$Location = function (externalId) {
	return function (domainId) {
		return function (longitude) {
			return function (latitude) {
				return function (langCode) {
					return function (name) {
						return function (displayLabel) {
							return function (country) {
								return function (city) {
									return function (address) {
										return function (postalCode) {
											return function (province) {
												return function (phone) {
													return function (emailAddress) {
														return function (contactPerson) {
															return function (image) {
																return function (companyLogo) {
																	return function (inserted) {
																		return function (updated) {
																			return function (seqNo) {
																				return function (masterDataOrigin) {
																					return {asW: address, qM: city, r0: companyLogo, sC: contactPerson, w5: country, Eb: displayLabel, dp: domainId, cm: emailAddress, GT: externalId, Nw: image, e6: inserted, Ql: langCode, QE: latitude, RZ: longitude, Sq: masterDataOrigin, dY: name, aR: phone, $B: postalCode, aau: province, agZ: seqNo, fY: updated};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Model$Location$locationDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'locationMasterDataOrigin',
	$author$project$Model$MasterDataOrigin$masterDataOriginDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'locationSeqNo',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'locationUpdated',
			$elm$json$Json$Decode$nullable($rtfeldman$elm_iso8601_date_strings$Iso8601$decoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'locationInserted',
				$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'locationCompanyLogo',
					$elm$json$Json$Decode$nullable($author$project$Model$ImageSource$imageSourceDecoder),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'locationImage',
						$elm$json$Json$Decode$nullable($author$project$Model$ImageSource$imageSourceDecoder),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'locationContactPerson',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'locationEmailAddress',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'locationPhone',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'locationProvince',
										$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'locationPostalCode',
											$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'locationAddress',
												$elm$json$Json$Decode$string,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'locationCity',
													$elm$json$Json$Decode$string,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'locationCountry',
														$elm$json$Json$Decode$string,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'locationDisplayLabel',
															$elm$json$Json$Decode$string,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'locationName',
																$elm$json$Json$Decode$string,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'locationLangCode',
																	$author$project$Model$LangCode$decoder,
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'locationLatitude',
																		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$float),
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'locationLongitude',
																			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$float),
																			A3(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																				'locationDomainId',
																				$author$project$Data$Id$decoder,
																				A3(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																					'locationExternalId',
																					$elm$json$Json$Decode$string,
																					$elm$json$Json$Decode$succeed($author$project$Model$Location$Location))))))))))))))))))))));
var $author$project$Model$Vacancy$Vacancy = function (externalId) {
	return function (domainId) {
		return function (recruiterId) {
			return function (hiringManagerId) {
				return function (isSpotlight) {
					return function (inserted) {
						return function (updated) {
							return function (deleted) {
								return function (publicationDate) {
									return function (endDate) {
										return function (title) {
											return function (subtitle) {
												return function (summary) {
													return function (publicationTitle) {
														return function (description) {
															return function (extraDescription1) {
																return function (extraDescription2) {
																	return function (extraDescription3) {
																		return function (extraDescription4) {
																			return function (extraDescription5) {
																				return function (extraDescription6) {
																					return function (extraDescription7) {
																						return function (minHours) {
																							return function (maxHours) {
																								return function (minSalary) {
																									return function (maxSalary) {
																										return function (minSalaryPerHour) {
																											return function (maxSalaryPerHour) {
																												return function (location) {
																													return function (assignedTo) {
																														return function (applicationFormType) {
																															return function (ats) {
																																return function (hidden) {
																																	return function (monsterBoardExport) {
																																		return function (extraMetadataV2) {
																																			return function (reference) {
																																				return function (indeedTitle) {
																																					return function (status) {
																																						return function (linkedInTitle) {
																																							return function (atmRecruiterId) {
																																								return function (atmHiringManagerId) {
																																									return {c0: applicationFormType, lt: assignedTo, c2: atmHiringManagerId, c3: atmRecruiterId, eH: ats, zq: deleted, dn: description, dp: domainId, F4: endDate, GT: externalId, dr: extraDescription1, ds: extraDescription2, dt: extraDescription3, du: extraDescription4, dv: extraDescription5, dw: extraDescription6, dx: extraDescription7, G6: extraMetadataV2, cs: hidden, eZ: hiringManagerId, dG: indeedTitle, e6: inserted, dL: isSpotlight, Rg: linkedInTitle, Rs: location, Sy: maxHours, SC: maxSalary, fe: maxSalaryPerHour, Te: minHours, Th: minSalary, fh: minSalaryPerHour, dV: monsterBoardExport, aax: publicationDate, aay: publicationTitle, fv: recruiterId, ea: reference, fL: status, en: subtitle, akW: summary, avV: title, fY: updated};
																																								};
																																							};
																																						};
																																					};
																																				};
																																			};
																																		};
																																	};
																																};
																															};
																														};
																													};
																												};
																											};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Vacancy$ApplicationFormType$BynerScript = F3(
	function (a, b, c) {
		return {$: 2, a: a, b: b, c: c};
	});
var $author$project$Vacancy$ApplicationFormType$EmplyApplicationForm = {$: 1};
var $author$project$Vacancy$ApplicationFormType$ExternalUrl = function (a) {
	return {$: 10, a: a};
};
var $author$project$Vacancy$ApplicationFormType$GreenhouseApplicationForm = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Vacancy$ApplicationFormType$GreenhouseIframe = function (a) {
	return {$: 5, a: a};
};
var $author$project$Vacancy$ApplicationFormType$HireserveApplicationForm = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Vacancy$ApplicationFormType$HrOfficeIframe = function (a) {
	return {$: 11, a: a};
};
var $author$project$Vacancy$ApplicationFormType$RecruiteeIframe = function (a) {
	return {$: 6, a: a};
};
var $author$project$Vacancy$ApplicationFormType$RecruiteeMatchLab = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Vacancy$ApplicationFormType$SalesforceApplicationForm = F3(
	function (a, b, c) {
		return {$: 8, a: a, b: b, c: c};
	});
var $author$project$Vacancy$ApplicationFormType$SalesforceWithQuestionnaire = F4(
	function (a, b, c, d) {
		return {$: 9, a: a, b: b, c: c, d: d};
	});
var $author$project$Vacancy$ApplicationFormType$TafkarJobApplicationForm = {$: 0};
var $author$project$Vacancy$ApplicationFormType$UbeeoV2ApplicationForm = function (a) {
	return {$: 12, a: a};
};
var $author$project$Vacancy$ApplicationFormType$applicationFormTypeDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'tafkar-job-application-form':
				return $elm$json$Json$Decode$succeed($author$project$Vacancy$ApplicationFormType$TafkarJobApplicationForm);
			case 'emply-application-form':
				return $elm$json$Json$Decode$succeed($author$project$Vacancy$ApplicationFormType$EmplyApplicationForm);
			case 'byner-script':
				return A2(
					$elm$json$Json$Decode$field,
					'contents',
					A2(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
						A2($elm$json$Json$Decode$index, 2, $elm$json$Json$Decode$string),
						A2(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
							A2($elm$json$Json$Decode$index, 1, $elm$json$Json$Decode$string),
							A2(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
								A2($elm$json$Json$Decode$index, 0, $elm$json$Json$Decode$string),
								$elm$json$Json$Decode$succeed($author$project$Vacancy$ApplicationFormType$BynerScript)))));
			case 'hireserve-application-form':
				return A2(
					$elm$json$Json$Decode$field,
					'contents',
					A2(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
						A2($elm$json$Json$Decode$index, 1, $elm$json$Json$Decode$bool),
						A2(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
							A2($elm$json$Json$Decode$index, 0, $elm$json$Json$Decode$int),
							$elm$json$Json$Decode$succeed($author$project$Vacancy$ApplicationFormType$HireserveApplicationForm))));
			case 'greenhouse-application-form':
				return A2(
					$elm$json$Json$Decode$field,
					'contents',
					A2(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
						A2($elm$json$Json$Decode$index, 1, $elm$json$Json$Decode$string),
						A2(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
							A2($elm$json$Json$Decode$index, 0, $elm$json$Json$Decode$string),
							$elm$json$Json$Decode$succeed($author$project$Vacancy$ApplicationFormType$GreenhouseApplicationForm))));
			case 'greenhouse-iframe':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Vacancy$ApplicationFormType$GreenhouseIframe));
			case 'recruitee-iframe':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Vacancy$ApplicationFormType$RecruiteeIframe));
			case 'recruitee-match-lab':
				return A2(
					$elm$json$Json$Decode$field,
					'contents',
					A2(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
						A2($elm$json$Json$Decode$index, 1, $elm$json$Json$Decode$string),
						A2(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
							A2($elm$json$Json$Decode$index, 0, $elm$json$Json$Decode$string),
							$elm$json$Json$Decode$succeed($author$project$Vacancy$ApplicationFormType$RecruiteeMatchLab))));
			case 'salesforce-application-form':
				return A2(
					$elm$json$Json$Decode$field,
					'contents',
					A2(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
						A2($elm$json$Json$Decode$index, 2, $elm$json$Json$Decode$string),
						A2(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
							A2($elm$json$Json$Decode$index, 1, $elm$json$Json$Decode$string),
							A2(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
								A2($elm$json$Json$Decode$index, 0, $elm$json$Json$Decode$string),
								$elm$json$Json$Decode$succeed($author$project$Vacancy$ApplicationFormType$SalesforceApplicationForm)))));
			case 'salesforce-with-questionnaire':
				return A2(
					$elm$json$Json$Decode$field,
					'contents',
					A2(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
						A2($elm$json$Json$Decode$index, 3, $elm$json$Json$Decode$string),
						A2(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
							A2($elm$json$Json$Decode$index, 2, $elm$json$Json$Decode$string),
							A2(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
								A2($elm$json$Json$Decode$index, 1, $elm$json$Json$Decode$string),
								A2(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
									A2($elm$json$Json$Decode$index, 0, $elm$json$Json$Decode$string),
									$elm$json$Json$Decode$succeed($author$project$Vacancy$ApplicationFormType$SalesforceWithQuestionnaire))))));
			case 'external-url':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Vacancy$ApplicationFormType$ExternalUrl));
			case 'hr-office-iframe':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Vacancy$ApplicationFormType$HrOfficeIframe));
			case 'ubeeo-v2-application-form':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$elm$json$Json$Decode$bool,
					$elm$json$Json$Decode$succeed($author$project$Vacancy$ApplicationFormType$UbeeoV2ApplicationForm));
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	A2($elm$json$Json$Decode$field, 'tag', $elm$json$Json$Decode$string));
var $author$project$Model$VacancyDescription$VacancyDescription = F2(
	function (heading, description) {
		return {dn: description, Mm: heading};
	});
var $author$project$Model$VacancyDescription$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'description',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'heading',
		$author$project$Model$Content$Heading$headingDecoder,
		$elm$json$Json$Decode$succeed($author$project$Model$VacancyDescription$VacancyDescription)));
var $author$project$Model$Metadata$AfasMeta = function (a) {
	return {$: 4, a: a};
};
var $author$project$Model$Metadata$AvatureMeta = function (a) {
	return {$: 8, a: a};
};
var $author$project$Model$Metadata$CarerixMeta = function (a) {
	return {$: 6, a: a};
};
var $author$project$Model$Metadata$EmplyMeta = function (a) {
	return {$: 5, a: a};
};
var $author$project$Model$Metadata$HireserveMeta = function (a) {
	return {$: 2, a: a};
};
var $author$project$Model$Metadata$OtysMeta = function (a) {
	return {$: 7, a: a};
};
var $author$project$Model$Metadata$UbeeoV2Meta = function (a) {
	return {$: 3, a: a};
};
var $author$project$Model$Metadata$VermaatMeta = function (a) {
	return {$: 0, a: a};
};
var $author$project$Model$Metadata$WorkdayMeta = function (a) {
	return {$: 1, a: a};
};
var $author$project$Model$Vacancy$Metadata$Afas = function (whatsapp) {
	return {asf: whatsapp};
};
var $author$project$Model$Vacancy$Metadata$afasDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'whatsapp',
	$elm$json$Json$Decode$bool,
	$elm$json$Json$Decode$succeed($author$project$Model$Vacancy$Metadata$Afas));
var $author$project$Model$Vacancy$Metadata$AvatureMetadata = function (workflowId) {
	return {ast: workflowId};
};
var $author$project$Model$Vacancy$Metadata$decodeAvatureMetadata = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'workflowId',
	$elm$json$Json$Decode$int,
	$elm$json$Json$Decode$succeed($author$project$Model$Vacancy$Metadata$AvatureMetadata));
var $author$project$Model$Vacancy$Metadata$HireserveMetadata = function (whatsappURL) {
	return {eB: whatsappURL};
};
var $author$project$Model$Vacancy$Metadata$decodeHireserveMetadata = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'whatsappURL',
	$elm$json$Json$Decode$string,
	$elm$json$Json$Decode$succeed($author$project$Model$Vacancy$Metadata$HireserveMetadata));
var $author$project$Model$Vacancy$Metadata$Otys = F3(
	function (recruiterId, recruiterName, recruiterEmail) {
		return {aa$: recruiterEmail, fv: recruiterId, aa0: recruiterName};
	});
var $author$project$Model$Vacancy$Metadata$decodeMetadata = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'recruiterEmail',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'recruiterName',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'recruiterId',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			$elm$json$Json$Decode$succeed($author$project$Model$Vacancy$Metadata$Otys))));
var $author$project$Model$Vacancy$Metadata$Emply = function (formId) {
	return {Kq: formId};
};
var $author$project$Model$Vacancy$Metadata$Emply$decodeMetadata = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'formId',
	$elm$json$Json$Decode$string,
	$elm$json$Json$Decode$succeed($author$project$Model$Vacancy$Metadata$Emply));
var $author$project$Model$Vacancy$Metadata$UbeeoV2Metadata = function (whatsappURL) {
	return {eB: whatsappURL};
};
var $author$project$Model$Vacancy$Metadata$decodeUbeeoV2Metadata = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'whatsappURL',
	$elm$json$Json$Decode$string,
	$elm$json$Json$Decode$succeed($author$project$Model$Vacancy$Metadata$UbeeoV2Metadata));
var $author$project$Model$Vacancy$Metadata$Carerix$Metadata = function (vacancyId) {
	return {aqL: vacancyId};
};
var $author$project$Model$Vacancy$Metadata$Carerix$metadataDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'vacancyId',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	$elm$json$Json$Decode$succeed($author$project$Model$Vacancy$Metadata$Carerix$Metadata));
var $author$project$Model$Vacancy$Metadata$VermaatMetadata = function (whatsapp) {
	return {asf: whatsapp};
};
var $author$project$Model$Vacancy$Metadata$vermaatMetadataDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'whatsapp',
	$elm$json$Json$Decode$bool,
	$elm$json$Json$Decode$succeed($author$project$Model$Vacancy$Metadata$VermaatMetadata));
var $author$project$Model$Vacancy$Metadata$Workday = function (isoCountryCode) {
	return {O6: isoCountryCode};
};
var $author$project$Model$ISO3166$Alpha2 = $elm$core$Basics$identity;
var $author$project$Model$ISO3166$decodeAlpha2 = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$string);
var $author$project$Model$Vacancy$Metadata$workdayDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'isoCountryCode',
	$elm$json$Json$Decode$nullable($author$project$Model$ISO3166$decodeAlpha2),
	$elm$json$Json$Decode$succeed($author$project$Model$Vacancy$Metadata$Workday));
var $author$project$Model$Metadata$metadataDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'vermaat-meta':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$Vacancy$Metadata$vermaatMetadataDecoder,
					$elm$json$Json$Decode$succeed($author$project$Model$Metadata$VermaatMeta));
			case 'workday-meta':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$Vacancy$Metadata$workdayDecoder,
					$elm$json$Json$Decode$succeed($author$project$Model$Metadata$WorkdayMeta));
			case 'hireserve-meta':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$Vacancy$Metadata$decodeHireserveMetadata,
					$elm$json$Json$Decode$succeed($author$project$Model$Metadata$HireserveMeta));
			case 'ubeeo-v2-meta':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$Vacancy$Metadata$decodeUbeeoV2Metadata,
					$elm$json$Json$Decode$succeed($author$project$Model$Metadata$UbeeoV2Meta));
			case 'afas-meta':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$Vacancy$Metadata$afasDecoder,
					$elm$json$Json$Decode$succeed($author$project$Model$Metadata$AfasMeta));
			case 'emply-meta':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$Vacancy$Metadata$Emply$decodeMetadata,
					$elm$json$Json$Decode$succeed($author$project$Model$Metadata$EmplyMeta));
			case 'carerix-meta':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$Vacancy$Metadata$Carerix$metadataDecoder,
					$elm$json$Json$Decode$succeed($author$project$Model$Metadata$CarerixMeta));
			case 'otys-meta':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$Vacancy$Metadata$decodeMetadata,
					$elm$json$Json$Decode$succeed($author$project$Model$Metadata$OtysMeta));
			case 'avature-meta':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$Vacancy$Metadata$decodeAvatureMetadata,
					$elm$json$Json$Decode$succeed($author$project$Model$Metadata$AvatureMeta));
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	A2($elm$json$Json$Decode$field, 'tag', $elm$json$Json$Decode$string));
var $author$project$Model$VacancyLocation$MultipleLocations = function (a) {
	return {$: 2, a: a};
};
var $author$project$Model$VacancyLocation$NoLocation = {$: 0};
var $author$project$Model$VacancyLocation$OneLocation = function (a) {
	return {$: 1, a: a};
};
var $author$project$Model$VacancyLocation$StandplaatsOnly = function (a) {
	return {$: 3, a: a};
};
var $author$project$Model$VacancyLocation$StandplaatsWithLocations = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Model$VacancyLocation$vacancyLocationDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'no-location':
				return $elm$json$Json$Decode$succeed($author$project$Model$VacancyLocation$NoLocation);
			case 'one-location':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Data$Id$decoder,
					$elm$json$Json$Decode$succeed($author$project$Model$VacancyLocation$OneLocation));
			case 'multiple-locations':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$elm$json$Json$Decode$list($author$project$Data$Id$decoder),
					$elm$json$Json$Decode$succeed($author$project$Model$VacancyLocation$MultipleLocations));
			case 'standplaats-only':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Data$Id$decoder,
					$elm$json$Json$Decode$succeed($author$project$Model$VacancyLocation$StandplaatsOnly));
			case 'standplaats-with-locations':
				return A2(
					$elm$json$Json$Decode$field,
					'contents',
					A2(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
						A2(
							$elm$json$Json$Decode$index,
							1,
							$elm$json$Json$Decode$list($author$project$Data$Id$decoder)),
						A2(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
							A2($elm$json$Json$Decode$index, 0, $author$project$Data$Id$decoder),
							$elm$json$Json$Decode$succeed($author$project$Model$VacancyLocation$StandplaatsWithLocations))));
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	A2($elm$json$Json$Decode$field, 'tag', $elm$json$Json$Decode$string));
var $author$project$Model$VacancyStatus$Closed = 3;
var $author$project$Model$VacancyStatus$Concept = 0;
var $author$project$Model$VacancyStatus$Paused = 2;
var $author$project$Model$VacancyStatus$Published = 1;
var $author$project$Model$VacancyStatus$vacancyStatusDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'concept':
				return $elm$json$Json$Decode$succeed(0);
			case 'published':
				return $elm$json$Json$Decode$succeed(1);
			case 'paused':
				return $elm$json$Json$Decode$succeed(2);
			case 'closed':
				return $elm$json$Json$Decode$succeed(3);
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Model$Vacancy$vacancyDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'vacancyAtmHiringManagerId',
	$elm$json$Json$Decode$nullable($author$project$Data$Id$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'vacancyAtmRecruiterId',
		$elm$json$Json$Decode$nullable($author$project$Data$Id$decoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'vacancyLinkedInTitle',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'vacancyStatus',
				$author$project$Model$VacancyStatus$vacancyStatusDecoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'vacancyIndeedTitle',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'vacancyReference',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'vacancyExtraMetadataV2',
							$elm$json$Json$Decode$nullable($author$project$Model$Metadata$metadataDecoder),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'vacancyMonsterBoardExport',
								$elm$json$Json$Decode$bool,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'vacancyHidden',
									$elm$json$Json$Decode$bool,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'vacancyAts',
										$author$project$Model$Ats$atsDecoder,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'vacancyApplicationFormType',
											$author$project$Vacancy$ApplicationFormType$applicationFormTypeDecoder,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'vacancyAssignedTo',
												$elm$json$Json$Decode$nullable($author$project$Data$Id$decoder),
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'vacancyLocation',
													$author$project$Model$VacancyLocation$vacancyLocationDecoder,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'vacancyMaxSalaryPerHour',
														$elm$json$Json$Decode$nullable($elm$json$Json$Decode$float),
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'vacancyMinSalaryPerHour',
															$elm$json$Json$Decode$nullable($elm$json$Json$Decode$float),
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'vacancyMaxSalary',
																$elm$json$Json$Decode$nullable($elm$json$Json$Decode$float),
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'vacancyMinSalary',
																	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$float),
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'vacancyMaxHours',
																		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$float),
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'vacancyMinHours',
																			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$float),
																			A3(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																				'vacancyExtraDescription7',
																				$author$project$Model$VacancyDescription$decoder,
																				A3(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																					'vacancyExtraDescription6',
																					$author$project$Model$VacancyDescription$decoder,
																					A3(
																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																						'vacancyExtraDescription5',
																						$author$project$Model$VacancyDescription$decoder,
																						A3(
																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																							'vacancyExtraDescription4',
																							$author$project$Model$VacancyDescription$decoder,
																							A3(
																								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																								'vacancyExtraDescription3',
																								$author$project$Model$VacancyDescription$decoder,
																								A3(
																									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																									'vacancyExtraDescription2',
																									$author$project$Model$VacancyDescription$decoder,
																									A3(
																										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																										'vacancyExtraDescription1',
																										$author$project$Model$VacancyDescription$decoder,
																										A3(
																											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																											'vacancyDescription',
																											$elm$json$Json$Decode$string,
																											A3(
																												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																												'vacancyPublicationTitle',
																												$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																												A3(
																													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																													'vacancySummary',
																													$elm$json$Json$Decode$string,
																													A3(
																														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																														'vacancySubtitle',
																														$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																														A3(
																															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																															'vacancyTitle',
																															$elm$json$Json$Decode$string,
																															A3(
																																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																'vacancyEndDate',
																																$elm$json$Json$Decode$nullable($rtfeldman$elm_iso8601_date_strings$Iso8601$decoder),
																																A3(
																																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																	'vacancyPublicationDate',
																																	$elm$json$Json$Decode$nullable($rtfeldman$elm_iso8601_date_strings$Iso8601$decoder),
																																	A3(
																																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																		'vacancyDeleted',
																																		$elm$json$Json$Decode$nullable($rtfeldman$elm_iso8601_date_strings$Iso8601$decoder),
																																		A3(
																																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																			'vacancyUpdated',
																																			$elm$json$Json$Decode$nullable($rtfeldman$elm_iso8601_date_strings$Iso8601$decoder),
																																			A3(
																																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																				'vacancyInserted',
																																				$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
																																				A3(
																																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																					'vacancyIsSpotlight',
																																					$elm$json$Json$Decode$bool,
																																					A3(
																																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																						'vacancyHiringManagerId',
																																						$elm$json$Json$Decode$nullable($author$project$Data$Id$decoder),
																																						A3(
																																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																							'vacancyRecruiterId',
																																							$elm$json$Json$Decode$nullable($author$project$Data$Id$decoder),
																																							A3(
																																								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																								'vacancyDomainId',
																																								$author$project$Data$Id$decoder,
																																								A3(
																																									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																									'vacancyExternalId',
																																									$elm$json$Json$Decode$string,
																																									$elm$json$Json$Decode$succeed($author$project$Model$Vacancy$Vacancy))))))))))))))))))))))))))))))))))))))))));
var $author$project$Model$VacancySearch$vacancyWithLocationDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'location',
	$elm$json$Json$Decode$nullable(
		$author$project$Data$Entity$decoder($author$project$Model$Location$locationDecoder)),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'vacancy',
		$author$project$Data$Entity$decoder($author$project$Model$Vacancy$vacancyDecoder),
		$elm$json$Json$Decode$succeed($author$project$Model$VacancySearch$VacancyWithLocation)));
var $author$project$Model$VacancySearch$resultWithMetadataDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'filters',
	$elm$json$Json$Decode$list($author$project$Model$VacancySearch$filterDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'filterFacets',
		$elm$json$Json$Decode$list($author$project$Model$VacancySearch$filterFacetDecoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'distanceInfo',
			$elm$json$Json$Decode$list($author$project$Model$VacancySearch$distanceInfoDecoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'overviewUrl',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'total',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'vacancies',
						$elm$json$Json$Decode$list($author$project$Model$VacancySearch$vacancyWithLocationDecoder),
						$elm$json$Json$Decode$succeed($author$project$Model$VacancySearch$ResultWithMetadata)))))));
var $author$project$Data$SearchParams$assignedToParam = 'a';
var $author$project$Data$SearchParams$checkedFiltersParam = 'f';
var $author$project$Data$SearchParams$cmsApplicationStatusParam = 'cst';
var $author$project$Data$SearchParams$cmsParam = 'cms';
var $author$project$Data$SearchParams$deletedParam = 'd';
var $author$project$Data$SearchParams$drivingModeParam = 'dm';
var $author$project$Data$SearchParams$insertedFromParam = 'if';
var $author$project$Data$SearchParams$insertedToParam = 'it';
var $elm$url$Url$Builder$int = F2(
	function (key, value) {
		return A2(
			$elm$url$Url$Builder$QueryParameter,
			$elm$url$Url$percentEncode(key),
			$elm$core$String$fromInt(value));
	});
var $author$project$Data$SearchParams$keywordsParam = 'keywords';
var $author$project$Data$SearchParams$limitToParam = 'n';
var $author$project$Data$SearchParams$locationNamesParam = 'ln';
var $author$project$Data$SearchParams$locationParam = 'location';
var $author$project$Data$SearchParams$maxHoursParam = 'hh';
var $author$project$Data$SearchParams$maxTravelTimeParam = 'mtt';
var $author$project$Data$SearchParams$minHoursParam = 'hl';
var $author$project$Data$SearchParams$offsetParam = 'o';
var $author$project$Data$SearchParams$salaryParam = 's';
var $author$project$Data$SearchParams$statusParam = 'st';
var $author$project$Data$DrivingMode$toString = function (drivingMode) {
	switch (drivingMode) {
		case 0:
			return 'car';
		case 1:
			return 'bike';
		case 2:
			return 'by-foot';
		default:
			return 'transit';
	}
};
var $author$project$Data$MaxTravelTime$toString = function (maxTravelTime) {
	switch (maxTravelTime) {
		case 0:
			return 'five-minutes';
		case 1:
			return 'fifteen-minutes';
		case 2:
			return 'thirty-minutes';
		case 3:
			return 'sixty-minutes';
		default:
			return 'does-not-matter';
	}
};
var $author$project$Data$VacancyStatus$toString = function (status) {
	switch (status) {
		case 1:
			return 'published';
		case 0:
			return 'concept';
		case 2:
			return 'paused';
		default:
			return 'closed';
	}
};
var $author$project$Data$SearchParams$toParams = function (params) {
	var mParam = F2(
		function (f, s) {
			return A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeL, $elm$core$List$singleton, f),
					s));
		});
	return $elm$core$List$concat(
		_List_fromArray(
			[
				_List_fromArray(
				[
					A2($elm$url$Url$Builder$int, $author$project$Data$SearchParams$salaryParam, params.adU),
					A2($elm$url$Url$Builder$int, $author$project$Data$SearchParams$offsetParam, params.XY),
					A2($elm$url$Url$Builder$int, $author$project$Data$SearchParams$limitToParam, params.QY),
					A2($elm$url$Url$Builder$string, $author$project$Data$SearchParams$locationParam, params.Rs),
					A2($elm$url$Url$Builder$string, $author$project$Data$SearchParams$keywordsParam, params.P6),
					A2(
					$elm$url$Url$Builder$string,
					$author$project$Data$SearchParams$cmsParam,
					params.OY ? 'true' : 'false')
				]),
				A2(
				mParam,
				A2(
					$elm$core$Basics$composeL,
					$elm$url$Url$Builder$string($author$project$Data$SearchParams$assignedToParam),
					$author$project$Data$Id$toString),
				params.lt),
				A2(
				mParam,
				$elm$url$Url$Builder$int($author$project$Data$SearchParams$minHoursParam),
				params.Te),
				A2(
				mParam,
				$elm$url$Url$Builder$int($author$project$Data$SearchParams$maxHoursParam),
				params.Sy),
				A2(
				$elm$core$List$map,
				A2(
					$elm$core$Basics$composeL,
					$elm$url$Url$Builder$string($author$project$Data$SearchParams$statusParam),
					$author$project$Data$VacancyStatus$toString),
				params.fL),
				A2(
				mParam,
				A2(
					$elm$core$Basics$composeL,
					$elm$url$Url$Builder$int($author$project$Data$SearchParams$deletedParam),
					$elm$time$Time$posixToMillis),
				params.zq),
				A2(
				$elm$core$List$map,
				A2(
					$elm$core$Basics$composeL,
					$elm$url$Url$Builder$string($author$project$Data$SearchParams$checkedFiltersParam),
					$author$project$Data$Id$toString),
				$elm$core$List$concat(params.da)),
				A2(
				$elm$core$List$map,
				A2(
					$elm$core$Basics$composeL,
					$elm$url$Url$Builder$string($author$project$Data$SearchParams$locationNamesParam),
					$author$project$Data$Id$toString),
				params.dQ),
				A2(
				$elm$core$List$map,
				A2(
					$elm$core$Basics$composeL,
					$elm$url$Url$Builder$string($author$project$Data$SearchParams$cmsApplicationStatusParam),
					$author$project$Data$Id$toString),
				params.rq),
				A2(
				mParam,
				A2(
					$elm$core$Basics$composeL,
					$elm$url$Url$Builder$int($author$project$Data$SearchParams$insertedFromParam),
					$elm$time$Time$posixToMillis),
				params.N5),
				A2(
				mParam,
				A2(
					$elm$core$Basics$composeL,
					$elm$url$Url$Builder$int($author$project$Data$SearchParams$insertedToParam),
					$elm$time$Time$posixToMillis),
				params.N6),
				A2(
				mParam,
				A2(
					$elm$core$Basics$composeL,
					$elm$url$Url$Builder$string($author$project$Data$SearchParams$maxTravelTimeParam),
					$author$project$Data$MaxTravelTime$toString),
				params.SD),
				A2(
				mParam,
				A2(
					$elm$core$Basics$composeL,
					$elm$url$Url$Builder$string($author$project$Data$SearchParams$drivingModeParam),
					$author$project$Data$DrivingMode$toString),
				params.EC)
			]));
};
var $author$project$Api$Endpoint$vacancySearch = F2(
	function (domainId, params) {
		return A2(
			$author$project$Api$Endpoint$endpointWithQueryParameters,
			_List_fromArray(
				[
					$author$project$Data$Id$toString(domainId),
					'vacancy-search'
				]),
			params);
	});
var $author$project$Data$VacancySearch$get = F3(
	function (domainId, csrfToken, params) {
		return A3(
			$author$project$Api$getWithHeader,
			A2(
				$author$project$Api$Endpoint$vacancySearch,
				domainId,
				$author$project$Data$SearchParams$toParams(params)),
			_List_fromArray(
				[
					_Utils_Tuple2('X-XSRF-TOKEN', csrfToken)
				]),
			$author$project$Model$VacancySearch$resultWithMetadataDecoder);
	});
var $author$project$View$ChatBot$requestVacancySearch = F4(
	function (nodeId, domainId, csrfToken, searchParams) {
		return A2(
			$author$project$Api$send,
			A2($author$project$View$ChatBot$GotVacancySearch, nodeId, searchParams),
			A3($author$project$Data$VacancySearch$get, domainId, csrfToken, searchParams));
	});
var $author$project$View$ChatBot$additionalNodeData = F3(
	function (domainId, node, model) {
		var _v0 = node.bh;
		_v0$4:
		while (true) {
			switch (_v0.$) {
				case 8:
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				case 5:
					if (!_v0.a.$) {
						var salaryCalculatorId = _v0.a.a;
						var _v1 = A2($author$project$Dict$Custom$get, salaryCalculatorId, model.bo);
						if (_v1.$ === 1) {
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										bo: A3($author$project$Dict$Custom$insert, salaryCalculatorId, $author$project$Data$Status$Loading, model.bo)
									}),
								A2(
									$author$project$Api$send,
									$author$project$View$ChatBot$GotSalaryCalculator(salaryCalculatorId),
									A2($author$project$Data$SalaryCalculator$get, domainId, salaryCalculatorId)));
						} else {
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						}
					} else {
						break _v0$4;
					}
				case 4:
					var settings = _v0.a;
					var originalSearchParams = A2($author$project$View$ChatBot$getOriginalSearchParams, node.dE, model.Y);
					var baseSearchParams = _Utils_update(
						originalSearchParams,
						{
							da: _List_fromArray(
								[settings.awg])
						});
					var searchParams = model.S ? _Utils_update(
						baseSearchParams,
						{QY: 3}) : baseSearchParams;
					var _v2 = A2($author$project$Dict$Custom$get, node.dE, model.Y);
					if (!_v2.$) {
						switch (_v2.a.$) {
							case 0:
								var _v3 = _v2.a;
								return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
							case 1:
								var _v4 = _v2.a;
								return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
							case 2:
								return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
							default:
								var _v5 = _v2.a.a;
								var cachedSearchParams = _v5.a;
								return A2(
									$author$project$View$ChatBot$requestFormData,
									domainId,
									_Utils_eq(cachedSearchParams, searchParams) ? _Utils_Tuple2(model, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(
										_Utils_update(
											model,
											{
												Y: A3($author$project$Dict$Custom$insert, node.dE, $author$project$Data$Status$Loading, model.Y)
											}),
										A4($author$project$View$ChatBot$requestVacancySearch, node.dE, domainId, model.ci, searchParams)));
						}
					} else {
						return A2(
							$author$project$View$ChatBot$requestFormData,
							domainId,
							_Utils_Tuple2(
								_Utils_update(
									model,
									{
										Y: A3($author$project$Dict$Custom$insert, node.dE, $author$project$Data$Status$Loading, model.Y)
									}),
								A4($author$project$View$ChatBot$requestVacancySearch, node.dE, domainId, model.ci, searchParams)));
					}
				case 9:
					if (!_v0.a.$) {
						var formId = _v0.a.a;
						return _Utils_eq(
							A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.O;
								},
								model.K),
							$elm$core$Maybe$Just(node.dE)) ? _Utils_Tuple2(model, $elm$core$Platform$Cmd$none) : A4(
							$author$project$View$ChatBot$requestOpenApplicationFormData,
							domainId,
							formId,
							node.dE,
							_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
					} else {
						break _v0$4;
					}
				default:
					break _v0$4;
			}
		}
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$View$ChatBot$requestAdditionalNodeData = F2(
	function (domainId, _v0) {
		var model = _v0.a;
		var cmds = _v0.b;
		var step = F2(
			function (node, _v1) {
				var accModel = _v1.a;
				var accCmds = _v1.b;
				return A2(
					$elm$core$Tuple$mapSecond,
					function (additionalCmds) {
						return $elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[additionalCmds, accCmds]));
					},
					A3(
						$author$project$View$ChatBot$additionalNodeData,
						domainId,
						$zwilias$elm_rosetree$Tree$label(node),
						accModel));
			});
		return A3(
			$elm$core$List$foldl,
			step,
			_Utils_Tuple2(model, cmds),
			$author$project$Data$ChatBot$currentAndBefore(model.qj));
	});
var $author$project$ScrollToInElement$SetTarget = function (a) {
	return {$: 2, a: a};
};
var $elm$browser$Browser$Dom$getViewportOf = _Browser_getViewportOf;
var $author$project$ScrollToInElement$scrollToCustomTask = F2(
	function (_v0, f) {
		var nodeId = _v0.a;
		return A2(
			$elm$core$Task$attempt,
			$author$project$ScrollToInElement$SetTarget,
			A2(
				$elm$core$Task$andThen,
				f,
				$elm$browser$Browser$Dom$getViewportOf(nodeId)));
	});
var $author$project$ScrollToInElement$scrollToCustom = F2(
	function (state, f) {
		return A2(
			$author$project$ScrollToInElement$scrollToCustomTask,
			state,
			A2($elm$core$Basics$composeL, $elm$core$Task$succeed, f));
	});
var $author$project$ScrollToInElement$scrollToBottom = function (state) {
	var f = function (_v0) {
		var scene = _v0.avu;
		var viewport = _v0.awo;
		return {
			KG: {asz: viewport.asz, m: viewport.m},
			am$: {asz: viewport.asz, m: scene.Mq - viewport.Mq}
		};
	};
	return A2($author$project$ScrollToInElement$scrollToCustom, state, f);
};
var $zwilias$elm_rosetree$Tree$Zipper$toTree = A2($elm$core$Basics$composeL, $zwilias$elm_rosetree$Tree$Zipper$tree, $zwilias$elm_rosetree$Tree$Zipper$root);
var $author$project$View$ChatBot$focusOn = F3(
	function (domainId, nodeId, model) {
		var nextModel = _Utils_update(
			model,
			{
				qj: A2(
					$elm$core$Maybe$withDefault,
					model.qj,
					A2(
						$zwilias$elm_rosetree$Tree$Zipper$findFromRoot,
						function (n) {
							return A2($author$project$Data$ChatBot$nodeIdEquals, n.dE, nodeId);
						},
						$zwilias$elm_rosetree$Tree$Zipper$fromTree(
							$zwilias$elm_rosetree$Tree$Zipper$toTree(model.qj))))
			});
		return A2(
			$author$project$View$ChatBot$requestAdditionalNodeData,
			domainId,
			_Utils_Tuple2(
				nextModel,
				$elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							A2(
							$elm$core$Platform$Cmd$map,
							$author$project$View$ChatBot$ScrollToMsg,
							$author$project$ScrollToInElement$scrollToBottom(model.V)),
							$author$project$View$ChatBot$queueNextNodeToShow(nextModel)
						]))));
	});
var $elm$core$String$padLeft = F3(
	function (n, _char, string) {
		return _Utils_ap(
			A2(
				$elm$core$String$repeat,
				n - $elm$core$String$length(string),
				$elm$core$String$fromChar(_char)),
			string);
	});
var $author$project$Util$UUID$fromString = function (input) {
	var hash = A3(
		$elm$core$List$foldl,
		F2(
			function (val, acc) {
				return A2($elm$core$Basics$modBy, 2147483647, (acc * 31) + val);
			}),
		0,
		A2(
			$elm$core$List$indexedMap,
			F2(
				function (i, c) {
					return $elm$core$Char$toCode(c) * (i + 1);
				}),
			$elm$core$String$toList(input)));
	var hashStr = $elm$core$String$fromInt(
		$elm$core$Basics$abs(hash));
	var paddedHash = A3($elm$core$String$padLeft, 32, '0', hashStr) + '00000000';
	var uuidStr = A3($elm$core$String$slice, 0, 8, paddedHash) + ('-' + (A3($elm$core$String$slice, 8, 12, paddedHash) + ('-' + ('4' + (A3($elm$core$String$slice, 12, 15, paddedHash) + ('-' + ('8' + (A3($elm$core$String$slice, 15, 18, paddedHash) + ('-' + A3($elm$core$String$slice, 18, 30, paddedHash))))))))));
	return $danyx23$elm_uuid$Uuid$fromString(uuidStr);
};
var $author$project$Data$ChatBot$generateUuidId = F2(
	function (path, node) {
		var pathStr = A2(
			$elm$core$String$join,
			'_',
			A2($elm$core$List$map, $elm$core$String$fromInt, path));
		var contentHash = function () {
			switch (node.$) {
				case 10:
					return 'root';
				case 1:
					var content = node.a;
					return 'text_' + content;
				case 2:
					var content = node.a;
					return 'title_' + content;
				case 0:
					var content = node.a;
					return 'option_' + content;
				case 3:
					var settings = node.a;
					return 'link_' + settings.avV;
				case 6:
					var url = node.a;
					return 'image_' + function () {
						switch (url.$) {
							case 1:
								var u = url.a;
								return u;
							case 2:
								var u = url.a;
								return u;
							default:
								var id = url.a;
								return $author$project$Data$Id$toString(id);
						}
					}();
				case 7:
					var url = node.a;
					return 'video_' + function () {
						switch (url.$) {
							case 1:
								var u = url.a;
								return u;
							case 2:
								var u = url.a;
								return u;
							default:
								var id = url.a;
								return $author$project$Data$Id$toString(id);
						}
					}();
				case 4:
					return 'vacancy_overview';
				case 5:
					return 'salary_calc';
				case 8:
					var maybeId = node.a;
					if (!maybeId.$) {
						var chatId = maybeId.a;
						return 'embedded_chat_' + $author$project$Data$Id$toString(chatId);
					} else {
						return 'embedded_chat_none';
					}
				default:
					var maybeFormId = node.a;
					if (!maybeFormId.$) {
						var formId = maybeFormId.a;
						return 'open_application_form_' + $author$project$Data$Id$toString(formId);
					} else {
						return 'open_application_form_none';
					}
			}
		}();
		var nodeIdentifier = pathStr + ('_' + contentHash);
		var _v0 = $author$project$Util$UUID$fromString(nodeIdentifier);
		if (!_v0.$) {
			var uuid = _v0.a;
			return $author$project$Data$ChatBot$UuidNodeId(uuid);
		} else {
			var _v1 = $author$project$Util$UUID$fromString('fallback_uuid');
			if (!_v1.$) {
				var fallbackUuid = _v1.a;
				return $author$project$Data$ChatBot$UuidNodeId(fallbackUuid);
			} else {
				return $author$project$Data$ChatBot$NodeIdUnset;
			}
		}
	});
var $author$project$Data$ChatBot$assignUuidIdsHelper = F2(
	function (path, tree) {
		var currentNode = $zwilias$elm_rosetree$Tree$label(tree);
		var uuidId = A2($author$project$Data$ChatBot$generateUuidId, path, currentNode.bh);
		var updatedNode = _Utils_update(
			currentNode,
			{dE: uuidId});
		var children = $zwilias$elm_rosetree$Tree$children(tree);
		var updatedChildren = A2(
			$elm$core$List$indexedMap,
			F2(
				function (index, child) {
					return A2(
						$author$project$Data$ChatBot$assignUuidIdsHelper,
						_Utils_ap(
							path,
							_List_fromArray(
								[index])),
						child);
				}),
			children);
		return A2($zwilias$elm_rosetree$Tree$tree, updatedNode, updatedChildren);
	});
var $author$project$Data$ChatBot$assignUuidIds = function (tree) {
	return A2($author$project$Data$ChatBot$assignUuidIdsHelper, _List_Nil, tree);
};
var $zwilias$elm_rosetree$Tree$Zipper$append = F2(
	function (t, _v0) {
		var zipper = _v0;
		return _Utils_update(
			zipper,
			{
				hf: A2($elm$core$List$cons, t, zipper.hf)
			});
	});
var $author$project$Data$ChatBot$withZipper = F3(
	function (id, tree, f) {
		return A2(
			$elm$core$Maybe$withDefault,
			tree,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeL,
					A2(
						$elm$core$Basics$composeL,
						A2($elm$core$Basics$composeL, $author$project$Data$ChatBot$setDepth, $author$project$Data$ChatBot$updateNewIds),
						$zwilias$elm_rosetree$Tree$Zipper$toTree),
					f),
				A2(
					$zwilias$elm_rosetree$Tree$Zipper$findFromRoot,
					A2(
						$elm$core$Basics$composeL,
						$elm$core$Basics$eq(id),
						function ($) {
							return $.dE;
						}),
					$zwilias$elm_rosetree$Tree$Zipper$fromTree(tree))));
	});
var $author$project$Data$ChatBot$appendTree = F3(
	function (toAppend, id, tree) {
		return A3(
			$author$project$Data$ChatBot$withZipper,
			id,
			tree,
			$zwilias$elm_rosetree$Tree$Zipper$append(toAppend));
	});
var $zwilias$elm_rosetree$Tree$Zipper$reconstructWithoutFocus = F3(
	function (l, before, after) {
		return A2(
			$zwilias$elm_rosetree$Tree$tree,
			l,
			_Utils_ap(
				$elm$core$List$reverse(before),
				after));
	});
var $zwilias$elm_rosetree$Tree$Zipper$removeTree = function (_v0) {
	var zipper = _v0;
	var _v1 = _Utils_Tuple3(zipper.J, zipper.oH, zipper.hf);
	if (_v1.a.b) {
		var _v2 = _v1.a;
		var crumb = _v2.a;
		var rest = _v2.b;
		var before = _v1.b;
		var after = _v1.c;
		return $elm$core$Maybe$Just(
			{
				hf: crumb.hf,
				oH: crumb.oH,
				J: rest,
				Iz: A3($zwilias$elm_rosetree$Tree$Zipper$reconstructWithoutFocus, crumb.bO, before, after)
			});
	} else {
		if (_v1.b.b) {
			var _v3 = _v1.b;
			var b = _v3.a;
			var bs = _v3.b;
			var after = _v1.c;
			return $elm$core$Maybe$Just(
				{hf: after, oH: bs, J: _List_Nil, Iz: b});
		} else {
			if (!_v1.c.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var _v4 = _v1.c;
				var a = _v4.a;
				var as_ = _v4.b;
				return $elm$core$Maybe$Just(
					{hf: as_, oH: _List_Nil, J: _List_Nil, Iz: a});
			}
		}
	}
};
var $author$project$Data$ChatBot$deleteNode = F2(
	function (id, tree) {
		return A3(
			$author$project$Data$ChatBot$withZipper,
			id,
			tree,
			function (z) {
				return A2(
					$elm$core$Maybe$withDefault,
					z,
					$zwilias$elm_rosetree$Tree$Zipper$removeTree(z));
			});
	});
var $author$project$Data$ChatBot$embeddedRecruitmentChatIds = A2(
	$zwilias$elm_rosetree$Tree$foldl,
	F2(
		function (x, acc) {
			var _v0 = x.bh;
			if ((_v0.$ === 8) && (!_v0.a.$)) {
				var recruitmentChatId = _v0.a.a;
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(x.dE, recruitmentChatId),
					acc);
			} else {
				return acc;
			}
		}),
	_List_Nil);
var $author$project$Data$ChatBot$fromChatBotHelperStable = F3(
	function (recursiveDepth, embeddableChatBots, tree) {
		var embeddedIds = $author$project$Data$ChatBot$embeddedRecruitmentChatIds(tree);
		return A4($author$project$Data$ChatBot$replaceEmbeddedChatBotStable, recursiveDepth, embeddableChatBots, tree, embeddedIds);
	});
var $author$project$Data$ChatBot$replaceEmbeddedChatBotStable = F4(
	function (recursiveDepth, embeddableChatBots, tree, idsToReplace) {
		var replace = F2(
			function (_v1, acc) {
				var nodeId = _v1.a;
				var recruitmentChatId = _v1.b;
				var _v0 = A2($author$project$Dict$Custom$get, recruitmentChatId, embeddableChatBots);
				if (_v0.$ === 1) {
					return acc;
				} else {
					var embeddableChatBot = _v0.a;
					return A2(
						$author$project$Data$ChatBot$deleteNode,
						nodeId,
						A3(
							$elm$core$List$foldr,
							F2(
								function (child, acc2) {
									return A3(
										$author$project$Data$ChatBot$appendTree,
										A2($zwilias$elm_rosetree$Tree$map, $author$project$Data$ChatBot$newNodeWithId, child),
										nodeId,
										acc2);
								}),
							acc,
							$zwilias$elm_rosetree$Tree$children(embeddableChatBot)));
				}
			});
		return ($elm$core$List$isEmpty(idsToReplace) || (recursiveDepth > 4)) ? tree : A3(
			$author$project$Data$ChatBot$fromChatBotHelperStable,
			recursiveDepth + 1,
			embeddableChatBots,
			A3(
				$elm$core$List$foldl,
				replace,
				tree,
				$author$project$Data$ChatBot$embeddedRecruitmentChatIds(tree)));
	});
var $author$project$Data$ChatBot$fromChatBotWithEmbedded = F2(
	function (embeddableChatBots, _v0) {
		var tree = _v0;
		var initialTree = A2($zwilias$elm_rosetree$Tree$map, $author$project$Data$ChatBot$newNodeWithId, tree);
		var afterHelper = A3($author$project$Data$ChatBot$fromChatBotHelperStable, 0, embeddableChatBots, initialTree);
		var afterUuidIds = $author$project$Data$ChatBot$assignUuidIds(afterHelper);
		var finalTree = $author$project$Data$ChatBot$setDepth(afterUuidIds);
		return finalTree;
	});
var $author$project$View$ChatBot$init = F2(
	function (lift, config) {
		return A2(
			$elm$core$Tuple$mapSecond,
			$elm$core$Platform$Cmd$map(lift),
			function () {
				var _v0 = config.dP;
				if (_v0.$ === 1) {
					var model = _Utils_update(
						$author$project$View$ChatBot$empty,
						{
							qj: $zwilias$elm_rosetree$Tree$Zipper$fromTree(
								A2($author$project$Data$ChatBot$fromChatBotWithEmbedded, config.FG, config.qj)),
							c9: config.FG,
							ci: config.ci,
							S: config.S,
							ft: config.ft,
							aV: config.aV,
							aW: config.aW,
							ape: config.ape,
							a3: config.a3
						});
					return A2(
						$author$project$View$ChatBot$requestAdditionalNodeData,
						config.dp,
						_Utils_Tuple2(
							model,
							$author$project$View$ChatBot$queueNextNodeToShow(model)));
				} else {
					var localStorageState = _v0.a;
					var model = _Utils_update(
						$author$project$View$ChatBot$empty,
						{
							G: A3(
								$elm$core$Maybe$map2,
								F2(
									function (nodeId, vacancyId) {
										return {IF: $author$project$Data$Status$NotAsked, O: nodeId, aqL: vacancyId};
									}),
								localStorageState.ahI,
								localStorageState.ahJ),
							K: A3(
								$elm$core$Maybe$map2,
								F2(
									function (nodeId, formId) {
										return {IF: $author$project$Data$Status$NotAsked, Kq: formId, O: nodeId};
									}),
								localStorageState.ah7,
								localStorageState.ah6),
							qj: $zwilias$elm_rosetree$Tree$Zipper$fromTree(
								A2($author$project$Data$ChatBot$fromChatBotWithEmbedded, config.FG, config.qj)),
							c9: config.FG,
							ci: config.ci,
							S: config.S,
							ft: config.ft,
							aV: config.aV,
							at: localStorageState.at,
							aW: config.aW,
							ape: config.ape,
							a3: config.a3
						});
					return A3($author$project$View$ChatBot$focusOn, config.dp, localStorageState.O, model);
				}
			}());
	});
var $author$project$RecruitmentChat$init = function (flags) {
	var sessionToken = $elm$core$Maybe$Just(flags.aW);
	var recruitmentChats = A2(
		$author$project$Dict$Custom$fromListVia,
		$author$project$Data$Id$emptyDict,
		A2(
			$elm$core$List$map,
			function (_v1) {
				var id = _v1.a;
				var val = _v1.b;
				return _Utils_Tuple2(id, val.qj);
			},
			flags.cH));
	var recruitmentChat = $author$project$Data$Entity$value(flags.aa4);
	var _v0 = A2(
		$author$project$View$ChatBot$init,
		$author$project$RecruitmentChat$ChatBotMsg,
		{qj: recruitmentChat.qj, ci: flags.ci, S: flags.S, dp: recruitmentChat.dp, FG: recruitmentChats, dP: flags.dP, ft: flags.ft, aV: flags.aV, aW: sessionToken, ape: flags.ape, a3: flags.a3});
	var chatBot = _v0.a;
	var chatBotCmd = _v0.b;
	return _Utils_Tuple2(
		{qj: chatBot, ci: flags.ci, S: flags.S, dp: flags.dp, Ql: flags.Ql, ft: flags.ft, aV: flags.aV, aa4: recruitmentChat, cH: recruitmentChats, aW: sessionToken, bp: flags.fE, eh: true, fV: flags.fV, ape: flags.ape, a3: flags.a3, cX: flags.cX},
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A2($author$project$RecruitmentChat$delayShowChatBot, flags.aht, flags.fE),
					chatBotCmd,
					$author$project$RecruitmentChat$autoHideIntroduction
				])));
};
var $author$project$RecruitmentChat$GotCsrfToken = function (a) {
	return {$: 5, a: a};
};
var $author$project$View$ChatBot$LocationSuggestionsMsg = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$View$ChatBot$OnLocationSelect = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$View$ChatBot$locationSuggestionsConfig = F4(
	function (domainId, nodeId, sessionToken, csrfToken) {
		return {
			db: '',
			ci: csrfToken,
			dp: domainId,
			aul: $elm$core$Maybe$Nothing,
			aut: $author$project$View$ChatBot$LocationSuggestionsMsg(nodeId),
			avy: 1,
			aW: sessionToken,
			avO: $author$project$View$Autocomplete$Http$Button(
				{
					avN: $author$project$View$ChatBot$OnLocationSelect(nodeId),
					av2: $elm$core$Maybe$Nothing
				}),
			avS: $elm$core$Maybe$Nothing,
			fX: 'location-chatbot'
		};
	});
var $author$project$ScrollToInElement$Tick = function (a) {
	return {$: 1, a: a};
};
var $tad_lispy$springs$Spring$atRest = function (_v0) {
	var _this = _v0;
	return _Utils_eq(_this.ey, _this.alt) && (_this.bt === 0.0);
};
var $author$project$ScrollToInElement$isScrolling = function (_v0) {
	var springs = _v0.b;
	return !($tad_lispy$springs$Spring$atRest(springs.asz) && $tad_lispy$springs$Spring$atRest(springs.m));
};
var $elm$browser$Browser$AnimationManager$Delta = function (a) {
	return {$: 1, a: a};
};
var $elm$browser$Browser$AnimationManager$State = F3(
	function (subs, request, oldTime) {
		return {fq: oldTime, ac6: request, akz: subs};
	});
var $elm$browser$Browser$AnimationManager$init = $elm$core$Task$succeed(
	A3($elm$browser$Browser$AnimationManager$State, _List_Nil, $elm$core$Maybe$Nothing, 0));
var $elm$browser$Browser$AnimationManager$now = _Browser_now(0);
var $elm$browser$Browser$AnimationManager$rAF = _Browser_rAF(0);
var $elm$browser$Browser$AnimationManager$onEffects = F3(
	function (router, subs, _v0) {
		var request = _v0.ac6;
		var oldTime = _v0.fq;
		var _v1 = _Utils_Tuple2(request, subs);
		if (_v1.a.$ === 1) {
			if (!_v1.b.b) {
				var _v2 = _v1.a;
				return $elm$browser$Browser$AnimationManager$init;
			} else {
				var _v4 = _v1.a;
				return A2(
					$elm$core$Task$andThen,
					function (pid) {
						return A2(
							$elm$core$Task$andThen,
							function (time) {
								return $elm$core$Task$succeed(
									A3(
										$elm$browser$Browser$AnimationManager$State,
										subs,
										$elm$core$Maybe$Just(pid),
										time));
							},
							$elm$browser$Browser$AnimationManager$now);
					},
					$elm$core$Process$spawn(
						A2(
							$elm$core$Task$andThen,
							$elm$core$Platform$sendToSelf(router),
							$elm$browser$Browser$AnimationManager$rAF)));
			}
		} else {
			if (!_v1.b.b) {
				var pid = _v1.a.a;
				return A2(
					$elm$core$Task$andThen,
					function (_v3) {
						return $elm$browser$Browser$AnimationManager$init;
					},
					$elm$core$Process$kill(pid));
			} else {
				return $elm$core$Task$succeed(
					A3($elm$browser$Browser$AnimationManager$State, subs, request, oldTime));
			}
		}
	});
var $elm$browser$Browser$AnimationManager$onSelfMsg = F3(
	function (router, newTime, _v0) {
		var subs = _v0.akz;
		var oldTime = _v0.fq;
		var send = function (sub) {
			if (!sub.$) {
				var tagger = sub.a;
				return A2(
					$elm$core$Platform$sendToApp,
					router,
					tagger(
						$elm$time$Time$millisToPosix(newTime)));
			} else {
				var tagger = sub.a;
				return A2(
					$elm$core$Platform$sendToApp,
					router,
					tagger(newTime - oldTime));
			}
		};
		return A2(
			$elm$core$Task$andThen,
			function (pid) {
				return A2(
					$elm$core$Task$andThen,
					function (_v1) {
						return $elm$core$Task$succeed(
							A3(
								$elm$browser$Browser$AnimationManager$State,
								subs,
								$elm$core$Maybe$Just(pid),
								newTime));
					},
					$elm$core$Task$sequence(
						A2($elm$core$List$map, send, subs)));
			},
			$elm$core$Process$spawn(
				A2(
					$elm$core$Task$andThen,
					$elm$core$Platform$sendToSelf(router),
					$elm$browser$Browser$AnimationManager$rAF)));
	});
var $elm$browser$Browser$AnimationManager$Time = function (a) {
	return {$: 0, a: a};
};
var $elm$browser$Browser$AnimationManager$subMap = F2(
	function (func, sub) {
		if (!sub.$) {
			var tagger = sub.a;
			return $elm$browser$Browser$AnimationManager$Time(
				A2($elm$core$Basics$composeL, func, tagger));
		} else {
			var tagger = sub.a;
			return $elm$browser$Browser$AnimationManager$Delta(
				A2($elm$core$Basics$composeL, func, tagger));
		}
	});
_Platform_effectManagers['Browser.AnimationManager'] = _Platform_createManager($elm$browser$Browser$AnimationManager$init, $elm$browser$Browser$AnimationManager$onEffects, $elm$browser$Browser$AnimationManager$onSelfMsg, 0, $elm$browser$Browser$AnimationManager$subMap);
var $elm$browser$Browser$AnimationManager$subscription = _Platform_leaf('Browser.AnimationManager');
var $elm$browser$Browser$AnimationManager$onAnimationFrameDelta = function (tagger) {
	return $elm$browser$Browser$AnimationManager$subscription(
		$elm$browser$Browser$AnimationManager$Delta(tagger));
};
var $elm$browser$Browser$Events$onAnimationFrameDelta = $elm$browser$Browser$AnimationManager$onAnimationFrameDelta;
var $author$project$ScrollToInElement$subscriptions = F2(
	function (lift, state) {
		return $author$project$ScrollToInElement$isScrolling(state) ? A2(
			$elm$core$Platform$Sub$map,
			lift,
			$elm$browser$Browser$Events$onAnimationFrameDelta($author$project$ScrollToInElement$Tick)) : $elm$core$Platform$Sub$none;
	});
var $author$project$View$ChatBot$subscriptions = F3(
	function (lift, domainId, model) {
		return A2(
			$elm$core$Platform$Sub$map,
			lift,
			$elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2($author$project$ScrollToInElement$subscriptions, $author$project$View$ChatBot$ScrollToMsg, model.V),
						function () {
						var _v0 = model.az;
						if (_v0.$ === 1) {
							return $elm$core$Platform$Sub$none;
						} else {
							var _v1 = _v0.a;
							var nodeId = _v1.a;
							var locationSuggestions = _v1.b;
							return A2(
								$author$project$View$LocationSuggestions$subscriptions,
								A4($author$project$View$ChatBot$locationSuggestionsConfig, domainId, nodeId, model.aW, model.ci),
								locationSuggestions);
						}
					}()
					])));
	});
var $author$project$RecruitmentChat$updateRecruitmentChatCsrfToken = _Platform_incomingPort('updateRecruitmentChatCsrfToken', $elm$json$Json$Decode$string);
var $author$project$RecruitmentChat$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A3($author$project$View$ChatBot$subscriptions, $author$project$RecruitmentChat$ChatBotMsg, model.dp, model.qj),
				$author$project$RecruitmentChat$updateRecruitmentChatCsrfToken($author$project$RecruitmentChat$GotCsrfToken)
			]));
};
var $author$project$View$ChatBot$GotCsrfToken = function (a) {
	return {$: 19, a: a};
};
var $author$project$Api$csrfTokenWithDefault = F2(
	function (current, fresh) {
		return $elm$core$String$isEmpty(fresh) ? current : fresh;
	});
var $elm$json$Json$Encode$int = _Json_wrap;
var $author$project$Data$Id$encode = function (_v0) {
	var id = _v0;
	return $elm$json$Json$Encode$int(id);
};
var $elm$json$Json$Encode$list = F2(
	function (func, entries) {
		return _Json_wrap(
			A3(
				$elm$core$List$foldl,
				_Json_addEntry(func),
				_Json_emptyArray(0),
				entries));
	});
var $author$project$Dict$Custom$encode = F3(
	function (_v0, g, h) {
		var f = _v0.b;
		var dict = _v0.c;
		return A2(
			$elm$json$Json$Encode$list,
			function (_v1) {
				var k = _v1.a;
				var v = _v1.b;
				return A2(
					$elm$json$Json$Encode$list,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							g(
							f(k)),
							h(v)
						]));
			},
			$elm$core$Dict$toList(dict));
	});
var $author$project$Data$ChatBot$encodeNodeId = function (nodeId) {
	switch (nodeId.$) {
		case 2:
			return $elm$json$Json$Encode$int(0);
		case 0:
			var id = nodeId.a;
			return $elm$json$Json$Encode$int(id);
		default:
			var uuid = nodeId.a;
			return $elm$json$Json$Encode$string(
				$danyx23$elm_uuid$Uuid$toString(uuid));
	}
};
var $author$project$View$ChatBot$encodeLocalStorageState = function (model) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'nodeId',
				$author$project$Data$ChatBot$encodeNodeId(
					$zwilias$elm_rosetree$Tree$Zipper$label(model.qj).dE)),
				_Utils_Tuple2(
				'showFormOfVacancyId',
				A2(
					$elm$core$Maybe$withDefault,
					$elm$json$Json$Encode$null,
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeL,
							$author$project$Data$Id$encode,
							function ($) {
								return $.aqL;
							}),
						model.G))),
				_Utils_Tuple2(
				'showFormOfNodeId',
				A2(
					$elm$core$Maybe$withDefault,
					$elm$json$Json$Encode$null,
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeL,
							$author$project$Data$ChatBot$encodeNodeId,
							function ($) {
								return $.O;
							}),
						model.G))),
				_Utils_Tuple2(
				'salaryCalculatorInput',
				A3(
					$author$project$Dict$Custom$encode,
					model.at,
					$author$project$Data$ChatBot$encodeNodeId,
					function (x) {
						return $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'age',
									$elm$json$Json$Encode$int(x.hj)),
									_Utils_Tuple2(
									'hours',
									$elm$json$Json$Encode$int(x.MX))
								]));
					})),
				_Utils_Tuple2(
				'showOpenApplicationFormId',
				A2(
					$elm$core$Maybe$withDefault,
					$elm$json$Json$Encode$null,
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeL,
							$author$project$Data$Id$encode,
							function ($) {
								return $.Kq;
							}),
						model.K))),
				_Utils_Tuple2(
				'showOpenApplicationNodeId',
				A2(
					$elm$core$Maybe$withDefault,
					$elm$json$Json$Encode$null,
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeL,
							$author$project$Data$ChatBot$encodeNodeId,
							function ($) {
								return $.O;
							}),
						model.K)))
			]));
};
var $author$project$RecruitmentChat$requestRecruitmentChatCsrfToken = _Platform_outgoingPort('requestRecruitmentChatCsrfToken', $elm$json$Json$Encode$bool);
var $author$project$RecruitmentChat$showRecruitmentChat = _Platform_outgoingPort('showRecruitmentChat', $elm$json$Json$Encode$bool);
var $author$project$View$ChatBot$storeLocalStorageState = _Platform_outgoingPort('storeLocalStorageState', $elm$core$Basics$identity);
var $author$project$Data$FormSource$FormCms = function (a) {
	return {$: 1, a: a};
};
var $author$project$View$ChatBot$FormMsg = function (a) {
	return {$: 10, a: a};
};
var $author$project$View$FormV2$GotCsrfToken = function (a) {
	return {$: 4, a: a};
};
var $author$project$Model$Form$FormType$JobApplicationData = function (a) {
	return {$: 0, a: a};
};
var $author$project$View$ChatBot$NoOp = {$: 0};
var $author$project$View$ChatBot$OpenApplicationFormMsg = function (a) {
	return {$: 13, a: a};
};
var $author$project$Model$Form$FormType$OpenJobApplicationData = function (a) {
	return {$: 1, a: a};
};
var $tad_lispy$springs$Spring$jumpTo = F2(
	function (newValue, _v0) {
		var _this = _v0;
		return _Utils_update(
			_this,
			{ey: newValue, bt: 0.0});
	});
var $tad_lispy$springs$Spring$target = function (_v0) {
	var _this = _v0;
	return _this.alt;
};
var $author$project$ScrollToInElement$cancel = function (_v0) {
	var nodeId = _v0.a;
	var springs = _v0.b;
	return A2(
		$author$project$ScrollToInElement$State,
		nodeId,
		{
			asz: A2(
				$tad_lispy$springs$Spring$jumpTo,
				$tad_lispy$springs$Spring$target(springs.asz),
				springs.asz),
			m: A2(
				$tad_lispy$springs$Spring$jumpTo,
				$tad_lispy$springs$Spring$target(springs.m),
				springs.m)
		});
};
var $author$project$View$FormV2$State = $elm$core$Basics$identity;
var $author$project$Model$FormFieldValueV2$TextValue = function (a) {
	return {$: 0, a: a};
};
var $pzp1997$assoc_list$AssocList$D = $elm$core$Basics$identity;
var $pzp1997$assoc_list$AssocList$empty = _List_Nil;
var $pzp1997$assoc_list$AssocList$remove = F2(
	function (targetKey, _v0) {
		var alist = _v0;
		return A2(
			$elm$core$List$filter,
			function (_v1) {
				var key = _v1.a;
				return !_Utils_eq(key, targetKey);
			},
			alist);
	});
var $pzp1997$assoc_list$AssocList$insert = F3(
	function (key, value, dict) {
		var _v0 = A2($pzp1997$assoc_list$AssocList$remove, key, dict);
		var alteredAlist = _v0;
		return A2(
			$elm$core$List$cons,
			_Utils_Tuple2(key, value),
			alteredAlist);
	});
var $author$project$View$FormV2$toDefaultFormInput = function (mPrefilledEmail) {
	return A2(
		$elm$core$Maybe$withDefault,
		$pzp1997$assoc_list$AssocList$empty,
		A2(
			$elm$core$Maybe$map,
			function (x) {
				return A3(
					$pzp1997$assoc_list$AssocList$insert,
					$author$project$Model$FormFieldV2$EmailAddress,
					$author$project$Model$FormFieldValueV2$TextValue(x),
					$pzp1997$assoc_list$AssocList$empty);
			},
			mPrefilledEmail));
};
var $author$project$View$FormV2$init = function (config) {
	return {
		bz: false,
		ch: false,
		ci: config.ci,
		atB: config.atB,
		atF: config.atF,
		j: $author$project$View$FormV2$toDefaultFormInput(config.auC),
		eW: config.eW,
		dA: config.dA,
		aeo: config.aeo,
		fB: config.fB,
		aY: $elm$core$Maybe$Nothing,
		bq: $author$project$Data$Status$NotAsked,
		fN: config.fN,
		fO: config.fO,
		ape: config.ape
	};
};
var $author$project$Data$Status$map = F2(
	function (f, status) {
		switch (status.$) {
			case 0:
				return $author$project$Data$Status$NotAsked;
			case 1:
				return $author$project$Data$Status$Loading;
			case 2:
				var err = status.a;
				return $author$project$Data$Status$Failure(err);
			default:
				var a = status.a;
				return $author$project$Data$Status$Success(
					f(a));
		}
	});
var $author$project$Data$ImageSource$mergeUploads = F2(
	function (_v0, _v1) {
		var earlier = _v0;
		var later = _v1;
		return A2($elm$core$Dict$union, later, earlier);
	});
var $elm$browser$Browser$Dom$getElement = _Browser_getElement;
var $author$project$View$ChatBot$scrollToFormNode = function (_v0) {
	var viewport = _v0.awo;
	return A2(
		$elm$core$Task$andThen,
		function (_v1) {
			var chat = _v1.a;
			var form = _v1.b;
			return $elm$core$Task$succeed(
				{
					KG: {asz: viewport.asz, m: viewport.m},
					am$: {asz: viewport.asz, m: viewport.m + (form.E4.m - chat.E4.m)}
				});
		},
		A3(
			$elm$core$Task$map2,
			$elm$core$Tuple$pair,
			$elm$browser$Browser$Dom$getElement('chat'),
			$elm$browser$Browser$Dom$getElement('form-node')));
};
var $author$project$View$ChatBot$setCsrfToken = F2(
	function (token, model) {
		return _Utils_update(
			model,
			{ci: token});
	});
var $author$project$View$ChatBot$storeLocalStorageState_ = function (_v0) {
	var model = _v0.a;
	var cmds = _v0.b;
	return _Utils_Tuple2(
		model,
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					cmds,
					$author$project$View$ChatBot$storeLocalStorageState(
					$author$project$View$ChatBot$encodeLocalStorageState(model))
				])));
};
var $author$project$View$FormV2$submitStatus = function (_v0) {
	var state = _v0;
	return state.bq;
};
var $author$project$Data$Translation$translationFieldFromLangCode = function (langCode) {
	switch (langCode) {
		case 1:
			return function ($) {
				return $.att;
			};
		case 2:
			return function ($) {
				return $.atu;
			};
		case 3:
			return function ($) {
				return $.atv;
			};
		case 4:
			return function ($) {
				return $.atw;
			};
		case 5:
			return function ($) {
				return $.F_;
			};
		case 6:
			return function ($) {
				return $.atJ;
			};
		case 7:
			return function ($) {
				return $.F_;
			};
		case 8:
			return function ($) {
				return $.atK;
			};
		case 9:
			return function ($) {
				return $.atM;
			};
		case 10:
			return function ($) {
				return $.atT;
			};
		case 11:
			return function ($) {
				return $.at1;
			};
		case 12:
			return function ($) {
				return $.at2;
			};
		case 13:
			return function ($) {
				return $.at3;
			};
		case 14:
			return function ($) {
				return $.at4;
			};
		case 15:
			return function ($) {
				return $.aug;
			};
		case 16:
			return function ($) {
				return $.auO;
			};
		case 17:
			return function ($) {
				return $.auP;
			};
		case 0:
			return function ($) {
				return $.ats;
			};
		case 18:
			return function ($) {
				return $.VA;
			};
		case 19:
			return function ($) {
				return $.avc;
			};
		case 20:
			return function ($) {
				return $.avj;
			};
		case 21:
			return function ($) {
				return $.avs;
			};
		case 22:
			return function ($) {
				return $.avB;
			};
		case 23:
			return function ($) {
				return $.avP;
			};
		default:
			return function ($) {
				return $.av5;
			};
	}
};
var $author$project$Data$Translation$translationsFromEntities = F2(
	function (langCode, xs) {
		var toName = function (_v1) {
			var name = _v1;
			return name;
		};
		return $elm$core$Dict$fromList(
			A2(
				$elm$core$List$map,
				function (_v0) {
					var t = _v0.b;
					return _Utils_Tuple2(
						toName(t.dY),
						A2($author$project$Data$Translation$translationFieldFromLangCode, langCode, t));
				},
				xs));
	});
var $author$project$ScrollToInElement$NoOp = {$: 0};
var $tad_lispy$springs$Spring$animate = F2(
	function (delta, spring) {
		var _this = spring;
		if ($tad_lispy$springs$Spring$atRest(spring)) {
			return spring;
		} else {
			if (($elm$core$Basics$abs(_this.ey - _this.alt) < 0.05) && ($elm$core$Basics$abs(_this.bt) < 0.05)) {
				return A2($tad_lispy$springs$Spring$jumpTo, _this.alt, spring);
			} else {
				var time = A2($elm$core$Basics$min, delta, 32) / 1000;
				var stretch = _this.alt - _this.ey;
				var force = stretch * _this.akg;
				var damping = _this.bt * _this.yk;
				var acceleration = time * (force - damping);
				var velocity = _this.bt + acceleration;
				var newValue = _this.ey + (velocity * time);
				return _Utils_update(
					_this,
					{ey: newValue, bt: velocity});
			}
		}
	});
var $tad_lispy$springs$Spring$setTarget = F2(
	function (newTarget, _v0) {
		var spring = _v0;
		return _Utils_update(
			spring,
			{alt: newTarget});
	});
var $elm$browser$Browser$Dom$setViewportOf = _Browser_setViewportOf;
var $tad_lispy$springs$Spring$value = function (_v0) {
	var _this = _v0;
	return _this.ey;
};
var $author$project$ScrollToInElement$update = F3(
	function (lift, msg, state) {
		var nodeId = state.a;
		var springs = state.b;
		return A2(
			$elm$core$Tuple$mapSecond,
			$elm$core$Platform$Cmd$map(lift),
			function () {
				switch (msg.$) {
					case 0:
						return _Utils_Tuple2(state, $elm$core$Platform$Cmd$none);
					case 1:
						var delta = msg.a;
						var next = {
							asz: A2($tad_lispy$springs$Spring$animate, delta, springs.asz),
							m: A2($tad_lispy$springs$Spring$animate, delta, springs.m)
						};
						var check = F3(
							function (current, next_, target) {
								return !$elm$core$Basics$round((current - target) + (next_ - target));
							});
						return (A3(
							check,
							$tad_lispy$springs$Spring$value(springs.asz),
							$tad_lispy$springs$Spring$value(next.asz),
							$tad_lispy$springs$Spring$target(next.asz)) && A3(
							check,
							$tad_lispy$springs$Spring$value(springs.m),
							$tad_lispy$springs$Spring$value(next.m),
							$tad_lispy$springs$Spring$target(next.m))) ? _Utils_Tuple2(
							A2(
								$author$project$ScrollToInElement$State,
								nodeId,
								{
									asz: A2(
										$tad_lispy$springs$Spring$jumpTo,
										$tad_lispy$springs$Spring$target(springs.asz),
										springs.asz),
									m: A2(
										$tad_lispy$springs$Spring$jumpTo,
										$tad_lispy$springs$Spring$target(springs.m),
										springs.m)
								}),
							$elm$core$Platform$Cmd$none) : _Utils_Tuple2(
							A2($author$project$ScrollToInElement$State, nodeId, next),
							A2(
								$elm$core$Task$attempt,
								function (_v1) {
									return $author$project$ScrollToInElement$NoOp;
								},
								A3(
									$elm$browser$Browser$Dom$setViewportOf,
									nodeId,
									$tad_lispy$springs$Spring$value(next.asz),
									$tad_lispy$springs$Spring$value(next.m))));
					default:
						if (!msg.a.$) {
							var from = msg.a.a.KG;
							var to = msg.a.a.am$;
							var setCurrent = $author$project$ScrollToInElement$isScrolling(state) ? $tad_lispy$springs$Spring$setTarget : $tad_lispy$springs$Spring$jumpTo;
							return _Utils_Tuple2(
								A2(
									$author$project$ScrollToInElement$State,
									nodeId,
									{
										asz: A2(
											$tad_lispy$springs$Spring$setTarget,
											to.asz,
											A2(setCurrent, from.asz, springs.asz)),
										m: A2(
											$tad_lispy$springs$Spring$setTarget,
											to.m,
											A2(setCurrent, from.m, springs.m))
									}),
								$elm$core$Platform$Cmd$none);
						} else {
							return _Utils_Tuple2(state, $elm$core$Platform$Cmd$none);
						}
				}
			}());
	});
var $author$project$View$FormV2$FileSelected = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$View$FormV2$GotAddressWithAutoFill = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $author$project$View$FormV2$GotFileAsUrl = F3(
	function (a, b, c) {
		return {$: 9, a: a, b: b, c: c};
	});
var $author$project$View$FormV2$InsertFieldValue = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Model$FormFieldValueV2$ScreeningQuestionValues = function (a) {
	return {$: 11, a: a};
};
var $author$project$View$FormV2$NotAnApplication = 2;
var $author$project$View$FormV2$SentByForm = 1;
var $author$project$View$FormV2$SentByThanksPage = 0;
var $author$project$View$FormV2$completionEvent = function (formTypeData) {
	switch (formTypeData.$) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		case 3:
			return 2;
		default:
			return 2;
	}
};
var $author$project$View$FormV2$completedWithoutThanksPage = F2(
	function (config, formTypeData) {
		var _v0 = $author$project$View$FormV2$completionEvent(formTypeData);
		switch (_v0) {
			case 1:
				return config.au4;
			case 0:
				return $elm$core$Platform$Cmd$none;
			default:
				return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$Data$Form$fieldNameToString = function (a) {
	switch (a.$) {
		case 0:
			return 'additional-file1';
		case 1:
			return 'additional-file2';
		case 2:
			return 'additional-file3';
		case 3:
			return 'additional-file4';
		case 4:
			return 'additional-file5';
		case 5:
			return 'address';
		case 6:
			return 'address-with-auto-fill';
		case 7:
			return 'agency-contact-email-address';
		case 8:
			return 'agency-contact-name';
		case 9:
			return 'agency-name';
		case 10:
			return 'availability';
		case 11:
			return 'business-unit';
		case 12:
			return 'button';
		case 13:
			return 'city';
		case 20:
			return 'custom-nationality';
		case 21:
			return 'custom-preferred-language';
		case 22:
			return 'custom-country';
		case 16:
			var val = a.a;
			return val;
		case 18:
			return 'custom-ethnic-identification';
		case 15:
			return 'conversion-factor';
		case 25:
			return 'custom-state';
		case 17:
			return 'custom-canada-province';
		case 19:
			return 'custom-how-did-you-get-here-select';
		case 23:
			return 'custom-is-hispanic';
		case 24:
			return 'custom-select';
		case 64:
			return 'resume';
		case 26:
			return 'date-of-birth';
		case 27:
			return 'desired-monthly-salary';
		case 28:
			return 'email-address';
		case 14:
			return 'confirm-email-address';
		case 29:
			return 'first-name';
		case 30:
			return 'grades-bachelor1';
		case 31:
			return 'grades-bachelor2';
		case 32:
			return 'grades-master1';
		case 33:
			return 'grades-master2';
		case 34:
			return 'heading';
		case 35:
			return 'reference-id';
		case 36:
			return 'referred-by';
		case 39:
			return 'image';
		case 40:
			return 'internal';
		case 41:
			return 'internship-evaluation1';
		case 42:
			return 'internship-evaluation2';
		case 43:
			return 'intro-text';
		case 44:
			return 'last-name';
		case 45:
			return 'link';
		case 46:
			return 'linked-in-url';
		case 47:
			return 'motivation';
		case 48:
			return 'motivation-text-area';
		case 49:
			return 'newsletter-subscription';
		case 37:
			return 'hours-available-per-week';
		case 38:
			return 'how-did-you-get-here';
		case 56:
			return 'ordered-list';
		case 55:
			return 'open-text';
		case 65:
			return 'salary-indication';
		case 68:
			return 'source';
		case 57:
			return 'phone-number';
		case 58:
			return 'phone-number-with-calling-code';
		case 61:
			return 'postal-code';
		case 59:
			return 'plain-text';
		case 60:
			return 'portfolio';
		case 62:
			return 'privacy';
		case 63:
			return 'referred';
		case 66:
			return 'screening-questions';
		case 67:
			return 'social-title';
		case 50:
			return 'open-application-external-id';
		case 52:
			return 'open-checkbox-one';
		case 54:
			return 'open-checkbox-two';
		case 53:
			return 'open-checkbox-three';
		case 51:
			return 'open-checkbox-four';
		case 69:
			return 'spacer';
		case 70:
			return 'store-data';
		case 71:
			return 'thesis';
		case 72:
			return 'unordered-list';
		case 73:
			return 'url';
		case 74:
			return 'usp';
		case 75:
			return 'video';
		default:
			return 'xing-url';
	}
};
var $elm$file$File$Select$file = F2(
	function (mimes, toMsg) {
		return A2(
			$elm$core$Task$perform,
			toMsg,
			_File_uploadOne(mimes));
	});
var $author$project$View$FormV2$NoOp = {$: 0};
var $author$project$Browser$Dom$Breakpoint$isBetween = F3(
	function (_v0, _v1, _v2) {
		var x = _v0;
		var a = _v1;
		var b = _v2;
		return (_Utils_cmp(x, a) > 0) && (_Utils_cmp(x, b) < 0);
	});
var $author$project$Browser$Dom$Breakpoint$Breakpoint = $elm$core$Basics$identity;
var $author$project$Browser$Dom$Breakpoint$medium = 1024;
var $elm$browser$Browser$Dom$setViewport = _Browser_setViewport;
var $author$project$Browser$Dom$Breakpoint$small = 768;
var $author$project$Data$FormSource$toForm = function (formSource) {
	if (!formSource.$) {
		var form = formSource.a;
		return form;
	} else {
		var entity = formSource.a;
		return $author$project$Data$Entity$value(entity);
	}
};
var $author$project$View$FormV2$focusOnErrorField = F2(
	function (formSource, error) {
		var form = $author$project$Data$FormSource$toForm(formSource);
		if (error.$ === 1) {
			return $elm$core$Platform$Cmd$none;
		} else {
			var fieldError = error.a.atU;
			var toScrollToWithOffset = function (_v3) {
				var element = _v3.E4;
				var scene = _v3.avu;
				return A2(
					$elm$browser$Browser$Dom$setViewport,
					0,
					A3($author$project$Browser$Dom$Breakpoint$isBetween, scene.cb, $author$project$Browser$Dom$Breakpoint$small, $author$project$Browser$Dom$Breakpoint$medium) ? (element.m - 180) : (element.m - 140));
			};
			var focusAndScroll = function (name_) {
				return A2(
					$elm$core$Task$attempt,
					$elm$core$Basics$always($author$project$View$FormV2$NoOp),
					A2(
						$elm$core$Task$andThen,
						function (_v2) {
							return $elm$browser$Browser$Dom$focus(
								$author$project$Data$Form$fieldNameToString(name_));
						},
						A2(
							$elm$core$Task$andThen,
							toScrollToWithOffset,
							$elm$browser$Browser$Dom$getElement(
								$author$project$Data$Form$fieldNameToString(name_)))));
			};
			var _v1 = form.atV;
			var fields = _v1;
			var fieldToFocus = $elm$core$List$head(
				A2(
					$elm$core$List$map,
					function ($) {
						return $.dY;
					},
					A2(
						$elm$core$List$filter,
						function (f) {
							return A2(
								$elm$core$Dict$member,
								$author$project$Data$Form$fieldNameToString(f.dY),
								fieldError);
						},
						$elm$core$List$concat(fields))));
			return A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Cmd$none,
				A2($elm$core$Maybe$map, focusAndScroll, fieldToFocus));
		}
	});
var $pzp1997$assoc_list$AssocList$get = F2(
	function (targetKey, _v0) {
		get:
		while (true) {
			var alist = _v0;
			if (!alist.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var _v2 = alist.a;
				var key = _v2.a;
				var value = _v2.b;
				var rest = alist.b;
				if (_Utils_eq(key, targetKey)) {
					return $elm$core$Maybe$Just(value);
				} else {
					var $temp$targetKey = targetKey,
						$temp$_v0 = rest;
					targetKey = $temp$targetKey;
					_v0 = $temp$_v0;
					continue get;
				}
			}
		}
	});
var $pzp1997$assoc_list$AssocList$fromList = function (alist) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, result) {
				var key = _v0.a;
				var value = _v0.b;
				return A3($pzp1997$assoc_list$AssocList$insert, key, value, result);
			}),
		_List_Nil,
		alist);
};
var $author$project$View$FormV2$getScreeningQuestionsValueDict = function (maybeFieldValues) {
	return $pzp1997$assoc_list$AssocList$fromList(
		A2(
			$elm$core$List$map,
			function (field) {
				return _Utils_Tuple2(field.dY, field);
			},
			A2($elm$core$Maybe$withDefault, _List_Nil, maybeFieldValues)));
};
var $pzp1997$assoc_list$AssocList$toList = function (_v0) {
	var alist = _v0;
	return alist;
};
var $author$project$View$FormV2$insertScreeningQuestionValue = F3(
	function (maybeFieldValues, id, val) {
		return A2(
			$elm$core$List$map,
			$elm$core$Tuple$second,
			$pzp1997$assoc_list$AssocList$toList(
				A3(
					$pzp1997$assoc_list$AssocList$insert,
					id,
					val,
					$author$project$View$FormV2$getScreeningQuestionsValueDict(maybeFieldValues))));
	});
var $author$project$Api$isForbiddenHttp = function (error) {
	if ((error.$ === 3) && (error.a === 403)) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Api$isForbidden = function (error) {
	if (error.$ === 1) {
		var httpError = error.a;
		return $author$project$Api$isForbiddenHttp(httpError);
	} else {
		return false;
	}
};
var $author$project$Browser$Console$logError_ = _Platform_outgoingPort('logError_', $elm$json$Json$Encode$string);
var $author$project$Browser$Console$logError = $author$project$Browser$Console$logError_;
var $author$project$Data$Status$mapFailure = F2(
	function (f, status) {
		switch (status.$) {
			case 0:
				return $author$project$Data$Status$NotAsked;
			case 1:
				return $author$project$Data$Status$Loading;
			case 2:
				var err = status.a;
				return $author$project$Data$Status$Failure(
					f(err));
			default:
				var a = status.a;
				return $author$project$Data$Status$Success(a);
		}
	});
var $elm$time$Time$Name = function (a) {
	return {$: 0, a: a};
};
var $elm$time$Time$Offset = function (a) {
	return {$: 1, a: a};
};
var $elm$time$Time$now = _Time_now($elm$time$Time$millisToPosix);
var $author$project$View$FormV2$retryWithFreshToken = F2(
	function (config, _v0) {
		var state_ = _v0;
		return _Utils_Tuple2(
			_Utils_update(
				state_,
				{bz: true, ch: true}),
			config.ac7(true));
	});
var $elm$core$Dict$singleton = F2(
	function (key, value) {
		return A5($elm$core$Dict$RBNode_elm_builtin, 1, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
	});
var $author$project$View$FormV2$GotSubmitForm = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$View$FormV2$GotSubmitFormNoContent = function (a) {
	return {$: 6, a: a};
};
var $author$project$Model$FormFieldValueV2$FieldValues = $elm$core$Basics$identity;
var $author$project$Model$FormFieldV2$encodeFieldName = function (a) {
	switch (a.$) {
		case 0:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('additional-file1'))
					]));
		case 1:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('additional-file2'))
					]));
		case 2:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('additional-file3'))
					]));
		case 3:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('additional-file4'))
					]));
		case 4:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('additional-file5'))
					]));
		case 5:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('address'))
					]));
		case 6:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('address-with-auto-fill'))
					]));
		case 7:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('agency-contact-email-address'))
					]));
		case 8:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('agency-contact-name'))
					]));
		case 9:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('agency-name'))
					]));
		case 10:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('availability'))
					]));
		case 11:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('business-unit'))
					]));
		case 12:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('button'))
					]));
		case 13:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('city'))
					]));
		case 14:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('confirm-email-address'))
					]));
		case 15:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('conversion-factor'))
					]));
		case 16:
			var b = a.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('custom')),
						_Utils_Tuple2(
						'contents',
						$elm$json$Json$Encode$string(b))
					]));
		case 17:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('custom-canada-province'))
					]));
		case 18:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('custom-ethnic-identification'))
					]));
		case 19:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('custom-how-did-you-get-here-select'))
					]));
		case 20:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('custom-nationality'))
					]));
		case 21:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('custom-preferred-language'))
					]));
		case 22:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('custom-country'))
					]));
		case 23:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('custom-is-hispanic'))
					]));
		case 24:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('custom-select'))
					]));
		case 25:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('custom-state'))
					]));
		case 26:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('date-of-birth'))
					]));
		case 27:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('desired-monthly-salary'))
					]));
		case 28:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('email-address'))
					]));
		case 29:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('first-name'))
					]));
		case 30:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('grades-bachelor1'))
					]));
		case 31:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('grades-bachelor2'))
					]));
		case 32:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('grades-master1'))
					]));
		case 33:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('grades-master2'))
					]));
		case 34:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('heading'))
					]));
		case 35:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('reference-id'))
					]));
		case 36:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('referred-by'))
					]));
		case 37:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('hours-available-per-week'))
					]));
		case 38:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('how-did-you-get-here'))
					]));
		case 39:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('image'))
					]));
		case 40:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('internal'))
					]));
		case 41:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('internship-evaluation1'))
					]));
		case 42:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('internship-evaluation2'))
					]));
		case 43:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('intro-text'))
					]));
		case 44:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('last-name'))
					]));
		case 45:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('link'))
					]));
		case 46:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('linked-in-url'))
					]));
		case 47:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('motivation'))
					]));
		case 48:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('motivation-text-area'))
					]));
		case 49:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('newsletter-subscription'))
					]));
		case 50:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('open-application-external-id'))
					]));
		case 51:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('open-checkbox-four'))
					]));
		case 52:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('open-checkbox-one'))
					]));
		case 53:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('open-checkbox-three'))
					]));
		case 54:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('open-checkbox-two'))
					]));
		case 55:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('open-text'))
					]));
		case 56:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('ordered-list'))
					]));
		case 57:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('phone-number'))
					]));
		case 58:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('phone-number-with-calling-code'))
					]));
		case 59:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('plain-text'))
					]));
		case 60:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('portfolio'))
					]));
		case 61:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('postal-code'))
					]));
		case 62:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('privacy'))
					]));
		case 63:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('referred'))
					]));
		case 64:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('resume'))
					]));
		case 65:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('salary-indication'))
					]));
		case 66:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('screening-questions'))
					]));
		case 67:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('social-title'))
					]));
		case 68:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('source'))
					]));
		case 69:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('spacer'))
					]));
		case 70:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('store-data'))
					]));
		case 71:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('thesis'))
					]));
		case 72:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('unordered-list'))
					]));
		case 73:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('url'))
					]));
		case 74:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('usp'))
					]));
		case 75:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('video'))
					]));
		default:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('xing-url'))
					]));
	}
};
var $author$project$Model$FormFieldValueV2$encodeAddressValue = function (a) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'street',
				$elm$json$Json$Encode$string(a.aj8)),
				_Utils_Tuple2(
				'houseNumber',
				$elm$json$Json$Encode$string(a.M3)),
				_Utils_Tuple2(
				'postalCode',
				$elm$json$Json$Encode$string(a.$B)),
				_Utils_Tuple2(
				'city',
				$elm$json$Json$Encode$string(a.qM))
			]));
};
var $justinmimbs$date$Date$monthToNumber = function (m) {
	switch (m) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		case 5:
			return 6;
		case 6:
			return 7;
		case 7:
			return 8;
		case 8:
			return 9;
		case 9:
			return 10;
		case 10:
			return 11;
		default:
			return 12;
	}
};
var $justinmimbs$date$Date$numberToMonth = function (mn) {
	var _v0 = A2($elm$core$Basics$max, 1, mn);
	switch (_v0) {
		case 1:
			return 0;
		case 2:
			return 1;
		case 3:
			return 2;
		case 4:
			return 3;
		case 5:
			return 4;
		case 6:
			return 5;
		case 7:
			return 6;
		case 8:
			return 7;
		case 9:
			return 8;
		case 10:
			return 9;
		case 11:
			return 10;
		default:
			return 11;
	}
};
var $justinmimbs$date$Date$toCalendarDateHelp = F3(
	function (y, m, d) {
		toCalendarDateHelp:
		while (true) {
			var monthDays = A2($justinmimbs$date$Date$daysInMonth, y, m);
			var mn = $justinmimbs$date$Date$monthToNumber(m);
			if ((mn < 12) && (_Utils_cmp(d, monthDays) > 0)) {
				var $temp$y = y,
					$temp$m = $justinmimbs$date$Date$numberToMonth(mn + 1),
					$temp$d = d - monthDays;
				y = $temp$y;
				m = $temp$m;
				d = $temp$d;
				continue toCalendarDateHelp;
			} else {
				return {yz: d, TF: m, asD: y};
			}
		}
	});
var $justinmimbs$date$Date$divWithRemainder = F2(
	function (a, b) {
		return _Utils_Tuple2(
			A2($justinmimbs$date$Date$floorDiv, a, b),
			A2($elm$core$Basics$modBy, b, a));
	});
var $justinmimbs$date$Date$year = function (_v0) {
	var rd = _v0;
	var _v1 = A2($justinmimbs$date$Date$divWithRemainder, rd, 146097);
	var n400 = _v1.a;
	var r400 = _v1.b;
	var _v2 = A2($justinmimbs$date$Date$divWithRemainder, r400, 36524);
	var n100 = _v2.a;
	var r100 = _v2.b;
	var _v3 = A2($justinmimbs$date$Date$divWithRemainder, r100, 1461);
	var n4 = _v3.a;
	var r4 = _v3.b;
	var _v4 = A2($justinmimbs$date$Date$divWithRemainder, r4, 365);
	var n1 = _v4.a;
	var r1 = _v4.b;
	var n = (!r1) ? 0 : 1;
	return ((((n400 * 400) + (n100 * 100)) + (n4 * 4)) + n1) + n;
};
var $justinmimbs$date$Date$toOrdinalDate = function (_v0) {
	var rd = _v0;
	var y = $justinmimbs$date$Date$year(rd);
	return {
		fs: rd - $justinmimbs$date$Date$daysBeforeYear(y),
		asD: y
	};
};
var $justinmimbs$date$Date$toCalendarDate = function (_v0) {
	var rd = _v0;
	var date = $justinmimbs$date$Date$toOrdinalDate(rd);
	return A3($justinmimbs$date$Date$toCalendarDateHelp, date.asD, 0, date.fs);
};
var $justinmimbs$date$Date$day = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toCalendarDate,
	function ($) {
		return $.yz;
	});
var $justinmimbs$date$Date$month = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toCalendarDate,
	function ($) {
		return $.TF;
	});
var $justinmimbs$date$Date$monthNumber = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$month, $justinmimbs$date$Date$monthToNumber);
var $justinmimbs$date$Date$ordinalDay = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toOrdinalDate,
	function ($) {
		return $.fs;
	});
var $justinmimbs$date$Date$padSignedInt = F2(
	function (length, _int) {
		return _Utils_ap(
			(_int < 0) ? '-' : '',
			A3(
				$elm$core$String$padLeft,
				length,
				'0',
				$elm$core$String$fromInt(
					$elm$core$Basics$abs(_int))));
	});
var $justinmimbs$date$Date$monthToQuarter = function (m) {
	return (($justinmimbs$date$Date$monthToNumber(m) + 2) / 3) | 0;
};
var $justinmimbs$date$Date$quarter = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$month, $justinmimbs$date$Date$monthToQuarter);
var $justinmimbs$date$Date$weekdayNumber = function (_v0) {
	var rd = _v0;
	var _v1 = A2($elm$core$Basics$modBy, 7, rd);
	if (!_v1) {
		return 7;
	} else {
		var n = _v1;
		return n;
	}
};
var $justinmimbs$date$Date$daysBeforeWeekYear = function (y) {
	var jan4 = $justinmimbs$date$Date$daysBeforeYear(y) + 4;
	return jan4 - $justinmimbs$date$Date$weekdayNumber(jan4);
};
var $justinmimbs$date$Date$numberToWeekday = function (wdn) {
	var _v0 = A2($elm$core$Basics$max, 1, wdn);
	switch (_v0) {
		case 1:
			return 0;
		case 2:
			return 1;
		case 3:
			return 2;
		case 4:
			return 3;
		case 5:
			return 4;
		case 6:
			return 5;
		default:
			return 6;
	}
};
var $justinmimbs$date$Date$toWeekDate = function (_v0) {
	var rd = _v0;
	var wdn = $justinmimbs$date$Date$weekdayNumber(rd);
	var wy = $justinmimbs$date$Date$year(rd + (4 - wdn));
	var week1Day1 = $justinmimbs$date$Date$daysBeforeWeekYear(wy) + 1;
	return {
		ar0: 1 + (((rd - week1Day1) / 7) | 0),
		ar1: wy,
		awq: $justinmimbs$date$Date$numberToWeekday(wdn)
	};
};
var $justinmimbs$date$Date$weekNumber = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toWeekDate,
	function ($) {
		return $.ar0;
	});
var $justinmimbs$date$Date$weekYear = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toWeekDate,
	function ($) {
		return $.ar1;
	});
var $justinmimbs$date$Date$weekday = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$weekdayNumber, $justinmimbs$date$Date$numberToWeekday);
var $justinmimbs$date$Date$ordinalSuffix = function (n) {
	var nn = A2($elm$core$Basics$modBy, 100, n);
	var _v0 = A2(
		$elm$core$Basics$min,
		(nn < 20) ? nn : A2($elm$core$Basics$modBy, 10, nn),
		4);
	switch (_v0) {
		case 1:
			return 'st';
		case 2:
			return 'nd';
		case 3:
			return 'rd';
		default:
			return 'th';
	}
};
var $justinmimbs$date$Date$withOrdinalSuffix = function (n) {
	return _Utils_ap(
		$elm$core$String$fromInt(n),
		$justinmimbs$date$Date$ordinalSuffix(n));
};
var $justinmimbs$date$Date$formatField = F4(
	function (language, _char, length, date) {
		switch (_char) {
			case 'y':
				if (length === 2) {
					return A2(
						$elm$core$String$right,
						2,
						A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$year(date))));
				} else {
					return A2(
						$justinmimbs$date$Date$padSignedInt,
						length,
						$justinmimbs$date$Date$year(date));
				}
			case 'Y':
				if (length === 2) {
					return A2(
						$elm$core$String$right,
						2,
						A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$weekYear(date))));
				} else {
					return A2(
						$justinmimbs$date$Date$padSignedInt,
						length,
						$justinmimbs$date$Date$weekYear(date));
				}
			case 'Q':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					case 2:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					case 3:
						return 'Q' + $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					case 4:
						return $justinmimbs$date$Date$withOrdinalSuffix(
							$justinmimbs$date$Date$quarter(date));
					case 5:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					default:
						return '';
				}
			case 'M':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$monthNumber(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$monthNumber(date)));
					case 3:
						return language.dW(
							$justinmimbs$date$Date$month(date));
					case 4:
						return language.fj(
							$justinmimbs$date$Date$month(date));
					case 5:
						return A2(
							$elm$core$String$left,
							1,
							language.dW(
								$justinmimbs$date$Date$month(date)));
					default:
						return '';
				}
			case 'w':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$weekNumber(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$weekNumber(date)));
					default:
						return '';
				}
			case 'd':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$day(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$day(date)));
					case 3:
						return language.eP(
							$justinmimbs$date$Date$day(date));
					default:
						return '';
				}
			case 'D':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$ordinalDay(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$ordinalDay(date)));
					case 3:
						return A3(
							$elm$core$String$padLeft,
							3,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$ordinalDay(date)));
					default:
						return '';
				}
			case 'E':
				switch (length) {
					case 1:
						return language.bv(
							$justinmimbs$date$Date$weekday(date));
					case 2:
						return language.bv(
							$justinmimbs$date$Date$weekday(date));
					case 3:
						return language.bv(
							$justinmimbs$date$Date$weekday(date));
					case 4:
						return language.f1(
							$justinmimbs$date$Date$weekday(date));
					case 5:
						return A2(
							$elm$core$String$left,
							1,
							language.bv(
								$justinmimbs$date$Date$weekday(date)));
					case 6:
						return A2(
							$elm$core$String$left,
							2,
							language.bv(
								$justinmimbs$date$Date$weekday(date)));
					default:
						return '';
				}
			case 'e':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$weekdayNumber(date));
					case 2:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$weekdayNumber(date));
					default:
						return A4($justinmimbs$date$Date$formatField, language, 'E', length, date);
				}
			default:
				return '';
		}
	});
var $justinmimbs$date$Date$formatWithTokens = F3(
	function (language, tokens, date) {
		return A3(
			$elm$core$List$foldl,
			F2(
				function (token, formatted) {
					if (!token.$) {
						var _char = token.a;
						var length = token.b;
						return _Utils_ap(
							A4($justinmimbs$date$Date$formatField, language, _char, length, date),
							formatted);
					} else {
						var str = token.a;
						return _Utils_ap(str, formatted);
					}
				}),
			'',
			tokens);
	});
var $justinmimbs$date$Pattern$Literal = function (a) {
	return {$: 1, a: a};
};
var $justinmimbs$date$Pattern$escapedQuote = A2(
	$elm$parser$Parser$ignorer,
	$elm$parser$Parser$succeed(
		$justinmimbs$date$Pattern$Literal('\'')),
	$elm$parser$Parser$token('\'\''));
var $justinmimbs$date$Pattern$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$getOffset = function (s) {
	return A3($elm$parser$Parser$Advanced$Good, false, s.F, s);
};
var $elm$parser$Parser$getOffset = $elm$parser$Parser$Advanced$getOffset;
var $justinmimbs$date$Pattern$fieldRepeats = function (str) {
	var _v0 = $elm$core$String$toList(str);
	if (_v0.b && (!_v0.b.b)) {
		var _char = _v0.a;
		return A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				$elm$parser$Parser$succeed(
					F2(
						function (x, y) {
							return A2($justinmimbs$date$Pattern$Field, _char, 1 + (y - x));
						})),
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$getOffset,
					$elm$parser$Parser$chompWhile(
						$elm$core$Basics$eq(_char)))),
			$elm$parser$Parser$getOffset);
	} else {
		return $elm$parser$Parser$problem('expected exactly one char');
	}
};
var $justinmimbs$date$Pattern$field = A2(
	$elm$parser$Parser$andThen,
	$justinmimbs$date$Pattern$fieldRepeats,
	$elm$parser$Parser$getChompedString(
		$elm$parser$Parser$chompIf($elm$core$Char$isAlpha)));
var $justinmimbs$date$Pattern$finalize = A2(
	$elm$core$List$foldl,
	F2(
		function (token, tokens) {
			var _v0 = _Utils_Tuple2(token, tokens);
			if (((_v0.a.$ === 1) && _v0.b.b) && (_v0.b.a.$ === 1)) {
				var x = _v0.a.a;
				var _v1 = _v0.b;
				var y = _v1.a.a;
				var rest = _v1.b;
				return A2(
					$elm$core$List$cons,
					$justinmimbs$date$Pattern$Literal(
						_Utils_ap(x, y)),
					rest);
			} else {
				return A2($elm$core$List$cons, token, tokens);
			}
		}),
	_List_Nil);
var $elm$parser$Parser$Advanced$lazy = function (thunk) {
	return function (s) {
		var _v0 = thunk(0);
		var parse = _v0;
		return parse(s);
	};
};
var $elm$parser$Parser$lazy = $elm$parser$Parser$Advanced$lazy;
var $justinmimbs$date$Pattern$isLiteralChar = function (_char) {
	return (_char !== '\'') && (!$elm$core$Char$isAlpha(_char));
};
var $justinmimbs$date$Pattern$literal = A2(
	$elm$parser$Parser$map,
	$justinmimbs$date$Pattern$Literal,
	$elm$parser$Parser$getChompedString(
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed(0),
				$elm$parser$Parser$chompIf($justinmimbs$date$Pattern$isLiteralChar)),
			$elm$parser$Parser$chompWhile($justinmimbs$date$Pattern$isLiteralChar))));
var $justinmimbs$date$Pattern$quotedHelp = function (result) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$andThen,
				function (str) {
					return $justinmimbs$date$Pattern$quotedHelp(
						_Utils_ap(result, str));
				},
				$elm$parser$Parser$getChompedString(
					A2(
						$elm$parser$Parser$ignorer,
						A2(
							$elm$parser$Parser$ignorer,
							$elm$parser$Parser$succeed(0),
							$elm$parser$Parser$chompIf(
								$elm$core$Basics$neq('\''))),
						$elm$parser$Parser$chompWhile(
							$elm$core$Basics$neq('\''))))),
				A2(
				$elm$parser$Parser$andThen,
				function (_v0) {
					return $justinmimbs$date$Pattern$quotedHelp(result + '\'');
				},
				$elm$parser$Parser$token('\'\'')),
				$elm$parser$Parser$succeed(result)
			]));
};
var $justinmimbs$date$Pattern$quoted = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$succeed($justinmimbs$date$Pattern$Literal),
		$elm$parser$Parser$chompIf(
			$elm$core$Basics$eq('\''))),
	A2(
		$elm$parser$Parser$ignorer,
		$justinmimbs$date$Pattern$quotedHelp(''),
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					$elm$parser$Parser$chompIf(
					$elm$core$Basics$eq('\'')),
					$elm$parser$Parser$end
				]))));
var $justinmimbs$date$Pattern$patternHelp = function (tokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$andThen,
				function (token) {
					return $justinmimbs$date$Pattern$patternHelp(
						A2($elm$core$List$cons, token, tokens));
				},
				$elm$parser$Parser$oneOf(
					_List_fromArray(
						[$justinmimbs$date$Pattern$field, $justinmimbs$date$Pattern$literal, $justinmimbs$date$Pattern$escapedQuote, $justinmimbs$date$Pattern$quoted]))),
				$elm$parser$Parser$lazy(
				function (_v0) {
					return $elm$parser$Parser$succeed(
						$justinmimbs$date$Pattern$finalize(tokens));
				})
			]));
};
var $justinmimbs$date$Pattern$fromString = function (str) {
	return A2(
		$elm$core$Result$withDefault,
		_List_fromArray(
			[
				$justinmimbs$date$Pattern$Literal(str)
			]),
		A2(
			$elm$parser$Parser$run,
			$justinmimbs$date$Pattern$patternHelp(_List_Nil),
			str));
};
var $justinmimbs$date$Date$formatWithLanguage = F2(
	function (language, pattern) {
		var tokens = $elm$core$List$reverse(
			$justinmimbs$date$Pattern$fromString(pattern));
		return A2($justinmimbs$date$Date$formatWithTokens, language, tokens);
	});
var $justinmimbs$date$Date$monthToName = function (m) {
	switch (m) {
		case 0:
			return 'January';
		case 1:
			return 'February';
		case 2:
			return 'March';
		case 3:
			return 'April';
		case 4:
			return 'May';
		case 5:
			return 'June';
		case 6:
			return 'July';
		case 7:
			return 'August';
		case 8:
			return 'September';
		case 9:
			return 'October';
		case 10:
			return 'November';
		default:
			return 'December';
	}
};
var $justinmimbs$date$Date$weekdayToName = function (wd) {
	switch (wd) {
		case 0:
			return 'Monday';
		case 1:
			return 'Tuesday';
		case 2:
			return 'Wednesday';
		case 3:
			return 'Thursday';
		case 4:
			return 'Friday';
		case 5:
			return 'Saturday';
		default:
			return 'Sunday';
	}
};
var $justinmimbs$date$Date$language_en = {
	eP: $justinmimbs$date$Date$withOrdinalSuffix,
	fj: $justinmimbs$date$Date$monthToName,
	dW: A2(
		$elm$core$Basics$composeR,
		$justinmimbs$date$Date$monthToName,
		$elm$core$String$left(3)),
	f1: $justinmimbs$date$Date$weekdayToName,
	bv: A2(
		$elm$core$Basics$composeR,
		$justinmimbs$date$Date$weekdayToName,
		$elm$core$String$left(3))
};
var $justinmimbs$date$Date$format = function (pattern) {
	return A2($justinmimbs$date$Date$formatWithLanguage, $justinmimbs$date$Date$language_en, pattern);
};
var $justinmimbs$date$Date$toIsoString = $justinmimbs$date$Date$format('yyyy-MM-dd');
var $author$project$Util$Date$encodeDate = A2($elm$core$Basics$composeL, $elm$json$Json$Encode$string, $justinmimbs$date$Date$toIsoString);
var $author$project$Model$FormFieldTypeV2$encodeDayOfWeek = function (a) {
	switch (a) {
		case 0:
			return $elm$json$Json$Encode$string('monday');
		case 1:
			return $elm$json$Json$Encode$string('tuesday');
		case 2:
			return $elm$json$Json$Encode$string('wednesday');
		case 3:
			return $elm$json$Json$Encode$string('thursday');
		case 4:
			return $elm$json$Json$Encode$string('friday');
		case 5:
			return $elm$json$Json$Encode$string('saturday');
		default:
			return $elm$json$Json$Encode$string('sunday');
	}
};
var $author$project$Model$FormFieldTypeV2$encodeDaypart = function (a) {
	switch (a) {
		case 0:
			return $elm$json$Json$Encode$string('morning');
		case 1:
			return $elm$json$Json$Encode$string('afternoon');
		case 2:
			return $elm$json$Json$Encode$string('evening');
		default:
			return $elm$json$Json$Encode$string('night');
	}
};
var $author$project$Util$Json$encodeEnum = function (toString) {
	return A2($elm$core$Basics$composeL, $elm$json$Json$Encode$string, toString);
};
var $author$project$Model$FormFieldValueV2$encodeBase64EncodedFile = function (a) {
	var b = a;
	return $elm$json$Json$Encode$string(b);
};
var $author$project$Model$FormFieldTypeV2$encodeMimeType = function (a) {
	var b = a;
	return $elm$json$Json$Encode$string(b);
};
var $author$project$Model$FormFieldValueV2$encodeFileValue = function (a) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'mimeType',
				$author$project$Model$FormFieldTypeV2$encodeMimeType(a.auG)),
				_Utils_Tuple2(
				'base64EncodedFile',
				$author$project$Model$FormFieldValueV2$encodeBase64EncodedFile(a.as5)),
				_Utils_Tuple2(
				'filename',
				$elm$json$Json$Encode$string(a.atW))
			]));
};
var $author$project$Model$CountryCallingCode$toString = function (a) {
	switch (a) {
		case 0:
			return 'afghanistan';
		case 1:
			return 'aland-islands';
		case 2:
			return 'albania';
		case 3:
			return 'algeria';
		case 4:
			return 'american-samoa';
		case 5:
			return 'andorra';
		case 6:
			return 'angola';
		case 7:
			return 'anguilla';
		case 8:
			return 'antiguaand-barbuda';
		case 9:
			return 'argentina';
		case 10:
			return 'armenia';
		case 11:
			return 'aruba';
		case 12:
			return 'australia';
		case 13:
			return 'austria';
		case 14:
			return 'azerbaijan';
		case 15:
			return 'bahamas';
		case 16:
			return 'bahrain';
		case 17:
			return 'bangladesh';
		case 18:
			return 'barbados';
		case 19:
			return 'belarus';
		case 20:
			return 'belgium';
		case 21:
			return 'belize';
		case 22:
			return 'benin';
		case 23:
			return 'bermuda';
		case 24:
			return 'bhutan';
		case 25:
			return 'bolivia';
		case 26:
			return 'bosniaand-herzegovina';
		case 27:
			return 'botswana';
		case 28:
			return 'brazil';
		case 29:
			return 'british-indian-ocean-territory';
		case 30:
			return 'british-virgin-islands';
		case 31:
			return 'brunei';
		case 32:
			return 'bulgaria';
		case 33:
			return 'burkina-faso';
		case 34:
			return 'burundi';
		case 35:
			return 'cambodia';
		case 36:
			return 'cameroon';
		case 37:
			return 'canada';
		case 38:
			return 'cape-verde';
		case 39:
			return 'caribbean-netherlands';
		case 40:
			return 'cayman-islands';
		case 41:
			return 'central-african-republic';
		case 42:
			return 'chad';
		case 43:
			return 'chile';
		case 44:
			return 'china';
		case 45:
			return 'christmas-island';
		case 46:
			return 'cocos-keeling-islands';
		case 47:
			return 'colombia';
		case 48:
			return 'comoros';
		case 49:
			return 'cook-islands';
		case 50:
			return 'costa-rica';
		case 51:
			return 'croatia';
		case 52:
			return 'cuba';
		case 53:
			return 'curacao';
		case 54:
			return 'cyprus';
		case 55:
			return 'czech-republic';
		case 56:
			return 'congo';
		case 57:
			return 'denmark';
		case 58:
			return 'djibouti';
		case 59:
			return 'dominica';
		case 60:
			return 'dominican-republic';
		case 61:
			return 'ecuador';
		case 62:
			return 'egypt';
		case 63:
			return 'el-salvador';
		case 64:
			return 'equatorial-guinea';
		case 65:
			return 'eritrea';
		case 66:
			return 'estonia';
		case 67:
			return 'eswatini';
		case 68:
			return 'ethiopia';
		case 69:
			return 'falkland-islands';
		case 70:
			return 'faroe-islands';
		case 71:
			return 'fiji';
		case 72:
			return 'finland';
		case 73:
			return 'france';
		case 74:
			return 'french-guiana';
		case 75:
			return 'french-polynesia';
		case 76:
			return 'gabon';
		case 77:
			return 'gambia';
		case 78:
			return 'georgia';
		case 79:
			return 'germany';
		case 80:
			return 'ghana';
		case 81:
			return 'gibraltar';
		case 82:
			return 'greece';
		case 83:
			return 'greenland';
		case 84:
			return 'grenada';
		case 85:
			return 'guadeloupe';
		case 86:
			return 'guam';
		case 87:
			return 'guatemala';
		case 88:
			return 'guernsey';
		case 89:
			return 'guinea';
		case 90:
			return 'guinea-bissau';
		case 91:
			return 'guyana';
		case 92:
			return 'haiti';
		case 93:
			return 'honduras';
		case 94:
			return 'hong-kong';
		case 95:
			return 'hungary';
		case 96:
			return 'iceland';
		case 97:
			return 'india';
		case 98:
			return 'indonesia';
		case 99:
			return 'iran';
		case 100:
			return 'iraq';
		case 101:
			return 'ireland';
		case 102:
			return 'isleof-man';
		case 103:
			return 'israel';
		case 104:
			return 'italy';
		case 105:
			return 'ivory-coast';
		case 106:
			return 'jamaica';
		case 107:
			return 'japan';
		case 108:
			return 'jersey';
		case 109:
			return 'jordan';
		case 110:
			return 'kazakhstan';
		case 111:
			return 'kenya';
		case 112:
			return 'kiribati';
		case 113:
			return 'kosovo';
		case 114:
			return 'kuwait';
		case 115:
			return 'kyrgyzstan';
		case 116:
			return 'laos';
		case 117:
			return 'latvia';
		case 118:
			return 'lebanon';
		case 119:
			return 'lesotho';
		case 120:
			return 'liberia';
		case 121:
			return 'libya';
		case 122:
			return 'liechtenstein';
		case 123:
			return 'lithuania';
		case 124:
			return 'luxembourg';
		case 125:
			return 'macau';
		case 126:
			return 'macedonia';
		case 127:
			return 'madagascar';
		case 128:
			return 'malawi';
		case 129:
			return 'malaysia';
		case 130:
			return 'maldives';
		case 131:
			return 'mali';
		case 132:
			return 'malta';
		case 133:
			return 'marshall-islands';
		case 134:
			return 'martinique';
		case 135:
			return 'mauritania';
		case 136:
			return 'mauritius';
		case 137:
			return 'mayotte';
		case 138:
			return 'mexico';
		case 139:
			return 'micronesia';
		case 140:
			return 'moldova';
		case 141:
			return 'monaco';
		case 142:
			return 'mongolia';
		case 143:
			return 'montenegro';
		case 144:
			return 'montserrat';
		case 145:
			return 'morocco';
		case 146:
			return 'mozambique';
		case 147:
			return 'myanmar';
		case 148:
			return 'namibia';
		case 149:
			return 'nauru';
		case 150:
			return 'nepal';
		case 151:
			return 'netherlands';
		case 152:
			return 'new-caledonia';
		case 153:
			return 'new-zealand';
		case 154:
			return 'nicaragua';
		case 155:
			return 'niger';
		case 156:
			return 'nigeria';
		case 157:
			return 'niue';
		case 158:
			return 'norfolk-island';
		case 159:
			return 'north-korea';
		case 160:
			return 'northern-mariana-islands';
		case 161:
			return 'norway';
		case 162:
			return 'oman';
		case 163:
			return 'pakistan';
		case 164:
			return 'palau';
		case 165:
			return 'palestine';
		case 166:
			return 'panama';
		case 167:
			return 'papua-new-guinea';
		case 168:
			return 'paraguay';
		case 169:
			return 'peru';
		case 170:
			return 'philippines';
		case 171:
			return 'poland';
		case 172:
			return 'portugal';
		case 173:
			return 'puerto-rico';
		case 174:
			return 'qatar';
		case 175:
			return 'republicofthe-congo';
		case 176:
			return 'romania';
		case 177:
			return 'russia';
		case 178:
			return 'rwanda';
		case 179:
			return 'reunion';
		case 180:
			return 'saint-barthelemy';
		case 181:
			return 'saint-helena-ascensionand-tristanda-cunha';
		case 182:
			return 'saint-kittsand-nevis';
		case 183:
			return 'saint-lucia';
		case 184:
			return 'saint-martin';
		case 185:
			return 'saint-pierreand-miquelon';
		case 186:
			return 'saint-vincentandthe-grenadines';
		case 187:
			return 'samoa';
		case 188:
			return 'san-marino';
		case 189:
			return 'sao-tomeand-principe';
		case 190:
			return 'saudi-arabia';
		case 191:
			return 'senegal';
		case 192:
			return 'serbia';
		case 193:
			return 'seychelles';
		case 194:
			return 'sierra-leone';
		case 195:
			return 'singapore';
		case 196:
			return 'sint-maarten';
		case 197:
			return 'slovakia';
		case 198:
			return 'slovenia';
		case 199:
			return 'solomon-islands';
		case 200:
			return 'somalia';
		case 201:
			return 'south-africa';
		case 202:
			return 'south-korea';
		case 203:
			return 'south-sudan';
		case 204:
			return 'spain';
		case 205:
			return 'sri-lanka';
		case 206:
			return 'sudan';
		case 207:
			return 'suriname';
		case 208:
			return 'svalbardand-jan-mayen';
		case 209:
			return 'sweden';
		case 210:
			return 'switzerland';
		case 211:
			return 'syria';
		case 212:
			return 'taiwan';
		case 213:
			return 'tajikistan';
		case 214:
			return 'tanzania';
		case 215:
			return 'thailand';
		case 216:
			return 'timor-leste';
		case 217:
			return 'togo';
		case 218:
			return 'tokelau';
		case 219:
			return 'tonga';
		case 220:
			return 'trinidadand-tobago';
		case 221:
			return 'tunisia';
		case 222:
			return 'turkey';
		case 223:
			return 'turkmenistan';
		case 224:
			return 'turksand-caicos-islands';
		case 225:
			return 'tuvalu';
		case 226:
			return 'uganda';
		case 227:
			return 'ukraine';
		case 228:
			return 'united-arab-emirates';
		case 229:
			return 'united-kingdom';
		case 230:
			return 'united-states';
		case 231:
			return 'united-states-virgin-islands';
		case 232:
			return 'uruguay';
		case 233:
			return 'uzbekistan';
		case 234:
			return 'vanuatu';
		case 235:
			return 'vatican-city';
		case 236:
			return 'venezuela';
		case 237:
			return 'vietnam';
		case 238:
			return 'wallisand-futuna';
		case 239:
			return 'western-sahara';
		case 240:
			return 'yemen';
		case 241:
			return 'zambia';
		default:
			return 'zimbabwe';
	}
};
var $author$project$Model$FormFieldValueV2$encodeFieldValue = function (a) {
	switch (a.$) {
		case 0:
			var b = a.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('text-value')),
						_Utils_Tuple2(
						'contents',
						$elm$json$Json$Encode$string(b))
					]));
		case 1:
			var b = a.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('date-value')),
						_Utils_Tuple2(
						'contents',
						A3($elm_community$maybe_extra$Maybe$Extra$unwrap, $elm$json$Json$Encode$null, $author$project$Util$Date$encodeDate, b))
					]));
		case 2:
			var b = a.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('bool-value')),
						_Utils_Tuple2(
						'contents',
						$elm$json$Json$Encode$bool(b))
					]));
		case 3:
			var b = a.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('file-value')),
						_Utils_Tuple2(
						'contents',
						A3($elm_community$maybe_extra$Maybe$Extra$unwrap, $elm$json$Json$Encode$null, $author$project$Model$FormFieldValueV2$encodeFileValue, b))
					]));
		case 4:
			var b = a.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('radio-value')),
						_Utils_Tuple2(
						'contents',
						$elm$json$Json$Encode$string(b))
					]));
		case 5:
			var b = a.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('select-value')),
						_Utils_Tuple2(
						'contents',
						A3($elm_community$maybe_extra$Maybe$Extra$unwrap, $elm$json$Json$Encode$null, $elm$json$Json$Encode$string, b))
					]));
		case 6:
			var b = a.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('select-multiple-value')),
						_Utils_Tuple2(
						'contents',
						A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, b))
					]));
		case 7:
			var b = a.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('range-value')),
						_Utils_Tuple2(
						'contents',
						$elm$json$Json$Encode$int(b))
					]));
		case 8:
			var b = a.a;
			var c = a.b;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('phone-number-with-calling-code-value')),
						_Utils_Tuple2(
						'contents',
						A2(
							$elm$json$Json$Encode$list,
							$elm$core$Basics$identity,
							_List_fromArray(
								[
									A2($author$project$Util$Json$encodeEnum, $author$project$Model$CountryCallingCode$toString, b),
									$elm$json$Json$Encode$string(c)
								])))
					]));
		case 9:
			var b = a.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('address-value')),
						_Utils_Tuple2(
						'contents',
						function () {
							var c = b.a;
							var d = b.b;
							return A2(
								$elm$json$Json$Encode$list,
								$elm$core$Basics$identity,
								_List_fromArray(
									[
										$elm$json$Json$Encode$bool(c),
										$author$project$Model$FormFieldValueV2$encodeAddressValue(d)
									]));
						}())
					]));
		case 10:
			var b = a.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('daypart-availability-value')),
						_Utils_Tuple2(
						'contents',
						A2(
							$elm$json$Json$Encode$list,
							function (c) {
								var d = c.a;
								var e = c.b;
								return A2(
									$elm$json$Json$Encode$list,
									$elm$core$Basics$identity,
									_List_fromArray(
										[
											$author$project$Model$FormFieldTypeV2$encodeDayOfWeek(d),
											$author$project$Model$FormFieldTypeV2$encodeDaypart(e)
										]));
							},
							b))
					]));
		default:
			var b = a.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('screening-question-values')),
						_Utils_Tuple2(
						'contents',
						A2($elm$json$Json$Encode$list, $author$project$Model$FormFieldValueV2$encodeScreeningQuestionValue, b))
					]));
	}
};
var $author$project$Model$FormFieldValueV2$encodeScreeningQuestionValue = function (a) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'name',
				$author$project$Model$FormFieldV2$encodeFieldName(a.dY)),
				_Utils_Tuple2(
				'value',
				$author$project$Model$FormFieldValueV2$encodeFieldValue(a.ey))
			]));
};
var $author$project$Model$FormFieldValueV2$encodeFieldValues = function (a) {
	var b = a;
	return A2(
		$elm$json$Json$Encode$list,
		function (c) {
			var d = c.a;
			var e = c.b;
			return A2(
				$elm$json$Json$Encode$list,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						$author$project$Model$FormFieldV2$encodeFieldName(d),
						$author$project$Model$FormFieldValueV2$encodeFieldValue(e)
					]));
		},
		b);
};
var $author$project$View$FormV2$encodeFormInput = A2(
	$elm$core$Basics$composeL,
	A2($elm$core$Basics$composeL, $author$project$Model$FormFieldValueV2$encodeFieldValues, $elm$core$Basics$identity),
	$pzp1997$assoc_list$AssocList$toList);
var $author$project$Api$NoContent = 0;
var $author$project$Api$expectNoContent = function (toMsg) {
	return A2(
		$author$project$Api$expectResponse,
		toMsg,
		F2(
			function (_v0, _v1) {
				return $elm$core$Result$Ok(0);
			}));
};
var $elm$http$Http$jsonBody = function (value) {
	return A2(
		_Http_pair,
		'application/json',
		A2($elm$json$Json$Encode$encode, 0, value));
};
var $author$project$Api$Endpoint$submitAtsJobApplication = F2(
	function (vK, queryParameters) {
		return A2(
			$author$project$Api$Endpoint$endpointWithQueryParameters,
			_List_fromArray(
				[
					'form',
					'job-application-ats',
					$author$project$Data$Id$toString(vK)
				]),
			queryParameters);
	});
var $author$project$Api$Endpoint$submitEventRegistration = F2(
	function (formId, eventId) {
		return $author$project$Api$Endpoint$endpoint(
			_List_fromArray(
				[
					'form',
					'event',
					$author$project$Data$Id$toString(formId),
					$author$project$Data$Id$toString(eventId)
				]));
	});
var $author$project$Api$Endpoint$submitJobApplication = F3(
	function (formId, vacancyId, queryParameters) {
		return A2(
			$author$project$Api$Endpoint$endpointWithQueryParameters,
			_List_fromArray(
				[
					'form',
					'job-application',
					$author$project$Data$Id$toString(formId),
					$author$project$Data$Id$toString(vacancyId)
				]),
			queryParameters);
	});
var $author$project$Api$Endpoint$submitOpenJobApplication = F3(
	function (formId, domainId, queryParameters) {
		return A2(
			$author$project$Api$Endpoint$endpointWithQueryParameters,
			_List_fromArray(
				[
					'form',
					'open-job-application',
					$author$project$Data$Id$toString(formId),
					$author$project$Data$Id$toString(domainId)
				]),
			queryParameters);
	});
var $author$project$View$FormV2$submitFormCmd = F2(
	function (config, _v0) {
		var state_ = _v0;
		var submitJobApplication = function (vacancyId) {
			var _v6 = state_.eW;
			if (!_v6.$) {
				return A2($author$project$Api$Endpoint$submitAtsJobApplication, vacancyId, config.aaH);
			} else {
				var formEntity = _v6.a;
				return A3(
					$author$project$Api$Endpoint$submitJobApplication,
					$author$project$Data$Entity$id(formEntity),
					vacancyId,
					config.aaH);
			}
		};
		var maybeFormId = function () {
			var _v5 = state_.eW;
			if (_v5.$ === 1) {
				var formEntity = _v5.a;
				return $elm$core$Maybe$Just(
					$author$project$Data$Entity$id(formEntity));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		var form = $author$project$Data$FormSource$toForm(state_.eW);
		var formType = form.aM;
		var conversationalHeaders = function () {
			var _v4 = config.atp;
			if (!_v4.$) {
				var sessionId = _v4.a;
				return A2(
					$elm$core$List$cons,
					A2($elm$http$Http$header, 'X-Conversational-Session-Id', sessionId),
					A2(
						$elm$core$List$filterMap,
						$elm$core$Basics$identity,
						_List_fromArray(
							[
								A2(
								$elm$core$Maybe$map,
								A2(
									$elm$core$Basics$composeL,
									$elm$http$Http$header('X-Form-Id'),
									$author$project$Data$Id$toString),
								maybeFormId),
								A2(
								$elm$core$Maybe$map,
								A2(
									$elm$core$Basics$composeL,
									$elm$http$Http$header('X-Template-Id'),
									$author$project$Data$Id$toString),
								config.alw)
							])));
			} else {
				return _List_Nil;
			}
		}();
		var post = F2(
			function (expect, endpoint) {
				return $author$project$Api$Endpoint$request(
					{
						_: $elm$http$Http$jsonBody(
							$author$project$View$FormV2$encodeFormInput(state_.j)),
						aH: expect,
						ax: A2(
							$elm$core$List$cons,
							A2($elm$http$Http$header, 'X-XSRF-TOKEN', state_.ci),
							conversationalHeaders),
						aO: 'POST',
						a_: $elm$core$Maybe$Nothing,
						av3: $elm$core$Maybe$Just('post'),
						a0: endpoint
					});
			});
		var _v1 = state_.dA;
		switch (_v1.$) {
			case 2:
				var eventId = _v1.a;
				var _v2 = state_.eW;
				if (_v2.$ === 1) {
					var formEntity = _v2.a;
					return A2(
						$elm$core$Platform$Cmd$map,
						config.aut,
						A2(
							post,
							$author$project$Api$expectNoContent($author$project$View$FormV2$GotSubmitFormNoContent),
							A2(
								$author$project$Api$Endpoint$submitEventRegistration,
								$author$project$Data$Entity$id(formEntity),
								eventId)));
				} else {
					return $elm$core$Platform$Cmd$none;
				}
			case 0:
				var vacancyId = _v1.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					config.aut,
					A2(
						post,
						A2(
							$author$project$Api$expectJson,
							$author$project$View$FormV2$GotSubmitForm(formType),
							$author$project$Model$RedirectUrl$redirectUrlDecoder),
						submitJobApplication(vacancyId)));
			case 1:
				var domainId = _v1.a;
				var _v3 = state_.eW;
				if (_v3.$ === 1) {
					var formEntity = _v3.a;
					return A2(
						$elm$core$Platform$Cmd$map,
						config.aut,
						A2(
							post,
							$author$project$Api$expectNoContent($author$project$View$FormV2$GotSubmitFormNoContent),
							A3(
								$author$project$Api$Endpoint$submitOpenJobApplication,
								$author$project$Data$Entity$id(formEntity),
								domainId,
								config.aaH)));
				} else {
					return $elm$core$Platform$Cmd$none;
				}
			case 3:
				return $elm$core$Platform$Cmd$none;
			default:
				return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$Model$FormFieldValueV2$FileValue_ = function (a) {
	return {$: 3, a: a};
};
var $author$project$Model$FormFieldValueV2$Base64EncodedFile = $elm$core$Basics$identity;
var $author$project$Data$Form$splitDataUrl = function (dataUrl) {
	var _v0 = A2(
		$elm$core$String$split,
		';base64,',
		A2($elm$core$String$dropLeft, 5, dataUrl));
	if ((_v0.b && _v0.b.b) && (!_v0.b.b.b)) {
		var mime = _v0.a;
		var _v1 = _v0.b;
		var base64 = _v1.a;
		return $elm$core$Result$Ok(
			_Utils_Tuple2(mime, base64));
	} else {
		var other = _v0;
		return $elm$core$Result$Err(
			'Split data url error, expected two element list but got: ' + $elm$core$String$concat(other));
	}
};
var $author$project$Data$Form$toFileValue = F2(
	function (file, fileAsUrl) {
		var toFileValue_ = function (_v0) {
			var mimeType = _v0.a;
			var base64EncodedFile = _v0.b;
			return {
				as5: base64EncodedFile,
				atW: $elm$file$File$name(file),
				auG: mimeType
			};
		};
		return A2(
			$elm$core$Result$map,
			toFileValue_,
			$author$project$Data$Form$splitDataUrl(fileAsUrl));
	});
var $author$project$Data$Form$toFieldValue = F3(
	function (fieldName, file, fileAsUrl) {
		return A2(
			$elm$core$Result$map,
			A2(
				$elm$core$Basics$composeL,
				A2(
					$elm$core$Basics$composeL,
					$elm$core$Tuple$pair(fieldName),
					$author$project$Model$FormFieldValueV2$FileValue_),
				$elm$core$Maybe$Just),
			A2($author$project$Data$Form$toFileValue, file, fileAsUrl));
	});
var $author$project$View$FormV2$toScreeningQuestionsValue = function (value_) {
	if (value_.$ === 11) {
		var valueList = value_.a;
		return $elm$core$Maybe$Just(valueList);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$View$FormV2$update = F3(
	function (config, msg, state) {
		update:
		while (true) {
			var state_ = state;
			switch (msg.$) {
				case 0:
					return _Utils_Tuple2(state, $elm$core$Platform$Cmd$none);
				case 1:
					var progress = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							state_,
							{
								aY: $elm$core$Maybe$Just(progress)
							}),
						$elm$core$Platform$Cmd$none);
				case 2:
					var fieldName = msg.a;
					var fieldValue = msg.b;
					var updateFailure = function (responseError) {
						if (responseError.$ === 1) {
							var err = responseError.a;
							return $author$project$Api$HttpError(err);
						} else {
							var err = responseError.a;
							return $author$project$Api$ValidationError(
								_Utils_update(
									err,
									{
										atU: A2(
											$elm$core$Dict$remove,
											$author$project$Data$Form$fieldNameToString(fieldName),
											err.atU)
									}));
						}
					};
					return _Utils_Tuple2(
						_Utils_update(
							state_,
							{
								j: A3($pzp1997$assoc_list$AssocList$insert, fieldName, fieldValue, state_.j),
								bq: A2($author$project$Data$Status$mapFailure, updateFailure, state_.bq)
							}),
						$elm$core$Platform$Cmd$none);
				case 7:
					var options = msg.a;
					var fieldName = msg.b;
					var mimeTypes = A2(
						$elm$core$List$map,
						function (_v2) {
							var x = _v2;
							return x;
						},
						options.Tc);
					return _Utils_Tuple2(
						state_,
						A2(
							$elm$core$Platform$Cmd$map,
							config.aut,
							A2(
								$elm$file$File$Select$file,
								mimeTypes,
								$author$project$View$FormV2$FileSelected(fieldName))));
				case 8:
					var fieldName = msg.a;
					var file = msg.b;
					return _Utils_Tuple2(
						state_,
						A2(
							$elm$core$Platform$Cmd$map,
							config.aut,
							A2(
								$elm$core$Task$attempt,
								A2($author$project$View$FormV2$GotFileAsUrl, fieldName, file),
								$elm$file$File$toUrl(file))));
				case 9:
					if (msg.c.$ === 1) {
						return _Utils_Tuple2(
							state_,
							$author$project$Browser$Console$logError('Unable to load file as URL'));
					} else {
						var fieldName = msg.a;
						var file = msg.b;
						var fileAsUrl = msg.c.a;
						var _v3 = A3($author$project$Data$Form$toFieldValue, fieldName, file, fileAsUrl);
						if (_v3.$ === 1) {
							var err = _v3.a;
							return _Utils_Tuple2(
								state_,
								$author$project$Browser$Console$logError(err));
						} else {
							var _v4 = _v3.a;
							var fieldName_ = _v4.a;
							var fieldValue = _v4.b;
							var isScreeningQuestion = function () {
								if (fieldName_.$ === 16) {
									var identifier = fieldName_.a;
									return A2(
										$elm$core$List$any,
										function (sq) {
											return _Utils_eq(sq.dE, identifier);
										},
										state_.fB);
								} else {
									return false;
								}
							}();
							var insertMsg = function () {
								if (isScreeningQuestion) {
									var screeningQuestionValue = {dY: fieldName_, ey: fieldValue};
									var currentScreeningValues = A2(
										$elm$core$Maybe$andThen,
										$author$project$View$FormV2$toScreeningQuestionsValue,
										A2($pzp1997$assoc_list$AssocList$get, $author$project$Model$FormFieldV2$ScreeningQuestions, state_.j));
									var updatedScreeningValues = A3($author$project$View$FormV2$insertScreeningQuestionValue, currentScreeningValues, fieldName_, screeningQuestionValue);
									return A2(
										$author$project$View$FormV2$InsertFieldValue,
										$author$project$Model$FormFieldV2$ScreeningQuestions,
										$author$project$Model$FormFieldValueV2$ScreeningQuestionValues(updatedScreeningValues));
								} else {
									return A2($author$project$View$FormV2$InsertFieldValue, fieldName_, fieldValue);
								}
							}();
							var $temp$config = config,
								$temp$msg = insertMsg,
								$temp$state = state;
							config = $temp$config;
							msg = $temp$msg;
							state = $temp$state;
							continue update;
						}
					}
				case 3:
					return _Utils_Tuple2(
						_Utils_update(
							state_,
							{bz: true, ch: false, bq: $author$project$Data$Status$Loading}),
						config.ac7(true));
				case 4:
					var token = msg.a;
					var withToken = _Utils_update(
						state_,
						{
							bz: false,
							ci: A2($author$project$Api$csrfTokenWithDefault, state_.ci, token)
						});
					return _Utils_Tuple2(
						withToken,
						state_.bz ? A2($author$project$View$FormV2$submitFormCmd, config, withToken) : $elm$core$Platform$Cmd$none);
				case 5:
					if (!msg.b.$) {
						switch (msg.a) {
							case 0:
								var _v6 = msg.a;
								var redirectUrl = msg.b.a;
								return _Utils_Tuple2(
									_Utils_update(
										state_,
										{
											aY: $elm$core$Maybe$Nothing,
											bq: $author$project$Data$Status$Success(0)
										}),
									config.X1(redirectUrl));
							case 1:
								var _v7 = msg.a;
								return _Utils_Tuple2(state_, $elm$core$Platform$Cmd$none);
							case 2:
								var _v8 = msg.a;
								return _Utils_Tuple2(
									_Utils_update(
										state_,
										{
											aY: $elm$core$Maybe$Nothing,
											bq: $author$project$Data$Status$Success(0)
										}),
									$elm$core$Platform$Cmd$none);
							case 3:
								var _v9 = msg.a;
								return _Utils_Tuple2(state_, $elm$core$Platform$Cmd$none);
							default:
								var _v10 = msg.a;
								return _Utils_Tuple2(state_, $elm$core$Platform$Cmd$none);
						}
					} else {
						var err = msg.b.a;
						return ($author$project$Api$isForbidden(err) && (!state_.ch)) ? A2($author$project$View$FormV2$retryWithFreshToken, config, state) : _Utils_Tuple2(
							_Utils_update(
								state_,
								{
									aY: $elm$core$Maybe$Nothing,
									bq: $author$project$Data$Status$Failure(err)
								}),
							A2(
								$elm$core$Platform$Cmd$map,
								config.aut,
								A2($author$project$View$FormV2$focusOnErrorField, state_.eW, err)));
					}
				case 6:
					if (!msg.a.$) {
						return _Utils_Tuple2(
							_Utils_update(
								state_,
								{
									aY: $elm$core$Maybe$Nothing,
									bq: $author$project$Data$Status$Success(0)
								}),
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A2($author$project$View$FormV2$completedWithoutThanksPage, config, state_.dA),
										function () {
										var _v11 = _Utils_Tuple2(state_.fN, state_.fO);
										if (!_v11.a.$) {
											return $elm$core$Platform$Cmd$none;
										} else {
											if (!_v11.b.$) {
												var _v12 = _v11.a;
												var url = _v11.b.a;
												return config.X1(
													{av7: url});
											} else {
												var _v13 = _v11.a;
												var _v14 = _v11.b;
												return $elm$core$Platform$Cmd$none;
											}
										}
									}()
									])));
					} else {
						var err = msg.a.a;
						return ($author$project$Api$isForbidden(err) && (!state_.ch)) ? A2($author$project$View$FormV2$retryWithFreshToken, config, state) : _Utils_Tuple2(
							_Utils_update(
								state_,
								{
									aY: $elm$core$Maybe$Nothing,
									bq: $author$project$Data$Status$Failure(err)
								}),
							A2(
								$elm$core$Platform$Cmd$map,
								config.aut,
								A2($author$project$View$FormV2$focusOnErrorField, state_.eW, err)));
					}
				case 10:
					var keyword = msg.a;
					var insertFieldValueMsg = msg.b;
					var params = _List_fromArray(
						[
							A2($elm$url$Url$Builder$string, 'keywords', keyword),
							A2($elm$url$Url$Builder$string, 'service', 'tomtom')
						]);
					return _Utils_Tuple2(
						state,
						A2(
							$elm$core$Platform$Cmd$map,
							config.aut,
							$elm$http$Http$request(
								{
									_: $elm$http$Http$emptyBody,
									aH: A2(
										$author$project$Api$expectJson,
										$author$project$View$FormV2$GotAddressWithAutoFill(insertFieldValueMsg),
										$elm$json$Json$Decode$list($author$project$Model$Suggestion$locationSuggestionDecoder)),
									ax: _List_fromArray(
										[
											A2($elm$http$Http$header, 'X-XSRF-TOKEN', state_.ci)
										]),
									aO: 'GET',
									a_: $elm$core$Maybe$Nothing,
									av3: $elm$core$Maybe$Just('addres-with-auto-fill'),
									a0: A2(
										$elm$url$Url$Builder$absolute,
										_List_fromArray(
											[
												'api',
												$author$project$Data$Id$toString(state_.atF),
												'suggestions',
												'locations'
											]),
										params)
								})));
				default:
					if (!msg.b.$) {
						if (!msg.b.a.b) {
							var validationError = $author$project$Api$ValidationError(
								{
									atU: A2(
										$elm$core$Dict$singleton,
										$author$project$Data$Form$fieldNameToString($author$project$Model$FormFieldV2$AddressWithAutoFill),
										A2($elm$core$Dict$singleton, 'nl', $author$project$Copy$copy.$C)),
									Ln: $elm$core$Dict$empty,
									_l: $elm$core$Dict$empty
								});
							return _Utils_Tuple2(
								_Utils_update(
									state_,
									{
										bq: $author$project$Data$Status$Failure(validationError)
									}),
								A2(
									$elm$core$Platform$Cmd$map,
									config.aut,
									A2($author$project$View$FormV2$focusOnErrorField, state_.eW, validationError)));
						} else {
							var insertFieldValueMsg = msg.a;
							var _v15 = msg.b.a;
							var locationSuggestion = _v15.a;
							return _Utils_Tuple2(
								state,
								A2(
									$elm$core$Task$perform,
									$elm$core$Basics$always(
										config.aut(
											insertFieldValueMsg(
												_Utils_Tuple2(locationSuggestion.akc, locationSuggestion.Rr)))),
									$elm$time$Time$now));
						}
					} else {
						var err = msg.b.a;
						return _Utils_Tuple2(
							state,
							A2(
								$elm$core$Platform$Cmd$map,
								config.aut,
								A2($author$project$View$FormV2$focusOnErrorField, state_.eW, err)));
					}
			}
		}
	});
var $author$project$View$ChatBot$updateLocationSuggestions = F5(
	function (domainId, nodeId, locationSuggestionsMsg, locationSuggestions, model) {
		var _v0 = A3(
			$author$project$View$LocationSuggestions$update,
			A4($author$project$View$ChatBot$locationSuggestionsConfig, domainId, nodeId, model.aW, model.ci),
			locationSuggestionsMsg,
			locationSuggestions);
		var locationSuggestionsModel = _v0.a;
		var locationSuggestionsCmds = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					az: $elm$core$Maybe$Just(
						_Utils_Tuple2(nodeId, locationSuggestionsModel))
				}),
			locationSuggestionsCmds);
	});
var $author$project$View$ChatBot$updateOpenApplicationForm = F6(
	function (requestCsrfToken, domainId, formMsg, activeForm, formData, model) {
		var _v0 = A3(
			$author$project$View$FormV2$update,
			{
				atp: $elm$core$Maybe$Nothing,
				aut: $author$project$View$ChatBot$OpenApplicationFormMsg,
				au4: $elm$core$Platform$Cmd$none,
				X1: $elm$core$Basics$always($elm$core$Platform$Cmd$none),
				aaH: _List_Nil,
				ac7: requestCsrfToken,
				alw: $elm$core$Maybe$Nothing
			},
			formMsg,
			formData.IF);
		var formState = _v0.a;
		var formCmds = _v0.b;
		var _v1 = function () {
			var _v2 = $author$project$View$FormV2$submitStatus(formState);
			if (_v2.$ === 3) {
				return $author$project$View$ChatBot$storeLocalStorageState_(
					A3($author$project$View$ChatBot$focusOn, domainId, activeForm.O, model));
			} else {
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			}
		}();
		var nextModel = _v1.a;
		var nextCmds = _v1.b;
		return _Utils_Tuple2(
			_Utils_update(
				nextModel,
				{
					K: $elm$core$Maybe$Just(
						_Utils_update(
							activeForm,
							{
								IF: $author$project$Data$Status$Success(
									_Utils_update(
										formData,
										{IF: formState}))
							}))
				}),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[formCmds, nextCmds])));
	});
var $author$project$View$ChatBot$updateInternal = F5(
	function (requestCsrfToken, domainId, langCode, msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 19:
				var rawToken = msg.a;
				var token = A2($author$project$Api$csrfTokenWithDefault, model.ci, rawToken);
				return A3(
					$elm$core$List$foldl,
					F2(
						function (formMsg, _v1) {
							var m = _v1.a;
							var cmds = _v1.b;
							return A2(
								$elm$core$Tuple$mapSecond,
								function (cmd) {
									return $elm$core$Platform$Cmd$batch(
										_List_fromArray(
											[cmds, cmd]));
								},
								A5($author$project$View$ChatBot$updateInternal, requestCsrfToken, domainId, langCode, formMsg, m));
						}),
					_Utils_Tuple2(
						A2($author$project$View$ChatBot$setCsrfToken, token, model),
						$elm$core$Platform$Cmd$none),
					_List_fromArray(
						[
							$author$project$View$ChatBot$FormMsg(
							$author$project$View$FormV2$GotCsrfToken(token)),
							$author$project$View$ChatBot$OpenApplicationFormMsg(
							$author$project$View$FormV2$GotCsrfToken(token))
						]));
			case 1:
				var nodeId = msg.a;
				var searchParams = msg.b;
				var result = msg.c;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							Y: A3(
								$author$project$Dict$Custom$insert,
								nodeId,
								A2(
									$author$project$Data$Status$map,
									$elm$core$Tuple$pair(searchParams),
									$author$project$Data$Status$fromResult(result)),
								model.Y)
						}),
					A2(
						$elm$core$Platform$Cmd$map,
						$author$project$View$ChatBot$ScrollToMsg,
						$author$project$ScrollToInElement$scrollToBottom(model.V)));
			case 2:
				var result = msg.a;
				var mergedUploads = A2(
					$elm$core$Result$withDefault,
					model.ape,
					A2(
						$elm$core$Result$map,
						function (fetched) {
							return A2($author$project$Data$ImageSource$mergeUploads, model.ape, fetched.ape);
						},
						result));
				var initForm = F2(
					function (vacancyId, fetched) {
						return {
							IF: $author$project$View$FormV2$init(
								{
									ci: model.ci,
									atB: 151,
									atF: domainId,
									eW: $author$project$Data$FormSource$FormCms(fetched.IF),
									dA: $author$project$Model$Form$FormType$JobApplicationData(vacancyId),
									auC: $elm$core$Maybe$Nothing,
									aeo: fetched.aeo,
									fB: fetched.fB,
									fN: $elm$core$Maybe$Nothing,
									fO: $elm$core$Maybe$Nothing,
									ape: mergedUploads
								}),
							anB: A2($author$project$Data$Translation$translationsFromEntities, langCode, fetched.anB)
						};
					});
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							G: A2(
								$elm$core$Maybe$map,
								function (x) {
									return _Utils_update(
										x,
										{
											IF: A2(
												$author$project$Data$Status$map,
												initForm(x.aqL),
												$author$project$Data$Status$fromResult(result))
										});
								},
								model.G),
							aI: $elm$core$Maybe$Just('0-input'),
							ape: mergedUploads
						}),
					A2(
						$elm$core$Platform$Cmd$map,
						$author$project$View$ChatBot$ScrollToMsg,
						A2($author$project$ScrollToInElement$scrollToCustomTask, model.V, $author$project$View$ChatBot$scrollToFormNode)));
			case 3:
				var nodeId = msg.a;
				return $author$project$View$ChatBot$storeLocalStorageState_(
					A3($author$project$View$ChatBot$focusOn, domainId, nodeId, model));
			case 4:
				var index = msg.a;
				var nextModel = _Utils_update(
					model,
					{
						bj: A2(
							$elm$core$Set$insert,
							$author$project$Data$ChatBot$idToString(index),
							model.bj)
					});
				return _Utils_Tuple2(
					nextModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2(
								$elm$core$Platform$Cmd$map,
								$author$project$View$ChatBot$ScrollToMsg,
								$author$project$ScrollToInElement$scrollToBottom(model.V)),
								$author$project$View$ChatBot$queueNextNodeToShow(nextModel)
							])));
			case 6:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aI: $elm$core$Maybe$Nothing,
							V: $author$project$ScrollToInElement$cancel(model.V)
						}),
					$elm$core$Platform$Cmd$none);
			case 5:
				var scrollToMsg = msg.a;
				var _v2 = A3($author$project$ScrollToInElement$update, $author$project$View$ChatBot$ScrollToMsg, scrollToMsg, model.V);
				var scrollToModel = _v2.a;
				var scrollToCmds = _v2.b;
				var _v3 = function () {
					var _v4 = _Utils_Tuple2(
						$author$project$ScrollToInElement$isScrolling(scrollToModel),
						model.aI);
					if ((!_v4.a) && (!_v4.b.$)) {
						var id = _v4.b.a;
						return _Utils_Tuple2(
							$elm$core$Maybe$Nothing,
							A2(
								$elm$core$Task$attempt,
								$elm$core$Basics$always($author$project$View$ChatBot$NoOp),
								$elm$browser$Browser$Dom$focus(id)));
					} else {
						return _Utils_Tuple2(model.aI, $elm$core$Platform$Cmd$none);
					}
				}();
				var focusAfterScroll = _v3.a;
				var focusCmd = _v3.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{aI: focusAfterScroll, V: scrollToModel}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[focusCmd, scrollToCmds])));
			case 7:
				var nodeId = msg.a;
				var locationSuggestionsMsg = msg.b;
				var _v5 = model.az;
				if (_v5.$ === 1) {
					return A5($author$project$View$ChatBot$updateLocationSuggestions, domainId, nodeId, locationSuggestionsMsg, $author$project$View$LocationSuggestions$init, model);
				} else {
					var _v6 = _v5.a;
					var currentNodeId = _v6.a;
					var locationSuggestions = _v6.b;
					return _Utils_eq(nodeId, currentNodeId) ? A5($author$project$View$ChatBot$updateLocationSuggestions, domainId, nodeId, locationSuggestionsMsg, locationSuggestions, model) : A5($author$project$View$ChatBot$updateLocationSuggestions, domainId, nodeId, locationSuggestionsMsg, $author$project$View$LocationSuggestions$init, model);
				}
			case 8:
				var nodeId = msg.a;
				var locationSuggestion = msg.b;
				var originalSearchParams = A2($author$project$View$ChatBot$getOriginalSearchParams, nodeId, model.Y);
				var searchParams = _Utils_update(
					originalSearchParams,
					{Rs: locationSuggestion.auy});
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							az: A2(
								$elm$core$Maybe$map,
								$elm$core$Tuple$mapSecond($author$project$View$LocationSuggestions$resetWithValue),
								model.az)
						}),
					A4($author$project$View$ChatBot$requestVacancySearch, nodeId, domainId, model.ci, searchParams));
			case 9:
				var nodeId = msg.a;
				var vacancyId = msg.b;
				return $author$project$View$ChatBot$storeLocalStorageState_(
					A2(
						$author$project$View$ChatBot$requestAdditionalNodeData,
						domainId,
						_Utils_Tuple2(
							_Utils_update(
								model,
								{
									G: $elm$core$Maybe$Just(
										{IF: $author$project$Data$Status$NotAsked, O: nodeId, aqL: vacancyId})
								}),
							$elm$core$Platform$Cmd$none)));
			case 10:
				var formMsg = msg.a;
				var _v7 = A2(
					$elm$core$Maybe$map,
					function (x) {
						return _Utils_Tuple3(x.O, x.aqL, x.IF);
					},
					model.G);
				if ((!_v7.$) && (_v7.a.c.$ === 3)) {
					var _v8 = _v7.a;
					var nodeId = _v8.a;
					var vacancyId = _v8.b;
					var formData = _v8.c.a;
					var _v9 = A3(
						$author$project$View$FormV2$update,
						{
							atp: $elm$core$Maybe$Nothing,
							aut: $author$project$View$ChatBot$FormMsg,
							au4: $elm$core$Platform$Cmd$none,
							X1: $elm$core$Basics$always($elm$core$Platform$Cmd$none),
							aaH: _List_Nil,
							ac7: requestCsrfToken,
							alw: $elm$core$Maybe$Nothing
						},
						formMsg,
						formData.IF);
					var formState = _v9.a;
					var formCmds = _v9.b;
					var _v10 = function () {
						var _v11 = $author$project$View$FormV2$submitStatus(formState);
						if (_v11.$ === 3) {
							return $author$project$View$ChatBot$storeLocalStorageState_(
								A3($author$project$View$ChatBot$focusOn, domainId, nodeId, model));
						} else {
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						}
					}();
					var nextModel = _v10.a;
					var nextCmds = _v10.b;
					return _Utils_Tuple2(
						_Utils_update(
							nextModel,
							{
								G: $elm$core$Maybe$Just(
									{
										IF: $author$project$Data$Status$Success(
											_Utils_update(
												formData,
												{IF: formState})),
										O: nodeId,
										aqL: vacancyId
									})
							}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[formCmds, nextCmds])));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 11:
				return $author$project$View$ChatBot$storeLocalStorageState_(
					_Utils_Tuple2(
						_Utils_update(
							model,
							{G: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none));
			case 12:
				var result = msg.a;
				var mergedUploads = A2(
					$elm$core$Result$withDefault,
					model.ape,
					A2(
						$elm$core$Result$map,
						function (fetched) {
							return A2($author$project$Data$ImageSource$mergeUploads, model.ape, fetched.ape);
						},
						result));
				var initForm = function (fetched) {
					return {
						IF: $author$project$View$FormV2$init(
							{
								ci: model.ci,
								atB: 151,
								atF: domainId,
								eW: $author$project$Data$FormSource$FormCms(fetched.IF),
								dA: $author$project$Model$Form$FormType$OpenJobApplicationData(domainId),
								auC: $elm$core$Maybe$Nothing,
								aeo: fetched.aeo,
								fB: _List_Nil,
								fN: $elm$core$Maybe$Nothing,
								fO: $elm$core$Maybe$Nothing,
								ape: mergedUploads
							}),
						anB: A2($author$project$Data$Translation$translationsFromEntities, langCode, fetched.anB)
					};
				};
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							K: A2(
								$elm$core$Maybe$map,
								function (activeForm) {
									return _Utils_update(
										activeForm,
										{
											IF: A2(
												$author$project$Data$Status$map,
												initForm,
												$author$project$Data$Status$fromResult(result))
										});
								},
								model.K),
							aI: $elm$core$Maybe$Just('0-input'),
							ape: mergedUploads
						}),
					A2(
						$elm$core$Platform$Cmd$map,
						$author$project$View$ChatBot$ScrollToMsg,
						A2($author$project$ScrollToInElement$scrollToCustomTask, model.V, $author$project$View$ChatBot$scrollToFormNode)));
			case 13:
				var formMsg = msg.a;
				var _v12 = model.K;
				if (!_v12.$) {
					var activeForm = _v12.a;
					var _v13 = activeForm.IF;
					if (_v13.$ === 3) {
						var formData = _v13.a;
						return A6($author$project$View$ChatBot$updateOpenApplicationForm, requestCsrfToken, domainId, formMsg, activeForm, formData, model);
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 14:
				return $author$project$View$ChatBot$storeLocalStorageState_(
					_Utils_Tuple2(
						_Utils_update(
							model,
							{K: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none));
			case 15:
				var salaryCalculatorId = msg.a;
				var result = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bo: A3(
								$author$project$Dict$Custom$insert,
								salaryCalculatorId,
								$author$project$Data$Status$fromResult(result),
								model.bo)
						}),
					$elm$core$Platform$Cmd$none);
			case 16:
				var nodeId = msg.a;
				var value = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							at: A3($author$project$Dict$Custom$insert, nodeId, value, model.at)
						}),
					$elm$core$Platform$Cmd$none);
			case 17:
				var _v14 = $zwilias$elm_rosetree$Tree$Zipper$parent(model.qj);
				if (!_v14.$) {
					var parentZipper = _v14.a;
					return $author$project$View$ChatBot$storeLocalStorageState_(
						A3(
							$author$project$View$ChatBot$focusOn,
							domainId,
							$zwilias$elm_rosetree$Tree$Zipper$label(parentZipper).dE,
							_Utils_update(
								model,
								{G: $elm$core$Maybe$Nothing, K: $elm$core$Maybe$Nothing})));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			default:
				var rootNodeId = $zwilias$elm_rosetree$Tree$Zipper$label(
					$zwilias$elm_rosetree$Tree$Zipper$root(model.qj)).dE;
				return $author$project$View$ChatBot$storeLocalStorageState_(
					A3(
						$author$project$View$ChatBot$focusOn,
						domainId,
						rootNodeId,
						_Utils_update(
							model,
							{G: $elm$core$Maybe$Nothing, K: $elm$core$Maybe$Nothing, az: $elm$core$Maybe$Nothing, at: $author$project$Data$ChatBot$emptyDict, bo: $author$project$Data$Id$emptyDict, Y: $author$project$Data$ChatBot$emptyDict})));
		}
	});
var $author$project$View$ChatBot$update = F6(
	function (lift, requestCsrfToken, domainId, langCode, msg, model) {
		return A2(
			$elm$core$Tuple$mapSecond,
			$elm$core$Platform$Cmd$map(lift),
			A5($author$project$View$ChatBot$updateInternal, requestCsrfToken, domainId, langCode, msg, model));
	});
var $author$project$RecruitmentChat$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 1:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bp: $elm$core$Maybe$Just(true)
						}),
					$author$project$RecruitmentChat$showRecruitmentChat(true));
			case 2:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bp: $elm$core$Maybe$Just(false)
						}),
					$author$project$RecruitmentChat$showRecruitmentChat(false));
			case 3:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{eh: false}),
					$elm$core$Platform$Cmd$none);
			case 0:
				var chatBotMsg = msg.a;
				var _v1 = A6($author$project$View$ChatBot$update, $author$project$RecruitmentChat$ChatBotMsg, $author$project$RecruitmentChat$requestRecruitmentChatCsrfToken, model.dp, model.Ql, chatBotMsg, model.qj);
				var chatBot = _v1.a;
				var chatBotCmd = _v1.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{qj: chatBot}),
					chatBotCmd);
			case 4:
				var _v2 = A2(
					$author$project$View$ChatBot$init,
					$author$project$RecruitmentChat$ChatBotMsg,
					{qj: model.aa4.qj, ci: model.ci, S: model.S, dp: model.aa4.dp, FG: model.cH, dP: $elm$core$Maybe$Nothing, ft: model.ft, aV: model.aV, aW: model.aW, ape: model.ape, a3: model.a3});
				var chatBot = _v2.a;
				var chatBotCmd = _v2.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{qj: chatBot}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								chatBotCmd,
								$author$project$View$ChatBot$storeLocalStorageState(
								$author$project$View$ChatBot$encodeLocalStorageState(chatBot))
							])));
			case 5:
				var rawToken = msg.a;
				var token = A2($author$project$Api$csrfTokenWithDefault, model.ci, rawToken);
				return A2(
					$elm$core$Tuple$mapFirst,
					function (m) {
						return _Utils_update(
							m,
							{ci: token});
					},
					A2(
						$author$project$RecruitmentChat$update,
						$author$project$RecruitmentChat$ChatBotMsg(
							$author$project$View$ChatBot$GotCsrfToken(token)),
						model));
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$RecruitmentChat$HideChatBot = {$: 2};
var $author$project$RecruitmentChat$ResetChat = {$: 4};
var $author$project$Browser$Dom$Breakpoint$custom = $elm$core$Basics$identity;
var $author$project$Browser$Dom$Breakpoint$zero = 0;
var $author$project$Browser$Dom$Breakpoint$isMobile = function (windowWidth) {
	return A3(
		$author$project$Browser$Dom$Breakpoint$isBetween,
		windowWidth,
		$author$project$Browser$Dom$Breakpoint$zero,
		$author$project$Browser$Dom$Breakpoint$custom(992));
};
var $author$project$RecruitmentChat$resolveBotAvatar = F2(
	function (uploads, maybeImageSource) {
		return A2(
			$elm$core$Maybe$andThen,
			$author$project$Data$ImageSource$toTextFromUploads(uploads),
			maybeImageSource);
	});
var $author$project$View$ChatBot$CancelScroll = {$: 6};
var $author$project$View$ChatBot$nodeMetadata = function (node) {
	switch (node.$) {
		case 0:
			return {dc: 'chatbot-node-option', ad: true};
		case 5:
			return {dc: 'chatbot-node-salarycalculator', ad: true};
		case 4:
			return {dc: 'chatbot-node-vacancyoverview', ad: false};
		case 1:
			return {dc: 'chatbot-node-text', ad: false};
		case 2:
			return {dc: 'chatbot-node-title', ad: false};
		case 3:
			var settings = node.a;
			return {
				dc: settings.ahr ? 'chatbot-node-link chatbot-node-link-button' : 'chatbot-node-link',
				ad: false
			};
		case 6:
			return {dc: 'chatbot-node-image', ad: false};
		case 7:
			return {dc: 'chatbot-node-video', ad: false};
		case 8:
			return {dc: 'chatbot-node-embeddedchatbot', ad: false};
		case 9:
			return {dc: 'chatbot-node-open-application-form', ad: false};
		default:
			return {dc: 'chatbot-node-root', ad: false};
	}
};
var $author$project$View$ChatBot$nodeClassName = A2(
	$elm$core$Basics$composeL,
	function ($) {
		return $.dc;
	},
	$author$project$View$ChatBot$nodeMetadata);
var $author$project$Data$Status$withStatus = F3(
	function (status, _default, f) {
		switch (status.$) {
			case 3:
				var a = status.a;
				return f(a);
			case 0:
				return _default;
			case 1:
				return _default;
			default:
				return _default;
		}
	});
var $author$project$View$ChatBot$getHoursAndAge = F4(
	function (nodeId, salaryCalculatorId, salaryCalculatorInput, salaryCalculators) {
		var mapStatus = function (val) {
			return A3(
				$author$project$Data$Status$withStatus,
				val,
				{hj: 16, MX: 40},
				function (_v0) {
					var salary = _v0.b;
					return {
						hj: $author$project$Data$SalaryCalculator$minAge(salary),
						MX: A2($elm$core$Maybe$withDefault, 40, salary.Sy)
					};
				});
		};
		var getDefault = A2(
			$elm$core$Maybe$withDefault,
			{hj: 16, MX: 40},
			A2(
				$elm$core$Maybe$map,
				mapStatus,
				$elm_community$maybe_extra$Maybe$Extra$join(
					A2(
						$elm$core$Maybe$map,
						function (id) {
							return A2($author$project$Dict$Custom$get, id, salaryCalculators);
						},
						salaryCalculatorId))));
		return A2(
			$elm$core$Maybe$withDefault,
			getDefault,
			A2($author$project$Dict$Custom$get, nodeId, salaryCalculatorInput));
	});
var $author$project$View$ChatBot$salaryCalculatorInputWithFallback = F3(
	function (salaryCalculatorId, data, nodeId) {
		return A4($author$project$View$ChatBot$getHoursAndAge, nodeId, salaryCalculatorId, data.at, data.bo);
	});
var $author$project$View$ChatBot$viewImageNode = F2(
	function (uploads, imageSource) {
		var _v0 = A2($author$project$Data$ImageSource$toTextFromUploads, uploads, imageSource);
		if (!_v0.$) {
			var path = _v0.a;
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$img,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$src(path)
						]),
					_List_Nil)
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Data$ChatBot$targetToValue = function (target) {
	if (!target) {
		return '_blank';
	} else {
		return '_self';
	}
};
var $author$project$View$ChatBot$viewLinkNode = function (settings) {
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$target(
					$author$project$Data$ChatBot$targetToValue(settings.alt)),
					$elm$html$Html$Attributes$href(settings.a0),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('btn btn-submit primary bg-color-1 color-white', settings.ahr)
						]))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(settings.avV)
				]))
		]);
};
var $author$project$View$ChatBot$isUserAction = A2(
	$elm$core$Basics$composeL,
	function ($) {
		return $.ad;
	},
	$author$project$View$ChatBot$nodeMetadata);
var $author$project$View$ChatBot$viewNodeAvatar = F2(
	function (node, maybeAvatar) {
		return A2(
			$author$project$Util$View$viewIfNot,
			$author$project$View$ChatBot$isUserAction(node),
			function (_v0) {
				return A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pop-in chatbot-node-avatar'),
							function () {
							if (maybeAvatar.$ === 1) {
								return $elm$html$Html$Attributes$class('chatbot-node-noavatar');
							} else {
								var avatar = maybeAvatar.a;
								return A2(
									$elm$html$Html$Attributes$style,
									'background-image',
									A2(
										$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
										'url(\'{0}\')',
										_List_fromArray(
											[avatar])));
							}
						}()
						]),
					_List_Nil);
			});
	});
var $author$project$View$FormV2$SubmitForm = {$: 3};
var $author$project$Data$Status$isSuccess = function (status) {
	switch (status.$) {
		case 3:
			return true;
		case 0:
			return false;
		case 1:
			return false;
		default:
			return false;
	}
};
var $author$project$View$FormV2$contentControlCountFor = function (content) {
	switch (content.$) {
		case 3:
			return 1;
		case 7:
			return 1;
		default:
			return 0;
	}
};
var $author$project$View$FormV2$controlCountForType = F2(
	function (screeningQuestions, fieldType) {
		switch (fieldType.$) {
			case 0:
				return 4;
			case 1:
				return 1;
			case 2:
				return 1;
			case 3:
				var content = fieldType.a;
				return $author$project$View$FormV2$contentControlCountFor(content);
			case 4:
				return 1;
			case 5:
				var options = fieldType.a;
				return $elm$core$List$length(options.as4);
			case 6:
				return 1;
			case 7:
				return 1;
			case 8:
				return 0;
			case 9:
				return 2;
			case 11:
				return 1;
			case 10:
				return 1;
			case 18:
				return A3(
					$elm$core$List$foldl,
					F2(
						function (question, total) {
							return total + A2($author$project$View$FormV2$controlCountForType, _List_Nil, question.Hy);
						}),
					0,
					screeningQuestions);
			case 12:
				return 1;
			case 13:
				var items = fieldType.a;
				return $elm$core$List$length(items);
			case 14:
				return 1;
			case 15:
				return 1;
			case 16:
				return 1;
			case 17:
				return 1;
			default:
				return 1;
		}
	});
var $author$project$View$FormV2$controlCountFor = F2(
	function (screeningQuestions, field) {
		var _v0 = field.dY;
		switch (_v0.$) {
			case 62:
				return 2;
			case 35:
				return 0;
			default:
				return A2($author$project$View$FormV2$controlCountForType, screeningQuestions, field.ew);
		}
	});
var $author$project$View$FormV2$submitTabIndex = F3(
	function (minIndex, screeningQuestions, fields) {
		return A3(
			$elm$core$List$foldl,
			F2(
				function (field, total) {
					return total + A2($author$project$View$FormV2$controlCountFor, screeningQuestions, field);
				}),
			minIndex,
			fields);
	});
var $author$project$View$FormV2$AlignFlexEnd = 2;
var $author$project$View$FormV2$Combined = 3;
var $author$project$View$FormV2$Joined = 1;
var $elm$core$List$intersperse = F2(
	function (sep, xs) {
		if (!xs.b) {
			return _List_Nil;
		} else {
			var hd = xs.a;
			var tl = xs.b;
			var step = F2(
				function (x, rest) {
					return A2(
						$elm$core$List$cons,
						sep,
						A2($elm$core$List$cons, x, rest));
				});
			var spersed = A3($elm$core$List$foldr, step, _List_Nil, tl);
			return A2($elm$core$List$cons, hd, spersed);
		}
	});
var $author$project$Util$Base$flip = F3(
	function (f, b, a) {
		return A2(f, a, b);
	});
var $author$project$View$FormV2$isCurrentRowOneOrMore = F2(
	function (currentFields, _v0) {
		var oneOrMore = _v0;
		var names = A2(
			$elm$core$List$map,
			function ($) {
				return $.dY;
			},
			currentFields);
		return A2(
			$elm$core$List$any,
			$elm$core$Basics$eq(true),
			A2(
				$elm$core$List$map,
				function (v) {
					return ($elm$core$List$length(v) >= 2) && A2(
						$elm$core$List$all,
						A2($author$project$Util$Base$flip, $elm$core$List$member, names),
						v);
				},
				oneOrMore));
	});
var $author$project$View$FormV2$intersperseOneOrMoreRow = F3(
	function (currentFields, oneOrMoreNames, columns) {
		return A2($author$project$View$FormV2$isCurrentRowOneOrMore, currentFields, oneOrMoreNames) ? A2(
			$elm$core$List$intersperse,
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('or')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text($author$project$Copy$copy.jC)
					])),
			columns) : columns;
	});
var $author$project$View$FormV2$tabindexMap = F3(
	function (minIndex, screeningQuestions, fields) {
		var step = F2(
			function (field, _v0) {
				var currentIndex = _v0.a;
				var dict = _v0.b;
				return _Utils_Tuple2(
					currentIndex + A2($author$project$View$FormV2$controlCountFor, screeningQuestions, field),
					A3($pzp1997$assoc_list$AssocList$insert, field.dY, currentIndex, dict));
			});
		return A3(
			$elm$core$List$foldl,
			step,
			_Utils_Tuple2(minIndex, $pzp1997$assoc_list$AssocList$empty),
			fields).b;
	});
var $author$project$View$FormV2$tabindex = F4(
	function (minIndex, screeningQuestions, fieldName, fields) {
		return A2(
			$elm$core$Maybe$withDefault,
			minIndex,
			A2(
				$pzp1997$assoc_list$AssocList$get,
				fieldName,
				A3($author$project$View$FormV2$tabindexMap, minIndex, screeningQuestions, fields)));
	});
var $author$project$View$FormV2$Normal = 0;
var $author$project$View$FormV2$toRowStyle = F2(
	function (oneOrMoreNames, fields) {
		var _v0 = _Utils_Tuple2(
			A2(
				$elm$core$List$map,
				function ($) {
					return $.dY;
				},
				fields),
			A2(
				$elm$core$List$map,
				function ($) {
					return $.ew;
				},
				fields));
		_v0$3:
		while (true) {
			_v0$4:
			while (true) {
				if (_v0.a.b) {
					if (_v0.a.b.b) {
						if (((_v0.a.a.$ === 29) && (_v0.a.b.a.$ === 44)) && (!_v0.a.b.b.b)) {
							var _v1 = _v0.a;
							var _v2 = _v1.a;
							var _v3 = _v1.b;
							var _v4 = _v3.a;
							return 1;
						} else {
							if ((_v0.b.b && (_v0.b.a.$ === 9)) && (!_v0.b.b.b)) {
								break _v0$3;
							} else {
								break _v0$4;
							}
						}
					} else {
						switch (_v0.a.a.$) {
							case 5:
								var _v5 = _v0.a;
								var _v6 = _v5.a;
								return 3;
							case 6:
								var _v7 = _v0.a;
								var _v8 = _v7.a;
								return 3;
							default:
								if ((_v0.b.b && (_v0.b.a.$ === 9)) && (!_v0.b.b.b)) {
									break _v0$3;
								} else {
									break _v0$4;
								}
						}
					}
				} else {
					if ((_v0.b.b && (_v0.b.a.$ === 9)) && (!_v0.b.b.b)) {
						break _v0$3;
					} else {
						break _v0$4;
					}
				}
			}
			return A2($author$project$View$FormV2$isCurrentRowOneOrMore, fields, oneOrMoreNames) ? 2 : 0;
		}
		var _v9 = _v0.b;
		var _v10 = _v9.a;
		return 3;
	});
var $author$project$Model$FormFieldValueV2$AddressValue_ = function (a) {
	return {$: 9, a: a};
};
var $author$project$Model$FormFieldValueV2$BoolValue = function (a) {
	return {$: 2, a: a};
};
var $author$project$Model$FormFieldValueV2$DateValue = function (a) {
	return {$: 1, a: a};
};
var $author$project$Model$FormFieldValueV2$PhoneNumberWithCallingCodeValue = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$Model$FormFieldValueV2$RadioValue = function (a) {
	return {$: 4, a: a};
};
var $author$project$Model$FormFieldValueV2$RangeValue = function (a) {
	return {$: 7, a: a};
};
var $author$project$Model$FormFieldValueV2$SelectMultipleValue = function (a) {
	return {$: 6, a: a};
};
var $author$project$Model$CountryCallingCode$all = _List_fromArray(
	[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126, 127, 128, 129, 130, 131, 132, 133, 134, 135, 136, 137, 138, 139, 140, 141, 142, 143, 144, 145, 146, 147, 148, 149, 150, 151, 152, 153, 154, 155, 156, 157, 158, 159, 160, 161, 162, 163, 164, 165, 166, 167, 168, 169, 170, 171, 172, 173, 174, 175, 176, 177, 178, 179, 180, 181, 182, 183, 184, 185, 186, 187, 188, 189, 190, 191, 192, 193, 194, 195, 196, 197, 198, 199, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 242]);
var $author$project$Model$Translation$callingCodeLabel = 'calling-code-label';
var $author$project$Component$Form$Checkbox$Attribute = $elm$core$Basics$identity;
var $author$project$Component$Form$Checkbox$Checkbox = $elm$core$Basics$identity;
var $author$project$Component$Form$Checkbox$set = function (_with) {
	return function (_v0) {
		var config = _v0;
		return _with(config);
	};
};
var $author$project$Component$Form$Checkbox$checked = function (value_) {
	return $author$project$Component$Form$Checkbox$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{ce: value_});
		});
};
var $rtfeldman$elm_css$Html$Styled$Attributes$attribute = $rtfeldman$elm_css$VirtualDom$Styled$attribute;
var $author$project$Component$Form$TextInput$htmlAttributes = function (attrs) {
	return $author$project$Component$Form$TextInput$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{cv: attrs});
		});
};
var $rtfeldman$elm_css$Html$Styled$Events$preventDefaultOn = F2(
	function (event, decoder) {
		return A2(
			$rtfeldman$elm_css$VirtualDom$Styled$on,
			event,
			$elm$virtual_dom$VirtualDom$MayPreventDefault(decoder));
	});
var $author$project$View$FormV2$disableCopyPasteAttrs = function (enabled) {
	return enabled ? _List_fromArray(
		[
			$author$project$Component$Form$TextInput$htmlAttributes(
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$Events$preventDefaultOn,
					'paste',
					$elm$json$Json$Decode$succeed(
						_Utils_Tuple2($author$project$View$FormV2$NoOp, true))),
					A2(
					$rtfeldman$elm_css$Html$Styled$Events$preventDefaultOn,
					'copy',
					$elm$json$Json$Decode$succeed(
						_Utils_Tuple2($author$project$View$FormV2$NoOp, true))),
					A2(
					$rtfeldman$elm_css$Html$Styled$Events$preventDefaultOn,
					'cut',
					$elm$json$Json$Decode$succeed(
						_Utils_Tuple2($author$project$View$FormV2$NoOp, true))),
					A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'autocomplete', 'off')
				]))
		]) : _List_Nil;
};
var $author$project$Component$Form$TextInput$disabled = function (disabled_) {
	return $author$project$Component$Form$TextInput$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{$7: disabled_});
		});
};
var $author$project$Component$Form$TextInput$Email = 0;
var $author$project$Component$Form$TextInput$type_ = function (inputType_) {
	return $author$project$Component$Form$TextInput$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{ew: inputType_});
		});
};
var $author$project$Component$Form$TextInput$email = $author$project$Component$Form$TextInput$type_(0);
var $author$project$Component$Form$Checkbox$error = function (error_) {
	return $author$project$Component$Form$Checkbox$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{cn: error_});
		});
};
var $author$project$Component$Form$CheckboxGroup$Attribute = $elm$core$Basics$identity;
var $author$project$Component$Form$CheckboxGroup$CheckboxGroup = $elm$core$Basics$identity;
var $author$project$Component$Form$CheckboxGroup$set = function (_with) {
	return function (_v0) {
		var config = _v0;
		return _with(config);
	};
};
var $author$project$Component$Form$CheckboxGroup$error = function (error_) {
	return $author$project$Component$Form$CheckboxGroup$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{cn: error_});
		});
};
var $author$project$Component$Form$DateInput$Attribute = $elm$core$Basics$identity;
var $author$project$Component$Form$DateInput$DateInput = $elm$core$Basics$identity;
var $author$project$Component$Form$DateInput$set = function (_with) {
	return function (_v0) {
		var config = _v0;
		return _with(config);
	};
};
var $author$project$Component$Form$DateInput$error = function (error_) {
	return $author$project$Component$Form$DateInput$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{
					bI: A2(
						$elm$core$Maybe$map,
						function (err) {
							return A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('error-message')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(err)
									]));
						},
						error_)
				});
		});
};
var $author$project$Component$Form$RangeInput$Attribute = $elm$core$Basics$identity;
var $author$project$Component$Form$RangeInput$RangeInput = $elm$core$Basics$identity;
var $author$project$Component$Form$RangeInput$set = function (_with) {
	return function (_v0) {
		var config = _v0;
		return _with(config);
	};
};
var $author$project$Component$Form$RangeInput$error = function (error_) {
	return $author$project$Component$Form$RangeInput$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{cn: error_});
		});
};
var $author$project$Component$Form$TextInput$extraHtml = function (html) {
	return $author$project$Component$Form$TextInput$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{
					co: $elm$core$Maybe$Just(html)
				});
		});
};
var $elm_community$maybe_extra$Maybe$Extra$filter = F2(
	function (f, m) {
		var _v0 = A2($elm$core$Maybe$map, f, m);
		if ((!_v0.$) && _v0.a) {
			return m;
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Model$CountryCallingCode$toCode = function (a) {
	switch (a) {
		case 0:
			return '+93';
		case 1:
			return '+358';
		case 2:
			return '+355';
		case 3:
			return '+213';
		case 4:
			return '+1';
		case 5:
			return '+376';
		case 6:
			return '+244';
		case 7:
			return '+1';
		case 8:
			return '+1';
		case 9:
			return '+54';
		case 10:
			return '+374';
		case 11:
			return '+297';
		case 12:
			return '+61';
		case 13:
			return '+43';
		case 14:
			return '+994';
		case 15:
			return '+1';
		case 16:
			return '+973';
		case 17:
			return '+880';
		case 18:
			return '+1';
		case 19:
			return '+375';
		case 20:
			return '+32';
		case 21:
			return '+501';
		case 22:
			return '+229';
		case 23:
			return '+1';
		case 24:
			return '+975';
		case 25:
			return '+591';
		case 26:
			return '+387';
		case 27:
			return '+267';
		case 28:
			return '+55';
		case 29:
			return '+246';
		case 30:
			return '+1';
		case 31:
			return '+673';
		case 32:
			return '+359';
		case 33:
			return '+226';
		case 34:
			return '+257';
		case 35:
			return '+855';
		case 36:
			return '+237';
		case 37:
			return '+1';
		case 38:
			return '+238';
		case 39:
			return '+599';
		case 40:
			return '+1';
		case 41:
			return '+236';
		case 42:
			return '+235';
		case 43:
			return '+56';
		case 44:
			return '+86';
		case 45:
			return '+61';
		case 46:
			return '+61';
		case 47:
			return '+57';
		case 48:
			return '+269';
		case 49:
			return '+682';
		case 50:
			return '+506';
		case 51:
			return '+385';
		case 52:
			return '+53';
		case 53:
			return '+599';
		case 54:
			return '+357';
		case 55:
			return '+420';
		case 56:
			return '+243';
		case 57:
			return '+45';
		case 58:
			return '+253';
		case 59:
			return '+1';
		case 60:
			return '+1';
		case 61:
			return '+593';
		case 62:
			return '+20';
		case 63:
			return '+503';
		case 64:
			return '+240';
		case 65:
			return '+291';
		case 66:
			return '+372';
		case 67:
			return '+268';
		case 68:
			return '+251';
		case 69:
			return '+500';
		case 70:
			return '+298';
		case 71:
			return '+679';
		case 72:
			return '+358';
		case 73:
			return '+33';
		case 74:
			return '+594';
		case 75:
			return '+689';
		case 76:
			return '+241';
		case 77:
			return '+220';
		case 78:
			return '+995';
		case 79:
			return '+49';
		case 80:
			return '+233';
		case 81:
			return '+350';
		case 82:
			return '+30';
		case 83:
			return '+299';
		case 84:
			return '+1';
		case 85:
			return '+590';
		case 86:
			return '+1';
		case 87:
			return '+502';
		case 88:
			return '+44';
		case 89:
			return '+224';
		case 90:
			return '+245';
		case 91:
			return '+592';
		case 92:
			return '+509';
		case 93:
			return '+504';
		case 94:
			return '+852';
		case 95:
			return '+36';
		case 96:
			return '+354';
		case 97:
			return '+91';
		case 98:
			return '+62';
		case 99:
			return '+98';
		case 100:
			return '+964';
		case 101:
			return '+353';
		case 102:
			return '+44';
		case 103:
			return '+972';
		case 104:
			return '+39';
		case 105:
			return '+225';
		case 106:
			return '+1';
		case 107:
			return '+81';
		case 108:
			return '+44';
		case 109:
			return '+962';
		case 110:
			return '+7';
		case 111:
			return '+254';
		case 112:
			return '+686';
		case 113:
			return '+383';
		case 114:
			return '+965';
		case 115:
			return '+996';
		case 116:
			return '+856';
		case 117:
			return '+371';
		case 118:
			return '+961';
		case 119:
			return '+266';
		case 120:
			return '+231';
		case 121:
			return '+218';
		case 122:
			return '+423';
		case 123:
			return '+370';
		case 124:
			return '+352';
		case 125:
			return '+853';
		case 126:
			return '+389';
		case 127:
			return '+261';
		case 128:
			return '+265';
		case 129:
			return '+60';
		case 130:
			return '+960';
		case 131:
			return '+223';
		case 132:
			return '+356';
		case 133:
			return '+692';
		case 134:
			return '+596';
		case 135:
			return '+222';
		case 136:
			return '+230';
		case 137:
			return '+262';
		case 138:
			return '+52';
		case 139:
			return '+691';
		case 140:
			return '+373';
		case 141:
			return '+377';
		case 142:
			return '+976';
		case 143:
			return '+382';
		case 144:
			return '+1';
		case 145:
			return '+212';
		case 146:
			return '+258';
		case 147:
			return '+95';
		case 148:
			return '+264';
		case 149:
			return '+674';
		case 150:
			return '+977';
		case 151:
			return '+31';
		case 152:
			return '+687';
		case 153:
			return '+64';
		case 154:
			return '+505';
		case 155:
			return '+227';
		case 156:
			return '+234';
		case 157:
			return '+683';
		case 158:
			return '+672';
		case 159:
			return '+850';
		case 160:
			return '+1';
		case 161:
			return '+47';
		case 162:
			return '+968';
		case 163:
			return '+92';
		case 164:
			return '+680';
		case 165:
			return '+970';
		case 166:
			return '+507';
		case 167:
			return '+675';
		case 168:
			return '+595';
		case 169:
			return '+51';
		case 170:
			return '+63';
		case 171:
			return '+48';
		case 172:
			return '+351';
		case 173:
			return '+1';
		case 174:
			return '+974';
		case 175:
			return '+242';
		case 176:
			return '+40';
		case 177:
			return '+7';
		case 178:
			return '+250';
		case 179:
			return '+262';
		case 180:
			return '+590';
		case 181:
			return '+290';
		case 182:
			return '+1';
		case 183:
			return '+1';
		case 184:
			return '+590';
		case 185:
			return '+508';
		case 186:
			return '+1';
		case 187:
			return '+685';
		case 188:
			return '+378';
		case 189:
			return '+239';
		case 190:
			return '+966';
		case 191:
			return '+221';
		case 192:
			return '+381';
		case 193:
			return '+248';
		case 194:
			return '+232';
		case 195:
			return '+65';
		case 196:
			return '+1';
		case 197:
			return '+421';
		case 198:
			return '+386';
		case 199:
			return '+677';
		case 200:
			return '+252';
		case 201:
			return '+27';
		case 202:
			return '+82';
		case 203:
			return '+211';
		case 204:
			return '+34';
		case 205:
			return '+94';
		case 206:
			return '+249';
		case 207:
			return '+597';
		case 208:
			return '+47';
		case 209:
			return '+46';
		case 210:
			return '+41';
		case 211:
			return '+963';
		case 212:
			return '+886';
		case 213:
			return '+992';
		case 214:
			return '+255';
		case 215:
			return '+66';
		case 216:
			return '+670';
		case 217:
			return '+228';
		case 218:
			return '+690';
		case 219:
			return '+676';
		case 220:
			return '+1';
		case 221:
			return '+216';
		case 222:
			return '+90';
		case 223:
			return '+993';
		case 224:
			return '+1';
		case 225:
			return '+688';
		case 226:
			return '+256';
		case 227:
			return '+380';
		case 228:
			return '+971';
		case 229:
			return '+44';
		case 230:
			return '+1';
		case 231:
			return '+1';
		case 232:
			return '+598';
		case 233:
			return '+998';
		case 234:
			return '+678';
		case 235:
			return '+39';
		case 236:
			return '+58';
		case 237:
			return '+84';
		case 238:
			return '+681';
		case 239:
			return '+212';
		case 240:
			return '+967';
		case 241:
			return '+260';
		default:
			return '+263';
	}
};
var $author$project$Data$CountryCallingCode$toCountryName = function (countryCallingCode) {
	switch (countryCallingCode) {
		case 0:
			return $author$project$Copy$copy.hd;
		case 1:
			return $author$project$Copy$copy.iZ;
		case 2:
			return $author$project$Copy$copy.i_;
		case 3:
			return $author$project$Copy$copy.i$;
		case 4:
			return $author$project$Copy$copy.jr;
		case 5:
			return $author$project$Copy$copy.jD;
		case 6:
			return $author$project$Copy$copy.jE;
		case 7:
			return $author$project$Copy$copy.jF;
		case 8:
			return $author$project$Copy$copy.jL;
		case 9:
			return $author$project$Copy$copy.kW;
		case 10:
			return $author$project$Copy$copy.kY;
		case 11:
			return $author$project$Copy$copy.lf;
		case 12:
			return $author$project$Copy$copy.nc;
		case 13:
			return $author$project$Copy$copy.as3;
		case 14:
			return $author$project$Copy$copy.ns;
		case 15:
			return $author$project$Copy$copy.nR;
		case 16:
			return $author$project$Copy$copy.nS;
		case 17:
			return $author$project$Copy$copy.n$;
		case 18:
			return $author$project$Copy$copy.oE;
		case 19:
			return $author$project$Copy$copy.oI;
		case 20:
			return $author$project$Copy$copy.as6;
		case 21:
			return $author$project$Copy$copy.oJ;
		case 22:
			return $author$project$Copy$copy.oK;
		case 23:
			return $author$project$Copy$copy.oL;
		case 24:
			return $author$project$Copy$copy.oS;
		case 25:
			return $author$project$Copy$copy.o_;
		case 26:
			return $author$project$Copy$copy.o1;
		case 27:
			return $author$project$Copy$copy.o3;
		case 28:
			return $author$project$Copy$copy.o8;
		case 29:
			return $author$project$Copy$copy.pb;
		case 30:
			return $author$project$Copy$copy.pc;
		case 31:
			return $author$project$Copy$copy.pj;
		case 32:
			return $author$project$Copy$copy.pl;
		case 33:
			return $author$project$Copy$copy.po;
		case 34:
			return $author$project$Copy$copy.pp;
		case 35:
			return $author$project$Copy$copy.px;
		case 36:
			return $author$project$Copy$copy.py;
		case 37:
			return $author$project$Copy$copy.pG;
		case 38:
			return $author$project$Copy$copy.pL;
		case 39:
			return $author$project$Copy$copy.pT;
		case 40:
			return $author$project$Copy$copy.pY;
		case 41:
			return $author$project$Copy$copy.p_;
		case 42:
			return $author$project$Copy$copy.p$;
		case 43:
			return $author$project$Copy$copy.qr;
		case 44:
			return $author$project$Copy$copy.atg;
		case 45:
			return $author$project$Copy$copy.qJ;
		case 46:
			return $author$project$Copy$copy.rA;
		case 47:
			return $author$project$Copy$copy.rE;
		case 48:
			return $author$project$Copy$copy.r$;
		case 49:
			return $author$project$Copy$copy.wI;
		case 50:
			return $author$project$Copy$copy.w3;
		case 51:
			return $author$project$Copy$copy.xw;
		case 52:
			return $author$project$Copy$copy.xL;
		case 53:
			return $author$project$Copy$copy.xM;
		case 54:
			return $author$project$Copy$copy.yi;
		case 55:
			return $author$project$Copy$copy.yj;
		case 56:
			return $author$project$Copy$copy.sn;
		case 57:
			return $author$project$Copy$copy.atD;
		case 58:
			return $author$project$Copy$copy.Eg;
		case 59:
			return $author$project$Copy$copy.Ev;
		case 60:
			return $author$project$Copy$copy.Ew;
		case 61:
			return $author$project$Copy$copy.EM;
		case 62:
			return $author$project$Copy$copy.E2;
		case 63:
			return $author$project$Copy$copy.E3;
		case 64:
			return $author$project$Copy$copy.F8;
		case 65:
			return $author$project$Copy$copy.F9;
		case 66:
			return $author$project$Copy$copy.Gn;
		case 67:
			return $author$project$Copy$copy.Go;
		case 68:
			return $author$project$Copy$copy.Gp;
		case 69:
			return $author$project$Copy$copy.He;
		case 70:
			return $author$project$Copy$copy.Hf;
		case 71:
			return $author$project$Copy$copy.HB;
		case 72:
			return $author$project$Copy$copy.atZ;
		case 73:
			return $author$project$Copy$copy.at6;
		case 74:
			return $author$project$Copy$copy.KC;
		case 75:
			return $author$project$Copy$copy.KD;
		case 76:
			return $author$project$Copy$copy.K9;
		case 77:
			return $author$project$Copy$copy.La;
		case 78:
			return $author$project$Copy$copy.Li;
		case 79:
			return $author$project$Copy$copy.at8;
		case 80:
			return $author$project$Copy$copy.Lj;
		case 81:
			return $author$project$Copy$copy.Lk;
		case 82:
			return $author$project$Copy$copy.LP;
		case 83:
			return $author$project$Copy$copy.LT;
		case 84:
			return $author$project$Copy$copy.LU;
		case 85:
			return $author$project$Copy$copy.L5;
		case 86:
			return $author$project$Copy$copy.L6;
		case 87:
			return $author$project$Copy$copy.L7;
		case 88:
			return $author$project$Copy$copy.L8;
		case 89:
			return $author$project$Copy$copy.L9;
		case 90:
			return $author$project$Copy$copy.Ma;
		case 91:
			return $author$project$Copy$copy.Mc;
		case 92:
			return $author$project$Copy$copy.Md;
		case 93:
			return $author$project$Copy$copy.MR;
		case 94:
			return $author$project$Copy$copy.MS;
		case 95:
			return $author$project$Copy$copy.auh;
		case 96:
			return $author$project$Copy$copy.Ns;
		case 97:
			return $author$project$Copy$copy.NT;
		case 98:
			return $author$project$Copy$copy.NU;
		case 99:
			return $author$project$Copy$copy.OU;
		case 100:
			return $author$project$Copy$copy.OV;
		case 101:
			return $author$project$Copy$copy.aup;
		case 102:
			return $author$project$Copy$copy.O5;
		case 103:
			return $author$project$Copy$copy.O7;
		case 104:
			return $author$project$Copy$copy.O9;
		case 105:
			return $author$project$Copy$copy.Pg;
		case 106:
			return $author$project$Copy$copy.Ph;
		case 107:
			return $author$project$Copy$copy.Pi;
		case 108:
			return $author$project$Copy$copy.Pj;
		case 109:
			return $author$project$Copy$copy.PR;
		case 110:
			return $author$project$Copy$copy.P_;
		case 111:
			return $author$project$Copy$copy.P$;
		case 112:
			return $author$project$Copy$copy.P9;
		case 113:
			return $author$project$Copy$copy.Qd;
		case 114:
			return $author$project$Copy$copy.Qf;
		case 115:
			return $author$project$Copy$copy.Qg;
		case 116:
			return $author$project$Copy$copy.Qo;
		case 117:
			return $author$project$Copy$copy.QF;
		case 118:
			return $author$project$Copy$copy.QQ;
		case 119:
			return $author$project$Copy$copy.QS;
		case 120:
			return $author$project$Copy$copy.QT;
		case 121:
			return $author$project$Copy$copy.QU;
		case 122:
			return $author$project$Copy$copy.QV;
		case 123:
			return $author$project$Copy$copy.Rn;
		case 124:
			return $author$project$Copy$copy.auB;
		case 125:
			return $author$project$Copy$copy.R_;
		case 126:
			return $author$project$Copy$copy.R$;
		case 127:
			return $author$project$Copy$copy.R0;
		case 128:
			return $author$project$Copy$copy.R5;
		case 129:
			return $author$project$Copy$copy.R6;
		case 130:
			return $author$project$Copy$copy.R7;
		case 131:
			return $author$project$Copy$copy.R8;
		case 132:
			return $author$project$Copy$copy.R9;
		case 133:
			return $author$project$Copy$copy.Sk;
		case 134:
			return $author$project$Copy$copy.Sl;
		case 135:
			return $author$project$Copy$copy.Ss;
		case 136:
			return $author$project$Copy$copy.St;
		case 137:
			return $author$project$Copy$copy.SO;
		case 138:
			return $author$project$Copy$copy.Ta;
		case 139:
			return $author$project$Copy$copy.Tb;
		case 140:
			return $author$project$Copy$copy.Tz;
		case 141:
			return $author$project$Copy$copy.TA;
		case 142:
			return $author$project$Copy$copy.TD;
		case 143:
			return $author$project$Copy$copy.TE;
		case 144:
			return $author$project$Copy$copy.TH;
		case 145:
			return $author$project$Copy$copy.TJ;
		case 146:
			return $author$project$Copy$copy.TP;
		case 147:
			return $author$project$Copy$copy.Ua;
		case 148:
			return $author$project$Copy$copy.Ug;
		case 149:
			return $author$project$Copy$copy.Ui;
		case 150:
			return $author$project$Copy$copy.Uq;
		case 151:
			return $author$project$Copy$copy.auN;
		case 152:
			return $author$project$Copy$copy.UH;
		case 153:
			return $author$project$Copy$copy.U9;
		case 154:
			return $author$project$Copy$copy.Vv;
		case 155:
			return $author$project$Copy$copy.Vw;
		case 156:
			return $author$project$Copy$copy.Vx;
		case 157:
			return $author$project$Copy$copy.Vz;
		case 158:
			return $author$project$Copy$copy.W3;
		case 159:
			return $author$project$Copy$copy.W4;
		case 160:
			return $author$project$Copy$copy.W5;
		case 161:
			return $author$project$Copy$copy.auX;
		case 162:
			return $author$project$Copy$copy.X$;
		case 163:
			return $author$project$Copy$copy.ZQ;
		case 164:
			return $author$project$Copy$copy.ZR;
		case 165:
			return $author$project$Copy$copy.ZS;
		case 166:
			return $author$project$Copy$copy._f;
		case 167:
			return $author$project$Copy$copy._h;
		case 168:
			return $author$project$Copy$copy._i;
		case 169:
			return $author$project$Copy$copy._L;
		case 170:
			return $author$project$Copy$copy._N;
		case 171:
			return $author$project$Copy$copy.ave;
		case 172:
			return $author$project$Copy$copy.avf;
		case 173:
			return $author$project$Copy$copy.aaD;
		case 174:
			return $author$project$Copy$copy.aaF;
		case 175:
			return $author$project$Copy$copy.ac4;
		case 176:
			return $author$project$Copy$copy.avt;
		case 177:
			return $author$project$Copy$copy.adI;
		case 178:
			return $author$project$Copy$copy.adJ;
		case 179:
			return $author$project$Copy$copy.adq;
		case 180:
			return $author$project$Copy$copy.adN;
		case 181:
			return $author$project$Copy$copy.adO;
		case 182:
			return $author$project$Copy$copy.adP;
		case 183:
			return $author$project$Copy$copy.adQ;
		case 184:
			return $author$project$Copy$copy.adR;
		case 185:
			return $author$project$Copy$copy.adS;
		case 186:
			return $author$project$Copy$copy.adT;
		case 187:
			return $author$project$Copy$copy.ad8;
		case 188:
			return $author$project$Copy$copy.ad9;
		case 189:
			return $author$project$Copy$copy.aed;
		case 190:
			return $author$project$Copy$copy.aeh;
		case 191:
			return $author$project$Copy$copy.agO;
		case 192:
			return $author$project$Copy$copy.ag_;
		case 193:
			return $author$project$Copy$copy.ag4;
		case 194:
			return $author$project$Copy$copy.aik;
		case 195:
			return $author$project$Copy$copy.avA;
		case 196:
			return $author$project$Copy$copy.aim;
		case 197:
			return $author$project$Copy$copy.avC;
		case 198:
			return $author$project$Copy$copy.aiG;
		case 199:
			return $author$project$Copy$copy.aiX;
		case 200:
			return $author$project$Copy$copy.aiY;
		case 201:
			return $author$project$Copy$copy.ajc;
		case 202:
			return $author$project$Copy$copy.ajd;
		case 203:
			return $author$project$Copy$copy.aje;
		case 204:
			return $author$project$Copy$copy.avD;
		case 205:
			return $author$project$Copy$copy.ajp;
		case 206:
			return $author$project$Copy$copy.akO;
		case 207:
			return $author$project$Copy$copy.ak5;
		case 208:
			return $author$project$Copy$copy.ak6;
		case 209:
			return $author$project$Copy$copy.avQ;
		case 210:
			return $author$project$Copy$copy.avR;
		case 211:
			return $author$project$Copy$copy.alc;
		case 212:
			return $author$project$Copy$copy.alo;
		case 213:
			return $author$project$Copy$copy.alp;
		case 214:
			return $author$project$Copy$copy.als;
		case 215:
			return $author$project$Copy$copy.alR;
		case 216:
			return $author$project$Copy$copy.amY;
		case 217:
			return $author$project$Copy$copy.am3;
		case 218:
			return $author$project$Copy$copy.am4;
		case 219:
			return $author$project$Copy$copy.am7;
		case 220:
			return $author$project$Copy$copy.anG;
		case 221:
			return $author$project$Copy$copy.anK;
		case 222:
			return $author$project$Copy$copy.anL;
		case 223:
			return $author$project$Copy$copy.anM;
		case 224:
			return $author$project$Copy$copy.anN;
		case 225:
			return $author$project$Copy$copy.anP;
		case 226:
			return $author$project$Copy$copy.an3;
		case 227:
			return $author$project$Copy$copy.av6;
		case 228:
			return $author$project$Copy$copy.aoF;
		case 229:
			return $author$project$Copy$copy.aoG;
		case 230:
			return $author$project$Copy$copy.av8;
		case 231:
			return $author$project$Copy$copy.aoH;
		case 232:
			return $author$project$Copy$copy.app;
		case 233:
			return $author$project$Copy$copy.ap6;
		case 234:
			return $author$project$Copy$copy.arj;
		case 235:
			return $author$project$Copy$copy.ark;
		case 236:
			return $author$project$Copy$copy.arl;
		case 237:
			return $author$project$Copy$copy.arz;
		case 238:
			return $author$project$Copy$copy.arU;
		case 239:
			return $author$project$Copy$copy.ase;
		case 240:
			return $author$project$Copy$copy.asG;
		case 241:
			return $author$project$Copy$copy.asP;
		default:
			return $author$project$Copy$copy.asS;
	}
};
var $author$project$Data$CountryCallingCode$formatWithCountryName = function (countryCallingCode) {
	return A2(
		$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
		'{0} {1}',
		_List_fromArray(
			[
				$author$project$Data$CountryCallingCode$toCountryName(countryCallingCode),
				$author$project$Model$CountryCallingCode$toCode(countryCallingCode)
			]));
};
var $elm_community$list_extra$List$Extra$findIndexHelp = F3(
	function (index, predicate, list) {
		findIndexHelp:
		while (true) {
			if (!list.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var x = list.a;
				var xs = list.b;
				if (predicate(x)) {
					return $elm$core$Maybe$Just(index);
				} else {
					var $temp$index = index + 1,
						$temp$predicate = predicate,
						$temp$list = xs;
					index = $temp$index;
					predicate = $temp$predicate;
					list = $temp$list;
					continue findIndexHelp;
				}
			}
		}
	});
var $elm_community$list_extra$List$Extra$findIndex = $elm_community$list_extra$List$Extra$findIndexHelp(0);
var $elm_community$list_extra$List$Extra$getAt = F2(
	function (idx, xs) {
		return (idx < 0) ? $elm$core$Maybe$Nothing : $elm$core$List$head(
			A2($elm$core$List$drop, idx, xs));
	});
var $author$project$View$FormV2$getValueForDomain = F2(
	function (domainKey, values) {
		return A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$second,
			$elm_community$maybe_extra$Maybe$Extra$join(
				A2(
					$elm$core$Maybe$map,
					function (i) {
						return A2($elm_community$list_extra$List$Extra$getAt, i, values);
					},
					A2(
						$elm_community$list_extra$List$Extra$findIndex,
						A2(
							$elm$core$Basics$composeL,
							$elm$core$Basics$eq(domainKey),
							$elm$core$Tuple$first),
						values))));
	});
var $author$project$Component$Form$TextInput$hidden = $author$project$Component$Form$TextInput$set(
	function (attributes) {
		return _Utils_update(
			attributes,
			{cs: true});
	});
var $author$project$Component$Form$CheckboxGroup$hiddenLabel = function (val) {
	return $author$project$Component$Form$CheckboxGroup$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{dC: val});
		});
};
var $author$project$Component$Form$DateInput$hiddenLabel = function (val) {
	return $author$project$Component$Form$DateInput$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{dC: val});
		});
};
var $author$project$Component$Form$RangeInput$hiddenLabel = function (val) {
	return $author$project$Component$Form$RangeInput$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{dC: val});
		});
};
var $author$project$Component$Form$Checkbox$htmlLabel = function (label_) {
	return $author$project$Component$Form$Checkbox$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{
					dD: $elm$core$Maybe$Just(label_)
				});
		});
};
var $author$project$Component$Form$DateInput$icon = function (path) {
	return $author$project$Component$Form$DateInput$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{
					bb: $elm$core$Maybe$Just(path)
				});
		});
};
var $author$project$Component$Form$Checkbox$id = function (id_) {
	return $author$project$Component$Form$Checkbox$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{
					dE: $elm$core$Maybe$Just(id_)
				});
		});
};
var $author$project$Component$Form$CheckboxGroup$id = function (id_) {
	return $author$project$Component$Form$CheckboxGroup$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{
					dE: $elm$core$Maybe$Just(id_)
				});
		});
};
var $author$project$Component$Form$DateInput$id = function (id_) {
	return $author$project$Component$Form$DateInput$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{
					dE: $elm$core$Maybe$Just(id_)
				});
		});
};
var $author$project$Component$Form$RangeInput$id = function (id_) {
	return $author$project$Component$Form$RangeInput$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{
					dE: $elm$core$Maybe$Just(id_)
				});
		});
};
var $author$project$Component$Form$TextArea$id = function (id_) {
	return $author$project$Component$Form$TextArea$set(
		function (config) {
			return _Utils_update(
				config,
				{dE: id_});
		});
};
var $author$project$Component$Form$TextInput$id = function (id_) {
	return $author$project$Component$Form$TextInput$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{
					dE: $elm$core$Maybe$Just(id_)
				});
		});
};
var $author$project$Component$Form$RangeInput$max = function (max_) {
	return $author$project$Component$Form$RangeInput$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{dS: max_});
		});
};
var $author$project$Component$Form$DateInput$maxOffsetFromTodayInYears = function (maxOffsetFromTodayInYears_) {
	return $author$project$Component$Form$DateInput$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{dT: maxOffsetFromTodayInYears_});
		});
};
var $author$project$View$FormV2$toScreeningQuestionsValue_ = F2(
	function (maybeScreeningQuestion, extractF) {
		return $elm_community$maybe_extra$Maybe$Extra$join(
			A2(
				$elm$core$Maybe$map,
				extractF,
				$elm_community$maybe_extra$Maybe$Extra$join(
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.ey;
						},
						maybeScreeningQuestion))));
	});
var $author$project$View$FormV2$maybeValue = F3(
	function (config, formInput, extractF) {
		return A2(
			$elm$core$Maybe$withDefault,
			A2($author$project$View$FormV2$toScreeningQuestionsValue_, config.ae, extractF),
			A2(
				$elm$core$Maybe$map,
				$elm$core$Maybe$Just,
				$elm_community$maybe_extra$Maybe$Extra$join(
					A2(
						$elm$core$Maybe$map,
						extractF,
						A2($pzp1997$assoc_list$AssocList$get, config.Hq.dY, formInput)))));
	});
var $author$project$Component$Form$RangeInput$min = function (min_) {
	return $author$project$Component$Form$RangeInput$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{cB: min_});
		});
};
var $author$project$Component$Form$DateInput$minOffsetFromTodayInYears = function (minOffsetFromTodayInYears_) {
	return $author$project$Component$Form$DateInput$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{dU: minOffsetFromTodayInYears_});
		});
};
var $author$project$Component$Form$CheckboxGroup$name = function (name_) {
	return $author$project$Component$Form$CheckboxGroup$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{
					dY: $elm$core$Maybe$Just(name_)
				});
		});
};
var $author$project$Component$Form$RangeInput$name = function (name_) {
	return $author$project$Component$Form$RangeInput$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{
					dY: $elm$core$Maybe$Just(name_)
				});
		});
};
var $author$project$Component$Form$CheckboxGroup$onChange = function (msg_) {
	return $author$project$Component$Form$CheckboxGroup$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{
					d$: $elm$core$Maybe$Just(msg_)
				});
		});
};
var $author$project$Component$Form$Checkbox$onCheck = function (msg_) {
	return $author$project$Component$Form$Checkbox$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{
					d0: $elm$core$Maybe$Just(msg_)
				});
		});
};
var $author$project$Component$Form$DateInput$onInput = function (msg_) {
	return $author$project$Component$Form$DateInput$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{
					d1: $elm$core$Maybe$Just(msg_)
				});
		});
};
var $author$project$Component$Form$RangeInput$onInput = function (msg_) {
	return $author$project$Component$Form$RangeInput$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{
					d1: $elm$core$Maybe$Just(msg_)
				});
		});
};
var $author$project$Component$Form$CheckboxGroup$options = function (options_) {
	return $author$project$Component$Form$CheckboxGroup$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{au7: options_});
		});
};
var $elm_community$maybe_extra$Maybe$Extra$orElse = F2(
	function (ma, mb) {
		if (mb.$ === 1) {
			return ma;
		} else {
			return mb;
		}
	});
var $author$project$Component$Form$TextInput$Phone = 3;
var $author$project$Component$Form$TextInput$phone = $author$project$Component$Form$TextInput$type_(3);
var $author$project$Component$Form$Checkbox$required = function (required_) {
	return $author$project$Component$Form$Checkbox$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{eb: required_});
		});
};
var $author$project$Component$Form$CheckboxGroup$selected = function (selected_) {
	return $author$project$Component$Form$CheckboxGroup$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{bX: selected_});
		});
};
var $author$project$Component$Form$RangeInput$showValue = $author$project$Component$Form$RangeInput$set(
	function (attributes) {
		return _Utils_update(
			attributes,
			{ei: true});
	});
var $author$project$Data$CountryCallingCode$foldDiacritic = function (_char) {
	switch (_char) {
		case 'ß':
			return 's';
		case 'à':
			return 'a';
		case 'á':
			return 'a';
		case 'â':
			return 'a';
		case 'ã':
			return 'a';
		case 'ä':
			return 'a';
		case 'å':
			return 'a';
		case 'æ':
			return 'a';
		case 'ç':
			return 'c';
		case 'è':
			return 'e';
		case 'é':
			return 'e';
		case 'ê':
			return 'e';
		case 'ë':
			return 'e';
		case 'ì':
			return 'i';
		case 'í':
			return 'i';
		case 'î':
			return 'i';
		case 'ï':
			return 'i';
		case 'ð':
			return 'd';
		case 'ñ':
			return 'n';
		case 'ò':
			return 'o';
		case 'ó':
			return 'o';
		case 'ô':
			return 'o';
		case 'õ':
			return 'o';
		case 'ö':
			return 'o';
		case 'ø':
			return 'o';
		case 'ù':
			return 'u';
		case 'ú':
			return 'u';
		case 'û':
			return 'u';
		case 'ü':
			return 'u';
		case 'ý':
			return 'y';
		case 'þ':
			return 't';
		case 'ÿ':
			return 'y';
		case 'ā':
			return 'a';
		case 'ă':
			return 'a';
		case 'ą':
			return 'a';
		case 'ć':
			return 'c';
		case 'ĉ':
			return 'c';
		case 'ċ':
			return 'c';
		case 'č':
			return 'c';
		case 'ď':
			return 'd';
		case 'đ':
			return 'd';
		case 'ē':
			return 'e';
		case 'ĕ':
			return 'e';
		case 'ė':
			return 'e';
		case 'ę':
			return 'e';
		case 'ě':
			return 'e';
		case 'ĝ':
			return 'g';
		case 'ğ':
			return 'g';
		case 'ġ':
			return 'g';
		case 'ģ':
			return 'g';
		case 'ĥ':
			return 'h';
		case 'ħ':
			return 'h';
		case 'ĩ':
			return 'i';
		case 'ī':
			return 'i';
		case 'ĭ':
			return 'i';
		case 'į':
			return 'i';
		case 'ı':
			return 'i';
		case 'ĵ':
			return 'j';
		case 'ķ':
			return 'k';
		case 'ĺ':
			return 'l';
		case 'ļ':
			return 'l';
		case 'ľ':
			return 'l';
		case 'ł':
			return 'l';
		case 'ń':
			return 'n';
		case 'ņ':
			return 'n';
		case 'ň':
			return 'n';
		case 'ŋ':
			return 'n';
		case 'ō':
			return 'o';
		case 'ŏ':
			return 'o';
		case 'ő':
			return 'o';
		case 'œ':
			return 'o';
		case 'ŕ':
			return 'r';
		case 'ŗ':
			return 'r';
		case 'ř':
			return 'r';
		case 'ś':
			return 's';
		case 'ŝ':
			return 's';
		case 'ş':
			return 's';
		case 'š':
			return 's';
		case 'ţ':
			return 't';
		case 'ť':
			return 't';
		case 'ŧ':
			return 't';
		case 'ũ':
			return 'u';
		case 'ū':
			return 'u';
		case 'ŭ':
			return 'u';
		case 'ů':
			return 'u';
		case 'ű':
			return 'u';
		case 'ų':
			return 'u';
		case 'ŵ':
			return 'w';
		case 'ŷ':
			return 'y';
		case 'ź':
			return 'z';
		case 'ż':
			return 'z';
		case 'ž':
			return 'z';
		case 'ș':
			return 's';
		case 'ț':
			return 't';
		default:
			return _char;
	}
};
var $elm$core$String$map = _String_map;
var $author$project$Data$CountryCallingCode$foldForSort = A2(
	$elm$core$Basics$composeL,
	$elm$core$String$map($author$project$Data$CountryCallingCode$foldDiacritic),
	$elm$core$String$toLower);
var $author$project$Data$CountryCallingCode$sortKey = function (countryCallingCode) {
	return $author$project$Data$CountryCallingCode$foldForSort(
		$author$project$Data$CountryCallingCode$toCountryName(countryCallingCode));
};
var $author$project$Data$CountryCallingCode$sortedByCountryName = A2($elm$core$List$sortBy, $author$project$Data$CountryCallingCode$sortKey, $author$project$Model$CountryCallingCode$all);
var $author$project$Component$Form$RangeInput$step = function (step_) {
	return $author$project$Component$Form$RangeInput$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{fM: step_});
		});
};
var $author$project$Component$Form$Checkbox$tabindex = function (index) {
	return $author$project$Component$Form$Checkbox$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{
					eq: $elm$core$Maybe$Just(index)
				});
		});
};
var $author$project$Component$Form$CheckboxGroup$tabindex = function (i) {
	return $author$project$Component$Form$CheckboxGroup$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{
					eq: $elm$core$Maybe$Just(i)
				});
		});
};
var $author$project$Component$Form$DateInput$tabindex = function (i) {
	return $author$project$Component$Form$DateInput$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{
					eq: $elm$core$Maybe$Just(i)
				});
		});
};
var $author$project$Component$Form$RadioInput$tabindex = function (index) {
	return $author$project$Component$Form$RadioInput$set(
		function (config) {
			return _Utils_update(
				config,
				{
					eq: $elm$core$Maybe$Just(index)
				});
		});
};
var $author$project$Component$Form$RangeInput$tabindex = function (i) {
	return $author$project$Component$Form$RangeInput$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{
					eq: $elm$core$Maybe$Just(i)
				});
		});
};
var $author$project$Component$Form$TextArea$tabindex = function (i) {
	return $author$project$Component$Form$TextArea$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{
					eq: $elm$core$Maybe$Just(i)
				});
		});
};
var $author$project$Component$Form$TextInput$tabindex = function (i) {
	return $author$project$Component$Form$TextInput$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{
					eq: $elm$core$Maybe$Just(i)
				});
		});
};
var $author$project$View$FormV2$toAdressValue = function (value_) {
	if (value_.$ === 9) {
		var val = value_.a;
		return $elm$core$Maybe$Just(val);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$View$FormV2$toBoolValue = function (value_) {
	if (value_.$ === 2) {
		var val = value_.a;
		return $elm$core$Maybe$Just(val);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$View$FormV2$toDateValue = function (value_) {
	if ((value_.$ === 1) && (!value_.a.$)) {
		var val = value_.a.a;
		return $elm$core$Maybe$Just(val);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$View$FormV2$toDaypartValue = function (value_) {
	if (value_.$ === 10) {
		var val = value_.a;
		return $elm$core$Maybe$Just(val);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$core$String$trim = _String_trim;
var $author$project$View$FormV2$fieldMessage = function (message) {
	var _v0 = A2(
		$elm_community$maybe_extra$Maybe$Extra$filter,
		A2(
			$elm$core$Basics$composeL,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$String$isEmpty),
			$elm$core$String$trim),
		message.eS);
	if (!_v0.$) {
		return message.dK;
	} else {
		return message.e9 ? message.fw : message.dK;
	}
};
var $author$project$View$FormV2$toErrorMessage = function (message) {
	return A2(
		$elm$core$Maybe$map,
		function (serverMessage) {
			return A2(
				$elm$core$Maybe$withDefault,
				serverMessage,
				A2(
					$elm_community$maybe_extra$Maybe$Extra$filter,
					A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$String$isEmpty),
					$author$project$View$FormV2$fieldMessage(message)));
		},
		message.am);
};
var $author$project$View$FormV2$toFileValue = function (value_) {
	if (value_.$ === 3) {
		var val = value_.a;
		return val;
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$View$FormV2$toPhoneWithCallingCodeValue = function (value_) {
	if (value_.$ === 8) {
		var callingCode = value_.a;
		var val = value_.b;
		return $elm$core$Maybe$Just(
			_Utils_Tuple2(callingCode, val));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$View$FormV2$toPrivacyLabel = F6(
	function (domainKey, translations, privacyPath, name, linkTabIndex, labels) {
		var translationName = function (type_) {
			return $author$project$Data$Form$fieldNameToString(name) + ('-consent-' + type_);
		};
		var val = function (type_) {
			return A2(
				$author$project$Data$Translation$toString,
				translations,
				translationName(type_));
		};
		var privacyLink = function (linkText) {
			return A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('link link-underline'),
						$elm$html$Html$Attributes$target('_blank'),
						$elm$html$Html$Attributes$href(privacyPath),
						$elm$html$Html$Attributes$tabindex(linkTabIndex)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(linkText)
					]));
		};
		if (name.$ === 62) {
			return $elm$core$Maybe$Just(
				A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('privacy-consent')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							val('text')),
							privacyLink(
							A2(
								$elm$core$Maybe$withDefault,
								val('label'),
								A2($author$project$View$FormV2$getValueForDomain, domainKey, labels)))
						])));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$View$FormV2$toRadioValue = function (value_) {
	if (value_.$ === 4) {
		var val = value_.a;
		return $elm$core$Maybe$Just(val);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$View$FormV2$toRangeValue = function (value_) {
	if (value_.$ === 7) {
		var val = value_.a;
		return $elm$core$Maybe$Just(val);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$View$FormV2$toScreeningQuestionFormField = function (screeningQuestion) {
	var placeholder = function () {
		var _v0 = screeningQuestion.Hy;
		if (_v0.$ === 7) {
			return $author$project$Copy$copy.aex;
		} else {
			return $author$project$Copy$copy.aey;
		}
	}();
	return {
		at$: {dB: false, auo: _List_Nil, bO: _List_Nil, auJ: _List_Nil, dY: $author$project$Model$FormFieldV2$ScreeningQuestions, d5: _List_Nil, aaI: _List_Nil, ew: screeningQuestion.Hy, awp: $elm$core$Maybe$Nothing},
		aui: screeningQuestion.dE,
		auo: $author$project$Copy$copy.Ox,
		bO: screeningQuestion.bO,
		auJ: $author$project$Copy$copy.Hw,
		d5: placeholder,
		eb: screeningQuestion.eb
	};
};
var $author$project$Model$FormFieldValueV2$SelectValue = function (a) {
	return {$: 5, a: a};
};
var $author$project$Component$Form$Select$viewDefaultOption = F2(
	function (maybeDefault, current) {
		return A2(
			$elm$html$Html$option,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$value(''),
					$elm$html$Html$Attributes$selected(
					A2(
						$elm$core$Maybe$withDefault,
						true,
						A2(
							$elm$core$Maybe$map,
							$elm$core$Basics$always(false),
							current)))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					A2($elm$core$Maybe$withDefault, '-', maybeDefault))
				]));
	});
var $author$project$Component$Form$Select$viewOption = F4(
	function (current, toTitle, toValue, opt) {
		return A2(
			$elm$html$Html$option,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$value(
					toValue(opt)),
					$elm$html$Html$Attributes$selected(
					A2(
						$elm$core$Maybe$withDefault,
						false,
						A2(
							$elm$core$Maybe$map,
							$elm$core$Basics$apR(opt),
							current)))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					toTitle(opt))
				]));
	});
var $author$project$Component$Form$Select$viewSelectHelp = F2(
	function (selectAttributes, config) {
		var isEmpty = function (s) {
			return $elm$core$String$isEmpty(s) ? $elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing) : $elm$json$Json$Decode$fail('Not empty');
		};
		var decoder = $elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$json$Json$Decode$andThen,
					isEmpty,
					A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['target', 'value']),
						$elm$json$Json$Decode$string)),
					A2(
					$elm$json$Json$Decode$map,
					config.at7,
					A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['target', 'value']),
						$elm$json$Json$Decode$string))
				]));
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('custom-select')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$select,
					A2(
						$elm$core$List$cons,
						A2(
							$elm$html$Html$Events$on,
							'change',
							A2($elm$json$Json$Decode$map, config.avZ, decoder)),
						selectAttributes),
					function () {
						var _v0 = config.au7;
						if (_v0.a.$ === 1) {
							var _v1 = _v0.a;
							var xs = _v0.b;
							return A2(
								$elm$core$List$cons,
								A2($author$project$Component$Form$Select$viewDefaultOption, config.y_, config.atr),
								A2(
									$elm$core$List$map,
									A3($author$project$Component$Form$Select$viewOption, config.atr, config.av_, config.av$),
									xs));
						} else {
							var x = _v0.a.a;
							var xs = _v0.b;
							return A2(
								$elm$core$List$map,
								A3($author$project$Component$Form$Select$viewOption, config.atr, config.av_, config.av$),
								A2($elm$core$List$cons, x, xs));
						}
					}())
				]));
	});
var $author$project$Component$Form$Select$viewSelectField = F2(
	function (idValue, index) {
		return $author$project$Component$Form$Select$viewSelectHelp(
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id(idValue),
					$elm$html$Html$Attributes$tabindex(index)
				]));
	});
var $author$project$View$FormV2$viewSelectWithError = F5(
	function (id, tabIndex, label_, maybeError, selectConfig) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('form-field', true),
							_Utils_Tuple2(
							'error',
							$elm_community$maybe_extra$Maybe$Extra$isJust(maybeError))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('label'),
							$elm$html$Html$Attributes$for(id)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(label_)
						])),
					A3($author$project$Component$Form$Select$viewSelectField, id, tabIndex, selectConfig),
					A2(
					$author$project$Util$View$viewMaybe,
					maybeError,
					function (message) {
						return A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('error-message')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(message)
								]));
					})
				]));
	});
var $author$project$View$FormV2$toSelectField = F8(
	function (id, tabIndex, label_, fieldName, options, toMsg, maybeError, currentValue) {
		var toOption = function (option) {
			return _Utils_Tuple2(
				A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'{0}-{1}',
					_List_fromArray(
						[
							$author$project$Data$Form$fieldNameToString(fieldName),
							option
						])),
				option);
		};
		var selectOptions = $elm$core$Dict$fromList(
			A2($elm$core$List$map, toOption, options));
		var selectConfig = {
			atr: $elm$core$Maybe$Just(
				A2(
					$elm$core$Basics$composeL,
					A2(
						$elm$core$Basics$composeL,
						$elm$core$Basics$eq(currentValue),
						$elm$core$Maybe$Just),
					$elm$core$Tuple$first)),
			y_: $elm$core$Maybe$Nothing,
			at7: $elm$core$Maybe$Just,
			au7: _Utils_Tuple2(
				$elm$core$Maybe$Nothing,
				$elm$core$Dict$toList(selectOptions)),
			avZ: A2($elm$core$Basics$composeL, toMsg, $author$project$Model$FormFieldValueV2$SelectValue),
			av_: $elm$core$Tuple$second,
			av$: $elm$core$Tuple$second
		};
		return A5($author$project$View$FormV2$viewSelectWithError, id, tabIndex, label_, maybeError, selectConfig);
	});
var $author$project$View$FormV2$toSelectMultipleValue = function (value_) {
	if (value_.$ === 6) {
		var val = value_.a;
		return $elm$core$Maybe$Just(val);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$View$FormV2$toSelectValue = function (value_) {
	if ((value_.$ === 5) && (!value_.a.$)) {
		var val = value_.a.a;
		return $elm$core$Maybe$Just(val);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$View$FormV2$toSelectWithIdsField = F7(
	function (id, tabIndex, label_, options, toMsg, maybeError, currentValue) {
		var selectConfig = {
			atr: $elm$core$Maybe$Just(
				A2(
					$elm$core$Basics$composeL,
					A2(
						$elm$core$Basics$composeL,
						$elm$core$Basics$eq(currentValue),
						$elm$core$Maybe$Just),
					$elm$core$Tuple$first)),
			y_: $elm$core$Maybe$Nothing,
			at7: $elm$core$Maybe$Just,
			au7: _Utils_Tuple2($elm$core$Maybe$Nothing, options),
			avZ: A2($elm$core$Basics$composeL, toMsg, $author$project$Model$FormFieldValueV2$SelectValue),
			av_: $elm$core$Tuple$second,
			av$: $elm$core$Tuple$first
		};
		return A5($author$project$View$FormV2$viewSelectWithError, id, tabIndex, label_, maybeError, selectConfig);
	});
var $author$project$Data$Translation$toStringOr = F3(
	function (translations, name, defaultValue) {
		var result = A2($author$project$Data$Translation$toString, translations, name);
		return $elm$core$String$isEmpty(result) ? defaultValue : result;
	});
var $author$project$View$FormV2$toTextValue = function (value_) {
	if (!value_.$) {
		if (value_.a === '') {
			return $elm$core$Maybe$Nothing;
		} else {
			var val = value_.a;
			return $elm$core$Maybe$Just(val);
		}
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$toValidationError = F2(
	function (key, errorResponse) {
		if (!errorResponse.$) {
			var validationErrors = errorResponse.a;
			return A2(
				$elm$core$Maybe$andThen,
				$elm$core$Dict$get(
					$author$project$Util$LangCode$toString($author$project$Copy$language)),
				A2($elm$core$Dict$get, key, validationErrors.atU));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Data$FormField$unFieldNamesList = function (_v0) {
	var names = _v0;
	return $elm$core$List$concat(names);
};
var $author$project$Component$Form$TextInput$Url = 2;
var $author$project$Component$Form$TextInput$url = $author$project$Component$Form$TextInput$type_(2);
var $author$project$Component$Form$DateInput$value = function (value_) {
	return $author$project$Component$Form$DateInput$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{
					ey: $elm$core$Maybe$Just(value_)
				});
		});
};
var $author$project$Component$Form$RangeInput$value = function (value_) {
	return $author$project$Component$Form$RangeInput$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{ey: value_});
		});
};
var $author$project$View$FormV2$value = F4(
	function (config, formInput, extractF, _default) {
		return A2(
			$elm$core$Maybe$withDefault,
			_default,
			A3($author$project$View$FormV2$maybeValue, config, formInput, extractF));
	});
var $author$project$Component$Form$Checkbox$Check = 0;
var $author$project$Component$Form$Checkbox$build = {c1: $elm$core$Maybe$Nothing, ce: false, db: $elm$core$Maybe$Nothing, x$: _List_Nil, cj: _List_Nil, $7: false, cn: $elm$core$Maybe$Nothing, dy: $elm$core$Maybe$Nothing, dD: $elm$core$Maybe$Nothing, dE: $elm$core$Maybe$Nothing, dI: false, bO: '', dY: $elm$core$Maybe$Nothing, d0: $elm$core$Maybe$Nothing, bm: 0, eb: false, eq: $elm$core$Maybe$Nothing, ev: $elm$core$Maybe$Nothing, ey: $elm$core$Maybe$Nothing};
var $author$project$Component$Form$Checkbox$label = function (label_) {
	return $author$project$Component$Form$Checkbox$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{bO: label_});
		});
};
var $author$project$Component$Form$Checkbox$Switch = 1;
var $rtfeldman$elm_css$Html$Styled$Attributes$checked = $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty('checked');
var $author$project$Component$Tooltip$Attribute = $elm$core$Basics$identity;
var $author$project$Component$Tooltip$Tooltip = $elm$core$Basics$identity;
var $author$project$Component$Tooltip$set = function (_with) {
	return function (_v0) {
		var config = _v0;
		return _with(config);
	};
};
var $author$project$Component$Tooltip$content = function (content_) {
	return $author$project$Component$Tooltip$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{dg: content_});
		});
};
var $author$project$Util$Tabindex$fieldTabIndex = A2(
	$elm$core$Basics$composeL,
	$elm$core$Maybe$withDefault(_List_Nil),
	$elm$core$Maybe$map(
		A2($elm$core$Basics$composeL, $elm$core$List$singleton, $rtfeldman$elm_css$Html$Styled$Attributes$tabindex)));
var $rtfeldman$elm_css$VirtualDom$Styled$unstyledAttribute = function (prop) {
	return A3($rtfeldman$elm_css$VirtualDom$Styled$Attribute, prop, false, '');
};
var $rtfeldman$elm_css$Html$Styled$Attributes$fromUnstyled = $rtfeldman$elm_css$VirtualDom$Styled$unstyledAttribute;
var $author$project$Component$Form$Checkbox$generateId = function (labelText) {
	return A2(
		$elm$core$String$join,
		'-',
		$elm$core$String$words(labelText));
};
var $author$project$Component$Tooltip$Right = {$: 1};
var $author$project$Component$Tooltip$build = {
	Q: _List_fromArray(
		[$author$project$Component$Tooltip$Right]),
	c_: $elm$core$Maybe$Nothing,
	dg: _List_Nil,
	dB: false,
	bO: ''
};
var $author$project$Component$Tooltip$label = function (label_) {
	return $author$project$Component$Tooltip$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{bO: label_});
		});
};
var $author$project$Component$Tooltip$Bottom = {$: 3};
var $author$project$Component$Tooltip$Left = {$: 0};
var $author$project$Component$Tooltip$getBottomCustom = function (l) {
	var finder = F3(
		function (f, d, a) {
			if (a.$ === 4) {
				var i = a.a;
				return f(i);
			} else {
				return d;
			}
		});
	return $elm_community$maybe_extra$Maybe$Extra$join(
		A2(
			$elm$core$Maybe$map,
			A2(finder, $elm$core$Maybe$Just, $elm$core$Maybe$Nothing),
			A2(
				$elm_community$list_extra$List$Extra$find,
				A2(
					finder,
					$elm$core$Basics$always(true),
					false),
				l)));
};
var $author$project$Component$Tooltip$getLeftCustom = function (l) {
	var finder = F3(
		function (f, d, a) {
			if (a.$ === 5) {
				var i = a.a;
				return f(i);
			} else {
				return d;
			}
		});
	return $elm_community$maybe_extra$Maybe$Extra$join(
		A2(
			$elm$core$Maybe$map,
			A2(finder, $elm$core$Maybe$Just, $elm$core$Maybe$Nothing),
			A2(
				$elm_community$list_extra$List$Extra$find,
				A2(
					finder,
					$elm$core$Basics$always(true),
					false),
				l)));
};
var $author$project$Component$Tooltip$viewTooltip = function (_v0) {
	var config = _v0;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('tooltip', true),
						_Utils_Tuple2(
						'left',
						A2($elm$core$List$member, $author$project$Component$Tooltip$Left, config.Q)),
						_Utils_Tuple2(
						'bottom',
						A2($elm$core$List$member, $author$project$Component$Tooltip$Bottom, config.Q)),
						_Utils_Tuple2('label', true)
					]))
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Util$View$viewIfNot,
				config.dB,
				function (_v1) {
					return A2(
						$elm$core$Maybe$withDefault,
						A2(
							$elm$html$Html$h4,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('label')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(config.bO)
								])),
						config.c_);
				}),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('tooltip-container')
					]),
				_List_fromArray(
					[
						$author$project$View$Icon$viewColored($author$project$View$Icon$path.auk),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('content-tooltip'),
								A2(
								$elm$core$Maybe$withDefault,
								A2($elm$html$Html$Attributes$style, '', ''),
								A2(
									$elm$core$Maybe$map,
									function (v) {
										return A2(
											$elm$html$Html$Attributes$style,
											'bottom',
											$elm$core$String$fromInt(v) + 'px');
									},
									$author$project$Component$Tooltip$getBottomCustom(config.Q))),
								A2(
								$elm$core$Maybe$withDefault,
								A2($elm$html$Html$Attributes$style, '', ''),
								A2(
									$elm$core$Maybe$map,
									function (v) {
										return A2(
											$elm$html$Html$Attributes$style,
											'left',
											$elm$core$String$fromInt(v) + 'px');
									},
									$author$project$Component$Tooltip$getLeftCustom(config.Q)))
							]),
						config.dg)
					]))
			]));
};
var $author$project$Component$Tooltip$view = F2(
	function (name, attributes) {
		return $author$project$Component$Tooltip$viewTooltip(
			A3(
				$elm$core$List$foldl,
				F2(
					function (_v0, b) {
						var attribute = _v0;
						return attribute(b);
					}),
				$author$project$Component$Tooltip$build,
				A2(
					$elm$core$List$cons,
					$author$project$Component$Tooltip$label(name),
					attributes)));
	});
var $author$project$Component$Form$Checkbox$viewCheckbox = function (_v0) {
	var config = _v0;
	var maybeAttributes = A2(
		$elm$core$List$filterMap,
		$elm$core$Basics$identity,
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$map,
				A2($elm$core$Basics$composeL, $rtfeldman$elm_css$Html$Styled$Attributes$fromUnstyled, $elm$html$Html$Events$onCheck),
				config.d0),
				A2($elm$core$Maybe$map, $rtfeldman$elm_css$Html$Styled$Attributes$name, config.dY),
				A2($elm$core$Maybe$map, $rtfeldman$elm_css$Html$Styled$Attributes$value, config.ey),
				A2(
				$elm$core$Maybe$map,
				$rtfeldman$elm_css$Html$Styled$Attributes$attribute('aria-label'),
				config.c1)
			]));
	var label_ = function () {
		var _v7 = config.dD;
		if (!_v7.$) {
			var htmlLabel_ = _v7.a;
			return htmlLabel_;
		} else {
			return $elm$html$Html$text(config.bO);
		}
	}();
	var inputClass = function () {
		var _v6 = config.bm;
		if (!_v6) {
			return 'checkbox';
		} else {
			return 'switch';
		}
	}();
	var idValue = function () {
		var _v5 = config.dE;
		if (!_v5.$) {
			var id_ = _v5.a;
			return id_;
		} else {
			return $author$project$Component$Form$Checkbox$generateId(config.bO);
		}
	}();
	var inputAttributes = _Utils_ap(
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$type_('checkbox'),
				$rtfeldman$elm_css$Html$Styled$Attributes$disabled(config.$7),
				$rtfeldman$elm_css$Html$Styled$Attributes$checked(config.ce),
				$rtfeldman$elm_css$Html$Styled$Attributes$required(config.eb),
				$rtfeldman$elm_css$Html$Styled$Attributes$id(idValue),
				$rtfeldman$elm_css$Html$Styled$Attributes$class(
				A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'form-{0}',
					_List_fromArray(
						[inputClass]))),
				$rtfeldman$elm_css$Html$Styled$Attributes$class(
				A2($elm$core$Maybe$withDefault, '', config.db))
			]),
		$author$project$Util$Tabindex$fieldTabIndex(config.eq));
	return $rtfeldman$elm_css$Html$Styled$toUnstyled(
		A2(
			$rtfeldman$elm_css$Html$Styled$div,
			A2(
				$elm$core$List$cons,
				$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('form-field', true),
							_Utils_Tuple2(
							'error',
							$elm_community$maybe_extra$Maybe$Extra$isJust(config.cn)),
							_Utils_Tuple2('inline', config.dI)
						])),
				A2($elm$core$List$map, $rtfeldman$elm_css$Html$Styled$Attributes$fromUnstyled, config.x$)),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$fromUnstyled(
					A2(
						$author$project$Util$View$viewMaybe,
						config.ev,
						function (_v1) {
							var val = _v1.a;
							var values = _v1.b;
							return A2(
								$author$project$Component$Tooltip$view,
								val,
								_List_fromArray(
									[
										$author$project$Component$Tooltip$content(values)
									]));
						})),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('form-field-wrapper', true),
									_Utils_Tuple2('checkbox-container', true),
									_Utils_Tuple2('switch-container', config.bm === 1),
									_Utils_Tuple2('inline', true)
								])),
							$rtfeldman$elm_css$Html$Styled$Attributes$css(config.cj)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$input,
							_Utils_ap(maybeAttributes, inputAttributes),
							_List_Nil),
							$rtfeldman$elm_css$Html$Styled$fromUnstyled(
							A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class(inputClass)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Util$View$viewIf,
										!config.bm,
										function (_v2) {
											return A2($author$project$View$Icon$viewMasked, 0, $author$project$View$Icon$path.ate);
										}),
										A2(
										$author$project$Util$View$viewIf,
										config.bm === 1,
										function (_v3) {
											return A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('label')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														config.ce ? $author$project$Copy$copy.au3 : $author$project$Copy$copy.au2)
													]));
										})
									]))),
							$rtfeldman$elm_css$Html$Styled$fromUnstyled(
							A2(
								$author$project$Util$View$viewIfNot,
								_Utils_eq(
									label_,
									$elm$html$Html$text('')),
								function (_v4) {
									return A2(
										$elm$html$Html$label,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('label'),
												$elm$html$Html$Attributes$for(idValue)
											]),
										_List_fromArray(
											[label_]));
								})),
							$rtfeldman$elm_css$Html$Styled$fromUnstyled(
							A2($author$project$Util$View$viewMaybe, config.dy, $elm$core$Basics$identity))
						])),
					$rtfeldman$elm_css$Html$Styled$fromUnstyled(
					A2(
						$author$project$Util$View$viewMaybe,
						config.cn,
						function (error_) {
							return A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('error-message')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(error_)
									]));
						}))
				])));
};
var $author$project$Component$Form$Checkbox$view = F2(
	function (label_, attributes) {
		return $author$project$Component$Form$Checkbox$viewCheckbox(
			A3(
				$elm$core$List$foldl,
				function (_v0) {
					var attribute = _v0;
					return attribute;
				},
				$author$project$Component$Form$Checkbox$build,
				A2(
					$elm$core$List$cons,
					$author$project$Component$Form$Checkbox$label(label_),
					attributes)));
	});
var $author$project$Component$Form$CheckboxGroup$build = {$7: false, cn: $elm$core$Maybe$Nothing, dC: false, dE: $elm$core$Maybe$Nothing, dI: false, bO: '', dY: $elm$core$Maybe$Nothing, d$: $elm$core$Maybe$Nothing, au7: _List_Nil, bX: _List_Nil, eq: $elm$core$Maybe$Nothing};
var $author$project$Component$Form$CheckboxGroup$label = function (label_) {
	return $author$project$Component$Form$CheckboxGroup$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{bO: label_});
		});
};
var $author$project$Component$Form$CheckboxGroup$generateId = function (labelText) {
	return A2(
		$elm$core$String$join,
		'-',
		$elm$core$String$words(labelText));
};
var $author$project$Component$Form$CheckboxGroup$viewCheckboxGroup = function (_v0) {
	var config = _v0;
	var labelClasslist = _List_fromArray(
		[
			_Utils_Tuple2('label', true),
			_Utils_Tuple2('visually-hidden', config.dC)
		]);
	var idValue = function () {
		var _v4 = config.dE;
		if (!_v4.$) {
			var id_ = _v4.a;
			return id_;
		} else {
			return $author$project$Component$Form$CheckboxGroup$generateId(config.bO);
		}
	}();
	var viewOption = F2(
		function (optionIndex, _v3) {
			var optionId = _v3.a;
			var optionLabel = _v3.b;
			var optionIdValue = idValue + ('-' + optionId);
			var isChecked = A2($elm$core$List$member, optionId, config.bX);
			var toggleSelection = isChecked ? A2(
				$elm$core$List$filter,
				$elm$core$Basics$neq(optionId),
				config.bX) : A2($elm$core$List$cons, optionId, config.bX);
			var checkboxAttrs = _Utils_ap(
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('form-checkbox'),
						$elm$html$Html$Attributes$type_('checkbox'),
						$elm$html$Html$Attributes$id(optionIdValue),
						$elm$html$Html$Attributes$checked(isChecked),
						$elm$html$Html$Attributes$disabled(config.$7)
					]),
				_Utils_ap(
					$author$project$Util$Tabindex$fieldTabIndexUnstyled(
						A2(
							$elm$core$Maybe$map,
							$elm$core$Basics$add(optionIndex),
							config.eq)),
					_Utils_ap(
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								function (handler) {
									return _List_fromArray(
										[
											$elm$html$Html$Events$onCheck(
											function (_v2) {
												return handler(toggleSelection);
											})
										]);
								},
								config.d$)),
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								function (n) {
									return _List_fromArray(
										[
											$elm$html$Html$Attributes$name(n)
										]);
								},
								config.dY)))));
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('checkbox-container', true),
								_Utils_Tuple2('inline', config.dI)
							]))
					]),
				_List_fromArray(
					[
						A2($elm$html$Html$input, checkboxAttrs, _List_Nil),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('checkbox')
							]),
						_List_fromArray(
							[
								A3(
								$elm$html$Html$node,
								'svg',
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
										A2($elm$html$Html$Attributes$attribute, 'viewBox', '0 0 24 24'),
										A2($elm$html$Html$Attributes$attribute, 'fill', 'none'),
										A2($elm$html$Html$Attributes$attribute, 'stroke', 'currentColor')
									]),
								_List_fromArray(
									[
										A3(
										$elm$html$Html$node,
										'polyline',
										_List_fromArray(
											[
												A2($elm$html$Html$Attributes$attribute, 'points', '20 6 9 17 4 12')
											]),
										_List_Nil)
									]))
							])),
						A2(
						$elm$html$Html$label,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('label'),
								$elm$html$Html$Attributes$for(optionIdValue)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(optionLabel)
							]))
					]));
		});
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('form-field', true),
						_Utils_Tuple2('form-field-checkbox-group', true),
						_Utils_Tuple2(
						'error',
						$elm_community$maybe_extra$Maybe$Extra$isJust(config.cn))
					]))
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('form-field-wrapper')
					]),
				_Utils_ap(
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(labelClasslist),
									$elm$html$Html$Attributes$for(idValue)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Util$View$viewIfNot,
									$elm$core$String$isEmpty(config.bO),
									function (_v1) {
										return $elm$html$Html$text(config.bO);
									})
								]))
						]),
					_Utils_ap(
						A2($elm$core$List$indexedMap, viewOption, config.au7),
						_List_fromArray(
							[
								A2(
								$author$project$Util$View$viewMaybe,
								config.cn,
								function (error_) {
									return A2(
										$elm$html$Html$p,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('error-message')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(error_)
											]));
								})
							]))))
			]));
};
var $author$project$Component$Form$CheckboxGroup$view = F2(
	function (label_, attributes) {
		return $author$project$Component$Form$CheckboxGroup$viewCheckboxGroup(
			A3(
				$elm$core$List$foldl,
				function (_v0) {
					var attribute = _v0;
					return attribute;
				},
				$author$project$Component$Form$CheckboxGroup$build,
				A2(
					$elm$core$List$cons,
					$author$project$Component$Form$CheckboxGroup$label(label_),
					attributes)));
	});
var $author$project$Component$Form$DateInput$build = function (today) {
	return {$7: false, bI: $elm$core$Maybe$Nothing, dy: $elm$core$Maybe$Nothing, dC: false, bb: $elm$core$Maybe$Nothing, dE: $elm$core$Maybe$Nothing, dI: false, bO: '', dT: 0, dU: 0, d1: $elm$core$Maybe$Nothing, d5: $elm$core$Maybe$Nothing, eb: false, eq: $elm$core$Maybe$Nothing, fV: today, ey: $elm$core$Maybe$Nothing};
};
var $author$project$Component$Form$DateInput$label = function (label_) {
	return $author$project$Component$Form$DateInput$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{bO: label_});
		});
};
var $justinmimbs$date$Date$Years = 0;
var $justinmimbs$date$Date$Months = 1;
var $justinmimbs$date$Date$add = F3(
	function (unit, n, _v0) {
		var rd = _v0;
		switch (unit) {
			case 0:
				return A3($justinmimbs$date$Date$add, 1, 12 * n, rd);
			case 1:
				var date = $justinmimbs$date$Date$toCalendarDate(rd);
				var wholeMonths = ((12 * (date.asD - 1)) + ($justinmimbs$date$Date$monthToNumber(date.TF) - 1)) + n;
				var m = $justinmimbs$date$Date$numberToMonth(
					A2($elm$core$Basics$modBy, 12, wholeMonths) + 1);
				var y = A2($justinmimbs$date$Date$floorDiv, wholeMonths, 12) + 1;
				return ($justinmimbs$date$Date$daysBeforeYear(y) + A2($justinmimbs$date$Date$daysBeforeMonth, y, m)) + A2(
					$elm$core$Basics$min,
					date.yz,
					A2($justinmimbs$date$Date$daysInMonth, y, m));
			case 2:
				return rd + (7 * n);
			default:
				return rd + n;
		}
	});
var $justinmimbs$date$Date$deadEndToString = function (_v0) {
	var problem = _v0.aag;
	if (problem.$ === 12) {
		var message = problem.a;
		return message;
	} else {
		return 'Expected a date in ISO 8601 format';
	}
};
var $justinmimbs$date$Date$MonthAndDay = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $justinmimbs$date$Date$OrdinalDay = function (a) {
	return {$: 2, a: a};
};
var $justinmimbs$date$Date$WeekAndWeekday = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$commit = function (a) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$Good, true, a, s);
	};
};
var $elm$parser$Parser$commit = $elm$parser$Parser$Advanced$commit;
var $elm$parser$Parser$mapChompedString = $elm$parser$Parser$Advanced$mapChompedString;
var $justinmimbs$date$Date$int1 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	$elm$parser$Parser$chompIf($elm$core$Char$isDigit));
var $justinmimbs$date$Date$int2 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed(0),
			$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
		$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
var $justinmimbs$date$Date$int3 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed(0),
				$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
			$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
		$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
var $justinmimbs$date$Date$dayOfYear = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed($elm$core$Basics$identity),
				$elm$parser$Parser$token('-')),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						$elm$parser$Parser$backtrackable(
						A2(
							$elm$parser$Parser$andThen,
							$elm$parser$Parser$commit,
							A2($elm$parser$Parser$map, $justinmimbs$date$Date$OrdinalDay, $justinmimbs$date$Date$int3))),
						A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							$elm$parser$Parser$succeed($justinmimbs$date$Date$MonthAndDay),
							$justinmimbs$date$Date$int2),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed($elm$core$Basics$identity),
										$elm$parser$Parser$token('-')),
									$justinmimbs$date$Date$int2),
									$elm$parser$Parser$succeed(1)
								]))),
						A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							A2(
								$elm$parser$Parser$ignorer,
								$elm$parser$Parser$succeed($justinmimbs$date$Date$WeekAndWeekday),
								$elm$parser$Parser$token('W')),
							$justinmimbs$date$Date$int2),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed($elm$core$Basics$identity),
										$elm$parser$Parser$token('-')),
									$justinmimbs$date$Date$int1),
									$elm$parser$Parser$succeed(1)
								])))
					]))),
			$elm$parser$Parser$backtrackable(
			A2(
				$elm$parser$Parser$andThen,
				$elm$parser$Parser$commit,
				A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						$elm$parser$Parser$succeed($justinmimbs$date$Date$MonthAndDay),
						$justinmimbs$date$Date$int2),
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								$justinmimbs$date$Date$int2,
								$elm$parser$Parser$succeed(1)
							]))))),
			A2($elm$parser$Parser$map, $justinmimbs$date$Date$OrdinalDay, $justinmimbs$date$Date$int3),
			A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed($justinmimbs$date$Date$WeekAndWeekday),
					$elm$parser$Parser$token('W')),
				$justinmimbs$date$Date$int2),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						$justinmimbs$date$Date$int1,
						$elm$parser$Parser$succeed(1)
					]))),
			$elm$parser$Parser$succeed(
			$justinmimbs$date$Date$OrdinalDay(1))
		]));
var $justinmimbs$date$Date$isBetweenInt = F3(
	function (a, b, x) {
		return (_Utils_cmp(a, x) < 1) && (_Utils_cmp(x, b) < 1);
	});
var $justinmimbs$date$Date$fromCalendarParts = F3(
	function (y, mn, d) {
		return (A3($justinmimbs$date$Date$isBetweenInt, 1, 12, mn) && A3(
			$justinmimbs$date$Date$isBetweenInt,
			1,
			A2(
				$justinmimbs$date$Date$daysInMonth,
				y,
				$justinmimbs$date$Date$numberToMonth(mn)),
			d)) ? $elm$core$Result$Ok(
			($justinmimbs$date$Date$daysBeforeYear(y) + A2(
				$justinmimbs$date$Date$daysBeforeMonth,
				y,
				$justinmimbs$date$Date$numberToMonth(mn))) + d) : $elm$core$Result$Err(
			'Invalid calendar date (' + ($elm$core$String$fromInt(y) + (', ' + ($elm$core$String$fromInt(mn) + (', ' + ($elm$core$String$fromInt(d) + ')'))))));
	});
var $justinmimbs$date$Date$fromOrdinalParts = F2(
	function (y, od) {
		return (A3($justinmimbs$date$Date$isBetweenInt, 1, 365, od) || ((od === 366) && $justinmimbs$date$Date$isLeapYear(y))) ? $elm$core$Result$Ok(
			$justinmimbs$date$Date$daysBeforeYear(y) + od) : $elm$core$Result$Err(
			'Invalid ordinal date (' + ($elm$core$String$fromInt(y) + (', ' + ($elm$core$String$fromInt(od) + ')'))));
	});
var $justinmimbs$date$Date$firstOfYear = function (y) {
	return $justinmimbs$date$Date$daysBeforeYear(y) + 1;
};
var $justinmimbs$date$Date$is53WeekYear = function (y) {
	var wdnJan1 = $justinmimbs$date$Date$weekdayNumber(
		$justinmimbs$date$Date$firstOfYear(y));
	return (wdnJan1 === 4) || ((wdnJan1 === 3) && $justinmimbs$date$Date$isLeapYear(y));
};
var $justinmimbs$date$Date$fromWeekParts = F3(
	function (wy, wn, wdn) {
		return (A3($justinmimbs$date$Date$isBetweenInt, 1, 7, wdn) && (A3($justinmimbs$date$Date$isBetweenInt, 1, 52, wn) || ((wn === 53) && $justinmimbs$date$Date$is53WeekYear(wy)))) ? $elm$core$Result$Ok(
			($justinmimbs$date$Date$daysBeforeWeekYear(wy) + ((wn - 1) * 7)) + wdn) : $elm$core$Result$Err(
			'Invalid week date (' + ($elm$core$String$fromInt(wy) + (', ' + ($elm$core$String$fromInt(wn) + (', ' + ($elm$core$String$fromInt(wdn) + ')'))))));
	});
var $justinmimbs$date$Date$fromYearAndDayOfYear = function (_v0) {
	var y = _v0.a;
	var doy = _v0.b;
	switch (doy.$) {
		case 0:
			var mn = doy.a;
			var d = doy.b;
			return A3($justinmimbs$date$Date$fromCalendarParts, y, mn, d);
		case 1:
			var wn = doy.a;
			var wdn = doy.b;
			return A3($justinmimbs$date$Date$fromWeekParts, y, wn, wdn);
		default:
			var od = doy.a;
			return A2($justinmimbs$date$Date$fromOrdinalParts, y, od);
	}
};
var $justinmimbs$date$Date$int4 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				A2(
					$elm$parser$Parser$ignorer,
					A2(
						$elm$parser$Parser$ignorer,
						$elm$parser$Parser$succeed(0),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									$elm$parser$Parser$chompIf(
									function (c) {
										return c === '-';
									}),
									$elm$parser$Parser$succeed(0)
								]))),
					$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
				$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
			$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
		$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
var $justinmimbs$date$Date$resultToParser = function (result) {
	if (!result.$) {
		var x = result.a;
		return $elm$parser$Parser$succeed(x);
	} else {
		var message = result.a;
		return $elm$parser$Parser$problem(message);
	}
};
var $justinmimbs$date$Date$parser = A2(
	$elm$parser$Parser$andThen,
	A2($elm$core$Basics$composeR, $justinmimbs$date$Date$fromYearAndDayOfYear, $justinmimbs$date$Date$resultToParser),
	A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$keeper,
			$elm$parser$Parser$succeed($elm$core$Tuple$pair),
			$justinmimbs$date$Date$int4),
		$justinmimbs$date$Date$dayOfYear));
var $justinmimbs$date$Date$fromIsoString = A2(
	$elm$core$Basics$composeR,
	$elm$parser$Parser$run(
		A2(
			$elm$parser$Parser$keeper,
			$elm$parser$Parser$succeed($elm$core$Basics$identity),
			A2(
				$elm$parser$Parser$ignorer,
				$justinmimbs$date$Date$parser,
				A2(
					$elm$parser$Parser$andThen,
					$justinmimbs$date$Date$resultToParser,
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								A2($elm$parser$Parser$map, $elm$core$Result$Ok, $elm$parser$Parser$end),
								A2(
								$elm$parser$Parser$map,
								$elm$core$Basics$always(
									$elm$core$Result$Err('Expected a date only, not a date and time')),
								$elm$parser$Parser$chompIf(
									$elm$core$Basics$eq('T'))),
								$elm$parser$Parser$succeed(
								$elm$core$Result$Err('Expected a date only'))
							])))))),
	$elm$core$Result$mapError(
		A2(
			$elm$core$Basics$composeR,
			$elm$core$List$head,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Maybe$map($justinmimbs$date$Date$deadEndToString),
				$elm$core$Maybe$withDefault('')))));
var $author$project$Util$Date$decodeDate = function () {
	var toDate = function (s) {
		var _v0 = $justinmimbs$date$Date$fromIsoString(s);
		if (!_v0.$) {
			var date = _v0.a;
			return $elm$json$Json$Decode$succeed(date);
		} else {
			var err = _v0.a;
			return $elm$json$Json$Decode$fail(err);
		}
	};
	return A2($elm$json$Json$Decode$andThen, toDate, $elm$json$Json$Decode$string);
}();
var $author$project$Component$Form$DateInput$generateId = function (labelText) {
	return A2(
		$elm$core$String$join,
		'-',
		$elm$core$String$words(labelText));
};
var $author$project$Component$Form$DateInput$viewDateInput = function (_v0) {
	var config = _v0;
	var toOnInput = function (onInput_) {
		return A2(
			$elm$html$Html$Events$on,
			'input',
			A2(
				$elm$json$Json$Decode$map,
				onInput_,
				A2(
					$elm$json$Json$Decode$at,
					_List_fromArray(
						['target', 'value']),
					$author$project$Util$Date$decodeDate)));
	};
	var placeholder_ = A2($elm$core$Maybe$withDefault, config.bO, config.d5);
	var maybeAttributes = A2(
		$elm$core$List$filterMap,
		$elm$core$Basics$identity,
		_List_fromArray(
			[
				A2($elm$core$Maybe$map, toOnInput, config.d1)
			]));
	var idValue = function () {
		var _v2 = config.dE;
		if (!_v2.$) {
			var id_ = _v2.a;
			return id_;
		} else {
			return $author$project$Component$Form$DateInput$generateId(config.bO);
		}
	}();
	var labelAttrs = _List_fromArray(
		[
			$elm$html$Html$Attributes$classList(
			_List_fromArray(
				[
					_Utils_Tuple2('label', true),
					_Utils_Tuple2('visually-hidden', config.dC)
				])),
			$elm$html$Html$Attributes$for(idValue)
		]);
	var attrs = _List_fromArray(
		[
			$elm$html$Html$Attributes$classList(
			_List_fromArray(
				[
					_Utils_Tuple2('form-field', true),
					_Utils_Tuple2('inline', config.dI),
					_Utils_Tuple2(
					'error',
					$elm_community$maybe_extra$Maybe$Extra$isJust(config.bI)),
					_Utils_Tuple2(
					'with-icon',
					$elm_community$maybe_extra$Maybe$Extra$isJust(config.bb))
				]))
		]);
	var _v1 = config.fV;
	var today = _v1;
	var maxDate = A3($justinmimbs$date$Date$add, 0, config.dT, today);
	var minDate = A3($justinmimbs$date$Date$add, 0, config.dU, today);
	var inputAttributes = _Utils_ap(
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('form-input'),
				$elm$html$Html$Attributes$type_('date'),
				$elm$html$Html$Attributes$min(
				$justinmimbs$date$Date$toIsoString(minDate)),
				$elm$html$Html$Attributes$max(
				$justinmimbs$date$Date$toIsoString(maxDate)),
				$elm$html$Html$Attributes$disabled(config.$7),
				$elm$html$Html$Attributes$placeholder(placeholder_),
				$elm$html$Html$Attributes$value(
				A2(
					$elm$core$Maybe$withDefault,
					'',
					A2($elm$core$Maybe$map, $justinmimbs$date$Date$toIsoString, config.ey))),
				$elm$html$Html$Attributes$id(idValue),
				$elm$html$Html$Attributes$required(config.eb)
			]),
		$author$project$Util$Tabindex$fieldTabIndexUnstyled(config.eq));
	return A2(
		$elm$html$Html$div,
		attrs,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$label,
				labelAttrs,
				_List_fromArray(
					[
						$elm$html$Html$text(config.bO)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('form-field-wrapper')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$input,
						_Utils_ap(inputAttributes, maybeAttributes),
						_List_Nil),
						A2($author$project$Util$View$viewMaybe, config.bb, $author$project$View$Icon$viewColored),
						A2($author$project$Util$View$viewMaybe, config.dy, $elm$core$Basics$identity)
					])),
				A2($author$project$Util$View$viewMaybe, config.bI, $elm$core$Basics$identity)
			]));
};
var $author$project$Component$Form$DateInput$view = F3(
	function (today_, label_, attributes) {
		return $author$project$Component$Form$DateInput$viewDateInput(
			A3(
				$elm$core$List$foldl,
				function (_v0) {
					var attribute = _v0;
					return attribute;
				},
				$author$project$Component$Form$DateInput$build(today_),
				A2(
					$elm$core$List$cons,
					$author$project$Component$Form$DateInput$label(label_),
					attributes)));
	});
var $author$project$Component$Form$RangeInput$build = {$7: false, cn: $elm$core$Maybe$Nothing, dC: false, dE: $elm$core$Maybe$Nothing, dI: false, bO: '', dS: 100, cB: 0, dY: $elm$core$Maybe$Nothing, d1: $elm$core$Maybe$Nothing, eb: false, ei: true, fM: 1, eq: $elm$core$Maybe$Nothing, ey: 0};
var $author$project$Component$Form$RangeInput$label = function (label_) {
	return $author$project$Component$Form$RangeInput$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{bO: label_});
		});
};
var $author$project$Component$Form$RangeInput$clampValue = F3(
	function (min_, max_, n) {
		return $elm$json$Json$Decode$succeed(
			A3($elm$core$Basics$clamp, min_, max_, n));
	});
var $author$project$Component$Form$RangeInput$generateId = function (labelText) {
	return A2(
		$elm$core$String$join,
		'-',
		$elm$core$String$words(labelText));
};
var $author$project$Component$Form$RangeInput$viewRangeInput = function (_v0) {
	var config = _v0;
	var toOnInput = function (toMsg) {
		return A2(
			$elm$html$Html$Events$on,
			'input',
			A2(
				$elm$json$Json$Decode$map,
				toMsg,
				A2(
					$elm$json$Json$Decode$andThen,
					A2($author$project$Component$Form$RangeInput$clampValue, config.cB, config.dS),
					A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['target', 'valueAsNumber']),
						$elm$json$Json$Decode$int))));
	};
	var percentage = ((config.ey - config.cB) / (config.dS - config.cB)) * 100;
	var percentageString = $elm$core$String$fromFloat(percentage) + '%';
	var maybeAttributes = A2(
		$elm$core$List$filterMap,
		$elm$core$Basics$identity,
		_List_fromArray(
			[
				A2($elm$core$Maybe$map, toOnInput, config.d1),
				A2($elm$core$Maybe$map, $elm$html$Html$Attributes$name, config.dY)
			]));
	var labelClasslist = _List_fromArray(
		[
			_Utils_Tuple2('label', true),
			_Utils_Tuple2('visually-hidden', config.dC)
		]);
	var idValue = function () {
		var _v3 = config.dE;
		if (!_v3.$) {
			var id_ = _v3.a;
			return id_;
		} else {
			return $author$project$Component$Form$RangeInput$generateId(config.bO);
		}
	}();
	var inputAttributes = _Utils_ap(
		_List_fromArray(
			[
				$elm$html$Html$Attributes$type_('range'),
				$elm$html$Html$Attributes$value(
				$elm$core$String$fromInt(config.ey)),
				$elm$html$Html$Attributes$min(
				$elm$core$String$fromInt(config.cB)),
				$elm$html$Html$Attributes$max(
				$elm$core$String$fromInt(config.dS)),
				$elm$html$Html$Attributes$step(
				$elm$core$String$fromInt(config.fM)),
				$elm$html$Html$Attributes$id(idValue),
				$elm$html$Html$Attributes$required(config.eb),
				$elm$html$Html$Attributes$disabled(config.$7)
			]),
		$author$project$Util$Tabindex$fieldTabIndexUnstyled(config.eq));
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('form-field', true),
						_Utils_Tuple2('form-field-range', true),
						_Utils_Tuple2(
						'error',
						$elm_community$maybe_extra$Maybe$Extra$isJust(config.cn)),
						_Utils_Tuple2('inline', config.dI)
					]))
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('form-field-wrapper')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$classList(labelClasslist),
								$elm$html$Html$Attributes$for(idValue)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Util$View$viewIfNot,
								$elm$core$String$isEmpty(config.bO),
								function (_v1) {
									return $elm$html$Html$text(config.bO);
								})
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('range-input', true),
										_Utils_Tuple2('styled', true)
									]))
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$input,
								_Utils_ap(inputAttributes, maybeAttributes),
								_List_Nil),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('track')
									]),
								_List_Nil),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('range'),
										A2($elm$html$Html$Attributes$style, 'left', percentageString)
									]),
								_List_Nil),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('thumb'),
										A2($elm$html$Html$Attributes$style, 'left', percentageString)
									]),
								_List_Nil),
								A2(
								$author$project$Util$View$viewIf,
								config.ei,
								function (_v2) {
									return A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('tooltip'),
												A2($elm$html$Html$Attributes$style, 'left', percentageString)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$elm$core$String$fromInt(config.ey))
											]));
								})
							])),
						A2(
						$author$project$Util$View$viewMaybe,
						config.cn,
						function (error_) {
							return A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('error-message')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(error_)
									]));
						})
					]))
			]));
};
var $author$project$Component$Form$RangeInput$view = F2(
	function (label_, attributes) {
		return $author$project$Component$Form$RangeInput$viewRangeInput(
			A3(
				$elm$core$List$foldl,
				function (_v0) {
					var attribute = _v0;
					return attribute;
				},
				$author$project$Component$Form$RangeInput$build,
				A2(
					$elm$core$List$cons,
					$author$project$Component$Form$RangeInput$label(label_),
					attributes)));
	});
var $author$project$Model$Translation$cityPlaceholder = 'city-placeholder';
var $author$project$Model$Translation$houseNumberPlaceholder = 'house-number-placeholder';
var $author$project$Model$Translation$postalCodePlaceholder = 'postal-code-placeholder';
var $author$project$Model$Translation$streetPlaceholder = 'street-placeholder';
var $author$project$View$FormV2$viewAddressFields = function (config) {
	var _v0 = config.dl;
	var addressIsFilled = _v0.a;
	var addressValue = _v0.b;
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('form-field')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('address-form-row')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Component$Form$TextInput$view,
							config.bO,
							_List_fromArray(
								[
									$author$project$Component$Form$TextInput$id('street'),
									$author$project$Component$Form$TextInput$placeholder(
									A2($author$project$Data$Translation$toString, config.anB, $author$project$Model$Translation$streetPlaceholder)),
									$author$project$Component$Form$TextInput$onInput(
									A2(
										$elm$core$Basics$composeL,
										config.avZ,
										function (v) {
											return _Utils_Tuple2(
												addressIsFilled,
												_Utils_update(
													addressValue,
													{aj8: v}));
										})),
									$author$project$Component$Form$TextInput$value(addressValue.aj8),
									$author$project$Component$Form$TextInput$tabindex(config.eq),
									$author$project$Component$Form$TextInput$error(config.am),
									$author$project$Component$Form$TextInput$class('street'),
									$author$project$Component$Form$TextInput$hiddenLabel(config.Hq.dB),
									$author$project$Component$Form$TextInput$icon($author$project$View$Icon$path.asW)
								])),
							A2(
							$author$project$Component$Form$TextInput$view,
							'',
							_List_fromArray(
								[
									$author$project$Component$Form$TextInput$id('house-number'),
									$author$project$Component$Form$TextInput$placeholder(
									A2($author$project$Data$Translation$toString, config.anB, $author$project$Model$Translation$houseNumberPlaceholder)),
									$author$project$Component$Form$TextInput$onInput(
									A2(
										$elm$core$Basics$composeL,
										config.avZ,
										function (v) {
											return _Utils_Tuple2(
												addressIsFilled,
												_Utils_update(
													addressValue,
													{M3: v}));
										})),
									$author$project$Component$Form$TextInput$value(addressValue.M3),
									$author$project$Component$Form$TextInput$error(config.am),
									$author$project$Component$Form$TextInput$tabindex(config.eq + 1),
									$author$project$Component$Form$TextInput$class('house-number'),
									$author$project$Component$Form$TextInput$hiddenLabel(config.Hq.dB)
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('address-form-row')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Component$Form$TextInput$view,
							'',
							_List_fromArray(
								[
									$author$project$Component$Form$TextInput$id('postal-code'),
									$author$project$Component$Form$TextInput$placeholder(
									A2($author$project$Data$Translation$toString, config.anB, $author$project$Model$Translation$postalCodePlaceholder)),
									$author$project$Component$Form$TextInput$onInput(
									A2(
										$elm$core$Basics$composeL,
										config.avZ,
										function (v) {
											return _Utils_Tuple2(
												addressIsFilled,
												_Utils_update(
													addressValue,
													{$B: v}));
										})),
									$author$project$Component$Form$TextInput$value(addressValue.$B),
									$author$project$Component$Form$TextInput$error(config.am),
									$author$project$Component$Form$TextInput$class('postal-code'),
									$author$project$Component$Form$TextInput$tabindex(config.eq + 2),
									$author$project$Component$Form$TextInput$hiddenLabel(config.Hq.dB),
									$author$project$Component$Form$TextInput$icon($author$project$View$Icon$path.asW)
								])),
							A2(
							$author$project$Component$Form$TextInput$view,
							'',
							_List_fromArray(
								[
									$author$project$Component$Form$TextInput$id('city'),
									$author$project$Component$Form$TextInput$placeholder(
									A2($author$project$Data$Translation$toString, config.anB, $author$project$Model$Translation$cityPlaceholder)),
									$author$project$Component$Form$TextInput$onInput(
									A2(
										$elm$core$Basics$composeL,
										config.avZ,
										function (v) {
											return _Utils_Tuple2(
												addressIsFilled,
												_Utils_update(
													addressValue,
													{qM: v}));
										})),
									$author$project$Component$Form$TextInput$value(addressValue.qM),
									$author$project$Component$Form$TextInput$tabindex(config.eq + 3),
									$author$project$Component$Form$TextInput$error(config.am),
									$author$project$Component$Form$TextInput$class('city'),
									$author$project$Component$Form$TextInput$hiddenLabel(config.Hq.dB)
								]))
						]))
				]))
		]);
};
var $author$project$View$FormV2$GetAddressWithAutoFill = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $author$project$View$FormV2$isDutchPostalCode = function (input) {
	return A2(
		$elm$regex$Regex$contains,
		A2(
			$elm$core$Maybe$withDefault,
			$elm$regex$Regex$never,
			$elm$regex$Regex$fromString('^[1-9][0-9]{3}( ?[A-Za-z]{2})$')),
		input);
};
var $author$project$Component$Form$TextInput$onBlur = function (msg_) {
	return $author$project$Component$Form$TextInput$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{
					d_: $elm$core$Maybe$Just(msg_)
				});
		});
};
var $author$project$View$FormV2$viewAddressWithAutoFillFields = function (config) {
	var _v0 = config.dl;
	var addressIsFilled = _v0.a;
	var addressValue = _v0.b;
	var onBlurMsg = ($author$project$View$FormV2$isDutchPostalCode(addressValue.$B) && (!addressIsFilled)) ? A2(
		$author$project$View$FormV2$GetAddressWithAutoFill,
		addressValue.$B + (' ' + addressValue.M3),
		A2(
			$elm$core$Basics$composeL,
			config.avZ,
			function (_v1) {
				var maybeStreetName = _v1.a;
				var maybeCity = _v1.b;
				return _Utils_Tuple2(
					true,
					_Utils_update(
						addressValue,
						{
							qM: A2($elm$core$Maybe$withDefault, addressValue.qM, maybeCity),
							aj8: A2($elm$core$Maybe$withDefault, addressValue.aj8, maybeStreetName)
						}));
			})) : $author$project$View$FormV2$NoOp;
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('form-field')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('address-with-autofill-form-row')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Component$Form$TextInput$view,
							'',
							_List_fromArray(
								[
									$author$project$Component$Form$TextInput$id('postal-code'),
									$author$project$Component$Form$TextInput$placeholder(
									A2($author$project$Data$Translation$toString, config.anB, $author$project$Model$Translation$postalCodePlaceholder)),
									$author$project$Component$Form$TextInput$onInput(
									A2(
										$elm$core$Basics$composeL,
										config.avZ,
										function (v) {
											return _Utils_Tuple2(
												_Utils_eq(v, addressValue.$B),
												_Utils_update(
													addressValue,
													{$B: v}));
										})),
									$author$project$Component$Form$TextInput$value(addressValue.$B),
									$author$project$Component$Form$TextInput$error(config.am),
									$author$project$Component$Form$TextInput$class('postal-code'),
									$author$project$Component$Form$TextInput$hiddenLabel(config.Hq.dB),
									$author$project$Component$Form$TextInput$icon($author$project$View$Icon$path.asW),
									$author$project$Component$Form$TextInput$tabindex(config.eq),
									$author$project$Component$Form$TextInput$onBlur(onBlurMsg)
								])),
							A2(
							$author$project$Component$Form$TextInput$view,
							'',
							_List_fromArray(
								[
									$author$project$Component$Form$TextInput$id('house-number'),
									$author$project$Component$Form$TextInput$placeholder(
									A2($author$project$Data$Translation$toString, config.anB, $author$project$Model$Translation$houseNumberPlaceholder)),
									$author$project$Component$Form$TextInput$onInput(
									A2(
										$elm$core$Basics$composeL,
										config.avZ,
										function (v) {
											return _Utils_Tuple2(
												_Utils_eq(v, addressValue.M3),
												_Utils_update(
													addressValue,
													{M3: v}));
										})),
									$author$project$Component$Form$TextInput$value(addressValue.M3),
									$author$project$Component$Form$TextInput$error(config.am),
									$author$project$Component$Form$TextInput$class('house-number'),
									$author$project$Component$Form$TextInput$tabindex(config.eq + 1),
									$author$project$Component$Form$TextInput$hiddenLabel(config.Hq.dB),
									$author$project$Component$Form$TextInput$onBlur(onBlurMsg)
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('address-with-autofill-form-row')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Component$Form$TextInput$view,
							config.bO,
							_List_fromArray(
								[
									$author$project$Component$Form$TextInput$id('street'),
									$author$project$Component$Form$TextInput$placeholder(
									A2($author$project$Data$Translation$toString, config.anB, $author$project$Model$Translation$streetPlaceholder)),
									$author$project$Component$Form$TextInput$onInput(
									A2(
										$elm$core$Basics$composeL,
										config.avZ,
										function (v) {
											return _Utils_Tuple2(
												addressIsFilled,
												_Utils_update(
													addressValue,
													{aj8: v}));
										})),
									$author$project$Component$Form$TextInput$value(addressValue.aj8),
									$author$project$Component$Form$TextInput$class('street'),
									$author$project$Component$Form$TextInput$tabindex(config.eq + 2),
									$author$project$Component$Form$TextInput$hiddenLabel(config.Hq.dB),
									$author$project$Component$Form$TextInput$icon($author$project$View$Icon$path.asW)
								])),
							A2(
							$author$project$Component$Form$TextInput$view,
							'',
							_List_fromArray(
								[
									$author$project$Component$Form$TextInput$id('city'),
									$author$project$Component$Form$TextInput$placeholder(
									A2($author$project$Data$Translation$toString, config.anB, $author$project$Model$Translation$cityPlaceholder)),
									$author$project$Component$Form$TextInput$onInput(
									A2(
										$elm$core$Basics$composeL,
										config.avZ,
										function (v) {
											return _Utils_Tuple2(
												addressIsFilled,
												_Utils_update(
													addressValue,
													{qM: v}));
										})),
									$author$project$Component$Form$TextInput$value(addressValue.qM),
									$author$project$Component$Form$TextInput$class('city'),
									$author$project$Component$Form$TextInput$tabindex(config.eq + 3),
									$author$project$Component$Form$TextInput$hiddenLabel(config.Hq.dB)
								]))
						]))
				]))
		]);
};
var $author$project$View$FormV2$viewContentField = F2(
	function (config, content) {
		return _List_fromArray(
			[
				A2(
				$author$project$Data$Content$View$view,
				{
					ji: false,
					GZ: _List_Nil,
					avS: ($author$project$View$FormV2$contentControlCountFor(content) > 0) ? $elm$core$Maybe$Just(config.eq) : $elm$core$Maybe$Nothing,
					ape: config.ape,
					apx: false,
					f_: $elm$core$Maybe$Nothing
				},
				content)
			]);
	});
var $author$project$Model$FormFieldValueV2$DaypartAvailabilityValue = function (a) {
	return {$: 10, a: a};
};
var $author$project$Data$Form$allDayparts = _List_fromArray(
	[0, 1, 2, 3]);
var $author$project$Data$Form$allDayEveryDay = _List_fromArray(
	[
		_Utils_Tuple2(0, $author$project$Data$Form$allDayparts),
		_Utils_Tuple2(1, $author$project$Data$Form$allDayparts),
		_Utils_Tuple2(2, $author$project$Data$Form$allDayparts),
		_Utils_Tuple2(3, $author$project$Data$Form$allDayparts),
		_Utils_Tuple2(4, $author$project$Data$Form$allDayparts),
		_Utils_Tuple2(5, $author$project$Data$Form$allDayparts),
		_Utils_Tuple2(6, $author$project$Data$Form$allDayparts)
	]);
var $author$project$Data$Form$groupedAndOrderedDayparts = function (_v0) {
	var availableParts = _v0.as4;
	var availableDays = A2($elm$core$List$map, $elm$core$Tuple$first, availableParts);
	var availableDayparts = A2($elm$core$List$map, $elm$core$Tuple$second, availableParts);
	var accumulateDayparts = F3(
		function (dayOfWeek, daypart, acc) {
			return A2(
				$elm$core$List$member,
				_Utils_Tuple2(dayOfWeek, daypart),
				availableParts) ? A2(
				$elm$core$List$cons,
				$elm$core$Maybe$Just(daypart),
				acc) : (A2($elm$core$List$member, daypart, availableDayparts) ? A2($elm$core$List$cons, $elm$core$Maybe$Nothing, acc) : acc);
		});
	var replaceUnavailable = function (_v1) {
		var dayOfWeek = _v1.a;
		var dayparts = _v1.b;
		return A2($elm$core$List$member, dayOfWeek, availableDays) ? $elm$core$Maybe$Just(
			_Utils_Tuple2(
				dayOfWeek,
				A3(
					$elm$core$List$foldr,
					accumulateDayparts(dayOfWeek),
					_List_Nil,
					dayparts))) : $elm$core$Maybe$Nothing;
	};
	return A2($elm$core$List$filterMap, replaceUnavailable, $author$project$Data$Form$allDayEveryDay);
};
var $author$project$Data$Form$allDaypartsOrdered = function (daypartAvailabilityFieldOptions) {
	var availableDayparts = A2(
		$elm$core$List$filterMap,
		$elm$core$Basics$identity,
		A2(
			$elm$core$List$concatMap,
			$elm$core$Tuple$second,
			$author$project$Data$Form$groupedAndOrderedDayparts(daypartAvailabilityFieldOptions)));
	return A2(
		$elm$core$List$filter,
		function (x) {
			return A2($elm$core$List$member, x, availableDayparts);
		},
		$author$project$Data$Form$allDayparts);
};
var $elm_community$list_extra$List$Extra$elemIndex = function (x) {
	return $elm_community$list_extra$List$Extra$findIndex(
		$elm$core$Basics$eq(x));
};
var $author$project$Data$Form$translateDayOfWeek = function (dayOfWeek) {
	switch (dayOfWeek) {
		case 0:
			return $author$project$Copy$copy.TB;
		case 1:
			return $author$project$Copy$copy.anH;
		case 2:
			return $author$project$Copy$copy.ar_;
		case 3:
			return $author$project$Copy$copy.amS;
		case 4:
			return $author$project$Copy$copy.KE;
		case 5:
			return $author$project$Copy$copy.aef;
		default:
			return $author$project$Copy$copy.akX;
	}
};
var $author$project$Data$Form$translateDaypart = function (daypart) {
	switch (daypart) {
		case 0:
			return $author$project$Copy$copy.TI;
		case 1:
			return $author$project$Copy$copy.hi;
		case 2:
			return $author$project$Copy$copy.Gr;
		default:
			return $author$project$Copy$copy.Vy;
	}
};
var $author$project$Component$DaypartAvailability$viewDaypartCheckbox = F5(
	function (toTabIndex, toMsg, currentValue, dayOfWeek, maybeDaypart) {
		if (maybeDaypart.$ === 1) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('daypart-field-daypart-hole')
					]),
				_List_Nil);
		} else {
			var daypart = maybeDaypart.a;
			var daypartString = $author$project$Data$Form$translateDaypart(daypart);
			var dayOfWeekString = $author$project$Data$Form$translateDayOfWeek(dayOfWeek);
			var uniqueId = 'daypart-' + (dayOfWeekString + ('-' + daypartString));
			var currentItem = _Utils_Tuple2(dayOfWeek, daypart);
			var isChecked = A2($elm$core$List$member, currentItem, currentValue);
			var updateField = function (newIsChecked) {
				var currentValueWithoutThisItem = A2(
					$elm$core$List$filter,
					$elm$core$Basics$neq(currentItem),
					currentValue);
				return toMsg(
					newIsChecked ? A2($elm$core$List$cons, currentItem, currentValueWithoutThisItem) : currentValueWithoutThisItem);
			};
			return A2(
				$author$project$Component$Form$Checkbox$view,
				'',
				_Utils_ap(
					_List_fromArray(
						[
							$author$project$Component$Form$Checkbox$onCheck(updateField),
							$author$project$Component$Form$Checkbox$checked(isChecked),
							$author$project$Component$Form$Checkbox$id(uniqueId)
						]),
					A2(
						$elm$core$List$filterMap,
						$elm$core$Basics$identity,
						_List_fromArray(
							[
								A2(
								$elm$core$Maybe$map,
								$author$project$Component$Form$Checkbox$tabindex,
								toTabIndex(currentItem))
							]))));
		}
	});
var $author$project$Component$DaypartAvailability$viewDayOfWeek = F4(
	function (toTabIndex, toMsg, currentValue, _v0) {
		var dayOfWeek = _v0.a;
		var dayparts = _v0.b;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('daypart-field-dayofweek')
				]),
			$elm$core$List$concat(
				_List_fromArray(
					[
						_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('daypart-field-dayofweek-label label')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$elm$core$String$left,
										2,
										$author$project$Data$Form$translateDayOfWeek(dayOfWeek)))
								]))
						]),
						A2(
						$elm$core$List$map,
						A4($author$project$Component$DaypartAvailability$viewDaypartCheckbox, toTabIndex, toMsg, currentValue, dayOfWeek),
						dayparts)
					])));
	});
var $author$project$Component$DaypartAvailability$viewDaypartLabel = function (daypart) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('daypart-field-daypart-label')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(
				$author$project$Data$Form$translateDaypart(daypart))
			]));
};
var $author$project$Component$DaypartAvailability$view = F4(
	function (maybeTabIndex, toMsg, availableOptions, currentValue) {
		var grouped = $author$project$Data$Form$groupedAndOrderedDayparts(availableOptions);
		var renderedParts = A2(
			$elm$core$List$concatMap,
			function (_v0) {
				var dayOfWeek = _v0.a;
				var dayparts = _v0.b;
				return A2(
					$elm$core$List$filterMap,
					$elm$core$Maybe$map(
						$elm$core$Tuple$pair(dayOfWeek)),
					dayparts);
			},
			grouped);
		var toTabIndex = function (part) {
			return A3(
				$elm$core$Maybe$map2,
				$elm$core$Basics$add,
				maybeTabIndex,
				A2($elm_community$list_extra$List$Extra$elemIndex, part, renderedParts));
		};
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('daypart-field-options')
				]),
			$elm$core$List$concat(
				_List_fromArray(
					[
						_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('daypart-field-daypart-labels')
								]),
							A2(
								$elm$core$List$map,
								$author$project$Component$DaypartAvailability$viewDaypartLabel,
								$author$project$Data$Form$allDaypartsOrdered(availableOptions)))
						]),
						A2(
						$elm$core$List$map,
						A3($author$project$Component$DaypartAvailability$viewDayOfWeek, toTabIndex, toMsg, currentValue),
						grouped)
					])));
	});
var $author$project$View$FormV2$viewDaypart = F6(
	function (field, label_, availableOptions, tabIndex, maybeError, currentValue) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('form-field', true),
							_Utils_Tuple2('af__daypart-field', true),
							_Utils_Tuple2(
							'error',
							$elm_community$maybe_extra$Maybe$Extra$isJust(maybeError))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('label')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(label_)
						])),
					A4(
					$author$project$Component$DaypartAvailability$view,
					$elm$core$Maybe$Just(tabIndex),
					A2(
						$elm$core$Basics$composeL,
						$author$project$View$FormV2$InsertFieldValue(field.dY),
						$author$project$Model$FormFieldValueV2$DaypartAvailabilityValue),
					availableOptions,
					currentValue),
					A2(
					$author$project$Util$View$viewMaybe,
					maybeError,
					function (message) {
						return A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('error-message')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(message)
								]));
					})
				]));
	});
var $author$project$View$FormV2$SelectFile = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$View$FormV2$viewFileField = F7(
	function (labelVal, placeholder, index, field, options, maybeError, maybeCurrentValue) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('form-field', true),
								_Utils_Tuple2('af__upload-field', true),
								_Utils_Tuple2(
								'error',
								$elm_community$maybe_extra$Maybe$Extra$isJust(maybeError)),
								_Utils_Tuple2(
								'has-cv-file',
								$elm_community$maybe_extra$Maybe$Extra$isJust(maybeCurrentValue))
							]))
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('label', true),
										_Utils_Tuple2('visually-hidden', field.dB)
									]))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(labelVal)
							])),
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('btn btn-outline border-color-2 color-2'),
								$elm$html$Html$Attributes$type_('button'),
								$elm$html$Html$Attributes$tabindex(index),
								$elm$html$Html$Attributes$id(
								$author$project$Data$Form$fieldNameToString(field.dY)),
								$elm$html$Html$Events$onClick(
								A2($author$project$View$FormV2$SelectFile, options, field.dY))
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('label')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(placeholder)
									]))
							])),
						A2(
						$author$project$Util$View$viewMaybe,
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.atW;
							},
							maybeCurrentValue),
						function (filename) {
							return A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('upload__file-name'),
										$elm$html$Html$Attributes$title(filename)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(filename)
									]));
						}),
						A2(
						$author$project$Util$View$viewMaybe,
						maybeError,
						function (err) {
							return A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('error-message')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(err)
									]));
						})
					]))
			]);
	});
var $author$project$Component$Form$SelectNonEmpty$viewSelectShortWhenSelected = F2(
	function (toShortTitle, ariaLabel) {
		return A2(
			$author$project$Component$Form$SelectNonEmpty$viewSelectHelp,
			$elm$core$Maybe$Just(toShortTitle),
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$attribute, 'aria-label', ariaLabel)
				]));
	});
var $author$project$View$FormV2$withRunningTabIndex = F2(
	function (startIndex, sqConfigs) {
		var step = F2(
			function (sqConfig, _v0) {
				var currentIndex = _v0.a;
				var acc = _v0.b;
				return _Utils_Tuple2(
					currentIndex + A2($author$project$View$FormV2$controlCountFor, _List_Nil, sqConfig.at$),
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(currentIndex, sqConfig),
						acc));
			});
		return $elm$core$List$reverse(
			A3(
				$elm$core$List$foldl,
				step,
				_Utils_Tuple2(startIndex, _List_Nil),
				sqConfigs).b);
	});
var $author$project$View$FormV2$toScreeningQuestionsHtmlFields = F2(
	function (state_, config) {
		var state = state_;
		var toScreeningQuestionValue = F2(
			function (screeningQuestionConfig, val) {
				return {
					dY: $author$project$Model$FormFieldV2$Custom(screeningQuestionConfig.aui),
					ey: val
				};
			});
		var currentValues = A3($author$project$View$FormV2$maybeValue, config, state.j, $author$project$View$FormV2$toScreeningQuestionsValue);
		var currentValue = function (fieldName) {
			return A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.ey;
				},
				A2(
					$pzp1997$assoc_list$AssocList$get,
					fieldName,
					$author$project$View$FormV2$getScreeningQuestionsValueDict(currentValues)));
		};
		return A2(
			$elm$core$List$map,
			function (_v13) {
				var sqTabIndex = _v13.a;
				var sqConfig = _v13.b;
				var fieldHtml = A2(
					$author$project$View$FormV2$viewFormField,
					state_,
					_Utils_update(
						config,
						{
							Hq: sqConfig.at$,
							ae: $elm$core$Maybe$Just(
								{
									auo: sqConfig.auo,
									bO: sqConfig.bO,
									auJ: sqConfig.auJ,
									fl: function (fieldValue) {
										return A2(
											$author$project$View$FormV2$InsertFieldValue,
											config.Hq.dY,
											$author$project$Model$FormFieldValueV2$ScreeningQuestionValues(
												A3(
													$author$project$View$FormV2$insertScreeningQuestionValue,
													currentValues,
													$author$project$Model$FormFieldV2$Custom(sqConfig.aui),
													A2(toScreeningQuestionValue, sqConfig, fieldValue))));
									},
									dY: $author$project$Model$FormFieldV2$Custom(sqConfig.aui),
									d5: sqConfig.d5,
									eb: sqConfig.eb,
									ey: currentValue(
										$author$project$Model$FormFieldV2$Custom(sqConfig.aui))
								}),
							eq: sqTabIndex
						}));
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('form-row')
						]),
					fieldHtml);
			},
			A2(
				$author$project$View$FormV2$withRunningTabIndex,
				config.eq,
				A2($elm$core$List$map, $author$project$View$FormV2$toScreeningQuestionFormField, state.fB)));
	});
var $author$project$View$FormV2$viewFormField = F2(
	function (state_, config) {
		var state = state_;
		var toTranslation = function (val) {
			return A2($author$project$Data$Translation$toString, config.anB, val);
		};
		var toMsg = function (val) {
			return A2(
				$elm$core$Maybe$withDefault,
				A2($author$project$View$FormV2$InsertFieldValue, config.Hq.dY, val),
				A2(
					$elm$core$Maybe$map,
					function (f) {
						return f.fl(val);
					},
					config.ae));
		};
		var screeningText = F2(
			function (getText, fallback) {
				return A2(
					$elm$core$Maybe$withDefault,
					fallback,
					A2($elm$core$Maybe$map, getText, config.ae));
			});
		var requiredMessage = A2(
			$elm_community$maybe_extra$Maybe$Extra$orElse,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.auJ;
				},
				config.ae),
			A2($author$project$View$FormV2$getValueForDomain, state.atF, config.Hq.auJ));
		var requiredByExport = function () {
			var _v12 = config.ae;
			if (!_v12.$) {
				return false;
			} else {
				return A2(
					$elm$core$Maybe$withDefault,
					false,
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.adb;
						},
						$elm$core$List$head(
							A2(
								$elm$core$List$filter,
								A2(
									$elm$core$Basics$composeL,
									$elm$core$Basics$eq(config.Hq.dY),
									function ($) {
										return $.dY;
									}),
								state.aeo))));
			}
		}();
		var label_ = A2(
			$elm$core$Maybe$withDefault,
			A2(
				screeningText,
				function ($) {
					return $.bO;
				},
				toTranslation(
					$author$project$Data$Form$fieldNameToString(config.Hq.dY) + '-label')),
			A2($author$project$View$FormV2$getValueForDomain, state.atF, config.Hq.bO));
		var isRequired = function () {
			var _v11 = config.ae;
			if (!_v11.$) {
				var sqConfig = _v11.a;
				return sqConfig.eb;
			} else {
				return A2(
					$elm$core$List$member,
					config.Hq.dY,
					A3(
						$elm$core$Basics$composeL,
						$author$project$Data$FormField$unFieldNamesList,
						function ($) {
							return $.eb;
						},
						$author$project$Data$FormSource$toForm(state.eW)));
			}
		}();
		var optionalField = !(isRequired || requiredByExport);
		var label = optionalField ? A2(
			$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
			'{0} ({1})',
			_List_fromArray(
				[label_, $author$project$Copy$copy.YP])) : label_;
		var invalidMessage = A2(
			$elm_community$maybe_extra$Maybe$Extra$orElse,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.auo;
				},
				config.ae),
			A2($author$project$View$FormV2$getValueForDomain, state.atF, config.Hq.auo));
		var getPlaceholder = A2(
			$elm$core$Maybe$withDefault,
			A2(
				screeningText,
				function ($) {
					return $.d5;
				},
				toTranslation(
					$author$project$Data$Form$fieldNameToString(config.Hq.dY) + '-placeholder')),
			A2($author$project$View$FormV2$getValueForDomain, state.atF, config.Hq.d5));
		var placeholder = optionalField ? A2(
			$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
			'{0} ({1})',
			_List_fromArray(
				[getPlaceholder, $author$project$Copy$copy.YP])) : getPlaceholder;
		var fieldName = A2(
			$elm$core$Maybe$withDefault,
			$author$project$Data$Form$fieldNameToString(config.Hq.dY),
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeL,
					$author$project$Data$Form$fieldNameToString,
					function ($) {
						return $.dY;
					}),
				config.ae));
		var maybeError = A2($author$project$Api$toValidationError, fieldName, config.f$);
		var errorMessage = function (_v10) {
			return $author$project$View$FormV2$toErrorMessage(
				{
					eS: A3($author$project$View$FormV2$maybeValue, config, state.j, $author$project$View$FormV2$toTextValue),
					dK: invalidMessage,
					e9: isRequired,
					am: maybeError,
					fw: requiredMessage
				});
		};
		var textInput = F2(
			function (mPrefilled, extraArgs) {
				return A2(
					$author$project$Component$Form$TextInput$view,
					label,
					_Utils_ap(
						_List_fromArray(
							[
								$author$project$Component$Form$TextInput$id(fieldName),
								$author$project$Component$Form$TextInput$placeholder(placeholder),
								$author$project$Component$Form$TextInput$tabindex(config.eq),
								$author$project$Component$Form$TextInput$onInput(
								A2($elm$core$Basics$composeL, toMsg, $author$project$Model$FormFieldValueV2$TextValue)),
								$author$project$Component$Form$TextInput$value(
								A4(
									$author$project$View$FormV2$value,
									config,
									state.j,
									$author$project$View$FormV2$toTextValue,
									A2($elm$core$Maybe$withDefault, '', mPrefilled))),
								$author$project$Component$Form$TextInput$error(
								errorMessage($author$project$View$FormV2$toTextValue)),
								$author$project$Component$Form$TextInput$hiddenLabel(config.Hq.dB)
							]),
						extraArgs));
			});
		var disableCopyPaste = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.D4;
				},
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeL,
							$elm$core$Basics$eq(config.Hq.dY),
							function ($) {
								return $.dY;
							}),
						state.aeo))));
		var fieldHtml = function () {
			var _v0 = config.Hq.ew;
			switch (_v0.$) {
				case 0:
					var addressConfig = {
						dl: A4(
							$author$project$View$FormV2$value,
							config,
							state.j,
							$author$project$View$FormV2$toAdressValue,
							_Utils_Tuple2(
								false,
								{qM: '', M3: '', $B: '', aj8: ''})),
						atF: state.atF,
						Hq: config.Hq,
						bO: label,
						am: errorMessage($author$project$View$FormV2$toAdressValue),
						eq: config.eq,
						avZ: A2($elm$core$Basics$composeL, toMsg, $author$project$Model$FormFieldValueV2$AddressValue_),
						anB: config.anB
					};
					return _Utils_eq(config.Hq.dY, $author$project$Model$FormFieldV2$Address) ? $author$project$View$FormV2$viewAddressFields(addressConfig) : $author$project$View$FormV2$viewAddressWithAutoFillFields(addressConfig);
				case 1:
					return _List_fromArray(
						[
							A2(
							$author$project$Component$Form$Checkbox$view,
							label,
							_Utils_ap(
								_List_fromArray(
									[
										$author$project$Component$Form$Checkbox$id(fieldName),
										$author$project$Component$Form$Checkbox$tabindex(config.eq),
										$author$project$Component$Form$Checkbox$required(isRequired),
										$author$project$Component$Form$Checkbox$onCheck(
										A2($elm$core$Basics$composeL, toMsg, $author$project$Model$FormFieldValueV2$BoolValue)),
										$author$project$Component$Form$Checkbox$checked(
										A4($author$project$View$FormV2$value, config, state.j, $author$project$View$FormV2$toBoolValue, false)),
										$author$project$Component$Form$Checkbox$error(
										errorMessage($author$project$View$FormV2$toBoolValue))
									]),
								A2(
									$elm$core$List$filterMap,
									$elm$core$Basics$identity,
									_List_fromArray(
										[
											A2(
											$elm$core$Maybe$map,
											$author$project$Component$Form$Checkbox$htmlLabel,
											A6($author$project$View$FormV2$toPrivacyLabel, state.atF, config.anB, config.aU, config.Hq.dY, config.eq + 1, config.Hq.bO))
										]))))
						]);
				case 19:
					var yesOption = {bO: $author$project$Copy$copy.asH, ey: true};
					var noOption = {bO: $author$project$Copy$copy.VA, ey: false};
					var yesNoOptions = _List_fromArray(
						[yesOption, noOption]);
					var currentValue = A3($author$project$View$FormV2$maybeValue, config, state.j, $author$project$View$FormV2$toBoolValue);
					var selectedOption = function () {
						if (!currentValue.$) {
							if (currentValue.a) {
								return $elm$core$Maybe$Just(yesOption);
							} else {
								return $elm$core$Maybe$Just(noOption);
							}
						} else {
							return $elm$core$Maybe$Nothing;
						}
					}();
					return _List_fromArray(
						[
							A2(
							$author$project$Component$Form$RadioInput$view,
							{
								bO: label,
								dY: fieldName,
								au7: yesNoOptions,
								cL: selectedOption,
								cO: function ($) {
									return $.bO;
								},
								av$: function (opt) {
									return opt.ey ? 'yes' : 'no';
								}
							},
							_List_fromArray(
								[
									$author$project$Component$Form$RadioInput$onSelect(
									function (opt) {
										return toMsg(
											$author$project$Model$FormFieldValueV2$BoolValue(opt.ey));
									}),
									$author$project$Component$Form$RadioInput$error(
									errorMessage($author$project$View$FormV2$toBoolValue)),
									$author$project$Component$Form$RadioInput$tabindex(config.eq)
								]))
						]);
				case 11:
					var radioOptions = _v0.a;
					var toOption = function (_v2) {
						var optionId = _v2.a;
						var optionLabel = _v2.b;
						return {dE: optionId, bO: optionLabel};
					};
					var options = A2($elm$core$List$map, toOption, radioOptions);
					var currentValue = A3($author$project$View$FormV2$maybeValue, config, state.j, $author$project$View$FormV2$toRadioValue);
					var selectedOption = A2(
						$elm$core$Maybe$andThen,
						function (val) {
							return $elm$core$List$head(
								A2(
									$elm$core$List$filter,
									function (opt) {
										return _Utils_eq(opt.dE, val);
									},
									options));
						},
						currentValue);
					return _List_fromArray(
						[
							A2(
							$author$project$Component$Form$RadioInput$view,
							{
								bO: label,
								dY: fieldName,
								au7: options,
								cL: selectedOption,
								cO: function ($) {
									return $.bO;
								},
								av$: function ($) {
									return $.dE;
								}
							},
							_List_fromArray(
								[
									$author$project$Component$Form$RadioInput$onSelect(
									function (opt) {
										return toMsg(
											$author$project$Model$FormFieldValueV2$RadioValue(opt.dE));
									}),
									$author$project$Component$Form$RadioInput$error(
									errorMessage($author$project$View$FormV2$toRadioValue)),
									$author$project$Component$Form$RadioInput$tabindex(config.eq)
								]))
						]);
				case 2:
					return _List_fromArray(
						[
							A2(
							$author$project$Component$Form$TextArea$view,
							label,
							_List_fromArray(
								[
									$author$project$Component$Form$TextArea$id(fieldName),
									$author$project$Component$Form$TextArea$tabindex(config.eq),
									$author$project$Component$Form$TextArea$placeholder(placeholder),
									$author$project$Component$Form$TextArea$onInput(
									A2($elm$core$Basics$composeL, toMsg, $author$project$Model$FormFieldValueV2$TextValue)),
									$author$project$Component$Form$TextArea$value(
									A4($author$project$View$FormV2$value, config, state.j, $author$project$View$FormV2$toTextValue, '')),
									$author$project$Component$Form$TextArea$error(
									errorMessage($author$project$View$FormV2$toTextValue)),
									$author$project$Component$Form$TextArea$hiddenLabel(config.Hq.dB),
									$author$project$Component$Form$TextArea$rows(8)
								]))
						]);
				case 10:
					var rangeOptions = _v0.a;
					return _List_fromArray(
						[
							A2(
							$author$project$Component$Form$RangeInput$view,
							label,
							_List_fromArray(
								[
									$author$project$Component$Form$RangeInput$id(fieldName),
									$author$project$Component$Form$RangeInput$name(fieldName),
									$author$project$Component$Form$RangeInput$tabindex(config.eq),
									$author$project$Component$Form$RangeInput$min(rangeOptions.Ti),
									$author$project$Component$Form$RangeInput$max(rangeOptions.SE),
									$author$project$Component$Form$RangeInput$step(rangeOptions.aj3),
									$author$project$Component$Form$RangeInput$value(
									A2(
										$elm$core$Maybe$withDefault,
										rangeOptions.Ti,
										A3($author$project$View$FormV2$maybeValue, config, state.j, $author$project$View$FormV2$toRangeValue))),
									$author$project$Component$Form$RangeInput$onInput(
									A2($elm$core$Basics$composeL, toMsg, $author$project$Model$FormFieldValueV2$RangeValue)),
									$author$project$Component$Form$RangeInput$error(
									errorMessage($author$project$View$FormV2$toRangeValue)),
									$author$project$Component$Form$RangeInput$hiddenLabel(config.Hq.dB),
									$author$project$Component$Form$RangeInput$showValue
								]))
						]);
				case 13:
					var selectOptions = _v0.a;
					return _List_fromArray(
						[
							A2(
							$author$project$Component$Form$CheckboxGroup$view,
							label,
							_List_fromArray(
								[
									$author$project$Component$Form$CheckboxGroup$id(fieldName),
									$author$project$Component$Form$CheckboxGroup$name(fieldName),
									$author$project$Component$Form$CheckboxGroup$tabindex(config.eq),
									$author$project$Component$Form$CheckboxGroup$options(selectOptions),
									$author$project$Component$Form$CheckboxGroup$selected(
									A2(
										$elm$core$Maybe$withDefault,
										_List_Nil,
										A3($author$project$View$FormV2$maybeValue, config, state.j, $author$project$View$FormV2$toSelectMultipleValue))),
									$author$project$Component$Form$CheckboxGroup$onChange(
									A2($elm$core$Basics$composeL, toMsg, $author$project$Model$FormFieldValueV2$SelectMultipleValue)),
									$author$project$Component$Form$CheckboxGroup$error(
									errorMessage($author$project$View$FormV2$toSelectMultipleValue)),
									$author$project$Component$Form$CheckboxGroup$hiddenLabel(config.Hq.dB)
								]))
						]);
				case 3:
					var content = _v0.a;
					return A2($author$project$View$FormV2$viewContentField, config, content);
				case 4:
					var options = _v0.a;
					var val = A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							A2($elm$core$Basics$composeL, $elm$core$List$singleton, $author$project$Component$Form$DateInput$value),
							A3($author$project$View$FormV2$maybeValue, config, state.j, $author$project$View$FormV2$toDateValue)));
					var attributes = _Utils_ap(
						_List_fromArray(
							[
								$author$project$Component$Form$DateInput$id(fieldName),
								$author$project$Component$Form$DateInput$tabindex(config.eq),
								$author$project$Component$Form$DateInput$maxOffsetFromTodayInYears(options.dU),
								$author$project$Component$Form$DateInput$minOffsetFromTodayInYears(options.dT),
								$author$project$Component$Form$DateInput$onInput(
								A2(
									$elm$core$Basics$composeL,
									A2($elm$core$Basics$composeL, toMsg, $author$project$Model$FormFieldValueV2$DateValue),
									$elm$core$Maybe$Just)),
								$author$project$Component$Form$DateInput$error(
								errorMessage($author$project$View$FormV2$toDateValue)),
								$author$project$Component$Form$DateInput$icon($author$project$View$Icon$path.yy),
								$author$project$Component$Form$DateInput$hiddenLabel(config.Hq.dB)
							]),
						val);
					return _List_fromArray(
						[
							A3($author$project$Component$Form$DateInput$view, config.fV, label, attributes)
						]);
				case 5:
					var options = _v0.a;
					return _List_fromArray(
						[
							A6(
							$author$project$View$FormV2$viewDaypart,
							config.Hq,
							label,
							options,
							config.eq,
							errorMessage($author$project$View$FormV2$toDaypartValue),
							A4($author$project$View$FormV2$value, config, state.j, $author$project$View$FormV2$toDaypartValue, _List_Nil))
						]);
				case 15:
					return _List_fromArray(
						[
							A2(
							textInput,
							$elm$core$Maybe$Nothing,
							function () {
								var _v3 = config.Hq.dY;
								switch (_v3.$) {
									case 29:
										return _List_fromArray(
											[
												$author$project$Component$Form$TextInput$icon($author$project$View$Icon$path.au9)
											]);
									case 44:
										return _List_fromArray(
											[
												$author$project$Component$Form$TextInput$icon($author$project$View$Icon$path.au9)
											]);
									case 57:
										return _List_fromArray(
											[
												$author$project$Component$Form$TextInput$icon($author$project$View$Icon$path.aR)
											]);
									case 13:
										return _List_fromArray(
											[
												$author$project$Component$Form$TextInput$icon($author$project$View$Icon$path.asW)
											]);
									case 35:
										return _List_fromArray(
											[$author$project$Component$Form$TextInput$hidden]);
									default:
										return _List_Nil;
								}
							}())
						]);
				case 8:
					return _List_fromArray(
						[
							A2(
							textInput,
							$elm$core$Maybe$Nothing,
							_List_fromArray(
								[$author$project$Component$Form$TextInput$hidden]))
						]);
				case 6:
					return _List_fromArray(
						[
							A2(
							textInput,
							A2(
								$elm_community$maybe_extra$Maybe$Extra$filter,
								$elm$core$Basics$always(!disableCopyPaste),
								config.aC),
							_Utils_ap(
								_List_fromArray(
									[
										$author$project$Component$Form$TextInput$email,
										$author$project$Component$Form$TextInput$icon($author$project$View$Icon$path.eR),
										$author$project$Component$Form$TextInput$disabled(
										(!disableCopyPaste) && $elm_community$maybe_extra$Maybe$Extra$isJust(config.aC))
									]),
								$author$project$View$FormV2$disableCopyPasteAttrs(disableCopyPaste)))
						]);
				case 7:
					var fileOptions = _v0.a;
					var field = config.Hq;
					var fileField = function () {
						var _v4 = config.ae;
						if (!_v4.$) {
							var sqConfig = _v4.a;
							return _Utils_update(
								field,
								{dY: sqConfig.dY});
						} else {
							return field;
						}
					}();
					return A7(
						$author$project$View$FormV2$viewFileField,
						label,
						getPlaceholder,
						config.eq,
						fileField,
						fileOptions,
						errorMessage($author$project$View$FormV2$toFileValue),
						A3($author$project$View$FormV2$maybeValue, config, state.j, $author$project$View$FormV2$toFileValue));
				case 9:
					var _v5 = A4(
						$author$project$View$FormV2$value,
						config,
						state.j,
						$author$project$View$FormV2$toPhoneWithCallingCodeValue,
						_Utils_Tuple2(config.atB, ''));
					var code = _v5.a;
					var p = _v5.b;
					var selectConfig = {
						atr: $elm$core$Maybe$Just(
							$elm$core$Basics$eq(code)),
						at7: $author$project$Model$CountryCallingCode$fromString,
						auq: $elm$core$Maybe$Nothing,
						au7: function () {
							var _v6 = $author$project$Data$CountryCallingCode$sortedByCountryName;
							if (_v6.b) {
								var hd = _v6.a;
								var rest = _v6.b;
								return _Utils_Tuple2(hd, rest);
							} else {
								return _Utils_Tuple2(code, $author$project$Model$CountryCallingCode$all);
							}
						}(),
						avz: false,
						avS: $elm$core$Maybe$Just(config.eq),
						avZ: A2(
							$elm$core$Basics$composeL,
							toMsg,
							A2($author$project$Util$Base$flip, $author$project$Model$FormFieldValueV2$PhoneNumberWithCallingCodeValue, p)),
						av_: $author$project$Data$CountryCallingCode$formatWithCountryName,
						av$: $author$project$Model$CountryCallingCode$toString
					};
					return _List_fromArray(
						[
							A2(
							$author$project$Component$Form$TextInput$view,
							label,
							_List_fromArray(
								[
									$author$project$Component$Form$TextInput$id(fieldName),
									$author$project$Component$Form$TextInput$extraHtml(
									A3(
										$author$project$Component$Form$SelectNonEmpty$viewSelectShortWhenSelected,
										$author$project$Model$CountryCallingCode$toCode,
										A3($author$project$Data$Translation$toStringOr, config.anB, $author$project$Model$Translation$callingCodeLabel, $author$project$Copy$copy.atb),
										selectConfig)),
									$author$project$Component$Form$TextInput$placeholder(placeholder),
									$author$project$Component$Form$TextInput$onInput(
									A2(
										$elm$core$Basics$composeL,
										toMsg,
										$author$project$Model$FormFieldValueV2$PhoneNumberWithCallingCodeValue(code))),
									$author$project$Component$Form$TextInput$value(p),
									$author$project$Component$Form$TextInput$tabindex(config.eq + 1),
									$author$project$Component$Form$TextInput$error(
									errorMessage($author$project$View$FormV2$toPhoneWithCallingCodeValue)),
									$author$project$Component$Form$TextInput$phone,
									$author$project$Component$Form$TextInput$icon($author$project$View$Icon$path.aR),
									$author$project$Component$Form$TextInput$class('phone with-calling-code'),
									$author$project$Component$Form$TextInput$hiddenLabel(config.Hq.dB)
								]))
						]);
				case 18:
					return A2($author$project$View$FormV2$toScreeningQuestionsHtmlFields, state_, config);
				case 12:
					var options = _v0.a;
					return _List_fromArray(
						[
							A8(
							$author$project$View$FormV2$toSelectField,
							fieldName,
							config.eq,
							label,
							config.Hq.dY,
							options,
							toMsg,
							errorMessage($author$project$View$FormV2$toSelectValue),
							A3($author$project$View$FormV2$maybeValue, config, state.j, $author$project$View$FormV2$toSelectValue))
						]);
				case 14:
					var options = _v0.a;
					return _List_fromArray(
						[
							A7(
							$author$project$View$FormV2$toSelectWithIdsField,
							fieldName,
							config.eq,
							label,
							options,
							toMsg,
							errorMessage($author$project$View$FormV2$toSelectValue),
							A3($author$project$View$FormV2$maybeValue, config, state.j, $author$project$View$FormV2$toSelectValue))
						]);
				case 16:
					return _List_fromArray(
						[
							A2(
							$author$project$Component$Form$TextArea$view,
							label,
							_List_fromArray(
								[
									$author$project$Component$Form$TextArea$id(fieldName),
									$author$project$Component$Form$TextArea$tabindex(config.eq),
									$author$project$Component$Form$TextArea$placeholder(placeholder),
									$author$project$Component$Form$TextArea$onInput(
									A2($elm$core$Basics$composeL, toMsg, $author$project$Model$FormFieldValueV2$TextValue)),
									$author$project$Component$Form$TextArea$value(
									A4($author$project$View$FormV2$value, config, state.j, $author$project$View$FormV2$toTextValue, '')),
									$author$project$Component$Form$TextArea$error(
									errorMessage($author$project$View$FormV2$toTextValue)),
									$author$project$Component$Form$TextArea$hiddenLabel(config.Hq.dB)
								]))
						]);
				default:
					switch (_v0.a) {
						case 2:
							var _v7 = _v0.a;
							return _List_fromArray(
								[
									A2(
									textInput,
									$elm$core$Maybe$Nothing,
									_List_fromArray(
										[
											$author$project$Component$Form$TextInput$url,
											$author$project$Component$Form$TextInput$icon($author$project$View$Icon$path.Rj)
										]))
								]);
						case 1:
							var _v8 = _v0.a;
							return _List_fromArray(
								[
									A2(
									textInput,
									$elm$core$Maybe$Nothing,
									_List_fromArray(
										[
											$author$project$Component$Form$TextInput$url,
											$author$project$Component$Form$TextInput$icon($author$project$View$Icon$path.asA)
										]))
								]);
						default:
							var _v9 = _v0.a;
							return _List_fromArray(
								[
									A2(
									textInput,
									$elm$core$Maybe$Nothing,
									_List_fromArray(
										[
											$author$project$Component$Form$TextInput$url,
											$author$project$Component$Form$TextInput$icon($author$project$View$Icon$path.Q0)
										]))
								]);
					}
			}
		}();
		return fieldHtml;
	});
var $author$project$View$FormV2$viewFormRow = F7(
	function (requiredFields, state, formConfig, validationResponse, allFields, rowIndex, fields) {
		var state_ = state;
		var fieldNames = A2(
			$elm$core$List$map,
			function ($) {
				return $.dY;
			},
			fields);
		var config = F2(
			function (colIndex, field) {
				return {
					rC: colIndex,
					atB: state_.atB,
					Hq: field,
					ae: $elm$core$Maybe$Nothing,
					aC: formConfig.aC,
					aU: formConfig.aU,
					adF: rowIndex,
					eq: A4(
						$author$project$View$FormV2$tabindex,
						formConfig.aP,
						state_.fB,
						field.dY,
						$elm$core$List$concat(allFields)),
					fV: formConfig.fV,
					anB: formConfig.anB,
					ape: state_.ape,
					f$: validationResponse
				};
			});
		var formFields = A3(
			$author$project$View$FormV2$intersperseOneOrMoreRow,
			fields,
			requiredFields,
			$elm$core$List$concat(
				A2(
					$elm$core$List$indexedMap,
					F2(
						function (index, field) {
							return A2(
								$author$project$View$FormV2$viewFormField,
								state,
								A2(config, index, field));
						}),
					fields)));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('form-row', true),
							_Utils_Tuple2(
							'joined',
							A2($author$project$View$FormV2$toRowStyle, requiredFields, fields) === 1),
							_Utils_Tuple2(
							'combined',
							A2($author$project$View$FormV2$toRowStyle, requiredFields, fields) === 3),
							_Utils_Tuple2(
							'align-flex-end',
							A2($author$project$View$FormV2$toRowStyle, requiredFields, fields) === 2),
							_Utils_Tuple2(
							'has-screening-questions',
							A2($elm$core$List$member, $author$project$Model$FormFieldV2$ScreeningQuestions, fieldNames))
						]))
				]),
			formFields);
	});
var $author$project$Data$Status$isLoading = function (status) {
	switch (status.$) {
		case 1:
			return true;
		case 0:
			return false;
		case 2:
			return false;
		default:
			return false;
	}
};
var $author$project$Model$Translation$submitForm = 'submit-form';
var $author$project$View$FormV2$viewFormSubmitButton = F4(
	function (status, translations, buttonOverwriteText, tabIndex) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('form-row')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('form-field')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('btn btn-submit bg-color-1 color-white'),
									$elm$html$Html$Attributes$type_('submit'),
									$elm$html$Html$Attributes$disabled(
									$author$project$Data$Status$isLoading(status)),
									$elm$html$Html$Attributes$tabindex(tabIndex)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('label')
										]),
									_List_fromArray(
										[
											A2(
											$elm$core$Maybe$withDefault,
											A2($author$project$Data$Translation$text, translations, $author$project$Model$Translation$submitForm),
											A2(
												$elm$core$Maybe$map,
												function (t) {
													return $elm$html$Html$text(t);
												},
												buttonOverwriteText))
										]))
								]))
						]))
				]));
	});
var $author$project$View$FormV2$viewHttpError = function (submitStatus_) {
	if ((submitStatus_.$ === 2) && (submitStatus_.a.$ === 1)) {
		var err = submitStatus_.a.a;
		var _v1 = $author$project$Util$Translation$httpError(err);
		var description = _v1.dn;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('form-row')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('form-http-error')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(description)
								]))
						]))
				]));
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$View$FormV2$viewSubmitProgress = function (_v0) {
	var progress = _v0;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('form-row')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('form-submit-progress')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('form-submit-progress-bar'),
								A2(
								$elm$html$Html$Attributes$style,
								'transform',
								A2(
									$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
									'translate({0}%,0)',
									_List_fromArray(
										[
											$elm$core$String$fromFloat((progress - 1) * 100)
										])))
							]),
						_List_Nil)
					]))
			]));
};
var $author$project$Model$Translation$submitFormSuccessMessage = 'submit-form-success-message';
var $author$project$View$FormV2$viewSuccessMessage = F2(
	function (translations, maybeCustomMessage) {
		var message = function () {
			if (!maybeCustomMessage.$) {
				var customMessage = maybeCustomMessage.a;
				return customMessage;
			} else {
				return A2($author$project$Data$Translation$toString, translations, $author$project$Model$Translation$submitFormSuccessMessage);
			}
		}();
		return A2(
			$elm$html$Html$form,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('form'),
					$elm$html$Html$Attributes$name('apply-form')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('form-row')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('form-submit-success-message')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(message)
										]))
								]))
						]))
				]));
	});
var $author$project$View$FormV2$view = F2(
	function (config, state) {
		var state_ = state;
		var validationResponse = function () {
			var _v1 = state_.bq;
			if ((_v1.$ === 2) && (!_v1.a.$)) {
				var err = _v1.a.a;
				return $elm$core$Maybe$Just(err);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		var isSubmitSuccess = $author$project$Data$Status$isSuccess(state_.bq);
		var form = $author$project$Data$FormSource$toForm(state_.eW);
		var _v0 = form.atV;
		var fields = _v0;
		return A2(
			$elm$html$Html$map,
			config.aut,
			isSubmitSuccess ? A2($author$project$View$FormV2$viewSuccessMessage, config.anB, state_.fN) : A2(
				$elm$html$Html$form,
				_List_fromArray(
					[
						$elm$html$Html$Events$onSubmit($author$project$View$FormV2$SubmitForm),
						$elm$html$Html$Attributes$class('form'),
						$elm$html$Html$Attributes$name('apply-form')
					]),
				$elm$core$List$concat(
					_List_fromArray(
						[
							A2(
							$elm$core$List$indexedMap,
							A5($author$project$View$FormV2$viewFormRow, form.eb, state, config, validationResponse, fields),
							fields),
							_List_fromArray(
							[
								A2($author$project$Util$View$viewMaybe, state_.aY, $author$project$View$FormV2$viewSubmitProgress),
								$author$project$View$FormV2$viewHttpError(state_.bq),
								A4(
								$author$project$View$FormV2$viewFormSubmitButton,
								state_.bq,
								config.anB,
								config.aG,
								A3(
									$author$project$View$FormV2$submitTabIndex,
									config.aP,
									state_.fB,
									$elm$core$List$concat(fields)))
							])
						]))));
	});
var $author$project$View$ChatBot$viewOpenApplicationForm = F3(
	function (today, privacyPageUrl, formData) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id('form-node'),
					$elm$html$Html$Attributes$class('chatbot-node-form chatbot-node-openapplicationform')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h3,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text($author$project$Copy$copy.Yd)
						])),
					A2(
					$author$project$View$FormV2$view,
					{aG: $elm$core$Maybe$Nothing, aut: $author$project$View$ChatBot$OpenApplicationFormMsg, aP: 0, aC: $elm$core$Maybe$Nothing, aU: privacyPageUrl, fV: today, anB: formData.anB},
					formData.IF)
				]));
	});
var $author$project$View$ChatBot$viewOpenApplicationFormNode = F4(
	function (today, currentNodesOnly, data, node) {
		var _v0 = data.K;
		if (!_v0.$) {
			var formData = _v0.a;
			if (_Utils_eq(formData.O, node.dE)) {
				var _v1 = formData.IF;
				switch (_v1.$) {
					case 3:
						var fd = _v1.a;
						return _List_fromArray(
							[
								A3($author$project$View$ChatBot$viewOpenApplicationForm, today, data.aV, fd)
							]);
					case 1:
						return _List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('chatbot-loading')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('...')
									]))
							]);
					case 2:
						return _List_fromArray(
							[
								$elm$html$Html$text($author$project$Copy$copy.aiZ)
							]);
					default:
						return _List_Nil;
				}
			} else {
				return _List_Nil;
			}
		} else {
			return _List_Nil;
		}
	});
var $author$project$View$ChatBot$FocusOn = function (a) {
	return {$: 3, a: a};
};
var $author$project$View$ChatBot$viewOptionNode = F2(
	function (node, content) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick(
						$author$project$View$ChatBot$FocusOn(node.dE)),
						$elm$html$Html$Attributes$class('btn btn-submit primary bg-color-1 color-white')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(content)
					]))
			]);
	});
var $author$project$View$ChatBot$OnSalaryCalculatorInput = F2(
	function (a, b) {
		return {$: 16, a: a, b: b};
	});
var $author$project$View$ChatBot$viewSalaryCalculatorNode = F4(
	function (node, value, salaryCalculatorId, salaryCalculators) {
		var _v0 = A2($author$project$Dict$Custom$get, salaryCalculatorId, salaryCalculators);
		if ((!_v0.$) && (_v0.a.$ === 3)) {
			var _v1 = _v0.a.a;
			var salaryCalculator = _v1.b;
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('chatbot-node-salarycalculator-inputs')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('chatbot-node-salarycalculator-input-wrapper')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$label,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text($author$project$Copy$copy.hj)
										])),
									A2(
									$author$project$Component$Form$NumberInput$view,
									'',
									_List_fromArray(
										[
											$author$project$Component$Form$NumberInput$onInput(
											function (v) {
												return A2(
													$author$project$View$ChatBot$OnSalaryCalculatorInput,
													node.dE,
													_Utils_update(
														value,
														{hj: v}));
											}),
											$author$project$Component$Form$NumberInput$id(
											$author$project$Data$ChatBot$idToString(node.dE) + 'age'),
											$author$project$Component$Form$NumberInput$value(value.hj),
											$author$project$Component$Form$NumberInput$placeholder(''),
											$author$project$Component$Form$NumberInput$min(
											$author$project$Data$SalaryCalculator$minAge(salaryCalculator))
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('chatbot-node-salarycalculator-input-wrapper')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$label,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text($author$project$Copy$copy.MX)
										])),
									A2(
									$author$project$Component$Form$NumberInput$view,
									'',
									_List_fromArray(
										[
											$author$project$Component$Form$NumberInput$onInput(
											function (v) {
												return A2(
													$author$project$View$ChatBot$OnSalaryCalculatorInput,
													node.dE,
													_Utils_update(
														value,
														{MX: v}));
											}),
											$author$project$Component$Form$NumberInput$id(
											$author$project$Data$ChatBot$idToString(node.dE) + 'hours'),
											$author$project$Component$Form$NumberInput$value(value.MX),
											$author$project$Component$Form$NumberInput$placeholder(''),
											$author$project$Component$Form$NumberInput$min(0),
											$author$project$Component$Form$NumberInput$max(
											A2($elm$core$Maybe$withDefault, 40, salaryCalculator.Sy))
										]))
								]))
						])),
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick(
							$author$project$View$ChatBot$FocusOn(node.dE)),
							$elm$html$Html$Attributes$class('btn btn-submit primary bg-color-1 color-white')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text($author$project$Copy$copy.pv)
						]))
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Data$ChatBot$findParentOf = function (id) {
	return A2(
		$elm$core$Basics$composeR,
		$zwilias$elm_rosetree$Tree$Zipper$findFromRoot(
			A2(
				$elm$core$Basics$composeL,
				$elm$core$Basics$eq(id),
				function ($) {
					return $.dE;
				})),
		$elm$core$Maybe$andThen($zwilias$elm_rosetree$Tree$Zipper$parent));
};
var $author$project$Data$ChatBot$parentOf = function (id) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Data$ChatBot$findParentOf(id),
		$elm$core$Maybe$map($zwilias$elm_rosetree$Tree$Zipper$label));
};
var $author$project$View$ChatBot$viewTextNode = F3(
	function (node, data, content) {
		var maybeSalaryCalculatorData = function () {
			var _v2 = A2(
				$elm$core$Maybe$map,
				function (parent) {
					return _Utils_Tuple2(parent.bh, parent.dE);
				},
				A2($author$project$Data$ChatBot$parentOf, node.dE, data.qj));
			if (((!_v2.$) && (_v2.a.a.$ === 5)) && (!_v2.a.a.a.$)) {
				var _v3 = _v2.a;
				var salaryCalculatorId = _v3.a.a.a;
				var parentId = _v3.b;
				var _v4 = A2(
					$elm$core$Maybe$map,
					function (v) {
						return _Utils_Tuple2(
							A3(
								$author$project$View$ChatBot$salaryCalculatorInputWithFallback,
								$elm$core$Maybe$Just(salaryCalculatorId),
								data,
								parentId),
							v);
					},
					A2($author$project$Dict$Custom$get, salaryCalculatorId, data.bo));
				if ((!_v4.$) && (_v4.a.b.$ === 3)) {
					var _v5 = _v4.a;
					var inputValue = _v5.a;
					var _v6 = _v5.b.a;
					var salaryCalculator = _v6.b;
					return $elm$core$Maybe$Just(
						_Utils_Tuple2(inputValue, salaryCalculator));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		if (!maybeSalaryCalculatorData.$) {
			var _v1 = maybeSalaryCalculatorData.a;
			var inputValue = _v1.a;
			var salaryCalculator = _v1.b;
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$pre,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A6($author$project$Data$SalaryCalculator$interpolateMessage, salaryCalculator, content, inputValue.hj, inputValue.MX, 1, data.a3))
						]))
				]);
		} else {
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$pre,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(content)
						]))
				]);
		}
	});
var $author$project$View$ChatBot$viewTitleNode = function (content) {
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$h3,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(content)
				]))
		]);
};
var $author$project$View$ChatBot$shouldHideVacancyOverview = F3(
	function (currentNodesOnly, data, nodeId) {
		return currentNodesOnly && A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function (formData) {
					return _Utils_eq(formData.O, nodeId) && $author$project$Data$Status$isSuccess(formData.IF);
				},
				data.G));
	});
var $author$project$View$ChatBot$CloseForm = {$: 11};
var $author$project$View$ChatBot$viewForm = F5(
	function (today, currentNodesOnly, privacyPageUrl, _v0, formData) {
		var vacancy = _v0.aqa;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id('form-node'),
					$elm$html$Html$Attributes$class('chatbot-node-form')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Util$View$viewIf,
					currentNodesOnly,
					function (_v1) {
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('form-back-button-wrapper')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Events$onClick($author$project$View$ChatBot$CloseForm),
											$elm$html$Html$Attributes$class('btn btn-secondary'),
											$elm$html$Html$Attributes$type_('button')
										]),
									_List_fromArray(
										[
											A2($author$project$View$Icon$viewMasked, 1, $author$project$Data$Icon$path.k2),
											$elm$html$Html$text($author$project$Copy$copy.Lq)
										]))
								]));
					}),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('form-node-header')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h3,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Data$Entity$value(vacancy).avV)
								])),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick($author$project$View$ChatBot$CloseForm),
									$elm$html$Html$Attributes$class('form-close-button'),
									$elm$html$Html$Attributes$type_('button')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('×')
								]))
						])),
					A2(
					$author$project$View$FormV2$view,
					{aG: $elm$core$Maybe$Nothing, aut: $author$project$View$ChatBot$FormMsg, aP: 0, aC: $elm$core$Maybe$Nothing, aU: privacyPageUrl, fV: today, anB: formData.anB},
					formData.IF)
				]));
	});
var $author$project$View$ChatBot$OnVacancySelect = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $elm$html$Html$footer = _VirtualDom_node('footer');
var $author$project$Data$Metadata$hoursToString = F3(
	function (langCode, mMinHours, mMaxHours) {
		var toHourTranslation = function (hours) {
			return ((langCode === 16) || (!hours)) ? $author$project$Copy$copy.MV : $author$project$Copy$copy.MX;
		};
		var _v0 = _Utils_Tuple2(mMinHours, mMaxHours);
		if (!_v0.a.$) {
			if (!_v0.b.$) {
				var minHours = _v0.a.a;
				var maxHours = _v0.b.a;
				return _Utils_eq(minHours, maxHours) ? A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'{0} {1}',
					_List_fromArray(
						[
							$elm$core$String$fromFloat(maxHours),
							toHourTranslation(maxHours)
						])) : A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'{0} - {1} {2}',
					_List_fromArray(
						[
							$elm$core$String$fromFloat(minHours),
							$elm$core$String$fromFloat(maxHours),
							toHourTranslation(maxHours)
						]));
			} else {
				var minHours = _v0.a.a;
				var _v2 = _v0.b;
				return A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'{0} {1} {2}',
					_List_fromArray(
						[
							$author$project$Copy$copy.Tm,
							$elm$core$String$fromFloat(minHours),
							toHourTranslation(minHours)
						]));
			}
		} else {
			if (!_v0.b.$) {
				var _v1 = _v0.a;
				var maxHours = _v0.b.a;
				return A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'{0} {1} {2}',
					_List_fromArray(
						[
							$author$project$Copy$copy.SH,
							$elm$core$String$fromFloat(maxHours),
							toHourTranslation(maxHours)
						]));
			} else {
				var _v3 = _v0.a;
				var _v4 = _v0.b;
				return '';
			}
		}
	});
var $elm$html$Html$i = _VirtualDom_node('i');
var $elm$html$Html$Attributes$rel = _VirtualDom_attribute('rel');
var $author$project$View$ChatBot$viewVacancyItem = F5(
	function (nodeId, langCode, pathPrefix, distanceInfo, searchResult) {
		var _v0 = searchResult.aqa;
		var vacancyId = _v0.a;
		var vacancy = _v0.b;
		var vacancyShortUrl = $elm$core$String$isEmpty(pathPrefix) ? A2(
			$elm$url$Url$Builder$absolute,
			_List_fromArray(
				['v', vacancy.GT]),
			_List_Nil) : A2(
			$elm$url$Url$Builder$absolute,
			_List_fromArray(
				[pathPrefix, 'v', vacancy.GT]),
			_List_Nil);
		var findDistanceInfo = $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeL,
					$elm$core$Basics$eq(vacancyId),
					function ($) {
						return $.aqL;
					}),
				distanceInfo));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('chatbot-node-vacancy')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h3,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(vacancy.avV)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('chatbot-node-vacancy-metadata')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Util$View$viewMaybe,
							searchResult.Rs,
							function (_v1) {
								var location = _v1.b;
								return A2(
									$author$project$Util$View$viewIfNot,
									$elm$core$String$isEmpty(location.qM),
									function (_v2) {
										return A2(
											$elm$html$Html$span,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(location.qM)
												]));
									});
							}),
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A3($author$project$Data$Metadata$hoursToString, langCode, vacancy.Te, vacancy.Sy))
								])),
							A2(
							$author$project$Util$View$viewMaybe,
							findDistanceInfo,
							function (info) {
								return A2(
									$elm$html$Html$i,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$elm$core$String$fromFloat(info.Ed)),
											$elm$html$Html$text('km')
										]));
							})
						])),
					A2(
					$elm$html$Html$footer,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$href(vacancyShortUrl),
									$elm$html$Html$Attributes$target('_blank'),
									$elm$html$Html$Attributes$class('link color-2'),
									$elm$html$Html$Attributes$rel('noopener noreferrer')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text($author$project$Copy$copy.abk)
								])),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$type_('button'),
									$elm$html$Html$Attributes$class('bg-color-1 color-white'),
									$elm$html$Html$Events$onClick(
									A2(
										$author$project$View$ChatBot$OnVacancySelect,
										nodeId,
										$author$project$Data$Entity$id(searchResult.aqa)))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text($author$project$Copy$copy.kC)
								]))
						]))
				]));
	});
var $author$project$View$ChatBot$viewVacancyOverviewSettings = F7(
	function (domainId, langCode, today, currentNodesOnly, node, settings, data) {
		var viewLocationSuggestions = A2(
			$author$project$Util$View$viewIf,
			settings.atL,
			function (_v9) {
				return A2(
					$author$project$View$LocationSuggestions$view,
					A4($author$project$View$ChatBot$locationSuggestionsConfig, domainId, node.dE, data.aW, data.ci),
					function () {
						var _v10 = data.az;
						if (!_v10.$) {
							var _v11 = _v10.a;
							var currentNodeId = _v11.a;
							var suggestions = _v11.b;
							return _Utils_eq(node.dE, currentNodeId) ? suggestions : $author$project$View$LocationSuggestions$init;
						} else {
							return $author$project$View$LocationSuggestions$init;
						}
					}());
			});
		var findVacancyById = F2(
			function (vacancyId, vacancies) {
				return $elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (v) {
							return _Utils_eq(
								$author$project$Data$Entity$id(v.aqa),
								vacancyId);
						},
						vacancies));
			});
		var toJobApplicationFormData = function (vacancies) {
			return A2(
				$elm$core$Maybe$andThen,
				function (formData) {
					return A2(
						$elm$core$Maybe$map,
						$elm$core$Tuple$pair(formData),
						A2(findVacancyById, formData.aqL, vacancies));
				},
				data.G);
		};
		var renderCurrentNodesOnlyMode = function (results) {
			var _v7 = toJobApplicationFormData(results.ap7);
			if (!_v7.$) {
				var _v8 = _v7.a;
				var formData = _v8.a;
				var vacancy = _v8.b;
				return _List_fromArray(
					[
						A3(
						$author$project$Data$Status$withStatus,
						formData.IF,
						$elm$html$Html$text(''),
						A4($author$project$View$ChatBot$viewForm, today, currentNodesOnly, data.aV, vacancy))
					]);
			} else {
				return _List_fromArray(
					[viewLocationSuggestions]);
			}
		};
		var renderNormalMode = function (results) {
			return _Utils_ap(
				_List_fromArray(
					[
						viewLocationSuggestions,
						A2(
						$author$project$Util$View$viewIf,
						$elm$core$List$isEmpty(results.ap7),
						function (_v2) {
							return A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text($author$project$Copy$copy.WW)
									]));
						}),
						A2(
						$author$project$Util$View$viewIfNot,
						$elm$core$List$isEmpty(results.ap7),
						function (_v3) {
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('chatbot-node-vacancies')
									]),
								A2(
									$elm$core$List$map,
									A4($author$project$View$ChatBot$viewVacancyItem, node.dE, langCode, data.ft, results.Ee),
									results.ap7));
						}),
						A2(
						$author$project$Util$View$viewIf,
						_Utils_cmp(results.ang, $author$project$View$ChatBot$maxResults) > 0,
						function (_v4) {
							return A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('chatbot-node-vacancies-more btn bg-color-1 color-white'),
										$elm$html$Html$Attributes$href(results.Zh)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										A2(
											$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
											'{0} ({1}) →',
											_List_fromArray(
												[
													$author$project$Copy$copy.arD,
													$elm$core$String$fromInt(results.ang)
												])))
									]));
						})
					]),
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function (_v5) {
							var formData = _v5.a;
							var vacancy = _v5.b;
							return _List_fromArray(
								[
									A2(
									$author$project$Util$View$viewIf,
									_Utils_eq(node.dE, formData.O) && (!data.S),
									function (_v6) {
										return A3(
											$author$project$Data$Status$withStatus,
											formData.IF,
											$elm$html$Html$text(''),
											A4($author$project$View$ChatBot$viewForm, today, currentNodesOnly, data.aV, vacancy));
									})
								]);
						},
						toJobApplicationFormData(results.ap7))));
		};
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$andThen,
				function (status) {
					if (status.$ === 3) {
						var _v1 = status.a;
						var results = _v1.b;
						return $elm$core$Maybe$Just(
							A3($author$project$View$ChatBot$shouldHideVacancyOverview, currentNodesOnly, data, node.dE) ? renderCurrentNodesOnlyMode(results) : renderNormalMode(results));
					} else {
						return $elm$core$Maybe$Nothing;
					}
				},
				A2($author$project$Dict$Custom$get, node.dE, data.Y)));
	});
var $author$project$View$ChatBot$viewVideoNode = F2(
	function (uploads, imageSource) {
		var _v0 = A2($author$project$Data$ImageSource$toTextFromUploads, uploads, imageSource);
		if (!_v0.$) {
			var path = _v0.a;
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$video,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$controls(true),
							$elm$html$Html$Attributes$src(path)
						]),
					_List_Nil)
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$View$ChatBot$viewNode = F7(
	function (domainId, langCode, today, currentNodesOnly, maybeAvatar, data, node) {
		var isNextNode = _Utils_eq(
			$author$project$View$ChatBot$nextNode(data),
			$elm$core$Maybe$Just(node));
		var display = (isNextNode || A2(
			$elm$core$Set$member,
			$author$project$Data$ChatBot$idToString(node.dE),
			data.bj)) ? A2($elm$html$Html$Attributes$style, 'display', 'inline-flex') : A2($elm$html$Html$Attributes$style, 'display', 'none');
		return A3(
			$elm$html$Html$Keyed$node,
			'div',
			_List_fromArray(
				[
					display,
					$elm$html$Html$Attributes$class('chatbot-node-wrapper'),
					$elm$html$Html$Attributes$class(
					$author$project$View$ChatBot$nodeClassName(node.bh))
				]),
			_List_fromArray(
				[
					_Utils_Tuple2(
					'avatar',
					A2($author$project$View$ChatBot$viewNodeAvatar, node.bh, maybeAvatar)),
					isNextNode ? _Utils_Tuple2(
					'loading',
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('fade-in chatbot-node chatbot-loading-node')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('...')
							]))) : A2(
					$elm$core$Tuple$pair,
					'node',
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class(
								currentNodesOnly ? 'appear chatbot-node' : 'appear appear-delay chatbot-node')
							]),
						function () {
							var _v0 = node.bh;
							switch (_v0.$) {
								case 0:
									var content = _v0.a;
									return A2($author$project$View$ChatBot$viewOptionNode, node, content);
								case 5:
									if (!_v0.a.$) {
										var salaryCalculatorId = _v0.a.a;
										return A4(
											$author$project$View$ChatBot$viewSalaryCalculatorNode,
											node,
											A3(
												$author$project$View$ChatBot$salaryCalculatorInputWithFallback,
												$elm$core$Maybe$Just(salaryCalculatorId),
												data,
												node.dE),
											salaryCalculatorId,
											data.bo);
									} else {
										return _List_fromArray(
											[
												$elm$html$Html$text($author$project$Copy$copy.WF)
											]);
									}
								case 4:
									var settings = _v0.a;
									return A7($author$project$View$ChatBot$viewVacancyOverviewSettings, domainId, langCode, today, currentNodesOnly, node, settings, data);
								case 1:
									var content = _v0.a;
									return A3($author$project$View$ChatBot$viewTextNode, node, data, content);
								case 2:
									var content = _v0.a;
									return $author$project$View$ChatBot$viewTitleNode(content);
								case 3:
									var settings = _v0.a;
									return $author$project$View$ChatBot$viewLinkNode(settings);
								case 6:
									var path = _v0.a;
									return A2($author$project$View$ChatBot$viewImageNode, data.ape, path);
								case 7:
									var path = _v0.a;
									return A2($author$project$View$ChatBot$viewVideoNode, data.ape, path);
								case 8:
									return _List_Nil;
								case 9:
									return A4($author$project$View$ChatBot$viewOpenApplicationFormNode, today, currentNodesOnly, data, node);
								default:
									return _List_Nil;
							}
						}()))
				]));
	});
var $author$project$View$ChatBot$viewChat = F6(
	function (domainId, langCode, today, currentNodesOnly, maybeAvatar, data) {
		var toChatBot = currentNodesOnly ? $author$project$Data$ChatBot$current(data.qj) : $author$project$Data$ChatBot$currentAndBefore(data.qj);
		var keyedNode = function (node) {
			return _Utils_Tuple2(
				$author$project$Data$ChatBot$idToString(node.dE),
				A7($author$project$View$ChatBot$viewNode, domainId, langCode, today, currentNodesOnly, maybeAvatar, data, node));
		};
		return A3(
			$elm$html$Html$Keyed$node,
			'div',
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id('chat-nodes'),
					$elm$html$Html$Attributes$class('chatbot-nodes')
				]),
			A2(
				$elm$core$List$map,
				A2($elm$core$Basics$composeL, keyedNode, $zwilias$elm_rosetree$Tree$label),
				toChatBot));
	});
var $author$project$View$ChatBot$GoBack = {$: 17};
var $author$project$View$ChatBot$GoToStart = {$: 18};
var $author$project$View$ChatBot$viewChatNav = F2(
	function (currentNodesOnly, data) {
		return A2(
			$author$project$Util$View$viewIf,
			currentNodesOnly && $elm_community$maybe_extra$Maybe$Extra$isJust(
				$zwilias$elm_rosetree$Tree$Zipper$parent(data.qj)),
			function (_v0) {
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('chatbot-nav')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick($author$project$View$ChatBot$GoBack),
									$elm$html$Html$Attributes$class('chatbot-nav-link'),
									$elm$html$Html$Attributes$type_('button')
								]),
							_List_fromArray(
								[
									A2($author$project$View$Icon$viewMasked, 1, $author$project$Data$Icon$path.la),
									$elm$html$Html$text($author$project$Copy$copy.P1)
								])),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick($author$project$View$ChatBot$GoToStart),
									$elm$html$Html$Attributes$class('chatbot-nav-link'),
									$elm$html$Html$Attributes$type_('button')
								]),
							_List_fromArray(
								[
									A2($author$project$View$Icon$viewMasked, 1, $author$project$Data$Icon$path.le),
									$elm$html$Html$text($author$project$Copy$copy.P0)
								]))
						]));
			});
	});
var $author$project$View$ChatBot$view = F7(
	function (lift, domainId, langCode, today, currentNodesOnly, maybeAvatar, model) {
		var onScroll = $author$project$ScrollToInElement$isScrolling(model.V) ? _List_fromArray(
			[
				A2(
				$elm$html$Html$Events$on,
				'wheel',
				$elm$json$Json$Decode$succeed($author$project$View$ChatBot$CancelScroll))
			]) : _List_Nil;
		return A2(
			$elm$html$Html$map,
			lift,
			A2(
				$elm$html$Html$div,
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$id('chat'),
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$class('chatbot'),
						onScroll)),
				_List_fromArray(
					[
						A6($author$project$View$ChatBot$viewChat, domainId, langCode, today, currentNodesOnly, maybeAvatar, model),
						A2($author$project$View$ChatBot$viewChatNav, currentNodesOnly, model)
					])));
	});
var $author$project$RecruitmentChat$viewOpenChatBot = function (_v0) {
	var botAvatar = _v0.o2;
	var background = function () {
		if (botAvatar.$ === 1) {
			return $elm$html$Html$Attributes$class('no-avatar');
		} else {
			var avatar = botAvatar.a;
			return A2(
				$elm$html$Html$Attributes$style,
				'background-image',
				A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'url(\'{0}\')',
					_List_fromArray(
						[avatar])));
		}
	}();
	return A2(
		$elm$html$Html$button,
		_List_fromArray(
			[
				$elm$html$Html$Events$onClick($author$project$RecruitmentChat$ShowChatBot),
				$elm$html$Html$Attributes$class('recruitment-chat-open-button'),
				background,
				$elm$html$Html$Attributes$title($author$project$Copy$copy.aa4),
				A2($elm$html$Html$Attributes$attribute, 'aria-label', $author$project$Copy$copy.aa4)
			]),
		_List_Nil);
};
var $author$project$RecruitmentChat$view = function (model) {
	var isOpen = A2($elm$core$Maybe$withDefault, false, model.bp) || model.S;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('recruitment-chat-inner-wrapper', true),
						_Utils_Tuple2('recruitment-chat-is-open', isOpen)
					]))
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Util$View$viewIfNot,
				model.S,
				function (_v0) {
					return $author$project$RecruitmentChat$viewOpenChatBot(
						{
							o2: A2($author$project$RecruitmentChat$resolveBotAvatar, model.ape, model.aa4.o2)
						});
				}),
				A2(
				$author$project$Util$View$viewIf,
				A2(
					$elm$core$List$all,
					$elm$core$Basics$eq(true),
					_List_fromArray(
						[
							model.eh,
							$elm_community$maybe_extra$Maybe$Extra$isNothing(model.bp),
							!$elm$core$String$isEmpty(model.aa4.cw)
						])),
				function (_v1) {
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('recruitment-chat-introduction')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(model.aa4.cw),
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('icon-btn bg-color-2'),
										$elm$html$Html$Events$onClick($author$project$RecruitmentChat$HideIntroduction),
										$elm$html$Html$Attributes$type_('button')
									]),
								_List_fromArray(
									[
										$author$project$View$Icon$viewColored($author$project$View$Icon$path.auZ)
									]))
							]));
				}),
				A2(
				$author$project$Util$View$viewIf,
				(!model.S) && (A2($elm$core$Maybe$withDefault, false, model.bp) && $author$project$Browser$Dom$Breakpoint$isMobile(model.cX)),
				function (_v2) {
					return A3(
						$elm$html$Html$node,
						'style',
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('body { overflow-y: hidden; }')
							]));
				}),
				A2(
				$author$project$Util$View$viewIf,
				isOpen,
				function (_v3) {
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('recruitment-chat-header')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('recruitment-chat-header-wrapper')
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Util$View$viewIfNot,
										model.S,
										function (_v4) {
											return A2(
												$elm$html$Html$h3,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(model.aa4.avV)
													]));
										}),
										A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												$elm$html$Html$Events$onClick($author$project$RecruitmentChat$ResetChat),
												$elm$html$Html$Attributes$class('recruitment-chat-close-button refresh')
											]),
										_List_fromArray(
											[
												$author$project$View$Icon$viewColored($author$project$View$Icon$path.le)
											])),
										A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												$elm$html$Html$Events$onClick($author$project$RecruitmentChat$HideChatBot),
												$elm$html$Html$Attributes$class('recruitment-chat-close-button')
											]),
										_List_fromArray(
											[
												$author$project$View$Icon$viewColored($author$project$View$Icon$path.auZ)
											]))
									]))
							]));
				}),
				A2(
				$author$project$Util$View$viewIf,
				isOpen,
				function (_v5) {
					return A7(
						$author$project$View$ChatBot$view,
						$author$project$RecruitmentChat$ChatBotMsg,
						model.dp,
						model.Ql,
						model.fV,
						model.S,
						A2($author$project$RecruitmentChat$resolveBotAvatar, model.ape, model.aa4.o2),
						model.qj);
				})
			]));
};
var $author$project$RecruitmentChat$main = A2(
	$author$project$Browser$Custom$elementWithFlags,
	$author$project$RecruitmentChat$decodeFlags,
	{dH: $author$project$RecruitmentChat$init, em: $author$project$RecruitmentChat$subscriptions, ex: $author$project$RecruitmentChat$update, ez: $author$project$RecruitmentChat$view});
var $author$project$View$LocationSearch$Flags = F5(
	function (domainKey, sessionToken, csrfToken, location, tabIndex) {
		return {ci: csrfToken, atF: domainKey, Rs: location, aW: sessionToken, avS: tabIndex};
	});
var $author$project$View$LocationSearch$flagsDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'tabIndex',
	$elm$json$Json$Decode$int,
	0,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'location',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'csrfToken',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'sessionToken',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'domainKey',
					$author$project$Data$Id$decoder,
					$elm$json$Json$Decode$succeed($author$project$View$LocationSearch$Flags))))));
var $author$project$LocationSearch$LocationSearchMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$View$LocationSearch$init = function (flags) {
	var location = A2(
		$elm$core$Maybe$withDefault,
		A3($lydell$elm_app_url$AppUrl$AppUrl, _List_Nil, $elm$core$Dict$empty, $elm$core$Maybe$Nothing),
		A2(
			$elm$core$Maybe$map,
			$lydell$elm_app_url$AppUrl$fromUrl,
			$elm$url$Url$fromString(flags.Rs)));
	return _Utils_Tuple2(
		{
			ci: flags.ci,
			atF: flags.atF,
			Rs: location,
			az: $author$project$View$LocationSuggestions$init,
			aW: $elm$core$Maybe$Just(flags.aW),
			avS: flags.avS
		},
		$elm$core$Platform$Cmd$none);
};
var $author$project$LocationSearch$init = function (flags) {
	var _v0 = $author$project$View$LocationSearch$init(flags);
	var model = _v0.a;
	var cmd = _v0.b;
	return _Utils_Tuple2(
		{P5: model},
		A2($elm$core$Platform$Cmd$map, $author$project$LocationSearch$LocationSearchMsg, cmd));
};
var $author$project$LocationSearch$GotCsrfToken = function (a) {
	return {$: 1, a: a};
};
var $author$project$View$LocationSearch$LocationSuggestionsMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$View$LocationSearch$toUrl = F2(
	function (url, location) {
		return $lydell$elm_app_url$AppUrl$toString(
			_Utils_update(
				url,
				{
					aaG: A3(
						$elm$core$Dict$insert,
						'location',
						_List_fromArray(
							[location]),
						url.aaG)
				}));
	});
var $author$project$View$LocationSearch$locationSuggestionsConfig = function (model) {
	return {
		db: '',
		ci: model.ci,
		dp: model.atF,
		aul: $elm$core$Maybe$Nothing,
		aut: $author$project$View$LocationSearch$LocationSuggestionsMsg,
		avy: 1,
		aW: model.aW,
		avO: $author$project$View$Autocomplete$Http$Link(
			{
				avM: A2(
					$elm$core$Basics$composeL,
					$author$project$View$LocationSearch$toUrl(model.Rs),
					function ($) {
						return $.auy;
					}),
				anl: $elm$core$Maybe$Nothing
			}),
		avS: $elm$core$Maybe$Just(model.avS),
		fX: 'location-suggestion'
	};
};
var $author$project$View$LocationSearch$subscriptions = F2(
	function (lift, model) {
		return A2(
			$elm$core$Platform$Sub$map,
			lift,
			$elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$author$project$View$LocationSuggestions$subscriptions,
						$author$project$View$LocationSearch$locationSuggestionsConfig(model),
						model.az)
					])));
	});
var $author$project$LocationSearch$updateLocationSearchCsrfToken = _Platform_incomingPort('updateLocationSearchCsrfToken', $elm$json$Json$Decode$string);
var $author$project$LocationSearch$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2($author$project$View$LocationSearch$subscriptions, $author$project$LocationSearch$LocationSearchMsg, model.P5),
				$author$project$LocationSearch$updateLocationSearchCsrfToken($author$project$LocationSearch$GotCsrfToken)
			]));
};
var $author$project$View$LocationSearch$setCsrfToken = F2(
	function (token, model) {
		return _Utils_update(
			model,
			{ci: token});
	});
var $author$project$View$LocationSuggestions$autocomplete = function (_v0) {
	var state = _v0;
	return state.al;
};
var $author$project$View$LocationSearch$update = F2(
	function (msg, model) {
		if (!msg.$) {
			var locationParam = A2(
				$elm$core$Maybe$withDefault,
				$author$project$View$Autocomplete$Http$currentInputValue(
					$author$project$View$LocationSuggestions$autocomplete(model.az)),
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.auy;
					},
					$author$project$View$Autocomplete$Http$currentlyFocussedValue(
						$author$project$View$LocationSuggestions$autocomplete(model.az))));
			return _Utils_Tuple2(
				model,
				$elm$browser$Browser$Navigation$load(
					A2($author$project$View$LocationSearch$toUrl, model.Rs, locationParam)));
		} else {
			var locationSuggestionsMsg = msg.a;
			var _v1 = A3(
				$author$project$View$LocationSuggestions$update,
				$author$project$View$LocationSearch$locationSuggestionsConfig(model),
				locationSuggestionsMsg,
				model.az);
			var locationSuggestionsModel = _v1.a;
			var locationSuggestionsCmds = _v1.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{az: locationSuggestionsModel}),
				locationSuggestionsCmds);
		}
	});
var $author$project$LocationSearch$update = F2(
	function (msg, model) {
		if (!msg.$) {
			var subMsg = msg.a;
			var _v1 = A2($author$project$View$LocationSearch$update, subMsg, model.P5);
			var model_ = _v1.a;
			var cmd = _v1.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{P5: model_}),
				A2($elm$core$Platform$Cmd$map, $author$project$LocationSearch$LocationSearchMsg, cmd));
		} else {
			var token = msg.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						P5: A2($author$project$View$LocationSearch$setCsrfToken, token, model.P5)
					}),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$View$LocationSearch$OnSubmit = {$: 0};
var $author$project$View$LocationSearch$view = function (model) {
	var msg = $elm$json$Json$Decode$succeed(
		{bT: $author$project$View$LocationSearch$OnSubmit, avg: true, avG: true});
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('search-bar-content')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$form,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('form-search'),
						A2($elm$html$Html$Events$custom, 'submit', msg)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$View$LocationSuggestions$view,
						$author$project$View$LocationSearch$locationSuggestionsConfig(model),
						model.az),
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$type_('submit'),
								$elm$html$Html$Attributes$tabindex(model.avS + 7),
								$elm$html$Html$Attributes$class('btn btn-submit bg-color-1 color-white')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('label')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text($author$project$Copy$copy.arG)
									]))
							]))
					]))
			]));
};
var $author$project$LocationSearch$view = function (model) {
	return A2(
		$elm$html$Html$map,
		$author$project$LocationSearch$LocationSearchMsg,
		$author$project$View$LocationSearch$view(model.P5));
};
var $author$project$LocationSearch$main = A2(
	$author$project$Browser$Custom$elementWithFlags,
	$author$project$View$LocationSearch$flagsDecoder,
	{dH: $author$project$LocationSearch$init, em: $author$project$LocationSearch$subscriptions, ex: $author$project$LocationSearch$update, ez: $author$project$LocationSearch$view});
var $author$project$Model$Component$KeywordSearch$Flags$Flags = function (totalVacancies) {
	return function (formSubmitPath) {
		return function (domainId) {
			return function (activeSearchFields) {
				return function (filterOptions) {
					return function (sessionToken) {
						return function (csrfToken) {
							return function (location) {
								return function (vacancySearchLocationEnabled) {
									return function (langCode) {
										return function (tabIndex) {
											return function (selectedDrivingMode) {
												return function (selectedMaxTravelTime) {
													return function (selectedLocation) {
														return function (selectedKeywords) {
															return function (isVacancyOverview) {
																return function (renderType) {
																	return {go: activeSearchFields, ci: csrfToken, dp: domainId, eU: filterOptions, Ky: formSubmitPath, O4: isVacancyOverview, Ql: langCode, Rs: location, bm: renderType, agy: selectedDrivingMode, agB: selectedKeywords, agC: selectedLocation, agD: selectedMaxTravelTime, aW: sessionToken, avS: tabIndex, ann: totalVacancies, aq4: vacancySearchLocationEnabled};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Model$DrivingMode$Bike = 1;
var $author$project$Model$DrivingMode$ByFoot = 2;
var $author$project$Model$DrivingMode$Car = 0;
var $author$project$Model$DrivingMode$Transit = 3;
var $author$project$Model$DrivingMode$drivingModeDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'car':
				return $elm$json$Json$Decode$succeed(0);
			case 'bike':
				return $elm$json$Json$Decode$succeed(1);
			case 'by-foot':
				return $elm$json$Json$Decode$succeed(2);
			case 'transit':
				return $elm$json$Json$Decode$succeed(3);
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Model$MaxTravelTime$DoesNotMatter = 4;
var $author$project$Model$MaxTravelTime$FifteenMinutes = 1;
var $author$project$Model$MaxTravelTime$FiveMinutes = 0;
var $author$project$Model$MaxTravelTime$SixtyMinutes = 3;
var $author$project$Model$MaxTravelTime$ThirtyMinutes = 2;
var $author$project$Model$MaxTravelTime$maxTravelTimeDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'five-minutes':
				return $elm$json$Json$Decode$succeed(0);
			case 'fifteen-minutes':
				return $elm$json$Json$Decode$succeed(1);
			case 'thirty-minutes':
				return $elm$json$Json$Decode$succeed(2);
			case 'sixty-minutes':
				return $elm$json$Json$Decode$succeed(3);
			case 'does-not-matter':
				return $elm$json$Json$Decode$succeed(4);
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Model$SearchFields$KeywordAndLocationSearch = 2;
var $author$project$Model$SearchFields$KeywordSearch = 0;
var $author$project$Model$SearchFields$LocationSearch = 1;
var $author$project$Model$SearchFields$searchFieldsDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'keyword-search':
				return $elm$json$Json$Decode$succeed(0);
			case 'location-search':
				return $elm$json$Json$Decode$succeed(1);
			case 'keyword-and-location-search':
				return $elm$json$Json$Decode$succeed(2);
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Model$VacancyListRenderType$GeoMap = 1;
var $author$project$Model$VacancyListRenderType$vacancyListRenderTypeDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'list':
				return $elm$json$Json$Decode$succeed(0);
			case 'geo-map':
				return $elm$json$Json$Decode$succeed(1);
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Model$Component$KeywordSearch$Flags$flagsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'renderType',
	$author$project$Model$VacancyListRenderType$vacancyListRenderTypeDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'isVacancyOverview',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'selectedKeywords',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'selectedLocation',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'selectedMaxTravelTime',
					$elm$json$Json$Decode$nullable($author$project$Model$MaxTravelTime$maxTravelTimeDecoder),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'selectedDrivingMode',
						$elm$json$Json$Decode$nullable($author$project$Model$DrivingMode$drivingModeDecoder),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'tabIndex',
							$elm$json$Json$Decode$int,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'langCode',
								$author$project$Model$LangCode$decoder,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'vacancySearchLocationEnabled',
									$elm$json$Json$Decode$bool,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'location',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'csrfToken',
											$elm$json$Json$Decode$string,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'sessionToken',
												$elm$json$Json$Decode$string,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'filterOptions',
													$elm$json$Json$Decode$list(
														$author$project$Data$Entity$decoder($author$project$Model$VacancyFilterOption$vacancyFilterOptionDecoder)),
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'activeSearchFields',
														$author$project$Model$SearchFields$searchFieldsDecoder,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'domainId',
															$author$project$Data$Id$decoder,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'formSubmitPath',
																$elm$json$Json$Decode$string,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'totalVacancies',
																	$elm$json$Json$Decode$int,
																	$elm$json$Json$Decode$succeed($author$project$Model$Component$KeywordSearch$Flags$Flags))))))))))))))))));
var $author$project$KeywordSearch$KeywordSearchMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$View$KeywordSearch$All = {$: 0};
var $author$project$View$KeywordSearch$WithFilter = function (a) {
	return {$: 1, a: a};
};
var $author$project$View$KeywordSearch$toVisibleTab = function (filterOptions) {
	if (filterOptions.b && (!filterOptions.b.b)) {
		var x = filterOptions.a;
		return $author$project$View$KeywordSearch$WithFilter(x);
	} else {
		return $author$project$View$KeywordSearch$All;
	}
};
var $author$project$View$KeywordSearch$init = function (flags) {
	return _Utils_Tuple2(
		{
			ci: flags.ci,
			dp: flags.dp,
			eU: flags.eU,
			Ky: flags.Ky,
			O4: flags.O4,
			Ql: flags.Ql,
			Rs: $elm$url$Url$fromString(flags.Rs),
			az: $author$project$View$LocationSuggestions$init,
			aP: flags.avS,
			bm: flags.bm,
			aeJ: flags.go,
			agy: flags.agy,
			agB: flags.agB,
			agC: flags.agC,
			agD: flags.agD,
			aW: $elm$core$Maybe$Just(flags.aW),
			ann: flags.ann,
			aj: $author$project$View$Autocomplete$Http$init,
			aq4: flags.aq4,
			o: $author$project$View$KeywordSearch$toVisibleTab(flags.eU)
		},
		$elm$core$Platform$Cmd$none);
};
var $author$project$KeywordSearch$init = function (flags) {
	var _v0 = $author$project$View$KeywordSearch$init(flags);
	var model = _v0.a;
	var cmd = _v0.b;
	return _Utils_Tuple2(
		{P5: model},
		A2($elm$core$Platform$Cmd$map, $author$project$KeywordSearch$KeywordSearchMsg, cmd));
};
var $author$project$KeywordSearch$GotCsrfToken = function (a) {
	return {$: 1, a: a};
};
var $author$project$View$KeywordSearch$UrlChanged = function (a) {
	return {$: 6, a: a};
};
var $author$project$View$KeywordSearch$VacancyAutocompleteMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$View$KeywordSearch$getCurrentKeywords = function (model) {
	var inputValue = $author$project$View$Autocomplete$Http$currentInputValue(model.aj);
	return $elm$core$String$isEmpty(inputValue) ? A2($elm$core$Maybe$withDefault, '', model.agB) : inputValue;
};
var $author$project$View$KeywordSearch$getCurrentLocation = function (model) {
	var inputValue = $author$project$View$Autocomplete$Http$currentInputValue(
		$author$project$View$LocationSuggestions$autocomplete(model.az));
	return $elm$core$String$isEmpty(inputValue) ? A2($elm$core$Maybe$withDefault, '', model.agC) : inputValue;
};
var $author$project$Util$Url$joinPath = function (segments) {
	return A2($elm$url$Url$Builder$absolute, segments, _List_Nil);
};
var $author$project$Model$Suggestion$VacancySuggestion = F4(
	function (vacancyTitle, vacancyId, vacancyPagePath, vacancyCities) {
		return {aqm: vacancyCities, aqL: vacancyId, aq$: vacancyPagePath, b9: vacancyTitle};
	});
var $author$project$Model$Suggestion$vacancySuggestionDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'vacancyCities',
	$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'vacancyPagePath',
		$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'vacancyId',
			$author$project$Data$Id$decoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'vacancyTitle',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Model$Suggestion$VacancySuggestion)))));
var $author$project$View$KeywordSearch$requestVacancySuggestion = F5(
	function (domainId, visibleTab, trackingId, csrfToken, keyword) {
		var params = function () {
			if (!visibleTab.$) {
				return _List_fromArray(
					[
						A2($elm$url$Url$Builder$string, 'keywords', keyword)
					]);
			} else {
				var _v1 = visibleTab.a;
				var filterId = _v1.a;
				return _List_fromArray(
					[
						A2($elm$url$Url$Builder$string, 'keywords', keyword),
						A2(
						$elm$url$Url$Builder$int,
						'f',
						$author$project$Data$Id$toInt(filterId))
					]);
			}
		}();
		return $elm$http$Http$request(
			{
				_: $elm$http$Http$emptyBody,
				aH: A2(
					$elm$http$Http$expectJson,
					$elm$core$Basics$identity,
					A3(
						$elm$json$Json$Decode$map2,
						$elm$core$Tuple$pair,
						A2(
							$elm$json$Json$Decode$index,
							0,
							$elm$json$Json$Decode$list($author$project$Model$Suggestion$vacancySuggestionDecoder)),
						$elm$json$Json$Decode$maybe(
							A2($elm$json$Json$Decode$index, 1, $elm$json$Json$Decode$int)))),
				ax: _List_fromArray(
					[
						A2($elm$http$Http$header, 'X-XSRF-TOKEN', csrfToken)
					]),
				aO: 'GET',
				a_: $elm$core$Maybe$Nothing,
				av3: $elm$core$Maybe$Just(trackingId),
				a0: A2(
					$elm$url$Url$Builder$absolute,
					_List_fromArray(
						[
							'api',
							$author$project$Data$Id$toString(domainId),
							'suggestions',
							'vacancies'
						]),
					params)
			});
	});
var $elm$url$Url$Builder$relative = F2(
	function (pathSegments, parameters) {
		return _Utils_ap(
			A2($elm$core$String$join, '/', pathSegments),
			$elm$url$Url$Builder$toQuery(parameters));
	});
var $author$project$View$KeywordSearch$buildQueryString = function (params) {
	if (!params.b) {
		return '';
	} else {
		return A2(
			$elm$core$String$join,
			'&',
			A2(
				$elm$core$List$map,
				function (_v1) {
					var k = _v1.a;
					var v = _v1.b;
					return k + ('=' + v);
				},
				params));
	}
};
var $author$project$View$KeywordSearch$parseQueryString = function (queryString) {
	var cleaned = A2($elm$core$String$startsWith, '?', queryString) ? A2($elm$core$String$dropLeft, 1, queryString) : (A2($elm$core$String$startsWith, '&', queryString) ? A2($elm$core$String$dropLeft, 1, queryString) : queryString);
	var pairs = A2(
		$elm$core$List$filterMap,
		function (pair) {
			var _v0 = A2($elm$core$String$split, '=', pair);
			if (_v0.b) {
				if (_v0.b.b && (!_v0.b.b.b)) {
					var key = _v0.a;
					var _v1 = _v0.b;
					var value = _v1.a;
					return $elm$core$Maybe$Just(
						_Utils_Tuple2(key, value));
				} else {
					var key = _v0.a;
					var rest = _v0.b;
					return $elm$core$Maybe$Just(
						_Utils_Tuple2(
							key,
							A2($elm$core$String$join, '=', rest)));
				}
			} else {
				return $elm$core$Maybe$Nothing;
			}
		},
		A2($elm$core$String$split, '&', cleaned));
	return pairs;
};
var $author$project$View$KeywordSearch$removeQueryParams = F2(
	function (paramsToRemove, queryString) {
		return $author$project$View$KeywordSearch$buildQueryString(
			A2(
				$elm$core$List$filter,
				function (_v0) {
					var key = _v0.a;
					return !A2($elm$core$List$member, key, paramsToRemove);
				},
				$author$project$View$KeywordSearch$parseQueryString(queryString)));
	});
var $author$project$View$KeywordSearch$removeQueryParam = F2(
	function (param, url) {
		return A2(
			$author$project$View$KeywordSearch$removeQueryParams,
			_List_fromArray(
				[param]),
			url);
	});
var $author$project$View$KeywordSearch$removeSearchQueryParams = function (url) {
	return A2(
		$author$project$View$KeywordSearch$removeQueryParams,
		_List_fromArray(
			['location', 'keywords', 'dm', 'mtt']),
		url);
};
var $author$project$View$KeywordSearch$toUrl = F2(
	function (mLocation, _v0) {
		var keywords = _v0.P6;
		var location = _v0.Rs;
		var formSubmitPath = _v0.Ky;
		var visibleTab = _v0.o;
		var drivingMode = _v0.EC;
		var maxTravelTime = _v0.SD;
		var toExistingParams = function (existingQuery) {
			return (A2($elm$core$String$startsWith, '?', existingQuery) || A2($elm$core$String$startsWith, '&', existingQuery)) ? A2($elm$core$String$dropLeft, 1, existingQuery) : existingQuery;
		};
		var ignoreEmptyString = F2(
			function (f, s) {
				return $elm$core$String$isEmpty(
					$elm$core$String$trim(s)) ? _List_Nil : _List_fromArray(
					[
						f(s)
					]);
			});
		var keywordParam = $elm$core$List$concat(
			_List_fromArray(
				[
					A2(
					ignoreEmptyString,
					$elm$url$Url$Builder$string('location'),
					location),
					A2(
					ignoreEmptyString,
					$elm$url$Url$Builder$string('keywords'),
					keywords),
					function () {
					if (!drivingMode.$) {
						var mode = drivingMode.a;
						return _List_fromArray(
							[
								A2(
								$elm$url$Url$Builder$string,
								'dm',
								$author$project$Data$DrivingMode$toString(mode))
							]);
					} else {
						return _List_Nil;
					}
				}(),
					function () {
					if (!maxTravelTime.$) {
						var time = maxTravelTime.a;
						return _List_fromArray(
							[
								A2(
								$elm$url$Url$Builder$string,
								'mtt',
								$author$project$Data$MaxTravelTime$toString(time))
							]);
					} else {
						return _List_Nil;
					}
				}()
				]));
		var newParams = A2(
			$elm$url$Url$Builder$relative,
			_List_Nil,
			function () {
				if (!visibleTab.$) {
					return keywordParam;
				} else {
					var _v2 = visibleTab.a;
					var filterId = _v2.a;
					return A2(
						$elm$core$List$cons,
						A2(
							$elm$url$Url$Builder$int,
							'f',
							$author$project$Data$Id$toInt(filterId)),
						keywordParam);
				}
			}());
		var emptyParams = $elm$core$String$isEmpty(newParams) ? '' : '{0}&{1}';
		var newQuery = function (existing) {
			return A2(
				$author$project$View$KeywordSearch$removeQueryParam,
				'o',
				A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					emptyParams,
					_List_fromArray(
						[
							newParams,
							$author$project$View$KeywordSearch$removeSearchQueryParams(
							toExistingParams(existing))
						])));
		};
		var finalQuery = function (q) {
			return A2($elm$core$String$startsWith, '?', q) ? A2($elm$core$String$dropLeft, 1, q) : (A2($elm$core$String$startsWith, '&', q) ? A2($elm$core$String$dropLeft, 1, q) : q);
		}(
			A2(
				$elm$core$Maybe$withDefault,
				newParams,
				A2(
					$elm$core$Maybe$map,
					newQuery,
					$elm_community$maybe_extra$Maybe$Extra$join(
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.avk;
							},
							mLocation)))));
		return $elm$core$String$isEmpty(finalQuery) ? formSubmitPath : (formSubmitPath + ('?' + finalQuery));
	});
var $author$project$View$KeywordSearch$maxNamedCities = 2;
var $author$project$View$KeywordSearch$toCityLabel = function (cities) {
	var sorted = A2($elm$core$List$sortBy, $elm$core$String$toLower, cities);
	var named = A2($elm$core$List$take, $author$project$View$KeywordSearch$maxNamedCities, sorted);
	var remaining = $elm$core$List$length(sorted) - $elm$core$List$length(named);
	return $elm$core$List$isEmpty(named) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
		{
			bg: A2($elm$core$String$join, ', ', named),
			bU: (remaining > 0) ? $elm$core$Maybe$Just(remaining) : $elm$core$Maybe$Nothing
		});
};
var $author$project$View$KeywordSearch$toVacancySuggestionLabel = F2(
	function (locationEnabled, suggestion) {
		var titleOnly = {bg: suggestion.b9, bU: $elm$core$Maybe$Nothing};
		return locationEnabled ? A2(
			$elm$core$Maybe$withDefault,
			titleOnly,
			A2(
				$elm$core$Maybe$map,
				function (cityLabel) {
					return {
						bg: A2(
							$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
							'{0} {1} {2}',
							_List_fromArray(
								[suggestion.b9, $author$project$Copy$copy.aq3, cityLabel.bg])),
						bU: cityLabel.bU
					};
				},
				$author$project$View$KeywordSearch$toCityLabel(suggestion.aqm))) : titleOnly;
	});
var $author$project$View$KeywordSearch$viewVacancySuggestionLabel = F2(
	function (locationEnabled, suggestion) {
		var label = A2($author$project$View$KeywordSearch$toVacancySuggestionLabel, locationEnabled, suggestion);
		var _v0 = label.bU;
		if (_v0.$ === 1) {
			return $elm$html$Html$text(label.bg);
		} else {
			var count = _v0.a;
			return A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(label.bg + ' '),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('location-count')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								'+' + $elm$core$String$fromInt(count))
							]))
					]));
		}
	});
var $author$project$View$KeywordSearch$keywordSearchConfig = function (model) {
	var toTotalRoute = F2(
		function (total, inputValue) {
			return {
				adz: A2(
					$author$project$View$KeywordSearch$toUrl,
					model.Rs,
					{
						EC: model.agy,
						Ky: model.Ky,
						P6: inputValue,
						Rs: $author$project$View$KeywordSearch$getCurrentLocation(model),
						SD: model.agD,
						o: model.o
					}),
				avV: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'{0} \"{1}\" ({2})',
					_List_fromArray(
						[
							$author$project$Copy$copy.jh,
							inputValue,
							$elm$core$String$fromInt(total)
						]))
			};
		});
	var id = 'vacancy';
	return {
		eI: $elm$core$Maybe$Nothing,
		dE: id,
		aul: $elm$core$Maybe$Just(
			A2(
				$author$project$View$KeywordSearch$toUrl,
				model.Rs,
				{
					EC: model.agy,
					Ky: model.Ky,
					P6: $author$project$View$KeywordSearch$getCurrentKeywords(model),
					Rs: $author$project$View$KeywordSearch$getCurrentLocation(model),
					SD: model.agD,
					o: model.o
				})),
		aut: $author$project$View$KeywordSearch$VacancyAutocompleteMsg,
		WC: $author$project$Copy$copy.W2,
		d5: $author$project$Copy$copy.aeG,
		ac8: A4($author$project$View$KeywordSearch$requestVacancySuggestion, model.dp, model.o, id, model.ci),
		avO: $author$project$View$Autocomplete$Http$Link(
			{
				avM: A2(
					$elm$core$Basics$composeL,
					$author$project$Util$Url$joinPath,
					function ($) {
						return $.aq$;
					}),
				anl: $elm$core$Maybe$Just(toTotalRoute)
			}),
		avS: $elm$core$Maybe$Just(model.aP + 1),
		am1: function ($) {
			return $.b9;
		},
		cO: $author$project$View$KeywordSearch$viewVacancySuggestionLabel(model.aq4),
		fW: $elm$core$Maybe$Just('all-vacancies'),
		fX: id
	};
};
var $author$project$View$KeywordSearch$LocationSuggestionsMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$View$KeywordSearch$searchFieldsToClass = function (searchFields) {
	switch (searchFields) {
		case 0:
			return 'keyword-search-only';
		case 1:
			return 'location-search-only';
		default:
			return 'keyword-and-location-search';
	}
};
var $author$project$View$KeywordSearch$locationSuggestionsConfig = function (model) {
	var toRoute = function (_v0) {
		var locationDescription = _v0.auy;
		return A2(
			$author$project$View$KeywordSearch$toUrl,
			model.Rs,
			{
				EC: model.agy,
				Ky: model.Ky,
				P6: $author$project$View$KeywordSearch$getCurrentKeywords(model),
				Rs: locationDescription,
				SD: model.agD,
				o: model.o
			});
	};
	return {
		db: $author$project$View$KeywordSearch$searchFieldsToClass(model.aeJ),
		ci: model.ci,
		dp: model.dp,
		aul: (!model.O4) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
			A2(
				$author$project$View$KeywordSearch$toUrl,
				model.Rs,
				{
					EC: model.agy,
					Ky: model.Ky,
					P6: $author$project$View$KeywordSearch$getCurrentKeywords(model),
					Rs: $author$project$View$KeywordSearch$getCurrentLocation(model),
					SD: model.agD,
					o: model.o
				})),
		aut: $author$project$View$KeywordSearch$LocationSuggestionsMsg,
		avy: 1,
		aW: model.aW,
		avO: $author$project$View$Autocomplete$Http$Link(
			{avM: toRoute, anl: $elm$core$Maybe$Nothing}),
		avS: $elm$core$Maybe$Just(model.aP),
		fX: 'location-suggestion'
	};
};
var $author$project$View$KeywordSearch$urlChanged = _Platform_incomingPort('urlChanged', $elm$json$Json$Decode$string);
var $author$project$View$KeywordSearch$subscriptions = F2(
	function (lift, model) {
		return A2(
			$elm$core$Platform$Sub$map,
			lift,
			$elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$author$project$View$Autocomplete$Http$subscriptions,
						$author$project$View$KeywordSearch$keywordSearchConfig(model),
						model.aj),
						A2(
						$author$project$View$LocationSuggestions$subscriptions,
						$author$project$View$KeywordSearch$locationSuggestionsConfig(model),
						model.az),
						$author$project$View$KeywordSearch$urlChanged($author$project$View$KeywordSearch$UrlChanged)
					])));
	});
var $author$project$KeywordSearch$updateKeywordSearchCsrfToken = _Platform_incomingPort('updateKeywordSearchCsrfToken', $elm$json$Json$Decode$string);
var $author$project$KeywordSearch$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2($author$project$View$KeywordSearch$subscriptions, $author$project$KeywordSearch$KeywordSearchMsg, model.P5),
				$author$project$KeywordSearch$updateKeywordSearchCsrfToken($author$project$KeywordSearch$GotCsrfToken)
			]));
};
var $author$project$View$KeywordSearch$setCsrfToken = F2(
	function (token, model) {
		return _Utils_update(
			model,
			{ci: token});
	});
var $author$project$View$Autocomplete$Http$refresh = F3(
	function (lift, config, state) {
		var inputValue = state.ak;
		var autocomplete = state.y;
		switch (autocomplete.$) {
			case 0:
				return A4(
					$author$project$View$Autocomplete$Http$update,
					lift,
					config,
					$author$project$View$Autocomplete$Http$OnInput(inputValue),
					state);
			case 1:
				return A4(
					$author$project$View$Autocomplete$Http$update,
					lift,
					config,
					$author$project$View$Autocomplete$Http$OnInput(inputValue),
					state);
			default:
				return A4($author$project$View$Autocomplete$Http$update, lift, config, $author$project$View$Autocomplete$Http$NoOp, state);
		}
	});
var $author$project$View$KeywordSearch$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var location = A2(
					$elm$core$Maybe$withDefault,
					$author$project$View$KeywordSearch$getCurrentLocation(model),
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.auy;
						},
						$author$project$View$Autocomplete$Http$currentlyFocussedValue(
							$author$project$View$LocationSuggestions$autocomplete(model.az))));
				var _v1 = $author$project$View$Autocomplete$Http$currentlyFocussedValue(model.aj);
				if (!_v1.$) {
					var suggestion = _v1.a;
					return _Utils_Tuple2(
						model,
						$elm$browser$Browser$Navigation$load(
							$author$project$Util$Url$joinPath(suggestion.aq$)));
				} else {
					return _Utils_Tuple2(
						model,
						$elm$browser$Browser$Navigation$load(
							A2(
								$author$project$View$KeywordSearch$toUrl,
								model.Rs,
								{
									EC: model.agy,
									Ky: model.Ky,
									P6: $author$project$View$KeywordSearch$getCurrentKeywords(model),
									Rs: location,
									SD: model.agD,
									o: model.o
								})));
				}
			case 1:
				var tab = msg.a;
				var _v2 = A3(
					$author$project$View$Autocomplete$Http$refresh,
					$author$project$View$KeywordSearch$VacancyAutocompleteMsg,
					$author$project$View$KeywordSearch$keywordSearchConfig(model),
					model.aj);
				var autocompleteState = _v2.a;
				var autocompleteCmds = _v2.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{aj: autocompleteState, o: tab}),
					autocompleteCmds);
			case 2:
				var msg_ = msg.a;
				var _v3 = A4(
					$author$project$View$Autocomplete$Http$update,
					$author$project$View$KeywordSearch$VacancyAutocompleteMsg,
					$author$project$View$KeywordSearch$keywordSearchConfig(model),
					msg_,
					model.aj);
				var autocompleteState = _v3.a;
				var autocompleteCmds = _v3.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							az: $author$project$View$LocationSuggestions$reset(model.az),
							aj: autocompleteState
						}),
					autocompleteCmds);
			case 3:
				var locationSuggestionsMsg = msg.a;
				var _v4 = A3(
					$author$project$View$LocationSuggestions$update,
					$author$project$View$KeywordSearch$locationSuggestionsConfig(model),
					locationSuggestionsMsg,
					model.az);
				var locationSuggestionsModel = _v4.a;
				var locationSuggestionsCmds = _v4.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{az: locationSuggestionsModel}),
					locationSuggestionsCmds);
			case 4:
				var drivingMode = msg.a;
				var updatedModel = _Utils_update(
					model,
					{agy: drivingMode});
				return _Utils_Tuple2(
					updatedModel,
					$elm$browser$Browser$Navigation$load(
						A2(
							$author$project$View$KeywordSearch$toUrl,
							updatedModel.Rs,
							{
								EC: updatedModel.agy,
								Ky: updatedModel.Ky,
								P6: $author$project$View$Autocomplete$Http$currentInputValue(updatedModel.aj),
								Rs: $author$project$View$KeywordSearch$getCurrentLocation(updatedModel),
								SD: updatedModel.agD,
								o: updatedModel.o
							})));
			case 5:
				var maxTravelTime = msg.a;
				var updatedModel = _Utils_update(
					model,
					{agD: maxTravelTime});
				return _Utils_Tuple2(
					updatedModel,
					$elm$browser$Browser$Navigation$load(
						A2(
							$author$project$View$KeywordSearch$toUrl,
							updatedModel.Rs,
							{
								EC: updatedModel.agy,
								Ky: updatedModel.Ky,
								P6: $author$project$View$Autocomplete$Http$currentInputValue(updatedModel.aj),
								Rs: $author$project$View$KeywordSearch$getCurrentLocation(updatedModel),
								SD: updatedModel.agD,
								o: updatedModel.o
							})));
			default:
				var newUrl = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							Rs: $elm$url$Url$fromString(newUrl)
						}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$KeywordSearch$update = F2(
	function (msg, model) {
		if (!msg.$) {
			var subMsg = msg.a;
			var _v1 = A2($author$project$View$KeywordSearch$update, subMsg, model.P5);
			var model_ = _v1.a;
			var cmd = _v1.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{P5: model_}),
				A2($elm$core$Platform$Cmd$map, $author$project$KeywordSearch$KeywordSearchMsg, cmd));
		} else {
			var token = msg.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						P5: A2($author$project$View$KeywordSearch$setCsrfToken, token, model.P5)
					}),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$View$KeywordSearch$OnSubmit = {$: 0};
var $author$project$View$KeywordSearch$viewAndOr = function (model) {
	return A2(
		$author$project$Util$View$viewIfNot,
		model.O4,
		function (_v0) {
			return A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('and-or'),
						$elm$html$Html$Attributes$tabindex(model.aP + 8)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text($author$project$Copy$copy.jC)
					]));
		});
};
var $author$project$Util$View$viewIfList = F2(
	function (bool, html) {
		return bool ? html(0) : _List_Nil;
	});
var $author$project$View$KeywordSearch$viewKeywordSearch = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('form-field')
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Util$View$viewIf,
				model.O4,
				function (_v0) {
					return A2(
						$elm$html$Html$label,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$for('vacancy'),
								$elm$html$Html$Attributes$tabindex(model.aP)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text($author$project$Copy$copy.aeT)
							]));
				}),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('form-field-wrapper', true),
								_Utils_Tuple2(
								$author$project$View$KeywordSearch$searchFieldsToClass(model.aeJ),
								true)
							])),
						$elm$html$Html$Attributes$id('form-field-keyword')
					]),
				_Utils_ap(
					A2(
						$author$project$View$Autocomplete$Http$view,
						$author$project$View$KeywordSearch$keywordSearchConfig(model),
						model.aj),
					A2(
						$author$project$Util$View$viewIfList,
						model.O4,
						function (_v1) {
							return _List_fromArray(
								[
									function () {
									var _v2 = $author$project$View$KeywordSearch$keywordSearchConfig(model).aul;
									if (!_v2.$) {
										var url = _v2.a;
										return A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('visitor-location-btn search'),
													$elm$html$Html$Attributes$href(url),
													$elm$html$Html$Attributes$tabindex(model.aP + 2)
												]),
											_List_fromArray(
												[
													$author$project$View$Icon$viewColored($author$project$View$Icon$path.aeC)
												]));
									} else {
										return $elm$html$Html$text('');
									}
								}()
								]);
						})))
			]));
};
var $author$project$View$KeywordSearch$viewLocationSearch = function (model) {
	var locationLabelTabIndex = function () {
		var _v1 = model.aeJ;
		switch (_v1) {
			case 2:
				return model.aP + 6;
			case 1:
				return model.aP + 3;
			default:
				return model.aP;
		}
	}();
	var locationInputTabIndex = locationLabelTabIndex + 1;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('form-field')
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Util$View$viewIf,
				model.O4,
				function (_v0) {
					return A2(
						$elm$html$Html$label,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$for('location'),
								$elm$html$Html$Attributes$tabindex(locationLabelTabIndex)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text($author$project$Copy$copy.aeQ)
							]));
				}),
				A2(
				$author$project$View$LocationSuggestions$view,
				$author$project$View$KeywordSearch$locationSuggestionsConfig(
					_Utils_update(
						model,
						{aP: locationInputTabIndex})),
				model.az)
			]));
};
var $author$project$View$KeywordSearch$SelectDrivingMode = function (a) {
	return {$: 4, a: a};
};
var $author$project$View$KeywordSearch$SelectMaxTravelTime = function (a) {
	return {$: 5, a: a};
};
var $author$project$Data$DrivingMode$allDrivingModes = _List_fromArray(
	[0, 1, 2, 3]);
var $author$project$Data$MaxTravelTime$allMaxTravelTimes = _List_fromArray(
	[0, 1, 2, 3]);
var $author$project$Data$DrivingMode$drivingModeToString = function (drivingMode) {
	switch (drivingMode) {
		case 0:
			return $author$project$Copy$copy.pN;
		case 1:
			return $author$project$Copy$copy.oT;
		case 3:
			return $author$project$Copy$copy.anA;
		default:
			return $author$project$Copy$copy.pt;
	}
};
var $author$project$View$KeywordSearch$selectDrivingModeFromString = function (str) {
	return $elm$core$String$isEmpty(str) ? $elm$core$Maybe$Nothing : $elm$core$List$head(
		A2(
			$elm$core$List$filter,
			function (mode) {
				return _Utils_eq(
					$author$project$Data$DrivingMode$drivingModeToString(mode),
					str);
			},
			$author$project$Data$DrivingMode$allDrivingModes));
};
var $author$project$Data$MaxTravelTime$maxTravelTimeToMinutes = function (maxTravelTime) {
	switch (maxTravelTime) {
		case 0:
			return 5;
		case 1:
			return 15;
		case 2:
			return 30;
		case 3:
			return 60;
		default:
			return 2147483647;
	}
};
var $author$project$View$KeywordSearch$selectMaxTravelTimeFromString = function (str) {
	return $elm$core$String$isEmpty(str) ? $elm$core$Maybe$Nothing : ((str === 'does-not-matter') ? $elm$core$Maybe$Just(4) : A2(
		$elm$core$Maybe$andThen,
		function (minutes) {
			return $elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (time) {
						return _Utils_eq(
							$author$project$Data$MaxTravelTime$maxTravelTimeToMinutes(time),
							minutes);
					},
					$author$project$Data$MaxTravelTime$allMaxTravelTimes));
		},
		$elm$core$String$toInt(str)));
};
var $author$project$View$KeywordSearch$viewDrivingModeOption = F2(
	function (selected, mode) {
		return A2(
			$elm$html$Html$option,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$value(
					$author$project$Data$DrivingMode$drivingModeToString(mode)),
					$elm$html$Html$Attributes$selected(
					_Utils_eq(
						selected,
						$elm$core$Maybe$Just(mode)))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Data$DrivingMode$drivingModeToString(mode))
				]));
	});
var $author$project$Data$MaxTravelTime$maxTravelTimeToString = function (maxTravelTime) {
	switch (maxTravelTime) {
		case 0:
			return $author$project$Copy$copy.Is;
		case 1:
			return $author$project$Copy$copy.HA;
		case 2:
			return $author$project$Copy$copy.amO;
		case 3:
			return $author$project$Copy$copy.aip;
		default:
			return $author$project$Copy$copy.jM;
	}
};
var $author$project$View$KeywordSearch$viewMaxTravelTimeOption = F2(
	function (selected, time) {
		return A2(
			$elm$html$Html$option,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$value(
					$elm$core$String$fromInt(
						$author$project$Data$MaxTravelTime$maxTravelTimeToMinutes(time))),
					$elm$html$Html$Attributes$selected(
					_Utils_eq(
						selected,
						$elm$core$Maybe$Just(time)))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Data$MaxTravelTime$maxTravelTimeToString(time))
				]));
	});
var $author$project$View$KeywordSearch$viewTravelTimeSelects = function (model) {
	return A2(
		$author$project$Util$View$viewIf,
		model.O4,
		function (_v0) {
			var _v1 = _Utils_Tuple2(model.agC, model.bm);
			if ((!_v1.a.$) && (_v1.b === 1)) {
				var _v2 = _v1.b;
				var travelTimeLabelTabIndex = function () {
					var _v3 = model.aeJ;
					switch (_v3) {
						case 2:
							return model.aP + 3;
						case 1:
							return model.aP;
						default:
							return model.aP;
					}
				}();
				var travelTimeSelect1TabIndex = travelTimeLabelTabIndex + 1;
				var travelTimeSelect2TabIndex = travelTimeLabelTabIndex + 2;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('form-field travel-time-selects')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$for('travel-time-selects'),
									$elm$html$Html$Attributes$tabindex(travelTimeLabelTabIndex)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text($author$project$Copy$copy.af_)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('form-row')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('custom-select')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$select,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$id('driving-mode-select'),
													$elm$html$Html$Attributes$tabindex(travelTimeSelect1TabIndex),
													$elm$html$Html$Events$onInput(
													A2($elm$core$Basics$composeR, $author$project$View$KeywordSearch$selectDrivingModeFromString, $author$project$View$KeywordSearch$SelectDrivingMode))
												]),
											A2(
												$elm$core$List$map,
												$author$project$View$KeywordSearch$viewDrivingModeOption(model.agy),
												$author$project$Data$DrivingMode$allDrivingModes))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('custom-select')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$select,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$id('max-travel-time-select'),
													$elm$html$Html$Attributes$tabindex(travelTimeSelect2TabIndex),
													$elm$html$Html$Events$onInput(
													A2($elm$core$Basics$composeR, $author$project$View$KeywordSearch$selectMaxTravelTimeFromString, $author$project$View$KeywordSearch$SelectMaxTravelTime))
												]),
											A2(
												$elm$core$List$cons,
												A2(
													$elm$html$Html$option,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$value('does-not-matter'),
															$elm$html$Html$Attributes$selected(
															_Utils_eq(
																model.agD,
																$elm$core$Maybe$Just(4)))
														]),
													_List_fromArray(
														[
															$elm$html$Html$text($author$project$Copy$copy.jM)
														])),
												A2(
													$elm$core$List$map,
													$author$project$View$KeywordSearch$viewMaxTravelTimeOption(model.agD),
													$author$project$Data$MaxTravelTime$allMaxTravelTimes)))
										]))
								]))
						]));
			} else {
				return $elm$html$Html$text('');
			}
		});
};
var $author$project$View$KeywordSearch$viewFormSearch = function (model) {
	var msg = $elm$json$Json$Decode$succeed(
		{bT: $author$project$View$KeywordSearch$OnSubmit, avg: true, avG: true});
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$form,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('form-search'),
					A2($elm$html$Html$Events$custom, 'submit', msg)
				]),
			$elm$core$List$concat(
				_List_fromArray(
					[
						function () {
						var _v0 = model.aeJ;
						switch (_v0) {
							case 0:
								return _List_fromArray(
									[
										$author$project$View$KeywordSearch$viewKeywordSearch(model)
									]);
							case 1:
								return _List_fromArray(
									[
										$author$project$View$KeywordSearch$viewTravelTimeSelects(model),
										$author$project$View$KeywordSearch$viewLocationSearch(model)
									]);
							default:
								return _List_fromArray(
									[
										$author$project$View$KeywordSearch$viewKeywordSearch(model),
										$author$project$View$KeywordSearch$viewTravelTimeSelects(model),
										$author$project$View$KeywordSearch$viewAndOr(model),
										$author$project$View$KeywordSearch$viewLocationSearch(model)
									]);
						}
					}(),
						A2(
						$author$project$Util$View$viewIfList,
						!model.O4,
						function (_v1) {
							return _List_fromArray(
								[
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$type_('submit'),
											$elm$html$Html$Attributes$class('btn btn-submit bg-color-1 color-white'),
											$elm$html$Html$Attributes$tabindex(model.aP + 20)
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('label')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text($author$project$Copy$copy.arG)
												]))
										]))
								]);
						})
					])))
		]);
};
var $author$project$View$KeywordSearch$ShowTab = function (a) {
	return {$: 1, a: a};
};
var $author$project$View$KeywordSearch$viewAmount = function (amount) {
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('amount')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(
				A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'({0})',
					_List_fromArray(
						[
							$elm$core$String$fromInt(amount)
						])))
			]));
};
var $author$project$View$KeywordSearch$viewTabSelectButton = F5(
	function (langCode, totalVacancies, tIndex, selectedTab, tab) {
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('btn'),
					$elm$html$Html$Events$onClick(
					$author$project$View$KeywordSearch$ShowTab(tab)),
					$elm$html$Html$Attributes$tabindex(tIndex),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'selected',
							_Utils_eq(selectedTab, tab))
						]))
				]),
			function () {
				if (!tab.$) {
					return _List_fromArray(
						[
							$elm$html$Html$text($author$project$Copy$copy.jg),
							$author$project$View$KeywordSearch$viewAmount(totalVacancies)
						]);
				} else {
					var _v1 = tab.a;
					var filter = _v1.b;
					return _List_fromArray(
						[
							$elm$html$Html$text(
							A2($author$project$Data$VacancyFilterOptionValue$toText, langCode, filter.ey)),
							$author$project$View$KeywordSearch$viewAmount(
							$elm$core$List$length(filter.awj))
						]);
				}
			}());
	});
var $author$project$View$KeywordSearch$viewTabSelect = F5(
	function (langCode, totalVacancies, visibleTab, filterOptions, tabIndex) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('banner-search-tabs')
				]),
			$elm$core$List$concat(
				_List_fromArray(
					[
						_List_fromArray(
						[
							A5($author$project$View$KeywordSearch$viewTabSelectButton, langCode, totalVacancies, tabIndex, visibleTab, $author$project$View$KeywordSearch$All)
						]),
						A2(
						$elm$core$List$indexedMap,
						F2(
							function (i, v) {
								return A5(
									$author$project$View$KeywordSearch$viewTabSelectButton,
									langCode,
									totalVacancies,
									(tabIndex + i) + 1,
									visibleTab,
									$author$project$View$KeywordSearch$WithFilter(v));
							}),
						filterOptions)
					])));
	});
var $author$project$View$KeywordSearch$view = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('search-bar-content')
			]),
		$elm$core$List$concat(
			_List_fromArray(
				[
					($elm$core$List$length(model.eU) <= 1) ? _List_Nil : _List_fromArray(
					[
						A5($author$project$View$KeywordSearch$viewTabSelect, model.Ql, model.ann, model.o, model.eU, model.aP)
					]),
					$author$project$View$KeywordSearch$viewFormSearch(model)
				])));
};
var $author$project$KeywordSearch$view = function (model) {
	return A2(
		$elm$html$Html$map,
		$author$project$KeywordSearch$KeywordSearchMsg,
		$author$project$View$KeywordSearch$view(model.P5));
};
var $author$project$KeywordSearch$main = A2(
	$author$project$Browser$Custom$elementWithFlags,
	$author$project$Model$Component$KeywordSearch$Flags$flagsDecoder,
	{dH: $author$project$KeywordSearch$init, em: $author$project$KeywordSearch$subscriptions, ex: $author$project$KeywordSearch$update, ez: $author$project$KeywordSearch$view});
var $author$project$JobAlertForm$Flags = function (privacyPath) {
	return function (postPath) {
		return function (filters) {
			return function (showLocationFields) {
				return function (email) {
					return function (introduction) {
						return function (domainId) {
							return function (windowWidth) {
								return function (sessionToken) {
									return function (csrfToken) {
										return function (translations) {
											return function (langCode) {
												return function (useDifferentDisciplineLabel) {
													return function (minTabIndex) {
														return function (preselectedOptions) {
															return {ci: csrfToken, dp: domainId, eR: email, If: filters, cw: introduction, Ql: langCode, aP: minTabIndex, d7: postPath, $U: preselectedOptions, cG: privacyPath, aW: sessionToken, ahU: showLocationFields, anB: translations, cV: useDifferentDisciplineLabel, cX: windowWidth};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$JobAlertForm$decodeFlags = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'preselectedOptions',
	$elm$json$Json$Decode$list($author$project$Data$Id$decoder),
	_List_Nil,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'minTabIndex',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'useDifferentDisciplineLabel',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'langCode',
				$author$project$Model$LangCode$decoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'translations',
					A2(
						$elm$json$Json$Decode$map,
						$elm$core$Basics$identity,
						$elm$json$Json$Decode$dict($elm$json$Json$Decode$string)),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'csrfToken',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'sessionToken',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'windowWidth',
								$author$project$Browser$Dom$Breakpoint$windowWidthDecoder,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'domainId',
									$author$project$Data$Id$decoder,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'introduction',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'email',
											$elm$json$Json$Decode$string,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'showLocationFields',
												$elm$json$Json$Decode$bool,
												A3(
													$elm$core$Basics$apL,
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required('filters'),
													$elm$json$Json$Decode$list(
														A3(
															$elm$json$Json$Decode$map2,
															$elm$core$Tuple$pair,
															A2(
																$elm$json$Json$Decode$index,
																0,
																$author$project$Data$Entity$decoder($author$project$Model$VacancyFilter$vacancyFilterDecoder)),
															A2(
																$elm$json$Json$Decode$index,
																1,
																$elm$json$Json$Decode$list(
																	A3(
																		$elm$json$Json$Decode$map2,
																		$elm$core$Tuple$pair,
																		A2($elm$json$Json$Decode$index, 0, $elm$json$Json$Decode$string),
																		A2(
																			$elm$json$Json$Decode$index,
																			1,
																			$elm$json$Json$Decode$list(
																				$author$project$Data$Entity$decoder($author$project$Model$VacancyFilterOption$vacancyFilterOptionDecoder)))))))),
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'postPath',
														$elm$json$Json$Decode$string,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'privacyPath',
															$elm$json$Json$Decode$string,
															$elm$json$Json$Decode$succeed($author$project$JobAlertForm$Flags))))))))))))))));
var $elm_community$list_extra$List$Extra$findMap = F2(
	function (f, list) {
		findMap:
		while (true) {
			if (!list.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var a = list.a;
				var tail = list.b;
				var _v1 = f(a);
				if (!_v1.$) {
					var b = _v1.a;
					return $elm$core$Maybe$Just(b);
				} else {
					var $temp$f = f,
						$temp$list = tail;
					f = $temp$f;
					list = $temp$list;
					continue findMap;
				}
			}
		}
	});
var $author$project$JobAlertForm$findGroupContaining = F2(
	function (targetId, filters) {
		return A2(
			$elm_community$list_extra$List$Extra$findMap,
			function (_v0) {
				var _v1 = _v0.a;
				var filterId = _v1.a;
				var groups = _v0.b;
				return A2(
					$elm_community$list_extra$List$Extra$findMap,
					function (_v2) {
						var label = _v2.a;
						var options = _v2.b;
						return A2(
							$elm$core$List$any,
							function (_v3) {
								var optId = _v3.a;
								return _Utils_eq(optId, targetId);
							},
							options) ? $elm$core$Maybe$Just(
							_Utils_Tuple3(
								filterId,
								label,
								A2($elm$core$List$map, $author$project$Data$Entity$id, options))) : $elm$core$Maybe$Nothing;
					},
					groups);
			},
			filters);
	});
var $author$project$JobAlertForm$insertIfNew = F4(
	function (filterId, label, optionIds, acc) {
		var existing = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2($author$project$Dict$Custom$get, filterId, acc));
		var alreadyExists = A2(
			$elm$core$List$any,
			function (_v0) {
				var lbl = _v0.a;
				return _Utils_eq(lbl, label);
			},
			existing);
		return alreadyExists ? acc : A3(
			$author$project$Dict$Custom$insert,
			filterId,
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(label, optionIds),
				existing),
			acc);
	});
var $author$project$JobAlertForm$addPreselection = F3(
	function (filters, preselectedId, acc) {
		return A2(
			$elm$core$Maybe$withDefault,
			acc,
			A2(
				$elm$core$Maybe$map,
				function (_v0) {
					var filterId = _v0.a;
					var displayLabel = _v0.b;
					var optionIds = _v0.c;
					return A4($author$project$JobAlertForm$insertIfNew, filterId, displayLabel, optionIds, acc);
				},
				A2($author$project$JobAlertForm$findGroupContaining, preselectedId, filters)));
	});
var $author$project$JobAlertForm$initPreselectedFilters = F2(
	function (filters, preselectedOptions) {
		return A3(
			$elm$core$List$foldl,
			$author$project$JobAlertForm$addPreselection(filters),
			$author$project$Data$Id$emptyDict,
			preselectedOptions);
	});
var $author$project$JobAlertForm$init = function (flags) {
	return _Utils_Tuple2(
		{
			bz: false,
			ch: false,
			ci: flags.ci,
			dp: flags.dp,
			If: flags.If,
			IF: {
				Ed: 20,
				eR: flags.eR,
				If: A2($author$project$JobAlertForm$initPreselectedFilters, flags.If, flags.$U),
				Ip: '',
				ct: $elm$core$Maybe$Nothing,
				Qx: '',
				Rs: A5($author$project$Model$Suggestion$LocationSuggestion, '', $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing),
				cF: false
			},
			cw: flags.cw,
			Ql: flags.Ql,
			az: $author$project$View$LocationSuggestions$init,
			aP: flags.aP,
			d7: flags.d7,
			cG: flags.cG,
			aW: $elm$core$Maybe$Just(flags.aW),
			ahU: flags.ahU,
			anB: flags.anB,
			cV: flags.cV,
			cX: flags.cX
		},
		$elm$core$Platform$Cmd$none);
};
var $author$project$JobAlertForm$GotCsrfToken = function (a) {
	return {$: 6, a: a};
};
var $author$project$JobAlertForm$LocationSuggestionsMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$JobAlertForm$SetLocationSuggestion = function (a) {
	return {$: 2, a: a};
};
var $author$project$JobAlertForm$locationSuggestionsConfig = F4(
	function (domainId, sessionToken, csrfToken, tabIndex) {
		return {
			db: '',
			ci: csrfToken,
			dp: domainId,
			aul: $elm$core$Maybe$Nothing,
			aut: $author$project$JobAlertForm$LocationSuggestionsMsg,
			avy: 1,
			aW: sessionToken,
			avO: $author$project$View$Autocomplete$Http$Button(
				{avN: $author$project$JobAlertForm$SetLocationSuggestion, av2: $elm$core$Maybe$Nothing}),
			avS: $elm$core$Maybe$Just(tabIndex),
			fX: 'location-search-job-alert'
		};
	});
var $author$project$JobAlertForm$updateJobAlertCsrfToken = _Platform_incomingPort('updateJobAlertCsrfToken', $elm$json$Json$Decode$string);
var $author$project$JobAlertForm$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$author$project$View$LocationSuggestions$subscriptions,
				A4($author$project$JobAlertForm$locationSuggestionsConfig, model.dp, model.aW, model.ci, model.aP),
				model.az),
				$author$project$JobAlertForm$updateJobAlertCsrfToken($author$project$JobAlertForm$GotCsrfToken)
			]));
};
var $author$project$JobAlertForm$GotSendJobAlertForm = function (a) {
	return {$: 5, a: a};
};
var $author$project$Dict$Custom$toList = function (_v0) {
	var g = _v0.b;
	var dict = _v0.c;
	var cons = F3(
		function (k, v, acc) {
			return A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					g(k),
					v),
				acc);
		});
	return A3($elm$core$Dict$foldr, cons, _List_Nil, dict);
};
var $author$project$JobAlertForm$toOptionList = A2(
	$elm$core$Basics$composeL,
	$elm$core$List$concatMap(
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Tuple$second,
			$elm$core$List$concatMap($elm$core$Tuple$second))),
	$author$project$Dict$Custom$toList);
var $author$project$JobAlertForm$encode = function (form) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'email',
				$elm$json$Json$Encode$string(form.eR)),
				_Utils_Tuple2(
				'firstName',
				$elm$json$Json$Encode$string(form.Ip)),
				_Utils_Tuple2(
				'lastName',
				$elm$json$Json$Encode$string(form.Qx)),
				_Utils_Tuple2(
				'honeypot',
				A3($elm_community$maybe_extra$Maybe$Extra$unwrap, $elm$json$Json$Encode$null, $elm$json$Json$Encode$string, form.ct)),
				_Utils_Tuple2(
				'latitude',
				A3($elm_community$maybe_extra$Maybe$Extra$unwrap, $elm$json$Json$Encode$null, $elm$json$Json$Encode$float, form.Rs.QE)),
				_Utils_Tuple2(
				'longitude',
				A3($elm_community$maybe_extra$Maybe$Extra$unwrap, $elm$json$Json$Encode$null, $elm$json$Json$Encode$float, form.Rs.RZ)),
				_Utils_Tuple2(
				'options',
				A2(
					$elm$json$Json$Encode$list,
					$author$project$Data$Id$encode,
					$author$project$JobAlertForm$toOptionList(form.If))),
				_Utils_Tuple2(
				'privacy',
				$elm$json$Json$Encode$bool(form.cF)),
				_Utils_Tuple2(
				'distanceInKm',
				$elm$json$Json$Encode$int(form.Ed))
			]));
};
var $author$project$Api$Endpoint$jobAlertForm = function (domainId) {
	return $author$project$Api$Endpoint$endpoint(
		_List_fromArray(
			[
				$author$project$Data$Id$toString(domainId),
				'job-alert'
			]));
};
var $author$project$Api$postWithHeader = F4(
	function (url, headers, body, decoder) {
		return $author$project$Api$Endpoint$requestLegacy(
			{
				_: body,
				aH: $NoRedInk$http_upgrade_shim$Http$Legacy$expectJson(decoder),
				ax: A2(
					$elm$core$List$map,
					function (_v0) {
						var k = _v0.a;
						var v = _v0.b;
						return A2($NoRedInk$http_upgrade_shim$Http$Legacy$header, k, v);
					},
					headers),
				aO: 'POST',
				a_: $elm$core$Maybe$Nothing,
				a0: url,
				bx: false
			});
	});
var $author$project$JobAlertForm$postData = F3(
	function (domainK, csrfToken, form) {
		return A2(
			$author$project$Api$send,
			$author$project$JobAlertForm$GotSendJobAlertForm,
			A4(
				$author$project$Api$postWithHeader,
				$author$project$Api$Endpoint$jobAlertForm(domainK),
				_List_fromArray(
					[
						_Utils_Tuple2('X-XSRF-TOKEN', csrfToken)
					]),
				$elm$http$Http$jsonBody(
					$author$project$JobAlertForm$encode(form)),
				$author$project$Model$RedirectUrl$redirectUrlDecoder));
	});
var $author$project$JobAlertForm$requestJobAlertCsrfToken = _Platform_outgoingPort('requestJobAlertCsrfToken', $elm$json$Json$Encode$bool);
var $author$project$JobAlertForm$update = F2(
	function (msg, model) {
		var form = model.IF;
		switch (msg.$) {
			case 0:
				var form_ = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{IF: form_}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var locationSuggestionsMsg = msg.a;
				var _v1 = A3(
					$author$project$View$LocationSuggestions$update,
					A4($author$project$JobAlertForm$locationSuggestionsConfig, model.dp, model.aW, model.ci, model.aP),
					locationSuggestionsMsg,
					model.az);
				var locationSuggestionsModel = _v1.a;
				var locationSuggestionsCmds = _v1.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{az: locationSuggestionsModel}),
					locationSuggestionsCmds);
			case 2:
				var suggestion = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							IF: _Utils_update(
								form,
								{Rs: suggestion}),
							az: $author$project$View$LocationSuggestions$reset(model.az)
						}),
					$elm$core$Platform$Cmd$none);
			case 3:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							IF: _Utils_update(
								form,
								{
									Rs: A5($author$project$Model$Suggestion$LocationSuggestion, '', $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing)
								})
						}),
					$elm$core$Platform$Cmd$none);
			case 4:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bz: true, ch: false}),
					$author$project$JobAlertForm$requestJobAlertCsrfToken(true));
			case 5:
				if (!msg.a.$) {
					var unRedirectUrl = msg.a.a.av7;
					return _Utils_Tuple2(
						model,
						$elm$browser$Browser$Navigation$load(unRedirectUrl));
				} else {
					var err = msg.a.a;
					return ($author$project$Api$isForbiddenHttp(err) && (!model.ch)) ? _Utils_Tuple2(
						_Utils_update(
							model,
							{bz: true, ch: true}),
						$author$project$JobAlertForm$requestJobAlertCsrfToken(true)) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			default:
				var rawToken = msg.a;
				var token = A2($author$project$Api$csrfTokenWithDefault, model.ci, rawToken);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bz: false, ci: token}),
					model.bz ? A3($author$project$JobAlertForm$postData, model.dp, token, model.IF) : $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$JobAlertForm$ClearLocation = {$: 3};
var $author$project$JobAlertForm$SendJobAlertForm = {$: 4};
var $author$project$JobAlertForm$UpdateForm = function (a) {
	return {$: 0, a: a};
};
var $author$project$View$Autocomplete$Http$autocompleteStateIsKnown = function (_v0) {
	var state = _v0;
	var _v1 = state.y;
	if (_v1.$ === 3) {
		return false;
	} else {
		return true;
	}
};
var $author$project$View$LocationSuggestions$autocompleteStateIsKnown = A2($elm$core$Basics$composeL, $author$project$View$Autocomplete$Http$autocompleteStateIsKnown, $author$project$View$LocationSuggestions$autocomplete);
var $author$project$JobAlertForm$calcTabIndexFilter = F3(
	function (filters, minTabIndex, i) {
		var previousFilters = A2($elm$core$List$take, i, filters);
		var countTabIndices = function (_v0) {
			var options = _v0.b;
			return 1 + ($elm$core$List$length(options) * 2);
		};
		var totalPreviousTabIndices = $elm$core$List$sum(
			A2($elm$core$List$map, countTabIndices, previousFilters));
		return minTabIndex + totalPreviousTabIndices;
	});
var $elm$html$Html$Attributes$multiple = $elm$html$Html$Attributes$boolProperty('multiple');
var $author$project$Component$Form$Checkbox$name = function (val_) {
	return $author$project$Component$Form$Checkbox$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{
					dY: $elm$core$Maybe$Just(val_)
				});
		});
};
var $author$project$Component$Form$NumberInput$name = function (name_) {
	return $author$project$Component$Form$NumberInput$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{
					dY: $elm$core$Maybe$Just(name_)
				});
		});
};
var $author$project$Component$Form$TextInput$name = function (name_) {
	return $author$project$Component$Form$TextInput$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{
					dY: $elm$core$Maybe$Just(name_)
				});
		});
};
var $author$project$Util$Decode$decodeEventObject = F2(
	function (keys, decoder) {
		return A2(
			$elm$json$Json$Decode$map,
			$elm$core$List$map($elm$core$Tuple$second),
			A2(
				$elm$json$Json$Decode$at,
				keys,
				$elm$json$Json$Decode$keyValuePairs(
					A2($elm$json$Json$Decode$field, 'value', decoder))));
	});
var $author$project$JobAlertForm$findGroupedOption = F2(
	function (displayLabels, _v0) {
		var filterOptions = _v0.b;
		return A2(
			$elm$core$List$filter,
			A2(
				$elm$core$Basics$composeL,
				A2($author$project$Util$Base$flip, $elm$core$List$member, displayLabels),
				$elm$core$Tuple$first),
			filterOptions);
	});
var $elm_community$maybe_extra$Maybe$Extra$toList = function (m) {
	if (m.$ === 1) {
		return _List_Nil;
	} else {
		var x = m.a;
		return _List_fromArray(
			[x]);
	}
};
var $author$project$JobAlertForm$findGroupedOptions = F3(
	function (filterId, filters, displayLabels) {
		return A2(
			$elm$core$List$map,
			function (_v0) {
				var a = _v0.a;
				var b = _v0.b;
				return _Utils_Tuple2(
					a,
					A2($elm$core$List$map, $author$project$Data$Entity$id, b));
			},
			$elm$core$List$concat(
				$elm_community$maybe_extra$Maybe$Extra$toList(
					A2(
						$elm$core$Maybe$map,
						$author$project$JobAlertForm$findGroupedOption(displayLabels),
						A2(
							$elm_community$list_extra$List$Extra$find,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$Tuple$first,
								A2(
									$elm$core$Basics$composeR,
									$author$project$Data$Entity$id,
									$elm$core$Basics$eq(filterId))),
							filters)))));
	});
var $author$project$JobAlertForm$onOptionSelect = F3(
	function (filterId, form, filters) {
		var groupedOptions = A2($author$project$JobAlertForm$findGroupedOptions, filterId, filters);
		var updateFilters = function (displayLabels) {
			return $author$project$JobAlertForm$UpdateForm(
				_Utils_update(
					form,
					{
						If: A3(
							$author$project$Dict$Custom$insert,
							filterId,
							groupedOptions(displayLabels),
							form.If)
					}));
		};
		var decodeMulti = A2(
			$author$project$Util$Decode$decodeEventObject,
			_List_fromArray(
				['target', 'selectedOptions']),
			$elm$json$Json$Decode$string);
		return A2(
			$elm$html$Html$Events$on,
			'change',
			A2($elm$json$Json$Decode$map, updateFilters, decodeMulti));
	});
var $author$project$Component$Form$NumberInput$required = $author$project$Component$Form$NumberInput$set(
	function (attributes) {
		return _Utils_update(
			attributes,
			{eb: true});
	});
var $author$project$Component$Form$TextInput$required = function (required_) {
	return $author$project$Component$Form$TextInput$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{eb: required_});
		});
};
var $author$project$Component$Form$NumberInput$tabindex = function (i) {
	return $author$project$Component$Form$NumberInput$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{
					eq: $elm$core$Maybe$Just(i)
				});
		});
};
var $author$project$JobAlertForm$viewCheckbox = F4(
	function (form, filterId, tabIndex, _v0) {
		var displayLabel = _v0.a;
		var groupedOptions = _v0.b;
		var toggleFilterOption = function (options) {
			return A2(
				$elm$core$List$member,
				displayLabel,
				A2($elm$core$List$map, $elm$core$Tuple$first, options)) ? A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeL,
					$elm$core$Basics$neq(displayLabel),
					$elm$core$Tuple$first),
				options) : A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					displayLabel,
					A2($elm$core$List$map, $author$project$Data$Entity$id, groupedOptions)),
				options);
		};
		var getOptions = A2($author$project$Dict$Custom$get, filterId, form.If);
		var addOption = A2(
			$elm$core$Maybe$withDefault,
			_List_fromArray(
				[
					_Utils_Tuple2(
					displayLabel,
					A2($elm$core$List$map, $author$project$Data$Entity$id, groupedOptions))
				]),
			A2($elm$core$Maybe$map, toggleFilterOption, getOptions));
		var updateOptions = function (_v1) {
			return $author$project$JobAlertForm$UpdateForm(
				_Utils_update(
					form,
					{
						If: A3($author$project$Dict$Custom$insert, filterId, addOption, form.If)
					}));
		};
		return A2(
			$author$project$Component$Form$Checkbox$view,
			displayLabel,
			_List_fromArray(
				[
					$author$project$Component$Form$Checkbox$name('options'),
					$author$project$Component$Form$Checkbox$tabindex(tabIndex),
					$author$project$Component$Form$Checkbox$onCheck(updateOptions),
					$author$project$Component$Form$Checkbox$checked(
					A2(
						$elm$core$Maybe$withDefault,
						false,
						A2(
							$elm$core$Maybe$map,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$List$map($elm$core$Tuple$first),
								$elm$core$List$member(displayLabel)),
							getOptions)))
				]));
	});
var $author$project$JobAlertForm$view = function (model) {
	var form = model.IF;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('job-alert-form')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('intro-job-alert')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text text-align-left'),
								$elm$html$Html$Attributes$tabindex(model.aP)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(model.cw)
							]))
					])),
				A2(
				$elm$html$Html$form,
				_List_fromArray(
					[
						$elm$html$Html$Events$onSubmit($author$project$JobAlertForm$SendJobAlertForm),
						$elm$html$Html$Attributes$class('form')
					]),
				$elm$core$List$concat(
					_List_fromArray(
						[
							_List_fromArray(
							[
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$type_('hidden'),
										$elm$html$Html$Attributes$name('_token'),
										$elm$html$Html$Attributes$value(model.ci)
									]),
								_List_Nil)
							]),
							_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('form-row')
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Component$Form$TextInput$view,
										'',
										_List_fromArray(
											[
												$author$project$Component$Form$TextInput$id('first-name'),
												$author$project$Component$Form$TextInput$placeholder($author$project$Copy$copy.Ip),
												$author$project$Component$Form$TextInput$onInput(
												function (v) {
													return $author$project$JobAlertForm$UpdateForm(
														_Utils_update(
															form,
															{Ip: v}));
												}),
												$author$project$Component$Form$TextInput$value(form.Ip),
												$author$project$Component$Form$TextInput$name('first_name'),
												$author$project$Component$Form$TextInput$icon($author$project$View$Icon$path.au9),
												$author$project$Component$Form$TextInput$required(true),
												$author$project$Component$Form$TextInput$tabindex(model.aP + 1)
											])),
										A2(
										$author$project$Component$Form$TextInput$view,
										'',
										_List_fromArray(
											[
												$author$project$Component$Form$TextInput$id('last-name'),
												$author$project$Component$Form$TextInput$placeholder($author$project$Copy$copy.Qx),
												$author$project$Component$Form$TextInput$onInput(
												function (v) {
													return $author$project$JobAlertForm$UpdateForm(
														_Utils_update(
															form,
															{Qx: v}));
												}),
												$author$project$Component$Form$TextInput$value(form.Qx),
												$author$project$Component$Form$TextInput$name('last_name'),
												$author$project$Component$Form$TextInput$required(true),
												$author$project$Component$Form$TextInput$tabindex(model.aP + 2)
											]))
									])),
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$autocomplete(false),
										$elm$html$Html$Attributes$name('password'),
										A2($elm$html$Html$Attributes$attribute, 'style', 'display:none !important'),
										A2($elm$html$Html$Attributes$attribute, 'tabindex', '-1'),
										$elm$html$Html$Attributes$type_('text'),
										$elm$html$Html$Attributes$value(
										A2($elm$core$Maybe$withDefault, '', form.ct)),
										$elm$html$Html$Events$onInput(
										function (v) {
											return $author$project$JobAlertForm$UpdateForm(
												_Utils_update(
													form,
													{
														ct: $elm$core$Maybe$Just(v)
													}));
										})
									]),
								_List_Nil),
								A2(
								$author$project$Component$Form$TextInput$view,
								'',
								_List_fromArray(
									[
										$author$project$Component$Form$TextInput$id('email'),
										$author$project$Component$Form$TextInput$placeholder($author$project$Copy$copy.eR),
										$author$project$Component$Form$TextInput$onInput(
										function (v) {
											return $author$project$JobAlertForm$UpdateForm(
												_Utils_update(
													form,
													{eR: v}));
										}),
										$author$project$Component$Form$TextInput$value(form.eR),
										$author$project$Component$Form$TextInput$email,
										$author$project$Component$Form$TextInput$required(true),
										$author$project$Component$Form$TextInput$icon($author$project$View$Icon$path.eR),
										$author$project$Component$Form$TextInput$name('email'),
										$author$project$Component$Form$TextInput$tabindex(model.aP + 3)
									]))
							]),
							function () {
							var _v0 = A3($elm$core$Maybe$map2, $elm$core$Tuple$pair, model.IF.Rs.QE, model.IF.Rs.RZ);
							if (!_v0.$) {
								var _v1 = _v0.a;
								var latitude = _v1.a;
								var longitude = _v1.b;
								return _List_fromArray(
									[
										A2(
										$author$project$Util$View$viewIf,
										model.ahU,
										function (_v2) {
											return A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('selected-location'),
														$elm$html$Html$Attributes$tabindex(model.aP + 4)
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$label,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('label')
															]),
														_List_fromArray(
															[
																$elm$html$Html$text($author$project$Copy$copy.agC)
															])),
														A2(
														$elm$html$Html$span,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('select-location-title'),
																$elm$html$Html$Attributes$tabindex(model.aP + 5)
															]),
														_List_fromArray(
															[
																$elm$html$Html$text(model.IF.Rs.auy),
																A2(
																$elm$html$Html$button,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$type_('button'),
																		$elm$html$Html$Events$onClick($author$project$JobAlertForm$ClearLocation)
																	]),
																_List_fromArray(
																	[
																		$author$project$View$Icon$viewColored($author$project$View$Icon$path.acQ)
																	]))
															])),
														A2(
														$elm$html$Html$input,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$type_('hidden'),
																$elm$html$Html$Attributes$name('latitude'),
																A2(
																$elm$html$Html$Attributes$attribute,
																'tabindex',
																$elm$core$String$fromInt(model.aP + 5)),
																$elm$html$Html$Attributes$value(
																$elm$core$String$fromFloat(latitude))
															]),
														_List_Nil),
														A2(
														$elm$html$Html$input,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$type_('hidden'),
																$elm$html$Html$Attributes$name('longitude'),
																A2(
																$elm$html$Html$Attributes$attribute,
																'tabindex',
																$elm$core$String$fromInt(model.aP + 6)),
																$elm$html$Html$Attributes$value(
																$elm$core$String$fromFloat(longitude))
															]),
														_List_Nil)
													]));
										})
									]);
							} else {
								return _List_fromArray(
									[
										A2(
										$author$project$Util$View$viewIf,
										model.ahU,
										function (_v3) {
											return A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('field input-field form-field')
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$div,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('label'),
																$elm$html$Html$Attributes$tabindex(model.aP + 4)
															]),
														_List_fromArray(
															[
																$elm$html$Html$text($author$project$Copy$copy.aeE)
															])),
														A2(
														$author$project$View$LocationSuggestions$view,
														A4($author$project$JobAlertForm$locationSuggestionsConfig, model.dp, model.aW, model.ci, model.aP + 5),
														model.az)
													]));
										})
									]);
							}
						}(),
							_List_fromArray(
							[
								A2(
								$author$project$Util$View$viewIf,
								model.ahU,
								function (_v4) {
									return A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('distance field-container')
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Component$Form$NumberInput$view,
												$author$project$Copy$copy.Ed,
												_List_fromArray(
													[
														$author$project$Component$Form$NumberInput$onInput(
														function (v) {
															return $author$project$JobAlertForm$UpdateForm(
																_Utils_update(
																	form,
																	{Ed: v}));
														}),
														$author$project$Component$Form$NumberInput$id('distance-in-km'),
														$author$project$Component$Form$NumberInput$name('distance_in_km'),
														$author$project$Component$Form$NumberInput$value(form.Ed),
														$author$project$Component$Form$NumberInput$placeholder($author$project$Copy$copy.Xj),
														$author$project$Component$Form$NumberInput$min(0),
														$author$project$Component$Form$NumberInput$max(10000),
														$author$project$Component$Form$NumberInput$required,
														$author$project$Component$Form$NumberInput$tabindex(model.aP + 7)
													]))
											]));
								})
							]),
							A2(
							$elm$core$List$indexedMap,
							F2(
								function (i, _v5) {
									var _v6 = _v5.a;
									var filterId = _v6.a;
									var filter = _v6.b;
									var groupedOptions = _v5.b;
									var filterTabIndex = A3($author$project$JobAlertForm$calcTabIndexFilter, model.If, model.aP + 8, i);
									return A2(
										$author$project$Util$View$viewIfNot,
										$elm$core$List$isEmpty(groupedOptions),
										function (_v7) {
											return A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('options')
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$div,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('field label'),
																$elm$html$Html$Attributes$tabindex(filterTabIndex)
															]),
														_List_fromArray(
															[
																$elm$html$Html$text(
																((filter.atY === 24) && model.cV) ? $author$project$Copy$copy.x8 : A2(
																	$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
																	'{0} {1}',
																	_List_fromArray(
																		[$author$project$Copy$copy.qF, filter.bO])))
															])),
														A2(
														$elm$html$Html$input,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$name('filter_id'),
																$elm$html$Html$Attributes$type_('hidden'),
																$elm$html$Html$Attributes$value(
																$author$project$Data$Id$toString(filterId))
															]),
														_List_Nil),
														A3(
														$author$project$Browser$Dom$Breakpoint$isBetween,
														model.cX,
														$author$project$Browser$Dom$Breakpoint$zero,
														$author$project$Browser$Dom$Breakpoint$custom(992)) ? A2(
														$elm$html$Html$select,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$id('options'),
																$elm$html$Html$Attributes$multiple(true),
																$elm$html$Html$Attributes$name('options'),
																A3($author$project$JobAlertForm$onOptionSelect, filterId, form, model.If)
															]),
														A2(
															$elm$core$List$map,
															function (_v8) {
																var displayLabel = _v8.a;
																return A2(
																	$elm$html$Html$option,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$value(displayLabel),
																			$elm$html$Html$Attributes$selected(
																			A2(
																				$elm$core$Maybe$withDefault,
																				false,
																				A2(
																					$elm$core$Maybe$map,
																					A2(
																						$elm$core$Basics$composeR,
																						$elm$core$List$map($elm$core$Tuple$first),
																						$elm$core$List$member(displayLabel)),
																					A2($author$project$Dict$Custom$get, filterId, form.If))))
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text(displayLabel)
																		]));
															},
															groupedOptions)) : A2(
														$elm$html$Html$div,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('checkbox-container')
															]),
														A2(
															$elm$core$List$indexedMap,
															F2(
																function (j, option) {
																	return A4($author$project$JobAlertForm$viewCheckbox, form, filterId, (filterTabIndex + j) + 1, option);
																}),
															groupedOptions))
													]));
										});
								}),
							model.If),
							function () {
							var counterOptions = $elm$core$List$sum(
								A2(
									$elm$core$List$map,
									function (_v9) {
										var options = _v9.b;
										return $elm$core$List$length(options) * 2;
									},
									model.If));
							return _List_fromArray(
								[
									A2(
									$author$project$Component$Form$Checkbox$view,
									'',
									_List_fromArray(
										[
											$author$project$Component$Form$Checkbox$id('privacy'),
											$author$project$Component$Form$Checkbox$name('privacy'),
											$author$project$Component$Form$Checkbox$tabindex((model.aP + 8) + counterOptions),
											$author$project$Component$Form$Checkbox$required(true),
											$author$project$Component$Form$Checkbox$onCheck(
											function (v) {
												return $author$project$JobAlertForm$UpdateForm(
													_Utils_update(
														form,
														{cF: v}));
											}),
											$author$project$Component$Form$Checkbox$checked(form.cF),
											$author$project$Component$Form$Checkbox$htmlLabel(
											A2(
												$elm$core$Maybe$withDefault,
												$elm$html$Html$text(''),
												A6($author$project$View$FormV2$toPrivacyLabel, model.dp, model.anB, model.cG, $author$project$Model$FormFieldV2$Privacy, (model.aP + 9) + counterOptions, _List_Nil)))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('button-container')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('btn btn-primary bg-color-2 color-white'),
													$elm$html$Html$Attributes$type_('submit'),
													$elm$html$Html$Attributes$tabindex((model.aP + 10) + counterOptions),
													$elm$html$Html$Attributes$disabled(
													$author$project$View$LocationSuggestions$autocompleteStateIsKnown(model.az))
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text($author$project$Copy$copy.avI)
														]))
												]))
										]))
								]);
						}()
						])))
			]));
};
var $author$project$JobAlertForm$main = A2(
	$author$project$Browser$Custom$elementWithFlags,
	$author$project$JobAlertForm$decodeFlags,
	{dH: $author$project$JobAlertForm$init, em: $author$project$JobAlertForm$subscriptions, ex: $author$project$JobAlertForm$update, ez: $author$project$JobAlertForm$view});
var $author$project$Form$Flags = function (formSource) {
	return function (formTypeData) {
		return function (translations) {
			return function (today) {
				return function (buttonOverwriteText) {
					return function (privacyPagePath) {
						return function (defaultCallingCode) {
							return function (domainId) {
								return function (schemaFields) {
									return function (screeningQuestions) {
										return function (preFilledEmail) {
											return function (minTabIndex) {
												return function (successRedirectUrl) {
													return function (successMessage) {
														return function (conversationalApplyEnabled) {
															return function (vacancyId) {
																return function (templateId) {
																	return function (confirmVacancyUrl) {
																		return function (confirmVacancyOverviewUrl) {
																			return function (vacancyTitle) {
																				return function (appliedDate) {
																					return function (prefersReducedMotion) {
																						return function (isOverlay) {
																							return function (viewportWidth) {
																								return function (sessionId) {
																									return function (csrfToken) {
																										return function (resumeMaxTurnIdx) {
																											return function (autoOpen) {
																												return function (organicResumeUrl) {
																													return function (organicStartedDate) {
																														return function (organicStartedRelative) {
																															return function (savedUntilDate) {
																																return function (resumeToken) {
																																	return function (formId) {
																																		return function (formName) {
																																			return function (formType) {
																																				return function (uploads) {
																																					return {eC: appliedDate, c4: autoOpen, aG: buttonOverwriteText, cf: confirmVacancyOverviewUrl, cg: confirmVacancyUrl, uj: conversationalApplyEnabled, ci: csrfToken, atB: defaultCallingCode, dp: domainId, Kq: formId, aL: formName, eW: formSource, aM: formType, dA: formTypeData, e8: isOverlay, aP: minTabIndex, Y1: organicResumeUrl, Y2: organicStartedDate, Y3: organicStartedRelative, aC: preFilledEmail, fu: prefersReducedMotion, aU: privacyPagePath, fx: resumeMaxTurnIdx, adl: resumeToken, fA: savedUntilDate, aeo: schemaFields, fB: screeningQuestions, ag$: sessionId, fN: successMessage, fO: successRedirectUrl, alw: templateId, fV: today, anB: translations, ape: uploads, aqL: vacancyId, b9: vacancyTitle, f0: viewportWidth};
																																				};
																																			};
																																		};
																																	};
																																};
																															};
																														};
																													};
																												};
																											};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Data$FormSource$FormAts = function (a) {
	return {$: 0, a: a};
};
var $author$project$Data$FormSource$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (tag) {
		switch (tag) {
			case 'form-ats':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Data$FormSource$FormAts,
					A2($elm$json$Json$Decode$field, 'contents', $author$project$Model$FormV2$formDecoder));
			case 'form-cms':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Data$FormSource$FormCms,
					A2(
						$elm$json$Json$Decode$field,
						'contents',
						$author$project$Data$Entity$decoder($author$project$Model$FormV2$formDecoder)));
			default:
				return $elm$json$Json$Decode$fail('Unknown FormSource tag: ' + tag);
		}
	},
	A2($elm$json$Json$Decode$field, 'tag', $elm$json$Json$Decode$string));
var $author$project$Model$Form$FormType$EventRegistrationData = function (a) {
	return {$: 2, a: a};
};
var $author$project$Model$Form$FormType$UbeeoEventRegistrationData = function (a) {
	return {$: 3, a: a};
};
var $author$project$Model$Form$FormType$UbeeoV2EventRegistrationData = function (a) {
	return {$: 4, a: a};
};
var $author$project$Model$Form$FormType$formTypeDataDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'job-application-data':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Data$Id$decoder,
					$elm$json$Json$Decode$succeed($author$project$Model$Form$FormType$JobApplicationData));
			case 'open-job-application-data':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Data$Id$decoder,
					$elm$json$Json$Decode$succeed($author$project$Model$Form$FormType$OpenJobApplicationData));
			case 'event-registration-data':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Data$Id$decoder,
					$elm$json$Json$Decode$succeed($author$project$Model$Form$FormType$EventRegistrationData));
			case 'ubeeo-event-registration-data':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Data$Id$decoder,
					$elm$json$Json$Decode$succeed($author$project$Model$Form$FormType$UbeeoEventRegistrationData));
			case 'ubeeo-v2-event-registration-data':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Data$Id$decoder,
					$elm$json$Json$Decode$succeed($author$project$Model$Form$FormType$UbeeoV2EventRegistrationData));
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	A2($elm$json$Json$Decode$field, 'tag', $elm$json$Json$Decode$string));
var $author$project$Model$RelativeDay$Older = 2;
var $author$project$Model$RelativeDay$Today = 0;
var $author$project$Model$RelativeDay$Yesterday = 1;
var $author$project$Model$RelativeDay$relativeDayDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'today':
				return $elm$json$Json$Decode$succeed(0);
			case 'yesterday':
				return $elm$json$Json$Decode$succeed(1);
			case 'older':
				return $elm$json$Json$Decode$succeed(2);
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Form$decodeFlags = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'uploads',
	$author$project$Data$Uploads$uploadsDecoder,
	$elm$core$Dict$empty,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'formType',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'formName',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'formId',
				$elm$json$Json$Decode$string,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'resumeToken',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
					$elm$core$Maybe$Nothing,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'savedUntilDate',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
						$elm$core$Maybe$Nothing,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'organicStartedRelative',
							$elm$json$Json$Decode$nullable($author$project$Model$RelativeDay$relativeDayDecoder),
							$elm$core$Maybe$Nothing,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'organicStartedDate',
								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
								$elm$core$Maybe$Nothing,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'organicResumeUrl',
									$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
									$elm$core$Maybe$Nothing,
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'autoOpen',
										$elm$json$Json$Decode$bool,
										false,
										A4(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
											'resumeMaxTurnIdx',
											$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
											$elm$core$Maybe$Nothing,
											A4(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
												'csrfToken',
												$elm$json$Json$Decode$string,
												'',
												A4(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
													'sessionId',
													$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
													$elm$core$Maybe$Nothing,
													A4(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
														'viewportWidth',
														$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
														$elm$core$Maybe$Nothing,
														A4(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
															'isOverlay',
															$elm$json$Json$Decode$bool,
															false,
															A4(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																'prefersReducedMotion',
																$elm$json$Json$Decode$bool,
																false,
																A4(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																	'appliedDate',
																	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																	$elm$core$Maybe$Nothing,
																	A4(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																		'vacancyTitle',
																		$elm$json$Json$Decode$string,
																		'',
																		A4(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																			'confirmVacancyOverviewUrl',
																			$elm$json$Json$Decode$string,
																			'',
																			A4(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																				'confirmVacancyUrl',
																				$elm$json$Json$Decode$string,
																				'',
																				A4(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																					'templateId',
																					$elm$json$Json$Decode$nullable($author$project$Data$Id$decoder),
																					$elm$core$Maybe$Nothing,
																					A4(
																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																						'vacancyId',
																						$elm$json$Json$Decode$nullable($author$project$Data$Id$decoder),
																						$elm$core$Maybe$Nothing,
																						A4(
																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																							'conversationalApplyEnabled',
																							$elm$json$Json$Decode$bool,
																							false,
																							A4(
																								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																								'successMessage',
																								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																								$elm$core$Maybe$Nothing,
																								A4(
																									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																									'successRedirectUrl',
																									$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																									$elm$core$Maybe$Nothing,
																									A4(
																										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																										'minTabIndex',
																										$elm$json$Json$Decode$int,
																										0,
																										A3(
																											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																											'preFilledEmail',
																											$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																											A3(
																												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																												'screeningQuestions',
																												$elm$json$Json$Decode$list($author$project$Model$FormFieldTypeV2$screeningQuestionDecoder),
																												A3(
																													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																													'schemaFields',
																													$elm$json$Json$Decode$list($author$project$Model$FormV2Schema$schemaFieldDecoder),
																													A3(
																														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																														'domainId',
																														$author$project$Data$Id$decoder,
																														A3(
																															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																															'defaultCallingCode',
																															$author$project$Util$Json$enumDecoder($author$project$Model$CountryCallingCode$fromString),
																															A3(
																																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																'privacyPagePath',
																																$elm$json$Json$Decode$string,
																																A3(
																																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																	'buttonOverwriteText',
																																	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																																	A3(
																																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																		'today',
																																		$author$project$Util$Date$todayDecoder,
																																		A3(
																																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																			'translations',
																																			A2(
																																				$elm$json$Json$Decode$map,
																																				$elm$core$Basics$identity,
																																				$elm$json$Json$Decode$dict($elm$json$Json$Decode$string)),
																																			A3(
																																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																				'formTypeData',
																																				$author$project$Model$Form$FormType$formTypeDataDecoder,
																																				A3(
																																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																					'formSource',
																																					$author$project$Data$FormSource$decoder,
																																					$elm$json$Json$Decode$succeed($author$project$Form$Flags))))))))))))))))))))))))))))))))))))));
var $author$project$Form$ConvMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Form$ConversationalMode = function (a) {
	return {$: 1, a: a};
};
var $author$project$Form$LinearMode = {$: 0};
var $author$project$View$ConversationalFormV2$OrganicResume = F3(
	function (resumeUrl, startedDate, startedRelative) {
		return {adm: resumeUrl, ajy: startedDate, ajz: startedRelative};
	});
var $author$project$View$ConversationalFormV2$Idle = 0;
var $author$project$View$ConversationalFormV2$State = $elm$core$Basics$identity;
var $author$project$View$ConversationalFormV2$init = function (cfg) {
	return {
		eC: cfg.eC,
		x: _List_Nil,
		H: $elm$core$Dict$empty,
		I: $elm$core$Dict$empty,
		g: '',
		t: false,
		ci: cfg.ci,
		a: 0,
		cl: false,
		a6: 0,
		bJ: $elm$core$Maybe$Nothing,
		IF: $author$project$View$FormV2$init(cfg.at0),
		M: false,
		O1: cfg.c4 || (!cfg.e8),
		e8: cfg.e8,
		Vu: cfg.c4 ? (A2($elm$core$Maybe$withDefault, 0, cfg.fx) + 1) : 0,
		au8: cfg.au8,
		w: _List_Nil,
		af: $elm$core$Maybe$Nothing,
		aB: $elm$core$Maybe$Nothing,
		cI: cfg.cI,
		an: _List_Nil,
		cK: $elm$core$Maybe$Nothing,
		bV: cfg.c4,
		fA: cfg.fA,
		X: _List_Nil,
		z: _List_Nil,
		b_: $elm$core$Maybe$Nothing,
		eo: false,
		alw: cfg.alw,
		b4: $elm$core$Maybe$Nothing,
		aqL: cfg.aqL,
		s: 0,
		f0: cfg.f0,
		a2: false
	};
};
var $author$project$View$ConversationalFormV2$InitialShownTick = function (a) {
	return {$: 22, a: a};
};
var $author$project$View$ConversationalFormV2$initialCmd = F2(
	function (lift, _v0) {
		return A2(
			$elm$core$Platform$Cmd$map,
			lift,
			A2($elm$core$Task$perform, $author$project$View$ConversationalFormV2$InitialShownTick, $elm$time$Time$now));
	});
var $author$project$Form$GotResumeValues = function (a) {
	return {$: 3, a: a};
};
var $author$project$Model$FormFieldValueV2$ScreeningQuestionValue = F2(
	function (name, value) {
		return {dY: name, ey: value};
	});
var $author$project$Model$FormFieldValueV2$AddressValue = F4(
	function (street, houseNumber, postalCode, city) {
		return {qM: city, M3: houseNumber, $B: postalCode, aj8: street};
	});
var $author$project$Model$FormFieldValueV2$addressValueDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'city',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'postalCode',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'houseNumber',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'street',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Model$FormFieldValueV2$AddressValue)))));
var $author$project$Model$FormFieldValueV2$FileValue = F3(
	function (mimeType, base64EncodedFile, filename) {
		return {as5: base64EncodedFile, atW: filename, auG: mimeType};
	});
var $author$project$Model$FormFieldValueV2$base64EncodedFileDecoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$string);
var $author$project$Model$FormFieldValueV2$fileValueDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'filename',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'base64EncodedFile',
		$author$project$Model$FormFieldValueV2$base64EncodedFileDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'mimeType',
			$author$project$Model$FormFieldTypeV2$mimeTypeDecoder,
			$elm$json$Json$Decode$succeed($author$project$Model$FormFieldValueV2$FileValue))));
function $author$project$Model$FormFieldValueV2$cyclic$screeningQuestionValueDecoder() {
	return A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'value',
		$author$project$Model$FormFieldValueV2$cyclic$fieldValueDecoder(),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'name',
			$author$project$Model$FormFieldV2$fieldNameDecoder,
			$elm$json$Json$Decode$succeed($author$project$Model$FormFieldValueV2$ScreeningQuestionValue)));
}
function $author$project$Model$FormFieldValueV2$cyclic$fieldValueDecoder() {
	return A2(
		$elm$json$Json$Decode$andThen,
		function (a) {
			switch (a) {
				case 'text-value':
					return A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'contents',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Model$FormFieldValueV2$TextValue));
				case 'date-value':
					return A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'contents',
						$elm$json$Json$Decode$nullable($author$project$Util$Date$decodeDate),
						$elm$json$Json$Decode$succeed($author$project$Model$FormFieldValueV2$DateValue));
				case 'bool-value':
					return A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'contents',
						$elm$json$Json$Decode$bool,
						$elm$json$Json$Decode$succeed($author$project$Model$FormFieldValueV2$BoolValue));
				case 'file-value':
					return A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'contents',
						$elm$json$Json$Decode$nullable($author$project$Model$FormFieldValueV2$fileValueDecoder),
						$elm$json$Json$Decode$succeed($author$project$Model$FormFieldValueV2$FileValue_));
				case 'radio-value':
					return A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'contents',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Model$FormFieldValueV2$RadioValue));
				case 'select-value':
					return A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'contents',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
						$elm$json$Json$Decode$succeed($author$project$Model$FormFieldValueV2$SelectValue));
				case 'select-multiple-value':
					return A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'contents',
						$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
						$elm$json$Json$Decode$succeed($author$project$Model$FormFieldValueV2$SelectMultipleValue));
				case 'range-value':
					return A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'contents',
						$elm$json$Json$Decode$int,
						$elm$json$Json$Decode$succeed($author$project$Model$FormFieldValueV2$RangeValue));
				case 'phone-number-with-calling-code-value':
					return A2(
						$elm$json$Json$Decode$field,
						'contents',
						A2(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
							A2($elm$json$Json$Decode$index, 1, $elm$json$Json$Decode$string),
							A2(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
								A2(
									$elm$json$Json$Decode$index,
									0,
									$author$project$Util$Json$enumDecoder($author$project$Model$CountryCallingCode$fromString)),
								$elm$json$Json$Decode$succeed($author$project$Model$FormFieldValueV2$PhoneNumberWithCallingCodeValue))));
				case 'address-value':
					return A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'contents',
						A3(
							$elm$json$Json$Decode$map2,
							$elm$core$Tuple$pair,
							A2($elm$json$Json$Decode$index, 0, $elm$json$Json$Decode$bool),
							A2($elm$json$Json$Decode$index, 1, $author$project$Model$FormFieldValueV2$addressValueDecoder)),
						$elm$json$Json$Decode$succeed($author$project$Model$FormFieldValueV2$AddressValue_));
				case 'daypart-availability-value':
					return A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'contents',
						$elm$json$Json$Decode$list(
							A3(
								$elm$json$Json$Decode$map2,
								$elm$core$Tuple$pair,
								A2($elm$json$Json$Decode$index, 0, $author$project$Model$FormFieldTypeV2$dayOfWeekDecoder),
								A2($elm$json$Json$Decode$index, 1, $author$project$Model$FormFieldTypeV2$daypartDecoder))),
						$elm$json$Json$Decode$succeed($author$project$Model$FormFieldValueV2$DaypartAvailabilityValue));
				case 'screening-question-values':
					return A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'contents',
						$elm$json$Json$Decode$list(
							$author$project$Model$FormFieldValueV2$cyclic$screeningQuestionValueDecoder()),
						$elm$json$Json$Decode$succeed($author$project$Model$FormFieldValueV2$ScreeningQuestionValues));
				default:
					return $elm$json$Json$Decode$fail('No matching constructor');
			}
		},
		A2($elm$json$Json$Decode$field, 'tag', $elm$json$Json$Decode$string));
}
var $author$project$Model$FormFieldValueV2$screeningQuestionValueDecoder = $author$project$Model$FormFieldValueV2$cyclic$screeningQuestionValueDecoder();
$author$project$Model$FormFieldValueV2$cyclic$screeningQuestionValueDecoder = function () {
	return $author$project$Model$FormFieldValueV2$screeningQuestionValueDecoder;
};
var $author$project$Model$FormFieldValueV2$fieldValueDecoder = $author$project$Model$FormFieldValueV2$cyclic$fieldValueDecoder();
$author$project$Model$FormFieldValueV2$cyclic$fieldValueDecoder = function () {
	return $author$project$Model$FormFieldValueV2$fieldValueDecoder;
};
var $author$project$Model$FormFieldValueV2$fieldValuesDecoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Basics$identity,
	$elm$json$Json$Decode$list(
		A3(
			$elm$json$Json$Decode$map2,
			$elm$core$Tuple$pair,
			A2($elm$json$Json$Decode$index, 0, $author$project$Model$FormFieldV2$fieldNameDecoder),
			A2($elm$json$Json$Decode$index, 1, $author$project$Model$FormFieldValueV2$fieldValueDecoder))));
var $author$project$Api$Endpoint$unfinishedApplicationValues = F3(
	function (domainId, sessionId, maybeToken) {
		return A2(
			$author$project$Api$Endpoint$endpointWithQueryParameters,
			_List_fromArray(
				[
					$author$project$Data$Id$toString(domainId),
					'unfinished-applications',
					sessionId,
					'values'
				]),
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						A2(
						$elm$core$Maybe$map,
						$elm$url$Url$Builder$string('token'),
						maybeToken)
					])));
	});
var $author$project$Form$resumeValuesCmd = function (flags) {
	var _v0 = _Utils_Tuple2(flags.c4, flags.ag$);
	if (_v0.a && (!_v0.b.$)) {
		var sessionId = _v0.b.a;
		return A2(
			$author$project$Api$send,
			$author$project$Form$GotResumeValues,
			A2(
				$author$project$Api$get,
				A3($author$project$Api$Endpoint$unfinishedApplicationValues, flags.dp, sessionId, flags.adl),
				$author$project$Model$FormFieldValueV2$fieldValuesDecoder));
	} else {
		return $elm$core$Platform$Cmd$none;
	}
};
var $author$project$Form$supportsConversationalApply = function (formTypeData) {
	switch (formTypeData.$) {
		case 0:
			return true;
		case 1:
			return true;
		case 2:
			return false;
		case 3:
			return false;
		default:
			return false;
	}
};
var $author$project$Form$init = function (flags) {
	var initialFormInit = {ci: flags.ci, atB: flags.atB, atF: flags.dp, eW: flags.eW, dA: flags.dA, auC: flags.aC, aeo: flags.aeo, fB: flags.fB, fN: flags.fN, fO: flags.fO, ape: flags.ape};
	var linearState = $author$project$View$FormV2$init(initialFormInit);
	var _v0 = function () {
		if (flags.uj && $author$project$Form$supportsConversationalApply(flags.dA)) {
			var convState = $author$project$View$ConversationalFormV2$init(
				{
					eC: flags.eC,
					c4: flags.c4,
					ci: flags.ci,
					at0: initialFormInit,
					e8: flags.e8,
					au8: A3(
						$elm$core$Maybe$map2,
						F2(
							function (url, date) {
								return A3(
									$author$project$View$ConversationalFormV2$OrganicResume,
									url,
									date,
									A2($elm$core$Maybe$withDefault, 2, flags.Y3));
							}),
						flags.Y1,
						flags.Y2),
					cI: flags.fu,
					fx: flags.fx,
					fA: flags.fA,
					alw: flags.alw,
					aqL: flags.aqL,
					f0: flags.f0
				});
			return _Utils_Tuple2(
				$author$project$Form$ConversationalMode(convState),
				$elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							A2($author$project$View$ConversationalFormV2$initialCmd, $author$project$Form$ConvMsg, convState),
							$author$project$Form$resumeValuesCmd(flags)
						])));
		} else {
			return _Utils_Tuple2($author$project$Form$LinearMode, $elm$core$Platform$Cmd$none);
		}
	}();
	var mode = _v0.a;
	var initCmd = _v0.b;
	return _Utils_Tuple2(
		{aG: flags.aG, cf: flags.cf, cg: flags.cg, ci: flags.ci, dp: flags.dp, IF: linearState, Kq: flags.Kq, aL: flags.aL, aM: flags.aM, cr: $elm$core$Maybe$Nothing, aP: flags.aP, aA: mode, aC: flags.aC, aU: flags.aU, cI: flags.fu, ag$: flags.ag$, fV: flags.fV, anB: flags.anB, b9: flags.b9},
		initCmd);
};
var $author$project$Form$FormMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Form$GaInfoReceived = function (a) {
	return {$: 2, a: a};
};
var $author$project$Form$GotCsrfToken = function (a) {
	return {$: 4, a: a};
};
var $author$project$View$ConversationalFormV2$KeyboardChanged = function (a) {
	return {$: 26, a: a};
};
var $author$project$Form$keyboardChanged = _Platform_incomingPort('keyboardChanged', $elm$json$Json$Decode$bool);
var $author$project$Data$GoogleAnalytics$receiveGoogleAnalyticsInfo = _Platform_incomingPort(
	'receiveGoogleAnalyticsInfo',
	A2(
		$elm$json$Json$Decode$andThen,
		function (utmCustom) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (trackingId) {
					return A2(
						$elm$json$Json$Decode$andThen,
						function (clientId) {
							return $elm$json$Json$Decode$succeed(
								{eM: clientId, fX: trackingId, fZ: utmCustom});
						},
						A2($elm$json$Json$Decode$field, 'clientId', $elm$json$Json$Decode$string));
				},
				A2($elm$json$Json$Decode$field, 'trackingId', $elm$json$Json$Decode$string));
		},
		A2($elm$json$Json$Decode$field, 'utmCustom', $elm$json$Json$Decode$string)));
var $author$project$View$ConversationalFormV2$FormMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$View$ConversationalFormV2$OnResize = F2(
	function (a, b) {
		return {$: 25, a: a, b: b};
	});
var $author$project$View$FormV2$HttpSendingProgress = $elm$core$Basics$identity;
var $author$project$View$FormV2$UpdateHttpProgress = function (a) {
	return {$: 1, a: a};
};
var $author$project$View$FormV2$subscriptions = function (lift) {
	var toMsg = function (progress) {
		if (!progress.$) {
			var x = progress.a;
			return $author$project$View$FormV2$UpdateHttpProgress(
				$elm$http$Http$fractionSent(x));
		} else {
			return $author$project$View$FormV2$NoOp;
		}
	};
	return A2(
		$elm$http$Http$track,
		'post',
		A2($elm$core$Basics$composeL, lift, toMsg));
};
var $author$project$View$ConversationalFormV2$subscriptions = function (lift) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				A2($elm$core$Basics$composeL, lift, $author$project$View$ConversationalFormV2$FormMsg),
				$author$project$View$FormV2$subscriptions($elm$core$Basics$identity)),
				$elm$browser$Browser$Events$onResize(
				F2(
					function (w, h) {
						return lift(
							A2($author$project$View$ConversationalFormV2$OnResize, w, h));
					}))
			]));
};
var $author$project$Form$updateFormV2CsrfToken = _Platform_incomingPort('updateFormV2CsrfToken', $elm$json$Json$Decode$string);
var $author$project$Form$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				function () {
				var _v0 = model.aA;
				if (_v0.$ === 1) {
					return $elm$core$Platform$Sub$batch(
						_List_fromArray(
							[
								A2(
								$elm$core$Platform$Sub$map,
								$author$project$Form$ConvMsg,
								$author$project$View$ConversationalFormV2$subscriptions($elm$core$Basics$identity)),
								$author$project$Form$keyboardChanged(
								A2($elm$core$Basics$composeL, $author$project$Form$ConvMsg, $author$project$View$ConversationalFormV2$KeyboardChanged))
							]));
				} else {
					return A2(
						$elm$core$Platform$Sub$map,
						$author$project$Form$FormMsg,
						$author$project$View$FormV2$subscriptions($elm$core$Basics$identity));
				}
			}(),
				$author$project$Data$GoogleAnalytics$receiveGoogleAnalyticsInfo($author$project$Form$GaInfoReceived),
				$author$project$Form$updateFormV2CsrfToken($author$project$Form$GotCsrfToken)
			]));
};
var $author$project$View$ConversationalFormV2$ConvResumeApplied = function (a) {
	return {$: 4, a: a};
};
var $author$project$Form$DraftForgotten = function (a) {
	return {$: 5, a: a};
};
var $author$project$Analytics$Conversational$event = F2(
	function (name, payload) {
		return $elm$json$Json$Encode$object(
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					'event',
					$elm$json$Json$Encode$string(name)),
				payload));
	});
var $author$project$View$ConversationalFormV2$completedEventValue = function (r) {
	return A2(
		$author$project$Analytics$Conversational$event,
		'application_completed',
		_List_fromArray(
			[
				_Utils_Tuple2(
				'form_id',
				$elm$json$Json$Encode$string(r.Kq)),
				_Utils_Tuple2(
				'form_name',
				$elm$json$Json$Encode$string(r.aL)),
				_Utils_Tuple2(
				'form_type',
				$elm$json$Json$Encode$string(r.aM))
			]));
};
var $NoRedInk$http_upgrade_shim$Http$Legacy$expectStringResponse = function (fromResponse) {
	return {
		bF: function (response) {
			return A2(
				$elm$core$Result$mapError,
				function (err) {
					return A2($NoRedInk$http_upgrade_shim$Http$Legacy$BadPayload, err, response);
				},
				fromResponse(response));
		},
		aH: A2(
			$elm$http$Http$expectStringResponse,
			A2($elm$core$Basics$composeL, $NoRedInk$http_upgrade_shim$Http$Legacy$fromHttpResponse, $NoRedInk$http_upgrade_shim$Http$Legacy$combine),
			$elm$core$Result$Ok)
	};
};
var $author$project$Api$deleteWithHeaders = F2(
	function (url, headers) {
		return $author$project$Api$Endpoint$requestLegacy(
			{
				_: $NoRedInk$http_upgrade_shim$Http$Legacy$emptyBody,
				aH: $NoRedInk$http_upgrade_shim$Http$Legacy$expectStringResponse(
					function (_v0) {
						return $elm$core$Result$Ok(0);
					}),
				ax: A2(
					$elm$core$List$map,
					function (_v1) {
						var k = _v1.a;
						var v = _v1.b;
						return A2($NoRedInk$http_upgrade_shim$Http$Legacy$header, k, v);
					},
					headers),
				aO: 'DELETE',
				a_: $elm$core$Maybe$Nothing,
				a0: url,
				bx: false
			});
	});
var $author$project$Form$focusConversationalStep = _Platform_outgoingPort(
	'focusConversationalStep',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Form$lockBodyScroll = _Platform_outgoingPort(
	'lockBodyScroll',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Form$pushAnalyticsEvent = _Platform_outgoingPort('pushAnalyticsEvent', $elm$core$Basics$identity);
var $author$project$Form$redirectTo = _Platform_outgoingPort('redirectTo', $elm$json$Json$Encode$string);
var $author$project$Form$requestCsrfToken = _Platform_outgoingPort('requestCsrfToken', $elm$json$Json$Encode$bool);
var $author$project$Form$resumedValues = function (result) {
	return A2($elm$core$Result$withDefault, _List_Nil, result);
};
var $author$project$View$FormV2$setCsrfToken = F2(
	function (token, _v0) {
		var state = _v0;
		return _Utils_update(
			state,
			{ci: token});
	});
var $author$project$View$ConversationalFormV2$setCsrfToken = F2(
	function (token, _v0) {
		var state = _v0;
		return _Utils_update(
			state,
			{
				ci: token,
				IF: A2($author$project$View$FormV2$setCsrfToken, token, state.IF)
			});
	});
var $author$project$Data$GoogleAnalytics$toParams = function (_v0) {
	var trackingId = _v0.fX;
	var clientId = _v0.eM;
	var utmCustom = _v0.fZ;
	return _List_fromArray(
		[
			A2($elm$url$Url$Builder$string, 'trackingId', trackingId),
			A2($elm$url$Url$Builder$string, 'clientId', clientId),
			A2($elm$url$Url$Builder$string, 'utmCustom', utmCustom)
		]);
};
var $author$project$Api$Endpoint$unfinishedApplicationSession = F2(
	function (domainId, sessionId) {
		return $author$project$Api$Endpoint$endpoint(
			_List_fromArray(
				[
					$author$project$Data$Id$toString(domainId),
					'unfinished-applications',
					sessionId
				]));
	});
var $author$project$Form$unlockBodyScroll = _Platform_outgoingPort(
	'unlockBodyScroll',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Model$ApplicationConversationTurn$Payload$BackNavigated = 1;
var $author$project$View$ConversationalFormV2$ConvNext = {$: 1};
var $author$project$View$ConversationalFormV2$ConvStartOver = {$: 3};
var $author$project$View$ConversationalFormV2$ConvSubmit = {$: 5};
var $author$project$View$ConversationalFormV2$GotIntent = function (a) {
	return {$: 18, a: a};
};
var $author$project$View$ConversationalFormV2$GotValidation = function (a) {
	return {$: 13, a: a};
};
var $author$project$View$ConversationalFormV2$NoOp = {$: 32};
var $author$project$View$ConversationalFormV2$OverlayOpen = {$: 27};
var $author$project$Model$ApplicationConversationTurn$Payload$PrivacyAccepted = 0;
var $author$project$Model$ApplicationConversationTurn$Payload$SessionResumed = 2;
var $author$project$View$ConversationalFormV2$StepAdvancedTick = F3(
	function (a, b, c) {
		return {$: 21, a: a, b: b, c: c};
	});
var $author$project$View$ConversationalFormV2$StepTick = function (a) {
	return {$: 20, a: a};
};
var $author$project$View$ConversationalFormV2$ValidateFailed = 2;
var $author$project$View$ConversationalFormV2$Validating = 1;
var $author$project$View$FormV2$getFormInput = function (_v0) {
	var state = _v0;
	return state.j;
};
var $author$project$View$ConversationalFormV2$hasFileValue = F2(
	function (formState, fieldName) {
		var _v0 = A2(
			$pzp1997$assoc_list$AssocList$get,
			fieldName,
			$author$project$View$FormV2$getFormInput(formState));
		if (((!_v0.$) && (_v0.a.$ === 3)) && (!_v0.a.a.$)) {
			return true;
		} else {
			return false;
		}
	});
var $author$project$View$ConversationalFormV2$PrivacyRow = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$View$ConversationalFormV2$RegularRow = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$View$ConversationalFormV2$ScreeningQuestionStep = function (a) {
	return {$: 3, a: a};
};
var $author$project$Data$FormField$fieldNameToCanonicalText = function (name) {
	if (name.$ === 16) {
		var identifier = name.a;
		return identifier;
	} else {
		var _v1 = A2(
			$elm$json$Json$Decode$decodeValue,
			A2($elm$json$Json$Decode$field, 'tag', $elm$json$Json$Decode$string),
			$author$project$Model$FormFieldV2$encodeFieldName(name));
		if (!_v1.$) {
			var tag = _v1.a;
			return tag;
		} else {
			return '';
		}
	}
};
var $author$project$View$ConversationalFormV2$formScreeningQuestions = function (_v0) {
	var state = _v0;
	return state.fB;
};
var $author$project$View$ConversationalFormV2$formSourceFromState = function (_v0) {
	var state = _v0;
	return state.eW;
};
var $author$project$View$ConversationalFormV2$formSource = function (state_) {
	return $author$project$View$ConversationalFormV2$formSourceFromState(state_);
};
var $author$project$Data$VisibilityRule$isEmptyValue = function (value) {
	switch (value.$) {
		case 0:
			var t = value.a;
			return $elm$core$String$isEmpty(
				$elm$core$String$trim(t));
		case 4:
			var t = value.a;
			return $elm$core$String$isEmpty(
				$elm$core$String$trim(t));
		case 5:
			var m = value.a;
			return _Utils_eq(m, $elm$core$Maybe$Nothing);
		case 6:
			var xs = value.a;
			return $elm$core$List$isEmpty(xs);
		case 2:
			return false;
		case 1:
			var m = value.a;
			return _Utils_eq(m, $elm$core$Maybe$Nothing);
		case 7:
			return false;
		case 8:
			var t = value.b;
			return $elm$core$String$isEmpty(
				$elm$core$String$trim(t));
		case 3:
			var m = value.a;
			return _Utils_eq(m, $elm$core$Maybe$Nothing);
		case 9:
			return false;
		case 10:
			return false;
		default:
			var xs = value.a;
			return $elm$core$List$isEmpty(xs);
	}
};
var $author$project$Data$VisibilityRule$valueContains = F2(
	function (needle, actual) {
		switch (actual.$) {
			case 0:
				var haystack = actual.a;
				return A2($elm$core$String$contains, needle, haystack);
			case 6:
				var actuals = actual.a;
				return A2($elm$core$List$member, needle, actuals);
			default:
				return false;
		}
	});
var $author$project$Data$VisibilityRule$valueIsOneOf = F2(
	function (opts, actual) {
		_v0$4:
		while (true) {
			switch (actual.$) {
				case 0:
					var v = actual.a;
					return A2($elm$core$List$member, v, opts);
				case 4:
					var v = actual.a;
					return A2($elm$core$List$member, v, opts);
				case 5:
					if (!actual.a.$) {
						var v = actual.a.a;
						return A2($elm$core$List$member, v, opts);
					} else {
						break _v0$4;
					}
				case 6:
					var vs = actual.a;
					return A2(
						$elm$core$List$any,
						function (v) {
							return A2($elm$core$List$member, v, opts);
						},
						vs);
				default:
					break _v0$4;
			}
		}
		return false;
	});
var $elm$core$List$sort = function (xs) {
	return A2($elm$core$List$sortBy, $elm$core$Basics$identity, xs);
};
var $author$project$Data$VisibilityRule$valueMatches = F2(
	function (expected, actual) {
		var _v0 = _Utils_Tuple2(expected, actual);
		_v0$5:
		while (true) {
			switch (_v0.a.$) {
				case 0:
					switch (_v0.b.$) {
						case 0:
							var t = _v0.a.a;
							var a = _v0.b.a;
							return _Utils_eq(t, a);
						case 4:
							var t = _v0.a.a;
							var a = _v0.b.a;
							return _Utils_eq(t, a);
						case 5:
							if (!_v0.b.a.$) {
								var t = _v0.a.a;
								var a = _v0.b.a.a;
								return _Utils_eq(t, a);
							} else {
								break _v0$5;
							}
						default:
							break _v0$5;
					}
				case 1:
					if (_v0.b.$ === 2) {
						var b = _v0.a.a;
						var a = _v0.b.a;
						return _Utils_eq(b, a);
					} else {
						break _v0$5;
					}
				case 2:
					if (_v0.b.$ === 6) {
						var xs = _v0.a.a;
						var actuals = _v0.b.a;
						return _Utils_eq(
							$elm$core$List$sort(xs),
							$elm$core$List$sort(actuals));
					} else {
						break _v0$5;
					}
				default:
					break _v0$5;
			}
		}
		return false;
	});
var $author$project$Data$VisibilityRule$evalCondition = F2(
	function (answers, condition) {
		var mActual = A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$second,
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (_v17) {
						var name = _v17.a;
						return _Utils_eq(name, condition.atj);
					},
					answers)));
		var _v0 = _Utils_Tuple3(condition.atk, condition.atl, mActual);
		switch (_v0.a) {
			case 0:
				if (!_v0.c.$) {
					var _v1 = _v0.a;
					var v = _v0.b;
					var actual = _v0.c.a;
					return A2($author$project$Data$VisibilityRule$valueMatches, v, actual);
				} else {
					var _v2 = _v0.a;
					var _v3 = _v0.c;
					return false;
				}
			case 1:
				if (!_v0.c.$) {
					var _v4 = _v0.a;
					var v = _v0.b;
					var actual = _v0.c.a;
					return !A2($author$project$Data$VisibilityRule$valueMatches, v, actual);
				} else {
					var _v5 = _v0.a;
					var _v6 = _v0.c;
					return true;
				}
			case 2:
				if (_v0.c.$ === 1) {
					var _v7 = _v0.a;
					var _v8 = _v0.c;
					return true;
				} else {
					var _v9 = _v0.a;
					var actual = _v0.c.a;
					return $author$project$Data$VisibilityRule$isEmptyValue(actual);
				}
			case 3:
				if (_v0.c.$ === 1) {
					var _v10 = _v0.a;
					var _v11 = _v0.c;
					return false;
				} else {
					var _v12 = _v0.a;
					var actual = _v0.c.a;
					return !$author$project$Data$VisibilityRule$isEmptyValue(actual);
				}
			case 4:
				if ((!_v0.b.$) && (!_v0.c.$)) {
					var _v13 = _v0.a;
					var needle = _v0.b.a;
					var actual = _v0.c.a;
					return A2($author$project$Data$VisibilityRule$valueContains, needle, actual);
				} else {
					var _v14 = _v0.a;
					return false;
				}
			default:
				if ((_v0.b.$ === 2) && (!_v0.c.$)) {
					var _v15 = _v0.a;
					var opts = _v0.b.a;
					var actual = _v0.c.a;
					return A2($author$project$Data$VisibilityRule$valueIsOneOf, opts, actual);
				} else {
					var _v16 = _v0.a;
					return false;
				}
		}
	});
var $author$project$Data$VisibilityRule$evaluate = F2(
	function (answers, rule) {
		var results = A2(
			$elm$core$List$map,
			$author$project$Data$VisibilityRule$evalCondition(answers),
			rule.atm);
		var _v0 = rule.ati;
		if (!_v0) {
			return A2($elm$core$List$all, $elm$core$Basics$identity, results);
		} else {
			return A2($elm$core$List$any, $elm$core$Basics$identity, results);
		}
	});
var $author$project$Data$VisibilityRule$isFieldCurrentlyVisible = F2(
	function (answers, field) {
		var _v0 = field.awp;
		if (_v0.$ === 1) {
			return true;
		} else {
			var rule = _v0.a;
			return A2($author$project$Data$VisibilityRule$evaluate, answers, rule);
		}
	});
var $author$project$View$ConversationalFormV2$isInternalQaField = function (f) {
	var haystack = $elm$core$String$toLower(
		A2(
			$elm$core$String$join,
			' ',
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$second,
				_Utils_ap(f.aaI, f.bO))));
	return A2($elm$core$String$contains, '(intern', haystack) || (A2($elm$core$String$contains, 'wordt niet gevraagd', haystack) || (A2($elm$core$String$contains, 'do not ask', haystack) || A2($elm$core$String$contains, 'qa-marker', haystack)));
};
var $author$project$View$ConversationalFormV2$videoSourceImage = function (video) {
	var _v0 = video.ai3;
	if (!_v0.$) {
		switch (_v0.a.$) {
			case 2:
				var source = _v0.a.a;
				return $elm$core$Maybe$Just(source);
			case 0:
				return $elm$core$Maybe$Nothing;
			default:
				return $elm$core$Maybe$Nothing;
		}
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$View$ConversationalFormV2$hasResolvableMedia = F2(
	function (uploads, content) {
		var resolves = A2(
			$elm$core$Basics$composeR,
			$elm$core$Maybe$andThen(
				$author$project$Data$ImageSource$toTextFromUploads(uploads)),
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Maybe$map(
					A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$String$isEmpty)),
				$elm$core$Maybe$withDefault(false)));
		switch (content.$) {
			case 5:
				var image = content.a;
				return resolves(image.ek);
			case 10:
				var responsiveImage = content.a;
				return A2(
					$elm$core$List$any,
					resolves,
					_List_fromArray(
						[responsiveImage.DP, responsiveImage.ale, responsiveImage.Ts]));
			case 12:
				var usp = content.a;
				return resolves(usp.ek);
			case 15:
				var video = content.a;
				return resolves(
					$author$project$View$ConversationalFormV2$videoSourceImage(video)) || resolves(video.aT);
			case 0:
				return false;
			case 1:
				return false;
			case 2:
				return false;
			case 3:
				return false;
			case 4:
				return false;
			case 6:
				return false;
			case 7:
				return false;
			case 8:
				return false;
			case 9:
				return false;
			case 11:
				return false;
			case 13:
				return false;
			default:
				return false;
		}
	});
var $author$project$View$ConversationalFormV2$firstNonEmpty = function (candidates) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		$elm$core$List$head(
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$String$isEmpty),
					$elm$core$String$trim),
				candidates)));
};
var $author$project$View$ConversationalFormV2$narratorPromptText = function (content) {
	switch (content.$) {
		case 3:
			var button = content.a;
			return button.alE;
		case 4:
			var heading = content.a;
			return heading.alE;
		case 5:
			var image = content.a;
			return $author$project$View$ConversationalFormV2$firstNonEmpty(
				_List_fromArray(
					[image.jn, image.avV, image.c1]));
		case 6:
			var introText = content.a;
			return introText.alE;
		case 7:
			var link = content.a;
			return link.alE;
		case 8:
			var orderedList = content.a;
			return A2($elm$core$String$join, ' ', orderedList.dM);
		case 9:
			var plainText = content.a;
			return plainText.alE;
		case 10:
			var responsiveImage = content.a;
			return $author$project$View$ConversationalFormV2$firstNonEmpty(
				_List_fromArray(
					[responsiveImage.jn, responsiveImage.avV]));
		case 13:
			var unorderedList = content.a;
			return A2($elm$core$String$join, ' ', unorderedList.dM);
		case 12:
			var usp = content.a;
			return $author$project$View$ConversationalFormV2$firstNonEmpty(
				_List_fromArray(
					[usp.alE, usp.dn, usp.jn, usp.c1]));
		case 15:
			var video = content.a;
			return video.c1;
		case 0:
			return '';
		case 1:
			return '';
		case 2:
			return '';
		case 11:
			return '';
		default:
			return '';
	}
};
var $author$project$View$ConversationalFormV2$isSilentFieldType = F2(
	function (uploads, fieldType) {
		switch (fieldType.$) {
			case 8:
				return true;
			case 3:
				var content = fieldType.a;
				return $elm$core$String$isEmpty(
					$elm$core$String$trim(
						$author$project$View$ConversationalFormV2$narratorPromptText(content))) && (!A2($author$project$View$ConversationalFormV2$hasResolvableMedia, uploads, content));
			default:
				return false;
		}
	});
var $author$project$View$ConversationalFormV2$visibleSteps = function (formState) {
	var formStateInner = formState;
	var screeningQuestionSteps = A2(
		$elm$core$List$map,
		$author$project$View$ConversationalFormV2$ScreeningQuestionStep,
		$author$project$View$ConversationalFormV2$formScreeningQuestions(formState));
	var priorAnswers = A2(
		$elm$core$List$map,
		function (_v5) {
			var name = _v5.a;
			var value = _v5.b;
			return _Utils_Tuple2(
				$author$project$Data$FormField$fieldNameToCanonicalText(name),
				value);
		},
		$pzp1997$assoc_list$AssocList$toList(
			$author$project$View$FormV2$getFormInput(formState)));
	var isPrivacyField = function (f) {
		return _Utils_eq(f.dY, $author$project$Model$FormFieldV2$Privacy);
	};
	var form = $author$project$Data$FormSource$toForm(
		$author$project$View$ConversationalFormV2$formSource(formState));
	var expandField = F2(
		function (i, f) {
			var _v4 = f.ew;
			if (_v4.$ === 18) {
				return screeningQuestionSteps;
			} else {
				return _List_fromArray(
					[
						A2(
						$author$project$View$ConversationalFormV2$RegularRow,
						i,
						_List_fromArray(
							[f]))
					]);
			}
		});
	var _v0 = form.atV;
	var rawRows = _v0;
	var rows = A2(
		$elm$core$List$filter,
		A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$List$isEmpty),
		A2(
			$elm$core$List$map,
			$elm$core$List$filter(
				function (f) {
					return A2($author$project$Data$VisibilityRule$isFieldCurrentlyVisible, priorAnswers, f) && ((!$author$project$View$ConversationalFormV2$isInternalQaField(f)) && (!A2($author$project$View$ConversationalFormV2$isSilentFieldType, formStateInner.ape, f.ew)));
				}),
			rawRows));
	var numbered = A2($elm$core$List$indexedMap, $elm$core$Tuple$pair, rows);
	var privacySteps = A2(
		$elm$core$List$concatMap,
		function (_v3) {
			var i = _v3.a;
			var row = _v3.b;
			return A2(
				$elm$core$List$map,
				function (f) {
					return A2(
						$author$project$View$ConversationalFormV2$PrivacyRow,
						i,
						_List_fromArray(
							[f]));
				},
				A2($elm$core$List$filter, isPrivacyField, row));
		},
		numbered);
	var regularRows = A2(
		$elm$core$List$filter,
		A2(
			$elm$core$Basics$composeL,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$List$isEmpty),
			$elm$core$Tuple$second),
		A2(
			$elm$core$List$map,
			$elm$core$Tuple$mapSecond(
				$elm$core$List$filter(
					A2($elm$core$Basics$composeL, $elm$core$Basics$not, isPrivacyField))),
			numbered));
	var regularSteps = A2(
		$elm$core$List$concatMap,
		function (_v1) {
			var i = _v1.a;
			var row = _v1.b;
			if (row.b && (!row.b.b)) {
				var singleField = row.a;
				return A2(expandField, i, singleField);
			} else {
				var multi = row;
				return A2(
					$elm$core$List$concatMap,
					expandField(i),
					multi);
			}
		},
		regularRows);
	return _Utils_ap(privacySteps, regularSteps);
};
var $author$project$View$ConversationalFormV2$activeFileDrop = function (_v0) {
	var state_ = _v0;
	var _v1 = $elm$core$List$head(
		A2(
			$elm$core$List$drop,
			state_.a,
			$author$project$View$ConversationalFormV2$visibleSteps(state_.IF)));
	if ((((!_v1.$) && (_v1.a.$ === 1)) && _v1.a.b.b) && (!_v1.a.b.b.b)) {
		var _v2 = _v1.a;
		var _v3 = _v2.b;
		var field = _v3.a;
		var _v4 = field.ew;
		if (_v4.$ === 7) {
			var options = _v4.a;
			return A2($author$project$View$ConversationalFormV2$hasFileValue, state_.IF, field.dY) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
				_Utils_Tuple2(options, field.dY));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$View$ConversationalFormV2$screeningQuestionAsField = function (sq) {
	return $author$project$View$FormV2$toScreeningQuestionFormField(sq).at$;
};
var $author$project$View$ConversationalFormV2$firstFieldOfStep = function (step) {
	_v0$3:
	while (true) {
		switch (step.$) {
			case 1:
				if (step.b.b) {
					var _v1 = step.b;
					var field = _v1.a;
					return $elm$core$Maybe$Just(field);
				} else {
					break _v0$3;
				}
			case 2:
				if (step.b.b) {
					var _v2 = step.b;
					var field = _v2.a;
					return $elm$core$Maybe$Just(field);
				} else {
					break _v0$3;
				}
			case 3:
				var sq = step.a;
				return $elm$core$Maybe$Just(
					$author$project$View$ConversationalFormV2$screeningQuestionAsField(sq));
			default:
				break _v0$3;
		}
	}
	return $elm$core$Maybe$Nothing;
};
var $author$project$View$ConversationalFormV2$isAutoAnsweredStep = F3(
	function (autoAnswered, steps, idx) {
		return A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function (field) {
					return A2($elm$core$List$member, field.dY, autoAnswered);
				},
				A2(
					$elm$core$Maybe$andThen,
					$author$project$View$ConversationalFormV2$firstFieldOfStep,
					$elm$core$List$head(
						A2($elm$core$List$drop, idx, steps)))));
	});
var $author$project$View$ConversationalFormV2$narratorContentOfStep = function (step) {
	var _v0 = $author$project$View$ConversationalFormV2$firstFieldOfStep(step);
	if (!_v0.$) {
		var field = _v0.a;
		var _v1 = field.ew;
		if (_v1.$ === 3) {
			var content = _v1.a;
			return $elm$core$Maybe$Just(content);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$View$ConversationalFormV2$stepIsNarratorContent = function (step) {
	var _v0 = $author$project$View$ConversationalFormV2$narratorContentOfStep(step);
	if (!_v0.$) {
		return true;
	} else {
		return false;
	}
};
var $author$project$View$ConversationalFormV2$addressableFieldOfStep = function (step) {
	return $author$project$View$ConversationalFormV2$stepIsNarratorContent(step) ? $elm$core$Maybe$Nothing : $author$project$View$ConversationalFormV2$firstFieldOfStep(step);
};
var $author$project$View$ConversationalFormV2$pushHistory = F3(
	function (idx, steps, history) {
		var _v0 = A2(
			$elm$core$Maybe$andThen,
			$author$project$View$ConversationalFormV2$addressableFieldOfStep,
			$elm$core$List$head(
				A2($elm$core$List$drop, idx, steps)));
		if (!_v0.$) {
			var field = _v0.a;
			return A2($elm$core$List$cons, field.dY, history);
		} else {
			return history;
		}
	});
var $author$project$View$ConversationalFormV2$advanceTarget = F4(
	function (autoAnswered, steps, idx, history) {
		advanceTarget:
		while (true) {
			if (A3($author$project$View$ConversationalFormV2$isAutoAnsweredStep, autoAnswered, steps, idx)) {
				var $temp$autoAnswered = autoAnswered,
					$temp$steps = steps,
					$temp$idx = idx + 1,
					$temp$history = A3($author$project$View$ConversationalFormV2$pushHistory, idx, steps, history);
				autoAnswered = $temp$autoAnswered;
				steps = $temp$steps;
				idx = $temp$idx;
				history = $temp$history;
				continue advanceTarget;
			} else {
				return {MO: history, NR: idx};
			}
		}
	});
var $author$project$Model$ApplicationConversationTurn$Role$AiClarificationRole = 2;
var $author$project$Api$ConversationTurn$WireAiClarificationP = function (a) {
	return {$: 2, a: a};
};
var $author$project$Effect$ConversationalTranscript$aiClarificationTurn = F2(
	function (args, accepted) {
		var promptText = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				$elm$core$Tuple$second,
				$elm$core$List$head(args.anB)));
		return {
			Ht: $elm$core$Maybe$Just(args.Ht),
			_y: $author$project$Api$ConversationTurn$WireAiClarificationP(
				{asU: accepted, QD: args.QD, Tx: args.Tx, avi: promptText, avL: args.avl}),
			adx: 2
		};
	});
var $author$project$View$ConversationalFormV2$aiClarificationTurnFromSuggestion = F2(
	function (suggestion, accepted) {
		return A2(
			$author$project$Effect$ConversationalTranscript$aiClarificationTurn,
			{Ht: suggestion.akQ, QD: suggestion.akR, Tx: suggestion.akS, avl: suggestion.akT, anB: suggestion.akV},
			accepted);
	});
var $author$project$View$ConversationalFormV2$fieldValueNonEmpty = function (value) {
	_v0$9:
	while (true) {
		switch (value.$) {
			case 0:
				var v = value.a;
				return !$elm$core$String$isEmpty(
					$elm$core$String$trim(v));
			case 1:
				if (value.a.$ === 1) {
					var _v1 = value.a;
					return false;
				} else {
					break _v0$9;
				}
			case 3:
				if (value.a.$ === 1) {
					var _v2 = value.a;
					return false;
				} else {
					break _v0$9;
				}
			case 4:
				var v = value.a;
				return !$elm$core$String$isEmpty(v);
			case 5:
				if (value.a.$ === 1) {
					var _v3 = value.a;
					return false;
				} else {
					break _v0$9;
				}
			case 6:
				var xs = value.a;
				return !$elm$core$List$isEmpty(xs);
			case 8:
				var v = value.b;
				return !$elm$core$String$isEmpty(
					$elm$core$String$trim(v));
			case 10:
				var xs = value.a;
				return !$elm$core$List$isEmpty(xs);
			case 11:
				var xs = value.a;
				return !$elm$core$List$isEmpty(xs);
			default:
				break _v0$9;
		}
	}
	return true;
};
var $author$project$View$ConversationalFormV2$firstUnansweredStepIdx = function (formState) {
	var steps = $author$project$View$ConversationalFormV2$visibleSteps(formState);
	var answered = $author$project$View$FormV2$getFormInput(formState);
	var screeningAnswered = function (sqId) {
		var _v2 = A2($pzp1997$assoc_list$AssocList$get, $author$project$Model$FormFieldV2$ScreeningQuestions, answered);
		if ((!_v2.$) && (_v2.a.$ === 11)) {
			var vs = _v2.a.a;
			return A2(
				$elm$core$List$any,
				function (v) {
					return _Utils_eq(
						v.dY,
						$author$project$Model$FormFieldV2$Custom(sqId));
				},
				vs);
		} else {
			return false;
		}
	};
	var stepAnswered = function (step) {
		switch (step.$) {
			case 0:
				return true;
			case 4:
				return true;
			case 2:
				return true;
			case 3:
				var sq = step.a;
				return screeningAnswered(sq.dE);
			default:
				var fields = step.b;
				return $author$project$View$ConversationalFormV2$stepIsNarratorContent(step) || A2(
					$elm$core$List$all,
					function (field) {
						var _v1 = A2($pzp1997$assoc_list$AssocList$get, field.dY, answered);
						if (!_v1.$) {
							var v = _v1.a;
							return $author$project$View$ConversationalFormV2$fieldValueNonEmpty(v);
						} else {
							return false;
						}
					},
					fields);
		}
	};
	return A2(
		$elm$core$Maybe$withDefault,
		A2(
			$elm$core$Basics$max,
			0,
			$elm$core$List$length(steps) - 1),
		$elm$core$List$head(
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				A2(
					$elm$core$List$indexedMap,
					F2(
						function (idx, step) {
							return stepAnswered(step) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(idx);
						}),
					steps))));
};
var $author$project$View$FormV2$setFormInput = F2(
	function (fi, _v0) {
		var state = _v0;
		return _Utils_update(
			state,
			{j: fi});
	});
var $author$project$View$ConversationalFormV2$applyResumeValues = F2(
	function (_v0, _v1) {
		var kvs = _v0;
		var state_ = _v1;
		var restored = A2(
			$author$project$View$FormV2$setFormInput,
			A3(
				$elm$core$List$foldl,
				F2(
					function (_v2, acc) {
						var name = _v2.a;
						var value = _v2.b;
						return A3($pzp1997$assoc_list$AssocList$insert, name, value, acc);
					}),
				$author$project$View$FormV2$getFormInput(state_.IF),
				kvs),
			state_.IF);
		var boundary = $author$project$View$ConversationalFormV2$firstUnansweredStepIdx(restored);
		return _Utils_update(
			state_,
			{
				a: boundary,
				IF: restored,
				cK: $elm$core$Maybe$Just(boundary),
				bV: false,
				a2: true
			});
	});
var $author$project$View$ConversationalFormV2$ConvNarratorAdvance = function (a) {
	return {$: 24, a: a};
};
var $author$project$View$ConversationalFormV2$autoAdvanceFromNarratorCmd = F4(
	function (lift, reducedMotion, idx, step) {
		return (reducedMotion || (!$author$project$View$ConversationalFormV2$stepIsNarratorContent(step))) ? $elm$core$Platform$Cmd$none : A2(
			$elm$core$Task$perform,
			function (_v0) {
				return lift(
					$author$project$View$ConversationalFormV2$ConvNarratorAdvance(idx));
			},
			$elm$core$Process$sleep(500));
	});
var $author$project$View$ConversationalFormV2$fieldNamesOfStep = function (step) {
	switch (step.$) {
		case 1:
			var fields = step.b;
			return A2(
				$elm$core$List$map,
				function ($) {
					return $.dY;
				},
				fields);
		case 2:
			var fields = step.b;
			return A2(
				$elm$core$List$map,
				function ($) {
					return $.dY;
				},
				fields);
		case 3:
			var sq = step.a;
			return _List_fromArray(
				[
					$author$project$Model$FormFieldV2$Custom(sq.dE)
				]);
		case 0:
			return _List_Nil;
		default:
			return _List_Nil;
	}
};
var $author$project$View$ConversationalFormV2$autoAnsweredElsewhere = function (state_) {
	var submittedNow = A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			$author$project$View$ConversationalFormV2$fieldNamesOfStep,
			$elm$core$List$head(
				A2(
					$elm$core$List$drop,
					state_.a,
					$author$project$View$ConversationalFormV2$visibleSteps(state_.IF)))));
	return A2(
		$elm$core$List$filter,
		function (name) {
			return !A2($elm$core$List$member, name, submittedNow);
		},
		state_.x);
};
var $author$project$Data$Translation$translateOr = F2(
	function (translations, key) {
		return A2($author$project$Data$Translation$toStringOr, translations, key);
	});
var $author$project$View$ConversationalFormV2$conversationalFallbackPrompt = F2(
	function (translations, field) {
		var _v0 = field.ew;
		switch (_v0.$) {
			case 16:
				return A3($author$project$Data$Translation$translateOr, translations, 'conversational-fallback-question-text-area', 'Wat is je motivatie voor deze rol?');
			case 4:
				return A3($author$project$Data$Translation$translateOr, translations, 'conversational-fallback-question-date', 'Wat is de datum?');
			case 9:
				return A3($author$project$Data$Translation$translateOr, translations, 'conversational-interrogative-phone', 'Wat is je telefoonnummer?');
			case 17:
				return A3($author$project$Data$Translation$translateOr, translations, 'conversational-fallback-question-url', 'Wat is de URL?');
			case 0:
				return A3($author$project$Data$Translation$translateOr, translations, 'conversational-interrogative-address', 'Wat is je adres?');
			case 13:
				return A3($author$project$Data$Translation$translateOr, translations, 'conversational-fallback-question-select-multiple', 'Welke opties passen bij jou?');
			case 12:
				return A3($author$project$Data$Translation$translateOr, translations, 'conversational-fallback-question-select', 'Welke optie past het beste?');
			case 14:
				return A3($author$project$Data$Translation$translateOr, translations, 'conversational-fallback-question-select', 'Welke optie past het beste?');
			case 11:
				return A3($author$project$Data$Translation$translateOr, translations, 'conversational-fallback-question-radio', 'Wat kies je?');
			case 1:
				return A3($author$project$Data$Translation$translateOr, translations, 'conversational-fallback-question-checkbox', 'Klopt dat?');
			case 19:
				return A3($author$project$Data$Translation$translateOr, translations, 'conversational-fallback-question-yes-no', 'Ja of nee?');
			default:
				return A3($author$project$Data$Translation$translateOr, translations, 'conversational-fallback-question-default', 'Wat is je antwoord?');
		}
	});
var $author$project$Data$Form$nameToLabel = function (a) {
	switch (a.$) {
		case 0:
			return $author$project$Copy$copy.gZ;
		case 1:
			return $author$project$Copy$copy.g$;
		case 2:
			return $author$project$Copy$copy.g1;
		case 3:
			return $author$project$Copy$copy.g3;
		case 4:
			return $author$project$Copy$copy.g5;
		case 5:
			return $author$project$Copy$copy.g9;
		case 6:
			return $author$project$Copy$copy.ha;
		case 7:
			return 'E-mailadres contactpersoon';
		case 8:
			return 'Naam contactpersoon';
		case 9:
			return 'Naam bureau';
		case 10:
			return $author$project$Copy$copy.nl;
		case 11:
			return 'Bedrijfsonderdeel';
		case 12:
			return 'button';
		case 13:
			return $author$project$Copy$copy.qN;
		case 16:
			var val = a.a;
			return val;
		case 20:
			return $author$project$Copy$copy.Uh;
		case 21:
			return $author$project$Copy$copy.$R;
		case 22:
			return $author$project$Copy$copy.w5;
		case 18:
			return 'Custom ethnic identification';
		case 15:
			return 'Omrekenfactor';
		case 25:
			return 'Custom state';
		case 17:
			return 'Canada province';
		case 19:
			return $author$project$Copy$copy.x7;
		case 23:
			return 'Is hispanic';
		case 24:
			return $author$project$Copy$copy.Yu;
		case 64:
			return $author$project$Copy$copy.adj;
		case 26:
			return $author$project$Copy$copy.ys;
		case 27:
			return 'Gewenst salaris';
		case 28:
			return $author$project$Copy$copy.E7;
		case 14:
			return $author$project$Copy$copy.sc;
		case 29:
			return $author$project$Copy$copy.Iq;
		case 30:
			return $author$project$Copy$copy.LH;
		case 31:
			return $author$project$Copy$copy.LJ;
		case 32:
			return $author$project$Copy$copy.LL;
		case 33:
			return $author$project$Copy$copy.LN;
		case 34:
			return $author$project$Copy$copy.Mm;
		case 35:
			return $author$project$Copy$copy.abw;
		case 36:
			return $author$project$Copy$copy.act;
		case 39:
			return $author$project$Copy$copy.Nw;
		case 40:
			return $author$project$Copy$copy.Oe;
		case 41:
			return $author$project$Copy$copy.Oj;
		case 42:
			return $author$project$Copy$copy.Ol;
		case 43:
			return $author$project$Copy$copy.Op;
		case 44:
			return $author$project$Copy$copy.Qx;
		case 45:
			return $author$project$Copy$copy.Q0;
		case 46:
			return $author$project$Copy$copy.Rh;
		case 47:
			return $author$project$Copy$copy.TK;
		case 48:
			return $author$project$Copy$copy.TM;
		case 49:
			return $author$project$Copy$copy.Vr;
		case 37:
			return 'Aantal uren beschikbaar per week';
		case 38:
			return $author$project$Copy$copy.x7;
		case 56:
			return $author$project$Copy$copy.Y$;
		case 55:
			return $author$project$Copy$copy.YB;
		case 65:
			return $author$project$Copy$copy.ad2;
		case 68:
			return $author$project$Copy$copy.afW;
		case 57:
			return $author$project$Copy$copy.avb;
		case 58:
			return $author$project$Copy$copy._T;
		case 61:
			return $author$project$Copy$copy.$D;
		case 59:
			return $author$project$Copy$copy._3;
		case 60:
			return $author$project$Copy$copy.$g;
		case 62:
			return $author$project$Copy$copy.$5;
		case 63:
			return 'Referred';
		case 66:
			return $author$project$Copy$copy.aez;
		case 67:
			return $author$project$Copy$copy.aiT;
		case 50:
			return 'OpenApplicationExternalId';
		case 52:
			return $author$project$Copy$copy.Yj;
		case 54:
			return $author$project$Copy$copy.Yn;
		case 53:
			return $author$project$Copy$copy.Yl;
		case 51:
			return $author$project$Copy$copy.Yh;
		case 69:
			return $author$project$Copy$copy.ajf;
		case 70:
			return $author$project$Copy$copy.aj6;
		case 71:
			return 'Thesis';
		case 72:
			return $author$project$Copy$copy.an5;
		case 73:
			return $author$project$Copy$copy.a0;
		case 74:
			return $author$project$Copy$copy.apY;
		case 75:
			return $author$project$Copy$copy.ars;
		default:
			return $author$project$Copy$copy.asB;
	}
};
var $author$project$View$ConversationalFormV2$rejectPlaceholderLabel = function (s) {
	var lowered = $elm$core$String$toLower(s);
	return (A2($elm$core$String$startsWith, 'selectieveld', lowered) || (A2($elm$core$String$startsWith, 'open select', lowered) || (A2($elm$core$String$startsWith, 'open text', lowered) || (A2($elm$core$String$startsWith, 'extra checkbox', lowered) || (A2($elm$core$String$startsWith, 'upload motivatie', lowered) || A2($elm$core$String$startsWith, 'upload motivation', lowered)))))) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(s);
};
var $author$project$View$ConversationalFormV2$questionForField = F3(
	function (translations, domainKey, field) {
		var nonEmpty = function (s) {
			return $elm$core$String$isEmpty(s) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(s);
		};
		var fromDomain = function (values) {
			return A2(
				$elm$core$Maybe$andThen,
				nonEmpty,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Tuple$second,
					$elm$core$List$head(
						A2(
							$elm$core$List$filter,
							function (_v1) {
								var d = _v1.a;
								return _Utils_eq(d, domainKey);
							},
							values))));
		};
		var firstJust = A2(
			$elm$core$List$foldl,
			F2(
				function (m, acc) {
					if (!acc.$) {
						return acc;
					} else {
						return m;
					}
				}),
			$elm$core$Maybe$Nothing);
		return A2(
			$elm$core$Maybe$withDefault,
			A2($author$project$View$ConversationalFormV2$conversationalFallbackPrompt, translations, field),
			firstJust(
				_List_fromArray(
					[
						fromDomain(field.aaI),
						fromDomain(field.bO),
						A2(
						$elm$core$Maybe$andThen,
						$author$project$View$ConversationalFormV2$rejectPlaceholderLabel,
						nonEmpty(
							$author$project$Data$Form$nameToLabel(field.dY)))
					])));
	});
var $author$project$Data$FormTemplate$Literal = function (a) {
	return {$: 0, a: a};
};
var $author$project$Data$FormTemplate$Reference = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Data$FormTemplate$Fallback = function (a) {
	return {$: 0, a: a};
};
var $author$project$Data$FormTemplate$Transform = function (a) {
	return {$: 1, a: a};
};
var $author$project$Data$FormTemplate$WordPick = function (a) {
	return {$: 2, a: a};
};
var $author$project$Data$FormTemplate$parseFilter = function (raw) {
	var _v0 = A2($elm$core$String$indexes, ':', raw);
	if (!_v0.b) {
		return $elm$core$Maybe$Nothing;
	} else {
		var firstIdx = _v0.a;
		var rest = A2($elm$core$String$dropLeft, firstIdx + 1, raw);
		var key = $elm$core$String$trim(
			A2($elm$core$String$left, firstIdx, raw));
		switch (key) {
			case 'fallback':
				return $elm$core$Maybe$Just(
					$author$project$Data$FormTemplate$Fallback(rest));
			case 'transform':
				return $elm$core$Maybe$Just(
					$author$project$Data$FormTemplate$Transform(
						$elm$core$String$trim(rest)));
			case 'word':
				return $elm$core$Maybe$Just(
					$author$project$Data$FormTemplate$WordPick(
						$elm$core$String$trim(rest)));
			default:
				return $elm$core$Maybe$Nothing;
		}
	}
};
var $author$project$Data$FormTemplate$parseReference = function (body) {
	var _v0 = A2(
		$elm$core$List$map,
		$elm$core$String$trim,
		A2($elm$core$String$split, '|', body));
	if (!_v0.b) {
		return $author$project$Data$FormTemplate$Literal('{{}}');
	} else {
		var name = _v0.a;
		var filterStrs = _v0.b;
		return A2(
			$author$project$Data$FormTemplate$Reference,
			name,
			A2($elm$core$List$filterMap, $author$project$Data$FormTemplate$parseFilter, filterStrs));
	}
};
var $author$project$Data$FormTemplate$parseTokensInto = F2(
	function (acc, input) {
		parseTokensInto:
		while (true) {
			var _v0 = A2($elm$core$String$indexes, '{{', input);
			if (!_v0.b) {
				return $elm$core$String$isEmpty(input) ? $elm$core$List$reverse(acc) : $elm$core$List$reverse(
					A2(
						$elm$core$List$cons,
						$author$project$Data$FormTemplate$Literal(input),
						acc));
			} else {
				var startIdx = _v0.a;
				var before = A2($elm$core$String$left, startIdx, input);
				var afterOpen = A2($elm$core$String$dropLeft, startIdx + 2, input);
				var _v1 = A2($elm$core$String$indexes, '}}', afterOpen);
				if (!_v1.b) {
					return $elm$core$List$reverse(
						A2(
							$elm$core$List$cons,
							$author$project$Data$FormTemplate$Literal(input),
							acc));
				} else {
					var endIdx = _v1.a;
					var rest = A2($elm$core$String$dropLeft, endIdx + 2, afterOpen);
					var prefix = $elm$core$String$isEmpty(before) ? _List_Nil : _List_fromArray(
						[
							$author$project$Data$FormTemplate$Literal(before)
						]);
					var inner = A2($elm$core$String$left, endIdx, afterOpen);
					var ref = $author$project$Data$FormTemplate$parseReference(
						$elm$core$String$trim(inner));
					var $temp$acc = A2(
						$elm$core$List$cons,
						ref,
						_Utils_ap(prefix, acc)),
						$temp$input = rest;
					acc = $temp$acc;
					input = $temp$input;
					continue parseTokensInto;
				}
			}
		}
	});
var $author$project$Data$FormTemplate$parseTokens = function (input) {
	return A2($author$project$Data$FormTemplate$parseTokensInto, _List_Nil, input);
};
var $author$project$Data$FormTemplate$fallbackOrEmpty = function (filters) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		$elm$core$List$head(
			A2(
				$elm$core$List$filterMap,
				function (f) {
					if (!f.$) {
						var s = f.a;
						return $elm$core$Maybe$Just(s);
					} else {
						return $elm$core$Maybe$Nothing;
					}
				},
				filters)));
};
var $author$project$Data$FormTemplate$applyFallback = F2(
	function (raw, filters) {
		if (!raw.$) {
			var t = raw.a;
			return $elm$core$String$isEmpty(
				$elm$core$String$trim(t)) ? $author$project$Data$FormTemplate$fallbackOrEmpty(filters) : t;
		} else {
			return $author$project$Data$FormTemplate$fallbackOrEmpty(filters);
		}
	});
var $elm$core$Char$toUpper = _Char_toUpper;
var $author$project$Data$FormTemplate$capitalize = function (t) {
	var _v0 = $elm$core$String$uncons(t);
	if (!_v0.$) {
		var _v1 = _v0.a;
		var c = _v1.a;
		var rest = _v1.b;
		return A2(
			$elm$core$String$cons,
			$elm$core$Char$toUpper(c),
			rest);
	} else {
		return t;
	}
};
var $author$project$Data$FormTemplate$applyOne = F2(
	function (filter, acc) {
		_v0$3:
		while (true) {
			if (filter.$ === 1) {
				switch (filter.a) {
					case 'lowercase':
						return $elm$core$String$toLower(acc);
					case 'uppercase':
						return $elm$core$String$toUpper(acc);
					case 'capitalize':
						return $author$project$Data$FormTemplate$capitalize(acc);
					default:
						break _v0$3;
				}
			} else {
				break _v0$3;
			}
		}
		return acc;
	});
var $author$project$Data$FormTemplate$applyTransforms = $elm$core$List$foldl($author$project$Data$FormTemplate$applyOne);
var $author$project$Data$FormTemplate$applyWord = F2(
	function (acc, filters) {
		var _v0 = $elm$core$List$head(
			A2(
				$elm$core$List$filterMap,
				function (f) {
					if (f.$ === 2) {
						var w = f.a;
						return $elm$core$Maybe$Just(w);
					} else {
						return $elm$core$Maybe$Nothing;
					}
				},
				filters));
		_v0$2:
		while (true) {
			if (!_v0.$) {
				switch (_v0.a) {
					case 'first':
						return A2(
							$elm$core$Maybe$withDefault,
							acc,
							$elm$core$List$head(
								$elm$core$String$words(acc)));
					case 'last':
						return A2(
							$elm$core$Maybe$withDefault,
							acc,
							$elm$core$List$head(
								$elm$core$List$reverse(
									$elm$core$String$words(acc))));
					default:
						break _v0$2;
				}
			} else {
				break _v0$2;
			}
		}
		return acc;
	});
var $author$project$Data$FormTemplate$pickAnswer = function (name) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$List$filter(
			function (_v0) {
				var n = _v0.a;
				return _Utils_eq(n, name);
			}),
		A2(
			$elm$core$Basics$composeR,
			$elm$core$List$head,
			$elm$core$Maybe$map($elm$core$Tuple$second)));
};
var $author$project$Data$FormTemplate$renderToken = F2(
	function (answers, token) {
		if (!token.$) {
			var t = token.a;
			return t;
		} else {
			var name = token.a;
			var filters = token.b;
			var raw = A2($author$project$Data$FormTemplate$pickAnswer, name, answers);
			var withFallback = A2($author$project$Data$FormTemplate$applyFallback, raw, filters);
			var transformed = A2($author$project$Data$FormTemplate$applyTransforms, withFallback, filters);
			return A2($author$project$Data$FormTemplate$applyWord, transformed, filters);
		}
	});
var $author$project$Data$FormTemplate$render = F2(
	function (answers, source) {
		return $elm$core$String$concat(
			A2(
				$elm$core$List$map,
				$author$project$Data$FormTemplate$renderToken(answers),
				$author$project$Data$FormTemplate$parseTokens(source)));
	});
var $author$project$View$ConversationalFormV2$monthLabelNl = function (month) {
	switch (month) {
		case 0:
			return 'januari';
		case 1:
			return 'februari';
		case 2:
			return 'maart';
		case 3:
			return 'april';
		case 4:
			return 'mei';
		case 5:
			return 'juni';
		case 6:
			return 'juli';
		case 7:
			return 'augustus';
		case 8:
			return 'september';
		case 9:
			return 'oktober';
		case 10:
			return 'november';
		default:
			return 'december';
	}
};
var $author$project$View$ConversationalFormV2$formatDateNl = function (d) {
	return A2(
		$elm$core$String$join,
		' ',
		_List_fromArray(
			[
				$elm$core$String$fromInt(
				$justinmimbs$date$Date$day(d)),
				$author$project$View$ConversationalFormV2$monthLabelNl(
				$justinmimbs$date$Date$month(d)),
				$elm$core$String$fromInt(
				$justinmimbs$date$Date$year(d))
			]));
};
var $author$project$View$ConversationalFormV2$formatDateForLocale = function (d) {
	var _v0 = $author$project$Copy$language;
	switch (_v0) {
		case 16:
			return $author$project$View$ConversationalFormV2$formatDateNl(d);
		case 17:
			return $author$project$View$ConversationalFormV2$formatDateNl(d);
		default:
			return $justinmimbs$date$Date$toIsoString(d);
	}
};
var $author$project$View$ConversationalFormV2$renderFieldValue = function (value) {
	switch (value.$) {
		case 0:
			var v = value.a;
			return v;
		case 1:
			if (value.a.$ === 1) {
				var _v1 = value.a;
				return '';
			} else {
				var d = value.a.a;
				return $author$project$View$ConversationalFormV2$formatDateForLocale(d);
			}
		case 2:
			if (value.a) {
				return $author$project$Copy$copy.asH;
			} else {
				return $author$project$Copy$copy.VA;
			}
		case 3:
			if (value.a.$ === 1) {
				var _v2 = value.a;
				return '';
			} else {
				var f = value.a.a;
				return f.atW;
			}
		case 4:
			var v = value.a;
			return v;
		case 5:
			if (value.a.$ === 1) {
				var _v3 = value.a;
				return '';
			} else {
				var v = value.a.a;
				return v;
			}
		case 6:
			var vs = value.a;
			return A2($elm$core$String$join, ', ', vs);
		case 7:
			var n = value.a;
			return $elm$core$String$fromInt(n);
		case 8:
			var v = value.b;
			return v;
		case 9:
			var _v4 = value.a;
			var a = _v4.b;
			return A2(
				$elm$core$String$join,
				' ',
				_List_fromArray(
					[a.aj8, a.M3, a.$B, a.qM]));
		case 10:
			return '[availability]';
		default:
			var vs = value.a;
			return $elm$core$String$fromInt(
				$elm$core$List$length(vs)) + ' answer(s)';
	}
};
var $author$project$View$ConversationalFormV2$renderTemplate = F2(
	function (formState, source) {
		var answersByText = A2(
			$elm$core$List$map,
			function (_v0) {
				var name = _v0.a;
				var value = _v0.b;
				return _Utils_Tuple2(
					$author$project$Data$FormField$fieldNameToCanonicalText(name),
					$author$project$View$ConversationalFormV2$renderFieldValue(value));
			},
			$pzp1997$assoc_list$AssocList$toList(
				$author$project$View$FormV2$getFormInput(formState)));
		return A2($author$project$Data$FormTemplate$render, answersByText, source);
	});
var $author$project$View$ConversationalFormV2$botPromptForStep = F3(
	function (translations, formStateOpaque, step) {
		var formState = formStateOpaque;
		var rendered = $author$project$View$ConversationalFormV2$renderTemplate(formStateOpaque);
		var _v0 = $author$project$View$ConversationalFormV2$narratorContentOfStep(step);
		if (!_v0.$) {
			var content = _v0.a;
			return $author$project$View$ConversationalFormV2$narratorPromptText(content);
		} else {
			switch (step.$) {
				case 0:
					var txt = step.a;
					return rendered(txt);
				case 1:
					if (step.b.b) {
						var _v2 = step.b;
						var first = _v2.a;
						return rendered(
							A3($author$project$View$ConversationalFormV2$questionForField, translations, formState.atF, first));
					} else {
						return '';
					}
				case 2:
					if (step.b.b) {
						var _v3 = step.b;
						var privacyField = _v3.a;
						return rendered(
							A3($author$project$View$ConversationalFormV2$questionForField, translations, formState.atF, privacyField));
					} else {
						return rendered('Privacy');
					}
				case 3:
					var sq = step.a;
					return rendered(sq.bO);
				default:
					return '';
			}
		}
	});
var $author$project$Model$ApplicationConversationTurn$Role$BotRole = 0;
var $author$project$Api$ConversationTurn$WireBotP = function (a) {
	return {$: 0, a: a};
};
var $author$project$Effect$ConversationalTranscript$buildBotTurnRecord = F2(
	function (fieldName, promptText) {
		return $elm$core$String$isEmpty(
			$elm$core$String$trim(promptText)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
			{
				Ht: fieldName,
				_y: $author$project$Api$ConversationTurn$WireBotP(
					{alE: promptText, anB: _List_Nil}),
				adx: 0
			});
	});
var $author$project$Model$ApplicationConversationTurn$Role$UserRole = 1;
var $author$project$Api$ConversationTurn$WireUserP = function (a) {
	return {$: 1, a: a};
};
var $author$project$Effect$ConversationalTranscript$screeningAnswerFor = F3(
	function (sqId, formInput, renderValue) {
		var _v0 = A2($pzp1997$assoc_list$AssocList$get, $author$project$Model$FormFieldV2$ScreeningQuestions, formInput);
		if ((!_v0.$) && (_v0.a.$ === 11)) {
			var vs = _v0.a.a;
			return A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.ey;
						},
						renderValue),
					$elm$core$List$head(
						A2(
							$elm$core$List$filter,
							function (v) {
								return _Utils_eq(
									v.dY,
									$author$project$Model$FormFieldV2$Custom(sqId));
							},
							vs))));
		} else {
			return '';
		}
	});
var $author$project$Effect$ConversationalTranscript$buildScreeningTurn = F3(
	function (sqId, kvs, renderValue) {
		var dict = $pzp1997$assoc_list$AssocList$fromList(kvs);
		var answerText = A3($author$project$Effect$ConversationalTranscript$screeningAnswerFor, sqId, dict, renderValue);
		return $elm$core$String$isEmpty(
			$elm$core$String$trim(answerText)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
			{
				Ht: $elm$core$Maybe$Just(sqId),
				_y: $author$project$Api$ConversationTurn$WireUserP(
					{
						aaO: answerText,
						aeb: answerText,
						akn: A2(
							$elm$core$Maybe$map,
							function (slot) {
								return _List_fromArray(
									[
										_Utils_Tuple2($author$project$Model$FormFieldV2$ScreeningQuestions, slot)
									]);
							},
							A2($pzp1997$assoc_list$AssocList$get, $author$project$Model$FormFieldV2$ScreeningQuestions, dict))
					}),
				adx: 1
			});
	});
var $author$project$Effect$ConversationalTranscript$buildUserTurnForFields = F4(
	function (fields, kvs, nameToLabel, renderValue) {
		var firstFieldName = A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.dY;
				},
				nameToLabel),
			$elm$core$List$head(fields));
		var fieldNames = A2(
			$elm$core$List$map,
			function ($) {
				return $.dY;
			},
			fields);
		var relevant = A2(
			$elm$core$List$filter,
			function (_v1) {
				var n = _v1.a;
				return A2($elm$core$List$member, n, fieldNames);
			},
			kvs);
		var rendered = A2(
			$elm$core$String$join,
			' · ',
			A2(
				$elm$core$List$filter,
				function (s) {
					return !$elm$core$String$isEmpty(
						$elm$core$String$trim(s));
				},
				A2(
					$elm$core$List$map,
					function (_v0) {
						var v = _v0.b;
						return renderValue(v);
					},
					relevant)));
		return $elm$core$String$isEmpty(
			$elm$core$String$trim(rendered)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
			{
				Ht: firstFieldName,
				_y: $author$project$Api$ConversationTurn$WireUserP(
					{
						aaO: rendered,
						aeb: rendered,
						akn: $elm$core$Maybe$Just(relevant)
					}),
				adx: 1
			});
	});
var $author$project$Effect$ConversationalTranscript$buildUserTurnRecord = F4(
	function (mStep, _v0, nameToLabel, renderValue) {
		var kvs = _v0;
		if (!mStep.$) {
			var fields = mStep.a.atV;
			var screeningId = mStep.a.avv;
			if (!screeningId.$) {
				var sqId = screeningId.a;
				return A3($author$project$Effect$ConversationalTranscript$buildScreeningTurn, sqId, kvs, renderValue);
			} else {
				return A4($author$project$Effect$ConversationalTranscript$buildUserTurnForFields, fields, kvs, nameToLabel, renderValue);
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Tafkar$AiAssist$ConversationContext$Applicant = 1;
var $author$project$Tafkar$AiAssist$ConversationContext$Bot = 0;
var $author$project$Tafkar$AiAssist$ConversationContext$ChatTurn = F3(
	function (role, text, fieldName) {
		return {Ht: fieldName, adx: role, alE: text};
	});
var $author$project$View$ConversationalFormV2$buildChatHistoryWire = F2(
	function (translations, state_) {
		var turnsForStep = function (_v2) {
			var idx = _v2.a;
			var step = _v2.b;
			var fieldName = A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.dY;
						},
						$author$project$Data$FormField$fieldNameToCanonicalText),
					$author$project$View$ConversationalFormV2$firstFieldOfStep(step)));
			var userAttempts = A2(
				$elm$core$List$map,
				function (t) {
					return A3($author$project$Tafkar$AiAssist$ConversationContext$ChatTurn, 1, t, fieldName);
				},
				A2(
					$elm$core$List$filter,
					function (s) {
						return !$elm$core$String$isEmpty(
							$elm$core$String$trim(s));
					},
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2($elm$core$Dict$get, idx, state_.I))));
			var botPrompt = A3($author$project$View$ConversationalFormV2$botPromptForStep, translations, state_.IF, step);
			var botTurn = $elm$core$String$isEmpty(
				$elm$core$String$trim(botPrompt)) ? _List_Nil : _List_fromArray(
				[
					A3($author$project$Tafkar$AiAssist$ConversationContext$ChatTurn, 0, botPrompt, fieldName)
				]);
			return _Utils_ap(botTurn, userAttempts);
		};
		var steps = $author$project$View$ConversationalFormV2$visibleSteps(state_.IF);
		var currentIdx = state_.a;
		var currentStepBotTurn = function () {
			var _v1 = $elm$core$List$head(
				A2($elm$core$List$drop, currentIdx, steps));
			if (_v1.$ === 1) {
				return _List_Nil;
			} else {
				var step = _v1.a;
				var fieldName = A2(
					$elm$core$Maybe$withDefault,
					'',
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.dY;
							},
							$author$project$Data$FormField$fieldNameToCanonicalText),
						$author$project$View$ConversationalFormV2$firstFieldOfStep(step)));
				var botPrompt = A3($author$project$View$ConversationalFormV2$botPromptForStep, translations, state_.IF, step);
				return $elm$core$String$isEmpty(
					$elm$core$String$trim(botPrompt)) ? _List_Nil : _List_fromArray(
					[
						A3($author$project$Tafkar$AiAssist$ConversationContext$ChatTurn, 0, botPrompt, fieldName)
					]);
			}
		}();
		var priorSteps = A2(
			$elm$core$List$filter,
			function (_v0) {
				var idx = _v0.a;
				return _Utils_cmp(idx, currentIdx) < 0;
			},
			A2($elm$core$List$indexedMap, $elm$core$Tuple$pair, steps));
		return _Utils_ap(
			A2($elm$core$List$concatMap, turnsForStep, priorSteps),
			currentStepBotTurn);
	});
var $author$project$View$ConversationalFormV2$defaultCallingCodeFor = function (_v0) {
	var s = _v0;
	return s.atB;
};
var $author$project$View$ConversationalFormV2$emptyFieldValueFor = F2(
	function (defaultCallingCode, fieldType) {
		switch (fieldType.$) {
			case 0:
				return $author$project$Model$FormFieldValueV2$AddressValue_(
					_Utils_Tuple2(
						false,
						{qM: '', M3: '', $B: '', aj8: ''}));
			case 1:
				return $author$project$Model$FormFieldValueV2$BoolValue(false);
			case 2:
				return $author$project$Model$FormFieldValueV2$TextValue('');
			case 3:
				return $author$project$Model$FormFieldValueV2$TextValue('');
			case 4:
				return $author$project$Model$FormFieldValueV2$DateValue($elm$core$Maybe$Nothing);
			case 5:
				return $author$project$Model$FormFieldValueV2$DaypartAvailabilityValue(_List_Nil);
			case 6:
				return $author$project$Model$FormFieldValueV2$TextValue('');
			case 7:
				return $author$project$Model$FormFieldValueV2$FileValue_($elm$core$Maybe$Nothing);
			case 8:
				return $author$project$Model$FormFieldValueV2$TextValue('');
			case 9:
				return A2($author$project$Model$FormFieldValueV2$PhoneNumberWithCallingCodeValue, defaultCallingCode, '');
			case 10:
				return $author$project$Model$FormFieldValueV2$RangeValue(0);
			case 11:
				return $author$project$Model$FormFieldValueV2$RadioValue('');
			case 12:
				return $author$project$Model$FormFieldValueV2$SelectValue($elm$core$Maybe$Nothing);
			case 13:
				return $author$project$Model$FormFieldValueV2$SelectMultipleValue(_List_Nil);
			case 14:
				return $author$project$Model$FormFieldValueV2$SelectValue($elm$core$Maybe$Nothing);
			case 15:
				return $author$project$Model$FormFieldValueV2$TextValue('');
			case 16:
				return $author$project$Model$FormFieldValueV2$TextValue('');
			case 17:
				return $author$project$Model$FormFieldValueV2$TextValue('');
			case 18:
				return $author$project$Model$FormFieldValueV2$ScreeningQuestionValues(_List_Nil);
			default:
				return $author$project$Model$FormFieldValueV2$BoolValue(false);
		}
	});
var $author$project$View$ConversationalFormV2$formEntityId = $author$project$Data$Entity$id;
var $author$project$View$ConversationalFormV2$formKeyFromSource = function (src) {
	if (src.$ === 1) {
		var formEntity = src.a;
		return $elm$core$Maybe$Just(
			$author$project$View$ConversationalFormV2$formEntityId(formEntity));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$View$ConversationalFormV2$buildValidationRequest = F3(
	function (translations, step, _v0) {
		var state_ = _v0;
		var stepFields = function () {
			switch (step.$) {
				case 1:
					var fields = step.b;
					return fields;
				case 2:
					var fields = step.b;
					return fields;
				case 3:
					return _List_Nil;
				case 0:
					return _List_Nil;
				default:
					return _List_Nil;
			}
		}();
		var stepNames = function () {
			if (step.$ === 3) {
				var sq = step.a;
				return _List_fromArray(
					[
						$author$project$Model$FormFieldV2$Custom(sq.dE)
					]);
			} else {
				return A2(
					$elm$core$List$map,
					function ($) {
						return $.dY;
					},
					stepFields);
			}
		}();
		var formSource_ = $author$project$View$ConversationalFormV2$formSource(state_.IF);
		var formInput_ = $author$project$View$FormV2$getFormInput(state_.IF);
		var defaultCallingCode = $author$project$View$ConversationalFormV2$defaultCallingCodeFor(state_.IF);
		var stepKvs = A2(
			$elm$core$List$map,
			function (f) {
				var _v6 = A2($pzp1997$assoc_list$AssocList$get, f.dY, formInput_);
				if (!_v6.$) {
					var v = _v6.a;
					return _Utils_Tuple2(f.dY, v);
				} else {
					return _Utils_Tuple2(
						f.dY,
						A2($author$project$View$ConversationalFormV2$emptyFieldValueFor, defaultCallingCode, f.ew));
				}
			},
			stepFields);
		var allKvs = $pzp1997$assoc_list$AssocList$toList(formInput_);
		var priorKvs = A2(
			$elm$core$List$filter,
			function (_v5) {
				var n = _v5.a;
				return (!A2($elm$core$List$member, n, stepNames)) && (!A2($elm$core$List$member, n, state_.an));
			},
			allKvs);
		var _v1 = function () {
			if (step.$ === 3) {
				var sq = step.a;
				var stored = A2($pzp1997$assoc_list$AssocList$get, $author$project$Model$FormFieldV2$ScreeningQuestions, formInput_);
				var currentAnswer = function () {
					if ((!stored.$) && (stored.a.$ === 11)) {
						var vs = stored.a.a;
						return A2(
							$elm$core$List$filter,
							function (v) {
								return _Utils_eq(
									v.dY,
									$author$project$Model$FormFieldV2$Custom(sq.dE));
							},
							vs);
					} else {
						return _List_Nil;
					}
				}();
				return _Utils_Tuple2(
					A2(
						$elm$core$List$map,
						function (v) {
							return _Utils_Tuple2(v.dY, v.ey);
						},
						currentAnswer),
					A2(
						$elm$core$List$filter,
						function (_v3) {
							var n = _v3.a;
							return !_Utils_eq(n, $author$project$Model$FormFieldV2$ScreeningQuestions);
						},
						allKvs));
			} else {
				return _Utils_Tuple2(stepKvs, priorKvs);
			}
		}();
		var stepForValidate = _v1.a;
		var priorForValidate = _v1.b;
		return {
			qk: A2($author$project$View$ConversationalFormV2$buildChatHistoryWire, translations, state_),
			Hz: stepForValidate,
			Kq: $author$project$View$ConversationalFormV2$formKeyFromSource(formSource_),
			$_: priorForValidate,
			alw: state_.alw,
			aqL: state_.aqL
		};
	});
var $author$project$View$ConversationalFormV2$clientSideRetryCopy = F2(
	function (translations, field) {
		var _v0 = field.ew;
		switch (_v0.$) {
			case 4:
				return A3($author$project$Data$Translation$translateOr, translations, 'conversational-retry-date', 'Kun je de datum als DD-MM-JJJJ typen, bv. \'12 april 1990\'?');
			case 5:
				return A3($author$project$Data$Translation$translateOr, translations, 'conversational-retry-daypart', 'Tik op de dagdelen die passen, of typ bv. \'maandag ochtend, vrijdag avond\'.');
			case 13:
				return A3($author$project$Data$Translation$translateOr, translations, 'conversational-retry-select-multiple', 'Klik aan wat past, of typ de namen gescheiden door komma\'s (bv. \'haskell, elm\').');
			case 7:
				return A3($author$project$Data$Translation$translateOr, translations, 'conversational-retry-file', 'Upload een bestand, of sla deze vraag over.');
			case 18:
				return A3($author$project$Data$Translation$translateOr, translations, 'conversational-retry-screening-questions', 'Beantwoord de vraag via de knoppen hieronder.');
			default:
				return A3($author$project$Data$Translation$translateOr, translations, 'conversational-retry-default', 'Sorry, dat begreep ik niet — kun je het nog eens anders proberen?');
		}
	});
var $author$project$View$ConversationalFormV2$coerceNonEmptyTextToFieldValue = F3(
	function (defaultCallingCode, fieldType, trimmed) {
		switch (fieldType.$) {
			case 15:
				return $elm$core$Maybe$Just(
					$author$project$Model$FormFieldValueV2$TextValue(trimmed));
			case 16:
				return $elm$core$Maybe$Just(
					$author$project$Model$FormFieldValueV2$TextValue(trimmed));
			case 8:
				return $elm$core$Maybe$Just(
					$author$project$Model$FormFieldValueV2$TextValue(trimmed));
			case 6:
				return $elm$core$Maybe$Just(
					$author$project$Model$FormFieldValueV2$TextValue(
						$elm$core$String$toLower(trimmed)));
			case 17:
				return $elm$core$Maybe$Just(
					$author$project$Model$FormFieldValueV2$TextValue(trimmed));
			case 2:
				return $elm$core$Maybe$Just(
					$author$project$Model$FormFieldValueV2$TextValue(
						$elm$core$String$toUpper(trimmed)));
			case 9:
				return $elm$core$Maybe$Just(
					A2($author$project$Model$FormFieldValueV2$PhoneNumberWithCallingCodeValue, defaultCallingCode, trimmed));
			case 4:
				return $elm$core$Maybe$Just(
					$author$project$Model$FormFieldValueV2$TextValue(trimmed));
			case 10:
				return $elm$core$Maybe$Just(
					$author$project$Model$FormFieldValueV2$TextValue(trimmed));
			case 12:
				return $elm$core$Maybe$Just(
					$author$project$Model$FormFieldValueV2$TextValue(trimmed));
			case 19:
				return $elm$core$Maybe$Just(
					$author$project$Model$FormFieldValueV2$TextValue(trimmed));
			case 1:
				return $elm$core$Maybe$Just(
					$author$project$Model$FormFieldValueV2$TextValue(trimmed));
			case 11:
				return $elm$core$Maybe$Just(
					$author$project$Model$FormFieldValueV2$TextValue(trimmed));
			case 0:
				return $elm$core$Maybe$Just(
					$author$project$Model$FormFieldValueV2$TextValue(trimmed));
			case 13:
				return $elm$core$Maybe$Just(
					$author$project$Model$FormFieldValueV2$TextValue(trimmed));
			case 14:
				var options = fieldType.a;
				var lower = $elm$core$String$toLower(trimmed);
				var match = $elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (_v2) {
							var oid = _v2.a;
							var olabel = _v2.b;
							return _Utils_eq(
								$elm$core$String$toLower(oid),
								lower) || _Utils_eq(
								$elm$core$String$toLower(olabel),
								lower);
						},
						options));
				return A2(
					$elm$core$Maybe$map,
					function (_v1) {
						var oid = _v1.a;
						return $author$project$Model$FormFieldValueV2$SelectValue(
							$elm$core$Maybe$Just(oid));
					},
					match);
			case 7:
				return $elm$core$Maybe$Nothing;
			case 5:
				return $elm$core$Maybe$Just(
					$author$project$Model$FormFieldValueV2$TextValue(trimmed));
			case 18:
				return $elm$core$Maybe$Nothing;
			default:
				return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$View$ConversationalFormV2$coerceTextToFieldValue = F3(
	function (defaultCallingCode, fieldType, rawText) {
		var trimmed = $elm$core$String$trim(rawText);
		return $elm$core$String$isEmpty(trimmed) ? $elm$core$Maybe$Nothing : A3($author$project$View$ConversationalFormV2$coerceNonEmptyTextToFieldValue, defaultCallingCode, fieldType, trimmed);
	});
var $author$project$View$ConversationalFormV2$dayLabelNl = function (day) {
	switch (day) {
		case 0:
			return 'maandag';
		case 1:
			return 'dinsdag';
		case 2:
			return 'woensdag';
		case 3:
			return 'donderdag';
		case 4:
			return 'vrijdag';
		case 5:
			return 'zaterdag';
		default:
			return 'zondag';
	}
};
var $author$project$View$ConversationalFormV2$daypartLabelNl = function (part) {
	switch (part) {
		case 0:
			return 'ochtend';
		case 1:
			return 'middag';
		case 2:
			return 'avond';
		default:
			return 'nacht';
	}
};
var $author$project$View$ConversationalFormV2$daypartSlotsToTokens = function (slots) {
	return A2(
		$elm$core$String$join,
		', ',
		A2(
			$elm$core$List$map,
			function (_v0) {
				var day = _v0.a;
				var daypart = _v0.b;
				return $author$project$View$ConversationalFormV2$dayLabelNl(day) + (' ' + $author$project$View$ConversationalFormV2$daypartLabelNl(daypart));
			},
			slots));
};
var $author$project$View$ConversationalFormV2$prependTokens = F2(
	function (prior, typed) {
		return $elm$core$String$isEmpty(
			$elm$core$String$trim(prior)) ? typed : (prior + (', ' + typed));
	});
var $author$project$View$ConversationalFormV2$mergeExistingSelectionIntoText = F2(
	function (existing, typed) {
		_v0$2:
		while (true) {
			if (!existing.$) {
				switch (existing.a.$) {
					case 6:
						var prior = existing.a.a;
						return A2(
							$author$project$View$ConversationalFormV2$prependTokens,
							A2($elm$core$String$join, ', ', prior),
							typed);
					case 10:
						var prior = existing.a.a;
						return A2(
							$author$project$View$ConversationalFormV2$prependTokens,
							$author$project$View$ConversationalFormV2$daypartSlotsToTokens(prior),
							typed);
					default:
						break _v0$2;
				}
			} else {
				break _v0$2;
			}
		}
		return typed;
	});
var $author$project$View$ConversationalFormV2$coerceComposerIntoForm = F2(
	function (state_, mStep) {
		var trimmed = $elm$core$String$trim(state_.g);
		if ($elm$core$String$isEmpty(trimmed)) {
			return state_;
		} else {
			if ((((!mStep.$) && (mStep.a.$ === 1)) && mStep.a.b.b) && (!mStep.a.b.b.b)) {
				var _v1 = mStep.a;
				var _v2 = _v1.b;
				var field = _v2.a;
				var existing = A2(
					$pzp1997$assoc_list$AssocList$get,
					field.dY,
					$author$project$View$FormV2$getFormInput(state_.IF));
				var coerceInput = A2($author$project$View$ConversationalFormV2$mergeExistingSelectionIntoText, existing, trimmed);
				var _v3 = A3(
					$author$project$View$ConversationalFormV2$coerceTextToFieldValue,
					$author$project$View$ConversationalFormV2$defaultCallingCodeFor(state_.IF),
					field.ew,
					coerceInput);
				if (_v3.$ === 1) {
					return state_;
				} else {
					var value = _v3.a;
					var mergedInput = A3(
						$pzp1997$assoc_list$AssocList$insert,
						field.dY,
						value,
						$author$project$View$FormV2$getFormInput(state_.IF));
					var updatedForm = A2($author$project$View$FormV2$setFormInput, mergedInput, state_.IF);
					return _Utils_update(
						state_,
						{g: '', IF: updatedForm});
				}
			} else {
				return state_;
			}
		}
	});
var $author$project$View$ConversationalFormV2$confirmAcceptMarker = '\uE001accept';
var $author$project$View$ConversationalFormV2$confirmRejectMarker = '\uE002reject';
var $elm$core$Result$toMaybe = function (result) {
	if (!result.$) {
		var v = result.a;
		return $elm$core$Maybe$Just(v);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Data$FieldValidation$decodeFieldName = function (raw) {
	var custom = '{\"tag\":\"custom\",\"contents\":\"' + (raw + '\"}');
	var canonical = '{\"tag\":\"' + (raw + '\"}');
	var _v0 = A2($elm$json$Json$Decode$decodeString, $author$project$Model$FormFieldV2$fieldNameDecoder, canonical);
	if (!_v0.$) {
		var fn = _v0.a;
		return $elm$core$Maybe$Just(fn);
	} else {
		return $elm$core$Result$toMaybe(
			A2($elm$json$Json$Decode$decodeString, $author$project$Model$FormFieldV2$fieldNameDecoder, custom));
	}
};
var $author$project$View$ConversationalFormV2$detectFileUpload = F2(
	function (before, after) {
		var beforeInput = $author$project$View$FormV2$getFormInput(before);
		var wasUploaded = function (_v2) {
			var name = _v2.a;
			var value = _v2.b;
			if ((value.$ === 3) && (!value.a.$)) {
				var f = value.a.a;
				var _v1 = A2($pzp1997$assoc_list$AssocList$get, name, beforeInput);
				if (((!_v1.$) && (_v1.a.$ === 3)) && (!_v1.a.a.$)) {
					var prior = _v1.a.a.a;
					return _Utils_eq(prior.atW, f.atW) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(f.atW);
				} else {
					return $elm$core$Maybe$Just(f.atW);
				}
			} else {
				return $elm$core$Maybe$Nothing;
			}
		};
		var afterInput = $author$project$View$FormV2$getFormInput(after);
		return $elm$core$List$head(
			A2(
				$elm$core$List$filterMap,
				wasUploaded,
				$pzp1997$assoc_list$AssocList$toList(afterInput)));
	});
var $author$project$View$ConversationalFormV2$GotTurnRecorded = F2(
	function (a, b) {
		return {$: 19, a: a, b: b};
	});
var $author$project$Api$Endpoint$conversationTurn = $author$project$Api$Endpoint$endpoint(
	_List_fromArray(
		['application', 'turn']));
var $danyx23$elm_uuid$Uuid$encode = A2($elm$core$Basics$composeR, $danyx23$elm_uuid$Uuid$toString, $elm$json$Json$Encode$string);
var $author$project$Model$ApplicationConversationTurn$Role$encodeRole = function (a) {
	switch (a) {
		case 0:
			return $elm$json$Json$Encode$string('bot-role');
		case 1:
			return $elm$json$Json$Encode$string('user-role');
		case 2:
			return $elm$json$Json$Encode$string('ai-clarification-role');
		default:
			return $elm$json$Json$Encode$string('system-role');
	}
};
var $author$project$Model$ApplicationConversationTurn$Payload$encodeAiClarificationPayload = function (a) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'suggestion',
				$elm$json$Json$Encode$string(a.avL)),
				_Utils_Tuple2(
				'promptText',
				$elm$json$Json$Encode$string(a.avi)),
				_Utils_Tuple2(
				'accepted',
				A3($elm_community$maybe_extra$Maybe$Extra$unwrap, $elm$json$Json$Encode$null, $elm$json$Json$Encode$bool, a.asU)),
				_Utils_Tuple2(
				'model',
				$elm$json$Json$Encode$string(a.Tx)),
				_Utils_Tuple2(
				'latencyMs',
				$elm$json$Json$Encode$int(a.QD))
			]));
};
var $author$project$Model$ApplicationConversationTurn$Payload$encodeBotPayload = function (a) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'text',
				$elm$json$Json$Encode$string(a.alE)),
				_Utils_Tuple2(
				'translations',
				A2(
					$elm$json$Json$Encode$list,
					function (b) {
						var c = b.a;
						var d = b.b;
						return A2(
							$elm$json$Json$Encode$list,
							$elm$core$Basics$identity,
							_List_fromArray(
								[
									$elm$json$Json$Encode$string(c),
									$elm$json$Json$Encode$string(d)
								]));
					},
					a.anB))
			]));
};
var $author$project$Model$ApplicationConversationTurn$Payload$encodeSystemEvent = function (a) {
	switch (a) {
		case 0:
			return $elm$json$Json$Encode$string('privacy-accepted');
		case 1:
			return $elm$json$Json$Encode$string('back-navigated');
		case 2:
			return $elm$json$Json$Encode$string('session-resumed');
		case 3:
			return $elm$json$Json$Encode$string('question-skipped');
		default:
			return $elm$json$Json$Encode$string('reminder-sent');
	}
};
var $author$project$Model$ApplicationConversationTurn$Payload$encodeSystemPayload = function (a) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'event',
				$author$project$Model$ApplicationConversationTurn$Payload$encodeSystemEvent(a.Gs)),
				_Utils_Tuple2(
				'details',
				$elm$json$Json$Encode$string(a.DV))
			]));
};
var $author$project$Api$ConversationTurn$encodeWireUserPayload = function (a) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'rawInput',
				$elm$json$Json$Encode$string(a.aaO)),
				_Utils_Tuple2(
				'sanitizedValue',
				$elm$json$Json$Encode$string(a.aeb)),
				_Utils_Tuple2(
				'structuredValue',
				A3($elm_community$maybe_extra$Maybe$Extra$unwrap, $elm$json$Json$Encode$null, $author$project$Model$FormFieldValueV2$encodeFieldValues, a.akn))
			]));
};
var $author$project$Api$ConversationTurn$encodeWirePayload = function (a) {
	switch (a.$) {
		case 0:
			var b = a.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('wire-bot-p')),
						_Utils_Tuple2(
						'contents',
						$author$project$Model$ApplicationConversationTurn$Payload$encodeBotPayload(b))
					]));
		case 1:
			var b = a.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('wire-user-p')),
						_Utils_Tuple2(
						'contents',
						$author$project$Api$ConversationTurn$encodeWireUserPayload(b))
					]));
		case 2:
			var b = a.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('wire-ai-clarification-p')),
						_Utils_Tuple2(
						'contents',
						$author$project$Model$ApplicationConversationTurn$Payload$encodeAiClarificationPayload(b))
					]));
		default:
			var b = a.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('wire-system-p')),
						_Utils_Tuple2(
						'contents',
						$author$project$Model$ApplicationConversationTurn$Payload$encodeSystemPayload(b))
					]));
	}
};
var $author$project$Api$ConversationTurn$encodeTurnRequest = function (a) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'sessionId',
				$danyx23$elm_uuid$Uuid$encode(a.ag$)),
				_Utils_Tuple2(
				'turnIdx',
				$elm$json$Json$Encode$int(a.anO)),
				_Utils_Tuple2(
				'role',
				$author$project$Model$ApplicationConversationTurn$Role$encodeRole(a.adx)),
				_Utils_Tuple2(
				'fieldName',
				A3($elm_community$maybe_extra$Maybe$Extra$unwrap, $elm$json$Json$Encode$null, $elm$json$Json$Encode$string, a.Ht)),
				_Utils_Tuple2(
				'payload',
				$author$project$Api$ConversationTurn$encodeWirePayload(a._y)),
				_Utils_Tuple2(
				'vacancyId',
				A3($elm_community$maybe_extra$Maybe$Extra$unwrap, $elm$json$Json$Encode$null, $author$project$Data$Id$encode, a.aqL)),
				_Utils_Tuple2(
				'formId',
				A3($elm_community$maybe_extra$Maybe$Extra$unwrap, $elm$json$Json$Encode$null, $author$project$Data$Id$encode, a.Kq)),
				_Utils_Tuple2(
				'templateId',
				A3($elm_community$maybe_extra$Maybe$Extra$unwrap, $elm$json$Json$Encode$null, $author$project$Data$Id$encode, a.alw))
			]));
};
var $NoRedInk$http_upgrade_shim$Http$Legacy$jsonBody = $elm$http$Http$jsonBody;
var $author$project$Effect$ConversationalTranscript$postTurn = F3(
	function (config, turnIdx, rec) {
		var _v0 = A2($elm$core$Maybe$andThen, $danyx23$elm_uuid$Uuid$fromString, config.ag$);
		if (_v0.$ === 1) {
			return $elm$core$Platform$Cmd$none;
		} else {
			var sessionUuid = _v0.a;
			var request = {Ht: rec.Ht, Kq: config.Kq, _y: rec._y, adx: rec.adx, ag$: sessionUuid, alw: config.alw, anO: turnIdx, aqL: config.aqL};
			return A2(
				$author$project$Api$send,
				config.aut(turnIdx),
				A4(
					$author$project$Api$postWithHeader,
					$author$project$Api$Endpoint$conversationTurn,
					_List_fromArray(
						[
							_Utils_Tuple2('X-XSRF-TOKEN', config.ci)
						]),
					$NoRedInk$http_upgrade_shim$Http$Legacy$jsonBody(
						$author$project$Api$ConversationTurn$encodeTurnRequest(request)),
					$elm$json$Json$Decode$succeed(0)));
		}
	});
var $author$project$Effect$ConversationalTranscript$dispatchTurns = F3(
	function (config, state, records) {
		var _v0 = A3(
			$elm$core$List$foldl,
			F2(
				function (rec, _v1) {
					var accCmds = _v1.a;
					var idx = _v1.b;
					return _Utils_Tuple2(
						A2(
							$elm$core$List$cons,
							A3($author$project$Effect$ConversationalTranscript$postTurn, config, idx, rec),
							accCmds),
						idx + 1);
				}),
			_Utils_Tuple2(_List_Nil, state.Vu),
			records);
		var reverseCmds = _v0.a;
		var finalIdx = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				state,
				{Vu: finalIdx}),
			$elm$core$List$reverse(reverseCmds));
	});
var $author$project$View$ConversationalFormV2$dispatchTurns = F3(
	function (config, state, records) {
		var _v0 = A3(
			$author$project$Effect$ConversationalTranscript$dispatchTurns,
			{
				ci: state.ci,
				Kq: $author$project$View$ConversationalFormV2$formKeyFromSource(
					$author$project$View$ConversationalFormV2$formSource(state.IF)),
				aut: function (idx) {
					return A2(
						$elm$core$Basics$composeL,
						config.aut,
						$author$project$View$ConversationalFormV2$GotTurnRecorded(idx));
				},
				ag$: config.ag$,
				alw: state.alw,
				aqL: state.aqL
			},
			{Vu: state.Vu},
			records);
		var updated = _v0.a;
		var cmds = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				state,
				{Vu: updated.Vu}),
			cmds);
	});
var $author$project$View$ConversationalFormV2$dropAutoAnswered = F2(
	function (names, autoAnswered) {
		return A2(
			$elm$core$List$filter,
			function (name) {
				return !A2($elm$core$List$member, name, names);
			},
			autoAnswered);
	});
var $elm$file$File$mime = _File_mime;
var $author$project$View$ConversationalFormV2$mimeAllowed = F2(
	function (options, file) {
		return $elm$core$List$isEmpty(options.Tc) || A2(
			$elm$core$List$member,
			$elm$file$File$mime(file),
			options.Tc);
	});
var $author$project$View$ConversationalFormV2$dropRejection = F3(
	function (translations, options, file) {
		return ((!$elm$file$File$size(file)) || (!A2($author$project$View$ConversationalFormV2$mimeAllowed, options, file))) ? $elm$core$Maybe$Just(
			A3($author$project$Data$Translation$translateOr, translations, 'conversational-dropzone-wrong-type', 'Sorry, I can\'t read that kind of file. Try a different one.')) : ((_Utils_cmp(
			$elm$file$File$size(file),
			options.Sv * 1000000) > 0) ? $elm$core$Maybe$Just(
			A2(
				$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
				A3($author$project$Data$Translation$translateOr, translations, 'conversational-dropzone-too-large', 'That file is too big. {0} MB is the maximum.'),
				_List_fromArray(
					[
						$elm$core$String$fromInt(options.Sv)
					]))) : $elm$core$Maybe$Nothing);
	});
var $author$project$View$ConversationalFormV2$ShowSuccessCard = function (a) {
	return {$: 31, a: a};
};
var $author$project$View$ConversationalFormV2$scrollThreadToBottom = function () {
	var scrollOnce = A2(
		$elm$core$Task$andThen,
		function (info) {
			return A3($elm$browser$Browser$Dom$setViewportOf, 'conversational-form-thread', 0, info.avu.Mq);
		},
		$elm$browser$Browser$Dom$getViewportOf('conversational-form-thread'));
	return A2(
		$elm$core$Task$andThen,
		function (_v1) {
			return scrollOnce;
		},
		A2(
			$elm$core$Task$andThen,
			function (_v0) {
				return A2(
					$elm$core$Task$map,
					$elm$core$Basics$always(0),
					$elm$core$Process$sleep(120));
			},
			scrollOnce));
}();
var $author$project$View$ConversationalFormV2$revealSuccessCardAfterDelay = F2(
	function (config, url) {
		return $elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A2(
					$elm$core$Task$perform,
					function (_v0) {
						return config.aut(
							$author$project$View$ConversationalFormV2$ShowSuccessCard(url));
					},
					$elm$core$Process$sleep(1800)),
					A2(
					$elm$core$Task$attempt,
					$elm$core$Basics$always(
						config.aut($author$project$View$ConversationalFormV2$NoOp)),
					$author$project$View$ConversationalFormV2$scrollThreadToBottom)
				]));
	});
var $author$project$View$ConversationalFormV2$dropFile = F5(
	function (config, _v0, options, fieldName, file) {
		var state_ = _v0;
		var _v1 = A3($author$project$View$ConversationalFormV2$dropRejection, config.anB, options, file);
		if (!_v1.$) {
			var reason = _v1.a;
			return _Utils_Tuple2(
				_Utils_update(
					state_,
					{
						bJ: $elm$core$Maybe$Just(
							_Utils_Tuple2(fieldName, reason))
					}),
				$elm$core$Platform$Cmd$none);
		} else {
			var _v2 = A3(
				$author$project$View$FormV2$update,
				{
					atp: config.ag$,
					aut: A2($elm$core$Basics$composeL, config.aut, $author$project$View$ConversationalFormV2$FormMsg),
					au4: $elm$core$Platform$Cmd$none,
					X1: function (url) {
						return A2($author$project$View$ConversationalFormV2$revealSuccessCardAfterDelay, config, url.av7);
					},
					aaH: config.aaH,
					ac7: config.ac7,
					alw: state_.alw
				},
				A2($author$project$View$FormV2$FileSelected, fieldName, file),
				state_.IF);
			var updatedForm = _v2.a;
			var formCmds = _v2.b;
			return _Utils_Tuple2(
				_Utils_update(
					state_,
					{bJ: $elm$core$Maybe$Nothing, IF: updatedForm}),
				formCmds);
		}
	});
var $author$project$View$ConversationalFormV2$dropStashedValues = F2(
	function (names, stash) {
		return A2(
			$elm$core$List$filter,
			function (_v0) {
				var name = _v0.a;
				return !A2($elm$core$List$member, name, names);
			},
			stash);
	});
var $author$project$View$ConversationalFormV2$fileCrossFieldValues = F2(
	function (incoming, formState) {
		var filed = A2(
			$elm$core$List$filterMap,
			function (entry) {
				return A3(
					$elm$core$Maybe$map2,
					$elm$core$Tuple$pair,
					$author$project$Data$FieldValidation$decodeFieldName(entry.xx),
					entry.xy);
			},
			incoming);
		return {
			eT: filed,
			IF: A2(
				$author$project$View$FormV2$setFormInput,
				A3(
					$elm$core$List$foldl,
					F2(
						function (_v0, acc) {
							var name = _v0.a;
							var value = _v0.b;
							return A3($pzp1997$assoc_list$AssocList$insert, name, value, acc);
						}),
					$author$project$View$FormV2$getFormInput(formState),
					filed),
				formState)
		};
	});
var $author$project$View$ConversationalFormV2$fieldsNamed = F2(
	function (name, formState) {
		var _v0 = $author$project$Data$FormSource$toForm(
			$author$project$View$ConversationalFormV2$formSource(formState)).atV;
		var rawRows = _v0;
		return A2(
			$elm$core$List$take,
			1,
			A2(
				$elm$core$List$filter,
				function (field) {
					return _Utils_eq(field.dY, name) && (!$author$project$View$ConversationalFormV2$isInternalQaField(field));
				},
				$elm$core$List$concat(rawRows)));
	});
var $author$project$View$ConversationalFormV2$filedTurnRecords = F2(
	function (formState, filed) {
		return A2(
			$elm$core$List$filterMap,
			function (_v0) {
				var name = _v0.a;
				var value = _v0.b;
				return A4(
					$author$project$Effect$ConversationalTranscript$buildUserTurnRecord,
					$elm$core$Maybe$Just(
						{
							atV: A2($author$project$View$ConversationalFormV2$fieldsNamed, name, formState),
							avv: $elm$core$Maybe$Nothing
						}),
					_List_fromArray(
						[
							_Utils_Tuple2(name, value)
						]),
					$author$project$Data$FormField$fieldNameToCanonicalText,
					$author$project$View$ConversationalFormV2$renderFieldValue);
			},
			filed);
	});
var $author$project$Effect$ConversationalTranscript$httpErrorToString = function (err) {
	switch (err.$) {
		case 2:
			return 'network';
		case 1:
			return 'timeout';
		case 3:
			var code = err.a;
			return 'status-' + $elm$core$String$fromInt(code);
		case 4:
			return 'decode-error';
		case 5:
			return 'validation-decode-error';
		default:
			return 'bad-url';
	}
};
var $author$project$Page$ConversationalForm$Diagnose$interrogativeFallback = F2(
	function (translations, field) {
		var _v0 = field.dY;
		switch (_v0.$) {
			case 29:
				return A3($author$project$Data$Translation$translateOr, translations, 'conversational-interrogative-first-name', 'Daarmee kunnen we je persoonlijk aanspreken in onze antwoorden. Wat is je voornaam?');
			case 44:
				return A3($author$project$Data$Translation$translateOr, translations, 'conversational-interrogative-last-name', 'Daarmee kunnen we je sollicitatie aan je CV koppelen. Wat is je achternaam?');
			case 28:
				return A3($author$project$Data$Translation$translateOr, translations, 'conversational-interrogative-email', 'Daar sturen we de bevestiging en eventuele uitnodiging heen. Wat is je e-mailadres, bv. naam@voorbeeld.nl?');
			case 14:
				return A3($author$project$Data$Translation$translateOr, translations, 'conversational-interrogative-email', 'Daar sturen we de bevestiging en eventuele uitnodiging heen. Wat is je e-mailadres, bv. naam@voorbeeld.nl?');
			case 57:
				return A3($author$project$Data$Translation$translateOr, translations, 'conversational-interrogative-phone', 'Zo kunnen we je bellen als er een vraag is over je sollicitatie. Wat is je telefoonnummer, bv. 0612345678?');
			case 58:
				return A3($author$project$Data$Translation$translateOr, translations, 'conversational-interrogative-phone', 'Zo kunnen we je bellen als er een vraag is over je sollicitatie. Wat is je telefoonnummer, bv. 0612345678?');
			case 5:
				return A3($author$project$Data$Translation$translateOr, translations, 'conversational-interrogative-address', 'Helpt ons de reisafstand in te schatten. Wat is je adres, bv. \'Hoofdstraat 12, 3052AB Rotterdam\'?');
			case 6:
				return A3($author$project$Data$Translation$translateOr, translations, 'conversational-interrogative-address', 'Helpt ons de reisafstand in te schatten. Wat is je adres, bv. \'Hoofdstraat 12, 3052AB Rotterdam\'?');
			case 13:
				return A3($author$project$Data$Translation$translateOr, translations, 'conversational-interrogative-city', 'Helpt ons de reisafstand in te schatten. In welke plaats woon je?');
			case 61:
				return A3($author$project$Data$Translation$translateOr, translations, 'conversational-interrogative-postal-code', 'Helpt ons de reisafstand in te schatten. Wat is je postcode, bv. 3052AB?');
			case 26:
				return A3($author$project$Data$Translation$translateOr, translations, 'conversational-interrogative-date-of-birth', 'Soms gevraagd voor het HR-contract. Wat is je geboortedatum, bv. 12-04-1990?');
			case 46:
				return A3($author$project$Data$Translation$translateOr, translations, 'conversational-interrogative-linkedin-url', 'Zo kan de recruiter je werk- en netwerkachtergrond bekijken. Wat is je LinkedIn-link?');
			case 47:
				return A3($author$project$Data$Translation$translateOr, translations, 'conversational-interrogative-motivation', 'Helpt ons begrijpen waarom deze rol bij jou past. Schrijf gerust in een paar zinnen wat je aanspreekt.');
			case 48:
				return A3($author$project$Data$Translation$translateOr, translations, 'conversational-interrogative-motivation', 'Helpt ons begrijpen waarom deze rol bij jou past. Schrijf gerust in een paar zinnen wat je aanspreekt.');
			case 64:
				return A3($author$project$Data$Translation$translateOr, translations, 'conversational-interrogative-resume', 'Kun je je CV uploaden? Zo kan de recruiter je ervaring snel bekijken voordat we contact opnemen.');
			case 10:
				return A3($author$project$Data$Translation$translateOr, translations, 'conversational-interrogative-availability', 'Helpt ons je voor te stellen voor diensten die passen. Tik de dagdelen aan die kunnen, of typ bv. \'maandag ochtend, vrijdag avond\'.');
			case 65:
				return A3($author$project$Data$Translation$translateOr, translations, 'conversational-interrogative-salary', 'Helpt ons matchen met de juiste rol. Geef een ruwe indicatie als bedrag of bandbreedte, bv. 3000 of 2800-3400.');
			default:
				var _v1 = field.ew;
				switch (_v1.$) {
					case 6:
						return A3($author$project$Data$Translation$translateOr, translations, 'conversational-interrogative-email-generic', 'Sorry — ik bedoelde je e-mailadres, bv. naam@voorbeeld.nl. Kun je het hier typen?');
					case 9:
						return A3($author$project$Data$Translation$translateOr, translations, 'conversational-interrogative-phone-generic', 'Ik bedoelde je telefoonnummer, bv. 0612345678. Kun je dat typen?');
					case 17:
						return A3($author$project$Data$Translation$translateOr, translations, 'conversational-interrogative-url-generic', 'Ik bedoelde een link, bv. https://www.voorbeeld.nl. Kun je die typen?');
					case 4:
						return A3($author$project$Data$Translation$translateOr, translations, 'conversational-interrogative-date-generic', 'Ik bedoelde een datum, bv. 12-04-1990 of \'12 april 1990\'. Kun je die typen?');
					case 0:
						return A3($author$project$Data$Translation$translateOr, translations, 'conversational-interrogative-address-generic', 'Ik bedoelde je adres, bv. \'Hoofdstraat 12, 3052AB Rotterdam\'. Kun je dat typen?');
					default:
						return A3($author$project$Data$Translation$translateOr, translations, 'conversational-interrogative-default', 'Geen probleem — typ je antwoord gewoon in het tekstvak hieronder.');
				}
		}
	});
var $author$project$View$ConversationalFormV2$isCustomFieldName = function (name) {
	if (name.$ === 16) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Page$ConversationalForm$Diagnose$isInterrogativeStem = function (raw) {
	var trimmed = $elm$core$String$trim(raw);
	var stems = _List_fromArray(
		['waarom ', 'wat ', 'hoe ', 'wie ', 'waar ', 'wanneer ', 'welk ', 'welke ', 'why ', 'what ', 'how ', 'who ', 'where ', 'when ', 'which ', 'warum ', 'wieso ', 'wann ', 'welche ', 'pourquoi ', 'comment ', 'que ', 'qui ', 'quel ', 'quelle ']);
	var lowered = $elm$core$String$toLower(trimmed);
	return ($elm$core$String$length(trimmed) < 80) && (A2($elm$core$String$contains, '?', trimmed) || A2(
		$elm$core$List$any,
		function (stem) {
			return A2($elm$core$String$startsWith, stem, lowered);
		},
		stems));
};
var $author$project$Page$ConversationalForm$Diagnose$isPlaceholderToken = function (raw) {
	var lowered = $elm$core$String$toLower(
		$elm$core$String$trim(raw));
	var corpus = _List_fromArray(
		['test', 'testing', 'tester', 'asdf', 'asdfg', 'asdfgh', 'asdfghjkl', 'qwerty', 'qwertz', 'zxcv', 'abc', 'abcd', 'abcdef', 'xyz', 'blah', 'lorem', 'lorem ipsum', 'ipsum', 'foo', 'bar', 'foobar', '1234', '12345', '123456', '1234567', '12345678', '0000', '00000', 'aaaa', 'aaaaa', 'bbbb', '....', '...', '.', '-', '--', 'x', 'xx', 'xxx', 'xxxx', 'anonymous', 'anoniem', 'unknown', 'onbekend', 'null', 'void']);
	return A2(
		$elm$core$List$any,
		function (p) {
			return _Utils_eq(lowered, p);
		},
		corpus);
};
var $author$project$Page$ConversationalForm$Diagnose$stripTrailingPunctuation = function (s) {
	stripTrailingPunctuation:
	while (true) {
		var ch = $elm$core$List$reverse(
			$elm$core$String$toList(s));
		if (ch.b) {
			var c = ch.a;
			if (A2(
				$elm$core$List$member,
				c,
				_List_fromArray(
					['.', '!', '?', ';', ':', ' ']))) {
				var $temp$s = A2($elm$core$String$dropRight, 1, s);
				s = $temp$s;
				continue stripTrailingPunctuation;
			} else {
				return s;
			}
		} else {
			return s;
		}
	}
};
var $author$project$Page$ConversationalForm$Diagnose$isRefusalPhrase = function (raw) {
	var trimmed = $elm$core$String$trim(raw);
	var starters = _List_fromArray(
		['nee ', 'nee,', 'nee.', 'nee:', 'no ', 'no,', 'no.', 'nein ', 'nein,', 'non ', 'non,', 'niet ', 'niet,', 'wil ik niet ', 'wil ik liever niet ']);
	var phrases = _List_fromArray(
		['geen idee', 'weet ik niet', 'weet niet', 'geen mening', 'n.v.t', 'nvt', 'n/a', 'geen', 'niets', 'niks', 'heb ik niet', 'die heb ik niet', 'stuur ik later op', 'later', 'skip', 'overslaan', 'wil ik niet geven', 'dat wil ik niet geven', 'wil ik liever niet geven', 'wil ik niet zeggen', 'dat zeg ik niet', 'dat geef ik niet', 'geef ik niet', 'liever niet', 'i don\'t know', 'i dont know', 'no idea', 'dunno', 'na', 'none', 'i don\'t have one', 'dont have one', 'i\'d rather not say', 'id rather not say', 'rather not say', 'prefer not to say', 'keine ahnung', 'weiß nicht', 'weiss nicht', 'habe ich nicht', 'lieber nicht', 'je ne sais pas', 'aucune idée', 'aucune idee', 'je n\'en ai pas', 'je préfère ne pas']);
	var lowered = $author$project$Page$ConversationalForm$Diagnose$stripTrailingPunctuation(
		$elm$core$String$toLower(trimmed));
	var startsWithRefusal = (($elm$core$String$length(trimmed) < 80) && ((lowered === 'nee') || ((lowered === 'no') || ((lowered === 'nein') || ((lowered === 'non') || (lowered === 'niet')))))) || A2(
		$elm$core$List$any,
		function (s) {
			return A2($elm$core$String$startsWith, s, lowered);
		},
		starters);
	return A2(
		$elm$core$List$any,
		function (p) {
			return _Utils_eq(lowered, p);
		},
		phrases) || startsWithRefusal;
};
var $author$project$Page$ConversationalForm$Diagnose$isInterrogativeInput = function (raw) {
	return $author$project$Page$ConversationalForm$Diagnose$isInterrogativeStem(raw) || ($author$project$Page$ConversationalForm$Diagnose$isRefusalPhrase(raw) || $author$project$Page$ConversationalForm$Diagnose$isPlaceholderToken(raw));
};
var $author$project$View$ConversationalFormV2$isMobileWidth = function (w) {
	return $author$project$Browser$Dom$Breakpoint$isMobile(w);
};
var $author$project$Analytics$Conversational$maybeString = A2(
	$elm$core$Basics$composeR,
	$elm$core$Maybe$map($elm$json$Json$Encode$string),
	$elm$core$Maybe$withDefault($elm$json$Json$Encode$null));
var $author$project$Analytics$Conversational$maybeVacancy = A2(
	$elm$core$Basics$composeR,
	$elm$core$Maybe$map($author$project$Data$Id$encode),
	$elm$core$Maybe$withDefault($elm$json$Json$Encode$null));
var $author$project$View$ConversationalFormV2$pendingBotIdxFor = F2(
	function (reducedMotion, idx) {
		return reducedMotion ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(idx);
	});
var $author$project$View$ConversationalFormV2$stepIdxForFieldNameValue = F2(
	function (name, steps) {
		return A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$first,
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (_v0) {
						var step = _v0.b;
						var _v1 = $author$project$View$ConversationalFormV2$firstFieldOfStep(step);
						if (!_v1.$) {
							var field = _v1.a;
							return _Utils_eq(field.dY, name);
						} else {
							return false;
						}
					},
					A2($elm$core$List$indexedMap, $elm$core$Tuple$pair, steps))));
	});
var $author$project$View$ConversationalFormV2$popHistory = F2(
	function (steps, history) {
		popHistory:
		while (true) {
			if (!history.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var name = history.a;
				var rest = history.b;
				var _v1 = A2($author$project$View$ConversationalFormV2$stepIdxForFieldNameValue, name, steps);
				if (!_v1.$) {
					var idx = _v1.a;
					return $elm$core$Maybe$Just(
						_Utils_Tuple2(idx, rest));
				} else {
					var $temp$steps = steps,
						$temp$history = rest;
					steps = $temp$steps;
					history = $temp$history;
					continue popHistory;
				}
			}
		}
	});
var $author$project$Data$FieldValidation$conversationalSessionHeader = function (maybeSessionId) {
	if (!maybeSessionId.$) {
		var sessionId = maybeSessionId.a;
		return _List_fromArray(
			[
				_Utils_Tuple2('X-Conversational-Session-Id', sessionId)
			]);
	} else {
		return _List_Nil;
	}
};
var $author$project$Tafkar$AiAssist$ConversationContext$encodeChatTurnRole = function (a) {
	if (!a) {
		return $elm$json$Json$Encode$string('bot');
	} else {
		return $elm$json$Json$Encode$string('applicant');
	}
};
var $author$project$Tafkar$AiAssist$ConversationContext$encodeChatTurn = function (a) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'role',
				$author$project$Tafkar$AiAssist$ConversationContext$encodeChatTurnRole(a.adx)),
				_Utils_Tuple2(
				'text',
				$elm$json$Json$Encode$string(a.alE)),
				_Utils_Tuple2(
				'fieldName',
				$elm$json$Json$Encode$string(a.Ht))
			]));
};
var $author$project$Api$FieldValidation$encodeFieldValidationRequest = function (a) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'formId',
				A3($elm_community$maybe_extra$Maybe$Extra$unwrap, $elm$json$Json$Encode$null, $author$project$Data$Id$encode, a.Kq)),
				_Utils_Tuple2(
				'vacancyId',
				A3($elm_community$maybe_extra$Maybe$Extra$unwrap, $elm$json$Json$Encode$null, $author$project$Data$Id$encode, a.aqL)),
				_Utils_Tuple2(
				'templateId',
				A3($elm_community$maybe_extra$Maybe$Extra$unwrap, $elm$json$Json$Encode$null, $author$project$Data$Id$encode, a.alw)),
				_Utils_Tuple2(
				'fieldValues',
				$author$project$Model$FormFieldValueV2$encodeFieldValues(a.Hz)),
				_Utils_Tuple2(
				'priorFieldValues',
				$author$project$Model$FormFieldValueV2$encodeFieldValues(a.$_)),
				_Utils_Tuple2(
				'chatHistory',
				A2($elm$json$Json$Encode$list, $author$project$Tafkar$AiAssist$ConversationContext$encodeChatTurn, a.qk))
			]));
};
var $author$project$Api$Endpoint$fieldValidate = $author$project$Api$Endpoint$endpoint(
	_List_fromArray(
		['form', 'field-validate']));
var $author$project$Api$FieldValidation$FieldValidationResponse = F4(
	function (sanitizedValues, errors, aiSuggestions, crossFieldValues) {
		return {iT: aiSuggestions, xA: crossFieldValues, Gk: errors, aec: sanitizedValues};
	});
var $author$project$Api$FieldValidation$AiSuggestion = F7(
	function (suggestionFieldName, suggestionRaw, suggestionTranslations, suggestionToken, suggestionAction, suggestionModel, suggestionLatencyMs) {
		return {akP: suggestionAction, akQ: suggestionFieldName, akR: suggestionLatencyMs, akS: suggestionModel, akT: suggestionRaw, akU: suggestionToken, akV: suggestionTranslations};
	});
var $author$project$Api$FieldValidation$aiSuggestionDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'suggestionLatencyMs',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'suggestionModel',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'suggestionAction',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'suggestionToken',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'suggestionTranslations',
					$elm$json$Json$Decode$list(
						A3(
							$elm$json$Json$Decode$map2,
							$elm$core$Tuple$pair,
							A2($elm$json$Json$Decode$index, 0, $elm$json$Json$Decode$string),
							A2($elm$json$Json$Decode$index, 1, $elm$json$Json$Decode$string))),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'suggestionRaw',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'suggestionFieldName',
							$elm$json$Json$Decode$string,
							$elm$json$Json$Decode$succeed($author$project$Api$FieldValidation$AiSuggestion))))))));
var $author$project$Api$FieldValidation$CrossFieldValue = F3(
	function (crossFieldName, crossFieldValue, crossFieldStored) {
		return {xx: crossFieldName, xy: crossFieldStored, xz: crossFieldValue};
	});
var $author$project$Api$FieldValidation$crossFieldValueDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'crossFieldStored',
	$elm$json$Json$Decode$nullable($author$project$Model$FormFieldValueV2$fieldValueDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'crossFieldValue',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'crossFieldName',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$FieldValidation$CrossFieldValue))));
var $author$project$Api$FieldValidation$fieldValidationResponseDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'crossFieldValues',
	$elm$json$Json$Decode$list($author$project$Api$FieldValidation$crossFieldValueDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'aiSuggestions',
		$elm$json$Json$Decode$list($author$project$Api$FieldValidation$aiSuggestionDecoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'errors',
			$author$project$Api$ValidationResponse$validationResponseDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'sanitizedValues',
				$author$project$Model$FormFieldValueV2$fieldValuesDecoder,
				$elm$json$Json$Decode$succeed($author$project$Api$FieldValidation$FieldValidationResponse)))));
var $author$project$Data$FieldValidation$post = F3(
	function (csrfToken, maybeSessionId, request) {
		return A4(
			$author$project$Api$postWithHeader,
			$author$project$Api$Endpoint$fieldValidate,
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2('X-XSRF-TOKEN', csrfToken),
				$author$project$Data$FieldValidation$conversationalSessionHeader(maybeSessionId)),
			$NoRedInk$http_upgrade_shim$Http$Legacy$jsonBody(
				$author$project$Api$FieldValidation$encodeFieldValidationRequest(request)),
			$author$project$Api$FieldValidation$fieldValidationResponseDecoder);
	});
var $author$project$View$ConversationalFormV2$GotConfirmation = F2(
	function (a, b) {
		return {$: 17, a: a, b: b};
	});
var $author$project$View$ConversationalFormV2$formIdFromState = function (s) {
	var _v0 = $author$project$View$ConversationalFormV2$formSource(s);
	if (_v0.$ === 1) {
		var entity = _v0.a;
		return $elm$core$Maybe$Just(
			$author$project$View$ConversationalFormV2$formEntityId(entity));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$FieldValidation$encodeFieldValidateConfirmRequest = function (a) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'confirmFormId',
				A3($elm_community$maybe_extra$Maybe$Extra$unwrap, $elm$json$Json$Encode$null, $author$project$Data$Id$encode, a.sh)),
				_Utils_Tuple2(
				'confirmVacancyId',
				A3($elm_community$maybe_extra$Maybe$Extra$unwrap, $elm$json$Json$Encode$null, $author$project$Data$Id$encode, a.sm)),
				_Utils_Tuple2(
				'confirmPriorFieldValues',
				$author$project$Model$FormFieldValueV2$encodeFieldValues(a.si)),
				_Utils_Tuple2(
				'confirmToken',
				$elm$json$Json$Encode$string(a.sl)),
				_Utils_Tuple2(
				'confirmAccepted',
				$elm$json$Json$Encode$bool(a.r4)),
				_Utils_Tuple2(
				'confirmTemplateId',
				A3($elm_community$maybe_extra$Maybe$Extra$unwrap, $elm$json$Json$Encode$null, $author$project$Data$Id$encode, a.sk))
			]));
};
var $author$project$Api$Endpoint$fieldValidateConfirm = $author$project$Api$Endpoint$endpoint(
	_List_fromArray(
		['form', 'field-validate', 'confirm']));
var $author$project$Api$FieldValidation$FieldValidateConfirmResponse = F4(
	function (confirmAccepted_, confirmFieldName, confirmSanitizedValue, confirmErrors) {
		return {r5: confirmAccepted_, sf: confirmErrors, sg: confirmFieldName, sj: confirmSanitizedValue};
	});
var $author$project$Api$FieldValidation$fieldValidateConfirmResponseDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'confirmErrors',
	$author$project$Api$ValidationResponse$validationResponseDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'confirmSanitizedValue',
		$elm$json$Json$Decode$nullable($author$project$Model$FormFieldValueV2$fieldValueDecoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'confirmFieldName',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'confirmAccepted_',
				$elm$json$Json$Decode$bool,
				$elm$json$Json$Decode$succeed($author$project$Api$FieldValidation$FieldValidateConfirmResponse)))));
var $author$project$Data$FieldValidation$postConfirm = F2(
	function (csrfToken, request) {
		return A4(
			$author$project$Api$postWithHeader,
			$author$project$Api$Endpoint$fieldValidateConfirm,
			_List_fromArray(
				[
					_Utils_Tuple2('X-XSRF-TOKEN', csrfToken)
				]),
			$NoRedInk$http_upgrade_shim$Http$Legacy$jsonBody(
				$author$project$Api$FieldValidation$encodeFieldValidateConfirmRequest(request)),
			$author$project$Api$FieldValidation$fieldValidateConfirmResponseDecoder);
	});
var $author$project$Api$httpLegacyToResponseError = function (err) {
	switch (err.$) {
		case 3:
			var body = err.a._;
			var status = err.a.fL;
			var _v1 = status.eN;
			if (_v1 === 400) {
				return $author$project$Api$decodeValidationError(body);
			} else {
				var code = _v1;
				return $author$project$Api$HttpError(
					A2($author$project$Api$BadStatus, code, body));
			}
		case 0:
			var url = err.a;
			return $author$project$Api$HttpError(
				$author$project$Api$BadUrl(url));
		case 1:
			return $author$project$Api$HttpError($author$project$Api$Timeout);
		case 2:
			return $author$project$Api$HttpError($author$project$Api$NetworkError);
		default:
			var error = err.a;
			return $author$project$Api$HttpError(
				$author$project$Api$DecodeError(error));
	}
};
var $author$project$Api$sendWithValidation = function (msg) {
	return $NoRedInk$http_upgrade_shim$Http$Legacy$send(
		A2(
			$elm$core$Basics$composeL,
			msg,
			$elm$core$Result$mapError($author$project$Api$httpLegacyToResponseError)));
};
var $author$project$View$ConversationalFormV2$postConfirmCmd = F4(
	function (config, _v0, accepted, suggestion) {
		var state_ = _v0;
		var priorValues = $pzp1997$assoc_list$AssocList$toList(
			$author$project$View$FormV2$getFormInput(state_.IF));
		return A2(
			$author$project$Api$sendWithValidation,
			A2(
				$elm$core$Basics$composeL,
				config.aut,
				$author$project$View$ConversationalFormV2$GotConfirmation(suggestion)),
			A2(
				$author$project$Data$FieldValidation$postConfirm,
				state_.ci,
				{
					r4: accepted,
					sh: $author$project$View$ConversationalFormV2$formIdFromState(state_.IF),
					si: priorValues,
					sk: state_.alw,
					sl: suggestion.akU,
					sm: state_.aqL
				}));
	});
var $author$project$Api$Endpoint$conversationalApplyIntent = $author$project$Api$Endpoint$endpoint(
	_List_fromArray(
		['conversational-apply', 'intent']));
var $author$project$Api$ConversationalApplyIntent$encodeKnownFieldDto = function (a) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'knownFieldNameDto',
				$elm$json$Json$Encode$string(a.Qb)),
				_Utils_Tuple2(
				'knownFieldLabelDto',
				$elm$json$Json$Encode$string(a.Qa))
			]));
};
var $author$project$Api$ConversationalApplyIntent$encodeIntentRequest = function (a) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'currentField',
				$elm$json$Json$Encode$string(a.xP)),
				_Utils_Tuple2(
				'currentQuestion',
				$elm$json$Json$Encode$string(a.xV)),
				_Utils_Tuple2(
				'knownFields',
				A2($elm$json$Json$Encode$list, $author$project$Api$ConversationalApplyIntent$encodeKnownFieldDto, a.Qc)),
				_Utils_Tuple2(
				'langCode',
				$elm$json$Json$Encode$string(a.Ql)),
				_Utils_Tuple2(
				'rawText',
				$elm$json$Json$Encode$string(a.aaQ))
			]));
};
var $author$project$Effect$ConversationalApplyIntent$Answer = {$: 0};
var $author$project$Effect$ConversationalApplyIntent$CorrectPending = function (a) {
	return {$: 2, a: a};
};
var $author$project$Effect$ConversationalApplyIntent$CorrectWithValue = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Effect$ConversationalApplyIntent$intentFromOk = function (r) {
	var _v0 = r.Oc;
	switch (_v0) {
		case 'correct-with-value':
			var _v1 = _Utils_Tuple2(r.Ob, r.Od);
			if ((!_v1.a.$) && (!_v1.b.$)) {
				var f = _v1.a.a;
				var v = _v1.b.a;
				return A2($author$project$Effect$ConversationalApplyIntent$CorrectWithValue, f, v);
			} else {
				return $author$project$Effect$ConversationalApplyIntent$Answer;
			}
		case 'correct-pending':
			var _v2 = r.Ob;
			if (!_v2.$) {
				var f = _v2.a;
				return $author$project$Effect$ConversationalApplyIntent$CorrectPending(f);
			} else {
				return $author$project$Effect$ConversationalApplyIntent$Answer;
			}
		default:
			return $author$project$Effect$ConversationalApplyIntent$Answer;
	}
};
var $author$project$Effect$ConversationalApplyIntent$intentFromResponse = A2(
	$elm$core$Basics$composeR,
	$elm$core$Result$toMaybe,
	A2(
		$elm$core$Basics$composeR,
		$elm$core$Maybe$map($author$project$Effect$ConversationalApplyIntent$intentFromOk),
		$elm$core$Maybe$withDefault($author$project$Effect$ConversationalApplyIntent$Answer)));
var $author$project$Api$ConversationalApplyIntent$IntentResponse = F3(
	function (intentTag, intentField, intentValue) {
		return {Ob: intentField, Oc: intentTag, Od: intentValue};
	});
var $author$project$Api$ConversationalApplyIntent$intentResponseDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'intentValue',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'intentField',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'intentTag',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$ConversationalApplyIntent$IntentResponse))));
var $author$project$Effect$ConversationalApplyIntent$postIntent = function (config) {
	var request = {
		xP: config.xP,
		xV: config.xV,
		Qc: A2(
			$elm$core$List$map,
			function (f) {
				return {Qa: f.bO, Qb: f.dY};
			},
			config.Qc),
		Ql: config.Ql,
		aaQ: config.aaQ
	};
	return A2(
		$author$project$Api$send,
		A2($elm$core$Basics$composeL, config.aut, $author$project$Effect$ConversationalApplyIntent$intentFromResponse),
		A4(
			$author$project$Api$postWithHeader,
			$author$project$Api$Endpoint$conversationalApplyIntent,
			_List_fromArray(
				[
					_Utils_Tuple2('X-XSRF-TOKEN', config.ci)
				]),
			$NoRedInk$http_upgrade_shim$Http$Legacy$jsonBody(
				$author$project$Api$ConversationalApplyIntent$encodeIntentRequest(request)),
			$author$project$Api$ConversationalApplyIntent$intentResponseDecoder));
};
var $author$project$View$ConversationalFormV2$nonEmptyString = function (s) {
	return $elm$core$String$isEmpty(
		$elm$core$String$trim(s)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(s);
};
var $author$project$View$ConversationalFormV2$rawInputFor = F2(
	function (field, formState) {
		return A2(
			$elm$core$Maybe$andThen,
			function (v) {
				_v0$8:
				while (true) {
					switch (v.$) {
						case 0:
							var t = v.a;
							return $elm$core$Maybe$Just(t);
						case 8:
							var t = v.b;
							return $elm$core$Maybe$Just(t);
						case 7:
							var n = v.a;
							return $elm$core$Maybe$Just(
								$elm$core$String$fromInt(n));
						case 5:
							if (!v.a.$) {
								var t = v.a.a;
								return $elm$core$Maybe$Just(t);
							} else {
								break _v0$8;
							}
						case 4:
							var t = v.a;
							return $elm$core$Maybe$Just(t);
						case 9:
							var _v1 = v.a;
							var a = _v1.b;
							return $author$project$View$ConversationalFormV2$nonEmptyString(
								$elm$core$String$trim(
									A2(
										$elm$core$String$join,
										' ',
										_List_fromArray(
											[a.aj8, a.M3, a.$B, a.qM]))));
						case 6:
							var items = v.a;
							return $author$project$View$ConversationalFormV2$nonEmptyString(
								A2($elm$core$String$join, ', ', items));
						case 10:
							var slots = v.a;
							return $author$project$View$ConversationalFormV2$nonEmptyString(
								A2(
									$elm$core$String$join,
									', ',
									A2(
										$elm$core$List$map,
										function (_v2) {
											var day = _v2.a;
											var daypart = _v2.b;
											return $author$project$View$ConversationalFormV2$dayLabelNl(day) + (' ' + $author$project$View$ConversationalFormV2$daypartLabelNl(daypart));
										},
										slots)));
						default:
							break _v0$8;
					}
				}
				return $elm$core$Maybe$Nothing;
			},
			A2(
				$pzp1997$assoc_list$AssocList$get,
				field.dY,
				$author$project$View$FormV2$getFormInput(formState)));
	});
var $author$project$View$ConversationalFormV2$stashedValueFor = F2(
	function (name, stash) {
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				$elm$core$Tuple$second,
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (_v0) {
							var stashedName = _v0.a;
							return _Utils_eq(stashedName, name);
						},
						stash))));
	});
var $author$project$View$ConversationalFormV2$previousRawInputAtStep = F2(
	function (stepIdx, state_) {
		var steps = $author$project$View$ConversationalFormV2$visibleSteps(state_.IF);
		var mField = A2(
			$elm$core$Maybe$andThen,
			$author$project$View$ConversationalFormV2$firstFieldOfStep,
			$elm$core$List$head(
				A2($elm$core$List$drop, stepIdx, steps)));
		if (!mField.$) {
			var field = mField.a;
			var _v1 = A2($author$project$View$ConversationalFormV2$rawInputFor, field, state_.IF);
			if (!_v1.$) {
				var raw = _v1.a;
				return raw;
			} else {
				return A2($author$project$View$ConversationalFormV2$stashedValueFor, field.dY, state_.X);
			}
		} else {
			return '';
		}
	});
var $author$project$View$ConversationalFormV2$questionFieldKey = function (step) {
	return A2(
		$elm$core$Maybe$map,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.dY;
			},
			$author$project$Data$FormField$fieldNameToCanonicalText),
		$author$project$View$ConversationalFormV2$firstFieldOfStep(step));
};
var $author$project$Model$ApplicationConversationTurn$Payload$QuestionSkipped = 3;
var $author$project$Model$ApplicationConversationTurn$Role$SystemRole = 3;
var $author$project$Api$ConversationTurn$WireSystemP = function (a) {
	return {$: 3, a: a};
};
var $author$project$Effect$ConversationalTranscript$questionSkippedTurn = function (fieldName) {
	return {
		Ht: $elm$core$Maybe$Just(fieldName),
		_y: $author$project$Api$ConversationTurn$WireSystemP(
			{DV: fieldName, Gs: 3}),
		adx: 3
	};
};
var $author$project$View$ConversationalFormV2$isPrivacyStep = function (step) {
	if (step.$ === 2) {
		return true;
	} else {
		return false;
	}
};
var $author$project$View$ConversationalFormV2$questionStepCount = A2(
	$elm$core$Basics$composeR,
	$elm$core$List$filter(
		function (step) {
			return (!$author$project$View$ConversationalFormV2$isPrivacyStep(step)) && (!$author$project$View$ConversationalFormV2$stepIsNarratorContent(step));
		}),
	$elm$core$List$length);
var $author$project$View$ConversationalFormV2$recordBotReask = F3(
	function (stepIdx, textToShow, state_) {
		if ($elm$core$String$isEmpty(
			$elm$core$String$trim(textToShow))) {
			return state_;
		} else {
			var existing = A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2($elm$core$Dict$get, stepIdx, state_.H));
			var withAppend = _Utils_eq(
				$elm$core$List$head(
					$elm$core$List$reverse(existing)),
				$elm$core$Maybe$Just(textToShow)) ? existing : _Utils_ap(
				existing,
				_List_fromArray(
					[textToShow]));
			return _Utils_update(
				state_,
				{
					H: A3($elm$core$Dict$insert, stepIdx, withAppend, state_.H)
				});
		}
	});
var $author$project$View$ConversationalFormV2$suggestionTextForDomain = function (sugg) {
	var domainLang = $author$project$Util$LangCode$toString($author$project$Copy$language);
	var matchDomain = function (_v2) {
		var langCode = _v2.a;
		return _Utils_eq(langCode, domainLang);
	};
	var _v0 = A2($elm$core$List$filter, matchDomain, sugg.akV);
	if (_v0.b) {
		var _v1 = _v0.a;
		var text = _v1.b;
		return $elm$core$Maybe$Just(text);
	} else {
		return A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$second,
			$elm$core$List$head(sugg.akV));
	}
};
var $author$project$View$ConversationalFormV2$recordAiBubbles = F3(
	function (stepIdx, suggestions, state_) {
		return A3(
			$elm$core$List$foldl,
			F2(
				function (sugg, acc) {
					var _v0 = $author$project$View$ConversationalFormV2$suggestionTextForDomain(sugg);
					if (!_v0.$) {
						var text = _v0.a;
						return A3($author$project$View$ConversationalFormV2$recordBotReask, stepIdx, text, acc);
					} else {
						return acc;
					}
				}),
			state_,
			suggestions);
	});
var $author$project$View$ConversationalFormV2$recordUserAttempt = F3(
	function (stepIdx, textToShow, state_) {
		if ($elm$core$String$isEmpty(
			$elm$core$String$trim(textToShow))) {
			return state_;
		} else {
			var existing = A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2($elm$core$Dict$get, stepIdx, state_.I));
			return _Utils_update(
				state_,
				{
					I: A3(
						$elm$core$Dict$insert,
						stepIdx,
						_Utils_ap(
							existing,
							_List_fromArray(
								[textToShow])),
						state_.I)
				});
		}
	});
var $author$project$View$ConversationalFormV2$rejectedElsewhere = function (state_) {
	var submittedNow = A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			$author$project$View$ConversationalFormV2$fieldNamesOfStep,
			$elm$core$List$head(
				A2(
					$elm$core$List$drop,
					state_.a,
					$author$project$View$ConversationalFormV2$visibleSteps(state_.IF)))));
	return A2(
		$elm$core$List$filter,
		function (name) {
			return !A2($elm$core$List$member, name, submittedNow);
		},
		state_.an);
};
var $author$project$View$ConversationalFormV2$genericRetryCopy = F2(
	function (translations, field) {
		var _v0 = field.ew;
		if (_v0.$ === 4) {
			return A3($author$project$Data$Translation$translateOr, translations, 'conversational-retry-date', 'Kun je de datum als DD-MM-JJJJ typen, of bijvoorbeeld \'12 april 1990\'?');
		} else {
			return A3($author$project$Data$Translation$translateOr, translations, 'conversational-retry-default', 'Sorry, dat begreep ik niet — kun je het nog eens anders proberen?');
		}
	});
var $author$project$View$ConversationalFormV2$joinSentences = F2(
	function (first, second) {
		var endsSentence = A2(
			$elm$core$List$any,
			function (p) {
				return A2($elm$core$String$endsWith, p, first);
			},
			_List_fromArray(
				['.', '!', '?']));
		return endsSentence ? (first + (' ' + second)) : (first + ('. ' + second));
	});
var $author$project$View$ConversationalFormV2$serverFieldError = F2(
	function (formState, fieldName) {
		var _v0 = $author$project$View$FormV2$submitStatus(formState);
		if ((_v0.$ === 2) && (!_v0.a.$)) {
			var response = _v0.a.a;
			return A2(
				$author$project$Api$toValidationError,
				$author$project$Data$Form$fieldNameToString(fieldName),
				$elm$core$Maybe$Just(response));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$View$ConversationalFormV2$retryTextForField = F3(
	function (translations, formState, field) {
		var raw = A2($author$project$View$ConversationalFormV2$rawInputFor, field, formState);
		var _v0 = _Utils_Tuple2(
			raw,
			$author$project$Page$ConversationalForm$Diagnose$isInterrogativeInput(
				A2($elm$core$Maybe$withDefault, '', raw)));
		if ((!_v0.a.$) && _v0.b) {
			var _v1 = A2($author$project$View$ConversationalFormV2$serverFieldError, formState, field.dY);
			if (!_v1.$) {
				var serverMsg = _v1.a;
				return A2(
					$author$project$View$ConversationalFormV2$joinSentences,
					serverMsg,
					A2($author$project$Page$ConversationalForm$Diagnose$interrogativeFallback, translations, field));
			} else {
				return A2($author$project$Page$ConversationalForm$Diagnose$interrogativeFallback, translations, field);
			}
		} else {
			var _v2 = A2($author$project$View$ConversationalFormV2$serverFieldError, formState, field.dY);
			if (!_v2.$) {
				var serverMsg = _v2.a;
				return serverMsg;
			} else {
				return A2($author$project$View$ConversationalFormV2$genericRetryCopy, translations, field);
			}
		}
	});
var $author$project$View$FormV2$setSubmitStatus = F2(
	function (status, _v0) {
		var state = _v0;
		return _Utils_update(
			state,
			{bq: status});
	});
var $author$project$View$ConversationalFormV2$routeToSubmitError = F4(
	function (config, state_, updatedForm, targetIdx) {
		var steps = $author$project$View$ConversationalFormV2$visibleSteps(updatedForm);
		var targetFieldM = A2(
			$elm$core$Maybe$andThen,
			$author$project$View$ConversationalFormV2$firstFieldOfStep,
			$elm$core$List$head(
				A2($elm$core$List$drop, targetIdx, steps)));
		var serverVerdict = function (field) {
			return A2($author$project$View$ConversationalFormV2$serverFieldError, updatedForm, field.dY);
		};
		var reaskText = function () {
			if (!targetFieldM.$) {
				var field = targetFieldM.a;
				return A2($author$project$Page$ConversationalForm$Diagnose$interrogativeFallback, config.anB, field);
			} else {
				return A3($author$project$Data$Translation$translateOr, config.anB, 'conversational-retry-default', 'Sorry, dat begreep ik niet — kun je het nog eens anders proberen?');
			}
		}();
		var explainText = function () {
			var _v0 = A2($elm$core$Maybe$andThen, serverVerdict, targetFieldM);
			if (!_v0.$) {
				var verdict = _v0.a;
				return A2($author$project$View$ConversationalFormV2$joinSentences, verdict, reaskText);
			} else {
				return reaskText;
			}
		}();
		var baseState = _Utils_update(
			state_,
			{
				H: A2($elm$core$Dict$remove, targetIdx, state_.H),
				I: A2($elm$core$Dict$remove, targetIdx, state_.I),
				g: A2(
					$author$project$View$ConversationalFormV2$previousRawInputAtStep,
					targetIdx,
					_Utils_update(
						state_,
						{IF: updatedForm})),
				t: false,
				a: targetIdx,
				IF: A2($author$project$View$FormV2$setSubmitStatus, $author$project$Data$Status$NotAsked, updatedForm),
				M: false,
				w: _List_Nil,
				aB: $elm$core$Maybe$Nothing,
				z: A3($author$project$View$ConversationalFormV2$pushHistory, state_.a, steps, state_.z),
				s: 0
			});
		return _Utils_Tuple2(
			A3($author$project$View$ConversationalFormV2$recordBotReask, targetIdx, explainText, baseState),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Task$attempt,
						$elm$core$Basics$always(
							config.aut($author$project$View$ConversationalFormV2$NoOp)),
						$author$project$View$ConversationalFormV2$scrollThreadToBottom),
						config.at_
					])));
	});
var $author$project$View$ConversationalFormV2$runCorrectionInPlace = F4(
	function (config, state_, fName, newValueText) {
		var confirmationTemplate = A3($author$project$Data$Translation$translateOr, config.anB, 'conversational-correction-confirm', 'Aangepast — {field} is nu \"{value}\". Terug naar je vorige antwoord.');
		var confirmationText = A3(
			$elm$core$String$replace,
			'{value}',
			newValueText,
			A3(
				$elm$core$String$replace,
				'{field}',
				$author$project$Data$Form$nameToLabel(fName),
				confirmationTemplate));
		var stateWithConfirmation = A3($author$project$View$ConversationalFormV2$recordBotReask, state_.a, confirmationText, state_);
		var coercedValue = A2(
			$elm$core$Maybe$withDefault,
			$author$project$Model$FormFieldValueV2$TextValue(newValueText),
			$elm$core$List$head(
				A2(
					$elm$core$List$filterMap,
					function (step) {
						var _v0 = $author$project$View$ConversationalFormV2$firstFieldOfStep(step);
						if (!_v0.$) {
							var f = _v0.a;
							return _Utils_eq(f.dY, fName) ? A3(
								$author$project$View$ConversationalFormV2$coerceTextToFieldValue,
								$author$project$View$ConversationalFormV2$defaultCallingCodeFor(state_.IF),
								f.ew,
								newValueText) : $elm$core$Maybe$Nothing;
						} else {
							return $elm$core$Maybe$Nothing;
						}
					},
					$author$project$View$ConversationalFormV2$visibleSteps(state_.IF))));
		var mergedInput = A3(
			$pzp1997$assoc_list$AssocList$insert,
			fName,
			coercedValue,
			$author$project$View$FormV2$getFormInput(state_.IF));
		var formWithMerged = A2(
			$author$project$View$FormV2$setSubmitStatus,
			$author$project$Data$Status$NotAsked,
			A2($author$project$View$FormV2$setFormInput, mergedInput, state_.IF));
		return _Utils_Tuple2(
			_Utils_update(
				stateWithConfirmation,
				{g: '', IF: formWithMerged, M: false}),
			A2(
				$elm$core$Task$attempt,
				$elm$core$Basics$always(
					config.aut($author$project$View$ConversationalFormV2$NoOp)),
				$author$project$View$ConversationalFormV2$scrollThreadToBottom));
	});
var $author$project$View$ConversationalFormV2$scrollThreadToBottomOnKeyboardOpen = function () {
	var scrollOnce = A2(
		$elm$core$Task$andThen,
		function (info) {
			return A3($elm$browser$Browser$Dom$setViewportOf, 'conversational-form-thread', 0, info.avu.Mq);
		},
		$elm$browser$Browser$Dom$getViewportOf('conversational-form-thread'));
	return A2(
		$elm$core$Task$andThen,
		function (info) {
			return ((info.avu.Mq - (info.awo.m + info.awo.Mq)) <= 80) ? A2(
				$elm$core$Task$andThen,
				function (_v1) {
					return scrollOnce;
				},
				A2(
					$elm$core$Task$andThen,
					function (_v0) {
						return A2(
							$elm$core$Task$map,
							$elm$core$Basics$always(0),
							$elm$core$Process$sleep(320));
					},
					scrollOnce)) : $elm$core$Task$succeed(0);
		},
		$elm$browser$Browser$Dom$getViewportOf('conversational-form-thread'));
}();
var $author$project$Effect$ConversationalApplyIntent$fieldNamingPhrases = _List_fromArray(
	['mijn voornaam', 'mijn achternaam', 'mijn naam', 'mijn email', 'mijn e-mail', 'mijn mail', 'mijn telefoon', 'mijn telefoonnummer', 'mijn nummer', 'mijn adres', 'mijn geboortedatum', 'mijn linkedin', 'my first name', 'my last name', 'my name', 'my email', 'my e-mail', 'my phone', 'my phone number', 'my number', 'my address', 'my birthdate', 'my date of birth', 'my linkedin', 'mein name', 'mein vorname', 'mein nachname', 'meine email', 'meine e-mail', 'meine telefonnummer', 'meine nummer', 'meine adresse', 'mon prénom', 'mon nom', 'mon email', 'mon e-mail', 'mon numéro', 'mon adresse']);
var $author$project$Effect$ConversationalApplyIntent$triggerPhrases = _List_fromArray(
	['oh ', 'wacht', 'sorry', 'klopt niet', 'is fout', 'ik bedoelde', 'eigenlijk', 'het moet', 'bijwerken', 'corrigeren', 'verander', 'shit', 'verkeerd', 'oh', 'wait', 'actually', 'is wrong', 'i meant', 'it should', 'change ', 'correct ', 'fix ', 'moment', 'warte', 'falsch', 'attends', 'mauvais']);
var $author$project$Effect$ConversationalApplyIntent$shouldClassify = function (rawText) {
	var lowered = $elm$core$String$toLower(
		$elm$core$String$trim(rawText));
	return A2(
		$elm$core$List$any,
		function (trigger) {
			return A2($elm$core$String$contains, trigger, lowered);
		},
		$author$project$Effect$ConversationalApplyIntent$triggerPhrases) || A2(
		$elm$core$List$any,
		function (phrase) {
			return A2($elm$core$String$startsWith, phrase, lowered);
		},
		$author$project$Effect$ConversationalApplyIntent$fieldNamingPhrases);
};
var $elm$core$Dict$sizeHelp = F2(
	function (n, dict) {
		sizeHelp:
		while (true) {
			if (dict.$ === -2) {
				return n;
			} else {
				var left = dict.d;
				var right = dict.e;
				var $temp$n = A2($elm$core$Dict$sizeHelp, n + 1, right),
					$temp$dict = left;
				n = $temp$n;
				dict = $temp$dict;
				continue sizeHelp;
			}
		}
	});
var $elm$core$Dict$size = function (dict) {
	return A2($elm$core$Dict$sizeHelp, 0, dict);
};
var $author$project$View$ConversationalFormV2$skipMarker = '\uE000skip';
var $author$project$View$ConversationalFormV2$requiredInGroups = F2(
	function (groups, fieldName) {
		return A2(
			$elm$core$List$any,
			$elm$core$List$member(fieldName),
			groups);
	});
var $author$project$View$FormV2$schemaFields = function (_v0) {
	var state = _v0;
	return state.aeo;
};
var $author$project$View$ConversationalFormV2$isFieldRequired = F2(
	function (formState, fieldName) {
		var requiredByExport = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.adb;
				},
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (schemaField) {
							return _Utils_eq(schemaField.dY, fieldName);
						},
						$author$project$View$FormV2$schemaFields(formState)))));
		var _v0 = $author$project$Data$FormSource$toForm(
			$author$project$View$ConversationalFormV2$formSource(formState)).eb;
		var required = _v0;
		var inRequiredMatrix = A2($author$project$View$ConversationalFormV2$requiredInGroups, required, fieldName);
		return inRequiredMatrix || requiredByExport;
	});
var $author$project$View$ConversationalFormV2$skipSuggestionTargetsRequiredField = F2(
	function (state_, suggestion) {
		var _v0 = $author$project$Data$FieldValidation$decodeFieldName(suggestion.akQ);
		if (!_v0.$) {
			var fName = _v0.a;
			return A2($author$project$View$ConversationalFormV2$isFieldRequired, state_.IF, fName);
		} else {
			return false;
		}
	});
var $author$project$View$ConversationalFormV2$stashCrossFieldValues = F2(
	function (incoming, existing) {
		var decoded = A2(
			$elm$core$List$filterMap,
			function (entry) {
				var _v1 = entry.xy;
				if (!_v1.$) {
					return $elm$core$Maybe$Nothing;
				} else {
					return A2(
						$elm$core$Maybe$map,
						function (name) {
							return _Utils_Tuple2(name, entry.xz);
						},
						$author$project$Data$FieldValidation$decodeFieldName(entry.xx));
				}
			},
			incoming);
		var incomingNames = A2($elm$core$List$map, $elm$core$Tuple$first, decoded);
		return _Utils_ap(
			decoded,
			A2(
				$elm$core$List$filter,
				function (_v0) {
					var name = _v0.a;
					return !A2($elm$core$List$member, name, incomingNames);
				},
				existing));
	});
var $author$project$View$ConversationalFormV2$stepFieldsForIntent = function (step) {
	var _v0 = $author$project$View$ConversationalFormV2$addressableFieldOfStep(step);
	if (!_v0.$) {
		var field = _v0.a;
		return _List_fromArray(
			[
				{
				bO: $author$project$Data$Form$nameToLabel(field.dY),
				dY: $author$project$Data$FormField$fieldNameToCanonicalText(field.dY)
			}
			]);
	} else {
		return _List_Nil;
	}
};
var $author$project$View$ConversationalFormV2$stepForTranscript = function (mStep) {
	_v0$3:
	while (true) {
		if (!mStep.$) {
			switch (mStep.a.$) {
				case 1:
					var _v1 = mStep.a;
					var fields = _v1.b;
					return $elm$core$Maybe$Just(
						{atV: fields, avv: $elm$core$Maybe$Nothing});
				case 2:
					var _v2 = mStep.a;
					var fields = _v2.b;
					return $elm$core$Maybe$Just(
						{atV: fields, avv: $elm$core$Maybe$Nothing});
				case 3:
					var sq = mStep.a.a;
					return $elm$core$Maybe$Just(
						{
							atV: _List_Nil,
							avv: $elm$core$Maybe$Just(sq.dE)
						});
				default:
					break _v0$3;
			}
		} else {
			break _v0$3;
		}
	}
	return $elm$core$Maybe$Nothing;
};
var $author$project$View$ConversationalFormV2$stepIdxForFieldName = F2(
	function (name, steps) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$filterMap,
				function (_v0) {
					var idx = _v0.a;
					var step = _v0.b;
					var _v1 = $author$project$View$ConversationalFormV2$firstFieldOfStep(step);
					if (!_v1.$) {
						var field = _v1.a;
						return _Utils_eq(
							$author$project$Data$FormField$fieldNameToCanonicalText(field.dY),
							name) ? $elm$core$Maybe$Just(idx) : $elm$core$Maybe$Nothing;
					} else {
						return $elm$core$Maybe$Nothing;
					}
				},
				A2($elm$core$List$indexedMap, $elm$core$Tuple$pair, steps)));
	});
var $author$project$View$ConversationalFormV2$stepShownEventValue = F4(
	function (config, vacancyId, totalSteps, stepIdx) {
		return A2(
			$author$project$Analytics$Conversational$event,
			'conversational-apply-step-shown',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'step_index',
					$elm$json$Json$Encode$int(stepIdx)),
					_Utils_Tuple2(
					'total_steps',
					$elm$json$Json$Encode$int(totalSteps)),
					_Utils_Tuple2(
					'vacancy_id',
					$author$project$Analytics$Conversational$maybeVacancy(vacancyId)),
					_Utils_Tuple2(
					'session_id',
					$author$project$Analytics$Conversational$maybeString(config.ag$)),
					_Utils_Tuple2(
					'form_id',
					$elm$json$Json$Encode$string(config.Kq)),
					_Utils_Tuple2(
					'form_name',
					$elm$json$Json$Encode$string(config.aL))
				]));
	});
var $elm$core$List$minimum = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(
			A3($elm$core$List$foldl, $elm$core$Basics$min, x, xs));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$View$ConversationalFormV2$submitErrorTargetStep = F3(
	function (prevForm, nextForm, steps) {
		var fieldErrorKeys = function (formState) {
			var _v0 = $author$project$View$FormV2$submitStatus(formState);
			if ((_v0.$ === 2) && (!_v0.a.$)) {
				var response = _v0.a.a;
				return $elm$core$Dict$keys(response.atU);
			} else {
				return _List_Nil;
			}
		};
		var nextKeys = fieldErrorKeys(nextForm);
		var prevKeys = fieldErrorKeys(prevForm);
		return ($elm$core$List$isEmpty(nextKeys) || _Utils_eq(nextKeys, prevKeys)) ? $elm$core$Maybe$Nothing : $elm$core$List$minimum(
			A2(
				$elm$core$List$filterMap,
				function (k) {
					return A2($author$project$View$ConversationalFormV2$stepIdxForFieldName, k, steps);
				},
				nextKeys));
	});
var $author$project$Effect$ConversationalTranscript$systemTurn = F2(
	function (event, details) {
		return {
			Ht: $elm$core$Maybe$Nothing,
			_y: $author$project$Api$ConversationTurn$WireSystemP(
				{DV: details, Gs: event}),
			adx: 3
		};
	});
var $author$project$View$ConversationalFormV2$transcriptBotPrompt = F3(
	function (translations, formState, step) {
		return $author$project$View$ConversationalFormV2$stepIsNarratorContent(step) ? '' : A3($author$project$View$ConversationalFormV2$botPromptForStep, translations, formState, step);
	});
var $pzp1997$assoc_list$AssocList$filter = F2(
	function (isGood, _v0) {
		var alist = _v0;
		return A2(
			$elm$core$List$filter,
			function (_v1) {
				var key = _v1.a;
				var value = _v1.b;
				return A2(isGood, key, value);
			},
			alist);
	});
var $author$project$View$ConversationalFormV2$pruneScreeningAnswers = F2(
	function (futureIds, input) {
		if ($elm$core$List$isEmpty(futureIds)) {
			return input;
		} else {
			var _v0 = A2($pzp1997$assoc_list$AssocList$get, $author$project$Model$FormFieldV2$ScreeningQuestions, input);
			if ((!_v0.$) && (_v0.a.$ === 11)) {
				var vs = _v0.a.a;
				var kept = A2(
					$elm$core$List$filter,
					function (v) {
						var _v1 = v.dY;
						if (_v1.$ === 16) {
							var sqId = _v1.a;
							return !A2($elm$core$List$member, sqId, futureIds);
						} else {
							return true;
						}
					},
					vs);
				return A3(
					$pzp1997$assoc_list$AssocList$insert,
					$author$project$Model$FormFieldV2$ScreeningQuestions,
					$author$project$Model$FormFieldValueV2$ScreeningQuestionValues(kept),
					input);
			} else {
				return input;
			}
		}
	});
var $author$project$View$ConversationalFormV2$splitAtInclusive = F2(
	function (n, xs) {
		return _Utils_Tuple2(
			A2($elm$core$List$take, n + 1, xs),
			A2($elm$core$List$drop, n + 1, xs));
	});
var $author$project$View$ConversationalFormV2$stepFieldNames = function (step) {
	switch (step.$) {
		case 1:
			var fields = step.b;
			return A2(
				$elm$core$List$map,
				function ($) {
					return $.dY;
				},
				fields);
		case 2:
			var fields = step.b;
			return A2(
				$elm$core$List$map,
				function ($) {
					return $.dY;
				},
				fields);
		case 3:
			return _List_Nil;
		case 0:
			return _List_Nil;
		default:
			return _List_Nil;
	}
};
var $author$project$View$ConversationalFormV2$truncateFormAfterStep = F2(
	function (targetIdx, formState) {
		var steps = $author$project$View$ConversationalFormV2$visibleSteps(formState);
		var currentInput = $author$project$View$FormV2$getFormInput(formState);
		var _v0 = A2($author$project$View$ConversationalFormV2$splitAtInclusive, targetIdx, steps);
		var futureSteps = _v0.b;
		var futureFieldNames = A2($elm$core$List$concatMap, $author$project$View$ConversationalFormV2$stepFieldNames, futureSteps);
		var futureScreeningIds = A2(
			$elm$core$List$filterMap,
			function (s) {
				if (s.$ === 3) {
					var sq = s.a;
					return $elm$core$Maybe$Just(sq.dE);
				} else {
					return $elm$core$Maybe$Nothing;
				}
			},
			futureSteps);
		var filteredInput = A2(
			$author$project$View$ConversationalFormV2$pruneScreeningAnswers,
			futureScreeningIds,
			A2(
				$pzp1997$assoc_list$AssocList$filter,
				F2(
					function (name, _v1) {
						return !A2($elm$core$List$member, name, futureFieldNames);
					}),
				currentInput));
		return A2($author$project$View$FormV2$setFormInput, filteredInput, formState);
	});
var $author$project$View$ConversationalFormV2$typedTextDidntCoerce = F2(
	function (state_, mStep) {
		var composerHasText = !$elm$core$String$isEmpty(
			$elm$core$String$trim(state_.g));
		if (!composerHasText) {
			return false;
		} else {
			if ((((!mStep.$) && (mStep.a.$ === 1)) && mStep.a.b.b) && (!mStep.a.b.b.b)) {
				var _v1 = mStep.a;
				var _v2 = _v1.b;
				var field = _v2.a;
				var _v3 = A3(
					$author$project$View$ConversationalFormV2$coerceTextToFieldValue,
					$author$project$View$ConversationalFormV2$defaultCallingCodeFor(state_.IF),
					field.ew,
					$elm$core$String$trim(state_.g));
				if (!_v3.$) {
					return false;
				} else {
					return true;
				}
			} else {
				return false;
			}
		}
	});
var $author$project$View$ConversationalFormV2$TypingDone = function (a) {
	return {$: 23, a: a};
};
var $author$project$View$ConversationalFormV2$typingDelayCmd = F4(
	function (lift, reducedMotion, idx, promptText) {
		if (reducedMotion) {
			return $elm$core$Platform$Cmd$none;
		} else {
			var perChar = 10;
			var cap = 1800;
			var base = 800;
			var delayMs = A2(
				$elm$core$Basics$min,
				cap,
				base + ($elm$core$String$length(promptText) * perChar));
			return A2(
				$elm$core$Task$perform,
				function (_v0) {
					return lift(
						$author$project$View$ConversationalFormV2$TypingDone(idx));
				},
				$elm$core$Process$sleep(delayMs));
		}
	});
var $author$project$View$ConversationalFormV2$walkToCorrection = F4(
	function (config, state_, targetIdx, _v0) {
		var nextStep = $elm$core$List$head(
			A2(
				$elm$core$List$drop,
				targetIdx,
				$author$project$View$ConversationalFormV2$visibleSteps(state_.IF)));
		var nextPrompt = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				A2($author$project$View$ConversationalFormV2$botPromptForStep, config.anB, state_.IF),
				nextStep));
		return _Utils_Tuple2(
			_Utils_update(
				state_,
				{
					g: '',
					a: targetIdx,
					IF: A2($author$project$View$FormV2$setSubmitStatus, $author$project$Data$Status$NotAsked, state_.IF),
					M: false,
					af: A2($author$project$View$ConversationalFormV2$pendingBotIdxFor, state_.cI, targetIdx),
					aB: $elm$core$Maybe$Just(state_.a)
				}),
			A4($author$project$View$ConversationalFormV2$typingDelayCmd, config.aut, state_.cI, targetIdx, nextPrompt));
	});
var $author$project$View$ConversationalFormV2$advanceUnvalidated = F3(
	function (config, state_, steps) {
		var leavingNarrator = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				$author$project$View$ConversationalFormV2$stepIsNarratorContent,
				$elm$core$List$head(
					A2($elm$core$List$drop, state_.a, steps))));
		var landing = A4(
			$author$project$View$ConversationalFormV2$advanceTarget,
			state_.x,
			steps,
			state_.a + 1,
			A3($author$project$View$ConversationalFormV2$pushHistory, state_.a, steps, state_.z));
		var nextIdx = landing.NR;
		var nextStep = $elm$core$List$head(
			A2($elm$core$List$drop, nextIdx, steps));
		var nextPrompt = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				A2($author$project$View$ConversationalFormV2$botPromptForStep, config.anB, state_.IF),
				nextStep));
		var advanceAnalyticsCmd = leavingNarrator ? $elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A2(
					$elm$core$Platform$Cmd$map,
					config.aut,
					A2($elm$core$Task$perform, $author$project$View$ConversationalFormV2$StepTick, $elm$time$Time$now)),
					config.aaE(
					A4(
						$author$project$View$ConversationalFormV2$stepShownEventValue,
						config,
						state_.aqL,
						$elm$core$List$length(steps),
						nextIdx))
				])) : A2(
			$elm$core$Platform$Cmd$map,
			config.aut,
			A2(
				$elm$core$Task$perform,
				A2($author$project$View$ConversationalFormV2$StepAdvancedTick, state_.a, nextIdx),
				$elm$time$Time$now));
		var _v58 = A3(
			$author$project$View$ConversationalFormV2$dispatchTurns,
			config,
			state_,
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						A2(
						$author$project$Effect$ConversationalTranscript$buildBotTurnRecord,
						A2($elm$core$Maybe$andThen, $author$project$View$ConversationalFormV2$questionFieldKey, nextStep),
						A2(
							$elm$core$Maybe$withDefault,
							'',
							A2(
								$elm$core$Maybe$map,
								A2($author$project$View$ConversationalFormV2$transcriptBotPrompt, config.anB, state_.IF),
								nextStep)))
					])));
		var turnState = _v58.a;
		var recordingCmds = _v58.b;
		return ((_Utils_cmp(
			nextIdx,
			$elm$core$List$length(steps)) > -1) && (!config.avh)) ? A3($author$project$View$ConversationalFormV2$update, config, $author$project$View$ConversationalFormV2$ConvSubmit, state_) : _Utils_Tuple2(
			_Utils_update(
				turnState,
				{
					g: A2($author$project$View$ConversationalFormV2$previousRawInputAtStep, nextIdx, state_),
					a: nextIdx,
					IF: A2($author$project$View$FormV2$setSubmitStatus, $author$project$Data$Status$NotAsked, state_.IF),
					af: A2($author$project$View$ConversationalFormV2$pendingBotIdxFor, state_.cI, nextIdx),
					z: landing.MO,
					s: 0
				}),
			$elm$core$Platform$Cmd$batch(
				_Utils_ap(
					_List_fromArray(
						[
							advanceAnalyticsCmd,
							A4($author$project$View$ConversationalFormV2$typingDelayCmd, config.aut, state_.cI, nextIdx, nextPrompt),
							A2(
							$elm$core$Task$attempt,
							$elm$core$Basics$always(
								config.aut($author$project$View$ConversationalFormV2$NoOp)),
							$author$project$View$ConversationalFormV2$scrollThreadToBottom),
							config.at_,
							A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							A2(
								$elm$core$Maybe$map,
								A3($author$project$View$ConversationalFormV2$autoAdvanceFromNarratorCmd, config.aut, state_.cI, nextIdx),
								nextStep))
						]),
					recordingCmds)));
	});
var $author$project$View$ConversationalFormV2$convAiSkipAdvance = F3(
	function (config, state_, suggestion) {
		var stateWithSkipBubble = A3($author$project$View$ConversationalFormV2$recordUserAttempt, state_.a, $author$project$View$ConversationalFormV2$skipMarker, state_);
		var clearedForm = function () {
			var _v57 = $author$project$Data$FieldValidation$decodeFieldName(suggestion.akQ);
			if (!_v57.$) {
				var fName = _v57.a;
				return A2(
					$author$project$View$FormV2$setSubmitStatus,
					$author$project$Data$Status$NotAsked,
					A2(
						$author$project$View$FormV2$setFormInput,
						A2(
							$pzp1997$assoc_list$AssocList$remove,
							fName,
							$author$project$View$FormV2$getFormInput(stateWithSkipBubble.IF)),
						stateWithSkipBubble.IF));
			} else {
				return A2($author$project$View$FormV2$setSubmitStatus, $author$project$Data$Status$NotAsked, stateWithSkipBubble.IF);
			}
		}();
		var advancedState = _Utils_update(
			stateWithSkipBubble,
			{
				x: A2(
					$author$project$View$ConversationalFormV2$dropAutoAnswered,
					A2(
						$elm$core$List$filterMap,
						$elm$core$Basics$identity,
						_List_fromArray(
							[
								$author$project$Data$FieldValidation$decodeFieldName(suggestion.akQ)
							])),
					stateWithSkipBubble.x),
				g: '',
				IF: clearedForm,
				w: A2(
					$elm$core$List$filter,
					function (s) {
						return !_Utils_eq(s.akQ, suggestion.akQ);
					},
					stateWithSkipBubble.w),
				X: A2(
					$author$project$View$ConversationalFormV2$dropStashedValues,
					A2(
						$elm$core$List$filterMap,
						$elm$core$Basics$identity,
						_List_fromArray(
							[
								$author$project$Data$FieldValidation$decodeFieldName(suggestion.akQ)
							])),
					stateWithSkipBubble.X)
			});
		var _v55 = A3(
			$author$project$View$ConversationalFormV2$dispatchTurns,
			config,
			advancedState,
			_List_fromArray(
				[
					$author$project$Effect$ConversationalTranscript$questionSkippedTurn(suggestion.akQ)
				]));
		var skipRecordedState = _v55.a;
		var skipCmds = _v55.b;
		var _v56 = A3(
			$author$project$View$ConversationalFormV2$advanceUnvalidated,
			config,
			skipRecordedState,
			$author$project$View$ConversationalFormV2$visibleSteps(clearedForm));
		var advanced = _v56.a;
		var advanceCmd = _v56.b;
		return _Utils_Tuple2(
			advanced,
			$elm$core$Platform$Cmd$batch(
				A2($elm$core$List$cons, advanceCmd, skipCmds)));
	});
var $author$project$View$ConversationalFormV2$handleIntent = F3(
	function (config, state_, intent) {
		if (!state_.M) {
			return _Utils_Tuple2(state_, $elm$core$Platform$Cmd$none);
		} else {
			switch (intent.$) {
				case 0:
					return A2(
						$author$project$View$ConversationalFormV2$runValidateNow,
						config,
						_Utils_update(
							state_,
							{M: false}));
				case 1:
					var fieldNameText = intent.a;
					var newValue = intent.b;
					var _v53 = _Utils_Tuple2(
						$author$project$Data$FieldValidation$decodeFieldName(fieldNameText),
						A2(
							$author$project$View$ConversationalFormV2$stepIdxForFieldName,
							fieldNameText,
							$author$project$View$ConversationalFormV2$visibleSteps(state_.IF)));
					if ((!_v53.a.$) && (!_v53.b.$)) {
						var fName = _v53.a.a;
						return A4($author$project$View$ConversationalFormV2$runCorrectionInPlace, config, state_, fName, newValue);
					} else {
						return A2(
							$author$project$View$ConversationalFormV2$runValidateNow,
							config,
							_Utils_update(
								state_,
								{M: false}));
					}
				default:
					var fieldNameText = intent.a;
					var _v54 = A2(
						$author$project$View$ConversationalFormV2$stepIdxForFieldName,
						fieldNameText,
						$author$project$View$ConversationalFormV2$visibleSteps(state_.IF));
					if (!_v54.$) {
						var targetIdx = _v54.a;
						return A4($author$project$View$ConversationalFormV2$walkToCorrection, config, state_, targetIdx, fieldNameText);
					} else {
						return A2(
							$author$project$View$ConversationalFormV2$runValidateNow,
							config,
							_Utils_update(
								state_,
								{M: false}));
					}
			}
		}
	});
var $author$project$View$ConversationalFormV2$runConvNext = F2(
	function (config, state_) {
		var withHistory = $elm$core$String$isEmpty(
			$elm$core$String$trim(state_.g)) ? state_ : A3($author$project$View$ConversationalFormV2$recordUserAttempt, state_.a, state_.g, state_);
		if ((!config.avh) && $author$project$Effect$ConversationalApplyIntent$shouldClassify(withHistory.g)) {
			var steps = $author$project$View$ConversationalFormV2$visibleSteps(withHistory.IF);
			var mCurrent = $elm$core$List$head(
				A2($elm$core$List$drop, withHistory.a, steps));
			var knownFields = A2($elm$core$List$concatMap, $author$project$View$ConversationalFormV2$stepFieldsForIntent, steps);
			var currentQuestion = A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					A2($author$project$View$ConversationalFormV2$botPromptForStep, config.anB, withHistory.IF),
					mCurrent));
			var currentField = A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.dY;
						},
						$author$project$Data$FormField$fieldNameToCanonicalText),
					A2($elm$core$Maybe$andThen, $author$project$View$ConversationalFormV2$firstFieldOfStep, mCurrent)));
			return _Utils_Tuple2(
				_Utils_update(
					withHistory,
					{M: true}),
				$elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							$author$project$Effect$ConversationalApplyIntent$postIntent(
							{
								ci: withHistory.ci,
								xP: currentField,
								xV: currentQuestion,
								Qc: knownFields,
								Ql: $author$project$Util$LangCode$toString($author$project$Copy$language),
								aut: A2($elm$core$Basics$composeL, config.aut, $author$project$View$ConversationalFormV2$GotIntent),
								aaQ: withHistory.g
							}),
							A2(
							$elm$core$Task$attempt,
							$elm$core$Basics$always(
								config.aut($author$project$View$ConversationalFormV2$NoOp)),
							$author$project$View$ConversationalFormV2$scrollThreadToBottom)
						])));
		} else {
			var _v51 = A2($author$project$View$ConversationalFormV2$runValidateNow, config, withHistory);
			var nextState = _v51.a;
			var nextCmd = _v51.b;
			return _Utils_Tuple2(
				nextState,
				$elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							nextCmd,
							A2(
							$elm$core$Task$attempt,
							$elm$core$Basics$always(
								config.aut($author$project$View$ConversationalFormV2$NoOp)),
							$author$project$View$ConversationalFormV2$scrollThreadToBottom)
						])));
		}
	});
var $author$project$View$ConversationalFormV2$runValidateAfterCoerce = F4(
	function (config, statePreCoerce, mCurrent, steps) {
		if (mCurrent.$ === 1) {
			return _Utils_Tuple2(statePreCoerce, $elm$core$Platform$Cmd$none);
		} else {
			switch (mCurrent.a.$) {
				case 4:
					var _v50 = mCurrent.a;
					return A3($author$project$View$ConversationalFormV2$advanceUnvalidated, config, statePreCoerce, steps);
				case 0:
					return A3($author$project$View$ConversationalFormV2$advanceUnvalidated, config, statePreCoerce, steps);
				default:
					var step = mCurrent.a;
					if (config.avh) {
						return A3($author$project$View$ConversationalFormV2$advanceUnvalidated, config, statePreCoerce, steps);
					} else {
						if ($author$project$View$ConversationalFormV2$stepIsNarratorContent(step)) {
							return A3($author$project$View$ConversationalFormV2$advanceUnvalidated, config, statePreCoerce, steps);
						} else {
							var request = A3($author$project$View$ConversationalFormV2$buildValidationRequest, config.anB, step, statePreCoerce);
							var cmd = A2(
								$author$project$Api$sendWithValidation,
								A2($elm$core$Basics$composeL, config.aut, $author$project$View$ConversationalFormV2$GotValidation),
								A3($author$project$Data$FieldValidation$post, statePreCoerce.ci, config.ag$, request));
							return _Utils_Tuple2(
								_Utils_update(
									statePreCoerce,
									{M: false, s: 1}),
								cmd);
						}
					}
			}
		}
	});
var $author$project$View$ConversationalFormV2$runValidateNow = F2(
	function (config, state_) {
		var steps = $author$project$View$ConversationalFormV2$visibleSteps(state_.IF);
		var mCurrent = $elm$core$List$head(
			A2($elm$core$List$drop, state_.a, steps));
		var statePreCoerce = A2($author$project$View$ConversationalFormV2$coerceComposerIntoForm, state_, mCurrent);
		if (A2($author$project$View$ConversationalFormV2$typedTextDidntCoerce, state_, mCurrent)) {
			var isUnsafe = $author$project$Page$ConversationalForm$Diagnose$isInterrogativeInput(state_.g);
			var field = A2($elm$core$Maybe$andThen, $author$project$View$ConversationalFormV2$firstFieldOfStep, mCurrent);
			var retryText = function () {
				var _v47 = _Utils_Tuple2(field, isUnsafe);
				if (!_v47.a.$) {
					if (_v47.b) {
						var f = _v47.a.a;
						return A2($author$project$Page$ConversationalForm$Diagnose$interrogativeFallback, config.anB, f);
					} else {
						var f = _v47.a.a;
						return A2($author$project$View$ConversationalFormV2$clientSideRetryCopy, config.anB, f);
					}
				} else {
					var _v48 = _v47.a;
					return A3($author$project$Data$Translation$translateOr, config.anB, 'conversational-retry-default', 'Sorry, dat begreep ik niet — kun je het nog eens anders proberen?');
				}
			}();
			var stateWithBot = A3($author$project$View$ConversationalFormV2$recordBotReask, state_.a, retryText, state_);
			return _Utils_Tuple2(
				_Utils_update(
					stateWithBot,
					{g: '', s: 2}),
				A2(
					$elm$core$Task$attempt,
					$elm$core$Basics$always(
						config.aut($author$project$View$ConversationalFormV2$NoOp)),
					$author$project$View$ConversationalFormV2$scrollThreadToBottom));
		} else {
			return A4($author$project$View$ConversationalFormV2$runValidateAfterCoerce, config, statePreCoerce, mCurrent, steps);
		}
	});
var $author$project$View$ConversationalFormV2$update = F3(
	function (config, msg, state) {
		update:
		while (true) {
			var state_ = state;
			switch (msg.$) {
				case 32:
					return _Utils_Tuple2(state, $elm$core$Platform$Cmd$none);
				case 31:
					return _Utils_Tuple2(
						_Utils_update(
							state_,
							{eo: true}),
						A2(
							$elm$core$Task$attempt,
							$elm$core$Basics$always(
								config.aut($author$project$View$ConversationalFormV2$NoOp)),
							$author$project$View$ConversationalFormV2$scrollThreadToBottom));
				case 0:
					if (msg.a.$ === 3) {
						var _v1 = msg.a;
						return _Utils_Tuple2(state, $elm$core$Platform$Cmd$none);
					} else {
						var formMsg = msg.a;
						var formConfig = {
							atp: config.ag$,
							aut: A2($elm$core$Basics$composeL, config.aut, $author$project$View$ConversationalFormV2$FormMsg),
							au4: $elm$core$Platform$Cmd$none,
							X1: function (url) {
								return A2($author$project$View$ConversationalFormV2$revealSuccessCardAfterDelay, config, url.av7);
							},
							aaH: config.aaH,
							ac7: config.ac7,
							alw: state_.alw
						};
						var _v2 = A3($author$project$View$FormV2$update, formConfig, formMsg, state_.IF);
						var updatedForm = _v2.a;
						var formCmds = _v2.b;
						var _v3 = A3(
							$author$project$View$ConversationalFormV2$submitErrorTargetStep,
							state_.IF,
							updatedForm,
							$author$project$View$ConversationalFormV2$visibleSteps(updatedForm));
						if (!_v3.$) {
							var targetIdx = _v3.a;
							return A4($author$project$View$ConversationalFormV2$routeToSubmitError, config, state_, updatedForm, targetIdx);
						} else {
							var uploadedFile = A2($author$project$View$ConversationalFormV2$detectFileUpload, state_.IF, updatedForm);
							var stateWithUpload = function () {
								if (!uploadedFile.$) {
									var filename = uploadedFile.a;
									return A3(
										$author$project$View$ConversationalFormV2$recordUserAttempt,
										state_.a,
										filename,
										_Utils_update(
											state_,
											{IF: updatedForm}));
								} else {
									return _Utils_update(
										state_,
										{IF: updatedForm});
								}
							}();
							if (!uploadedFile.$) {
								var $temp$config = config,
									$temp$msg = $author$project$View$ConversationalFormV2$ConvNext,
									$temp$state = stateWithUpload;
								config = $temp$config;
								msg = $temp$msg;
								state = $temp$state;
								continue update;
							} else {
								return _Utils_Tuple2(stateWithUpload, formCmds);
							}
						}
					}
				case 5:
					var formConfig = {
						atp: config.ag$,
						aut: A2($elm$core$Basics$composeL, config.aut, $author$project$View$ConversationalFormV2$FormMsg),
						au4: $elm$core$Platform$Cmd$none,
						X1: function (url) {
							return A2($author$project$View$ConversationalFormV2$revealSuccessCardAfterDelay, config, url.av7);
						},
						aaH: config.aaH,
						ac7: config.ac7,
						alw: state_.alw
					};
					var analyticsCmd = function () {
						var _v7 = _Utils_Tuple2(
							state_.b4,
							$elm$core$List$length(
								$author$project$View$ConversationalFormV2$visibleSteps(state_.IF)));
						if (!_v7.a.$) {
							var totalSteps = _v7.b;
							return $elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										config.aaE(
										A2(
											$author$project$Analytics$Conversational$event,
											'conversational-apply-submitted',
											_List_fromArray(
												[
													_Utils_Tuple2(
													'total_steps',
													$elm$json$Json$Encode$int(totalSteps)),
													_Utils_Tuple2(
													'vacancy_id',
													$author$project$Analytics$Conversational$maybeVacancy(state_.aqL)),
													_Utils_Tuple2(
													'session_id',
													$author$project$Analytics$Conversational$maybeString(config.ag$))
												]))),
										config.aaE(
										$author$project$View$ConversationalFormV2$completedEventValue(config))
									]));
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}();
					var _v6 = A3($author$project$View$FormV2$update, formConfig, $author$project$View$FormV2$SubmitForm, state_.IF);
					var updatedForm = _v6.a;
					var formCmds = _v6.b;
					return _Utils_Tuple2(
						_Utils_update(
							state_,
							{IF: updatedForm}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[formCmds, analyticsCmd])));
				case 30:
					var text = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							state_,
							{g: text}),
						$elm$core$Platform$Cmd$none);
				case 1:
					return ((state_.s === 1) || (state_.M || state_.t)) ? _Utils_Tuple2(state, $elm$core$Platform$Cmd$none) : A2($author$project$View$ConversationalFormV2$runConvNext, config, state_);
				case 13:
					if (msg.a.$ === 1) {
						var err = msg.a.a;
						if (state_.s !== 1) {
							return _Utils_Tuple2(state, $elm$core$Platform$Cmd$none);
						} else {
							var formWithError = A2(
								$author$project$View$FormV2$setSubmitStatus,
								$author$project$Data$Status$Failure(err),
								state_.IF);
							var analyticsCmd = config.aaE(
								A2(
									$author$project$Analytics$Conversational$event,
									'conversational-apply-step-validation-failed',
									_List_fromArray(
										[
											_Utils_Tuple2(
											'step_index',
											$elm$json$Json$Encode$int(state_.a)),
											_Utils_Tuple2(
											'error_count',
											$elm$json$Json$Encode$int(1)),
											_Utils_Tuple2(
											'error_kind',
											$elm$json$Json$Encode$string('network')),
											_Utils_Tuple2(
											'vacancy_id',
											$author$project$Analytics$Conversational$maybeVacancy(state_.aqL)),
											_Utils_Tuple2(
											'session_id',
											$author$project$Analytics$Conversational$maybeString(config.ag$))
										])));
							return _Utils_Tuple2(
								_Utils_update(
									state_,
									{IF: formWithError, s: 2}),
								analyticsCmd);
						}
					} else {
						var response = msg.a.a;
						if (state_.s !== 1) {
							return _Utils_Tuple2(state, $elm$core$Platform$Cmd$none);
						} else {
							var errCount = $elm$core$Dict$size(response.Gk.atU);
							var aiSuggestions = response.iT;
							var handoffCmds = A2(
								$elm$core$List$map,
								function (sugg) {
									return config.aaE(
										A2(
											$author$project$Analytics$Conversational$event,
											'conversational-apply-ai-handoff',
											_List_fromArray(
												[
													_Utils_Tuple2(
													'field_name',
													$elm$json$Json$Encode$string(sugg.akQ)),
													_Utils_Tuple2(
													'step_index',
													$elm$json$Json$Encode$int(state_.a)),
													_Utils_Tuple2(
													'vacancy_id',
													$author$project$Analytics$Conversational$maybeVacancy(state_.aqL)),
													_Utils_Tuple2(
													'session_id',
													$author$project$Analytics$Conversational$maybeString(config.ag$))
												])));
								},
								aiSuggestions);
							if (errCount > 0) {
								var rejectedNow = _Utils_ap(
									A2(
										$elm$core$List$filterMap,
										$author$project$Data$FieldValidation$decodeFieldName,
										$elm$core$Dict$keys(response.Gk.atU)),
									$author$project$View$ConversationalFormV2$rejectedElsewhere(state_));
								var formWithErrors = A2(
									$author$project$View$FormV2$setSubmitStatus,
									$author$project$Data$Status$Failure(
										$author$project$Api$ValidationError(response.Gk)),
									state_.IF);
								var stepFieldForRetry = A2(
									$elm$core$Maybe$andThen,
									$author$project$View$ConversationalFormV2$firstFieldOfStep,
									$elm$core$List$head(
										A2(
											$elm$core$List$drop,
											state_.a,
											$author$project$View$ConversationalFormV2$visibleSteps(formWithErrors))));
								var filed = A2($author$project$View$ConversationalFormV2$fileCrossFieldValues, response.xA, formWithErrors);
								var baseState = _Utils_update(
									state_,
									{
										x: _Utils_ap(
											A2($elm$core$List$map, $elm$core$Tuple$first, filed.eT),
											state_.x),
										IF: filed.IF,
										w: aiSuggestions,
										an: rejectedNow,
										X: A2($author$project$View$ConversationalFormV2$stashCrossFieldValues, response.xA, state_.X),
										s: 0
									});
								var stateWithBubbles = function () {
									if ($elm$core$List$isEmpty(aiSuggestions)) {
										if (!stepFieldForRetry.$) {
											var field = stepFieldForRetry.a;
											return A3(
												$author$project$View$ConversationalFormV2$recordBotReask,
												state_.a,
												A3($author$project$View$ConversationalFormV2$retryTextForField, config.anB, formWithErrors, field),
												baseState);
										} else {
											return baseState;
										}
									} else {
										return A3($author$project$View$ConversationalFormV2$recordAiBubbles, state_.a, aiSuggestions, baseState);
									}
								}();
								var analyticsCmd = config.aaE(
									A2(
										$author$project$Analytics$Conversational$event,
										'conversational-apply-step-validation-failed',
										_List_fromArray(
											[
												_Utils_Tuple2(
												'step_index',
												$elm$json$Json$Encode$int(state_.a)),
												_Utils_Tuple2(
												'error_count',
												$elm$json$Json$Encode$int(errCount)),
												_Utils_Tuple2(
												'error_kind',
												$elm$json$Json$Encode$string('field')),
												_Utils_Tuple2(
												'vacancy_id',
												$author$project$Analytics$Conversational$maybeVacancy(state_.aqL)),
												_Utils_Tuple2(
												'session_id',
												$author$project$Analytics$Conversational$maybeString(config.ag$))
											])));
								var _v8 = A3(
									$author$project$View$ConversationalFormV2$dispatchTurns,
									config,
									stateWithBubbles,
									A2($author$project$View$ConversationalFormV2$filedTurnRecords, filed.IF, filed.eT));
								var turnState = _v8.a;
								var filedCmds = _v8.b;
								return _Utils_Tuple2(
									turnState,
									$elm$core$Platform$Cmd$batch(
										A2(
											$elm$core$List$cons,
											analyticsCmd,
											A2(
												$elm$core$List$cons,
												A2(
													$elm$core$Task$attempt,
													$elm$core$Basics$always(
														config.aut($author$project$View$ConversationalFormV2$NoOp)),
													$author$project$View$ConversationalFormV2$scrollThreadToBottom),
												_Utils_ap(handoffCmds, filedCmds)))));
							} else {
								if (!$elm$core$List$isEmpty(aiSuggestions)) {
									var reaskFields = A2(
										$elm$core$List$filterMap,
										function (s) {
											return $author$project$Data$FieldValidation$decodeFieldName(s.akQ);
										},
										A2(
											$elm$core$List$filter,
											function (s) {
												return _Utils_eq(
													s.akP,
													$elm$core$Maybe$Just('reask'));
											},
											aiSuggestions));
									var prunedStash = A2($author$project$View$ConversationalFormV2$dropStashedValues, reaskFields, state_.X);
									var _v10 = response.aec;
									var sanitisedKvs = _v10;
									var mergedInput = A3(
										$elm$core$List$foldl,
										F2(
											function (_v11, acc) {
												var n = _v11.a;
												var v = _v11.b;
												return A2($elm$core$List$member, n, reaskFields) ? A2($pzp1997$assoc_list$AssocList$remove, n, acc) : A3($pzp1997$assoc_list$AssocList$insert, n, v, acc);
											}),
										$author$project$View$FormV2$getFormInput(state_.IF),
										sanitisedKvs);
									var clearedForm = A2(
										$author$project$View$FormV2$setSubmitStatus,
										$author$project$Data$Status$NotAsked,
										A2($author$project$View$FormV2$setFormInput, mergedInput, state_.IF));
									return _Utils_Tuple2(
										A3(
											$author$project$View$ConversationalFormV2$recordAiBubbles,
											state_.a,
											aiSuggestions,
											_Utils_update(
												state_,
												{
													x: A2($author$project$View$ConversationalFormV2$dropAutoAnswered, reaskFields, state_.x),
													IF: clearedForm,
													w: aiSuggestions,
													an: $author$project$View$ConversationalFormV2$rejectedElsewhere(state_),
													X: prunedStash,
													s: 0
												})),
										$elm$core$Platform$Cmd$batch(
											A2(
												$elm$core$List$cons,
												A2(
													$elm$core$Task$attempt,
													$elm$core$Basics$always(
														config.aut($author$project$View$ConversationalFormV2$NoOp)),
													$author$project$View$ConversationalFormV2$scrollThreadToBottom),
												handoffCmds)));
								} else {
									var rawNextIdx = function () {
										var _v18 = state_.aB;
										if (!_v18.$) {
											var returnIdx = _v18.a;
											return returnIdx;
										} else {
											return state_.a + 1;
										}
									}();
									var isCorrectionReturn = !_Utils_eq(state_.aB, $elm$core$Maybe$Nothing);
									var _v12 = response.aec;
									var sanitisedKvs = _v12;
									var mergeableKvs = A2(
										$elm$core$List$filter,
										function (_v17) {
											var n = _v17.a;
											return !$author$project$View$ConversationalFormV2$isCustomFieldName(n);
										},
										sanitisedKvs);
									var mergedInput = A3(
										$elm$core$List$foldl,
										F2(
											function (_v16, acc) {
												var n = _v16.a;
												var v = _v16.b;
												return A3($pzp1997$assoc_list$AssocList$insert, n, v, acc);
											}),
										$author$project$View$FormV2$getFormInput(state_.IF),
										mergeableKvs);
									var clearedForm = A2(
										$author$project$View$FormV2$setSubmitStatus,
										$author$project$Data$Status$NotAsked,
										A2($author$project$View$FormV2$setFormInput, mergedInput, state_.IF));
									var steps = $author$project$View$ConversationalFormV2$visibleSteps(clearedForm);
									var historyOnLeaving = isCorrectionReturn ? state_.z : A3($author$project$View$ConversationalFormV2$pushHistory, state_.a, steps, state_.z);
									var landing = A4($author$project$View$ConversationalFormV2$advanceTarget, state_.x, steps, rawNextIdx, historyOnLeaving);
									var nextIdx = landing.NR;
									var totalSteps = $elm$core$List$length(steps);
									if (_Utils_cmp(nextIdx, totalSteps) > -1) {
										var advancedState = _Utils_update(
											state_,
											{IF: clearedForm, w: _List_Nil, s: 0});
										var $temp$config = config,
											$temp$msg = $author$project$View$ConversationalFormV2$ConvSubmit,
											$temp$state = advancedState;
										config = $temp$config;
										msg = $temp$msg;
										state = $temp$state;
										continue update;
									} else {
										var nextStep = $elm$core$List$head(
											A2($elm$core$List$drop, nextIdx, steps));
										var nextPrompt = A2(
											$elm$core$Maybe$withDefault,
											'',
											A2(
												$elm$core$Maybe$map,
												A2($author$project$View$ConversationalFormV2$botPromptForStep, config.anB, state_.IF),
												nextStep));
										var currentStep_ = $elm$core$List$head(
											A2($elm$core$List$drop, state_.a, steps));
										var userTurn = A4(
											$author$project$Effect$ConversationalTranscript$buildUserTurnRecord,
											$author$project$View$ConversationalFormV2$stepForTranscript(currentStep_),
											response.aec,
											$author$project$Data$Form$fieldNameToString,
											$author$project$View$ConversationalFormV2$renderFieldValue);
										var wasPrivacyStep = function () {
											if ((!currentStep_.$) && (currentStep_.a.$ === 2)) {
												var _v15 = currentStep_.a;
												return true;
											} else {
												return false;
											}
										}();
										var privacyTurn = wasPrivacyStep ? $elm$core$Maybe$Just(
											A2(
												$author$project$Effect$ConversationalTranscript$systemTurn,
												0,
												$elm$core$String$fromInt(
													$author$project$View$ConversationalFormV2$questionStepCount(steps)))) : $elm$core$Maybe$Nothing;
										var botTurn = A2(
											$author$project$Effect$ConversationalTranscript$buildBotTurnRecord,
											A2($elm$core$Maybe$andThen, $author$project$View$ConversationalFormV2$questionFieldKey, nextStep),
											A2(
												$elm$core$Maybe$withDefault,
												'',
												A2(
													$elm$core$Maybe$map,
													A2($author$project$View$ConversationalFormV2$transcriptBotPrompt, config.anB, clearedForm),
													nextStep)));
										var _v13 = A3(
											$author$project$View$ConversationalFormV2$dispatchTurns,
											config,
											state_,
											A2(
												$elm$core$List$filterMap,
												$elm$core$Basics$identity,
												_List_fromArray(
													[privacyTurn, userTurn, botTurn])));
										var finalState = _v13.a;
										var recordingCmds = _v13.b;
										return _Utils_Tuple2(
											_Utils_update(
												finalState,
												{
													x: $author$project$View$ConversationalFormV2$autoAnsweredElsewhere(state_),
													g: A2(
														$author$project$View$ConversationalFormV2$previousRawInputAtStep,
														nextIdx,
														_Utils_update(
															state_,
															{IF: clearedForm})),
													a: nextIdx,
													cl: state_.cl || wasPrivacyStep,
													IF: clearedForm,
													w: _List_Nil,
													af: A2($author$project$View$ConversationalFormV2$pendingBotIdxFor, state_.cI, nextIdx),
													aB: $elm$core$Maybe$Nothing,
													an: $author$project$View$ConversationalFormV2$rejectedElsewhere(state_),
													z: landing.MO,
													s: 0
												}),
											$elm$core$Platform$Cmd$batch(
												_Utils_ap(
													_List_fromArray(
														[
															A2(
															$elm$core$Platform$Cmd$map,
															config.aut,
															A2(
																$elm$core$Task$perform,
																A2($author$project$View$ConversationalFormV2$StepAdvancedTick, state_.a, nextIdx),
																$elm$time$Time$now)),
															A2(
															$elm$core$Task$attempt,
															$elm$core$Basics$always(
																config.aut($author$project$View$ConversationalFormV2$NoOp)),
															$author$project$View$ConversationalFormV2$scrollThreadToBottom),
															config.at_,
															A4($author$project$View$ConversationalFormV2$typingDelayCmd, config.aut, state_.cI, nextIdx, nextPrompt),
															A2(
															$elm$core$Maybe$withDefault,
															$elm$core$Platform$Cmd$none,
															A2(
																$elm$core$Maybe$map,
																A3($author$project$View$ConversationalFormV2$autoAdvanceFromNarratorCmd, config.aut, state_.cI, nextIdx),
																nextStep))
														]),
													recordingCmds)));
									}
								}
							}
						}
					}
				case 6:
					var targetIdx = msg.a;
					var totalSteps = $elm$core$List$length(
						$author$project$View$ConversationalFormV2$visibleSteps(state_.IF));
					var safeIdx = A2(
						$elm$core$Basics$max,
						0,
						A2($elm$core$Basics$min, targetIdx, totalSteps - 1));
					var truncatedForm = (_Utils_cmp(safeIdx, state_.a) < 0) ? A2($author$project$View$ConversationalFormV2$truncateFormAfterStep, safeIdx, state_.IF) : state_.IF;
					var clearedForm = A2($author$project$View$FormV2$setSubmitStatus, $author$project$Data$Status$NotAsked, truncatedForm);
					return _Utils_eq(safeIdx, state_.a) ? _Utils_Tuple2(state, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(
						_Utils_update(
							state_,
							{
								a: safeIdx,
								IF: clearedForm,
								af: $elm$core$Maybe$Nothing,
								z: A3(
									$author$project$View$ConversationalFormV2$pushHistory,
									state_.a,
									$author$project$View$ConversationalFormV2$visibleSteps(state_.IF),
									state_.z),
								s: 0
							}),
						A2(
							$elm$core$Platform$Cmd$map,
							config.aut,
							A2($elm$core$Task$perform, $author$project$View$ConversationalFormV2$StepTick, $elm$time$Time$now)));
				case 7:
					var fieldName = msg.a;
					var fieldValue = msg.b;
					var mergedInput = A3(
						$pzp1997$assoc_list$AssocList$insert,
						fieldName,
						fieldValue,
						$author$project$View$FormV2$getFormInput(state_.IF));
					var newForm = A2($author$project$View$FormV2$setFormInput, mergedInput, state_.IF);
					var isSkipLikeValue = function () {
						if ((fieldValue.$ === 3) && (fieldValue.a.$ === 1)) {
							var _v20 = fieldValue.a;
							return true;
						} else {
							return false;
						}
					}();
					var isPrivacyClick = _Utils_eq(fieldName, $author$project$Model$FormFieldV2$Privacy);
					var isPrivacyDecline = isPrivacyClick && _Utils_eq(
						fieldValue,
						$author$project$Model$FormFieldValueV2$BoolValue(false));
					if (isPrivacyDecline) {
						var explainText = A3($author$project$Data$Translation$translateOr, config.anB, 'conversational-privacy-decline-explain', 'Geen probleem dat je twijfelt — maar zonder akkoord met de privacyverklaring kunnen we je sollicitatie niet verwerken. Klik **Akkoord** als je verder wilt.');
						var declineLabel = A3($author$project$Data$Translation$translateOr, config.anB, 'conversational-privacy-decline', 'Niet akkoord');
						var clearedState = _Utils_update(
							state_,
							{
								H: A2($elm$core$Dict$remove, state_.a, state_.H),
								I: A2($elm$core$Dict$remove, state_.a, state_.I),
								IF: newForm
							});
						var stateWithUser = A3($author$project$View$ConversationalFormV2$recordUserAttempt, state_.a, declineLabel, clearedState);
						var stateWithBot = A3($author$project$View$ConversationalFormV2$recordBotReask, state_.a, explainText, stateWithUser);
						return _Utils_Tuple2(
							stateWithBot,
							A2(
								$elm$core$Task$attempt,
								$elm$core$Basics$always(
									config.aut($author$project$View$ConversationalFormV2$NoOp)),
								$author$project$View$ConversationalFormV2$scrollThreadToBottom));
					} else {
						if (isPrivacyClick) {
							var clearedState = _Utils_update(
								state_,
								{
									H: A2($elm$core$Dict$remove, state_.a, state_.H),
									I: A2($elm$core$Dict$remove, state_.a, state_.I),
									IF: newForm
								});
							var acceptLabel = A3($author$project$Data$Translation$translateOr, config.anB, 'conversational-privacy-accept', 'Akkoord');
							var stateWithUser = A3($author$project$View$ConversationalFormV2$recordUserAttempt, state_.a, acceptLabel, clearedState);
							var $temp$config = config,
								$temp$msg = $author$project$View$ConversationalFormV2$ConvNext,
								$temp$state = stateWithUser;
							config = $temp$config;
							msg = $temp$msg;
							state = $temp$state;
							continue update;
						} else {
							var stateWithHistory = isSkipLikeValue ? A3(
								$author$project$View$ConversationalFormV2$recordUserAttempt,
								state_.a,
								$author$project$View$ConversationalFormV2$skipMarker,
								_Utils_update(
									state_,
									{IF: newForm})) : _Utils_update(
								state_,
								{IF: newForm});
							var $temp$config = config,
								$temp$msg = $author$project$View$ConversationalFormV2$ConvNext,
								$temp$state = stateWithHistory;
							config = $temp$config;
							msg = $temp$msg;
							state = $temp$state;
							continue update;
						}
					}
				case 8:
					var fieldName = msg.a;
					var newSelection = msg.b;
					var mergedInput = A3(
						$pzp1997$assoc_list$AssocList$insert,
						fieldName,
						$author$project$Model$FormFieldValueV2$SelectMultipleValue(newSelection),
						$author$project$View$FormV2$getFormInput(state_.IF));
					var newForm = A2($author$project$View$FormV2$setFormInput, mergedInput, state_.IF);
					return _Utils_Tuple2(
						_Utils_update(
							state_,
							{IF: newForm}),
						A2(
							$elm$core$Task$attempt,
							$elm$core$Basics$always(
								config.aut($author$project$View$ConversationalFormV2$NoOp)),
							$author$project$View$ConversationalFormV2$scrollThreadToBottom));
				case 9:
					var fieldName = msg.a;
					var newSelection = msg.b;
					var mergedInput = A3(
						$pzp1997$assoc_list$AssocList$insert,
						fieldName,
						$author$project$Model$FormFieldValueV2$DaypartAvailabilityValue(newSelection),
						$author$project$View$FormV2$getFormInput(state_.IF));
					var newForm = A2($author$project$View$FormV2$setFormInput, mergedInput, state_.IF);
					return _Utils_Tuple2(
						_Utils_update(
							state_,
							{IF: newForm}),
						A2(
							$elm$core$Task$attempt,
							$elm$core$Basics$always(
								config.aut($author$project$View$ConversationalFormV2$NoOp)),
							$author$project$View$ConversationalFormV2$scrollThreadToBottom));
				case 10:
					var options = msg.a;
					var fieldName = msg.b;
					var _v21 = A3(
						$author$project$View$FormV2$update,
						{
							atp: config.ag$,
							aut: A2($elm$core$Basics$composeL, config.aut, $author$project$View$ConversationalFormV2$FormMsg),
							au4: $elm$core$Platform$Cmd$none,
							X1: function (url) {
								return A2($author$project$View$ConversationalFormV2$revealSuccessCardAfterDelay, config, url.av7);
							},
							aaH: config.aaH,
							ac7: config.ac7,
							alw: state_.alw
						},
						A2($author$project$View$FormV2$SelectFile, options, fieldName),
						state_.IF);
					var updatedForm = _v21.a;
					var formCmds = _v21.b;
					return _Utils_Tuple2(
						_Utils_update(
							state_,
							{bJ: $elm$core$Maybe$Nothing, IF: updatedForm}),
						formCmds);
				case 11:
					var delta = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							state_,
							{
								a6: A2($elm$core$Basics$max, 0, state_.a6 + delta)
							}),
						$elm$core$Platform$Cmd$none);
				case 12:
					var files = msg.a;
					var _v22 = _Utils_Tuple2(
						$author$project$View$ConversationalFormV2$activeFileDrop(state),
						$elm$core$List$head(files));
					if ((!_v22.a.$) && (!_v22.b.$)) {
						var _v23 = _v22.a.a;
						var options = _v23.a;
						var fieldName = _v23.b;
						var file = _v22.b.a;
						return A5(
							$author$project$View$ConversationalFormV2$dropFile,
							config,
							_Utils_update(
								state_,
								{a6: 0}),
							options,
							fieldName,
							file);
					} else {
						return _Utils_Tuple2(
							_Utils_update(
								state_,
								{a6: 0}),
							$elm$core$Platform$Cmd$none);
					}
				case 23:
					var idx = msg.a;
					return _Utils_eq(
						state_.af,
						$elm$core$Maybe$Just(idx)) ? _Utils_Tuple2(
						_Utils_update(
							state_,
							{af: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2(
									$elm$core$Task$attempt,
									$elm$core$Basics$always(
										config.aut($author$project$View$ConversationalFormV2$NoOp)),
									$author$project$View$ConversationalFormV2$scrollThreadToBottom),
									config.at_
								]))) : _Utils_Tuple2(state, $elm$core$Platform$Cmd$none);
				case 24:
					var idx = msg.a;
					if (_Utils_eq(state_.a, idx)) {
						var $temp$config = config,
							$temp$msg = $author$project$View$ConversationalFormV2$ConvNext,
							$temp$state = state;
						config = $temp$config;
						msg = $temp$msg;
						state = $temp$state;
						continue update;
					} else {
						return _Utils_Tuple2(state, $elm$core$Platform$Cmd$none);
					}
				case 2:
					var _v24 = A2(
						$author$project$View$ConversationalFormV2$popHistory,
						$author$project$View$ConversationalFormV2$visibleSteps(state_.IF),
						state_.z);
					if (_v24.$ === 1) {
						return _Utils_Tuple2(state, $elm$core$Platform$Cmd$none);
					} else {
						var _v25 = _v24.a;
						var prev = _v25.a;
						var rest = _v25.b;
						var priorUserHistory = A2($elm$core$Dict$remove, prev, state_.I);
						var priorBotHistory = A2($elm$core$Dict$remove, prev, state_.H);
						var prefilledComposer = A2($author$project$View$ConversationalFormV2$previousRawInputAtStep, prev, state_);
						var clearedForm = A2($author$project$View$FormV2$setSubmitStatus, $author$project$Data$Status$NotAsked, state_.IF);
						var backTurn = A2(
							$author$project$Effect$ConversationalTranscript$systemTurn,
							1,
							$elm$core$String$fromInt(state_.a) + ('->' + $elm$core$String$fromInt(prev)));
						var analyticsCmd = config.aaE(
							A2(
								$author$project$Analytics$Conversational$event,
								'conversational-apply-step-back',
								_List_fromArray(
									[
										_Utils_Tuple2(
										'from_step',
										$elm$json$Json$Encode$int(state_.a)),
										_Utils_Tuple2(
										'to_step',
										$elm$json$Json$Encode$int(prev)),
										_Utils_Tuple2(
										'vacancy_id',
										$author$project$Analytics$Conversational$maybeVacancy(state_.aqL)),
										_Utils_Tuple2(
										'session_id',
										$author$project$Analytics$Conversational$maybeString(config.ag$))
									])));
						var _v26 = A3(
							$author$project$View$ConversationalFormV2$dispatchTurns,
							config,
							state_,
							_List_fromArray(
								[backTurn]));
						var finalState = _v26.a;
						var recordingCmds = _v26.b;
						return _Utils_Tuple2(
							_Utils_update(
								finalState,
								{H: priorBotHistory, I: priorUserHistory, g: prefilledComposer, t: false, a: prev, IF: clearedForm, M: false, w: _List_Nil, aB: $elm$core$Maybe$Nothing, z: rest, s: 0}),
							$elm$core$Platform$Cmd$batch(
								A2($elm$core$List$cons, analyticsCmd, recordingCmds)));
					}
				case 3:
					return _Utils_Tuple2(
						_Utils_update(
							state_,
							{
								x: _List_Nil,
								H: $elm$core$Dict$empty,
								I: $elm$core$Dict$empty,
								g: '',
								t: false,
								a: 0,
								IF: A2(
									$author$project$View$FormV2$setSubmitStatus,
									$author$project$Data$Status$NotAsked,
									A2($author$project$View$FormV2$setFormInput, $pzp1997$assoc_list$AssocList$empty, state_.IF)),
								M: false,
								w: _List_Nil,
								aB: $elm$core$Maybe$Nothing,
								an: _List_Nil,
								cK: $elm$core$Maybe$Nothing,
								X: _List_Nil,
								z: _List_Nil,
								s: 0,
								a2: false
							}),
						config.aaE(
							A2(
								$author$project$Analytics$Conversational$event,
								'conversational-apply-restart',
								_List_fromArray(
									[
										_Utils_Tuple2(
										'from_step',
										$elm$json$Json$Encode$int(state_.a)),
										_Utils_Tuple2(
										'vacancy_id',
										$author$project$Analytics$Conversational$maybeVacancy(state_.aqL)),
										_Utils_Tuple2(
										'session_id',
										$author$project$Analytics$Conversational$maybeString(config.ag$))
									]))));
				case 4:
					var values = msg.a;
					var kvs = values;
					var _v27 = A2($author$project$View$ConversationalFormV2$applyResumeValues, values, state_);
					var appliedState_ = _v27;
					var shownCmd = config.aaE(
						A4(
							$author$project$View$ConversationalFormV2$stepShownEventValue,
							config,
							appliedState_.aqL,
							$elm$core$List$length(
								$author$project$View$ConversationalFormV2$visibleSteps(appliedState_.IF)),
							appliedState_.a));
					if ($elm$core$List$isEmpty(kvs)) {
						return _Utils_Tuple2(appliedState_, shownCmd);
					} else {
						var resumeTurn = A2(
							$author$project$Effect$ConversationalTranscript$systemTurn,
							2,
							$elm$core$String$fromInt(appliedState_.a));
						var _v28 = A3(
							$author$project$View$ConversationalFormV2$dispatchTurns,
							config,
							appliedState_,
							_List_fromArray(
								[resumeTurn]));
						var finalState = _v28.a;
						var recordingCmds = _v28.b;
						return _Utils_Tuple2(
							finalState,
							$elm$core$Platform$Cmd$batch(
								A2($elm$core$List$cons, shownCmd, recordingCmds)));
					}
				case 14:
					var suggestion = msg.a;
					var withUserBubble = A3(
						$author$project$View$ConversationalFormV2$recordUserAttempt,
						state_.a,
						$author$project$View$ConversationalFormV2$confirmAcceptMarker,
						_Utils_update(
							state_,
							{t: true}));
					var _v29 = A3(
						$author$project$View$ConversationalFormV2$dispatchTurns,
						config,
						withUserBubble,
						_List_fromArray(
							[
								A2(
								$author$project$View$ConversationalFormV2$aiClarificationTurnFromSuggestion,
								suggestion,
								$elm$core$Maybe$Just(true))
							]));
					var withClarification = _v29.a;
					var clarificationCmds = _v29.b;
					return _Utils_Tuple2(
						withClarification,
						$elm$core$Platform$Cmd$batch(
							A2(
								$elm$core$List$cons,
								A4($author$project$View$ConversationalFormV2$postConfirmCmd, config, state, true, suggestion),
								A2(
									$elm$core$List$cons,
									A2(
										$elm$core$Task$attempt,
										$elm$core$Basics$always(
											config.aut($author$project$View$ConversationalFormV2$NoOp)),
										$author$project$View$ConversationalFormV2$scrollThreadToBottom),
									clarificationCmds))));
				case 15:
					var suggestion = msg.a;
					var isPlausibilityChallenge = function () {
						var _v35 = $author$project$Data$FieldValidation$decodeFieldName(suggestion.akQ);
						if (!_v35.$) {
							var fName = _v35.a;
							var _v36 = A2(
								$pzp1997$assoc_list$AssocList$get,
								fName,
								$author$project$View$FormV2$getFormInput(state_.IF));
							if ((!_v36.$) && (!_v36.a.$)) {
								var stored = _v36.a.a;
								return _Utils_eq(stored, suggestion.akT);
							} else {
								return false;
							}
						} else {
							return false;
						}
					}();
					var clearedForm = function () {
						if (isPlausibilityChallenge) {
							var _v34 = $author$project$Data$FieldValidation$decodeFieldName(suggestion.akQ);
							if (!_v34.$) {
								var fName = _v34.a;
								return A2(
									$author$project$View$FormV2$setFormInput,
									A2(
										$pzp1997$assoc_list$AssocList$remove,
										fName,
										$author$project$View$FormV2$getFormInput(state_.IF)),
									state_.IF);
							} else {
								return state_.IF;
							}
						} else {
							return state_.IF;
						}
					}();
					var clearedComposer = function () {
						if (isPlausibilityChallenge) {
							return '';
						} else {
							var _v31 = $author$project$Data$FieldValidation$decodeFieldName(suggestion.akQ);
							if (!_v31.$) {
								var fName = _v31.a;
								var _v32 = A2(
									$pzp1997$assoc_list$AssocList$get,
									fName,
									$author$project$View$FormV2$getFormInput(state_.IF));
								_v32$2:
								while (true) {
									if (!_v32.$) {
										switch (_v32.a.$) {
											case 0:
												var stored = _v32.a.a;
												return stored;
											case 8:
												var _v33 = _v32.a;
												var stored = _v33.b;
												return stored;
											default:
												break _v32$2;
										}
									} else {
										break _v32$2;
									}
								}
								return state_.g;
							} else {
								return state_.g;
							}
						}
					}();
					var withUserBubble = A3(
						$author$project$View$ConversationalFormV2$recordUserAttempt,
						state_.a,
						$author$project$View$ConversationalFormV2$confirmRejectMarker,
						_Utils_update(
							state_,
							{
								x: isPlausibilityChallenge ? A2(
									$author$project$View$ConversationalFormV2$dropAutoAnswered,
									A2(
										$elm$core$List$filterMap,
										$elm$core$Basics$identity,
										_List_fromArray(
											[
												$author$project$Data$FieldValidation$decodeFieldName(suggestion.akQ)
											])),
									state_.x) : state_.x,
								g: clearedComposer,
								t: true,
								IF: clearedForm,
								w: A2(
									$elm$core$List$filter,
									function (s) {
										return !_Utils_eq(s.akQ, suggestion.akQ);
									},
									state_.w),
								X: isPlausibilityChallenge ? A2(
									$author$project$View$ConversationalFormV2$dropStashedValues,
									A2(
										$elm$core$List$filterMap,
										$elm$core$Basics$identity,
										_List_fromArray(
											[
												$author$project$Data$FieldValidation$decodeFieldName(suggestion.akQ)
											])),
									state_.X) : state_.X
							}));
					var _v30 = A3(
						$author$project$View$ConversationalFormV2$dispatchTurns,
						config,
						withUserBubble,
						_List_fromArray(
							[
								A2(
								$author$project$View$ConversationalFormV2$aiClarificationTurnFromSuggestion,
								suggestion,
								$elm$core$Maybe$Just(false))
							]));
					var withClarification = _v30.a;
					var clarificationCmds = _v30.b;
					return _Utils_Tuple2(
						withClarification,
						$elm$core$Platform$Cmd$batch(
							A2(
								$elm$core$List$cons,
								A4($author$project$View$ConversationalFormV2$postConfirmCmd, config, state, false, suggestion),
								A2(
									$elm$core$List$cons,
									A2(
										$elm$core$Task$attempt,
										$elm$core$Basics$always(
											config.aut($author$project$View$ConversationalFormV2$NoOp)),
										$author$project$View$ConversationalFormV2$scrollThreadToBottom),
									clarificationCmds))));
				case 16:
					var suggestion = msg.a;
					if (A2($author$project$View$ConversationalFormV2$skipSuggestionTargetsRequiredField, state_, suggestion)) {
						var currentFieldM = A2(
							$elm$core$Maybe$andThen,
							$author$project$View$ConversationalFormV2$firstFieldOfStep,
							$elm$core$List$head(
								A2(
									$elm$core$List$drop,
									state_.a,
									$author$project$View$ConversationalFormV2$visibleSteps(state_.IF))));
						var explainText = function () {
							if (!currentFieldM.$) {
								var field = currentFieldM.a;
								return A2($author$project$Page$ConversationalForm$Diagnose$interrogativeFallback, config.anB, field);
							} else {
								return A3($author$project$Data$Translation$translateOr, config.anB, 'conversational-retry-default', 'Sorry, dat begreep ik niet — kun je het nog eens anders proberen?');
							}
						}();
						var cleared = _Utils_update(
							state_,
							{t: false, w: _List_Nil});
						return _Utils_Tuple2(
							A3($author$project$View$ConversationalFormV2$recordBotReask, state_.a, explainText, cleared),
							A2(
								$elm$core$Task$attempt,
								$elm$core$Basics$always(
									config.aut($author$project$View$ConversationalFormV2$NoOp)),
								$author$project$View$ConversationalFormV2$scrollThreadToBottom));
					} else {
						return A3($author$project$View$ConversationalFormV2$convAiSkipAdvance, config, state_, suggestion);
					}
				case 17:
					if (msg.b.$ === 1) {
						var suggestion = msg.a;
						var err = msg.b.a;
						if (!state_.t) {
							return _Utils_Tuple2(state, $elm$core$Platform$Cmd$none);
						} else {
							var formWithError = A2(
								$author$project$View$FormV2$setSubmitStatus,
								$author$project$Data$Status$Failure(err),
								state_.IF);
							var analyticsCmd = config.aaE(
								A2(
									$author$project$Analytics$Conversational$event,
									'conversational-apply-step-validation-failed',
									_List_fromArray(
										[
											_Utils_Tuple2(
											'step_index',
											$elm$json$Json$Encode$int(state_.a)),
											_Utils_Tuple2(
											'error_count',
											$elm$json$Json$Encode$int(1)),
											_Utils_Tuple2(
											'error_kind',
											$elm$json$Json$Encode$string('ai-confirm-network')),
											_Utils_Tuple2(
											'field_name',
											$elm$json$Json$Encode$string(suggestion.akQ)),
											_Utils_Tuple2(
											'vacancy_id',
											$author$project$Analytics$Conversational$maybeVacancy(state_.aqL)),
											_Utils_Tuple2(
											'session_id',
											$author$project$Analytics$Conversational$maybeString(config.ag$))
										])));
							return _Utils_Tuple2(
								_Utils_update(
									state_,
									{t: false, IF: formWithError}),
								analyticsCmd);
						}
					} else {
						var suggestion = msg.a;
						var response = msg.b.a;
						if (!state_.t) {
							return _Utils_Tuple2(state, $elm$core$Platform$Cmd$none);
						} else {
							if (response.r5) {
								var fieldName = $author$project$Data$FieldValidation$decodeFieldName(response.sg);
								var mergedInput = function () {
									var _v41 = _Utils_Tuple2(fieldName, response.sj);
									if ((!_v41.a.$) && (!_v41.b.$)) {
										var n = _v41.a.a;
										var v = _v41.b.a;
										return A3(
											$pzp1997$assoc_list$AssocList$insert,
											n,
											v,
											$author$project$View$FormV2$getFormInput(state_.IF));
									} else {
										return $author$project$View$FormV2$getFormInput(state_.IF);
									}
								}();
								var releasedRejections = A2(
									$elm$core$List$filter,
									function (n) {
										return !_Utils_eq(
											$elm$core$Maybe$Just(n),
											fieldName);
									},
									state_.an);
								var clearedForm = A2(
									$author$project$View$FormV2$setSubmitStatus,
									$author$project$Data$Status$NotAsked,
									A2($author$project$View$FormV2$setFormInput, mergedInput, state_.IF));
								var steps = $author$project$View$ConversationalFormV2$visibleSteps(clearedForm);
								var correctedTurn = function () {
									var _v40 = _Utils_Tuple2(fieldName, response.sj);
									if ((!_v40.a.$) && (!_v40.b.$)) {
										var n = _v40.a.a;
										var v = _v40.b.a;
										return A4(
											$author$project$Effect$ConversationalTranscript$buildUserTurnRecord,
											$author$project$View$ConversationalFormV2$stepForTranscript(
												$elm$core$List$head(
													A2($elm$core$List$drop, state_.a, steps))),
											_List_fromArray(
												[
													_Utils_Tuple2(n, v)
												]),
											$author$project$Data$Form$fieldNameToString,
											$author$project$View$ConversationalFormV2$renderFieldValue);
									} else {
										return $elm$core$Maybe$Nothing;
									}
								}();
								var landing = A4(
									$author$project$View$ConversationalFormV2$advanceTarget,
									state_.x,
									steps,
									state_.a + 1,
									A3($author$project$View$ConversationalFormV2$pushHistory, state_.a, steps, state_.z));
								var nextIdx = landing.NR;
								var totalSteps = $elm$core$List$length(steps);
								var acceptedCmd = config.aaE(
									A2(
										$author$project$Analytics$Conversational$event,
										'conversational-apply-ai-accepted',
										_List_fromArray(
											[
												_Utils_Tuple2(
												'field_name',
												$elm$json$Json$Encode$string(suggestion.akQ)),
												_Utils_Tuple2(
												'vacancy_id',
												$author$project$Analytics$Conversational$maybeVacancy(state_.aqL)),
												_Utils_Tuple2(
												'session_id',
												$author$project$Analytics$Conversational$maybeString(config.ag$))
											])));
								if (_Utils_cmp(nextIdx, totalSteps) > -1) {
									var advancedState = _Utils_update(
										state_,
										{t: false, IF: clearedForm, w: _List_Nil, an: releasedRejections});
									var _v38 = A3($author$project$View$ConversationalFormV2$update, config, $author$project$View$ConversationalFormV2$ConvSubmit, advancedState);
									var submitState = _v38.a;
									var submitCmd = _v38.b;
									return _Utils_Tuple2(
										submitState,
										$elm$core$Platform$Cmd$batch(
											_List_fromArray(
												[submitCmd, acceptedCmd])));
								} else {
									var nextStep = $elm$core$List$head(
										A2($elm$core$List$drop, nextIdx, steps));
									var nextPrompt = A2(
										$elm$core$Maybe$withDefault,
										'',
										A2(
											$elm$core$Maybe$map,
											A2($author$project$View$ConversationalFormV2$botPromptForStep, config.anB, clearedForm),
											nextStep));
									var _v39 = A3(
										$author$project$View$ConversationalFormV2$dispatchTurns,
										config,
										state_,
										A2(
											$elm$core$List$filterMap,
											$elm$core$Basics$identity,
											_List_fromArray(
												[correctedTurn])));
									var dispatchedState = _v39.a;
									var correctionCmds = _v39.b;
									return _Utils_Tuple2(
										_Utils_update(
											dispatchedState,
											{
												g: A2(
													$author$project$View$ConversationalFormV2$previousRawInputAtStep,
													nextIdx,
													_Utils_update(
														state_,
														{IF: clearedForm})),
												t: false,
												a: nextIdx,
												IF: clearedForm,
												w: _List_Nil,
												af: A2($author$project$View$ConversationalFormV2$pendingBotIdxFor, state_.cI, nextIdx),
												an: releasedRejections,
												z: landing.MO
											}),
										$elm$core$Platform$Cmd$batch(
											_Utils_ap(
												_List_fromArray(
													[
														acceptedCmd,
														A2(
														$elm$core$Platform$Cmd$map,
														config.aut,
														A2(
															$elm$core$Task$perform,
															A2($author$project$View$ConversationalFormV2$StepAdvancedTick, state_.a, nextIdx),
															$elm$time$Time$now)),
														A2(
														$elm$core$Task$attempt,
														$elm$core$Basics$always(
															config.aut($author$project$View$ConversationalFormV2$NoOp)),
														$author$project$View$ConversationalFormV2$scrollThreadToBottom),
														config.at_,
														A4($author$project$View$ConversationalFormV2$typingDelayCmd, config.aut, state_.cI, nextIdx, nextPrompt),
														A2(
														$elm$core$Maybe$withDefault,
														$elm$core$Platform$Cmd$none,
														A2(
															$elm$core$Maybe$map,
															A3($author$project$View$ConversationalFormV2$autoAdvanceFromNarratorCmd, config.aut, state_.cI, nextIdx),
															nextStep))
													]),
												correctionCmds)));
								}
							} else {
								var rejectedCmd = config.aaE(
									A2(
										$author$project$Analytics$Conversational$event,
										'conversational-apply-ai-rejected',
										_List_fromArray(
											[
												_Utils_Tuple2(
												'field_name',
												$elm$json$Json$Encode$string(suggestion.akQ)),
												_Utils_Tuple2(
												'vacancy_id',
												$author$project$Analytics$Conversational$maybeVacancy(state_.aqL)),
												_Utils_Tuple2(
												'session_id',
												$author$project$Analytics$Conversational$maybeString(config.ag$))
											])));
								var formWithErrors = $elm$core$Dict$isEmpty(response.sf.atU) ? state_.IF : A2(
									$author$project$View$FormV2$setSubmitStatus,
									$author$project$Data$Status$Failure(
										$author$project$Api$ValidationError(response.sf)),
									state_.IF);
								return _Utils_Tuple2(
									_Utils_update(
										state_,
										{t: false, IF: formWithErrors}),
									rejectedCmd);
							}
						}
					}
				case 18:
					var intent = msg.a;
					return A3($author$project$View$ConversationalFormV2$handleIntent, config, state_, intent);
				case 19:
					if (!msg.b.$) {
						return _Utils_Tuple2(state, $elm$core$Platform$Cmd$none);
					} else {
						var idx = msg.a;
						var err = msg.b.a;
						return _Utils_Tuple2(
							state,
							config.aaE(
								A2(
									$author$project$Analytics$Conversational$event,
									'conversational-apply-transcript-write-failed',
									_List_fromArray(
										[
											_Utils_Tuple2(
											'turn_idx',
											$elm$json$Json$Encode$int(idx)),
											_Utils_Tuple2(
											'error',
											$elm$json$Json$Encode$string(
												$author$project$Effect$ConversationalTranscript$httpErrorToString(err))),
											_Utils_Tuple2(
											'vacancy_id',
											$author$project$Analytics$Conversational$maybeVacancy(state_.aqL)),
											_Utils_Tuple2(
											'session_id',
											$author$project$Analytics$Conversational$maybeString(config.ag$))
										]))));
					}
				case 20:
					var now = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							state_,
							{
								b_: $elm$core$Maybe$Just(now),
								b4: function () {
									var _v42 = state_.b4;
									if (_v42.$ === 1) {
										return $elm$core$Maybe$Just(now);
									} else {
										var existing = _v42;
										return existing;
									}
								}()
							}),
						$elm$core$Platform$Cmd$none);
				case 22:
					var now = msg.a;
					var totalSteps = $elm$core$List$length(
						$author$project$View$ConversationalFormV2$visibleSteps(state_.IF));
					var openedIdx = state_.a;
					var openedStep = $elm$core$List$head(
						A2(
							$elm$core$List$drop,
							openedIdx,
							$author$project$View$ConversationalFormV2$visibleSteps(state_.IF)));
					var openedPrompt = A2(
						$elm$core$Maybe$withDefault,
						'',
						A2(
							$elm$core$Maybe$map,
							A2($author$project$View$ConversationalFormV2$botPromptForStep, config.anB, state_.IF),
							openedStep));
					var shownCmd = state_.bV ? $elm$core$Platform$Cmd$none : config.aaE(
						A4($author$project$View$ConversationalFormV2$stepShownEventValue, config, state_.aqL, totalSteps, openedIdx));
					return _Utils_Tuple2(
						_Utils_update(
							state_,
							{
								af: A2($author$project$View$ConversationalFormV2$pendingBotIdxFor, state_.cI, openedIdx),
								b_: $elm$core$Maybe$Just(now),
								b4: $elm$core$Maybe$Just(now)
							}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									shownCmd,
									A4($author$project$View$ConversationalFormV2$typingDelayCmd, config.aut, state_.cI, openedIdx, openedPrompt)
								])));
				case 21:
					var fromIdx = msg.a;
					var toIdx = msg.b;
					var now = msg.c;
					var totalSteps = $elm$core$List$length(
						$author$project$View$ConversationalFormV2$visibleSteps(state_.IF));
					var shownCmd = config.aaE(
						A4($author$project$View$ConversationalFormV2$stepShownEventValue, config, state_.aqL, totalSteps, toIdx));
					var duration = A2(
						$elm$core$Maybe$withDefault,
						0,
						A2(
							$elm$core$Maybe$map,
							function (started) {
								return $elm$time$Time$posixToMillis(now) - $elm$time$Time$posixToMillis(started);
							},
							state_.b_));
					var answeredCmd = config.aaE(
						A2(
							$author$project$Analytics$Conversational$event,
							'conversational-apply-step-answered',
							_List_fromArray(
								[
									_Utils_Tuple2(
									'step_index',
									$elm$json$Json$Encode$int(fromIdx)),
									_Utils_Tuple2(
									'duration_ms',
									$elm$json$Json$Encode$int(duration)),
									_Utils_Tuple2(
									'vacancy_id',
									$author$project$Analytics$Conversational$maybeVacancy(state_.aqL)),
									_Utils_Tuple2(
									'session_id',
									$author$project$Analytics$Conversational$maybeString(config.ag$)),
									_Utils_Tuple2(
									'form_id',
									$elm$json$Json$Encode$string(config.Kq)),
									_Utils_Tuple2(
									'form_name',
									$elm$json$Json$Encode$string(config.aL))
								])));
					return _Utils_Tuple2(
						_Utils_update(
							state_,
							{
								b_: $elm$core$Maybe$Just(now)
							}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[answeredCmd, shownCmd])));
				case 25:
					var w = msg.a;
					var wasMobile = function () {
						var _v43 = state_.f0;
						if (!_v43.$) {
							var prev = _v43.a;
							return $author$project$View$ConversationalFormV2$isMobileWidth(prev);
						} else {
							return true;
						}
					}();
					var crossedToDesktop = wasMobile && ((!$author$project$View$ConversationalFormV2$isMobileWidth(w)) && state_.O1);
					var unlockCmd = crossedToDesktop ? config.awc : $elm$core$Platform$Cmd$none;
					return _Utils_Tuple2(
						_Utils_update(
							state_,
							{
								f0: $elm$core$Maybe$Just(w)
							}),
						unlockCmd);
				case 26:
					var isOpen = msg.a;
					return _Utils_Tuple2(
						state,
						isOpen ? A2(
							$elm$core$Task$attempt,
							$elm$core$Basics$always(
								config.aut($author$project$View$ConversationalFormV2$NoOp)),
							$author$project$View$ConversationalFormV2$scrollThreadToBottomOnKeyboardOpen) : $elm$core$Platform$Cmd$none);
				case 27:
					var isMobileNow = function () {
						var _v44 = state_.f0;
						if (!_v44.$) {
							var w = _v44.a;
							return $author$project$View$ConversationalFormV2$isMobileWidth(w);
						} else {
							return true;
						}
					}();
					var lockCmd = isMobileNow ? config.auA : $elm$core$Platform$Cmd$none;
					var analyticsCmd = config.aaE(
						A2(
							$author$project$Analytics$Conversational$event,
							'conversational-apply-overlay-opened',
							_List_fromArray(
								[
									_Utils_Tuple2(
									'vacancy_id',
									$author$project$Analytics$Conversational$maybeVacancy(state_.aqL)),
									_Utils_Tuple2(
									'session_id',
									$author$project$Analytics$Conversational$maybeString(config.ag$))
								])));
					return _Utils_Tuple2(
						_Utils_update(
							state_,
							{O1: true}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[lockCmd, analyticsCmd, config.at_])));
				case 28:
					return _Utils_Tuple2(
						_Utils_update(
							state_,
							{O1: false}),
						config.awc);
				default:
					var _v45 = A3($author$project$View$ConversationalFormV2$update, config, $author$project$View$ConversationalFormV2$ConvStartOver, state);
					var clearedState = _v45.a;
					var clearCmd = _v45.b;
					var _v46 = A3($author$project$View$ConversationalFormV2$update, config, $author$project$View$ConversationalFormV2$OverlayOpen, clearedState);
					var openedState = _v46.a;
					var openCmd = _v46.b;
					return _Utils_Tuple2(
						openedState,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[clearCmd, openCmd])));
			}
		}
	});
var $author$project$Form$update = F2(
	function (msg, model) {
		update:
		while (true) {
			switch (msg.$) {
				case 0:
					var formMsg = msg.a;
					var _v1 = A3(
						$author$project$View$FormV2$update,
						{
							atp: $elm$core$Maybe$Nothing,
							aut: $elm$core$Basics$identity,
							au4: $author$project$Form$pushAnalyticsEvent(
								$author$project$View$ConversationalFormV2$completedEventValue(model)),
							X1: function (redirect) {
								return $author$project$Form$redirectTo(redirect.av7);
							},
							aaH: A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2($elm$core$Maybe$map, $author$project$Data$GoogleAnalytics$toParams, model.cr)),
							ac7: $author$project$Form$requestCsrfToken,
							alw: $elm$core$Maybe$Nothing
						},
						formMsg,
						model.IF);
					var formModel = _v1.a;
					var formCmds = _v1.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{IF: formModel}),
						A2($elm$core$Platform$Cmd$map, $author$project$Form$FormMsg, formCmds));
				case 1:
					var convMsg = msg.a;
					var _v2 = model.aA;
					if (_v2.$ === 1) {
						var convState = _v2.a;
						var startOverCmd = function () {
							var _v4 = _Utils_Tuple2(convMsg, model.ag$);
							if ((_v4.a.$ === 3) && (!_v4.b.$)) {
								var _v5 = _v4.a;
								var sid = _v4.b.a;
								return A2(
									$author$project$Api$send,
									$author$project$Form$DraftForgotten,
									A2(
										$author$project$Api$deleteWithHeaders,
										A2($author$project$Api$Endpoint$unfinishedApplicationSession, model.dp, sid),
										_List_fromArray(
											[
												_Utils_Tuple2('X-XSRF-TOKEN', model.ci)
											])));
							} else {
								return $elm$core$Platform$Cmd$none;
							}
						}();
						var _v3 = A3(
							$author$project$View$ConversationalFormV2$update,
							{
								at_: $author$project$Form$focusConversationalStep(0),
								Kq: model.Kq,
								aL: model.aL,
								aM: model.aM,
								aut: $elm$core$Basics$identity,
								auA: $author$project$Form$lockBodyScroll(0),
								X1: $author$project$Form$redirectTo,
								avh: false,
								aaE: $author$project$Form$pushAnalyticsEvent,
								aaH: A2(
									$elm$core$Maybe$withDefault,
									_List_Nil,
									A2($elm$core$Maybe$map, $author$project$Data$GoogleAnalytics$toParams, model.cr)),
								ac7: $author$project$Form$requestCsrfToken,
								ag$: model.ag$,
								anB: model.anB,
								awc: $author$project$Form$unlockBodyScroll(0)
							},
							convMsg,
							convState);
						var newConvState = _v3.a;
						var convCmds = _v3.b;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									aA: $author$project$Form$ConversationalMode(newConvState)
								}),
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A2($elm$core$Platform$Cmd$map, $author$project$Form$ConvMsg, convCmds),
										startOverCmd
									])));
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				case 2:
					var gaInfo = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								cr: $elm$core$Maybe$Just(gaInfo)
							}),
						$elm$core$Platform$Cmd$none);
				case 3:
					var result = msg.a;
					var $temp$msg = $author$project$Form$ConvMsg(
						$author$project$View$ConversationalFormV2$ConvResumeApplied(
							$author$project$Form$resumedValues(result))),
						$temp$model = model;
					msg = $temp$msg;
					model = $temp$model;
					continue update;
				case 5:
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				default:
					var rawToken = msg.a;
					var token = A2($author$project$Api$csrfTokenWithDefault, model.ci, rawToken);
					var stored = _Utils_update(
						model,
						{
							ci: token,
							IF: A2($author$project$View$FormV2$setCsrfToken, token, model.IF),
							aA: function () {
								var _v7 = model.aA;
								if (_v7.$ === 1) {
									var convState = _v7.a;
									return $author$project$Form$ConversationalMode(
										A2($author$project$View$ConversationalFormV2$setCsrfToken, token, convState));
								} else {
									return $author$project$Form$LinearMode;
								}
							}()
						});
					var _v6 = stored.aA;
					if (_v6.$ === 1) {
						var $temp$msg = $author$project$Form$ConvMsg(
							$author$project$View$ConversationalFormV2$FormMsg(
								$author$project$View$FormV2$GotCsrfToken(token))),
							$temp$model = stored;
						msg = $temp$msg;
						model = $temp$model;
						continue update;
					} else {
						var $temp$msg = $author$project$Form$FormMsg(
							$author$project$View$FormV2$GotCsrfToken(token)),
							$temp$model = stored;
						msg = $temp$msg;
						model = $temp$model;
						continue update;
					}
			}
		}
	});
var $author$project$View$ConversationalFormV2$markBold = function (value) {
	return $elm$core$String$isEmpty(value) ? value : ('**' + (value + '**'));
};
var $elm$html$Html$strong = _VirtualDom_node('strong');
var $author$project$View$ConversationalFormV2$renderInlineBold = function (raw) {
	var zipAlternate = F3(
		function (idx, items, acc) {
			zipAlternate:
			while (true) {
				if (!items.b) {
					return $elm$core$List$reverse(acc);
				} else {
					var t = items.a;
					var rest = items.b;
					var node = (!A2($elm$core$Basics$modBy, 2, idx)) ? $elm$html$Html$text(t) : A2(
						$elm$html$Html$strong,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(t)
							]));
					var $temp$idx = idx + 1,
						$temp$items = rest,
						$temp$acc = A2($elm$core$List$cons, node, acc);
					idx = $temp$idx;
					items = $temp$items;
					acc = $temp$acc;
					continue zipAlternate;
				}
			}
		});
	var parts = A2($elm$core$String$split, '**', raw);
	if (!parts.b) {
		return _List_Nil;
	} else {
		return (!A2(
			$elm$core$Basics$modBy,
			2,
			$elm$core$List$length(parts))) ? _List_fromArray(
			[
				$elm$html$Html$text(raw)
			]) : A3(zipAlternate, 0, parts, _List_Nil);
	}
};
var $author$project$View$ConversationalFormV2$interpolateBold = F2(
	function (template, values) {
		return $author$project$View$ConversationalFormV2$renderInlineBold(
			A2(
				$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
				template,
				A2($elm$core$List$map, $author$project$View$ConversationalFormV2$markBold, values)));
	});
var $author$project$View$ConversationalFormV2$viewAlreadyAppliedCard = F2(
	function (config, appliedDate) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('conversational-form-card-title conversational-form-welcome-title conversational-form-already-applied-title')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						A3($author$project$Data$Translation$translateOr, config.anB, 'conversational-banner-already-applied-title', $author$project$Copy$copy.us))
					])),
				A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('conversational-form-card-intro')
					]),
				A2(
					$author$project$View$ConversationalFormV2$interpolateBold,
					A3($author$project$Data$Translation$translateOr, config.anB, 'conversational-banner-already-applied-body', $author$project$Copy$copy.uq),
					_List_fromArray(
						[appliedDate]))),
				A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$type_('button'),
						$elm$html$Html$Attributes$class('btn bg-color-1 color-white conversational-form-trigger'),
						$elm$html$Html$Attributes$disabled(true)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						A3($author$project$Data$Translation$translateOr, config.anB, 'conversational-overlay-open', 'Apply'))
					]))
			]);
	});
var $author$project$View$ConversationalFormV2$OverlayRestart = {$: 29};
var $author$project$View$ConversationalFormV2$resumeBannerBody = F4(
	function (config, startedRelative, startedDate, savedUntilDate) {
		var until = A2($elm$core$Maybe$withDefault, '', savedUntilDate);
		switch (startedRelative) {
			case 0:
				return A2(
					$author$project$View$ConversationalFormV2$interpolateBold,
					A3($author$project$Data$Translation$translateOr, config.anB, 'conversational-banner-today', 'Je bent vandaag begonnen met solliciteren op deze vacature. We bewaren je gegevens tot {0}.'),
					_List_fromArray(
						[until]));
			case 1:
				return A2(
					$author$project$View$ConversationalFormV2$interpolateBold,
					A3($author$project$Data$Translation$translateOr, config.anB, 'conversational-banner-yesterday', 'Je bent gisteren begonnen met solliciteren op deze vacature. We bewaren je gegevens tot {0}.'),
					_List_fromArray(
						[until]));
			default:
				return A2(
					$author$project$View$ConversationalFormV2$interpolateBold,
					A3($author$project$Data$Translation$translateOr, config.anB, 'conversational-banner-body', 'Je bent op {0} begonnen met solliciteren op deze vacature. We bewaren je gegevens tot {1}.'),
					_List_fromArray(
						[startedDate, until]));
		}
	});
var $author$project$View$ConversationalFormV2$viewComposerTrigger = F4(
	function (toNode, sharedAttrs, desktopLabel, mobileLabel) {
		return _List_fromArray(
			[
				A2(
				toNode,
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$class('btn bg-color-1 color-white conversational-form-trigger conversational-form-composer-button'),
					sharedAttrs),
				_List_fromArray(
					[
						$elm$html$Html$text(desktopLabel)
					])),
				A2(
				toNode,
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$class('conversational-form-composer'),
					sharedAttrs),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('conversational-form-composer-placeholder')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(mobileLabel)
							])),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('conversational-form-composer-send')
							]),
						_List_fromArray(
							[
								$author$project$View$Icon$view($author$project$View$Icon$path._g)
							]))
					]))
			]);
	});
var $author$project$View$ConversationalFormV2$viewInSessionResumeCard = F2(
	function (config, savedUntilDate) {
		var resumeBody = A4($author$project$View$ConversationalFormV2$resumeBannerBody, config, 0, '', savedUntilDate);
		return _Utils_ap(
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('conversational-form-card-title conversational-form-welcome-title')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A3($author$project$Data$Translation$translateOr, config.anB, 'conversational-resume-title', $author$project$Copy$copy.v8))
						])),
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('conversational-form-card-intro conversational-form-welcome-intro')
						]),
					resumeBody)
				]),
			_Utils_ap(
				A4(
					$author$project$View$ConversationalFormV2$viewComposerTrigger,
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('button'),
							$elm$html$Html$Events$onClick(
							config.aut($author$project$View$ConversationalFormV2$OverlayOpen))
						]),
					A3($author$project$Data$Translation$translateOr, config.anB, 'conversational-banner-continue', $author$project$Copy$copy.uu),
					A3($author$project$Data$Translation$translateOr, config.anB, 'conversational-resume-title', $author$project$Copy$copy.v8)),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$type_('button'),
								$elm$html$Html$Attributes$class('conversational-form-card-link conversational-form-resume-restart'),
								$elm$html$Html$Events$onClick(
								config.aut($author$project$View$ConversationalFormV2$OverlayRestart))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								A3($author$project$Data$Translation$translateOr, config.anB, 'conversational-banner-restart', $author$project$Copy$copy.uv))
							]))
					])));
	});
var $author$project$View$ConversationalFormV2$viewResumeCard = F3(
	function (config, savedUntilDate, resume) {
		var resumeBody = A4($author$project$View$ConversationalFormV2$resumeBannerBody, config, resume.ajz, resume.ajy, savedUntilDate);
		return _Utils_ap(
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('conversational-form-card-title conversational-form-welcome-title')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A3($author$project$Data$Translation$translateOr, config.anB, 'conversational-resume-title', $author$project$Copy$copy.v8))
						])),
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('conversational-form-card-intro conversational-form-welcome-intro')
						]),
					resumeBody)
				]),
			_Utils_ap(
				A4(
					$author$project$View$ConversationalFormV2$viewComposerTrigger,
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href(resume.adm)
						]),
					A3($author$project$Data$Translation$translateOr, config.anB, 'conversational-banner-continue', $author$project$Copy$copy.uu),
					A3($author$project$Data$Translation$translateOr, config.anB, 'conversational-resume-title', $author$project$Copy$copy.v8)),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$type_('button'),
								$elm$html$Html$Attributes$class('conversational-form-card-link conversational-form-resume-restart'),
								$elm$html$Html$Events$onClick(
								config.aut($author$project$View$ConversationalFormV2$OverlayOpen))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								A3($author$project$Data$Translation$translateOr, config.anB, 'conversational-banner-restart', $author$project$Copy$copy.uv))
							]))
					])));
	});
var $author$project$View$FormV2$getDomainKey = function (_v0) {
	var state = _v0;
	return state.atF;
};
var $author$project$View$ConversationalFormV2$resolveIntroText = F2(
	function (domainKey, intro) {
		var nonEmpty = function (s) {
			return $elm$core$String$isEmpty(
				$elm$core$String$trim(s)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(s);
		};
		return A2(
			$elm$core$Maybe$andThen,
			nonEmpty,
			A2(
				$elm$core$Maybe$map,
				$elm$core$Tuple$second,
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (_v0) {
							var d = _v0.a;
							return _Utils_eq(d, domainKey);
						},
						intro.alE))));
	});
var $author$project$Util$View$viewMaybeList = F2(
	function (maybe, html) {
		if (!maybe.$) {
			var a = maybe.a;
			return html(a);
		} else {
			return _List_Nil;
		}
	});
var $author$project$View$ConversationalFormV2$viewWelcomeCard = F2(
	function (config, _v0) {
		var state_ = _v0;
		var questionCount = $author$project$View$ConversationalFormV2$questionStepCount(
			$author$project$View$ConversationalFormV2$visibleSteps(state_.IF));
		var minutes = A2(
			$elm$core$Basics$max,
			1,
			$elm$core$Basics$round((questionCount * 25) / 60));
		var label = function () {
			var _v2 = config.aG;
			if (!_v2.$) {
				var t = _v2.a;
				return t;
			} else {
				return A3($author$project$Data$Translation$translateOr, config.anB, 'conversational-overlay-open', 'Apply');
			}
		}();
		var form = $author$project$Data$FormSource$toForm(
			$author$project$View$ConversationalFormV2$formSource(state_.IF));
		var domainKey = $author$project$View$FormV2$getDomainKey(state_.IF);
		var intro = A2($author$project$View$ConversationalFormV2$resolveIntroText, domainKey, form.Op);
		var welcomeTitle = A2($author$project$View$ConversationalFormV2$resolveIntroText, domainKey, form.asb);
		var badge = A2(
			$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
			A3($author$project$Data$Translation$translateOr, config.anB, 'conversational-welcome-meta', '{0} korte vragen · ± {1} minuten'),
			_List_fromArray(
				[
					$elm$core$String$fromInt(questionCount),
					$elm$core$String$fromInt(minutes)
				]));
		var welcomeNodes = _Utils_ap(
			A2(
				$author$project$Util$View$viewMaybeList,
				welcomeTitle,
				function (t) {
					return _List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('conversational-form-card-title conversational-form-welcome-title')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(t)
								]))
						]);
				}),
			_Utils_ap(
				A2(
					$author$project$Util$View$viewMaybeList,
					intro,
					function (t) {
						return _List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('conversational-form-card-intro conversational-form-welcome-intro')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(t)
									]))
							]);
					}),
				A2(
					$author$project$Util$View$viewIfList,
					questionCount > 0,
					function (_v1) {
						return _List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('conversational-form-welcome-badge')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(badge)
									]))
							]);
					})));
		return _Utils_ap(
			welcomeNodes,
			A4(
				$author$project$View$ConversationalFormV2$viewComposerTrigger,
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$type_('button'),
						$elm$html$Html$Events$onClick(
						config.aut($author$project$View$ConversationalFormV2$OverlayOpen))
					]),
				label,
				label));
	});
var $author$project$View$ConversationalFormV2$viewClosedTrigger = F2(
	function (config, _v0) {
		var state_ = _v0;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('conversational-form-trigger-wrap')
				]),
			function () {
				var _v1 = state_.eC;
				if (!_v1.$) {
					var date = _v1.a;
					return A2($author$project$View$ConversationalFormV2$viewAlreadyAppliedCard, config, date);
				} else {
					var _v2 = state_.au8;
					if (!_v2.$) {
						var resume = _v2.a;
						return A3($author$project$View$ConversationalFormV2$viewResumeCard, config, state_.fA, resume);
					} else {
						return (state_.cl || state_.a2) ? A2($author$project$View$ConversationalFormV2$viewInSessionResumeCard, config, state_.fA) : A2($author$project$View$ConversationalFormV2$viewWelcomeCard, config, state_);
					}
				}
			}());
	});
var $author$project$View$ConversationalFormV2$OverlayClose = {$: 28};
var $author$project$View$ConversationalFormV2$ConvFileDragDepth = function (a) {
	return {$: 11, a: a};
};
var $author$project$View$ConversationalFormV2$ConvFileDropped = function (a) {
	return {$: 12, a: a};
};
var $elm$file$File$decoder = _File_decoder;
var $author$project$View$ConversationalFormV2$droppedFilesDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['dataTransfer', 'files']),
			$elm$json$Json$Decode$list($elm$file$File$decoder)),
			$elm$json$Json$Decode$succeed(_List_Nil)
		]));
var $author$project$View$ConversationalFormV2$dragDropAttrs = function (config) {
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$Events$preventDefaultOn,
			'dragenter',
			$elm$json$Json$Decode$succeed(
				_Utils_Tuple2(
					config.aut(
						$author$project$View$ConversationalFormV2$ConvFileDragDepth(1)),
					true))),
			A2(
			$elm$html$Html$Events$preventDefaultOn,
			'dragover',
			$elm$json$Json$Decode$succeed(
				_Utils_Tuple2(
					config.aut(
						$author$project$View$ConversationalFormV2$ConvFileDragDepth(0)),
					true))),
			A2(
			$elm$html$Html$Events$on,
			'dragleave',
			$elm$json$Json$Decode$succeed(
				config.aut(
					$author$project$View$ConversationalFormV2$ConvFileDragDepth(-1)))),
			A2(
			$elm$html$Html$Events$preventDefaultOn,
			'drop',
			A2(
				$elm$json$Json$Decode$map,
				function (files) {
					return _Utils_Tuple2(
						config.aut(
							$author$project$View$ConversationalFormV2$ConvFileDropped(files)),
						true);
				},
				$author$project$View$ConversationalFormV2$droppedFilesDecoder))
		]);
};
var $author$project$View$ConversationalFormV2$isDesktopInContainer = function (_v0) {
	var state_ = _v0;
	return state_.e8 && A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, $author$project$View$ConversationalFormV2$isMobileWidth),
			state_.f0));
};
var $author$project$View$ConversationalFormV2$ConvBack = {$: 2};
var $author$project$View$ConversationalFormV2$viewBackRow = F2(
	function (config, _v0) {
		var state_ = _v0;
		return $elm$core$List$isEmpty(state_.z) ? $elm$html$Html$text('') : A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('conversational-form-back-row')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('button'),
							$elm$html$Html$Attributes$class('conversational-form-back'),
							$elm$html$Html$Events$onClick(
							config.aut($author$project$View$ConversationalFormV2$ConvBack))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A3($author$project$Data$Translation$translateOr, config.anB, 'conversational-back-button', 'Back'))
						]))
				]));
	});
var $author$project$View$ConversationalFormV2$isLastStep = function (_v0) {
	var state_ = _v0;
	return _Utils_cmp(
		state_.a + 1,
		$elm$core$List$length(
			$author$project$View$ConversationalFormV2$visibleSteps(state_.IF))) > -1;
};
var $elm$html$Html$Attributes$novalidate = $elm$html$Html$Attributes$boolProperty('noValidate');
var $author$project$View$ConversationalFormV2$ConvComposerInput = function (a) {
	return {$: 30, a: a};
};
var $elm$html$Html$Attributes$autofocus = $elm$html$Html$Attributes$boolProperty('autofocus');
var $author$project$View$ConversationalFormV2$htmlInputType = function (fieldType) {
	switch (fieldType.$) {
		case 6:
			return 'email';
		case 9:
			return 'tel';
		case 17:
			return 'url';
		case 4:
			return 'text';
		case 10:
			return 'text';
		default:
			return 'text';
	}
};
var $author$project$View$ConversationalFormV2$viewSendIcon = A2(
	$elm$html$Html$span,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('conversational-form-send-icon')
		]),
	_List_fromArray(
		[
			$author$project$View$Icon$view($author$project$View$Icon$path.k8)
		]));
var $author$project$View$ConversationalFormV2$viewComposerTextInput = F4(
	function (config, state, field, disabled) {
		var state_ = state;
		var sendLabel = $author$project$View$ConversationalFormV2$isLastStep(state) ? A3($author$project$Data$Translation$translateOr, config.anB, 'conversational-submit-button', 'Submit application') : A3($author$project$Data$Translation$translateOr, config.anB, 'conversational-next-button', 'Send');
		var enterHint = A3($author$project$Data$Translation$translateOr, config.anB, 'conversational-press-enter', 'press Enter ↵');
		var ariaLabel = $author$project$Data$Form$nameToLabel(field.dY);
		var inputAttrs = _List_fromArray(
			[
				$elm$html$Html$Attributes$class('conversational-form-composer-input'),
				$elm$html$Html$Attributes$id('conv-composer-input'),
				$elm$html$Html$Attributes$value(state_.g),
				$elm$html$Html$Attributes$disabled(disabled),
				$elm$html$Html$Events$onInput(
				A2($elm$core$Basics$composeL, config.aut, $author$project$View$ConversationalFormV2$ConvComposerInput)),
				A2($elm$html$Html$Attributes$attribute, 'aria-label', ariaLabel),
				$elm$html$Html$Attributes$autofocus(true),
				$elm$html$Html$Attributes$name(
				$author$project$Data$Form$nameToLabel(field.dY)),
				A2($elm$html$Html$Attributes$attribute, 'autocomplete', 'off'),
				A2($elm$html$Html$Attributes$attribute, 'data-form-type', 'other'),
				A2($elm$html$Html$Attributes$attribute, 'data-1p-ignore', 'true'),
				A2($elm$html$Html$Attributes$attribute, 'data-lpignore', 'true'),
				A2($elm$html$Html$Attributes$attribute, 'data-bwignore', 'true')
			]);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('conversational-form-persistent-input')
				]),
			_List_fromArray(
				[
					A3(
					$elm$html$Html$Keyed$node,
					'div',
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('conversational-form-persistent-widget')
						]),
					_List_fromArray(
						[
							_Utils_Tuple2(
							'conv-composer-input',
							A2(
								$elm$html$Html$input,
								A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$type_(
										$author$project$View$ConversationalFormV2$htmlInputType(field.ew)),
									inputAttrs),
								_List_Nil))
						])),
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('submit'),
							$elm$html$Html$Attributes$class('conversational-form-send'),
							$elm$html$Html$Attributes$disabled(
							disabled || $elm$core$String$isEmpty(
								$elm$core$String$trim(state_.g))),
							A2($elm$html$Html$Attributes$attribute, 'aria-label', sendLabel)
						]),
					_List_fromArray(
						[
							$author$project$View$ConversationalFormV2$viewSendIcon,
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('conversational-form-send-label')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(sendLabel)
								]))
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('conversational-form-enter-hint')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(enterHint)
						]))
				]));
	});
var $author$project$View$ConversationalFormV2$viewActiveInputForField = F5(
	function (config, state, _v0, field, disabled) {
		var _v1 = field.ew;
		if (_v1.$ === 7) {
			return $elm$html$Html$text('');
		} else {
			return A4($author$project$View$ConversationalFormV2$viewComposerTextInput, config, state, field, disabled);
		}
	});
var $author$project$View$ConversationalFormV2$viewContinuePill = F3(
	function (config, state, disabled) {
		var label = $author$project$View$ConversationalFormV2$isLastStep(state) ? A3($author$project$Data$Translation$translateOr, config.anB, 'conversational-submit-button', 'Submit application') : A3($author$project$Data$Translation$translateOr, config.anB, 'conversational-next-button', 'Continue');
		var enterHint = A3($author$project$Data$Translation$translateOr, config.anB, 'conversational-press-enter', 'press Enter ↵');
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('conversational-form-submit-row')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('button'),
							$elm$html$Html$Attributes$class('conversational-form-pill primary'),
							$elm$html$Html$Attributes$disabled(disabled),
							$elm$html$Html$Events$onClick(
							config.aut($author$project$View$ConversationalFormV2$ConvNext))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(label)
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('conversational-form-enter-hint')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(enterHint)
						]))
				]));
	});
var $author$project$View$ConversationalFormV2$viewActiveInput = F4(
	function (config, state, step, disabled) {
		var state_ = state;
		switch (step.$) {
			case 0:
				return A3($author$project$View$ConversationalFormV2$viewContinuePill, config, state, disabled);
			case 4:
				return A3($author$project$View$ConversationalFormV2$viewContinuePill, config, state, disabled);
			case 3:
				var sq = step.a;
				return A5(
					$author$project$View$ConversationalFormV2$viewActiveInputForField,
					config,
					state,
					$elm$core$Maybe$Just(sq),
					$author$project$View$ConversationalFormV2$screeningQuestionAsField(sq),
					disabled);
			case 1:
				if (step.b.b) {
					if (!step.b.b.b) {
						var _v1 = step.b;
						var field = _v1.a;
						return A5($author$project$View$ConversationalFormV2$viewActiveInputForField, config, state, $elm$core$Maybe$Nothing, field, disabled);
					} else {
						var _v2 = step.b;
						var firstField = _v2.a;
						return A4($author$project$View$ConversationalFormV2$viewComposerTextInput, config, state, firstField, disabled);
					}
				} else {
					return $elm$html$Html$text('');
				}
			default:
				return $elm$html$Html$text('');
		}
	});
var $author$project$View$ConversationalFormV2$viewHiddenSubmit = A2(
	$elm$html$Html$button,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$type_('submit'),
			A2($elm$html$Html$Attributes$attribute, 'aria-hidden', 'true'),
			$elm$html$Html$Attributes$tabindex(-1),
			A2($elm$html$Html$Attributes$style, 'display', 'none')
		]),
	_List_Nil);
var $author$project$View$ConversationalFormV2$viewChatInputArea = F3(
	function (config, state, steps) {
		var state_ = state;
		var mStep = $elm$core$List$head(
			A2($elm$core$List$drop, state_.a, steps));
		var isValidating = state_.s === 1;
		var isTyping = _Utils_eq(
			state_.af,
			$elm$core$Maybe$Just(state_.a));
		var disabled = isTyping || isValidating;
		if (mStep.$ === 1) {
			return $elm$html$Html$text('');
		} else {
			var step = mStep.a;
			return A2(
				$elm$html$Html$form,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('conversational-form-input-area'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('is-disabled', disabled),
								_Utils_Tuple2('is-loading', isValidating),
								_Utils_Tuple2(
								'is-last',
								$author$project$View$ConversationalFormV2$isLastStep(state))
							])),
						$elm$html$Html$Events$onSubmit(
						config.aut($author$project$View$ConversationalFormV2$ConvNext)),
						$elm$html$Html$Attributes$novalidate(true)
					]),
				_List_fromArray(
					[
						A4($author$project$View$ConversationalFormV2$viewActiveInput, config, state, step, disabled),
						$author$project$View$ConversationalFormV2$viewHiddenSubmit
					]));
		}
	});
var $author$project$View$ConversationalFormV2$ConvAiAccept = function (a) {
	return {$: 14, a: a};
};
var $author$project$View$ConversationalFormV2$ConvAiReject = function (a) {
	return {$: 15, a: a};
};
var $author$project$View$ConversationalFormV2$ConvAiSkip = function (a) {
	return {$: 16, a: a};
};
var $author$project$View$ConversationalFormV2$viewAiSuggestions = F2(
	function (config, _v0) {
		var state_ = _v0;
		var skipFieldIsRequired = function (suggestion) {
			var _v2 = $author$project$Data$FieldValidation$decodeFieldName(suggestion.akQ);
			if (!_v2.$) {
				var fName = _v2.a;
				return A2($author$project$View$ConversationalFormV2$isFieldRequired, state_.IF, fName);
			} else {
				return false;
			}
		};
		var promptTextFor = function (suggestion) {
			return A2(
				$elm$core$Maybe$withDefault,
				A3($author$project$Data$Translation$translateOr, config.anB, 'conversational-retry-default', 'Sorry, dat begreep ik niet — kun je het nog eens anders proberen?'),
				$author$project$View$ConversationalFormV2$suggestionTextForDomain(suggestion));
		};
		var bubbleFor = F2(
			function (suggestion, buttons) {
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('conversational-form-message bot ai-clarification')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('conversational-form-ai-prompt')
								]),
							$author$project$View$ConversationalFormV2$renderInlineBold(
								promptTextFor(suggestion))),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('conversational-form-quick-replies')
								]),
							buttons)
						]));
			});
		var viewOne = function (suggestion) {
			var _v1 = suggestion.akP;
			_v1$2:
			while (true) {
				if (!_v1.$) {
					switch (_v1.a) {
						case 'skip':
							return skipFieldIsRequired(suggestion) ? A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('conversational-form-message bot ai-clarification')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$p,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('conversational-form-ai-prompt')
											]),
										$author$project$View$ConversationalFormV2$renderInlineBold(
											promptTextFor(suggestion)))
									])) : A2(
								bubbleFor,
								suggestion,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$type_('button'),
												$elm$html$Html$Attributes$class('conversational-form-pill primary'),
												$elm$html$Html$Attributes$disabled(state_.t),
												$elm$html$Html$Events$onClick(
												config.aut(
													$author$project$View$ConversationalFormV2$ConvAiSkip(suggestion)))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												A3($author$project$Data$Translation$translateOr, config.anB, 'conversational-ai-skip', 'Sla over'))
											]))
									]));
						case 'reask':
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('conversational-form-message bot ai-clarification')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$p,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('conversational-form-ai-prompt')
											]),
										$author$project$View$ConversationalFormV2$renderInlineBold(
											promptTextFor(suggestion)))
									]));
						default:
							break _v1$2;
					}
				} else {
					break _v1$2;
				}
			}
			return A2(
				bubbleFor,
				suggestion,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$type_('button'),
								$elm$html$Html$Attributes$class('conversational-form-pill primary'),
								$elm$html$Html$Attributes$disabled(state_.t),
								$elm$html$Html$Events$onClick(
								config.aut(
									$author$project$View$ConversationalFormV2$ConvAiAccept(suggestion)))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								A3($author$project$Data$Translation$translateOr, config.anB, 'conversational-ai-accept', 'Ja, klopt'))
							])),
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$type_('button'),
								$elm$html$Html$Attributes$class('conversational-form-pill'),
								$elm$html$Html$Attributes$disabled(state_.t),
								$elm$html$Html$Events$onClick(
								config.aut(
									$author$project$View$ConversationalFormV2$ConvAiReject(suggestion)))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								A3($author$project$Data$Translation$translateOr, config.anB, 'conversational-ai-reject', 'Nee'))
							]))
					]));
		};
		return A2($elm$core$List$map, viewOne, state_.w);
	});
var $rtfeldman$elm_css$Css$alignItems = function (fn) {
	return A3(
		$rtfeldman$elm_css$Css$Internal$getOverloadedProperty,
		'alignItems',
		'align-items',
		fn($rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty));
};
var $rtfeldman$elm_css$Css$block = {u: 0, ey: 'block'};
var $rtfeldman$elm_css$Css$column = _Utils_update(
	$rtfeldman$elm_css$Css$row,
	{ey: 'column'});
var $author$project$View$ConversationalFormV2$confirmMetaLine = function (config) {
	return A2(
		$elm$core$String$join,
		' · ',
		A2(
			$elm$core$List$filter,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$String$isEmpty),
			_List_fromArray(
				[
					config.b9,
					A3($author$project$Data$Translation$translateOr, config.anB, 'conversational-confirm-just-sent', 'Just now sent')
				])));
};
var $rtfeldman$elm_css$Css$display = $rtfeldman$elm_css$Css$prop1('display');
var $rtfeldman$elm_css$Css$flexDirection = $rtfeldman$elm_css$Css$prop1('flex-direction');
var $rtfeldman$elm_css$Css$flexShrink = $rtfeldman$elm_css$Css$prop1('flex-shrink');
var $rtfeldman$elm_css$Css$fontSize = $rtfeldman$elm_css$Css$prop1('font-size');
var $rtfeldman$elm_css$Html$Styled$h2 = $rtfeldman$elm_css$Html$Styled$node('h2');
var $rtfeldman$elm_css$Css$height = $rtfeldman$elm_css$Css$prop1('height');
var $rtfeldman$elm_css$Css$hidden = {aa: 0, bU: 0, ey: 'hidden', cW: 0};
var $rtfeldman$elm_css$Css$justifyContent = function (fn) {
	return A3(
		$rtfeldman$elm_css$Css$Internal$getOverloadedProperty,
		'justifyContent',
		'justify-content',
		fn($rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty));
};
var $rtfeldman$elm_css$Css$letterSpacing = $rtfeldman$elm_css$Css$prop1('letter-spacing');
var $rtfeldman$elm_css$Css$lineHeight = $rtfeldman$elm_css$Css$prop1('line-height');
var $rtfeldman$elm_css$Css$margin = $rtfeldman$elm_css$Css$prop1('margin');
var $rtfeldman$elm_css$Css$marginTop = $rtfeldman$elm_css$Css$prop1('margin-top');
var $rtfeldman$elm_css$Css$UnitlessFloat = 0;
var $rtfeldman$elm_css$Css$num = function (val) {
	return {
		be: 0,
		ay: 0,
		bS: 0,
		au1: 0,
		dZ: 0,
		aQ: val,
		b6: '',
		cT: 0,
		ey: $elm$core$String$fromFloat(val)
	};
};
var $rtfeldman$elm_css$Css$overflow = $rtfeldman$elm_css$Css$prop1('overflow');
var $rtfeldman$elm_css$Html$Styled$p = $rtfeldman$elm_css$Html$Styled$node('p');
var $rtfeldman$elm_css$Css$prop4 = F5(
	function (key, argA, argB, argC, argD) {
		return A2($rtfeldman$elm_css$Css$property, key, argA.ey + (' ' + (argB.ey + (' ' + (argC.ey + (' ' + argD.ey))))));
	});
var $rtfeldman$elm_css$Css$padding4 = $rtfeldman$elm_css$Css$prop4('padding');
var $rtfeldman$elm_css$Css$paddingBottom = $rtfeldman$elm_css$Css$prop1('padding-bottom');
var $rtfeldman$elm_css$Css$stretch = $rtfeldman$elm_css$Css$prop1('stretch');
var $rtfeldman$elm_css$Css$textTransform = $rtfeldman$elm_css$Css$prop1('text-transform');
var $rtfeldman$elm_css$Css$uppercase = {bs: 0, ey: 'uppercase'};
var $rtfeldman$elm_css$Html$Styled$a = $rtfeldman$elm_css$Html$Styled$node('a');
var $rtfeldman$elm_css$Css$borderBox = {eJ: 0, c7: 0, ey: 'border-box'};
var $rtfeldman$elm_css$Css$boxSizing = $rtfeldman$elm_css$Css$prop1('box-sizing');
var $rtfeldman$elm_css$Css$textAlign = function (fn) {
	return A3(
		$rtfeldman$elm_css$Css$Internal$getOverloadedProperty,
		'textAlign',
		'text-align',
		fn($rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty));
};
var $rtfeldman$elm_css$Css$textDecoration = $rtfeldman$elm_css$Css$prop1('text-decoration');
var $author$project$View$ConversationalFormV2$confirmButtonBaseCss = _List_fromArray(
	[
		$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$block),
		$rtfeldman$elm_css$Css$width(
		$rtfeldman$elm_css$Css$pct(100)),
		$rtfeldman$elm_css$Css$boxSizing($rtfeldman$elm_css$Css$borderBox),
		A2(
		$rtfeldman$elm_css$Css$padding2,
		$rtfeldman$elm_css$Css$px(12),
		$rtfeldman$elm_css$Css$px(16)),
		$rtfeldman$elm_css$Css$borderRadius(
		$rtfeldman$elm_css$Css$px(8)),
		$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
		$rtfeldman$elm_css$Css$textDecoration($rtfeldman$elm_css$Css$none),
		$rtfeldman$elm_css$Css$fontWeight(
		$rtfeldman$elm_css$Css$int(600))
	]);
var $rtfeldman$elm_css$Html$Styled$Attributes$href = function (url) {
	return A2($rtfeldman$elm_css$Html$Styled$Attributes$stringProperty, 'href', url);
};
var $author$project$View$ConversationalFormV2$viewConfirmButtons = function (config) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$displayFlex,
						$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
						A2($rtfeldman$elm_css$Css$property, 'gap', '8px'),
						$rtfeldman$elm_css$Css$marginTop(
						$rtfeldman$elm_css$Css$px(8))
					]))
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$a,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$href(config.awl),
						$rtfeldman$elm_css$Html$Styled$Attributes$class('conversational-form-confirm-button primary'),
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$ConversationalFormV2$confirmButtonBaseCss)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A3($author$project$Data$Translation$translateOr, config.anB, 'conversational-confirm-other-vacancies', 'View more vacancies'))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$a,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$href(config.awn),
						$rtfeldman$elm_css$Html$Styled$Attributes$class('conversational-form-confirm-button secondary'),
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$ConversationalFormV2$confirmButtonBaseCss)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A3($author$project$Data$Translation$translateOr, config.anB, 'conversational-confirm-back-to-vacancy', 'Back to the vacancy'))
					]))
			]));
};
var $rtfeldman$elm_css$Css$zero = {cx: 0, bP: 0, aN: 0, bQ: 0, bR: 0, bd: 0, be: 0, au1: 0, aQ: 0, d3: 0, b6: '', cT: 0, ey: '0'};
var $author$project$View$ConversationalFormV2$viewConfirmationCard = F4(
	function (config, confirmTitle, confirmWhatsNext, confirmDescription) {
		return $rtfeldman$elm_css$Html$Styled$toUnstyled(
			A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('conversational-form-confirm-card'),
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$displayFlex,
								$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
								$rtfeldman$elm_css$Css$alignSelf($rtfeldman$elm_css$Css$stretch),
								$rtfeldman$elm_css$Css$width(
								$rtfeldman$elm_css$Css$pct(100)),
								$rtfeldman$elm_css$Css$flexShrink(
								$rtfeldman$elm_css$Css$int(0)),
								$rtfeldman$elm_css$Css$borderRadius(
								$rtfeldman$elm_css$Css$px(12)),
								$rtfeldman$elm_css$Css$overflow($rtfeldman$elm_css$Css$hidden)
							])),
						A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'status'),
						A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-live', 'polite')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('conversational-form-confirm-header'),
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Css$displayFlex,
										$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
										A2($rtfeldman$elm_css$Css$property, 'gap', '12px'),
										$rtfeldman$elm_css$Css$padding(
										$rtfeldman$elm_css$Css$px(16))
									]))
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('conversational-form-confirm-check'),
										$rtfeldman$elm_css$Html$Styled$Attributes$css(
										_List_fromArray(
											[
												$rtfeldman$elm_css$Css$flexShrink(
												$rtfeldman$elm_css$Css$int(0)),
												$rtfeldman$elm_css$Css$width(
												$rtfeldman$elm_css$Css$px(40)),
												$rtfeldman$elm_css$Css$height(
												$rtfeldman$elm_css$Css$px(40)),
												$rtfeldman$elm_css$Css$borderRadius(
												$rtfeldman$elm_css$Css$pct(50)),
												$rtfeldman$elm_css$Css$displayFlex,
												$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
												$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
												$rtfeldman$elm_css$Css$fontSize(
												$rtfeldman$elm_css$Css$px(20))
											])),
										A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-hidden', 'true')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('✓')
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css(
										_List_fromArray(
											[
												$rtfeldman$elm_css$Css$displayFlex,
												$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column)
											]))
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$h2,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('conversational-form-confirm-title'),
												$rtfeldman$elm_css$Html$Styled$Attributes$css(
												_List_fromArray(
													[
														$rtfeldman$elm_css$Css$fontSize(
														$rtfeldman$elm_css$Css$px(18)),
														$rtfeldman$elm_css$Css$lineHeight(
														$rtfeldman$elm_css$Css$num(1.2)),
														$rtfeldman$elm_css$Css$margin($rtfeldman$elm_css$Css$zero),
														$rtfeldman$elm_css$Css$paddingBottom($rtfeldman$elm_css$Css$zero)
													]))
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(confirmTitle)
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$p,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('conversational-form-confirm-meta'),
												$rtfeldman$elm_css$Html$Styled$Attributes$css(
												_List_fromArray(
													[
														$rtfeldman$elm_css$Css$margin($rtfeldman$elm_css$Css$zero),
														$rtfeldman$elm_css$Css$marginTop(
														$rtfeldman$elm_css$Css$px(1)),
														$rtfeldman$elm_css$Css$fontSize(
														$rtfeldman$elm_css$Css$px(13))
													]))
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$author$project$View$ConversationalFormV2$confirmMetaLine(config))
											]))
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[
										A4(
										$rtfeldman$elm_css$Css$padding4,
										$rtfeldman$elm_css$Css$px(12),
										$rtfeldman$elm_css$Css$px(16),
										$rtfeldman$elm_css$Css$px(16),
										$rtfeldman$elm_css$Css$px(16)),
										$rtfeldman$elm_css$Css$displayFlex,
										$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
										A2($rtfeldman$elm_css$Css$property, 'gap', '10px')
									]))
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('conversational-form-confirm-eyebrow'),
										$rtfeldman$elm_css$Html$Styled$Attributes$css(
										_List_fromArray(
											[
												$rtfeldman$elm_css$Css$margin($rtfeldman$elm_css$Css$zero),
												$rtfeldman$elm_css$Css$fontSize(
												$rtfeldman$elm_css$Css$px(12)),
												$rtfeldman$elm_css$Css$fontWeight(
												$rtfeldman$elm_css$Css$int(600)),
												$rtfeldman$elm_css$Css$letterSpacing(
												$rtfeldman$elm_css$Css$px(0.5)),
												$rtfeldman$elm_css$Css$textTransform($rtfeldman$elm_css$Css$uppercase)
											]))
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(confirmWhatsNext)
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('conversational-form-confirm-body'),
										$rtfeldman$elm_css$Html$Styled$Attributes$css(
										_List_fromArray(
											[
												$rtfeldman$elm_css$Css$displayFlex,
												$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
												A2($rtfeldman$elm_css$Css$property, 'gap', '4px'),
												$rtfeldman$elm_css$Css$lineHeight(
												$rtfeldman$elm_css$Css$num(1.5))
											]))
									]),
								A2(
									$elm$core$List$map,
									function (line) {
										return A2(
											$rtfeldman$elm_css$Html$Styled$p,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css(
													_List_fromArray(
														[
															$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$block),
															$rtfeldman$elm_css$Css$margin($rtfeldman$elm_css$Css$zero)
														]))
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(line)
												]));
									},
									A2($elm$core$String$split, '\n', confirmDescription))),
								$author$project$View$ConversationalFormV2$viewConfirmButtons(config)
							]))
					])));
	});
var $author$project$View$ConversationalFormV2$viewResumeDivider = F3(
	function (config, _v0, boundaryIdx) {
		var state_ = _v0;
		return (state_.a2 && (boundaryIdx > 0)) ? _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('conversational-form-resume-divider')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								A3($author$project$Data$Translation$translateOr, config.anB, 'conversational-resume-divider', 'hervat'))
							]))
					]))
			]) : _List_Nil;
	});
var $author$project$View$ConversationalFormV2$nonEmptyText = function (s) {
	return $elm$core$String$isEmpty(s) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(s);
};
var $author$project$View$ConversationalFormV2$labelForField = F2(
	function (domainKey, field) {
		var fromDomain = function (values) {
			return A2(
				$elm$core$Maybe$andThen,
				$author$project$View$ConversationalFormV2$nonEmptyText,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Tuple$second,
					$elm$core$List$head(
						A2(
							$elm$core$List$filter,
							function (_v1) {
								var d = _v1.a;
								return _Utils_eq(d, domainKey);
							},
							values))));
		};
		var firstJust = A2(
			$elm$core$List$foldl,
			F2(
				function (m, acc) {
					if (!acc.$) {
						return acc;
					} else {
						return m;
					}
				}),
			$elm$core$Maybe$Nothing);
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$Data$Form$nameToLabel(field.dY),
			firstJust(
				_List_fromArray(
					[
						fromDomain(field.bO)
					])));
	});
var $author$project$View$ConversationalFormV2$shouldHideQuestionHeading = F3(
	function (translations, _v0, step) {
		var formState = _v0;
		if (((step.$ === 1) && step.b.b) && (!step.b.b.b)) {
			var _v2 = step.b;
			var field = _v2.a;
			var _v3 = field.ew;
			if (_v3.$ === 1) {
				return _Utils_eq(
					A3($author$project$View$ConversationalFormV2$questionForField, translations, formState.atF, field),
					A2($author$project$View$ConversationalFormV2$labelForField, formState.atF, field));
			} else {
				return false;
			}
		} else {
			return false;
		}
	});
var $author$project$View$ConversationalFormV2$stepIsNarratorVideo = function (step) {
	var _v0 = $author$project$View$ConversationalFormV2$narratorContentOfStep(step);
	if (!_v0.$) {
		if (_v0.a.$ === 15) {
			return true;
		} else {
			return false;
		}
	} else {
		return false;
	}
};
var $author$project$View$ConversationalFormV2$fieldHasAuthoredQuestion = function (field) {
	return A2(
		$elm$core$List$any,
		function (_v0) {
			var q = _v0.b;
			return !$elm$core$String$isEmpty(
				$elm$core$String$trim(q));
		},
		field.aaI);
};
var $author$project$View$ConversationalFormV2$preferQuestionTranslation = F3(
	function (translations, step, fallback) {
		switch (step.$) {
			case 2:
				if (step.b.b) {
					var _v1 = step.b;
					var privacyField = _v1.a;
					return $author$project$View$ConversationalFormV2$fieldHasAuthoredQuestion(privacyField) ? fallback : A3($author$project$Data$Translation$translateOr, translations, 'conversational-prompt-privacy', fallback);
				} else {
					return A3($author$project$Data$Translation$translateOr, translations, 'conversational-prompt-privacy', fallback);
				}
			case 3:
				var sq = step.a;
				return A3($author$project$Data$Translation$translateOr, translations, 'conversational-prompt-screening-' + sq.dE, fallback);
			default:
				return fallback;
		}
	});
var $author$project$View$ConversationalFormV2$viewNarratorContent = F2(
	function (uploads, content) {
		return _List_fromArray(
			[
				A2(
				$author$project$Data$Content$View$view,
				{ji: false, GZ: _List_Nil, avS: $elm$core$Maybe$Nothing, ape: uploads, apx: false, f_: $elm$core$Maybe$Nothing},
				content)
			]);
	});
var $author$project$View$ConversationalFormV2$viewPrivacyConsent = F2(
	function (config, step) {
		if (step.$ === 2) {
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('conversational-form-privacy-consent')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A3($author$project$Data$Translation$translateOr, config.anB, 'conversational-privacy-consent-text', $author$project$Copy$copy.v0)),
							$elm$html$Html$text(' '),
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('link link-underline'),
									$elm$html$Html$Attributes$href(config.aU),
									$elm$html$Html$Attributes$target('_blank'),
									$elm$html$Html$Attributes$rel('noopener noreferrer')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A3($author$project$Data$Translation$translateOr, config.anB, 'conversational-privacy-consent-link-text', $author$project$Copy$copy.v$))
								]))
						]))
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$View$ConversationalFormV2$viewBotBubbleBody = F3(
	function (config, formState, step) {
		var formStateInner = formState;
		var _v0 = $author$project$View$ConversationalFormV2$narratorContentOfStep(step);
		if (!_v0.$) {
			var content = _v0.a;
			return A2($author$project$View$ConversationalFormV2$viewNarratorContent, formStateInner.ape, content);
		} else {
			var _v1 = A2($author$project$View$ConversationalFormV2$viewPrivacyConsent, config, step);
			if (_v1.b) {
				var consentLine = _v1.a;
				var rest = _v1.b;
				return A2($elm$core$List$cons, consentLine, rest);
			} else {
				return _List_fromArray(
					[
						$elm$html$Html$text(
						A3(
							$author$project$View$ConversationalFormV2$preferQuestionTranslation,
							config.anB,
							step,
							A3($author$project$View$ConversationalFormV2$botPromptForStep, config.anB, formState, step)))
					]);
			}
		}
	});
var $author$project$View$ConversationalFormV2$viewBotBubbleForStep = F4(
	function (config, formState, step, idx) {
		return A3(
			$elm$html$Html$node,
			'div',
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('conversational-form-message', true),
							_Utils_Tuple2('bot', true),
							_Utils_Tuple2(
							'narrator',
							$author$project$View$ConversationalFormV2$stepIsNarratorContent(step)),
							_Utils_Tuple2(
							'narrator-video',
							$author$project$View$ConversationalFormV2$stepIsNarratorVideo(step)),
							_Utils_Tuple2(
							'consent',
							$author$project$View$ConversationalFormV2$isPrivacyStep(step))
						])),
					A2(
					$elm$html$Html$Attributes$attribute,
					'data-step-key',
					$elm$core$String$fromInt(idx))
				]),
			A3($author$project$View$ConversationalFormV2$viewBotBubbleBody, config, formState, step));
	});
var $author$project$View$ConversationalFormV2$maxInlinePills = 25;
var $author$project$View$ConversationalFormV2$ConvToggleDaypart = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $author$project$View$ConversationalFormV2$dayOfWeekLabel = F2(
	function (config, day) {
		var _v0 = function () {
			switch (day) {
				case 0:
					return _Utils_Tuple2('day-mon', 'Ma');
				case 1:
					return _Utils_Tuple2('day-tue', 'Di');
				case 2:
					return _Utils_Tuple2('day-wed', 'Wo');
				case 3:
					return _Utils_Tuple2('day-thu', 'Do');
				case 4:
					return _Utils_Tuple2('day-fri', 'Vr');
				case 5:
					return _Utils_Tuple2('day-sat', 'Za');
				default:
					return _Utils_Tuple2('day-sun', 'Zo');
			}
		}();
		var key = _v0.a;
		var fallback = _v0.b;
		return A3($author$project$Data$Translation$translateOr, config.anB, key, fallback);
	});
var $author$project$View$ConversationalFormV2$daypartLabel = F2(
	function (config, daypart) {
		var _v0 = function () {
			switch (daypart) {
				case 0:
					return _Utils_Tuple2('daypart-morning', 'ochtend');
				case 1:
					return _Utils_Tuple2('daypart-afternoon', 'middag');
				case 2:
					return _Utils_Tuple2('daypart-evening', 'avond');
				default:
					return _Utils_Tuple2('daypart-night', 'nacht');
			}
		}();
		var key = _v0.a;
		var fallback = _v0.b;
		return A3($author$project$Data$Translation$translateOr, config.anB, key, fallback);
	});
var $elm$html$Html$fieldset = _VirtualDom_node('fieldset');
var $elm$html$Html$legend = _VirtualDom_node('legend');
var $author$project$View$ConversationalFormV2$viewDaypartAvailabilityPills = F5(
	function (config, state, field, options, disabled) {
		var state_ = state;
		var currentSelection = function () {
			var _v1 = A2(
				$pzp1997$assoc_list$AssocList$get,
				field.dY,
				$author$project$View$FormV2$getFormInput(state_.IF));
			if ((!_v1.$) && (_v1.a.$ === 10)) {
				var vs = _v1.a.a;
				return vs;
			} else {
				return _List_Nil;
			}
		}();
		var toggle = function (cell) {
			return A2($elm$core$List$member, cell, currentSelection) ? A2(
				$elm$core$List$filter,
				$elm$core$Basics$neq(cell),
				currentSelection) : _Utils_ap(
				currentSelection,
				_List_fromArray(
					[cell]));
		};
		var allowed = options.as4;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('conversational-form-multi-select')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$fieldset,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('conversational-form-quick-replies')
						]),
					A2(
						$elm$core$List$cons,
						A2(
							$elm$html$Html$legend,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('sr-only')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Data$Form$nameToLabel(field.dY))
								])),
						A2(
							$elm$core$List$map,
							function (cell) {
								var selected = A2($elm$core$List$member, cell, currentSelection);
								var extraClass = selected ? ' primary' : '';
								var _v0 = cell;
								var day = _v0.a;
								var daypart = _v0.b;
								var label = A2($author$project$View$ConversationalFormV2$dayOfWeekLabel, config, day) + (' ' + A2($author$project$View$ConversationalFormV2$daypartLabel, config, daypart));
								return A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$type_('button'),
											$elm$html$Html$Attributes$class('conversational-form-pill' + extraClass),
											$elm$html$Html$Attributes$disabled(disabled),
											$elm$html$Html$Events$onClick(
											config.aut(
												A2(
													$author$project$View$ConversationalFormV2$ConvToggleDaypart,
													field.dY,
													toggle(cell))))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(label)
										]));
							},
							allowed))),
					$elm$core$List$isEmpty(currentSelection) ? $elm$html$Html$text('') : A3($author$project$View$ConversationalFormV2$viewContinuePill, config, state, disabled)
				]));
	});
var $author$project$View$ConversationalFormV2$ConvPickFile = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $author$project$View$ConversationalFormV2$ConvQuickReply = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$View$ConversationalFormV2$viewUploadedFile = F2(
	function (_v0, fieldName) {
		var state_ = _v0;
		var filename = function () {
			var _v1 = A2(
				$pzp1997$assoc_list$AssocList$get,
				fieldName,
				$author$project$View$FormV2$getFormInput(state_.IF));
			if (((!_v1.$) && (_v1.a.$ === 3)) && (!_v1.a.a.$)) {
				var f = _v1.a.a.a;
				return f.atW;
			} else {
				return '';
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('conversational-form-uploaded-file')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('conversational-form-uploaded-file-icon')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('📄')
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('conversational-form-uploaded-file-name')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(filename)
						]))
				]));
	});
var $author$project$View$ConversationalFormV2$viewFilePills = F5(
	function (config, state, field, options, disabled) {
		var state_ = state;
		var uploadLabel = A3($author$project$Data$Translation$translateOr, config.anB, 'conversational-upload-button', 'Upload file');
		var skipLabel = A3($author$project$Data$Translation$translateOr, config.anB, 'conversational-skip-button', 'Skip');
		var isRequired = A2($author$project$View$ConversationalFormV2$isFieldRequired, state_.IF, field.dY);
		var dropError = function () {
			var _v1 = state_.bJ;
			if (!_v1.$) {
				var _v2 = _v1.a;
				var erroredField = _v2.a;
				var reason = _v2.b;
				return _Utils_eq(erroredField, field.dY) ? $elm$core$Maybe$Just(reason) : $elm$core$Maybe$Nothing;
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		var alreadyUploaded = A2($author$project$View$ConversationalFormV2$hasFileValue, state_.IF, field.dY);
		var showSkip = (!alreadyUploaded) && ((!isRequired) && (!_Utils_eq(field.dY, $author$project$Model$FormFieldV2$Privacy)));
		return A2(
			$elm$html$Html$fieldset,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('conversational-form-quick-replies is-file')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$legend,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('sr-only')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Data$Form$nameToLabel(field.dY))
						])),
					alreadyUploaded ? A2($author$project$View$ConversationalFormV2$viewUploadedFile, state, field.dY) : A2(
					$elm$html$Html$div,
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('conversational-form-dropzone', true),
									_Utils_Tuple2('is-dragover', state_.a6 > 0),
									_Utils_Tuple2(
									'has-error',
									!_Utils_eq(dropError, $elm$core$Maybe$Nothing))
								])),
						disabled ? _List_Nil : _List_fromArray(
							[
								$elm$html$Html$Events$onClick(
								config.aut(
									A2($author$project$View$ConversationalFormV2$ConvPickFile, options, field.dY)))
							])),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('conversational-form-dropzone-icon')
								]),
							_List_fromArray(
								[
									$author$project$View$Icon$view($author$project$View$Icon$path.ao_)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('conversational-form-dropzone-hint')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A3($author$project$Data$Translation$translateOr, config.anB, 'conversational-dropzone-hint', 'Drag & Drop your file here'))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('conversational-form-dropzone-divider')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A3($author$project$Data$Translation$translateOr, config.anB, 'conversational-dropzone-or', 'OR'))
								])),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$type_('button'),
									$elm$html$Html$Attributes$class('conversational-form-pill primary conversational-form-dropzone-browse'),
									$elm$html$Html$Attributes$disabled(disabled),
									A2(
									$elm$html$Html$Events$stopPropagationOn,
									'click',
									$elm$json$Json$Decode$succeed(
										_Utils_Tuple2(
											config.aut(
												A2($author$project$View$ConversationalFormV2$ConvPickFile, options, field.dY)),
											true)))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(uploadLabel)
								]))
						])),
					function () {
					if (!dropError.$) {
						var reason = dropError.a;
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('conversational-form-dropzone-error'),
									A2($elm$html$Html$Attributes$attribute, 'role', 'alert')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(reason)
								]));
					} else {
						return $elm$html$Html$text('');
					}
				}(),
					alreadyUploaded ? A3($author$project$View$ConversationalFormV2$viewContinuePill, config, state, disabled) : $elm$html$Html$text(''),
					showSkip ? A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('button'),
							$elm$html$Html$Attributes$class('conversational-form-skip-link'),
							$elm$html$Html$Attributes$disabled(disabled),
							$elm$html$Html$Events$onClick(
							config.aut(
								A2(
									$author$project$View$ConversationalFormV2$ConvQuickReply,
									field.dY,
									$author$project$Model$FormFieldValueV2$FileValue_($elm$core$Maybe$Nothing))))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(skipLabel)
						])) : $elm$html$Html$text('')
				]));
	});
var $author$project$View$ConversationalFormV2$viewPrivacyPills = F4(
	function (config, _v0, field, disabled) {
		var state_ = _v0;
		var promptAsLegend = $author$project$Data$Form$nameToLabel(field.dY);
		var declineLabel = A3($author$project$Data$Translation$translateOr, config.anB, 'conversational-privacy-decline', 'Niet akkoord');
		var alreadyDeclined = function () {
			var _v1 = A2(
				$pzp1997$assoc_list$AssocList$get,
				field.dY,
				$author$project$View$FormV2$getFormInput(state_.IF));
			if (((!_v1.$) && (_v1.a.$ === 2)) && (!_v1.a.a)) {
				return true;
			} else {
				return false;
			}
		}();
		var acceptLabel = A3($author$project$Data$Translation$translateOr, config.anB, 'conversational-privacy-accept', 'Akkoord');
		return A2(
			$elm$html$Html$fieldset,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('conversational-form-quick-replies')
				]),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$elm$html$Html$legend,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('sr-only')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(promptAsLegend)
							])),
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$type_('button'),
								$elm$html$Html$Attributes$class('conversational-form-pill primary'),
								$elm$html$Html$Attributes$disabled(disabled),
								$elm$html$Html$Events$onClick(
								config.aut(
									A2(
										$author$project$View$ConversationalFormV2$ConvQuickReply,
										field.dY,
										$author$project$Model$FormFieldValueV2$BoolValue(true))))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(acceptLabel)
							]))
					]),
				alreadyDeclined ? _List_Nil : _List_fromArray(
					[
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$type_('button'),
								$elm$html$Html$Attributes$class('conversational-form-pill'),
								$elm$html$Html$Attributes$disabled(disabled),
								$elm$html$Html$Events$onClick(
								config.aut(
									A2(
										$author$project$View$ConversationalFormV2$ConvQuickReply,
										field.dY,
										$author$project$Model$FormFieldValueV2$BoolValue(false))))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(declineLabel)
							]))
					])));
	});
var $author$project$View$ConversationalFormV2$viewRadioPills = F5(
	function (config, state, field, options, disabled) {
		var promptAsLegend = $author$project$Data$Form$nameToLabel(field.dY);
		return A2(
			$elm$html$Html$fieldset,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('conversational-form-quick-replies')
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$elm$html$Html$legend,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('sr-only')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(promptAsLegend)
						])),
				A2(
					$elm$core$List$map,
					function (_v0) {
						var optValue = _v0.a;
						var optLabel = _v0.b;
						return A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$type_('button'),
									$elm$html$Html$Attributes$class('conversational-form-pill'),
									$elm$html$Html$Attributes$disabled(disabled),
									$elm$html$Html$Events$onClick(
									config.aut(
										A2(
											$author$project$View$ConversationalFormV2$ConvQuickReply,
											field.dY,
											$author$project$Model$FormFieldValueV2$RadioValue(optValue))))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(optLabel)
								]));
					},
					options)));
	});
var $author$project$View$ConversationalFormV2$ConvToggleSelectMultiple = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$View$ConversationalFormV2$viewSelectMultiplePills = F5(
	function (config, state, field, options, disabled) {
		var state_ = state;
		var currentSelection = function () {
			var _v1 = A2(
				$pzp1997$assoc_list$AssocList$get,
				field.dY,
				$author$project$View$FormV2$getFormInput(state_.IF));
			if ((!_v1.$) && (_v1.a.$ === 6)) {
				var vs = _v1.a.a;
				return vs;
			} else {
				return _List_Nil;
			}
		}();
		var toggle = function (optId) {
			return A2($elm$core$List$member, optId, currentSelection) ? A2(
				$elm$core$List$filter,
				$elm$core$Basics$neq(optId),
				currentSelection) : _Utils_ap(
				currentSelection,
				_List_fromArray(
					[optId]));
		};
		var toggleMsg = function (optId) {
			return A2(
				$author$project$View$ConversationalFormV2$ConvToggleSelectMultiple,
				field.dY,
				toggle(optId));
		};
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('conversational-form-multi-select')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$fieldset,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('conversational-form-quick-replies')
						]),
					A2(
						$elm$core$List$cons,
						A2(
							$elm$html$Html$legend,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('sr-only')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Data$Form$nameToLabel(field.dY))
								])),
						A2(
							$elm$core$List$map,
							function (_v0) {
								var optId = _v0.a;
								var optLabel = _v0.b;
								var selected = A2($elm$core$List$member, optId, currentSelection);
								var extraClass = selected ? ' primary' : '';
								return A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$type_('button'),
											$elm$html$Html$Attributes$class('conversational-form-pill' + extraClass),
											$elm$html$Html$Attributes$disabled(disabled),
											$elm$html$Html$Events$onClick(
											config.aut(
												toggleMsg(optId)))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(optLabel)
										]));
							},
							options))),
					$elm$core$List$isEmpty(currentSelection) ? $elm$html$Html$text('') : A3($author$project$View$ConversationalFormV2$viewContinuePill, config, state, disabled)
				]));
	});
var $author$project$View$ConversationalFormV2$viewSelectPills = F5(
	function (config, _v0, field, options, disabled) {
		return A2(
			$elm$html$Html$fieldset,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('conversational-form-quick-replies')
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$elm$html$Html$legend,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('sr-only')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Data$Form$nameToLabel(field.dY))
						])),
				A2(
					$elm$core$List$map,
					function (optLabel) {
						return A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$type_('button'),
									$elm$html$Html$Attributes$class('conversational-form-pill'),
									$elm$html$Html$Attributes$disabled(disabled),
									$elm$html$Html$Events$onClick(
									config.aut(
										A2(
											$author$project$View$ConversationalFormV2$ConvQuickReply,
											field.dY,
											$author$project$Model$FormFieldValueV2$SelectValue(
												$elm$core$Maybe$Just(optLabel)))))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(optLabel)
								]));
					},
					options)));
	});
var $author$project$View$ConversationalFormV2$viewSelectWithIdsPills = F5(
	function (config, _v0, field, options, disabled) {
		return A2(
			$elm$html$Html$fieldset,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('conversational-form-quick-replies')
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$elm$html$Html$legend,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('sr-only')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Data$Form$nameToLabel(field.dY))
						])),
				A2(
					$elm$core$List$map,
					function (_v1) {
						var optId = _v1.a;
						var optLabel = _v1.b;
						return A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$type_('button'),
									$elm$html$Html$Attributes$class('conversational-form-pill'),
									$elm$html$Html$Attributes$disabled(disabled),
									$elm$html$Html$Events$onClick(
									config.aut(
										A2(
											$author$project$View$ConversationalFormV2$ConvQuickReply,
											field.dY,
											$author$project$Model$FormFieldValueV2$SelectValue(
												$elm$core$Maybe$Just(optId)))))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(optLabel)
								]));
					},
					options)));
	});
var $author$project$View$ConversationalFormV2$viewYesNoPills = F4(
	function (config, state, field, disabled) {
		var promptAsLegend = $author$project$Data$Form$nameToLabel(field.dY);
		var _v0 = _Utils_Tuple2(
			A3($author$project$Data$Translation$translateOr, config.anB, 'yes', $author$project$Copy$copy.asH),
			A3($author$project$Data$Translation$translateOr, config.anB, 'no', $author$project$Copy$copy.VA));
		var yesLabel = _v0.a;
		var noLabel = _v0.b;
		return A2(
			$elm$html$Html$fieldset,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('conversational-form-quick-replies')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$legend,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('sr-only')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(promptAsLegend)
						])),
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('button'),
							$elm$html$Html$Attributes$class('conversational-form-pill'),
							$elm$html$Html$Attributes$disabled(disabled),
							$elm$html$Html$Events$onClick(
							config.aut(
								A2(
									$author$project$View$ConversationalFormV2$ConvQuickReply,
									field.dY,
									$author$project$Model$FormFieldValueV2$BoolValue(true))))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(yesLabel)
						])),
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('button'),
							$elm$html$Html$Attributes$class('conversational-form-pill'),
							$elm$html$Html$Attributes$disabled(disabled),
							$elm$html$Html$Events$onClick(
							config.aut(
								A2(
									$author$project$View$ConversationalFormV2$ConvQuickReply,
									field.dY,
									$author$project$Model$FormFieldValueV2$BoolValue(false))))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(noLabel)
						]))
				]));
	});
var $author$project$View$ConversationalFormV2$viewInlineQuickReplies = F3(
	function (config, state, step) {
		var state_ = state;
		var isValidating = state_.s === 1;
		var disabled = isValidating;
		_v0$2:
		while (true) {
			switch (step.$) {
				case 1:
					if (step.b.b && (!step.b.b.b)) {
						var _v1 = step.b;
						var field = _v1.a;
						var _v2 = field.ew;
						switch (_v2.$) {
							case 19:
								return _List_fromArray(
									[
										A4($author$project$View$ConversationalFormV2$viewYesNoPills, config, state, field, disabled)
									]);
							case 1:
								return _List_fromArray(
									[
										A4($author$project$View$ConversationalFormV2$viewYesNoPills, config, state, field, disabled)
									]);
							case 11:
								var options = _v2.a;
								return (_Utils_cmp(
									$elm$core$List$length(options),
									$author$project$View$ConversationalFormV2$maxInlinePills) < 1) ? _List_fromArray(
									[
										A5($author$project$View$ConversationalFormV2$viewRadioPills, config, state, field, options, disabled)
									]) : _List_Nil;
							case 12:
								var options = _v2.a;
								return (_Utils_cmp(
									$elm$core$List$length(options),
									$author$project$View$ConversationalFormV2$maxInlinePills) < 1) ? _List_fromArray(
									[
										A5($author$project$View$ConversationalFormV2$viewSelectPills, config, state, field, options, disabled)
									]) : _List_Nil;
							case 14:
								var options = _v2.a;
								return (_Utils_cmp(
									$elm$core$List$length(options),
									$author$project$View$ConversationalFormV2$maxInlinePills) < 1) ? _List_fromArray(
									[
										A5($author$project$View$ConversationalFormV2$viewSelectWithIdsPills, config, state, field, options, disabled)
									]) : _List_Nil;
							case 13:
								var options = _v2.a;
								return (_Utils_cmp(
									$elm$core$List$length(options),
									$author$project$View$ConversationalFormV2$maxInlinePills) < 1) ? _List_fromArray(
									[
										A5($author$project$View$ConversationalFormV2$viewSelectMultiplePills, config, state, field, options, disabled)
									]) : _List_Nil;
							case 5:
								var options = _v2.a;
								return _List_fromArray(
									[
										A5($author$project$View$ConversationalFormV2$viewDaypartAvailabilityPills, config, state, field, options, disabled)
									]);
							case 7:
								var options = _v2.a;
								return _List_fromArray(
									[
										A5($author$project$View$ConversationalFormV2$viewFilePills, config, state, field, options, disabled)
									]);
							default:
								return _List_Nil;
						}
					} else {
						break _v0$2;
					}
				case 2:
					if (step.b.b && (!step.b.b.b)) {
						var _v3 = step.b;
						var singlePrivacyField = _v3.a;
						return _List_fromArray(
							[
								A4($author$project$View$ConversationalFormV2$viewPrivacyPills, config, state, singlePrivacyField, disabled)
							]);
					} else {
						break _v0$2;
					}
				default:
					break _v0$2;
			}
		}
		return _List_Nil;
	});
var $author$project$View$ConversationalFormV2$viewRetryBubblesForStep = F3(
	function (config, _v0, step) {
		var state_ = _v0;
		var hasErrors = function () {
			var _v3 = $author$project$View$FormV2$submitStatus(state_.IF);
			if ((_v3.$ === 2) && (!_v3.a.$)) {
				var response = _v3.a.a;
				return !$elm$core$Dict$isEmpty(response.atU);
			} else {
				return false;
			}
		}();
		var alreadyInHistory = function (text_) {
			return A2(
				$elm$core$List$any,
				function (b) {
					return _Utils_eq(b, text_);
				},
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2($elm$core$Dict$get, state_.a, state_.H)));
		};
		if ((step.$ === 1) && step.b.b) {
			var _v2 = step.b;
			var field = _v2.a;
			if (hasErrors && $elm$core$List$isEmpty(state_.w)) {
				var msg = A3($author$project$View$ConversationalFormV2$retryTextForField, config.anB, state_.IF, field);
				return alreadyInHistory(msg) ? _List_Nil : _List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('conversational-form-message bot retry')
							]),
						$author$project$View$ConversationalFormV2$renderInlineBold(msg))
					]);
			} else {
				return _List_Nil;
			}
		} else {
			return _List_Nil;
		}
	});
var $author$project$View$ConversationalFormV2$viewTypingIndicator = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('conversational-form-message bot typing'),
			A2($elm$html$Html$Attributes$attribute, 'aria-hidden', 'true')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('conversational-form-typing-dot')
				]),
			_List_Nil),
			A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('conversational-form-typing-dot')
				]),
			_List_Nil),
			A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('conversational-form-typing-dot')
				]),
			_List_Nil)
		]));
var $author$project$View$ConversationalFormV2$screeningAnswerFor = F2(
	function (sqId, formInput) {
		var _v0 = A2($pzp1997$assoc_list$AssocList$get, $author$project$Model$FormFieldV2$ScreeningQuestions, formInput);
		if ((!_v0.$) && (_v0.a.$ === 11)) {
			var vs = _v0.a.a;
			return A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.ey;
						},
						$author$project$View$ConversationalFormV2$renderFieldValue),
					$elm$core$List$head(
						A2(
							$elm$core$List$filter,
							function (v) {
								return _Utils_eq(
									v.dY,
									$author$project$Model$FormFieldV2$Custom(sqId));
							},
							vs))));
		} else {
			return '';
		}
	});
var $author$project$View$ConversationalFormV2$viewUserBubblesForStep = F4(
	function (config, _v0, idx, step) {
		var state_ = _v0;
		var pendingTexts = A2($elm$core$List$filterMap, $author$project$View$ConversationalFormV2$suggestionTextForDomain, state_.w);
		var labelForAnswer = F2(
			function (field, val) {
				var _v7 = _Utils_Tuple2(field.ew, val);
				_v7$5:
				while (true) {
					switch (_v7.b.$) {
						case 2:
							if (_v7.b.a) {
								switch (_v7.a.$) {
									case 19:
										var _v8 = _v7.a;
										return A3($author$project$Data$Translation$translateOr, config.anB, 'yes', 'Ja');
									case 1:
										var _v10 = _v7.a;
										return _Utils_eq(field.dY, $author$project$Model$FormFieldV2$Privacy) ? A3($author$project$Data$Translation$translateOr, config.anB, 'conversational-privacy-accept', 'Akkoord') : A3($author$project$Data$Translation$translateOr, config.anB, 'yes', 'Ja');
									default:
										break _v7$5;
								}
							} else {
								switch (_v7.a.$) {
									case 19:
										var _v9 = _v7.a;
										return A3($author$project$Data$Translation$translateOr, config.anB, 'no', 'Nee');
									case 1:
										var _v11 = _v7.a;
										return _Utils_eq(field.dY, $author$project$Model$FormFieldV2$Privacy) ? A3($author$project$Data$Translation$translateOr, config.anB, 'conversational-privacy-decline', 'Niet akkoord') : A3($author$project$Data$Translation$translateOr, config.anB, 'no', 'Nee');
									default:
										break _v7$5;
								}
							}
						case 10:
							var parts = _v7.b.a;
							return A2(
								$elm$core$String$join,
								', ',
								A2(
									$elm$core$List$map,
									function (_v12) {
										var day = _v12.a;
										var daypart = _v12.b;
										return A2($author$project$View$ConversationalFormV2$dayOfWeekLabel, config, day) + (' ' + A2($author$project$View$ConversationalFormV2$daypartLabel, config, daypart));
									},
									parts));
						default:
							break _v7$5;
					}
				}
				return $author$project$View$ConversationalFormV2$renderFieldValue(val);
			});
		var historyBotReasks = A2(
			$elm$core$List$filter,
			function (s) {
				return !A2($elm$core$List$member, s, pendingTexts);
			},
			A2(
				$elm$core$List$filter,
				function (s) {
					return !$elm$core$String$isEmpty(
						$elm$core$String$trim(s));
				},
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2($elm$core$Dict$get, idx, state_.H))));
		var historyAttempts = A2(
			$elm$core$List$filter,
			function (s) {
				return !$elm$core$String$isEmpty(
					$elm$core$String$trim(s));
			},
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2($elm$core$Dict$get, idx, state_.I)));
		var formInput = $author$project$View$FormV2$getFormInput(state_.IF);
		var rowAnswers = function (fields) {
			return A2(
				$elm$core$List$filter,
				function (s) {
					return !$elm$core$String$isEmpty(
						$elm$core$String$trim(s));
				},
				A2(
					$elm$core$List$filterMap,
					function (f) {
						return A2(
							$elm$core$Maybe$map,
							labelForAnswer(f),
							A2($pzp1997$assoc_list$AssocList$get, f.dY, formInput));
					},
					fields));
		};
		var bubbleFor = function (txt) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('conversational-form-message user')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(txt)
					]));
		};
		var projectedScreeningAnswer = function (ans) {
			return $elm$core$String$isEmpty(
				$elm$core$String$trim(ans)) ? _List_Nil : _List_fromArray(
				[
					bubbleFor(ans)
				]);
		};
		var projectedAnswers = function () {
			switch (step.$) {
				case 1:
					var fields = step.b;
					return A2(
						$elm$core$List$map,
						bubbleFor,
						rowAnswers(fields));
				case 2:
					var fields = step.b;
					return A2(
						$elm$core$List$map,
						bubbleFor,
						rowAnswers(fields));
				case 3:
					var sq = step.a;
					return projectedScreeningAnswer(
						A2($author$project$View$ConversationalFormV2$screeningAnswerFor, sq.dE, formInput));
				default:
					return _List_Nil;
			}
		}();
		var renderAttempt = function (raw) {
			return _Utils_eq(raw, $author$project$View$ConversationalFormV2$skipMarker) ? bubbleFor(
				A3($author$project$Data$Translation$translateOr, config.anB, 'conversational-skip-bubble', '(overgeslagen)')) : (_Utils_eq(raw, $author$project$View$ConversationalFormV2$confirmAcceptMarker) ? bubbleFor(
				A3($author$project$Data$Translation$translateOr, config.anB, 'conversational-ai-accept', 'Ja, klopt')) : (_Utils_eq(raw, $author$project$View$ConversationalFormV2$confirmRejectMarker) ? bubbleFor(
				A3($author$project$Data$Translation$translateOr, config.anB, 'conversational-ai-reject', 'Nee')) : bubbleFor(raw)));
		};
		var botBubbleFor = function (txt) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('conversational-form-message bot ai-clarification')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('conversational-form-ai-prompt')
							]),
						$author$project$View$ConversationalFormV2$renderInlineBold(txt))
					]));
		};
		var interleaved = F2(
			function (users, bots) {
				var _v1 = _Utils_Tuple2(users, bots);
				if (_v1.a.b) {
					if (_v1.b.b) {
						var _v2 = _v1.a;
						var u = _v2.a;
						var us = _v2.b;
						var _v3 = _v1.b;
						var b = _v3.a;
						var bs = _v3.b;
						return A2(
							$elm$core$List$cons,
							renderAttempt(u),
							A2(
								$elm$core$List$cons,
								botBubbleFor(b),
								A2(interleaved, us, bs)));
					} else {
						var _v4 = _v1.a;
						var u = _v4.a;
						var us = _v4.b;
						return A2(
							$elm$core$List$cons,
							renderAttempt(u),
							A2(interleaved, us, _List_Nil));
					}
				} else {
					if (_v1.b.b) {
						var _v5 = _v1.b;
						var b = _v5.a;
						var bs = _v5.b;
						return A2(
							$elm$core$List$cons,
							botBubbleFor(b),
							A2(interleaved, _List_Nil, bs));
					} else {
						return _List_Nil;
					}
				}
			});
		return (!$elm$core$List$isEmpty(historyAttempts)) ? A2(interleaved, historyAttempts, historyBotReasks) : _Utils_ap(
			projectedAnswers,
			A2($elm$core$List$map, botBubbleFor, historyBotReasks));
	});
var $author$project$View$ConversationalFormV2$viewStepBubbles = F4(
	function (config, _v0, currentIdx, _v1) {
		var state_ = _v0;
		var idx = _v1.a;
		var step = _v1.b;
		var userBubbles = (_Utils_cmp(idx, currentIdx) < 1) ? A4($author$project$View$ConversationalFormV2$viewUserBubblesForStep, config, state_, idx, step) : _List_Nil;
		var submitStarted = $author$project$Data$Status$isLoading(
			$author$project$View$FormV2$submitStatus(state_.IF)) || $author$project$Data$Status$isSuccess(
			$author$project$View$FormV2$submitStatus(state_.IF));
		var isCurrent = _Utils_eq(idx, currentIdx);
		var showTyping = isCurrent && _Utils_eq(
			state_.af,
			$elm$core$Maybe$Just(idx));
		var wasAnsweredForThem = (!isCurrent) && A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function (field) {
					return A2($elm$core$List$member, field.dY, state_.x);
				},
				$author$project$View$ConversationalFormV2$firstFieldOfStep(step)));
		var hideBot = A3($author$project$View$ConversationalFormV2$shouldHideQuestionHeading, config.anB, state_.IF, step);
		var maybeBotBubble = hideBot ? $elm$core$Maybe$Nothing : (showTyping ? $elm$core$Maybe$Just($author$project$View$ConversationalFormV2$viewTypingIndicator) : $elm$core$Maybe$Just(
			A4($author$project$View$ConversationalFormV2$viewBotBubbleForStep, config, state_.IF, step, idx)));
		var awaitingServer = isCurrent && ((state_.s === 1) || (state_.M || state_.t));
		var pendingBotBubble = awaitingServer ? _List_fromArray(
			[$author$project$View$ConversationalFormV2$viewTypingIndicator]) : _List_Nil;
		var retryBubbles = (isCurrent && ((!showTyping) && (!awaitingServer))) ? A3($author$project$View$ConversationalFormV2$viewRetryBubblesForStep, config, state_, step) : _List_Nil;
		var inlineReplies = (isCurrent && ((!showTyping) && ((!awaitingServer) && (!submitStarted)))) ? A3($author$project$View$ConversationalFormV2$viewInlineQuickReplies, config, state_, step) : _List_Nil;
		return wasAnsweredForThem ? _List_Nil : _Utils_ap(
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[maybeBotBubble])),
			_Utils_ap(
				userBubbles,
				_Utils_ap(
					retryBubbles,
					_Utils_ap(inlineReplies, pendingBotBubble))));
	});
var $author$project$View$ConversationalFormV2$renderFailureBanner = F2(
	function (_v0, messages) {
		return $elm$core$List$isEmpty(messages) ? $elm$html$Html$text('') : A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('conversational-form-message bot submit-error'),
					A2($elm$html$Html$Attributes$attribute, 'role', 'alert'),
					A2($elm$html$Html$Attributes$attribute, 'aria-live', 'assertive')
				]),
			A2(
				$elm$core$List$map,
				function (m) {
					return A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('conversational-form-ai-prompt')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(m)
							]));
				},
				messages));
	});
var $author$project$View$ConversationalFormV2$viewSubmitFailureBanner = F2(
	function (config, formState) {
		var _v0 = $author$project$View$FormV2$submitStatus(formState);
		if (_v0.$ === 2) {
			if (!_v0.a.$) {
				var response = _v0.a.a;
				var parseMessages = A2(
					$elm$core$List$filter,
					A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$String$isEmpty),
					$elm$core$Dict$values(response._l));
				var globalMessages = A2(
					$elm$core$List$filter,
					A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$String$isEmpty),
					$elm$core$Dict$values(response.Ln));
				var allMessages = _Utils_ap(globalMessages, parseMessages);
				return A2($author$project$View$ConversationalFormV2$renderFailureBanner, config, allMessages);
			} else {
				return A2(
					$author$project$View$ConversationalFormV2$renderFailureBanner,
					config,
					_List_fromArray(
						[
							A3($author$project$Data$Translation$translateOr, config.anB, 'conversational-submit-error', 'Er ging iets mis bij het versturen. Probeer het opnieuw.')
						]));
			}
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$View$ConversationalFormV2$viewSuccessChatBubble = function (config) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('conversational-form-message bot')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(
				A3($author$project$Data$Translation$translateOr, config.anB, 'conversational-success-body', 'You will receive a confirmation by email.'))
			]));
};
var $author$project$View$ConversationalFormV2$viewWelcomeBackBubbles = F3(
	function (config, _v0, boundaryIdx) {
		var state_ = _v0;
		return (state_.a2 && (boundaryIdx > 0)) ? _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('conversational-form-message bot')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						A3($author$project$Data$Translation$translateOr, config.anB, 'conversational-welcome-back', 'Welkom terug! Je antwoorden zijn bewaard — we gaan verder waar je was gebleven.'))
					]))
			]) : _List_Nil;
	});
var $author$project$View$ConversationalFormV2$viewChatThreadLoaded = F4(
	function (config, state, steps, isSubmitSuccess) {
		var state_ = state;
		var introBubbles = function () {
			if (state_.e8) {
				return _List_Nil;
			} else {
				var form = $author$project$Data$FormSource$toForm(
					$author$project$View$ConversationalFormV2$formSource(state_.IF));
				var _v0 = A2(
					$author$project$View$ConversationalFormV2$resolveIntroText,
					$author$project$View$FormV2$getDomainKey(state_.IF),
					form.Op);
				if (!_v0.$) {
					var txt = _v0.a;
					return _List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('conversational-form-message bot intro')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(txt)
								]))
						]);
				} else {
					return _List_Nil;
				}
			}
		}();
		var currentIdx = state_.a;
		var resumeBoundary = A2($elm$core$Maybe$withDefault, currentIdx, state_.cK);
		var shown = A2(
			$elm$core$List$indexedMap,
			$elm$core$Tuple$pair,
			A2($elm$core$List$take, currentIdx + 1, steps));
		var stepBubbles = _Utils_ap(
			A2(
				$elm$core$List$concatMap,
				A3($author$project$View$ConversationalFormV2$viewStepBubbles, config, state, currentIdx),
				A2($elm$core$List$take, resumeBoundary, shown)),
			_Utils_ap(
				A3($author$project$View$ConversationalFormV2$viewResumeDivider, config, state, resumeBoundary),
				_Utils_ap(
					A3($author$project$View$ConversationalFormV2$viewWelcomeBackBubbles, config, state, resumeBoundary),
					A2(
						$elm$core$List$concatMap,
						A3($author$project$View$ConversationalFormV2$viewStepBubbles, config, state, currentIdx),
						A2($elm$core$List$drop, resumeBoundary, shown)))));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('conversational-form-thread'),
					$elm$html$Html$Attributes$id('conversational-form-thread'),
					A2($elm$html$Html$Attributes$attribute, 'role', 'log'),
					A2($elm$html$Html$Attributes$attribute, 'aria-live', 'polite'),
					A2($elm$html$Html$Attributes$attribute, 'aria-relevant', 'additions text')
				]),
			_Utils_ap(
				introBubbles,
				_Utils_ap(
					stepBubbles,
					_Utils_ap(
						A2($author$project$View$ConversationalFormV2$viewAiSuggestions, config, state),
						isSubmitSuccess ? A2(
							$elm$core$List$cons,
							$author$project$View$ConversationalFormV2$viewSuccessChatBubble(config),
							state_.eo ? _List_fromArray(
								[
									A4(
									$author$project$View$ConversationalFormV2$viewConfirmationCard,
									config,
									A3($author$project$Data$Translation$translateOr, config.anB, 'conversational-confirm-title-default', 'Application submitted'),
									A3($author$project$Data$Translation$translateOr, config.anB, 'conversational-confirm-whats-next-default', 'What happens next?'),
									A3($author$project$Data$Translation$translateOr, config.anB, 'conversational-confirm-description-default', 'We\'ve received your application.\nWe\'ll be in touch about the next steps as soon as possible.'))
								]) : _List_Nil) : _List_fromArray(
							[
								A2($author$project$View$ConversationalFormV2$viewSubmitFailureBanner, config, state_.IF)
							])))));
	});
var $author$project$View$ConversationalFormV2$viewChatThread = F4(
	function (config, state, steps, isSubmitSuccess) {
		var state_ = state;
		return state_.bV ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('conversational-form-thread'),
					$elm$html$Html$Attributes$id('conversational-form-thread'),
					A2($elm$html$Html$Attributes$attribute, 'role', 'log'),
					A2($elm$html$Html$Attributes$attribute, 'aria-live', 'polite')
				]),
			_List_fromArray(
				[$author$project$View$ConversationalFormV2$viewTypingIndicator])) : A4($author$project$View$ConversationalFormV2$viewChatThreadLoaded, config, state, steps, isSubmitSuccess);
	});
var $elm$html$Html$header = _VirtualDom_node('header');
var $author$project$View$ConversationalFormV2$viewDesktopHeader = F2(
	function (config, showRestart) {
		var restartLabel = A3($author$project$Data$Translation$translateOr, config.anB, 'conversational-restart-button', 'Opnieuw beginnen');
		var restartTextButton = A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$type_('button'),
					$elm$html$Html$Attributes$class('conversational-form-overlay-nav-text'),
					$elm$html$Html$Events$onClick(
					config.aut($author$project$View$ConversationalFormV2$ConvStartOver))
				]),
			_List_fromArray(
				[
					A2($author$project$View$Icon$viewMasked, 1, $author$project$Data$Icon$path.le),
					$elm$html$Html$text(restartLabel)
				]));
		return showRestart ? A2(
			$elm$html$Html$header,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('conversational-form-overlay-header is-desktop')
				]),
			_List_fromArray(
				[restartTextButton])) : $elm$html$Html$text('');
	});
var $author$project$View$ConversationalFormV2$whenList = F2(
	function (cond, items) {
		return cond ? items : _List_Nil;
	});
var $author$project$View$ConversationalFormV2$viewMobileHeader = F3(
	function (config, hasHistory, showRestart) {
		var restartLabel = A3($author$project$Data$Translation$translateOr, config.anB, 'conversational-restart-button', 'Opnieuw beginnen');
		var restartIconButton = A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$type_('button'),
					$elm$html$Html$Attributes$class('conversational-form-overlay-nav-icon'),
					A2($elm$html$Html$Attributes$attribute, 'aria-label', restartLabel),
					$elm$html$Html$Events$onClick(
					config.aut($author$project$View$ConversationalFormV2$ConvStartOver))
				]),
			_List_fromArray(
				[
					A2($author$project$View$Icon$viewMasked, 1, $author$project$Data$Icon$path.le)
				]));
		var closeLabel = A3($author$project$Data$Translation$translateOr, config.anB, 'conversational-close-button', 'Terug naar de vacature');
		return A2(
			$elm$html$Html$header,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('conversational-form-overlay-header is-mobile')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('button'),
							$elm$html$Html$Attributes$class('conversational-form-overlay-close-to-vacancy'),
							$elm$html$Html$Events$onClick(
							config.aut($author$project$View$ConversationalFormV2$OverlayClose))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(closeLabel)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('conversational-form-overlay-nav-icons')
						]),
					A2(
						$author$project$View$ConversationalFormV2$whenList,
						showRestart,
						_List_fromArray(
							[restartIconButton])))
				]));
	});
var $author$project$View$ConversationalFormV2$viewOverlayHeader = F2(
	function (config, _v0) {
		var state_ = _v0;
		var hasHistory = !$elm$core$List$isEmpty(state_.z);
		var showRestart = hasHistory || state_.a2;
		return $author$project$View$ConversationalFormV2$isDesktopInContainer(state_) ? A2($author$project$View$ConversationalFormV2$viewDesktopHeader, config, showRestart) : A3($author$project$View$ConversationalFormV2$viewMobileHeader, config, hasHistory, showRestart);
	});
var $author$project$View$ConversationalFormV2$viewProgressBar = F3(
	function (config, _v0, totalSteps) {
		var state_ = _v0;
		var stepNumber = state_.a + 1;
		var percent = (!totalSteps) ? 0 : A3($elm$core$Basics$clamp, 0, 100, (stepNumber / totalSteps) * 100);
		var displayStepNumber = (!totalSteps) ? stepNumber : A3($elm$core$Basics$clamp, 1, totalSteps, stepNumber);
		var progressLabel = A2(
			$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
			A3($author$project$Data$Translation$translateOr, config.anB, 'conversational-step-of', 'Step {0} of {1}'),
			_List_fromArray(
				[
					$elm$core$String$fromInt(displayStepNumber),
					$elm$core$String$fromInt(totalSteps)
				]));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('conversational-form-progress-bar'),
					A2($elm$html$Html$Attributes$attribute, 'role', 'progressbar'),
					A2($elm$html$Html$Attributes$attribute, 'aria-valuemin', '0'),
					A2($elm$html$Html$Attributes$attribute, 'aria-valuemax', '100'),
					A2(
					$elm$html$Html$Attributes$attribute,
					'aria-valuenow',
					$elm$core$String$fromFloat(percent)),
					A2($elm$html$Html$Attributes$attribute, 'aria-label', progressLabel)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('conversational-form-progress-fill'),
							A2(
							$elm$html$Html$Attributes$style,
							'width',
							$elm$core$String$fromFloat(percent) + '%')
						]),
					_List_Nil)
				]));
	});
var $author$project$View$ConversationalFormV2$viewMobile = F2(
	function (config, state) {
		var state_ = state;
		var steps = $author$project$View$ConversationalFormV2$visibleSteps(state_.IF);
		var totalSteps = $elm$core$List$length(steps);
		var outerClass = $author$project$View$ConversationalFormV2$isDesktopInContainer(state_) ? 'conversational-form-overlay desktop' : 'conversational-form-overlay mobile';
		var isSubmitSuccess = $author$project$Data$Status$isSuccess(
			$author$project$View$FormV2$submitStatus(state_.IF));
		return A2(
			$elm$html$Html$div,
			_Utils_ap(
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class(outerClass),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('is-overlay', state_.e8),
								_Utils_Tuple2('is-page', !state_.e8),
								_Utils_Tuple2('is-open', state_.O1),
								_Utils_Tuple2(
								'is-in-container',
								$author$project$View$ConversationalFormV2$isDesktopInContainer(state_))
							]))
					]),
				$author$project$View$ConversationalFormV2$dragDropAttrs(config)),
			_List_fromArray(
				[
					(state_.e8 && (!$author$project$View$ConversationalFormV2$isDesktopInContainer(state_))) ? A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('conversational-form-overlay-backdrop'),
							A2($elm$html$Html$Attributes$attribute, 'aria-hidden', 'true'),
							$elm$html$Html$Events$onClick(
							config.aut($author$project$View$ConversationalFormV2$OverlayClose))
						]),
					_List_Nil) : $elm$html$Html$text(''),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('conversational-form-overlay-sheet')
						]),
					_List_fromArray(
						[
							state_.e8 ? A2($author$project$View$ConversationalFormV2$viewOverlayHeader, config, state) : $elm$html$Html$text(''),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('conversational-form mobile'),
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('is-reduced-motion', state_.cI),
											_Utils_Tuple2('is-submitted', isSubmitSuccess)
										]))
								]),
							_List_fromArray(
								[
									(isSubmitSuccess || state_.e8) ? $elm$html$Html$text('') : A2($author$project$View$ConversationalFormV2$viewBackRow, config, state),
									A3($author$project$View$ConversationalFormV2$viewProgressBar, config, state, totalSteps),
									A4($author$project$View$ConversationalFormV2$viewChatThread, config, state, steps, isSubmitSuccess),
									(isSubmitSuccess || state_.bV) ? $elm$html$Html$text('') : A3($author$project$View$ConversationalFormV2$viewChatInputArea, config, state, steps)
								]))
						]))
				]));
	});
var $author$project$View$ConversationalFormV2$view = F2(
	function (config, state) {
		var state_ = state;
		return (state_.e8 && (!state_.O1)) ? A2($author$project$View$ConversationalFormV2$viewClosedTrigger, config, state) : A2($author$project$View$ConversationalFormV2$viewMobile, config, state);
	});
var $author$project$Form$view = function (model) {
	var _v0 = model.aA;
	if (!_v0.$) {
		return A2(
			$elm$html$Html$map,
			$author$project$Form$FormMsg,
			A2(
				$author$project$View$FormV2$view,
				{aG: model.aG, aut: $elm$core$Basics$identity, aP: model.aP, aC: model.aC, aU: model.aU, fV: model.fV, anB: model.anB},
				model.IF));
	} else {
		var convState = _v0.a;
		return A2(
			$elm$html$Html$map,
			$author$project$Form$ConvMsg,
			A2(
				$author$project$View$ConversationalFormV2$view,
				{aG: model.aG, Kq: model.Kq, aL: model.aL, aM: model.aM, aut: $elm$core$Basics$identity, aP: model.aP, aC: model.aC, aU: model.aU, aaE: $author$project$Form$pushAnalyticsEvent, cI: model.cI, ag$: model.ag$, fV: model.fV, anB: model.anB, awl: model.cf, b9: model.b9, awn: model.cg},
				convState));
	}
};
var $author$project$Form$main = A2(
	$author$project$Browser$Custom$elementWithFlags,
	$author$project$Form$decodeFlags,
	{dH: $author$project$Form$init, em: $author$project$Form$subscriptions, ex: $author$project$Form$update, ez: $author$project$Form$view});
var $author$project$Model$Component$ContactForm$Flags$Flags = F7(
	function (domainId, componentId, redirect, buttonText, defaultCallingCode, minTabIndex, csrfToken) {
		return {cd: buttonText, de: componentId, ci: csrfToken, atB: defaultCallingCode, dp: domainId, aP: minTabIndex, avn: redirect};
	});
var $author$project$Model$Component$ContactForm$Flags$flagsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'csrfToken',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'minTabIndex',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'defaultCallingCode',
			$author$project$Util$Json$enumDecoder($author$project$Model$CountryCallingCode$fromString),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'buttonText',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'redirect',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'componentId',
						$author$project$Data$Id$decoder,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'domainId',
							$author$project$Data$Id$decoder,
							$elm$json$Json$Decode$succeed($author$project$Model$Component$ContactForm$Flags$Flags))))))));
var $author$project$ContactForm$emptyForm = function (defaultCallingCode) {
	return {
		cm: '',
		ct: $elm$core$Maybe$Nothing,
		bT: '',
		dY: '',
		aR: _Utils_Tuple2(defaultCallingCode, '')
	};
};
var $author$project$ContactForm$init = function (flags) {
	return _Utils_Tuple2(
		{
			bz: false,
			cd: flags.cd,
			de: flags.de,
			ch: false,
			ci: flags.ci,
			dp: flags.dp,
			IF: $author$project$ContactForm$emptyForm(flags.atB),
			aP: flags.aP,
			d9: flags.avn,
			bq: $author$project$Data$Status$NotAsked,
			ca: $elm$core$Maybe$Nothing
		},
		$elm$core$Platform$Cmd$none);
};
var $author$project$ContactForm$GotCsrfToken = function (a) {
	return {$: 3, a: a};
};
var $author$project$ContactForm$updateContactFormCsrfToken = _Platform_incomingPort('updateContactFormCsrfToken', $elm$json$Json$Decode$string);
var $author$project$ContactForm$subscriptions = function (_v0) {
	return $author$project$ContactForm$updateContactFormCsrfToken($author$project$ContactForm$GotCsrfToken);
};
var $author$project$ContactForm$GotSubmitForm = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$ContactForm$encodeContactForm = function (form) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(form.dY)),
				_Utils_Tuple2(
				'emailAddress',
				$elm$json$Json$Encode$string(form.cm)),
				_Utils_Tuple2(
				'contactMsg',
				$elm$json$Json$Encode$string(form.bT)),
				_Utils_Tuple2(
				'honeypot',
				A3($elm_community$maybe_extra$Maybe$Extra$unwrap, $elm$json$Json$Encode$null, $elm$json$Json$Encode$string, form.ct)),
				_Utils_Tuple2(
				'phone',
				A2(
					$elm$json$Json$Encode$list,
					$elm$json$Json$Encode$string,
					_List_fromArray(
						[
							$author$project$Model$CountryCallingCode$toString(form.aR.a),
							form.aR.b
						])))
			]));
};
var $author$project$Api$Endpoint$submitContactForm = F2(
	function (domainId, componentId) {
		return $author$project$Api$Endpoint$endpoint(
			_List_fromArray(
				[
					'form',
					'contact',
					$author$project$Data$Id$toString(domainId),
					$author$project$Data$Id$toString(componentId)
				]));
	});
var $author$project$ContactForm$postContactForm = F2(
	function (csrfToken, model) {
		return $author$project$Api$Endpoint$request(
			{
				_: $elm$http$Http$jsonBody(
					$author$project$ContactForm$encodeContactForm(model.IF)),
				aH: A2(
					$author$project$Api$expectJson,
					$author$project$ContactForm$GotSubmitForm(model.IF.aR.a),
					$elm$json$Json$Decode$succeed(0)),
				ax: _List_fromArray(
					[
						A2($elm$http$Http$header, 'X-XSRF-TOKEN', csrfToken)
					]),
				aO: 'POST',
				a_: $elm$core$Maybe$Nothing,
				av3: $elm$core$Maybe$Just('post'),
				a0: A2($author$project$Api$Endpoint$submitContactForm, model.dp, model.de)
			});
	});
var $author$project$ContactForm$requestContactFormCsrfToken = _Platform_outgoingPort('requestContactFormCsrfToken', $elm$json$Json$Encode$bool);
var $author$project$ContactForm$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var field = msg.a;
				var form = msg.b;
				var validationResponse = A2(
					$elm$core$Maybe$map,
					function (validationErrors) {
						return _Utils_update(
							validationErrors,
							{
								atU: A2($elm$core$Dict$remove, field, validationErrors.atU)
							});
					},
					model.ca);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{IF: form, ca: validationResponse}),
					$elm$core$Platform$Cmd$none);
			case 1:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bz: true, ch: false, bq: $author$project$Data$Status$Loading}),
					$author$project$ContactForm$requestContactFormCsrfToken(true));
			case 2:
				if (!msg.b.$) {
					var code = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								IF: $author$project$ContactForm$emptyForm(code),
								bq: $author$project$Data$Status$Success(0)
							}),
						$elm$core$String$isEmpty(model.d9) ? $elm$core$Platform$Cmd$none : $elm$browser$Browser$Navigation$load(model.d9));
				} else {
					if (!msg.b.a.$) {
						var validationError = msg.b.a.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									bq: $author$project$Data$Status$Failure(
										$author$project$Api$ValidationError(validationError)),
									ca: $elm$core$Maybe$Just(validationError)
								}),
							$elm$core$Platform$Cmd$none);
					} else {
						var err = msg.b.a;
						return ($author$project$Api$isForbidden(err) && (!model.ch)) ? _Utils_Tuple2(
							_Utils_update(
								model,
								{bz: true, ch: true}),
							$author$project$ContactForm$requestContactFormCsrfToken(true)) : _Utils_Tuple2(
							_Utils_update(
								model,
								{
									bq: $author$project$Data$Status$Failure(err)
								}),
							$elm$core$Platform$Cmd$none);
					}
				}
			default:
				var rawToken = msg.a;
				var token = A2($author$project$Api$csrfTokenWithDefault, model.ci, rawToken);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bz: false, ci: token}),
					model.bz ? A2($author$project$ContactForm$postContactForm, token, model) : $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$ContactForm$SubmitForm = {$: 1};
var $author$project$ContactForm$UpdateForm = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$ContactForm$maybeError = F2(
	function (inputId, validationResponse) {
		return A2($author$project$Api$toValidationError, inputId, validationResponse);
	});
var $author$project$ContactForm$phoneField = F4(
	function (_v0, tabIndex, maybeErr, toMsg) {
		var countryCallingCode = _v0.a;
		var phoneNumber = _v0.b;
		var selectConfig = {
			atr: $elm$core$Maybe$Just(
				$elm$core$Basics$eq(countryCallingCode)),
			at7: $author$project$Model$CountryCallingCode$fromString,
			auq: $elm$core$Maybe$Nothing,
			au7: function () {
				var _v1 = $author$project$Data$CountryCallingCode$sortedByCountryName;
				if (_v1.b) {
					var hd = _v1.a;
					var rest = _v1.b;
					return _Utils_Tuple2(hd, rest);
				} else {
					return _Utils_Tuple2(countryCallingCode, $author$project$Model$CountryCallingCode$all);
				}
			}(),
			avz: false,
			avS: $elm$core$Maybe$Just(tabIndex),
			avZ: A2(
				$elm$core$Basics$composeL,
				toMsg,
				A2($author$project$Util$Base$flip, $elm$core$Tuple$pair, phoneNumber)),
			av_: $author$project$Data$CountryCallingCode$formatWithCountryName,
			av$: $author$project$Model$CountryCallingCode$toString
		};
		return A2(
			$author$project$Component$Form$TextInput$view,
			'',
			_List_fromArray(
				[
					$author$project$Component$Form$TextInput$id('phoneNumber'),
					$author$project$Component$Form$TextInput$extraHtml(
					A3($author$project$Component$Form$SelectNonEmpty$viewSelectShortWhenSelected, $author$project$Model$CountryCallingCode$toCode, $author$project$Copy$copy.atb, selectConfig)),
					$author$project$Component$Form$TextInput$placeholder($author$project$Copy$copy.avb),
					$author$project$Component$Form$TextInput$onInput(
					A2(
						$elm$core$Basics$composeL,
						toMsg,
						$elm$core$Tuple$pair(countryCallingCode))),
					$author$project$Component$Form$TextInput$value(phoneNumber),
					$author$project$Component$Form$TextInput$error(maybeErr),
					$author$project$Component$Form$TextInput$phone,
					$author$project$Component$Form$TextInput$icon($author$project$View$Icon$path.aR),
					$author$project$Component$Form$TextInput$class('phone with-calling-code'),
					$author$project$Component$Form$TextInput$tabindex(tabIndex + 1)
				]));
	});
var $author$project$ContactForm$viewError = F2(
	function (inputId, validationResponse) {
		return A2(
			$author$project$Util$View$viewMaybe,
			A2($author$project$ContactForm$maybeError, inputId, validationResponse),
			function (message) {
				return A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('error-message')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(message)
						]));
			});
	});
var $author$project$ContactForm$viewTextAreaInput = F6(
	function (toMsg, inputId, val, placeholder_, tabIndex, validationResponse) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('form-field', true),
							_Utils_Tuple2(
							'error',
							$elm_community$maybe_extra$Maybe$Extra$isJust(
								A2($author$project$ContactForm$maybeError, inputId, validationResponse)))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('field-content')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$textarea,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$placeholder(placeholder_),
									$elm$html$Html$Attributes$class('form-input form-textarea'),
									$elm$html$Html$Attributes$required(true),
									$elm$html$Html$Attributes$value(val),
									$elm$html$Html$Attributes$tabindex(tabIndex),
									$elm$html$Html$Events$onInput(toMsg),
									$elm$html$Html$Attributes$id(
									A2(
										$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
										'{0}-input',
										_List_fromArray(
											[inputId])))
								]),
							_List_Nil)
						])),
					A2($author$project$ContactForm$viewError, inputId, validationResponse)
				]));
	});
var $author$project$ContactForm$view = function (model) {
	var form = model.IF;
	var validationError = model.ca;
	var buttonTextR = function () {
		var _v1 = model.cd;
		if (_v1.$ === 1) {
			return $author$project$Copy$copy.avI;
		} else {
			return A2($elm$core$Maybe$withDefault, '', model.cd);
		}
	}();
	return A2(
		$elm$html$Html$form,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('form'),
				$elm$html$Html$Events$onSubmit($author$project$ContactForm$SubmitForm)
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('form-row')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Component$Form$TextInput$view,
						$author$project$Copy$copy.dY,
						_List_fromArray(
							[
								$author$project$Component$Form$TextInput$id('name'),
								$author$project$Component$Form$TextInput$placeholder($author$project$Copy$copy.dY),
								$author$project$Component$Form$TextInput$icon($author$project$View$Icon$path.au9),
								$author$project$Component$Form$TextInput$onInput(
								function (v) {
									return A2(
										$author$project$ContactForm$UpdateForm,
										'name',
										_Utils_update(
											form,
											{dY: v}));
								}),
								$author$project$Component$Form$TextInput$value(form.dY),
								$author$project$Component$Form$TextInput$error(
								A2($author$project$ContactForm$maybeError, 'name', validationError)),
								$author$project$Component$Form$TextInput$hiddenLabel(true),
								$author$project$Component$Form$TextInput$tabindex(model.aP)
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('form-row')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Component$Form$TextInput$view,
						$author$project$Copy$copy.eR,
						_List_fromArray(
							[
								$author$project$Component$Form$TextInput$id('email'),
								$author$project$Component$Form$TextInput$placeholder($author$project$Copy$copy.eR),
								$author$project$Component$Form$TextInput$icon($author$project$View$Icon$path.eR),
								$author$project$Component$Form$TextInput$onInput(
								function (v) {
									return A2(
										$author$project$ContactForm$UpdateForm,
										'emailAddress',
										_Utils_update(
											form,
											{cm: v}));
								}),
								$author$project$Component$Form$TextInput$value(form.cm),
								$author$project$Component$Form$TextInput$error(
								A2($author$project$ContactForm$maybeError, 'emailAddress', validationError)),
								$author$project$Component$Form$TextInput$hiddenLabel(true),
								$author$project$Component$Form$TextInput$tabindex(model.aP + 1)
							]))
					])),
				A4(
				$author$project$ContactForm$phoneField,
				form.aR,
				model.aP + 2,
				A2($author$project$ContactForm$maybeError, 'phone-number-with-calling-code', validationError),
				function (phoneIncludingCallingCode) {
					return A2(
						$author$project$ContactForm$UpdateForm,
						'phone-number-with-calling-code',
						_Utils_update(
							form,
							{aR: phoneIncludingCallingCode}));
				}),
				A6(
				$author$project$ContactForm$viewTextAreaInput,
				function (v) {
					return A2(
						$author$project$ContactForm$UpdateForm,
						'contactMsg',
						_Utils_update(
							form,
							{bT: v}));
				},
				'contactMsg',
				form.bT,
				$author$project$Copy$copy.bT,
				model.aP + 4,
				validationError),
				A2(
				$elm$html$Html$input,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$autocomplete(false),
						$elm$html$Html$Attributes$name('password'),
						A2($elm$html$Html$Attributes$attribute, 'style', 'display:none !important'),
						A2($elm$html$Html$Attributes$attribute, 'tabindex', '-1'),
						$elm$html$Html$Attributes$type_('text'),
						$elm$html$Html$Attributes$value(
						A2($elm$core$Maybe$withDefault, '', form.ct)),
						$elm$html$Html$Events$onInput(
						function (v) {
							return A2(
								$author$project$ContactForm$UpdateForm,
								'',
								_Utils_update(
									form,
									{
										ct: $elm$core$Maybe$Just(v)
									}));
						})
					]),
				_List_Nil),
				A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$type_('submit'),
						$elm$html$Html$Attributes$class('btn bg-color-1 color-white'),
						$elm$html$Html$Attributes$tabindex(model.aP + 5)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('btn-label')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(buttonTextR)
							]))
					])),
				function () {
				var _v0 = model.bq;
				switch (_v0.$) {
					case 3:
						return A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('success')
								]),
							_List_fromArray(
								[
									$author$project$View$Icon$viewColored($author$project$View$Icon$path.ate),
									$elm$html$Html$text($author$project$Copy$copy.avJ)
								]));
					case 2:
						return A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('error')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text($author$project$Copy$copy.av9)
								]));
					default:
						return $elm$html$Html$text('');
				}
			}()
			]));
};
var $author$project$ContactForm$main = A2(
	$author$project$Browser$Custom$elementWithFlags,
	$author$project$Model$Component$ContactForm$Flags$flagsDecoder,
	{dH: $author$project$ContactForm$init, em: $author$project$ContactForm$subscriptions, ex: $author$project$ContactForm$update, ez: $author$project$ContactForm$view});
_Platform_export({'ContactForm':{'init':$author$project$ContactForm$main($elm$json$Json$Decode$value)(0)},'VacancyFilterOptionSearch':{'init':$author$project$VacancyFilterOptionSearch$main($elm$json$Json$Decode$value)(0)},'TravelTime':{'init':$author$project$TravelTime$main($elm$json$Json$Decode$value)(0)},'Slider':{'init':$author$project$Slider$main($elm$json$Json$Decode$value)(0)},'ShareToolForm':{'init':$author$project$ShareToolForm$main($elm$json$Json$Decode$value)(0)},'ShareToolEmployeeContentCollection':{'init':$author$project$ShareToolEmployeeContentCollection$main($elm$json$Json$Decode$value)(0)},'SalaryCalculator':{'init':$author$project$SalaryCalculator$main($elm$json$Json$Decode$value)(0)},'ReferralToolForm':{'init':$author$project$ReferralToolForm$main($elm$json$Json$Decode$value)(0)},'ReferralToolEditForm':{'init':$author$project$ReferralToolEditForm$main($elm$json$Json$Decode$value)(0)},'RecruitmentChat':{'init':$author$project$RecruitmentChat$main($elm$json$Json$Decode$value)(0)},'LocationSearch':{'init':$author$project$LocationSearch$main($elm$json$Json$Decode$value)(0)},'KeywordSearch':{'init':$author$project$KeywordSearch$main($elm$json$Json$Decode$value)(0)},'JobAlertForm':{'init':$author$project$JobAlertForm$main($elm$json$Json$Decode$value)(0)},'Form':{'init':$author$project$Form$main($elm$json$Json$Decode$value)(0)}});}(this));